(function(){"use strict";try{if(typeof document<"u"){var o=document.createElement("style");o.appendChild(document.createTextNode('.emoji-mart,.emoji-mart *{box-sizing:border-box;line-height:1.15}.emoji-mart{font-family:-apple-system,BlinkMacSystemFont,Helvetica Neue,sans-serif;font-size:16px;display:inline-block;color:#222427;border:1px solid #d9d9d9;border-radius:5px;background:#fff}.emoji-mart .emoji-mart-emoji{padding:6px}.emoji-mart-bar{border:0 solid #d9d9d9}.emoji-mart-bar:first-child{border-bottom-width:1px;border-top-left-radius:5px;border-top-right-radius:5px}.emoji-mart-bar:last-child{border-top-width:1px;border-bottom-left-radius:5px;border-bottom-right-radius:5px}.emoji-mart-anchors{display:flex;flex-direction:row;justify-content:space-between;padding:0 6px;line-height:0}.emoji-mart-anchor{position:relative;display:block;flex:1 1 auto;color:#858585;text-align:center;padding:12px 4px;overflow:hidden;transition:color .1s ease-out;margin:0;box-shadow:none;background:none;border:none}.emoji-mart-anchor:focus{outline:0}.emoji-mart-anchor:hover,.emoji-mart-anchor:focus,.emoji-mart-anchor-selected{color:#464646}.emoji-mart-anchor-selected .emoji-mart-anchor-bar{bottom:0}.emoji-mart-anchor-bar{position:absolute;bottom:-3px;left:0;width:100%;height:3px;background-color:#464646}.emoji-mart-anchors i{display:inline-block;width:100%;max-width:22px}.emoji-mart-anchors svg,.emoji-mart-anchors img{fill:currentColor;height:18px;width:18px}.emoji-mart-scroll{overflow-y:scroll;overflow-x:hidden;height:270px;padding:0 6px 6px;will-change:transform}.emoji-mart-search{margin-top:6px;padding:0 6px;position:relative}.emoji-mart-search input{font-size:16px;display:block;width:100%;padding:5px 25px 6px 10px;border-radius:5px;border:1px solid #d9d9d9;outline:0}.emoji-mart-search input,.emoji-mart-search input::-webkit-search-decoration,.emoji-mart-search input::-webkit-search-cancel-button,.emoji-mart-search input::-webkit-search-results-button,.emoji-mart-search input::-webkit-search-results-decoration{-webkit-appearance:none}.emoji-mart-search-icon{position:absolute;top:7px;right:11px;z-index:2;padding:2px 5px 1px;border:none;background:none}.emoji-mart-category .emoji-mart-emoji span{z-index:1;position:relative;text-align:center;cursor:default}.emoji-mart-category .emoji-mart-emoji:hover:before{z-index:0;content:"";position:absolute;top:0;left:0;width:100%;height:100%;background-color:#f4f4f4;border-radius:100%}.emoji-mart-category-label{z-index:2;position:relative;position:-webkit-sticky;position:sticky;top:0}.emoji-mart-category-label span{display:block;width:100%;font-weight:500;padding:5px 6px;background-color:#fff;background-color:#fffffff2}.emoji-mart-category-list{margin:0;padding:0}.emoji-mart-category-list li{list-style:none;margin:0;padding:0;display:inline-block}.emoji-mart-emoji{position:relative;display:inline-block;font-size:0;margin:0;padding:0;border:none;background:none;box-shadow:none}.emoji-mart-emoji-native{font-family:"Segoe UI Emoji",Segoe UI Symbol,Segoe UI,"Apple Color Emoji",Twemoji Mozilla,"Noto Color Emoji","Android Emoji"}.emoji-mart-no-results{font-size:14px;text-align:center;padding-top:70px;color:#858585}.emoji-mart-no-results-img{display:block;margin-left:auto;margin-right:auto;width:50%}.emoji-mart-no-results .emoji-mart-category-label{display:none}.emoji-mart-no-results .emoji-mart-no-results-label{margin-top:.2em}.emoji-mart-no-results .emoji-mart-emoji:hover:before{content:none}.emoji-mart-preview{position:relative;height:70px}.emoji-mart-preview-emoji,.emoji-mart-preview-data,.emoji-mart-preview-skins{position:absolute;top:50%;transform:translateY(-50%)}.emoji-mart-preview-emoji{left:12px}.emoji-mart-preview-data{left:68px;right:12px;word-break:break-all}.emoji-mart-preview-skins{right:30px;text-align:right}.emoji-mart-preview-skins.custom{right:10px;text-align:right}.emoji-mart-preview-name{font-size:14px}.emoji-mart-preview-shortname{font-size:12px;color:#888}.emoji-mart-preview-shortname+.emoji-mart-preview-shortname,.emoji-mart-preview-shortname+.emoji-mart-preview-emoticon,.emoji-mart-preview-emoticon+.emoji-mart-preview-emoticon{margin-left:.5em}.emoji-mart-preview-emoticon{font-size:11px;color:#bbb}.emoji-mart-title span{display:inline-block;vertical-align:middle}.emoji-mart-title .emoji-mart-emoji{padding:0}.emoji-mart-title-label{color:#999a9c;font-size:26px;font-weight:300}.emoji-mart-skin-swatches{font-size:0;padding:2px 0;border:1px solid #d9d9d9;border-radius:12px;background-color:#fff}.emoji-mart-skin-swatches.custom{font-size:0;border:none;background-color:#fff}.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch{width:16px;padding:0 2px}.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch.selected:after{opacity:.75}.emoji-mart-skin-swatch{display:inline-block;width:0;vertical-align:middle;transition-property:width,padding;transition-duration:.125s;transition-timing-function:ease-out}.emoji-mart-skin-swatch:nth-child(1){transition-delay:0s}.emoji-mart-skin-swatch:nth-child(2){transition-delay:.03s}.emoji-mart-skin-swatch:nth-child(3){transition-delay:.06s}.emoji-mart-skin-swatch:nth-child(4){transition-delay:.09s}.emoji-mart-skin-swatch:nth-child(5){transition-delay:.12s}.emoji-mart-skin-swatch:nth-child(6){transition-delay:.15s}.emoji-mart-skin-swatch.selected{position:relative;width:16px;padding:0 2px}.emoji-mart-skin-swatch.selected:after{content:"";position:absolute;top:50%;left:50%;width:4px;height:4px;margin:-2px 0 0 -2px;background-color:#fff;border-radius:100%;pointer-events:none;opacity:0;transition:opacity .2s ease-out}.emoji-mart-skin-swatch.custom{display:inline-block;width:0;height:38px;overflow:hidden;vertical-align:middle;transition-property:width,height;transition-duration:.125s;transition-timing-function:ease-out;cursor:default}.emoji-mart-skin-swatch.custom.selected{position:relative;width:36px;height:38px;padding:0 2px 0 0}.emoji-mart-skin-swatch.custom.selected:after{content:"";width:0;height:0}.emoji-mart-skin-swatches.custom .emoji-mart-skin-swatch.custom:hover{background-color:#f4f4f4;border-radius:10%}.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom{width:36px;height:38px;padding:0 2px 0 0}.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom.selected:after{opacity:.75}.emoji-mart-skin-text.opened{display:inline-block;vertical-align:middle;text-align:left;color:#888;font-size:11px;padding:5px 2px;width:95px;height:40px;border-radius:10%;background-color:#fff}.emoji-mart-skin{display:inline-block;width:100%;padding-top:100%;max-width:12px;border-radius:100%}.emoji-mart-skin-tone-1{background-color:#ffc93a}.emoji-mart-skin-tone-2{background-color:#fadcbc}.emoji-mart-skin-tone-3{background-color:#e0bb95}.emoji-mart-skin-tone-4{background-color:#bf8f68}.emoji-mart-skin-tone-5{background-color:#9b643d}.emoji-mart-skin-tone-6{background-color:#594539}.emoji-mart-sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.emoji-mart-dark{color:#fff;border-color:#555453;background-color:#222}.emoji-mart-dark .emoji-mart-bar{border-color:#555453}.emoji-mart-dark .emoji-mart-search input{color:#fff;border-color:#555453;background-color:#2f2f2f}.emoji-mart-dark .emoji-mart-search-icon svg{fill:#fff}.emoji-mart-dark .emoji-mart-category .emoji-mart-emoji:hover:before{background-color:#444}.emoji-mart-dark .emoji-mart-category-label span{background-color:#222;color:#fff}.emoji-mart-dark .emoji-mart-skin-swatches{border-color:#555453;background-color:#222}.emoji-mart-dark .emoji-mart-anchor:hover,.emoji-mart-dark .emoji-mart-anchor:focus,.emoji-mart-dark .emoji-mart-anchor-selected{color:#bfbfbf}')),document.head.appendChild(o)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
var Wj = Object.defineProperty;
var Vj = (e, t, r) => t in e ? Wj(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var tu = (e, t, r) => (Vj(e, typeof t != "symbol" ? t + "" : t, r), r);
import * as se from "react";
import M, { useMemo as qe, useContext as Et, useState as Xe, useRef as tt, useCallback as ue, useEffect as at, memo as sh, useLayoutEffect as td, Fragment as m3, forwardRef as Xn, createContext as dr, useInsertionEffect as Aw, createElement as uh, useId as p3, cloneElement as gr, Children as Vn, isValidElement as $n, useReducer as Ow, useImperativeHandle as Tw, PureComponent as ji, Component as Hj } from "react";
import { ArrowDownFilled as Df, ArrowUpFilled as dh, PlusCircleFilled as zj, ClockFilled as Kj, CloseCircleFilled as Cf, TickCircleFilled as Yj, HangUpFilled as Xj, CallFilled as Qj, RingingOutlined as Zj, RingingFilled as Jj, PeopleFilled as eM, KeypadFilled as tM, VoicemailOutlined as xb, OutboundOutlined as rM, InboundOutlined as nM, ChevronUpOutlined as F3, ChevronDownOutlined as Su, SpinnerOutlined as Pw, TickOutlined as lh, CopyOutlined as Iw, SearchOutlined as fh, CloseOutlined as Rw, LockedFilled as aM, LoadingRedoUndoOutlined as iM, CloseCircleOutlined as oM, MenuVerticalFilled as y3, PlayFilled as sM, ControlStopFilled as uM, ChevronLeftOutlined as dM, ExternalOutlined as lM, HistoryOutlined as fM, MinusOutlined as cM, QuestionFilled as hM, InformationOutlined as gM, UserOutlined as _M } from "@aircall/icons";
import { Flex as Ae, Typography as $e, getSpace as vt, IconButton as _a, Button as nr, Spacer as Dt, ThemeProvider as jw, Icon as sr, Select as Sf, OrderDirection as __, defaultTheme as Mw, Avatar as ch, AvatarImg as Bw, AvatarText as mM, Box as ot, Tooltip as hh, ModalDialog as b3, ModalBody as v3, Banner as wl, BannerIcon as kl, BannerHeading as xl, ModalFooter as E3, FlagIcon as Nw, ComboBoxItem as pM, MenuItemPrefix as FM, MenuItemLabel as $3, MenuItemSuffix as w3, MenuItemDescription as yM, Skeleton as ls, getColor as He, useComboBox as rd, ComboBoxTrigger as Lw, ComboBoxContent as qw, ComboBoxMenu as Uw, ComboBox as Gw, TextInput as nd, usePopoverPlacement as bM, DatePicker as Db, useDropdownContext as vM, Dropdown as k3, Grid as ad, toasts as Ww, Divider as Vw, getRadii as Ba, noop as Hw, Form as x3, FormItem as fs, ActionMenu as zw, List as EM, ListView as $M, ListItem as Kw, useColor as Mr, useAudio as Yw, PlayButton as wM, MotionBox as kM, AudioCurrentTime as xM, AudioDuration as DM, AudioBar as CM, AudioManager as Xw, Audio as Qw, PasswordInput as SM, Popover as D3, Link as Zw, isScrollAtBottom as AM, isScrollAtTop as OM, Pagination as TM, useTheme as PM, Menu as C3, MenuItem as S3, Table as IM, ModalHeader as RM, ModalTitle as jM, Tag as ms, TagLabel as MM, TagDeleteIcon as BM, TabContainer as NM, TabContent as LM, TabMenu as qM, TabMenuItem as UM, TabItem as Cb, RadioGroup as Jw, Radio as ek, RadioLabel as GM, RadioDescription as WM, useSelect as VM, DropdownButton as HM } from "@aircall/tractor-v2";
import m_, { createGlobalStyle as A3, ThemeContext as zM, css as KM } from "styled-components";
import { matchPath as YM, UNSAFE_NavigationContext as XM, useLocation as Af, useNavigate as tk, Navigate as QM, Outlet as rk, useSearchParams as ZM, Link as nk } from "react-router-dom";
import { useControllableState as O3 } from "@aircall/hooks";
import { Form as T3, useField as ak, useForm as P3, Field as sl, version as JM } from "react-final-form";
import { createPortal as I3 } from "react-dom";
import { useLocation as ik, useNavigate as eB } from "react-router";
import { fieldSubscriptionItems as tB, version as rB, ARRAY_ERROR as nB } from "final-form";
function aB(e, t) {
  for (var r = 0; r < t.length; r++) {
    const n = t[r];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const a in n)
        if (a !== "default" && !(a in e)) {
          const i = Object.getOwnPropertyDescriptor(n, a);
          i && Object.defineProperty(e, a, i.get ? i : {
            enumerable: !0,
            get: () => n[a]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
var un = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function iB(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function oB(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      if (this instanceof n) {
        var a = [null];
        a.push.apply(a, arguments);
        var i = Function.bind.apply(t, a);
        return new i();
      }
      return t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Dl = {}, sB = {
  get exports() {
    return Dl;
  },
  set exports(e) {
    Dl = e;
  }
}, Bd = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Sb;
function uB() {
  if (Sb)
    return Bd;
  Sb = 1;
  var e = M, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(u, d, s) {
    var l, f = {}, c = null, h = null;
    s !== void 0 && (c = "" + s), d.key !== void 0 && (c = "" + d.key), d.ref !== void 0 && (h = d.ref);
    for (l in d)
      n.call(d, l) && !i.hasOwnProperty(l) && (f[l] = d[l]);
    if (u && u.defaultProps)
      for (l in d = u.defaultProps, d)
        f[l] === void 0 && (f[l] = d[l]);
    return { $$typeof: t, type: u, key: c, ref: h, props: f, _owner: a.current };
  }
  return Bd.Fragment = r, Bd.jsx = o, Bd.jsxs = o, Bd;
}
var Nd = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ab;
function dB() {
  return Ab || (Ab = 1, process.env.NODE_ENV !== "production" && function() {
    var e = M, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), u = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), s = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), c = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), _ = Symbol.iterator, F = "@@iterator";
    function v(L) {
      if (L === null || typeof L != "object")
        return null;
      var we = _ && L[_] || L[F];
      return typeof we == "function" ? we : null;
    }
    var $ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(L) {
      {
        for (var we = arguments.length, Te = new Array(we > 1 ? we - 1 : 0), it = 1; it < we; it++)
          Te[it - 1] = arguments[it];
        D("error", L, Te);
      }
    }
    function D(L, we, Te) {
      {
        var it = $.ReactDebugCurrentFrame, $t = it.getStackAddendum();
        $t !== "" && (we += "%s", Te = Te.concat([$t]));
        var bt = Te.map(function(ht) {
          return String(ht);
        });
        bt.unshift("Warning: " + we), Function.prototype.apply.call(console[L], console, bt);
      }
    }
    var w = !1, k = !1, A = !1, P = !1, S = !1, N;
    N = Symbol.for("react.module.reference");
    function W(L) {
      return !!(typeof L == "string" || typeof L == "function" || L === n || L === i || S || L === a || L === s || L === l || P || L === h || w || k || A || typeof L == "object" && L !== null && (L.$$typeof === c || L.$$typeof === f || L.$$typeof === o || L.$$typeof === u || L.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      L.$$typeof === N || L.getModuleId !== void 0));
    }
    function V(L, we, Te) {
      var it = L.displayName;
      if (it)
        return it;
      var $t = we.displayName || we.name || "";
      return $t !== "" ? Te + "(" + $t + ")" : Te;
    }
    function K(L) {
      return L.displayName || "Context";
    }
    function U(L) {
      if (L == null)
        return null;
      if (typeof L.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof L == "function")
        return L.displayName || L.name || null;
      if (typeof L == "string")
        return L;
      switch (L) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case s:
          return "Suspense";
        case l:
          return "SuspenseList";
      }
      if (typeof L == "object")
        switch (L.$$typeof) {
          case u:
            var we = L;
            return K(we) + ".Consumer";
          case o:
            var Te = L;
            return K(Te._context) + ".Provider";
          case d:
            return V(L, L.render, "ForwardRef");
          case f:
            var it = L.displayName || null;
            return it !== null ? it : U(L.type) || "Memo";
          case c: {
            var $t = L, bt = $t._payload, ht = $t._init;
            try {
              return U(ht(bt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var j = Object.assign, G = 0, H, J, ae, de, te, ee, ge;
    function De() {
    }
    De.__reactDisabledLog = !0;
    function xe() {
      {
        if (G === 0) {
          H = console.log, J = console.info, ae = console.warn, de = console.error, te = console.group, ee = console.groupCollapsed, ge = console.groupEnd;
          var L = {
            configurable: !0,
            enumerable: !0,
            value: De,
            writable: !0
          };
          Object.defineProperties(console, {
            info: L,
            log: L,
            warn: L,
            error: L,
            group: L,
            groupCollapsed: L,
            groupEnd: L
          });
        }
        G++;
      }
    }
    function ze() {
      {
        if (G--, G === 0) {
          var L = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: j({}, L, {
              value: H
            }),
            info: j({}, L, {
              value: J
            }),
            warn: j({}, L, {
              value: ae
            }),
            error: j({}, L, {
              value: de
            }),
            group: j({}, L, {
              value: te
            }),
            groupCollapsed: j({}, L, {
              value: ee
            }),
            groupEnd: j({}, L, {
              value: ge
            })
          });
        }
        G < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var q = $.ReactCurrentDispatcher, Ue;
    function Ce(L, we, Te) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($t) {
            var it = $t.stack.trim().match(/\n( *(at )?)/);
            Ue = it && it[1] || "";
          }
        return `
` + Ue + L;
      }
    }
    var me = !1, Fe;
    {
      var ce = typeof WeakMap == "function" ? WeakMap : Map;
      Fe = new ce();
    }
    function z(L, we) {
      if (!L || me)
        return "";
      {
        var Te = Fe.get(L);
        if (Te !== void 0)
          return Te;
      }
      var it;
      me = !0;
      var $t = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var bt;
      bt = q.current, q.current = null, xe();
      try {
        if (we) {
          var ht = function() {
            throw Error();
          };
          if (Object.defineProperty(ht.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ht, []);
            } catch (an) {
              it = an;
            }
            Reflect.construct(L, [], ht);
          } else {
            try {
              ht.call();
            } catch (an) {
              it = an;
            }
            L.call(ht.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (an) {
            it = an;
          }
          L();
        }
      } catch (an) {
        if (an && it && typeof an.stack == "string") {
          for (var dt = an.stack.split(`
`), Jt = it.stack.split(`
`), Pt = dt.length - 1, Ot = Jt.length - 1; Pt >= 1 && Ot >= 0 && dt[Pt] !== Jt[Ot]; )
            Ot--;
          for (; Pt >= 1 && Ot >= 0; Pt--, Ot--)
            if (dt[Pt] !== Jt[Ot]) {
              if (Pt !== 1 || Ot !== 1)
                do
                  if (Pt--, Ot--, Ot < 0 || dt[Pt] !== Jt[Ot]) {
                    var Pr = `
` + dt[Pt].replace(" at new ", " at ");
                    return L.displayName && Pr.includes("<anonymous>") && (Pr = Pr.replace("<anonymous>", L.displayName)), typeof L == "function" && Fe.set(L, Pr), Pr;
                  }
                while (Pt >= 1 && Ot >= 0);
              break;
            }
        }
      } finally {
        me = !1, q.current = bt, ze(), Error.prepareStackTrace = $t;
      }
      var Ur = L ? L.displayName || L.name : "", nn = Ur ? Ce(Ur) : "";
      return typeof L == "function" && Fe.set(L, nn), nn;
    }
    function Me(L, we, Te) {
      return z(L, !1);
    }
    function le(L) {
      var we = L.prototype;
      return !!(we && we.isReactComponent);
    }
    function Be(L, we, Te) {
      if (L == null)
        return "";
      if (typeof L == "function")
        return z(L, le(L));
      if (typeof L == "string")
        return Ce(L);
      switch (L) {
        case s:
          return Ce("Suspense");
        case l:
          return Ce("SuspenseList");
      }
      if (typeof L == "object")
        switch (L.$$typeof) {
          case d:
            return Me(L.render);
          case f:
            return Be(L.type, we, Te);
          case c: {
            var it = L, $t = it._payload, bt = it._init;
            try {
              return Be(bt($t), we, Te);
            } catch {
            }
          }
        }
      return "";
    }
    var rt = Object.prototype.hasOwnProperty, ve = {}, qt = $.ReactDebugCurrentFrame;
    function fr(L) {
      if (L) {
        var we = L._owner, Te = Be(L.type, L._source, we ? we.type : null);
        qt.setExtraStackFrame(Te);
      } else
        qt.setExtraStackFrame(null);
    }
    function Kt(L, we, Te, it, $t) {
      {
        var bt = Function.call.bind(rt);
        for (var ht in L)
          if (bt(L, ht)) {
            var dt = void 0;
            try {
              if (typeof L[ht] != "function") {
                var Jt = Error((it || "React class") + ": " + Te + " type `" + ht + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof L[ht] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Jt.name = "Invariant Violation", Jt;
              }
              dt = L[ht](we, ht, it, Te, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Pt) {
              dt = Pt;
            }
            dt && !(dt instanceof Error) && (fr($t), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", it || "React class", Te, ht, typeof dt), fr(null)), dt instanceof Error && !(dt.message in ve) && (ve[dt.message] = !0, fr($t), E("Failed %s type: %s", Te, dt.message), fr(null));
          }
      }
    }
    var hr = Array.isArray;
    function mr(L) {
      return hr(L);
    }
    function Lr(L) {
      {
        var we = typeof Symbol == "function" && Symbol.toStringTag, Te = we && L[Symbol.toStringTag] || L.constructor.name || "Object";
        return Te;
      }
    }
    function Oe(L) {
      try {
        return Pe(L), !1;
      } catch {
        return !0;
      }
    }
    function Pe(L) {
      return "" + L;
    }
    function st(L) {
      if (Oe(L))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Lr(L)), Pe(L);
    }
    var Qe = $.ReactCurrentOwner, et = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Tt, qr, hn;
    hn = {};
    function Cn(L) {
      if (rt.call(L, "ref")) {
        var we = Object.getOwnPropertyDescriptor(L, "ref").get;
        if (we && we.isReactWarning)
          return !1;
      }
      return L.ref !== void 0;
    }
    function gn(L) {
      if (rt.call(L, "key")) {
        var we = Object.getOwnPropertyDescriptor(L, "key").get;
        if (we && we.isReactWarning)
          return !1;
      }
      return L.key !== void 0;
    }
    function Zn(L, we) {
      if (typeof L.ref == "string" && Qe.current && we && Qe.current.stateNode !== we) {
        var Te = U(Qe.current.type);
        hn[Te] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', U(Qe.current.type), L.ref), hn[Te] = !0);
      }
    }
    function Sn(L, we) {
      {
        var Te = function() {
          Tt || (Tt = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", we));
        };
        Te.isReactWarning = !0, Object.defineProperty(L, "key", {
          get: Te,
          configurable: !0
        });
      }
    }
    function va(L, we) {
      {
        var Te = function() {
          qr || (qr = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", we));
        };
        Te.isReactWarning = !0, Object.defineProperty(L, "ref", {
          get: Te,
          configurable: !0
        });
      }
    }
    var Ea = function(L, we, Te, it, $t, bt, ht) {
      var dt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: L,
        key: we,
        ref: Te,
        props: ht,
        // Record the component responsible for creating this element.
        _owner: bt
      };
      return dt._store = {}, Object.defineProperty(dt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(dt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: it
      }), Object.defineProperty(dt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $t
      }), Object.freeze && (Object.freeze(dt.props), Object.freeze(dt)), dt;
    };
    function _n(L, we, Te, it, $t) {
      {
        var bt, ht = {}, dt = null, Jt = null;
        Te !== void 0 && (st(Te), dt = "" + Te), gn(we) && (st(we.key), dt = "" + we.key), Cn(we) && (Jt = we.ref, Zn(we, $t));
        for (bt in we)
          rt.call(we, bt) && !et.hasOwnProperty(bt) && (ht[bt] = we[bt]);
        if (L && L.defaultProps) {
          var Pt = L.defaultProps;
          for (bt in Pt)
            ht[bt] === void 0 && (ht[bt] = Pt[bt]);
        }
        if (dt || Jt) {
          var Ot = typeof L == "function" ? L.displayName || L.name || "Unknown" : L;
          dt && Sn(ht, Ot), Jt && va(ht, Ot);
        }
        return Ea(L, dt, Jt, $t, it, Qe.current, ht);
      }
    }
    var xr = $.ReactCurrentOwner, Oo = $.ReactDebugCurrentFrame;
    function Jn(L) {
      if (L) {
        var we = L._owner, Te = Be(L.type, L._source, we ? we.type : null);
        Oo.setExtraStackFrame(Te);
      } else
        Oo.setExtraStackFrame(null);
    }
    var ea;
    ea = !1;
    function An(L) {
      return typeof L == "object" && L !== null && L.$$typeof === t;
    }
    function To() {
      {
        if (xr.current) {
          var L = U(xr.current.type);
          if (L)
            return `

Check the render method of \`` + L + "`.";
        }
        return "";
      }
    }
    function Ms(L) {
      {
        if (L !== void 0) {
          var we = L.fileName.replace(/^.*[\\\/]/, ""), Te = L.lineNumber;
          return `

Check your code at ` + we + ":" + Te + ".";
        }
        return "";
      }
    }
    var Dr = {};
    function ta(L) {
      {
        var we = To();
        if (!we) {
          var Te = typeof L == "string" ? L : L.displayName || L.name;
          Te && (we = `

Check the top-level render call using <` + Te + ">.");
        }
        return we;
      }
    }
    function ra(L, we) {
      {
        if (!L._store || L._store.validated || L.key != null)
          return;
        L._store.validated = !0;
        var Te = ta(we);
        if (Dr[Te])
          return;
        Dr[Te] = !0;
        var it = "";
        L && L._owner && L._owner !== xr.current && (it = " It was passed a child from " + U(L._owner.type) + "."), Jn(L), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Te, it), Jn(null);
      }
    }
    function na(L, we) {
      {
        if (typeof L != "object")
          return;
        if (mr(L))
          for (var Te = 0; Te < L.length; Te++) {
            var it = L[Te];
            An(it) && ra(it, we);
          }
        else if (An(L))
          L._store && (L._store.validated = !0);
        else if (L) {
          var $t = v(L);
          if (typeof $t == "function" && $t !== L.entries)
            for (var bt = $t.call(L), ht; !(ht = bt.next()).done; )
              An(ht.value) && ra(ht.value, we);
        }
      }
    }
    function Bs(L) {
      {
        var we = L.type;
        if (we == null || typeof we == "string")
          return;
        var Te;
        if (typeof we == "function")
          Te = we.propTypes;
        else if (typeof we == "object" && (we.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        we.$$typeof === f))
          Te = we.propTypes;
        else
          return;
        if (Te) {
          var it = U(we);
          Kt(Te, L.props, "prop", it, L);
        } else if (we.PropTypes !== void 0 && !ea) {
          ea = !0;
          var $t = U(we);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $t || "Unknown");
        }
        typeof we.getDefaultProps == "function" && !we.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function aa(L) {
      {
        for (var we = Object.keys(L.props), Te = 0; Te < we.length; Te++) {
          var it = we[Te];
          if (it !== "children" && it !== "key") {
            Jn(L), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", it), Jn(null);
            break;
          }
        }
        L.ref !== null && (Jn(L), E("Invalid attribute `ref` supplied to `React.Fragment`."), Jn(null));
      }
    }
    function On(L, we, Te, it, $t, bt) {
      {
        var ht = W(L);
        if (!ht) {
          var dt = "";
          (L === void 0 || typeof L == "object" && L !== null && Object.keys(L).length === 0) && (dt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Jt = Ms($t);
          Jt ? dt += Jt : dt += To();
          var Pt;
          L === null ? Pt = "null" : mr(L) ? Pt = "array" : L !== void 0 && L.$$typeof === t ? (Pt = "<" + (U(L.type) || "Unknown") + " />", dt = " Did you accidentally export a JSX literal instead of a component?") : Pt = typeof L, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Pt, dt);
        }
        var Ot = _n(L, we, Te, $t, bt);
        if (Ot == null)
          return Ot;
        if (ht) {
          var Pr = we.children;
          if (Pr !== void 0)
            if (it)
              if (mr(Pr)) {
                for (var Ur = 0; Ur < Pr.length; Ur++)
                  na(Pr[Ur], L);
                Object.freeze && Object.freeze(Pr);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              na(Pr, L);
        }
        return L === n ? aa(Ot) : Bs(Ot), Ot;
      }
    }
    function Ns(L, we, Te) {
      return On(L, we, Te, !0);
    }
    function ia(L, we, Te) {
      return On(L, we, Te, !1);
    }
    var Tn = ia, oa = Ns;
    Nd.Fragment = n, Nd.jsx = Tn, Nd.jsxs = oa;
  }()), Nd;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = uB() : e.exports = dB();
})(sB);
const Nr = Dl.Fragment, b = Dl.jsx, ne = Dl.jsxs, Ob = {
  small: "16px",
  regular: "24px"
}, lB = {
  small: "supportingRegularXS",
  regular: "supportingMediumS"
};
function ok({
  "data-test": e = "count",
  size: t = "regular",
  value: r
}) {
  return /* @__PURE__ */ b(
    Ae,
    {
      backgroundColor: "graphic-inverted",
      borderRadius: "full",
      display: "flex",
      justifyContent: "center",
      minH: Ob[t],
      minWidth: Ob[t],
      px: "xxs",
      py: "xxxs",
      children: /* @__PURE__ */ b(
        $e,
        {
          alignSelf: "center",
          color: "text-inverted",
          "data-test": e,
          variant: lB[t],
          children: r
        }
      )
    }
  );
}
const fB = process.env.NODE_ENV !== "production", sk = ["__proto__", "constructor", "prototype"], sn = (e) => e != null, ho = (e) => typeof e == "number" && !Number.isNaN(e), wn = (e) => typeof e == "string" && e !== "", Au = (e) => typeof e == "object" && e !== null, uk = (e) => typeof e == "function", cB = (e) => ho(e) && e < 0, hB = (e, t) => {
  const r = String(t).split("."), n = r.length;
  let a = e;
  for (let i = 0; i < n; i += 1) {
    if (!sn(a))
      return a;
    const o = r[i];
    a = sn(a[o]) ? a[o] : void 0;
  }
  return a;
}, dk = (e, t) => {
  if (!sn(t))
    return e;
  for (const r in t)
    sk.indexOf(r) === -1 && (e[r] = t[r]);
  return e;
}, R3 = (e, t) => {
  if (!sn(t))
    return e;
  for (const r in t)
    sk.indexOf(r) === -1 && (Au(e[r]) ? e[r] = R3(dk({}, e[r]), t[r]) : e[r] = t[r]);
  return e;
}, gB = (e, t) => {
  fB && !e && console.error && console.error(t);
};
function gh(e, t) {
  return typeof e == "function" ? gh(e(t), t) : e;
}
const j1 = (e, t, r = e.theme) => gh(hB(r, t), e);
function _B(e) {
  return e.reduce((t, r) => {
    const n = t.length - 1, a = t[n];
    return typeof a == "string" && typeof r == "string" ? t[n] = a + r : t.push(r), t;
  }, []);
}
var Tb = Math.pow;
const lk = (e) => Math.round(e * Tb(10, 4)) / Tb(10, 4), j3 = (e) => (t) => ho(t) && t !== 0 ? `${t}${e}` : t, mB = j3("ms"), _h = j3("px"), pB = j3("deg"), FB = (e, { rootFontSize: t = 16 } = {}) => lk(e / t), fk = (e, t) => {
  if (!wn(e) || e.length < 4 || e.slice(-3) !== "rpx")
    return e;
  const n = Number(e.slice(0, e.length - 3));
  return n === 0 ? 0 : `${FB(n, t)}rem`;
}, yB = (e) => ho(e) && e !== 0 && e >= -1 && e <= 1 ? `${lk(e * 100)}%` : e, ck = (e, { rawValue: t, variants: r, props: n }) => {
  if (wn(t)) {
    const a = t.startsWith("-"), i = a ? t.substr(1) : t, o = j1(n, i, r), u = wn(o) || ho(o) ? o : i;
    return a ? `-${u}` : u;
  }
  if (ho(t)) {
    const a = cB(t), i = Math.abs(t), o = r ? r[i] : void 0;
    if (wn(o))
      return a ? `-${o}` : o;
    const u = ho(o) ? o : i;
    return a ? u * -1 : u;
  }
}, bB = (e) => e ? `@media (min-width: ${e})` : null, hk = (e, t) => {
  const r = e[t];
  return r === 0 ? null : _h(r);
}, vB = (e, t) => {
  const r = e[t];
  return r === 0 ? null : _h(r - 0.02);
};
var EB = Object.defineProperty, Pb = Object.getOwnPropertySymbols, $B = Object.prototype.hasOwnProperty, wB = Object.prototype.propertyIsEnumerable, Ib = (e, t, r) => t in e ? EB(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Rb = (e, t) => {
  for (var r in t || (t = {}))
    $B.call(t, r) && Ib(e, r, t[r]);
  if (Pb)
    for (var r of Pb(t))
      wB.call(t, r) && Ib(e, r, t[r]);
  return e;
};
const M3 = (e) => e.theme && e.theme.screens ? e.theme.screens : {}, kB = (e) => e.theme && e.theme.states ? e.theme.states : {}, xB = (e) => {
  const t = M3(e), r = kB(e), n = {};
  for (const i in t)
    n[i] = bB(hk(t, i));
  const a = Rb(Rb({}, n), r);
  for (const [i, o] of Object.entries(a))
    o && o.startsWith("@") && (delete a[i], a[i] = o);
  return a;
}, gk = (e, t) => {
  if (t.has("_variants"))
    return t.get("_variants");
  const r = xB(e);
  return t.set("_variants", r), r;
}, DB = typeof Map < "u" && typeof WeakMap < "u", Xc = DB ? /* @__PURE__ */ new WeakMap() : null, CB = (e) => {
  var t;
  return ((t = e == null ? void 0 : e.xstyled) == null ? void 0 : t.cache) === !1;
}, SB = (e) => {
  if (CB(e) || Xc === null)
    return null;
  if (Xc.has(e))
    return Xc.get(e) || null;
  const r = {};
  return Xc.set(e, r), r;
}, jb = {
  has: () => !1,
  set: () => {
  },
  get: () => {
  }
}, mh = (e, t) => {
  if (!e)
    return jb;
  const r = SB(e);
  return !r || !e ? jb : (r[t] = r[t] || /* @__PURE__ */ new Map(), r[t]);
};
var AB = Object.defineProperty, Mb = Object.getOwnPropertySymbols, OB = Object.prototype.hasOwnProperty, TB = Object.prototype.propertyIsEnumerable, Bb = (e, t, r) => t in e ? AB(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, PB = (e, t) => {
  for (var r in t || (t = {}))
    OB.call(t, r) && Bb(e, r, t[r]);
  if (Mb)
    for (var r of Mb(t))
      TB.call(t, r) && Bb(e, r, t[r]);
  return e;
};
let IB = 0;
const Nb = {
  shorthand: [/\s+/, " "],
  multiple: [/\s*,\s*/, ","]
}, Lb = (e, t) => (r) => r.split(e[0]).map(t).join(e[1]), Nt = ({
  name: e,
  transform: t,
  key: r,
  compose: n,
  shorthand: a,
  multiple: i
}) => {
  const o = IB++, u = (d, s) => (l) => {
    let f = d;
    if (!wn(d) && !ho(d) && d !== !0)
      return f;
    const c = `${typeof d}-${d}-${s}`, h = mh(l.theme, `__themeGetter${o}`);
    if (h.has(c))
      return h.get(c);
    const _ = (F) => {
      const v = sn(s) ? s : F;
      let $ = F;
      const E = sn(r) ? j1(l, r) : null;
      if (sn(E)) {
        const k = F === !0 ? "default" : wn(F) || ho(F) ? F : null;
        if (sn(k)) {
          const A = j1(l, k, E);
          $ = Array.isArray(A) ? A.join(",") : A;
        }
      }
      let D = F;
      sn($) || (D = v, $ = v);
      const w = (e && l.theme && l.theme.transformers ? l.theme.transformers[e] : null) || t;
      return w && ($ = w($, {
        rawValue: D,
        variants: E,
        props: l
      })), n ? n($)(l) : $;
    };
    if ((a || i) && wn(d)) {
      let F = _;
      a && (F = Lb(Nb.shorthand, F)), i && (F = Lb(Nb.multiple, F)), f = F(d);
    } else
      f = _(d);
    return h.set(c, f), f;
  };
  return u.meta = { name: e, transform: t }, u;
}, ph = ({
  getStyle: e,
  props: t,
  cssGetters: r = {},
  generators: n
}) => {
  const a = e;
  return a.meta = {
    props: t,
    cssGetters: r,
    getStyle: a,
    generators: n
  }, a.apply = (i) => ({ theme: o }) => a(PB({ theme: o }, i)), a;
}, M1 = (e, t, r) => {
  const n = mh(e.theme, "__variants"), a = gk(e, n);
  let i = {};
  for (const o in t) {
    const u = r(t[o]);
    if (u === null)
      continue;
    const d = o in a ? a[o] : o;
    d !== void 0 && (d === null ? i = R3(i, u) : i[d] = i[d] ? dk(i[d], u) : u);
  }
  return i;
}, RB = (e, t, r) => (n) => {
  const a = (s) => sn(s) ? Au(s) ? M1(n, s, a) : gh(t(r ? r(s)(n) : s), n) : null, i = n[e];
  if (!sn(i))
    return null;
  const o = mh(n.theme, e), u = Au(i) ? JSON.stringify(i) : i;
  if (o.has(u))
    return o.get(u);
  const d = a(i);
  return o.set(u, d), d;
}, jB = (e) => {
  const t = {};
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    if (n && n.meta)
      for (let a = 0; a < n.meta.props.length; a++) {
        const i = n.meta.props[a];
        t[i] = n;
      }
  }
  return t;
}, MB = (e, t) => {
  for (const r in t) {
    const n = t[r], a = e[n];
    a && (delete e[n], e[n] = a);
  }
  return e;
};
function br(...e) {
  let t = [];
  e.forEach((o) => {
    gB(Boolean(o), 'Undefined generator in "compose" method'), o && (o.meta.generators ? t = [...t, ...o.meta.generators] : t.push(o));
  });
  const r = jB(t), n = (o, u = !0) => {
    const d = {};
    let s;
    for (const f in o) {
      const c = r[f];
      if (c) {
        const h = c.meta.getStyle(o, !1);
        R3(d, h), s = !0;
      }
    }
    if (!s || !u)
      return d;
    const l = gk(o, mh(o.theme, "__states"));
    return MB(d, l);
  }, a = [], i = {};
  for (let o = 0; o < t.length; o++) {
    const u = t[o];
    a.push(...u.meta.props), Object.assign(i, u.meta.cssGetters);
  }
  return ph({ getStyle: n, props: a, cssGetters: i, generators: e });
}
const BB = (e) => (t) => {
  if (wn(e))
    return { [e]: t };
  const r = {};
  for (const n in e)
    r[e[n]] = t;
  return r;
}, qb = (e) => uk(e) ? e : BB(e), NB = (e) => e.replace(/[A-Z]/g, "-$&").toLowerCase(), ie = ({
  prop: e,
  css: t,
  themeGet: r,
  key: n,
  transform: a,
  cssProps: i
}) => {
  const o = r || (n || a ? Nt({ key: n, transform: a }) : void 0), u = i || (wn(t) ? [t] : Array.isArray(t) ? t : wn(e) ? [e] : Array.isArray(e) ? e : []);
  if (Array.isArray(e)) {
    const _ = t && qb(t), F = e.map(
      (v) => ie({ prop: v, css: _, cssProps: u, themeGet: o })
    );
    return br(...F);
  }
  const d = [e], s = qb(t || d), l = [], f = RB(e, s, o), c = o ? u.reduce((_, F) => (_[NB(F)] = o, _), {}) : {}, h = ph({ getStyle: f, props: d, cssGetters: c });
  return l.push(h), br(...l);
}, Mi = Nt({
  name: "px",
  transform: (e, { props: t }) => {
    var r, n, a;
    const i = (a = (n = (r = t == null ? void 0 : t.theme) == null ? void 0 : r.settings) == null ? void 0 : n.rootFontSize) != null ? a : void 0, o = Number(e);
    return _h(fk(Number.isNaN(o) ? e : o, { rootFontSize: i }));
  }
}), Fh = Nt({
  name: "duration",
  key: "durations",
  transform: (e) => {
    const t = Number(e);
    return mB(Number.isNaN(t) ? e : t);
  }
}), yh = Nt({
  name: "angle",
  transform: (e) => {
    const t = Number(e);
    return pB(Number.isNaN(t) ? e : t);
  }
}), Of = Nt({
  name: "percent",
  compose: Mi,
  transform: yB
}), _k = Nt({
  name: "transition",
  key: "transitions"
}), mk = Nt({
  name: "transitionProperty",
  key: "transitionProperties"
}), B3 = Nt({
  name: "timingFunction",
  key: "timingFunctions"
}), LB = ie({
  prop: "transition",
  themeGet: _k
}), qB = ie({
  prop: "transitionProperty",
  themeGet: mk
}), UB = ie({
  prop: "transitionDuration",
  themeGet: Fh
}), GB = ie({
  prop: "transitionTimingFunction",
  themeGet: B3
}), WB = ie({
  prop: "transitionDelay",
  themeGet: Fh
}), VB = br(
  LB,
  qB,
  UB,
  GB,
  WB
), pk = Nt({
  name: "animation",
  key: "animations"
}), HB = ie({
  prop: "animation",
  themeGet: pk
}), zB = ie({
  prop: "animationDuration",
  themeGet: Fh
}), KB = ie({
  prop: "animationTimingFunction",
  themeGet: B3
}), YB = br(
  HB,
  zB,
  KB
), pt = Nt({
  name: "color",
  key: "colors"
}), Fk = {
  "gradient-to-t": "linear-gradient(to top, var(--x-gradient-stops))",
  "gradient-to-tr": "linear-gradient(to top right, var(--x-gradient-stops))",
  "gradient-to-r": "linear-gradient(to right, var(--x-gradient-stops))",
  "gradient-to-br": "linear-gradient(to bottom right, var(--x-gradient-stops))",
  "gradient-to-b": "linear-gradient(to bottom, var(--x-gradient-stops))",
  "gradient-to-bl": "linear-gradient(to bottom left, var(--x-gradient-stops))",
  "gradient-to-l": "linear-gradient(to left, var(--x-gradient-stops))",
  "gradient-to-tl": "linear-gradient(to top left, var(--x-gradient-stops))"
}, XB = ie({
  prop: "background",
  css: (e) => ({
    background: Fk[e] || e
  })
}), QB = ie({
  prop: ["backgroundColor", "bg"],
  css: "backgroundColor",
  themeGet: pt
}), ZB = ie({
  prop: "backgroundImage",
  css: (e) => ({
    backgroundImage: Fk[e] || e
  })
}), JB = ie({
  prop: "backgroundSize"
}), eN = ie({
  prop: "backgroundPosition"
}), tN = ie({
  prop: "backgroundRepeat"
}), rN = ie({
  prop: "backgroundAttachment"
}), nN = ie({
  prop: "backgroundClip",
  css: ["backgroundClip", "-webkitBackgroundClip"]
}), aN = ie({
  prop: "gradientFrom",
  themeGet: pt,
  css: (e) => ({
    "--x-gradient-from": e,
    "--x-gradient-stops": "var(--x-gradient-from), var(--x-gradient-to, transparent)"
  })
}), iN = ie({
  prop: "gradientVia",
  themeGet: pt,
  css: (e) => ({
    "--x-gradient-stops": `var(--x-gradient-from), ${e}, var(--x-gradient-to, transparent)`
  })
}), oN = ie({
  prop: "gradientTo",
  themeGet: pt,
  css: "--x-gradient-to"
}), sN = br(
  XB,
  QB,
  ZB,
  JB,
  eN,
  tN,
  rN,
  nN,
  aN,
  iN,
  oN
), ws = Nt({
  name: "border",
  key: "borders",
  transform: (e) => {
    const t = Number(e);
    return t > 0 ? `${_h(t)} solid` : e;
  }
}), Ya = Nt({
  name: "borderWidth",
  key: "borderWidths",
  compose: Mi,
  shorthand: !0
}), yk = Nt({
  name: "borderColor",
  compose: pt,
  shorthand: !0
}), $o = Nt({
  name: "borderStyle",
  key: "borderStyles"
}), uN = ie({
  prop: "border",
  themeGet: ws
}), dN = ie({
  prop: "borderTop",
  themeGet: ws
}), lN = ie({
  prop: "borderRight",
  themeGet: ws
}), fN = ie({
  prop: "borderBottom",
  themeGet: ws
}), cN = ie({
  prop: "borderLeft",
  themeGet: ws
}), hN = ie({
  prop: "borderColor",
  themeGet: yk
}), gN = ie({
  prop: "borderTopColor",
  themeGet: pt
}), _N = ie({
  prop: "borderRightColor",
  themeGet: pt
}), mN = ie({
  prop: "borderBottomColor",
  themeGet: pt
}), pN = ie({
  prop: "borderLeftColor",
  themeGet: pt
}), FN = ie({
  prop: "borderWidth",
  themeGet: Ya
}), yN = ie({
  prop: "borderTopWidth",
  themeGet: Ya
}), bN = ie({
  prop: "borderRightWidth",
  themeGet: Ya
}), vN = ie({
  prop: "borderBottomWidth",
  themeGet: Ya
}), EN = ie({
  prop: "borderLeftWidth",
  themeGet: Ya
}), $N = ie({
  prop: "borderStyle",
  themeGet: $o,
  cssProps: [
    "borderStyle",
    "borderTopStyle",
    "borderRightStyle",
    "borderBottomStyle",
    "borderLeftStyle"
  ]
}), wN = ie({
  prop: "borderTopStyle",
  themeGet: $o
}), kN = ie({
  prop: "borderRightStyle",
  themeGet: $o
}), xN = ie({
  prop: "borderBottomStyle",
  themeGet: $o
}), DN = ie({
  prop: "borderLeftStyle",
  themeGet: $o
}), CN = ie({
  prop: "outline",
  themeGet: ws
}), SN = ie({
  prop: "outlineColor",
  themeGet: pt
}), AN = ie({
  prop: "outlineWidth",
  themeGet: Ya
}), ON = ie({
  prop: "outlineStyle",
  themeGet: $o
}), TN = ie({
  prop: "outlineOffset",
  themeGet: Ya
}), bk = Nt({
  name: "radius",
  key: "radii",
  compose: Mi,
  shorthand: !0
}), PN = ie({
  prop: "borderRadius",
  themeGet: bk,
  cssProps: [
    "borderRadius",
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomRightRadius",
    "borderBottomLeftRadius"
  ]
}), id = "& > :not([hidden]) ~ :not([hidden])", IN = ie({
  prop: "divideY",
  themeGet: Ya,
  css: (e) => {
    const t = e === !0 ? 1 : e;
    return {
      [id]: {
        "--x-divide-y-reverse": 0,
        borderTopWidth: `calc(${t} * calc(1 - var(--x-divide-y-reverse)))`,
        borderBottomWidth: `calc(${t} * var(--x-divide-y-reverse))`
      }
    };
  }
}), RN = ie({
  prop: "divideX",
  themeGet: Ya,
  css: (e) => {
    const t = e === !0 ? 1 : e;
    return {
      [id]: {
        "--x-divide-x-reverse": 0,
        borderRightWidth: `calc(${t} * var(--x-divide-x-reverse))`,
        borderLeftWidth: `calc(${t} * calc(1 - var(--x-divide-x-reverse)))`
      }
    };
  }
}), jN = ie({
  prop: "divideXReverse",
  css: () => ({
    [id]: {
      "--x-divide-x-reverse": "1"
    }
  })
}), MN = ie({
  prop: "divideYReverse",
  css: () => ({
    [id]: {
      "--x-divide-y-reverse": "1"
    }
  })
}), BN = ie({
  prop: "divideColor",
  themeGet: pt,
  css: (e) => ({
    [id]: {
      borderColor: e
    }
  })
}), NN = ie({
  prop: "divideStyle",
  themeGet: $o,
  css: (e) => ({
    [id]: {
      borderStyle: e
    }
  })
}), vk = Nt({
  name: "ringWidth",
  key: "ringWidths",
  compose: Mi
}), LN = ie({
  prop: "ring",
  themeGet: vk,
  css: (e) => ({
    "--x-ring-shadow": `var(--x-ring-inset, /*!*/ /*!*/) 0 0 0 ${e} var(--x-ring-color)`,
    boxShadow: "var(--x-ring-shadow, 0 0 #0000), var(--x-shadow, 0 0 #0000)"
  })
}), qN = ie({
  prop: "ringInset",
  css: () => ({ "--x-ring-inset": "inset" })
}), UN = ie({
  prop: "ringColor",
  themeGet: pt,
  css: (e) => ({ "--x-ring-color": e })
}), GN = br(
  uN,
  dN,
  lN,
  fN,
  cN,
  hN,
  gN,
  _N,
  mN,
  pN,
  FN,
  yN,
  bN,
  vN,
  EN,
  $N,
  wN,
  kN,
  xN,
  DN,
  PN,
  CN,
  SN,
  AN,
  ON,
  TN,
  RN,
  IN,
  jN,
  MN,
  BN,
  NN,
  LN,
  qN,
  UN
), bh = Nt({
  name: "shadow",
  key: "shadows",
  multiple: !0
}), WN = ie({
  prop: "opacity"
}), VN = ie({
  prop: "boxShadow",
  themeGet: bh,
  css: (e) => ({
    "--x-shadow": e,
    boxShadow: "var(--x-ring-shadow, 0 0 #0000), var(--x-shadow)"
  })
}), HN = ie({
  prop: "textShadow",
  themeGet: bh
}), zN = br(WN, VN, HN);
var KN = Object.defineProperty, Ub = Object.getOwnPropertySymbols, YN = Object.prototype.hasOwnProperty, XN = Object.prototype.propertyIsEnumerable, Gb = (e, t, r) => t in e ? KN(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Qc = (e, t) => {
  for (var r in t || (t = {}))
    YN.call(t, r) && Gb(e, r, t[r]);
  if (Ub)
    for (var r of Ub(t))
      XN.call(t, r) && Gb(e, r, t[r]);
  return e;
};
const QN = ie({
  prop: "row",
  css: () => ({
    boxSizing: "border-box",
    flexGrow: 1,
    flexWrap: "wrap",
    display: "flex"
  })
}), Wb = (e, t) => {
  if (!sn(t))
    return null;
  if (t === !0)
    return {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    };
  if (t === "auto")
    return {
      flex: "0 0 auto",
      maxWidth: "none",
      width: "auto"
    };
  const r = Of(t)(e);
  return {
    flex: `0 0 ${r}`,
    maxWidth: r
  };
}, ZN = ph({
  getStyle: (e) => {
    const t = e.col, r = {
      boxSizing: "border-box",
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    };
    if (Au(t)) {
      const n = M1(
        e,
        t,
        (a) => Wb(e, a)
      );
      return Qc(Qc({}, r), n);
    }
    return Qc(Qc({}, r), Wb(e, t));
  },
  props: ["col"]
}), JN = br(QN, ZN);
var eL = Object.defineProperty, Vb = Object.getOwnPropertySymbols, tL = Object.prototype.hasOwnProperty, rL = Object.prototype.propertyIsEnumerable, Hb = (e, t, r) => t in e ? eL(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, nL = (e, t) => {
  for (var r in t || (t = {}))
    tL.call(t, r) && Hb(e, r, t[r]);
  if (Vb)
    for (var r of Vb(t))
      rL.call(t, r) && Hb(e, r, t[r]);
  return e;
};
const Ek = ie({
  prop: "display"
}), aL = ie({
  prop: "float"
}), iL = ie({
  prop: "boxSizing"
}), oL = ph({
  getStyle: (e) => {
    if (!e.container)
      return null;
    const t = M3(e);
    let r = M1(
      e,
      t,
      (n) => n !== 0 ? { maxWidth: n } : {}
    );
    return Au(e.container) && (r = M1(e, e.container, () => r)), nL({
      width: "100%"
    }, r);
  },
  props: ["container"]
}), sL = ie({
  prop: "overflow"
}), uL = ie({
  prop: "overflowX"
}), dL = ie({
  prop: "overflowY"
}), $k = Nt({
  name: "zIndex",
  key: "zIndices"
}), lL = ie({
  prop: "zIndex",
  themeGet: $k
}), fL = ie({
  prop: "position"
}), Tf = Nt({
  name: "inset",
  key: "inset",
  compose: Mi,
  transform: ck
}), cL = ie({
  prop: "top",
  themeGet: Tf
}), hL = ie({
  prop: "right",
  themeGet: Tf
}), gL = ie({
  prop: "bottom",
  themeGet: Tf
}), _L = ie({
  prop: "left",
  themeGet: Tf
}), mL = ie({
  prop: "visibility"
}), pL = ie({
  prop: "overscrollBehavior"
}), FL = ie({
  prop: "objectFit"
}), yL = br(
  iL,
  Ek,
  aL,
  oL,
  sL,
  uL,
  dL,
  fL,
  lL,
  cL,
  hL,
  gL,
  _L,
  mL,
  pL,
  FL
), bL = ie({
  prop: "alignItems"
}), vL = ie({
  prop: "alignContent"
}), EL = ie({
  prop: "justifyContent"
}), $L = ie({
  prop: "justifyItems"
}), wL = ie({
  prop: "flexWrap"
}), kL = ie({
  prop: "flexGrow"
}), xL = ie({
  prop: "flexShrink"
}), DL = ie({
  prop: "flexBasis",
  themeGet: Of
}), CL = ie({
  prop: "flexDirection"
}), SL = ie({
  prop: "flex"
}), AL = ie({
  prop: "justifySelf"
}), OL = ie({
  prop: "alignSelf"
}), TL = ie({
  prop: "order"
}), PL = br(
  Ek,
  bL,
  vL,
  EL,
  $L,
  wL,
  DL,
  xL,
  kL,
  CL,
  SL,
  AL,
  OL,
  TL
), lr = Nt({
  name: "space",
  key: "space",
  compose: Mi,
  shorthand: !0,
  transform: ck
}), IL = ie({
  prop: ["margin", "m"],
  themeGet: lr,
  css: "margin"
}), RL = ie({
  prop: ["marginTop", "mt"],
  themeGet: lr,
  css: "marginTop"
}), jL = ie({
  prop: ["marginRight", "mr"],
  themeGet: lr,
  css: "marginRight"
}), ML = ie({
  prop: ["marginBottom", "mb"],
  themeGet: lr,
  css: "marginBottom"
}), BL = ie({
  prop: ["marginLeft", "ml"],
  themeGet: lr,
  css: "marginLeft"
}), NL = ie({
  prop: "mx",
  themeGet: lr,
  css: ["marginRight", "marginLeft"]
}), LL = ie({
  prop: "my",
  themeGet: lr,
  css: ["marginTop", "marginBottom"]
}), qL = ie({
  prop: ["padding", "p"],
  themeGet: lr,
  css: "padding"
}), UL = ie({
  prop: ["paddingTop", "pt"],
  themeGet: lr,
  css: "paddingTop"
}), GL = ie({
  prop: ["paddingRight", "pr"],
  themeGet: lr,
  css: "paddingRight"
}), WL = ie({
  prop: ["paddingBottom", "pb"],
  themeGet: lr,
  css: "paddingBottom"
}), VL = ie({
  prop: ["paddingLeft", "pl"],
  themeGet: lr,
  css: "paddingLeft"
}), HL = ie({
  prop: "px",
  themeGet: lr,
  css: ["paddingRight", "paddingLeft"]
}), zL = ie({
  prop: "py",
  themeGet: lr,
  css: ["paddingTop", "paddingBottom"]
}), KL = ie({
  prop: "spaceY",
  themeGet: lr,
  css: (e) => ({
    "& > :not([hidden]) ~ :not([hidden])": {
      "--x-space-y-reverse": 0,
      marginTop: `calc(${e} * calc(1 - var(--x-space-y-reverse)))`,
      marginBottom: `calc(${e} * var(--x-space-y-reverse))`
    }
  })
}), YL = ie({
  prop: "spaceX",
  themeGet: lr,
  css: (e) => ({
    "& > :not([hidden]) ~ :not([hidden])": {
      "--x-space-x-reverse": 0,
      marginRight: `calc(${e} * var(--x-space-x-reverse))`,
      marginLeft: `calc(${e} * calc(1 - var(--x-space-x-reverse)))`
    }
  })
}), XL = ie({
  prop: "spaceXReverse",
  css: () => ({
    "& > :not([hidden]) ~ :not([hidden])": {
      "--x-space-x-reverse": "1"
    }
  })
}), QL = ie({
  prop: "spaceYReverse",
  css: () => ({
    "& > :not([hidden]) ~ :not([hidden])": {
      "--x-space-y-reverse": "1"
    }
  })
}), wk = br(
  IL,
  RL,
  jL,
  ML,
  BL,
  NL,
  LL,
  qL,
  UL,
  GL,
  WL,
  VL,
  HL,
  zL,
  YL,
  KL,
  XL,
  QL
), ZL = ie({
  prop: "gap",
  themeGet: lr
}), JL = ie({
  prop: "columnGap",
  themeGet: lr
}), eq = ie({
  prop: "rowGap",
  themeGet: lr
}), tq = ie({
  prop: "gridColumn"
}), rq = ie({
  prop: "gridRow"
}), nq = ie({
  prop: "gridAutoFlow"
}), aq = ie({
  prop: "gridAutoColumns"
}), iq = ie({
  prop: "gridAutoRows"
}), oq = ie({
  prop: "gridTemplateColumns",
  key: "gridTemplateColumns"
}), sq = ie({
  prop: "gridTemplateRows",
  key: "gridTemplateRows"
}), uq = ie({
  prop: "gridTemplateAreas"
}), dq = ie({
  prop: "gridArea"
}), lq = br(
  ZL,
  JL,
  eq,
  tq,
  rq,
  nq,
  aq,
  iq,
  oq,
  sq,
  uq,
  dq
), fq = ie({
  prop: "appearance"
}), cq = ie({
  prop: "cursor"
}), hq = ie({
  prop: "pointerEvents"
}), gq = ie({
  prop: "resize"
}), _q = ie({
  prop: "userSelect"
}), mq = br(
  fq,
  cq,
  hq,
  gq,
  _q
), ks = Nt({
  name: "size",
  key: "sizes",
  compose: Of
}), pq = ie({
  prop: "w",
  themeGet: ks,
  css: "width"
}), Fq = ie({
  prop: "h",
  themeGet: ks,
  css: "height"
}), yq = ie({
  prop: ["maxWidth", "maxW"],
  themeGet: ks,
  css: "maxWidth"
}), bq = ie({
  prop: ["maxHeight", "maxH"],
  themeGet: ks,
  css: "maxHeight"
}), vq = ie({
  prop: ["minWidth", "minW"],
  themeGet: ks,
  css: "minWidth"
}), Eq = ie({
  prop: ["minHeight", "minH"],
  themeGet: ks,
  css: "minHeight"
}), $q = ie({
  prop: "maskSize",
  themeGet: Nt({
    name: "size",
    key: "sizes",
    compose: Of,
    multiple: !0,
    shorthand: !0
  })
}), wq = br(
  pq,
  Fq,
  yq,
  bq,
  vq,
  Eq,
  $q
), kq = ie({
  prop: "fill",
  themeGet: pt
}), xq = ie({
  prop: "stroke",
  themeGet: pt
}), Dq = br(kq, xq), Cq = ie({
  prop: "borderCollapse"
}), Sq = ie({
  prop: "tableLayout"
}), Aq = br(Cq, Sq), kk = Nt({
  name: "transform",
  key: "transforms"
}), Oq = ie({
  prop: "transform",
  themeGet: kk,
  css: (e) => e === !0 ? {
    "--x-translate-x": 0,
    "--x-translate-y": 0,
    "--x-rotate": 0,
    "--x-skew-x": 0,
    "--x-skew-y": 0,
    "--x-scale-x": "1",
    "--x-scale-y": "1",
    transform: "translate3d(var(--x-translate-x), var(--x-translate-y), 0) rotate(var(--x-rotate)) skewX(var(--x-skew-x)) skewY(var(--x-skew-y)) scaleX(var(--x-scale-x)) scaleY(var(--x-scale-y))"
  } : { transform: e }
}), Tq = ie({
  prop: "transformOrigin"
}), Pq = ie({
  prop: "translateX",
  themeGet: lr,
  css: "--x-translate-x"
}), Iq = ie({
  prop: "translateY",
  themeGet: lr,
  css: "--x-translate-y"
}), Rq = ie({
  prop: "rotate",
  themeGet: yh,
  css: "--x-rotate"
}), jq = ie({
  prop: "skewX",
  themeGet: yh,
  css: "--x-skew-x"
}), Mq = ie({
  prop: "skewY",
  themeGet: yh,
  css: "--x-skew-y"
}), Bq = ie({
  prop: "scale",
  transform: (e) => String(e),
  css: ["--x-scale-x", "--x-scale-y"]
}), Nq = ie({
  prop: "scaleX",
  transform: (e) => String(e),
  css: "--x-scale-x"
}), Lq = ie({
  prop: "scaleY",
  transform: (e) => String(e),
  css: "--x-scale-y"
}), qq = br(
  Oq,
  Tq,
  Pq,
  Iq,
  Rq,
  jq,
  Mq,
  Bq,
  Nq,
  Lq
);
var Uq = Object.defineProperty, Gq = Object.defineProperties, Wq = Object.getOwnPropertyDescriptors, zb = Object.getOwnPropertySymbols, Vq = Object.prototype.hasOwnProperty, Hq = Object.prototype.propertyIsEnumerable, Kb = (e, t, r) => t in e ? Uq(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, zq = (e, t) => {
  for (var r in t || (t = {}))
    Vq.call(t, r) && Kb(e, r, t[r]);
  if (zb)
    for (var r of zb(t))
      Hq.call(t, r) && Kb(e, r, t[r]);
  return e;
}, Kq = (e, t) => Gq(e, Wq(t));
const xk = Nt({ name: "font", key: "fonts" }), Dk = Nt({
  name: "lineHeight",
  key: "lineHeights",
  transform: (e, { props: t }) => {
    var r, n, a;
    const i = (a = (n = (r = t == null ? void 0 : t.theme) == null ? void 0 : r.settings) == null ? void 0 : n.rootFontSize) != null ? a : void 0;
    return fk(e, { rootFontSize: i });
  }
}), Ck = Nt({
  name: "fontWeight",
  key: "fontWeights"
}), Sk = Nt({
  name: "letterSpacing",
  key: "letterSpacings",
  compose: Mi
}), Ak = Nt({
  name: "fontSize",
  key: "fontSizes",
  compose: Mi
}), Yq = ie({
  prop: "fontFamily",
  themeGet: xk
}), Xq = ie({
  prop: "fontSize",
  themeGet: Ak
}), Qq = ie({
  prop: "lineHeight",
  themeGet: Dk
}), Zq = ie({
  prop: "fontWeight",
  themeGet: Ck
}), Jq = ie({
  prop: "fontStyle"
}), eU = ie({
  prop: "letterSpacing",
  themeGet: Sk
}), tU = ie({
  prop: "color",
  themeGet: pt
}), rU = ie({
  prop: "textTransform"
}), nU = ie({
  prop: "textDecoration"
}), aU = ie({
  prop: "textAlign"
}), iU = ie({
  prop: "verticalAlign"
}), oU = ie({
  prop: "whiteSpace"
}), sU = ie({
  prop: "textOverflow"
}), uU = ie({
  prop: "listStyleType"
}), dU = ie({
  prop: "listStylePosition"
}), Ok = br(
  wk,
  Yq,
  Xq,
  Jq,
  Qq,
  Zq,
  aU,
  eU,
  tU,
  rU,
  nU,
  iU,
  oU,
  sU,
  uU,
  dU
), lU = ie({
  prop: "text",
  key: "texts",
  css: (e) => ({ theme: t }) => Ok(Kq(zq({}, e), { theme: t }))
}), fU = br(Ok, lU), Tk = br(
  YB,
  sN,
  GN,
  zN,
  JN,
  PL,
  lq,
  mq,
  yL,
  wq,
  wk,
  Dq,
  Aq,
  qq,
  VB,
  fU
), Mt = (e, t) => (r) => {
  const n = j1(r, e);
  return sn(n) ? n : sn(t) ? t : e;
};
[
  yh,
  pk,
  ws,
  yk,
  $o,
  Ya,
  pt,
  Fh,
  xk,
  Ak,
  Ck,
  Tf,
  Sk,
  Dk,
  Of,
  Mi,
  bk,
  vk,
  bh,
  ks,
  lr,
  B3,
  kk,
  _k,
  mk,
  $k
].forEach((e) => {
  Mt[e.meta.name] = e;
});
var cU = Object.defineProperty, Yb = Object.getOwnPropertySymbols, hU = Object.prototype.hasOwnProperty, gU = Object.prototype.propertyIsEnumerable, Xb = (e, t, r) => t in e ? cU(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Qb = (e, t) => {
  for (var r in t || (t = {}))
    hU.call(t, r) && Xb(e, r, t[r]);
  if (Yb)
    for (var r of Yb(t))
      gU.call(t, r) && Xb(e, r, t[r]);
  return e;
};
const _U = [
  0,
  5,
  10,
  20,
  25,
  30,
  40,
  50,
  60,
  70,
  75,
  80,
  90,
  95,
  100
], Pk = (e, t = _U) => {
  const r = (a, i) => `${a}${Math.round(i / 100 * 255).toString(16).padStart(2, "0")}`, n = Object.keys(e).reduce((a, i) => (t.forEach((o) => {
    const u = e[i], d = `${i}-a${o}`;
    a[d] = wn(u) ? r(u, o) : Pk(u, t);
  }), a), {});
  return Qb(Qb({}, e), n);
};
var mU = Object.defineProperty, pU = Object.defineProperties, FU = Object.getOwnPropertyDescriptors, Zb = Object.getOwnPropertySymbols, yU = Object.prototype.hasOwnProperty, bU = Object.prototype.propertyIsEnumerable, Jb = (e, t, r) => t in e ? mU(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, vU = (e, t) => {
  for (var r in t || (t = {}))
    yU.call(t, r) && Jb(e, r, t[r]);
  if (Zb)
    for (var r of Zb(t))
      bU.call(t, r) && Jb(e, r, t[r]);
  return e;
}, EU = (e, t) => pU(e, FU(t));
const Zc = {
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  11: "2.75rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
}, Ik = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
}, q2 = {
  default: [
    "background-color",
    "border-color",
    "color",
    "fill",
    "stroke",
    "opacity",
    "box-shadow",
    "transform"
  ],
  colors: ["background-color", "border-color", "color", "fill", "stroke"],
  opacity: ["opacity"],
  shadow: ["box-shadow"],
  transform: ["transform"]
}, $U = Object.keys(
  q2
).reduce((e, t) => (e[t] = q2[t].map((r) => `${r} ${Ik["ease-in-out"]} 150ms`).join(","), e), {}), wU = {
  black: "#000000",
  white: "#ffffff",
  "blue-gray-50": "#f8fafc",
  "blue-gray-100": "#f1f5f9",
  "blue-gray-200": "#e2e8f0",
  "blue-gray-300": "#cbd5e1",
  "blue-gray-400": "#94a3b8",
  "blue-gray-500": "#64748b",
  "blue-gray-600": "#475569",
  "blue-gray-700": "#334155",
  "blue-gray-800": "#1e293b",
  "blue-gray-900": "#0f172a",
  "cool-gray-50": "#f9fafb",
  "cool-gray-100": "#f3f4f6",
  "cool-gray-200": "#e5e7eb",
  "cool-gray-300": "#d1d5db",
  "cool-gray-400": "#9ca3af",
  "cool-gray-500": "#6b7280",
  "cool-gray-600": "#4b5563",
  "cool-gray-700": "#374151",
  "cool-gray-800": "#1f2937",
  "cool-gray-900": "#111827",
  "gray-50": "#fafafa",
  "gray-100": "#f4f4f5",
  "gray-200": "#e4e4e7",
  "gray-300": "#d4d4d8",
  "gray-400": "#a1a1aa",
  "gray-500": "#71717a",
  "gray-600": "#52525b",
  "gray-700": "#3f3f46",
  "gray-800": "#27272a",
  "gray-900": "#18181b",
  "true-gray-50": "#fafafa",
  "true-gray-100": "#f5f5f5",
  "true-gray-200": "#e5e5e5",
  "true-gray-300": "#d4d4d4",
  "true-gray-400": "#a3a3a3",
  "true-gray-500": "#737373",
  "true-gray-600": "#525252",
  "true-gray-700": "#404040",
  "true-gray-800": "#262626",
  "true-gray-900": "#171717",
  "warm-gray-50": "#fafaf9",
  "warm-gray-100": "#f5f5f4",
  "warm-gray-200": "#e7e5e4",
  "warm-gray-300": "#d6d3d1",
  "warm-gray-400": "#a8a29e",
  "warm-gray-500": "#78716c",
  "warm-gray-600": "#57534e",
  "warm-gray-700": "#44403c",
  "warm-gray-800": "#292524",
  "warm-gray-900": "#1c1917",
  "red-50": "#fef2f2",
  "red-100": "#fee2e2",
  "red-200": "#fecaca",
  "red-300": "#fca5a5",
  "red-400": "#f87171",
  "red-500": "#ef4444",
  "red-600": "#dc2626",
  "red-700": "#b91c1c",
  "red-800": "#991b1b",
  "red-900": "#7f1d1d",
  "orange-50": "#fff7ed",
  "orange-100": "#ffedd5",
  "orange-200": "#fed7aa",
  "orange-300": "#fdba74",
  "orange-400": "#fb923c",
  "orange-500": "#f97316",
  "orange-600": "#ea580c",
  "orange-700": "#c2410c",
  "orange-800": "#9a3412",
  "orange-900": "#7c2d12",
  "amber-50": "#fffbeb",
  "amber-100": "#fef3c7",
  "amber-200": "#fde68a",
  "amber-300": "#fcd34d",
  "amber-400": "#fbbf24",
  "amber-500": "#f59e0b",
  "amber-600": "#d97706",
  "amber-700": "#b45309",
  "amber-800": "#92400e",
  "amber-900": "#78350f",
  "yellow-50": "#fefce8",
  "yellow-100": "#fef9c3",
  "yellow-200": "#fef08a",
  "yellow-300": "#fde047",
  "yellow-400": "#facc15",
  "yellow-500": "#eab308",
  "yellow-600": "#ca8a04",
  "yellow-700": "#a16207",
  "yellow-800": "#854d0e",
  "yellow-900": "#713f12",
  "lime-50": "#f7fee7",
  "lime-100": "#ecfccb",
  "lime-200": "#d9f99d",
  "lime-300": "#bef264",
  "lime-400": "#a3e635",
  "lime-500": "#84cc16",
  "lime-600": "#65a30d",
  "lime-700": "#4d7c0f",
  "lime-800": "#3f6212",
  "lime-900": "#365314",
  "green-50": "#f0fdf4",
  "green-100": "#dcfce7",
  "green-200": "#bbf7d0",
  "green-300": "#86efac",
  "green-400": "#4ade80",
  "green-500": "#22c55e",
  "green-600": "#16a34a",
  "green-700": "#15803d",
  "green-800": "#166534",
  "green-900": "#14532d",
  "emerald-50": "#ecfdf5",
  "emerald-100": "#d1fae5",
  "emerald-200": "#a7f3d0",
  "emerald-300": "#6ee7b7",
  "emerald-400": "#34d399",
  "emerald-500": "#10b981",
  "emerald-600": "#059669",
  "emerald-700": "#047857",
  "emerald-800": "#065f46",
  "emerald-900": "#064e3b",
  "teal-50": "#f0fdfa",
  "teal-100": "#ccfbf1",
  "teal-200": "#99f6e4",
  "teal-300": "#5eead4",
  "teal-400": "#2dd4bf",
  "teal-500": "#14b8a6",
  "teal-600": "#0d9488",
  "teal-700": "#0f766e",
  "teal-800": "#115e59",
  "teal-900": "#134e4a",
  "cyan-50": "#ecfeff",
  "cyan-100": "#cffafe",
  "cyan-200": "#a5f3fc",
  "cyan-300": "#67e8f9",
  "cyan-400": "#22d3ee",
  "cyan-500": "#06b6d4",
  "cyan-600": "#0891b2",
  "cyan-700": "#0e7490",
  "cyan-800": "#155e75",
  "cyan-900": "#164e63",
  "light-blue-50": "#f0f9ff",
  "light-blue-100": "#e0f2fe",
  "light-blue-200": "#bae6fd",
  "light-blue-300": "#7dd3fc",
  "light-blue-400": "#38bdf8",
  "light-blue-500": "#0ea5e9",
  "light-blue-600": "#0284c7",
  "light-blue-700": "#0369a1",
  "light-blue-800": "#075985",
  "light-blue-900": "#0c4a6e",
  "blue-50": "#eff6ff",
  "blue-100": "#dbeafe",
  "blue-200": "#bfdbfe",
  "blue-300": "#93c5fd",
  "blue-400": "#60a5fa",
  "blue-500": "#3b82f6",
  "blue-600": "#2563eb",
  "blue-700": "#1d4ed8",
  "blue-800": "#1e40af",
  "blue-900": "#1e3a8a",
  "indigo-50": "#eef2ff",
  "indigo-100": "#e0e7ff",
  "indigo-200": "#c7d2fe",
  "indigo-300": "#a5b4fc",
  "indigo-400": "#818cf8",
  "indigo-500": "#6366f1",
  "indigo-600": "#4f46e5",
  "indigo-700": "#4338ca",
  "indigo-800": "#3730a3",
  "indigo-900": "#312e81",
  "violet-50": "#f5f3ff",
  "violet-100": "#ede9fe",
  "violet-200": "#ddd6fe",
  "violet-300": "#c4b5fd",
  "violet-400": "#a78bfa",
  "violet-500": "#8b5cf6",
  "violet-600": "#7c3aed",
  "violet-700": "#6d28d9",
  "violet-800": "#5b21b6",
  "violet-900": "#4c1d95",
  "purple-50": "#faf5ff",
  "purple-100": "#f3e8ff",
  "purple-200": "#e9d5ff",
  "purple-300": "#d8b4fe",
  "purple-400": "#c084fc",
  "purple-500": "#a855f7",
  "purple-600": "#9333ea",
  "purple-700": "#7e22ce",
  "purple-800": "#6b21a8",
  "purple-900": "#581c87",
  "fuchsia-50": "#fdf4ff",
  "fuchsia-100": "#fae8ff",
  "fuchsia-200": "#f5d0fe",
  "fuchsia-300": "#f0abfc",
  "fuchsia-400": "#e879f9",
  "fuchsia-500": "#d946ef",
  "fuchsia-600": "#c026d3",
  "fuchsia-700": "#a21caf",
  "fuchsia-800": "#86198f",
  "fuchsia-900": "#701a75",
  "pink-50": "#fdf2f8",
  "pink-100": "#fce7f3",
  "pink-200": "#fbcfe8",
  "pink-300": "#f9a8d4",
  "pink-400": "#f472b6",
  "pink-500": "#ec4899",
  "pink-600": "#db2777",
  "pink-700": "#be185d",
  "pink-800": "#9d174d",
  "pink-900": "#831843",
  "rose-50": "#fff1f2",
  "rose-100": "#ffe4e6",
  "rose-200": "#fecdd3",
  "rose-300": "#fda4af",
  "rose-400": "#fb7185",
  "rose-500": "#f43f5e",
  "rose-600": "#e11d48",
  "rose-700": "#be123c",
  "rose-800": "#9f1239",
  "rose-900": "#881337"
}, Rk = {
  xs: "0.75rem",
  sm: "0.875rem",
  default: "1rem",
  lg: "1.125rem",
  xl: "1.25rem",
  "2xl": "1.5rem",
  "3xl": "1.875rem",
  "4xl": "2.25rem",
  "5xl": "3rem",
  "6xl": "3.75rem",
  "7xl": "4.5rem",
  "8xl": "6rem",
  "9xl": "8rem"
}, kU = Object.keys(Rk).reduce(
  (e, t) => (e[t] = { fontSize: t, lineHeight: t }, e),
  {}
);
Pk(wU), EU(vU({}, Zc), {
  0.5: void 0,
  1: void 0,
  "0.5s": Zc[0.5],
  "1s": Zc[1],
  full: "100%",
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  "7xl": "80rem"
});
const xU = (e) => `
/*! modern-normalize v1.0.0 | MIT License | https://github.com/sindresorhus/modern-normalize */
*,::after,::before{box-sizing:border-box}:root{-moz-tab-size:4;tab-size:4}html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}body{font-family:system-ui,-apple-system,'Segoe UI',Roboto,Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji'}hr{height:0;color:inherit}abbr[title]{text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,pre,samp{font-family:ui-monospace,SFMono-Regular,Consolas,'Liberation Mono',Menlo,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}::-moz-focus-inner{border-style:none;padding:0}:-moz-focusring{outline:1px dotted ButtonText}:-moz-ui-invalid{box-shadow:none}legend{padding:0}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}

/* Role button pointer */
[role=button], button {
  cursor: pointer;
}

/* Remove default margins */
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

/* Remove headings styles */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/* Unstyle lists */
ol,
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Image are block-level */
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  vertical-align: middle;
}

/* Reset border styles */
*,
::before,
::after {
  border-width: 0;
  border-style: solid;
  border-color: ${Mt.color("default-border-color", "currentColor")({ theme: e })};
}

* {
  --x-ring-color: ${Mt.color(
  "default-ring-color",
  "rgba(59,130,246,0.5)"
)({ theme: e })};
}

/* Default outline on buttons */
button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

// Animations
@keyframes x-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes x-ping {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes x-pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: .5;
  }
}

@keyframes x-bounce {
  0%, 100% {
    transform: translateY(-25%);
    animationTimingFunction: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: translateY(0);
    animationTimingFunction: cubic-bezier(0, 0, 0.2, 1);
  }
}
`, DU = (...e) => e.filter(Boolean).join("."), e6 = (e) => `--${e.replace(/\./g, "-")}`, t6 = (e, t) => `${e}: ${t};`;
function U2(e, t, r = Object.keys(e), n, a = { value: "" }) {
  for (const i in r) {
    const o = r[i], u = e[o], d = DU(n, o);
    if (Au(u)) {
      U2(
        u,
        t,
        Object.keys(u),
        d,
        a
      );
      continue;
    }
    if (wn(u)) {
      a.value += t6(e6(d), u);
      continue;
    }
    if (uk(u)) {
      a.value += t6(e6(d), gh(u, { theme: t }));
      continue;
    }
  }
  return a.value;
}
var CU = Object.defineProperty, SU = Object.defineProperties, AU = Object.getOwnPropertyDescriptors, B1 = Object.getOwnPropertySymbols, jk = Object.prototype.hasOwnProperty, Mk = Object.prototype.propertyIsEnumerable, r6 = (e, t, r) => t in e ? CU(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, ul = (e, t) => {
  for (var r in t || (t = {}))
    jk.call(t, r) && r6(e, r, t[r]);
  if (B1)
    for (var r of B1(t))
      Mk.call(t, r) && r6(e, r, t[r]);
  return e;
}, OU = (e, t) => SU(e, AU(t)), n6 = (e, t) => {
  var r = {};
  for (var n in e)
    jk.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && B1)
    for (var n of B1(e))
      t.indexOf(n) < 0 && Mk.call(e, n) && (r[n] = e[n]);
  return r;
};
typeof window < "u" && (() => {
  try {
    const e = "xstyled-test-key";
    return window.localStorage.setItem(e, e), window.localStorage.removeItem(e), !0;
  } catch {
    return !1;
  }
})();
const TU = "xstyled-color-mode-", PU = (e) => `${TU}${e}`, a6 = "xstyled-colors", IU = ["light", "dark"];
function RU(e, t) {
  return OU(ul({}, e), {
    colors: ul(ul({}, e.colors), e.colors.modes[t])
  });
}
const jU = (e) => `@media ${e}`, MU = (e) => `(prefers-color-scheme: ${e})`;
function BU(e) {
  return Boolean(e && e.colors && e.colors.modes);
}
function NU(e) {
  return e.initialColorModeName || "default";
}
function LU(e) {
  let t = [];
  for (const r in e)
    t = [...t, ...Object.keys(e[r])];
  return t;
}
function qU(e, { targetSelector: t = "body" } = {}) {
  if (!BU(e))
    return null;
  const r = e.colors, { modes: n } = r, a = n6(r, ["modes"]), i = LU(n);
  let o = U2(
    a,
    e,
    i,
    a6
  );
  function u(s) {
    const l = RU(e, s), f = l.colors, { modes: c } = f, h = n6(f, ["modes"]);
    return U2(
      ul(ul({}, h), c[s]),
      l,
      i,
      a6
    );
  }
  return e.useColorSchemeMediaQuery !== !1 && IU.forEach((s) => {
    if (n[s]) {
      const l = jU(MU(s));
      o += `${l}{${u(s)}}`;
    }
  }), [NU(e), ...Object.keys(n)].forEach((s) => {
    const l = `&.${PU(s)}`;
    o += `${l}{${u(s)}}`;
  }), `${t}{${o}}`;
}
se.createContext(null);
Tk.meta;
const i6 = (e) => (t) => (r) => {
  const n = e(M3(r), t);
  return n === null ? "0" : n || t;
}, UU = {
  "min-width": i6(hk),
  "max-width": i6(vB)
}, Bk = "[-\\w]", GU = "(?:\\\\[\\s\\S]|[^\\\\;{}])", WU = `(${Bk}+)(\\s*:\\s*)(?=\\S)(${GU}*?)(\\s*!important)?(\\s*;)`, VU = "[^{]", HU = `(@media\\b\\s*)(?=\\S)(${VU}+?)(\\s*\\{)`, zU = new RegExp(`(?:${WU}|${HU})`, "g"), KU = new RegExp(
  `(\\(\\s*)(${Bk}+)(\\s*:\\s*)([^\\)]*?)(\\s*\\))`,
  "g"
), YU = (e) => {
  let t, r = 0;
  const n = [];
  for (; t = KU.exec(e); ) {
    const [, a, i, o, u, d] = t, s = UU[i];
    s && (n.push(e.slice(r, t.index)), n.push(
      (l) => `${a}${i}${o}${s(u)(l)}${d}`
    ), r = t.index + t[0].length);
  }
  return n.push(e.slice(r, e.length)), n;
}, XU = (e) => (t) => {
  if (typeof t != "string")
    return t;
  let r, n = 0;
  const a = [];
  for (; r = zU.exec(t); ) {
    const [, i, o, u, d, s, l, f, c] = r;
    if (l)
      a.push(t.slice(n, r.index)), a.push(l), YU(f).forEach((h) => a.push(h)), a.push(c), n = r.index + r[0].length;
    else {
      const h = e.meta.cssGetters[i];
      h && (a.push(t.slice(n, r.index)), a.push(
        (_) => `${i}${o}${h(u)(_)}${d || ""}${s}`
      ), n = r.index + r[0].length);
    }
  }
  return a.push(t.slice(n, t.length)), a;
}, Ht = (e, t) => (r, n) => {
  const a = t();
  return qe(
    () => e(r, n)({ theme: a }),
    [r, n, a]
  );
};
A3`${(e) => qU(e.theme, { targetSelector: e.targetSelector })}`;
const zt = () => Et(zM);
Ht(Mt.angle, zt);
Ht(Mt.animation, zt);
Ht(Mt.border, zt);
Ht(Mt.borderColor, zt);
Ht(Mt.borderStyle, zt);
Ht(Mt.borderWidth, zt);
Ht(Mt.color, zt);
Ht(Mt.duration, zt);
Ht(Mt.font, zt);
Ht(Mt.fontSize, zt);
Ht(Mt.fontWeight, zt);
Ht(Mt.inset, zt);
Ht(Mt.letterSpacing, zt);
Ht(Mt.lineHeight, zt);
Ht(Mt.percent, zt);
Ht(Mt.px, zt);
Ht(Mt.radius, zt);
Ht(Mt.ringWidth, zt);
Ht(Mt.shadow, zt);
Ht(Mt.size, zt);
Ht(Mt.space, zt);
Ht(Mt.timingFunction, zt);
Ht(Mt.transform, zt);
Ht(Mt.transition, zt);
Ht(Mt.transitionProperty, zt);
Ht(Mt.zIndex, zt);
A3(({ theme: e }) => xU(e));
const vh = (e) => {
  const t = XU(e);
  return (...r) => {
    const n = KM(...r);
    return _B(n).map(t);
  };
}, N3 = typeof m_ == "function" ? m_ : m_.default, G2 = (e, t, r) => {
  const n = (...a) => e`${t(...a)}${r}`;
  return n.attrs = (a) => G2(e.attrs(a), t, r), n.withConfig = (a) => G2(e.withConfig(a), t, r), n;
}, QU = (e) => {
  const t = new Set(e.meta.props);
  return (r, n, a) => wn(r) && t.has(r) ? !1 : typeof a == "string" ? n(r) : !0;
}, W2 = (e, t) => {
  const r = t ? {
    shouldForwardProp: QU(t)
  } : {};
  return (n) => {
    const a = N3(n);
    return G2(r ? a.withConfig(r) : a, e, t);
  };
}, ZU = (e) => {
  const t = vh(e), r = W2(t), n = W2(t, e);
  return r.box = n("div"), Object.keys(N3).forEach((a) => {
    r[a] = r(a), r[`${a}Box`] = n(a);
  }), r;
}, JU = (e) => {
  const t = W2(vh(e), e), r = {};
  return Object.keys(N3).forEach((n) => {
    r[n] = t(n)``;
  }), r;
}, eG = (e) => {
  const t = vh(e);
  return (...r) => A3([
    t(...r)
  ]);
}, tG = (e) => ({
  css: vh(e),
  x: JU(e),
  styled: ZU(e),
  createGlobalStyle: eG(e)
}), { css: _r, styled: Ge, x: cAe, createGlobalStyle: Nk } = tG(Tk), rG = Ge(Ae)`
  gap: ${({ gap: e }) => vt(e)};
  ${({ columnGap: e }) => e && _r`
      column-gap: ${vt(e)};
    `}
  ${({ rowGap: e }) => e && _r`
      row-gap: ${vt(e)};
    `}
`;
function ur({
  children: e,
  gap: t,
  space: r,
  "data-test": n,
  ...a
}) {
  return /* @__PURE__ */ b(rG, { "data-test": n, gap: t ?? r ?? "s", ...a, children: e });
}
function hAe({
  title: e,
  count: t,
  minimizable: r = !0,
  children: n,
  ...a
}) {
  const [i, o] = Xe(!1);
  function u() {
    o((d) => !d);
  }
  return /* @__PURE__ */ b(
    Ae,
    {
      backgroundColor: "neutral-100",
      padding: "m",
      borderRadius: "default",
      w: "100%",
      ...a,
      children: /* @__PURE__ */ ne(ur, { flexDirection: "column", w: "100%", children: [
        /* @__PURE__ */ ne(Ae, { alignItems: "center", justifyContent: "space-between", children: [
          /* @__PURE__ */ ne(ur, { alignItems: "center", gap: "xxs", children: [
            /* @__PURE__ */ b($e, { variant: "bodySemiboldM", children: e }),
            t !== void 0 && /* @__PURE__ */ b(ok, { value: t })
          ] }),
          r && /* @__PURE__ */ b(
            _a,
            {
              "data-test": "toggle-minimized",
              component: i ? Df : dh,
              size: 16,
              color: "neutral-1000",
              onClick: u
            }
          )
        ] }),
        !i && /* @__PURE__ */ b(Ae, { children: n })
      ] })
    }
  );
}
function nG({
  isLarge: e = !1,
  children: t,
  ...r
}) {
  const n = e ? /* @__PURE__ */ b(zj, {}) : null, a = e ? t : `+ ${t}`;
  return /* @__PURE__ */ ne(nr, { size: e ? "regular" : "xSmall", ...r, mode: e ? "outline" : "link", children: [
    n,
    a
  ] });
}
const aG = Ge(Dt)`
  background: linear-gradient(95.08deg, #c2ffec 1.17%, #f5fffb 100%);
`;
function gAe({
  actionButtonHref: e,
  buttonTexts: t,
  icon: r,
  onClose: n,
  title: a,
  alignItems: i = "center",
  border: o = "1px solid #c2ffec",
  borderRadius: u = 16,
  direction: d = "horizontal",
  fluid: s = !0,
  justifyContent: l = "space-between",
  px: f = "m",
  py: c = "s",
  space: h = "s",
  "data-test": _ = "ai-promotional-banner",
  ...F
}) {
  return /* @__PURE__ */ b(jw, { children: /* @__PURE__ */ ne(
    aG,
    {
      direction: d,
      alignItems: i,
      fluid: s,
      justifyContent: l,
      py: c,
      px: f,
      space: h,
      border: o,
      borderRadius: u,
      "data-test": _,
      ...F,
      children: [
        /* @__PURE__ */ ne(Dt, { space: "s", pr: "xs", alignItems: "center", children: [
          /* @__PURE__ */ b(sr, { component: r, color: "icon-interactive-secondary", size: 24 }),
          /* @__PURE__ */ b(
            $e,
            {
              variant: "bodySemiboldM",
              color: "text-base",
              "data-test": `${_}-title`,
              children: a
            }
          )
        ] }),
        /* @__PURE__ */ ne(Dt, { space: "s", alignItems: "center", children: [
          n && /* @__PURE__ */ b(
            nr,
            {
              variant: "secondary",
              onClick: n,
              mode: "link",
              size: "xSmall",
              "data-test": `${_}-close-button`,
              children: t.close
            }
          ),
          /* @__PURE__ */ b(
            nr,
            {
              as: "a",
              href: e,
              target: "_blank",
              size: "small",
              "data-test": `${_}-action-button`,
              children: t.action
            }
          )
        ] })
      ]
    }
  ) });
}
var so = /* @__PURE__ */ ((e) => (e.ALWAYS_CLOSED = "ALWAYS_CLOSED", e.ALWAYS_OPENED = "ALWAYS_OPENED", e.CUSTOM = "CUSTOM", e))(so || {});
function iG({
  texts: e,
  ...t
}) {
  const r = [
    {
      label: e.always,
      description: e.alwaysDescription,
      value: so.ALWAYS_OPENED
    },
    {
      label: e.never,
      description: e.neverDescription,
      value: so.ALWAYS_CLOSED
    },
    {
      label: e.scheduled,
      value: so.CUSTOM
    }
  ];
  function n(i) {
    switch (i.value) {
      case so.ALWAYS_OPENED:
        return /* @__PURE__ */ b(sr, { size: 24, component: Yj, color: "primary-500" });
      case so.ALWAYS_CLOSED:
        return /* @__PURE__ */ b(sr, { size: 24, component: Cf, color: "critical-500" });
      case so.CUSTOM:
        return /* @__PURE__ */ b(sr, { size: 24, component: Kj, color: "informative-500" });
      default:
        return null;
    }
  }
  function a(i) {
    return /* @__PURE__ */ ne(ur, { alignItems: "center", gap: "xxs", children: [
      n(i),
      /* @__PURE__ */ ne(Ae, { flexDirection: "column", gap: "2px", children: [
        /* @__PURE__ */ b($e, { variant: "bodyRegularS", children: i.label }),
        /* @__PURE__ */ b($e, { variant: "supportingRegularXS", color: "text-secondary", children: i.description })
      ] })
    ] });
  }
  return /* @__PURE__ */ b(
    Sf,
    {
      "data-test": "availability-select",
      renderOption: a,
      selectionMode: "single",
      ...t,
      options: r
    }
  );
}
function Lk(e, t) {
  const r = e.map((n) => [JSON.stringify(
    t.map((i) => n[i])
  ), n]);
  return [...new Map(r).values()];
}
var oG = /* @__PURE__ */ ((e) => (e.PASSWORD = "password", e.GOOGLE = "google", e.SAML = "saml", e))(oG || {}), sG = /* @__PURE__ */ ((e) => (e.OKTA = "Okta", e.MS_AZURE_AD = "MS Azure AD", e.OAUTH = "OAuth", e.PIDC = "PIDC", e.JUMP_CLOUD = "JumpCloud", e.ONE_LOGIN = "OneLogin", e.GOOGLE_WORKSPACE = "Google Workspace", e))(sG || {}), Ou = {}, uG = {
  get exports() {
    return Ou;
  },
  set exports(e) {
    Ou = e;
  }
};
/*!
 * Platform.js v1.3.6
 * Copyright 2014-2020 Benjamin Tan
 * Copyright 2011-2013 John-David Dalton
 * Available under MIT license
 */
(function(e, t) {
  (function() {
    var r = {
      function: !0,
      object: !0
    }, n = r[typeof window] && window || this, a = t, i = e && !e.nodeType && e, o = a && i && typeof un == "object" && un;
    o && (o.global === o || o.window === o || o.self === o) && (n = o);
    var u = Math.pow(2, 53) - 1, d = /\bOpera/, s = Object.prototype, l = s.hasOwnProperty, f = s.toString;
    function c(S) {
      return S = String(S), S.charAt(0).toUpperCase() + S.slice(1);
    }
    function h(S, N, W) {
      var V = {
        "10.0": "10",
        "6.4": "10 Technical Preview",
        "6.3": "8.1",
        "6.2": "8",
        "6.1": "Server 2008 R2 / 7",
        "6.0": "Server 2008 / Vista",
        "5.2": "Server 2003 / XP 64-bit",
        "5.1": "XP",
        "5.01": "2000 SP1",
        "5.0": "2000",
        "4.0": "NT",
        "4.90": "ME"
      };
      return N && W && /^Win/i.test(S) && !/^Windows Phone /i.test(S) && (V = V[/[\d.]+$/.exec(S)]) && (S = "Windows " + V), S = String(S), N && W && (S = S.replace(RegExp(N, "i"), W)), S = F(
        S.replace(/ ce$/i, " CE").replace(/\bhpw/i, "web").replace(/\bMacintosh\b/, "Mac OS").replace(/_PowerPC\b/i, " OS").replace(/\b(OS X) [^ \d]+/i, "$1").replace(/\bMac (OS X)\b/, "$1").replace(/\/(\d)/, " $1").replace(/_/g, ".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "").replace(/\bx86\.64\b/gi, "x86_64").replace(/\b(Windows Phone) OS\b/, "$1").replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1").split(" on ")[0]
      ), S;
    }
    function _(S, N) {
      var W = -1, V = S ? S.length : 0;
      if (typeof V == "number" && V > -1 && V <= u)
        for (; ++W < V; )
          N(S[W], W, S);
      else
        v(S, N);
    }
    function F(S) {
      return S = k(S), /^(?:webOS|i(?:OS|P))/.test(S) ? S : c(S);
    }
    function v(S, N) {
      for (var W in S)
        l.call(S, W) && N(S[W], W, S);
    }
    function $(S) {
      return S == null ? c(S) : f.call(S).slice(8, -1);
    }
    function E(S, N) {
      var W = S != null ? typeof S[N] : "number";
      return !/^(?:boolean|number|string|undefined)$/.test(W) && (W == "object" ? !!S[N] : !0);
    }
    function D(S) {
      return String(S).replace(/([ -])(?!$)/g, "$1?");
    }
    function w(S, N) {
      var W = null;
      return _(S, function(V, K) {
        W = N(W, V, K, S);
      }), W;
    }
    function k(S) {
      return String(S).replace(/^ +| +$/g, "");
    }
    function A(S) {
      var N = n, W = S && typeof S == "object" && $(S) != "String";
      W && (N = S, S = null);
      var V = N.navigator || {}, K = V.userAgent || "";
      S || (S = K);
      var U = W ? !!V.likeChrome : /\bChrome\b/.test(S) && !/internal|\n/i.test(f.toString()), j = "Object", G = W ? j : "ScriptBridgingProxyObject", H = W ? j : "Environment", J = W && N.java ? "JavaPackage" : $(N.java), ae = W ? j : "RuntimeObject", de = /\bJava/.test(J) && N.java, te = de && $(N.environment) == H, ee = de ? "a" : "α", ge = de ? "b" : "β", De = N.document || {}, xe = N.operamini || N.opera, ze = d.test(ze = W && xe ? xe["[[Class]]"] : $(xe)) ? ze : xe = null, q, Ue = S, Ce = [], me = null, Fe = S == K, ce = Fe && xe && typeof xe.version == "function" && xe.version(), z, Me = qt([
        { label: "EdgeHTML", pattern: "Edge" },
        "Trident",
        { label: "WebKit", pattern: "AppleWebKit" },
        "iCab",
        "Presto",
        "NetFront",
        "Tasman",
        "KHTML",
        "Gecko"
      ]), le = Kt([
        "Adobe AIR",
        "Arora",
        "Avant Browser",
        "Breach",
        "Camino",
        "Electron",
        "Epiphany",
        "Fennec",
        "Flock",
        "Galeon",
        "GreenBrowser",
        "iCab",
        "Iceweasel",
        "K-Meleon",
        "Konqueror",
        "Lunascape",
        "Maxthon",
        { label: "Microsoft Edge", pattern: "(?:Edge|Edg|EdgA|EdgiOS)" },
        "Midori",
        "Nook Browser",
        "PaleMoon",
        "PhantomJS",
        "Raven",
        "Rekonq",
        "RockMelt",
        { label: "Samsung Internet", pattern: "SamsungBrowser" },
        "SeaMonkey",
        { label: "Silk", pattern: "(?:Cloud9|Silk-Accelerated)" },
        "Sleipnir",
        "SlimBrowser",
        { label: "SRWare Iron", pattern: "Iron" },
        "Sunrise",
        "Swiftfox",
        "Vivaldi",
        "Waterfox",
        "WebPositive",
        { label: "Yandex Browser", pattern: "YaBrowser" },
        { label: "UC Browser", pattern: "UCBrowser" },
        "Opera Mini",
        { label: "Opera Mini", pattern: "OPiOS" },
        "Opera",
        { label: "Opera", pattern: "OPR" },
        "Chromium",
        "Chrome",
        { label: "Chrome", pattern: "(?:HeadlessChrome)" },
        { label: "Chrome Mobile", pattern: "(?:CriOS|CrMo)" },
        { label: "Firefox", pattern: "(?:Firefox|Minefield)" },
        { label: "Firefox for iOS", pattern: "FxiOS" },
        { label: "IE", pattern: "IEMobile" },
        { label: "IE", pattern: "MSIE" },
        "Safari"
      ]), Be = mr([
        { label: "BlackBerry", pattern: "BB10" },
        "BlackBerry",
        { label: "Galaxy S", pattern: "GT-I9000" },
        { label: "Galaxy S2", pattern: "GT-I9100" },
        { label: "Galaxy S3", pattern: "GT-I9300" },
        { label: "Galaxy S4", pattern: "GT-I9500" },
        { label: "Galaxy S5", pattern: "SM-G900" },
        { label: "Galaxy S6", pattern: "SM-G920" },
        { label: "Galaxy S6 Edge", pattern: "SM-G925" },
        { label: "Galaxy S7", pattern: "SM-G930" },
        { label: "Galaxy S7 Edge", pattern: "SM-G935" },
        "Google TV",
        "Lumia",
        "iPad",
        "iPod",
        "iPhone",
        "Kindle",
        { label: "Kindle Fire", pattern: "(?:Cloud9|Silk-Accelerated)" },
        "Nexus",
        "Nook",
        "PlayBook",
        "PlayStation Vita",
        "PlayStation",
        "TouchPad",
        "Transformer",
        { label: "Wii U", pattern: "WiiU" },
        "Wii",
        "Xbox One",
        { label: "Xbox 360", pattern: "Xbox" },
        "Xoom"
      ]), rt = fr({
        Apple: { iPad: 1, iPhone: 1, iPod: 1 },
        Alcatel: {},
        Archos: {},
        Amazon: { Kindle: 1, "Kindle Fire": 1 },
        Asus: { Transformer: 1 },
        "Barnes & Noble": { Nook: 1 },
        BlackBerry: { PlayBook: 1 },
        Google: { "Google TV": 1, Nexus: 1 },
        HP: { TouchPad: 1 },
        HTC: {},
        Huawei: {},
        Lenovo: {},
        LG: {},
        Microsoft: { Xbox: 1, "Xbox One": 1 },
        Motorola: { Xoom: 1 },
        Nintendo: { "Wii U": 1, Wii: 1 },
        Nokia: { Lumia: 1 },
        Oppo: {},
        Samsung: { "Galaxy S": 1, "Galaxy S2": 1, "Galaxy S3": 1, "Galaxy S4": 1 },
        Sony: { PlayStation: 1, "PlayStation Vita": 1 },
        Xiaomi: { Mi: 1, Redmi: 1 }
      }), ve = hr([
        "Windows Phone",
        "KaiOS",
        "Android",
        "CentOS",
        { label: "Chrome OS", pattern: "CrOS" },
        "Debian",
        { label: "DragonFly BSD", pattern: "DragonFly" },
        "Fedora",
        "FreeBSD",
        "Gentoo",
        "Haiku",
        "Kubuntu",
        "Linux Mint",
        "OpenBSD",
        "Red Hat",
        "SuSE",
        "Ubuntu",
        "Xubuntu",
        "Cygwin",
        "Symbian OS",
        "hpwOS",
        "webOS ",
        "webOS",
        "Tablet OS",
        "Tizen",
        "Linux",
        "Mac OS X",
        "Macintosh",
        "Mac",
        "Windows 98;",
        "Windows "
      ]);
      function qt(st) {
        return w(st, function(Qe, et) {
          return Qe || RegExp("\\b" + (et.pattern || D(et)) + "\\b", "i").exec(S) && (et.label || et);
        });
      }
      function fr(st) {
        return w(st, function(Qe, et, Tt) {
          return Qe || (et[Be] || et[/^[a-z]+(?: +[a-z]+\b)*/i.exec(Be)] || RegExp("\\b" + D(Tt) + "(?:\\b|\\w*\\d)", "i").exec(S)) && Tt;
        });
      }
      function Kt(st) {
        return w(st, function(Qe, et) {
          return Qe || RegExp("\\b" + (et.pattern || D(et)) + "\\b", "i").exec(S) && (et.label || et);
        });
      }
      function hr(st) {
        return w(st, function(Qe, et) {
          var Tt = et.pattern || D(et);
          return !Qe && (Qe = RegExp("\\b" + Tt + "(?:/[\\d.]+|[ \\w.]*)", "i").exec(S)) && (Qe = h(Qe, Tt, et.label || et)), Qe;
        });
      }
      function mr(st) {
        return w(st, function(Qe, et) {
          var Tt = et.pattern || D(et);
          return !Qe && (Qe = RegExp("\\b" + Tt + " *\\d+[.\\w_]*", "i").exec(S) || RegExp("\\b" + Tt + " *\\w+-[\\w]*", "i").exec(S) || RegExp("\\b" + Tt + "(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)", "i").exec(S)) && ((Qe = String(et.label && !RegExp(Tt, "i").test(et.label) ? et.label : Qe).split("/"))[1] && !/[\d.]+/.test(Qe[0]) && (Qe[0] += " " + Qe[1]), et = et.label || et, Qe = F(Qe[0].replace(RegExp(Tt, "i"), et).replace(RegExp("; *(?:" + et + "[_-])?", "i"), " ").replace(RegExp("(" + et + ")[-_.]?(\\w)", "i"), "$1 $2"))), Qe;
        });
      }
      function Lr(st) {
        return w(st, function(Qe, et) {
          return Qe || (RegExp(et + "(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)", "i").exec(S) || 0)[1] || null;
        });
      }
      function Oe() {
        return this.description || "";
      }
      if (Me && (Me = [Me]), /\bAndroid\b/.test(ve) && !Be && (q = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(S)) && (Be = k(q[1]).replace(/^[a-z]{2}-[a-z]{2};\s*/i, "") || null), rt && !Be ? Be = mr([rt]) : rt && Be && (Be = Be.replace(RegExp("^(" + D(rt) + ")[-_.\\s]", "i"), rt + " ").replace(RegExp("^(" + D(rt) + ")[-_.]?(\\w)", "i"), rt + " $2")), (q = /\bGoogle TV\b/.exec(Be)) && (Be = q[0]), /\bSimulator\b/i.test(S) && (Be = (Be ? Be + " " : "") + "Simulator"), le == "Opera Mini" && /\bOPiOS\b/.test(S) && Ce.push("running in Turbo/Uncompressed mode"), le == "IE" && /\blike iPhone OS\b/.test(S) ? (q = A(S.replace(/like iPhone OS/, "")), rt = q.manufacturer, Be = q.product) : /^iP/.test(Be) ? (le || (le = "Safari"), ve = "iOS" + ((q = / OS ([\d_]+)/i.exec(S)) ? " " + q[1].replace(/_/g, ".") : "")) : le == "Konqueror" && /^Linux\b/i.test(ve) ? ve = "Kubuntu" : rt && rt != "Google" && (/Chrome/.test(le) && !/\bMobile Safari\b/i.test(S) || /\bVita\b/.test(Be)) || /\bAndroid\b/.test(ve) && /^Chrome/.test(le) && /\bVersion\//i.test(S) ? (le = "Android Browser", ve = /\bAndroid\b/.test(ve) ? ve : "Android") : le == "Silk" ? (/\bMobi/i.test(S) || (ve = "Android", Ce.unshift("desktop mode")), /Accelerated *= *true/i.test(S) && Ce.unshift("accelerated")) : le == "UC Browser" && /\bUCWEB\b/.test(S) ? Ce.push("speed mode") : le == "PaleMoon" && (q = /\bFirefox\/([\d.]+)\b/.exec(S)) ? Ce.push("identifying as Firefox " + q[1]) : le == "Firefox" && (q = /\b(Mobile|Tablet|TV)\b/i.exec(S)) ? (ve || (ve = "Firefox OS"), Be || (Be = q[1])) : !le || (q = !/\bMinefield\b/i.test(S) && /\b(?:Firefox|Safari)\b/.exec(le)) ? (le && !Be && /[\/,]|^[^(]+?\)/.test(S.slice(S.indexOf(q + "/") + 8)) && (le = null), (q = Be || rt || ve) && (Be || rt || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(ve)) && (le = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(ve) ? ve : q) + " Browser")) : le == "Electron" && (q = (/\bChrome\/([\d.]+)\b/.exec(S) || 0)[1]) && Ce.push("Chromium " + q), ce || (ce = Lr([
        "(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)",
        "Version",
        D(le),
        "(?:Firefox|Minefield|NetFront)"
      ])), (q = Me == "iCab" && parseFloat(ce) > 3 && "WebKit" || /\bOpera\b/.test(le) && (/\bOPR\b/.test(S) ? "Blink" : "Presto") || /\b(?:Midori|Nook|Safari)\b/i.test(S) && !/^(?:Trident|EdgeHTML)$/.test(Me) && "WebKit" || !Me && /\bMSIE\b/i.test(S) && (ve == "Mac OS" ? "Tasman" : "Trident") || Me == "WebKit" && /\bPlayStation\b(?! Vita\b)/i.test(le) && "NetFront") && (Me = [q]), le == "IE" && (q = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(S) || 0)[1]) ? (le += " Mobile", ve = "Windows Phone " + (/\+$/.test(q) ? q : q + ".x"), Ce.unshift("desktop mode")) : /\bWPDesktop\b/i.test(S) ? (le = "IE Mobile", ve = "Windows Phone 8.x", Ce.unshift("desktop mode"), ce || (ce = (/\brv:([\d.]+)/.exec(S) || 0)[1])) : le != "IE" && Me == "Trident" && (q = /\brv:([\d.]+)/.exec(S)) && (le && Ce.push("identifying as " + le + (ce ? " " + ce : "")), le = "IE", ce = q[1]), Fe) {
        if (E(N, "global"))
          if (de && (q = de.lang.System, Ue = q.getProperty("os.arch"), ve = ve || q.getProperty("os.name") + " " + q.getProperty("os.version")), te) {
            try {
              ce = N.require("ringo/engine").version.join("."), le = "RingoJS";
            } catch {
              (q = N.system) && q.global.system == N.system && (le = "Narwhal", ve || (ve = q[0].os || null));
            }
            le || (le = "Rhino");
          } else
            typeof N.process == "object" && !N.process.browser && (q = N.process) && (typeof q.versions == "object" && (typeof q.versions.electron == "string" ? (Ce.push("Node " + q.versions.node), le = "Electron", ce = q.versions.electron) : typeof q.versions.nw == "string" && (Ce.push("Chromium " + ce, "Node " + q.versions.node), le = "NW.js", ce = q.versions.nw)), le || (le = "Node.js", Ue = q.arch, ve = q.platform, ce = /[\d.]+/.exec(q.version), ce = ce ? ce[0] : null));
        else
          $(q = N.runtime) == G ? (le = "Adobe AIR", ve = q.flash.system.Capabilities.os) : $(q = N.phantom) == ae ? (le = "PhantomJS", ce = (q = q.version || null) && q.major + "." + q.minor + "." + q.patch) : typeof De.documentMode == "number" && (q = /\bTrident\/(\d+)/i.exec(S)) ? (ce = [ce, De.documentMode], (q = +q[1] + 4) != ce[1] && (Ce.push("IE " + ce[1] + " mode"), Me && (Me[1] = ""), ce[1] = q), ce = le == "IE" ? String(ce[1].toFixed(1)) : ce[0]) : typeof De.documentMode == "number" && /^(?:Chrome|Firefox)\b/.test(le) && (Ce.push("masking as " + le + " " + ce), le = "IE", ce = "11.0", Me = ["Trident"], ve = "Windows");
        ve = ve && F(ve);
      }
      if (ce && (q = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(ce) || /(?:alpha|beta)(?: ?\d)?/i.exec(S + ";" + (Fe && V.appMinorVersion)) || /\bMinefield\b/i.test(S) && "a") && (me = /b/i.test(q) ? "beta" : "alpha", ce = ce.replace(RegExp(q + "\\+?$"), "") + (me == "beta" ? ge : ee) + (/\d+\+?/.exec(q) || "")), le == "Fennec" || le == "Firefox" && /\b(?:Android|Firefox OS|KaiOS)\b/.test(ve))
        le = "Firefox Mobile";
      else if (le == "Maxthon" && ce)
        ce = ce.replace(/\.[\d.]+/, ".x");
      else if (/\bXbox\b/i.test(Be))
        Be == "Xbox 360" && (ve = null), Be == "Xbox 360" && /\bIEMobile\b/.test(S) && Ce.unshift("mobile mode");
      else if ((/^(?:Chrome|IE|Opera)$/.test(le) || le && !Be && !/Browser|Mobi/.test(le)) && (ve == "Windows CE" || /Mobi/i.test(S)))
        le += " Mobile";
      else if (le == "IE" && Fe)
        try {
          N.external === null && Ce.unshift("platform preview");
        } catch {
          Ce.unshift("embedded");
        }
      else
        (/\bBlackBerry\b/.test(Be) || /\bBB10\b/.test(S)) && (q = (RegExp(Be.replace(/ +/g, " *") + "/([.\\d]+)", "i").exec(S) || 0)[1] || ce) ? (q = [q, /BB10/.test(S)], ve = (q[1] ? (Be = null, rt = "BlackBerry") : "Device Software") + " " + q[0], ce = null) : this != v && Be != "Wii" && (Fe && xe || /Opera/.test(le) && /\b(?:MSIE|Firefox)\b/i.test(S) || le == "Firefox" && /\bOS X (?:\d+\.){2,}/.test(ve) || le == "IE" && (ve && !/^Win/.test(ve) && ce > 5.5 || /\bWindows XP\b/.test(ve) && ce > 8 || ce == 8 && !/\bTrident\b/.test(S))) && !d.test(q = A.call(v, S.replace(d, "") + ";")) && q.name && (q = "ing as " + q.name + ((q = q.version) ? " " + q : ""), d.test(le) ? (/\bIE\b/.test(q) && ve == "Mac OS" && (ve = null), q = "identify" + q) : (q = "mask" + q, ze ? le = F(ze.replace(/([a-z])([A-Z])/g, "$1 $2")) : le = "Opera", /\bIE\b/.test(q) && (ve = null), Fe || (ce = null)), Me = ["Presto"], Ce.push(q));
      (q = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(S) || 0)[1]) && (q = [parseFloat(q.replace(/\.(\d)$/, ".0$1")), q], le == "Safari" && q[1].slice(-1) == "+" ? (le = "WebKit Nightly", me = "alpha", ce = q[1].slice(0, -1)) : (ce == q[1] || ce == (q[2] = (/\bSafari\/([\d.]+\+?)/i.exec(S) || 0)[1])) && (ce = null), q[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(S) || 0)[1], q[0] == 537.36 && q[2] == 537.36 && parseFloat(q[1]) >= 28 && Me == "WebKit" && (Me = ["Blink"]), !Fe || !U && !q[1] ? (Me && (Me[1] = "like Safari"), q = (q = q[0], q < 400 ? 1 : q < 500 ? 2 : q < 526 ? 3 : q < 533 ? 4 : q < 534 ? "4+" : q < 535 ? 5 : q < 537 ? 6 : q < 538 ? 7 : q < 601 ? 8 : q < 602 ? 9 : q < 604 ? 10 : q < 606 ? 11 : q < 608 ? 12 : "12")) : (Me && (Me[1] = "like Chrome"), q = q[1] || (q = q[0], q < 530 ? 1 : q < 532 ? 2 : q < 532.05 ? 3 : q < 533 ? 4 : q < 534.03 ? 5 : q < 534.07 ? 6 : q < 534.1 ? 7 : q < 534.13 ? 8 : q < 534.16 ? 9 : q < 534.24 ? 10 : q < 534.3 ? 11 : q < 535.01 ? 12 : q < 535.02 ? "13+" : q < 535.07 ? 15 : q < 535.11 ? 16 : q < 535.19 ? 17 : q < 536.05 ? 18 : q < 536.1 ? 19 : q < 537.01 ? 20 : q < 537.11 ? "21+" : q < 537.13 ? 23 : q < 537.18 ? 24 : q < 537.24 ? 25 : q < 537.36 ? 26 : Me != "Blink" ? "27" : "28")), Me && (Me[1] += " " + (q += typeof q == "number" ? ".x" : /[.+]/.test(q) ? "" : "+")), le == "Safari" && (!ce || parseInt(ce) > 45) ? ce = q : le == "Chrome" && /\bHeadlessChrome/i.test(S) && Ce.unshift("headless")), le == "Opera" && (q = /\bzbov|zvav$/.exec(ve)) ? (le += " ", Ce.unshift("desktop mode"), q == "zvav" ? (le += "Mini", ce = null) : le += "Mobile", ve = ve.replace(RegExp(" *" + q + "$"), "")) : le == "Safari" && /\bChrome\b/.exec(Me && Me[1]) ? (Ce.unshift("desktop mode"), le = "Chrome Mobile", ce = null, /\bOS X\b/.test(ve) ? (rt = "Apple", ve = "iOS 4.3+") : ve = null) : /\bSRWare Iron\b/.test(le) && !ce && (ce = Lr("Chrome")), ce && ce.indexOf(q = /[\d.]+$/.exec(ve)) == 0 && S.indexOf("/" + q + "-") > -1 && (ve = k(ve.replace(q, ""))), ve && ve.indexOf(le) != -1 && !RegExp(le + " OS").test(ve) && (ve = ve.replace(RegExp(" *" + D(le) + " *"), "")), Me && !/\b(?:Avant|Nook)\b/.test(le) && (/Browser|Lunascape|Maxthon/.test(le) || le != "Safari" && /^iOS/.test(ve) && /\bSafari\b/.test(Me[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(le) && Me[1]) && (q = Me[Me.length - 1]) && Ce.push(q), Ce.length && (Ce = ["(" + Ce.join("; ") + ")"]), rt && Be && Be.indexOf(rt) < 0 && Ce.push("on " + rt), Be && Ce.push((/^on /.test(Ce[Ce.length - 1]) ? "" : "on ") + Be), ve && (q = / ([\d.+]+)$/.exec(ve), z = q && ve.charAt(ve.length - q[0].length - 1) == "/", ve = {
        architecture: 32,
        family: q && !z ? ve.replace(q[0], "") : ve,
        version: q ? q[1] : null,
        toString: function() {
          var st = this.version;
          return this.family + (st && !z ? " " + st : "") + (this.architecture == 64 ? " 64-bit" : "");
        }
      }), (q = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(Ue)) && !/\bi686\b/i.test(Ue) ? (ve && (ve.architecture = 64, ve.family = ve.family.replace(RegExp(" *" + q), "")), le && (/\bWOW64\b/i.test(S) || Fe && /\w(?:86|32)$/.test(V.cpuClass || V.platform) && !/\bWin64; x64\b/i.test(S)) && Ce.unshift("32-bit")) : ve && /^OS X/.test(ve.family) && le == "Chrome" && parseFloat(ce) >= 39 && (ve.architecture = 64), S || (S = null);
      var Pe = {};
      return Pe.description = S, Pe.layout = Me && Me[0], Pe.manufacturer = rt, Pe.name = le, Pe.prerelease = me, Pe.product = Be, Pe.ua = S, Pe.version = le && ce, Pe.os = ve || {
        /**
         * The CPU architecture the OS is built for.
         *
         * @memberOf platform.os
         * @type number|null
         */
        architecture: null,
        /**
         * The family of the OS.
         *
         * Common values include:
         * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
         * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
         * "SuSE", "Android", "iOS" and "Windows Phone"
         *
         * @memberOf platform.os
         * @type string|null
         */
        family: null,
        /**
         * The version of the OS.
         *
         * @memberOf platform.os
         * @type string|null
         */
        version: null,
        /**
         * Returns the OS string.
         *
         * @memberOf platform.os
         * @returns {string} The OS string.
         */
        toString: function() {
          return "null";
        }
      }, Pe.parse = A, Pe.toString = Oe, Pe.version && Ce.unshift(ce), Pe.name && Ce.unshift(le), ve && le && !(ve == String(ve).split(" ")[0] && (ve == le.split(" ")[0] || Be)) && Ce.push(Be ? "(" + ve + ")" : "on " + ve), Ce.length && (Pe.description = Ce.join(" ")), Pe;
    }
    var P = A();
    a && i ? v(P, function(S, N) {
      a[N] = S;
    }) : n.platform = P;
  }).call(un);
})(uG, Ou);
const o6 = Ou, dG = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? (...e) => console.error("SEMVER", ...e) : () => {
};
var Eh = dG;
const lG = "2.0.0", qk = 256, fG = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
9007199254740991, cG = 16, hG = qk - 6, gG = [
  "major",
  "premajor",
  "minor",
  "preminor",
  "patch",
  "prepatch",
  "prerelease"
];
var L3 = {
  MAX_LENGTH: qk,
  MAX_SAFE_COMPONENT_LENGTH: cG,
  MAX_SAFE_BUILD_LENGTH: hG,
  MAX_SAFE_INTEGER: fG,
  RELEASE_TYPES: gG,
  SEMVER_SPEC_VERSION: lG,
  FLAG_INCLUDE_PRERELEASE: 1,
  FLAG_LOOSE: 2
}, ps = {}, _G = {
  get exports() {
    return ps;
  },
  set exports(e) {
    ps = e;
  }
};
(function(e, t) {
  const {
    MAX_SAFE_COMPONENT_LENGTH: r,
    MAX_SAFE_BUILD_LENGTH: n,
    MAX_LENGTH: a
  } = L3, i = Eh;
  t = e.exports = {};
  const o = t.re = [], u = t.safeRe = [], d = t.src = [], s = t.t = {};
  let l = 0;
  const f = "[a-zA-Z0-9-]", c = [
    ["\\s", 1],
    ["\\d", a],
    [f, n]
  ], h = (F) => {
    for (const [v, $] of c)
      F = F.split(`${v}*`).join(`${v}{0,${$}}`).split(`${v}+`).join(`${v}{1,${$}}`);
    return F;
  }, _ = (F, v, $) => {
    const E = h(v), D = l++;
    i(F, D, v), s[F] = D, d[D] = v, o[D] = new RegExp(v, $ ? "g" : void 0), u[D] = new RegExp(E, $ ? "g" : void 0);
  };
  _("NUMERICIDENTIFIER", "0|[1-9]\\d*"), _("NUMERICIDENTIFIERLOOSE", "\\d+"), _("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${f}*`), _("MAINVERSION", `(${d[s.NUMERICIDENTIFIER]})\\.(${d[s.NUMERICIDENTIFIER]})\\.(${d[s.NUMERICIDENTIFIER]})`), _("MAINVERSIONLOOSE", `(${d[s.NUMERICIDENTIFIERLOOSE]})\\.(${d[s.NUMERICIDENTIFIERLOOSE]})\\.(${d[s.NUMERICIDENTIFIERLOOSE]})`), _("PRERELEASEIDENTIFIER", `(?:${d[s.NUMERICIDENTIFIER]}|${d[s.NONNUMERICIDENTIFIER]})`), _("PRERELEASEIDENTIFIERLOOSE", `(?:${d[s.NUMERICIDENTIFIERLOOSE]}|${d[s.NONNUMERICIDENTIFIER]})`), _("PRERELEASE", `(?:-(${d[s.PRERELEASEIDENTIFIER]}(?:\\.${d[s.PRERELEASEIDENTIFIER]})*))`), _("PRERELEASELOOSE", `(?:-?(${d[s.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${d[s.PRERELEASEIDENTIFIERLOOSE]})*))`), _("BUILDIDENTIFIER", `${f}+`), _("BUILD", `(?:\\+(${d[s.BUILDIDENTIFIER]}(?:\\.${d[s.BUILDIDENTIFIER]})*))`), _("FULLPLAIN", `v?${d[s.MAINVERSION]}${d[s.PRERELEASE]}?${d[s.BUILD]}?`), _("FULL", `^${d[s.FULLPLAIN]}$`), _("LOOSEPLAIN", `[v=\\s]*${d[s.MAINVERSIONLOOSE]}${d[s.PRERELEASELOOSE]}?${d[s.BUILD]}?`), _("LOOSE", `^${d[s.LOOSEPLAIN]}$`), _("GTLT", "((?:<|>)?=?)"), _("XRANGEIDENTIFIERLOOSE", `${d[s.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), _("XRANGEIDENTIFIER", `${d[s.NUMERICIDENTIFIER]}|x|X|\\*`), _("XRANGEPLAIN", `[v=\\s]*(${d[s.XRANGEIDENTIFIER]})(?:\\.(${d[s.XRANGEIDENTIFIER]})(?:\\.(${d[s.XRANGEIDENTIFIER]})(?:${d[s.PRERELEASE]})?${d[s.BUILD]}?)?)?`), _("XRANGEPLAINLOOSE", `[v=\\s]*(${d[s.XRANGEIDENTIFIERLOOSE]})(?:\\.(${d[s.XRANGEIDENTIFIERLOOSE]})(?:\\.(${d[s.XRANGEIDENTIFIERLOOSE]})(?:${d[s.PRERELEASELOOSE]})?${d[s.BUILD]}?)?)?`), _("XRANGE", `^${d[s.GTLT]}\\s*${d[s.XRANGEPLAIN]}$`), _("XRANGELOOSE", `^${d[s.GTLT]}\\s*${d[s.XRANGEPLAINLOOSE]}$`), _("COERCEPLAIN", `(^|[^\\d])(\\d{1,${r}})(?:\\.(\\d{1,${r}}))?(?:\\.(\\d{1,${r}}))?`), _("COERCE", `${d[s.COERCEPLAIN]}(?:$|[^\\d])`), _("COERCEFULL", d[s.COERCEPLAIN] + `(?:${d[s.PRERELEASE]})?(?:${d[s.BUILD]})?(?:$|[^\\d])`), _("COERCERTL", d[s.COERCE], !0), _("COERCERTLFULL", d[s.COERCEFULL], !0), _("LONETILDE", "(?:~>?)"), _("TILDETRIM", `(\\s*)${d[s.LONETILDE]}\\s+`, !0), t.tildeTrimReplace = "$1~", _("TILDE", `^${d[s.LONETILDE]}${d[s.XRANGEPLAIN]}$`), _("TILDELOOSE", `^${d[s.LONETILDE]}${d[s.XRANGEPLAINLOOSE]}$`), _("LONECARET", "(?:\\^)"), _("CARETTRIM", `(\\s*)${d[s.LONECARET]}\\s+`, !0), t.caretTrimReplace = "$1^", _("CARET", `^${d[s.LONECARET]}${d[s.XRANGEPLAIN]}$`), _("CARETLOOSE", `^${d[s.LONECARET]}${d[s.XRANGEPLAINLOOSE]}$`), _("COMPARATORLOOSE", `^${d[s.GTLT]}\\s*(${d[s.LOOSEPLAIN]})$|^$`), _("COMPARATOR", `^${d[s.GTLT]}\\s*(${d[s.FULLPLAIN]})$|^$`), _("COMPARATORTRIM", `(\\s*)${d[s.GTLT]}\\s*(${d[s.LOOSEPLAIN]}|${d[s.XRANGEPLAIN]})`, !0), t.comparatorTrimReplace = "$1$2$3", _("HYPHENRANGE", `^\\s*(${d[s.XRANGEPLAIN]})\\s+-\\s+(${d[s.XRANGEPLAIN]})\\s*$`), _("HYPHENRANGELOOSE", `^\\s*(${d[s.XRANGEPLAINLOOSE]})\\s+-\\s+(${d[s.XRANGEPLAINLOOSE]})\\s*$`), _("STAR", "(<|>)?=?\\s*\\*"), _("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), _("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})(_G, ps);
const mG = Object.freeze({ loose: !0 }), pG = Object.freeze({}), FG = (e) => e ? typeof e != "object" ? mG : e : pG;
var q3 = FG;
const s6 = /^[0-9]+$/, Uk = (e, t) => {
  const r = s6.test(e), n = s6.test(t);
  return r && n && (e = +e, t = +t), e === t ? 0 : r && !n ? -1 : n && !r ? 1 : e < t ? -1 : 1;
}, yG = (e, t) => Uk(t, e);
var bG = {
  compareIdentifiers: Uk,
  rcompareIdentifiers: yG
};
const Jc = Eh, { MAX_LENGTH: u6, MAX_SAFE_INTEGER: e1 } = L3, { safeRe: d6, t: l6 } = ps, vG = q3, { compareIdentifiers: ru } = bG;
let EG = class Pa {
  constructor(t, r) {
    if (r = vG(r), t instanceof Pa) {
      if (t.loose === !!r.loose && t.includePrerelease === !!r.includePrerelease)
        return t;
      t = t.version;
    } else if (typeof t != "string")
      throw new TypeError(`Invalid version. Must be a string. Got type "${typeof t}".`);
    if (t.length > u6)
      throw new TypeError(
        `version is longer than ${u6} characters`
      );
    Jc("SemVer", t, r), this.options = r, this.loose = !!r.loose, this.includePrerelease = !!r.includePrerelease;
    const n = t.trim().match(r.loose ? d6[l6.LOOSE] : d6[l6.FULL]);
    if (!n)
      throw new TypeError(`Invalid Version: ${t}`);
    if (this.raw = t, this.major = +n[1], this.minor = +n[2], this.patch = +n[3], this.major > e1 || this.major < 0)
      throw new TypeError("Invalid major version");
    if (this.minor > e1 || this.minor < 0)
      throw new TypeError("Invalid minor version");
    if (this.patch > e1 || this.patch < 0)
      throw new TypeError("Invalid patch version");
    n[4] ? this.prerelease = n[4].split(".").map((a) => {
      if (/^[0-9]+$/.test(a)) {
        const i = +a;
        if (i >= 0 && i < e1)
          return i;
      }
      return a;
    }) : this.prerelease = [], this.build = n[5] ? n[5].split(".") : [], this.format();
  }
  format() {
    return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
  }
  toString() {
    return this.version;
  }
  compare(t) {
    if (Jc("SemVer.compare", this.version, this.options, t), !(t instanceof Pa)) {
      if (typeof t == "string" && t === this.version)
        return 0;
      t = new Pa(t, this.options);
    }
    return t.version === this.version ? 0 : this.compareMain(t) || this.comparePre(t);
  }
  compareMain(t) {
    return t instanceof Pa || (t = new Pa(t, this.options)), ru(this.major, t.major) || ru(this.minor, t.minor) || ru(this.patch, t.patch);
  }
  comparePre(t) {
    if (t instanceof Pa || (t = new Pa(t, this.options)), this.prerelease.length && !t.prerelease.length)
      return -1;
    if (!this.prerelease.length && t.prerelease.length)
      return 1;
    if (!this.prerelease.length && !t.prerelease.length)
      return 0;
    let r = 0;
    do {
      const n = this.prerelease[r], a = t.prerelease[r];
      if (Jc("prerelease compare", r, n, a), n === void 0 && a === void 0)
        return 0;
      if (a === void 0)
        return 1;
      if (n === void 0)
        return -1;
      if (n === a)
        continue;
      return ru(n, a);
    } while (++r);
  }
  compareBuild(t) {
    t instanceof Pa || (t = new Pa(t, this.options));
    let r = 0;
    do {
      const n = this.build[r], a = t.build[r];
      if (Jc("prerelease compare", r, n, a), n === void 0 && a === void 0)
        return 0;
      if (a === void 0)
        return 1;
      if (n === void 0)
        return -1;
      if (n === a)
        continue;
      return ru(n, a);
    } while (++r);
  }
  // preminor will bump the version up to the next minor release, and immediately
  // down to pre-release. premajor and prepatch work the same way.
  inc(t, r, n) {
    switch (t) {
      case "premajor":
        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", r, n);
        break;
      case "preminor":
        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", r, n);
        break;
      case "prepatch":
        this.prerelease.length = 0, this.inc("patch", r, n), this.inc("pre", r, n);
        break;
      case "prerelease":
        this.prerelease.length === 0 && this.inc("patch", r, n), this.inc("pre", r, n);
        break;
      case "major":
        (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
        break;
      case "minor":
        (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
        break;
      case "patch":
        this.prerelease.length === 0 && this.patch++, this.prerelease = [];
        break;
      case "pre": {
        const a = Number(n) ? 1 : 0;
        if (!r && n === !1)
          throw new Error("invalid increment argument: identifier is empty");
        if (this.prerelease.length === 0)
          this.prerelease = [a];
        else {
          let i = this.prerelease.length;
          for (; --i >= 0; )
            typeof this.prerelease[i] == "number" && (this.prerelease[i]++, i = -2);
          if (i === -1) {
            if (r === this.prerelease.join(".") && n === !1)
              throw new Error("invalid increment argument: identifier already exists");
            this.prerelease.push(a);
          }
        }
        if (r) {
          let i = [r, a];
          n === !1 && (i = [r]), ru(this.prerelease[0], r) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = i) : this.prerelease = i;
        }
        break;
      }
      default:
        throw new Error(`invalid increment argument: ${t}`);
    }
    return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
  }
};
var Pf = EG;
const f6 = Pf, $G = (e, t, r = !1) => {
  if (e instanceof f6)
    return e;
  try {
    return new f6(e, t);
  } catch (n) {
    if (!r)
      return null;
    throw n;
  }
};
var Gk = $G;
const wG = Pf, kG = Gk, { safeRe: t1, t: r1 } = ps, xG = (e, t) => {
  if (e instanceof wG)
    return e;
  if (typeof e == "number" && (e = String(e)), typeof e != "string")
    return null;
  t = t || {};
  let r = null;
  if (!t.rtl)
    r = e.match(t.includePrerelease ? t1[r1.COERCEFULL] : t1[r1.COERCE]);
  else {
    const d = t.includePrerelease ? t1[r1.COERCERTLFULL] : t1[r1.COERCERTL];
    let s;
    for (; (s = d.exec(e)) && (!r || r.index + r[0].length !== e.length); )
      (!r || s.index + s[0].length !== r.index + r[0].length) && (r = s), d.lastIndex = s.index + s[1].length + s[2].length;
    d.lastIndex = -1;
  }
  if (r === null)
    return null;
  const n = r[2], a = r[3] || "0", i = r[4] || "0", o = t.includePrerelease && r[5] ? `-${r[5]}` : "", u = t.includePrerelease && r[6] ? `+${r[6]}` : "";
  return kG(`${n}.${a}.${i}${o}${u}`, t);
};
var DG = xG, p_, c6;
function CG() {
  return c6 || (c6 = 1, p_ = function(e) {
    e.prototype[Symbol.iterator] = function* () {
      for (let t = this.head; t; t = t.next)
        yield t.value;
    };
  }), p_;
}
var SG = St;
St.Node = Fs;
St.create = St;
function St(e) {
  var t = this;
  if (t instanceof St || (t = new St()), t.tail = null, t.head = null, t.length = 0, e && typeof e.forEach == "function")
    e.forEach(function(a) {
      t.push(a);
    });
  else if (arguments.length > 0)
    for (var r = 0, n = arguments.length; r < n; r++)
      t.push(arguments[r]);
  return t;
}
St.prototype.removeNode = function(e) {
  if (e.list !== this)
    throw new Error("removing node which does not belong to this list");
  var t = e.next, r = e.prev;
  return t && (t.prev = r), r && (r.next = t), e === this.head && (this.head = t), e === this.tail && (this.tail = r), e.list.length--, e.next = null, e.prev = null, e.list = null, t;
};
St.prototype.unshiftNode = function(e) {
  if (e !== this.head) {
    e.list && e.list.removeNode(e);
    var t = this.head;
    e.list = this, e.next = t, t && (t.prev = e), this.head = e, this.tail || (this.tail = e), this.length++;
  }
};
St.prototype.pushNode = function(e) {
  if (e !== this.tail) {
    e.list && e.list.removeNode(e);
    var t = this.tail;
    e.list = this, e.prev = t, t && (t.next = e), this.tail = e, this.head || (this.head = e), this.length++;
  }
};
St.prototype.push = function() {
  for (var e = 0, t = arguments.length; e < t; e++)
    OG(this, arguments[e]);
  return this.length;
};
St.prototype.unshift = function() {
  for (var e = 0, t = arguments.length; e < t; e++)
    TG(this, arguments[e]);
  return this.length;
};
St.prototype.pop = function() {
  if (this.tail) {
    var e = this.tail.value;
    return this.tail = this.tail.prev, this.tail ? this.tail.next = null : this.head = null, this.length--, e;
  }
};
St.prototype.shift = function() {
  if (this.head) {
    var e = this.head.value;
    return this.head = this.head.next, this.head ? this.head.prev = null : this.tail = null, this.length--, e;
  }
};
St.prototype.forEach = function(e, t) {
  t = t || this;
  for (var r = this.head, n = 0; r !== null; n++)
    e.call(t, r.value, n, this), r = r.next;
};
St.prototype.forEachReverse = function(e, t) {
  t = t || this;
  for (var r = this.tail, n = this.length - 1; r !== null; n--)
    e.call(t, r.value, n, this), r = r.prev;
};
St.prototype.get = function(e) {
  for (var t = 0, r = this.head; r !== null && t < e; t++)
    r = r.next;
  if (t === e && r !== null)
    return r.value;
};
St.prototype.getReverse = function(e) {
  for (var t = 0, r = this.tail; r !== null && t < e; t++)
    r = r.prev;
  if (t === e && r !== null)
    return r.value;
};
St.prototype.map = function(e, t) {
  t = t || this;
  for (var r = new St(), n = this.head; n !== null; )
    r.push(e.call(t, n.value, this)), n = n.next;
  return r;
};
St.prototype.mapReverse = function(e, t) {
  t = t || this;
  for (var r = new St(), n = this.tail; n !== null; )
    r.push(e.call(t, n.value, this)), n = n.prev;
  return r;
};
St.prototype.reduce = function(e, t) {
  var r, n = this.head;
  if (arguments.length > 1)
    r = t;
  else if (this.head)
    n = this.head.next, r = this.head.value;
  else
    throw new TypeError("Reduce of empty list with no initial value");
  for (var a = 0; n !== null; a++)
    r = e(r, n.value, a), n = n.next;
  return r;
};
St.prototype.reduceReverse = function(e, t) {
  var r, n = this.tail;
  if (arguments.length > 1)
    r = t;
  else if (this.tail)
    n = this.tail.prev, r = this.tail.value;
  else
    throw new TypeError("Reduce of empty list with no initial value");
  for (var a = this.length - 1; n !== null; a--)
    r = e(r, n.value, a), n = n.prev;
  return r;
};
St.prototype.toArray = function() {
  for (var e = new Array(this.length), t = 0, r = this.head; r !== null; t++)
    e[t] = r.value, r = r.next;
  return e;
};
St.prototype.toArrayReverse = function() {
  for (var e = new Array(this.length), t = 0, r = this.tail; r !== null; t++)
    e[t] = r.value, r = r.prev;
  return e;
};
St.prototype.slice = function(e, t) {
  t = t || this.length, t < 0 && (t += this.length), e = e || 0, e < 0 && (e += this.length);
  var r = new St();
  if (t < e || t < 0)
    return r;
  e < 0 && (e = 0), t > this.length && (t = this.length);
  for (var n = 0, a = this.head; a !== null && n < e; n++)
    a = a.next;
  for (; a !== null && n < t; n++, a = a.next)
    r.push(a.value);
  return r;
};
St.prototype.sliceReverse = function(e, t) {
  t = t || this.length, t < 0 && (t += this.length), e = e || 0, e < 0 && (e += this.length);
  var r = new St();
  if (t < e || t < 0)
    return r;
  e < 0 && (e = 0), t > this.length && (t = this.length);
  for (var n = this.length, a = this.tail; a !== null && n > t; n--)
    a = a.prev;
  for (; a !== null && n > e; n--, a = a.prev)
    r.push(a.value);
  return r;
};
St.prototype.splice = function(e, t, ...r) {
  e > this.length && (e = this.length - 1), e < 0 && (e = this.length + e);
  for (var n = 0, a = this.head; a !== null && n < e; n++)
    a = a.next;
  for (var i = [], n = 0; a && n < t; n++)
    i.push(a.value), a = this.removeNode(a);
  a === null && (a = this.tail), a !== this.head && a !== this.tail && (a = a.prev);
  for (var n = 0; n < r.length; n++)
    a = AG(this, a, r[n]);
  return i;
};
St.prototype.reverse = function() {
  for (var e = this.head, t = this.tail, r = e; r !== null; r = r.prev) {
    var n = r.prev;
    r.prev = r.next, r.next = n;
  }
  return this.head = t, this.tail = e, this;
};
function AG(e, t, r) {
  var n = t === e.head ? new Fs(r, null, t, e) : new Fs(r, t, t.next, e);
  return n.next === null && (e.tail = n), n.prev === null && (e.head = n), e.length++, n;
}
function OG(e, t) {
  e.tail = new Fs(t, e.tail, null, e), e.head || (e.head = e.tail), e.length++;
}
function TG(e, t) {
  e.head = new Fs(t, null, e.head, e), e.tail || (e.tail = e.head), e.length++;
}
function Fs(e, t, r, n) {
  if (!(this instanceof Fs))
    return new Fs(e, t, r, n);
  this.list = n, this.value = e, t ? (t.next = this, this.prev = t) : this.prev = null, r ? (r.prev = this, this.next = r) : this.next = null;
}
try {
  CG()(St);
} catch {
}
const PG = SG, ts = Symbol("max"), bi = Symbol("length"), nu = Symbol("lengthCalculator"), dl = Symbol("allowStale"), as = Symbol("maxAge"), mi = Symbol("dispose"), h6 = Symbol("noDisposeOnSet"), Sr = Symbol("lruList"), la = Symbol("cache"), Wk = Symbol("updateAgeOnGet"), F_ = () => 1;
class IG {
  constructor(t) {
    if (typeof t == "number" && (t = { max: t }), t || (t = {}), t.max && (typeof t.max != "number" || t.max < 0))
      throw new TypeError("max must be a non-negative number");
    this[ts] = t.max || 1 / 0;
    const r = t.length || F_;
    if (this[nu] = typeof r != "function" ? F_ : r, this[dl] = t.stale || !1, t.maxAge && typeof t.maxAge != "number")
      throw new TypeError("maxAge must be a number");
    this[as] = t.maxAge || 0, this[mi] = t.dispose, this[h6] = t.noDisposeOnSet || !1, this[Wk] = t.updateAgeOnGet || !1, this.reset();
  }
  // resize the cache when the max changes.
  set max(t) {
    if (typeof t != "number" || t < 0)
      throw new TypeError("max must be a non-negative number");
    this[ts] = t || 1 / 0, Ld(this);
  }
  get max() {
    return this[ts];
  }
  set allowStale(t) {
    this[dl] = !!t;
  }
  get allowStale() {
    return this[dl];
  }
  set maxAge(t) {
    if (typeof t != "number")
      throw new TypeError("maxAge must be a non-negative number");
    this[as] = t, Ld(this);
  }
  get maxAge() {
    return this[as];
  }
  // resize the cache when the lengthCalculator changes.
  set lengthCalculator(t) {
    typeof t != "function" && (t = F_), t !== this[nu] && (this[nu] = t, this[bi] = 0, this[Sr].forEach((r) => {
      r.length = this[nu](r.value, r.key), this[bi] += r.length;
    })), Ld(this);
  }
  get lengthCalculator() {
    return this[nu];
  }
  get length() {
    return this[bi];
  }
  get itemCount() {
    return this[Sr].length;
  }
  rforEach(t, r) {
    r = r || this;
    for (let n = this[Sr].tail; n !== null; ) {
      const a = n.prev;
      g6(this, t, n, r), n = a;
    }
  }
  forEach(t, r) {
    r = r || this;
    for (let n = this[Sr].head; n !== null; ) {
      const a = n.next;
      g6(this, t, n, r), n = a;
    }
  }
  keys() {
    return this[Sr].toArray().map((t) => t.key);
  }
  values() {
    return this[Sr].toArray().map((t) => t.value);
  }
  reset() {
    this[mi] && this[Sr] && this[Sr].length && this[Sr].forEach((t) => this[mi](t.key, t.value)), this[la] = /* @__PURE__ */ new Map(), this[Sr] = new PG(), this[bi] = 0;
  }
  dump() {
    return this[Sr].map((t) => N1(this, t) ? !1 : {
      k: t.key,
      v: t.value,
      e: t.now + (t.maxAge || 0)
    }).toArray().filter((t) => t);
  }
  dumpLru() {
    return this[Sr];
  }
  set(t, r, n) {
    if (n = n || this[as], n && typeof n != "number")
      throw new TypeError("maxAge must be a number");
    const a = n ? Date.now() : 0, i = this[nu](r, t);
    if (this[la].has(t)) {
      if (i > this[ts])
        return $u(this, this[la].get(t)), !1;
      const d = this[la].get(t).value;
      return this[mi] && (this[h6] || this[mi](t, d.value)), d.now = a, d.maxAge = n, d.value = r, this[bi] += i - d.length, d.length = i, this.get(t), Ld(this), !0;
    }
    const o = new RG(t, r, i, a, n);
    return o.length > this[ts] ? (this[mi] && this[mi](t, r), !1) : (this[bi] += o.length, this[Sr].unshift(o), this[la].set(t, this[Sr].head), Ld(this), !0);
  }
  has(t) {
    if (!this[la].has(t))
      return !1;
    const r = this[la].get(t).value;
    return !N1(this, r);
  }
  get(t) {
    return y_(this, t, !0);
  }
  peek(t) {
    return y_(this, t, !1);
  }
  pop() {
    const t = this[Sr].tail;
    return t ? ($u(this, t), t.value) : null;
  }
  del(t) {
    $u(this, this[la].get(t));
  }
  load(t) {
    this.reset();
    const r = Date.now();
    for (let n = t.length - 1; n >= 0; n--) {
      const a = t[n], i = a.e || 0;
      if (i === 0)
        this.set(a.k, a.v);
      else {
        const o = i - r;
        o > 0 && this.set(a.k, a.v, o);
      }
    }
  }
  prune() {
    this[la].forEach((t, r) => y_(this, r, !1));
  }
}
const y_ = (e, t, r) => {
  const n = e[la].get(t);
  if (n) {
    const a = n.value;
    if (N1(e, a)) {
      if ($u(e, n), !e[dl])
        return;
    } else
      r && (e[Wk] && (n.value.now = Date.now()), e[Sr].unshiftNode(n));
    return a.value;
  }
}, N1 = (e, t) => {
  if (!t || !t.maxAge && !e[as])
    return !1;
  const r = Date.now() - t.now;
  return t.maxAge ? r > t.maxAge : e[as] && r > e[as];
}, Ld = (e) => {
  if (e[bi] > e[ts])
    for (let t = e[Sr].tail; e[bi] > e[ts] && t !== null; ) {
      const r = t.prev;
      $u(e, t), t = r;
    }
}, $u = (e, t) => {
  if (t) {
    const r = t.value;
    e[mi] && e[mi](r.key, r.value), e[bi] -= r.length, e[la].delete(r.key), e[Sr].removeNode(t);
  }
};
class RG {
  constructor(t, r, n, a, i) {
    this.key = t, this.value = r, this.length = n, this.now = a, this.maxAge = i || 0;
  }
}
const g6 = (e, t, r, n) => {
  let a = r.value;
  N1(e, a) && ($u(e, r), e[dl] || (a = void 0)), a && t.call(n, a.value, a.key, e);
};
var jG = IG;
const _6 = Pf, MG = (e, t, r) => new _6(e, r).compare(new _6(t, r));
var od = MG;
const BG = od, NG = (e, t, r) => BG(e, t, r) === 0;
var LG = NG;
const qG = od, UG = (e, t, r) => qG(e, t, r) !== 0;
var GG = UG;
const WG = od, VG = (e, t, r) => WG(e, t, r) > 0;
var HG = VG;
const zG = od, KG = (e, t, r) => zG(e, t, r) >= 0;
var YG = KG;
const XG = od, QG = (e, t, r) => XG(e, t, r) < 0;
var ZG = QG;
const JG = od, eW = (e, t, r) => JG(e, t, r) <= 0;
var tW = eW;
const rW = LG, nW = GG, aW = HG, iW = YG, oW = ZG, sW = tW, uW = (e, t, r, n) => {
  switch (t) {
    case "===":
      return typeof e == "object" && (e = e.version), typeof r == "object" && (r = r.version), e === r;
    case "!==":
      return typeof e == "object" && (e = e.version), typeof r == "object" && (r = r.version), e !== r;
    case "":
    case "=":
    case "==":
      return rW(e, r, n);
    case "!=":
      return nW(e, r, n);
    case ">":
      return aW(e, r, n);
    case ">=":
      return iW(e, r, n);
    case "<":
      return oW(e, r, n);
    case "<=":
      return sW(e, r, n);
    default:
      throw new TypeError(`Invalid operator: ${t}`);
  }
};
var dW = uW, b_, m6;
function lW() {
  if (m6)
    return b_;
  m6 = 1;
  const e = Symbol("SemVer ANY");
  class t {
    static get ANY() {
      return e;
    }
    constructor(l, f) {
      if (f = r(f), l instanceof t) {
        if (l.loose === !!f.loose)
          return l;
        l = l.value;
      }
      l = l.trim().split(/\s+/).join(" "), o("comparator", l, f), this.options = f, this.loose = !!f.loose, this.parse(l), this.semver === e ? this.value = "" : this.value = this.operator + this.semver.version, o("comp", this);
    }
    parse(l) {
      const f = this.options.loose ? n[a.COMPARATORLOOSE] : n[a.COMPARATOR], c = l.match(f);
      if (!c)
        throw new TypeError(`Invalid comparator: ${l}`);
      this.operator = c[1] !== void 0 ? c[1] : "", this.operator === "=" && (this.operator = ""), c[2] ? this.semver = new u(c[2], this.options.loose) : this.semver = e;
    }
    toString() {
      return this.value;
    }
    test(l) {
      if (o("Comparator.test", l, this.options.loose), this.semver === e || l === e)
        return !0;
      if (typeof l == "string")
        try {
          l = new u(l, this.options);
        } catch {
          return !1;
        }
      return i(l, this.operator, this.semver, this.options);
    }
    intersects(l, f) {
      if (!(l instanceof t))
        throw new TypeError("a Comparator is required");
      return this.operator === "" ? this.value === "" ? !0 : new d(l.value, f).test(this.value) : l.operator === "" ? l.value === "" ? !0 : new d(this.value, f).test(l.semver) : (f = r(f), f.includePrerelease && (this.value === "<0.0.0-0" || l.value === "<0.0.0-0") || !f.includePrerelease && (this.value.startsWith("<0.0.0") || l.value.startsWith("<0.0.0")) ? !1 : !!(this.operator.startsWith(">") && l.operator.startsWith(">") || this.operator.startsWith("<") && l.operator.startsWith("<") || this.semver.version === l.semver.version && this.operator.includes("=") && l.operator.includes("=") || i(this.semver, "<", l.semver, f) && this.operator.startsWith(">") && l.operator.startsWith("<") || i(this.semver, ">", l.semver, f) && this.operator.startsWith("<") && l.operator.startsWith(">")));
    }
  }
  b_ = t;
  const r = q3, { safeRe: n, t: a } = ps, i = dW, o = Eh, u = Pf, d = Vk();
  return b_;
}
var v_, p6;
function Vk() {
  if (p6)
    return v_;
  p6 = 1;
  class e {
    constructor(j, G) {
      if (G = n(G), j instanceof e)
        return j.loose === !!G.loose && j.includePrerelease === !!G.includePrerelease ? j : new e(j.raw, G);
      if (j instanceof a)
        return this.raw = j.value, this.set = [[j]], this.format(), this;
      if (this.options = G, this.loose = !!G.loose, this.includePrerelease = !!G.includePrerelease, this.raw = j.trim().split(/\s+/).join(" "), this.set = this.raw.split("||").map((H) => this.parseRange(H.trim())).filter((H) => H.length), !this.set.length)
        throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
      if (this.set.length > 1) {
        const H = this.set[0];
        if (this.set = this.set.filter((J) => !_(J[0])), this.set.length === 0)
          this.set = [H];
        else if (this.set.length > 1) {
          for (const J of this.set)
            if (J.length === 1 && F(J[0])) {
              this.set = [J];
              break;
            }
        }
      }
      this.format();
    }
    format() {
      return this.range = this.set.map((j) => j.join(" ").trim()).join("||").trim(), this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(j) {
      const H = ((this.options.includePrerelease && c) | (this.options.loose && h)) + ":" + j, J = r.get(H);
      if (J)
        return J;
      const ae = this.options.loose, de = ae ? u[d.HYPHENRANGELOOSE] : u[d.HYPHENRANGE];
      j = j.replace(de, V(this.options.includePrerelease)), i("hyphen replace", j), j = j.replace(u[d.COMPARATORTRIM], s), i("comparator trim", j), j = j.replace(u[d.TILDETRIM], l), i("tilde trim", j), j = j.replace(u[d.CARETTRIM], f), i("caret trim", j);
      let te = j.split(" ").map((xe) => $(xe, this.options)).join(" ").split(/\s+/).map((xe) => W(xe, this.options));
      ae && (te = te.filter((xe) => (i("loose invalid filter", xe, this.options), !!xe.match(u[d.COMPARATORLOOSE])))), i("range list", te);
      const ee = /* @__PURE__ */ new Map(), ge = te.map((xe) => new a(xe, this.options));
      for (const xe of ge) {
        if (_(xe))
          return [xe];
        ee.set(xe.value, xe);
      }
      ee.size > 1 && ee.has("") && ee.delete("");
      const De = [...ee.values()];
      return r.set(H, De), De;
    }
    intersects(j, G) {
      if (!(j instanceof e))
        throw new TypeError("a Range is required");
      return this.set.some((H) => v(H, G) && j.set.some((J) => v(J, G) && H.every((ae) => J.every((de) => ae.intersects(de, G)))));
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(j) {
      if (!j)
        return !1;
      if (typeof j == "string")
        try {
          j = new o(j, this.options);
        } catch {
          return !1;
        }
      for (let G = 0; G < this.set.length; G++)
        if (K(this.set[G], j, this.options))
          return !0;
      return !1;
    }
  }
  v_ = e;
  const t = jG, r = new t({ max: 1e3 }), n = q3, a = lW(), i = Eh, o = Pf, {
    safeRe: u,
    t: d,
    comparatorTrimReplace: s,
    tildeTrimReplace: l,
    caretTrimReplace: f
  } = ps, { FLAG_INCLUDE_PRERELEASE: c, FLAG_LOOSE: h } = L3, _ = (U) => U.value === "<0.0.0-0", F = (U) => U.value === "", v = (U, j) => {
    let G = !0;
    const H = U.slice();
    let J = H.pop();
    for (; G && H.length; )
      G = H.every((ae) => J.intersects(ae, j)), J = H.pop();
    return G;
  }, $ = (U, j) => (i("comp", U, j), U = k(U, j), i("caret", U), U = D(U, j), i("tildes", U), U = P(U, j), i("xrange", U), U = N(U, j), i("stars", U), U), E = (U) => !U || U.toLowerCase() === "x" || U === "*", D = (U, j) => U.trim().split(/\s+/).map((G) => w(G, j)).join(" "), w = (U, j) => {
    const G = j.loose ? u[d.TILDELOOSE] : u[d.TILDE];
    return U.replace(G, (H, J, ae, de, te) => {
      i("tilde", U, H, J, ae, de, te);
      let ee;
      return E(J) ? ee = "" : E(ae) ? ee = `>=${J}.0.0 <${+J + 1}.0.0-0` : E(de) ? ee = `>=${J}.${ae}.0 <${J}.${+ae + 1}.0-0` : te ? (i("replaceTilde pr", te), ee = `>=${J}.${ae}.${de}-${te} <${J}.${+ae + 1}.0-0`) : ee = `>=${J}.${ae}.${de} <${J}.${+ae + 1}.0-0`, i("tilde return", ee), ee;
    });
  }, k = (U, j) => U.trim().split(/\s+/).map((G) => A(G, j)).join(" "), A = (U, j) => {
    i("caret", U, j);
    const G = j.loose ? u[d.CARETLOOSE] : u[d.CARET], H = j.includePrerelease ? "-0" : "";
    return U.replace(G, (J, ae, de, te, ee) => {
      i("caret", U, J, ae, de, te, ee);
      let ge;
      return E(ae) ? ge = "" : E(de) ? ge = `>=${ae}.0.0${H} <${+ae + 1}.0.0-0` : E(te) ? ae === "0" ? ge = `>=${ae}.${de}.0${H} <${ae}.${+de + 1}.0-0` : ge = `>=${ae}.${de}.0${H} <${+ae + 1}.0.0-0` : ee ? (i("replaceCaret pr", ee), ae === "0" ? de === "0" ? ge = `>=${ae}.${de}.${te}-${ee} <${ae}.${de}.${+te + 1}-0` : ge = `>=${ae}.${de}.${te}-${ee} <${ae}.${+de + 1}.0-0` : ge = `>=${ae}.${de}.${te}-${ee} <${+ae + 1}.0.0-0`) : (i("no pr"), ae === "0" ? de === "0" ? ge = `>=${ae}.${de}.${te}${H} <${ae}.${de}.${+te + 1}-0` : ge = `>=${ae}.${de}.${te}${H} <${ae}.${+de + 1}.0-0` : ge = `>=${ae}.${de}.${te} <${+ae + 1}.0.0-0`), i("caret return", ge), ge;
    });
  }, P = (U, j) => (i("replaceXRanges", U, j), U.split(/\s+/).map((G) => S(G, j)).join(" ")), S = (U, j) => {
    U = U.trim();
    const G = j.loose ? u[d.XRANGELOOSE] : u[d.XRANGE];
    return U.replace(G, (H, J, ae, de, te, ee) => {
      i("xRange", U, H, J, ae, de, te, ee);
      const ge = E(ae), De = ge || E(de), xe = De || E(te), ze = xe;
      return J === "=" && ze && (J = ""), ee = j.includePrerelease ? "-0" : "", ge ? J === ">" || J === "<" ? H = "<0.0.0-0" : H = "*" : J && ze ? (De && (de = 0), te = 0, J === ">" ? (J = ">=", De ? (ae = +ae + 1, de = 0, te = 0) : (de = +de + 1, te = 0)) : J === "<=" && (J = "<", De ? ae = +ae + 1 : de = +de + 1), J === "<" && (ee = "-0"), H = `${J + ae}.${de}.${te}${ee}`) : De ? H = `>=${ae}.0.0${ee} <${+ae + 1}.0.0-0` : xe && (H = `>=${ae}.${de}.0${ee} <${ae}.${+de + 1}.0-0`), i("xRange return", H), H;
    });
  }, N = (U, j) => (i("replaceStars", U, j), U.trim().replace(u[d.STAR], "")), W = (U, j) => (i("replaceGTE0", U, j), U.trim().replace(u[j.includePrerelease ? d.GTE0PRE : d.GTE0], "")), V = (U) => (j, G, H, J, ae, de, te, ee, ge, De, xe, ze, q) => (E(H) ? G = "" : E(J) ? G = `>=${H}.0.0${U ? "-0" : ""}` : E(ae) ? G = `>=${H}.${J}.0${U ? "-0" : ""}` : de ? G = `>=${G}` : G = `>=${G}${U ? "-0" : ""}`, E(ge) ? ee = "" : E(De) ? ee = `<${+ge + 1}.0.0-0` : E(xe) ? ee = `<${ge}.${+De + 1}.0-0` : ze ? ee = `<=${ge}.${De}.${xe}-${ze}` : U ? ee = `<${ge}.${De}.${+xe + 1}-0` : ee = `<=${ee}`, `${G} ${ee}`.trim()), K = (U, j, G) => {
    for (let H = 0; H < U.length; H++)
      if (!U[H].test(j))
        return !1;
    if (j.prerelease.length && !G.includePrerelease) {
      for (let H = 0; H < U.length; H++)
        if (i(U[H].semver), U[H].semver !== a.ANY && U[H].semver.prerelease.length > 0) {
          const J = U[H].semver;
          if (J.major === j.major && J.minor === j.minor && J.patch === j.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  };
  return v_;
}
const fW = Vk(), cW = (e, t, r) => {
  try {
    t = new fW(t, r);
  } catch {
    return !1;
  }
  return t.test(e);
};
var au = cW;
const hW = Gk, gW = (e, t) => {
  const r = hW(e, t);
  return r ? r.version : null;
};
var _W = gW;
const mW = "", pW = "", FW = ">=14.x.x", yW = "", bW = "", vW = "<=0.0.0", EW = {
  chrome: (e) => au(e, mW),
  firefox: (e) => au(e, pW),
  safari: (e) => au(e, FW),
  opera: (e) => au(e, yW),
  edge: (e) => au(e, bW),
  ie: (e) => au(e, vW)
};
function $W(e) {
  return ({ version: t, name: r }) => !t || !r ? !1 : Object.keys(e).includes(r) ? e[r](t) : !0;
}
function _Ae() {
  var e;
  return $W(EW)({
    name: ((e = o6.name) == null ? void 0 : e.toLocaleLowerCase()) || "",
    version: _W(DG(o6.version)) || ""
  });
}
function wW() {
  var a, i;
  const e = Ou.parse(window.navigator.userAgent), t = (a = e.os) == null ? void 0 : a.family, r = t != null && t.startsWith("Win") ? "windows" : "mac", n = ((i = e.os) == null ? void 0 : i.toString()) ?? "n/a";
  return {
    currentOS: r,
    osVersion: n
  };
}
function mAe(e) {
  return e === "mac" ? "windows" : "mac";
}
function pAe() {
  const e = Ou.parse(window.navigator.userAgent);
  return `Browser: ${e.name} ${e.version}`;
}
const kW = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
function L1(e) {
  if (!kW.test(e))
    return [0, 0, 0];
  const t = e.replace("#", "");
  return [
    t.slice(0, 2),
    t.slice(2, 4),
    t.slice(4, 6)
  ].map((r) => parseInt(r, 16));
}
function xW(e, t) {
  const [r, n, a] = L1(e), [i, o, u] = L1(t);
  return Math.sqrt(
    (i - r) ** 2 + (o - n) ** 2 + (u - a) ** 2
  );
}
function DW(e, t) {
  return t.map((n) => [
    n,
    xW(n, e)
  ]).reduce(
    (n, [a, i]) => i < n.distance ? { color: a, distance: i } : n,
    {
      color: "",
      distance: 1 / 0
    }
  );
}
const CW = {
  AD: "AND",
  AE: "ARE",
  AF: "AFG",
  AG: "ATG",
  AI: "AIA",
  AL: "ALB",
  AM: "ARM",
  AN: "ANT",
  AO: "AGO",
  AQ: "ATA",
  AR: "ARG",
  AS: "ASM",
  AT: "AUT",
  AU: "AUS",
  AW: "ABW",
  AX: "ALA",
  AZ: "AZE",
  BA: "BIH",
  BB: "BRB",
  BD: "BGD",
  BE: "BEL",
  BF: "BFA",
  BG: "BGR",
  BH: "BHR",
  BI: "BDI",
  BJ: "BEN",
  BL: "BLM",
  BM: "BMU",
  BN: "BRN",
  BO: "BOL",
  BR: "BRA",
  BS: "BHS",
  BT: "BTN",
  BV: "BVT",
  BW: "BWA",
  BY: "BLR",
  BZ: "BLZ",
  CA: "CAN",
  CC: "CCK",
  CD: "COD",
  CF: "CAF",
  CG: "COG",
  CH: "CHE",
  CI: "CIV",
  CK: "COK",
  CL: "CHL",
  CM: "CMR",
  CN: "CHN",
  CO: "COL",
  CR: "CRI",
  CU: "CUB",
  CV: "CPV",
  CX: "CXR",
  CY: "CYP",
  CZ: "CZE",
  DE: "DEU",
  DJ: "DJI",
  DK: "DNK",
  DM: "DMA",
  DO: "DOM",
  DZ: "DZA",
  EC: "ECU",
  EE: "EST",
  EG: "EGY",
  EH: "ESH",
  ER: "ERI",
  ES: "ESP",
  ET: "ETH",
  FI: "FIN",
  FJ: "FJI",
  FK: "FLK",
  FM: "FSM",
  FO: "FRO",
  FR: "FRA",
  GA: "GAB",
  GB: "GBR",
  GD: "GRD",
  GE: "GEO",
  GF: "GUF",
  GG: "GGY",
  GH: "GHA",
  GI: "GIB",
  GL: "GRL",
  GM: "GMB",
  GN: "GIN",
  GP: "GLP",
  GQ: "GNQ",
  GR: "GRC",
  GS: "SGS",
  GT: "GTM",
  GU: "GUM",
  GW: "GNB",
  GY: "GUY",
  HK: "HKG",
  HM: "HMD",
  HN: "HND",
  HR: "HRV",
  HT: "HTI",
  HU: "HUN",
  ID: "IDN",
  IE: "IRL",
  IL: "ISR",
  IM: "IMN",
  IN: "IND",
  IO: "IOT",
  IQ: "IRQ",
  IR: "IRN",
  IS: "ISL",
  IT: "ITA",
  JE: "JEY",
  JM: "JAM",
  JO: "JOR",
  JP: "JPN",
  KE: "KEN",
  KG: "KGZ",
  KH: "KHM",
  KI: "KIR",
  KM: "COM",
  KN: "KNA",
  KP: "PRK",
  KR: "KOR",
  KW: "KWT",
  KY: "CYM",
  KZ: "KAZ",
  LA: "LAO",
  LB: "LBN",
  LC: "LCA",
  LI: "LIE",
  LK: "LKA",
  LR: "LBR",
  LS: "LSO",
  LT: "LTU",
  LU: "LUX",
  LV: "LVA",
  LY: "LBY",
  MA: "MAR",
  MC: "MCO",
  MD: "MDA",
  ME: "MNE",
  MF: "MAF",
  MG: "MDG",
  MH: "MHL",
  MK: "MKD",
  ML: "MLI",
  MM: "MMR",
  MN: "MNG",
  MO: "MAC",
  MP: "MNP",
  MQ: "MTQ",
  MR: "MRT",
  MS: "MSR",
  MT: "MLT",
  MU: "MUS",
  MV: "MDV",
  MW: "MWI",
  MX: "MEX",
  MY: "MYS",
  MZ: "MOZ",
  NA: "NAM",
  NC: "NCL",
  NE: "NER",
  NF: "NFK",
  NG: "NGA",
  NI: "NIC",
  NL: "NLD",
  NO: "NOR",
  NP: "NPL",
  NR: "NRU",
  NU: "NIU",
  NZ: "NZL",
  OM: "OMN",
  PA: "PAN",
  PE: "PER",
  PF: "PYF",
  PG: "PNG",
  PH: "PHL",
  PK: "PAK",
  PL: "POL",
  PM: "SPM",
  PN: "PCN",
  PR: "PRI",
  PS: "PSE",
  PT: "PRT",
  PW: "PLW",
  PY: "PRY",
  QA: "QAT",
  RE: "REU",
  RO: "ROU",
  RS: "SRB",
  RU: "RUS",
  RW: "RWA",
  SA: "SAU",
  SB: "SLB",
  SC: "SYC",
  SD: "SDN",
  SE: "SWE",
  SG: "SGP",
  SH: "SHN",
  SI: "SVN",
  SJ: "SJM",
  SK: "SVK",
  SL: "SLE",
  SM: "SMR",
  SN: "SEN",
  SO: "SOM",
  SR: "SUR",
  SS: "SSD",
  ST: "STP",
  SV: "SLV",
  SY: "SYR",
  SZ: "SWZ",
  TC: "TCA",
  TD: "TCD",
  TF: "ATF",
  TG: "TGO",
  TH: "THA",
  TJ: "TJK",
  TK: "TKL",
  TL: "TLS",
  TM: "TKM",
  TN: "TUN",
  TO: "TON",
  TR: "TUR",
  TT: "TTO",
  TV: "TUV",
  TW: "TWN",
  TZ: "TZA",
  UA: "UKR",
  UG: "UGA",
  UM: "UMI",
  US: "USA",
  UY: "URY",
  UZ: "UZB",
  VA: "VAT",
  VC: "VCT",
  VE: "VEN",
  VG: "VGB",
  VI: "VIR",
  VN: "VNM",
  VU: "VUT",
  WF: "WLF",
  WS: "WSM",
  XK: "XKX",
  YE: "YEM",
  YT: "MYT",
  ZA: "ZAF",
  ZM: "ZMB",
  ZW: "ZWE"
}, SW = (e, t = "USA") => CW[e] || t, FAe = (e) => {
  const t = SW(e.toUpperCase());
  return `Flag${t.charAt(0).toUpperCase()}${t.slice(1).toLowerCase()}`;
}, Hk = [
  {
    name: "Israel",
    dial_code: "+972",
    code: "IL",
    region: "EMEA"
  },
  {
    name: "Afghanistan",
    dial_code: "+93",
    code: "AF",
    region: "EMEA"
  },
  {
    name: "Albania",
    dial_code: "+355",
    code: "AL",
    region: "EMEA"
  },
  {
    name: "Algeria",
    dial_code: "+213",
    code: "DZ",
    region: "EMEA"
  },
  {
    name: "AmericanSamoa",
    dial_code: "+1 684",
    code: "AS",
    region: "NA"
  },
  {
    name: "Andorra",
    dial_code: "+376",
    code: "AD",
    region: "EMEA"
  },
  {
    name: "Angola",
    dial_code: "+244",
    code: "AO",
    region: "EMEA"
  },
  {
    name: "Anguilla",
    dial_code: "+1 264",
    code: "AI",
    region: "EMEA"
  },
  {
    name: "Antigua and Barbuda",
    dial_code: "+1268",
    code: "AG",
    region: "EMEA"
  },
  {
    name: "Argentina",
    dial_code: "+54",
    code: "AR",
    region: "EMEA"
  },
  {
    name: "Armenia",
    dial_code: "+374",
    code: "AM",
    region: "EMEA"
  },
  {
    name: "Aruba",
    dial_code: "+297",
    code: "AW",
    region: "EMEA"
  },
  {
    name: "Australia",
    dial_code: "+61",
    code: "AU",
    region: "APAC"
  },
  {
    name: "Austria",
    dial_code: "+43",
    code: "AT",
    region: "EMEA"
  },
  {
    name: "Azerbaijan",
    dial_code: "+994",
    code: "AZ",
    region: "EMEA"
  },
  {
    name: "Bahamas",
    dial_code: "+1 242",
    code: "BS",
    region: "EMEA"
  },
  {
    name: "Bahrain",
    dial_code: "+973",
    code: "BH",
    region: "EMEA"
  },
  {
    name: "Bangladesh",
    dial_code: "+880",
    code: "BD",
    region: "APAC"
  },
  {
    name: "Barbados",
    dial_code: "+1 246",
    code: "BB",
    region: "EMEA"
  },
  {
    name: "Belarus",
    dial_code: "+375",
    code: "BY",
    region: "EMEA"
  },
  {
    name: "Belgium",
    dial_code: "+32",
    code: "BE",
    region: "EMEA"
  },
  {
    name: "Belize",
    dial_code: "+501",
    code: "BZ",
    region: "EMEA"
  },
  {
    name: "Benin",
    dial_code: "+229",
    code: "BJ",
    region: "EMEA"
  },
  {
    name: "Bermuda",
    dial_code: "+1 441",
    code: "BM",
    region: "EMEA"
  },
  {
    name: "Bhutan",
    dial_code: "+975",
    code: "BT",
    region: "APAC"
  },
  {
    name: "Bosnia and Herzegovina",
    dial_code: "+387",
    code: "BA",
    region: "EMEA"
  },
  {
    name: "Botswana",
    dial_code: "+267",
    code: "BW",
    region: "EMEA"
  },
  {
    name: "Brazil",
    dial_code: "+55",
    code: "BR",
    region: "EMEA"
  },
  {
    name: "British Indian Ocean Territory",
    dial_code: "+246",
    code: "IO",
    region: "EMEA"
  },
  {
    name: "Bulgaria",
    dial_code: "+359",
    code: "BG",
    region: "EMEA"
  },
  {
    name: "Burkina Faso",
    dial_code: "+226",
    code: "BF",
    region: "EMEA"
  },
  {
    name: "Burundi",
    dial_code: "+257",
    code: "BI",
    region: "EMEA"
  },
  {
    name: "Cambodia",
    dial_code: "+855",
    code: "KH",
    region: "APAC"
  },
  {
    name: "Cameroon",
    dial_code: "+237",
    code: "CM",
    region: "EMEA"
  },
  {
    name: "Canada",
    dial_code: "+1",
    code: "CA",
    region: "NA"
  },
  {
    name: "Cape Verde",
    dial_code: "+238",
    code: "CV",
    region: "EMEA"
  },
  {
    name: "Cayman Islands",
    dial_code: "+ 345",
    code: "KY",
    region: "EMEA"
  },
  {
    name: "Central African Republic",
    dial_code: "+236",
    code: "CF",
    region: "EMEA"
  },
  {
    name: "Chad",
    dial_code: "+235",
    code: "TD",
    region: "EMEA"
  },
  {
    name: "Chile",
    dial_code: "+56",
    code: "CL",
    region: "EMEA"
  },
  {
    name: "China",
    dial_code: "+86",
    code: "CN",
    region: "APAC"
  },
  {
    name: "Christmas Island",
    dial_code: "+61",
    code: "CX",
    region: "APAC"
  },
  {
    name: "Colombia",
    dial_code: "+57",
    code: "CO",
    region: "EMEA"
  },
  {
    name: "Comoros",
    dial_code: "+269",
    code: "KM",
    region: "EMEA"
  },
  {
    name: "Congo",
    dial_code: "+242",
    code: "CG",
    region: "EMEA"
  },
  {
    name: "Cook Islands",
    dial_code: "+682",
    code: "CK",
    region: "APAC"
  },
  {
    name: "Costa Rica",
    dial_code: "+506",
    code: "CR",
    region: "EMEA"
  },
  {
    name: "Croatia",
    dial_code: "+385",
    code: "HR",
    region: "EMEA"
  },
  {
    name: "Cuba",
    dial_code: "+53",
    code: "CU",
    region: "EMEA"
  },
  {
    name: "Cyprus",
    dial_code: "+357",
    code: "CY",
    region: "EMEA"
  },
  {
    name: "Czech Republic",
    dial_code: "+420",
    code: "CZ",
    region: "EMEA"
  },
  {
    name: "Denmark",
    dial_code: "+45",
    code: "DK",
    region: "EMEA"
  },
  {
    name: "Djibouti",
    dial_code: "+253",
    code: "DJ",
    region: "EMEA"
  },
  {
    name: "Dominica",
    dial_code: "+1 767",
    code: "DM",
    region: "EMEA"
  },
  {
    name: "Dominican Republic",
    dial_code: "+1 849",
    code: "DO",
    region: "EMEA"
  },
  {
    name: "Ecuador",
    dial_code: "+593",
    code: "EC",
    region: "EMEA"
  },
  {
    name: "Egypt",
    dial_code: "+20",
    code: "EG",
    region: "EMEA"
  },
  {
    name: "El Salvador",
    dial_code: "+503",
    code: "SV",
    region: "EMEA"
  },
  {
    name: "Equatorial Guinea",
    dial_code: "+240",
    code: "GQ",
    region: "EMEA"
  },
  {
    name: "Eritrea",
    dial_code: "+291",
    code: "ER",
    region: "EMEA"
  },
  {
    name: "Estonia",
    dial_code: "+372",
    code: "EE",
    region: "EMEA"
  },
  {
    name: "Ethiopia",
    dial_code: "+251",
    code: "ET",
    region: "EMEA"
  },
  {
    name: "Faroe Islands",
    dial_code: "+298",
    code: "FO",
    region: "EMEA"
  },
  {
    name: "Fiji",
    dial_code: "+679",
    code: "FJ",
    region: "APAC"
  },
  {
    name: "Finland",
    dial_code: "+358",
    code: "FI",
    region: "EMEA"
  },
  {
    name: "France",
    dial_code: "+33",
    code: "FR",
    region: "EMEA"
  },
  {
    name: "French Guiana",
    dial_code: "+594",
    code: "GF",
    region: "EMEA"
  },
  {
    name: "French Polynesia",
    dial_code: "+689",
    code: "PF",
    region: "EMEA"
  },
  {
    name: "Gabon",
    dial_code: "+241",
    code: "GA",
    region: "EMEA"
  },
  {
    name: "Gambia",
    dial_code: "+220",
    code: "GM",
    region: "EMEA"
  },
  {
    name: "Georgia",
    dial_code: "+995",
    code: "GE",
    region: "EMEA"
  },
  {
    name: "Germany",
    dial_code: "+49",
    code: "DE",
    region: "EMEA"
  },
  {
    name: "Ghana",
    dial_code: "+233",
    code: "GH",
    region: "EMEA"
  },
  {
    name: "Gibraltar",
    dial_code: "+350",
    code: "GI",
    region: "EMEA"
  },
  {
    name: "Greece",
    dial_code: "+30",
    code: "GR",
    region: "EMEA"
  },
  {
    name: "Greenland",
    dial_code: "+299",
    code: "GL",
    region: "EMEA"
  },
  {
    name: "Grenada",
    dial_code: "+1 473",
    code: "GD",
    region: "EMEA"
  },
  {
    name: "Guadeloupe",
    dial_code: "+590",
    code: "GP",
    region: "EMEA"
  },
  {
    name: "Guam",
    dial_code: "+1 671",
    code: "GU",
    region: "APAC"
  },
  {
    name: "Guatemala",
    dial_code: "+502",
    code: "GT",
    region: "EMEA"
  },
  {
    name: "Guinea",
    dial_code: "+224",
    code: "GN",
    region: "EMEA"
  },
  {
    name: "Guinea-Bissau",
    dial_code: "+245",
    code: "GW",
    region: "EMEA"
  },
  {
    name: "Guyana",
    dial_code: "+595",
    code: "GY",
    region: "EMEA"
  },
  {
    name: "Haiti",
    dial_code: "+509",
    code: "HT",
    region: "EMEA"
  },
  {
    name: "Heard and McDonald Islands",
    dial_code: "+672",
    code: "HM",
    region: "EMEA"
  },
  {
    name: "Honduras",
    dial_code: "+504",
    code: "HN",
    region: "EMEA"
  },
  {
    name: "Hungary",
    dial_code: "+36",
    code: "HU",
    region: "EMEA"
  },
  {
    name: "Iceland",
    dial_code: "+354",
    code: "IS",
    region: "EMEA"
  },
  {
    name: "India",
    dial_code: "+91",
    code: "IN",
    region: "APAC"
  },
  {
    name: "Indonesia",
    dial_code: "+62",
    code: "ID",
    region: "APAC"
  },
  {
    name: "Iraq",
    dial_code: "+964",
    code: "IQ",
    region: "EMEA"
  },
  {
    name: "Ireland",
    dial_code: "+353",
    code: "IE",
    region: "EMEA"
  },
  {
    name: "Italy",
    dial_code: "+39",
    code: "IT",
    region: "EMEA"
  },
  {
    name: "Jamaica",
    dial_code: "+1 876",
    code: "JM",
    region: "EMEA"
  },
  {
    name: "Japan",
    dial_code: "+81",
    code: "JP",
    region: "APAC"
  },
  {
    name: "Jordan",
    dial_code: "+962",
    code: "JO",
    region: "EMEA"
  },
  {
    name: "Kosovo",
    dial_code: "+383",
    code: "XK",
    region: "EMEA"
  },
  {
    name: "Kazakhstan",
    dial_code: "+7 7",
    code: "KZ",
    region: "EMEA"
  },
  {
    name: "Kenya",
    dial_code: "+254",
    code: "KE",
    region: "EMEA"
  },
  {
    name: "Kiribati",
    dial_code: "+686",
    code: "KI",
    region: "APAC"
  },
  {
    name: "Kuwait",
    dial_code: "+965",
    code: "KW",
    region: "EMEA"
  },
  {
    name: "Kyrgyzstan",
    dial_code: "+996",
    code: "KG",
    region: "EMEA"
  },
  {
    name: "Latvia",
    dial_code: "+371",
    code: "LV",
    region: "EMEA"
  },
  {
    name: "Lebanon",
    dial_code: "+961",
    code: "LB",
    region: "EMEA"
  },
  {
    name: "Lesotho",
    dial_code: "+266",
    code: "LS",
    region: "EMEA"
  },
  {
    name: "Liberia",
    dial_code: "+231",
    code: "LR",
    region: "EMEA"
  },
  {
    name: "Liechtenstein",
    dial_code: "+423",
    code: "LI",
    region: "EMEA"
  },
  {
    name: "Lithuania",
    dial_code: "+370",
    code: "LT",
    region: "EMEA"
  },
  {
    name: "Luxembourg",
    dial_code: "+352",
    code: "LU",
    region: "EMEA"
  },
  {
    name: "Madagascar",
    dial_code: "+261",
    code: "MG",
    region: "EMEA"
  },
  {
    name: "Malawi",
    dial_code: "+265",
    code: "MW",
    region: "EMEA"
  },
  {
    name: "Malaysia",
    dial_code: "+60",
    code: "MY",
    region: "APAC"
  },
  {
    name: "Maldives",
    dial_code: "+960",
    code: "MV",
    region: "APAC"
  },
  {
    name: "Mali",
    dial_code: "+223",
    code: "ML",
    region: "EMEA"
  },
  {
    name: "Malta",
    dial_code: "+356",
    code: "MT",
    region: "EMEA"
  },
  {
    name: "Marshall Islands",
    dial_code: "+692",
    code: "MH",
    region: "NA"
  },
  {
    name: "Martinique",
    dial_code: "+596",
    code: "MQ",
    region: "EMEA"
  },
  {
    name: "Mauritania",
    dial_code: "+222",
    code: "MR",
    region: "EMEA"
  },
  {
    name: "Mauritius",
    dial_code: "+230",
    code: "MU",
    region: "EMEA"
  },
  {
    name: "Mayotte",
    dial_code: "+262",
    code: "YT",
    region: "EMEA"
  },
  {
    name: "Mexico",
    dial_code: "+52",
    code: "MX",
    region: "EMEA"
  },
  {
    name: "Monaco",
    dial_code: "+377",
    code: "MC",
    region: "EMEA"
  },
  {
    name: "Mongolia",
    dial_code: "+976",
    code: "MN",
    region: "APAC"
  },
  {
    name: "Montenegro",
    dial_code: "+382",
    code: "ME",
    region: "EMEA"
  },
  {
    name: "Montserrat",
    dial_code: "+1664",
    code: "MS",
    region: "EMEA"
  },
  {
    name: "Morocco",
    dial_code: "+212",
    code: "MA",
    region: "EMEA"
  },
  {
    name: "Myanmar",
    dial_code: "+95",
    code: "MM",
    region: "APAC"
  },
  {
    name: "Namibia",
    dial_code: "+264",
    code: "NA",
    region: "EMEA"
  },
  {
    name: "Nauru",
    dial_code: "+674",
    code: "NR",
    region: "APAC"
  },
  {
    name: "Nepal",
    dial_code: "+977",
    code: "NP",
    region: "APAC"
  },
  {
    name: "Netherlands",
    dial_code: "+31",
    code: "NL",
    region: "EMEA"
  },
  {
    name: "Netherlands Antilles",
    dial_code: "+599",
    code: "AN",
    region: "EMEA"
  },
  {
    name: "New Caledonia",
    dial_code: "+687",
    code: "NC",
    region: "EMEA"
  },
  {
    name: "New Zealand",
    dial_code: "+64",
    code: "NZ",
    region: "APAC"
  },
  {
    name: "Nicaragua",
    dial_code: "+505",
    code: "NI",
    region: "EMEA"
  },
  {
    name: "Niger",
    dial_code: "+227",
    code: "NE",
    region: "EMEA"
  },
  {
    name: "Nigeria",
    dial_code: "+234",
    code: "NG",
    region: "EMEA"
  },
  {
    name: "Niue",
    dial_code: "+683",
    code: "NU",
    region: "APAC"
  },
  {
    name: "Norfolk Island",
    dial_code: "+672",
    code: "NF",
    region: "APAC"
  },
  {
    name: "Northern Mariana Islands",
    dial_code: "+1 670",
    code: "MP",
    region: "APAC"
  },
  {
    name: "Norway",
    dial_code: "+47",
    code: "NO",
    region: "EMEA"
  },
  {
    name: "Oman",
    dial_code: "+968",
    code: "OM",
    region: "EMEA"
  },
  {
    name: "Pakistan",
    dial_code: "+92",
    code: "PK",
    region: "APAC"
  },
  {
    name: "Palau",
    dial_code: "+680",
    code: "PW",
    region: "APAC"
  },
  {
    name: "Panama",
    dial_code: "+507",
    code: "PA",
    region: "EMEA"
  },
  {
    name: "Papua New Guinea",
    dial_code: "+675",
    code: "PG",
    region: "APAC"
  },
  {
    name: "Paraguay",
    dial_code: "+595",
    code: "PY",
    region: "EMEA"
  },
  {
    name: "Peru",
    dial_code: "+51",
    code: "PE",
    region: "EMEA"
  },
  {
    name: "Philippines",
    dial_code: "+63",
    code: "PH",
    region: "APAC"
  },
  {
    name: "Poland",
    dial_code: "+48",
    code: "PL",
    region: "EMEA"
  },
  {
    name: "Portugal",
    dial_code: "+351",
    code: "PT",
    region: "EMEA"
  },
  {
    name: "Puerto Rico",
    dial_code: "+1 939",
    code: "PR",
    region: "NA"
  },
  {
    name: "Qatar",
    dial_code: "+974",
    code: "QA",
    region: "EMEA"
  },
  {
    name: "Romania",
    dial_code: "+40",
    code: "RO",
    region: "EMEA"
  },
  {
    name: "Rwanda",
    dial_code: "+250",
    code: "RW",
    region: "EMEA"
  },
  {
    name: "Samoa",
    dial_code: "+685",
    code: "WS",
    region: "APAC"
  },
  {
    name: "San Marino",
    dial_code: "+378",
    code: "SM",
    region: "EMEA"
  },
  {
    name: "Saudi Arabia",
    dial_code: "+966",
    code: "SA",
    region: "EMEA"
  },
  {
    name: "Senegal",
    dial_code: "+221",
    code: "SN",
    region: "EMEA"
  },
  {
    name: "Serbia",
    dial_code: "+381",
    code: "RS",
    region: "EMEA"
  },
  {
    name: "Seychelles",
    dial_code: "+248",
    code: "SC",
    region: "EMEA"
  },
  {
    name: "Sierra Leone",
    dial_code: "+232",
    code: "SL",
    region: "EMEA"
  },
  {
    name: "Singapore",
    dial_code: "+65",
    code: "SG",
    region: "APAC"
  },
  {
    name: "Slovakia",
    dial_code: "+421",
    code: "SK",
    region: "EMEA"
  },
  {
    name: "Slovenia",
    dial_code: "+386",
    code: "SI",
    region: "EMEA"
  },
  {
    name: "Solomon Islands",
    dial_code: "+677",
    code: "SB",
    region: "APAC"
  },
  {
    name: "South Africa",
    dial_code: "+27",
    code: "ZA",
    region: "EMEA"
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    dial_code: "+500",
    code: "GS",
    region: "EMEA"
  },
  {
    name: "Spain",
    dial_code: "+34",
    code: "ES",
    region: "EMEA"
  },
  {
    name: "Sri Lanka",
    dial_code: "+94",
    code: "LK",
    region: "APAC"
  },
  {
    name: "Sudan",
    dial_code: "+249",
    code: "SD",
    region: "EMEA"
  },
  {
    name: "Suriname",
    dial_code: "+597",
    code: "SR",
    region: "EMEA"
  },
  {
    name: "Swaziland",
    dial_code: "+268",
    code: "SZ",
    region: "EMEA"
  },
  {
    name: "Sweden",
    dial_code: "+46",
    code: "SE",
    region: "EMEA"
  },
  {
    name: "Switzerland",
    dial_code: "+41",
    code: "CH",
    region: "EMEA"
  },
  {
    name: "Tajikistan",
    dial_code: "+992",
    code: "TJ",
    region: "EMEA"
  },
  {
    name: "Thailand",
    dial_code: "+66",
    code: "TH",
    region: "APAC"
  },
  {
    name: "Togo",
    dial_code: "+228",
    code: "TG",
    region: "EMEA"
  },
  {
    name: "Tokelau",
    dial_code: "+690",
    code: "TK",
    region: "APAC"
  },
  {
    name: "Tonga",
    dial_code: "+676",
    code: "TO",
    region: "APAC"
  },
  {
    name: "Trinidad and Tobago",
    dial_code: "+1 868",
    code: "TT",
    region: "EMEA"
  },
  {
    name: "Tunisia",
    dial_code: "+216",
    code: "TN",
    region: "EMEA"
  },
  {
    name: "Turkey",
    dial_code: "+90",
    code: "TR",
    region: "EMEA"
  },
  {
    name: "Turkmenistan",
    dial_code: "+993",
    code: "TM",
    region: "EMEA"
  },
  {
    name: "Turks and Caicos Islands",
    dial_code: "+1 649",
    code: "TC",
    region: "EMEA"
  },
  {
    name: "Tuvalu",
    dial_code: "+688",
    code: "TV",
    region: "APAC"
  },
  {
    name: "Uganda",
    dial_code: "+256",
    code: "UG",
    region: "EMEA"
  },
  {
    name: "Ukraine",
    dial_code: "+380",
    code: "UA",
    region: "EMEA"
  },
  {
    name: "United Arab Emirates",
    dial_code: "+971",
    code: "AE",
    region: "EMEA"
  },
  {
    name: "United Kingdom",
    dial_code: "+44",
    code: "GB",
    region: "EMEA"
  },
  {
    name: "United States",
    dial_code: "+1",
    code: "US",
    region: "NA"
  },
  {
    name: "Uruguay",
    dial_code: "+598",
    code: "UY",
    region: "EMEA"
  },
  {
    name: "Uzbekistan",
    dial_code: "+998",
    code: "UZ",
    region: "EMEA"
  },
  {
    name: "Vanuatu",
    dial_code: "+678",
    code: "VU",
    region: "EMEA"
  },
  {
    name: "Wallis and Futuna",
    dial_code: "+681",
    code: "WF",
    region: "EMEA"
  },
  {
    name: "Yemen",
    dial_code: "+967",
    code: "YE",
    region: "EMEA"
  },
  {
    name: "Zambia",
    dial_code: "+260",
    code: "ZM",
    region: "EMEA"
  },
  {
    name: "Zimbabwe",
    dial_code: "+263",
    code: "ZW",
    region: "EMEA"
  },
  {
    name: "Antarctica",
    dial_code: null,
    code: "AQ",
    region: "EMEA"
  },
  {
    name: "Bolivia, Plurinational State of",
    dial_code: "+591",
    code: "BO",
    region: "EMEA"
  },
  {
    name: "Brunei Darussalam",
    dial_code: "+673",
    code: "BN",
    region: "APAC"
  },
  {
    name: "Cocos (Keeling) Islands",
    dial_code: "+61",
    code: "CC",
    region: "APAC"
  },
  {
    name: "Congo, The Democratic Republic of the",
    dial_code: "+243",
    code: "CD",
    region: "EMEA"
  },
  {
    name: "Cote d'Ivoire",
    dial_code: "+225",
    code: "CI",
    region: "EMEA"
  },
  {
    name: "Falkland Islands (Malvinas)",
    dial_code: "+500",
    code: "FK",
    region: "EMEA"
  },
  {
    name: "Guernsey",
    dial_code: "+44",
    code: "GG",
    region: "EMEA"
  },
  {
    name: "Holy See (Vatican City State)",
    dial_code: "+379",
    code: "VA",
    region: "EMEA"
  },
  {
    name: "Hong Kong",
    dial_code: "+852",
    code: "HK",
    region: "APAC"
  },
  {
    name: "Iran, Islamic Republic of",
    dial_code: "+98",
    code: "IR",
    region: "EMEA"
  },
  {
    name: "Isle of Man",
    dial_code: "+44",
    code: "IM",
    region: "EMEA"
  },
  {
    name: "Jersey",
    dial_code: "+44",
    code: "JE",
    region: "EMEA"
  },
  {
    name: "Korea, Democratic People's Republic of",
    dial_code: "+850",
    code: "KP",
    region: "APAC"
  },
  {
    name: "Korea, Republic of",
    dial_code: "+82",
    code: "KR",
    region: "APAC"
  },
  {
    name: "Lao People's Democratic Republic",
    dial_code: "+856",
    code: "LA",
    region: "APAC"
  },
  {
    name: "Libyan Arab Jamahiriya",
    dial_code: "+218",
    code: "LY",
    region: "EMEA"
  },
  {
    name: "Macao",
    dial_code: "+853",
    code: "MO",
    region: "EMEA"
  },
  {
    name: "Macedonia, The Former Yugoslav Republic of",
    dial_code: "+389",
    code: "MK",
    region: "EMEA"
  },
  {
    name: "Micronesia, Federated States of",
    dial_code: "+691",
    code: "FM",
    region: "APAC"
  },
  {
    name: "Moldova, Republic of",
    dial_code: "+373",
    code: "MD",
    region: "EMEA"
  },
  {
    name: "Mozambique",
    dial_code: "+258",
    code: "MZ",
    region: "EMEA"
  },
  {
    name: "Palestinian Territory, Occupied",
    dial_code: "+970",
    code: "PS",
    region: "EMEA"
  },
  {
    name: "Pitcairn",
    dial_code: "+872",
    code: "PN",
    region: "APAC"
  },
  {
    name: "Réunion",
    dial_code: "+262",
    code: "RE",
    region: "EMEA"
  },
  {
    name: "Russia",
    dial_code: "+7",
    code: "RU",
    region: "EMEA"
  },
  {
    name: "Saint Barthélemy",
    dial_code: "+590",
    code: "BL",
    region: "EMEA"
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    dial_code: "+290",
    code: "SH",
    region: "EMEA"
  },
  {
    name: "Saint Kitts and Nevis",
    dial_code: "+1 869",
    code: "KN",
    region: "EMEA"
  },
  {
    name: "Saint Lucia",
    dial_code: "+1 758",
    code: "LC",
    region: "EMEA"
  },
  {
    name: "Saint Martin",
    dial_code: "+590",
    code: "MF",
    region: "EMEA"
  },
  {
    name: "Saint Pierre and Miquelon",
    dial_code: "+508",
    code: "PM",
    region: "EMEA"
  },
  {
    name: "Saint Vincent and the Grenadines",
    dial_code: "+1 784",
    code: "VC",
    region: "EMEA"
  },
  {
    name: "Sao Tome and Principe",
    dial_code: "+239",
    code: "ST",
    region: "EMEA"
  },
  {
    name: "Somalia",
    dial_code: "+252",
    code: "SO",
    region: "EMEA"
  },
  {
    name: "Svalbard and Jan Mayen",
    dial_code: "+47",
    code: "SJ",
    region: "EMEA"
  },
  {
    name: "Syrian Arab Republic",
    dial_code: "+963",
    code: "SY",
    region: "EMEA"
  },
  {
    name: "Taiwan, Province of China",
    dial_code: "+886",
    code: "TW",
    region: "APAC"
  },
  {
    name: "Tanzania, United Republic of",
    dial_code: "+255",
    code: "TZ",
    region: "EMEA"
  },
  {
    name: "Timor-Leste",
    dial_code: "+670",
    code: "TL",
    region: "EMEA"
  },
  {
    name: "Venezuela, Bolivarian Republic of",
    dial_code: "+58",
    code: "VE",
    region: "EMEA"
  },
  {
    name: "Viet Nam",
    dial_code: "+84",
    code: "VN",
    region: "APAC"
  },
  {
    name: "Virgin Islands, British",
    dial_code: "+1 284",
    code: "VG",
    region: "EMEA"
  },
  {
    name: "Virgin Islands, U.S.",
    dial_code: "+1 340",
    code: "VI",
    region: "NA"
  }
], AW = [
  {
    name: "Alabama",
    code: "AL"
  },
  {
    name: "Alaska",
    code: "AK"
  },
  {
    name: "Arizona",
    code: "AZ"
  },
  {
    name: "Arkansas",
    code: "AR"
  },
  {
    name: "California",
    code: "CA"
  },
  {
    name: "Colorado",
    code: "CO"
  },
  {
    name: "Connecticut",
    code: "CT"
  },
  {
    name: "Delaware",
    code: "DE"
  },
  {
    name: "District of Columbia",
    code: "DC"
  },
  {
    name: "Florida",
    code: "FL"
  },
  {
    name: "Georgia",
    code: "GA"
  },
  {
    name: "Hawaii",
    code: "HI"
  },
  {
    name: "Idaho",
    code: "ID"
  },
  {
    name: "Illinois",
    code: "IL"
  },
  {
    name: "Indiana",
    code: "IN"
  },
  {
    name: "Iowa",
    code: "IA"
  },
  {
    name: "Kansas",
    code: "KS"
  },
  {
    name: "Kentucky",
    code: "KY"
  },
  {
    name: "Louisiana",
    code: "LA"
  },
  {
    name: "Maine",
    code: "ME"
  },
  {
    name: "Maryland",
    code: "MD"
  },
  {
    name: "Massachusetts",
    code: "MA"
  },
  {
    name: "Michigan",
    code: "MI"
  },
  {
    name: "Minnesota",
    code: "MN"
  },
  {
    name: "Mississippi",
    code: "MS"
  },
  {
    name: "Missouri",
    code: "MO"
  },
  {
    name: "Montana",
    code: "MT"
  },
  {
    name: "Nebraska",
    code: "NE"
  },
  {
    name: "Nevada",
    code: "NV"
  },
  {
    name: "New Hampshire",
    code: "NH"
  },
  {
    name: "New Jersey",
    code: "NJ"
  },
  {
    name: "New Mexico",
    code: "NM"
  },
  {
    name: "New York",
    code: "NY"
  },
  {
    name: "North Carolina",
    code: "NC"
  },
  {
    name: "North Dakota",
    code: "ND"
  },
  {
    name: "Ohio",
    code: "OH"
  },
  {
    name: "Oklahoma",
    code: "OK"
  },
  {
    name: "Oregon",
    code: "OR"
  },
  {
    name: "Pennsylvania",
    code: "PA"
  },
  {
    name: "Rhode Island",
    code: "RI"
  },
  {
    name: "South Carolina",
    code: "SC"
  },
  {
    name: "South Dakota",
    code: "SD"
  },
  {
    name: "Tennessee",
    code: "TN"
  },
  {
    name: "Texas",
    code: "TX"
  },
  {
    name: "Utah",
    code: "UT"
  },
  {
    name: "Vermont",
    code: "VT"
  },
  {
    name: "Virginia",
    code: "VA"
  },
  {
    name: "Washington",
    code: "WA"
  },
  {
    name: "West Virginia",
    code: "WV"
  },
  {
    name: "Wisconsin",
    code: "WI"
  },
  {
    name: "Wyoming",
    code: "WY"
  }
], OW = [
  {
    name: "New South Wales",
    code: "NSW"
  },
  {
    name: "Queensland",
    code: "QLD"
  },
  {
    name: "South Australia",
    code: "SA"
  },
  {
    name: "Tasmania",
    code: "TAS"
  },
  {
    name: "Victoria",
    code: "VIC"
  },
  {
    name: "Western Australia",
    code: "WA"
  }
], yAe = {
  US: AW,
  AU: OW
};
var x = /* @__PURE__ */ ((e) => (e.EUR = "EUR", e.USD = "USD", e.AUD = "AUD", e.GBP = "GBP", e))(x || {});
const TW = {
  EUR: "€",
  USD: "$",
  AUD: "$",
  GBP: "£"
}, PW = [
  {
    country: "Afghanistan",
    prefixCode: "93",
    countryCode: "AF",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Albania",
    prefixCode: "355",
    countryCode: "AL",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Algeria",
    prefixCode: "213",
    countryCode: "DZ",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "AmericanSamoa",
    prefixCode: "+1 684",
    countryCode: "AS",
    currency: x.USD
  },
  {
    country: "Andorra",
    prefixCode: "376",
    countryCode: "AD",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Angola",
    prefixCode: "244",
    countryCode: "AO",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Anguilla",
    prefixCode: "+1 264",
    countryCode: "AI",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Antarctica",
    prefixCode: "null",
    countryCode: "AQ",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Antigua and Barbuda",
    prefixCode: "1268",
    countryCode: "AG",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Argentina",
    prefixCode: "54",
    countryCode: "AR",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Armenia",
    prefixCode: "374",
    countryCode: "AM",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Aruba",
    prefixCode: "297",
    countryCode: "AW",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Australia",
    prefixCode: "61",
    countryCode: "AU",
    currency: x.AUD
  },
  {
    country: "Austria",
    prefixCode: "43",
    countryCode: "AT",
    currency: x.EUR
  },
  {
    country: "Azerbaijan",
    prefixCode: "994",
    countryCode: "AZ",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Bahamas",
    prefixCode: "+1 242",
    countryCode: "BS",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Bahrain",
    prefixCode: "973",
    countryCode: "BH",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Bangladesh",
    prefixCode: "880",
    countryCode: "BD",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Barbados",
    prefixCode: "+1 246",
    countryCode: "BB",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Belarus",
    prefixCode: "375",
    countryCode: "BY",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Belgium",
    prefixCode: "32",
    countryCode: "BE",
    currency: x.EUR
  },
  {
    country: "Belize",
    prefixCode: "501",
    countryCode: "BZ",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Benin",
    prefixCode: "229",
    countryCode: "BJ",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Bermuda",
    prefixCode: "+1 441",
    countryCode: "BM",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Bhutan",
    prefixCode: "975",
    countryCode: "BT",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Bolivia, Plurinational State of",
    prefixCode: "591",
    countryCode: "BO",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Bosnia and Herzegovina",
    prefixCode: "387",
    countryCode: "BA",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Botswana",
    prefixCode: "267",
    countryCode: "BW",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Brazil",
    prefixCode: "55",
    countryCode: "BR",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "British Indian Ocean Territory",
    prefixCode: "246",
    countryCode: "IO",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Brunei Darussalam",
    prefixCode: "673",
    countryCode: "BN",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Bulgaria",
    prefixCode: "359",
    countryCode: "BG",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Burkina Faso",
    prefixCode: "226",
    countryCode: "BF",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Burundi",
    prefixCode: "257",
    countryCode: "BI",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Cambodia",
    prefixCode: "855",
    countryCode: "KH",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Cameroon",
    prefixCode: "237",
    countryCode: "CM",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Canada",
    prefixCode: "1",
    countryCode: "CA",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Cape Verde",
    prefixCode: "238",
    countryCode: "CV",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Cayman Islands",
    prefixCode: "345",
    countryCode: "KY",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Central African Republic",
    prefixCode: "236",
    countryCode: "CF",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Chad",
    prefixCode: "235",
    countryCode: "TD",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Chile",
    prefixCode: "56",
    countryCode: "CL",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "China",
    prefixCode: "86",
    countryCode: "CN",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Christmas Island",
    prefixCode: "61",
    countryCode: "CX",
    currency: x.AUD
  },
  {
    country: "Cocos (Keeling) Islands",
    prefixCode: "61",
    countryCode: "CC",
    currency: x.AUD
  },
  {
    country: "Colombia",
    prefixCode: "57",
    countryCode: "CO",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Comoros",
    prefixCode: "269",
    countryCode: "KM",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Congo",
    prefixCode: "242",
    countryCode: "CG",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Congo, The Democratic Republic of the",
    prefixCode: "243",
    countryCode: "CD",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Cook Islands",
    prefixCode: "682",
    countryCode: "CK",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Costa Rica",
    prefixCode: "506",
    countryCode: "CR",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Cote d'Ivoire",
    prefixCode: "225",
    countryCode: "CI",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Croatia",
    prefixCode: "385",
    countryCode: "HR",
    currency: x.EUR
  },
  {
    country: "Cuba",
    prefixCode: "53",
    countryCode: "CU",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Cyprus",
    prefixCode: "357",
    countryCode: "CY",
    currency: x.EUR
  },
  {
    country: "Czech Republic",
    prefixCode: "420",
    countryCode: "CZ",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Denmark",
    prefixCode: "45",
    countryCode: "DK",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Djibouti",
    prefixCode: "253",
    countryCode: "DJ",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Dominica",
    prefixCode: "+1 767",
    countryCode: "DM",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Dominican Republic",
    prefixCode: "+1 849",
    countryCode: "DO",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Ecuador",
    prefixCode: "593",
    countryCode: "EC",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Egypt",
    prefixCode: "20",
    countryCode: "EG",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "El Salvador",
    prefixCode: "503",
    countryCode: "SV",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Equatorial Guinea",
    prefixCode: "240",
    countryCode: "GQ",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Eritrea",
    prefixCode: "291",
    countryCode: "ER",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Estonia",
    prefixCode: "372",
    countryCode: "EE",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Ethiopia",
    prefixCode: "251",
    countryCode: "ET",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Falkland Islands (Malvinas)",
    prefixCode: "500",
    countryCode: "FK",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Faroe Islands",
    prefixCode: "298",
    countryCode: "FO",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Fiji",
    prefixCode: "679",
    countryCode: "FJ",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Finland",
    prefixCode: "358",
    countryCode: "FI",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "France",
    prefixCode: "33",
    countryCode: "FR",
    currency: x.EUR
  },
  {
    country: "French Guiana",
    prefixCode: "594",
    countryCode: "GF",
    currency: x.EUR
  },
  {
    country: "French Polynesia",
    prefixCode: "689",
    countryCode: "PF",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Gabon",
    prefixCode: "241",
    countryCode: "GA",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Gambia",
    prefixCode: "220",
    countryCode: "GM",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Georgia",
    prefixCode: "995",
    countryCode: "GE",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Germany",
    prefixCode: "49",
    countryCode: "DE",
    currency: x.EUR
  },
  {
    country: "Ghana",
    prefixCode: "233",
    countryCode: "GH",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Gibraltar",
    prefixCode: "350",
    countryCode: "GI",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Greece",
    prefixCode: "30",
    countryCode: "GR",
    currency: x.EUR
  },
  {
    country: "Greenland",
    prefixCode: "299",
    countryCode: "GL",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Grenada",
    prefixCode: "+1 473",
    countryCode: "GD",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Guadeloupe",
    prefixCode: "590",
    countryCode: "GP",
    currency: x.EUR
  },
  {
    country: "Guam",
    prefixCode: "+1 671",
    countryCode: "GU",
    currency: x.USD
  },
  {
    country: "Guatemala",
    prefixCode: "502",
    countryCode: "GT",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Guernsey",
    prefixCode: "44",
    countryCode: "GG",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Guinea",
    prefixCode: "224",
    countryCode: "GN",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Guinea-Bissau",
    prefixCode: "245",
    countryCode: "GW",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Guyana",
    prefixCode: "595",
    countryCode: "GY",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Haiti",
    prefixCode: "509",
    countryCode: "HT",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Heard and McDonald Islands",
    prefixCode: "672",
    countryCode: "HM",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Holy See (Vatican City State)",
    prefixCode: "379",
    countryCode: "VA",
    currency: x.EUR,
    currency2: x.EUR
  },
  {
    country: "Honduras",
    prefixCode: "504",
    countryCode: "HN",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Hong Kong",
    prefixCode: "852",
    countryCode: "HK",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Hungary",
    prefixCode: "36",
    countryCode: "HU",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Iceland",
    prefixCode: "354",
    countryCode: "IS",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "India",
    prefixCode: "91",
    countryCode: "IN",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Indonesia",
    prefixCode: "62",
    countryCode: "ID",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Iran, Islamic Republic of",
    prefixCode: "98",
    countryCode: "IR",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Iraq",
    prefixCode: "964",
    countryCode: "IQ",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Ireland",
    prefixCode: "353",
    countryCode: "IE",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Isle of Man",
    prefixCode: "44",
    countryCode: "IM",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Israel",
    prefixCode: "972",
    countryCode: "IL",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Italy",
    prefixCode: "39",
    countryCode: "IT",
    currency: x.EUR,
    currency2: x.EUR
  },
  {
    country: "Jamaica",
    prefixCode: "+1 876",
    countryCode: "JM",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Japan",
    prefixCode: "81",
    countryCode: "JP",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Jersey",
    prefixCode: "44",
    countryCode: "JE",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Jordan",
    prefixCode: "962",
    countryCode: "JO",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Kazakhstan",
    prefixCode: "+7 7",
    countryCode: "KZ",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Kenya",
    prefixCode: "254",
    countryCode: "KE",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Kiribati",
    prefixCode: "686",
    countryCode: "KI",
    currency: x.AUD,
    currency2: x.USD
  },
  {
    country: "Korea, Democratic People's Republic of",
    prefixCode: "850",
    countryCode: "KP",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Korea, Republic of",
    prefixCode: "82",
    countryCode: "KR",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Kosovo",
    prefixCode: "383",
    countryCode: "XK",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Kuwait",
    prefixCode: "965",
    countryCode: "KW",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Kyrgyzstan",
    prefixCode: "996",
    countryCode: "KG",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Lao People's Democratic Republic",
    prefixCode: "856",
    countryCode: "LA",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Latvia",
    prefixCode: "371",
    countryCode: "LV",
    currency: x.EUR
  },
  {
    country: "Lebanon",
    prefixCode: "961",
    countryCode: "LB",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Lesotho",
    prefixCode: "266",
    countryCode: "LS",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Liberia",
    prefixCode: "231",
    countryCode: "LR",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Libyan Arab Jamahiriya",
    prefixCode: "218",
    countryCode: "LY",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Liechtenstein",
    prefixCode: "423",
    countryCode: "LI",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Lithuania",
    prefixCode: "370",
    countryCode: "LT",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Luxembourg",
    prefixCode: "352",
    countryCode: "LU",
    currency: x.EUR,
    currency2: x.EUR
  },
  {
    country: "Macao",
    prefixCode: "853",
    countryCode: "MO",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Macedonia, The Former Yugoslav Republic of",
    prefixCode: "389",
    countryCode: "MK",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Madagascar",
    prefixCode: "261",
    countryCode: "MG",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Malawi",
    prefixCode: "265",
    countryCode: "MW",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Malaysia",
    prefixCode: "60",
    countryCode: "MY",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Maldives",
    prefixCode: "960",
    countryCode: "MV",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Mali",
    prefixCode: "223",
    countryCode: "ML",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Malta",
    prefixCode: "356",
    countryCode: "MT",
    currency: x.EUR
  },
  {
    country: "Marshall Islands",
    prefixCode: "692",
    countryCode: "MH",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Martinique",
    prefixCode: "596",
    countryCode: "MQ",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Mauritania",
    prefixCode: "222",
    countryCode: "MR",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Mauritius",
    prefixCode: "230",
    countryCode: "MU",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Mayotte",
    prefixCode: "262",
    countryCode: "YT",
    currency: x.EUR,
    currency2: x.EUR
  },
  {
    country: "Mexico",
    prefixCode: "52",
    countryCode: "MX",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Micronesia, Federated States of",
    prefixCode: "691",
    countryCode: "FM",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Moldova, Republic of",
    prefixCode: "373",
    countryCode: "MD",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Monaco",
    prefixCode: "377",
    countryCode: "MC",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Mongolia",
    prefixCode: "976",
    countryCode: "MN",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Montenegro",
    prefixCode: "382",
    countryCode: "ME",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Montserrat",
    prefixCode: "1664",
    countryCode: "MS",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Morocco",
    prefixCode: "212",
    countryCode: "MA",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Mozambique",
    prefixCode: "258",
    countryCode: "MZ",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Myanmar",
    prefixCode: "95",
    countryCode: "MM",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Namibia",
    prefixCode: "264",
    countryCode: "NA",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Nauru",
    prefixCode: "674",
    countryCode: "NR",
    currency: x.AUD,
    currency2: x.USD
  },
  {
    country: "Nepal",
    prefixCode: "977",
    countryCode: "NP",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Netherlands",
    prefixCode: "31",
    countryCode: "NL",
    currency: x.EUR,
    currency2: x.EUR
  },
  {
    country: "Netherlands Antilles",
    prefixCode: "599",
    countryCode: "AN",
    currency: x.USD,
    currency2: x.USD
  },
  {
    country: "New Caledonia",
    prefixCode: "687",
    countryCode: "NC",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "New Zealand",
    prefixCode: "64",
    countryCode: "NZ",
    currency: x.AUD,
    currency2: x.USD
  },
  {
    country: "Nicaragua",
    prefixCode: "505",
    countryCode: "NI",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Niger",
    prefixCode: "227",
    countryCode: "NE",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Nigeria",
    prefixCode: "234",
    countryCode: "NG",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Niue",
    prefixCode: "683",
    countryCode: "NU",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Norfolk Island",
    prefixCode: "672",
    countryCode: "NF",
    currency: x.AUD
  },
  {
    country: "Northern Mariana Islands",
    prefixCode: "+1 670",
    countryCode: "MP",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Norway",
    prefixCode: "47",
    countryCode: "NO",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Oman",
    prefixCode: "968",
    countryCode: "OM",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Pakistan",
    prefixCode: "92",
    countryCode: "PK",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Palau",
    prefixCode: "680",
    countryCode: "PW",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Palestinian Territory, Occupied",
    prefixCode: "970",
    countryCode: "PS",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Panama",
    prefixCode: "507",
    countryCode: "PA",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Papua New Guinea",
    prefixCode: "675",
    countryCode: "PG",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Paraguay",
    prefixCode: "595",
    countryCode: "PY",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Peru",
    prefixCode: "51",
    countryCode: "PE",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Philippines",
    prefixCode: "63",
    countryCode: "PH",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Pitcairn",
    prefixCode: "872",
    countryCode: "PN",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Poland",
    prefixCode: "48",
    countryCode: "PL",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Portugal",
    prefixCode: "351",
    countryCode: "PT",
    currency: x.EUR,
    currency2: x.EUR
  },
  {
    country: "Puerto Rico",
    prefixCode: "+1 939",
    countryCode: "PR",
    currency: x.USD,
    currency2: x.USD
  },
  {
    country: "Qatar",
    prefixCode: "974",
    countryCode: "QA",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Reunion",
    prefixCode: "262",
    countryCode: "RE",
    currency: x.EUR,
    currency2: x.EUR
  },
  {
    country: "Romania",
    prefixCode: "40",
    countryCode: "RO",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Russia",
    prefixCode: "7",
    countryCode: "RU",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Rwanda",
    prefixCode: "250",
    countryCode: "RW",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Saint Barth√©lemy",
    prefixCode: "590",
    countryCode: "BL",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Saint Helena, Ascension and Tristan Da Cunha",
    prefixCode: "290",
    countryCode: "SH",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Saint Kitts and Nevis",
    prefixCode: "+1 869",
    countryCode: "KN",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Saint Lucia",
    prefixCode: "+1 758",
    countryCode: "LC",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Saint Martin",
    prefixCode: "590",
    countryCode: "MF",
    currency: x.EUR
  },
  {
    country: "Saint Pierre and Miquelon",
    prefixCode: "508",
    countryCode: "PM",
    currency: x.EUR
  },
  {
    country: "Saint Vincent and the Grenadines",
    prefixCode: "+1 784",
    countryCode: "VC",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Samoa",
    prefixCode: "685",
    countryCode: "WS",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "San Marino",
    prefixCode: "378",
    countryCode: "SM",
    currency: x.EUR
  },
  {
    country: "Sao Tome and Principe",
    prefixCode: "239",
    countryCode: "ST",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Saudi Arabia",
    prefixCode: "966",
    countryCode: "SA",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Senegal",
    prefixCode: "221",
    countryCode: "SN",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Serbia",
    prefixCode: "381",
    countryCode: "RS",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Seychelles",
    prefixCode: "248",
    countryCode: "SC",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Sierra Leone",
    prefixCode: "232",
    countryCode: "SL",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Singapore",
    prefixCode: "65",
    countryCode: "SG",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Slovakia",
    prefixCode: "421",
    countryCode: "SK",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Slovenia",
    prefixCode: "386",
    countryCode: "SI",
    currency: x.EUR,
    currency2: x.EUR
  },
  {
    country: "Solomon Islands",
    prefixCode: "677",
    countryCode: "SB",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Somalia",
    prefixCode: "252",
    countryCode: "SO",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "South Africa",
    prefixCode: "27",
    countryCode: "ZA",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "South Georgia and the South Sandwich Islands",
    prefixCode: "500",
    countryCode: "GS",
    currency: x.GBP
  },
  {
    country: "Spain",
    prefixCode: "34",
    countryCode: "ES",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Sri Lanka",
    prefixCode: "94",
    countryCode: "LK",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Sudan",
    prefixCode: "249",
    countryCode: "SD",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Suriname",
    prefixCode: "597",
    countryCode: "SR",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Svalbard and Jan Mayen",
    prefixCode: "47",
    countryCode: "SJ",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Swaziland",
    prefixCode: "268",
    countryCode: "SZ",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Sweden",
    prefixCode: "46",
    countryCode: "SE",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Switzerland",
    prefixCode: "41",
    countryCode: "CH",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Syrian Arab Republic",
    prefixCode: "963",
    countryCode: "SY",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Taiwan, Province of China",
    prefixCode: "886",
    countryCode: "TW",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Tajikistan",
    prefixCode: "992",
    countryCode: "TJ",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Tanzania, United Republic of",
    prefixCode: "255",
    countryCode: "TZ",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Thailand",
    prefixCode: "66",
    countryCode: "TH",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Timor-Leste",
    prefixCode: "670",
    countryCode: "TL",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Togo",
    prefixCode: "228",
    countryCode: "TG",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Tokelau",
    prefixCode: "690",
    countryCode: "TK",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Tonga",
    prefixCode: "676",
    countryCode: "TO",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Trinidad and Tobago",
    prefixCode: "+1 868",
    countryCode: "TT",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Tunisia",
    prefixCode: "216",
    countryCode: "TN",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Turkey",
    prefixCode: "90",
    countryCode: "TR",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Turkmenistan",
    prefixCode: "993",
    countryCode: "TM",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Turks and Caicos Islands",
    prefixCode: "+1 649",
    countryCode: "TC",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Tuvalu",
    prefixCode: "688",
    countryCode: "TV",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Uganda",
    prefixCode: "256",
    countryCode: "UG",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Ukraine",
    prefixCode: "380",
    countryCode: "UA",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "United Arab Emirates",
    prefixCode: "971",
    countryCode: "AE",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "United Kingdom",
    prefixCode: "44",
    countryCode: "GB",
    currency: x.GBP,
    currency2: x.USD
  },
  {
    country: "United States",
    prefixCode: "1",
    countryCode: "US",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Uruguay",
    prefixCode: "598",
    countryCode: "UY",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Uzbekistan",
    prefixCode: "998",
    countryCode: "UZ",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Vanuatu",
    prefixCode: "678",
    countryCode: "VU",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Venezuela, Bolivarian Republic of",
    prefixCode: "58",
    countryCode: "VE",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Viet Nam",
    prefixCode: "84",
    countryCode: "VN",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Virgin Islands (British)",
    prefixCode: "+1",
    countryCode: "VG",
    currency: x.USD
  },
  {
    country: "Virgin Islands (U.S.)",
    prefixCode: "+1 340",
    countryCode: "VI",
    currency: x.USD
  },
  {
    country: "Wallis and Futuna",
    prefixCode: "681",
    countryCode: "WF",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Yemen",
    prefixCode: "967",
    countryCode: "YE",
    currency: x.USD,
    currency2: x.EUR
  },
  {
    country: "Zambia",
    prefixCode: "260",
    countryCode: "ZM",
    currency: x.EUR,
    currency2: x.USD
  },
  {
    country: "Zimbabwe",
    prefixCode: "263",
    countryCode: "ZW",
    currency: x.USD,
    currency2: x.EUR
  }
], F6 = x.USD;
function bAe(e) {
  var r;
  return e && ((r = PW.find(
    (n) => n.countryCode === e
  )) == null ? void 0 : r.currency) || F6;
}
const vAe = (e, t = x.EUR, r = "en-US") => new Intl.NumberFormat(r, {
  style: "currency",
  currency: t,
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
}).format(e);
function y6(e) {
  return TW[e];
}
function EAe(e, t) {
  return t === x.EUR ? `${e}${y6(t)}` : `${y6(t)}${e}`;
}
function Cl(e) {
  return Cl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Cl(e);
}
function zr(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function mt(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function yt(e) {
  mt(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Cl(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), new Date(NaN));
}
function IW(e, t) {
  mt(2, arguments);
  var r = yt(e), n = zr(t);
  return isNaN(n) ? new Date(NaN) : (n && r.setDate(r.getDate() + n), r);
}
function RW(e, t) {
  mt(2, arguments);
  var r = yt(e), n = zr(t);
  if (isNaN(n))
    return new Date(NaN);
  if (!n)
    return r;
  var a = r.getDate(), i = new Date(r.getTime());
  i.setMonth(r.getMonth() + n + 1, 0);
  var o = i.getDate();
  return a >= o ? i : (r.setFullYear(i.getFullYear(), i.getMonth(), a), r);
}
function qd(e, t) {
  if (mt(2, arguments), !t || Cl(t) !== "object")
    return new Date(NaN);
  var r = t.years ? zr(t.years) : 0, n = t.months ? zr(t.months) : 0, a = t.weeks ? zr(t.weeks) : 0, i = t.days ? zr(t.days) : 0, o = t.hours ? zr(t.hours) : 0, u = t.minutes ? zr(t.minutes) : 0, d = t.seconds ? zr(t.seconds) : 0, s = yt(e), l = n || r ? RW(s, n + r * 12) : s, f = i || a ? IW(l, i + a * 7) : l, c = u + o * 60, h = d + c * 60, _ = h * 1e3, F = new Date(f.getTime() + _);
  return F;
}
function jW(e, t) {
  mt(2, arguments);
  var r = yt(e).getTime(), n = zr(t);
  return new Date(r + n);
}
var MW = {};
function $h() {
  return MW;
}
function V2(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function q1(e) {
  mt(1, arguments);
  var t = yt(e);
  return t.setHours(0, 0, 0, 0), t;
}
var BW = 864e5;
function NW(e, t) {
  mt(2, arguments);
  var r = q1(e), n = q1(t), a = r.getTime() - V2(r), i = n.getTime() - V2(n);
  return Math.round((a - i) / BW);
}
function wu(e, t) {
  mt(2, arguments);
  var r = yt(e), n = yt(t), a = r.getTime() - n.getTime();
  return a < 0 ? -1 : a > 0 ? 1 : a;
}
var LW = 6e4, qW = 36e5;
function H2(e, t) {
  mt(2, arguments);
  var r = q1(e), n = q1(t);
  return r.getTime() === n.getTime();
}
function UW(e) {
  return mt(1, arguments), e instanceof Date || Cl(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function GW(e) {
  if (mt(1, arguments), !UW(e) && typeof e != "number")
    return !1;
  var t = yt(e);
  return !isNaN(Number(t));
}
function WW(e, t) {
  mt(2, arguments);
  var r = yt(e), n = yt(t), a = r.getFullYear() - n.getFullYear(), i = r.getMonth() - n.getMonth();
  return a * 12 + i;
}
function VW(e, t) {
  mt(2, arguments);
  var r = yt(e), n = yt(t);
  return r.getFullYear() - n.getFullYear();
}
function b6(e, t) {
  var r = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function zk(e, t) {
  mt(2, arguments);
  var r = yt(e), n = yt(t), a = b6(r, n), i = Math.abs(NW(r, n));
  r.setDate(r.getDate() - a * i);
  var o = Number(b6(r, n) === -a), u = a * (i - o);
  return u === 0 ? 0 : u;
}
function U3(e, t) {
  return mt(2, arguments), yt(e).getTime() - yt(t).getTime();
}
var v6 = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
  }
  // Math.trunc is not supported by IE
}, HW = "trunc";
function G3(e) {
  return e ? v6[e] : v6[HW];
}
function zW(e, t, r) {
  mt(2, arguments);
  var n = U3(e, t) / qW;
  return G3(r == null ? void 0 : r.roundingMethod)(n);
}
function Kk(e, t, r) {
  mt(2, arguments);
  var n = U3(e, t) / LW;
  return G3(r == null ? void 0 : r.roundingMethod)(n);
}
function KW(e) {
  mt(1, arguments);
  var t = yt(e);
  return t.setHours(23, 59, 59, 999), t;
}
function YW(e) {
  mt(1, arguments);
  var t = yt(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function XW(e) {
  mt(1, arguments);
  var t = yt(e);
  return KW(t).getTime() === YW(t).getTime();
}
function QW(e, t) {
  mt(2, arguments);
  var r = yt(e), n = yt(t), a = wu(r, n), i = Math.abs(WW(r, n)), o;
  if (i < 1)
    o = 0;
  else {
    r.getMonth() === 1 && r.getDate() > 27 && r.setDate(30), r.setMonth(r.getMonth() - a * i);
    var u = wu(r, n) === -a;
    XW(yt(e)) && i === 1 && wu(e, n) === 1 && (u = !1), o = a * (i - Number(u));
  }
  return o === 0 ? 0 : o;
}
function ZW(e, t, r) {
  mt(2, arguments);
  var n = U3(e, t) / 1e3;
  return G3(r == null ? void 0 : r.roundingMethod)(n);
}
function JW(e, t) {
  mt(2, arguments);
  var r = yt(e), n = yt(t), a = wu(r, n), i = Math.abs(VW(r, n));
  r.setFullYear(1584), n.setFullYear(1584);
  var o = wu(r, n) === -a, u = a * (i - Number(o));
  return u === 0 ? 0 : u;
}
function eV(e, t) {
  mt(2, arguments);
  var r = zr(t);
  return jW(e, -r);
}
var tV = 864e5;
function rV(e) {
  mt(1, arguments);
  var t = yt(e), r = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var n = t.getTime(), a = r - n;
  return Math.floor(a / tV) + 1;
}
function U1(e) {
  mt(1, arguments);
  var t = 1, r = yt(e), n = r.getUTCDay(), a = (n < t ? 7 : 0) + n - t;
  return r.setUTCDate(r.getUTCDate() - a), r.setUTCHours(0, 0, 0, 0), r;
}
function Yk(e) {
  mt(1, arguments);
  var t = yt(e), r = t.getUTCFullYear(), n = new Date(0);
  n.setUTCFullYear(r + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var a = U1(n), i = new Date(0);
  i.setUTCFullYear(r, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = U1(i);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function nV(e) {
  mt(1, arguments);
  var t = Yk(e), r = new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var n = U1(r);
  return n;
}
var aV = 6048e5;
function iV(e) {
  mt(1, arguments);
  var t = yt(e), r = U1(t).getTime() - nV(t).getTime();
  return Math.round(r / aV) + 1;
}
function G1(e, t) {
  var r, n, a, i, o, u, d, s;
  mt(1, arguments);
  var l = $h(), f = zr((r = (n = (a = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && a !== void 0 ? a : l.weekStartsOn) !== null && n !== void 0 ? n : (d = l.locale) === null || d === void 0 || (s = d.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var c = yt(e), h = c.getUTCDay(), _ = (h < f ? 7 : 0) + h - f;
  return c.setUTCDate(c.getUTCDate() - _), c.setUTCHours(0, 0, 0, 0), c;
}
function Xk(e, t) {
  var r, n, a, i, o, u, d, s;
  mt(1, arguments);
  var l = yt(e), f = l.getUTCFullYear(), c = $h(), h = zr((r = (n = (a = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && a !== void 0 ? a : c.firstWeekContainsDate) !== null && n !== void 0 ? n : (d = c.locale) === null || d === void 0 || (s = d.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var _ = new Date(0);
  _.setUTCFullYear(f + 1, 0, h), _.setUTCHours(0, 0, 0, 0);
  var F = G1(_, t), v = new Date(0);
  v.setUTCFullYear(f, 0, h), v.setUTCHours(0, 0, 0, 0);
  var $ = G1(v, t);
  return l.getTime() >= F.getTime() ? f + 1 : l.getTime() >= $.getTime() ? f : f - 1;
}
function oV(e, t) {
  var r, n, a, i, o, u, d, s;
  mt(1, arguments);
  var l = $h(), f = zr((r = (n = (a = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && a !== void 0 ? a : l.firstWeekContainsDate) !== null && n !== void 0 ? n : (d = l.locale) === null || d === void 0 || (s = d.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), c = Xk(e, t), h = new Date(0);
  h.setUTCFullYear(c, 0, f), h.setUTCHours(0, 0, 0, 0);
  var _ = G1(h, t);
  return _;
}
var sV = 6048e5;
function uV(e, t) {
  mt(1, arguments);
  var r = yt(e), n = G1(r, t).getTime() - oV(r, t).getTime();
  return Math.round(n / sV) + 1;
}
function jt(e, t) {
  for (var r = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return r + n;
}
var dV = {
  // Year
  y: function(t, r) {
    var n = t.getUTCFullYear(), a = n > 0 ? n : 1 - n;
    return jt(r === "yy" ? a % 100 : a, r.length);
  },
  // Month
  M: function(t, r) {
    var n = t.getUTCMonth();
    return r === "M" ? String(n + 1) : jt(n + 1, 2);
  },
  // Day of the month
  d: function(t, r) {
    return jt(t.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(t, r) {
    var n = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, r) {
    return jt(t.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(t, r) {
    return jt(t.getUTCHours(), r.length);
  },
  // Minute
  m: function(t, r) {
    return jt(t.getUTCMinutes(), r.length);
  },
  // Second
  s: function(t, r) {
    return jt(t.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(t, r) {
    var n = r.length, a = t.getUTCMilliseconds(), i = Math.floor(a * Math.pow(10, n - 3));
    return jt(i, r.length);
  }
};
const io = dV;
var iu = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, lV = {
  // Era
  G: function(t, r, n) {
    var a = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, {
          width: "abbreviated"
        });
      case "GGGGG":
        return n.era(a, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return n.era(a, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, r, n) {
    if (r === "yo") {
      var a = t.getUTCFullYear(), i = a > 0 ? a : 1 - a;
      return n.ordinalNumber(i, {
        unit: "year"
      });
    }
    return io.y(t, r);
  },
  // Local week-numbering year
  Y: function(t, r, n, a) {
    var i = Xk(t, a), o = i > 0 ? i : 1 - i;
    if (r === "YY") {
      var u = o % 100;
      return jt(u, 2);
    }
    return r === "Yo" ? n.ordinalNumber(o, {
      unit: "year"
    }) : jt(o, r.length);
  },
  // ISO week-numbering year
  R: function(t, r) {
    var n = Yk(t);
    return jt(n, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, r) {
    var n = t.getUTCFullYear();
    return jt(n, r.length);
  },
  // Quarter
  Q: function(t, r, n) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(a);
      case "QQ":
        return jt(a, 2);
      case "Qo":
        return n.ordinalNumber(a, {
          unit: "quarter"
        });
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, r, n) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(a);
      case "qq":
        return jt(a, 2);
      case "qo":
        return n.ordinalNumber(a, {
          unit: "quarter"
        });
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, r, n) {
    var a = t.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return io.M(t, r);
      case "Mo":
        return n.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, r, n) {
    var a = t.getUTCMonth();
    switch (r) {
      case "L":
        return String(a + 1);
      case "LL":
        return jt(a + 1, 2);
      case "Lo":
        return n.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, r, n, a) {
    var i = uV(t, a);
    return r === "wo" ? n.ordinalNumber(i, {
      unit: "week"
    }) : jt(i, r.length);
  },
  // ISO week of year
  I: function(t, r, n) {
    var a = iV(t);
    return r === "Io" ? n.ordinalNumber(a, {
      unit: "week"
    }) : jt(a, r.length);
  },
  // Day of the month
  d: function(t, r, n) {
    return r === "do" ? n.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : io.d(t, r);
  },
  // Day of year
  D: function(t, r, n) {
    var a = rV(t);
    return r === "Do" ? n.ordinalNumber(a, {
      unit: "dayOfYear"
    }) : jt(a, r.length);
  },
  // Day of week
  E: function(t, r, n) {
    var a = t.getUTCDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, r, n, a) {
    var i = t.getUTCDay(), o = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(o);
      case "ee":
        return jt(o, 2);
      case "eo":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, r, n, a) {
    var i = t.getUTCDay(), o = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(o);
      case "cc":
        return jt(o, r.length);
      case "co":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, r, n) {
    var a = t.getUTCDay(), i = a === 0 ? 7 : a;
    switch (r) {
      case "i":
        return String(i);
      case "ii":
        return jt(i, r.length);
      case "io":
        return n.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, r, n) {
    var a = t.getUTCHours(), i = a / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, r, n) {
    var a = t.getUTCHours(), i;
    switch (a === 12 ? i = iu.noon : a === 0 ? i = iu.midnight : i = a / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, r, n) {
    var a = t.getUTCHours(), i;
    switch (a >= 17 ? i = iu.evening : a >= 12 ? i = iu.afternoon : a >= 4 ? i = iu.morning : i = iu.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, r, n) {
    if (r === "ho") {
      var a = t.getUTCHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, {
        unit: "hour"
      });
    }
    return io.h(t, r);
  },
  // Hour [0-23]
  H: function(t, r, n) {
    return r === "Ho" ? n.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : io.H(t, r);
  },
  // Hour [0-11]
  K: function(t, r, n) {
    var a = t.getUTCHours() % 12;
    return r === "Ko" ? n.ordinalNumber(a, {
      unit: "hour"
    }) : jt(a, r.length);
  },
  // Hour [1-24]
  k: function(t, r, n) {
    var a = t.getUTCHours();
    return a === 0 && (a = 24), r === "ko" ? n.ordinalNumber(a, {
      unit: "hour"
    }) : jt(a, r.length);
  },
  // Minute
  m: function(t, r, n) {
    return r === "mo" ? n.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : io.m(t, r);
  },
  // Second
  s: function(t, r, n) {
    return r === "so" ? n.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : io.s(t, r);
  },
  // Fraction of second
  S: function(t, r) {
    return io.S(t, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (r) {
      case "X":
        return $6(o);
      case "XXXX":
      case "XX":
        return zo(o);
      case "XXXXX":
      case "XXX":
      default:
        return zo(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "x":
        return $6(o);
      case "xxxx":
      case "xx":
        return zo(o);
      case "xxxxx":
      case "xxx":
      default:
        return zo(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + E6(o, ":");
      case "OOOO":
      default:
        return "GMT" + zo(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + E6(o, ":");
      case "zzzz":
      default:
        return "GMT" + zo(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, r, n, a) {
    var i = a._originalDate || t, o = Math.floor(i.getTime() / 1e3);
    return jt(o, r.length);
  },
  // Milliseconds timestamp
  T: function(t, r, n, a) {
    var i = a._originalDate || t, o = i.getTime();
    return jt(o, r.length);
  }
};
function E6(e, t) {
  var r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.floor(n / 60), i = n % 60;
  if (i === 0)
    return r + String(a);
  var o = t || "";
  return r + String(a) + o + jt(i, 2);
}
function $6(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + jt(Math.abs(e) / 60, 2);
  }
  return zo(e, t);
}
function zo(e, t) {
  var r = t || "", n = e > 0 ? "-" : "+", a = Math.abs(e), i = jt(Math.floor(a / 60), 2), o = jt(a % 60, 2);
  return n + i + r + o;
}
const fV = lV;
var w6 = function(t, r) {
  switch (t) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    case "PPPP":
    default:
      return r.date({
        width: "full"
      });
  }
}, Qk = function(t, r) {
  switch (t) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    case "pppp":
    default:
      return r.time({
        width: "full"
      });
  }
}, cV = function(t, r) {
  var n = t.match(/(P+)(p+)?/) || [], a = n[1], i = n[2];
  if (!i)
    return w6(t, r);
  var o;
  switch (a) {
    case "P":
      o = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = r.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = r.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", w6(a, r)).replace("{{time}}", Qk(i, r));
}, hV = {
  p: Qk,
  P: cV
};
const gV = hV;
var _V = ["D", "DD"], mV = ["YY", "YYYY"];
function pV(e) {
  return _V.indexOf(e) !== -1;
}
function FV(e) {
  return mV.indexOf(e) !== -1;
}
function k6(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var yV = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, bV = function(t, r, n) {
  var a, i = yV[t];
  return typeof i == "string" ? a = i : r === 1 ? a = i.one : a = i.other.replace("{{count}}", r.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
const vV = bV;
function E_(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.width ? String(t.width) : e.defaultWidth, n = e.formats[r] || e.formats[e.defaultWidth];
    return n;
  };
}
var EV = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, $V = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, wV = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, kV = {
  date: E_({
    formats: EV,
    defaultWidth: "full"
  }),
  time: E_({
    formats: $V,
    defaultWidth: "full"
  }),
  dateTime: E_({
    formats: wV,
    defaultWidth: "full"
  })
};
const xV = kV;
var DV = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, CV = function(t, r, n, a) {
  return DV[t];
};
const SV = CV;
function Ud(e) {
  return function(t, r) {
    var n = r != null && r.context ? String(r.context) : "standalone", a;
    if (n === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth, o = r != null && r.width ? String(r.width) : i;
      a = e.formattingValues[o] || e.formattingValues[i];
    } else {
      var u = e.defaultWidth, d = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[d] || e.values[u];
    }
    var s = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[s];
  };
}
var AV = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, OV = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, TV = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, PV = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, IV = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, RV = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, jV = function(t, r) {
  var n = Number(t), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, MV = {
  ordinalNumber: jV,
  era: Ud({
    values: AV,
    defaultWidth: "wide"
  }),
  quarter: Ud({
    values: OV,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: Ud({
    values: TV,
    defaultWidth: "wide"
  }),
  day: Ud({
    values: PV,
    defaultWidth: "wide"
  }),
  dayPeriod: Ud({
    values: IV,
    defaultWidth: "wide",
    formattingValues: RV,
    defaultFormattingWidth: "wide"
  })
};
const BV = MV;
function Gd(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    var o = i[0], u = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], d = Array.isArray(u) ? LV(u, function(f) {
      return f.test(o);
    }) : NV(u, function(f) {
      return f.test(o);
    }), s;
    s = e.valueCallback ? e.valueCallback(d) : d, s = r.valueCallback ? r.valueCallback(s) : s;
    var l = t.slice(o.length);
    return {
      value: s,
      rest: l
    };
  };
}
function NV(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r) && t(e[r]))
      return r;
}
function LV(e, t) {
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function qV(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.match(e.matchPattern);
    if (!n)
      return null;
    var a = n[0], i = t.match(e.parsePattern);
    if (!i)
      return null;
    var o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    var u = t.slice(a.length);
    return {
      value: o,
      rest: u
    };
  };
}
var UV = /^(\d+)(th|st|nd|rd)?/i, GV = /\d+/i, WV = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, VV = {
  any: [/^b/i, /^(a|c)/i]
}, HV = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, zV = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, KV = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, YV = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, XV = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, QV = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, ZV = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, JV = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, eH = {
  ordinalNumber: qV({
    matchPattern: UV,
    parsePattern: GV,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Gd({
    matchPatterns: WV,
    defaultMatchWidth: "wide",
    parsePatterns: VV,
    defaultParseWidth: "any"
  }),
  quarter: Gd({
    matchPatterns: HV,
    defaultMatchWidth: "wide",
    parsePatterns: zV,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Gd({
    matchPatterns: KV,
    defaultMatchWidth: "wide",
    parsePatterns: YV,
    defaultParseWidth: "any"
  }),
  day: Gd({
    matchPatterns: XV,
    defaultMatchWidth: "wide",
    parsePatterns: QV,
    defaultParseWidth: "any"
  }),
  dayPeriod: Gd({
    matchPatterns: ZV,
    defaultMatchWidth: "any",
    parsePatterns: JV,
    defaultParseWidth: "any"
  })
};
const tH = eH;
var rH = {
  code: "en-US",
  formatDistance: vV,
  formatLong: xV,
  formatRelative: SV,
  localize: BV,
  match: tH,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const nH = rH;
var aH = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, iH = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, oH = /^'([^]*?)'?$/, sH = /''/g, uH = /[a-zA-Z]/;
function Zk(e, t, r) {
  var n, a, i, o, u, d, s, l, f, c, h, _, F, v, $, E, D, w;
  mt(2, arguments);
  var k = String(t), A = $h(), P = (n = (a = r == null ? void 0 : r.locale) !== null && a !== void 0 ? a : A.locale) !== null && n !== void 0 ? n : nH, S = zr((i = (o = (u = (d = r == null ? void 0 : r.firstWeekContainsDate) !== null && d !== void 0 ? d : r == null || (s = r.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && u !== void 0 ? u : A.firstWeekContainsDate) !== null && o !== void 0 ? o : (f = A.locale) === null || f === void 0 || (c = f.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(S >= 1 && S <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var N = zr((h = (_ = (F = (v = r == null ? void 0 : r.weekStartsOn) !== null && v !== void 0 ? v : r == null || ($ = r.locale) === null || $ === void 0 || (E = $.options) === null || E === void 0 ? void 0 : E.weekStartsOn) !== null && F !== void 0 ? F : A.weekStartsOn) !== null && _ !== void 0 ? _ : (D = A.locale) === null || D === void 0 || (w = D.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(N >= 0 && N <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!P.localize)
    throw new RangeError("locale must contain localize property");
  if (!P.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var W = yt(e);
  if (!GW(W))
    throw new RangeError("Invalid time value");
  var V = V2(W), K = eV(W, V), U = {
    firstWeekContainsDate: S,
    weekStartsOn: N,
    locale: P,
    _originalDate: W
  }, j = k.match(iH).map(function(G) {
    var H = G[0];
    if (H === "p" || H === "P") {
      var J = gV[H];
      return J(G, P.formatLong);
    }
    return G;
  }).join("").match(aH).map(function(G) {
    if (G === "''")
      return "'";
    var H = G[0];
    if (H === "'")
      return dH(G);
    var J = fV[H];
    if (J)
      return !(r != null && r.useAdditionalWeekYearTokens) && FV(G) && k6(G, t, String(e)), !(r != null && r.useAdditionalDayOfYearTokens) && pV(G) && k6(G, t, String(e)), J(K, G, P.localize, U);
    if (H.match(uH))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + H + "`");
    return G;
  }).join("");
  return j;
}
function dH(e) {
  var t = e.match(oH);
  return t ? t[1].replace(sH, "'") : e;
}
function lH(e) {
  return mt(1, arguments), yt(e).getFullYear();
}
function fH(e) {
  mt(1, arguments);
  var t = yt(e.start), r = yt(e.end);
  if (isNaN(t.getTime()))
    throw new RangeError("Start Date is invalid");
  if (isNaN(r.getTime()))
    throw new RangeError("End Date is invalid");
  var n = {};
  n.years = Math.abs(JW(r, t));
  var a = wu(r, t), i = qd(t, {
    years: a * n.years
  });
  n.months = Math.abs(QW(r, i));
  var o = qd(i, {
    months: a * n.months
  });
  n.days = Math.abs(zk(r, o));
  var u = qd(o, {
    days: a * n.days
  });
  n.hours = Math.abs(zW(r, u));
  var d = qd(u, {
    hours: a * n.hours
  });
  n.minutes = Math.abs(Kk(r, d));
  var s = qd(d, {
    minutes: a * n.minutes
  });
  return n.seconds = Math.abs(ZW(r, s)), n;
}
function Jk(e, t, r) {
  var n;
  mt(1, arguments);
  var a;
  return cH(t) ? a = t : r = t, new Intl.DateTimeFormat((n = r) === null || n === void 0 ? void 0 : n.locale, a).format(e);
}
function cH(e) {
  return e !== void 0 && !("locale" in e);
}
function hH(e, t) {
  mt(2, arguments);
  var r = yt(e), n = yt(t);
  return r.getFullYear() === n.getFullYear() && r.getMonth() === n.getMonth();
}
function ex(e, t) {
  mt(2, arguments);
  var r = yt(e), n = yt(t);
  return r.getFullYear() === n.getFullYear();
}
function x6(e) {
  return mt(1, arguments), ex(e, Date.now());
}
var W1 = /* @__PURE__ */ ((e) => (e.INBOUND = "INBOUND", e.OUTBOUND = "OUTBOUND", e))(W1 || {}), Je = /* @__PURE__ */ ((e) => (e.ANSWERED = "ANSWERED", e.IN_CALL = "IN_CALL", e.IN_IVR = "IN_IVR", e.IN_QUEUE = "IN_QUEUE", e.RINGING = "RINGING", e.UNANSWERED = "UNANSWERED", e.UNANSWERED_ABANDONED_BEFORE_10_SECONDS = "UNANSWERED_ABANDONED_BEFORE_10_SECONDS", e.UNANSWERED_ABANDONED_DURING_WELCOME_MESSAGE = "UNANSWERED_ABANDONED_DURING_WELCOME_MESSAGE", e.UNANSWERED_ABANDONED_IN_IVR = "UNANSWERED_ABANDONED_IN_IVR", e.UNANSWERED_ALL_AGENTS_UNAVAILABLE = "UNANSWERED_ALL_AGENTS_UNAVAILABLE", e.UNANSWERED_CALLBACK_REQUEST = "UNANSWERED_CALLBACK_REQUEST", e.UNANSWERED_OUTSIDE_BUSINESS_HOURS = "UNANSWERED_OUTSIDE_BUSINESS_HOURS", e.UNANSWERED_USERS_DID_NOT_ANSWER = "UNANSWERED_USERS_DID_NOT_ANSWER", e))(Je || {});
const gH = [403, 401], _H = [404], mH = [400, 409, 422], pH = [429], FH = [504], D6 = "Nonexistent resource", $_ = "Request failed with status code 404", C6 = "Request failed with status code 422", Rr = {
  INVALID_VALUE: "is_invalid",
  HAS_ALREADY_BEEN_TAKEN: "has already been taken",
  // Billing details related keys
  WRONG_VAT_PATTERN: "VAT country code does not match with the country",
  // Password related keys
  PASSWORD_EQUAL_TO_CURRENT_PASSWORD: "equal_to_current_password",
  PASSWORD_WRONG_FORMAT: "password_format",
  PASSWORD_TOO_SHORT: "too_short",
  PASSWORD_TAKEN_IN_PAST: "taken_in_past",
  EMAIL_ALREADY_EXISTS: "email already exists",
  RESET_PASSWORD_TOKEN_IS_INVALID: "invalid_code",
  TOO_MANY_REQUEST: "too_many_requests",
  TEAM_NAME_ALREADY_USED_BY_THE_COMPANY: "is already used by the company",
  MAX_NUMBER_OF_TEAMS_REACHED: "number of teams allowed has been reached",
  INVALID_PASSWORD: "Invalid password.",
  // Critical actions related keys
  UPDATE_EMAIL_BAD_REQUEST: "email/bad-request",
  UPDATE_EMAIL_ALREADY_IN_USE: "email/already-in-use",
  UPDATE_EMAIL_UNKNOWN: "email/unknown",
  ADD_PAYMENT_CARD_UNKNOWN: "card/unknown"
}, yH = {
  [Rr.INVALID_VALUE]: "generic_errors.backend_validation.is_invalid",
  [Rr.HAS_ALREADY_BEEN_TAKEN]: "generic_errors.backend_validation.has_already_been_taken",
  [Rr.WRONG_VAT_PATTERN]: "generic_errors.frontend_validation.wrong_vat_pattern",
  [Rr.PASSWORD_EQUAL_TO_CURRENT_PASSWORD]: "generic_errors.backend_validation.password_equal_to_current_password",
  [Rr.PASSWORD_WRONG_FORMAT]: "generic_errors.backend_validation.password_strength",
  [Rr.TOO_MANY_REQUEST]: "generic_errors.backend_validation.too_many_requests",
  [Rr.INVALID_PASSWORD]: "generic_errors.backend_validation.password_strength",
  [Rr.RESET_PASSWORD_TOKEN_IS_INVALID]: "generic_errors.backend_validation.token_invalid",
  [Rr.MAX_NUMBER_OF_TEAMS_REACHED]: "generic_errors.backend_validation.max_number_of_teams_reached",
  [Rr.PASSWORD_TOO_SHORT]: "generic_errors.backend_validation.password_length",
  [Rr.PASSWORD_TAKEN_IN_PAST]: "generic_errors.backend_validation.password_taken_in_past",
  [Rr.EMAIL_ALREADY_EXISTS]: "generic_errors.backend_validation.email_already_exists",
  [Rr.TEAM_NAME_ALREADY_USED_BY_THE_COMPANY]: "generic_errors.backend_validation.has_already_been_taken",
  [Rr.UPDATE_EMAIL_BAD_REQUEST]: "generic_errors.frontend_validation.invalid_email",
  [Rr.UPDATE_EMAIL_ALREADY_IN_USE]: "generic_errors.backend_validation.email_already_exists",
  [Rr.UPDATE_EMAIL_UNKNOWN]: "generic_errors.other.unknown_error",
  [Rr.ADD_PAYMENT_CARD_UNKNOWN]: "credit_card.card_unknown_error"
}, pn = {
  INVALID_DATA_ERROR: "generic_errors.backend_validation.is_invalid",
  UNKNOWN_ERROR: "generic_errors.other.unknown_error",
  NETWORK_ERROR: "generic_errors.other.network_error",
  GATEWAY_TIMEOUT_ERROR: "generic_errors.other.gateway_timeout_error",
  WRONG_ERROR: "generic_errors.other.wrong_error",
  TOO_MANY_REQUESTS: "generic_errors.other.too_many_requests",
  REQUEST_TOO_EARLY: "generic_errors.other.request_too_early",
  CREDENTIALS_ERROR: "login.errors.credential",
  MFA_CREDENTIALS_ERROR: "login.mfa.invalid_code",
  MFA_SESSION_EXPIRED: "login.message.session_expired"
}, wr = {
  WRONG_FORMAT: "generic_errors.frontend_validation.wrong_format",
  INVALID_VALUE: "generic_errors.frontend_validation.invalid_value",
  PASSWORD_STRENGTH: "generic_errors.frontend_validation.password_strength",
  PASSWORD_LENGTH: "generic_errors.frontend_validation.password_length",
  PASSWORD_NOT_MATCH: "generic_errors.frontend_validation.password_not_match",
  INVALID_EMAIL: "generic_errors.frontend_validation.invalid_email",
  REQUIRED_FIELD: "generic_errors.frontend_validation.required",
  MAX_LENGTH: "generic_errors.frontend_validation.max_length",
  ALREADY_EXISTS: "generic_errors.frontend_validation.already_exists",
  WRONG_PICTURE_FORMAT: "generic_errors.frontend_validation.wrong_picture_format",
  PICTURE_SIZE_TOO_LARGE: "generic_errors.frontend_validation.picture_size_too_large",
  TOO_SHORT: "generic_errors.frontend_validation.too_short",
  NO_CREDIT_CARD: "generic_errors.frontend_validation.no_credit_card",
  NO_ADDRESS: "generic_errors.frontend_validation.no_address",
  INVALID_NUMBER_NAME: "generic_errors.frontend_validation.invalid_number_name"
}, bH = {
  "email already exists": "email",
  "email/bad-request": "email",
  "email/already-in-use": "email",
  "email/unknown": "email",
  "card/unknown": "card",
  "VAT country code does not match with the country": "VATWrongFormat"
}, $Ae = "FINAL_FORM/form-error", wAe = {
  DELETION_SUCCESS: "success_feedback_messages.deletion_success",
  UPDATE_SUCCESS: "success_feedback_messages.update_success",
  CREATION_SUCCESS: "success_feedback_messages.creation_success",
  ADD_SUCCESS: "success_feedback_messages.add_success"
}, kAe = 46e5;
var La = /* @__PURE__ */ ((e) => (e.CANCEL = "cancel", e.UNDO = "undo", e.SAVED = "saved", e.SUBMIT = "submit", e.UNSAVED = "unsaved", e))(La || {});
const vH = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, EH = /(?=.{8,})/, $H = /^(?!\s)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.[\]{}()+?\-"!@#%&/,><':;|_~`\\"'])[\^$*.[\]{}()+?\-"!@#%&/,><':;|_~`\u0020a-zA-Z0-9\\"']{8,99}[^-\s]$/, wH = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w~:/?#[\]@!$&'()*+,;=.]+$/, tx = /^\d*$/, kH = /^\d*%$/, xH = /\D+/g, DH = /[-_][a-z]+$/i, CH = /<\/?[a-z][\s\S]*>/i, xAe = /^https?:\/\/?/, qa = {
  en: {
    Admin: "Admin",
    Agent: "Agent",
    cancel: "Cancel",
    Owner: "Owner",
    saved: "Saved",
    submit: "Confirm",
    Supervisor: "Supervisor",
    undo: "Undo",
    unsaved: "Save changes"
  },
  de: {
    Admin: "Admin",
    Agent: "Agent",
    cancel: "Abbrechen",
    Owner: "Eigentümer",
    saved: "Gespeichert",
    submit: "Bestätigen",
    Supervisor: "Supervisor",
    undo: "Rückgängig",
    unsaved: "Änderungen speichern"
  },
  es: {
    Admin: "Administrador",
    Agent: "Agente",
    cancel: "Cancelar",
    Owner: "Propietario",
    saved: "Guardado",
    submit: "Confirmar",
    Supervisor: "Supervisor",
    undo: "Deshacer",
    unsaved: "Guardar cambios"
  },
  fr: {
    Admin: "Admin",
    Agent: "Agent",
    cancel: "Annuler",
    Owner: "Propriétaire",
    saved: "Enregistré",
    submit: "Confirmer",
    Supervisor: "Superviseur",
    undo: "Annuler",
    unsaved: "Enregistrer les modifications"
  },
  it: {
    Admin: "Admin",
    Agent: "Agente",
    cancel: "Annulla",
    Owner: "Proprietario",
    saved: "Salvato",
    submit: "Conferma",
    Supervisor: "Supervisore",
    undo: "Annulla",
    unsaved: "Salva modifiche"
  },
  nb: {
    Admin: "Admin",
    Agent: "Agent",
    cancel: "Avbryte",
    Owner: "Owner",
    saved: "Lagret",
    submit: "Bekreft",
    Supervisor: "Supervisor",
    undo: "Kansellere",
    unsaved: "Lagre endringene"
  },
  pt: {
    Admin: "Admin",
    Agent: "Agente",
    cancel: "Cancelar",
    Owner: "Proprietário",
    saved: "Salvo",
    submit: "Confirmar",
    Supervisor: "Supervisor",
    undo: "Desfazer",
    unsaved: "Salvar alterações"
  }
};
var Ko = /* @__PURE__ */ ((e) => (e.AFTER_CALL_WORK = "AFTER_CALL_WORK", e.AVAILABLE = "AVAILABLE", e.BUSY = "BUSY", e.DOING_BACK_OFFICE = "DOING_BACK_OFFICE", e.DO_NOT_DISTURB = "DO_NOT_DISTURB", e.IN_CALL = "IN_CALL", e.IN_MANDATORY_TAGGING = "IN_MANDATORY_TAGGING", e.IN_TRAINING = "IN_TRAINING", e.OFFLINE = "OFFLINE", e.ON_A_BREAK = "ON_A_BREAK", e.ON_MOBILE = "ON_MOBILE", e.OTHER = "OTHER", e.OUT_FOR_LUNCH = "OUT_FOR_LUNCH", e.RINGING = "RINGING", e.UNAVAILABLE = "UNAVAILABLE", e))(Ko || {});
function W3(e, t = "") {
  return (e.trim().charAt(0) + t.trim().charAt(0)).toUpperCase();
}
function V1(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function DAe(...e) {
  return e.map(V1).join(" ").trim();
}
function CAe(e) {
  return CH.test(e);
}
function SAe({
  regex: e,
  replacement: t
}) {
  return (r) => r.replace(e, t);
}
function AAe(e) {
  return e.toLowerCase();
}
const SH = (e) => e == null ? void 0 : e.trim();
function rx(e, t = "en") {
  try {
    const r = t.replace(DH, "");
    return new Intl.DisplayNames([r], {
      type: "region"
    }).of(e);
  } catch {
    return e;
  }
}
function AH(e, t) {
  return e.length <= t ? e : `${e.slice(0, t)}...`;
}
function nx(e, t) {
  function r(n) {
    return n.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");
  }
  return r(e).includes(
    r(t)
  );
}
function ax(e) {
  const t = e.match(/(\d*)([\s\S]*)/);
  if (e !== "" && t) {
    const [, ...r] = t;
    return r;
  }
  return null;
}
const OAe = (e, t = "en-US") => new Intl.DateTimeFormat(t, { month: "long" }).format(e), TAe = (e) => Zk(e, "MM/yy"), PAe = (e) => Zk(e, "PPP"), IAe = (e, t) => zk(e, t), RAe = (e, t) => Kk(e, t), jAe = (e) => {
  const t = e.getHours();
  return t >= 6 && t < 12 ? "morning" : t >= 12 && t < 18 ? "afternoon" : (t >= 18 && t < 24, "evening");
};
function MAe(e = "en-US") {
  return (t) => Jk(
    new Date(t),
    { weekday: "long", year: "numeric", month: "long", day: "numeric" },
    { locale: e }
  );
}
function BAe(e = "en-US") {
  return (t) => Jk(
    new Date(t),
    { year: "numeric", month: "long", day: "numeric" },
    { locale: e }
  );
}
const w_ = (e, t = "en-US") => new Intl.DateTimeFormat(t, { day: "numeric" }).format(e), k_ = (e, t = "en-US") => new Intl.DateTimeFormat(t, { month: "short" }).format(e), n1 = (e, t = "en-US") => new Intl.DateTimeFormat(t, {
  day: "numeric",
  month: "short",
  year: "numeric"
}).format(e), ix = (e) => {
  const {
    years: t = 0,
    months: r = 0,
    days: n = 0,
    hours: a = 0,
    minutes: i = 0,
    seconds: o = 0
  } = fH({
    start: 0,
    end: e * 1e3
  });
  return t || r ? `${t * 365 + r * 30 + n}d ${a}h ${i}min ${o}s` : n ? `${n}d ${a}h ${i}min ${o}s` : a ? `${a}h ${i}min ${o}s` : i ? `${i}min ${o}s` : `${o}s`;
}, OH = (e, t = "en-US") => e.toLocaleTimeString(t, {
  hour: "numeric",
  minute: "2-digit"
}), S6 = (e = new Date()) => {
  const t = new Date(e.getTime());
  return t.setHours(0, 0, 0, 0), t;
}, A6 = /* @__PURE__ */ new Map(), TH = (e) => {
  let t = A6.get(e);
  return t || (t = new Intl.RelativeTimeFormat(e, { numeric: "auto" }), A6.set(e, t)), t;
}, PH = 1e3 * 3600 * 24, IH = 7, RH = (e, t = "en-US") => {
  const r = TH(t), n = S6(e), a = S6(), i = (n.getTime() - a.getTime()) / PH;
  return i === 0 ? "Today" : Math.abs(i) <= IH ? V1(r.format(Math.round(i), "days")) : n.getFullYear() === a.getFullYear() ? n.toLocaleDateString(t, { month: "short", day: "numeric" }) : n.toLocaleDateString(t);
}, jH = !0, MH = [
  {
    id: "people",
    name: "Smileys & People",
    emojis: [
      "grinning",
      "smiley",
      "smile",
      "grin",
      "laughing",
      "sweat_smile",
      "rolling_on_the_floor_laughing",
      "joy",
      "slightly_smiling_face",
      "upside_down_face",
      "wink",
      "blush",
      "innocent",
      "smiling_face_with_3_hearts",
      "heart_eyes",
      "star-struck",
      "kissing_heart",
      "kissing",
      "relaxed",
      "kissing_closed_eyes",
      "kissing_smiling_eyes",
      "yum",
      "stuck_out_tongue",
      "stuck_out_tongue_winking_eye",
      "zany_face",
      "stuck_out_tongue_closed_eyes",
      "money_mouth_face",
      "hugging_face",
      "face_with_hand_over_mouth",
      "shushing_face",
      "thinking_face",
      "zipper_mouth_face",
      "face_with_raised_eyebrow",
      "neutral_face",
      "expressionless",
      "no_mouth",
      "smirk",
      "unamused",
      "face_with_rolling_eyes",
      "grimacing",
      "lying_face",
      "relieved",
      "pensive",
      "sleepy",
      "drooling_face",
      "sleeping",
      "mask",
      "face_with_thermometer",
      "face_with_head_bandage",
      "nauseated_face",
      "face_vomiting",
      "sneezing_face",
      "hot_face",
      "cold_face",
      "woozy_face",
      "dizzy_face",
      "exploding_head",
      "face_with_cowboy_hat",
      "partying_face",
      "sunglasses",
      "nerd_face",
      "face_with_monocle",
      "confused",
      "worried",
      "slightly_frowning_face",
      "white_frowning_face",
      "open_mouth",
      "hushed",
      "astonished",
      "flushed",
      "pleading_face",
      "frowning",
      "anguished",
      "fearful",
      "cold_sweat",
      "disappointed_relieved",
      "cry",
      "sob",
      "scream",
      "confounded",
      "persevere",
      "disappointed",
      "sweat",
      "weary",
      "tired_face",
      "yawning_face",
      "triumph",
      "rage",
      "angry",
      "face_with_symbols_on_mouth",
      "smiling_imp",
      "imp",
      "skull",
      "skull_and_crossbones",
      "hankey",
      "clown_face",
      "japanese_ogre",
      "japanese_goblin",
      "ghost",
      "alien",
      "space_invader",
      "robot_face",
      "smiley_cat",
      "smile_cat",
      "joy_cat",
      "heart_eyes_cat",
      "smirk_cat",
      "kissing_cat",
      "scream_cat",
      "crying_cat_face",
      "pouting_cat",
      "see_no_evil",
      "hear_no_evil",
      "speak_no_evil",
      "wave",
      "raised_back_of_hand",
      "raised_hand_with_fingers_splayed",
      "hand",
      "spock-hand",
      "ok_hand",
      "pinching_hand",
      "v",
      "crossed_fingers",
      "i_love_you_hand_sign",
      "the_horns",
      "call_me_hand",
      "point_left",
      "point_right",
      "point_up_2",
      "middle_finger",
      "point_down",
      "point_up",
      "+1",
      "-1",
      "fist",
      "facepunch",
      "left-facing_fist",
      "right-facing_fist",
      "clap",
      "raised_hands",
      "open_hands",
      "palms_up_together",
      "handshake",
      "pray",
      "writing_hand",
      "nail_care",
      "selfie",
      "muscle",
      "mechanical_arm",
      "mechanical_leg",
      "leg",
      "foot",
      "ear",
      "ear_with_hearing_aid",
      "nose",
      "brain",
      "tooth",
      "bone",
      "eyes",
      "eye",
      "tongue",
      "lips",
      "baby",
      "child",
      "boy",
      "girl",
      "adult",
      "person_with_blond_hair",
      "man",
      "bearded_person",
      "red_haired_man",
      "curly_haired_man",
      "white_haired_man",
      "bald_man",
      "woman",
      "red_haired_woman",
      "red_haired_person",
      "curly_haired_woman",
      "curly_haired_person",
      "white_haired_woman",
      "white_haired_person",
      "bald_woman",
      "bald_person",
      "blond-haired-woman",
      "blond-haired-man",
      "older_adult",
      "older_man",
      "older_woman",
      "person_frowning",
      "man-frowning",
      "woman-frowning",
      "person_with_pouting_face",
      "man-pouting",
      "woman-pouting",
      "no_good",
      "man-gesturing-no",
      "woman-gesturing-no",
      "ok_woman",
      "man-gesturing-ok",
      "woman-gesturing-ok",
      "information_desk_person",
      "man-tipping-hand",
      "woman-tipping-hand",
      "raising_hand",
      "man-raising-hand",
      "woman-raising-hand",
      "deaf_person",
      "deaf_man",
      "deaf_woman",
      "bow",
      "man-bowing",
      "woman-bowing",
      "face_palm",
      "man-facepalming",
      "woman-facepalming",
      "shrug",
      "man-shrugging",
      "woman-shrugging",
      "health_worker",
      "male-doctor",
      "female-doctor",
      "student",
      "male-student",
      "female-student",
      "teacher",
      "male-teacher",
      "female-teacher",
      "judge",
      "male-judge",
      "female-judge",
      "farmer",
      "male-farmer",
      "female-farmer",
      "cook",
      "male-cook",
      "female-cook",
      "mechanic",
      "male-mechanic",
      "female-mechanic",
      "factory_worker",
      "male-factory-worker",
      "female-factory-worker",
      "office_worker",
      "male-office-worker",
      "female-office-worker",
      "scientist",
      "male-scientist",
      "female-scientist",
      "technologist",
      "male-technologist",
      "female-technologist",
      "singer",
      "male-singer",
      "female-singer",
      "artist",
      "male-artist",
      "female-artist",
      "pilot",
      "male-pilot",
      "female-pilot",
      "astronaut",
      "male-astronaut",
      "female-astronaut",
      "firefighter",
      "male-firefighter",
      "female-firefighter",
      "cop",
      "male-police-officer",
      "female-police-officer",
      "sleuth_or_spy",
      "male-detective",
      "female-detective",
      "guardsman",
      "male-guard",
      "female-guard",
      "construction_worker",
      "male-construction-worker",
      "female-construction-worker",
      "prince",
      "princess",
      "man_with_turban",
      "man-wearing-turban",
      "woman-wearing-turban",
      "man_with_gua_pi_mao",
      "person_with_headscarf",
      "man_in_tuxedo",
      "bride_with_veil",
      "pregnant_woman",
      "breast-feeding",
      "angel",
      "santa",
      "mrs_claus",
      "superhero",
      "male_superhero",
      "female_superhero",
      "supervillain",
      "male_supervillain",
      "female_supervillain",
      "mage",
      "male_mage",
      "female_mage",
      "fairy",
      "male_fairy",
      "female_fairy",
      "vampire",
      "male_vampire",
      "female_vampire",
      "merperson",
      "merman",
      "mermaid",
      "elf",
      "male_elf",
      "female_elf",
      "genie",
      "male_genie",
      "female_genie",
      "zombie",
      "male_zombie",
      "female_zombie",
      "massage",
      "man-getting-massage",
      "woman-getting-massage",
      "haircut",
      "man-getting-haircut",
      "woman-getting-haircut",
      "walking",
      "man-walking",
      "woman-walking",
      "standing_person",
      "man_standing",
      "woman_standing",
      "kneeling_person",
      "man_kneeling",
      "woman_kneeling",
      "person_with_probing_cane",
      "man_with_probing_cane",
      "woman_with_probing_cane",
      "person_in_motorized_wheelchair",
      "man_in_motorized_wheelchair",
      "woman_in_motorized_wheelchair",
      "person_in_manual_wheelchair",
      "man_in_manual_wheelchair",
      "woman_in_manual_wheelchair",
      "runner",
      "man-running",
      "woman-running",
      "dancer",
      "man_dancing",
      "man_in_business_suit_levitating",
      "dancers",
      "man-with-bunny-ears-partying",
      "woman-with-bunny-ears-partying",
      "person_in_steamy_room",
      "man_in_steamy_room",
      "woman_in_steamy_room",
      "person_climbing",
      "man_climbing",
      "woman_climbing",
      "fencer",
      "horse_racing",
      "skier",
      "snowboarder",
      "golfer",
      "man-golfing",
      "woman-golfing",
      "surfer",
      "man-surfing",
      "woman-surfing",
      "rowboat",
      "man-rowing-boat",
      "woman-rowing-boat",
      "swimmer",
      "man-swimming",
      "woman-swimming",
      "person_with_ball",
      "man-bouncing-ball",
      "woman-bouncing-ball",
      "weight_lifter",
      "man-lifting-weights",
      "woman-lifting-weights",
      "bicyclist",
      "man-biking",
      "woman-biking",
      "mountain_bicyclist",
      "man-mountain-biking",
      "woman-mountain-biking",
      "person_doing_cartwheel",
      "man-cartwheeling",
      "woman-cartwheeling",
      "wrestlers",
      "man-wrestling",
      "woman-wrestling",
      "water_polo",
      "man-playing-water-polo",
      "woman-playing-water-polo",
      "handball",
      "man-playing-handball",
      "woman-playing-handball",
      "juggling",
      "man-juggling",
      "woman-juggling",
      "person_in_lotus_position",
      "man_in_lotus_position",
      "woman_in_lotus_position",
      "bath",
      "sleeping_accommodation",
      "people_holding_hands",
      "two_women_holding_hands",
      "couple",
      "two_men_holding_hands",
      "couplekiss",
      "woman-kiss-man",
      "man-kiss-man",
      "woman-kiss-woman",
      "couple_with_heart",
      "woman-heart-man",
      "man-heart-man",
      "woman-heart-woman",
      "family",
      "man-woman-boy",
      "man-woman-girl",
      "man-woman-girl-boy",
      "man-woman-boy-boy",
      "man-woman-girl-girl",
      "man-man-boy",
      "man-man-girl",
      "man-man-girl-boy",
      "man-man-boy-boy",
      "man-man-girl-girl",
      "woman-woman-boy",
      "woman-woman-girl",
      "woman-woman-girl-boy",
      "woman-woman-boy-boy",
      "woman-woman-girl-girl",
      "man-boy",
      "man-boy-boy",
      "man-girl",
      "man-girl-boy",
      "man-girl-girl",
      "woman-boy",
      "woman-boy-boy",
      "woman-girl",
      "woman-girl-boy",
      "woman-girl-girl",
      "speaking_head_in_silhouette",
      "bust_in_silhouette",
      "busts_in_silhouette",
      "footprints",
      "kiss",
      "love_letter",
      "cupid",
      "gift_heart",
      "sparkling_heart",
      "heartpulse",
      "heartbeat",
      "revolving_hearts",
      "two_hearts",
      "heart_decoration",
      "heavy_heart_exclamation_mark_ornament",
      "broken_heart",
      "heart",
      "orange_heart",
      "yellow_heart",
      "green_heart",
      "blue_heart",
      "purple_heart",
      "brown_heart",
      "black_heart",
      "white_heart",
      "100",
      "anger",
      "boom",
      "dizzy",
      "sweat_drops",
      "dash",
      "hole",
      "bomb",
      "speech_balloon",
      "eye-in-speech-bubble",
      "left_speech_bubble",
      "right_anger_bubble",
      "thought_balloon",
      "zzz"
    ]
  },
  {
    id: "nature",
    name: "Animals & Nature",
    emojis: [
      "monkey_face",
      "monkey",
      "gorilla",
      "orangutan",
      "dog",
      "dog2",
      "guide_dog",
      "service_dog",
      "poodle",
      "wolf",
      "fox_face",
      "raccoon",
      "cat",
      "cat2",
      "lion_face",
      "tiger",
      "tiger2",
      "leopard",
      "horse",
      "racehorse",
      "unicorn_face",
      "zebra_face",
      "deer",
      "cow",
      "ox",
      "water_buffalo",
      "cow2",
      "pig",
      "pig2",
      "boar",
      "pig_nose",
      "ram",
      "sheep",
      "goat",
      "dromedary_camel",
      "camel",
      "llama",
      "giraffe_face",
      "elephant",
      "rhinoceros",
      "hippopotamus",
      "mouse",
      "mouse2",
      "rat",
      "hamster",
      "rabbit",
      "rabbit2",
      "chipmunk",
      "hedgehog",
      "bat",
      "bear",
      "koala",
      "panda_face",
      "sloth",
      "otter",
      "skunk",
      "kangaroo",
      "badger",
      "feet",
      "turkey",
      "chicken",
      "rooster",
      "hatching_chick",
      "baby_chick",
      "hatched_chick",
      "bird",
      "penguin",
      "dove_of_peace",
      "eagle",
      "duck",
      "swan",
      "owl",
      "flamingo",
      "peacock",
      "parrot",
      "frog",
      "crocodile",
      "turtle",
      "lizard",
      "snake",
      "dragon_face",
      "dragon",
      "sauropod",
      "t-rex",
      "whale",
      "whale2",
      "dolphin",
      "fish",
      "tropical_fish",
      "blowfish",
      "shark",
      "octopus",
      "shell",
      "snail",
      "butterfly",
      "bug",
      "ant",
      "bee",
      "beetle",
      "cricket",
      "spider",
      "spider_web",
      "scorpion",
      "mosquito",
      "microbe",
      "bouquet",
      "cherry_blossom",
      "white_flower",
      "rosette",
      "rose",
      "wilted_flower",
      "hibiscus",
      "sunflower",
      "blossom",
      "tulip",
      "seedling",
      "evergreen_tree",
      "deciduous_tree",
      "palm_tree",
      "cactus",
      "ear_of_rice",
      "herb",
      "shamrock",
      "four_leaf_clover",
      "maple_leaf",
      "fallen_leaf",
      "leaves"
    ]
  },
  {
    id: "foods",
    name: "Food & Drink",
    emojis: [
      "grapes",
      "melon",
      "watermelon",
      "tangerine",
      "lemon",
      "banana",
      "pineapple",
      "mango",
      "apple",
      "green_apple",
      "pear",
      "peach",
      "cherries",
      "strawberry",
      "kiwifruit",
      "tomato",
      "coconut",
      "avocado",
      "eggplant",
      "potato",
      "carrot",
      "corn",
      "hot_pepper",
      "cucumber",
      "leafy_green",
      "broccoli",
      "garlic",
      "onion",
      "mushroom",
      "peanuts",
      "chestnut",
      "bread",
      "croissant",
      "baguette_bread",
      "pretzel",
      "bagel",
      "pancakes",
      "waffle",
      "cheese_wedge",
      "meat_on_bone",
      "poultry_leg",
      "cut_of_meat",
      "bacon",
      "hamburger",
      "fries",
      "pizza",
      "hotdog",
      "sandwich",
      "taco",
      "burrito",
      "stuffed_flatbread",
      "falafel",
      "egg",
      "fried_egg",
      "shallow_pan_of_food",
      "stew",
      "bowl_with_spoon",
      "green_salad",
      "popcorn",
      "butter",
      "salt",
      "canned_food",
      "bento",
      "rice_cracker",
      "rice_ball",
      "rice",
      "curry",
      "ramen",
      "spaghetti",
      "sweet_potato",
      "oden",
      "sushi",
      "fried_shrimp",
      "fish_cake",
      "moon_cake",
      "dango",
      "dumpling",
      "fortune_cookie",
      "takeout_box",
      "crab",
      "lobster",
      "shrimp",
      "squid",
      "oyster",
      "icecream",
      "shaved_ice",
      "ice_cream",
      "doughnut",
      "cookie",
      "birthday",
      "cake",
      "cupcake",
      "pie",
      "chocolate_bar",
      "candy",
      "lollipop",
      "custard",
      "honey_pot",
      "baby_bottle",
      "glass_of_milk",
      "coffee",
      "tea",
      "sake",
      "champagne",
      "wine_glass",
      "cocktail",
      "tropical_drink",
      "beer",
      "beers",
      "clinking_glasses",
      "tumbler_glass",
      "cup_with_straw",
      "beverage_box",
      "mate_drink",
      "ice_cube",
      "chopsticks",
      "knife_fork_plate",
      "fork_and_knife",
      "spoon",
      "hocho",
      "amphora"
    ]
  },
  {
    id: "activity",
    name: "Activities",
    emojis: [
      "jack_o_lantern",
      "christmas_tree",
      "fireworks",
      "sparkler",
      "firecracker",
      "sparkles",
      "balloon",
      "tada",
      "confetti_ball",
      "tanabata_tree",
      "bamboo",
      "dolls",
      "flags",
      "wind_chime",
      "rice_scene",
      "red_envelope",
      "ribbon",
      "gift",
      "reminder_ribbon",
      "admission_tickets",
      "ticket",
      "medal",
      "trophy",
      "sports_medal",
      "first_place_medal",
      "second_place_medal",
      "third_place_medal",
      "soccer",
      "baseball",
      "softball",
      "basketball",
      "volleyball",
      "football",
      "rugby_football",
      "tennis",
      "flying_disc",
      "bowling",
      "cricket_bat_and_ball",
      "field_hockey_stick_and_ball",
      "ice_hockey_stick_and_puck",
      "lacrosse",
      "table_tennis_paddle_and_ball",
      "badminton_racquet_and_shuttlecock",
      "boxing_glove",
      "martial_arts_uniform",
      "goal_net",
      "golf",
      "ice_skate",
      "fishing_pole_and_fish",
      "diving_mask",
      "running_shirt_with_sash",
      "ski",
      "sled",
      "curling_stone",
      "dart",
      "yo-yo",
      "kite",
      "8ball",
      "crystal_ball",
      "nazar_amulet",
      "video_game",
      "joystick",
      "slot_machine",
      "game_die",
      "jigsaw",
      "teddy_bear",
      "spades",
      "hearts",
      "diamonds",
      "clubs",
      "chess_pawn",
      "black_joker",
      "mahjong",
      "flower_playing_cards",
      "performing_arts",
      "frame_with_picture",
      "art",
      "thread",
      "yarn"
    ]
  },
  {
    id: "places",
    name: "Travel & Places",
    emojis: [
      "earth_africa",
      "earth_americas",
      "earth_asia",
      "globe_with_meridians",
      "world_map",
      "japan",
      "compass",
      "snow_capped_mountain",
      "mountain",
      "volcano",
      "mount_fuji",
      "camping",
      "beach_with_umbrella",
      "desert",
      "desert_island",
      "national_park",
      "stadium",
      "classical_building",
      "building_construction",
      "bricks",
      "house_buildings",
      "derelict_house_building",
      "house",
      "house_with_garden",
      "office",
      "post_office",
      "european_post_office",
      "hospital",
      "bank",
      "hotel",
      "love_hotel",
      "convenience_store",
      "school",
      "department_store",
      "factory",
      "japanese_castle",
      "european_castle",
      "wedding",
      "tokyo_tower",
      "statue_of_liberty",
      "church",
      "mosque",
      "hindu_temple",
      "synagogue",
      "shinto_shrine",
      "kaaba",
      "fountain",
      "tent",
      "foggy",
      "night_with_stars",
      "cityscape",
      "sunrise_over_mountains",
      "sunrise",
      "city_sunset",
      "city_sunrise",
      "bridge_at_night",
      "hotsprings",
      "carousel_horse",
      "ferris_wheel",
      "roller_coaster",
      "barber",
      "circus_tent",
      "steam_locomotive",
      "railway_car",
      "bullettrain_side",
      "bullettrain_front",
      "train2",
      "metro",
      "light_rail",
      "station",
      "tram",
      "monorail",
      "mountain_railway",
      "train",
      "bus",
      "oncoming_bus",
      "trolleybus",
      "minibus",
      "ambulance",
      "fire_engine",
      "police_car",
      "oncoming_police_car",
      "taxi",
      "oncoming_taxi",
      "car",
      "oncoming_automobile",
      "blue_car",
      "truck",
      "articulated_lorry",
      "tractor",
      "racing_car",
      "racing_motorcycle",
      "motor_scooter",
      "manual_wheelchair",
      "motorized_wheelchair",
      "auto_rickshaw",
      "bike",
      "scooter",
      "skateboard",
      "busstop",
      "motorway",
      "railway_track",
      "oil_drum",
      "fuelpump",
      "rotating_light",
      "traffic_light",
      "vertical_traffic_light",
      "octagonal_sign",
      "construction",
      "anchor",
      "boat",
      "canoe",
      "speedboat",
      "passenger_ship",
      "ferry",
      "motor_boat",
      "ship",
      "airplane",
      "small_airplane",
      "airplane_departure",
      "airplane_arriving",
      "parachute",
      "seat",
      "helicopter",
      "suspension_railway",
      "mountain_cableway",
      "aerial_tramway",
      "satellite",
      "rocket",
      "flying_saucer",
      "bellhop_bell",
      "luggage",
      "hourglass",
      "hourglass_flowing_sand",
      "watch",
      "alarm_clock",
      "stopwatch",
      "timer_clock",
      "mantelpiece_clock",
      "clock12",
      "clock1230",
      "clock1",
      "clock130",
      "clock2",
      "clock230",
      "clock3",
      "clock330",
      "clock4",
      "clock430",
      "clock5",
      "clock530",
      "clock6",
      "clock630",
      "clock7",
      "clock730",
      "clock8",
      "clock830",
      "clock9",
      "clock930",
      "clock10",
      "clock1030",
      "clock11",
      "clock1130",
      "new_moon",
      "waxing_crescent_moon",
      "first_quarter_moon",
      "moon",
      "full_moon",
      "waning_gibbous_moon",
      "last_quarter_moon",
      "waning_crescent_moon",
      "crescent_moon",
      "new_moon_with_face",
      "first_quarter_moon_with_face",
      "last_quarter_moon_with_face",
      "thermometer",
      "sunny",
      "full_moon_with_face",
      "sun_with_face",
      "ringed_planet",
      "star",
      "star2",
      "stars",
      "milky_way",
      "cloud",
      "partly_sunny",
      "thunder_cloud_and_rain",
      "mostly_sunny",
      "barely_sunny",
      "partly_sunny_rain",
      "rain_cloud",
      "snow_cloud",
      "lightning",
      "tornado",
      "fog",
      "wind_blowing_face",
      "cyclone",
      "rainbow",
      "closed_umbrella",
      "umbrella",
      "umbrella_with_rain_drops",
      "umbrella_on_ground",
      "zap",
      "snowflake",
      "snowman",
      "snowman_without_snow",
      "comet",
      "fire",
      "droplet",
      "ocean"
    ]
  },
  {
    id: "objects",
    name: "Objects",
    emojis: [
      "eyeglasses",
      "dark_sunglasses",
      "goggles",
      "lab_coat",
      "safety_vest",
      "necktie",
      "shirt",
      "jeans",
      "scarf",
      "gloves",
      "coat",
      "socks",
      "dress",
      "kimono",
      "sari",
      "one-piece_swimsuit",
      "briefs",
      "shorts",
      "bikini",
      "womans_clothes",
      "purse",
      "handbag",
      "pouch",
      "shopping_bags",
      "school_satchel",
      "mans_shoe",
      "athletic_shoe",
      "hiking_boot",
      "womans_flat_shoe",
      "high_heel",
      "sandal",
      "ballet_shoes",
      "boot",
      "crown",
      "womans_hat",
      "tophat",
      "mortar_board",
      "billed_cap",
      "helmet_with_white_cross",
      "prayer_beads",
      "lipstick",
      "ring",
      "gem",
      "mute",
      "speaker",
      "sound",
      "loud_sound",
      "loudspeaker",
      "mega",
      "postal_horn",
      "bell",
      "no_bell",
      "musical_score",
      "musical_note",
      "notes",
      "studio_microphone",
      "level_slider",
      "control_knobs",
      "microphone",
      "headphones",
      "radio",
      "saxophone",
      "guitar",
      "musical_keyboard",
      "trumpet",
      "violin",
      "banjo",
      "drum_with_drumsticks",
      "iphone",
      "calling",
      "phone",
      "telephone_receiver",
      "pager",
      "fax",
      "battery",
      "electric_plug",
      "computer",
      "desktop_computer",
      "printer",
      "keyboard",
      "three_button_mouse",
      "trackball",
      "minidisc",
      "floppy_disk",
      "cd",
      "dvd",
      "abacus",
      "movie_camera",
      "film_frames",
      "film_projector",
      "clapper",
      "tv",
      "camera",
      "camera_with_flash",
      "video_camera",
      "vhs",
      "mag",
      "mag_right",
      "candle",
      "bulb",
      "flashlight",
      "izakaya_lantern",
      "diya_lamp",
      "notebook_with_decorative_cover",
      "closed_book",
      "book",
      "green_book",
      "blue_book",
      "orange_book",
      "books",
      "notebook",
      "ledger",
      "page_with_curl",
      "scroll",
      "page_facing_up",
      "newspaper",
      "rolled_up_newspaper",
      "bookmark_tabs",
      "bookmark",
      "label",
      "moneybag",
      "yen",
      "dollar",
      "euro",
      "pound",
      "money_with_wings",
      "credit_card",
      "receipt",
      "chart",
      "currency_exchange",
      "heavy_dollar_sign",
      "email",
      "e-mail",
      "incoming_envelope",
      "envelope_with_arrow",
      "outbox_tray",
      "inbox_tray",
      "package",
      "mailbox",
      "mailbox_closed",
      "mailbox_with_mail",
      "mailbox_with_no_mail",
      "postbox",
      "ballot_box_with_ballot",
      "pencil2",
      "black_nib",
      "lower_left_fountain_pen",
      "lower_left_ballpoint_pen",
      "lower_left_paintbrush",
      "lower_left_crayon",
      "memo",
      "briefcase",
      "file_folder",
      "open_file_folder",
      "card_index_dividers",
      "date",
      "calendar",
      "spiral_note_pad",
      "spiral_calendar_pad",
      "card_index",
      "chart_with_upwards_trend",
      "chart_with_downwards_trend",
      "bar_chart",
      "clipboard",
      "pushpin",
      "round_pushpin",
      "paperclip",
      "linked_paperclips",
      "straight_ruler",
      "triangular_ruler",
      "scissors",
      "card_file_box",
      "file_cabinet",
      "wastebasket",
      "lock",
      "unlock",
      "lock_with_ink_pen",
      "closed_lock_with_key",
      "key",
      "old_key",
      "hammer",
      "axe",
      "pick",
      "hammer_and_pick",
      "hammer_and_wrench",
      "dagger_knife",
      "crossed_swords",
      "gun",
      "bow_and_arrow",
      "shield",
      "wrench",
      "nut_and_bolt",
      "gear",
      "compression",
      "scales",
      "probing_cane",
      "link",
      "chains",
      "toolbox",
      "magnet",
      "alembic",
      "test_tube",
      "petri_dish",
      "dna",
      "microscope",
      "telescope",
      "satellite_antenna",
      "syringe",
      "drop_of_blood",
      "pill",
      "adhesive_bandage",
      "stethoscope",
      "door",
      "bed",
      "couch_and_lamp",
      "chair",
      "toilet",
      "shower",
      "bathtub",
      "razor",
      "lotion_bottle",
      "safety_pin",
      "broom",
      "basket",
      "roll_of_paper",
      "soap",
      "sponge",
      "fire_extinguisher",
      "shopping_trolley",
      "smoking",
      "coffin",
      "funeral_urn",
      "moyai"
    ]
  },
  {
    id: "symbols",
    name: "Symbols",
    emojis: [
      "atm",
      "put_litter_in_its_place",
      "potable_water",
      "wheelchair",
      "mens",
      "womens",
      "restroom",
      "baby_symbol",
      "wc",
      "passport_control",
      "customs",
      "baggage_claim",
      "left_luggage",
      "warning",
      "children_crossing",
      "no_entry",
      "no_entry_sign",
      "no_bicycles",
      "no_smoking",
      "do_not_litter",
      "non-potable_water",
      "no_pedestrians",
      "no_mobile_phones",
      "underage",
      "radioactive_sign",
      "biohazard_sign",
      "arrow_up",
      "arrow_upper_right",
      "arrow_right",
      "arrow_lower_right",
      "arrow_down",
      "arrow_lower_left",
      "arrow_left",
      "arrow_upper_left",
      "arrow_up_down",
      "left_right_arrow",
      "leftwards_arrow_with_hook",
      "arrow_right_hook",
      "arrow_heading_up",
      "arrow_heading_down",
      "arrows_clockwise",
      "arrows_counterclockwise",
      "back",
      "end",
      "on",
      "soon",
      "top",
      "place_of_worship",
      "atom_symbol",
      "om_symbol",
      "star_of_david",
      "wheel_of_dharma",
      "yin_yang",
      "latin_cross",
      "orthodox_cross",
      "star_and_crescent",
      "peace_symbol",
      "menorah_with_nine_branches",
      "six_pointed_star",
      "aries",
      "taurus",
      "gemini",
      "cancer",
      "leo",
      "virgo",
      "libra",
      "scorpius",
      "sagittarius",
      "capricorn",
      "aquarius",
      "pisces",
      "ophiuchus",
      "twisted_rightwards_arrows",
      "repeat",
      "repeat_one",
      "arrow_forward",
      "fast_forward",
      "black_right_pointing_double_triangle_with_vertical_bar",
      "black_right_pointing_triangle_with_double_vertical_bar",
      "arrow_backward",
      "rewind",
      "black_left_pointing_double_triangle_with_vertical_bar",
      "arrow_up_small",
      "arrow_double_up",
      "arrow_down_small",
      "arrow_double_down",
      "double_vertical_bar",
      "black_square_for_stop",
      "black_circle_for_record",
      "eject",
      "cinema",
      "low_brightness",
      "high_brightness",
      "signal_strength",
      "vibration_mode",
      "mobile_phone_off",
      "female_sign",
      "male_sign",
      "medical_symbol",
      "infinity",
      "recycle",
      "fleur_de_lis",
      "trident",
      "name_badge",
      "beginner",
      "o",
      "white_check_mark",
      "ballot_box_with_check",
      "heavy_check_mark",
      "heavy_multiplication_x",
      "x",
      "negative_squared_cross_mark",
      "heavy_plus_sign",
      "heavy_minus_sign",
      "heavy_division_sign",
      "curly_loop",
      "loop",
      "part_alternation_mark",
      "eight_spoked_asterisk",
      "eight_pointed_black_star",
      "sparkle",
      "bangbang",
      "interrobang",
      "question",
      "grey_question",
      "grey_exclamation",
      "exclamation",
      "wavy_dash",
      "copyright",
      "registered",
      "tm",
      "hash",
      "keycap_star",
      "zero",
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
      "keycap_ten",
      "capital_abcd",
      "abcd",
      "1234",
      "symbols",
      "abc",
      "a",
      "ab",
      "b",
      "cl",
      "cool",
      "free",
      "information_source",
      "id",
      "m",
      "new",
      "ng",
      "o2",
      "ok",
      "parking",
      "sos",
      "up",
      "vs",
      "koko",
      "sa",
      "u6708",
      "u6709",
      "u6307",
      "ideograph_advantage",
      "u5272",
      "u7121",
      "u7981",
      "accept",
      "u7533",
      "u5408",
      "u7a7a",
      "congratulations",
      "secret",
      "u55b6",
      "u6e80",
      "red_circle",
      "large_orange_circle",
      "large_yellow_circle",
      "large_green_circle",
      "large_blue_circle",
      "large_purple_circle",
      "large_brown_circle",
      "black_circle",
      "white_circle",
      "large_red_square",
      "large_orange_square",
      "large_yellow_square",
      "large_green_square",
      "large_blue_square",
      "large_purple_square",
      "large_brown_square",
      "black_large_square",
      "white_large_square",
      "black_medium_square",
      "white_medium_square",
      "black_medium_small_square",
      "white_medium_small_square",
      "black_small_square",
      "white_small_square",
      "large_orange_diamond",
      "large_blue_diamond",
      "small_orange_diamond",
      "small_blue_diamond",
      "small_red_triangle",
      "small_red_triangle_down",
      "diamond_shape_with_a_dot_inside",
      "radio_button",
      "white_square_button",
      "black_square_button"
    ]
  },
  {
    id: "flags",
    name: "Flags",
    emojis: [
      "checkered_flag",
      "cn",
      "crossed_flags",
      "de",
      "es",
      "flag-ac",
      "flag-ad",
      "flag-ae",
      "flag-af",
      "flag-ag",
      "flag-ai",
      "flag-al",
      "flag-am",
      "flag-ao",
      "flag-aq",
      "flag-ar",
      "flag-as",
      "flag-at",
      "flag-au",
      "flag-aw",
      "flag-ax",
      "flag-az",
      "flag-ba",
      "flag-bb",
      "flag-bd",
      "flag-be",
      "flag-bf",
      "flag-bg",
      "flag-bh",
      "flag-bi",
      "flag-bj",
      "flag-bl",
      "flag-bm",
      "flag-bn",
      "flag-bo",
      "flag-bq",
      "flag-br",
      "flag-bs",
      "flag-bt",
      "flag-bv",
      "flag-bw",
      "flag-by",
      "flag-bz",
      "flag-ca",
      "flag-cc",
      "flag-cd",
      "flag-cf",
      "flag-cg",
      "flag-ch",
      "flag-ci",
      "flag-ck",
      "flag-cl",
      "flag-cm",
      "flag-co",
      "flag-cp",
      "flag-cr",
      "flag-cu",
      "flag-cv",
      "flag-cw",
      "flag-cx",
      "flag-cy",
      "flag-cz",
      "flag-dg",
      "flag-dj",
      "flag-dk",
      "flag-dm",
      "flag-do",
      "flag-dz",
      "flag-ea",
      "flag-ec",
      "flag-ee",
      "flag-eg",
      "flag-eh",
      "flag-england",
      "flag-er",
      "flag-et",
      "flag-eu",
      "flag-fi",
      "flag-fj",
      "flag-fk",
      "flag-fm",
      "flag-fo",
      "flag-ga",
      "flag-gd",
      "flag-ge",
      "flag-gf",
      "flag-gg",
      "flag-gh",
      "flag-gi",
      "flag-gl",
      "flag-gm",
      "flag-gn",
      "flag-gp",
      "flag-gq",
      "flag-gr",
      "flag-gs",
      "flag-gt",
      "flag-gu",
      "flag-gw",
      "flag-gy",
      "flag-hk",
      "flag-hm",
      "flag-hn",
      "flag-hr",
      "flag-ht",
      "flag-hu",
      "flag-ic",
      "flag-id",
      "flag-ie",
      "flag-il",
      "flag-im",
      "flag-in",
      "flag-io",
      "flag-iq",
      "flag-ir",
      "flag-is",
      "flag-je",
      "flag-jm",
      "flag-jo",
      "flag-ke",
      "flag-kg",
      "flag-kh",
      "flag-ki",
      "flag-km",
      "flag-kn",
      "flag-kp",
      "flag-kw",
      "flag-ky",
      "flag-kz",
      "flag-la",
      "flag-lb",
      "flag-lc",
      "flag-li",
      "flag-lk",
      "flag-lr",
      "flag-ls",
      "flag-lt",
      "flag-lu",
      "flag-lv",
      "flag-ly",
      "flag-ma",
      "flag-mc",
      "flag-md",
      "flag-me",
      "flag-mf",
      "flag-mg",
      "flag-mh",
      "flag-mk",
      "flag-ml",
      "flag-mm",
      "flag-mn",
      "flag-mo",
      "flag-mp",
      "flag-mq",
      "flag-mr",
      "flag-ms",
      "flag-mt",
      "flag-mu",
      "flag-mv",
      "flag-mw",
      "flag-mx",
      "flag-my",
      "flag-mz",
      "flag-na",
      "flag-nc",
      "flag-ne",
      "flag-nf",
      "flag-ng",
      "flag-ni",
      "flag-nl",
      "flag-no",
      "flag-np",
      "flag-nr",
      "flag-nu",
      "flag-nz",
      "flag-om",
      "flag-pa",
      "flag-pe",
      "flag-pf",
      "flag-pg",
      "flag-ph",
      "flag-pk",
      "flag-pl",
      "flag-pm",
      "flag-pn",
      "flag-pr",
      "flag-ps",
      "flag-pt",
      "flag-pw",
      "flag-py",
      "flag-qa",
      "flag-re",
      "flag-ro",
      "flag-rs",
      "flag-rw",
      "flag-sa",
      "flag-sb",
      "flag-sc",
      "flag-scotland",
      "flag-sd",
      "flag-se",
      "flag-sg",
      "flag-sh",
      "flag-si",
      "flag-sj",
      "flag-sk",
      "flag-sl",
      "flag-sm",
      "flag-sn",
      "flag-so",
      "flag-sr",
      "flag-ss",
      "flag-st",
      "flag-sv",
      "flag-sx",
      "flag-sy",
      "flag-sz",
      "flag-ta",
      "flag-tc",
      "flag-td",
      "flag-tf",
      "flag-tg",
      "flag-th",
      "flag-tj",
      "flag-tk",
      "flag-tl",
      "flag-tm",
      "flag-tn",
      "flag-to",
      "flag-tr",
      "flag-tt",
      "flag-tv",
      "flag-tw",
      "flag-tz",
      "flag-ua",
      "flag-ug",
      "flag-um",
      "flag-uy",
      "flag-uz",
      "flag-va",
      "flag-vc",
      "flag-ve",
      "flag-vg",
      "flag-vi",
      "flag-vn",
      "flag-vu",
      "flag-wales",
      "flag-wf",
      "flag-ws",
      "flag-xk",
      "flag-ye",
      "flag-yt",
      "flag-za",
      "flag-zm",
      "flag-zw",
      "fr",
      "gb",
      "it",
      "jp",
      "kr",
      "pirate_flag",
      "rainbow-flag",
      "ru",
      "triangular_flag_on_post",
      "us",
      "waving_black_flag",
      "waving_white_flag"
    ]
  }
], BH = {
  100: {
    a: "Hundred Points Symbol",
    b: "1F4AF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "score",
      "perfect",
      "numbers",
      "century",
      "exam",
      "quiz",
      "test",
      "pass",
      "hundred"
    ],
    k: [
      26,
      5
    ],
    o: 2
  },
  1234: {
    a: "Input Symbol for Numbers",
    b: "1F522",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "numbers",
      "blue-square"
    ],
    k: [
      28,
      5
    ],
    o: 2
  },
  grinning: {
    a: "Grinning Face",
    b: "1F600",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "smile",
      "happy",
      "joy",
      ":D",
      "grin"
    ],
    k: [
      30,
      35
    ],
    m: ":D",
    o: 2
  },
  monkey_face: {
    a: "Monkey Face",
    b: "1F435",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "circus"
    ],
    k: [
      12,
      25
    ],
    l: [
      ":o)"
    ],
    o: 2
  },
  grapes: {
    a: "Grapes",
    b: "1F347",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "food",
      "wine"
    ],
    k: [
      6,
      31
    ],
    o: 2
  },
  eyeglasses: {
    a: "Eyeglasses",
    b: "1F453",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fashion",
      "accessories",
      "eyesight",
      "nerdy",
      "dork",
      "geek"
    ],
    k: [
      14,
      7
    ],
    o: 2
  },
  checkered_flag: {
    a: "Chequered Flag",
    b: "1F3C1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "contest",
      "finishline",
      "race",
      "gokart"
    ],
    k: [
      8,
      39
    ],
    o: 2
  },
  jack_o_lantern: {
    a: "Jack-O-Lantern",
    b: "1F383",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "halloween",
      "light",
      "pumpkin",
      "creepy",
      "fall"
    ],
    k: [
      7,
      34
    ],
    o: 2
  },
  wave: {
    skin_variations: {
      "1F3FB": {
        unified: "1F44B-1F3FB",
        non_qualified: null,
        image: "1f44b-1f3fb.png",
        sheet_x: 13,
        sheet_y: 27,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F44B-1F3FC",
        non_qualified: null,
        image: "1f44b-1f3fc.png",
        sheet_x: 13,
        sheet_y: 28,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F44B-1F3FD",
        non_qualified: null,
        image: "1f44b-1f3fd.png",
        sheet_x: 13,
        sheet_y: 29,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F44B-1F3FE",
        non_qualified: null,
        image: "1f44b-1f3fe.png",
        sheet_x: 13,
        sheet_y: 30,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F44B-1F3FF",
        non_qualified: null,
        image: "1f44b-1f3ff.png",
        sheet_x: 13,
        sheet_y: 31,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Waving Hand Sign",
    b: "1F44B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hands",
      "gesture",
      "goodbye",
      "solong",
      "farewell",
      "hello",
      "hi",
      "palm"
    ],
    k: [
      13,
      26
    ],
    o: 2
  },
  earth_africa: {
    a: "Earth Globe Europe-Africa",
    b: "1F30D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "globe",
      "world",
      "international"
    ],
    k: [
      5,
      32
    ],
    o: 2
  },
  atm: {
    a: "Automated Teller Machine",
    b: "1F3E7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "money",
      "sales",
      "cash",
      "blue-square",
      "payment",
      "bank"
    ],
    k: [
      11,
      1
    ],
    o: 2
  },
  melon: {
    a: "Melon",
    b: "1F348",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "nature",
      "food"
    ],
    k: [
      6,
      32
    ],
    o: 2
  },
  triangular_flag_on_post: {
    a: "Triangular Flag on Post",
    b: "1F6A9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "mark",
      "milestone",
      "place"
    ],
    k: [
      35,
      0
    ],
    o: 2
  },
  put_litter_in_its_place: {
    a: "Put Litter in Its Place Symbol",
    b: "1F6AE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "sign",
      "human",
      "info"
    ],
    k: [
      35,
      5
    ],
    o: 2
  },
  christmas_tree: {
    a: "Christmas Tree",
    b: "1F384",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "festival",
      "vacation",
      "december",
      "xmas",
      "celebration"
    ],
    k: [
      7,
      35
    ],
    o: 2
  },
  monkey: {
    a: "Monkey",
    b: "1F412",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "banana",
      "circus"
    ],
    k: [
      11,
      46
    ],
    o: 2
  },
  earth_americas: {
    a: "Earth Globe Americas",
    b: "1F30E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "globe",
      "world",
      "USA",
      "international"
    ],
    k: [
      5,
      33
    ],
    o: 2
  },
  dark_sunglasses: {
    a: "Dark Sunglasses",
    b: "1F576-FE0F",
    c: "1F576",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "cool",
      "accessories"
    ],
    k: [
      29,
      33
    ],
    o: 2
  },
  raised_back_of_hand: {
    skin_variations: {
      "1F3FB": {
        unified: "1F91A-1F3FB",
        non_qualified: null,
        image: "1f91a-1f3fb.png",
        sheet_x: 37,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F91A-1F3FC",
        non_qualified: null,
        image: "1f91a-1f3fc.png",
        sheet_x: 37,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F91A-1F3FD",
        non_qualified: null,
        image: "1f91a-1f3fd.png",
        sheet_x: 37,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F91A-1F3FE",
        non_qualified: null,
        image: "1f91a-1f3fe.png",
        sheet_x: 37,
        sheet_y: 47,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F91A-1F3FF",
        non_qualified: null,
        image: "1f91a-1f3ff.png",
        sheet_x: 37,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Raised Back of Hand",
    b: "1F91A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fingers",
      "raised",
      "backhand"
    ],
    k: [
      37,
      43
    ],
    o: 4
  },
  smiley: {
    a: "Smiling Face with Open Mouth",
    b: "1F603",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "happy",
      "joy",
      "haha",
      ":D",
      ":)",
      "smile",
      "funny"
    ],
    k: [
      30,
      38
    ],
    l: [
      "=)",
      "=-)"
    ],
    m: ":)",
    o: 2
  },
  earth_asia: {
    a: "Earth Globe Asia-Australia",
    b: "1F30F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "globe",
      "world",
      "east",
      "international"
    ],
    k: [
      5,
      34
    ],
    o: 2
  },
  crossed_flags: {
    a: "Crossed Flags",
    b: "1F38C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "japanese",
      "nation",
      "country",
      "border"
    ],
    k: [
      7,
      48
    ],
    o: 2
  },
  watermelon: {
    a: "Watermelon",
    b: "1F349",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "food",
      "picnic",
      "summer"
    ],
    k: [
      6,
      33
    ],
    o: 2
  },
  goggles: {
    a: "Goggles",
    b: "1F97D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      15
    ],
    o: 11
  },
  raised_hand_with_fingers_splayed: {
    skin_variations: {
      "1F3FB": {
        unified: "1F590-1F3FB",
        non_qualified: null,
        image: "1f590-1f3fb.png",
        sheet_x: 29,
        sheet_y: 49,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F590-1F3FC",
        non_qualified: null,
        image: "1f590-1f3fc.png",
        sheet_x: 29,
        sheet_y: 50,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F590-1F3FD",
        non_qualified: null,
        image: "1f590-1f3fd.png",
        sheet_x: 29,
        sheet_y: 51,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F590-1F3FE",
        non_qualified: null,
        image: "1f590-1f3fe.png",
        sheet_x: 29,
        sheet_y: 52,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F590-1F3FF",
        non_qualified: null,
        image: "1f590-1f3ff.png",
        sheet_x: 29,
        sheet_y: 53,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Raised Hand with Fingers Splayed",
    b: "1F590-FE0F",
    c: "1F590",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hand",
      "fingers",
      "palm"
    ],
    k: [
      29,
      48
    ],
    o: 2
  },
  smile: {
    a: "Smiling Face with Open Mouth and Smiling Eyes",
    b: "1F604",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "happy",
      "joy",
      "funny",
      "haha",
      "laugh",
      "like",
      ":D",
      ":)"
    ],
    k: [
      30,
      39
    ],
    l: [
      "C:",
      "c:",
      ":D",
      ":-D"
    ],
    m: ":)",
    o: 2
  },
  potable_water: {
    a: "Potable Water Symbol",
    b: "1F6B0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "liquid",
      "restroom",
      "cleaning",
      "faucet"
    ],
    k: [
      35,
      7
    ],
    o: 2
  },
  fireworks: {
    a: "Fireworks",
    b: "1F386",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "festival",
      "carnival",
      "congratulations"
    ],
    k: [
      7,
      42
    ],
    o: 2
  },
  gorilla: {
    a: "Gorilla",
    b: "1F98D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "circus"
    ],
    k: [
      42,
      31
    ],
    o: 4
  },
  lab_coat: {
    a: "Lab Coat",
    b: "1F97C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      14
    ],
    o: 11
  },
  tangerine: {
    a: "Tangerine",
    b: "1F34A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "fruit",
      "nature",
      "orange"
    ],
    k: [
      6,
      34
    ],
    o: 2
  },
  wheelchair: {
    a: "Wheelchair Symbol",
    b: "267F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "disabled",
      "a11y",
      "accessibility"
    ],
    k: [
      53,
      40
    ],
    o: 2
  },
  waving_black_flag: {
    a: "Waving Black Flag",
    b: "1F3F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      11,
      17
    ],
    o: 2
  },
  orangutan: {
    a: "Orangutan",
    b: "1F9A7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      55
    ],
    o: 12
  },
  sparkler: {
    a: "Firework Sparkler",
    b: "1F387",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stars",
      "night",
      "shine"
    ],
    k: [
      7,
      43
    ],
    o: 2
  },
  globe_with_meridians: {
    a: "Globe with Meridians",
    b: "1F310",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "earth",
      "international",
      "world",
      "internet",
      "interweb",
      "i18n"
    ],
    k: [
      5,
      35
    ],
    o: 2
  },
  grin: {
    a: "Grinning Face with Smiling Eyes",
    b: "1F601",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "happy",
      "smile",
      "joy",
      "kawaii"
    ],
    k: [
      30,
      36
    ],
    o: 2
  },
  hand: {
    skin_variations: {
      "1F3FB": {
        unified: "270B-1F3FB",
        non_qualified: null,
        image: "270b-1f3fb.png",
        sheet_x: 54,
        sheet_y: 50,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "270B-1F3FC",
        non_qualified: null,
        image: "270b-1f3fc.png",
        sheet_x: 54,
        sheet_y: 51,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "270B-1F3FD",
        non_qualified: null,
        image: "270b-1f3fd.png",
        sheet_x: 54,
        sheet_y: 52,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "270B-1F3FE",
        non_qualified: null,
        image: "270b-1f3fe.png",
        sheet_x: 54,
        sheet_y: 53,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "270B-1F3FF",
        non_qualified: null,
        image: "270b-1f3ff.png",
        sheet_x: 54,
        sheet_y: 54,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Raised Hand",
    b: "270B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      54,
      49
    ],
    n: [
      "raised_hand"
    ],
    o: 2
  },
  firecracker: {
    a: "Firecracker",
    b: "1F9E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      27
    ],
    o: 11
  },
  lemon: {
    a: "Lemon",
    b: "1F34B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "nature"
    ],
    k: [
      6,
      35
    ],
    o: 2
  },
  dog: {
    a: "Dog Face",
    b: "1F436",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "friend",
      "nature",
      "woof",
      "puppy",
      "pet",
      "faithful"
    ],
    k: [
      12,
      26
    ],
    o: 2
  },
  mens: {
    a: "Mens Symbol",
    b: "1F6B9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "toilet",
      "restroom",
      "wc",
      "blue-square",
      "gender",
      "male"
    ],
    k: [
      36,
      10
    ],
    o: 2
  },
  "spock-hand": {
    skin_variations: {
      "1F3FB": {
        unified: "1F596-1F3FB",
        non_qualified: null,
        image: "1f596-1f3fb.png",
        sheet_x: 30,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F596-1F3FC",
        non_qualified: null,
        image: "1f596-1f3fc.png",
        sheet_x: 30,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F596-1F3FD",
        non_qualified: null,
        image: "1f596-1f3fd.png",
        sheet_x: 30,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F596-1F3FE",
        non_qualified: null,
        image: "1f596-1f3fe.png",
        sheet_x: 30,
        sheet_y: 7,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F596-1F3FF",
        non_qualified: null,
        image: "1f596-1f3ff.png",
        sheet_x: 30,
        sheet_y: 8,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Raised Hand with Part Between Middle and Ring Fingers",
    b: "1F596",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      3
    ],
    o: 2
  },
  world_map: {
    a: "World Map",
    b: "1F5FA-FE0F",
    c: "1F5FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "location",
      "direction"
    ],
    k: [
      30,
      29
    ],
    o: 2
  },
  laughing: {
    a: "Smiling Face with Open Mouth and Tightly-Closed Eyes",
    b: "1F606",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "happy",
      "joy",
      "lol",
      "satisfied",
      "haha",
      "face",
      "glad",
      "XD",
      "laugh"
    ],
    k: [
      30,
      41
    ],
    l: [
      ":>",
      ":->"
    ],
    n: [
      "satisfied"
    ],
    o: 2
  },
  waving_white_flag: {
    a: "Waving White Flag",
    b: "1F3F3-FE0F",
    c: "1F3F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      11,
      12
    ],
    o: 2
  },
  safety_vest: {
    a: "Safety Vest",
    b: "1F9BA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      54
    ],
    o: 12
  },
  sweat_smile: {
    a: "Smiling Face with Open Mouth and Cold Sweat",
    b: "1F605",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "hot",
      "happy",
      "laugh",
      "sweat",
      "smile",
      "relief"
    ],
    k: [
      30,
      40
    ],
    o: 2
  },
  sparkles: {
    a: "Sparkles",
    b: "2728",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stars",
      "shine",
      "shiny",
      "cool",
      "awesome",
      "good",
      "magic"
    ],
    k: [
      55,
      16
    ],
    o: 2
  },
  banana: {
    a: "Banana",
    b: "1F34C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "food",
      "monkey"
    ],
    k: [
      6,
      36
    ],
    o: 2
  },
  "rainbow-flag": {
    a: "Rainbow Flag",
    b: "1F3F3-FE0F-200D-1F308",
    c: "1F3F3-200D-1F308",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      11,
      11
    ],
    o: 4
  },
  ok_hand: {
    skin_variations: {
      "1F3FB": {
        unified: "1F44C-1F3FB",
        non_qualified: null,
        image: "1f44c-1f3fb.png",
        sheet_x: 13,
        sheet_y: 33,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F44C-1F3FC",
        non_qualified: null,
        image: "1f44c-1f3fc.png",
        sheet_x: 13,
        sheet_y: 34,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F44C-1F3FD",
        non_qualified: null,
        image: "1f44c-1f3fd.png",
        sheet_x: 13,
        sheet_y: 35,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F44C-1F3FE",
        non_qualified: null,
        image: "1f44c-1f3fe.png",
        sheet_x: 13,
        sheet_y: 36,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F44C-1F3FF",
        non_qualified: null,
        image: "1f44c-1f3ff.png",
        sheet_x: 13,
        sheet_y: 37,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Ok Hand Sign",
    b: "1F44C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fingers",
      "limbs",
      "perfect",
      "ok",
      "okay"
    ],
    k: [
      13,
      32
    ],
    o: 2
  },
  japan: {
    a: "Silhouette of Japan",
    b: "1F5FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nation",
      "country",
      "japanese",
      "asia"
    ],
    k: [
      30,
      33
    ],
    o: 2
  },
  dog2: {
    a: "Dog",
    b: "1F415",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "friend",
      "doge",
      "pet",
      "faithful"
    ],
    k: [
      11,
      50
    ],
    o: 2
  },
  womens: {
    a: "Womens Symbol",
    b: "1F6BA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "purple-square",
      "woman",
      "female",
      "toilet",
      "loo",
      "restroom",
      "gender"
    ],
    k: [
      36,
      11
    ],
    o: 2
  },
  necktie: {
    a: "Necktie",
    b: "1F454",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shirt",
      "suitup",
      "formal",
      "fashion",
      "cloth",
      "business"
    ],
    k: [
      14,
      8
    ],
    o: 2
  },
  pirate_flag: {
    a: "Pirate Flag",
    b: "1F3F4-200D-2620-FE0F",
    c: "1F3F4-200D-2620",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      11,
      13
    ],
    o: 11
  },
  guide_dog: {
    a: "Guide Dog",
    b: "1F9AE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      2
    ],
    o: 12
  },
  restroom: {
    a: "Restroom",
    b: "1F6BB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "toilet",
      "refresh",
      "wc",
      "gender"
    ],
    k: [
      36,
      12
    ],
    o: 2
  },
  compass: {
    a: "Compass",
    b: "1F9ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      32
    ],
    o: 11
  },
  rolling_on_the_floor_laughing: {
    a: "Rolling on the Floor Laughing",
    b: "1F923",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      20
    ],
    o: 4
  },
  balloon: {
    a: "Balloon",
    b: "1F388",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "party",
      "celebration",
      "birthday",
      "circus"
    ],
    k: [
      7,
      44
    ],
    o: 2
  },
  pinching_hand: {
    skin_variations: {
      "1F3FB": {
        unified: "1F90F-1F3FB",
        non_qualified: null,
        image: "1f90f-1f3fb.png",
        sheet_x: 37,
        sheet_y: 18,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F90F-1F3FC",
        non_qualified: null,
        image: "1f90f-1f3fc.png",
        sheet_x: 37,
        sheet_y: 19,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F90F-1F3FD",
        non_qualified: null,
        image: "1f90f-1f3fd.png",
        sheet_x: 37,
        sheet_y: 20,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F90F-1F3FE",
        non_qualified: null,
        image: "1f90f-1f3fe.png",
        sheet_x: 37,
        sheet_y: 21,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F90F-1F3FF",
        non_qualified: null,
        image: "1f90f-1f3ff.png",
        sheet_x: 37,
        sheet_y: 22,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Pinching Hand",
    b: "1F90F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      17
    ],
    o: 12
  },
  pineapple: {
    a: "Pineapple",
    b: "1F34D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "nature",
      "food"
    ],
    k: [
      6,
      37
    ],
    o: 2
  },
  shirt: {
    a: "T-Shirt",
    b: "1F455",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      14,
      9
    ],
    n: [
      "tshirt"
    ],
    o: 2
  },
  service_dog: {
    a: "Service Dog",
    b: "1F415-200D-1F9BA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      11,
      49
    ],
    o: 12
  },
  baby_symbol: {
    a: "Baby Symbol",
    b: "1F6BC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "orange-square",
      "child"
    ],
    k: [
      36,
      13
    ],
    o: 2
  },
  joy: {
    a: "Face with Tears of Joy",
    b: "1F602",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "cry",
      "tears",
      "weep",
      "happy",
      "happytears",
      "haha"
    ],
    k: [
      30,
      37
    ],
    o: 2
  },
  tada: {
    a: "Party Popper",
    b: "1F389",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "party",
      "congratulations",
      "birthday",
      "magic",
      "circus",
      "celebration"
    ],
    k: [
      7,
      45
    ],
    o: 2
  },
  mango: {
    a: "Mango",
    b: "1F96D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      3
    ],
    o: 11
  },
  v: {
    skin_variations: {
      "1F3FB": {
        unified: "270C-1F3FB",
        non_qualified: null,
        image: "270c-1f3fb.png",
        sheet_x: 54,
        sheet_y: 56,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "270C-1F3FC",
        non_qualified: null,
        image: "270c-1f3fc.png",
        sheet_x: 55,
        sheet_y: 0,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "270C-1F3FD",
        non_qualified: null,
        image: "270c-1f3fd.png",
        sheet_x: 55,
        sheet_y: 1,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "270C-1F3FE",
        non_qualified: null,
        image: "270c-1f3fe.png",
        sheet_x: 55,
        sheet_y: 2,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "270C-1F3FF",
        non_qualified: null,
        image: "270c-1f3ff.png",
        sheet_x: 55,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Victory Hand",
    b: "270C-FE0F",
    c: "270C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fingers",
      "ohyeah",
      "hand",
      "peace",
      "victory",
      "two"
    ],
    k: [
      54,
      55
    ],
    o: 2
  },
  snow_capped_mountain: {
    a: "Snow Capped Mountain",
    b: "1F3D4-FE0F",
    c: "1F3D4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      10,
      39
    ],
    o: 2
  },
  "flag-ac": {
    a: "Ascension Island Flag",
    b: "1F1E6-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      31
    ],
    o: 2
  },
  jeans: {
    a: "Jeans",
    b: "1F456",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fashion",
      "shopping"
    ],
    k: [
      14,
      10
    ],
    o: 2
  },
  poodle: {
    a: "Poodle",
    b: "1F429",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dog",
      "animal",
      "101",
      "nature",
      "pet"
    ],
    k: [
      12,
      13
    ],
    o: 2
  },
  crossed_fingers: {
    skin_variations: {
      "1F3FB": {
        unified: "1F91E-1F3FB",
        non_qualified: null,
        image: "1f91e-1f3fb.png",
        sheet_x: 38,
        sheet_y: 6,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F91E-1F3FC",
        non_qualified: null,
        image: "1f91e-1f3fc.png",
        sheet_x: 38,
        sheet_y: 7,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F91E-1F3FD",
        non_qualified: null,
        image: "1f91e-1f3fd.png",
        sheet_x: 38,
        sheet_y: 8,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F91E-1F3FE",
        non_qualified: null,
        image: "1f91e-1f3fe.png",
        sheet_x: 38,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F91E-1F3FF",
        non_qualified: null,
        image: "1f91e-1f3ff.png",
        sheet_x: 38,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Hand with Index and Middle Fingers Crossed",
    b: "1F91E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "good",
      "lucky"
    ],
    k: [
      38,
      5
    ],
    n: [
      "hand_with_index_and_middle_fingers_crossed"
    ],
    o: 4
  },
  "flag-ad": {
    a: "Andorra Flag",
    b: "1F1E6-1F1E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      32
    ],
    o: 2
  },
  slightly_smiling_face: {
    a: "Slightly Smiling Face",
    b: "1F642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "smile"
    ],
    k: [
      31,
      44
    ],
    l: [
      ":)",
      "(:",
      ":-)"
    ],
    o: 2
  },
  apple: {
    a: "Red Apple",
    b: "1F34E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "mac",
      "school"
    ],
    k: [
      6,
      38
    ],
    o: 2
  },
  wc: {
    a: "Water Closet",
    b: "1F6BE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "toilet",
      "restroom",
      "blue-square"
    ],
    k: [
      36,
      15
    ],
    o: 2
  },
  scarf: {
    a: "Scarf",
    b: "1F9E3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      22
    ],
    o: 5
  },
  mountain: {
    a: "Mountain",
    b: "26F0-FE0F",
    c: "26F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "nature",
      "environment"
    ],
    k: [
      54,
      11
    ],
    o: 2
  },
  confetti_ball: {
    a: "Confetti Ball",
    b: "1F38A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "festival",
      "party",
      "birthday",
      "circus"
    ],
    k: [
      7,
      46
    ],
    o: 2
  },
  i_love_you_hand_sign: {
    skin_variations: {
      "1F3FB": {
        unified: "1F91F-1F3FB",
        non_qualified: null,
        image: "1f91f-1f3fb.png",
        sheet_x: 38,
        sheet_y: 12,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F91F-1F3FC",
        non_qualified: null,
        image: "1f91f-1f3fc.png",
        sheet_x: 38,
        sheet_y: 13,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F91F-1F3FD",
        non_qualified: null,
        image: "1f91f-1f3fd.png",
        sheet_x: 38,
        sheet_y: 14,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F91F-1F3FE",
        non_qualified: null,
        image: "1f91f-1f3fe.png",
        sheet_x: 38,
        sheet_y: 15,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F91F-1F3FF",
        non_qualified: null,
        image: "1f91f-1f3ff.png",
        sheet_x: 38,
        sheet_y: 16,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "I Love You Hand Sign",
    b: "1F91F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      11
    ],
    o: 5
  },
  wolf: {
    a: "Wolf Face",
    b: "1F43A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "wild"
    ],
    k: [
      12,
      30
    ],
    o: 2
  },
  gloves: {
    a: "Gloves",
    b: "1F9E4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      23
    ],
    o: 5
  },
  "flag-ae": {
    a: "United Arab Emirates Flag",
    b: "1F1E6-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      33
    ],
    o: 2
  },
  upside_down_face: {
    a: "Upside-Down Face",
    b: "1F643",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "flipped",
      "silly",
      "smile"
    ],
    k: [
      31,
      45
    ],
    o: 2
  },
  green_apple: {
    a: "Green Apple",
    b: "1F34F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "nature"
    ],
    k: [
      6,
      39
    ],
    o: 2
  },
  passport_control: {
    a: "Passport Control",
    b: "1F6C2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "custom",
      "blue-square"
    ],
    k: [
      36,
      24
    ],
    o: 2
  },
  volcano: {
    a: "Volcano",
    b: "1F30B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "nature",
      "disaster"
    ],
    k: [
      5,
      30
    ],
    o: 2
  },
  tanabata_tree: {
    a: "Tanabata Tree",
    b: "1F38B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "plant",
      "nature",
      "branch",
      "summer"
    ],
    k: [
      7,
      47
    ],
    o: 2
  },
  customs: {
    a: "Customs",
    b: "1F6C3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "passport",
      "border",
      "blue-square"
    ],
    k: [
      36,
      25
    ],
    o: 2
  },
  coat: {
    a: "Coat",
    b: "1F9E5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      24
    ],
    o: 5
  },
  wink: {
    a: "Winking Face",
    b: "1F609",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "happy",
      "mischievous",
      "secret",
      ";)",
      "smile",
      "eye"
    ],
    k: [
      30,
      44
    ],
    l: [
      ";)",
      ";-)"
    ],
    m: ";)",
    o: 2
  },
  bamboo: {
    a: "Pine Decoration",
    b: "1F38D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "plant",
      "nature",
      "vegetable",
      "panda",
      "pine_decoration"
    ],
    k: [
      7,
      49
    ],
    o: 2
  },
  "flag-af": {
    a: "Afghanistan Flag",
    b: "1F1E6-1F1EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      34
    ],
    o: 2
  },
  fox_face: {
    a: "Fox Face",
    b: "1F98A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "face"
    ],
    k: [
      42,
      28
    ],
    o: 4
  },
  pear: {
    a: "Pear",
    b: "1F350",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "nature",
      "food"
    ],
    k: [
      6,
      40
    ],
    o: 2
  },
  mount_fuji: {
    a: "Mount Fuji",
    b: "1F5FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "mountain",
      "nature",
      "japanese"
    ],
    k: [
      30,
      30
    ],
    o: 2
  },
  the_horns: {
    skin_variations: {
      "1F3FB": {
        unified: "1F918-1F3FB",
        non_qualified: null,
        image: "1f918-1f3fb.png",
        sheet_x: 37,
        sheet_y: 32,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F918-1F3FC",
        non_qualified: null,
        image: "1f918-1f3fc.png",
        sheet_x: 37,
        sheet_y: 33,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F918-1F3FD",
        non_qualified: null,
        image: "1f918-1f3fd.png",
        sheet_x: 37,
        sheet_y: 34,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F918-1F3FE",
        non_qualified: null,
        image: "1f918-1f3fe.png",
        sheet_x: 37,
        sheet_y: 35,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F918-1F3FF",
        non_qualified: null,
        image: "1f918-1f3ff.png",
        sheet_x: 37,
        sheet_y: 36,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Sign of the Horns",
    b: "1F918",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      31
    ],
    n: [
      "sign_of_the_horns"
    ],
    o: 2
  },
  call_me_hand: {
    skin_variations: {
      "1F3FB": {
        unified: "1F919-1F3FB",
        non_qualified: null,
        image: "1f919-1f3fb.png",
        sheet_x: 37,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F919-1F3FC",
        non_qualified: null,
        image: "1f919-1f3fc.png",
        sheet_x: 37,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F919-1F3FD",
        non_qualified: null,
        image: "1f919-1f3fd.png",
        sheet_x: 37,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F919-1F3FE",
        non_qualified: null,
        image: "1f919-1f3fe.png",
        sheet_x: 37,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F919-1F3FF",
        non_qualified: null,
        image: "1f919-1f3ff.png",
        sheet_x: 37,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Call Me Hand",
    b: "1F919",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hands",
      "gesture"
    ],
    k: [
      37,
      37
    ],
    o: 4
  },
  "flag-ag": {
    a: "Antigua & Barbuda Flag",
    b: "1F1E6-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      35
    ],
    o: 2
  },
  raccoon: {
    a: "Raccoon",
    b: "1F99D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      47
    ],
    o: 11
  },
  dolls: {
    a: "Japanese Dolls",
    b: "1F38E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "japanese",
      "toy",
      "kimono"
    ],
    k: [
      7,
      50
    ],
    o: 2
  },
  blush: {
    a: "Smiling Face with Smiling Eyes",
    b: "1F60A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "smile",
      "happy",
      "flushed",
      "crush",
      "embarrassed",
      "shy",
      "joy"
    ],
    k: [
      30,
      45
    ],
    m: ":)",
    o: 2
  },
  peach: {
    a: "Peach",
    b: "1F351",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "nature",
      "food"
    ],
    k: [
      6,
      41
    ],
    o: 2
  },
  baggage_claim: {
    a: "Baggage Claim",
    b: "1F6C4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "airport",
      "transport"
    ],
    k: [
      36,
      26
    ],
    o: 2
  },
  socks: {
    a: "Socks",
    b: "1F9E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      25
    ],
    o: 5
  },
  camping: {
    a: "Camping",
    b: "1F3D5-FE0F",
    c: "1F3D5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "outdoors",
      "tent"
    ],
    k: [
      10,
      40
    ],
    o: 2
  },
  dress: {
    a: "Dress",
    b: "1F457",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "clothes",
      "fashion",
      "shopping"
    ],
    k: [
      14,
      11
    ],
    o: 2
  },
  beach_with_umbrella: {
    a: "Beach with Umbrella",
    b: "1F3D6-FE0F",
    c: "1F3D6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      10,
      41
    ],
    o: 2
  },
  cherries: {
    a: "Cherries",
    b: "1F352",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "fruit"
    ],
    k: [
      6,
      42
    ],
    o: 2
  },
  cat: {
    a: "Cat Face",
    b: "1F431",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "meow",
      "nature",
      "pet",
      "kitten"
    ],
    k: [
      12,
      21
    ],
    o: 2
  },
  point_left: {
    skin_variations: {
      "1F3FB": {
        unified: "1F448-1F3FB",
        non_qualified: null,
        image: "1f448-1f3fb.png",
        sheet_x: 13,
        sheet_y: 9,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F448-1F3FC",
        non_qualified: null,
        image: "1f448-1f3fc.png",
        sheet_x: 13,
        sheet_y: 10,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F448-1F3FD",
        non_qualified: null,
        image: "1f448-1f3fd.png",
        sheet_x: 13,
        sheet_y: 11,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F448-1F3FE",
        non_qualified: null,
        image: "1f448-1f3fe.png",
        sheet_x: 13,
        sheet_y: 12,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F448-1F3FF",
        non_qualified: null,
        image: "1f448-1f3ff.png",
        sheet_x: 13,
        sheet_y: 13,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "White Left Pointing Backhand Index",
    b: "1F448",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "direction",
      "fingers",
      "hand",
      "left"
    ],
    k: [
      13,
      8
    ],
    o: 2
  },
  left_luggage: {
    a: "Left Luggage",
    b: "1F6C5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "travel"
    ],
    k: [
      36,
      27
    ],
    o: 2
  },
  "flag-ai": {
    a: "Anguilla Flag",
    b: "1F1E6-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      36
    ],
    o: 2
  },
  innocent: {
    a: "Smiling Face with Halo",
    b: "1F607",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "angel",
      "heaven",
      "halo"
    ],
    k: [
      30,
      42
    ],
    o: 2
  },
  flags: {
    a: "Carp Streamer",
    b: "1F38F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fish",
      "japanese",
      "koinobori",
      "carp",
      "banner"
    ],
    k: [
      7,
      51
    ],
    o: 2
  },
  warning: {
    a: "Warning Sign",
    b: "26A0-FE0F",
    c: "26A0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "exclamation",
      "wip",
      "alert",
      "error",
      "problem",
      "issue"
    ],
    k: [
      53,
      50
    ],
    o: 2
  },
  strawberry: {
    a: "Strawberry",
    b: "1F353",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "food",
      "nature"
    ],
    k: [
      6,
      43
    ],
    o: 2
  },
  point_right: {
    skin_variations: {
      "1F3FB": {
        unified: "1F449-1F3FB",
        non_qualified: null,
        image: "1f449-1f3fb.png",
        sheet_x: 13,
        sheet_y: 15,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F449-1F3FC",
        non_qualified: null,
        image: "1f449-1f3fc.png",
        sheet_x: 13,
        sheet_y: 16,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F449-1F3FD",
        non_qualified: null,
        image: "1f449-1f3fd.png",
        sheet_x: 13,
        sheet_y: 17,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F449-1F3FE",
        non_qualified: null,
        image: "1f449-1f3fe.png",
        sheet_x: 13,
        sheet_y: 18,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F449-1F3FF",
        non_qualified: null,
        image: "1f449-1f3ff.png",
        sheet_x: 13,
        sheet_y: 19,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "White Right Pointing Backhand Index",
    b: "1F449",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fingers",
      "hand",
      "direction",
      "right"
    ],
    k: [
      13,
      14
    ],
    o: 2
  },
  desert: {
    a: "Desert",
    b: "1F3DC-FE0F",
    c: "1F3DC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "warm",
      "saharah"
    ],
    k: [
      10,
      47
    ],
    o: 2
  },
  kimono: {
    a: "Kimono",
    b: "1F458",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dress",
      "fashion",
      "women",
      "female",
      "japanese"
    ],
    k: [
      14,
      12
    ],
    o: 2
  },
  "flag-al": {
    a: "Albania Flag",
    b: "1F1E6-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      37
    ],
    o: 2
  },
  wind_chime: {
    a: "Wind Chime",
    b: "1F390",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "ding",
      "spring",
      "bell"
    ],
    k: [
      7,
      52
    ],
    o: 2
  },
  smiling_face_with_3_hearts: {
    a: "Smiling Face with Smiling Eyes and Three Hearts",
    b: "1F970",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      6
    ],
    o: 11
  },
  cat2: {
    a: "Cat",
    b: "1F408",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "meow",
      "pet",
      "cats"
    ],
    k: [
      11,
      36
    ],
    o: 2
  },
  rice_scene: {
    a: "Moon Viewing Ceremony",
    b: "1F391",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "japan",
      "asia",
      "tsukimi"
    ],
    k: [
      7,
      53
    ],
    o: 2
  },
  heart_eyes: {
    a: "Smiling Face with Heart-Shaped Eyes",
    b: "1F60D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation",
      "crush",
      "heart"
    ],
    k: [
      30,
      48
    ],
    o: 2
  },
  sari: {
    a: "Sari",
    b: "1F97B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      13
    ],
    o: 12
  },
  "flag-am": {
    a: "Armenia Flag",
    b: "1F1E6-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      38
    ],
    o: 2
  },
  lion_face: {
    a: "Lion Face",
    b: "1F981",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      19
    ],
    o: 2
  },
  desert_island: {
    a: "Desert Island",
    b: "1F3DD-FE0F",
    c: "1F3DD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "tropical",
      "mojito"
    ],
    k: [
      10,
      48
    ],
    o: 2
  },
  point_up_2: {
    skin_variations: {
      "1F3FB": {
        unified: "1F446-1F3FB",
        non_qualified: null,
        image: "1f446-1f3fb.png",
        sheet_x: 12,
        sheet_y: 54,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F446-1F3FC",
        non_qualified: null,
        image: "1f446-1f3fc.png",
        sheet_x: 12,
        sheet_y: 55,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F446-1F3FD",
        non_qualified: null,
        image: "1f446-1f3fd.png",
        sheet_x: 12,
        sheet_y: 56,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F446-1F3FE",
        non_qualified: null,
        image: "1f446-1f3fe.png",
        sheet_x: 13,
        sheet_y: 0,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F446-1F3FF",
        non_qualified: null,
        image: "1f446-1f3ff.png",
        sheet_x: 13,
        sheet_y: 1,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "White Up Pointing Backhand Index",
    b: "1F446",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fingers",
      "hand",
      "direction",
      "up"
    ],
    k: [
      12,
      53
    ],
    o: 2
  },
  kiwifruit: {
    a: "Kiwifruit",
    b: "1F95D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      44
    ],
    o: 4
  },
  children_crossing: {
    a: "Children Crossing",
    b: "1F6B8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "school",
      "warning",
      "danger",
      "sign",
      "driving",
      "yellow-diamond"
    ],
    k: [
      36,
      9
    ],
    o: 2
  },
  national_park: {
    a: "National Park",
    b: "1F3DE-FE0F",
    c: "1F3DE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "environment",
      "nature"
    ],
    k: [
      10,
      49
    ],
    o: 2
  },
  no_entry: {
    a: "No Entry",
    b: "26D4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "limit",
      "security",
      "privacy",
      "bad",
      "denied",
      "stop",
      "circle"
    ],
    k: [
      54,
      8
    ],
    o: 2
  },
  "one-piece_swimsuit": {
    a: "One-Piece Swimsuit",
    b: "1FA71",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      52
    ],
    o: 12
  },
  tiger: {
    a: "Tiger Face",
    b: "1F42F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cat",
      "danger",
      "wild",
      "nature",
      "roar"
    ],
    k: [
      12,
      19
    ],
    o: 2
  },
  red_envelope: {
    a: "Red Gift Envelope",
    b: "1F9E7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      26
    ],
    o: 11
  },
  "star-struck": {
    a: "Grinning Face with Star Eyes",
    b: "1F929",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      43
    ],
    n: [
      "grinning_face_with_star_eyes"
    ],
    o: 5
  },
  middle_finger: {
    skin_variations: {
      "1F3FB": {
        unified: "1F595-1F3FB",
        non_qualified: null,
        image: "1f595-1f3fb.png",
        sheet_x: 29,
        sheet_y: 55,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F595-1F3FC",
        non_qualified: null,
        image: "1f595-1f3fc.png",
        sheet_x: 29,
        sheet_y: 56,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F595-1F3FD",
        non_qualified: null,
        image: "1f595-1f3fd.png",
        sheet_x: 30,
        sheet_y: 0,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F595-1F3FE",
        non_qualified: null,
        image: "1f595-1f3fe.png",
        sheet_x: 30,
        sheet_y: 1,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F595-1F3FF",
        non_qualified: null,
        image: "1f595-1f3ff.png",
        sheet_x: 30,
        sheet_y: 2,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Reversed Hand with Middle Finger Extended",
    b: "1F595",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      29,
      54
    ],
    n: [
      "reversed_hand_with_middle_finger_extended"
    ],
    o: 2
  },
  "flag-ao": {
    a: "Angola Flag",
    b: "1F1E6-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      39
    ],
    o: 2
  },
  tomato: {
    a: "Tomato",
    b: "1F345",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "vegetable",
      "nature",
      "food"
    ],
    k: [
      6,
      29
    ],
    o: 2
  },
  coconut: {
    a: "Coconut",
    b: "1F965",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      52
    ],
    o: 5
  },
  ribbon: {
    a: "Ribbon",
    b: "1F380",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "decoration",
      "pink",
      "girl",
      "bowtie"
    ],
    k: [
      7,
      31
    ],
    o: 2
  },
  no_entry_sign: {
    a: "No Entry Sign",
    b: "1F6AB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "forbid",
      "stop",
      "limit",
      "denied",
      "disallow",
      "circle"
    ],
    k: [
      35,
      2
    ],
    o: 2
  },
  point_down: {
    skin_variations: {
      "1F3FB": {
        unified: "1F447-1F3FB",
        non_qualified: null,
        image: "1f447-1f3fb.png",
        sheet_x: 13,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F447-1F3FC",
        non_qualified: null,
        image: "1f447-1f3fc.png",
        sheet_x: 13,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F447-1F3FD",
        non_qualified: null,
        image: "1f447-1f3fd.png",
        sheet_x: 13,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F447-1F3FE",
        non_qualified: null,
        image: "1f447-1f3fe.png",
        sheet_x: 13,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F447-1F3FF",
        non_qualified: null,
        image: "1f447-1f3ff.png",
        sheet_x: 13,
        sheet_y: 7,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "White Down Pointing Backhand Index",
    b: "1F447",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fingers",
      "hand",
      "direction",
      "down"
    ],
    k: [
      13,
      2
    ],
    o: 2
  },
  "flag-aq": {
    a: "Antarctica Flag",
    b: "1F1E6-1F1F6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      40
    ],
    o: 2
  },
  briefs: {
    a: "Briefs",
    b: "1FA72",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      53
    ],
    o: 12
  },
  kissing_heart: {
    a: "Face Throwing a Kiss",
    b: "1F618",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation",
      "kiss"
    ],
    k: [
      31,
      2
    ],
    l: [
      ":*",
      ":-*"
    ],
    o: 2
  },
  tiger2: {
    a: "Tiger",
    b: "1F405",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "roar"
    ],
    k: [
      11,
      33
    ],
    o: 2
  },
  stadium: {
    a: "Stadium",
    b: "1F3DF-FE0F",
    c: "1F3DF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "place",
      "sports",
      "concert",
      "venue"
    ],
    k: [
      10,
      50
    ],
    o: 2
  },
  leopard: {
    a: "Leopard",
    b: "1F406",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature"
    ],
    k: [
      11,
      34
    ],
    o: 2
  },
  no_bicycles: {
    a: "No Bicycles",
    b: "1F6B3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "cyclist",
      "prohibited",
      "circle"
    ],
    k: [
      35,
      10
    ],
    o: 2
  },
  kissing: {
    a: "Kissing Face",
    b: "1F617",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "face",
      "3",
      "valentines",
      "infatuation",
      "kiss"
    ],
    k: [
      31,
      1
    ],
    o: 2
  },
  "flag-ar": {
    a: "Argentina Flag",
    b: "1F1E6-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      41
    ],
    o: 2
  },
  avocado: {
    a: "Avocado",
    b: "1F951",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "food"
    ],
    k: [
      41,
      32
    ],
    o: 4
  },
  point_up: {
    skin_variations: {
      "1F3FB": {
        unified: "261D-1F3FB",
        non_qualified: null,
        image: "261d-1f3fb.png",
        sheet_x: 53,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "261D-1F3FC",
        non_qualified: null,
        image: "261d-1f3fc.png",
        sheet_x: 53,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "261D-1F3FD",
        non_qualified: null,
        image: "261d-1f3fd.png",
        sheet_x: 53,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "261D-1F3FE",
        non_qualified: null,
        image: "261d-1f3fe.png",
        sheet_x: 53,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "261D-1F3FF",
        non_qualified: null,
        image: "261d-1f3ff.png",
        sheet_x: 53,
        sheet_y: 7,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "White Up Pointing Index",
    b: "261D-FE0F",
    c: "261D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hand",
      "fingers",
      "direction",
      "up"
    ],
    k: [
      53,
      2
    ],
    o: 2
  },
  gift: {
    a: "Wrapped Present",
    b: "1F381",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "present",
      "birthday",
      "christmas",
      "xmas"
    ],
    k: [
      7,
      32
    ],
    o: 2
  },
  classical_building: {
    a: "Classical Building",
    b: "1F3DB-FE0F",
    c: "1F3DB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "art",
      "culture",
      "history"
    ],
    k: [
      10,
      46
    ],
    o: 2
  },
  shorts: {
    a: "Shorts",
    b: "1FA73",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      54
    ],
    o: 12
  },
  "+1": {
    skin_variations: {
      "1F3FB": {
        unified: "1F44D-1F3FB",
        non_qualified: null,
        image: "1f44d-1f3fb.png",
        sheet_x: 13,
        sheet_y: 39,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F44D-1F3FC",
        non_qualified: null,
        image: "1f44d-1f3fc.png",
        sheet_x: 13,
        sheet_y: 40,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F44D-1F3FD",
        non_qualified: null,
        image: "1f44d-1f3fd.png",
        sheet_x: 13,
        sheet_y: 41,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F44D-1F3FE",
        non_qualified: null,
        image: "1f44d-1f3fe.png",
        sheet_x: 13,
        sheet_y: 42,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F44D-1F3FF",
        non_qualified: null,
        image: "1f44d-1f3ff.png",
        sheet_x: 13,
        sheet_y: 43,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Thumbs Up Sign",
    b: "1F44D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "thumbsup",
      "yes",
      "awesome",
      "good",
      "agree",
      "accept",
      "cool",
      "hand",
      "like"
    ],
    k: [
      13,
      38
    ],
    n: [
      "thumbsup"
    ],
    o: 2
  },
  horse: {
    a: "Horse Face",
    b: "1F434",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "brown",
      "nature"
    ],
    k: [
      12,
      24
    ],
    o: 2
  },
  bikini: {
    a: "Bikini",
    b: "1F459",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "swimming",
      "female",
      "woman",
      "girl",
      "fashion",
      "beach",
      "summer"
    ],
    k: [
      14,
      13
    ],
    o: 2
  },
  no_smoking: {
    a: "No Smoking Symbol",
    b: "1F6AD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "cigarette",
      "blue-square",
      "smell",
      "smoke"
    ],
    k: [
      35,
      4
    ],
    o: 2
  },
  eggplant: {
    a: "Aubergine",
    b: "1F346",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vegetable",
      "nature",
      "food",
      "aubergine"
    ],
    k: [
      6,
      30
    ],
    o: 2
  },
  "flag-as": {
    a: "American Samoa Flag",
    b: "1F1E6-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      42
    ],
    o: 2
  },
  reminder_ribbon: {
    a: "Reminder Ribbon",
    b: "1F397-FE0F",
    c: "1F397",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "cause",
      "support",
      "awareness"
    ],
    k: [
      8,
      0
    ],
    o: 2
  },
  building_construction: {
    a: "Building Construction",
    b: "1F3D7-FE0F",
    c: "1F3D7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "wip",
      "working",
      "progress"
    ],
    k: [
      10,
      42
    ],
    o: 2
  },
  relaxed: {
    a: "White Smiling Face",
    b: "263A-FE0F",
    c: "263A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "blush",
      "massage",
      "happiness"
    ],
    k: [
      53,
      17
    ],
    o: 2
  },
  kissing_closed_eyes: {
    a: "Kissing Face with Closed Eyes",
    b: "1F61A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation",
      "kiss"
    ],
    k: [
      31,
      4
    ],
    o: 2
  },
  "-1": {
    skin_variations: {
      "1F3FB": {
        unified: "1F44E-1F3FB",
        non_qualified: null,
        image: "1f44e-1f3fb.png",
        sheet_x: 13,
        sheet_y: 45,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F44E-1F3FC",
        non_qualified: null,
        image: "1f44e-1f3fc.png",
        sheet_x: 13,
        sheet_y: 46,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F44E-1F3FD",
        non_qualified: null,
        image: "1f44e-1f3fd.png",
        sheet_x: 13,
        sheet_y: 47,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F44E-1F3FE",
        non_qualified: null,
        image: "1f44e-1f3fe.png",
        sheet_x: 13,
        sheet_y: 48,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F44E-1F3FF",
        non_qualified: null,
        image: "1f44e-1f3ff.png",
        sheet_x: 13,
        sheet_y: 49,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Thumbs Down Sign",
    b: "1F44E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "thumbsdown",
      "no",
      "dislike",
      "hand"
    ],
    k: [
      13,
      44
    ],
    n: [
      "thumbsdown"
    ],
    o: 2
  },
  admission_tickets: {
    a: "Admission Tickets",
    b: "1F39F-FE0F",
    c: "1F39F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      8,
      5
    ],
    o: 2
  },
  "flag-at": {
    a: "Austria Flag",
    b: "1F1E6-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      43
    ],
    o: 2
  },
  womans_clothes: {
    a: "Womans Clothes",
    b: "1F45A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fashion",
      "shopping_bags",
      "female"
    ],
    k: [
      14,
      14
    ],
    o: 2
  },
  do_not_litter: {
    a: "Do Not Litter Symbol",
    b: "1F6AF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "trash",
      "bin",
      "garbage",
      "circle"
    ],
    k: [
      35,
      6
    ],
    o: 2
  },
  potato: {
    a: "Potato",
    b: "1F954",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "tuber",
      "vegatable",
      "starch"
    ],
    k: [
      41,
      35
    ],
    o: 4
  },
  racehorse: {
    a: "Horse",
    b: "1F40E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "gamble",
      "luck"
    ],
    k: [
      11,
      42
    ],
    o: 2
  },
  bricks: {
    a: "Brick",
    b: "1F9F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      36
    ],
    o: 11
  },
  fist: {
    skin_variations: {
      "1F3FB": {
        unified: "270A-1F3FB",
        non_qualified: null,
        image: "270a-1f3fb.png",
        sheet_x: 54,
        sheet_y: 44,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "270A-1F3FC",
        non_qualified: null,
        image: "270a-1f3fc.png",
        sheet_x: 54,
        sheet_y: 45,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "270A-1F3FD",
        non_qualified: null,
        image: "270a-1f3fd.png",
        sheet_x: 54,
        sheet_y: 46,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "270A-1F3FE",
        non_qualified: null,
        image: "270a-1f3fe.png",
        sheet_x: 54,
        sheet_y: 47,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "270A-1F3FF",
        non_qualified: null,
        image: "270a-1f3ff.png",
        sheet_x: 54,
        sheet_y: 48,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Raised Fist",
    b: "270A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fingers",
      "hand",
      "grasp"
    ],
    k: [
      54,
      43
    ],
    o: 2
  },
  house_buildings: {
    a: "House Buildings",
    b: "1F3D8-FE0F",
    c: "1F3D8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      10,
      43
    ],
    o: 2
  },
  carrot: {
    a: "Carrot",
    b: "1F955",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vegetable",
      "food",
      "orange"
    ],
    k: [
      41,
      36
    ],
    o: 4
  },
  ticket: {
    a: "Ticket",
    b: "1F3AB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "event",
      "concert",
      "pass"
    ],
    k: [
      8,
      17
    ],
    o: 2
  },
  "flag-au": {
    a: "Australia Flag",
    b: "1F1E6-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      44
    ],
    o: 2
  },
  "non-potable_water": {
    a: "Non-Potable Water Symbol",
    b: "1F6B1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "drink",
      "faucet",
      "tap",
      "circle"
    ],
    k: [
      35,
      8
    ],
    o: 2
  },
  purse: {
    a: "Purse",
    b: "1F45B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fashion",
      "accessories",
      "money",
      "sales",
      "shopping"
    ],
    k: [
      14,
      15
    ],
    o: 2
  },
  unicorn_face: {
    a: "Unicorn Face",
    b: "1F984",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      22
    ],
    o: 2
  },
  kissing_smiling_eyes: {
    a: "Kissing Face with Smiling Eyes",
    b: "1F619",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "affection",
      "valentines",
      "infatuation",
      "kiss"
    ],
    k: [
      31,
      3
    ],
    o: 2
  },
  facepunch: {
    skin_variations: {
      "1F3FB": {
        unified: "1F44A-1F3FB",
        non_qualified: null,
        image: "1f44a-1f3fb.png",
        sheet_x: 13,
        sheet_y: 21,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F44A-1F3FC",
        non_qualified: null,
        image: "1f44a-1f3fc.png",
        sheet_x: 13,
        sheet_y: 22,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F44A-1F3FD",
        non_qualified: null,
        image: "1f44a-1f3fd.png",
        sheet_x: 13,
        sheet_y: 23,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F44A-1F3FE",
        non_qualified: null,
        image: "1f44a-1f3fe.png",
        sheet_x: 13,
        sheet_y: 24,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F44A-1F3FF",
        non_qualified: null,
        image: "1f44a-1f3ff.png",
        sheet_x: 13,
        sheet_y: 25,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Fisted Hand Sign",
    b: "1F44A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "angry",
      "violence",
      "fist",
      "hit",
      "attack",
      "hand"
    ],
    k: [
      13,
      20
    ],
    n: [
      "punch"
    ],
    o: 2
  },
  medal: {
    a: "Medal",
    b: "1F396-FE0F",
    c: "1F396",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      7,
      56
    ],
    o: 2
  },
  zebra_face: {
    a: "Zebra Face",
    b: "1F993",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      37
    ],
    o: 5
  },
  handbag: {
    a: "Handbag",
    b: "1F45C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fashion",
      "accessory",
      "accessories",
      "shopping"
    ],
    k: [
      14,
      16
    ],
    o: 2
  },
  derelict_house_building: {
    a: "Derelict House Building",
    b: "1F3DA-FE0F",
    c: "1F3DA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      10,
      45
    ],
    o: 2
  },
  yum: {
    a: "Face Savouring Delicious Food",
    b: "1F60B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "happy",
      "joy",
      "tongue",
      "smile",
      "face",
      "silly",
      "yummy",
      "nom",
      "delicious",
      "savouring"
    ],
    k: [
      30,
      46
    ],
    o: 2
  },
  corn: {
    a: "Ear of Maize",
    b: "1F33D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "vegetable",
      "plant"
    ],
    k: [
      6,
      21
    ],
    o: 2
  },
  "flag-aw": {
    a: "Aruba Flag",
    b: "1F1E6-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      45
    ],
    o: 2
  },
  no_pedestrians: {
    a: "No Pedestrians",
    b: "1F6B7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "rules",
      "crossing",
      "walking",
      "circle"
    ],
    k: [
      36,
      8
    ],
    o: 2
  },
  house: {
    a: "House Building",
    b: "1F3E0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "home"
    ],
    k: [
      10,
      51
    ],
    o: 2
  },
  hot_pepper: {
    a: "Hot Pepper",
    b: "1F336-FE0F",
    c: "1F336",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "spicy",
      "chilli",
      "chili"
    ],
    k: [
      6,
      14
    ],
    o: 2
  },
  "flag-ax": {
    a: "Åland Islands Flag",
    b: "1F1E6-1F1FD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      46
    ],
    o: 2
  },
  trophy: {
    a: "Trophy",
    b: "1F3C6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "win",
      "award",
      "contest",
      "place",
      "ftw",
      "ceremony"
    ],
    k: [
      9,
      26
    ],
    o: 2
  },
  deer: {
    a: "Deer",
    b: "1F98C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "horns",
      "venison"
    ],
    k: [
      42,
      30
    ],
    o: 4
  },
  "left-facing_fist": {
    skin_variations: {
      "1F3FB": {
        unified: "1F91B-1F3FB",
        non_qualified: null,
        image: "1f91b-1f3fb.png",
        sheet_x: 37,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F91B-1F3FC",
        non_qualified: null,
        image: "1f91b-1f3fc.png",
        sheet_x: 37,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F91B-1F3FD",
        non_qualified: null,
        image: "1f91b-1f3fd.png",
        sheet_x: 37,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F91B-1F3FE",
        non_qualified: null,
        image: "1f91b-1f3fe.png",
        sheet_x: 37,
        sheet_y: 53,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F91B-1F3FF",
        non_qualified: null,
        image: "1f91b-1f3ff.png",
        sheet_x: 37,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Left-Facing Fist",
    b: "1F91B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      49
    ],
    o: 4
  },
  stuck_out_tongue: {
    a: "Face with Stuck-out Tongue",
    b: "1F61B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "prank",
      "childish",
      "playful",
      "mischievous",
      "smile",
      "tongue"
    ],
    k: [
      31,
      5
    ],
    l: [
      ":p",
      ":-p",
      ":P",
      ":-P",
      ":b",
      ":-b"
    ],
    m: ":p",
    o: 2
  },
  pouch: {
    a: "Pouch",
    b: "1F45D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bag",
      "accessories",
      "shopping"
    ],
    k: [
      14,
      17
    ],
    o: 2
  },
  no_mobile_phones: {
    a: "No Mobile Phones",
    b: "1F4F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "iphone",
      "mute",
      "circle"
    ],
    k: [
      27,
      18
    ],
    o: 2
  },
  stuck_out_tongue_winking_eye: {
    a: "Face with Stuck-out Tongue and Winking Eye",
    b: "1F61C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "prank",
      "childish",
      "playful",
      "mischievous",
      "smile",
      "wink",
      "tongue"
    ],
    k: [
      31,
      6
    ],
    l: [
      ";p",
      ";-p",
      ";b",
      ";-b",
      ";P",
      ";-P"
    ],
    m: ";p",
    o: 2
  },
  sports_medal: {
    a: "Sports Medal",
    b: "1F3C5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      9,
      25
    ],
    o: 2
  },
  cucumber: {
    a: "Cucumber",
    b: "1F952",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fruit",
      "food",
      "pickle"
    ],
    k: [
      41,
      33
    ],
    o: 4
  },
  cow: {
    a: "Cow Face",
    b: "1F42E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "beef",
      "ox",
      "animal",
      "nature",
      "moo",
      "milk"
    ],
    k: [
      12,
      18
    ],
    o: 2
  },
  underage: {
    a: "No One Under Eighteen Symbol",
    b: "1F51E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "18",
      "drink",
      "pub",
      "night",
      "minor",
      "circle"
    ],
    k: [
      28,
      1
    ],
    o: 2
  },
  "flag-az": {
    a: "Azerbaijan Flag",
    b: "1F1E6-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      47
    ],
    o: 2
  },
  shopping_bags: {
    a: "Shopping Bags",
    b: "1F6CD-FE0F",
    c: "1F6CD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      36,
      35
    ],
    o: 2
  },
  "right-facing_fist": {
    skin_variations: {
      "1F3FB": {
        unified: "1F91C-1F3FB",
        non_qualified: null,
        image: "1f91c-1f3fb.png",
        sheet_x: 37,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F91C-1F3FC",
        non_qualified: null,
        image: "1f91c-1f3fc.png",
        sheet_x: 38,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F91C-1F3FD",
        non_qualified: null,
        image: "1f91c-1f3fd.png",
        sheet_x: 38,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F91C-1F3FE",
        non_qualified: null,
        image: "1f91c-1f3fe.png",
        sheet_x: 38,
        sheet_y: 2,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F91C-1F3FF",
        non_qualified: null,
        image: "1f91c-1f3ff.png",
        sheet_x: 38,
        sheet_y: 3,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Right-Facing Fist",
    b: "1F91C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      55
    ],
    o: 4
  },
  house_with_garden: {
    a: "House with Garden",
    b: "1F3E1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "home",
      "plant",
      "nature"
    ],
    k: [
      10,
      52
    ],
    o: 2
  },
  clap: {
    skin_variations: {
      "1F3FB": {
        unified: "1F44F-1F3FB",
        non_qualified: null,
        image: "1f44f-1f3fb.png",
        sheet_x: 13,
        sheet_y: 51,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F44F-1F3FC",
        non_qualified: null,
        image: "1f44f-1f3fc.png",
        sheet_x: 13,
        sheet_y: 52,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F44F-1F3FD",
        non_qualified: null,
        image: "1f44f-1f3fd.png",
        sheet_x: 13,
        sheet_y: 53,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F44F-1F3FE",
        non_qualified: null,
        image: "1f44f-1f3fe.png",
        sheet_x: 13,
        sheet_y: 54,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F44F-1F3FF",
        non_qualified: null,
        image: "1f44f-1f3ff.png",
        sheet_x: 13,
        sheet_y: 55,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Clapping Hands Sign",
    b: "1F44F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hands",
      "praise",
      "applause",
      "congrats",
      "yay"
    ],
    k: [
      13,
      50
    ],
    o: 2
  },
  leafy_green: {
    a: "Leafy Green",
    b: "1F96C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      2
    ],
    o: 11
  },
  office: {
    a: "Office Building",
    b: "1F3E2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "bureau",
      "work"
    ],
    k: [
      10,
      53
    ],
    o: 2
  },
  "flag-ba": {
    a: "Bosnia & Herzegovina Flag",
    b: "1F1E7-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      48
    ],
    o: 2
  },
  zany_face: {
    a: "Grinning Face with One Large and One Small Eye",
    b: "1F92A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      44
    ],
    n: [
      "grinning_face_with_one_large_and_one_small_eye"
    ],
    o: 5
  },
  first_place_medal: {
    a: "First Place Medal",
    b: "1F947",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      22
    ],
    o: 4
  },
  ox: {
    a: "Ox",
    b: "1F402",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cow",
      "beef"
    ],
    k: [
      11,
      30
    ],
    o: 2
  },
  school_satchel: {
    a: "School Satchel",
    b: "1F392",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "student",
      "education",
      "bag",
      "backpack"
    ],
    k: [
      7,
      54
    ],
    o: 2
  },
  radioactive_sign: {
    a: "Radioactive Sign",
    b: "2622-FE0F",
    c: "2622",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      53,
      9
    ],
    o: 2
  },
  second_place_medal: {
    a: "Second Place Medal",
    b: "1F948",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      23
    ],
    o: 4
  },
  stuck_out_tongue_closed_eyes: {
    a: "Face with Stuck-out Tongue and Tightly-Closed Eyes",
    b: "1F61D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "prank",
      "playful",
      "mischievous",
      "smile",
      "tongue"
    ],
    k: [
      31,
      7
    ],
    o: 2
  },
  broccoli: {
    a: "Broccoli",
    b: "1F966",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      53
    ],
    o: 5
  },
  biohazard_sign: {
    a: "Biohazard Sign",
    b: "2623-FE0F",
    c: "2623",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      53,
      10
    ],
    o: 2
  },
  mans_shoe: {
    a: "Mans Shoe",
    b: "1F45E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fashion",
      "male"
    ],
    k: [
      14,
      18
    ],
    n: [
      "shoe"
    ],
    o: 2
  },
  raised_hands: {
    skin_variations: {
      "1F3FB": {
        unified: "1F64C-1F3FB",
        non_qualified: null,
        image: "1f64c-1f3fb.png",
        sheet_x: 33,
        sheet_y: 9,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F64C-1F3FC",
        non_qualified: null,
        image: "1f64c-1f3fc.png",
        sheet_x: 33,
        sheet_y: 10,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F64C-1F3FD",
        non_qualified: null,
        image: "1f64c-1f3fd.png",
        sheet_x: 33,
        sheet_y: 11,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F64C-1F3FE",
        non_qualified: null,
        image: "1f64c-1f3fe.png",
        sheet_x: 33,
        sheet_y: 12,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F64C-1F3FF",
        non_qualified: null,
        image: "1f64c-1f3ff.png",
        sheet_x: 33,
        sheet_y: 13,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Person Raising Both Hands in Celebration",
    b: "1F64C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "gesture",
      "hooray",
      "yea",
      "celebration",
      "hands"
    ],
    k: [
      33,
      8
    ],
    o: 2
  },
  post_office: {
    a: "Japanese Post Office",
    b: "1F3E3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "envelope",
      "communication"
    ],
    k: [
      10,
      54
    ],
    o: 2
  },
  "flag-bb": {
    a: "Barbados Flag",
    b: "1F1E7-1F1E7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      49
    ],
    o: 2
  },
  water_buffalo: {
    a: "Water Buffalo",
    b: "1F403",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "ox",
      "cow"
    ],
    k: [
      11,
      31
    ],
    o: 2
  },
  third_place_medal: {
    a: "Third Place Medal",
    b: "1F949",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      24
    ],
    o: 4
  },
  european_post_office: {
    a: "European Post Office",
    b: "1F3E4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "email"
    ],
    k: [
      10,
      55
    ],
    o: 2
  },
  athletic_shoe: {
    a: "Athletic Shoe",
    b: "1F45F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shoes",
      "sports",
      "sneakers"
    ],
    k: [
      14,
      19
    ],
    o: 2
  },
  arrow_up: {
    a: "Upwards Black Arrow",
    b: "2B06-FE0F",
    c: "2B06",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "continue",
      "top",
      "direction"
    ],
    k: [
      55,
      38
    ],
    o: 2
  },
  cow2: {
    a: "Cow",
    b: "1F404",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "beef",
      "ox",
      "animal",
      "nature",
      "moo",
      "milk"
    ],
    k: [
      11,
      32
    ],
    o: 2
  },
  open_hands: {
    skin_variations: {
      "1F3FB": {
        unified: "1F450-1F3FB",
        non_qualified: null,
        image: "1f450-1f3fb.png",
        sheet_x: 14,
        sheet_y: 0,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F450-1F3FC",
        non_qualified: null,
        image: "1f450-1f3fc.png",
        sheet_x: 14,
        sheet_y: 1,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F450-1F3FD",
        non_qualified: null,
        image: "1f450-1f3fd.png",
        sheet_x: 14,
        sheet_y: 2,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F450-1F3FE",
        non_qualified: null,
        image: "1f450-1f3fe.png",
        sheet_x: 14,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F450-1F3FF",
        non_qualified: null,
        image: "1f450-1f3ff.png",
        sheet_x: 14,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Open Hands Sign",
    b: "1F450",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fingers",
      "butterfly",
      "hands",
      "open"
    ],
    k: [
      13,
      56
    ],
    o: 2
  },
  garlic: {
    a: "Garlic",
    b: "1F9C4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      12
    ],
    o: 12
  },
  money_mouth_face: {
    a: "Money-Mouth Face",
    b: "1F911",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "rich",
      "dollar",
      "money"
    ],
    k: [
      37,
      24
    ],
    o: 2
  },
  "flag-bd": {
    a: "Bangladesh Flag",
    b: "1F1E7-1F1E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      50
    ],
    o: 2
  },
  soccer: {
    a: "Soccer Ball",
    b: "26BD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "football"
    ],
    k: [
      53,
      56
    ],
    o: 2
  },
  hugging_face: {
    a: "Hugging Face",
    b: "1F917",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      30
    ],
    o: 2
  },
  onion: {
    a: "Onion",
    b: "1F9C5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      13
    ],
    o: 12
  },
  arrow_upper_right: {
    a: "North East Arrow",
    b: "2197-FE0F",
    c: "2197",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "point",
      "direction",
      "diagonal",
      "northeast"
    ],
    k: [
      52,
      17
    ],
    o: 2
  },
  palms_up_together: {
    skin_variations: {
      "1F3FB": {
        unified: "1F932-1F3FB",
        non_qualified: null,
        image: "1f932-1f3fb.png",
        sheet_x: 39,
        sheet_y: 6,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F932-1F3FC",
        non_qualified: null,
        image: "1f932-1f3fc.png",
        sheet_x: 39,
        sheet_y: 7,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F932-1F3FD",
        non_qualified: null,
        image: "1f932-1f3fd.png",
        sheet_x: 39,
        sheet_y: 8,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F932-1F3FE",
        non_qualified: null,
        image: "1f932-1f3fe.png",
        sheet_x: 39,
        sheet_y: 9,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F932-1F3FF",
        non_qualified: null,
        image: "1f932-1f3ff.png",
        sheet_x: 39,
        sheet_y: 10,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Palms Up Together",
    b: "1F932",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      39,
      5
    ],
    o: 5
  },
  pig: {
    a: "Pig Face",
    b: "1F437",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "oink",
      "nature"
    ],
    k: [
      12,
      27
    ],
    o: 2
  },
  hospital: {
    a: "Hospital",
    b: "1F3E5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "health",
      "surgery",
      "doctor"
    ],
    k: [
      10,
      56
    ],
    o: 2
  },
  hiking_boot: {
    a: "Hiking Boot",
    b: "1F97E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      16
    ],
    o: 11
  },
  "flag-be": {
    a: "Belgium Flag",
    b: "1F1E7-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      51
    ],
    o: 2
  },
  "flag-bf": {
    a: "Burkina Faso Flag",
    b: "1F1E7-1F1EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      52
    ],
    o: 2
  },
  mushroom: {
    a: "Mushroom",
    b: "1F344",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "plant",
      "vegetable"
    ],
    k: [
      6,
      28
    ],
    o: 2
  },
  pig2: {
    a: "Pig",
    b: "1F416",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature"
    ],
    k: [
      11,
      51
    ],
    o: 2
  },
  baseball: {
    a: "Baseball",
    b: "26BE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "balls"
    ],
    k: [
      54,
      0
    ],
    o: 2
  },
  face_with_hand_over_mouth: {
    a: "Smiling Face with Smiling Eyes and Hand Covering Mouth",
    b: "1F92D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      47
    ],
    n: [
      "smiling_face_with_smiling_eyes_and_hand_covering_mouth"
    ],
    o: 5
  },
  handshake: {
    a: "Handshake",
    b: "1F91D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "agreement",
      "shake"
    ],
    k: [
      38,
      4
    ],
    o: 4
  },
  womans_flat_shoe: {
    a: "Flat Shoe",
    b: "1F97F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      17
    ],
    o: 11
  },
  bank: {
    a: "Bank",
    b: "1F3E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "money",
      "sales",
      "cash",
      "business",
      "enterprise"
    ],
    k: [
      11,
      0
    ],
    o: 2
  },
  arrow_right: {
    a: "Black Rightwards Arrow",
    b: "27A1-FE0F",
    c: "27A1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "next"
    ],
    k: [
      55,
      32
    ],
    o: 2
  },
  peanuts: {
    a: "Peanuts",
    b: "1F95C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "nut"
    ],
    k: [
      41,
      43
    ],
    o: 4
  },
  shushing_face: {
    a: "Face with Finger Covering Closed Lips",
    b: "1F92B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      45
    ],
    n: [
      "face_with_finger_covering_closed_lips"
    ],
    o: 5
  },
  pray: {
    skin_variations: {
      "1F3FB": {
        unified: "1F64F-1F3FB",
        non_qualified: null,
        image: "1f64f-1f3fb.png",
        sheet_x: 33,
        sheet_y: 51,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F64F-1F3FC",
        non_qualified: null,
        image: "1f64f-1f3fc.png",
        sheet_x: 33,
        sheet_y: 52,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F64F-1F3FD",
        non_qualified: null,
        image: "1f64f-1f3fd.png",
        sheet_x: 33,
        sheet_y: 53,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F64F-1F3FE",
        non_qualified: null,
        image: "1f64f-1f3fe.png",
        sheet_x: 33,
        sheet_y: 54,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F64F-1F3FF",
        non_qualified: null,
        image: "1f64f-1f3ff.png",
        sheet_x: 33,
        sheet_y: 55,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Person with Folded Hands",
    b: "1F64F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "please",
      "hope",
      "wish",
      "namaste",
      "highfive"
    ],
    k: [
      33,
      50
    ],
    o: 2
  },
  softball: {
    a: "Softball",
    b: "1F94E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      29
    ],
    o: 11
  },
  high_heel: {
    a: "High-Heeled Shoe",
    b: "1F460",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fashion",
      "shoes",
      "female",
      "pumps",
      "stiletto"
    ],
    k: [
      14,
      20
    ],
    o: 2
  },
  "flag-bg": {
    a: "Bulgaria Flag",
    b: "1F1E7-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      53
    ],
    o: 2
  },
  arrow_lower_right: {
    a: "South East Arrow",
    b: "2198-FE0F",
    c: "2198",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "direction",
      "diagonal",
      "southeast"
    ],
    k: [
      52,
      18
    ],
    o: 2
  },
  hotel: {
    a: "Hotel",
    b: "1F3E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "accomodation",
      "checkin"
    ],
    k: [
      11,
      2
    ],
    o: 2
  },
  boar: {
    a: "Boar",
    b: "1F417",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature"
    ],
    k: [
      11,
      52
    ],
    o: 2
  },
  sandal: {
    a: "Womans Sandal",
    b: "1F461",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shoes",
      "fashion",
      "flip flops"
    ],
    k: [
      14,
      21
    ],
    o: 2
  },
  "flag-bh": {
    a: "Bahrain Flag",
    b: "1F1E7-1F1ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      54
    ],
    o: 2
  },
  arrow_down: {
    a: "Downwards Black Arrow",
    b: "2B07-FE0F",
    c: "2B07",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "direction",
      "bottom"
    ],
    k: [
      55,
      39
    ],
    o: 2
  },
  thinking_face: {
    a: "Thinking Face",
    b: "1F914",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      27
    ],
    o: 2
  },
  writing_hand: {
    skin_variations: {
      "1F3FB": {
        unified: "270D-1F3FB",
        non_qualified: null,
        image: "270d-1f3fb.png",
        sheet_x: 55,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "270D-1F3FC",
        non_qualified: null,
        image: "270d-1f3fc.png",
        sheet_x: 55,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "270D-1F3FD",
        non_qualified: null,
        image: "270d-1f3fd.png",
        sheet_x: 55,
        sheet_y: 7,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "270D-1F3FE",
        non_qualified: null,
        image: "270d-1f3fe.png",
        sheet_x: 55,
        sheet_y: 8,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "270D-1F3FF",
        non_qualified: null,
        image: "270d-1f3ff.png",
        sheet_x: 55,
        sheet_y: 9,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Writing Hand",
    b: "270D-FE0F",
    c: "270D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "lower_left_ballpoint_pen",
      "stationery",
      "write",
      "compose"
    ],
    k: [
      55,
      4
    ],
    o: 2
  },
  chestnut: {
    a: "Chestnut",
    b: "1F330",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "squirrel"
    ],
    k: [
      6,
      8
    ],
    o: 2
  },
  basketball: {
    a: "Basketball and Hoop",
    b: "1F3C0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "balls",
      "NBA"
    ],
    k: [
      8,
      38
    ],
    o: 2
  },
  pig_nose: {
    a: "Pig Nose",
    b: "1F43D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "oink"
    ],
    k: [
      12,
      33
    ],
    o: 2
  },
  love_hotel: {
    a: "Love Hotel",
    b: "1F3E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "like",
      "affection",
      "dating"
    ],
    k: [
      11,
      3
    ],
    o: 2
  },
  nail_care: {
    skin_variations: {
      "1F3FB": {
        unified: "1F485-1F3FB",
        non_qualified: null,
        image: "1f485-1f3fb.png",
        sheet_x: 24,
        sheet_y: 34,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F485-1F3FC",
        non_qualified: null,
        image: "1f485-1f3fc.png",
        sheet_x: 24,
        sheet_y: 35,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F485-1F3FD",
        non_qualified: null,
        image: "1f485-1f3fd.png",
        sheet_x: 24,
        sheet_y: 36,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F485-1F3FE",
        non_qualified: null,
        image: "1f485-1f3fe.png",
        sheet_x: 24,
        sheet_y: 37,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F485-1F3FF",
        non_qualified: null,
        image: "1f485-1f3ff.png",
        sheet_x: 24,
        sheet_y: 38,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Nail Polish",
    b: "1F485",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "beauty",
      "manicure",
      "finger",
      "fashion",
      "nail"
    ],
    k: [
      24,
      33
    ],
    o: 2
  },
  volleyball: {
    a: "Volleyball",
    b: "1F3D0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "balls"
    ],
    k: [
      10,
      35
    ],
    o: 2
  },
  "flag-bi": {
    a: "Burundi Flag",
    b: "1F1E7-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      55
    ],
    o: 2
  },
  arrow_lower_left: {
    a: "South West Arrow",
    b: "2199-FE0F",
    c: "2199",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "direction",
      "diagonal",
      "southwest"
    ],
    k: [
      52,
      19
    ],
    o: 2
  },
  ram: {
    a: "Ram",
    b: "1F40F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "sheep",
      "nature"
    ],
    k: [
      11,
      43
    ],
    o: 2
  },
  ballet_shoes: {
    a: "Ballet Shoes",
    b: "1FA70",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      51
    ],
    o: 12
  },
  zipper_mouth_face: {
    a: "Zipper-Mouth Face",
    b: "1F910",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "sealed",
      "zipper",
      "secret"
    ],
    k: [
      37,
      23
    ],
    o: 2
  },
  bread: {
    a: "Bread",
    b: "1F35E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "wheat",
      "breakfast",
      "toast"
    ],
    k: [
      6,
      54
    ],
    o: 2
  },
  convenience_store: {
    a: "Convenience Store",
    b: "1F3EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "shopping",
      "groceries"
    ],
    k: [
      11,
      4
    ],
    o: 2
  },
  boot: {
    a: "Womans Boots",
    b: "1F462",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shoes",
      "fashion"
    ],
    k: [
      14,
      22
    ],
    o: 2
  },
  sheep: {
    a: "Sheep",
    b: "1F411",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "wool",
      "shipit"
    ],
    k: [
      11,
      45
    ],
    o: 2
  },
  face_with_raised_eyebrow: {
    a: "Face with One Eyebrow Raised",
    b: "1F928",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      42
    ],
    n: [
      "face_with_one_eyebrow_raised"
    ],
    o: 5
  },
  "flag-bj": {
    a: "Benin Flag",
    b: "1F1E7-1F1EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      0,
      56
    ],
    o: 2
  },
  arrow_left: {
    a: "Leftwards Black Arrow",
    b: "2B05-FE0F",
    c: "2B05",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "previous",
      "back"
    ],
    k: [
      55,
      37
    ],
    o: 2
  },
  selfie: {
    skin_variations: {
      "1F3FB": {
        unified: "1F933-1F3FB",
        non_qualified: null,
        image: "1f933-1f3fb.png",
        sheet_x: 39,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F933-1F3FC",
        non_qualified: null,
        image: "1f933-1f3fc.png",
        sheet_x: 39,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F933-1F3FD",
        non_qualified: null,
        image: "1f933-1f3fd.png",
        sheet_x: 39,
        sheet_y: 14,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F933-1F3FE",
        non_qualified: null,
        image: "1f933-1f3fe.png",
        sheet_x: 39,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F933-1F3FF",
        non_qualified: null,
        image: "1f933-1f3ff.png",
        sheet_x: 39,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Selfie",
    b: "1F933",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "camera",
      "phone"
    ],
    k: [
      39,
      11
    ],
    o: 4
  },
  croissant: {
    a: "Croissant",
    b: "1F950",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "bread",
      "french"
    ],
    k: [
      41,
      31
    ],
    o: 4
  },
  school: {
    a: "School",
    b: "1F3EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "student",
      "education",
      "learn",
      "teach"
    ],
    k: [
      11,
      5
    ],
    o: 2
  },
  football: {
    a: "American Football",
    b: "1F3C8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "balls",
      "NFL"
    ],
    k: [
      9,
      33
    ],
    o: 2
  },
  goat: {
    a: "Goat",
    b: "1F410",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature"
    ],
    k: [
      11,
      44
    ],
    o: 2
  },
  department_store: {
    a: "Department Store",
    b: "1F3EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "shopping",
      "mall"
    ],
    k: [
      11,
      6
    ],
    o: 2
  },
  "flag-bl": {
    a: "St. Barthélemy Flag",
    b: "1F1E7-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      0
    ],
    o: 2
  },
  crown: {
    a: "Crown",
    b: "1F451",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "king",
      "kod",
      "leader",
      "royalty",
      "lord"
    ],
    k: [
      14,
      5
    ],
    o: 2
  },
  arrow_upper_left: {
    a: "North West Arrow",
    b: "2196-FE0F",
    c: "2196",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "point",
      "direction",
      "diagonal",
      "northwest"
    ],
    k: [
      52,
      16
    ],
    o: 2
  },
  neutral_face: {
    a: "Neutral Face",
    b: "1F610",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "indifference",
      "meh",
      ":|",
      "neutral"
    ],
    k: [
      30,
      51
    ],
    l: [
      ":|",
      ":-|"
    ],
    o: 2
  },
  rugby_football: {
    a: "Rugby Football",
    b: "1F3C9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "team"
    ],
    k: [
      9,
      34
    ],
    o: 2
  },
  muscle: {
    skin_variations: {
      "1F3FB": {
        unified: "1F4AA-1F3FB",
        non_qualified: null,
        image: "1f4aa-1f3fb.png",
        sheet_x: 25,
        sheet_y: 53,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F4AA-1F3FC",
        non_qualified: null,
        image: "1f4aa-1f3fc.png",
        sheet_x: 25,
        sheet_y: 54,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F4AA-1F3FD",
        non_qualified: null,
        image: "1f4aa-1f3fd.png",
        sheet_x: 25,
        sheet_y: 55,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F4AA-1F3FE",
        non_qualified: null,
        image: "1f4aa-1f3fe.png",
        sheet_x: 25,
        sheet_y: 56,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F4AA-1F3FF",
        non_qualified: null,
        image: "1f4aa-1f3ff.png",
        sheet_x: 26,
        sheet_y: 0,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Flexed Biceps",
    b: "1F4AA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "arm",
      "flex",
      "hand",
      "summer",
      "strong",
      "biceps"
    ],
    k: [
      25,
      52
    ],
    o: 2
  },
  baguette_bread: {
    a: "Baguette Bread",
    b: "1F956",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "bread",
      "french"
    ],
    k: [
      41,
      37
    ],
    o: 4
  },
  expressionless: {
    a: "Expressionless Face",
    b: "1F611",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "indifferent",
      "-_-",
      "meh",
      "deadpan"
    ],
    k: [
      30,
      52
    ],
    o: 2
  },
  womans_hat: {
    a: "Womans Hat",
    b: "1F452",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fashion",
      "accessories",
      "female",
      "lady",
      "spring"
    ],
    k: [
      14,
      6
    ],
    o: 2
  },
  pretzel: {
    a: "Pretzel",
    b: "1F968",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      55
    ],
    o: 5
  },
  mechanical_arm: {
    a: "Mechanical Arm",
    b: "1F9BE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      6
    ],
    o: 12
  },
  arrow_up_down: {
    a: "Up Down Arrow",
    b: "2195-FE0F",
    c: "2195",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "direction",
      "way",
      "vertical"
    ],
    k: [
      52,
      15
    ],
    o: 2
  },
  dromedary_camel: {
    a: "Dromedary Camel",
    b: "1F42A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "hot",
      "desert",
      "hump"
    ],
    k: [
      12,
      14
    ],
    o: 2
  },
  tennis: {
    a: "Tennis Racquet and Ball",
    b: "1F3BE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "balls",
      "green"
    ],
    k: [
      8,
      36
    ],
    o: 2
  },
  "flag-bm": {
    a: "Bermuda Flag",
    b: "1F1E7-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      1
    ],
    o: 2
  },
  factory: {
    a: "Factory",
    b: "1F3ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "industry",
      "pollution",
      "smoke"
    ],
    k: [
      11,
      7
    ],
    o: 2
  },
  japanese_castle: {
    a: "Japanese Castle",
    b: "1F3EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "building"
    ],
    k: [
      11,
      9
    ],
    o: 2
  },
  no_mouth: {
    a: "Face Without Mouth",
    b: "1F636",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "hellokitty"
    ],
    k: [
      31,
      32
    ],
    o: 2
  },
  mechanical_leg: {
    a: "Mechanical Leg",
    b: "1F9BF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      7
    ],
    o: 12
  },
  bagel: {
    a: "Bagel",
    b: "1F96F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      5
    ],
    o: 11
  },
  camel: {
    a: "Bactrian Camel",
    b: "1F42B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "hot",
      "desert",
      "hump"
    ],
    k: [
      12,
      15
    ],
    o: 2
  },
  tophat: {
    a: "Top Hat",
    b: "1F3A9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "magic",
      "gentleman",
      "classy",
      "circus"
    ],
    k: [
      8,
      15
    ],
    o: 2
  },
  left_right_arrow: {
    a: "Left Right Arrow",
    b: "2194-FE0F",
    c: "2194",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "direction",
      "horizontal",
      "sideways"
    ],
    k: [
      52,
      14
    ],
    o: 2
  },
  "flag-bn": {
    a: "Brunei Flag",
    b: "1F1E7-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      2
    ],
    o: 2
  },
  flying_disc: {
    a: "Flying Disc",
    b: "1F94F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      30
    ],
    o: 11
  },
  smirk: {
    a: "Smirking Face",
    b: "1F60F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "smile",
      "mean",
      "prank",
      "smug",
      "sarcasm"
    ],
    k: [
      30,
      50
    ],
    o: 2
  },
  mortar_board: {
    a: "Graduation Cap",
    b: "1F393",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "school",
      "college",
      "degree",
      "university",
      "graduation",
      "cap",
      "hat",
      "legal",
      "learn",
      "education"
    ],
    k: [
      7,
      55
    ],
    o: 2
  },
  european_castle: {
    a: "European Castle",
    b: "1F3F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "royalty",
      "history"
    ],
    k: [
      11,
      10
    ],
    o: 2
  },
  leg: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9B5-1F3FB",
        non_qualified: null,
        image: "1f9b5-1f3fb.png",
        sheet_x: 43,
        sheet_y: 6,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9B5-1F3FC",
        non_qualified: null,
        image: "1f9b5-1f3fc.png",
        sheet_x: 43,
        sheet_y: 7,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9B5-1F3FD",
        non_qualified: null,
        image: "1f9b5-1f3fd.png",
        sheet_x: 43,
        sheet_y: 8,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9B5-1F3FE",
        non_qualified: null,
        image: "1f9b5-1f3fe.png",
        sheet_x: 43,
        sheet_y: 9,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9B5-1F3FF",
        non_qualified: null,
        image: "1f9b5-1f3ff.png",
        sheet_x: 43,
        sheet_y: 10,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Leg",
    b: "1F9B5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      5
    ],
    o: 11
  },
  pancakes: {
    a: "Pancakes",
    b: "1F95E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "breakfast",
      "flapjacks",
      "hotcakes"
    ],
    k: [
      41,
      45
    ],
    o: 4
  },
  leftwards_arrow_with_hook: {
    a: "Leftwards Arrow with Hook",
    b: "21A9-FE0F",
    c: "21A9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "back",
      "return",
      "blue-square",
      "undo",
      "enter"
    ],
    k: [
      52,
      20
    ],
    o: 2
  },
  "flag-bo": {
    a: "Bolivia Flag",
    b: "1F1E7-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      3
    ],
    o: 2
  },
  bowling: {
    a: "Bowling",
    b: "1F3B3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "fun",
      "play"
    ],
    k: [
      8,
      25
    ],
    o: 2
  },
  llama: {
    a: "Llama",
    b: "1F999",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      43
    ],
    o: 11
  },
  arrow_right_hook: {
    a: "Rightwards Arrow with Hook",
    b: "21AA-FE0F",
    c: "21AA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "return",
      "rotate",
      "direction"
    ],
    k: [
      52,
      21
    ],
    o: 2
  },
  wedding: {
    a: "Wedding",
    b: "1F492",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "affection",
      "couple",
      "marriage",
      "bride",
      "groom"
    ],
    k: [
      25,
      28
    ],
    o: 2
  },
  "flag-bq": {
    a: "Caribbean Netherlands Flag",
    b: "1F1E7-1F1F6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      4
    ],
    o: 2
  },
  foot: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9B6-1F3FB",
        non_qualified: null,
        image: "1f9b6-1f3fb.png",
        sheet_x: 43,
        sheet_y: 12,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9B6-1F3FC",
        non_qualified: null,
        image: "1f9b6-1f3fc.png",
        sheet_x: 43,
        sheet_y: 13,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9B6-1F3FD",
        non_qualified: null,
        image: "1f9b6-1f3fd.png",
        sheet_x: 43,
        sheet_y: 14,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9B6-1F3FE",
        non_qualified: null,
        image: "1f9b6-1f3fe.png",
        sheet_x: 43,
        sheet_y: 15,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9B6-1F3FF",
        non_qualified: null,
        image: "1f9b6-1f3ff.png",
        sheet_x: 43,
        sheet_y: 16,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Foot",
    b: "1F9B6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      11
    ],
    o: 11
  },
  giraffe_face: {
    a: "Giraffe Face",
    b: "1F992",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      36
    ],
    o: 5
  },
  unamused: {
    a: "Unamused Face",
    b: "1F612",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "indifference",
      "bored",
      "straight face",
      "serious",
      "sarcasm"
    ],
    k: [
      30,
      53
    ],
    m: ":(",
    o: 2
  },
  billed_cap: {
    a: "Billed Cap",
    b: "1F9E2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      21
    ],
    o: 5
  },
  waffle: {
    a: "Waffle",
    b: "1F9C7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      15
    ],
    o: 12
  },
  cricket_bat_and_ball: {
    a: "Cricket Bat and Ball",
    b: "1F3CF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      10,
      34
    ],
    o: 2
  },
  helmet_with_white_cross: {
    a: "Helmet with White Cross",
    b: "26D1-FE0F",
    c: "26D1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      54,
      6
    ],
    o: 2
  },
  ear: {
    skin_variations: {
      "1F3FB": {
        unified: "1F442-1F3FB",
        non_qualified: null,
        image: "1f442-1f3fb.png",
        sheet_x: 12,
        sheet_y: 40,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F442-1F3FC",
        non_qualified: null,
        image: "1f442-1f3fc.png",
        sheet_x: 12,
        sheet_y: 41,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F442-1F3FD",
        non_qualified: null,
        image: "1f442-1f3fd.png",
        sheet_x: 12,
        sheet_y: 42,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F442-1F3FE",
        non_qualified: null,
        image: "1f442-1f3fe.png",
        sheet_x: 12,
        sheet_y: 43,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F442-1F3FF",
        non_qualified: null,
        image: "1f442-1f3ff.png",
        sheet_x: 12,
        sheet_y: 44,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Ear",
    b: "1F442",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "hear",
      "sound",
      "listen"
    ],
    k: [
      12,
      39
    ],
    o: 2
  },
  elephant: {
    a: "Elephant",
    b: "1F418",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "nose",
      "th",
      "circus"
    ],
    k: [
      11,
      53
    ],
    o: 2
  },
  cheese_wedge: {
    a: "Cheese Wedge",
    b: "1F9C0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      8
    ],
    o: 2
  },
  tokyo_tower: {
    a: "Tokyo Tower",
    b: "1F5FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "japanese"
    ],
    k: [
      30,
      31
    ],
    o: 2
  },
  arrow_heading_up: {
    a: "Arrow Pointing Rightwards Then Curving Upwards",
    b: "2934-FE0F",
    c: "2934",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "direction",
      "top"
    ],
    k: [
      55,
      35
    ],
    o: 2
  },
  field_hockey_stick_and_ball: {
    a: "Field Hockey Stick and Ball",
    b: "1F3D1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      10,
      36
    ],
    o: 2
  },
  "flag-br": {
    a: "Brazil Flag",
    b: "1F1E7-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      5
    ],
    o: 2
  },
  face_with_rolling_eyes: {
    a: "Face with Rolling Eyes",
    b: "1F644",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      31,
      46
    ],
    o: 2
  },
  ear_with_hearing_aid: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9BB-1F3FB",
        non_qualified: null,
        image: "1f9bb-1f3fb.png",
        sheet_x: 43,
        sheet_y: 56,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9BB-1F3FC",
        non_qualified: null,
        image: "1f9bb-1f3fc.png",
        sheet_x: 44,
        sheet_y: 0,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9BB-1F3FD",
        non_qualified: null,
        image: "1f9bb-1f3fd.png",
        sheet_x: 44,
        sheet_y: 1,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9BB-1F3FE",
        non_qualified: null,
        image: "1f9bb-1f3fe.png",
        sheet_x: 44,
        sheet_y: 2,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9BB-1F3FF",
        non_qualified: null,
        image: "1f9bb-1f3ff.png",
        sheet_x: 44,
        sheet_y: 3,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Ear with Hearing Aid",
    b: "1F9BB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      55
    ],
    o: 12
  },
  arrow_heading_down: {
    a: "Arrow Pointing Rightwards Then Curving Downwards",
    b: "2935-FE0F",
    c: "2935",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "direction",
      "bottom"
    ],
    k: [
      55,
      36
    ],
    o: 2
  },
  ice_hockey_stick_and_puck: {
    a: "Ice Hockey Stick and Puck",
    b: "1F3D2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      10,
      37
    ],
    o: 2
  },
  meat_on_bone: {
    a: "Meat on Bone",
    b: "1F356",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "good",
      "food",
      "drumstick"
    ],
    k: [
      6,
      46
    ],
    o: 2
  },
  prayer_beads: {
    a: "Prayer Beads",
    b: "1F4FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dhikr",
      "religious"
    ],
    k: [
      27,
      27
    ],
    o: 2
  },
  statue_of_liberty: {
    a: "Statue of Liberty",
    b: "1F5FD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "american",
      "newyork"
    ],
    k: [
      30,
      32
    ],
    o: 2
  },
  grimacing: {
    a: "Grimacing Face",
    b: "1F62C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "grimace",
      "teeth"
    ],
    k: [
      31,
      22
    ],
    o: 2
  },
  "flag-bs": {
    a: "Bahamas Flag",
    b: "1F1E7-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      6
    ],
    o: 2
  },
  rhinoceros: {
    a: "Rhinoceros",
    b: "1F98F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "horn"
    ],
    k: [
      42,
      33
    ],
    o: 4
  },
  lacrosse: {
    a: "Lacrosse Stick and Ball",
    b: "1F94D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      28
    ],
    o: 11
  },
  poultry_leg: {
    a: "Poultry Leg",
    b: "1F357",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "meat",
      "drumstick",
      "bird",
      "chicken",
      "turkey"
    ],
    k: [
      6,
      47
    ],
    o: 2
  },
  hippopotamus: {
    a: "Hippopotamus",
    b: "1F99B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      45
    ],
    o: 11
  },
  nose: {
    skin_variations: {
      "1F3FB": {
        unified: "1F443-1F3FB",
        non_qualified: null,
        image: "1f443-1f3fb.png",
        sheet_x: 12,
        sheet_y: 46,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F443-1F3FC",
        non_qualified: null,
        image: "1f443-1f3fc.png",
        sheet_x: 12,
        sheet_y: 47,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F443-1F3FD",
        non_qualified: null,
        image: "1f443-1f3fd.png",
        sheet_x: 12,
        sheet_y: 48,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F443-1F3FE",
        non_qualified: null,
        image: "1f443-1f3fe.png",
        sheet_x: 12,
        sheet_y: 49,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F443-1F3FF",
        non_qualified: null,
        image: "1f443-1f3ff.png",
        sheet_x: 12,
        sheet_y: 50,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Nose",
    b: "1F443",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "smell",
      "sniff"
    ],
    k: [
      12,
      45
    ],
    o: 2
  },
  arrows_clockwise: {
    a: "Clockwise Downwards and Upwards Open Circle Arrows",
    b: "1F503",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sync",
      "cycle",
      "round",
      "repeat"
    ],
    k: [
      27,
      31
    ],
    o: 2
  },
  "flag-bt": {
    a: "Bhutan Flag",
    b: "1F1E7-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      7
    ],
    o: 2
  },
  church: {
    a: "Church",
    b: "26EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "building",
      "religion",
      "christ"
    ],
    k: [
      54,
      10
    ],
    o: 2
  },
  lipstick: {
    a: "Lipstick",
    b: "1F484",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "female",
      "girl",
      "fashion",
      "woman"
    ],
    k: [
      24,
      32
    ],
    o: 2
  },
  lying_face: {
    a: "Lying Face",
    b: "1F925",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "lie",
      "pinocchio"
    ],
    k: [
      38,
      22
    ],
    o: 4
  },
  arrows_counterclockwise: {
    a: "Anticlockwise Downwards and Upwards Open Circle Arrows",
    b: "1F504",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "sync",
      "cycle"
    ],
    k: [
      27,
      32
    ],
    o: 2
  },
  "flag-bv": {
    a: "Bouvet Island Flag",
    b: "1F1E7-1F1FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      8
    ],
    o: 2
  },
  cut_of_meat: {
    a: "Cut of Meat",
    b: "1F969",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      56
    ],
    o: 5
  },
  mosque: {
    a: "Mosque",
    b: "1F54C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "islam",
      "worship",
      "minaret"
    ],
    k: [
      28,
      36
    ],
    o: 2
  },
  ring: {
    a: "Ring",
    b: "1F48D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "wedding",
      "propose",
      "marriage",
      "valentines",
      "diamond",
      "fashion",
      "jewelry",
      "gem",
      "engagement"
    ],
    k: [
      25,
      23
    ],
    o: 2
  },
  brain: {
    a: "Brain",
    b: "1F9E0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      19
    ],
    o: 5
  },
  table_tennis_paddle_and_ball: {
    a: "Table Tennis Paddle and Ball",
    b: "1F3D3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      10,
      38
    ],
    o: 2
  },
  relieved: {
    a: "Relieved Face",
    b: "1F60C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "relaxed",
      "phew",
      "massage",
      "happiness"
    ],
    k: [
      30,
      47
    ],
    o: 2
  },
  mouse: {
    a: "Mouse Face",
    b: "1F42D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "cheese_wedge",
      "rodent"
    ],
    k: [
      12,
      17
    ],
    o: 2
  },
  hindu_temple: {
    a: "Hindu Temple",
    b: "1F6D5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      36,
      41
    ],
    o: 12
  },
  back: {
    a: "Back with Leftwards Arrow Above",
    b: "1F519",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "arrow",
      "words",
      "return"
    ],
    k: [
      27,
      53
    ],
    o: 2
  },
  gem: {
    a: "Gem Stone",
    b: "1F48E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue",
      "ruby",
      "diamond",
      "jewelry"
    ],
    k: [
      25,
      24
    ],
    o: 2
  },
  pensive: {
    a: "Pensive Face",
    b: "1F614",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "sad",
      "depressed",
      "upset"
    ],
    k: [
      30,
      55
    ],
    o: 2
  },
  "flag-bw": {
    a: "Botswana Flag",
    b: "1F1E7-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      9
    ],
    o: 2
  },
  mouse2: {
    a: "Mouse",
    b: "1F401",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "rodent"
    ],
    k: [
      11,
      29
    ],
    o: 2
  },
  bacon: {
    a: "Bacon",
    b: "1F953",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "breakfast",
      "pork",
      "pig",
      "meat"
    ],
    k: [
      41,
      34
    ],
    o: 4
  },
  tooth: {
    a: "Tooth",
    b: "1F9B7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      17
    ],
    o: 11
  },
  badminton_racquet_and_shuttlecock: {
    a: "Badminton Racquet and Shuttlecock",
    b: "1F3F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      11,
      20
    ],
    o: 2
  },
  rat: {
    a: "Rat",
    b: "1F400",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "mouse",
      "rodent"
    ],
    k: [
      11,
      28
    ],
    o: 2
  },
  synagogue: {
    a: "Synagogue",
    b: "1F54D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "judaism",
      "worship",
      "temple",
      "jewish"
    ],
    k: [
      28,
      37
    ],
    o: 2
  },
  end: {
    a: "End with Leftwards Arrow Above",
    b: "1F51A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "words",
      "arrow"
    ],
    k: [
      27,
      54
    ],
    o: 2
  },
  bone: {
    a: "Bone",
    b: "1F9B4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      4
    ],
    o: 11
  },
  boxing_glove: {
    a: "Boxing Glove",
    b: "1F94A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "fighting"
    ],
    k: [
      41,
      25
    ],
    o: 4
  },
  mute: {
    a: "Speaker with Cancellation Stroke",
    b: "1F507",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sound",
      "volume",
      "silence",
      "quiet"
    ],
    k: [
      27,
      35
    ],
    o: 2
  },
  hamburger: {
    a: "Hamburger",
    b: "1F354",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "meat",
      "fast food",
      "beef",
      "cheeseburger",
      "mcdonalds",
      "burger king"
    ],
    k: [
      6,
      44
    ],
    o: 2
  },
  "flag-by": {
    a: "Belarus Flag",
    b: "1F1E7-1F1FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      10
    ],
    o: 2
  },
  sleepy: {
    a: "Sleepy Face",
    b: "1F62A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "tired",
      "rest",
      "nap"
    ],
    k: [
      31,
      20
    ],
    o: 2
  },
  on: {
    a: "On with Exclamation Mark with Left Right Arrow Above",
    b: "1F51B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "arrow",
      "words"
    ],
    k: [
      27,
      55
    ],
    o: 2
  },
  martial_arts_uniform: {
    a: "Martial Arts Uniform",
    b: "1F94B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "judo",
      "karate",
      "taekwondo"
    ],
    k: [
      41,
      26
    ],
    o: 4
  },
  speaker: {
    a: "Speaker",
    b: "1F508",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sound",
      "volume",
      "silence",
      "broadcast"
    ],
    k: [
      27,
      36
    ],
    o: 2
  },
  drooling_face: {
    a: "Drooling Face",
    b: "1F924",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face"
    ],
    k: [
      38,
      21
    ],
    o: 4
  },
  eyes: {
    a: "Eyes",
    b: "1F440",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "look",
      "watch",
      "stalk",
      "peek",
      "see"
    ],
    k: [
      12,
      36
    ],
    o: 2
  },
  "flag-bz": {
    a: "Belize Flag",
    b: "1F1E7-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      11
    ],
    o: 2
  },
  hamster: {
    a: "Hamster Face",
    b: "1F439",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature"
    ],
    k: [
      12,
      29
    ],
    o: 2
  },
  shinto_shrine: {
    a: "Shinto Shrine",
    b: "26E9-FE0F",
    c: "26E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "temple",
      "japan",
      "kyoto"
    ],
    k: [
      54,
      9
    ],
    o: 2
  },
  fries: {
    a: "French Fries",
    b: "1F35F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "chips",
      "snack",
      "fast food"
    ],
    k: [
      6,
      55
    ],
    o: 2
  },
  goal_net: {
    a: "Goal Net",
    b: "1F945",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports"
    ],
    k: [
      41,
      21
    ],
    o: 4
  },
  kaaba: {
    a: "Kaaba",
    b: "1F54B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "mecca",
      "mosque",
      "islam"
    ],
    k: [
      28,
      35
    ],
    o: 2
  },
  soon: {
    a: "Soon with Rightwards Arrow Above",
    b: "1F51C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "arrow",
      "words"
    ],
    k: [
      27,
      56
    ],
    o: 2
  },
  "flag-ca": {
    a: "Canada Flag",
    b: "1F1E8-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      12
    ],
    o: 2
  },
  rabbit: {
    a: "Rabbit Face",
    b: "1F430",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "pet",
      "spring",
      "magic",
      "bunny"
    ],
    k: [
      12,
      20
    ],
    o: 2
  },
  eye: {
    a: "Eye",
    b: "1F441-FE0F",
    c: "1F441",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "look",
      "see",
      "watch",
      "stare"
    ],
    k: [
      12,
      38
    ],
    o: 2
  },
  sleeping: {
    a: "Sleeping Face",
    b: "1F634",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "tired",
      "sleepy",
      "night",
      "zzz"
    ],
    k: [
      31,
      30
    ],
    o: 2
  },
  pizza: {
    a: "Slice of Pizza",
    b: "1F355",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "party"
    ],
    k: [
      6,
      45
    ],
    o: 2
  },
  sound: {
    a: "Speaker with One Sound Wave",
    b: "1F509",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "volume",
      "speaker",
      "broadcast"
    ],
    k: [
      27,
      37
    ],
    o: 2
  },
  rabbit2: {
    a: "Rabbit",
    b: "1F407",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "pet",
      "magic",
      "spring"
    ],
    k: [
      11,
      35
    ],
    o: 2
  },
  fountain: {
    a: "Fountain",
    b: "26F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "summer",
      "water",
      "fresh"
    ],
    k: [
      54,
      13
    ],
    o: 2
  },
  golf: {
    a: "Flag in Hole",
    b: "26F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "business",
      "flag",
      "hole",
      "summer"
    ],
    k: [
      54,
      14
    ],
    o: 2
  },
  top: {
    a: "Top with Upwards Arrow Above",
    b: "1F51D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "words",
      "blue-square"
    ],
    k: [
      28,
      0
    ],
    o: 2
  },
  mask: {
    a: "Face with Medical Mask",
    b: "1F637",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "sick",
      "ill",
      "disease"
    ],
    k: [
      31,
      33
    ],
    o: 2
  },
  "flag-cc": {
    a: "Cocos (keeling) Islands Flag",
    b: "1F1E8-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      13
    ],
    o: 2
  },
  hotdog: {
    a: "Hot Dog",
    b: "1F32D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "frankfurter"
    ],
    k: [
      6,
      5
    ],
    o: 2
  },
  loud_sound: {
    a: "Speaker with Three Sound Waves",
    b: "1F50A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "volume",
      "noise",
      "noisy",
      "speaker",
      "broadcast"
    ],
    k: [
      27,
      38
    ],
    o: 2
  },
  tongue: {
    a: "Tongue",
    b: "1F445",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "mouth",
      "playful"
    ],
    k: [
      12,
      52
    ],
    o: 2
  },
  place_of_worship: {
    a: "Place of Worship",
    b: "1F6D0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "religion",
      "church",
      "temple",
      "prayer"
    ],
    k: [
      36,
      38
    ],
    o: 2
  },
  ice_skate: {
    a: "Ice Skate",
    b: "26F8-FE0F",
    c: "26F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports"
    ],
    k: [
      54,
      18
    ],
    o: 2
  },
  sandwich: {
    a: "Sandwich",
    b: "1F96A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      0
    ],
    o: 5
  },
  chipmunk: {
    a: "Chipmunk",
    b: "1F43F-FE0F",
    c: "1F43F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "rodent",
      "squirrel"
    ],
    k: [
      12,
      35
    ],
    o: 2
  },
  loudspeaker: {
    a: "Public Address Loudspeaker",
    b: "1F4E2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "volume",
      "sound"
    ],
    k: [
      26,
      56
    ],
    o: 2
  },
  lips: {
    a: "Mouth",
    b: "1F444",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "mouth",
      "kiss"
    ],
    k: [
      12,
      51
    ],
    o: 2
  },
  "flag-cd": {
    a: "Congo - Kinshasa Flag",
    b: "1F1E8-1F1E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      14
    ],
    o: 2
  },
  tent: {
    a: "Tent",
    b: "26FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "camping",
      "outdoors"
    ],
    k: [
      54,
      37
    ],
    o: 2
  },
  face_with_thermometer: {
    a: "Face with Thermometer",
    b: "1F912",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sick",
      "temperature",
      "thermometer",
      "cold",
      "fever"
    ],
    k: [
      37,
      25
    ],
    o: 2
  },
  taco: {
    a: "Taco",
    b: "1F32E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "mexican"
    ],
    k: [
      6,
      6
    ],
    o: 2
  },
  foggy: {
    a: "Foggy",
    b: "1F301",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "mountain"
    ],
    k: [
      5,
      20
    ],
    o: 2
  },
  "flag-cf": {
    a: "Central African Republic Flag",
    b: "1F1E8-1F1EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      15
    ],
    o: 2
  },
  baby: {
    skin_variations: {
      "1F3FB": {
        unified: "1F476-1F3FB",
        non_qualified: null,
        image: "1f476-1f3fb.png",
        sheet_x: 23,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F476-1F3FC",
        non_qualified: null,
        image: "1f476-1f3fc.png",
        sheet_x: 23,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F476-1F3FD",
        non_qualified: null,
        image: "1f476-1f3fd.png",
        sheet_x: 23,
        sheet_y: 7,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F476-1F3FE",
        non_qualified: null,
        image: "1f476-1f3fe.png",
        sheet_x: 23,
        sheet_y: 8,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F476-1F3FF",
        non_qualified: null,
        image: "1f476-1f3ff.png",
        sheet_x: 23,
        sheet_y: 9,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Baby",
    b: "1F476",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "child",
      "boy",
      "girl",
      "toddler"
    ],
    k: [
      23,
      4
    ],
    o: 2
  },
  atom_symbol: {
    a: "Atom Symbol",
    b: "269B-FE0F",
    c: "269B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "science",
      "physics",
      "chemistry"
    ],
    k: [
      53,
      48
    ],
    o: 2
  },
  fishing_pole_and_fish: {
    a: "Fishing Pole and Fish",
    b: "1F3A3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "hobby",
      "summer"
    ],
    k: [
      8,
      9
    ],
    o: 2
  },
  hedgehog: {
    a: "Hedgehog",
    b: "1F994",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      38
    ],
    o: 5
  },
  face_with_head_bandage: {
    a: "Face with Head-Bandage",
    b: "1F915",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "injured",
      "clumsy",
      "bandage",
      "hurt"
    ],
    k: [
      37,
      28
    ],
    o: 2
  },
  mega: {
    a: "Cheering Megaphone",
    b: "1F4E3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sound",
      "speaker",
      "volume"
    ],
    k: [
      27,
      0
    ],
    o: 2
  },
  nauseated_face: {
    a: "Nauseated Face",
    b: "1F922",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "vomit",
      "gross",
      "green",
      "sick",
      "throw up",
      "ill"
    ],
    k: [
      38,
      19
    ],
    o: 4
  },
  child: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D2-1F3FB",
        non_qualified: null,
        image: "1f9d2-1f3fb.png",
        sheet_x: 48,
        sheet_y: 17,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9D2-1F3FC",
        non_qualified: null,
        image: "1f9d2-1f3fc.png",
        sheet_x: 48,
        sheet_y: 18,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9D2-1F3FD",
        non_qualified: null,
        image: "1f9d2-1f3fd.png",
        sheet_x: 48,
        sheet_y: 19,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9D2-1F3FE",
        non_qualified: null,
        image: "1f9d2-1f3fe.png",
        sheet_x: 48,
        sheet_y: 20,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9D2-1F3FF",
        non_qualified: null,
        image: "1f9d2-1f3ff.png",
        sheet_x: 48,
        sheet_y: 21,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Child",
    b: "1F9D2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      48,
      16
    ],
    o: 5
  },
  "flag-cg": {
    a: "Congo - Brazzaville Flag",
    b: "1F1E8-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      16
    ],
    o: 2
  },
  bat: {
    a: "Bat",
    b: "1F987",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "blind",
      "vampire"
    ],
    k: [
      42,
      25
    ],
    o: 4
  },
  diving_mask: {
    a: "Diving Mask",
    b: "1F93F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      15
    ],
    o: 12
  },
  burrito: {
    a: "Burrito",
    b: "1F32F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "mexican"
    ],
    k: [
      6,
      7
    ],
    o: 2
  },
  postal_horn: {
    a: "Postal Horn",
    b: "1F4EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "instrument",
      "music"
    ],
    k: [
      27,
      12
    ],
    o: 2
  },
  night_with_stars: {
    a: "Night with Stars",
    b: "1F303",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "evening",
      "city",
      "downtown"
    ],
    k: [
      5,
      22
    ],
    o: 2
  },
  om_symbol: {
    a: "Om Symbol",
    b: "1F549-FE0F",
    c: "1F549",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      28,
      33
    ],
    o: 2
  },
  star_of_david: {
    a: "Star of David",
    b: "2721-FE0F",
    c: "2721",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "judaism"
    ],
    k: [
      55,
      15
    ],
    o: 2
  },
  boy: {
    skin_variations: {
      "1F3FB": {
        unified: "1F466-1F3FB",
        non_qualified: null,
        image: "1f466-1f3fb.png",
        sheet_x: 14,
        sheet_y: 27,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F466-1F3FC",
        non_qualified: null,
        image: "1f466-1f3fc.png",
        sheet_x: 14,
        sheet_y: 28,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F466-1F3FD",
        non_qualified: null,
        image: "1f466-1f3fd.png",
        sheet_x: 14,
        sheet_y: 29,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F466-1F3FE",
        non_qualified: null,
        image: "1f466-1f3fe.png",
        sheet_x: 14,
        sheet_y: 30,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F466-1F3FF",
        non_qualified: null,
        image: "1f466-1f3ff.png",
        sheet_x: 14,
        sheet_y: 31,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Boy",
    b: "1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "man",
      "male",
      "guy",
      "teenager"
    ],
    k: [
      14,
      26
    ],
    o: 2
  },
  bell: {
    a: "Bell",
    b: "1F514",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sound",
      "notification",
      "christmas",
      "xmas",
      "chime"
    ],
    k: [
      27,
      48
    ],
    o: 2
  },
  "flag-ch": {
    a: "Switzerland Flag",
    b: "1F1E8-1F1ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      17
    ],
    o: 2
  },
  running_shirt_with_sash: {
    a: "Running Shirt with Sash",
    b: "1F3BD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "play",
      "pageant"
    ],
    k: [
      8,
      35
    ],
    o: 2
  },
  stuffed_flatbread: {
    a: "Stuffed Flatbread",
    b: "1F959",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "flatbread",
      "stuffed",
      "gyro"
    ],
    k: [
      41,
      40
    ],
    o: 4
  },
  bear: {
    a: "Bear Face",
    b: "1F43B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "wild"
    ],
    k: [
      12,
      31
    ],
    o: 2
  },
  cityscape: {
    a: "Cityscape",
    b: "1F3D9-FE0F",
    c: "1F3D9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "night life",
      "urban"
    ],
    k: [
      10,
      44
    ],
    o: 2
  },
  face_vomiting: {
    a: "Face with Open Mouth Vomiting",
    b: "1F92E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      48
    ],
    n: [
      "face_with_open_mouth_vomiting"
    ],
    o: 5
  },
  wheel_of_dharma: {
    a: "Wheel of Dharma",
    b: "2638-FE0F",
    c: "2638",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hinduism",
      "buddhism",
      "sikhism",
      "jainism"
    ],
    k: [
      53,
      15
    ],
    o: 2
  },
  ski: {
    a: "Ski and Ski Boot",
    b: "1F3BF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "winter",
      "cold",
      "snow"
    ],
    k: [
      8,
      37
    ],
    o: 2
  },
  girl: {
    skin_variations: {
      "1F3FB": {
        unified: "1F467-1F3FB",
        non_qualified: null,
        image: "1f467-1f3fb.png",
        sheet_x: 14,
        sheet_y: 33,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F467-1F3FC",
        non_qualified: null,
        image: "1f467-1f3fc.png",
        sheet_x: 14,
        sheet_y: 34,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F467-1F3FD",
        non_qualified: null,
        image: "1f467-1f3fd.png",
        sheet_x: 14,
        sheet_y: 35,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F467-1F3FE",
        non_qualified: null,
        image: "1f467-1f3fe.png",
        sheet_x: 14,
        sheet_y: 36,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F467-1F3FF",
        non_qualified: null,
        image: "1f467-1f3ff.png",
        sheet_x: 14,
        sheet_y: 37,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Girl",
    b: "1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "female",
      "woman",
      "teenager"
    ],
    k: [
      14,
      32
    ],
    o: 2
  },
  falafel: {
    a: "Falafel",
    b: "1F9C6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      14
    ],
    o: 12
  },
  sneezing_face: {
    a: "Sneezing Face",
    b: "1F927",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "gesundheit",
      "sneeze",
      "sick",
      "allergy"
    ],
    k: [
      38,
      41
    ],
    o: 4
  },
  no_bell: {
    a: "Bell with Cancellation Stroke",
    b: "1F515",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sound",
      "volume",
      "mute",
      "quiet",
      "silent"
    ],
    k: [
      27,
      49
    ],
    o: 2
  },
  koala: {
    a: "Koala",
    b: "1F428",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature"
    ],
    k: [
      12,
      12
    ],
    o: 2
  },
  sunrise_over_mountains: {
    a: "Sunrise over Mountains",
    b: "1F304",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "view",
      "vacation",
      "photo"
    ],
    k: [
      5,
      23
    ],
    o: 2
  },
  "flag-ci": {
    a: "Côte D’ivoire Flag",
    b: "1F1E8-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      18
    ],
    o: 2
  },
  sunrise: {
    a: "Sunrise",
    b: "1F305",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "morning",
      "view",
      "vacation",
      "photo"
    ],
    k: [
      5,
      24
    ],
    o: 2
  },
  yin_yang: {
    a: "Yin Yang",
    b: "262F-FE0F",
    c: "262F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "balance"
    ],
    k: [
      53,
      14
    ],
    o: 2
  },
  adult: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB",
        non_qualified: null,
        image: "1f9d1-1f3fb.png",
        sheet_x: 48,
        sheet_y: 11,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC",
        non_qualified: null,
        image: "1f9d1-1f3fc.png",
        sheet_x: 48,
        sheet_y: 12,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD",
        non_qualified: null,
        image: "1f9d1-1f3fd.png",
        sheet_x: 48,
        sheet_y: 13,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE",
        non_qualified: null,
        image: "1f9d1-1f3fe.png",
        sheet_x: 48,
        sheet_y: 14,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF",
        non_qualified: null,
        image: "1f9d1-1f3ff.png",
        sheet_x: 48,
        sheet_y: 15,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Adult",
    b: "1F9D1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      48,
      10
    ],
    o: 5
  },
  hot_face: {
    a: "Overheated Face",
    b: "1F975",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      10
    ],
    o: 11
  },
  musical_score: {
    a: "Musical Score",
    b: "1F3BC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "treble",
      "clef",
      "compose"
    ],
    k: [
      8,
      34
    ],
    o: 2
  },
  sled: {
    a: "Sled",
    b: "1F6F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      36,
      56
    ],
    o: 5
  },
  egg: {
    a: "Egg",
    b: "1F95A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "chicken",
      "breakfast"
    ],
    k: [
      41,
      41
    ],
    o: 4
  },
  panda_face: {
    a: "Panda Face",
    b: "1F43C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "panda"
    ],
    k: [
      12,
      32
    ],
    o: 2
  },
  "flag-ck": {
    a: "Cook Islands Flag",
    b: "1F1E8-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      19
    ],
    o: 2
  },
  "flag-cl": {
    a: "Chile Flag",
    b: "1F1E8-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      20
    ],
    o: 2
  },
  person_with_blond_hair: {
    skin_variations: {
      "1F3FB": {
        unified: "1F471-1F3FB",
        non_qualified: null,
        image: "1f471-1f3fb.png",
        sheet_x: 22,
        sheet_y: 20,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F471-1F3FC",
        non_qualified: null,
        image: "1f471-1f3fc.png",
        sheet_x: 22,
        sheet_y: 21,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F471-1F3FD",
        non_qualified: null,
        image: "1f471-1f3fd.png",
        sheet_x: 22,
        sheet_y: 22,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F471-1F3FE",
        non_qualified: null,
        image: "1f471-1f3fe.png",
        sheet_x: 22,
        sheet_y: 23,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F471-1F3FF",
        non_qualified: null,
        image: "1f471-1f3ff.png",
        sheet_x: 22,
        sheet_y: 24,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F471-200D-2642-FE0F",
    a: "Person with Blond Hair",
    b: "1F471",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      22,
      19
    ],
    o: 2
  },
  sloth: {
    a: "Sloth",
    b: "1F9A5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      53
    ],
    o: 12
  },
  latin_cross: {
    a: "Latin Cross",
    b: "271D-FE0F",
    c: "271D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "christianity"
    ],
    k: [
      55,
      14
    ],
    o: 2
  },
  curling_stone: {
    a: "Curling Stone",
    b: "1F94C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      27
    ],
    o: 5
  },
  cold_face: {
    a: "Freezing Face",
    b: "1F976",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      11
    ],
    o: 11
  },
  fried_egg: {
    a: "Cooking",
    b: "1F373",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "breakfast",
      "kitchen",
      "egg"
    ],
    k: [
      7,
      18
    ],
    n: [
      "cooking"
    ],
    o: 2
  },
  city_sunset: {
    a: "Cityscape at Dusk",
    b: "1F306",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "evening",
      "sky",
      "buildings"
    ],
    k: [
      5,
      25
    ],
    o: 2
  },
  musical_note: {
    a: "Musical Note",
    b: "1F3B5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "score",
      "tone",
      "sound"
    ],
    k: [
      8,
      27
    ],
    o: 2
  },
  "flag-cm": {
    a: "Cameroon Flag",
    b: "1F1E8-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      21
    ],
    o: 2
  },
  notes: {
    a: "Multiple Musical Notes",
    b: "1F3B6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "music",
      "score"
    ],
    k: [
      8,
      28
    ],
    o: 2
  },
  woozy_face: {
    a: "Face with Uneven Eyes and Wavy Mouth",
    b: "1F974",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      9
    ],
    o: 11
  },
  dart: {
    a: "Direct Hit",
    b: "1F3AF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "game",
      "play",
      "bar"
    ],
    k: [
      8,
      21
    ],
    o: 2
  },
  orthodox_cross: {
    a: "Orthodox Cross",
    b: "2626-FE0F",
    c: "2626",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "suppedaneum",
      "religion"
    ],
    k: [
      53,
      11
    ],
    o: 2
  },
  shallow_pan_of_food: {
    a: "Shallow Pan of Food",
    b: "1F958",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "cooking",
      "casserole",
      "paella"
    ],
    k: [
      41,
      39
    ],
    o: 4
  },
  otter: {
    a: "Otter",
    b: "1F9A6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      54
    ],
    o: 12
  },
  man: {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB",
        non_qualified: null,
        image: "1f468-1f3fb.png",
        sheet_x: 17,
        sheet_y: 23,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC",
        non_qualified: null,
        image: "1f468-1f3fc.png",
        sheet_x: 17,
        sheet_y: 24,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD",
        non_qualified: null,
        image: "1f468-1f3fd.png",
        sheet_x: 17,
        sheet_y: 25,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE",
        non_qualified: null,
        image: "1f468-1f3fe.png",
        sheet_x: 17,
        sheet_y: 26,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF",
        non_qualified: null,
        image: "1f468-1f3ff.png",
        sheet_x: 17,
        sheet_y: 27,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man",
    b: "1F468",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "mustache",
      "father",
      "dad",
      "guy",
      "classy",
      "sir",
      "moustache"
    ],
    k: [
      17,
      22
    ],
    o: 2
  },
  city_sunrise: {
    a: "Sunset over Buildings",
    b: "1F307",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "good morning",
      "dawn"
    ],
    k: [
      5,
      26
    ],
    o: 2
  },
  bearded_person: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D4-1F3FB",
        non_qualified: null,
        image: "1f9d4-1f3fb.png",
        sheet_x: 48,
        sheet_y: 29,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9D4-1F3FC",
        non_qualified: null,
        image: "1f9d4-1f3fc.png",
        sheet_x: 48,
        sheet_y: 30,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9D4-1F3FD",
        non_qualified: null,
        image: "1f9d4-1f3fd.png",
        sheet_x: 48,
        sheet_y: 31,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9D4-1F3FE",
        non_qualified: null,
        image: "1f9d4-1f3fe.png",
        sheet_x: 48,
        sheet_y: 32,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9D4-1F3FF",
        non_qualified: null,
        image: "1f9d4-1f3ff.png",
        sheet_x: 48,
        sheet_y: 33,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Bearded Person",
    b: "1F9D4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      48,
      28
    ],
    o: 5
  },
  skunk: {
    a: "Skunk",
    b: "1F9A8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      56
    ],
    o: 12
  },
  stew: {
    a: "Pot of Food",
    b: "1F372",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "meat",
      "soup"
    ],
    k: [
      7,
      17
    ],
    o: 2
  },
  cn: {
    a: "China Flag",
    b: "1F1E8-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "china",
      "chinese",
      "prc",
      "flag",
      "country",
      "nation",
      "banner"
    ],
    k: [
      1,
      22
    ],
    n: [
      "flag-cn"
    ],
    o: 2
  },
  studio_microphone: {
    a: "Studio Microphone",
    b: "1F399-FE0F",
    c: "1F399",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sing",
      "recording",
      "artist",
      "talkshow"
    ],
    k: [
      8,
      1
    ],
    o: 2
  },
  star_and_crescent: {
    a: "Star and Crescent",
    b: "262A-FE0F",
    c: "262A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "islam"
    ],
    k: [
      53,
      12
    ],
    o: 2
  },
  "yo-yo": {
    a: "Yo-Yo",
    b: "1FA80",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      1
    ],
    o: 12
  },
  bridge_at_night: {
    a: "Bridge at Night",
    b: "1F309",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "sanfrancisco"
    ],
    k: [
      5,
      28
    ],
    o: 2
  },
  dizzy_face: {
    a: "Dizzy Face",
    b: "1F635",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "spent",
      "unconscious",
      "xox",
      "dizzy"
    ],
    k: [
      31,
      31
    ],
    o: 2
  },
  red_haired_man: {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F9B0",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f9b0.png",
        sheet_x: 16,
        sheet_y: 24,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F9B0",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f9b0.png",
        sheet_x: 16,
        sheet_y: 25,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F9B0",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f9b0.png",
        sheet_x: 16,
        sheet_y: 26,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F9B0",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f9b0.png",
        sheet_x: 16,
        sheet_y: 27,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F9B0",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f9b0.png",
        sheet_x: 16,
        sheet_y: 28,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Red Haired Man",
    b: "1F468-200D-1F9B0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      16,
      23
    ],
    o: 11
  },
  kite: {
    a: "Kite",
    b: "1FA81",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      2
    ],
    o: 12
  },
  bowl_with_spoon: {
    a: "Bowl with Spoon",
    b: "1F963",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      50
    ],
    o: 5
  },
  "flag-co": {
    a: "Colombia Flag",
    b: "1F1E8-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      23
    ],
    o: 2
  },
  peace_symbol: {
    a: "Peace Symbol",
    b: "262E-FE0F",
    c: "262E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hippie"
    ],
    k: [
      53,
      13
    ],
    o: 2
  },
  kangaroo: {
    a: "Kangaroo",
    b: "1F998",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      42
    ],
    o: 11
  },
  hotsprings: {
    a: "Hot Springs",
    b: "2668-FE0F",
    c: "2668",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bath",
      "warm",
      "relax"
    ],
    k: [
      53,
      37
    ],
    o: 2
  },
  exploding_head: {
    a: "Shocked Face with Exploding Head",
    b: "1F92F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      49
    ],
    n: [
      "shocked_face_with_exploding_head"
    ],
    o: 5
  },
  level_slider: {
    a: "Level Slider",
    b: "1F39A-FE0F",
    c: "1F39A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "scale"
    ],
    k: [
      8,
      2
    ],
    o: 2
  },
  badger: {
    a: "Badger",
    b: "1F9A1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      51
    ],
    o: 11
  },
  "8ball": {
    a: "Billiards",
    b: "1F3B1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "pool",
      "hobby",
      "game",
      "luck",
      "magic"
    ],
    k: [
      8,
      23
    ],
    o: 2
  },
  curly_haired_man: {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F9B1",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f9b1.png",
        sheet_x: 16,
        sheet_y: 30,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F9B1",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f9b1.png",
        sheet_x: 16,
        sheet_y: 31,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F9B1",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f9b1.png",
        sheet_x: 16,
        sheet_y: 32,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F9B1",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f9b1.png",
        sheet_x: 16,
        sheet_y: 33,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F9B1",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f9b1.png",
        sheet_x: 16,
        sheet_y: 34,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Curly Haired Man",
    b: "1F468-200D-1F9B1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      16,
      29
    ],
    o: 11
  },
  "flag-cp": {
    a: "Clipperton Island Flag",
    b: "1F1E8-1F1F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      24
    ],
    o: 2
  },
  carousel_horse: {
    a: "Carousel Horse",
    b: "1F3A0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "carnival"
    ],
    k: [
      8,
      6
    ],
    o: 2
  },
  face_with_cowboy_hat: {
    a: "Face with Cowboy Hat",
    b: "1F920",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      17
    ],
    o: 4
  },
  menorah_with_nine_branches: {
    a: "Menorah with Nine Branches",
    b: "1F54E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      28,
      38
    ],
    o: 2
  },
  green_salad: {
    a: "Green Salad",
    b: "1F957",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "healthy",
      "lettuce"
    ],
    k: [
      41,
      38
    ],
    o: 4
  },
  control_knobs: {
    a: "Control Knobs",
    b: "1F39B-FE0F",
    c: "1F39B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dial"
    ],
    k: [
      8,
      3
    ],
    o: 2
  },
  popcorn: {
    a: "Popcorn",
    b: "1F37F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "movie theater",
      "films",
      "snack"
    ],
    k: [
      7,
      30
    ],
    o: 2
  },
  six_pointed_star: {
    a: "Six Pointed Star with Middle Dot",
    b: "1F52F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "purple-square",
      "religion",
      "jewish",
      "hexagram"
    ],
    k: [
      28,
      18
    ],
    o: 2
  },
  feet: {
    a: "Paw Prints",
    b: "1F43E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      12,
      34
    ],
    n: [
      "paw_prints"
    ],
    o: 2
  },
  ferris_wheel: {
    a: "Ferris Wheel",
    b: "1F3A1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "carnival",
      "londoneye"
    ],
    k: [
      8,
      7
    ],
    o: 2
  },
  microphone: {
    a: "Microphone",
    b: "1F3A4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sound",
      "music",
      "PA",
      "sing",
      "talkshow"
    ],
    k: [
      8,
      10
    ],
    o: 2
  },
  crystal_ball: {
    a: "Crystal Ball",
    b: "1F52E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "disco",
      "party",
      "magic",
      "circus",
      "fortune_teller"
    ],
    k: [
      28,
      17
    ],
    o: 2
  },
  partying_face: {
    a: "Face with Party Horn and Party Hat",
    b: "1F973",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      8
    ],
    o: 11
  },
  "flag-cr": {
    a: "Costa Rica Flag",
    b: "1F1E8-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      25
    ],
    o: 2
  },
  white_haired_man: {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F9B3",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f9b3.png",
        sheet_x: 16,
        sheet_y: 42,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F9B3",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f9b3.png",
        sheet_x: 16,
        sheet_y: 43,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F9B3",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f9b3.png",
        sheet_x: 16,
        sheet_y: 44,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F9B3",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f9b3.png",
        sheet_x: 16,
        sheet_y: 45,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F9B3",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f9b3.png",
        sheet_x: 16,
        sheet_y: 46,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "White Haired Man",
    b: "1F468-200D-1F9B3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      16,
      41
    ],
    o: 11
  },
  headphones: {
    a: "Headphone",
    b: "1F3A7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "music",
      "score",
      "gadgets"
    ],
    k: [
      8,
      13
    ],
    o: 2
  },
  bald_man: {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F9B2",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f9b2.png",
        sheet_x: 16,
        sheet_y: 36,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F9B2",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f9b2.png",
        sheet_x: 16,
        sheet_y: 37,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F9B2",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f9b2.png",
        sheet_x: 16,
        sheet_y: 38,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F9B2",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f9b2.png",
        sheet_x: 16,
        sheet_y: 39,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F9B2",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f9b2.png",
        sheet_x: 16,
        sheet_y: 40,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Bald Man",
    b: "1F468-200D-1F9B2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      16,
      35
    ],
    o: 11
  },
  sunglasses: {
    a: "Smiling Face with Sunglasses",
    b: "1F60E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "cool",
      "smile",
      "summer",
      "beach",
      "sunglass"
    ],
    k: [
      30,
      49
    ],
    l: [
      "8)"
    ],
    o: 2
  },
  butter: {
    a: "Butter",
    b: "1F9C8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      16
    ],
    o: 12
  },
  roller_coaster: {
    a: "Roller Coaster",
    b: "1F3A2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "carnival",
      "playground",
      "photo",
      "fun"
    ],
    k: [
      8,
      8
    ],
    o: 2
  },
  turkey: {
    a: "Turkey",
    b: "1F983",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "bird"
    ],
    k: [
      42,
      21
    ],
    o: 2
  },
  nazar_amulet: {
    a: "Nazar Amulet",
    b: "1F9FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      50
    ],
    o: 11
  },
  "flag-cu": {
    a: "Cuba Flag",
    b: "1F1E8-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      26
    ],
    o: 2
  },
  aries: {
    a: "Aries",
    b: "2648",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "purple-square",
      "zodiac",
      "astrology"
    ],
    k: [
      53,
      20
    ],
    o: 2
  },
  "flag-cv": {
    a: "Cape Verde Flag",
    b: "1F1E8-1F1FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      27
    ],
    o: 2
  },
  barber: {
    a: "Barber Pole",
    b: "1F488",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hair",
      "salon",
      "style"
    ],
    k: [
      25,
      18
    ],
    o: 2
  },
  taurus: {
    a: "Taurus",
    b: "2649",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "purple-square",
      "sign",
      "zodiac",
      "astrology"
    ],
    k: [
      53,
      21
    ],
    o: 2
  },
  salt: {
    a: "Salt Shaker",
    b: "1F9C2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      10
    ],
    o: 11
  },
  woman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB",
        non_qualified: null,
        image: "1f469-1f3fb.png",
        sheet_x: 20,
        sheet_y: 10,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC",
        non_qualified: null,
        image: "1f469-1f3fc.png",
        sheet_x: 20,
        sheet_y: 11,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD",
        non_qualified: null,
        image: "1f469-1f3fd.png",
        sheet_x: 20,
        sheet_y: 12,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE",
        non_qualified: null,
        image: "1f469-1f3fe.png",
        sheet_x: 20,
        sheet_y: 13,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF",
        non_qualified: null,
        image: "1f469-1f3ff.png",
        sheet_x: 20,
        sheet_y: 14,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman",
    b: "1F469",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "female",
      "girls",
      "lady"
    ],
    k: [
      20,
      9
    ],
    o: 2
  },
  video_game: {
    a: "Video Game",
    b: "1F3AE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "play",
      "console",
      "PS4",
      "controller"
    ],
    k: [
      8,
      20
    ],
    o: 2
  },
  chicken: {
    a: "Chicken",
    b: "1F414",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cluck",
      "nature",
      "bird"
    ],
    k: [
      11,
      48
    ],
    o: 2
  },
  radio: {
    a: "Radio",
    b: "1F4FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "communication",
      "music",
      "podcast",
      "program"
    ],
    k: [
      27,
      24
    ],
    o: 2
  },
  nerd_face: {
    a: "Nerd Face",
    b: "1F913",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "nerdy",
      "geek",
      "dork"
    ],
    k: [
      37,
      26
    ],
    o: 2
  },
  red_haired_woman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F9B0",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f9b0.png",
        sheet_x: 19,
        sheet_y: 9,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F9B0",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f9b0.png",
        sheet_x: 19,
        sheet_y: 10,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F9B0",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f9b0.png",
        sheet_x: 19,
        sheet_y: 11,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F9B0",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f9b0.png",
        sheet_x: 19,
        sheet_y: 12,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F9B0",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f9b0.png",
        sheet_x: 19,
        sheet_y: 13,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Red Haired Woman",
    b: "1F469-200D-1F9B0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      8
    ],
    o: 11
  },
  circus_tent: {
    a: "Circus Tent",
    b: "1F3AA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "festival",
      "carnival",
      "party"
    ],
    k: [
      8,
      16
    ],
    o: 2
  },
  face_with_monocle: {
    a: "Face with Monocle",
    b: "1F9D0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      45,
      16
    ],
    o: 5
  },
  canned_food: {
    a: "Canned Food",
    b: "1F96B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      1
    ],
    o: 5
  },
  "flag-cw": {
    a: "Curaçao Flag",
    b: "1F1E8-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      28
    ],
    o: 2
  },
  gemini: {
    a: "Gemini",
    b: "264A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "zodiac",
      "purple-square",
      "astrology"
    ],
    k: [
      53,
      22
    ],
    o: 2
  },
  saxophone: {
    a: "Saxophone",
    b: "1F3B7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "music",
      "instrument",
      "jazz",
      "blues"
    ],
    k: [
      8,
      29
    ],
    o: 2
  },
  rooster: {
    a: "Rooster",
    b: "1F413",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "chicken"
    ],
    k: [
      11,
      47
    ],
    o: 2
  },
  joystick: {
    a: "Joystick",
    b: "1F579-FE0F",
    c: "1F579",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "game",
      "play"
    ],
    k: [
      29,
      36
    ],
    o: 2
  },
  guitar: {
    a: "Guitar",
    b: "1F3B8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "music",
      "instrument"
    ],
    k: [
      8,
      30
    ],
    o: 2
  },
  slot_machine: {
    a: "Slot Machine",
    b: "1F3B0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bet",
      "gamble",
      "vegas",
      "fruit machine",
      "luck",
      "casino"
    ],
    k: [
      8,
      22
    ],
    o: 2
  },
  bento: {
    a: "Bento Box",
    b: "1F371",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "japanese",
      "box"
    ],
    k: [
      7,
      16
    ],
    o: 2
  },
  steam_locomotive: {
    a: "Steam Locomotive",
    b: "1F682",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle",
      "train"
    ],
    k: [
      34,
      1
    ],
    o: 2
  },
  confused: {
    a: "Confused Face",
    b: "1F615",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "indifference",
      "huh",
      "weird",
      "hmmm",
      ":/"
    ],
    k: [
      30,
      56
    ],
    l: [
      ":\\",
      ":-\\",
      ":/",
      ":-/"
    ],
    o: 2
  },
  "flag-cx": {
    a: "Christmas Island Flag",
    b: "1F1E8-1F1FD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      29
    ],
    o: 2
  },
  hatching_chick: {
    a: "Hatching Chick",
    b: "1F423",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "chicken",
      "egg",
      "born",
      "baby",
      "bird"
    ],
    k: [
      12,
      7
    ],
    o: 2
  },
  cancer: {
    a: "Cancer",
    b: "264B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "zodiac",
      "purple-square",
      "astrology"
    ],
    k: [
      53,
      23
    ],
    o: 2
  },
  red_haired_person: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F9B0",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f9b0.png",
        sheet_x: 47,
        sheet_y: 14,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F9B0",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f9b0.png",
        sheet_x: 47,
        sheet_y: 15,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F9B0",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f9b0.png",
        sheet_x: 47,
        sheet_y: 16,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F9B0",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f9b0.png",
        sheet_x: 47,
        sheet_y: 17,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F9B0",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f9b0.png",
        sheet_x: 47,
        sheet_y: 18,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Red Haired Person",
    b: "1F9D1-200D-1F9B0",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      47,
      13
    ],
    o: 12
  },
  "flag-cy": {
    a: "Cyprus Flag",
    b: "1F1E8-1F1FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      30
    ],
    o: 2
  },
  worried: {
    a: "Worried Face",
    b: "1F61F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "concern",
      "nervous",
      ":("
    ],
    k: [
      31,
      9
    ],
    o: 2
  },
  railway_car: {
    a: "Railway Car",
    b: "1F683",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle"
    ],
    k: [
      34,
      2
    ],
    o: 2
  },
  leo: {
    a: "Leo",
    b: "264C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "purple-square",
      "zodiac",
      "astrology"
    ],
    k: [
      53,
      24
    ],
    o: 2
  },
  curly_haired_woman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F9B1",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f9b1.png",
        sheet_x: 19,
        sheet_y: 15,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F9B1",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f9b1.png",
        sheet_x: 19,
        sheet_y: 16,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F9B1",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f9b1.png",
        sheet_x: 19,
        sheet_y: 17,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F9B1",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f9b1.png",
        sheet_x: 19,
        sheet_y: 18,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F9B1",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f9b1.png",
        sheet_x: 19,
        sheet_y: 19,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Curly Haired Woman",
    b: "1F469-200D-1F9B1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      14
    ],
    o: 11
  },
  baby_chick: {
    a: "Baby Chick",
    b: "1F424",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "chicken",
      "bird"
    ],
    k: [
      12,
      8
    ],
    o: 2
  },
  musical_keyboard: {
    a: "Musical Keyboard",
    b: "1F3B9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "piano",
      "instrument",
      "compose"
    ],
    k: [
      8,
      31
    ],
    o: 2
  },
  game_die: {
    a: "Game Die",
    b: "1F3B2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dice",
      "random",
      "tabletop",
      "play",
      "luck"
    ],
    k: [
      8,
      24
    ],
    o: 2
  },
  rice_cracker: {
    a: "Rice Cracker",
    b: "1F358",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "japanese"
    ],
    k: [
      6,
      48
    ],
    o: 2
  },
  virgo: {
    a: "Virgo",
    b: "264D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "zodiac",
      "purple-square",
      "astrology"
    ],
    k: [
      53,
      25
    ],
    o: 2
  },
  "flag-cz": {
    a: "Czechia Flag",
    b: "1F1E8-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      31
    ],
    o: 2
  },
  curly_haired_person: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F9B1",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f9b1.png",
        sheet_x: 47,
        sheet_y: 20,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F9B1",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f9b1.png",
        sheet_x: 47,
        sheet_y: 21,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F9B1",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f9b1.png",
        sheet_x: 47,
        sheet_y: 22,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F9B1",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f9b1.png",
        sheet_x: 47,
        sheet_y: 23,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F9B1",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f9b1.png",
        sheet_x: 47,
        sheet_y: 24,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Curly Haired Person",
    b: "1F9D1-200D-1F9B1",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      47,
      19
    ],
    o: 12
  },
  rice_ball: {
    a: "Rice Ball",
    b: "1F359",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "japanese"
    ],
    k: [
      6,
      49
    ],
    o: 2
  },
  hatched_chick: {
    a: "Front-Facing Baby Chick",
    b: "1F425",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "chicken",
      "baby",
      "bird"
    ],
    k: [
      12,
      9
    ],
    o: 2
  },
  jigsaw: {
    a: "Jigsaw Puzzle Piece",
    b: "1F9E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      28
    ],
    o: 11
  },
  trumpet: {
    a: "Trumpet",
    b: "1F3BA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "music",
      "brass"
    ],
    k: [
      8,
      32
    ],
    o: 2
  },
  slightly_frowning_face: {
    a: "Slightly Frowning Face",
    b: "1F641",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "frowning",
      "disappointed",
      "sad",
      "upset"
    ],
    k: [
      31,
      43
    ],
    o: 2
  },
  bullettrain_side: {
    a: "High-Speed Train",
    b: "1F684",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle"
    ],
    k: [
      34,
      3
    ],
    o: 2
  },
  libra: {
    a: "Libra",
    b: "264E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "purple-square",
      "zodiac",
      "astrology"
    ],
    k: [
      53,
      26
    ],
    o: 2
  },
  de: {
    a: "Germany Flag",
    b: "1F1E9-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "german",
      "nation",
      "flag",
      "country",
      "banner"
    ],
    k: [
      1,
      32
    ],
    n: [
      "flag-de"
    ],
    o: 2
  },
  rice: {
    a: "Cooked Rice",
    b: "1F35A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "china",
      "asian"
    ],
    k: [
      6,
      50
    ],
    o: 2
  },
  violin: {
    a: "Violin",
    b: "1F3BB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "music",
      "instrument",
      "orchestra",
      "symphony"
    ],
    k: [
      8,
      33
    ],
    o: 2
  },
  white_haired_woman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F9B3",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f9b3.png",
        sheet_x: 19,
        sheet_y: 27,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F9B3",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f9b3.png",
        sheet_x: 19,
        sheet_y: 28,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F9B3",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f9b3.png",
        sheet_x: 19,
        sheet_y: 29,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F9B3",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f9b3.png",
        sheet_x: 19,
        sheet_y: 30,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F9B3",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f9b3.png",
        sheet_x: 19,
        sheet_y: 31,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "White Haired Woman",
    b: "1F469-200D-1F9B3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      26
    ],
    o: 11
  },
  bird: {
    a: "Bird",
    b: "1F426",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "fly",
      "tweet",
      "spring"
    ],
    k: [
      12,
      10
    ],
    o: 2
  },
  white_frowning_face: {
    a: "White Frowning Face",
    b: "2639-FE0F",
    c: "2639",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      53,
      16
    ],
    o: 2
  },
  bullettrain_front: {
    a: "High-Speed Train with Bullet Nose",
    b: "1F685",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle",
      "speed",
      "fast",
      "public",
      "travel"
    ],
    k: [
      34,
      4
    ],
    o: 2
  },
  teddy_bear: {
    a: "Teddy Bear",
    b: "1F9F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      43
    ],
    o: 11
  },
  white_haired_person: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F9B3",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f9b3.png",
        sheet_x: 47,
        sheet_y: 32,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F9B3",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f9b3.png",
        sheet_x: 47,
        sheet_y: 33,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F9B3",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f9b3.png",
        sheet_x: 47,
        sheet_y: 34,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F9B3",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f9b3.png",
        sheet_x: 47,
        sheet_y: 35,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F9B3",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f9b3.png",
        sheet_x: 47,
        sheet_y: 36,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "White Haired Person",
    b: "1F9D1-200D-1F9B3",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      47,
      31
    ],
    o: 12
  },
  spades: {
    a: "Black Spade Suit",
    b: "2660-FE0F",
    c: "2660",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "poker",
      "cards",
      "suits",
      "magic"
    ],
    k: [
      53,
      33
    ],
    o: 2
  },
  banjo: {
    a: "Banjo",
    b: "1FA95",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      9
    ],
    o: 12
  },
  train2: {
    a: "Train",
    b: "1F686",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle"
    ],
    k: [
      34,
      5
    ],
    o: 2
  },
  scorpius: {
    a: "Scorpius",
    b: "264F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "zodiac",
      "purple-square",
      "astrology",
      "scorpio"
    ],
    k: [
      53,
      27
    ],
    o: 2
  },
  curry: {
    a: "Curry and Rice",
    b: "1F35B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "spicy",
      "hot",
      "indian"
    ],
    k: [
      6,
      51
    ],
    o: 2
  },
  open_mouth: {
    a: "Face with Open Mouth",
    b: "1F62E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "surprise",
      "impressed",
      "wow",
      "whoa",
      ":O"
    ],
    k: [
      31,
      24
    ],
    l: [
      ":o",
      ":-o",
      ":O",
      ":-O"
    ],
    o: 2
  },
  "flag-dg": {
    a: "Diego Garcia Flag",
    b: "1F1E9-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      33
    ],
    o: 2
  },
  penguin: {
    a: "Penguin",
    b: "1F427",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature"
    ],
    k: [
      12,
      11
    ],
    o: 2
  },
  hearts: {
    a: "Black Heart Suit",
    b: "2665-FE0F",
    c: "2665",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "poker",
      "cards",
      "magic",
      "suits"
    ],
    k: [
      53,
      35
    ],
    o: 2
  },
  ramen: {
    a: "Steaming Bowl",
    b: "1F35C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "japanese",
      "noodle",
      "chopsticks"
    ],
    k: [
      6,
      52
    ],
    o: 2
  },
  sagittarius: {
    a: "Sagittarius",
    b: "2650",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "zodiac",
      "purple-square",
      "astrology"
    ],
    k: [
      53,
      28
    ],
    o: 2
  },
  bald_woman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F9B2",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f9b2.png",
        sheet_x: 19,
        sheet_y: 21,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F9B2",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f9b2.png",
        sheet_x: 19,
        sheet_y: 22,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F9B2",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f9b2.png",
        sheet_x: 19,
        sheet_y: 23,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F9B2",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f9b2.png",
        sheet_x: 19,
        sheet_y: 24,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F9B2",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f9b2.png",
        sheet_x: 19,
        sheet_y: 25,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Bald Woman",
    b: "1F469-200D-1F9B2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      20
    ],
    o: 11
  },
  dove_of_peace: {
    a: "Dove of Peace",
    b: "1F54A-FE0F",
    c: "1F54A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      28,
      34
    ],
    o: 2
  },
  hushed: {
    a: "Hushed Face",
    b: "1F62F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "woo",
      "shh"
    ],
    k: [
      31,
      25
    ],
    o: 2
  },
  metro: {
    a: "Metro",
    b: "1F687",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "blue-square",
      "mrt",
      "underground",
      "tube"
    ],
    k: [
      34,
      6
    ],
    o: 2
  },
  "flag-dj": {
    a: "Djibouti Flag",
    b: "1F1E9-1F1EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      34
    ],
    o: 2
  },
  drum_with_drumsticks: {
    a: "Drum with Drumsticks",
    b: "1F941",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      17
    ],
    o: 4
  },
  spaghetti: {
    a: "Spaghetti",
    b: "1F35D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "italian",
      "noodle"
    ],
    k: [
      6,
      53
    ],
    o: 2
  },
  eagle: {
    a: "Eagle",
    b: "1F985",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "bird"
    ],
    k: [
      42,
      23
    ],
    o: 4
  },
  astonished: {
    a: "Astonished Face",
    b: "1F632",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "xox",
      "surprised",
      "poisoned"
    ],
    k: [
      31,
      28
    ],
    o: 2
  },
  capricorn: {
    a: "Capricorn",
    b: "2651",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "zodiac",
      "purple-square",
      "astrology"
    ],
    k: [
      53,
      29
    ],
    o: 2
  },
  light_rail: {
    a: "Light Rail",
    b: "1F688",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle"
    ],
    k: [
      34,
      7
    ],
    o: 2
  },
  "flag-dk": {
    a: "Denmark Flag",
    b: "1F1E9-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      35
    ],
    o: 2
  },
  iphone: {
    a: "Mobile Phone",
    b: "1F4F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "apple",
      "gadgets",
      "dial"
    ],
    k: [
      27,
      14
    ],
    o: 2
  },
  bald_person: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F9B2",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f9b2.png",
        sheet_x: 47,
        sheet_y: 26,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F9B2",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f9b2.png",
        sheet_x: 47,
        sheet_y: 27,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F9B2",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f9b2.png",
        sheet_x: 47,
        sheet_y: 28,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F9B2",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f9b2.png",
        sheet_x: 47,
        sheet_y: 29,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F9B2",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f9b2.png",
        sheet_x: 47,
        sheet_y: 30,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Bald Person",
    b: "1F9D1-200D-1F9B2",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      47,
      25
    ],
    o: 12
  },
  diamonds: {
    a: "Black Diamond Suit",
    b: "2666-FE0F",
    c: "2666",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "poker",
      "cards",
      "magic",
      "suits"
    ],
    k: [
      53,
      36
    ],
    o: 2
  },
  clubs: {
    a: "Black Club Suit",
    b: "2663-FE0F",
    c: "2663",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "poker",
      "cards",
      "magic",
      "suits"
    ],
    k: [
      53,
      34
    ],
    o: 2
  },
  aquarius: {
    a: "Aquarius",
    b: "2652",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "purple-square",
      "zodiac",
      "astrology"
    ],
    k: [
      53,
      30
    ],
    o: 2
  },
  sweet_potato: {
    a: "Roasted Sweet Potato",
    b: "1F360",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "nature"
    ],
    k: [
      6,
      56
    ],
    o: 2
  },
  "flag-dm": {
    a: "Dominica Flag",
    b: "1F1E9-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      36
    ],
    o: 2
  },
  duck: {
    a: "Duck",
    b: "1F986",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "bird",
      "mallard"
    ],
    k: [
      42,
      24
    ],
    o: 4
  },
  calling: {
    a: "Mobile Phone with Rightwards Arrow at Left",
    b: "1F4F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "iphone",
      "incoming"
    ],
    k: [
      27,
      15
    ],
    o: 2
  },
  station: {
    a: "Station",
    b: "1F689",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle",
      "public"
    ],
    k: [
      34,
      8
    ],
    o: 2
  },
  "blond-haired-woman": {
    skin_variations: {
      "1F3FB": {
        unified: "1F471-1F3FB-200D-2640-FE0F",
        non_qualified: "1F471-1F3FB-200D-2640",
        image: "1f471-1f3fb-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 8,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F471-1F3FC-200D-2640-FE0F",
        non_qualified: "1F471-1F3FC-200D-2640",
        image: "1f471-1f3fc-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F471-1F3FD-200D-2640-FE0F",
        non_qualified: "1F471-1F3FD-200D-2640",
        image: "1f471-1f3fd-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F471-1F3FE-200D-2640-FE0F",
        non_qualified: "1F471-1F3FE-200D-2640",
        image: "1f471-1f3fe-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F471-1F3FF-200D-2640-FE0F",
        non_qualified: "1F471-1F3FF-200D-2640",
        image: "1f471-1f3ff-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Blond Haired Woman",
    b: "1F471-200D-2640-FE0F",
    c: "1F471-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      22,
      7
    ],
    o: 4
  },
  flushed: {
    a: "Flushed Face",
    b: "1F633",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "blush",
      "shy",
      "flattered"
    ],
    k: [
      31,
      29
    ],
    o: 2
  },
  pisces: {
    a: "Pisces",
    b: "2653",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "purple-square",
      "sign",
      "zodiac",
      "astrology"
    ],
    k: [
      53,
      31
    ],
    o: 2
  },
  chess_pawn: {
    a: "Chess Pawn",
    b: "265F-FE0F",
    c: "265F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      53,
      32
    ],
    o: 11
  },
  "blond-haired-man": {
    skin_variations: {
      "1F3FB": {
        unified: "1F471-1F3FB-200D-2642-FE0F",
        non_qualified: "1F471-1F3FB-200D-2642",
        image: "1f471-1f3fb-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 14,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F471-1F3FC-200D-2642-FE0F",
        non_qualified: "1F471-1F3FC-200D-2642",
        image: "1f471-1f3fc-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F471-1F3FD-200D-2642-FE0F",
        non_qualified: "1F471-1F3FD-200D-2642",
        image: "1f471-1f3fd-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F471-1F3FE-200D-2642-FE0F",
        non_qualified: "1F471-1F3FE-200D-2642",
        image: "1f471-1f3fe-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F471-1F3FF-200D-2642-FE0F",
        non_qualified: "1F471-1F3FF-200D-2642",
        image: "1f471-1f3ff-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F471",
    a: "Blond Haired Man",
    b: "1F471-200D-2642-FE0F",
    c: "1F471-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      22,
      13
    ],
    o: 4
  },
  phone: {
    a: "Black Telephone",
    b: "260E-FE0F",
    c: "260E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "communication",
      "dial",
      "telephone"
    ],
    k: [
      52,
      54
    ],
    n: [
      "telephone"
    ],
    o: 2
  },
  oden: {
    a: "Oden",
    b: "1F362",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "japanese"
    ],
    k: [
      7,
      1
    ],
    o: 2
  },
  "flag-do": {
    a: "Dominican Republic Flag",
    b: "1F1E9-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      37
    ],
    o: 2
  },
  tram: {
    a: "Tram",
    b: "1F68A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle"
    ],
    k: [
      34,
      9
    ],
    o: 2
  },
  swan: {
    a: "Swan",
    b: "1F9A2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      52
    ],
    o: 11
  },
  pleading_face: {
    a: "Face with Pleading Eyes",
    b: "1F97A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      12
    ],
    o: 11
  },
  "flag-dz": {
    a: "Algeria Flag",
    b: "1F1E9-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      38
    ],
    o: 2
  },
  monorail: {
    a: "Monorail",
    b: "1F69D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle"
    ],
    k: [
      34,
      28
    ],
    o: 2
  },
  owl: {
    a: "Owl",
    b: "1F989",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "bird",
      "hoot"
    ],
    k: [
      42,
      27
    ],
    o: 4
  },
  sushi: {
    a: "Sushi",
    b: "1F363",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "fish",
      "japanese",
      "rice"
    ],
    k: [
      7,
      2
    ],
    o: 2
  },
  telephone_receiver: {
    a: "Telephone Receiver",
    b: "1F4DE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "communication",
      "dial"
    ],
    k: [
      26,
      52
    ],
    o: 2
  },
  black_joker: {
    a: "Playing Card Black Joker",
    b: "1F0CF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "poker",
      "cards",
      "game",
      "play",
      "magic"
    ],
    k: [
      0,
      15
    ],
    o: 2
  },
  ophiuchus: {
    a: "Ophiuchus",
    b: "26CE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sign",
      "purple-square",
      "constellation",
      "astrology"
    ],
    k: [
      54,
      4
    ],
    o: 2
  },
  frowning: {
    a: "Frowning Face with Open Mouth",
    b: "1F626",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "aw",
      "what"
    ],
    k: [
      31,
      16
    ],
    o: 2
  },
  older_adult: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D3-1F3FB",
        non_qualified: null,
        image: "1f9d3-1f3fb.png",
        sheet_x: 48,
        sheet_y: 23,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9D3-1F3FC",
        non_qualified: null,
        image: "1f9d3-1f3fc.png",
        sheet_x: 48,
        sheet_y: 24,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9D3-1F3FD",
        non_qualified: null,
        image: "1f9d3-1f3fd.png",
        sheet_x: 48,
        sheet_y: 25,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9D3-1F3FE",
        non_qualified: null,
        image: "1f9d3-1f3fe.png",
        sheet_x: 48,
        sheet_y: 26,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9D3-1F3FF",
        non_qualified: null,
        image: "1f9d3-1f3ff.png",
        sheet_x: 48,
        sheet_y: 27,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Older Adult",
    b: "1F9D3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      48,
      22
    ],
    o: 5
  },
  "flag-ea": {
    a: "Ceuta & Melilla Flag",
    b: "1F1EA-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      39
    ],
    o: 2
  },
  flamingo: {
    a: "Flamingo",
    b: "1F9A9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      0
    ],
    o: 12
  },
  pager: {
    a: "Pager",
    b: "1F4DF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bbcall",
      "oldschool",
      "90s"
    ],
    k: [
      26,
      53
    ],
    o: 2
  },
  mountain_railway: {
    a: "Mountain Railway",
    b: "1F69E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle"
    ],
    k: [
      34,
      29
    ],
    o: 2
  },
  mahjong: {
    a: "Mahjong Tile Red Dragon",
    b: "1F004",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "game",
      "play",
      "chinese",
      "kanji"
    ],
    k: [
      0,
      14
    ],
    o: 2
  },
  older_man: {
    skin_variations: {
      "1F3FB": {
        unified: "1F474-1F3FB",
        non_qualified: null,
        image: "1f474-1f3fb.png",
        sheet_x: 22,
        sheet_y: 50,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F474-1F3FC",
        non_qualified: null,
        image: "1f474-1f3fc.png",
        sheet_x: 22,
        sheet_y: 51,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F474-1F3FD",
        non_qualified: null,
        image: "1f474-1f3fd.png",
        sheet_x: 22,
        sheet_y: 52,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F474-1F3FE",
        non_qualified: null,
        image: "1f474-1f3fe.png",
        sheet_x: 22,
        sheet_y: 53,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F474-1F3FF",
        non_qualified: null,
        image: "1f474-1f3ff.png",
        sheet_x: 22,
        sheet_y: 54,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Older Man",
    b: "1F474",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "human",
      "male",
      "men",
      "old",
      "elder",
      "senior"
    ],
    k: [
      22,
      49
    ],
    o: 2
  },
  twisted_rightwards_arrows: {
    a: "Twisted Rightwards Arrows",
    b: "1F500",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "shuffle",
      "music",
      "random"
    ],
    k: [
      27,
      28
    ],
    o: 2
  },
  fried_shrimp: {
    a: "Fried Shrimp",
    b: "1F364",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "animal",
      "appetizer",
      "summer"
    ],
    k: [
      7,
      3
    ],
    o: 2
  },
  anguished: {
    a: "Anguished Face",
    b: "1F627",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "stunned",
      "nervous"
    ],
    k: [
      31,
      17
    ],
    l: [
      "D:"
    ],
    o: 2
  },
  repeat: {
    a: "Clockwise Rightwards and Leftwards Open Circle Arrows",
    b: "1F501",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "loop",
      "record"
    ],
    k: [
      27,
      29
    ],
    o: 2
  },
  fish_cake: {
    a: "Fish Cake with Swirl Design",
    b: "1F365",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "japan",
      "sea",
      "beach",
      "narutomaki",
      "pink",
      "swirl",
      "kamaboko",
      "surimi",
      "ramen"
    ],
    k: [
      7,
      4
    ],
    o: 2
  },
  fax: {
    a: "Fax Machine",
    b: "1F4E0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "communication",
      "technology"
    ],
    k: [
      26,
      54
    ],
    o: 2
  },
  older_woman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F475-1F3FB",
        non_qualified: null,
        image: "1f475-1f3fb.png",
        sheet_x: 22,
        sheet_y: 56,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F475-1F3FC",
        non_qualified: null,
        image: "1f475-1f3fc.png",
        sheet_x: 23,
        sheet_y: 0,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F475-1F3FD",
        non_qualified: null,
        image: "1f475-1f3fd.png",
        sheet_x: 23,
        sheet_y: 1,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F475-1F3FE",
        non_qualified: null,
        image: "1f475-1f3fe.png",
        sheet_x: 23,
        sheet_y: 2,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F475-1F3FF",
        non_qualified: null,
        image: "1f475-1f3ff.png",
        sheet_x: 23,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Older Woman",
    b: "1F475",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "human",
      "female",
      "women",
      "lady",
      "old",
      "elder",
      "senior"
    ],
    k: [
      22,
      55
    ],
    o: 2
  },
  "flag-ec": {
    a: "Ecuador Flag",
    b: "1F1EA-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      40
    ],
    o: 2
  },
  peacock: {
    a: "Peacock",
    b: "1F99A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      44
    ],
    o: 11
  },
  fearful: {
    a: "Fearful Face",
    b: "1F628",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "scared",
      "terrified",
      "nervous",
      "oops",
      "huh"
    ],
    k: [
      31,
      18
    ],
    o: 2
  },
  train: {
    a: "Tram Car",
    b: "1F68B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle",
      "carriage",
      "public",
      "travel"
    ],
    k: [
      34,
      10
    ],
    o: 2
  },
  flower_playing_cards: {
    a: "Flower Playing Cards",
    b: "1F3B4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "game",
      "sunset",
      "red"
    ],
    k: [
      8,
      26
    ],
    o: 2
  },
  repeat_one: {
    a: "Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay",
    b: "1F502",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "loop"
    ],
    k: [
      27,
      30
    ],
    o: 2
  },
  moon_cake: {
    a: "Moon Cake",
    b: "1F96E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      4
    ],
    o: 11
  },
  performing_arts: {
    a: "Performing Arts",
    b: "1F3AD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "acting",
      "theater",
      "drama"
    ],
    k: [
      8,
      19
    ],
    o: 2
  },
  cold_sweat: {
    a: "Face with Open Mouth and Cold Sweat",
    b: "1F630",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "nervous",
      "sweat"
    ],
    k: [
      31,
      26
    ],
    o: 2
  },
  person_frowning: {
    skin_variations: {
      "1F3FB": {
        unified: "1F64D-1F3FB",
        non_qualified: null,
        image: "1f64d-1f3fb.png",
        sheet_x: 33,
        sheet_y: 27,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F64D-1F3FC",
        non_qualified: null,
        image: "1f64d-1f3fc.png",
        sheet_x: 33,
        sheet_y: 28,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F64D-1F3FD",
        non_qualified: null,
        image: "1f64d-1f3fd.png",
        sheet_x: 33,
        sheet_y: 29,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F64D-1F3FE",
        non_qualified: null,
        image: "1f64d-1f3fe.png",
        sheet_x: 33,
        sheet_y: 30,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F64D-1F3FF",
        non_qualified: null,
        image: "1f64d-1f3ff.png",
        sheet_x: 33,
        sheet_y: 31,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F64D-200D-2640-FE0F",
    a: "Person Frowning",
    b: "1F64D",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      33,
      26
    ],
    o: 2
  },
  "flag-ee": {
    a: "Estonia Flag",
    b: "1F1EA-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      41
    ],
    o: 2
  },
  battery: {
    a: "Battery",
    b: "1F50B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "power",
      "energy",
      "sustain"
    ],
    k: [
      27,
      39
    ],
    o: 2
  },
  parrot: {
    a: "Parrot",
    b: "1F99C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      46
    ],
    o: 11
  },
  bus: {
    a: "Bus",
    b: "1F68C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "car",
      "vehicle",
      "transportation"
    ],
    k: [
      34,
      11
    ],
    o: 2
  },
  "flag-eg": {
    a: "Egypt Flag",
    b: "1F1EA-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      42
    ],
    o: 2
  },
  arrow_forward: {
    a: "Black Right-Pointing Triangle",
    b: "25B6-FE0F",
    c: "25B6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "right",
      "direction",
      "play"
    ],
    k: [
      52,
      43
    ],
    o: 2
  },
  "man-frowning": {
    skin_variations: {
      "1F3FB": {
        unified: "1F64D-1F3FB-200D-2642-FE0F",
        non_qualified: "1F64D-1F3FB-200D-2642",
        image: "1f64d-1f3fb-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 21,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F64D-1F3FC-200D-2642-FE0F",
        non_qualified: "1F64D-1F3FC-200D-2642",
        image: "1f64d-1f3fc-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 22,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F64D-1F3FD-200D-2642-FE0F",
        non_qualified: "1F64D-1F3FD-200D-2642",
        image: "1f64d-1f3fd-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 23,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F64D-1F3FE-200D-2642-FE0F",
        non_qualified: "1F64D-1F3FE-200D-2642",
        image: "1f64d-1f3fe-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 24,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F64D-1F3FF-200D-2642-FE0F",
        non_qualified: "1F64D-1F3FF-200D-2642",
        image: "1f64d-1f3ff-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 25,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Frowning",
    b: "1F64D-200D-2642-FE0F",
    c: "1F64D-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      33,
      20
    ],
    o: 4
  },
  disappointed_relieved: {
    a: "Disappointed but Relieved Face",
    b: "1F625",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "phew",
      "sweat",
      "nervous"
    ],
    k: [
      31,
      15
    ],
    o: 2
  },
  electric_plug: {
    a: "Electric Plug",
    b: "1F50C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "charger",
      "power"
    ],
    k: [
      27,
      40
    ],
    o: 2
  },
  frame_with_picture: {
    a: "Frame with Picture",
    b: "1F5BC-FE0F",
    c: "1F5BC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      14
    ],
    o: 2
  },
  oncoming_bus: {
    a: "Oncoming Bus",
    b: "1F68D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "transportation"
    ],
    k: [
      34,
      12
    ],
    o: 2
  },
  dango: {
    a: "Dango",
    b: "1F361",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "dessert",
      "sweet",
      "japanese",
      "barbecue",
      "meat"
    ],
    k: [
      7,
      0
    ],
    o: 2
  },
  frog: {
    a: "Frog Face",
    b: "1F438",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "croak",
      "toad"
    ],
    k: [
      12,
      28
    ],
    o: 2
  },
  computer: {
    a: "Personal Computer",
    b: "1F4BB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "laptop",
      "screen",
      "display",
      "monitor"
    ],
    k: [
      26,
      17
    ],
    o: 2
  },
  art: {
    a: "Artist Palette",
    b: "1F3A8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "design",
      "paint",
      "draw",
      "colors"
    ],
    k: [
      8,
      14
    ],
    o: 2
  },
  "flag-eh": {
    a: "Western Sahara Flag",
    b: "1F1EA-1F1ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      43
    ],
    o: 2
  },
  fast_forward: {
    a: "Black Right-Pointing Double Triangle",
    b: "23E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "play",
      "speed",
      "continue"
    ],
    k: [
      52,
      26
    ],
    o: 2
  },
  cry: {
    a: "Crying Face",
    b: "1F622",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "tears",
      "sad",
      "depressed",
      "upset",
      ":'("
    ],
    k: [
      31,
      12
    ],
    l: [
      ":'("
    ],
    m: ":'(",
    o: 2
  },
  "woman-frowning": {
    skin_variations: {
      "1F3FB": {
        unified: "1F64D-1F3FB-200D-2640-FE0F",
        non_qualified: "1F64D-1F3FB-200D-2640",
        image: "1f64d-1f3fb-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F64D-1F3FC-200D-2640-FE0F",
        non_qualified: "1F64D-1F3FC-200D-2640",
        image: "1f64d-1f3fc-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F64D-1F3FD-200D-2640-FE0F",
        non_qualified: "1F64D-1F3FD-200D-2640",
        image: "1f64d-1f3fd-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F64D-1F3FE-200D-2640-FE0F",
        non_qualified: "1F64D-1F3FE-200D-2640",
        image: "1f64d-1f3fe-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F64D-1F3FF-200D-2640-FE0F",
        non_qualified: "1F64D-1F3FF-200D-2640",
        image: "1f64d-1f3ff-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F64D",
    a: "Woman Frowning",
    b: "1F64D-200D-2640-FE0F",
    c: "1F64D-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      33,
      14
    ],
    o: 4
  },
  trolleybus: {
    a: "Trolleybus",
    b: "1F68E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bart",
      "transportation",
      "vehicle"
    ],
    k: [
      34,
      13
    ],
    o: 2
  },
  crocodile: {
    a: "Crocodile",
    b: "1F40A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "reptile",
      "lizard",
      "alligator"
    ],
    k: [
      11,
      38
    ],
    o: 2
  },
  dumpling: {
    a: "Dumpling",
    b: "1F95F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      46
    ],
    o: 5
  },
  black_right_pointing_double_triangle_with_vertical_bar: {
    a: "Black Right Pointing Double Triangle with Vertical Bar",
    b: "23ED-FE0F",
    c: "23ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      30
    ],
    o: 2
  },
  desktop_computer: {
    a: "Desktop Computer",
    b: "1F5A5-FE0F",
    c: "1F5A5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "computing",
      "screen"
    ],
    k: [
      30,
      10
    ],
    o: 2
  },
  person_with_pouting_face: {
    skin_variations: {
      "1F3FB": {
        unified: "1F64E-1F3FB",
        non_qualified: null,
        image: "1f64e-1f3fb.png",
        sheet_x: 33,
        sheet_y: 45,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F64E-1F3FC",
        non_qualified: null,
        image: "1f64e-1f3fc.png",
        sheet_x: 33,
        sheet_y: 46,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F64E-1F3FD",
        non_qualified: null,
        image: "1f64e-1f3fd.png",
        sheet_x: 33,
        sheet_y: 47,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F64E-1F3FE",
        non_qualified: null,
        image: "1f64e-1f3fe.png",
        sheet_x: 33,
        sheet_y: 48,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F64E-1F3FF",
        non_qualified: null,
        image: "1f64e-1f3ff.png",
        sheet_x: 33,
        sheet_y: 49,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F64E-200D-2640-FE0F",
    a: "Person with Pouting Face",
    b: "1F64E",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      33,
      44
    ],
    o: 2
  },
  turtle: {
    a: "Turtle",
    b: "1F422",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "slow",
      "nature",
      "tortoise"
    ],
    k: [
      12,
      6
    ],
    o: 2
  },
  sob: {
    a: "Loudly Crying Face",
    b: "1F62D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "cry",
      "tears",
      "sad",
      "upset",
      "depressed"
    ],
    k: [
      31,
      23
    ],
    m: ":'(",
    o: 2
  },
  "flag-er": {
    a: "Eritrea Flag",
    b: "1F1EA-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      44
    ],
    o: 2
  },
  thread: {
    a: "Spool of Thread",
    b: "1F9F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      40
    ],
    o: 11
  },
  minibus: {
    a: "Minibus",
    b: "1F690",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "car",
      "transportation"
    ],
    k: [
      34,
      15
    ],
    o: 2
  },
  fortune_cookie: {
    a: "Fortune Cookie",
    b: "1F960",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      47
    ],
    o: 5
  },
  yarn: {
    a: "Ball of Yarn",
    b: "1F9F6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      41
    ],
    o: 11
  },
  takeout_box: {
    a: "Takeout Box",
    b: "1F961",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      48
    ],
    o: 5
  },
  "man-pouting": {
    skin_variations: {
      "1F3FB": {
        unified: "1F64E-1F3FB-200D-2642-FE0F",
        non_qualified: "1F64E-1F3FB-200D-2642",
        image: "1f64e-1f3fb-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F64E-1F3FC-200D-2642-FE0F",
        non_qualified: "1F64E-1F3FC-200D-2642",
        image: "1f64e-1f3fc-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F64E-1F3FD-200D-2642-FE0F",
        non_qualified: "1F64E-1F3FD-200D-2642",
        image: "1f64e-1f3fd-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F64E-1F3FE-200D-2642-FE0F",
        non_qualified: "1F64E-1F3FE-200D-2642",
        image: "1f64e-1f3fe-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F64E-1F3FF-200D-2642-FE0F",
        non_qualified: "1F64E-1F3FF-200D-2642",
        image: "1f64e-1f3ff-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Pouting",
    b: "1F64E-200D-2642-FE0F",
    c: "1F64E-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      33,
      38
    ],
    o: 4
  },
  printer: {
    a: "Printer",
    b: "1F5A8-FE0F",
    c: "1F5A8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "paper",
      "ink"
    ],
    k: [
      30,
      11
    ],
    o: 2
  },
  scream: {
    a: "Face Screaming in Fear",
    b: "1F631",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "munch",
      "scared",
      "omg"
    ],
    k: [
      31,
      27
    ],
    o: 2
  },
  es: {
    a: "Spain Flag",
    b: "1F1EA-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "spain",
      "flag",
      "nation",
      "country",
      "banner"
    ],
    k: [
      1,
      45
    ],
    n: [
      "flag-es"
    ],
    o: 2
  },
  ambulance: {
    a: "Ambulance",
    b: "1F691",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "health",
      "911",
      "hospital"
    ],
    k: [
      34,
      16
    ],
    o: 2
  },
  black_right_pointing_triangle_with_double_vertical_bar: {
    a: "Black Right Pointing Triangle with Double Vertical Bar",
    b: "23EF-FE0F",
    c: "23EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      32
    ],
    o: 2
  },
  lizard: {
    a: "Lizard",
    b: "1F98E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "reptile"
    ],
    k: [
      42,
      32
    ],
    o: 4
  },
  "flag-et": {
    a: "Ethiopia Flag",
    b: "1F1EA-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      46
    ],
    o: 2
  },
  keyboard: {
    a: "Keyboard",
    b: "2328-FE0F",
    c: "2328",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "computer",
      "type",
      "input",
      "text"
    ],
    k: [
      52,
      24
    ],
    o: 2
  },
  crab: {
    a: "Crab",
    b: "1F980",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "crustacean"
    ],
    k: [
      42,
      18
    ],
    o: 2
  },
  confounded: {
    a: "Confounded Face",
    b: "1F616",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "confused",
      "sick",
      "unwell",
      "oops",
      ":S"
    ],
    k: [
      31,
      0
    ],
    o: 2
  },
  snake: {
    a: "Snake",
    b: "1F40D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "evil",
      "nature",
      "hiss",
      "python"
    ],
    k: [
      11,
      41
    ],
    o: 2
  },
  "woman-pouting": {
    skin_variations: {
      "1F3FB": {
        unified: "1F64E-1F3FB-200D-2640-FE0F",
        non_qualified: "1F64E-1F3FB-200D-2640",
        image: "1f64e-1f3fb-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 33,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F64E-1F3FC-200D-2640-FE0F",
        non_qualified: "1F64E-1F3FC-200D-2640",
        image: "1f64e-1f3fc-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 34,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F64E-1F3FD-200D-2640-FE0F",
        non_qualified: "1F64E-1F3FD-200D-2640",
        image: "1f64e-1f3fd-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 35,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F64E-1F3FE-200D-2640-FE0F",
        non_qualified: "1F64E-1F3FE-200D-2640",
        image: "1f64e-1f3fe-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F64E-1F3FF-200D-2640-FE0F",
        non_qualified: "1F64E-1F3FF-200D-2640",
        image: "1f64e-1f3ff-200d-2640-fe0f.png",
        sheet_x: 33,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F64E",
    a: "Woman Pouting",
    b: "1F64E-200D-2640-FE0F",
    c: "1F64E-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      33,
      32
    ],
    o: 4
  },
  arrow_backward: {
    a: "Black Left-Pointing Triangle",
    b: "25C0-FE0F",
    c: "25C0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "left",
      "direction"
    ],
    k: [
      52,
      44
    ],
    o: 2
  },
  fire_engine: {
    a: "Fire Engine",
    b: "1F692",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "cars",
      "vehicle"
    ],
    k: [
      34,
      17
    ],
    o: 2
  },
  rewind: {
    a: "Black Left-Pointing Double Triangle",
    b: "23EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "play",
      "blue-square"
    ],
    k: [
      52,
      27
    ],
    o: 2
  },
  three_button_mouse: {
    a: "Three Button Mouse",
    b: "1F5B1-FE0F",
    c: "1F5B1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      12
    ],
    o: 2
  },
  no_good: {
    skin_variations: {
      "1F3FB": {
        unified: "1F645-1F3FB",
        non_qualified: null,
        image: "1f645-1f3fb.png",
        sheet_x: 32,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F645-1F3FC",
        non_qualified: null,
        image: "1f645-1f3fc.png",
        sheet_x: 32,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F645-1F3FD",
        non_qualified: null,
        image: "1f645-1f3fd.png",
        sheet_x: 32,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F645-1F3FE",
        non_qualified: null,
        image: "1f645-1f3fe.png",
        sheet_x: 32,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F645-1F3FF",
        non_qualified: null,
        image: "1f645-1f3ff.png",
        sheet_x: 32,
        sheet_y: 7,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F645-200D-2640-FE0F",
    a: "Face with No Good Gesture",
    b: "1F645",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      32,
      2
    ],
    o: 2
  },
  police_car: {
    a: "Police Car",
    b: "1F693",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "cars",
      "transportation",
      "law",
      "legal",
      "enforcement"
    ],
    k: [
      34,
      18
    ],
    o: 2
  },
  dragon_face: {
    a: "Dragon Face",
    b: "1F432",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "myth",
      "nature",
      "chinese",
      "green"
    ],
    k: [
      12,
      22
    ],
    o: 2
  },
  persevere: {
    a: "Persevering Face",
    b: "1F623",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "sick",
      "no",
      "upset",
      "oops"
    ],
    k: [
      31,
      13
    ],
    o: 2
  },
  lobster: {
    a: "Lobster",
    b: "1F99E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      48
    ],
    o: 11
  },
  "flag-eu": {
    a: "European Union Flag",
    b: "1F1EA-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      47
    ],
    o: 2
  },
  disappointed: {
    a: "Disappointed Face",
    b: "1F61E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "sad",
      "upset",
      "depressed",
      ":("
    ],
    k: [
      31,
      8
    ],
    l: [
      "):",
      ":(",
      ":-("
    ],
    m: ":(",
    o: 2
  },
  shrimp: {
    a: "Shrimp",
    b: "1F990",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "ocean",
      "nature",
      "seafood"
    ],
    k: [
      42,
      34
    ],
    o: 4
  },
  dragon: {
    a: "Dragon",
    b: "1F409",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "myth",
      "nature",
      "chinese",
      "green"
    ],
    k: [
      11,
      37
    ],
    o: 2
  },
  "man-gesturing-no": {
    skin_variations: {
      "1F3FB": {
        unified: "1F645-1F3FB-200D-2642-FE0F",
        non_qualified: "1F645-1F3FB-200D-2642",
        image: "1f645-1f3fb-200d-2642-fe0f.png",
        sheet_x: 31,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F645-1F3FC-200D-2642-FE0F",
        non_qualified: "1F645-1F3FC-200D-2642",
        image: "1f645-1f3fc-200d-2642-fe0f.png",
        sheet_x: 31,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F645-1F3FD-200D-2642-FE0F",
        non_qualified: "1F645-1F3FD-200D-2642",
        image: "1f645-1f3fd-200d-2642-fe0f.png",
        sheet_x: 31,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F645-1F3FE-200D-2642-FE0F",
        non_qualified: "1F645-1F3FE-200D-2642",
        image: "1f645-1f3fe-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F645-1F3FF-200D-2642-FE0F",
        non_qualified: "1F645-1F3FF-200D-2642",
        image: "1f645-1f3ff-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Gesturing No",
    b: "1F645-200D-2642-FE0F",
    c: "1F645-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      31,
      53
    ],
    o: 4
  },
  "flag-fi": {
    a: "Finland Flag",
    b: "1F1EB-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      48
    ],
    o: 2
  },
  trackball: {
    a: "Trackball",
    b: "1F5B2-FE0F",
    c: "1F5B2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "trackpad"
    ],
    k: [
      30,
      13
    ],
    o: 2
  },
  black_left_pointing_double_triangle_with_vertical_bar: {
    a: "Black Left Pointing Double Triangle with Vertical Bar",
    b: "23EE-FE0F",
    c: "23EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      31
    ],
    o: 2
  },
  oncoming_police_car: {
    a: "Oncoming Police Car",
    b: "1F694",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "law",
      "legal",
      "enforcement",
      "911"
    ],
    k: [
      34,
      19
    ],
    o: 2
  },
  minidisc: {
    a: "Minidisc",
    b: "1F4BD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "record",
      "data",
      "disk",
      "90s"
    ],
    k: [
      26,
      19
    ],
    o: 2
  },
  sweat: {
    a: "Face with Cold Sweat",
    b: "1F613",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "hot",
      "sad",
      "tired",
      "exercise"
    ],
    k: [
      30,
      54
    ],
    o: 2
  },
  squid: {
    a: "Squid",
    b: "1F991",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "ocean",
      "sea"
    ],
    k: [
      42,
      35
    ],
    o: 4
  },
  sauropod: {
    a: "Sauropod",
    b: "1F995",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      39
    ],
    o: 5
  },
  arrow_up_small: {
    a: "Up-Pointing Small Red Triangle",
    b: "1F53C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "triangle",
      "direction",
      "point",
      "forward",
      "top"
    ],
    k: [
      28,
      31
    ],
    o: 2
  },
  "flag-fj": {
    a: "Fiji Flag",
    b: "1F1EB-1F1EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      49
    ],
    o: 2
  },
  "woman-gesturing-no": {
    skin_variations: {
      "1F3FB": {
        unified: "1F645-1F3FB-200D-2640-FE0F",
        non_qualified: "1F645-1F3FB-200D-2640",
        image: "1f645-1f3fb-200d-2640-fe0f.png",
        sheet_x: 31,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F645-1F3FC-200D-2640-FE0F",
        non_qualified: "1F645-1F3FC-200D-2640",
        image: "1f645-1f3fc-200d-2640-fe0f.png",
        sheet_x: 31,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F645-1F3FD-200D-2640-FE0F",
        non_qualified: "1F645-1F3FD-200D-2640",
        image: "1f645-1f3fd-200d-2640-fe0f.png",
        sheet_x: 31,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F645-1F3FE-200D-2640-FE0F",
        non_qualified: "1F645-1F3FE-200D-2640",
        image: "1f645-1f3fe-200d-2640-fe0f.png",
        sheet_x: 31,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F645-1F3FF-200D-2640-FE0F",
        non_qualified: "1F645-1F3FF-200D-2640",
        image: "1f645-1f3ff-200d-2640-fe0f.png",
        sheet_x: 31,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F645",
    a: "Woman Gesturing No",
    b: "1F645-200D-2640-FE0F",
    c: "1F645-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      31,
      47
    ],
    o: 4
  },
  taxi: {
    a: "Taxi",
    b: "1F695",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "uber",
      "vehicle",
      "cars",
      "transportation"
    ],
    k: [
      34,
      20
    ],
    o: 2
  },
  "flag-fk": {
    a: "Falkland Islands Flag",
    b: "1F1EB-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      50
    ],
    o: 2
  },
  floppy_disk: {
    a: "Floppy Disk",
    b: "1F4BE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "oldschool",
      "technology",
      "save",
      "90s",
      "80s"
    ],
    k: [
      26,
      20
    ],
    o: 2
  },
  "t-rex": {
    a: "T-Rex",
    b: "1F996",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      40
    ],
    o: 5
  },
  oyster: {
    a: "Oyster",
    b: "1F9AA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      1
    ],
    o: 12
  },
  arrow_double_up: {
    a: "Black Up-Pointing Double Triangle",
    b: "23EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "direction",
      "top"
    ],
    k: [
      52,
      28
    ],
    o: 2
  },
  oncoming_taxi: {
    a: "Oncoming Taxi",
    b: "1F696",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "cars",
      "uber"
    ],
    k: [
      34,
      21
    ],
    o: 2
  },
  ok_woman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F646-1F3FB",
        non_qualified: null,
        image: "1f646-1f3fb.png",
        sheet_x: 32,
        sheet_y: 21,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F646-1F3FC",
        non_qualified: null,
        image: "1f646-1f3fc.png",
        sheet_x: 32,
        sheet_y: 22,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F646-1F3FD",
        non_qualified: null,
        image: "1f646-1f3fd.png",
        sheet_x: 32,
        sheet_y: 23,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F646-1F3FE",
        non_qualified: null,
        image: "1f646-1f3fe.png",
        sheet_x: 32,
        sheet_y: 24,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F646-1F3FF",
        non_qualified: null,
        image: "1f646-1f3ff.png",
        sheet_x: 32,
        sheet_y: 25,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F646-200D-2640-FE0F",
    a: "Face with Ok Gesture",
    b: "1F646",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "women",
      "girl",
      "female",
      "pink",
      "human",
      "woman"
    ],
    k: [
      32,
      20
    ],
    o: 2
  },
  weary: {
    a: "Weary Face",
    b: "1F629",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "tired",
      "sleepy",
      "sad",
      "frustrated",
      "upset"
    ],
    k: [
      31,
      19
    ],
    o: 2
  },
  "man-gesturing-ok": {
    skin_variations: {
      "1F3FB": {
        unified: "1F646-1F3FB-200D-2642-FE0F",
        non_qualified: "1F646-1F3FB-200D-2642",
        image: "1f646-1f3fb-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F646-1F3FC-200D-2642-FE0F",
        non_qualified: "1F646-1F3FC-200D-2642",
        image: "1f646-1f3fc-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F646-1F3FD-200D-2642-FE0F",
        non_qualified: "1F646-1F3FD-200D-2642",
        image: "1f646-1f3fd-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F646-1F3FE-200D-2642-FE0F",
        non_qualified: "1F646-1F3FE-200D-2642",
        image: "1f646-1f3fe-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F646-1F3FF-200D-2642-FE0F",
        non_qualified: "1F646-1F3FF-200D-2642",
        image: "1f646-1f3ff-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Gesturing Ok",
    b: "1F646-200D-2642-FE0F",
    c: "1F646-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      32,
      14
    ],
    o: 4
  },
  arrow_down_small: {
    a: "Down-Pointing Small Red Triangle",
    b: "1F53D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "direction",
      "bottom"
    ],
    k: [
      28,
      32
    ],
    o: 2
  },
  tired_face: {
    a: "Tired Face",
    b: "1F62B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sick",
      "whine",
      "upset",
      "frustrated"
    ],
    k: [
      31,
      21
    ],
    o: 2
  },
  car: {
    a: "Automobile",
    b: "1F697",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      34,
      22
    ],
    n: [
      "red_car"
    ],
    o: 2
  },
  icecream: {
    a: "Soft Ice Cream",
    b: "1F366",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "hot",
      "dessert",
      "summer"
    ],
    k: [
      7,
      5
    ],
    o: 2
  },
  cd: {
    a: "Optical Disc",
    b: "1F4BF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "dvd",
      "disk",
      "disc",
      "90s"
    ],
    k: [
      26,
      21
    ],
    o: 2
  },
  whale: {
    a: "Spouting Whale",
    b: "1F433",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "sea",
      "ocean"
    ],
    k: [
      12,
      23
    ],
    o: 2
  },
  "flag-fm": {
    a: "Micronesia Flag",
    b: "1F1EB-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      51
    ],
    o: 2
  },
  oncoming_automobile: {
    a: "Oncoming Automobile",
    b: "1F698",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "car",
      "vehicle",
      "transportation"
    ],
    k: [
      34,
      23
    ],
    o: 2
  },
  arrow_double_down: {
    a: "Black Down-Pointing Double Triangle",
    b: "23EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "direction",
      "bottom"
    ],
    k: [
      52,
      29
    ],
    o: 2
  },
  "woman-gesturing-ok": {
    skin_variations: {
      "1F3FB": {
        unified: "1F646-1F3FB-200D-2640-FE0F",
        non_qualified: "1F646-1F3FB-200D-2640",
        image: "1f646-1f3fb-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F646-1F3FC-200D-2640-FE0F",
        non_qualified: "1F646-1F3FC-200D-2640",
        image: "1f646-1f3fc-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F646-1F3FD-200D-2640-FE0F",
        non_qualified: "1F646-1F3FD-200D-2640",
        image: "1f646-1f3fd-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F646-1F3FE-200D-2640-FE0F",
        non_qualified: "1F646-1F3FE-200D-2640",
        image: "1f646-1f3fe-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F646-1F3FF-200D-2640-FE0F",
        non_qualified: "1F646-1F3FF-200D-2640",
        image: "1f646-1f3ff-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F646",
    a: "Woman Gesturing Ok",
    b: "1F646-200D-2640-FE0F",
    c: "1F646-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      32,
      8
    ],
    o: 4
  },
  yawning_face: {
    a: "Yawning Face",
    b: "1F971",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      7
    ],
    o: 12
  },
  dvd: {
    a: "Dvd",
    b: "1F4C0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "cd",
      "disk",
      "disc"
    ],
    k: [
      26,
      22
    ],
    o: 2
  },
  whale2: {
    a: "Whale",
    b: "1F40B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "sea",
      "ocean"
    ],
    k: [
      11,
      39
    ],
    o: 2
  },
  "flag-fo": {
    a: "Faroe Islands Flag",
    b: "1F1EB-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      52
    ],
    o: 2
  },
  shaved_ice: {
    a: "Shaved Ice",
    b: "1F367",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hot",
      "dessert",
      "summer"
    ],
    k: [
      7,
      6
    ],
    o: 2
  },
  double_vertical_bar: {
    a: "Double Vertical Bar",
    b: "23F8-FE0F",
    c: "23F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      37
    ],
    o: 2
  },
  information_desk_person: {
    skin_variations: {
      "1F3FB": {
        unified: "1F481-1F3FB",
        non_qualified: null,
        image: "1f481-1f3fb.png",
        sheet_x: 24,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F481-1F3FC",
        non_qualified: null,
        image: "1f481-1f3fc.png",
        sheet_x: 24,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F481-1F3FD",
        non_qualified: null,
        image: "1f481-1f3fd.png",
        sheet_x: 24,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F481-1F3FE",
        non_qualified: null,
        image: "1f481-1f3fe.png",
        sheet_x: 24,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F481-1F3FF",
        non_qualified: null,
        image: "1f481-1f3ff.png",
        sheet_x: 24,
        sheet_y: 7,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F481-200D-2640-FE0F",
    a: "Information Desk Person",
    b: "1F481",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      24,
      2
    ],
    o: 2
  },
  dolphin: {
    a: "Dolphin",
    b: "1F42C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "fish",
      "sea",
      "ocean",
      "flipper",
      "fins",
      "beach"
    ],
    k: [
      12,
      16
    ],
    n: [
      "flipper"
    ],
    o: 2
  },
  blue_car: {
    a: "Recreational Vehicle",
    b: "1F699",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle"
    ],
    k: [
      34,
      24
    ],
    o: 2
  },
  ice_cream: {
    a: "Ice Cream",
    b: "1F368",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "hot",
      "dessert"
    ],
    k: [
      7,
      7
    ],
    o: 2
  },
  fr: {
    a: "France Flag",
    b: "1F1EB-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "banner",
      "flag",
      "nation",
      "france",
      "french",
      "country"
    ],
    k: [
      1,
      53
    ],
    n: [
      "flag-fr"
    ],
    o: 2
  },
  triumph: {
    a: "Face with Look of Triumph",
    b: "1F624",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "gas",
      "phew",
      "proud",
      "pride"
    ],
    k: [
      31,
      14
    ],
    o: 2
  },
  abacus: {
    a: "Abacus",
    b: "1F9EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      33
    ],
    o: 11
  },
  "man-tipping-hand": {
    skin_variations: {
      "1F3FB": {
        unified: "1F481-1F3FB-200D-2642-FE0F",
        non_qualified: "1F481-1F3FB-200D-2642",
        image: "1f481-1f3fb-200d-2642-fe0f.png",
        sheet_x: 23,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F481-1F3FC-200D-2642-FE0F",
        non_qualified: "1F481-1F3FC-200D-2642",
        image: "1f481-1f3fc-200d-2642-fe0f.png",
        sheet_x: 23,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F481-1F3FD-200D-2642-FE0F",
        non_qualified: "1F481-1F3FD-200D-2642",
        image: "1f481-1f3fd-200d-2642-fe0f.png",
        sheet_x: 23,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F481-1F3FE-200D-2642-FE0F",
        non_qualified: "1F481-1F3FE-200D-2642",
        image: "1f481-1f3fe-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F481-1F3FF-200D-2642-FE0F",
        non_qualified: "1F481-1F3FF-200D-2642",
        image: "1f481-1f3ff-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Tipping Hand",
    b: "1F481-200D-2642-FE0F",
    c: "1F481-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      23,
      53
    ],
    o: 4
  },
  doughnut: {
    a: "Doughnut",
    b: "1F369",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "dessert",
      "snack",
      "sweet",
      "donut"
    ],
    k: [
      7,
      8
    ],
    o: 2
  },
  fish: {
    a: "Fish",
    b: "1F41F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "food",
      "nature"
    ],
    k: [
      12,
      3
    ],
    o: 2
  },
  truck: {
    a: "Delivery Truck",
    b: "1F69A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "cars",
      "transportation"
    ],
    k: [
      34,
      25
    ],
    o: 2
  },
  movie_camera: {
    a: "Movie Camera",
    b: "1F3A5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "film",
      "record"
    ],
    k: [
      8,
      11
    ],
    o: 2
  },
  "flag-ga": {
    a: "Gabon Flag",
    b: "1F1EC-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      54
    ],
    o: 2
  },
  rage: {
    a: "Pouting Face",
    b: "1F621",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "angry",
      "mad",
      "hate",
      "despise"
    ],
    k: [
      31,
      11
    ],
    o: 2
  },
  black_square_for_stop: {
    a: "Black Square for Stop",
    b: "23F9-FE0F",
    c: "23F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      38
    ],
    o: 2
  },
  articulated_lorry: {
    a: "Articulated Lorry",
    b: "1F69B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "cars",
      "transportation",
      "express"
    ],
    k: [
      34,
      26
    ],
    o: 2
  },
  angry: {
    a: "Angry Face",
    b: "1F620",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "mad",
      "face",
      "annoyed",
      "frustrated"
    ],
    k: [
      31,
      10
    ],
    l: [
      ">:(",
      ">:-("
    ],
    o: 2
  },
  cookie: {
    a: "Cookie",
    b: "1F36A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "snack",
      "oreo",
      "chocolate",
      "sweet",
      "dessert"
    ],
    k: [
      7,
      9
    ],
    o: 2
  },
  gb: {
    a: "United Kingdom Flag",
    b: "1F1EC-1F1E7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      55
    ],
    n: [
      "uk",
      "flag-gb"
    ],
    o: 2
  },
  tropical_fish: {
    a: "Tropical Fish",
    b: "1F420",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "swim",
      "ocean",
      "beach",
      "nemo"
    ],
    k: [
      12,
      4
    ],
    o: 2
  },
  "woman-tipping-hand": {
    skin_variations: {
      "1F3FB": {
        unified: "1F481-1F3FB-200D-2640-FE0F",
        non_qualified: "1F481-1F3FB-200D-2640",
        image: "1f481-1f3fb-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F481-1F3FC-200D-2640-FE0F",
        non_qualified: "1F481-1F3FC-200D-2640",
        image: "1f481-1f3fc-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F481-1F3FD-200D-2640-FE0F",
        non_qualified: "1F481-1F3FD-200D-2640",
        image: "1f481-1f3fd-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F481-1F3FE-200D-2640-FE0F",
        non_qualified: "1F481-1F3FE-200D-2640",
        image: "1f481-1f3fe-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F481-1F3FF-200D-2640-FE0F",
        non_qualified: "1F481-1F3FF-200D-2640",
        image: "1f481-1f3ff-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F481",
    a: "Woman Tipping Hand",
    b: "1F481-200D-2640-FE0F",
    c: "1F481-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      23,
      47
    ],
    o: 4
  },
  black_circle_for_record: {
    a: "Black Circle for Record",
    b: "23FA-FE0F",
    c: "23FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      39
    ],
    o: 2
  },
  film_frames: {
    a: "Film Frames",
    b: "1F39E-FE0F",
    c: "1F39E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      8,
      4
    ],
    o: 2
  },
  film_projector: {
    a: "Film Projector",
    b: "1F4FD-FE0F",
    c: "1F4FD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "video",
      "tape",
      "record",
      "movie"
    ],
    k: [
      27,
      26
    ],
    o: 2
  },
  "flag-gd": {
    a: "Grenada Flag",
    b: "1F1EC-1F1E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      1,
      56
    ],
    o: 2
  },
  blowfish: {
    a: "Blowfish",
    b: "1F421",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "food",
      "sea",
      "ocean"
    ],
    k: [
      12,
      5
    ],
    o: 2
  },
  face_with_symbols_on_mouth: {
    a: "Serious Face with Symbols Covering Mouth",
    b: "1F92C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      46
    ],
    n: [
      "serious_face_with_symbols_covering_mouth"
    ],
    o: 5
  },
  birthday: {
    a: "Birthday Cake",
    b: "1F382",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "dessert",
      "cake"
    ],
    k: [
      7,
      33
    ],
    o: 2
  },
  eject: {
    a: "Eject",
    b: "23CF-FE0F",
    c: "23CF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      25
    ],
    o: 2
  },
  raising_hand: {
    skin_variations: {
      "1F3FB": {
        unified: "1F64B-1F3FB",
        non_qualified: null,
        image: "1f64b-1f3fb.png",
        sheet_x: 33,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F64B-1F3FC",
        non_qualified: null,
        image: "1f64b-1f3fc.png",
        sheet_x: 33,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F64B-1F3FD",
        non_qualified: null,
        image: "1f64b-1f3fd.png",
        sheet_x: 33,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F64B-1F3FE",
        non_qualified: null,
        image: "1f64b-1f3fe.png",
        sheet_x: 33,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F64B-1F3FF",
        non_qualified: null,
        image: "1f64b-1f3ff.png",
        sheet_x: 33,
        sheet_y: 7,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F64B-200D-2640-FE0F",
    a: "Happy Person Raising One Hand",
    b: "1F64B",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      33,
      2
    ],
    o: 2
  },
  tractor: {
    a: "Tractor",
    b: "1F69C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "car",
      "farming",
      "agriculture"
    ],
    k: [
      34,
      27
    ],
    o: 2
  },
  "flag-ge": {
    a: "Georgia Flag",
    b: "1F1EC-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      0
    ],
    o: 2
  },
  smiling_imp: {
    a: "Smiling Face with Horns",
    b: "1F608",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "devil",
      "horns"
    ],
    k: [
      30,
      43
    ],
    o: 2
  },
  racing_car: {
    a: "Racing Car",
    b: "1F3CE-FE0F",
    c: "1F3CE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "race",
      "fast",
      "formula",
      "f1"
    ],
    k: [
      10,
      33
    ],
    o: 2
  },
  cinema: {
    a: "Cinema",
    b: "1F3A6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "record",
      "film",
      "movie",
      "curtain",
      "stage",
      "theater"
    ],
    k: [
      8,
      12
    ],
    o: 2
  },
  clapper: {
    a: "Clapper Board",
    b: "1F3AC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "movie",
      "film",
      "record"
    ],
    k: [
      8,
      18
    ],
    o: 2
  },
  shark: {
    a: "Shark",
    b: "1F988",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "nature",
      "fish",
      "sea",
      "ocean",
      "jaws",
      "fins",
      "beach"
    ],
    k: [
      42,
      26
    ],
    o: 4
  },
  cake: {
    a: "Shortcake",
    b: "1F370",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "dessert"
    ],
    k: [
      7,
      15
    ],
    o: 2
  },
  "man-raising-hand": {
    skin_variations: {
      "1F3FB": {
        unified: "1F64B-1F3FB-200D-2642-FE0F",
        non_qualified: "1F64B-1F3FB-200D-2642",
        image: "1f64b-1f3fb-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F64B-1F3FC-200D-2642-FE0F",
        non_qualified: "1F64B-1F3FC-200D-2642",
        image: "1f64b-1f3fc-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F64B-1F3FD-200D-2642-FE0F",
        non_qualified: "1F64B-1F3FD-200D-2642",
        image: "1f64b-1f3fd-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F64B-1F3FE-200D-2642-FE0F",
        non_qualified: "1F64B-1F3FE-200D-2642",
        image: "1f64b-1f3fe-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F64B-1F3FF-200D-2642-FE0F",
        non_qualified: "1F64B-1F3FF-200D-2642",
        image: "1f64b-1f3ff-200d-2642-fe0f.png",
        sheet_x: 33,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Raising Hand",
    b: "1F64B-200D-2642-FE0F",
    c: "1F64B-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      32,
      53
    ],
    o: 4
  },
  octopus: {
    a: "Octopus",
    b: "1F419",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "creature",
      "ocean",
      "sea",
      "nature",
      "beach"
    ],
    k: [
      11,
      54
    ],
    o: 2
  },
  "woman-raising-hand": {
    skin_variations: {
      "1F3FB": {
        unified: "1F64B-1F3FB-200D-2640-FE0F",
        non_qualified: "1F64B-1F3FB-200D-2640",
        image: "1f64b-1f3fb-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F64B-1F3FC-200D-2640-FE0F",
        non_qualified: "1F64B-1F3FC-200D-2640",
        image: "1f64b-1f3fc-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F64B-1F3FD-200D-2640-FE0F",
        non_qualified: "1F64B-1F3FD-200D-2640",
        image: "1f64b-1f3fd-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F64B-1F3FE-200D-2640-FE0F",
        non_qualified: "1F64B-1F3FE-200D-2640",
        image: "1f64b-1f3fe-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F64B-1F3FF-200D-2640-FE0F",
        non_qualified: "1F64B-1F3FF-200D-2640",
        image: "1f64b-1f3ff-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F64B",
    a: "Woman Raising Hand",
    b: "1F64B-200D-2640-FE0F",
    c: "1F64B-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      32,
      47
    ],
    o: 4
  },
  "flag-gf": {
    a: "French Guiana Flag",
    b: "1F1EC-1F1EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      1
    ],
    o: 2
  },
  tv: {
    a: "Television",
    b: "1F4FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "technology",
      "program",
      "oldschool",
      "show",
      "television"
    ],
    k: [
      27,
      23
    ],
    o: 2
  },
  imp: {
    a: "Imp",
    b: "1F47F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "devil",
      "angry",
      "horns"
    ],
    k: [
      23,
      45
    ],
    o: 2
  },
  cupcake: {
    a: "Cupcake",
    b: "1F9C1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      9
    ],
    o: 11
  },
  racing_motorcycle: {
    a: "Racing Motorcycle",
    b: "1F3CD-FE0F",
    c: "1F3CD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      10,
      32
    ],
    o: 2
  },
  low_brightness: {
    a: "Low Brightness Symbol",
    b: "1F505",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sun",
      "afternoon",
      "warm",
      "summer"
    ],
    k: [
      27,
      33
    ],
    o: 2
  },
  shell: {
    a: "Spiral Shell",
    b: "1F41A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "sea",
      "beach"
    ],
    k: [
      11,
      55
    ],
    o: 2
  },
  "flag-gg": {
    a: "Guernsey Flag",
    b: "1F1EC-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      2
    ],
    o: 2
  },
  high_brightness: {
    a: "High Brightness Symbol",
    b: "1F506",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sun",
      "light"
    ],
    k: [
      27,
      34
    ],
    o: 2
  },
  deaf_person: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9CF-1F3FB",
        non_qualified: null,
        image: "1f9cf-1f3fb.png",
        sheet_x: 45,
        sheet_y: 11,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9CF-1F3FC",
        non_qualified: null,
        image: "1f9cf-1f3fc.png",
        sheet_x: 45,
        sheet_y: 12,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9CF-1F3FD",
        non_qualified: null,
        image: "1f9cf-1f3fd.png",
        sheet_x: 45,
        sheet_y: 13,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9CF-1F3FE",
        non_qualified: null,
        image: "1f9cf-1f3fe.png",
        sheet_x: 45,
        sheet_y: 14,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9CF-1F3FF",
        non_qualified: null,
        image: "1f9cf-1f3ff.png",
        sheet_x: 45,
        sheet_y: 15,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Deaf Person",
    b: "1F9CF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      45,
      10
    ],
    o: 12
  },
  skull: {
    a: "Skull",
    b: "1F480",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dead",
      "skeleton",
      "creepy",
      "death"
    ],
    k: [
      23,
      46
    ],
    o: 2
  },
  motor_scooter: {
    a: "Motor Scooter",
    b: "1F6F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "vespa",
      "sasha"
    ],
    k: [
      36,
      54
    ],
    o: 4
  },
  camera: {
    a: "Camera",
    b: "1F4F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "gadgets",
      "photography"
    ],
    k: [
      27,
      20
    ],
    o: 2
  },
  pie: {
    a: "Pie",
    b: "1F967",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      54
    ],
    o: 5
  },
  "flag-gh": {
    a: "Ghana Flag",
    b: "1F1EC-1F1ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      3
    ],
    o: 2
  },
  deaf_man: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9CF-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9CF-1F3FB-200D-2642",
        image: "1f9cf-1f3fb-200d-2642-fe0f.png",
        sheet_x: 45,
        sheet_y: 5,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9CF-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9CF-1F3FC-200D-2642",
        image: "1f9cf-1f3fc-200d-2642-fe0f.png",
        sheet_x: 45,
        sheet_y: 6,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9CF-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9CF-1F3FD-200D-2642",
        image: "1f9cf-1f3fd-200d-2642-fe0f.png",
        sheet_x: 45,
        sheet_y: 7,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9CF-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9CF-1F3FE-200D-2642",
        image: "1f9cf-1f3fe-200d-2642-fe0f.png",
        sheet_x: 45,
        sheet_y: 8,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9CF-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9CF-1F3FF-200D-2642",
        image: "1f9cf-1f3ff-200d-2642-fe0f.png",
        sheet_x: 45,
        sheet_y: 9,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Deaf Man",
    b: "1F9CF-200D-2642-FE0F",
    c: "1F9CF-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      45,
      4
    ],
    o: 12
  },
  skull_and_crossbones: {
    a: "Skull and Crossbones",
    b: "2620-FE0F",
    c: "2620",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "poison",
      "danger",
      "deadly",
      "scary",
      "death",
      "pirate",
      "evil"
    ],
    k: [
      53,
      8
    ],
    o: 2
  },
  camera_with_flash: {
    a: "Camera with Flash",
    b: "1F4F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      27,
      21
    ],
    o: 2
  },
  signal_strength: {
    a: "Antenna with Bars",
    b: "1F4F6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "reception",
      "phone",
      "internet",
      "connection",
      "wifi",
      "bluetooth",
      "bars"
    ],
    k: [
      27,
      19
    ],
    o: 2
  },
  chocolate_bar: {
    a: "Chocolate Bar",
    b: "1F36B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "snack",
      "dessert",
      "sweet"
    ],
    k: [
      7,
      10
    ],
    o: 2
  },
  manual_wheelchair: {
    a: "Manual Wheelchair",
    b: "1F9BD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      5
    ],
    o: 12
  },
  snail: {
    a: "Snail",
    b: "1F40C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "slow",
      "animal",
      "shell"
    ],
    k: [
      11,
      40
    ],
    o: 2
  },
  motorized_wheelchair: {
    a: "Motorized Wheelchair",
    b: "1F9BC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      4
    ],
    o: 12
  },
  "flag-gi": {
    a: "Gibraltar Flag",
    b: "1F1EC-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      4
    ],
    o: 2
  },
  hankey: {
    a: "Pile of Poo",
    b: "1F4A9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      25,
      51
    ],
    n: [
      "poop",
      "shit"
    ],
    o: 2
  },
  vibration_mode: {
    a: "Vibration Mode",
    b: "1F4F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "orange-square",
      "phone"
    ],
    k: [
      27,
      16
    ],
    o: 2
  },
  deaf_woman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9CF-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9CF-1F3FB-200D-2640",
        image: "1f9cf-1f3fb-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 56,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9CF-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9CF-1F3FC-200D-2640",
        image: "1f9cf-1f3fc-200d-2640-fe0f.png",
        sheet_x: 45,
        sheet_y: 0,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9CF-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9CF-1F3FD-200D-2640",
        image: "1f9cf-1f3fd-200d-2640-fe0f.png",
        sheet_x: 45,
        sheet_y: 1,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9CF-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9CF-1F3FE-200D-2640",
        image: "1f9cf-1f3fe-200d-2640-fe0f.png",
        sheet_x: 45,
        sheet_y: 2,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9CF-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9CF-1F3FF-200D-2640",
        image: "1f9cf-1f3ff-200d-2640-fe0f.png",
        sheet_x: 45,
        sheet_y: 3,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Deaf Woman",
    b: "1F9CF-200D-2640-FE0F",
    c: "1F9CF-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      55
    ],
    o: 12
  },
  butterfly: {
    a: "Butterfly",
    b: "1F98B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "insect",
      "nature",
      "caterpillar"
    ],
    k: [
      42,
      29
    ],
    o: 4
  },
  video_camera: {
    a: "Video Camera",
    b: "1F4F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "film",
      "record"
    ],
    k: [
      27,
      22
    ],
    o: 2
  },
  candy: {
    a: "Candy",
    b: "1F36C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "snack",
      "dessert",
      "sweet",
      "lolly"
    ],
    k: [
      7,
      11
    ],
    o: 2
  },
  auto_rickshaw: {
    a: "Auto Rickshaw",
    b: "1F6FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      2
    ],
    o: 12
  },
  bow: {
    skin_variations: {
      "1F3FB": {
        unified: "1F647-1F3FB",
        non_qualified: null,
        image: "1f647-1f3fb.png",
        sheet_x: 32,
        sheet_y: 39,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F647-1F3FC",
        non_qualified: null,
        image: "1f647-1f3fc.png",
        sheet_x: 32,
        sheet_y: 40,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F647-1F3FD",
        non_qualified: null,
        image: "1f647-1f3fd.png",
        sheet_x: 32,
        sheet_y: 41,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F647-1F3FE",
        non_qualified: null,
        image: "1f647-1f3fe.png",
        sheet_x: 32,
        sheet_y: 42,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F647-1F3FF",
        non_qualified: null,
        image: "1f647-1f3ff.png",
        sheet_x: 32,
        sheet_y: 43,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F647-200D-2642-FE0F",
    a: "Person Bowing Deeply",
    b: "1F647",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      32,
      38
    ],
    o: 2
  },
  mobile_phone_off: {
    a: "Mobile Phone off",
    b: "1F4F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "mute",
      "orange-square",
      "silence",
      "quiet"
    ],
    k: [
      27,
      17
    ],
    o: 2
  },
  clown_face: {
    a: "Clown Face",
    b: "1F921",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face"
    ],
    k: [
      38,
      18
    ],
    o: 4
  },
  lollipop: {
    a: "Lollipop",
    b: "1F36D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "snack",
      "candy",
      "sweet"
    ],
    k: [
      7,
      12
    ],
    o: 2
  },
  "flag-gl": {
    a: "Greenland Flag",
    b: "1F1EC-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      5
    ],
    o: 2
  },
  vhs: {
    a: "Videocassette",
    b: "1F4FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "record",
      "video",
      "oldschool",
      "90s",
      "80s"
    ],
    k: [
      27,
      25
    ],
    o: 2
  },
  bug: {
    a: "Bug",
    b: "1F41B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "insect",
      "nature",
      "worm"
    ],
    k: [
      11,
      56
    ],
    o: 2
  },
  bike: {
    a: "Bicycle",
    b: "1F6B2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "bicycle",
      "exercise",
      "hipster"
    ],
    k: [
      35,
      9
    ],
    o: 2
  },
  "man-bowing": {
    skin_variations: {
      "1F3FB": {
        unified: "1F647-1F3FB-200D-2642-FE0F",
        non_qualified: "1F647-1F3FB-200D-2642",
        image: "1f647-1f3fb-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 33,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F647-1F3FC-200D-2642-FE0F",
        non_qualified: "1F647-1F3FC-200D-2642",
        image: "1f647-1f3fc-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 34,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F647-1F3FD-200D-2642-FE0F",
        non_qualified: "1F647-1F3FD-200D-2642",
        image: "1f647-1f3fd-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 35,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F647-1F3FE-200D-2642-FE0F",
        non_qualified: "1F647-1F3FE-200D-2642",
        image: "1f647-1f3fe-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F647-1F3FF-200D-2642-FE0F",
        non_qualified: "1F647-1F3FF-200D-2642",
        image: "1f647-1f3ff-200d-2642-fe0f.png",
        sheet_x: 32,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F647",
    a: "Man Bowing",
    b: "1F647-200D-2642-FE0F",
    c: "1F647-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      32,
      32
    ],
    o: 4
  },
  female_sign: {
    a: "Female Sign",
    b: "2640-FE0F",
    c: "2640",
    d: !1,
    e: !0,
    f: !0,
    h: !0,
    k: [
      53,
      18
    ],
    o: 4
  },
  japanese_ogre: {
    a: "Japanese Ogre",
    b: "1F479",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "monster",
      "red",
      "mask",
      "halloween",
      "scary",
      "creepy",
      "devil",
      "demon",
      "japanese",
      "ogre"
    ],
    k: [
      23,
      34
    ],
    o: 2
  },
  custard: {
    a: "Custard",
    b: "1F36E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dessert",
      "food"
    ],
    k: [
      7,
      13
    ],
    o: 2
  },
  ant: {
    a: "Ant",
    b: "1F41C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "insect",
      "nature",
      "bug"
    ],
    k: [
      12,
      0
    ],
    o: 2
  },
  mag: {
    a: "Left-Pointing Magnifying Glass",
    b: "1F50D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "search",
      "zoom",
      "find",
      "detective"
    ],
    k: [
      27,
      41
    ],
    o: 2
  },
  "flag-gm": {
    a: "Gambia Flag",
    b: "1F1EC-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      6
    ],
    o: 2
  },
  honey_pot: {
    a: "Honey Pot",
    b: "1F36F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bees",
      "sweet",
      "kitchen"
    ],
    k: [
      7,
      14
    ],
    o: 2
  },
  "woman-bowing": {
    skin_variations: {
      "1F3FB": {
        unified: "1F647-1F3FB-200D-2640-FE0F",
        non_qualified: "1F647-1F3FB-200D-2640",
        image: "1f647-1f3fb-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 27,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F647-1F3FC-200D-2640-FE0F",
        non_qualified: "1F647-1F3FC-200D-2640",
        image: "1f647-1f3fc-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 28,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F647-1F3FD-200D-2640-FE0F",
        non_qualified: "1F647-1F3FD-200D-2640",
        image: "1f647-1f3fd-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 29,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F647-1F3FE-200D-2640-FE0F",
        non_qualified: "1F647-1F3FE-200D-2640",
        image: "1f647-1f3fe-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F647-1F3FF-200D-2640-FE0F",
        non_qualified: "1F647-1F3FF-200D-2640",
        image: "1f647-1f3ff-200d-2640-fe0f.png",
        sheet_x: 32,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Bowing",
    b: "1F647-200D-2640-FE0F",
    c: "1F647-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      32,
      26
    ],
    o: 4
  },
  male_sign: {
    a: "Male Sign",
    b: "2642-FE0F",
    c: "2642",
    d: !1,
    e: !0,
    f: !0,
    h: !0,
    k: [
      53,
      19
    ],
    o: 4
  },
  mag_right: {
    a: "Right-Pointing Magnifying Glass",
    b: "1F50E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "search",
      "zoom",
      "find",
      "detective"
    ],
    k: [
      27,
      42
    ],
    o: 2
  },
  japanese_goblin: {
    a: "Japanese Goblin",
    b: "1F47A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "red",
      "evil",
      "mask",
      "monster",
      "scary",
      "creepy",
      "japanese",
      "goblin"
    ],
    k: [
      23,
      35
    ],
    o: 2
  },
  scooter: {
    a: "Scooter",
    b: "1F6F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      36,
      53
    ],
    o: 4
  },
  bee: {
    a: "Honeybee",
    b: "1F41D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      12,
      1
    ],
    n: [
      "honeybee"
    ],
    o: 2
  },
  "flag-gn": {
    a: "Guinea Flag",
    b: "1F1EC-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      7
    ],
    o: 2
  },
  candle: {
    a: "Candle",
    b: "1F56F-FE0F",
    c: "1F56F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fire",
      "wax"
    ],
    k: [
      29,
      6
    ],
    o: 2
  },
  skateboard: {
    a: "Skateboard",
    b: "1F6F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      1
    ],
    o: 11
  },
  medical_symbol: {
    a: "Medical Symbol",
    b: "2695-FE0F",
    c: "2695",
    d: !1,
    e: !0,
    f: !0,
    h: !0,
    k: [
      53,
      44
    ],
    n: [
      "staff_of_aesculapius"
    ],
    o: 4
  },
  ghost: {
    a: "Ghost",
    b: "1F47B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "halloween",
      "spooky",
      "scary"
    ],
    k: [
      23,
      36
    ],
    o: 2
  },
  beetle: {
    a: "Lady Beetle",
    b: "1F41E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "insect",
      "nature",
      "ladybug"
    ],
    k: [
      12,
      2
    ],
    o: 2
  },
  face_palm: {
    skin_variations: {
      "1F3FB": {
        unified: "1F926-1F3FB",
        non_qualified: null,
        image: "1f926-1f3fb.png",
        sheet_x: 38,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F926-1F3FC",
        non_qualified: null,
        image: "1f926-1f3fc.png",
        sheet_x: 38,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F926-1F3FD",
        non_qualified: null,
        image: "1f926-1f3fd.png",
        sheet_x: 38,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F926-1F3FE",
        non_qualified: null,
        image: "1f926-1f3fe.png",
        sheet_x: 38,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F926-1F3FF",
        non_qualified: null,
        image: "1f926-1f3ff.png",
        sheet_x: 38,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    a: "Face Palm",
    b: "1F926",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      38,
      35
    ],
    o: 4
  },
  "flag-gp": {
    a: "Guadeloupe Flag",
    b: "1F1EC-1F1F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      8
    ],
    o: 2
  },
  baby_bottle: {
    a: "Baby Bottle",
    b: "1F37C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "food",
      "container",
      "milk"
    ],
    k: [
      7,
      27
    ],
    o: 2
  },
  infinity: {
    a: "Infinity",
    b: "267E-FE0F",
    c: "267E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      53,
      39
    ],
    o: 11
  },
  glass_of_milk: {
    a: "Glass of Milk",
    b: "1F95B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      42
    ],
    o: 4
  },
  "man-facepalming": {
    skin_variations: {
      "1F3FB": {
        unified: "1F926-1F3FB-200D-2642-FE0F",
        non_qualified: "1F926-1F3FB-200D-2642",
        image: "1f926-1f3fb-200d-2642-fe0f.png",
        sheet_x: 38,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F926-1F3FC-200D-2642-FE0F",
        non_qualified: "1F926-1F3FC-200D-2642",
        image: "1f926-1f3fc-200d-2642-fe0f.png",
        sheet_x: 38,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F926-1F3FD-200D-2642-FE0F",
        non_qualified: "1F926-1F3FD-200D-2642",
        image: "1f926-1f3fd-200d-2642-fe0f.png",
        sheet_x: 38,
        sheet_y: 32,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F926-1F3FE-200D-2642-FE0F",
        non_qualified: "1F926-1F3FE-200D-2642",
        image: "1f926-1f3fe-200d-2642-fe0f.png",
        sheet_x: 38,
        sheet_y: 33,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F926-1F3FF-200D-2642-FE0F",
        non_qualified: "1F926-1F3FF-200D-2642",
        image: "1f926-1f3ff-200d-2642-fe0f.png",
        sheet_x: 38,
        sheet_y: 34,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Facepalming",
    b: "1F926-200D-2642-FE0F",
    c: "1F926-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      29
    ],
    o: 4
  },
  cricket: {
    a: "Cricket",
    b: "1F997",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports"
    ],
    k: [
      42,
      41
    ],
    o: 5
  },
  busstop: {
    a: "Bus Stop",
    b: "1F68F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "wait"
    ],
    k: [
      34,
      14
    ],
    o: 2
  },
  "flag-gq": {
    a: "Equatorial Guinea Flag",
    b: "1F1EC-1F1F6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      9
    ],
    o: 2
  },
  alien: {
    a: "Extraterrestrial Alien",
    b: "1F47D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "UFO",
      "paul",
      "weird",
      "outer_space"
    ],
    k: [
      23,
      43
    ],
    o: 2
  },
  bulb: {
    a: "Electric Light Bulb",
    b: "1F4A1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "light",
      "electricity",
      "idea"
    ],
    k: [
      25,
      43
    ],
    o: 2
  },
  "woman-facepalming": {
    skin_variations: {
      "1F3FB": {
        unified: "1F926-1F3FB-200D-2640-FE0F",
        non_qualified: "1F926-1F3FB-200D-2640",
        image: "1f926-1f3fb-200d-2640-fe0f.png",
        sheet_x: 38,
        sheet_y: 24,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F926-1F3FC-200D-2640-FE0F",
        non_qualified: "1F926-1F3FC-200D-2640",
        image: "1f926-1f3fc-200d-2640-fe0f.png",
        sheet_x: 38,
        sheet_y: 25,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F926-1F3FD-200D-2640-FE0F",
        non_qualified: "1F926-1F3FD-200D-2640",
        image: "1f926-1f3fd-200d-2640-fe0f.png",
        sheet_x: 38,
        sheet_y: 26,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F926-1F3FE-200D-2640-FE0F",
        non_qualified: "1F926-1F3FE-200D-2640",
        image: "1f926-1f3fe-200d-2640-fe0f.png",
        sheet_x: 38,
        sheet_y: 27,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F926-1F3FF-200D-2640-FE0F",
        non_qualified: "1F926-1F3FF-200D-2640",
        image: "1f926-1f3ff-200d-2640-fe0f.png",
        sheet_x: 38,
        sheet_y: 28,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Facepalming",
    b: "1F926-200D-2640-FE0F",
    c: "1F926-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      23
    ],
    o: 4
  },
  spider: {
    a: "Spider",
    b: "1F577-FE0F",
    c: "1F577",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "arachnid"
    ],
    k: [
      29,
      34
    ],
    o: 2
  },
  space_invader: {
    a: "Alien Monster",
    b: "1F47E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "game",
      "arcade",
      "play"
    ],
    k: [
      23,
      44
    ],
    o: 2
  },
  motorway: {
    a: "Motorway",
    b: "1F6E3-FE0F",
    c: "1F6E3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "road",
      "cupertino",
      "interstate",
      "highway"
    ],
    k: [
      36,
      45
    ],
    o: 2
  },
  "flag-gr": {
    a: "Greece Flag",
    b: "1F1EC-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      10
    ],
    o: 2
  },
  recycle: {
    a: "Black Universal Recycling Symbol",
    b: "267B-FE0F",
    c: "267B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "arrow",
      "environment",
      "garbage",
      "trash"
    ],
    k: [
      53,
      38
    ],
    o: 2
  },
  coffee: {
    a: "Hot Beverage",
    b: "2615",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "beverage",
      "caffeine",
      "latte",
      "espresso"
    ],
    k: [
      53,
      0
    ],
    o: 2
  },
  flashlight: {
    a: "Electric Torch",
    b: "1F526",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dark",
      "camping",
      "sight",
      "night"
    ],
    k: [
      28,
      9
    ],
    o: 2
  },
  spider_web: {
    a: "Spider Web",
    b: "1F578-FE0F",
    c: "1F578",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "insect",
      "arachnid",
      "silk"
    ],
    k: [
      29,
      35
    ],
    o: 2
  },
  izakaya_lantern: {
    a: "Izakaya Lantern",
    b: "1F3EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "light",
      "paper",
      "halloween",
      "spooky"
    ],
    k: [
      11,
      8
    ],
    n: [
      "lantern"
    ],
    o: 2
  },
  "flag-gs": {
    a: "South Georgia & South Sandwich Islands Flag",
    b: "1F1EC-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      11
    ],
    o: 2
  },
  shrug: {
    skin_variations: {
      "1F3FB": {
        unified: "1F937-1F3FB",
        non_qualified: null,
        image: "1f937-1f3fb.png",
        sheet_x: 39,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F937-1F3FC",
        non_qualified: null,
        image: "1f937-1f3fc.png",
        sheet_x: 39,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F937-1F3FD",
        non_qualified: null,
        image: "1f937-1f3fd.png",
        sheet_x: 39,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F937-1F3FE",
        non_qualified: null,
        image: "1f937-1f3fe.png",
        sheet_x: 39,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F937-1F3FF",
        non_qualified: null,
        image: "1f937-1f3ff.png",
        sheet_x: 39,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    a: "Shrug",
    b: "1F937",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      39,
      47
    ],
    o: 4
  },
  fleur_de_lis: {
    a: "Fleur De Lis",
    b: "269C-FE0F",
    c: "269C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "decorative",
      "scout"
    ],
    k: [
      53,
      49
    ],
    o: 2
  },
  robot_face: {
    a: "Robot Face",
    b: "1F916",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      29
    ],
    o: 2
  },
  railway_track: {
    a: "Railway Track",
    b: "1F6E4-FE0F",
    c: "1F6E4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "train",
      "transportation"
    ],
    k: [
      36,
      46
    ],
    o: 2
  },
  tea: {
    a: "Teacup Without Handle",
    b: "1F375",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "drink",
      "bowl",
      "breakfast",
      "green",
      "british"
    ],
    k: [
      7,
      20
    ],
    o: 2
  },
  "flag-gt": {
    a: "Guatemala Flag",
    b: "1F1EC-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      12
    ],
    o: 2
  },
  oil_drum: {
    a: "Oil Drum",
    b: "1F6E2-FE0F",
    c: "1F6E2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "barrell"
    ],
    k: [
      36,
      44
    ],
    o: 2
  },
  diya_lamp: {
    a: "Diya Lamp",
    b: "1FA94",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      8
    ],
    o: 12
  },
  sake: {
    a: "Sake Bottle and Cup",
    b: "1F376",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "wine",
      "drink",
      "drunk",
      "beverage",
      "japanese",
      "alcohol",
      "booze"
    ],
    k: [
      7,
      21
    ],
    o: 2
  },
  trident: {
    a: "Trident Emblem",
    b: "1F531",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weapon",
      "spear"
    ],
    k: [
      28,
      20
    ],
    o: 2
  },
  "man-shrugging": {
    skin_variations: {
      "1F3FB": {
        unified: "1F937-1F3FB-200D-2642-FE0F",
        non_qualified: "1F937-1F3FB-200D-2642",
        image: "1f937-1f3fb-200d-2642-fe0f.png",
        sheet_x: 39,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F937-1F3FC-200D-2642-FE0F",
        non_qualified: "1F937-1F3FC-200D-2642",
        image: "1f937-1f3fc-200d-2642-fe0f.png",
        sheet_x: 39,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F937-1F3FD-200D-2642-FE0F",
        non_qualified: "1F937-1F3FD-200D-2642",
        image: "1f937-1f3fd-200d-2642-fe0f.png",
        sheet_x: 39,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F937-1F3FE-200D-2642-FE0F",
        non_qualified: "1F937-1F3FE-200D-2642",
        image: "1f937-1f3fe-200d-2642-fe0f.png",
        sheet_x: 39,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F937-1F3FF-200D-2642-FE0F",
        non_qualified: "1F937-1F3FF-200D-2642",
        image: "1f937-1f3ff-200d-2642-fe0f.png",
        sheet_x: 39,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Shrugging",
    b: "1F937-200D-2642-FE0F",
    c: "1F937-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      39,
      41
    ],
    o: 4
  },
  smiley_cat: {
    a: "Smiling Cat Face with Open Mouth",
    b: "1F63A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cats",
      "happy",
      "smile"
    ],
    k: [
      31,
      36
    ],
    o: 2
  },
  scorpion: {
    a: "Scorpion",
    b: "1F982",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "arachnid"
    ],
    k: [
      42,
      20
    ],
    o: 2
  },
  "woman-shrugging": {
    skin_variations: {
      "1F3FB": {
        unified: "1F937-1F3FB-200D-2640-FE0F",
        non_qualified: "1F937-1F3FB-200D-2640",
        image: "1f937-1f3fb-200d-2640-fe0f.png",
        sheet_x: 39,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F937-1F3FC-200D-2640-FE0F",
        non_qualified: "1F937-1F3FC-200D-2640",
        image: "1f937-1f3fc-200d-2640-fe0f.png",
        sheet_x: 39,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F937-1F3FD-200D-2640-FE0F",
        non_qualified: "1F937-1F3FD-200D-2640",
        image: "1f937-1f3fd-200d-2640-fe0f.png",
        sheet_x: 39,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F937-1F3FE-200D-2640-FE0F",
        non_qualified: "1F937-1F3FE-200D-2640",
        image: "1f937-1f3fe-200d-2640-fe0f.png",
        sheet_x: 39,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F937-1F3FF-200D-2640-FE0F",
        non_qualified: "1F937-1F3FF-200D-2640",
        image: "1f937-1f3ff-200d-2640-fe0f.png",
        sheet_x: 39,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Shrugging",
    b: "1F937-200D-2640-FE0F",
    c: "1F937-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      39,
      35
    ],
    o: 4
  },
  notebook_with_decorative_cover: {
    a: "Notebook with Decorative Cover",
    b: "1F4D4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "classroom",
      "notes",
      "record",
      "paper",
      "study"
    ],
    k: [
      26,
      42
    ],
    o: 2
  },
  fuelpump: {
    a: "Fuel Pump",
    b: "26FD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "gas station",
      "petroleum"
    ],
    k: [
      54,
      38
    ],
    o: 2
  },
  name_badge: {
    a: "Name Badge",
    b: "1F4DB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "fire",
      "forbid"
    ],
    k: [
      26,
      49
    ],
    o: 2
  },
  mosquito: {
    a: "Mosquito",
    b: "1F99F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      49
    ],
    o: 11
  },
  "flag-gu": {
    a: "Guam Flag",
    b: "1F1EC-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      13
    ],
    o: 2
  },
  smile_cat: {
    a: "Grinning Cat Face with Smiling Eyes",
    b: "1F638",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cats",
      "smile"
    ],
    k: [
      31,
      34
    ],
    o: 2
  },
  champagne: {
    a: "Bottle with Popping Cork",
    b: "1F37E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "drink",
      "wine",
      "bottle",
      "celebration"
    ],
    k: [
      7,
      29
    ],
    o: 2
  },
  joy_cat: {
    a: "Cat Face with Tears of Joy",
    b: "1F639",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cats",
      "haha",
      "happy",
      "tears"
    ],
    k: [
      31,
      35
    ],
    o: 2
  },
  closed_book: {
    a: "Closed Book",
    b: "1F4D5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "read",
      "library",
      "knowledge",
      "textbook",
      "learn"
    ],
    k: [
      26,
      43
    ],
    o: 2
  },
  health_worker: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-2695-FE0F",
        non_qualified: "1F9D1-1F3FB-200D-2695",
        image: "1f9d1-1f3fb-200d-2695-fe0f.png",
        sheet_x: 47,
        sheet_y: 50,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-2695-FE0F",
        non_qualified: "1F9D1-1F3FC-200D-2695",
        image: "1f9d1-1f3fc-200d-2695-fe0f.png",
        sheet_x: 47,
        sheet_y: 51,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-2695-FE0F",
        non_qualified: "1F9D1-1F3FD-200D-2695",
        image: "1f9d1-1f3fd-200d-2695-fe0f.png",
        sheet_x: 47,
        sheet_y: 52,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-2695-FE0F",
        non_qualified: "1F9D1-1F3FE-200D-2695",
        image: "1f9d1-1f3fe-200d-2695-fe0f.png",
        sheet_x: 47,
        sheet_y: 53,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-2695-FE0F",
        non_qualified: "1F9D1-1F3FF-200D-2695",
        image: "1f9d1-1f3ff-200d-2695-fe0f.png",
        sheet_x: 47,
        sheet_y: 54,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Health Worker",
    b: "1F9D1-200D-2695-FE0F",
    c: "1F9D1-200D-2695",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      47,
      49
    ],
    o: 12
  },
  rotating_light: {
    a: "Police Cars Revolving Light",
    b: "1F6A8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "police",
      "ambulance",
      "911",
      "emergency",
      "alert",
      "error",
      "pinged",
      "law",
      "legal"
    ],
    k: [
      34,
      56
    ],
    o: 2
  },
  microbe: {
    a: "Microbe",
    b: "1F9A0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      42,
      50
    ],
    o: 11
  },
  "flag-gw": {
    a: "Guinea-Bissau Flag",
    b: "1F1EC-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      14
    ],
    o: 2
  },
  wine_glass: {
    a: "Wine Glass",
    b: "1F377",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "drink",
      "beverage",
      "drunk",
      "alcohol",
      "booze"
    ],
    k: [
      7,
      22
    ],
    o: 2
  },
  beginner: {
    a: "Japanese Symbol for Beginner",
    b: "1F530",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "badge",
      "shield"
    ],
    k: [
      28,
      19
    ],
    o: 2
  },
  bouquet: {
    a: "Bouquet",
    b: "1F490",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "flowers",
      "nature",
      "spring"
    ],
    k: [
      25,
      26
    ],
    o: 2
  },
  heart_eyes_cat: {
    a: "Smiling Cat Face with Heart-Shaped Eyes",
    b: "1F63B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "love",
      "like",
      "affection",
      "cats",
      "valentines",
      "heart"
    ],
    k: [
      31,
      37
    ],
    o: 2
  },
  "male-doctor": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-2695-FE0F",
        non_qualified: "1F468-1F3FB-200D-2695",
        image: "1f468-1f3fb-200d-2695-fe0f.png",
        sheet_x: 17,
        sheet_y: 3,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-2695-FE0F",
        non_qualified: "1F468-1F3FC-200D-2695",
        image: "1f468-1f3fc-200d-2695-fe0f.png",
        sheet_x: 17,
        sheet_y: 4,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-2695-FE0F",
        non_qualified: "1F468-1F3FD-200D-2695",
        image: "1f468-1f3fd-200d-2695-fe0f.png",
        sheet_x: 17,
        sheet_y: 5,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-2695-FE0F",
        non_qualified: "1F468-1F3FE-200D-2695",
        image: "1f468-1f3fe-200d-2695-fe0f.png",
        sheet_x: 17,
        sheet_y: 6,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-2695-FE0F",
        non_qualified: "1F468-1F3FF-200D-2695",
        image: "1f468-1f3ff-200d-2695-fe0f.png",
        sheet_x: 17,
        sheet_y: 7,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Doctor",
    b: "1F468-200D-2695-FE0F",
    c: "1F468-200D-2695",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      2
    ],
    o: 4
  },
  book: {
    a: "Open Book",
    b: "1F4D6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      26,
      44
    ],
    n: [
      "open_book"
    ],
    o: 2
  },
  traffic_light: {
    a: "Horizontal Traffic Light",
    b: "1F6A5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "signal"
    ],
    k: [
      34,
      53
    ],
    o: 2
  },
  cocktail: {
    a: "Cocktail Glass",
    b: "1F378",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "drink",
      "drunk",
      "alcohol",
      "beverage",
      "booze",
      "mojito"
    ],
    k: [
      7,
      23
    ],
    o: 2
  },
  o: {
    a: "Heavy Large Circle",
    b: "2B55",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "circle",
      "round"
    ],
    k: [
      55,
      43
    ],
    o: 2
  },
  "flag-gy": {
    a: "Guyana Flag",
    b: "1F1EC-1F1FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      15
    ],
    o: 2
  },
  "female-doctor": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-2695-FE0F",
        non_qualified: "1F469-1F3FB-200D-2695",
        image: "1f469-1f3fb-200d-2695-fe0f.png",
        sheet_x: 19,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-2695-FE0F",
        non_qualified: "1F469-1F3FC-200D-2695",
        image: "1f469-1f3fc-200d-2695-fe0f.png",
        sheet_x: 19,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-2695-FE0F",
        non_qualified: "1F469-1F3FD-200D-2695",
        image: "1f469-1f3fd-200d-2695-fe0f.png",
        sheet_x: 19,
        sheet_y: 47,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-2695-FE0F",
        non_qualified: "1F469-1F3FE-200D-2695",
        image: "1f469-1f3fe-200d-2695-fe0f.png",
        sheet_x: 19,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-2695-FE0F",
        non_qualified: "1F469-1F3FF-200D-2695",
        image: "1f469-1f3ff-200d-2695-fe0f.png",
        sheet_x: 19,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Doctor",
    b: "1F469-200D-2695-FE0F",
    c: "1F469-200D-2695",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      44
    ],
    o: 4
  },
  smirk_cat: {
    a: "Cat Face with Wry Smile",
    b: "1F63C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cats",
      "smirk"
    ],
    k: [
      31,
      38
    ],
    o: 2
  },
  green_book: {
    a: "Green Book",
    b: "1F4D7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "read",
      "library",
      "knowledge",
      "study"
    ],
    k: [
      26,
      45
    ],
    o: 2
  },
  cherry_blossom: {
    a: "Cherry Blossom",
    b: "1F338",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "plant",
      "spring",
      "flower"
    ],
    k: [
      6,
      16
    ],
    o: 2
  },
  "flag-hk": {
    a: "Hong Kong Sar China Flag",
    b: "1F1ED-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      16
    ],
    o: 2
  },
  vertical_traffic_light: {
    a: "Vertical Traffic Light",
    b: "1F6A6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "driving"
    ],
    k: [
      34,
      54
    ],
    o: 2
  },
  white_check_mark: {
    a: "White Heavy Check Mark",
    b: "2705",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "green-square",
      "ok",
      "agree",
      "vote",
      "election",
      "answer",
      "tick"
    ],
    k: [
      54,
      40
    ],
    o: 2
  },
  tropical_drink: {
    a: "Tropical Drink",
    b: "1F379",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "beverage",
      "cocktail",
      "summer",
      "beach",
      "alcohol",
      "booze",
      "mojito"
    ],
    k: [
      7,
      24
    ],
    o: 2
  },
  kissing_cat: {
    a: "Kissing Cat Face with Closed Eyes",
    b: "1F63D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cats",
      "kiss"
    ],
    k: [
      31,
      39
    ],
    o: 2
  },
  "flag-hm": {
    a: "Heard & Mcdonald Islands Flag",
    b: "1F1ED-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      17
    ],
    o: 2
  },
  octagonal_sign: {
    a: "Octagonal Sign",
    b: "1F6D1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      36,
      39
    ],
    o: 4
  },
  white_flower: {
    a: "White Flower",
    b: "1F4AE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "japanese",
      "spring"
    ],
    k: [
      26,
      4
    ],
    o: 2
  },
  ballot_box_with_check: {
    a: "Ballot Box with Check",
    b: "2611-FE0F",
    c: "2611",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "ok",
      "agree",
      "confirm",
      "black-square",
      "vote",
      "election",
      "yes",
      "tick"
    ],
    k: [
      52,
      55
    ],
    o: 2
  },
  student: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F393",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f393.png",
        sheet_x: 45,
        sheet_y: 30,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F393",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f393.png",
        sheet_x: 45,
        sheet_y: 31,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F393",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f393.png",
        sheet_x: 45,
        sheet_y: 32,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F393",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f393.png",
        sheet_x: 45,
        sheet_y: 33,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F393",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f393.png",
        sheet_x: 45,
        sheet_y: 34,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Student",
    b: "1F9D1-200D-1F393",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      45,
      29
    ],
    o: 12
  },
  blue_book: {
    a: "Blue Book",
    b: "1F4D8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "read",
      "library",
      "knowledge",
      "learn",
      "study"
    ],
    k: [
      26,
      46
    ],
    o: 2
  },
  beer: {
    a: "Beer Mug",
    b: "1F37A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "relax",
      "beverage",
      "drink",
      "drunk",
      "party",
      "pub",
      "summer",
      "alcohol",
      "booze"
    ],
    k: [
      7,
      25
    ],
    o: 2
  },
  construction: {
    a: "Construction Sign",
    b: "1F6A7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "wip",
      "progress",
      "caution",
      "warning"
    ],
    k: [
      34,
      55
    ],
    o: 2
  },
  rosette: {
    a: "Rosette",
    b: "1F3F5-FE0F",
    c: "1F3F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "flower",
      "decoration",
      "military"
    ],
    k: [
      11,
      18
    ],
    o: 2
  },
  heavy_check_mark: {
    a: "Heavy Check Mark",
    b: "2714-FE0F",
    c: "2714",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "ok",
      "nike",
      "answer",
      "yes",
      "tick"
    ],
    k: [
      55,
      12
    ],
    o: 2
  },
  scream_cat: {
    a: "Weary Cat Face",
    b: "1F640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cats",
      "munch",
      "scared",
      "scream"
    ],
    k: [
      31,
      42
    ],
    o: 2
  },
  orange_book: {
    a: "Orange Book",
    b: "1F4D9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "read",
      "library",
      "knowledge",
      "textbook",
      "study"
    ],
    k: [
      26,
      47
    ],
    o: 2
  },
  beers: {
    a: "Clinking Beer Mugs",
    b: "1F37B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "relax",
      "beverage",
      "drink",
      "drunk",
      "party",
      "pub",
      "summer",
      "alcohol",
      "booze"
    ],
    k: [
      7,
      26
    ],
    o: 2
  },
  "male-student": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F393",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f393.png",
        sheet_x: 14,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F393",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f393.png",
        sheet_x: 14,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F393",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f393.png",
        sheet_x: 14,
        sheet_y: 53,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F393",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f393.png",
        sheet_x: 14,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F393",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f393.png",
        sheet_x: 14,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Student",
    b: "1F468-200D-1F393",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      14,
      50
    ],
    o: 4
  },
  "flag-hn": {
    a: "Honduras Flag",
    b: "1F1ED-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      18
    ],
    o: 2
  },
  crying_cat_face: {
    a: "Crying Cat Face",
    b: "1F63F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "tears",
      "weep",
      "sad",
      "cats",
      "upset",
      "cry"
    ],
    k: [
      31,
      41
    ],
    o: 2
  },
  anchor: {
    a: "Anchor",
    b: "2693",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "ship",
      "ferry",
      "sea",
      "boat"
    ],
    k: [
      53,
      42
    ],
    o: 2
  },
  "flag-hr": {
    a: "Croatia Flag",
    b: "1F1ED-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      19
    ],
    o: 2
  },
  heavy_multiplication_x: {
    a: "Heavy Multiplication X",
    b: "2716-FE0F",
    c: "2716",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "math",
      "calculation"
    ],
    k: [
      55,
      13
    ],
    o: 2
  },
  "female-student": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F393",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f393.png",
        sheet_x: 17,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F393",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f393.png",
        sheet_x: 17,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F393",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f393.png",
        sheet_x: 17,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F393",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f393.png",
        sheet_x: 17,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F393",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f393.png",
        sheet_x: 17,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Student",
    b: "1F469-200D-1F393",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      40
    ],
    o: 4
  },
  rose: {
    a: "Rose",
    b: "1F339",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "flowers",
      "valentines",
      "love",
      "spring"
    ],
    k: [
      6,
      17
    ],
    o: 2
  },
  books: {
    a: "Books",
    b: "1F4DA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "literature",
      "library",
      "study"
    ],
    k: [
      26,
      48
    ],
    o: 2
  },
  clinking_glasses: {
    a: "Clinking Glasses",
    b: "1F942",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "beverage",
      "drink",
      "party",
      "alcohol",
      "celebrate",
      "cheers"
    ],
    k: [
      41,
      18
    ],
    o: 4
  },
  teacher: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F3EB",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f3eb.png",
        sheet_x: 45,
        sheet_y: 48,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F3EB",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f3eb.png",
        sheet_x: 45,
        sheet_y: 49,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F3EB",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f3eb.png",
        sheet_x: 45,
        sheet_y: 50,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F3EB",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f3eb.png",
        sheet_x: 45,
        sheet_y: 51,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F3EB",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f3eb.png",
        sheet_x: 45,
        sheet_y: 52,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Teacher",
    b: "1F9D1-200D-1F3EB",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      45,
      47
    ],
    o: 12
  },
  x: {
    a: "Cross Mark",
    b: "274C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "no",
      "delete",
      "remove",
      "cancel"
    ],
    k: [
      55,
      21
    ],
    o: 2
  },
  pouting_cat: {
    a: "Pouting Cat Face",
    b: "1F63E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "cats"
    ],
    k: [
      31,
      40
    ],
    o: 2
  },
  wilted_flower: {
    a: "Wilted Flower",
    b: "1F940",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "plant",
      "nature",
      "flower"
    ],
    k: [
      41,
      16
    ],
    o: 4
  },
  boat: {
    a: "Sailboat",
    b: "26F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      54,
      16
    ],
    n: [
      "sailboat"
    ],
    o: 2
  },
  "flag-ht": {
    a: "Haiti Flag",
    b: "1F1ED-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      20
    ],
    o: 2
  },
  tumbler_glass: {
    a: "Tumbler Glass",
    b: "1F943",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "drink",
      "beverage",
      "drunk",
      "alcohol",
      "liquor",
      "booze",
      "bourbon",
      "scotch",
      "whisky",
      "glass",
      "shot"
    ],
    k: [
      41,
      19
    ],
    o: 4
  },
  notebook: {
    a: "Notebook",
    b: "1F4D3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stationery",
      "record",
      "notes",
      "paper",
      "study"
    ],
    k: [
      26,
      41
    ],
    o: 2
  },
  "male-teacher": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F3EB",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f3eb.png",
        sheet_x: 15,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F3EB",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f3eb.png",
        sheet_x: 15,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F3EB",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f3eb.png",
        sheet_x: 15,
        sheet_y: 14,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F3EB",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f3eb.png",
        sheet_x: 15,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F3EB",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f3eb.png",
        sheet_x: 15,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Teacher",
    b: "1F468-200D-1F3EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      11
    ],
    o: 4
  },
  ledger: {
    a: "Ledger",
    b: "1F4D2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "notes",
      "paper"
    ],
    k: [
      26,
      40
    ],
    o: 2
  },
  "flag-hu": {
    a: "Hungary Flag",
    b: "1F1ED-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      21
    ],
    o: 2
  },
  cup_with_straw: {
    a: "Cup with Straw",
    b: "1F964",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      51
    ],
    o: 5
  },
  hibiscus: {
    a: "Hibiscus",
    b: "1F33A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "plant",
      "vegetable",
      "flowers",
      "beach"
    ],
    k: [
      6,
      18
    ],
    o: 2
  },
  see_no_evil: {
    a: "See-No-Evil Monkey",
    b: "1F648",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "monkey",
      "animal",
      "nature",
      "haha"
    ],
    k: [
      32,
      44
    ],
    o: 2
  },
  canoe: {
    a: "Canoe",
    b: "1F6F6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "boat",
      "paddle",
      "water",
      "ship"
    ],
    k: [
      36,
      55
    ],
    o: 4
  },
  negative_squared_cross_mark: {
    a: "Negative Squared Cross Mark",
    b: "274E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "x",
      "green-square",
      "no",
      "deny"
    ],
    k: [
      55,
      22
    ],
    o: 2
  },
  "flag-ic": {
    a: "Canary Islands Flag",
    b: "1F1EE-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      22
    ],
    o: 2
  },
  beverage_box: {
    a: "Beverage Box",
    b: "1F9C3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      11
    ],
    o: 12
  },
  speedboat: {
    a: "Speedboat",
    b: "1F6A4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "ship",
      "transportation",
      "vehicle",
      "summer"
    ],
    k: [
      34,
      52
    ],
    o: 2
  },
  heavy_plus_sign: {
    a: "Heavy Plus Sign",
    b: "2795",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "math",
      "calculation",
      "addition",
      "more",
      "increase"
    ],
    k: [
      55,
      29
    ],
    o: 2
  },
  sunflower: {
    a: "Sunflower",
    b: "1F33B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "plant",
      "fall"
    ],
    k: [
      6,
      19
    ],
    o: 2
  },
  page_with_curl: {
    a: "Page with Curl",
    b: "1F4C3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "documents",
      "office",
      "paper"
    ],
    k: [
      26,
      25
    ],
    o: 2
  },
  "female-teacher": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F3EB",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f3eb.png",
        sheet_x: 18,
        sheet_y: 2,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F3EB",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f3eb.png",
        sheet_x: 18,
        sheet_y: 3,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F3EB",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f3eb.png",
        sheet_x: 18,
        sheet_y: 4,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F3EB",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f3eb.png",
        sheet_x: 18,
        sheet_y: 5,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F3EB",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f3eb.png",
        sheet_x: 18,
        sheet_y: 6,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Teacher",
    b: "1F469-200D-1F3EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      1
    ],
    o: 4
  },
  hear_no_evil: {
    a: "Hear-No-Evil Monkey",
    b: "1F649",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "monkey",
      "nature"
    ],
    k: [
      32,
      45
    ],
    o: 2
  },
  mate_drink: {
    a: "Mate Drink",
    b: "1F9C9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      17
    ],
    o: 12
  },
  passenger_ship: {
    a: "Passenger Ship",
    b: "1F6F3-FE0F",
    c: "1F6F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "yacht",
      "cruise",
      "ferry"
    ],
    k: [
      36,
      52
    ],
    o: 2
  },
  judge: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-2696-FE0F",
        non_qualified: "1F9D1-1F3FB-200D-2696",
        image: "1f9d1-1f3fb-200d-2696-fe0f.png",
        sheet_x: 47,
        sheet_y: 56,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-2696-FE0F",
        non_qualified: "1F9D1-1F3FC-200D-2696",
        image: "1f9d1-1f3fc-200d-2696-fe0f.png",
        sheet_x: 48,
        sheet_y: 0,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-2696-FE0F",
        non_qualified: "1F9D1-1F3FD-200D-2696",
        image: "1f9d1-1f3fd-200d-2696-fe0f.png",
        sheet_x: 48,
        sheet_y: 1,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-2696-FE0F",
        non_qualified: "1F9D1-1F3FE-200D-2696",
        image: "1f9d1-1f3fe-200d-2696-fe0f.png",
        sheet_x: 48,
        sheet_y: 2,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-2696-FE0F",
        non_qualified: "1F9D1-1F3FF-200D-2696",
        image: "1f9d1-1f3ff-200d-2696-fe0f.png",
        sheet_x: 48,
        sheet_y: 3,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Judge",
    b: "1F9D1-200D-2696-FE0F",
    c: "1F9D1-200D-2696",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      47,
      55
    ],
    o: 12
  },
  scroll: {
    a: "Scroll",
    b: "1F4DC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "documents",
      "ancient",
      "history",
      "paper"
    ],
    k: [
      26,
      50
    ],
    o: 2
  },
  blossom: {
    a: "Blossom",
    b: "1F33C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "flowers",
      "yellow"
    ],
    k: [
      6,
      20
    ],
    o: 2
  },
  "flag-id": {
    a: "Indonesia Flag",
    b: "1F1EE-1F1E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      23
    ],
    o: 2
  },
  speak_no_evil: {
    a: "Speak-No-Evil Monkey",
    b: "1F64A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "monkey",
      "animal",
      "nature",
      "omg"
    ],
    k: [
      32,
      46
    ],
    o: 2
  },
  heavy_minus_sign: {
    a: "Heavy Minus Sign",
    b: "2796",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "math",
      "calculation",
      "subtract",
      "less"
    ],
    k: [
      55,
      30
    ],
    o: 2
  },
  "flag-ie": {
    a: "Ireland Flag",
    b: "1F1EE-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      24
    ],
    o: 2
  },
  ice_cube: {
    a: "Ice Cube",
    b: "1F9CA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      18
    ],
    o: 12
  },
  page_facing_up: {
    a: "Page Facing Up",
    b: "1F4C4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "documents",
      "office",
      "paper",
      "information"
    ],
    k: [
      26,
      26
    ],
    o: 2
  },
  "male-judge": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-2696-FE0F",
        non_qualified: "1F468-1F3FB-200D-2696",
        image: "1f468-1f3fb-200d-2696-fe0f.png",
        sheet_x: 17,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-2696-FE0F",
        non_qualified: "1F468-1F3FC-200D-2696",
        image: "1f468-1f3fc-200d-2696-fe0f.png",
        sheet_x: 17,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-2696-FE0F",
        non_qualified: "1F468-1F3FD-200D-2696",
        image: "1f468-1f3fd-200d-2696-fe0f.png",
        sheet_x: 17,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-2696-FE0F",
        non_qualified: "1F468-1F3FE-200D-2696",
        image: "1f468-1f3fe-200d-2696-fe0f.png",
        sheet_x: 17,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-2696-FE0F",
        non_qualified: "1F468-1F3FF-200D-2696",
        image: "1f468-1f3ff-200d-2696-fe0f.png",
        sheet_x: 17,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Judge",
    b: "1F468-200D-2696-FE0F",
    c: "1F468-200D-2696",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      8
    ],
    o: 4
  },
  tulip: {
    a: "Tulip",
    b: "1F337",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "flowers",
      "plant",
      "nature",
      "summer",
      "spring"
    ],
    k: [
      6,
      15
    ],
    o: 2
  },
  ferry: {
    a: "Ferry",
    b: "26F4-FE0F",
    c: "26F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "boat",
      "ship",
      "yacht"
    ],
    k: [
      54,
      15
    ],
    o: 2
  },
  kiss: {
    a: "Kiss Mark",
    b: "1F48B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "face",
      "lips",
      "love",
      "like",
      "affection",
      "valentines"
    ],
    k: [
      25,
      21
    ],
    o: 2
  },
  heavy_division_sign: {
    a: "Heavy Division Sign",
    b: "2797",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "divide",
      "math",
      "calculation"
    ],
    k: [
      55,
      31
    ],
    o: 2
  },
  newspaper: {
    a: "Newspaper",
    b: "1F4F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "press",
      "headline"
    ],
    k: [
      27,
      13
    ],
    o: 2
  },
  "female-judge": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-2696-FE0F",
        non_qualified: "1F469-1F3FB-200D-2696",
        image: "1f469-1f3fb-200d-2696-fe0f.png",
        sheet_x: 19,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-2696-FE0F",
        non_qualified: "1F469-1F3FC-200D-2696",
        image: "1f469-1f3fc-200d-2696-fe0f.png",
        sheet_x: 19,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-2696-FE0F",
        non_qualified: "1F469-1F3FD-200D-2696",
        image: "1f469-1f3fd-200d-2696-fe0f.png",
        sheet_x: 19,
        sheet_y: 53,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-2696-FE0F",
        non_qualified: "1F469-1F3FE-200D-2696",
        image: "1f469-1f3fe-200d-2696-fe0f.png",
        sheet_x: 19,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-2696-FE0F",
        non_qualified: "1F469-1F3FF-200D-2696",
        image: "1f469-1f3ff-200d-2696-fe0f.png",
        sheet_x: 19,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Judge",
    b: "1F469-200D-2696-FE0F",
    c: "1F469-200D-2696",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      50
    ],
    o: 4
  },
  seedling: {
    a: "Seedling",
    b: "1F331",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "plant",
      "nature",
      "grass",
      "lawn",
      "spring"
    ],
    k: [
      6,
      9
    ],
    o: 2
  },
  love_letter: {
    a: "Love Letter",
    b: "1F48C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "email",
      "like",
      "affection",
      "envelope",
      "valentines"
    ],
    k: [
      25,
      22
    ],
    o: 2
  },
  chopsticks: {
    a: "Chopsticks",
    b: "1F962",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      49
    ],
    o: 5
  },
  motor_boat: {
    a: "Motor Boat",
    b: "1F6E5-FE0F",
    c: "1F6E5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "ship"
    ],
    k: [
      36,
      47
    ],
    o: 2
  },
  "flag-il": {
    a: "Israel Flag",
    b: "1F1EE-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      25
    ],
    o: 2
  },
  curly_loop: {
    a: "Curly Loop",
    b: "27B0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "scribble",
      "draw",
      "shape",
      "squiggle"
    ],
    k: [
      55,
      33
    ],
    o: 2
  },
  "flag-im": {
    a: "Isle of Man Flag",
    b: "1F1EE-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      26
    ],
    o: 2
  },
  evergreen_tree: {
    a: "Evergreen Tree",
    b: "1F332",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "plant",
      "nature"
    ],
    k: [
      6,
      10
    ],
    o: 2
  },
  cupid: {
    a: "Heart with Arrow",
    b: "1F498",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "heart",
      "affection",
      "valentines"
    ],
    k: [
      25,
      34
    ],
    o: 2
  },
  loop: {
    a: "Double Curly Loop",
    b: "27BF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "tape",
      "cassette"
    ],
    k: [
      55,
      34
    ],
    o: 2
  },
  ship: {
    a: "Ship",
    b: "1F6A2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "titanic",
      "deploy"
    ],
    k: [
      34,
      33
    ],
    o: 2
  },
  farmer: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F33E",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f33e.png",
        sheet_x: 45,
        sheet_y: 18,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F33E",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f33e.png",
        sheet_x: 45,
        sheet_y: 19,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F33E",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f33e.png",
        sheet_x: 45,
        sheet_y: 20,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F33E",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f33e.png",
        sheet_x: 45,
        sheet_y: 21,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F33E",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f33e.png",
        sheet_x: 45,
        sheet_y: 22,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Farmer",
    b: "1F9D1-200D-1F33E",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      45,
      17
    ],
    o: 12
  },
  rolled_up_newspaper: {
    a: "Rolled Up Newspaper",
    b: "1F5DE-FE0F",
    c: "1F5DE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      23
    ],
    o: 2
  },
  knife_fork_plate: {
    a: "Knife Fork Plate",
    b: "1F37D-FE0F",
    c: "1F37D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      7,
      28
    ],
    o: 2
  },
  fork_and_knife: {
    a: "Fork and Knife",
    b: "1F374",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "cutlery",
      "kitchen"
    ],
    k: [
      7,
      19
    ],
    o: 2
  },
  "male-farmer": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F33E",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f33e.png",
        sheet_x: 14,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F33E",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f33e.png",
        sheet_x: 14,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F33E",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f33e.png",
        sheet_x: 14,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F33E",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f33e.png",
        sheet_x: 14,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F33E",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f33e.png",
        sheet_x: 14,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Farmer",
    b: "1F468-200D-1F33E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      14,
      38
    ],
    o: 4
  },
  bookmark_tabs: {
    a: "Bookmark Tabs",
    b: "1F4D1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "favorite",
      "save",
      "order",
      "tidy"
    ],
    k: [
      26,
      39
    ],
    o: 2
  },
  part_alternation_mark: {
    a: "Part Alternation Mark",
    b: "303D-FE0F",
    c: "303D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "graph",
      "presentation",
      "stats",
      "business",
      "economics",
      "bad"
    ],
    k: [
      55,
      45
    ],
    o: 2
  },
  "flag-in": {
    a: "India Flag",
    b: "1F1EE-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      27
    ],
    o: 2
  },
  gift_heart: {
    a: "Heart with Ribbon",
    b: "1F49D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "valentines"
    ],
    k: [
      25,
      39
    ],
    o: 2
  },
  airplane: {
    a: "Airplane",
    b: "2708-FE0F",
    c: "2708",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "transportation",
      "flight",
      "fly"
    ],
    k: [
      54,
      41
    ],
    o: 2
  },
  deciduous_tree: {
    a: "Deciduous Tree",
    b: "1F333",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "plant",
      "nature"
    ],
    k: [
      6,
      11
    ],
    o: 2
  },
  spoon: {
    a: "Spoon",
    b: "1F944",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "cutlery",
      "kitchen",
      "tableware"
    ],
    k: [
      41,
      20
    ],
    o: 4
  },
  "flag-io": {
    a: "British Indian Ocean Territory Flag",
    b: "1F1EE-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      28
    ],
    o: 2
  },
  palm_tree: {
    a: "Palm Tree",
    b: "1F334",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "plant",
      "vegetable",
      "nature",
      "summer",
      "beach",
      "mojito",
      "tropical"
    ],
    k: [
      6,
      12
    ],
    o: 2
  },
  sparkling_heart: {
    a: "Sparkling Heart",
    b: "1F496",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    k: [
      25,
      32
    ],
    o: 2
  },
  "female-farmer": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F33E",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f33e.png",
        sheet_x: 17,
        sheet_y: 29,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F33E",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f33e.png",
        sheet_x: 17,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F33E",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f33e.png",
        sheet_x: 17,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F33E",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f33e.png",
        sheet_x: 17,
        sheet_y: 32,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F33E",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f33e.png",
        sheet_x: 17,
        sheet_y: 33,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Farmer",
    b: "1F469-200D-1F33E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      28
    ],
    o: 4
  },
  eight_spoked_asterisk: {
    a: "Eight Spoked Asterisk",
    b: "2733-FE0F",
    c: "2733",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "star",
      "sparkle",
      "green-square"
    ],
    k: [
      55,
      17
    ],
    o: 2
  },
  small_airplane: {
    a: "Small Airplane",
    b: "1F6E9-FE0F",
    c: "1F6E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "flight",
      "transportation",
      "fly",
      "vehicle"
    ],
    k: [
      36,
      48
    ],
    o: 2
  },
  bookmark: {
    a: "Bookmark",
    b: "1F516",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "favorite",
      "label",
      "save"
    ],
    k: [
      27,
      50
    ],
    o: 2
  },
  cook: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F373",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f373.png",
        sheet_x: 45,
        sheet_y: 24,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F373",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f373.png",
        sheet_x: 45,
        sheet_y: 25,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F373",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f373.png",
        sheet_x: 45,
        sheet_y: 26,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F373",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f373.png",
        sheet_x: 45,
        sheet_y: 27,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F373",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f373.png",
        sheet_x: 45,
        sheet_y: 28,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Cook",
    b: "1F9D1-200D-1F373",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      45,
      23
    ],
    o: 12
  },
  eight_pointed_black_star: {
    a: "Eight Pointed Black Star",
    b: "2734-FE0F",
    c: "2734",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "orange-square",
      "shape",
      "polygon"
    ],
    k: [
      55,
      18
    ],
    o: 2
  },
  heartpulse: {
    a: "Growing Heart",
    b: "1F497",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "like",
      "love",
      "affection",
      "valentines",
      "pink"
    ],
    k: [
      25,
      33
    ],
    o: 2
  },
  label: {
    a: "Label",
    b: "1F3F7-FE0F",
    c: "1F3F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sale",
      "tag"
    ],
    k: [
      11,
      19
    ],
    o: 2
  },
  "flag-iq": {
    a: "Iraq Flag",
    b: "1F1EE-1F1F6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      29
    ],
    o: 2
  },
  hocho: {
    a: "Hocho",
    b: "1F52A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "knife",
      "blade",
      "cutlery",
      "kitchen",
      "weapon"
    ],
    k: [
      28,
      13
    ],
    n: [
      "knife"
    ],
    o: 2
  },
  cactus: {
    a: "Cactus",
    b: "1F335",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vegetable",
      "plant",
      "nature"
    ],
    k: [
      6,
      13
    ],
    o: 2
  },
  airplane_departure: {
    a: "Airplane Departure",
    b: "1F6EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      36,
      49
    ],
    o: 2
  },
  airplane_arriving: {
    a: "Airplane Arriving",
    b: "1F6EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      36,
      50
    ],
    o: 2
  },
  ear_of_rice: {
    a: "Ear of Rice",
    b: "1F33E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "plant"
    ],
    k: [
      6,
      22
    ],
    o: 2
  },
  "flag-ir": {
    a: "Iran Flag",
    b: "1F1EE-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      30
    ],
    o: 2
  },
  moneybag: {
    a: "Money Bag",
    b: "1F4B0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dollar",
      "payment",
      "coins",
      "sale"
    ],
    k: [
      26,
      6
    ],
    o: 2
  },
  "male-cook": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F373",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f373.png",
        sheet_x: 14,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F373",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f373.png",
        sheet_x: 14,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F373",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f373.png",
        sheet_x: 14,
        sheet_y: 47,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F373",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f373.png",
        sheet_x: 14,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F373",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f373.png",
        sheet_x: 14,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Cook",
    b: "1F468-200D-1F373",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      14,
      44
    ],
    o: 4
  },
  heartbeat: {
    a: "Beating Heart",
    b: "1F493",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "affection",
      "valentines",
      "pink",
      "heart"
    ],
    k: [
      25,
      29
    ],
    o: 2
  },
  sparkle: {
    a: "Sparkle",
    b: "2747-FE0F",
    c: "2747",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stars",
      "green-square",
      "awesome",
      "good",
      "fireworks"
    ],
    k: [
      55,
      20
    ],
    o: 2
  },
  amphora: {
    a: "Amphora",
    b: "1F3FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vase",
      "jar"
    ],
    k: [
      11,
      22
    ],
    o: 2
  },
  yen: {
    a: "Banknote with Yen Sign",
    b: "1F4B4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "money",
      "sales",
      "japanese",
      "dollar",
      "currency"
    ],
    k: [
      26,
      10
    ],
    o: 2
  },
  revolving_hearts: {
    a: "Revolving Hearts",
    b: "1F49E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    k: [
      25,
      40
    ],
    o: 2
  },
  bangbang: {
    a: "Double Exclamation Mark",
    b: "203C-FE0F",
    c: "203C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "exclamation",
      "surprise"
    ],
    k: [
      52,
      10
    ],
    o: 2
  },
  parachute: {
    a: "Parachute",
    b: "1FA82",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      3
    ],
    o: 12
  },
  herb: {
    a: "Herb",
    b: "1F33F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vegetable",
      "plant",
      "medicine",
      "weed",
      "grass",
      "lawn"
    ],
    k: [
      6,
      23
    ],
    o: 2
  },
  "flag-is": {
    a: "Iceland Flag",
    b: "1F1EE-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      31
    ],
    o: 2
  },
  "female-cook": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F373",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f373.png",
        sheet_x: 17,
        sheet_y: 35,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F373",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f373.png",
        sheet_x: 17,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F373",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f373.png",
        sheet_x: 17,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F373",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f373.png",
        sheet_x: 17,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F373",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f373.png",
        sheet_x: 17,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Cook",
    b: "1F469-200D-1F373",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      34
    ],
    o: 4
  },
  mechanic: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F527",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f527.png",
        sheet_x: 46,
        sheet_y: 15,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F527",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f527.png",
        sheet_x: 46,
        sheet_y: 16,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F527",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f527.png",
        sheet_x: 46,
        sheet_y: 17,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F527",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f527.png",
        sheet_x: 46,
        sheet_y: 18,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F527",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f527.png",
        sheet_x: 46,
        sheet_y: 19,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Mechanic",
    b: "1F9D1-200D-1F527",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      46,
      14
    ],
    o: 12
  },
  interrobang: {
    a: "Exclamation Question Mark",
    b: "2049-FE0F",
    c: "2049",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "wat",
      "punctuation",
      "surprise"
    ],
    k: [
      52,
      11
    ],
    o: 2
  },
  seat: {
    a: "Seat",
    b: "1F4BA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sit",
      "airplane",
      "transport",
      "bus",
      "flight",
      "fly"
    ],
    k: [
      26,
      16
    ],
    o: 2
  },
  dollar: {
    a: "Banknote with Dollar Sign",
    b: "1F4B5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "money",
      "sales",
      "bill",
      "currency"
    ],
    k: [
      26,
      11
    ],
    o: 2
  },
  two_hearts: {
    a: "Two Hearts",
    b: "1F495",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "affection",
      "valentines",
      "heart"
    ],
    k: [
      25,
      31
    ],
    o: 2
  },
  it: {
    a: "Italy Flag",
    b: "1F1EE-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "italy",
      "flag",
      "nation",
      "country",
      "banner"
    ],
    k: [
      2,
      32
    ],
    n: [
      "flag-it"
    ],
    o: 2
  },
  shamrock: {
    a: "Shamrock",
    b: "2618-FE0F",
    c: "2618",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vegetable",
      "plant",
      "nature",
      "irish",
      "clover"
    ],
    k: [
      53,
      1
    ],
    o: 2
  },
  four_leaf_clover: {
    a: "Four Leaf Clover",
    b: "1F340",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vegetable",
      "plant",
      "nature",
      "lucky",
      "irish"
    ],
    k: [
      6,
      24
    ],
    o: 2
  },
  euro: {
    a: "Banknote with Euro Sign",
    b: "1F4B6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "money",
      "sales",
      "dollar",
      "currency"
    ],
    k: [
      26,
      12
    ],
    o: 2
  },
  question: {
    a: "Black Question Mark Ornament",
    b: "2753",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "doubt",
      "confused"
    ],
    k: [
      55,
      23
    ],
    o: 2
  },
  helicopter: {
    a: "Helicopter",
    b: "1F681",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle",
      "fly"
    ],
    k: [
      34,
      0
    ],
    o: 2
  },
  heart_decoration: {
    a: "Heart Decoration",
    b: "1F49F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "purple-square",
      "love",
      "like"
    ],
    k: [
      25,
      41
    ],
    o: 2
  },
  "flag-je": {
    a: "Jersey Flag",
    b: "1F1EF-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      33
    ],
    o: 2
  },
  "male-mechanic": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F527",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f527.png",
        sheet_x: 15,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F527",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f527.png",
        sheet_x: 15,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F527",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f527.png",
        sheet_x: 15,
        sheet_y: 53,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F527",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f527.png",
        sheet_x: 15,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F527",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f527.png",
        sheet_x: 15,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Mechanic",
    b: "1F468-200D-1F527",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      50
    ],
    o: 4
  },
  suspension_railway: {
    a: "Suspension Railway",
    b: "1F69F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vehicle",
      "transportation"
    ],
    k: [
      34,
      30
    ],
    o: 2
  },
  heavy_heart_exclamation_mark_ornament: {
    a: "Heavy Heart Exclamation Mark Ornament",
    b: "2763-FE0F",
    c: "2763",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      55,
      27
    ],
    o: 2
  },
  "female-mechanic": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F527",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f527.png",
        sheet_x: 18,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F527",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f527.png",
        sheet_x: 18,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F527",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f527.png",
        sheet_x: 18,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F527",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f527.png",
        sheet_x: 18,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F527",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f527.png",
        sheet_x: 18,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Mechanic",
    b: "1F469-200D-1F527",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      35
    ],
    o: 4
  },
  "flag-jm": {
    a: "Jamaica Flag",
    b: "1F1EF-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      34
    ],
    o: 2
  },
  grey_question: {
    a: "White Question Mark Ornament",
    b: "2754",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "doubts",
      "gray",
      "huh",
      "confused"
    ],
    k: [
      55,
      24
    ],
    o: 2
  },
  maple_leaf: {
    a: "Maple Leaf",
    b: "1F341",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "plant",
      "vegetable",
      "ca",
      "fall"
    ],
    k: [
      6,
      25
    ],
    o: 2
  },
  pound: {
    a: "Banknote with Pound Sign",
    b: "1F4B7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "british",
      "sterling",
      "money",
      "sales",
      "bills",
      "uk",
      "england",
      "currency"
    ],
    k: [
      26,
      13
    ],
    o: 2
  },
  money_with_wings: {
    a: "Money with Wings",
    b: "1F4B8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dollar",
      "bills",
      "payment",
      "sale"
    ],
    k: [
      26,
      14
    ],
    o: 2
  },
  "flag-jo": {
    a: "Jordan Flag",
    b: "1F1EF-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      35
    ],
    o: 2
  },
  fallen_leaf: {
    a: "Fallen Leaf",
    b: "1F342",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "plant",
      "vegetable",
      "leaves"
    ],
    k: [
      6,
      26
    ],
    o: 2
  },
  factory_worker: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F3ED",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f3ed.png",
        sheet_x: 45,
        sheet_y: 54,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F3ED",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f3ed.png",
        sheet_x: 45,
        sheet_y: 55,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F3ED",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f3ed.png",
        sheet_x: 45,
        sheet_y: 56,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F3ED",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f3ed.png",
        sheet_x: 46,
        sheet_y: 0,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F3ED",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f3ed.png",
        sheet_x: 46,
        sheet_y: 1,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Factory Worker",
    b: "1F9D1-200D-1F3ED",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      45,
      53
    ],
    o: 12
  },
  broken_heart: {
    a: "Broken Heart",
    b: "1F494",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sad",
      "sorry",
      "break",
      "heart",
      "heartbreak"
    ],
    k: [
      25,
      30
    ],
    l: [
      "</3"
    ],
    m: "</3",
    o: 2
  },
  grey_exclamation: {
    a: "White Exclamation Mark Ornament",
    b: "2755",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "surprise",
      "punctuation",
      "gray",
      "wow",
      "warning"
    ],
    k: [
      55,
      25
    ],
    o: 2
  },
  mountain_cableway: {
    a: "Mountain Cableway",
    b: "1F6A0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle",
      "ski"
    ],
    k: [
      34,
      31
    ],
    o: 2
  },
  exclamation: {
    a: "Heavy Exclamation Mark Symbol",
    b: "2757",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "heavy_exclamation_mark",
      "danger",
      "surprise",
      "punctuation",
      "wow",
      "warning"
    ],
    k: [
      55,
      26
    ],
    n: [
      "heavy_exclamation_mark"
    ],
    o: 2
  },
  leaves: {
    a: "Leaf Fluttering in Wind",
    b: "1F343",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "plant",
      "tree",
      "vegetable",
      "grass",
      "lawn",
      "spring"
    ],
    k: [
      6,
      27
    ],
    o: 2
  },
  heart: {
    a: "Heavy Black Heart",
    b: "2764-FE0F",
    c: "2764",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "valentines"
    ],
    k: [
      55,
      28
    ],
    l: [
      "<3"
    ],
    m: "<3",
    o: 2
  },
  jp: {
    a: "Japan Flag",
    b: "1F1EF-1F1F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "japanese",
      "nation",
      "flag",
      "country",
      "banner"
    ],
    k: [
      2,
      36
    ],
    n: [
      "flag-jp"
    ],
    o: 2
  },
  "male-factory-worker": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F3ED",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f3ed.png",
        sheet_x: 15,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F3ED",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f3ed.png",
        sheet_x: 15,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F3ED",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f3ed.png",
        sheet_x: 15,
        sheet_y: 20,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F3ED",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f3ed.png",
        sheet_x: 15,
        sheet_y: 21,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F3ED",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f3ed.png",
        sheet_x: 15,
        sheet_y: 22,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Factory Worker",
    b: "1F468-200D-1F3ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      17
    ],
    o: 4
  },
  credit_card: {
    a: "Credit Card",
    b: "1F4B3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "money",
      "sales",
      "dollar",
      "bill",
      "payment",
      "shopping"
    ],
    k: [
      26,
      9
    ],
    o: 2
  },
  aerial_tramway: {
    a: "Aerial Tramway",
    b: "1F6A1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "transportation",
      "vehicle",
      "ski"
    ],
    k: [
      34,
      32
    ],
    o: 2
  },
  "female-factory-worker": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F3ED",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f3ed.png",
        sheet_x: 18,
        sheet_y: 8,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F3ED",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f3ed.png",
        sheet_x: 18,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F3ED",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f3ed.png",
        sheet_x: 18,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F3ED",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f3ed.png",
        sheet_x: 18,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F3ED",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f3ed.png",
        sheet_x: 18,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Factory Worker",
    b: "1F469-200D-1F3ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      7
    ],
    o: 4
  },
  receipt: {
    a: "Receipt",
    b: "1F9FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      49
    ],
    o: 11
  },
  wavy_dash: {
    a: "Wavy Dash",
    b: "3030-FE0F",
    c: "3030",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "draw",
      "line",
      "moustache",
      "mustache",
      "squiggle",
      "scribble"
    ],
    k: [
      55,
      44
    ],
    o: 2
  },
  "flag-ke": {
    a: "Kenya Flag",
    b: "1F1F0-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      37
    ],
    o: 2
  },
  satellite: {
    a: "Satellite",
    b: "1F6F0-FE0F",
    c: "1F6F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "communication",
      "future",
      "radio",
      "space"
    ],
    k: [
      36,
      51
    ],
    o: 2
  },
  orange_heart: {
    a: "Orange Heart",
    b: "1F9E1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      20
    ],
    o: 5
  },
  yellow_heart: {
    a: "Yellow Heart",
    b: "1F49B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    k: [
      25,
      37
    ],
    m: "<3",
    o: 2
  },
  copyright: {
    a: "Copyright Sign",
    b: "00A9-FE0F",
    c: "00A9",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "ip",
      "license",
      "circle",
      "law",
      "legal"
    ],
    k: [
      0,
      12
    ],
    o: 2
  },
  rocket: {
    a: "Rocket",
    b: "1F680",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "launch",
      "ship",
      "staffmode",
      "NASA",
      "outer space",
      "outer_space",
      "fly"
    ],
    k: [
      33,
      56
    ],
    o: 2
  },
  chart: {
    a: "Chart with Upwards Trend and Yen Sign",
    b: "1F4B9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "green-square",
      "graph",
      "presentation",
      "stats"
    ],
    k: [
      26,
      15
    ],
    o: 2
  },
  "flag-kg": {
    a: "Kyrgyzstan Flag",
    b: "1F1F0-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      38
    ],
    o: 2
  },
  office_worker: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F4BC",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f4bc.png",
        sheet_x: 46,
        sheet_y: 9,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F4BC",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f4bc.png",
        sheet_x: 46,
        sheet_y: 10,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F4BC",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f4bc.png",
        sheet_x: 46,
        sheet_y: 11,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F4BC",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f4bc.png",
        sheet_x: 46,
        sheet_y: 12,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F4BC",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f4bc.png",
        sheet_x: 46,
        sheet_y: 13,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Office Worker",
    b: "1F9D1-200D-1F4BC",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      46,
      8
    ],
    o: 12
  },
  currency_exchange: {
    a: "Currency Exchange",
    b: "1F4B1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "money",
      "sales",
      "dollar",
      "travel"
    ],
    k: [
      26,
      7
    ],
    o: 2
  },
  registered: {
    a: "Registered Sign",
    b: "00AE-FE0F",
    c: "00AE",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "alphabet",
      "circle"
    ],
    k: [
      0,
      13
    ],
    o: 2
  },
  green_heart: {
    a: "Green Heart",
    b: "1F49A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    k: [
      25,
      36
    ],
    m: "<3",
    o: 2
  },
  flying_saucer: {
    a: "Flying Saucer",
    b: "1F6F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      0
    ],
    o: 5
  },
  "flag-kh": {
    a: "Cambodia Flag",
    b: "1F1F0-1F1ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      39
    ],
    o: 2
  },
  "male-office-worker": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F4BC",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f4bc.png",
        sheet_x: 15,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F4BC",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f4bc.png",
        sheet_x: 15,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F4BC",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f4bc.png",
        sheet_x: 15,
        sheet_y: 47,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F4BC",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f4bc.png",
        sheet_x: 15,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F4BC",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f4bc.png",
        sheet_x: 15,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Office Worker",
    b: "1F468-200D-1F4BC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      44
    ],
    o: 4
  },
  tm: {
    a: "Trade Mark Sign",
    b: "2122-FE0F",
    c: "2122",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "trademark",
      "brand",
      "law",
      "legal"
    ],
    k: [
      52,
      12
    ],
    o: 2
  },
  bellhop_bell: {
    a: "Bellhop Bell",
    b: "1F6CE-FE0F",
    c: "1F6CE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "service"
    ],
    k: [
      36,
      36
    ],
    o: 2
  },
  blue_heart: {
    a: "Blue Heart",
    b: "1F499",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    k: [
      25,
      35
    ],
    m: "<3",
    o: 2
  },
  "flag-ki": {
    a: "Kiribati Flag",
    b: "1F1F0-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      40
    ],
    o: 2
  },
  heavy_dollar_sign: {
    a: "Heavy Dollar Sign",
    b: "1F4B2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "money",
      "sales",
      "payment",
      "currency",
      "buck"
    ],
    k: [
      26,
      8
    ],
    o: 2
  },
  "female-office-worker": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F4BC",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f4bc.png",
        sheet_x: 18,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F4BC",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f4bc.png",
        sheet_x: 18,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F4BC",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f4bc.png",
        sheet_x: 18,
        sheet_y: 32,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F4BC",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f4bc.png",
        sheet_x: 18,
        sheet_y: 33,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F4BC",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f4bc.png",
        sheet_x: 18,
        sheet_y: 34,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Office Worker",
    b: "1F469-200D-1F4BC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      29
    ],
    o: 4
  },
  purple_heart: {
    a: "Purple Heart",
    b: "1F49C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    k: [
      25,
      38
    ],
    m: "<3",
    o: 2
  },
  scientist: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F52C",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f52c.png",
        sheet_x: 46,
        sheet_y: 21,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F52C",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f52c.png",
        sheet_x: 46,
        sheet_y: 22,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F52C",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f52c.png",
        sheet_x: 46,
        sheet_y: 23,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F52C",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f52c.png",
        sheet_x: 46,
        sheet_y: 24,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F52C",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f52c.png",
        sheet_x: 46,
        sheet_y: 25,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Scientist",
    b: "1F9D1-200D-1F52C",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      46,
      20
    ],
    o: 12
  },
  luggage: {
    a: "Luggage",
    b: "1F9F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      38
    ],
    o: 11
  },
  hash: {
    a: "Hash Key",
    b: "0023-FE0F-20E3",
    c: "0023-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "symbol",
      "blue-square",
      "twitter"
    ],
    k: [
      0,
      0
    ],
    o: 0
  },
  "flag-km": {
    a: "Comoros Flag",
    b: "1F1F0-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      41
    ],
    o: 2
  },
  email: {
    a: "Envelope",
    b: "2709-FE0F",
    c: "2709",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "letter",
      "postal",
      "inbox",
      "communication"
    ],
    k: [
      54,
      42
    ],
    n: [
      "envelope"
    ],
    o: 2
  },
  "e-mail": {
    a: "E-Mail Symbol",
    b: "1F4E7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "communication",
      "inbox"
    ],
    k: [
      27,
      4
    ],
    o: 2
  },
  keycap_star: {
    a: "Keycap Star",
    b: "002A-FE0F-20E3",
    c: "002A-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      0,
      1
    ],
    o: 0
  },
  "flag-kn": {
    a: "St. Kitts & Nevis Flag",
    b: "1F1F0-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      42
    ],
    o: 2
  },
  hourglass: {
    a: "Hourglass",
    b: "231B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "clock",
      "oldschool",
      "limit",
      "exam",
      "quiz",
      "test"
    ],
    k: [
      52,
      23
    ],
    o: 2
  },
  brown_heart: {
    a: "Brown Heart",
    b: "1F90E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      16
    ],
    o: 12
  },
  "male-scientist": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F52C",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f52c.png",
        sheet_x: 16,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F52C",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f52c.png",
        sheet_x: 16,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F52C",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f52c.png",
        sheet_x: 16,
        sheet_y: 2,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F52C",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f52c.png",
        sheet_x: 16,
        sheet_y: 3,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F52C",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f52c.png",
        sheet_x: 16,
        sheet_y: 4,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Scientist",
    b: "1F468-200D-1F52C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      56
    ],
    o: 4
  },
  hourglass_flowing_sand: {
    a: "Hourglass with Flowing Sand",
    b: "23F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "oldschool",
      "time",
      "countdown"
    ],
    k: [
      52,
      36
    ],
    o: 2
  },
  black_heart: {
    a: "Black Heart",
    b: "1F5A4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "evil"
    ],
    k: [
      30,
      9
    ],
    o: 4
  },
  zero: {
    a: "Keycap 0",
    b: "0030-FE0F-20E3",
    c: "0030-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "0",
      "numbers",
      "blue-square",
      "null"
    ],
    k: [
      0,
      2
    ],
    o: 0
  },
  incoming_envelope: {
    a: "Incoming Envelope",
    b: "1F4E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "email",
      "inbox"
    ],
    k: [
      27,
      5
    ],
    o: 2
  },
  "flag-kp": {
    a: "North Korea Flag",
    b: "1F1F0-1F1F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      43
    ],
    o: 2
  },
  "female-scientist": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F52C",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f52c.png",
        sheet_x: 18,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F52C",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f52c.png",
        sheet_x: 18,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F52C",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f52c.png",
        sheet_x: 18,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F52C",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f52c.png",
        sheet_x: 18,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F52C",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f52c.png",
        sheet_x: 18,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Scientist",
    b: "1F469-200D-1F52C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      41
    ],
    o: 4
  },
  watch: {
    a: "Watch",
    b: "231A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "accessories"
    ],
    k: [
      52,
      22
    ],
    o: 2
  },
  white_heart: {
    a: "White Heart",
    b: "1F90D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      15
    ],
    o: 12
  },
  one: {
    a: "Keycap 1",
    b: "0031-FE0F-20E3",
    c: "0031-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "blue-square",
      "numbers",
      "1"
    ],
    k: [
      0,
      3
    ],
    o: 0
  },
  kr: {
    a: "South Korea Flag",
    b: "1F1F0-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "south",
      "korea",
      "nation",
      "flag",
      "country",
      "banner"
    ],
    k: [
      2,
      44
    ],
    n: [
      "flag-kr"
    ],
    o: 2
  },
  envelope_with_arrow: {
    a: "Envelope with Downwards Arrow Above",
    b: "1F4E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "email",
      "communication"
    ],
    k: [
      27,
      6
    ],
    o: 2
  },
  technologist: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F4BB",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f4bb.png",
        sheet_x: 46,
        sheet_y: 3,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F4BB",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f4bb.png",
        sheet_x: 46,
        sheet_y: 4,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F4BB",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f4bb.png",
        sheet_x: 46,
        sheet_y: 5,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F4BB",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f4bb.png",
        sheet_x: 46,
        sheet_y: 6,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F4BB",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f4bb.png",
        sheet_x: 46,
        sheet_y: 7,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Technologist",
    b: "1F9D1-200D-1F4BB",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      46,
      2
    ],
    o: 12
  },
  outbox_tray: {
    a: "Outbox Tray",
    b: "1F4E4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "inbox",
      "email"
    ],
    k: [
      27,
      1
    ],
    o: 2
  },
  "male-technologist": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F4BB",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f4bb.png",
        sheet_x: 15,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F4BB",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f4bb.png",
        sheet_x: 15,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F4BB",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f4bb.png",
        sheet_x: 15,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F4BB",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f4bb.png",
        sheet_x: 15,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F4BB",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f4bb.png",
        sheet_x: 15,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Technologist",
    b: "1F468-200D-1F4BB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      38
    ],
    o: 4
  },
  alarm_clock: {
    a: "Alarm Clock",
    b: "23F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "wake"
    ],
    k: [
      52,
      33
    ],
    o: 2
  },
  "flag-kw": {
    a: "Kuwait Flag",
    b: "1F1F0-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      45
    ],
    o: 2
  },
  two: {
    a: "Keycap 2",
    b: "0032-FE0F-20E3",
    c: "0032-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "numbers",
      "2",
      "prime",
      "blue-square"
    ],
    k: [
      0,
      4
    ],
    o: 0
  },
  anger: {
    a: "Anger Symbol",
    b: "1F4A2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "angry",
      "mad"
    ],
    k: [
      25,
      44
    ],
    o: 2
  },
  inbox_tray: {
    a: "Inbox Tray",
    b: "1F4E5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "email",
      "documents"
    ],
    k: [
      27,
      2
    ],
    o: 2
  },
  three: {
    a: "Keycap 3",
    b: "0033-FE0F-20E3",
    c: "0033-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "3",
      "numbers",
      "prime",
      "blue-square"
    ],
    k: [
      0,
      5
    ],
    o: 0
  },
  "flag-ky": {
    a: "Cayman Islands Flag",
    b: "1F1F0-1F1FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      46
    ],
    o: 2
  },
  stopwatch: {
    a: "Stopwatch",
    b: "23F1-FE0F",
    c: "23F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "deadline"
    ],
    k: [
      52,
      34
    ],
    o: 2
  },
  "female-technologist": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F4BB",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f4bb.png",
        sheet_x: 18,
        sheet_y: 24,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F4BB",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f4bb.png",
        sheet_x: 18,
        sheet_y: 25,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F4BB",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f4bb.png",
        sheet_x: 18,
        sheet_y: 26,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F4BB",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f4bb.png",
        sheet_x: 18,
        sheet_y: 27,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F4BB",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f4bb.png",
        sheet_x: 18,
        sheet_y: 28,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Technologist",
    b: "1F469-200D-1F4BB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      23
    ],
    o: 4
  },
  boom: {
    a: "Collision Symbol",
    b: "1F4A5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bomb",
      "explode",
      "explosion",
      "collision",
      "blown"
    ],
    k: [
      25,
      47
    ],
    n: [
      "collision"
    ],
    o: 2
  },
  "flag-kz": {
    a: "Kazakhstan Flag",
    b: "1F1F0-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      47
    ],
    o: 2
  },
  four: {
    a: "Keycap 4",
    b: "0034-FE0F-20E3",
    c: "0034-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "4",
      "numbers",
      "blue-square"
    ],
    k: [
      0,
      6
    ],
    o: 0
  },
  timer_clock: {
    a: "Timer Clock",
    b: "23F2-FE0F",
    c: "23F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "alarm"
    ],
    k: [
      52,
      35
    ],
    o: 2
  },
  singer: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F3A4",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f3a4.png",
        sheet_x: 45,
        sheet_y: 36,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F3A4",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f3a4.png",
        sheet_x: 45,
        sheet_y: 37,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F3A4",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f3a4.png",
        sheet_x: 45,
        sheet_y: 38,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F3A4",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f3a4.png",
        sheet_x: 45,
        sheet_y: 39,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F3A4",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f3a4.png",
        sheet_x: 45,
        sheet_y: 40,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Singer",
    b: "1F9D1-200D-1F3A4",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      45,
      35
    ],
    o: 12
  },
  package: {
    a: "Package",
    b: "1F4E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "mail",
      "gift",
      "cardboard",
      "box",
      "moving"
    ],
    k: [
      27,
      3
    ],
    o: 2
  },
  mailbox: {
    a: "Closed Mailbox with Raised Flag",
    b: "1F4EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "email",
      "inbox",
      "communication"
    ],
    k: [
      27,
      8
    ],
    o: 2
  },
  "flag-la": {
    a: "Laos Flag",
    b: "1F1F1-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      48
    ],
    o: 2
  },
  dizzy: {
    a: "Dizzy Symbol",
    b: "1F4AB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "star",
      "sparkle",
      "shoot",
      "magic"
    ],
    k: [
      26,
      1
    ],
    o: 2
  },
  five: {
    a: "Keycap 5",
    b: "0035-FE0F-20E3",
    c: "0035-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "5",
      "numbers",
      "blue-square",
      "prime"
    ],
    k: [
      0,
      7
    ],
    o: 0
  },
  "male-singer": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F3A4",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f3a4.png",
        sheet_x: 15,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F3A4",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f3a4.png",
        sheet_x: 15,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F3A4",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f3a4.png",
        sheet_x: 15,
        sheet_y: 2,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F3A4",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f3a4.png",
        sheet_x: 15,
        sheet_y: 3,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F3A4",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f3a4.png",
        sheet_x: 15,
        sheet_y: 4,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Singer",
    b: "1F468-200D-1F3A4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      14,
      56
    ],
    o: 4
  },
  mantelpiece_clock: {
    a: "Mantelpiece Clock",
    b: "1F570-FE0F",
    c: "1F570",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time"
    ],
    k: [
      29,
      7
    ],
    o: 2
  },
  "female-singer": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F3A4",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f3a4.png",
        sheet_x: 17,
        sheet_y: 47,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F3A4",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f3a4.png",
        sheet_x: 17,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F3A4",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f3a4.png",
        sheet_x: 17,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F3A4",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f3a4.png",
        sheet_x: 17,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F3A4",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f3a4.png",
        sheet_x: 17,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Singer",
    b: "1F469-200D-1F3A4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      46
    ],
    o: 4
  },
  "flag-lb": {
    a: "Lebanon Flag",
    b: "1F1F1-1F1E7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      49
    ],
    o: 2
  },
  six: {
    a: "Keycap 6",
    b: "0036-FE0F-20E3",
    c: "0036-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "6",
      "numbers",
      "blue-square"
    ],
    k: [
      0,
      8
    ],
    o: 0
  },
  mailbox_closed: {
    a: "Closed Mailbox with Lowered Flag",
    b: "1F4EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "email",
      "communication",
      "inbox"
    ],
    k: [
      27,
      7
    ],
    o: 2
  },
  sweat_drops: {
    a: "Splashing Sweat Symbol",
    b: "1F4A6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "water",
      "drip",
      "oops"
    ],
    k: [
      25,
      48
    ],
    o: 2
  },
  clock12: {
    a: "Clock Face Twelve Oclock",
    b: "1F55B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "noon",
      "midnight",
      "midday",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      50
    ],
    o: 2
  },
  seven: {
    a: "Keycap 7",
    b: "0037-FE0F-20E3",
    c: "0037-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "7",
      "numbers",
      "blue-square",
      "prime"
    ],
    k: [
      0,
      9
    ],
    o: 0
  },
  mailbox_with_mail: {
    a: "Open Mailbox with Raised Flag",
    b: "1F4EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "email",
      "inbox",
      "communication"
    ],
    k: [
      27,
      9
    ],
    o: 2
  },
  clock1230: {
    a: "Clock Face Twelve-Thirty",
    b: "1F567",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      29,
      5
    ],
    o: 2
  },
  dash: {
    a: "Dash Symbol",
    b: "1F4A8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "wind",
      "air",
      "fast",
      "shoo",
      "fart",
      "smoke",
      "puff"
    ],
    k: [
      25,
      50
    ],
    o: 2
  },
  artist: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F3A8",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f3a8.png",
        sheet_x: 45,
        sheet_y: 42,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F3A8",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f3a8.png",
        sheet_x: 45,
        sheet_y: 43,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F3A8",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f3a8.png",
        sheet_x: 45,
        sheet_y: 44,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F3A8",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f3a8.png",
        sheet_x: 45,
        sheet_y: 45,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F3A8",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f3a8.png",
        sheet_x: 45,
        sheet_y: 46,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Artist",
    b: "1F9D1-200D-1F3A8",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      45,
      41
    ],
    o: 12
  },
  "flag-lc": {
    a: "St. Lucia Flag",
    b: "1F1F1-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      50
    ],
    o: 2
  },
  hole: {
    a: "Hole",
    b: "1F573-FE0F",
    c: "1F573",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "embarrassing"
    ],
    k: [
      29,
      8
    ],
    o: 2
  },
  "male-artist": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F3A8",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f3a8.png",
        sheet_x: 15,
        sheet_y: 6,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F3A8",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f3a8.png",
        sheet_x: 15,
        sheet_y: 7,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F3A8",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f3a8.png",
        sheet_x: 15,
        sheet_y: 8,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F3A8",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f3a8.png",
        sheet_x: 15,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F3A8",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f3a8.png",
        sheet_x: 15,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Artist",
    b: "1F468-200D-1F3A8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      5
    ],
    o: 4
  },
  clock1: {
    a: "Clock Face One Oclock",
    b: "1F550",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      39
    ],
    o: 2
  },
  eight: {
    a: "Keycap 8",
    b: "0038-FE0F-20E3",
    c: "0038-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "8",
      "blue-square",
      "numbers"
    ],
    k: [
      0,
      10
    ],
    o: 0
  },
  mailbox_with_no_mail: {
    a: "Open Mailbox with Lowered Flag",
    b: "1F4ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "email",
      "inbox"
    ],
    k: [
      27,
      10
    ],
    o: 2
  },
  "flag-li": {
    a: "Liechtenstein Flag",
    b: "1F1F1-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      51
    ],
    o: 2
  },
  bomb: {
    a: "Bomb",
    b: "1F4A3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "boom",
      "explode",
      "explosion",
      "terrorism"
    ],
    k: [
      25,
      45
    ],
    o: 2
  },
  nine: {
    a: "Keycap 9",
    b: "0039-FE0F-20E3",
    c: "0039-20E3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "blue-square",
      "numbers",
      "9"
    ],
    k: [
      0,
      11
    ],
    o: 0
  },
  postbox: {
    a: "Postbox",
    b: "1F4EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "email",
      "letter",
      "envelope"
    ],
    k: [
      27,
      11
    ],
    o: 2
  },
  "female-artist": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F3A8",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f3a8.png",
        sheet_x: 17,
        sheet_y: 53,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F3A8",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f3a8.png",
        sheet_x: 17,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F3A8",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f3a8.png",
        sheet_x: 17,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F3A8",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f3a8.png",
        sheet_x: 17,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F3A8",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f3a8.png",
        sheet_x: 18,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Artist",
    b: "1F469-200D-1F3A8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      52
    ],
    o: 4
  },
  clock130: {
    a: "Clock Face One-Thirty",
    b: "1F55C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      51
    ],
    o: 2
  },
  "flag-lk": {
    a: "Sri Lanka Flag",
    b: "1F1F1-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      52
    ],
    o: 2
  },
  ballot_box_with_ballot: {
    a: "Ballot Box with Ballot",
    b: "1F5F3-FE0F",
    c: "1F5F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      28
    ],
    o: 2
  },
  pilot: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-2708-FE0F",
        non_qualified: "1F9D1-1F3FB-200D-2708",
        image: "1f9d1-1f3fb-200d-2708-fe0f.png",
        sheet_x: 48,
        sheet_y: 5,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-2708-FE0F",
        non_qualified: "1F9D1-1F3FC-200D-2708",
        image: "1f9d1-1f3fc-200d-2708-fe0f.png",
        sheet_x: 48,
        sheet_y: 6,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-2708-FE0F",
        non_qualified: "1F9D1-1F3FD-200D-2708",
        image: "1f9d1-1f3fd-200d-2708-fe0f.png",
        sheet_x: 48,
        sheet_y: 7,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-2708-FE0F",
        non_qualified: "1F9D1-1F3FE-200D-2708",
        image: "1f9d1-1f3fe-200d-2708-fe0f.png",
        sheet_x: 48,
        sheet_y: 8,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-2708-FE0F",
        non_qualified: "1F9D1-1F3FF-200D-2708",
        image: "1f9d1-1f3ff-200d-2708-fe0f.png",
        sheet_x: 48,
        sheet_y: 9,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Pilot",
    b: "1F9D1-200D-2708-FE0F",
    c: "1F9D1-200D-2708",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      48,
      4
    ],
    o: 12
  },
  keycap_ten: {
    a: "Keycap Ten",
    b: "1F51F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "numbers",
      "10",
      "blue-square"
    ],
    k: [
      28,
      2
    ],
    o: 2
  },
  clock2: {
    a: "Clock Face Two Oclock",
    b: "1F551",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      40
    ],
    o: 2
  },
  "flag-lr": {
    a: "Liberia Flag",
    b: "1F1F1-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      53
    ],
    o: 2
  },
  speech_balloon: {
    a: "Speech Balloon",
    b: "1F4AC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bubble",
      "words",
      "message",
      "talk",
      "chatting"
    ],
    k: [
      26,
      2
    ],
    o: 2
  },
  "eye-in-speech-bubble": {
    a: "Eye in Speech Bubble",
    b: "1F441-FE0F-200D-1F5E8-FE0F",
    d: !0,
    e: !0,
    f: !1,
    h: !1,
    k: [
      12,
      37
    ],
    o: 2
  },
  "flag-ls": {
    a: "Lesotho Flag",
    b: "1F1F1-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      54
    ],
    o: 2
  },
  clock230: {
    a: "Clock Face Two-Thirty",
    b: "1F55D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      52
    ],
    o: 2
  },
  "male-pilot": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-2708-FE0F",
        non_qualified: "1F468-1F3FB-200D-2708",
        image: "1f468-1f3fb-200d-2708-fe0f.png",
        sheet_x: 17,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-2708-FE0F",
        non_qualified: "1F468-1F3FC-200D-2708",
        image: "1f468-1f3fc-200d-2708-fe0f.png",
        sheet_x: 17,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-2708-FE0F",
        non_qualified: "1F468-1F3FD-200D-2708",
        image: "1f468-1f3fd-200d-2708-fe0f.png",
        sheet_x: 17,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-2708-FE0F",
        non_qualified: "1F468-1F3FE-200D-2708",
        image: "1f468-1f3fe-200d-2708-fe0f.png",
        sheet_x: 17,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-2708-FE0F",
        non_qualified: "1F468-1F3FF-200D-2708",
        image: "1f468-1f3ff-200d-2708-fe0f.png",
        sheet_x: 17,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Pilot",
    b: "1F468-200D-2708-FE0F",
    c: "1F468-200D-2708",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      14
    ],
    o: 4
  },
  capital_abcd: {
    a: "Input Symbol for Latin Capital Letters",
    b: "1F520",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "alphabet",
      "words",
      "blue-square"
    ],
    k: [
      28,
      3
    ],
    o: 2
  },
  pencil2: {
    a: "Pencil",
    b: "270F-FE0F",
    c: "270F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stationery",
      "write",
      "paper",
      "writing",
      "school",
      "study"
    ],
    k: [
      55,
      10
    ],
    o: 2
  },
  "female-pilot": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-2708-FE0F",
        non_qualified: "1F469-1F3FB-200D-2708",
        image: "1f469-1f3fb-200d-2708-fe0f.png",
        sheet_x: 20,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-2708-FE0F",
        non_qualified: "1F469-1F3FC-200D-2708",
        image: "1f469-1f3fc-200d-2708-fe0f.png",
        sheet_x: 20,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-2708-FE0F",
        non_qualified: "1F469-1F3FD-200D-2708",
        image: "1f469-1f3fd-200d-2708-fe0f.png",
        sheet_x: 20,
        sheet_y: 2,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-2708-FE0F",
        non_qualified: "1F469-1F3FE-200D-2708",
        image: "1f469-1f3fe-200d-2708-fe0f.png",
        sheet_x: 20,
        sheet_y: 3,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-2708-FE0F",
        non_qualified: "1F469-1F3FF-200D-2708",
        image: "1f469-1f3ff-200d-2708-fe0f.png",
        sheet_x: 20,
        sheet_y: 4,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Pilot",
    b: "1F469-200D-2708-FE0F",
    c: "1F469-200D-2708",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      56
    ],
    o: 4
  },
  black_nib: {
    a: "Black Nib",
    b: "2712-FE0F",
    c: "2712",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "pen",
      "stationery",
      "writing",
      "write"
    ],
    k: [
      55,
      11
    ],
    o: 2
  },
  left_speech_bubble: {
    a: "Left Speech Bubble",
    b: "1F5E8-FE0F",
    c: "1F5E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "words",
      "message",
      "talk",
      "chatting"
    ],
    k: [
      30,
      26
    ],
    o: 2
  },
  clock3: {
    a: "Clock Face Three Oclock",
    b: "1F552",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      41
    ],
    o: 2
  },
  abcd: {
    a: "Input Symbol for Latin Small Letters",
    b: "1F521",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "alphabet"
    ],
    k: [
      28,
      4
    ],
    o: 2
  },
  "flag-lt": {
    a: "Lithuania Flag",
    b: "1F1F1-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      55
    ],
    o: 2
  },
  clock330: {
    a: "Clock Face Three-Thirty",
    b: "1F55E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      53
    ],
    o: 2
  },
  astronaut: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F680",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f680.png",
        sheet_x: 46,
        sheet_y: 27,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F680",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f680.png",
        sheet_x: 46,
        sheet_y: 28,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F680",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f680.png",
        sheet_x: 46,
        sheet_y: 29,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F680",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f680.png",
        sheet_x: 46,
        sheet_y: 30,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F680",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f680.png",
        sheet_x: 46,
        sheet_y: 31,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Astronaut",
    b: "1F9D1-200D-1F680",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      46,
      26
    ],
    o: 12
  },
  "flag-lu": {
    a: "Luxembourg Flag",
    b: "1F1F1-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      2,
      56
    ],
    o: 2
  },
  right_anger_bubble: {
    a: "Right Anger Bubble",
    b: "1F5EF-FE0F",
    c: "1F5EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "caption",
      "speech",
      "thinking",
      "mad"
    ],
    k: [
      30,
      27
    ],
    o: 2
  },
  lower_left_fountain_pen: {
    a: "Lower Left Fountain Pen",
    b: "1F58B-FE0F",
    c: "1F58B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      29,
      45
    ],
    o: 2
  },
  "male-astronaut": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F680",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f680.png",
        sheet_x: 16,
        sheet_y: 6,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F680",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f680.png",
        sheet_x: 16,
        sheet_y: 7,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F680",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f680.png",
        sheet_x: 16,
        sheet_y: 8,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F680",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f680.png",
        sheet_x: 16,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F680",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f680.png",
        sheet_x: 16,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Astronaut",
    b: "1F468-200D-1F680",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      16,
      5
    ],
    o: 4
  },
  thought_balloon: {
    a: "Thought Balloon",
    b: "1F4AD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bubble",
      "cloud",
      "speech",
      "thinking",
      "dream"
    ],
    k: [
      26,
      3
    ],
    o: 2
  },
  symbols: {
    a: "Input Symbol for Symbols",
    b: "1F523",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "music",
      "note",
      "ampersand",
      "percent",
      "glyphs",
      "characters"
    ],
    k: [
      28,
      6
    ],
    o: 2
  },
  clock4: {
    a: "Clock Face Four Oclock",
    b: "1F553",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      42
    ],
    o: 2
  },
  "flag-lv": {
    a: "Latvia Flag",
    b: "1F1F1-1F1FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      0
    ],
    o: 2
  },
  lower_left_ballpoint_pen: {
    a: "Lower Left Ballpoint Pen",
    b: "1F58A-FE0F",
    c: "1F58A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      29,
      44
    ],
    o: 2
  },
  abc: {
    a: "Input Symbol for Latin Letters",
    b: "1F524",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "alphabet"
    ],
    k: [
      28,
      7
    ],
    o: 2
  },
  zzz: {
    a: "Sleeping Symbol",
    b: "1F4A4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sleepy",
      "tired",
      "dream"
    ],
    k: [
      25,
      46
    ],
    o: 2
  },
  lower_left_paintbrush: {
    a: "Lower Left Paintbrush",
    b: "1F58C-FE0F",
    c: "1F58C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      29,
      46
    ],
    o: 2
  },
  "female-astronaut": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F680",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f680.png",
        sheet_x: 18,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F680",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f680.png",
        sheet_x: 18,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F680",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f680.png",
        sheet_x: 18,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F680",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f680.png",
        sheet_x: 18,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F680",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f680.png",
        sheet_x: 18,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Astronaut",
    b: "1F469-200D-1F680",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      47
    ],
    o: 4
  },
  "flag-ly": {
    a: "Libya Flag",
    b: "1F1F1-1F1FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      1
    ],
    o: 2
  },
  clock430: {
    a: "Clock Face Four-Thirty",
    b: "1F55F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      54
    ],
    o: 2
  },
  "flag-ma": {
    a: "Morocco Flag",
    b: "1F1F2-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      2
    ],
    o: 2
  },
  a: {
    a: "Negative Squared Latin Capital Letter a",
    b: "1F170-FE0F",
    c: "1F170",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "red-square",
      "alphabet",
      "letter"
    ],
    k: [
      0,
      16
    ],
    o: 2
  },
  clock5: {
    a: "Clock Face Five Oclock",
    b: "1F554",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      43
    ],
    o: 2
  },
  lower_left_crayon: {
    a: "Lower Left Crayon",
    b: "1F58D-FE0F",
    c: "1F58D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      29,
      47
    ],
    o: 2
  },
  firefighter: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F692",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f692.png",
        sheet_x: 46,
        sheet_y: 33,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F692",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f692.png",
        sheet_x: 46,
        sheet_y: 34,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F692",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f692.png",
        sheet_x: 46,
        sheet_y: 35,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F692",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f692.png",
        sheet_x: 46,
        sheet_y: 36,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F692",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f692.png",
        sheet_x: 46,
        sheet_y: 37,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Firefighter",
    b: "1F9D1-200D-1F692",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      46,
      32
    ],
    o: 12
  },
  "male-firefighter": {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F692",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f692.png",
        sheet_x: 16,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F692",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f692.png",
        sheet_x: 16,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F692",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f692.png",
        sheet_x: 16,
        sheet_y: 14,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F692",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f692.png",
        sheet_x: 16,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F692",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f692.png",
        sheet_x: 16,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Firefighter",
    b: "1F468-200D-1F692",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      16,
      11
    ],
    o: 4
  },
  memo: {
    a: "Memo",
    b: "1F4DD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "write",
      "documents",
      "stationery",
      "pencil",
      "paper",
      "writing",
      "legal",
      "exam",
      "quiz",
      "test",
      "study",
      "compose"
    ],
    k: [
      26,
      51
    ],
    n: [
      "pencil"
    ],
    o: 2
  },
  ab: {
    a: "Negative Squared Ab",
    b: "1F18E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "red-square",
      "alphabet"
    ],
    k: [
      0,
      20
    ],
    o: 2
  },
  "flag-mc": {
    a: "Monaco Flag",
    b: "1F1F2-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      3
    ],
    o: 2
  },
  clock530: {
    a: "Clock Face Five-Thirty",
    b: "1F560",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      55
    ],
    o: 2
  },
  briefcase: {
    a: "Briefcase",
    b: "1F4BC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "business",
      "documents",
      "work",
      "law",
      "legal",
      "job",
      "career"
    ],
    k: [
      26,
      18
    ],
    o: 2
  },
  "female-firefighter": {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F692",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f692.png",
        sheet_x: 18,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F692",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f692.png",
        sheet_x: 18,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F692",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f692.png",
        sheet_x: 18,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F692",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f692.png",
        sheet_x: 19,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F692",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f692.png",
        sheet_x: 19,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Firefighter",
    b: "1F469-200D-1F692",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      53
    ],
    o: 4
  },
  clock6: {
    a: "Clock Face Six Oclock",
    b: "1F555",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule",
      "dawn",
      "dusk"
    ],
    k: [
      28,
      44
    ],
    o: 2
  },
  b: {
    a: "Negative Squared Latin Capital Letter B",
    b: "1F171-FE0F",
    c: "1F171",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "red-square",
      "alphabet",
      "letter"
    ],
    k: [
      0,
      17
    ],
    o: 2
  },
  "flag-md": {
    a: "Moldova Flag",
    b: "1F1F2-1F1E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      4
    ],
    o: 2
  },
  clock630: {
    a: "Clock Face Six-Thirty",
    b: "1F561",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      56
    ],
    o: 2
  },
  cl: {
    a: "Squared Cl",
    b: "1F191",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "alphabet",
      "words",
      "red-square"
    ],
    k: [
      0,
      21
    ],
    o: 2
  },
  "flag-me": {
    a: "Montenegro Flag",
    b: "1F1F2-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      5
    ],
    o: 2
  },
  file_folder: {
    a: "File Folder",
    b: "1F4C1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "documents",
      "business",
      "office"
    ],
    k: [
      26,
      23
    ],
    o: 2
  },
  cop: {
    skin_variations: {
      "1F3FB": {
        unified: "1F46E-1F3FB",
        non_qualified: null,
        image: "1f46e-1f3fb.png",
        sheet_x: 21,
        sheet_y: 50,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F46E-1F3FC",
        non_qualified: null,
        image: "1f46e-1f3fc.png",
        sheet_x: 21,
        sheet_y: 51,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F46E-1F3FD",
        non_qualified: null,
        image: "1f46e-1f3fd.png",
        sheet_x: 21,
        sheet_y: 52,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F46E-1F3FE",
        non_qualified: null,
        image: "1f46e-1f3fe.png",
        sheet_x: 21,
        sheet_y: 53,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F46E-1F3FF",
        non_qualified: null,
        image: "1f46e-1f3ff.png",
        sheet_x: 21,
        sheet_y: 54,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F46E-200D-2642-FE0F",
    a: "Police Officer",
    b: "1F46E",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      21,
      49
    ],
    o: 2
  },
  "male-police-officer": {
    skin_variations: {
      "1F3FB": {
        unified: "1F46E-1F3FB-200D-2642-FE0F",
        non_qualified: "1F46E-1F3FB-200D-2642",
        image: "1f46e-1f3fb-200d-2642-fe0f.png",
        sheet_x: 21,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F46E-1F3FC-200D-2642-FE0F",
        non_qualified: "1F46E-1F3FC-200D-2642",
        image: "1f46e-1f3fc-200d-2642-fe0f.png",
        sheet_x: 21,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F46E-1F3FD-200D-2642-FE0F",
        non_qualified: "1F46E-1F3FD-200D-2642",
        image: "1f46e-1f3fd-200d-2642-fe0f.png",
        sheet_x: 21,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F46E-1F3FE-200D-2642-FE0F",
        non_qualified: "1F46E-1F3FE-200D-2642",
        image: "1f46e-1f3fe-200d-2642-fe0f.png",
        sheet_x: 21,
        sheet_y: 47,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F46E-1F3FF-200D-2642-FE0F",
        non_qualified: "1F46E-1F3FF-200D-2642",
        image: "1f46e-1f3ff-200d-2642-fe0f.png",
        sheet_x: 21,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F46E",
    a: "Male Police Officer",
    b: "1F46E-200D-2642-FE0F",
    c: "1F46E-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      21,
      43
    ],
    o: 4
  },
  cool: {
    a: "Squared Cool",
    b: "1F192",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "words",
      "blue-square"
    ],
    k: [
      0,
      22
    ],
    o: 2
  },
  clock7: {
    a: "Clock Face Seven Oclock",
    b: "1F556",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      45
    ],
    o: 2
  },
  "flag-mf": {
    a: "St. Martin Flag",
    b: "1F1F2-1F1EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      6
    ],
    o: 2
  },
  open_file_folder: {
    a: "Open File Folder",
    b: "1F4C2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "documents",
      "load"
    ],
    k: [
      26,
      24
    ],
    o: 2
  },
  card_index_dividers: {
    a: "Card Index Dividers",
    b: "1F5C2-FE0F",
    c: "1F5C2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "organizing",
      "business",
      "stationery"
    ],
    k: [
      30,
      15
    ],
    o: 2
  },
  "flag-mg": {
    a: "Madagascar Flag",
    b: "1F1F2-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      7
    ],
    o: 2
  },
  free: {
    a: "Squared Free",
    b: "1F193",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "words"
    ],
    k: [
      0,
      23
    ],
    o: 2
  },
  "female-police-officer": {
    skin_variations: {
      "1F3FB": {
        unified: "1F46E-1F3FB-200D-2640-FE0F",
        non_qualified: "1F46E-1F3FB-200D-2640",
        image: "1f46e-1f3fb-200d-2640-fe0f.png",
        sheet_x: 21,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F46E-1F3FC-200D-2640-FE0F",
        non_qualified: "1F46E-1F3FC-200D-2640",
        image: "1f46e-1f3fc-200d-2640-fe0f.png",
        sheet_x: 21,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F46E-1F3FD-200D-2640-FE0F",
        non_qualified: "1F46E-1F3FD-200D-2640",
        image: "1f46e-1f3fd-200d-2640-fe0f.png",
        sheet_x: 21,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F46E-1F3FE-200D-2640-FE0F",
        non_qualified: "1F46E-1F3FE-200D-2640",
        image: "1f46e-1f3fe-200d-2640-fe0f.png",
        sheet_x: 21,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F46E-1F3FF-200D-2640-FE0F",
        non_qualified: "1F46E-1F3FF-200D-2640",
        image: "1f46e-1f3ff-200d-2640-fe0f.png",
        sheet_x: 21,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Police Officer",
    b: "1F46E-200D-2640-FE0F",
    c: "1F46E-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      21,
      37
    ],
    o: 4
  },
  clock730: {
    a: "Clock Face Seven-Thirty",
    b: "1F562",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      29,
      0
    ],
    o: 2
  },
  date: {
    a: "Calendar",
    b: "1F4C5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "calendar",
      "schedule"
    ],
    k: [
      26,
      27
    ],
    o: 2
  },
  clock8: {
    a: "Clock Face Eight Oclock",
    b: "1F557",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      46
    ],
    o: 2
  },
  information_source: {
    a: "Information Source",
    b: "2139-FE0F",
    c: "2139",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "alphabet",
      "letter"
    ],
    k: [
      52,
      13
    ],
    o: 2
  },
  sleuth_or_spy: {
    skin_variations: {
      "1F3FB": {
        unified: "1F575-1F3FB",
        non_qualified: null,
        image: "1f575-1f3fb.png",
        sheet_x: 29,
        sheet_y: 28,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F575-1F3FC",
        non_qualified: null,
        image: "1f575-1f3fc.png",
        sheet_x: 29,
        sheet_y: 29,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F575-1F3FD",
        non_qualified: null,
        image: "1f575-1f3fd.png",
        sheet_x: 29,
        sheet_y: 30,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F575-1F3FE",
        non_qualified: null,
        image: "1f575-1f3fe.png",
        sheet_x: 29,
        sheet_y: 31,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F575-1F3FF",
        non_qualified: null,
        image: "1f575-1f3ff.png",
        sheet_x: 29,
        sheet_y: 32,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F575-FE0F-200D-2642-FE0F",
    a: "Sleuth or Spy",
    b: "1F575-FE0F",
    c: "1F575",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      29,
      27
    ],
    o: 2
  },
  "flag-mh": {
    a: "Marshall Islands Flag",
    b: "1F1F2-1F1ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      8
    ],
    o: 2
  },
  clock830: {
    a: "Clock Face Eight-Thirty",
    b: "1F563",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      29,
      1
    ],
    o: 2
  },
  calendar: {
    a: "Tear-off Calendar",
    b: "1F4C6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "schedule",
      "date",
      "planning"
    ],
    k: [
      26,
      28
    ],
    o: 2
  },
  "male-detective": {
    skin_variations: {
      "1F3FB": {
        unified: "1F575-1F3FB-200D-2642-FE0F",
        non_qualified: "1F575-1F3FB-200D-2642",
        image: "1f575-1f3fb-200d-2642-fe0f.png",
        sheet_x: 29,
        sheet_y: 22,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F575-1F3FC-200D-2642-FE0F",
        non_qualified: "1F575-1F3FC-200D-2642",
        image: "1f575-1f3fc-200d-2642-fe0f.png",
        sheet_x: 29,
        sheet_y: 23,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F575-1F3FD-200D-2642-FE0F",
        non_qualified: "1F575-1F3FD-200D-2642",
        image: "1f575-1f3fd-200d-2642-fe0f.png",
        sheet_x: 29,
        sheet_y: 24,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F575-1F3FE-200D-2642-FE0F",
        non_qualified: "1F575-1F3FE-200D-2642",
        image: "1f575-1f3fe-200d-2642-fe0f.png",
        sheet_x: 29,
        sheet_y: 25,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F575-1F3FF-200D-2642-FE0F",
        non_qualified: "1F575-1F3FF-200D-2642",
        image: "1f575-1f3ff-200d-2642-fe0f.png",
        sheet_x: 29,
        sheet_y: 26,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F575-FE0F",
    a: "Male Detective",
    b: "1F575-FE0F-200D-2642-FE0F",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      29,
      21
    ],
    o: 4
  },
  "flag-mk": {
    a: "North Macedonia Flag",
    b: "1F1F2-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      9
    ],
    o: 2
  },
  id: {
    a: "Squared Id",
    b: "1F194",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "purple-square",
      "words"
    ],
    k: [
      0,
      24
    ],
    o: 2
  },
  spiral_note_pad: {
    a: "Spiral Note Pad",
    b: "1F5D2-FE0F",
    c: "1F5D2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      19
    ],
    o: 2
  },
  "female-detective": {
    skin_variations: {
      "1F3FB": {
        unified: "1F575-1F3FB-200D-2640-FE0F",
        non_qualified: "1F575-1F3FB-200D-2640",
        image: "1f575-1f3fb-200d-2640-fe0f.png",
        sheet_x: 29,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F575-1F3FC-200D-2640-FE0F",
        non_qualified: "1F575-1F3FC-200D-2640",
        image: "1f575-1f3fc-200d-2640-fe0f.png",
        sheet_x: 29,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F575-1F3FD-200D-2640-FE0F",
        non_qualified: "1F575-1F3FD-200D-2640",
        image: "1f575-1f3fd-200d-2640-fe0f.png",
        sheet_x: 29,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F575-1F3FE-200D-2640-FE0F",
        non_qualified: "1F575-1F3FE-200D-2640",
        image: "1f575-1f3fe-200d-2640-fe0f.png",
        sheet_x: 29,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F575-1F3FF-200D-2640-FE0F",
        non_qualified: "1F575-1F3FF-200D-2640",
        image: "1f575-1f3ff-200d-2640-fe0f.png",
        sheet_x: 29,
        sheet_y: 20,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Detective",
    b: "1F575-FE0F-200D-2640-FE0F",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      29,
      15
    ],
    o: 4
  },
  clock9: {
    a: "Clock Face Nine Oclock",
    b: "1F558",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      47
    ],
    o: 2
  },
  "flag-ml": {
    a: "Mali Flag",
    b: "1F1F2-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      10
    ],
    o: 2
  },
  m: {
    a: "Circled Latin Capital Letter M",
    b: "24C2-FE0F",
    c: "24C2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "alphabet",
      "blue-circle",
      "letter"
    ],
    k: [
      52,
      40
    ],
    o: 2
  },
  "flag-mm": {
    a: "Myanmar (burma) Flag",
    b: "1F1F2-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      11
    ],
    o: 2
  },
  clock930: {
    a: "Clock Face Nine-Thirty",
    b: "1F564",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      29,
      2
    ],
    o: 2
  },
  guardsman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F482-1F3FB",
        non_qualified: null,
        image: "1f482-1f3fb.png",
        sheet_x: 24,
        sheet_y: 21,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F482-1F3FC",
        non_qualified: null,
        image: "1f482-1f3fc.png",
        sheet_x: 24,
        sheet_y: 22,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F482-1F3FD",
        non_qualified: null,
        image: "1f482-1f3fd.png",
        sheet_x: 24,
        sheet_y: 23,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F482-1F3FE",
        non_qualified: null,
        image: "1f482-1f3fe.png",
        sheet_x: 24,
        sheet_y: 24,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F482-1F3FF",
        non_qualified: null,
        image: "1f482-1f3ff.png",
        sheet_x: 24,
        sheet_y: 25,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F482-200D-2642-FE0F",
    a: "Guardsman",
    b: "1F482",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "uk",
      "gb",
      "british",
      "male",
      "guy",
      "royal"
    ],
    k: [
      24,
      20
    ],
    o: 2
  },
  new: {
    a: "Squared New",
    b: "1F195",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "words",
      "start"
    ],
    k: [
      0,
      25
    ],
    o: 2
  },
  spiral_calendar_pad: {
    a: "Spiral Calendar Pad",
    b: "1F5D3-FE0F",
    c: "1F5D3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      20
    ],
    o: 2
  },
  ng: {
    a: "Squared Ng",
    b: "1F196",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "words",
      "shape",
      "icon"
    ],
    k: [
      0,
      26
    ],
    o: 2
  },
  card_index: {
    a: "Card Index",
    b: "1F4C7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "business",
      "stationery"
    ],
    k: [
      26,
      29
    ],
    o: 2
  },
  clock10: {
    a: "Clock Face Ten Oclock",
    b: "1F559",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      48
    ],
    o: 2
  },
  "flag-mn": {
    a: "Mongolia Flag",
    b: "1F1F2-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      12
    ],
    o: 2
  },
  "male-guard": {
    skin_variations: {
      "1F3FB": {
        unified: "1F482-1F3FB-200D-2642-FE0F",
        non_qualified: "1F482-1F3FB-200D-2642",
        image: "1f482-1f3fb-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F482-1F3FC-200D-2642-FE0F",
        non_qualified: "1F482-1F3FC-200D-2642",
        image: "1f482-1f3fc-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F482-1F3FD-200D-2642-FE0F",
        non_qualified: "1F482-1F3FD-200D-2642",
        image: "1f482-1f3fd-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F482-1F3FE-200D-2642-FE0F",
        non_qualified: "1F482-1F3FE-200D-2642",
        image: "1f482-1f3fe-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F482-1F3FF-200D-2642-FE0F",
        non_qualified: "1F482-1F3FF-200D-2642",
        image: "1f482-1f3ff-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F482",
    a: "Male Guard",
    b: "1F482-200D-2642-FE0F",
    c: "1F482-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      24,
      14
    ],
    o: 4
  },
  "flag-mo": {
    a: "Macao Sar China Flag",
    b: "1F1F2-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      13
    ],
    o: 2
  },
  clock1030: {
    a: "Clock Face Ten-Thirty",
    b: "1F565",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      29,
      3
    ],
    o: 2
  },
  chart_with_upwards_trend: {
    a: "Chart with Upwards Trend",
    b: "1F4C8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "graph",
      "presentation",
      "stats",
      "recovery",
      "business",
      "economics",
      "money",
      "sales",
      "good",
      "success"
    ],
    k: [
      26,
      30
    ],
    o: 2
  },
  o2: {
    a: "Negative Squared Latin Capital Letter O",
    b: "1F17E-FE0F",
    c: "1F17E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "alphabet",
      "red-square",
      "letter"
    ],
    k: [
      0,
      18
    ],
    o: 2
  },
  "female-guard": {
    skin_variations: {
      "1F3FB": {
        unified: "1F482-1F3FB-200D-2640-FE0F",
        non_qualified: "1F482-1F3FB-200D-2640",
        image: "1f482-1f3fb-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F482-1F3FC-200D-2640-FE0F",
        non_qualified: "1F482-1F3FC-200D-2640",
        image: "1f482-1f3fc-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F482-1F3FD-200D-2640-FE0F",
        non_qualified: "1F482-1F3FD-200D-2640",
        image: "1f482-1f3fd-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F482-1F3FE-200D-2640-FE0F",
        non_qualified: "1F482-1F3FE-200D-2640",
        image: "1f482-1f3fe-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F482-1F3FF-200D-2640-FE0F",
        non_qualified: "1F482-1F3FF-200D-2640",
        image: "1f482-1f3ff-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Guard",
    b: "1F482-200D-2640-FE0F",
    c: "1F482-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      24,
      8
    ],
    o: 4
  },
  chart_with_downwards_trend: {
    a: "Chart with Downwards Trend",
    b: "1F4C9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "graph",
      "presentation",
      "stats",
      "recession",
      "business",
      "economics",
      "money",
      "sales",
      "bad",
      "failure"
    ],
    k: [
      26,
      31
    ],
    o: 2
  },
  "flag-mp": {
    a: "Northern Mariana Islands Flag",
    b: "1F1F2-1F1F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      14
    ],
    o: 2
  },
  ok: {
    a: "Squared Ok",
    b: "1F197",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "good",
      "agree",
      "yes",
      "blue-square"
    ],
    k: [
      0,
      27
    ],
    o: 2
  },
  clock11: {
    a: "Clock Face Eleven Oclock",
    b: "1F55A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      28,
      49
    ],
    o: 2
  },
  construction_worker: {
    skin_variations: {
      "1F3FB": {
        unified: "1F477-1F3FB",
        non_qualified: null,
        image: "1f477-1f3fb.png",
        sheet_x: 23,
        sheet_y: 23,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F477-1F3FC",
        non_qualified: null,
        image: "1f477-1f3fc.png",
        sheet_x: 23,
        sheet_y: 24,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F477-1F3FD",
        non_qualified: null,
        image: "1f477-1f3fd.png",
        sheet_x: 23,
        sheet_y: 25,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F477-1F3FE",
        non_qualified: null,
        image: "1f477-1f3fe.png",
        sheet_x: 23,
        sheet_y: 26,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F477-1F3FF",
        non_qualified: null,
        image: "1f477-1f3ff.png",
        sheet_x: 23,
        sheet_y: 27,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F477-200D-2642-FE0F",
    a: "Construction Worker",
    b: "1F477",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      23,
      22
    ],
    o: 2
  },
  "male-construction-worker": {
    skin_variations: {
      "1F3FB": {
        unified: "1F477-1F3FB-200D-2642-FE0F",
        non_qualified: "1F477-1F3FB-200D-2642",
        image: "1f477-1f3fb-200d-2642-fe0f.png",
        sheet_x: 23,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F477-1F3FC-200D-2642-FE0F",
        non_qualified: "1F477-1F3FC-200D-2642",
        image: "1f477-1f3fc-200d-2642-fe0f.png",
        sheet_x: 23,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F477-1F3FD-200D-2642-FE0F",
        non_qualified: "1F477-1F3FD-200D-2642",
        image: "1f477-1f3fd-200d-2642-fe0f.png",
        sheet_x: 23,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F477-1F3FE-200D-2642-FE0F",
        non_qualified: "1F477-1F3FE-200D-2642",
        image: "1f477-1f3fe-200d-2642-fe0f.png",
        sheet_x: 23,
        sheet_y: 20,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F477-1F3FF-200D-2642-FE0F",
        non_qualified: "1F477-1F3FF-200D-2642",
        image: "1f477-1f3ff-200d-2642-fe0f.png",
        sheet_x: 23,
        sheet_y: 21,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F477",
    a: "Male Construction Worker",
    b: "1F477-200D-2642-FE0F",
    c: "1F477-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      23,
      16
    ],
    o: 4
  },
  clock1130: {
    a: "Clock Face Eleven-Thirty",
    b: "1F566",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "time",
      "late",
      "early",
      "schedule"
    ],
    k: [
      29,
      4
    ],
    o: 2
  },
  "flag-mq": {
    a: "Martinique Flag",
    b: "1F1F2-1F1F6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      15
    ],
    o: 2
  },
  bar_chart: {
    a: "Bar Chart",
    b: "1F4CA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "graph",
      "presentation",
      "stats"
    ],
    k: [
      26,
      32
    ],
    o: 2
  },
  parking: {
    a: "Negative Squared Latin Capital Letter P",
    b: "1F17F-FE0F",
    c: "1F17F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "cars",
      "blue-square",
      "alphabet",
      "letter"
    ],
    k: [
      0,
      19
    ],
    o: 2
  },
  new_moon: {
    a: "New Moon Symbol",
    b: "1F311",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      36
    ],
    o: 2
  },
  "female-construction-worker": {
    skin_variations: {
      "1F3FB": {
        unified: "1F477-1F3FB-200D-2640-FE0F",
        non_qualified: "1F477-1F3FB-200D-2640",
        image: "1f477-1f3fb-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F477-1F3FC-200D-2640-FE0F",
        non_qualified: "1F477-1F3FC-200D-2640",
        image: "1f477-1f3fc-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F477-1F3FD-200D-2640-FE0F",
        non_qualified: "1F477-1F3FD-200D-2640",
        image: "1f477-1f3fd-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F477-1F3FE-200D-2640-FE0F",
        non_qualified: "1F477-1F3FE-200D-2640",
        image: "1f477-1f3fe-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 14,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F477-1F3FF-200D-2640-FE0F",
        non_qualified: "1F477-1F3FF-200D-2640",
        image: "1f477-1f3ff-200d-2640-fe0f.png",
        sheet_x: 23,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Construction Worker",
    b: "1F477-200D-2640-FE0F",
    c: "1F477-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      23,
      10
    ],
    o: 4
  },
  sos: {
    a: "Squared Sos",
    b: "1F198",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "help",
      "red-square",
      "words",
      "emergency",
      "911"
    ],
    k: [
      0,
      28
    ],
    o: 2
  },
  clipboard: {
    a: "Clipboard",
    b: "1F4CB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stationery",
      "documents"
    ],
    k: [
      26,
      33
    ],
    o: 2
  },
  "flag-mr": {
    a: "Mauritania Flag",
    b: "1F1F2-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      16
    ],
    o: 2
  },
  prince: {
    skin_variations: {
      "1F3FB": {
        unified: "1F934-1F3FB",
        non_qualified: null,
        image: "1f934-1f3fb.png",
        sheet_x: 39,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F934-1F3FC",
        non_qualified: null,
        image: "1f934-1f3fc.png",
        sheet_x: 39,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F934-1F3FD",
        non_qualified: null,
        image: "1f934-1f3fd.png",
        sheet_x: 39,
        sheet_y: 20,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F934-1F3FE",
        non_qualified: null,
        image: "1f934-1f3fe.png",
        sheet_x: 39,
        sheet_y: 21,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F934-1F3FF",
        non_qualified: null,
        image: "1f934-1f3ff.png",
        sheet_x: 39,
        sheet_y: 22,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Prince",
    b: "1F934",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "boy",
      "man",
      "male",
      "crown",
      "royal",
      "king"
    ],
    k: [
      39,
      17
    ],
    o: 4
  },
  waxing_crescent_moon: {
    a: "Waxing Crescent Moon Symbol",
    b: "1F312",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      37
    ],
    o: 2
  },
  "flag-ms": {
    a: "Montserrat Flag",
    b: "1F1F2-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      17
    ],
    o: 2
  },
  pushpin: {
    a: "Pushpin",
    b: "1F4CC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stationery",
      "mark",
      "here"
    ],
    k: [
      26,
      34
    ],
    o: 2
  },
  up: {
    a: "Squared Up with Exclamation Mark",
    b: "1F199",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "above",
      "high"
    ],
    k: [
      0,
      29
    ],
    o: 2
  },
  "flag-mt": {
    a: "Malta Flag",
    b: "1F1F2-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      18
    ],
    o: 2
  },
  princess: {
    skin_variations: {
      "1F3FB": {
        unified: "1F478-1F3FB",
        non_qualified: null,
        image: "1f478-1f3fb.png",
        sheet_x: 23,
        sheet_y: 29,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F478-1F3FC",
        non_qualified: null,
        image: "1f478-1f3fc.png",
        sheet_x: 23,
        sheet_y: 30,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F478-1F3FD",
        non_qualified: null,
        image: "1f478-1f3fd.png",
        sheet_x: 23,
        sheet_y: 31,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F478-1F3FE",
        non_qualified: null,
        image: "1f478-1f3fe.png",
        sheet_x: 23,
        sheet_y: 32,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F478-1F3FF",
        non_qualified: null,
        image: "1f478-1f3ff.png",
        sheet_x: 23,
        sheet_y: 33,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Princess",
    b: "1F478",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "girl",
      "woman",
      "female",
      "blond",
      "crown",
      "royal",
      "queen"
    ],
    k: [
      23,
      28
    ],
    o: 2
  },
  round_pushpin: {
    a: "Round Pushpin",
    b: "1F4CD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stationery",
      "location",
      "map",
      "here"
    ],
    k: [
      26,
      35
    ],
    o: 2
  },
  first_quarter_moon: {
    a: "First Quarter Moon Symbol",
    b: "1F313",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      38
    ],
    o: 2
  },
  vs: {
    a: "Squared Vs",
    b: "1F19A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "words",
      "orange-square"
    ],
    k: [
      0,
      30
    ],
    o: 2
  },
  "flag-mu": {
    a: "Mauritius Flag",
    b: "1F1F2-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      19
    ],
    o: 2
  },
  koko: {
    a: "Squared Katakana Koko",
    b: "1F201",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "blue-square",
      "here",
      "katakana",
      "japanese",
      "destination"
    ],
    k: [
      5,
      4
    ],
    o: 2
  },
  man_with_turban: {
    skin_variations: {
      "1F3FB": {
        unified: "1F473-1F3FB",
        non_qualified: null,
        image: "1f473-1f3fb.png",
        sheet_x: 22,
        sheet_y: 44,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F473-1F3FC",
        non_qualified: null,
        image: "1f473-1f3fc.png",
        sheet_x: 22,
        sheet_y: 45,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F473-1F3FD",
        non_qualified: null,
        image: "1f473-1f3fd.png",
        sheet_x: 22,
        sheet_y: 46,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F473-1F3FE",
        non_qualified: null,
        image: "1f473-1f3fe.png",
        sheet_x: 22,
        sheet_y: 47,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F473-1F3FF",
        non_qualified: null,
        image: "1f473-1f3ff.png",
        sheet_x: 22,
        sheet_y: 48,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F473-200D-2642-FE0F",
    a: "Man with Turban",
    b: "1F473",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    j: [
      "male",
      "indian",
      "hinduism",
      "arabs"
    ],
    k: [
      22,
      43
    ],
    o: 2
  },
  moon: {
    a: "Waxing Gibbous Moon Symbol",
    b: "1F314",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      5,
      39
    ],
    n: [
      "waxing_gibbous_moon"
    ],
    o: 2
  },
  paperclip: {
    a: "Paperclip",
    b: "1F4CE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "documents",
      "stationery"
    ],
    k: [
      26,
      36
    ],
    o: 2
  },
  linked_paperclips: {
    a: "Linked Paperclips",
    b: "1F587-FE0F",
    c: "1F587",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      29,
      43
    ],
    o: 2
  },
  "man-wearing-turban": {
    skin_variations: {
      "1F3FB": {
        unified: "1F473-1F3FB-200D-2642-FE0F",
        non_qualified: "1F473-1F3FB-200D-2642",
        image: "1f473-1f3fb-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F473-1F3FC-200D-2642-FE0F",
        non_qualified: "1F473-1F3FC-200D-2642",
        image: "1f473-1f3fc-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F473-1F3FD-200D-2642-FE0F",
        non_qualified: "1F473-1F3FD-200D-2642",
        image: "1f473-1f3fd-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F473-1F3FE-200D-2642-FE0F",
        non_qualified: "1F473-1F3FE-200D-2642",
        image: "1f473-1f3fe-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F473-1F3FF-200D-2642-FE0F",
        non_qualified: "1F473-1F3FF-200D-2642",
        image: "1f473-1f3ff-200d-2642-fe0f.png",
        sheet_x: 22,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F473",
    a: "Man Wearing Turban",
    b: "1F473-200D-2642-FE0F",
    c: "1F473-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      22,
      37
    ],
    o: 4
  },
  sa: {
    a: "Squared Katakana Sa",
    b: "1F202-FE0F",
    c: "1F202",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "japanese",
      "blue-square",
      "katakana"
    ],
    k: [
      5,
      5
    ],
    o: 2
  },
  full_moon: {
    a: "Full Moon Symbol",
    b: "1F315",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "yellow",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      40
    ],
    o: 2
  },
  "flag-mv": {
    a: "Maldives Flag",
    b: "1F1F2-1F1FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      20
    ],
    o: 2
  },
  "flag-mw": {
    a: "Malawi Flag",
    b: "1F1F2-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      21
    ],
    o: 2
  },
  waning_gibbous_moon: {
    a: "Waning Gibbous Moon Symbol",
    b: "1F316",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep",
      "waxing_gibbous_moon"
    ],
    k: [
      5,
      41
    ],
    o: 2
  },
  "woman-wearing-turban": {
    skin_variations: {
      "1F3FB": {
        unified: "1F473-1F3FB-200D-2640-FE0F",
        non_qualified: "1F473-1F3FB-200D-2640",
        image: "1f473-1f3fb-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 32,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F473-1F3FC-200D-2640-FE0F",
        non_qualified: "1F473-1F3FC-200D-2640",
        image: "1f473-1f3fc-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 33,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F473-1F3FD-200D-2640-FE0F",
        non_qualified: "1F473-1F3FD-200D-2640",
        image: "1f473-1f3fd-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 34,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F473-1F3FE-200D-2640-FE0F",
        non_qualified: "1F473-1F3FE-200D-2640",
        image: "1f473-1f3fe-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 35,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F473-1F3FF-200D-2640-FE0F",
        non_qualified: "1F473-1F3FF-200D-2640",
        image: "1f473-1f3ff-200d-2640-fe0f.png",
        sheet_x: 22,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Wearing Turban",
    b: "1F473-200D-2640-FE0F",
    c: "1F473-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      22,
      31
    ],
    o: 4
  },
  u6708: {
    a: "Squared Cjk Unified Ideograph-6708",
    b: "1F237-FE0F",
    c: "1F237",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "chinese",
      "month",
      "moon",
      "japanese",
      "orange-square",
      "kanji"
    ],
    k: [
      5,
      13
    ],
    o: 2
  },
  straight_ruler: {
    a: "Straight Ruler",
    b: "1F4CF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stationery",
      "calculate",
      "length",
      "math",
      "school",
      "drawing",
      "architect",
      "sketch"
    ],
    k: [
      26,
      37
    ],
    o: 2
  },
  u6709: {
    a: "Squared Cjk Unified Ideograph-6709",
    b: "1F236",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "orange-square",
      "chinese",
      "have",
      "kanji"
    ],
    k: [
      5,
      12
    ],
    o: 2
  },
  triangular_ruler: {
    a: "Triangular Ruler",
    b: "1F4D0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stationery",
      "math",
      "architect",
      "sketch"
    ],
    k: [
      26,
      38
    ],
    o: 2
  },
  man_with_gua_pi_mao: {
    skin_variations: {
      "1F3FB": {
        unified: "1F472-1F3FB",
        non_qualified: null,
        image: "1f472-1f3fb.png",
        sheet_x: 22,
        sheet_y: 26,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F472-1F3FC",
        non_qualified: null,
        image: "1f472-1f3fc.png",
        sheet_x: 22,
        sheet_y: 27,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F472-1F3FD",
        non_qualified: null,
        image: "1f472-1f3fd.png",
        sheet_x: 22,
        sheet_y: 28,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F472-1F3FE",
        non_qualified: null,
        image: "1f472-1f3fe.png",
        sheet_x: 22,
        sheet_y: 29,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F472-1F3FF",
        non_qualified: null,
        image: "1f472-1f3ff.png",
        sheet_x: 22,
        sheet_y: 30,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man with Gua Pi Mao",
    b: "1F472",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "male",
      "boy",
      "chinese"
    ],
    k: [
      22,
      25
    ],
    o: 2
  },
  "flag-mx": {
    a: "Mexico Flag",
    b: "1F1F2-1F1FD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      22
    ],
    o: 2
  },
  last_quarter_moon: {
    a: "Last Quarter Moon Symbol",
    b: "1F317",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      42
    ],
    o: 2
  },
  person_with_headscarf: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D5-1F3FB",
        non_qualified: null,
        image: "1f9d5-1f3fb.png",
        sheet_x: 48,
        sheet_y: 35,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9D5-1F3FC",
        non_qualified: null,
        image: "1f9d5-1f3fc.png",
        sheet_x: 48,
        sheet_y: 36,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9D5-1F3FD",
        non_qualified: null,
        image: "1f9d5-1f3fd.png",
        sheet_x: 48,
        sheet_y: 37,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9D5-1F3FE",
        non_qualified: null,
        image: "1f9d5-1f3fe.png",
        sheet_x: 48,
        sheet_y: 38,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9D5-1F3FF",
        non_qualified: null,
        image: "1f9d5-1f3ff.png",
        sheet_x: 48,
        sheet_y: 39,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Person with Headscarf",
    b: "1F9D5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      48,
      34
    ],
    o: 5
  },
  waning_crescent_moon: {
    a: "Waning Crescent Moon Symbol",
    b: "1F318",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      43
    ],
    o: 2
  },
  u6307: {
    a: "Squared Cjk Unified Ideograph-6307",
    b: "1F22F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "chinese",
      "point",
      "green-square",
      "kanji"
    ],
    k: [
      5,
      7
    ],
    o: 2
  },
  scissors: {
    a: "Black Scissors",
    b: "2702-FE0F",
    c: "2702",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stationery",
      "cut"
    ],
    k: [
      54,
      39
    ],
    o: 2
  },
  "flag-my": {
    a: "Malaysia Flag",
    b: "1F1F2-1F1FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      23
    ],
    o: 2
  },
  ideograph_advantage: {
    a: "Circled Ideograph Advantage",
    b: "1F250",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "chinese",
      "kanji",
      "obtain",
      "get",
      "circle"
    ],
    k: [
      5,
      17
    ],
    o: 2
  },
  man_in_tuxedo: {
    skin_variations: {
      "1F3FB": {
        unified: "1F935-1F3FB",
        non_qualified: null,
        image: "1f935-1f3fb.png",
        sheet_x: 39,
        sheet_y: 24,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F935-1F3FC",
        non_qualified: null,
        image: "1f935-1f3fc.png",
        sheet_x: 39,
        sheet_y: 25,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F935-1F3FD",
        non_qualified: null,
        image: "1f935-1f3fd.png",
        sheet_x: 39,
        sheet_y: 26,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F935-1F3FE",
        non_qualified: null,
        image: "1f935-1f3fe.png",
        sheet_x: 39,
        sheet_y: 27,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F935-1F3FF",
        non_qualified: null,
        image: "1f935-1f3ff.png",
        sheet_x: 39,
        sheet_y: 28,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man in Tuxedo",
    b: "1F935",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "couple",
      "marriage",
      "wedding",
      "groom"
    ],
    k: [
      39,
      23
    ],
    o: 4
  },
  "flag-mz": {
    a: "Mozambique Flag",
    b: "1F1F2-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      24
    ],
    o: 2
  },
  card_file_box: {
    a: "Card File Box",
    b: "1F5C3-FE0F",
    c: "1F5C3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "business",
      "stationery"
    ],
    k: [
      30,
      16
    ],
    o: 2
  },
  crescent_moon: {
    a: "Crescent Moon",
    b: "1F319",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "night",
      "sleep",
      "sky",
      "evening",
      "magic"
    ],
    k: [
      5,
      44
    ],
    o: 2
  },
  "flag-na": {
    a: "Namibia Flag",
    b: "1F1F3-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      25
    ],
    o: 2
  },
  bride_with_veil: {
    skin_variations: {
      "1F3FB": {
        unified: "1F470-1F3FB",
        non_qualified: null,
        image: "1f470-1f3fb.png",
        sheet_x: 22,
        sheet_y: 2,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F470-1F3FC",
        non_qualified: null,
        image: "1f470-1f3fc.png",
        sheet_x: 22,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F470-1F3FD",
        non_qualified: null,
        image: "1f470-1f3fd.png",
        sheet_x: 22,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F470-1F3FE",
        non_qualified: null,
        image: "1f470-1f3fe.png",
        sheet_x: 22,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F470-1F3FF",
        non_qualified: null,
        image: "1f470-1f3ff.png",
        sheet_x: 22,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Bride with Veil",
    b: "1F470",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "couple",
      "marriage",
      "wedding",
      "woman",
      "bride"
    ],
    k: [
      22,
      1
    ],
    o: 2
  },
  new_moon_with_face: {
    a: "New Moon with Face",
    b: "1F31A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      45
    ],
    o: 2
  },
  file_cabinet: {
    a: "File Cabinet",
    b: "1F5C4-FE0F",
    c: "1F5C4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "filing",
      "organizing"
    ],
    k: [
      30,
      17
    ],
    o: 2
  },
  u5272: {
    a: "Squared Cjk Unified Ideograph-5272",
    b: "1F239",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "cut",
      "divide",
      "chinese",
      "kanji",
      "pink-square"
    ],
    k: [
      5,
      15
    ],
    o: 2
  },
  wastebasket: {
    a: "Wastebasket",
    b: "1F5D1-FE0F",
    c: "1F5D1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "bin",
      "trash",
      "rubbish",
      "garbage",
      "toss"
    ],
    k: [
      30,
      18
    ],
    o: 2
  },
  pregnant_woman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F930-1F3FB",
        non_qualified: null,
        image: "1f930-1f3fb.png",
        sheet_x: 38,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F930-1F3FC",
        non_qualified: null,
        image: "1f930-1f3fc.png",
        sheet_x: 38,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F930-1F3FD",
        non_qualified: null,
        image: "1f930-1f3fd.png",
        sheet_x: 38,
        sheet_y: 53,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F930-1F3FE",
        non_qualified: null,
        image: "1f930-1f3fe.png",
        sheet_x: 38,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F930-1F3FF",
        non_qualified: null,
        image: "1f930-1f3ff.png",
        sheet_x: 38,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Pregnant Woman",
    b: "1F930",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "baby"
    ],
    k: [
      38,
      50
    ],
    o: 4
  },
  first_quarter_moon_with_face: {
    a: "First Quarter Moon with Face",
    b: "1F31B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      46
    ],
    o: 2
  },
  "flag-nc": {
    a: "New Caledonia Flag",
    b: "1F1F3-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      26
    ],
    o: 2
  },
  u7121: {
    a: "Squared Cjk Unified Ideograph-7121",
    b: "1F21A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nothing",
      "chinese",
      "kanji",
      "japanese",
      "orange-square"
    ],
    k: [
      5,
      6
    ],
    o: 2
  },
  lock: {
    a: "Lock",
    b: "1F512",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "security",
      "password",
      "padlock"
    ],
    k: [
      27,
      46
    ],
    o: 2
  },
  "flag-ne": {
    a: "Niger Flag",
    b: "1F1F3-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      27
    ],
    o: 2
  },
  last_quarter_moon_with_face: {
    a: "Last Quarter Moon with Face",
    b: "1F31C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      47
    ],
    o: 2
  },
  "breast-feeding": {
    skin_variations: {
      "1F3FB": {
        unified: "1F931-1F3FB",
        non_qualified: null,
        image: "1f931-1f3fb.png",
        sheet_x: 39,
        sheet_y: 0,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F931-1F3FC",
        non_qualified: null,
        image: "1f931-1f3fc.png",
        sheet_x: 39,
        sheet_y: 1,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F931-1F3FD",
        non_qualified: null,
        image: "1f931-1f3fd.png",
        sheet_x: 39,
        sheet_y: 2,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F931-1F3FE",
        non_qualified: null,
        image: "1f931-1f3fe.png",
        sheet_x: 39,
        sheet_y: 3,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F931-1F3FF",
        non_qualified: null,
        image: "1f931-1f3ff.png",
        sheet_x: 39,
        sheet_y: 4,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Breast-Feeding",
    b: "1F931",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      38,
      56
    ],
    o: 5
  },
  u7981: {
    a: "Squared Cjk Unified Ideograph-7981",
    b: "1F232",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "kanji",
      "japanese",
      "chinese",
      "forbidden",
      "limit",
      "restricted",
      "red-square"
    ],
    k: [
      5,
      8
    ],
    o: 2
  },
  accept: {
    a: "Circled Ideograph Accept",
    b: "1F251",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "ok",
      "good",
      "chinese",
      "kanji",
      "agree",
      "yes",
      "orange-circle"
    ],
    k: [
      5,
      18
    ],
    o: 2
  },
  angel: {
    skin_variations: {
      "1F3FB": {
        unified: "1F47C-1F3FB",
        non_qualified: null,
        image: "1f47c-1f3fb.png",
        sheet_x: 23,
        sheet_y: 38,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F47C-1F3FC",
        non_qualified: null,
        image: "1f47c-1f3fc.png",
        sheet_x: 23,
        sheet_y: 39,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F47C-1F3FD",
        non_qualified: null,
        image: "1f47c-1f3fd.png",
        sheet_x: 23,
        sheet_y: 40,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F47C-1F3FE",
        non_qualified: null,
        image: "1f47c-1f3fe.png",
        sheet_x: 23,
        sheet_y: 41,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F47C-1F3FF",
        non_qualified: null,
        image: "1f47c-1f3ff.png",
        sheet_x: 23,
        sheet_y: 42,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Baby Angel",
    b: "1F47C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "heaven",
      "wings",
      "halo"
    ],
    k: [
      23,
      37
    ],
    o: 2
  },
  unlock: {
    a: "Open Lock",
    b: "1F513",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "privacy",
      "security"
    ],
    k: [
      27,
      47
    ],
    o: 2
  },
  "flag-nf": {
    a: "Norfolk Island Flag",
    b: "1F1F3-1F1EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      28
    ],
    o: 2
  },
  thermometer: {
    a: "Thermometer",
    b: "1F321-FE0F",
    c: "1F321",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weather",
      "temperature",
      "hot",
      "cold"
    ],
    k: [
      5,
      52
    ],
    o: 2
  },
  "flag-ng": {
    a: "Nigeria Flag",
    b: "1F1F3-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      29
    ],
    o: 2
  },
  u7533: {
    a: "Squared Cjk Unified Ideograph-7533",
    b: "1F238",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "chinese",
      "japanese",
      "kanji",
      "orange-square"
    ],
    k: [
      5,
      14
    ],
    o: 2
  },
  sunny: {
    a: "Black Sun with Rays",
    b: "2600-FE0F",
    c: "2600",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weather",
      "nature",
      "brightness",
      "summer",
      "beach",
      "spring"
    ],
    k: [
      52,
      49
    ],
    o: 2
  },
  lock_with_ink_pen: {
    a: "Lock with Ink Pen",
    b: "1F50F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "security",
      "secret"
    ],
    k: [
      27,
      43
    ],
    o: 2
  },
  santa: {
    skin_variations: {
      "1F3FB": {
        unified: "1F385-1F3FB",
        non_qualified: null,
        image: "1f385-1f3fb.png",
        sheet_x: 7,
        sheet_y: 37,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F385-1F3FC",
        non_qualified: null,
        image: "1f385-1f3fc.png",
        sheet_x: 7,
        sheet_y: 38,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F385-1F3FD",
        non_qualified: null,
        image: "1f385-1f3fd.png",
        sheet_x: 7,
        sheet_y: 39,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F385-1F3FE",
        non_qualified: null,
        image: "1f385-1f3fe.png",
        sheet_x: 7,
        sheet_y: 40,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F385-1F3FF",
        non_qualified: null,
        image: "1f385-1f3ff.png",
        sheet_x: 7,
        sheet_y: 41,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Father Christmas",
    b: "1F385",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "festival",
      "man",
      "male",
      "xmas",
      "father christmas"
    ],
    k: [
      7,
      36
    ],
    o: 2
  },
  closed_lock_with_key: {
    a: "Closed Lock with Key",
    b: "1F510",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "security",
      "privacy"
    ],
    k: [
      27,
      44
    ],
    o: 2
  },
  u5408: {
    a: "Squared Cjk Unified Ideograph-5408",
    b: "1F234",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "japanese",
      "chinese",
      "join",
      "kanji",
      "red-square"
    ],
    k: [
      5,
      10
    ],
    o: 2
  },
  "flag-ni": {
    a: "Nicaragua Flag",
    b: "1F1F3-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      30
    ],
    o: 2
  },
  mrs_claus: {
    skin_variations: {
      "1F3FB": {
        unified: "1F936-1F3FB",
        non_qualified: null,
        image: "1f936-1f3fb.png",
        sheet_x: 39,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F936-1F3FC",
        non_qualified: null,
        image: "1f936-1f3fc.png",
        sheet_x: 39,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F936-1F3FD",
        non_qualified: null,
        image: "1f936-1f3fd.png",
        sheet_x: 39,
        sheet_y: 32,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F936-1F3FE",
        non_qualified: null,
        image: "1f936-1f3fe.png",
        sheet_x: 39,
        sheet_y: 33,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F936-1F3FF",
        non_qualified: null,
        image: "1f936-1f3ff.png",
        sheet_x: 39,
        sheet_y: 34,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Mother Christmas",
    b: "1F936",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "woman",
      "female",
      "xmas",
      "mother christmas"
    ],
    k: [
      39,
      29
    ],
    n: [
      "mother_christmas"
    ],
    o: 4
  },
  full_moon_with_face: {
    a: "Full Moon with Face",
    b: "1F31D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    k: [
      5,
      48
    ],
    o: 2
  },
  key: {
    a: "Key",
    b: "1F511",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "lock",
      "door",
      "password"
    ],
    k: [
      27,
      45
    ],
    o: 2
  },
  superhero: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9B8-1F3FB",
        non_qualified: null,
        image: "1f9b8-1f3fb.png",
        sheet_x: 43,
        sheet_y: 31,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9B8-1F3FC",
        non_qualified: null,
        image: "1f9b8-1f3fc.png",
        sheet_x: 43,
        sheet_y: 32,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9B8-1F3FD",
        non_qualified: null,
        image: "1f9b8-1f3fd.png",
        sheet_x: 43,
        sheet_y: 33,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9B8-1F3FE",
        non_qualified: null,
        image: "1f9b8-1f3fe.png",
        sheet_x: 43,
        sheet_y: 34,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9B8-1F3FF",
        non_qualified: null,
        image: "1f9b8-1f3ff.png",
        sheet_x: 43,
        sheet_y: 35,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Superhero",
    b: "1F9B8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      30
    ],
    o: 11
  },
  "flag-nl": {
    a: "Netherlands Flag",
    b: "1F1F3-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      31
    ],
    o: 2
  },
  u7a7a: {
    a: "Squared Cjk Unified Ideograph-7a7a",
    b: "1F233",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "kanji",
      "japanese",
      "chinese",
      "empty",
      "sky",
      "blue-square"
    ],
    k: [
      5,
      9
    ],
    o: 2
  },
  sun_with_face: {
    a: "Sun with Face",
    b: "1F31E",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "morning",
      "sky"
    ],
    k: [
      5,
      49
    ],
    o: 2
  },
  male_superhero: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9B8-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9B8-1F3FB-200D-2642",
        image: "1f9b8-1f3fb-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 25,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9B8-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9B8-1F3FC-200D-2642",
        image: "1f9b8-1f3fc-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 26,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9B8-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9B8-1F3FD-200D-2642",
        image: "1f9b8-1f3fd-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 27,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9B8-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9B8-1F3FE-200D-2642",
        image: "1f9b8-1f3fe-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 28,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9B8-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9B8-1F3FF-200D-2642",
        image: "1f9b8-1f3ff-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 29,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Superhero",
    b: "1F9B8-200D-2642-FE0F",
    c: "1F9B8-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      24
    ],
    o: 11
  },
  ringed_planet: {
    a: "Ringed Planet",
    b: "1FA90",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      4
    ],
    o: 12
  },
  old_key: {
    a: "Old Key",
    b: "1F5DD-FE0F",
    c: "1F5DD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "lock",
      "door",
      "password"
    ],
    k: [
      30,
      22
    ],
    o: 2
  },
  congratulations: {
    a: "Circled Ideograph Congratulation",
    b: "3297-FE0F",
    c: "3297",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "chinese",
      "kanji",
      "japanese",
      "red-circle"
    ],
    k: [
      55,
      46
    ],
    o: 2
  },
  "flag-no": {
    a: "Norway Flag",
    b: "1F1F3-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      32
    ],
    o: 2
  },
  star: {
    a: "White Medium Star",
    b: "2B50",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "night",
      "yellow"
    ],
    k: [
      55,
      42
    ],
    o: 2
  },
  secret: {
    a: "Circled Ideograph Secret",
    b: "3299-FE0F",
    c: "3299",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "privacy",
      "chinese",
      "sshh",
      "kanji",
      "red-circle"
    ],
    k: [
      55,
      47
    ],
    o: 2
  },
  "flag-np": {
    a: "Nepal Flag",
    b: "1F1F3-1F1F5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      33
    ],
    o: 2
  },
  female_superhero: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9B8-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9B8-1F3FB-200D-2640",
        image: "1f9b8-1f3fb-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 19,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9B8-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9B8-1F3FC-200D-2640",
        image: "1f9b8-1f3fc-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 20,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9B8-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9B8-1F3FD-200D-2640",
        image: "1f9b8-1f3fd-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 21,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9B8-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9B8-1F3FE-200D-2640",
        image: "1f9b8-1f3fe-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 22,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9B8-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9B8-1F3FF-200D-2640",
        image: "1f9b8-1f3ff-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 23,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Superhero",
    b: "1F9B8-200D-2640-FE0F",
    c: "1F9B8-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      18
    ],
    o: 11
  },
  hammer: {
    a: "Hammer",
    b: "1F528",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "tools",
      "build",
      "create"
    ],
    k: [
      28,
      11
    ],
    o: 2
  },
  star2: {
    a: "Glowing Star",
    b: "1F31F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "night",
      "sparkle",
      "awesome",
      "good",
      "magic"
    ],
    k: [
      5,
      50
    ],
    o: 2
  },
  "flag-nr": {
    a: "Nauru Flag",
    b: "1F1F3-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      34
    ],
    o: 2
  },
  axe: {
    a: "Axe",
    b: "1FA93",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      7
    ],
    o: 12
  },
  u55b6: {
    a: "Squared Cjk Unified Ideograph-55b6",
    b: "1F23A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "japanese",
      "opening hours",
      "orange-square"
    ],
    k: [
      5,
      16
    ],
    o: 2
  },
  supervillain: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9B9-1F3FB",
        non_qualified: null,
        image: "1f9b9-1f3fb.png",
        sheet_x: 43,
        sheet_y: 49,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9B9-1F3FC",
        non_qualified: null,
        image: "1f9b9-1f3fc.png",
        sheet_x: 43,
        sheet_y: 50,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9B9-1F3FD",
        non_qualified: null,
        image: "1f9b9-1f3fd.png",
        sheet_x: 43,
        sheet_y: 51,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9B9-1F3FE",
        non_qualified: null,
        image: "1f9b9-1f3fe.png",
        sheet_x: 43,
        sheet_y: 52,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9B9-1F3FF",
        non_qualified: null,
        image: "1f9b9-1f3ff.png",
        sheet_x: 43,
        sheet_y: 53,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Supervillain",
    b: "1F9B9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      48
    ],
    o: 11
  },
  stars: {
    a: "Shooting Star",
    b: "1F320",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "night",
      "photo"
    ],
    k: [
      5,
      51
    ],
    o: 2
  },
  u6e80: {
    a: "Squared Cjk Unified Ideograph-6e80",
    b: "1F235",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "full",
      "chinese",
      "japanese",
      "red-square",
      "kanji"
    ],
    k: [
      5,
      11
    ],
    o: 2
  },
  "flag-nu": {
    a: "Niue Flag",
    b: "1F1F3-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      35
    ],
    o: 2
  },
  pick: {
    a: "Pick",
    b: "26CF-FE0F",
    c: "26CF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "tools",
      "dig"
    ],
    k: [
      54,
      5
    ],
    o: 2
  },
  male_supervillain: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9B9-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9B9-1F3FB-200D-2642",
        image: "1f9b9-1f3fb-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 43,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9B9-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9B9-1F3FC-200D-2642",
        image: "1f9b9-1f3fc-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 44,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9B9-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9B9-1F3FD-200D-2642",
        image: "1f9b9-1f3fd-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 45,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9B9-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9B9-1F3FE-200D-2642",
        image: "1f9b9-1f3fe-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 46,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9B9-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9B9-1F3FF-200D-2642",
        image: "1f9b9-1f3ff-200d-2642-fe0f.png",
        sheet_x: 43,
        sheet_y: 47,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Supervillain",
    b: "1F9B9-200D-2642-FE0F",
    c: "1F9B9-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      42
    ],
    o: 11
  },
  female_supervillain: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9B9-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9B9-1F3FB-200D-2640",
        image: "1f9b9-1f3fb-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 37,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9B9-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9B9-1F3FC-200D-2640",
        image: "1f9b9-1f3fc-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 38,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9B9-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9B9-1F3FD-200D-2640",
        image: "1f9b9-1f3fd-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 39,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9B9-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9B9-1F3FE-200D-2640",
        image: "1f9b9-1f3fe-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 40,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9B9-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9B9-1F3FF-200D-2640",
        image: "1f9b9-1f3ff-200d-2640-fe0f.png",
        sheet_x: 43,
        sheet_y: 41,
        added_in: "11.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Supervillain",
    b: "1F9B9-200D-2640-FE0F",
    c: "1F9B9-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      36
    ],
    o: 11
  },
  hammer_and_pick: {
    a: "Hammer and Pick",
    b: "2692-FE0F",
    c: "2692",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "tools",
      "build",
      "create"
    ],
    k: [
      53,
      41
    ],
    o: 2
  },
  milky_way: {
    a: "Milky Way",
    b: "1F30C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "photo",
      "space",
      "stars"
    ],
    k: [
      5,
      31
    ],
    o: 2
  },
  red_circle: {
    a: "Large Red Circle",
    b: "1F534",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "error",
      "danger"
    ],
    k: [
      28,
      23
    ],
    o: 2
  },
  "flag-nz": {
    a: "New Zealand Flag",
    b: "1F1F3-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      36
    ],
    o: 2
  },
  large_orange_circle: {
    a: "Large Orange Circle",
    b: "1F7E0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      3
    ],
    o: 12
  },
  hammer_and_wrench: {
    a: "Hammer and Wrench",
    b: "1F6E0-FE0F",
    c: "1F6E0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "tools",
      "build",
      "create"
    ],
    k: [
      36,
      42
    ],
    o: 2
  },
  "flag-om": {
    a: "Oman Flag",
    b: "1F1F4-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      37
    ],
    o: 2
  },
  cloud: {
    a: "Cloud",
    b: "2601-FE0F",
    c: "2601",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weather",
      "sky"
    ],
    k: [
      52,
      50
    ],
    o: 2
  },
  mage: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D9-1F3FB",
        non_qualified: null,
        image: "1f9d9-1f3fb.png",
        sheet_x: 49,
        sheet_y: 50,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D9-1F3FB-200D-2640-FE0F"
      },
      "1F3FC": {
        unified: "1F9D9-1F3FC",
        non_qualified: null,
        image: "1f9d9-1f3fc.png",
        sheet_x: 49,
        sheet_y: 51,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D9-1F3FC-200D-2640-FE0F"
      },
      "1F3FD": {
        unified: "1F9D9-1F3FD",
        non_qualified: null,
        image: "1f9d9-1f3fd.png",
        sheet_x: 49,
        sheet_y: 52,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D9-1F3FD-200D-2640-FE0F"
      },
      "1F3FE": {
        unified: "1F9D9-1F3FE",
        non_qualified: null,
        image: "1f9d9-1f3fe.png",
        sheet_x: 49,
        sheet_y: 53,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D9-1F3FE-200D-2640-FE0F"
      },
      "1F3FF": {
        unified: "1F9D9-1F3FF",
        non_qualified: null,
        image: "1f9d9-1f3ff.png",
        sheet_x: 49,
        sheet_y: 54,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D9-1F3FF-200D-2640-FE0F"
      }
    },
    obsoleted_by: "1F9D9-200D-2640-FE0F",
    a: "Mage",
    b: "1F9D9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      49
    ],
    o: 5
  },
  dagger_knife: {
    a: "Dagger Knife",
    b: "1F5E1-FE0F",
    c: "1F5E1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      24
    ],
    o: 2
  },
  partly_sunny: {
    a: "Sun Behind Cloud",
    b: "26C5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weather",
      "nature",
      "cloudy",
      "morning",
      "fall",
      "spring"
    ],
    k: [
      54,
      2
    ],
    o: 2
  },
  large_yellow_circle: {
    a: "Large Yellow Circle",
    b: "1F7E1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      4
    ],
    o: 12
  },
  male_mage: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D9-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9D9-1F3FB-200D-2642",
        image: "1f9d9-1f3fb-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 44,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9D9-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9D9-1F3FC-200D-2642",
        image: "1f9d9-1f3fc-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 45,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9D9-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9D9-1F3FD-200D-2642",
        image: "1f9d9-1f3fd-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 46,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9D9-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9D9-1F3FE-200D-2642",
        image: "1f9d9-1f3fe-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 47,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9D9-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9D9-1F3FF-200D-2642",
        image: "1f9d9-1f3ff-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 48,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Mage",
    b: "1F9D9-200D-2642-FE0F",
    c: "1F9D9-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      43
    ],
    o: 5
  },
  "flag-pa": {
    a: "Panama Flag",
    b: "1F1F5-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      38
    ],
    o: 2
  },
  thunder_cloud_and_rain: {
    a: "Thunder Cloud and Rain",
    b: "26C8-FE0F",
    c: "26C8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      54,
      3
    ],
    o: 2
  },
  large_green_circle: {
    a: "Large Green Circle",
    b: "1F7E2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      5
    ],
    o: 12
  },
  female_mage: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D9-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9D9-1F3FB-200D-2640",
        image: "1f9d9-1f3fb-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 38,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D9-1F3FB"
      },
      "1F3FC": {
        unified: "1F9D9-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9D9-1F3FC-200D-2640",
        image: "1f9d9-1f3fc-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 39,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D9-1F3FC"
      },
      "1F3FD": {
        unified: "1F9D9-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9D9-1F3FD-200D-2640",
        image: "1f9d9-1f3fd-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 40,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D9-1F3FD"
      },
      "1F3FE": {
        unified: "1F9D9-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9D9-1F3FE-200D-2640",
        image: "1f9d9-1f3fe-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 41,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D9-1F3FE"
      },
      "1F3FF": {
        unified: "1F9D9-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9D9-1F3FF-200D-2640",
        image: "1f9d9-1f3ff-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 42,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D9-1F3FF"
      }
    },
    obsoletes: "1F9D9",
    a: "Female Mage",
    b: "1F9D9-200D-2640-FE0F",
    c: "1F9D9-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      37
    ],
    o: 5
  },
  crossed_swords: {
    a: "Crossed Swords",
    b: "2694-FE0F",
    c: "2694",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weapon"
    ],
    k: [
      53,
      43
    ],
    o: 2
  },
  "flag-pe": {
    a: "Peru Flag",
    b: "1F1F5-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      39
    ],
    o: 2
  },
  gun: {
    a: "Pistol",
    b: "1F52B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "violence",
      "weapon",
      "pistol",
      "revolver"
    ],
    k: [
      28,
      14
    ],
    o: 2
  },
  mostly_sunny: {
    a: "Mostly Sunny",
    b: "1F324-FE0F",
    c: "1F324",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      5,
      53
    ],
    n: [
      "sun_small_cloud"
    ],
    o: 2
  },
  fairy: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DA-1F3FB",
        non_qualified: null,
        image: "1f9da-1f3fb.png",
        sheet_x: 50,
        sheet_y: 11,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoleted_by: "1F9DA-1F3FB-200D-2640-FE0F"
      },
      "1F3FC": {
        unified: "1F9DA-1F3FC",
        non_qualified: null,
        image: "1f9da-1f3fc.png",
        sheet_x: 50,
        sheet_y: 12,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoleted_by: "1F9DA-1F3FC-200D-2640-FE0F"
      },
      "1F3FD": {
        unified: "1F9DA-1F3FD",
        non_qualified: null,
        image: "1f9da-1f3fd.png",
        sheet_x: 50,
        sheet_y: 13,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoleted_by: "1F9DA-1F3FD-200D-2640-FE0F"
      },
      "1F3FE": {
        unified: "1F9DA-1F3FE",
        non_qualified: null,
        image: "1f9da-1f3fe.png",
        sheet_x: 50,
        sheet_y: 14,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoleted_by: "1F9DA-1F3FE-200D-2640-FE0F"
      },
      "1F3FF": {
        unified: "1F9DA-1F3FF",
        non_qualified: null,
        image: "1f9da-1f3ff.png",
        sheet_x: 50,
        sheet_y: 15,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoleted_by: "1F9DA-1F3FF-200D-2640-FE0F"
      }
    },
    obsoleted_by: "1F9DA-200D-2640-FE0F",
    a: "Fairy",
    b: "1F9DA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      50,
      10
    ],
    o: 5
  },
  "flag-pf": {
    a: "French Polynesia Flag",
    b: "1F1F5-1F1EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      40
    ],
    o: 2
  },
  large_blue_circle: {
    a: "Large Blue Circle",
    b: "1F535",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "icon",
      "button"
    ],
    k: [
      28,
      24
    ],
    o: 2
  },
  large_purple_circle: {
    a: "Large Purple Circle",
    b: "1F7E3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      6
    ],
    o: 12
  },
  bow_and_arrow: {
    a: "Bow and Arrow",
    b: "1F3F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports"
    ],
    k: [
      11,
      21
    ],
    o: 2
  },
  male_fairy: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DA-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9DA-1F3FB-200D-2642",
        image: "1f9da-1f3fb-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 5,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9DA-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9DA-1F3FC-200D-2642",
        image: "1f9da-1f3fc-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 6,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9DA-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9DA-1F3FD-200D-2642",
        image: "1f9da-1f3fd-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 7,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9DA-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9DA-1F3FE-200D-2642",
        image: "1f9da-1f3fe-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 8,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9DA-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9DA-1F3FF-200D-2642",
        image: "1f9da-1f3ff-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 9,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    a: "Male Fairy",
    b: "1F9DA-200D-2642-FE0F",
    c: "1F9DA-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      50,
      4
    ],
    o: 5
  },
  barely_sunny: {
    a: "Barely Sunny",
    b: "1F325-FE0F",
    c: "1F325",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      5,
      54
    ],
    n: [
      "sun_behind_cloud"
    ],
    o: 2
  },
  "flag-pg": {
    a: "Papua New Guinea Flag",
    b: "1F1F5-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      41
    ],
    o: 2
  },
  shield: {
    a: "Shield",
    b: "1F6E1-FE0F",
    c: "1F6E1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "protection",
      "security"
    ],
    k: [
      36,
      43
    ],
    o: 2
  },
  partly_sunny_rain: {
    a: "Partly Sunny Rain",
    b: "1F326-FE0F",
    c: "1F326",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      5,
      55
    ],
    n: [
      "sun_behind_rain_cloud"
    ],
    o: 2
  },
  large_brown_circle: {
    a: "Large Brown Circle",
    b: "1F7E4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      7
    ],
    o: 12
  },
  female_fairy: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DA-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9DA-1F3FB-200D-2640",
        image: "1f9da-1f3fb-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 56,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoletes: "1F9DA-1F3FB"
      },
      "1F3FC": {
        unified: "1F9DA-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9DA-1F3FC-200D-2640",
        image: "1f9da-1f3fc-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 0,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoletes: "1F9DA-1F3FC"
      },
      "1F3FD": {
        unified: "1F9DA-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9DA-1F3FD-200D-2640",
        image: "1f9da-1f3fd-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 1,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoletes: "1F9DA-1F3FD"
      },
      "1F3FE": {
        unified: "1F9DA-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9DA-1F3FE-200D-2640",
        image: "1f9da-1f3fe-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 2,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoletes: "1F9DA-1F3FE"
      },
      "1F3FF": {
        unified: "1F9DA-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9DA-1F3FF-200D-2640",
        image: "1f9da-1f3ff-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 3,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1,
        obsoletes: "1F9DA-1F3FF"
      }
    },
    obsoletes: "1F9DA",
    a: "Female Fairy",
    b: "1F9DA-200D-2640-FE0F",
    c: "1F9DA-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      55
    ],
    o: 5
  },
  "flag-ph": {
    a: "Philippines Flag",
    b: "1F1F5-1F1ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      42
    ],
    o: 2
  },
  "flag-pk": {
    a: "Pakistan Flag",
    b: "1F1F5-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      43
    ],
    o: 2
  },
  black_circle: {
    a: "Medium Black Circle",
    b: "26AB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "button",
      "round"
    ],
    k: [
      53,
      53
    ],
    o: 2
  },
  wrench: {
    a: "Wrench",
    b: "1F527",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "tools",
      "diy",
      "ikea",
      "fix",
      "maintainer"
    ],
    k: [
      28,
      10
    ],
    o: 2
  },
  vampire: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DB-1F3FB",
        non_qualified: null,
        image: "1f9db-1f3fb.png",
        sheet_x: 50,
        sheet_y: 29,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DB-1F3FB-200D-2640-FE0F"
      },
      "1F3FC": {
        unified: "1F9DB-1F3FC",
        non_qualified: null,
        image: "1f9db-1f3fc.png",
        sheet_x: 50,
        sheet_y: 30,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DB-1F3FC-200D-2640-FE0F"
      },
      "1F3FD": {
        unified: "1F9DB-1F3FD",
        non_qualified: null,
        image: "1f9db-1f3fd.png",
        sheet_x: 50,
        sheet_y: 31,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DB-1F3FD-200D-2640-FE0F"
      },
      "1F3FE": {
        unified: "1F9DB-1F3FE",
        non_qualified: null,
        image: "1f9db-1f3fe.png",
        sheet_x: 50,
        sheet_y: 32,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DB-1F3FE-200D-2640-FE0F"
      },
      "1F3FF": {
        unified: "1F9DB-1F3FF",
        non_qualified: null,
        image: "1f9db-1f3ff.png",
        sheet_x: 50,
        sheet_y: 33,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DB-1F3FF-200D-2640-FE0F"
      }
    },
    obsoleted_by: "1F9DB-200D-2640-FE0F",
    a: "Vampire",
    b: "1F9DB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      50,
      28
    ],
    o: 5
  },
  rain_cloud: {
    a: "Rain Cloud",
    b: "1F327-FE0F",
    c: "1F327",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      5,
      56
    ],
    o: 2
  },
  snow_cloud: {
    a: "Snow Cloud",
    b: "1F328-FE0F",
    c: "1F328",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      6,
      0
    ],
    o: 2
  },
  "flag-pl": {
    a: "Poland Flag",
    b: "1F1F5-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      44
    ],
    o: 2
  },
  male_vampire: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DB-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9DB-1F3FB-200D-2642",
        image: "1f9db-1f3fb-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 23,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9DB-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9DB-1F3FC-200D-2642",
        image: "1f9db-1f3fc-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 24,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9DB-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9DB-1F3FD-200D-2642",
        image: "1f9db-1f3fd-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 25,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9DB-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9DB-1F3FE-200D-2642",
        image: "1f9db-1f3fe-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 26,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9DB-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9DB-1F3FF-200D-2642",
        image: "1f9db-1f3ff-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 27,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Male Vampire",
    b: "1F9DB-200D-2642-FE0F",
    c: "1F9DB-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      50,
      22
    ],
    o: 5
  },
  nut_and_bolt: {
    a: "Nut and Bolt",
    b: "1F529",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "handy",
      "tools",
      "fix"
    ],
    k: [
      28,
      12
    ],
    o: 2
  },
  white_circle: {
    a: "Medium White Circle",
    b: "26AA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "round"
    ],
    k: [
      53,
      52
    ],
    o: 2
  },
  female_vampire: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DB-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9DB-1F3FB-200D-2640",
        image: "1f9db-1f3fb-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 17,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DB-1F3FB"
      },
      "1F3FC": {
        unified: "1F9DB-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9DB-1F3FC-200D-2640",
        image: "1f9db-1f3fc-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 18,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DB-1F3FC"
      },
      "1F3FD": {
        unified: "1F9DB-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9DB-1F3FD-200D-2640",
        image: "1f9db-1f3fd-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 19,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DB-1F3FD"
      },
      "1F3FE": {
        unified: "1F9DB-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9DB-1F3FE-200D-2640",
        image: "1f9db-1f3fe-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 20,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DB-1F3FE"
      },
      "1F3FF": {
        unified: "1F9DB-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9DB-1F3FF-200D-2640",
        image: "1f9db-1f3ff-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 21,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DB-1F3FF"
      }
    },
    obsoletes: "1F9DB",
    a: "Female Vampire",
    b: "1F9DB-200D-2640-FE0F",
    c: "1F9DB-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      50,
      16
    ],
    o: 5
  },
  "flag-pm": {
    a: "St. Pierre & Miquelon Flag",
    b: "1F1F5-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      45
    ],
    o: 2
  },
  large_red_square: {
    a: "Large Red Square",
    b: "1F7E5",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      8
    ],
    o: 12
  },
  lightning: {
    a: "Lightning",
    b: "1F329-FE0F",
    c: "1F329",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      6,
      1
    ],
    n: [
      "lightning_cloud"
    ],
    o: 2
  },
  gear: {
    a: "Gear",
    b: "2699-FE0F",
    c: "2699",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "cog"
    ],
    k: [
      53,
      47
    ],
    o: 2
  },
  merperson: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DC-1F3FB",
        non_qualified: null,
        image: "1f9dc-1f3fb.png",
        sheet_x: 50,
        sheet_y: 47,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DC-1F3FB-200D-2642-FE0F"
      },
      "1F3FC": {
        unified: "1F9DC-1F3FC",
        non_qualified: null,
        image: "1f9dc-1f3fc.png",
        sheet_x: 50,
        sheet_y: 48,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DC-1F3FC-200D-2642-FE0F"
      },
      "1F3FD": {
        unified: "1F9DC-1F3FD",
        non_qualified: null,
        image: "1f9dc-1f3fd.png",
        sheet_x: 50,
        sheet_y: 49,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DC-1F3FD-200D-2642-FE0F"
      },
      "1F3FE": {
        unified: "1F9DC-1F3FE",
        non_qualified: null,
        image: "1f9dc-1f3fe.png",
        sheet_x: 50,
        sheet_y: 50,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DC-1F3FE-200D-2642-FE0F"
      },
      "1F3FF": {
        unified: "1F9DC-1F3FF",
        non_qualified: null,
        image: "1f9dc-1f3ff.png",
        sheet_x: 50,
        sheet_y: 51,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DC-1F3FF-200D-2642-FE0F"
      }
    },
    obsoleted_by: "1F9DC-200D-2642-FE0F",
    a: "Merperson",
    b: "1F9DC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      50,
      46
    ],
    o: 5
  },
  tornado: {
    a: "Tornado",
    b: "1F32A-FE0F",
    c: "1F32A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weather",
      "cyclone",
      "twister"
    ],
    k: [
      6,
      2
    ],
    n: [
      "tornado_cloud"
    ],
    o: 2
  },
  large_orange_square: {
    a: "Large Orange Square",
    b: "1F7E7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      10
    ],
    o: 12
  },
  "flag-pn": {
    a: "Pitcairn Islands Flag",
    b: "1F1F5-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      46
    ],
    o: 2
  },
  compression: {
    a: "Compression",
    b: "1F5DC-FE0F",
    c: "1F5DC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      21
    ],
    o: 2
  },
  merman: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DC-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9DC-1F3FB-200D-2642",
        image: "1f9dc-1f3fb-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 41,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DC-1F3FB"
      },
      "1F3FC": {
        unified: "1F9DC-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9DC-1F3FC-200D-2642",
        image: "1f9dc-1f3fc-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 42,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DC-1F3FC"
      },
      "1F3FD": {
        unified: "1F9DC-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9DC-1F3FD-200D-2642",
        image: "1f9dc-1f3fd-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 43,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DC-1F3FD"
      },
      "1F3FE": {
        unified: "1F9DC-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9DC-1F3FE-200D-2642",
        image: "1f9dc-1f3fe-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 44,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DC-1F3FE"
      },
      "1F3FF": {
        unified: "1F9DC-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9DC-1F3FF-200D-2642",
        image: "1f9dc-1f3ff-200d-2642-fe0f.png",
        sheet_x: 50,
        sheet_y: 45,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DC-1F3FF"
      }
    },
    obsoletes: "1F9DC",
    a: "Merman",
    b: "1F9DC-200D-2642-FE0F",
    c: "1F9DC-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      50,
      40
    ],
    o: 5
  },
  large_yellow_square: {
    a: "Large Yellow Square",
    b: "1F7E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      11
    ],
    o: 12
  },
  fog: {
    a: "Fog",
    b: "1F32B-FE0F",
    c: "1F32B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weather"
    ],
    k: [
      6,
      3
    ],
    o: 2
  },
  scales: {
    a: "Scales",
    b: "2696-FE0F",
    c: "2696",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      53,
      45
    ],
    o: 2
  },
  "flag-pr": {
    a: "Puerto Rico Flag",
    b: "1F1F5-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      47
    ],
    o: 2
  },
  wind_blowing_face: {
    a: "Wind Blowing Face",
    b: "1F32C-FE0F",
    c: "1F32C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      6,
      4
    ],
    o: 2
  },
  "flag-ps": {
    a: "Palestinian Territories Flag",
    b: "1F1F5-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      48
    ],
    o: 2
  },
  mermaid: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DC-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9DC-1F3FB-200D-2640",
        image: "1f9dc-1f3fb-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 35,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9DC-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9DC-1F3FC-200D-2640",
        image: "1f9dc-1f3fc-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 36,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9DC-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9DC-1F3FD-200D-2640",
        image: "1f9dc-1f3fd-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 37,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9DC-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9DC-1F3FE-200D-2640",
        image: "1f9dc-1f3fe-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 38,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9DC-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9DC-1F3FF-200D-2640",
        image: "1f9dc-1f3ff-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 39,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Mermaid",
    b: "1F9DC-200D-2640-FE0F",
    c: "1F9DC-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      50,
      34
    ],
    o: 5
  },
  probing_cane: {
    a: "Probing Cane",
    b: "1F9AF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      43,
      3
    ],
    o: 12
  },
  large_green_square: {
    a: "Large Green Square",
    b: "1F7E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      12
    ],
    o: 12
  },
  "flag-pt": {
    a: "Portugal Flag",
    b: "1F1F5-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      49
    ],
    o: 2
  },
  link: {
    a: "Link Symbol",
    b: "1F517",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "rings",
      "url"
    ],
    k: [
      27,
      51
    ],
    o: 2
  },
  large_blue_square: {
    a: "Large Blue Square",
    b: "1F7E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      9
    ],
    o: 12
  },
  elf: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DD-1F3FB",
        non_qualified: null,
        image: "1f9dd-1f3fb.png",
        sheet_x: 51,
        sheet_y: 8,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DD-1F3FB-200D-2642-FE0F"
      },
      "1F3FC": {
        unified: "1F9DD-1F3FC",
        non_qualified: null,
        image: "1f9dd-1f3fc.png",
        sheet_x: 51,
        sheet_y: 9,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DD-1F3FC-200D-2642-FE0F"
      },
      "1F3FD": {
        unified: "1F9DD-1F3FD",
        non_qualified: null,
        image: "1f9dd-1f3fd.png",
        sheet_x: 51,
        sheet_y: 10,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DD-1F3FD-200D-2642-FE0F"
      },
      "1F3FE": {
        unified: "1F9DD-1F3FE",
        non_qualified: null,
        image: "1f9dd-1f3fe.png",
        sheet_x: 51,
        sheet_y: 11,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DD-1F3FE-200D-2642-FE0F"
      },
      "1F3FF": {
        unified: "1F9DD-1F3FF",
        non_qualified: null,
        image: "1f9dd-1f3ff.png",
        sheet_x: 51,
        sheet_y: 12,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9DD-1F3FF-200D-2642-FE0F"
      }
    },
    obsoleted_by: "1F9DD-200D-2642-FE0F",
    a: "Elf",
    b: "1F9DD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      7
    ],
    o: 5
  },
  cyclone: {
    a: "Cyclone",
    b: "1F300",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weather",
      "swirl",
      "blue",
      "cloud",
      "vortex",
      "spiral",
      "whirlpool",
      "spin",
      "tornado",
      "hurricane",
      "typhoon"
    ],
    k: [
      5,
      19
    ],
    o: 2
  },
  rainbow: {
    a: "Rainbow",
    b: "1F308",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "nature",
      "happy",
      "unicorn_face",
      "photo",
      "sky",
      "spring"
    ],
    k: [
      5,
      27
    ],
    o: 2
  },
  male_elf: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DD-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9DD-1F3FB-200D-2642",
        image: "1f9dd-1f3fb-200d-2642-fe0f.png",
        sheet_x: 51,
        sheet_y: 2,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DD-1F3FB"
      },
      "1F3FC": {
        unified: "1F9DD-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9DD-1F3FC-200D-2642",
        image: "1f9dd-1f3fc-200d-2642-fe0f.png",
        sheet_x: 51,
        sheet_y: 3,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DD-1F3FC"
      },
      "1F3FD": {
        unified: "1F9DD-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9DD-1F3FD-200D-2642",
        image: "1f9dd-1f3fd-200d-2642-fe0f.png",
        sheet_x: 51,
        sheet_y: 4,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DD-1F3FD"
      },
      "1F3FE": {
        unified: "1F9DD-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9DD-1F3FE-200D-2642",
        image: "1f9dd-1f3fe-200d-2642-fe0f.png",
        sheet_x: 51,
        sheet_y: 5,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DD-1F3FE"
      },
      "1F3FF": {
        unified: "1F9DD-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9DD-1F3FF-200D-2642",
        image: "1f9dd-1f3ff-200d-2642-fe0f.png",
        sheet_x: 51,
        sheet_y: 6,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9DD-1F3FF"
      }
    },
    obsoletes: "1F9DD",
    a: "Male Elf",
    b: "1F9DD-200D-2642-FE0F",
    c: "1F9DD-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      1
    ],
    o: 5
  },
  "flag-pw": {
    a: "Palau Flag",
    b: "1F1F5-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      50
    ],
    o: 2
  },
  chains: {
    a: "Chains",
    b: "26D3-FE0F",
    c: "26D3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "lock",
      "arrest"
    ],
    k: [
      54,
      7
    ],
    o: 2
  },
  large_purple_square: {
    a: "Large Purple Square",
    b: "1F7EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      13
    ],
    o: 12
  },
  female_elf: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9DD-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9DD-1F3FB-200D-2640",
        image: "1f9dd-1f3fb-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 53,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9DD-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9DD-1F3FC-200D-2640",
        image: "1f9dd-1f3fc-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 54,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9DD-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9DD-1F3FD-200D-2640",
        image: "1f9dd-1f3fd-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 55,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9DD-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9DD-1F3FE-200D-2640",
        image: "1f9dd-1f3fe-200d-2640-fe0f.png",
        sheet_x: 50,
        sheet_y: 56,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9DD-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9DD-1F3FF-200D-2640",
        image: "1f9dd-1f3ff-200d-2640-fe0f.png",
        sheet_x: 51,
        sheet_y: 0,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Female Elf",
    b: "1F9DD-200D-2640-FE0F",
    c: "1F9DD-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      50,
      52
    ],
    o: 5
  },
  "flag-py": {
    a: "Paraguay Flag",
    b: "1F1F5-1F1FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      51
    ],
    o: 2
  },
  closed_umbrella: {
    a: "Closed Umbrella",
    b: "1F302",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "weather",
      "rain",
      "drizzle"
    ],
    k: [
      5,
      21
    ],
    o: 2
  },
  toolbox: {
    a: "Toolbox",
    b: "1F9F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      35
    ],
    o: 11
  },
  large_brown_square: {
    a: "Large Brown Square",
    b: "1F7EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      37,
      14
    ],
    o: 12
  },
  magnet: {
    a: "Magnet",
    b: "1F9F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      37
    ],
    o: 11
  },
  genie: {
    obsoleted_by: "1F9DE-200D-2642-FE0F",
    a: "Genie",
    b: "1F9DE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      15
    ],
    o: 5
  },
  "flag-qa": {
    a: "Qatar Flag",
    b: "1F1F6-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      52
    ],
    o: 2
  },
  umbrella: {
    a: "Umbrella",
    b: "2602-FE0F",
    c: "2602",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "rainy",
      "weather",
      "spring"
    ],
    k: [
      52,
      51
    ],
    o: 2
  },
  black_large_square: {
    a: "Black Large Square",
    b: "2B1B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "icon",
      "button"
    ],
    k: [
      55,
      40
    ],
    o: 2
  },
  male_genie: {
    obsoletes: "1F9DE",
    a: "Male Genie",
    b: "1F9DE-200D-2642-FE0F",
    c: "1F9DE-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      14
    ],
    o: 5
  },
  umbrella_with_rain_drops: {
    a: "Umbrella with Rain Drops",
    b: "2614",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      56
    ],
    o: 2
  },
  "flag-re": {
    a: "Réunion Flag",
    b: "1F1F7-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      53
    ],
    o: 2
  },
  white_large_square: {
    a: "White Large Square",
    b: "2B1C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "icon",
      "stone",
      "button"
    ],
    k: [
      55,
      41
    ],
    o: 2
  },
  alembic: {
    a: "Alembic",
    b: "2697-FE0F",
    c: "2697",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "distilling",
      "science",
      "experiment",
      "chemistry"
    ],
    k: [
      53,
      46
    ],
    o: 2
  },
  black_medium_square: {
    a: "Black Medium Square",
    b: "25FC-FE0F",
    c: "25FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "button",
      "icon"
    ],
    k: [
      52,
      46
    ],
    o: 2
  },
  test_tube: {
    a: "Test Tube",
    b: "1F9EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      29
    ],
    o: 11
  },
  "flag-ro": {
    a: "Romania Flag",
    b: "1F1F7-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      54
    ],
    o: 2
  },
  female_genie: {
    a: "Female Genie",
    b: "1F9DE-200D-2640-FE0F",
    c: "1F9DE-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      13
    ],
    o: 5
  },
  umbrella_on_ground: {
    a: "Umbrella on Ground",
    b: "26F1-FE0F",
    c: "26F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      54,
      12
    ],
    o: 2
  },
  zombie: {
    obsoleted_by: "1F9DF-200D-2642-FE0F",
    a: "Zombie",
    b: "1F9DF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      18
    ],
    o: 5
  },
  zap: {
    a: "High Voltage Sign",
    b: "26A1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "thunder",
      "weather",
      "lightning bolt",
      "fast"
    ],
    k: [
      53,
      51
    ],
    o: 2
  },
  white_medium_square: {
    a: "White Medium Square",
    b: "25FB-FE0F",
    c: "25FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "stone",
      "icon"
    ],
    k: [
      52,
      45
    ],
    o: 2
  },
  "flag-rs": {
    a: "Serbia Flag",
    b: "1F1F7-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      3,
      55
    ],
    o: 2
  },
  petri_dish: {
    a: "Petri Dish",
    b: "1F9EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      30
    ],
    o: 11
  },
  snowflake: {
    a: "Snowflake",
    b: "2744-FE0F",
    c: "2744",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "winter",
      "season",
      "cold",
      "weather",
      "christmas",
      "xmas"
    ],
    k: [
      55,
      19
    ],
    o: 2
  },
  dna: {
    a: "Dna Double Helix",
    b: "1F9EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      31
    ],
    o: 11
  },
  male_zombie: {
    obsoletes: "1F9DF",
    a: "Male Zombie",
    b: "1F9DF-200D-2642-FE0F",
    c: "1F9DF-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      17
    ],
    o: 5
  },
  black_medium_small_square: {
    a: "Black Medium Small Square",
    b: "25FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "icon",
      "shape",
      "button"
    ],
    k: [
      52,
      48
    ],
    o: 2
  },
  ru: {
    a: "Russia Flag",
    b: "1F1F7-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "russian",
      "federation",
      "flag",
      "nation",
      "country",
      "banner"
    ],
    k: [
      3,
      56
    ],
    n: [
      "flag-ru"
    ],
    o: 2
  },
  female_zombie: {
    a: "Female Zombie",
    b: "1F9DF-200D-2640-FE0F",
    c: "1F9DF-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      16
    ],
    o: 5
  },
  "flag-rw": {
    a: "Rwanda Flag",
    b: "1F1F7-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      0
    ],
    o: 2
  },
  snowman: {
    a: "Snowman",
    b: "2603-FE0F",
    c: "2603",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "winter",
      "season",
      "cold",
      "weather",
      "christmas",
      "xmas",
      "frozen",
      "without_snow"
    ],
    k: [
      52,
      52
    ],
    o: 2
  },
  white_medium_small_square: {
    a: "White Medium Small Square",
    b: "25FD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "stone",
      "icon",
      "button"
    ],
    k: [
      52,
      47
    ],
    o: 2
  },
  microscope: {
    a: "Microscope",
    b: "1F52C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "laboratory",
      "experiment",
      "zoomin",
      "science",
      "study"
    ],
    k: [
      28,
      15
    ],
    o: 2
  },
  snowman_without_snow: {
    a: "Snowman Without Snow",
    b: "26C4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      54,
      1
    ],
    o: 2
  },
  telescope: {
    a: "Telescope",
    b: "1F52D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "stars",
      "space",
      "zoom",
      "science",
      "astronomy"
    ],
    k: [
      28,
      16
    ],
    o: 2
  },
  massage: {
    skin_variations: {
      "1F3FB": {
        unified: "1F486-1F3FB",
        non_qualified: null,
        image: "1f486-1f3fb.png",
        sheet_x: 24,
        sheet_y: 52,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F486-1F3FC",
        non_qualified: null,
        image: "1f486-1f3fc.png",
        sheet_x: 24,
        sheet_y: 53,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F486-1F3FD",
        non_qualified: null,
        image: "1f486-1f3fd.png",
        sheet_x: 24,
        sheet_y: 54,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F486-1F3FE",
        non_qualified: null,
        image: "1f486-1f3fe.png",
        sheet_x: 24,
        sheet_y: 55,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F486-1F3FF",
        non_qualified: null,
        image: "1f486-1f3ff.png",
        sheet_x: 24,
        sheet_y: 56,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F486-200D-2640-FE0F",
    a: "Face Massage",
    b: "1F486",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      24,
      51
    ],
    o: 2
  },
  black_small_square: {
    a: "Black Small Square",
    b: "25AA-FE0F",
    c: "25AA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "icon"
    ],
    k: [
      52,
      41
    ],
    o: 2
  },
  "flag-sa": {
    a: "Saudi Arabia Flag",
    b: "1F1F8-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      1
    ],
    o: 2
  },
  "man-getting-massage": {
    skin_variations: {
      "1F3FB": {
        unified: "1F486-1F3FB-200D-2642-FE0F",
        non_qualified: "1F486-1F3FB-200D-2642",
        image: "1f486-1f3fb-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F486-1F3FC-200D-2642-FE0F",
        non_qualified: "1F486-1F3FC-200D-2642",
        image: "1f486-1f3fc-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 47,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F486-1F3FD-200D-2642-FE0F",
        non_qualified: "1F486-1F3FD-200D-2642",
        image: "1f486-1f3fd-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F486-1F3FE-200D-2642-FE0F",
        non_qualified: "1F486-1F3FE-200D-2642",
        image: "1f486-1f3fe-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F486-1F3FF-200D-2642-FE0F",
        non_qualified: "1F486-1F3FF-200D-2642",
        image: "1f486-1f3ff-200d-2642-fe0f.png",
        sheet_x: 24,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Getting Massage",
    b: "1F486-200D-2642-FE0F",
    c: "1F486-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      24,
      45
    ],
    o: 4
  },
  comet: {
    a: "Comet",
    b: "2604-FE0F",
    c: "2604",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "space"
    ],
    k: [
      52,
      53
    ],
    o: 2
  },
  white_small_square: {
    a: "White Small Square",
    b: "25AB-FE0F",
    c: "25AB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "icon"
    ],
    k: [
      52,
      42
    ],
    o: 2
  },
  "flag-sb": {
    a: "Solomon Islands Flag",
    b: "1F1F8-1F1E7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      2
    ],
    o: 2
  },
  satellite_antenna: {
    a: "Satellite Antenna",
    b: "1F4E1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      26,
      55
    ],
    o: 2
  },
  large_orange_diamond: {
    a: "Large Orange Diamond",
    b: "1F536",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "jewel",
      "gem"
    ],
    k: [
      28,
      25
    ],
    o: 2
  },
  "woman-getting-massage": {
    skin_variations: {
      "1F3FB": {
        unified: "1F486-1F3FB-200D-2640-FE0F",
        non_qualified: "1F486-1F3FB-200D-2640",
        image: "1f486-1f3fb-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F486-1F3FC-200D-2640-FE0F",
        non_qualified: "1F486-1F3FC-200D-2640",
        image: "1f486-1f3fc-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F486-1F3FD-200D-2640-FE0F",
        non_qualified: "1F486-1F3FD-200D-2640",
        image: "1f486-1f3fd-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F486-1F3FE-200D-2640-FE0F",
        non_qualified: "1F486-1F3FE-200D-2640",
        image: "1f486-1f3fe-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F486-1F3FF-200D-2640-FE0F",
        non_qualified: "1F486-1F3FF-200D-2640",
        image: "1f486-1f3ff-200d-2640-fe0f.png",
        sheet_x: 24,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F486",
    a: "Woman Getting Massage",
    b: "1F486-200D-2640-FE0F",
    c: "1F486-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      24,
      39
    ],
    o: 4
  },
  fire: {
    a: "Fire",
    b: "1F525",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "hot",
      "cook",
      "flame"
    ],
    k: [
      28,
      8
    ],
    o: 2
  },
  syringe: {
    a: "Syringe",
    b: "1F489",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "health",
      "hospital",
      "drugs",
      "blood",
      "medicine",
      "needle",
      "doctor",
      "nurse"
    ],
    k: [
      25,
      19
    ],
    o: 2
  },
  "flag-sc": {
    a: "Seychelles Flag",
    b: "1F1F8-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      3
    ],
    o: 2
  },
  large_blue_diamond: {
    a: "Large Blue Diamond",
    b: "1F537",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "jewel",
      "gem"
    ],
    k: [
      28,
      26
    ],
    o: 2
  },
  "flag-sd": {
    a: "Sudan Flag",
    b: "1F1F8-1F1E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      4
    ],
    o: 2
  },
  droplet: {
    a: "Droplet",
    b: "1F4A7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "water",
      "drip",
      "faucet",
      "spring"
    ],
    k: [
      25,
      49
    ],
    o: 2
  },
  drop_of_blood: {
    a: "Drop of Blood",
    b: "1FA78",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      55
    ],
    o: 12
  },
  haircut: {
    skin_variations: {
      "1F3FB": {
        unified: "1F487-1F3FB",
        non_qualified: null,
        image: "1f487-1f3fb.png",
        sheet_x: 25,
        sheet_y: 13,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F487-1F3FC",
        non_qualified: null,
        image: "1f487-1f3fc.png",
        sheet_x: 25,
        sheet_y: 14,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F487-1F3FD",
        non_qualified: null,
        image: "1f487-1f3fd.png",
        sheet_x: 25,
        sheet_y: 15,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F487-1F3FE",
        non_qualified: null,
        image: "1f487-1f3fe.png",
        sheet_x: 25,
        sheet_y: 16,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F487-1F3FF",
        non_qualified: null,
        image: "1f487-1f3ff.png",
        sheet_x: 25,
        sheet_y: 17,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F487-200D-2640-FE0F",
    a: "Haircut",
    b: "1F487",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      25,
      12
    ],
    o: 2
  },
  ocean: {
    a: "Water Wave",
    b: "1F30A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sea",
      "water",
      "wave",
      "nature",
      "tsunami",
      "disaster"
    ],
    k: [
      5,
      29
    ],
    o: 2
  },
  "flag-se": {
    a: "Sweden Flag",
    b: "1F1F8-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      5
    ],
    o: 2
  },
  "man-getting-haircut": {
    skin_variations: {
      "1F3FB": {
        unified: "1F487-1F3FB-200D-2642-FE0F",
        non_qualified: "1F487-1F3FB-200D-2642",
        image: "1f487-1f3fb-200d-2642-fe0f.png",
        sheet_x: 25,
        sheet_y: 7,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F487-1F3FC-200D-2642-FE0F",
        non_qualified: "1F487-1F3FC-200D-2642",
        image: "1f487-1f3fc-200d-2642-fe0f.png",
        sheet_x: 25,
        sheet_y: 8,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F487-1F3FD-200D-2642-FE0F",
        non_qualified: "1F487-1F3FD-200D-2642",
        image: "1f487-1f3fd-200d-2642-fe0f.png",
        sheet_x: 25,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F487-1F3FE-200D-2642-FE0F",
        non_qualified: "1F487-1F3FE-200D-2642",
        image: "1f487-1f3fe-200d-2642-fe0f.png",
        sheet_x: 25,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F487-1F3FF-200D-2642-FE0F",
        non_qualified: "1F487-1F3FF-200D-2642",
        image: "1f487-1f3ff-200d-2642-fe0f.png",
        sheet_x: 25,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Getting Haircut",
    b: "1F487-200D-2642-FE0F",
    c: "1F487-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      25,
      6
    ],
    o: 4
  },
  small_orange_diamond: {
    a: "Small Orange Diamond",
    b: "1F538",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "jewel",
      "gem"
    ],
    k: [
      28,
      27
    ],
    o: 2
  },
  pill: {
    a: "Pill",
    b: "1F48A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "health",
      "medicine",
      "doctor",
      "pharmacy",
      "drug"
    ],
    k: [
      25,
      20
    ],
    o: 2
  },
  "woman-getting-haircut": {
    skin_variations: {
      "1F3FB": {
        unified: "1F487-1F3FB-200D-2640-FE0F",
        non_qualified: "1F487-1F3FB-200D-2640",
        image: "1f487-1f3fb-200d-2640-fe0f.png",
        sheet_x: 25,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F487-1F3FC-200D-2640-FE0F",
        non_qualified: "1F487-1F3FC-200D-2640",
        image: "1f487-1f3fc-200d-2640-fe0f.png",
        sheet_x: 25,
        sheet_y: 2,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F487-1F3FD-200D-2640-FE0F",
        non_qualified: "1F487-1F3FD-200D-2640",
        image: "1f487-1f3fd-200d-2640-fe0f.png",
        sheet_x: 25,
        sheet_y: 3,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F487-1F3FE-200D-2640-FE0F",
        non_qualified: "1F487-1F3FE-200D-2640",
        image: "1f487-1f3fe-200d-2640-fe0f.png",
        sheet_x: 25,
        sheet_y: 4,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F487-1F3FF-200D-2640-FE0F",
        non_qualified: "1F487-1F3FF-200D-2640",
        image: "1f487-1f3ff-200d-2640-fe0f.png",
        sheet_x: 25,
        sheet_y: 5,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F487",
    a: "Woman Getting Haircut",
    b: "1F487-200D-2640-FE0F",
    c: "1F487-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      25,
      0
    ],
    o: 4
  },
  small_blue_diamond: {
    a: "Small Blue Diamond",
    b: "1F539",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "jewel",
      "gem"
    ],
    k: [
      28,
      28
    ],
    o: 2
  },
  "flag-sg": {
    a: "Singapore Flag",
    b: "1F1F8-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      6
    ],
    o: 2
  },
  adhesive_bandage: {
    a: "Adhesive Bandage",
    b: "1FA79",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      56
    ],
    o: 12
  },
  walking: {
    skin_variations: {
      "1F3FB": {
        unified: "1F6B6-1F3FB",
        non_qualified: null,
        image: "1f6b6-1f3fb.png",
        sheet_x: 36,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F6B6-1F3FC",
        non_qualified: null,
        image: "1f6b6-1f3fc.png",
        sheet_x: 36,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F6B6-1F3FD",
        non_qualified: null,
        image: "1f6b6-1f3fd.png",
        sheet_x: 36,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F6B6-1F3FE",
        non_qualified: null,
        image: "1f6b6-1f3fe.png",
        sheet_x: 36,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F6B6-1F3FF",
        non_qualified: null,
        image: "1f6b6-1f3ff.png",
        sheet_x: 36,
        sheet_y: 7,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F6B6-200D-2642-FE0F",
    a: "Pedestrian",
    b: "1F6B6",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      36,
      2
    ],
    o: 2
  },
  small_red_triangle: {
    a: "Up-Pointing Red Triangle",
    b: "1F53A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "direction",
      "up",
      "top"
    ],
    k: [
      28,
      29
    ],
    o: 2
  },
  "flag-sh": {
    a: "St. Helena Flag",
    b: "1F1F8-1F1ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      7
    ],
    o: 2
  },
  stethoscope: {
    a: "Stethoscope",
    b: "1FA7A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      0
    ],
    o: 12
  },
  "man-walking": {
    skin_variations: {
      "1F3FB": {
        unified: "1F6B6-1F3FB-200D-2642-FE0F",
        non_qualified: "1F6B6-1F3FB-200D-2642",
        image: "1f6b6-1f3fb-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6B6-1F3FC-200D-2642-FE0F",
        non_qualified: "1F6B6-1F3FC-200D-2642",
        image: "1f6b6-1f3fc-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6B6-1F3FD-200D-2642-FE0F",
        non_qualified: "1F6B6-1F3FD-200D-2642",
        image: "1f6b6-1f3fd-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6B6-1F3FE-200D-2642-FE0F",
        non_qualified: "1F6B6-1F3FE-200D-2642",
        image: "1f6b6-1f3fe-200d-2642-fe0f.png",
        sheet_x: 36,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6B6-1F3FF-200D-2642-FE0F",
        non_qualified: "1F6B6-1F3FF-200D-2642",
        image: "1f6b6-1f3ff-200d-2642-fe0f.png",
        sheet_x: 36,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F6B6",
    a: "Man Walking",
    b: "1F6B6-200D-2642-FE0F",
    c: "1F6B6-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      35,
      53
    ],
    o: 4
  },
  "flag-si": {
    a: "Slovenia Flag",
    b: "1F1F8-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      8
    ],
    o: 2
  },
  door: {
    a: "Door",
    b: "1F6AA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "house",
      "entry",
      "exit"
    ],
    k: [
      35,
      1
    ],
    o: 2
  },
  small_red_triangle_down: {
    a: "Down-Pointing Red Triangle",
    b: "1F53B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "direction",
      "bottom"
    ],
    k: [
      28,
      30
    ],
    o: 2
  },
  "flag-sj": {
    a: "Svalbard & Jan Mayen Flag",
    b: "1F1F8-1F1EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      9
    ],
    o: 2
  },
  diamond_shape_with_a_dot_inside: {
    a: "Diamond Shape with a Dot Inside",
    b: "1F4A0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "jewel",
      "blue",
      "gem",
      "crystal",
      "fancy"
    ],
    k: [
      25,
      42
    ],
    o: 2
  },
  "woman-walking": {
    skin_variations: {
      "1F3FB": {
        unified: "1F6B6-1F3FB-200D-2640-FE0F",
        non_qualified: "1F6B6-1F3FB-200D-2640",
        image: "1f6b6-1f3fb-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6B6-1F3FC-200D-2640-FE0F",
        non_qualified: "1F6B6-1F3FC-200D-2640",
        image: "1f6b6-1f3fc-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6B6-1F3FD-200D-2640-FE0F",
        non_qualified: "1F6B6-1F3FD-200D-2640",
        image: "1f6b6-1f3fd-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6B6-1F3FE-200D-2640-FE0F",
        non_qualified: "1F6B6-1F3FE-200D-2640",
        image: "1f6b6-1f3fe-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6B6-1F3FF-200D-2640-FE0F",
        non_qualified: "1F6B6-1F3FF-200D-2640",
        image: "1f6b6-1f3ff-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Walking",
    b: "1F6B6-200D-2640-FE0F",
    c: "1F6B6-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      35,
      47
    ],
    o: 4
  },
  bed: {
    a: "Bed",
    b: "1F6CF-FE0F",
    c: "1F6CF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sleep",
      "rest"
    ],
    k: [
      36,
      37
    ],
    o: 2
  },
  radio_button: {
    a: "Radio Button",
    b: "1F518",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "input",
      "old",
      "music",
      "circle"
    ],
    k: [
      27,
      52
    ],
    o: 2
  },
  "flag-sk": {
    a: "Slovakia Flag",
    b: "1F1F8-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      10
    ],
    o: 2
  },
  standing_person: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9CD-1F3FB",
        non_qualified: null,
        image: "1f9cd-1f3fb.png",
        sheet_x: 44,
        sheet_y: 32,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9CD-1F3FC",
        non_qualified: null,
        image: "1f9cd-1f3fc.png",
        sheet_x: 44,
        sheet_y: 33,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9CD-1F3FD",
        non_qualified: null,
        image: "1f9cd-1f3fd.png",
        sheet_x: 44,
        sheet_y: 34,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9CD-1F3FE",
        non_qualified: null,
        image: "1f9cd-1f3fe.png",
        sheet_x: 44,
        sheet_y: 35,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9CD-1F3FF",
        non_qualified: null,
        image: "1f9cd-1f3ff.png",
        sheet_x: 44,
        sheet_y: 36,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Standing Person",
    b: "1F9CD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      31
    ],
    o: 12
  },
  couch_and_lamp: {
    a: "Couch and Lamp",
    b: "1F6CB-FE0F",
    c: "1F6CB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "read",
      "chill"
    ],
    k: [
      36,
      28
    ],
    o: 2
  },
  man_standing: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9CD-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9CD-1F3FB-200D-2642",
        image: "1f9cd-1f3fb-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 26,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9CD-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9CD-1F3FC-200D-2642",
        image: "1f9cd-1f3fc-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 27,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9CD-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9CD-1F3FD-200D-2642",
        image: "1f9cd-1f3fd-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 28,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9CD-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9CD-1F3FE-200D-2642",
        image: "1f9cd-1f3fe-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 29,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9CD-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9CD-1F3FF-200D-2642",
        image: "1f9cd-1f3ff-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 30,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Standing",
    b: "1F9CD-200D-2642-FE0F",
    c: "1F9CD-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      25
    ],
    o: 12
  },
  white_square_button: {
    a: "White Square Button",
    b: "1F533",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "input"
    ],
    k: [
      28,
      22
    ],
    o: 2
  },
  "flag-sl": {
    a: "Sierra Leone Flag",
    b: "1F1F8-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      11
    ],
    o: 2
  },
  chair: {
    a: "Chair",
    b: "1FA91",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      5
    ],
    o: 12
  },
  toilet: {
    a: "Toilet",
    b: "1F6BD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "restroom",
      "wc",
      "washroom",
      "bathroom",
      "potty"
    ],
    k: [
      36,
      14
    ],
    o: 2
  },
  black_square_button: {
    a: "Black Square Button",
    b: "1F532",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "shape",
      "input",
      "frame"
    ],
    k: [
      28,
      21
    ],
    o: 2
  },
  "flag-sm": {
    a: "San Marino Flag",
    b: "1F1F8-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      12
    ],
    o: 2
  },
  woman_standing: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9CD-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9CD-1F3FB-200D-2640",
        image: "1f9cd-1f3fb-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 20,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9CD-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9CD-1F3FC-200D-2640",
        image: "1f9cd-1f3fc-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 21,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9CD-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9CD-1F3FD-200D-2640",
        image: "1f9cd-1f3fd-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 22,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9CD-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9CD-1F3FE-200D-2640",
        image: "1f9cd-1f3fe-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 23,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9CD-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9CD-1F3FF-200D-2640",
        image: "1f9cd-1f3ff-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 24,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Standing",
    b: "1F9CD-200D-2640-FE0F",
    c: "1F9CD-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      19
    ],
    o: 12
  },
  kneeling_person: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9CE-1F3FB",
        non_qualified: null,
        image: "1f9ce-1f3fb.png",
        sheet_x: 44,
        sheet_y: 50,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9CE-1F3FC",
        non_qualified: null,
        image: "1f9ce-1f3fc.png",
        sheet_x: 44,
        sheet_y: 51,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9CE-1F3FD",
        non_qualified: null,
        image: "1f9ce-1f3fd.png",
        sheet_x: 44,
        sheet_y: 52,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9CE-1F3FE",
        non_qualified: null,
        image: "1f9ce-1f3fe.png",
        sheet_x: 44,
        sheet_y: 53,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9CE-1F3FF",
        non_qualified: null,
        image: "1f9ce-1f3ff.png",
        sheet_x: 44,
        sheet_y: 54,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Kneeling Person",
    b: "1F9CE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      49
    ],
    o: 12
  },
  shower: {
    a: "Shower",
    b: "1F6BF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "clean",
      "water",
      "bathroom"
    ],
    k: [
      36,
      16
    ],
    o: 2
  },
  "flag-sn": {
    a: "Senegal Flag",
    b: "1F1F8-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      13
    ],
    o: 2
  },
  bathtub: {
    a: "Bathtub",
    b: "1F6C1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "clean",
      "shower",
      "bathroom"
    ],
    k: [
      36,
      23
    ],
    o: 2
  },
  "flag-so": {
    a: "Somalia Flag",
    b: "1F1F8-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      14
    ],
    o: 2
  },
  man_kneeling: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9CE-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9CE-1F3FB-200D-2642",
        image: "1f9ce-1f3fb-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 44,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9CE-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9CE-1F3FC-200D-2642",
        image: "1f9ce-1f3fc-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 45,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9CE-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9CE-1F3FD-200D-2642",
        image: "1f9ce-1f3fd-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 46,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9CE-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9CE-1F3FE-200D-2642",
        image: "1f9ce-1f3fe-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 47,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9CE-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9CE-1F3FF-200D-2642",
        image: "1f9ce-1f3ff-200d-2642-fe0f.png",
        sheet_x: 44,
        sheet_y: 48,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Kneeling",
    b: "1F9CE-200D-2642-FE0F",
    c: "1F9CE-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      43
    ],
    o: 12
  },
  "flag-sr": {
    a: "Suriname Flag",
    b: "1F1F8-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      15
    ],
    o: 2
  },
  woman_kneeling: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9CE-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9CE-1F3FB-200D-2640",
        image: "1f9ce-1f3fb-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 38,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9CE-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9CE-1F3FC-200D-2640",
        image: "1f9ce-1f3fc-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 39,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9CE-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9CE-1F3FD-200D-2640",
        image: "1f9ce-1f3fd-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 40,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9CE-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9CE-1F3FE-200D-2640",
        image: "1f9ce-1f3fe-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 41,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9CE-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9CE-1F3FF-200D-2640",
        image: "1f9ce-1f3ff-200d-2640-fe0f.png",
        sheet_x: 44,
        sheet_y: 42,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Kneeling",
    b: "1F9CE-200D-2640-FE0F",
    c: "1F9CE-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      44,
      37
    ],
    o: 12
  },
  razor: {
    a: "Razor",
    b: "1FA92",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      52,
      6
    ],
    o: 12
  },
  person_with_probing_cane: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F9AF",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f9af.png",
        sheet_x: 47,
        sheet_y: 8,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F9AF",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f9af.png",
        sheet_x: 47,
        sheet_y: 9,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F9AF",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f9af.png",
        sheet_x: 47,
        sheet_y: 10,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F9AF",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f9af.png",
        sheet_x: 47,
        sheet_y: 11,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F9AF",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f9af.png",
        sheet_x: 47,
        sheet_y: 12,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Person with Probing Cane",
    b: "1F9D1-200D-1F9AF",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      47,
      7
    ],
    o: 12
  },
  "flag-ss": {
    a: "South Sudan Flag",
    b: "1F1F8-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      16
    ],
    o: 2
  },
  lotion_bottle: {
    a: "Lotion Bottle",
    b: "1F9F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      39
    ],
    o: 11
  },
  "flag-st": {
    a: "São Tomé & Príncipe Flag",
    b: "1F1F8-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      17
    ],
    o: 2
  },
  safety_pin: {
    a: "Safety Pin",
    b: "1F9F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      42
    ],
    o: 11
  },
  man_with_probing_cane: {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F9AF",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f9af.png",
        sheet_x: 16,
        sheet_y: 18,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F9AF",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f9af.png",
        sheet_x: 16,
        sheet_y: 19,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F9AF",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f9af.png",
        sheet_x: 16,
        sheet_y: 20,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F9AF",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f9af.png",
        sheet_x: 16,
        sheet_y: 21,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F9AF",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f9af.png",
        sheet_x: 16,
        sheet_y: 22,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man with Probing Cane",
    b: "1F468-200D-1F9AF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      16,
      17
    ],
    o: 12
  },
  broom: {
    a: "Broom",
    b: "1F9F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      44
    ],
    o: 11
  },
  woman_with_probing_cane: {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F9AF",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f9af.png",
        sheet_x: 19,
        sheet_y: 3,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F9AF",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f9af.png",
        sheet_x: 19,
        sheet_y: 4,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F9AF",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f9af.png",
        sheet_x: 19,
        sheet_y: 5,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F9AF",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f9af.png",
        sheet_x: 19,
        sheet_y: 6,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F9AF",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f9af.png",
        sheet_x: 19,
        sheet_y: 7,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman with Probing Cane",
    b: "1F469-200D-1F9AF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      2
    ],
    o: 12
  },
  "flag-sv": {
    a: "El Salvador Flag",
    b: "1F1F8-1F1FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      18
    ],
    o: 2
  },
  "flag-sx": {
    a: "Sint Maarten Flag",
    b: "1F1F8-1F1FD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      19
    ],
    o: 2
  },
  basket: {
    a: "Basket",
    b: "1F9FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      45
    ],
    o: 11
  },
  person_in_motorized_wheelchair: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F9BC",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f9bc.png",
        sheet_x: 47,
        sheet_y: 38,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F9BC",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f9bc.png",
        sheet_x: 47,
        sheet_y: 39,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F9BC",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f9bc.png",
        sheet_x: 47,
        sheet_y: 40,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F9BC",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f9bc.png",
        sheet_x: 47,
        sheet_y: 41,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F9BC",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f9bc.png",
        sheet_x: 47,
        sheet_y: 42,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Person in Motorized Wheelchair",
    b: "1F9D1-200D-1F9BC",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      47,
      37
    ],
    o: 12
  },
  man_in_motorized_wheelchair: {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F9BC",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f9bc.png",
        sheet_x: 16,
        sheet_y: 48,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F9BC",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f9bc.png",
        sheet_x: 16,
        sheet_y: 49,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F9BC",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f9bc.png",
        sheet_x: 16,
        sheet_y: 50,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F9BC",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f9bc.png",
        sheet_x: 16,
        sheet_y: 51,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F9BC",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f9bc.png",
        sheet_x: 16,
        sheet_y: 52,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man in Motorized Wheelchair",
    b: "1F468-200D-1F9BC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      16,
      47
    ],
    o: 12
  },
  "flag-sy": {
    a: "Syria Flag",
    b: "1F1F8-1F1FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      20
    ],
    o: 2
  },
  roll_of_paper: {
    a: "Roll of Paper",
    b: "1F9FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      46
    ],
    o: 11
  },
  woman_in_motorized_wheelchair: {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F9BC",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f9bc.png",
        sheet_x: 19,
        sheet_y: 33,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F9BC",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f9bc.png",
        sheet_x: 19,
        sheet_y: 34,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F9BC",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f9bc.png",
        sheet_x: 19,
        sheet_y: 35,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F9BC",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f9bc.png",
        sheet_x: 19,
        sheet_y: 36,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F9BC",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f9bc.png",
        sheet_x: 19,
        sheet_y: 37,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman in Motorized Wheelchair",
    b: "1F469-200D-1F9BC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      32
    ],
    o: 12
  },
  "flag-sz": {
    a: "Eswatini Flag",
    b: "1F1F8-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      21
    ],
    o: 2
  },
  soap: {
    a: "Bar of Soap",
    b: "1F9FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      47
    ],
    o: 11
  },
  "flag-ta": {
    a: "Tristan Da Cunha Flag",
    b: "1F1F9-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      22
    ],
    o: 2
  },
  sponge: {
    a: "Sponge",
    b: "1F9FD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      48
    ],
    o: 11
  },
  person_in_manual_wheelchair: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F9BD",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f9bd.png",
        sheet_x: 47,
        sheet_y: 44,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F9BD",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f9bd.png",
        sheet_x: 47,
        sheet_y: 45,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F9BD",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f9bd.png",
        sheet_x: 47,
        sheet_y: 46,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F9BD",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f9bd.png",
        sheet_x: 47,
        sheet_y: 47,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F9BD",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f9bd.png",
        sheet_x: 47,
        sheet_y: 48,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !1,
        has_img_facebook: !1
      }
    },
    a: "Person in Manual Wheelchair",
    b: "1F9D1-200D-1F9BD",
    d: !0,
    e: !1,
    f: !1,
    h: !1,
    k: [
      47,
      43
    ],
    o: 12
  },
  fire_extinguisher: {
    a: "Fire Extinguisher",
    b: "1F9EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      51,
      34
    ],
    o: 11
  },
  man_in_manual_wheelchair: {
    skin_variations: {
      "1F3FB": {
        unified: "1F468-1F3FB-200D-1F9BD",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f9bd.png",
        sheet_x: 16,
        sheet_y: 54,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F468-1F3FC-200D-1F9BD",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f9bd.png",
        sheet_x: 16,
        sheet_y: 55,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F468-1F3FD-200D-1F9BD",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f9bd.png",
        sheet_x: 16,
        sheet_y: 56,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F468-1F3FE-200D-1F9BD",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f9bd.png",
        sheet_x: 17,
        sheet_y: 0,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F468-1F3FF-200D-1F9BD",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f9bd.png",
        sheet_x: 17,
        sheet_y: 1,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man in Manual Wheelchair",
    b: "1F468-200D-1F9BD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      16,
      53
    ],
    o: 12
  },
  "flag-tc": {
    a: "Turks & Caicos Islands Flag",
    b: "1F1F9-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      23
    ],
    o: 2
  },
  woman_in_manual_wheelchair: {
    skin_variations: {
      "1F3FB": {
        unified: "1F469-1F3FB-200D-1F9BD",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f9bd.png",
        sheet_x: 19,
        sheet_y: 39,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F469-1F3FC-200D-1F9BD",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f9bd.png",
        sheet_x: 19,
        sheet_y: 40,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F469-1F3FD-200D-1F9BD",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f9bd.png",
        sheet_x: 19,
        sheet_y: 41,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F469-1F3FE-200D-1F9BD",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f9bd.png",
        sheet_x: 19,
        sheet_y: 42,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F469-1F3FF-200D-1F9BD",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f9bd.png",
        sheet_x: 19,
        sheet_y: 43,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman in Manual Wheelchair",
    b: "1F469-200D-1F9BD",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      19,
      38
    ],
    o: 12
  },
  "flag-td": {
    a: "Chad Flag",
    b: "1F1F9-1F1E9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      24
    ],
    o: 2
  },
  shopping_trolley: {
    a: "Shopping Trolley",
    b: "1F6D2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      36,
      40
    ],
    o: 4
  },
  runner: {
    skin_variations: {
      "1F3FB": {
        unified: "1F3C3-1F3FB",
        non_qualified: null,
        image: "1f3c3-1f3fb.png",
        sheet_x: 9,
        sheet_y: 2,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F3C3-1F3FC",
        non_qualified: null,
        image: "1f3c3-1f3fc.png",
        sheet_x: 9,
        sheet_y: 3,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F3C3-1F3FD",
        non_qualified: null,
        image: "1f3c3-1f3fd.png",
        sheet_x: 9,
        sheet_y: 4,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F3C3-1F3FE",
        non_qualified: null,
        image: "1f3c3-1f3fe.png",
        sheet_x: 9,
        sheet_y: 5,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F3C3-1F3FF",
        non_qualified: null,
        image: "1f3c3-1f3ff.png",
        sheet_x: 9,
        sheet_y: 6,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F3C3-200D-2642-FE0F",
    a: "Runner",
    b: "1F3C3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      9,
      1
    ],
    n: [
      "running"
    ],
    o: 2
  },
  "flag-tf": {
    a: "French Southern Territories Flag",
    b: "1F1F9-1F1EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      25
    ],
    o: 2
  },
  smoking: {
    a: "Smoking Symbol",
    b: "1F6AC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "kills",
      "tobacco",
      "cigarette",
      "joint",
      "smoke"
    ],
    k: [
      35,
      3
    ],
    o: 2
  },
  coffin: {
    a: "Coffin",
    b: "26B0-FE0F",
    c: "26B0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "vampire",
      "dead",
      "die",
      "death",
      "rip",
      "graveyard",
      "cemetery",
      "casket",
      "funeral",
      "box"
    ],
    k: [
      53,
      54
    ],
    o: 2
  },
  "man-running": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3C3-1F3FB-200D-2642-FE0F",
        non_qualified: "1F3C3-1F3FB-200D-2642",
        image: "1f3c3-1f3fb-200d-2642-fe0f.png",
        sheet_x: 8,
        sheet_y: 53,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3C3-1F3FC-200D-2642-FE0F",
        non_qualified: "1F3C3-1F3FC-200D-2642",
        image: "1f3c3-1f3fc-200d-2642-fe0f.png",
        sheet_x: 8,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3C3-1F3FD-200D-2642-FE0F",
        non_qualified: "1F3C3-1F3FD-200D-2642",
        image: "1f3c3-1f3fd-200d-2642-fe0f.png",
        sheet_x: 8,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3C3-1F3FE-200D-2642-FE0F",
        non_qualified: "1F3C3-1F3FE-200D-2642",
        image: "1f3c3-1f3fe-200d-2642-fe0f.png",
        sheet_x: 8,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3C3-1F3FF-200D-2642-FE0F",
        non_qualified: "1F3C3-1F3FF-200D-2642",
        image: "1f3c3-1f3ff-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F3C3",
    a: "Man Running",
    b: "1F3C3-200D-2642-FE0F",
    c: "1F3C3-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      8,
      52
    ],
    o: 4
  },
  "flag-tg": {
    a: "Togo Flag",
    b: "1F1F9-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      26
    ],
    o: 2
  },
  "woman-running": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3C3-1F3FB-200D-2640-FE0F",
        non_qualified: "1F3C3-1F3FB-200D-2640",
        image: "1f3c3-1f3fb-200d-2640-fe0f.png",
        sheet_x: 8,
        sheet_y: 47,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3C3-1F3FC-200D-2640-FE0F",
        non_qualified: "1F3C3-1F3FC-200D-2640",
        image: "1f3c3-1f3fc-200d-2640-fe0f.png",
        sheet_x: 8,
        sheet_y: 48,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3C3-1F3FD-200D-2640-FE0F",
        non_qualified: "1F3C3-1F3FD-200D-2640",
        image: "1f3c3-1f3fd-200d-2640-fe0f.png",
        sheet_x: 8,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3C3-1F3FE-200D-2640-FE0F",
        non_qualified: "1F3C3-1F3FE-200D-2640",
        image: "1f3c3-1f3fe-200d-2640-fe0f.png",
        sheet_x: 8,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3C3-1F3FF-200D-2640-FE0F",
        non_qualified: "1F3C3-1F3FF-200D-2640",
        image: "1f3c3-1f3ff-200d-2640-fe0f.png",
        sheet_x: 8,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Running",
    b: "1F3C3-200D-2640-FE0F",
    c: "1F3C3-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      8,
      46
    ],
    o: 4
  },
  funeral_urn: {
    a: "Funeral Urn",
    b: "26B1-FE0F",
    c: "26B1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "dead",
      "die",
      "death",
      "rip",
      "ashes"
    ],
    k: [
      53,
      55
    ],
    o: 2
  },
  "flag-th": {
    a: "Thailand Flag",
    b: "1F1F9-1F1ED",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      27
    ],
    o: 2
  },
  moyai: {
    a: "Moyai",
    b: "1F5FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "rock",
      "easter island",
      "moai"
    ],
    k: [
      30,
      34
    ],
    o: 2
  },
  "flag-tj": {
    a: "Tajikistan Flag",
    b: "1F1F9-1F1EF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      28
    ],
    o: 2
  },
  dancer: {
    skin_variations: {
      "1F3FB": {
        unified: "1F483-1F3FB",
        non_qualified: null,
        image: "1f483-1f3fb.png",
        sheet_x: 24,
        sheet_y: 27,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F483-1F3FC",
        non_qualified: null,
        image: "1f483-1f3fc.png",
        sheet_x: 24,
        sheet_y: 28,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F483-1F3FD",
        non_qualified: null,
        image: "1f483-1f3fd.png",
        sheet_x: 24,
        sheet_y: 29,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F483-1F3FE",
        non_qualified: null,
        image: "1f483-1f3fe.png",
        sheet_x: 24,
        sheet_y: 30,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F483-1F3FF",
        non_qualified: null,
        image: "1f483-1f3ff.png",
        sheet_x: 24,
        sheet_y: 31,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Dancer",
    b: "1F483",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "female",
      "girl",
      "woman",
      "fun"
    ],
    k: [
      24,
      26
    ],
    o: 2
  },
  "flag-tk": {
    a: "Tokelau Flag",
    b: "1F1F9-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      29
    ],
    o: 2
  },
  man_dancing: {
    skin_variations: {
      "1F3FB": {
        unified: "1F57A-1F3FB",
        non_qualified: null,
        image: "1f57a-1f3fb.png",
        sheet_x: 29,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F57A-1F3FC",
        non_qualified: null,
        image: "1f57a-1f3fc.png",
        sheet_x: 29,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F57A-1F3FD",
        non_qualified: null,
        image: "1f57a-1f3fd.png",
        sheet_x: 29,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F57A-1F3FE",
        non_qualified: null,
        image: "1f57a-1f3fe.png",
        sheet_x: 29,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F57A-1F3FF",
        non_qualified: null,
        image: "1f57a-1f3ff.png",
        sheet_x: 29,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Dancing",
    b: "1F57A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "male",
      "boy",
      "fun",
      "dancer"
    ],
    k: [
      29,
      37
    ],
    o: 4
  },
  "flag-tl": {
    a: "Timor-Leste Flag",
    b: "1F1F9-1F1F1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      30
    ],
    o: 2
  },
  man_in_business_suit_levitating: {
    skin_variations: {
      "1F3FB": {
        unified: "1F574-1F3FB",
        non_qualified: null,
        image: "1f574-1f3fb.png",
        sheet_x: 29,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F574-1F3FC",
        non_qualified: null,
        image: "1f574-1f3fc.png",
        sheet_x: 29,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F574-1F3FD",
        non_qualified: null,
        image: "1f574-1f3fd.png",
        sheet_x: 29,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F574-1F3FE",
        non_qualified: null,
        image: "1f574-1f3fe.png",
        sheet_x: 29,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F574-1F3FF",
        non_qualified: null,
        image: "1f574-1f3ff.png",
        sheet_x: 29,
        sheet_y: 14,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man in Business Suit Levitating",
    b: "1F574-FE0F",
    c: "1F574",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      29,
      9
    ],
    o: 2
  },
  "flag-tm": {
    a: "Turkmenistan Flag",
    b: "1F1F9-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      31
    ],
    o: 2
  },
  dancers: {
    obsoleted_by: "1F46F-200D-2640-FE0F",
    a: "Woman with Bunny Ears",
    b: "1F46F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      22,
      0
    ],
    o: 2
  },
  "man-with-bunny-ears-partying": {
    a: "Man with Bunny Ears Partying",
    b: "1F46F-200D-2642-FE0F",
    c: "1F46F-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      21,
      56
    ],
    o: 4
  },
  "flag-tn": {
    a: "Tunisia Flag",
    b: "1F1F9-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      32
    ],
    o: 2
  },
  "flag-to": {
    a: "Tonga Flag",
    b: "1F1F9-1F1F4",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      33
    ],
    o: 2
  },
  "woman-with-bunny-ears-partying": {
    obsoletes: "1F46F",
    a: "Woman with Bunny Ears Partying",
    b: "1F46F-200D-2640-FE0F",
    c: "1F46F-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      21,
      55
    ],
    o: 4
  },
  "flag-tr": {
    a: "Turkey Flag",
    b: "1F1F9-1F1F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      34
    ],
    o: 2
  },
  person_in_steamy_room: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D6-1F3FB",
        non_qualified: null,
        image: "1f9d6-1f3fb.png",
        sheet_x: 48,
        sheet_y: 53,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D6-1F3FB-200D-2642-FE0F"
      },
      "1F3FC": {
        unified: "1F9D6-1F3FC",
        non_qualified: null,
        image: "1f9d6-1f3fc.png",
        sheet_x: 48,
        sheet_y: 54,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D6-1F3FC-200D-2642-FE0F"
      },
      "1F3FD": {
        unified: "1F9D6-1F3FD",
        non_qualified: null,
        image: "1f9d6-1f3fd.png",
        sheet_x: 48,
        sheet_y: 55,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D6-1F3FD-200D-2642-FE0F"
      },
      "1F3FE": {
        unified: "1F9D6-1F3FE",
        non_qualified: null,
        image: "1f9d6-1f3fe.png",
        sheet_x: 48,
        sheet_y: 56,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D6-1F3FE-200D-2642-FE0F"
      },
      "1F3FF": {
        unified: "1F9D6-1F3FF",
        non_qualified: null,
        image: "1f9d6-1f3ff.png",
        sheet_x: 49,
        sheet_y: 0,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D6-1F3FF-200D-2642-FE0F"
      }
    },
    obsoleted_by: "1F9D6-200D-2642-FE0F",
    a: "Person in Steamy Room",
    b: "1F9D6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      48,
      52
    ],
    o: 5
  },
  man_in_steamy_room: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D6-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9D6-1F3FB-200D-2642",
        image: "1f9d6-1f3fb-200d-2642-fe0f.png",
        sheet_x: 48,
        sheet_y: 47,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D6-1F3FB"
      },
      "1F3FC": {
        unified: "1F9D6-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9D6-1F3FC-200D-2642",
        image: "1f9d6-1f3fc-200d-2642-fe0f.png",
        sheet_x: 48,
        sheet_y: 48,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D6-1F3FC"
      },
      "1F3FD": {
        unified: "1F9D6-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9D6-1F3FD-200D-2642",
        image: "1f9d6-1f3fd-200d-2642-fe0f.png",
        sheet_x: 48,
        sheet_y: 49,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D6-1F3FD"
      },
      "1F3FE": {
        unified: "1F9D6-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9D6-1F3FE-200D-2642",
        image: "1f9d6-1f3fe-200d-2642-fe0f.png",
        sheet_x: 48,
        sheet_y: 50,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D6-1F3FE"
      },
      "1F3FF": {
        unified: "1F9D6-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9D6-1F3FF-200D-2642",
        image: "1f9d6-1f3ff-200d-2642-fe0f.png",
        sheet_x: 48,
        sheet_y: 51,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D6-1F3FF"
      }
    },
    obsoletes: "1F9D6",
    a: "Man in Steamy Room",
    b: "1F9D6-200D-2642-FE0F",
    c: "1F9D6-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      48,
      46
    ],
    o: 5
  },
  "flag-tt": {
    a: "Trinidad & Tobago Flag",
    b: "1F1F9-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      35
    ],
    o: 2
  },
  woman_in_steamy_room: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D6-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9D6-1F3FB-200D-2640",
        image: "1f9d6-1f3fb-200d-2640-fe0f.png",
        sheet_x: 48,
        sheet_y: 41,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9D6-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9D6-1F3FC-200D-2640",
        image: "1f9d6-1f3fc-200d-2640-fe0f.png",
        sheet_x: 48,
        sheet_y: 42,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9D6-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9D6-1F3FD-200D-2640",
        image: "1f9d6-1f3fd-200d-2640-fe0f.png",
        sheet_x: 48,
        sheet_y: 43,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9D6-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9D6-1F3FE-200D-2640",
        image: "1f9d6-1f3fe-200d-2640-fe0f.png",
        sheet_x: 48,
        sheet_y: 44,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9D6-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9D6-1F3FF-200D-2640",
        image: "1f9d6-1f3ff-200d-2640-fe0f.png",
        sheet_x: 48,
        sheet_y: 45,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman in Steamy Room",
    b: "1F9D6-200D-2640-FE0F",
    c: "1F9D6-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      48,
      40
    ],
    o: 5
  },
  "flag-tv": {
    a: "Tuvalu Flag",
    b: "1F1F9-1F1FB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      36
    ],
    o: 2
  },
  "flag-tw": {
    a: "Taiwan Flag",
    b: "1F1F9-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      37
    ],
    o: 2
  },
  person_climbing: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D7-1F3FB",
        non_qualified: null,
        image: "1f9d7-1f3fb.png",
        sheet_x: 49,
        sheet_y: 14,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D7-1F3FB-200D-2640-FE0F"
      },
      "1F3FC": {
        unified: "1F9D7-1F3FC",
        non_qualified: null,
        image: "1f9d7-1f3fc.png",
        sheet_x: 49,
        sheet_y: 15,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D7-1F3FC-200D-2640-FE0F"
      },
      "1F3FD": {
        unified: "1F9D7-1F3FD",
        non_qualified: null,
        image: "1f9d7-1f3fd.png",
        sheet_x: 49,
        sheet_y: 16,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D7-1F3FD-200D-2640-FE0F"
      },
      "1F3FE": {
        unified: "1F9D7-1F3FE",
        non_qualified: null,
        image: "1f9d7-1f3fe.png",
        sheet_x: 49,
        sheet_y: 17,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D7-1F3FE-200D-2640-FE0F"
      },
      "1F3FF": {
        unified: "1F9D7-1F3FF",
        non_qualified: null,
        image: "1f9d7-1f3ff.png",
        sheet_x: 49,
        sheet_y: 18,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D7-1F3FF-200D-2640-FE0F"
      }
    },
    obsoleted_by: "1F9D7-200D-2640-FE0F",
    a: "Person Climbing",
    b: "1F9D7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      13
    ],
    o: 5
  },
  man_climbing: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D7-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9D7-1F3FB-200D-2642",
        image: "1f9d7-1f3fb-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 8,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9D7-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9D7-1F3FC-200D-2642",
        image: "1f9d7-1f3fc-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 9,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9D7-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9D7-1F3FD-200D-2642",
        image: "1f9d7-1f3fd-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 10,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9D7-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9D7-1F3FE-200D-2642",
        image: "1f9d7-1f3fe-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 11,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9D7-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9D7-1F3FF-200D-2642",
        image: "1f9d7-1f3ff-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 12,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Climbing",
    b: "1F9D7-200D-2642-FE0F",
    c: "1F9D7-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      7
    ],
    o: 5
  },
  "flag-tz": {
    a: "Tanzania Flag",
    b: "1F1F9-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      38
    ],
    o: 2
  },
  "flag-ua": {
    a: "Ukraine Flag",
    b: "1F1FA-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      39
    ],
    o: 2
  },
  woman_climbing: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D7-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9D7-1F3FB-200D-2640",
        image: "1f9d7-1f3fb-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 2,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D7-1F3FB"
      },
      "1F3FC": {
        unified: "1F9D7-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9D7-1F3FC-200D-2640",
        image: "1f9d7-1f3fc-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 3,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D7-1F3FC"
      },
      "1F3FD": {
        unified: "1F9D7-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9D7-1F3FD-200D-2640",
        image: "1f9d7-1f3fd-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 4,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D7-1F3FD"
      },
      "1F3FE": {
        unified: "1F9D7-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9D7-1F3FE-200D-2640",
        image: "1f9d7-1f3fe-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 5,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D7-1F3FE"
      },
      "1F3FF": {
        unified: "1F9D7-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9D7-1F3FF-200D-2640",
        image: "1f9d7-1f3ff-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 6,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D7-1F3FF"
      }
    },
    obsoletes: "1F9D7",
    a: "Woman Climbing",
    b: "1F9D7-200D-2640-FE0F",
    c: "1F9D7-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      1
    ],
    o: 5
  },
  "flag-ug": {
    a: "Uganda Flag",
    b: "1F1FA-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      40
    ],
    o: 2
  },
  fencer: {
    a: "Fencer",
    b: "1F93A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      32
    ],
    o: 4
  },
  "flag-um": {
    a: "U.s. Outlying Islands Flag",
    b: "1F1FA-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      41
    ],
    o: 2
  },
  horse_racing: {
    skin_variations: {
      "1F3FB": {
        unified: "1F3C7-1F3FB",
        non_qualified: null,
        image: "1f3c7-1f3fb.png",
        sheet_x: 9,
        sheet_y: 28,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3C7-1F3FC",
        non_qualified: null,
        image: "1f3c7-1f3fc.png",
        sheet_x: 9,
        sheet_y: 29,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3C7-1F3FD",
        non_qualified: null,
        image: "1f3c7-1f3fd.png",
        sheet_x: 9,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3C7-1F3FE",
        non_qualified: null,
        image: "1f3c7-1f3fe.png",
        sheet_x: 9,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3C7-1F3FF",
        non_qualified: null,
        image: "1f3c7-1f3ff.png",
        sheet_x: 9,
        sheet_y: 32,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Horse Racing",
    b: "1F3C7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "animal",
      "betting",
      "competition",
      "gambling",
      "luck"
    ],
    k: [
      9,
      27
    ],
    o: 2
  },
  skier: {
    a: "Skier",
    b: "26F7-FE0F",
    c: "26F7",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "winter",
      "snow"
    ],
    k: [
      54,
      17
    ],
    o: 2
  },
  "flag-un": {
    a: "United Nations Flag",
    b: "1F1FA-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      42
    ],
    o: 4
  },
  us: {
    a: "United States Flag",
    b: "1F1FA-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "united",
      "states",
      "america",
      "flag",
      "nation",
      "country",
      "banner"
    ],
    k: [
      4,
      43
    ],
    n: [
      "flag-us"
    ],
    o: 2
  },
  snowboarder: {
    skin_variations: {
      "1F3FB": {
        unified: "1F3C2-1F3FB",
        non_qualified: null,
        image: "1f3c2-1f3fb.png",
        sheet_x: 8,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3C2-1F3FC",
        non_qualified: null,
        image: "1f3c2-1f3fc.png",
        sheet_x: 8,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3C2-1F3FD",
        non_qualified: null,
        image: "1f3c2-1f3fd.png",
        sheet_x: 8,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3C2-1F3FE",
        non_qualified: null,
        image: "1f3c2-1f3fe.png",
        sheet_x: 8,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3C2-1F3FF",
        non_qualified: null,
        image: "1f3c2-1f3ff.png",
        sheet_x: 8,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Snowboarder",
    b: "1F3C2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "sports",
      "winter"
    ],
    k: [
      8,
      40
    ],
    o: 2
  },
  golfer: {
    skin_variations: {
      "1F3FB": {
        unified: "1F3CC-1F3FB",
        non_qualified: null,
        image: "1f3cc-1f3fb.png",
        sheet_x: 10,
        sheet_y: 27,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F3CC-1F3FC",
        non_qualified: null,
        image: "1f3cc-1f3fc.png",
        sheet_x: 10,
        sheet_y: 28,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F3CC-1F3FD",
        non_qualified: null,
        image: "1f3cc-1f3fd.png",
        sheet_x: 10,
        sheet_y: 29,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F3CC-1F3FE",
        non_qualified: null,
        image: "1f3cc-1f3fe.png",
        sheet_x: 10,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F3CC-1F3FF",
        non_qualified: null,
        image: "1f3cc-1f3ff.png",
        sheet_x: 10,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F3CC-FE0F-200D-2642-FE0F",
    a: "Golfer",
    b: "1F3CC-FE0F",
    c: "1F3CC",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      10,
      26
    ],
    o: 2
  },
  "flag-uy": {
    a: "Uruguay Flag",
    b: "1F1FA-1F1FE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      44
    ],
    o: 2
  },
  "flag-uz": {
    a: "Uzbekistan Flag",
    b: "1F1FA-1F1FF",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      45
    ],
    o: 2
  },
  "man-golfing": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3CC-1F3FB-200D-2642-FE0F",
        non_qualified: "1F3CC-1F3FB-200D-2642",
        image: "1f3cc-1f3fb-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 21,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3CC-1F3FC-200D-2642-FE0F",
        non_qualified: "1F3CC-1F3FC-200D-2642",
        image: "1f3cc-1f3fc-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 22,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3CC-1F3FD-200D-2642-FE0F",
        non_qualified: "1F3CC-1F3FD-200D-2642",
        image: "1f3cc-1f3fd-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 23,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3CC-1F3FE-200D-2642-FE0F",
        non_qualified: "1F3CC-1F3FE-200D-2642",
        image: "1f3cc-1f3fe-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 24,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3CC-1F3FF-200D-2642-FE0F",
        non_qualified: "1F3CC-1F3FF-200D-2642",
        image: "1f3cc-1f3ff-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 25,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F3CC-FE0F",
    a: "Man Golfing",
    b: "1F3CC-FE0F-200D-2642-FE0F",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      10,
      20
    ],
    o: 4
  },
  "flag-va": {
    a: "Vatican City Flag",
    b: "1F1FB-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      46
    ],
    o: 2
  },
  "woman-golfing": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3CC-1F3FB-200D-2640-FE0F",
        non_qualified: "1F3CC-1F3FB-200D-2640",
        image: "1f3cc-1f3fb-200d-2640-fe0f.png",
        sheet_x: 10,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3CC-1F3FC-200D-2640-FE0F",
        non_qualified: "1F3CC-1F3FC-200D-2640",
        image: "1f3cc-1f3fc-200d-2640-fe0f.png",
        sheet_x: 10,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3CC-1F3FD-200D-2640-FE0F",
        non_qualified: "1F3CC-1F3FD-200D-2640",
        image: "1f3cc-1f3fd-200d-2640-fe0f.png",
        sheet_x: 10,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3CC-1F3FE-200D-2640-FE0F",
        non_qualified: "1F3CC-1F3FE-200D-2640",
        image: "1f3cc-1f3fe-200d-2640-fe0f.png",
        sheet_x: 10,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3CC-1F3FF-200D-2640-FE0F",
        non_qualified: "1F3CC-1F3FF-200D-2640",
        image: "1f3cc-1f3ff-200d-2640-fe0f.png",
        sheet_x: 10,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Golfing",
    b: "1F3CC-FE0F-200D-2640-FE0F",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      10,
      14
    ],
    o: 4
  },
  "flag-vc": {
    a: "St. Vincent & Grenadines Flag",
    b: "1F1FB-1F1E8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      47
    ],
    o: 2
  },
  surfer: {
    skin_variations: {
      "1F3FB": {
        unified: "1F3C4-1F3FB",
        non_qualified: null,
        image: "1f3c4-1f3fb.png",
        sheet_x: 9,
        sheet_y: 20,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F3C4-1F3FC",
        non_qualified: null,
        image: "1f3c4-1f3fc.png",
        sheet_x: 9,
        sheet_y: 21,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F3C4-1F3FD",
        non_qualified: null,
        image: "1f3c4-1f3fd.png",
        sheet_x: 9,
        sheet_y: 22,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F3C4-1F3FE",
        non_qualified: null,
        image: "1f3c4-1f3fe.png",
        sheet_x: 9,
        sheet_y: 23,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F3C4-1F3FF",
        non_qualified: null,
        image: "1f3c4-1f3ff.png",
        sheet_x: 9,
        sheet_y: 24,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F3C4-200D-2642-FE0F",
    a: "Surfer",
    b: "1F3C4",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      9,
      19
    ],
    o: 2
  },
  "man-surfing": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3C4-1F3FB-200D-2642-FE0F",
        non_qualified: "1F3C4-1F3FB-200D-2642",
        image: "1f3c4-1f3fb-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 14,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3C4-1F3FC-200D-2642-FE0F",
        non_qualified: "1F3C4-1F3FC-200D-2642",
        image: "1f3c4-1f3fc-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3C4-1F3FD-200D-2642-FE0F",
        non_qualified: "1F3C4-1F3FD-200D-2642",
        image: "1f3c4-1f3fd-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3C4-1F3FE-200D-2642-FE0F",
        non_qualified: "1F3C4-1F3FE-200D-2642",
        image: "1f3c4-1f3fe-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3C4-1F3FF-200D-2642-FE0F",
        non_qualified: "1F3C4-1F3FF-200D-2642",
        image: "1f3c4-1f3ff-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F3C4",
    a: "Man Surfing",
    b: "1F3C4-200D-2642-FE0F",
    c: "1F3C4-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      9,
      13
    ],
    o: 4
  },
  "flag-ve": {
    a: "Venezuela Flag",
    b: "1F1FB-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      48
    ],
    o: 2
  },
  "flag-vg": {
    a: "British Virgin Islands Flag",
    b: "1F1FB-1F1EC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      49
    ],
    o: 2
  },
  "woman-surfing": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3C4-1F3FB-200D-2640-FE0F",
        non_qualified: "1F3C4-1F3FB-200D-2640",
        image: "1f3c4-1f3fb-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 8,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3C4-1F3FC-200D-2640-FE0F",
        non_qualified: "1F3C4-1F3FC-200D-2640",
        image: "1f3c4-1f3fc-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3C4-1F3FD-200D-2640-FE0F",
        non_qualified: "1F3C4-1F3FD-200D-2640",
        image: "1f3c4-1f3fd-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3C4-1F3FE-200D-2640-FE0F",
        non_qualified: "1F3C4-1F3FE-200D-2640",
        image: "1f3c4-1f3fe-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3C4-1F3FF-200D-2640-FE0F",
        non_qualified: "1F3C4-1F3FF-200D-2640",
        image: "1f3c4-1f3ff-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Surfing",
    b: "1F3C4-200D-2640-FE0F",
    c: "1F3C4-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      9,
      7
    ],
    o: 4
  },
  rowboat: {
    skin_variations: {
      "1F3FB": {
        unified: "1F6A3-1F3FB",
        non_qualified: null,
        image: "1f6a3-1f3fb.png",
        sheet_x: 34,
        sheet_y: 47,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F6A3-1F3FC",
        non_qualified: null,
        image: "1f6a3-1f3fc.png",
        sheet_x: 34,
        sheet_y: 48,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F6A3-1F3FD",
        non_qualified: null,
        image: "1f6a3-1f3fd.png",
        sheet_x: 34,
        sheet_y: 49,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F6A3-1F3FE",
        non_qualified: null,
        image: "1f6a3-1f3fe.png",
        sheet_x: 34,
        sheet_y: 50,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F6A3-1F3FF",
        non_qualified: null,
        image: "1f6a3-1f3ff.png",
        sheet_x: 34,
        sheet_y: 51,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F6A3-200D-2642-FE0F",
    a: "Rowboat",
    b: "1F6A3",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      34,
      46
    ],
    o: 2
  },
  "flag-vi": {
    a: "U.s. Virgin Islands Flag",
    b: "1F1FB-1F1EE",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      50
    ],
    o: 2
  },
  "man-rowing-boat": {
    skin_variations: {
      "1F3FB": {
        unified: "1F6A3-1F3FB-200D-2642-FE0F",
        non_qualified: "1F6A3-1F3FB-200D-2642",
        image: "1f6a3-1f3fb-200d-2642-fe0f.png",
        sheet_x: 34,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6A3-1F3FC-200D-2642-FE0F",
        non_qualified: "1F6A3-1F3FC-200D-2642",
        image: "1f6a3-1f3fc-200d-2642-fe0f.png",
        sheet_x: 34,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6A3-1F3FD-200D-2642-FE0F",
        non_qualified: "1F6A3-1F3FD-200D-2642",
        image: "1f6a3-1f3fd-200d-2642-fe0f.png",
        sheet_x: 34,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6A3-1F3FE-200D-2642-FE0F",
        non_qualified: "1F6A3-1F3FE-200D-2642",
        image: "1f6a3-1f3fe-200d-2642-fe0f.png",
        sheet_x: 34,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6A3-1F3FF-200D-2642-FE0F",
        non_qualified: "1F6A3-1F3FF-200D-2642",
        image: "1f6a3-1f3ff-200d-2642-fe0f.png",
        sheet_x: 34,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F6A3",
    a: "Man Rowing Boat",
    b: "1F6A3-200D-2642-FE0F",
    c: "1F6A3-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      34,
      40
    ],
    o: 4
  },
  "flag-vn": {
    a: "Vietnam Flag",
    b: "1F1FB-1F1F3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      51
    ],
    o: 2
  },
  "flag-vu": {
    a: "Vanuatu Flag",
    b: "1F1FB-1F1FA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      52
    ],
    o: 2
  },
  "woman-rowing-boat": {
    skin_variations: {
      "1F3FB": {
        unified: "1F6A3-1F3FB-200D-2640-FE0F",
        non_qualified: "1F6A3-1F3FB-200D-2640",
        image: "1f6a3-1f3fb-200d-2640-fe0f.png",
        sheet_x: 34,
        sheet_y: 35,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6A3-1F3FC-200D-2640-FE0F",
        non_qualified: "1F6A3-1F3FC-200D-2640",
        image: "1f6a3-1f3fc-200d-2640-fe0f.png",
        sheet_x: 34,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6A3-1F3FD-200D-2640-FE0F",
        non_qualified: "1F6A3-1F3FD-200D-2640",
        image: "1f6a3-1f3fd-200d-2640-fe0f.png",
        sheet_x: 34,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6A3-1F3FE-200D-2640-FE0F",
        non_qualified: "1F6A3-1F3FE-200D-2640",
        image: "1f6a3-1f3fe-200d-2640-fe0f.png",
        sheet_x: 34,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6A3-1F3FF-200D-2640-FE0F",
        non_qualified: "1F6A3-1F3FF-200D-2640",
        image: "1f6a3-1f3ff-200d-2640-fe0f.png",
        sheet_x: 34,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Rowing Boat",
    b: "1F6A3-200D-2640-FE0F",
    c: "1F6A3-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      34,
      34
    ],
    o: 4
  },
  swimmer: {
    skin_variations: {
      "1F3FB": {
        unified: "1F3CA-1F3FB",
        non_qualified: null,
        image: "1f3ca-1f3fb.png",
        sheet_x: 9,
        sheet_y: 48,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F3CA-1F3FC",
        non_qualified: null,
        image: "1f3ca-1f3fc.png",
        sheet_x: 9,
        sheet_y: 49,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F3CA-1F3FD",
        non_qualified: null,
        image: "1f3ca-1f3fd.png",
        sheet_x: 9,
        sheet_y: 50,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F3CA-1F3FE",
        non_qualified: null,
        image: "1f3ca-1f3fe.png",
        sheet_x: 9,
        sheet_y: 51,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F3CA-1F3FF",
        non_qualified: null,
        image: "1f3ca-1f3ff.png",
        sheet_x: 9,
        sheet_y: 52,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F3CA-200D-2642-FE0F",
    a: "Swimmer",
    b: "1F3CA",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      9,
      47
    ],
    o: 2
  },
  "flag-wf": {
    a: "Wallis & Futuna Flag",
    b: "1F1FC-1F1EB",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      53
    ],
    o: 2
  },
  "man-swimming": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3CA-1F3FB-200D-2642-FE0F",
        non_qualified: "1F3CA-1F3FB-200D-2642",
        image: "1f3ca-1f3fb-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 42,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3CA-1F3FC-200D-2642-FE0F",
        non_qualified: "1F3CA-1F3FC-200D-2642",
        image: "1f3ca-1f3fc-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3CA-1F3FD-200D-2642-FE0F",
        non_qualified: "1F3CA-1F3FD-200D-2642",
        image: "1f3ca-1f3fd-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3CA-1F3FE-200D-2642-FE0F",
        non_qualified: "1F3CA-1F3FE-200D-2642",
        image: "1f3ca-1f3fe-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3CA-1F3FF-200D-2642-FE0F",
        non_qualified: "1F3CA-1F3FF-200D-2642",
        image: "1f3ca-1f3ff-200d-2642-fe0f.png",
        sheet_x: 9,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F3CA",
    a: "Man Swimming",
    b: "1F3CA-200D-2642-FE0F",
    c: "1F3CA-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      9,
      41
    ],
    o: 4
  },
  "flag-ws": {
    a: "Samoa Flag",
    b: "1F1FC-1F1F8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      54
    ],
    o: 2
  },
  "woman-swimming": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3CA-1F3FB-200D-2640-FE0F",
        non_qualified: "1F3CA-1F3FB-200D-2640",
        image: "1f3ca-1f3fb-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3CA-1F3FC-200D-2640-FE0F",
        non_qualified: "1F3CA-1F3FC-200D-2640",
        image: "1f3ca-1f3fc-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3CA-1F3FD-200D-2640-FE0F",
        non_qualified: "1F3CA-1F3FD-200D-2640",
        image: "1f3ca-1f3fd-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3CA-1F3FE-200D-2640-FE0F",
        non_qualified: "1F3CA-1F3FE-200D-2640",
        image: "1f3ca-1f3fe-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3CA-1F3FF-200D-2640-FE0F",
        non_qualified: "1F3CA-1F3FF-200D-2640",
        image: "1f3ca-1f3ff-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Swimming",
    b: "1F3CA-200D-2640-FE0F",
    c: "1F3CA-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      9,
      35
    ],
    o: 4
  },
  "flag-xk": {
    a: "Kosovo Flag",
    b: "1F1FD-1F1F0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      55
    ],
    o: 2
  },
  person_with_ball: {
    skin_variations: {
      "1F3FB": {
        unified: "26F9-1F3FB",
        non_qualified: null,
        image: "26f9-1f3fb.png",
        sheet_x: 54,
        sheet_y: 32,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "26F9-1F3FC",
        non_qualified: null,
        image: "26f9-1f3fc.png",
        sheet_x: 54,
        sheet_y: 33,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "26F9-1F3FD",
        non_qualified: null,
        image: "26f9-1f3fd.png",
        sheet_x: 54,
        sheet_y: 34,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "26F9-1F3FE",
        non_qualified: null,
        image: "26f9-1f3fe.png",
        sheet_x: 54,
        sheet_y: 35,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "26F9-1F3FF",
        non_qualified: null,
        image: "26f9-1f3ff.png",
        sheet_x: 54,
        sheet_y: 36,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "26F9-FE0F-200D-2642-FE0F",
    a: "Person with Ball",
    b: "26F9-FE0F",
    c: "26F9",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      54,
      31
    ],
    o: 2
  },
  "flag-ye": {
    a: "Yemen Flag",
    b: "1F1FE-1F1EA",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      4,
      56
    ],
    o: 2
  },
  "man-bouncing-ball": {
    skin_variations: {
      "1F3FB": {
        unified: "26F9-1F3FB-200D-2642-FE0F",
        non_qualified: "26F9-1F3FB-200D-2642",
        image: "26f9-1f3fb-200d-2642-fe0f.png",
        sheet_x: 54,
        sheet_y: 26,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "26F9-1F3FC-200D-2642-FE0F",
        non_qualified: "26F9-1F3FC-200D-2642",
        image: "26f9-1f3fc-200d-2642-fe0f.png",
        sheet_x: 54,
        sheet_y: 27,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "26F9-1F3FD-200D-2642-FE0F",
        non_qualified: "26F9-1F3FD-200D-2642",
        image: "26f9-1f3fd-200d-2642-fe0f.png",
        sheet_x: 54,
        sheet_y: 28,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "26F9-1F3FE-200D-2642-FE0F",
        non_qualified: "26F9-1F3FE-200D-2642",
        image: "26f9-1f3fe-200d-2642-fe0f.png",
        sheet_x: 54,
        sheet_y: 29,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "26F9-1F3FF-200D-2642-FE0F",
        non_qualified: "26F9-1F3FF-200D-2642",
        image: "26f9-1f3ff-200d-2642-fe0f.png",
        sheet_x: 54,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "26F9-FE0F",
    a: "Man Bouncing Ball",
    b: "26F9-FE0F-200D-2642-FE0F",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      54,
      25
    ],
    o: 4
  },
  "flag-yt": {
    a: "Mayotte Flag",
    b: "1F1FE-1F1F9",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      5,
      0
    ],
    o: 2
  },
  "woman-bouncing-ball": {
    skin_variations: {
      "1F3FB": {
        unified: "26F9-1F3FB-200D-2640-FE0F",
        non_qualified: "26F9-1F3FB-200D-2640",
        image: "26f9-1f3fb-200d-2640-fe0f.png",
        sheet_x: 54,
        sheet_y: 20,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "26F9-1F3FC-200D-2640-FE0F",
        non_qualified: "26F9-1F3FC-200D-2640",
        image: "26f9-1f3fc-200d-2640-fe0f.png",
        sheet_x: 54,
        sheet_y: 21,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "26F9-1F3FD-200D-2640-FE0F",
        non_qualified: "26F9-1F3FD-200D-2640",
        image: "26f9-1f3fd-200d-2640-fe0f.png",
        sheet_x: 54,
        sheet_y: 22,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "26F9-1F3FE-200D-2640-FE0F",
        non_qualified: "26F9-1F3FE-200D-2640",
        image: "26f9-1f3fe-200d-2640-fe0f.png",
        sheet_x: 54,
        sheet_y: 23,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "26F9-1F3FF-200D-2640-FE0F",
        non_qualified: "26F9-1F3FF-200D-2640",
        image: "26f9-1f3ff-200d-2640-fe0f.png",
        sheet_x: 54,
        sheet_y: 24,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Bouncing Ball",
    b: "26F9-FE0F-200D-2640-FE0F",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      54,
      19
    ],
    o: 4
  },
  "flag-za": {
    a: "South Africa Flag",
    b: "1F1FF-1F1E6",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      5,
      1
    ],
    o: 2
  },
  "flag-zm": {
    a: "Zambia Flag",
    b: "1F1FF-1F1F2",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      5,
      2
    ],
    o: 2
  },
  weight_lifter: {
    skin_variations: {
      "1F3FB": {
        unified: "1F3CB-1F3FB",
        non_qualified: null,
        image: "1f3cb-1f3fb.png",
        sheet_x: 10,
        sheet_y: 9,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F3CB-1F3FC",
        non_qualified: null,
        image: "1f3cb-1f3fc.png",
        sheet_x: 10,
        sheet_y: 10,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F3CB-1F3FD",
        non_qualified: null,
        image: "1f3cb-1f3fd.png",
        sheet_x: 10,
        sheet_y: 11,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F3CB-1F3FE",
        non_qualified: null,
        image: "1f3cb-1f3fe.png",
        sheet_x: 10,
        sheet_y: 12,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F3CB-1F3FF",
        non_qualified: null,
        image: "1f3cb-1f3ff.png",
        sheet_x: 10,
        sheet_y: 13,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F3CB-FE0F-200D-2642-FE0F",
    a: "Weight Lifter",
    b: "1F3CB-FE0F",
    c: "1F3CB",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      10,
      8
    ],
    o: 2
  },
  "man-lifting-weights": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3CB-1F3FB-200D-2642-FE0F",
        non_qualified: "1F3CB-1F3FB-200D-2642",
        image: "1f3cb-1f3fb-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 3,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3CB-1F3FC-200D-2642-FE0F",
        non_qualified: "1F3CB-1F3FC-200D-2642",
        image: "1f3cb-1f3fc-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 4,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3CB-1F3FD-200D-2642-FE0F",
        non_qualified: "1F3CB-1F3FD-200D-2642",
        image: "1f3cb-1f3fd-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 5,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3CB-1F3FE-200D-2642-FE0F",
        non_qualified: "1F3CB-1F3FE-200D-2642",
        image: "1f3cb-1f3fe-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 6,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3CB-1F3FF-200D-2642-FE0F",
        non_qualified: "1F3CB-1F3FF-200D-2642",
        image: "1f3cb-1f3ff-200d-2642-fe0f.png",
        sheet_x: 10,
        sheet_y: 7,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F3CB-FE0F",
    a: "Man Lifting Weights",
    b: "1F3CB-FE0F-200D-2642-FE0F",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      10,
      2
    ],
    o: 4
  },
  "flag-zw": {
    a: "Zimbabwe Flag",
    b: "1F1FF-1F1FC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      5,
      3
    ],
    o: 2
  },
  "woman-lifting-weights": {
    skin_variations: {
      "1F3FB": {
        unified: "1F3CB-1F3FB-200D-2640-FE0F",
        non_qualified: "1F3CB-1F3FB-200D-2640",
        image: "1f3cb-1f3fb-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F3CB-1F3FC-200D-2640-FE0F",
        non_qualified: "1F3CB-1F3FC-200D-2640",
        image: "1f3cb-1f3fc-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F3CB-1F3FD-200D-2640-FE0F",
        non_qualified: "1F3CB-1F3FD-200D-2640",
        image: "1f3cb-1f3fd-200d-2640-fe0f.png",
        sheet_x: 9,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F3CB-1F3FE-200D-2640-FE0F",
        non_qualified: "1F3CB-1F3FE-200D-2640",
        image: "1f3cb-1f3fe-200d-2640-fe0f.png",
        sheet_x: 10,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F3CB-1F3FF-200D-2640-FE0F",
        non_qualified: "1F3CB-1F3FF-200D-2640",
        image: "1f3cb-1f3ff-200d-2640-fe0f.png",
        sheet_x: 10,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Lifting Weights",
    b: "1F3CB-FE0F-200D-2640-FE0F",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      9,
      53
    ],
    o: 4
  },
  "flag-england": {
    a: "England Flag",
    b: "1F3F4-E0067-E0062-E0065-E006E-E0067-E007F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      11,
      14
    ],
    o: 5
  },
  bicyclist: {
    skin_variations: {
      "1F3FB": {
        unified: "1F6B4-1F3FB",
        non_qualified: null,
        image: "1f6b4-1f3fb.png",
        sheet_x: 35,
        sheet_y: 24,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F6B4-1F3FC",
        non_qualified: null,
        image: "1f6b4-1f3fc.png",
        sheet_x: 35,
        sheet_y: 25,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F6B4-1F3FD",
        non_qualified: null,
        image: "1f6b4-1f3fd.png",
        sheet_x: 35,
        sheet_y: 26,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F6B4-1F3FE",
        non_qualified: null,
        image: "1f6b4-1f3fe.png",
        sheet_x: 35,
        sheet_y: 27,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F6B4-1F3FF",
        non_qualified: null,
        image: "1f6b4-1f3ff.png",
        sheet_x: 35,
        sheet_y: 28,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F6B4-200D-2642-FE0F",
    a: "Bicyclist",
    b: "1F6B4",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      35,
      23
    ],
    o: 2
  },
  "flag-scotland": {
    a: "Scotland Flag",
    b: "1F3F4-E0067-E0062-E0073-E0063-E0074-E007F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      11,
      15
    ],
    o: 5
  },
  "flag-wales": {
    a: "Wales Flag",
    b: "1F3F4-E0067-E0062-E0077-E006C-E0073-E007F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      11,
      16
    ],
    o: 5
  },
  "man-biking": {
    skin_variations: {
      "1F3FB": {
        unified: "1F6B4-1F3FB-200D-2642-FE0F",
        non_qualified: "1F6B4-1F3FB-200D-2642",
        image: "1f6b4-1f3fb-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6B4-1F3FC-200D-2642-FE0F",
        non_qualified: "1F6B4-1F3FC-200D-2642",
        image: "1f6b4-1f3fc-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6B4-1F3FD-200D-2642-FE0F",
        non_qualified: "1F6B4-1F3FD-200D-2642",
        image: "1f6b4-1f3fd-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 20,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6B4-1F3FE-200D-2642-FE0F",
        non_qualified: "1F6B4-1F3FE-200D-2642",
        image: "1f6b4-1f3fe-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 21,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6B4-1F3FF-200D-2642-FE0F",
        non_qualified: "1F6B4-1F3FF-200D-2642",
        image: "1f6b4-1f3ff-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 22,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F6B4",
    a: "Man Biking",
    b: "1F6B4-200D-2642-FE0F",
    c: "1F6B4-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      35,
      17
    ],
    o: 4
  },
  "woman-biking": {
    skin_variations: {
      "1F3FB": {
        unified: "1F6B4-1F3FB-200D-2640-FE0F",
        non_qualified: "1F6B4-1F3FB-200D-2640",
        image: "1f6b4-1f3fb-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6B4-1F3FC-200D-2640-FE0F",
        non_qualified: "1F6B4-1F3FC-200D-2640",
        image: "1f6b4-1f3fc-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6B4-1F3FD-200D-2640-FE0F",
        non_qualified: "1F6B4-1F3FD-200D-2640",
        image: "1f6b4-1f3fd-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 14,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6B4-1F3FE-200D-2640-FE0F",
        non_qualified: "1F6B4-1F3FE-200D-2640",
        image: "1f6b4-1f3fe-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6B4-1F3FF-200D-2640-FE0F",
        non_qualified: "1F6B4-1F3FF-200D-2640",
        image: "1f6b4-1f3ff-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Biking",
    b: "1F6B4-200D-2640-FE0F",
    c: "1F6B4-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      35,
      11
    ],
    o: 4
  },
  mountain_bicyclist: {
    skin_variations: {
      "1F3FB": {
        unified: "1F6B5-1F3FB",
        non_qualified: null,
        image: "1f6b5-1f3fb.png",
        sheet_x: 35,
        sheet_y: 42,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F6B5-1F3FC",
        non_qualified: null,
        image: "1f6b5-1f3fc.png",
        sheet_x: 35,
        sheet_y: 43,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F6B5-1F3FD",
        non_qualified: null,
        image: "1f6b5-1f3fd.png",
        sheet_x: 35,
        sheet_y: 44,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F6B5-1F3FE",
        non_qualified: null,
        image: "1f6b5-1f3fe.png",
        sheet_x: 35,
        sheet_y: 45,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F6B5-1F3FF",
        non_qualified: null,
        image: "1f6b5-1f3ff.png",
        sheet_x: 35,
        sheet_y: 46,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    obsoleted_by: "1F6B5-200D-2642-FE0F",
    a: "Mountain Bicyclist",
    b: "1F6B5",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      35,
      41
    ],
    o: 2
  },
  "man-mountain-biking": {
    skin_variations: {
      "1F3FB": {
        unified: "1F6B5-1F3FB-200D-2642-FE0F",
        non_qualified: "1F6B5-1F3FB-200D-2642",
        image: "1f6b5-1f3fb-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 36,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6B5-1F3FC-200D-2642-FE0F",
        non_qualified: "1F6B5-1F3FC-200D-2642",
        image: "1f6b5-1f3fc-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6B5-1F3FD-200D-2642-FE0F",
        non_qualified: "1F6B5-1F3FD-200D-2642",
        image: "1f6b5-1f3fd-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6B5-1F3FE-200D-2642-FE0F",
        non_qualified: "1F6B5-1F3FE-200D-2642",
        image: "1f6b5-1f3fe-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6B5-1F3FF-200D-2642-FE0F",
        non_qualified: "1F6B5-1F3FF-200D-2642",
        image: "1f6b5-1f3ff-200d-2642-fe0f.png",
        sheet_x: 35,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    obsoletes: "1F6B5",
    a: "Man Mountain Biking",
    b: "1F6B5-200D-2642-FE0F",
    c: "1F6B5-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      35,
      35
    ],
    o: 4
  },
  "woman-mountain-biking": {
    skin_variations: {
      "1F3FB": {
        unified: "1F6B5-1F3FB-200D-2640-FE0F",
        non_qualified: "1F6B5-1F3FB-200D-2640",
        image: "1f6b5-1f3fb-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6B5-1F3FC-200D-2640-FE0F",
        non_qualified: "1F6B5-1F3FC-200D-2640",
        image: "1f6b5-1f3fc-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6B5-1F3FD-200D-2640-FE0F",
        non_qualified: "1F6B5-1F3FD-200D-2640",
        image: "1f6b5-1f3fd-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 32,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6B5-1F3FE-200D-2640-FE0F",
        non_qualified: "1F6B5-1F3FE-200D-2640",
        image: "1f6b5-1f3fe-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 33,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6B5-1F3FF-200D-2640-FE0F",
        non_qualified: "1F6B5-1F3FF-200D-2640",
        image: "1f6b5-1f3ff-200d-2640-fe0f.png",
        sheet_x: 35,
        sheet_y: 34,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Mountain Biking",
    b: "1F6B5-200D-2640-FE0F",
    c: "1F6B5-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      35,
      29
    ],
    o: 4
  },
  person_doing_cartwheel: {
    skin_variations: {
      "1F3FB": {
        unified: "1F938-1F3FB",
        non_qualified: null,
        image: "1f938-1f3fb.png",
        sheet_x: 40,
        sheet_y: 9,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F938-1F3FC",
        non_qualified: null,
        image: "1f938-1f3fc.png",
        sheet_x: 40,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F938-1F3FD",
        non_qualified: null,
        image: "1f938-1f3fd.png",
        sheet_x: 40,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F938-1F3FE",
        non_qualified: null,
        image: "1f938-1f3fe.png",
        sheet_x: 40,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F938-1F3FF",
        non_qualified: null,
        image: "1f938-1f3ff.png",
        sheet_x: 40,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    a: "Person Doing Cartwheel",
    b: "1F938",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      40,
      8
    ],
    o: 4
  },
  "man-cartwheeling": {
    skin_variations: {
      "1F3FB": {
        unified: "1F938-1F3FB-200D-2642-FE0F",
        non_qualified: "1F938-1F3FB-200D-2642",
        image: "1f938-1f3fb-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 3,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F938-1F3FC-200D-2642-FE0F",
        non_qualified: "1F938-1F3FC-200D-2642",
        image: "1f938-1f3fc-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 4,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F938-1F3FD-200D-2642-FE0F",
        non_qualified: "1F938-1F3FD-200D-2642",
        image: "1f938-1f3fd-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 5,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F938-1F3FE-200D-2642-FE0F",
        non_qualified: "1F938-1F3FE-200D-2642",
        image: "1f938-1f3fe-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 6,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F938-1F3FF-200D-2642-FE0F",
        non_qualified: "1F938-1F3FF-200D-2642",
        image: "1f938-1f3ff-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 7,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Cartwheeling",
    b: "1F938-200D-2642-FE0F",
    c: "1F938-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      2
    ],
    o: 4
  },
  "woman-cartwheeling": {
    skin_variations: {
      "1F3FB": {
        unified: "1F938-1F3FB-200D-2640-FE0F",
        non_qualified: "1F938-1F3FB-200D-2640",
        image: "1f938-1f3fb-200d-2640-fe0f.png",
        sheet_x: 39,
        sheet_y: 54,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F938-1F3FC-200D-2640-FE0F",
        non_qualified: "1F938-1F3FC-200D-2640",
        image: "1f938-1f3fc-200d-2640-fe0f.png",
        sheet_x: 39,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F938-1F3FD-200D-2640-FE0F",
        non_qualified: "1F938-1F3FD-200D-2640",
        image: "1f938-1f3fd-200d-2640-fe0f.png",
        sheet_x: 39,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F938-1F3FE-200D-2640-FE0F",
        non_qualified: "1F938-1F3FE-200D-2640",
        image: "1f938-1f3fe-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F938-1F3FF-200D-2640-FE0F",
        non_qualified: "1F938-1F3FF-200D-2640",
        image: "1f938-1f3ff-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Cartwheeling",
    b: "1F938-200D-2640-FE0F",
    c: "1F938-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      39,
      53
    ],
    o: 4
  },
  wrestlers: {
    a: "Wrestlers",
    b: "1F93C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      35
    ],
    o: 4
  },
  "man-wrestling": {
    a: "Man Wrestling",
    b: "1F93C-200D-2642-FE0F",
    c: "1F93C-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      34
    ],
    o: 4
  },
  "woman-wrestling": {
    a: "Woman Wrestling",
    b: "1F93C-200D-2640-FE0F",
    c: "1F93C-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      33
    ],
    o: 4
  },
  water_polo: {
    skin_variations: {
      "1F3FB": {
        unified: "1F93D-1F3FB",
        non_qualified: null,
        image: "1f93d-1f3fb.png",
        sheet_x: 40,
        sheet_y: 49,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F93D-1F3FC",
        non_qualified: null,
        image: "1f93d-1f3fc.png",
        sheet_x: 40,
        sheet_y: 50,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F93D-1F3FD",
        non_qualified: null,
        image: "1f93d-1f3fd.png",
        sheet_x: 40,
        sheet_y: 51,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F93D-1F3FE",
        non_qualified: null,
        image: "1f93d-1f3fe.png",
        sheet_x: 40,
        sheet_y: 52,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F93D-1F3FF",
        non_qualified: null,
        image: "1f93d-1f3ff.png",
        sheet_x: 40,
        sheet_y: 53,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    a: "Water Polo",
    b: "1F93D",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      40,
      48
    ],
    o: 4
  },
  "man-playing-water-polo": {
    skin_variations: {
      "1F3FB": {
        unified: "1F93D-1F3FB-200D-2642-FE0F",
        non_qualified: "1F93D-1F3FB-200D-2642",
        image: "1f93d-1f3fb-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 43,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F93D-1F3FC-200D-2642-FE0F",
        non_qualified: "1F93D-1F3FC-200D-2642",
        image: "1f93d-1f3fc-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 44,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F93D-1F3FD-200D-2642-FE0F",
        non_qualified: "1F93D-1F3FD-200D-2642",
        image: "1f93d-1f3fd-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 45,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F93D-1F3FE-200D-2642-FE0F",
        non_qualified: "1F93D-1F3FE-200D-2642",
        image: "1f93d-1f3fe-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 46,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F93D-1F3FF-200D-2642-FE0F",
        non_qualified: "1F93D-1F3FF-200D-2642",
        image: "1f93d-1f3ff-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 47,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Playing Water Polo",
    b: "1F93D-200D-2642-FE0F",
    c: "1F93D-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      42
    ],
    o: 4
  },
  "woman-playing-water-polo": {
    skin_variations: {
      "1F3FB": {
        unified: "1F93D-1F3FB-200D-2640-FE0F",
        non_qualified: "1F93D-1F3FB-200D-2640",
        image: "1f93d-1f3fb-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 37,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F93D-1F3FC-200D-2640-FE0F",
        non_qualified: "1F93D-1F3FC-200D-2640",
        image: "1f93d-1f3fc-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 38,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F93D-1F3FD-200D-2640-FE0F",
        non_qualified: "1F93D-1F3FD-200D-2640",
        image: "1f93d-1f3fd-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 39,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F93D-1F3FE-200D-2640-FE0F",
        non_qualified: "1F93D-1F3FE-200D-2640",
        image: "1f93d-1f3fe-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 40,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F93D-1F3FF-200D-2640-FE0F",
        non_qualified: "1F93D-1F3FF-200D-2640",
        image: "1f93d-1f3ff-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 41,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Playing Water Polo",
    b: "1F93D-200D-2640-FE0F",
    c: "1F93D-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      36
    ],
    o: 4
  },
  handball: {
    skin_variations: {
      "1F3FB": {
        unified: "1F93E-1F3FB",
        non_qualified: null,
        image: "1f93e-1f3fb.png",
        sheet_x: 41,
        sheet_y: 10,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC": {
        unified: "1F93E-1F3FC",
        non_qualified: null,
        image: "1f93e-1f3fc.png",
        sheet_x: 41,
        sheet_y: 11,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD": {
        unified: "1F93E-1F3FD",
        non_qualified: null,
        image: "1f93e-1f3fd.png",
        sheet_x: 41,
        sheet_y: 12,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE": {
        unified: "1F93E-1F3FE",
        non_qualified: null,
        image: "1f93e-1f3fe.png",
        sheet_x: 41,
        sheet_y: 13,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF": {
        unified: "1F93E-1F3FF",
        non_qualified: null,
        image: "1f93e-1f3ff.png",
        sheet_x: 41,
        sheet_y: 14,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !1
      }
    },
    a: "Handball",
    b: "1F93E",
    d: !0,
    e: !0,
    f: !0,
    h: !1,
    k: [
      41,
      9
    ],
    o: 4
  },
  "man-playing-handball": {
    skin_variations: {
      "1F3FB": {
        unified: "1F93E-1F3FB-200D-2642-FE0F",
        non_qualified: "1F93E-1F3FB-200D-2642",
        image: "1f93e-1f3fb-200d-2642-fe0f.png",
        sheet_x: 41,
        sheet_y: 4,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F93E-1F3FC-200D-2642-FE0F",
        non_qualified: "1F93E-1F3FC-200D-2642",
        image: "1f93e-1f3fc-200d-2642-fe0f.png",
        sheet_x: 41,
        sheet_y: 5,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F93E-1F3FD-200D-2642-FE0F",
        non_qualified: "1F93E-1F3FD-200D-2642",
        image: "1f93e-1f3fd-200d-2642-fe0f.png",
        sheet_x: 41,
        sheet_y: 6,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F93E-1F3FE-200D-2642-FE0F",
        non_qualified: "1F93E-1F3FE-200D-2642",
        image: "1f93e-1f3fe-200d-2642-fe0f.png",
        sheet_x: 41,
        sheet_y: 7,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F93E-1F3FF-200D-2642-FE0F",
        non_qualified: "1F93E-1F3FF-200D-2642",
        image: "1f93e-1f3ff-200d-2642-fe0f.png",
        sheet_x: 41,
        sheet_y: 8,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Playing Handball",
    b: "1F93E-200D-2642-FE0F",
    c: "1F93E-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      41,
      3
    ],
    o: 4
  },
  "woman-playing-handball": {
    skin_variations: {
      "1F3FB": {
        unified: "1F93E-1F3FB-200D-2640-FE0F",
        non_qualified: "1F93E-1F3FB-200D-2640",
        image: "1f93e-1f3fb-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 55,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F93E-1F3FC-200D-2640-FE0F",
        non_qualified: "1F93E-1F3FC-200D-2640",
        image: "1f93e-1f3fc-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 56,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F93E-1F3FD-200D-2640-FE0F",
        non_qualified: "1F93E-1F3FD-200D-2640",
        image: "1f93e-1f3fd-200d-2640-fe0f.png",
        sheet_x: 41,
        sheet_y: 0,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F93E-1F3FE-200D-2640-FE0F",
        non_qualified: "1F93E-1F3FE-200D-2640",
        image: "1f93e-1f3fe-200d-2640-fe0f.png",
        sheet_x: 41,
        sheet_y: 1,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F93E-1F3FF-200D-2640-FE0F",
        non_qualified: "1F93E-1F3FF-200D-2640",
        image: "1f93e-1f3ff-200d-2640-fe0f.png",
        sheet_x: 41,
        sheet_y: 2,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Playing Handball",
    b: "1F93E-200D-2640-FE0F",
    c: "1F93E-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      54
    ],
    o: 4
  },
  juggling: {
    skin_variations: {
      "1F3FB": {
        unified: "1F939-1F3FB",
        non_qualified: null,
        image: "1f939-1f3fb.png",
        sheet_x: 40,
        sheet_y: 27,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F939-1F3FC",
        non_qualified: null,
        image: "1f939-1f3fc.png",
        sheet_x: 40,
        sheet_y: 28,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F939-1F3FD",
        non_qualified: null,
        image: "1f939-1f3fd.png",
        sheet_x: 40,
        sheet_y: 29,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F939-1F3FE",
        non_qualified: null,
        image: "1f939-1f3fe.png",
        sheet_x: 40,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F939-1F3FF",
        non_qualified: null,
        image: "1f939-1f3ff.png",
        sheet_x: 40,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Juggling",
    b: "1F939",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      26
    ],
    o: 4
  },
  "man-juggling": {
    skin_variations: {
      "1F3FB": {
        unified: "1F939-1F3FB-200D-2642-FE0F",
        non_qualified: "1F939-1F3FB-200D-2642",
        image: "1f939-1f3fb-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 21,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F939-1F3FC-200D-2642-FE0F",
        non_qualified: "1F939-1F3FC-200D-2642",
        image: "1f939-1f3fc-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 22,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F939-1F3FD-200D-2642-FE0F",
        non_qualified: "1F939-1F3FD-200D-2642",
        image: "1f939-1f3fd-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 23,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F939-1F3FE-200D-2642-FE0F",
        non_qualified: "1F939-1F3FE-200D-2642",
        image: "1f939-1f3fe-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 24,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F939-1F3FF-200D-2642-FE0F",
        non_qualified: "1F939-1F3FF-200D-2642",
        image: "1f939-1f3ff-200d-2642-fe0f.png",
        sheet_x: 40,
        sheet_y: 25,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man Juggling",
    b: "1F939-200D-2642-FE0F",
    c: "1F939-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      20
    ],
    o: 4
  },
  "woman-juggling": {
    skin_variations: {
      "1F3FB": {
        unified: "1F939-1F3FB-200D-2640-FE0F",
        non_qualified: "1F939-1F3FB-200D-2640",
        image: "1f939-1f3fb-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 15,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F939-1F3FC-200D-2640-FE0F",
        non_qualified: "1F939-1F3FC-200D-2640",
        image: "1f939-1f3fc-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 16,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F939-1F3FD-200D-2640-FE0F",
        non_qualified: "1F939-1F3FD-200D-2640",
        image: "1f939-1f3fd-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 17,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F939-1F3FE-200D-2640-FE0F",
        non_qualified: "1F939-1F3FE-200D-2640",
        image: "1f939-1f3fe-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 18,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F939-1F3FF-200D-2640-FE0F",
        non_qualified: "1F939-1F3FF-200D-2640",
        image: "1f939-1f3ff-200d-2640-fe0f.png",
        sheet_x: 40,
        sheet_y: 19,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Woman Juggling",
    b: "1F939-200D-2640-FE0F",
    c: "1F939-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      40,
      14
    ],
    o: 4
  },
  person_in_lotus_position: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D8-1F3FB",
        non_qualified: null,
        image: "1f9d8-1f3fb.png",
        sheet_x: 49,
        sheet_y: 32,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D8-1F3FB-200D-2640-FE0F"
      },
      "1F3FC": {
        unified: "1F9D8-1F3FC",
        non_qualified: null,
        image: "1f9d8-1f3fc.png",
        sheet_x: 49,
        sheet_y: 33,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D8-1F3FC-200D-2640-FE0F"
      },
      "1F3FD": {
        unified: "1F9D8-1F3FD",
        non_qualified: null,
        image: "1f9d8-1f3fd.png",
        sheet_x: 49,
        sheet_y: 34,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D8-1F3FD-200D-2640-FE0F"
      },
      "1F3FE": {
        unified: "1F9D8-1F3FE",
        non_qualified: null,
        image: "1f9d8-1f3fe.png",
        sheet_x: 49,
        sheet_y: 35,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D8-1F3FE-200D-2640-FE0F"
      },
      "1F3FF": {
        unified: "1F9D8-1F3FF",
        non_qualified: null,
        image: "1f9d8-1f3ff.png",
        sheet_x: 49,
        sheet_y: 36,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoleted_by: "1F9D8-1F3FF-200D-2640-FE0F"
      }
    },
    obsoleted_by: "1F9D8-200D-2640-FE0F",
    a: "Person in Lotus Position",
    b: "1F9D8",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      31
    ],
    o: 5
  },
  man_in_lotus_position: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D8-1F3FB-200D-2642-FE0F",
        non_qualified: "1F9D8-1F3FB-200D-2642",
        image: "1f9d8-1f3fb-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 26,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F9D8-1F3FC-200D-2642-FE0F",
        non_qualified: "1F9D8-1F3FC-200D-2642",
        image: "1f9d8-1f3fc-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 27,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F9D8-1F3FD-200D-2642-FE0F",
        non_qualified: "1F9D8-1F3FD-200D-2642",
        image: "1f9d8-1f3fd-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 28,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F9D8-1F3FE-200D-2642-FE0F",
        non_qualified: "1F9D8-1F3FE-200D-2642",
        image: "1f9d8-1f3fe-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 29,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F9D8-1F3FF-200D-2642-FE0F",
        non_qualified: "1F9D8-1F3FF-200D-2642",
        image: "1f9d8-1f3ff-200d-2642-fe0f.png",
        sheet_x: 49,
        sheet_y: 30,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man in Lotus Position",
    b: "1F9D8-200D-2642-FE0F",
    c: "1F9D8-200D-2642",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      25
    ],
    o: 5
  },
  woman_in_lotus_position: {
    skin_variations: {
      "1F3FB": {
        unified: "1F9D8-1F3FB-200D-2640-FE0F",
        non_qualified: "1F9D8-1F3FB-200D-2640",
        image: "1f9d8-1f3fb-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 20,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D8-1F3FB"
      },
      "1F3FC": {
        unified: "1F9D8-1F3FC-200D-2640-FE0F",
        non_qualified: "1F9D8-1F3FC-200D-2640",
        image: "1f9d8-1f3fc-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 21,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D8-1F3FC"
      },
      "1F3FD": {
        unified: "1F9D8-1F3FD-200D-2640-FE0F",
        non_qualified: "1F9D8-1F3FD-200D-2640",
        image: "1f9d8-1f3fd-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 22,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D8-1F3FD"
      },
      "1F3FE": {
        unified: "1F9D8-1F3FE-200D-2640-FE0F",
        non_qualified: "1F9D8-1F3FE-200D-2640",
        image: "1f9d8-1f3fe-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 23,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D8-1F3FE"
      },
      "1F3FF": {
        unified: "1F9D8-1F3FF-200D-2640-FE0F",
        non_qualified: "1F9D8-1F3FF-200D-2640",
        image: "1f9d8-1f3ff-200d-2640-fe0f.png",
        sheet_x: 49,
        sheet_y: 24,
        added_in: "5.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0,
        obsoletes: "1F9D8-1F3FF"
      }
    },
    obsoletes: "1F9D8",
    a: "Woman in Lotus Position",
    b: "1F9D8-200D-2640-FE0F",
    c: "1F9D8-200D-2640",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      49,
      19
    ],
    o: 5
  },
  bath: {
    skin_variations: {
      "1F3FB": {
        unified: "1F6C0-1F3FB",
        non_qualified: null,
        image: "1f6c0-1f3fb.png",
        sheet_x: 36,
        sheet_y: 18,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6C0-1F3FC",
        non_qualified: null,
        image: "1f6c0-1f3fc.png",
        sheet_x: 36,
        sheet_y: 19,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6C0-1F3FD",
        non_qualified: null,
        image: "1f6c0-1f3fd.png",
        sheet_x: 36,
        sheet_y: 20,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6C0-1F3FE",
        non_qualified: null,
        image: "1f6c0-1f3fe.png",
        sheet_x: 36,
        sheet_y: 21,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6C0-1F3FF",
        non_qualified: null,
        image: "1f6c0-1f3ff.png",
        sheet_x: 36,
        sheet_y: 22,
        added_in: "2.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Bath",
    b: "1F6C0",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "clean",
      "shower",
      "bathroom"
    ],
    k: [
      36,
      17
    ],
    o: 2
  },
  sleeping_accommodation: {
    skin_variations: {
      "1F3FB": {
        unified: "1F6CC-1F3FB",
        non_qualified: null,
        image: "1f6cc-1f3fb.png",
        sheet_x: 36,
        sheet_y: 30,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F6CC-1F3FC",
        non_qualified: null,
        image: "1f6cc-1f3fc.png",
        sheet_x: 36,
        sheet_y: 31,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F6CC-1F3FD",
        non_qualified: null,
        image: "1f6cc-1f3fd.png",
        sheet_x: 36,
        sheet_y: 32,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F6CC-1F3FE",
        non_qualified: null,
        image: "1f6cc-1f3fe.png",
        sheet_x: 36,
        sheet_y: 33,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F6CC-1F3FF",
        non_qualified: null,
        image: "1f6cc-1f3ff.png",
        sheet_x: 36,
        sheet_y: 34,
        added_in: "4.0",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Sleeping Accommodation",
    b: "1F6CC",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      36,
      29
    ],
    o: 2
  },
  people_holding_hands: {
    skin_variations: {
      "1F3FB-1F3FB": {
        unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FB",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb.png",
        sheet_x: 46,
        sheet_y: 39,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FB-1F3FC": {
        unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FC",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc.png",
        sheet_x: 46,
        sheet_y: 40,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FB-1F3FD": {
        unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FD",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd.png",
        sheet_x: 46,
        sheet_y: 41,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FB-1F3FE": {
        unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FE",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe.png",
        sheet_x: 46,
        sheet_y: 42,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FB-1F3FF": {
        unified: "1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FF",
        non_qualified: null,
        image: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff.png",
        sheet_x: 46,
        sheet_y: 43,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC-1F3FB": {
        unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FB",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb.png",
        sheet_x: 46,
        sheet_y: 44,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC-1F3FC": {
        unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FC",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc.png",
        sheet_x: 46,
        sheet_y: 45,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC-1F3FD": {
        unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FD",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd.png",
        sheet_x: 46,
        sheet_y: 46,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC-1F3FE": {
        unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FE",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe.png",
        sheet_x: 46,
        sheet_y: 47,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC-1F3FF": {
        unified: "1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FF",
        non_qualified: null,
        image: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff.png",
        sheet_x: 46,
        sheet_y: 48,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD-1F3FB": {
        unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FB",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb.png",
        sheet_x: 46,
        sheet_y: 49,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FC": {
        unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FC",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc.png",
        sheet_x: 46,
        sheet_y: 50,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FD": {
        unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FD",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd.png",
        sheet_x: 46,
        sheet_y: 51,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FE": {
        unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FE",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe.png",
        sheet_x: 46,
        sheet_y: 52,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD-1F3FF": {
        unified: "1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FF",
        non_qualified: null,
        image: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff.png",
        sheet_x: 46,
        sheet_y: 53,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE-1F3FB": {
        unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FB",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb.png",
        sheet_x: 46,
        sheet_y: 54,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FC": {
        unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FC",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc.png",
        sheet_x: 46,
        sheet_y: 55,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FD": {
        unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FD",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd.png",
        sheet_x: 46,
        sheet_y: 56,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FE": {
        unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FE",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe.png",
        sheet_x: 47,
        sheet_y: 0,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FF": {
        unified: "1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FF",
        non_qualified: null,
        image: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff.png",
        sheet_x: 47,
        sheet_y: 1,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF-1F3FB": {
        unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FB",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb.png",
        sheet_x: 47,
        sheet_y: 2,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FC": {
        unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FC",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc.png",
        sheet_x: 47,
        sheet_y: 3,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FD": {
        unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FD",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd.png",
        sheet_x: 47,
        sheet_y: 4,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FE": {
        unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FE",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe.png",
        sheet_x: 47,
        sheet_y: 5,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FF": {
        unified: "1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FF",
        non_qualified: null,
        image: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff.png",
        sheet_x: 47,
        sheet_y: 6,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "People Holding Hands",
    b: "1F9D1-200D-1F91D-200D-1F9D1",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      46,
      38
    ],
    o: 12
  },
  two_women_holding_hands: {
    skin_variations: {
      "1F3FB": {
        unified: "1F46D-1F3FB",
        non_qualified: null,
        image: "1f46d-1f3fb.png",
        sheet_x: 21,
        sheet_y: 12,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F46D-1F3FC",
        non_qualified: null,
        image: "1f46d-1f3fc.png",
        sheet_x: 21,
        sheet_y: 13,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F46D-1F3FD",
        non_qualified: null,
        image: "1f46d-1f3fd.png",
        sheet_x: 21,
        sheet_y: 14,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F46D-1F3FE",
        non_qualified: null,
        image: "1f46d-1f3fe.png",
        sheet_x: 21,
        sheet_y: 15,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F46D-1F3FF",
        non_qualified: null,
        image: "1f46d-1f3ff.png",
        sheet_x: 21,
        sheet_y: 16,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FB-1F3FC": {
        unified: "1F469-1F3FB-200D-1F91D-200D-1F469-1F3FC",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc.png",
        sheet_x: 21,
        sheet_y: 17,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FB-1F3FD": {
        unified: "1F469-1F3FB-200D-1F91D-200D-1F469-1F3FD",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd.png",
        sheet_x: 21,
        sheet_y: 18,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FB-1F3FE": {
        unified: "1F469-1F3FB-200D-1F91D-200D-1F469-1F3FE",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe.png",
        sheet_x: 21,
        sheet_y: 19,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FB-1F3FF": {
        unified: "1F469-1F3FB-200D-1F91D-200D-1F469-1F3FF",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff.png",
        sheet_x: 21,
        sheet_y: 20,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC-1F3FB": {
        unified: "1F469-1F3FC-200D-1F91D-200D-1F469-1F3FB",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb.png",
        sheet_x: 21,
        sheet_y: 21,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC-1F3FD": {
        unified: "1F469-1F3FC-200D-1F91D-200D-1F469-1F3FD",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd.png",
        sheet_x: 21,
        sheet_y: 22,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC-1F3FE": {
        unified: "1F469-1F3FC-200D-1F91D-200D-1F469-1F3FE",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe.png",
        sheet_x: 21,
        sheet_y: 23,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC-1F3FF": {
        unified: "1F469-1F3FC-200D-1F91D-200D-1F469-1F3FF",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff.png",
        sheet_x: 21,
        sheet_y: 24,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD-1F3FB": {
        unified: "1F469-1F3FD-200D-1F91D-200D-1F469-1F3FB",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb.png",
        sheet_x: 21,
        sheet_y: 25,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FC": {
        unified: "1F469-1F3FD-200D-1F91D-200D-1F469-1F3FC",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc.png",
        sheet_x: 21,
        sheet_y: 26,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FE": {
        unified: "1F469-1F3FD-200D-1F91D-200D-1F469-1F3FE",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe.png",
        sheet_x: 21,
        sheet_y: 27,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD-1F3FF": {
        unified: "1F469-1F3FD-200D-1F91D-200D-1F469-1F3FF",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff.png",
        sheet_x: 21,
        sheet_y: 28,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE-1F3FB": {
        unified: "1F469-1F3FE-200D-1F91D-200D-1F469-1F3FB",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb.png",
        sheet_x: 21,
        sheet_y: 29,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FC": {
        unified: "1F469-1F3FE-200D-1F91D-200D-1F469-1F3FC",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc.png",
        sheet_x: 21,
        sheet_y: 30,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FD": {
        unified: "1F469-1F3FE-200D-1F91D-200D-1F469-1F3FD",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd.png",
        sheet_x: 21,
        sheet_y: 31,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FF": {
        unified: "1F469-1F3FE-200D-1F91D-200D-1F469-1F3FF",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff.png",
        sheet_x: 21,
        sheet_y: 32,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF-1F3FB": {
        unified: "1F469-1F3FF-200D-1F91D-200D-1F469-1F3FB",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb.png",
        sheet_x: 21,
        sheet_y: 33,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FC": {
        unified: "1F469-1F3FF-200D-1F91D-200D-1F469-1F3FC",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc.png",
        sheet_x: 21,
        sheet_y: 34,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FD": {
        unified: "1F469-1F3FF-200D-1F91D-200D-1F469-1F3FD",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd.png",
        sheet_x: 21,
        sheet_y: 35,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FE": {
        unified: "1F469-1F3FF-200D-1F91D-200D-1F469-1F3FE",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe.png",
        sheet_x: 21,
        sheet_y: 36,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Two Women Holding Hands",
    b: "1F46D",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "pair",
      "friendship",
      "couple",
      "love",
      "like",
      "female",
      "people",
      "human"
    ],
    k: [
      21,
      11
    ],
    n: [
      "women_holding_hands"
    ],
    o: 2
  },
  couple: {
    skin_variations: {
      "1F3FB": {
        unified: "1F46B-1F3FB",
        non_qualified: null,
        image: "1f46b-1f3fb.png",
        sheet_x: 20,
        sheet_y: 17,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F46B-1F3FC",
        non_qualified: null,
        image: "1f46b-1f3fc.png",
        sheet_x: 20,
        sheet_y: 18,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F46B-1F3FD",
        non_qualified: null,
        image: "1f46b-1f3fd.png",
        sheet_x: 20,
        sheet_y: 19,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F46B-1F3FE",
        non_qualified: null,
        image: "1f46b-1f3fe.png",
        sheet_x: 20,
        sheet_y: 20,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F46B-1F3FF",
        non_qualified: null,
        image: "1f46b-1f3ff.png",
        sheet_x: 20,
        sheet_y: 21,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FB-1F3FC": {
        unified: "1F469-1F3FB-200D-1F91D-200D-1F468-1F3FC",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc.png",
        sheet_x: 20,
        sheet_y: 22,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FB-1F3FD": {
        unified: "1F469-1F3FB-200D-1F91D-200D-1F468-1F3FD",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd.png",
        sheet_x: 20,
        sheet_y: 23,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FB-1F3FE": {
        unified: "1F469-1F3FB-200D-1F91D-200D-1F468-1F3FE",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe.png",
        sheet_x: 20,
        sheet_y: 24,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FB-1F3FF": {
        unified: "1F469-1F3FB-200D-1F91D-200D-1F468-1F3FF",
        non_qualified: null,
        image: "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff.png",
        sheet_x: 20,
        sheet_y: 25,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC-1F3FB": {
        unified: "1F469-1F3FC-200D-1F91D-200D-1F468-1F3FB",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb.png",
        sheet_x: 20,
        sheet_y: 26,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC-1F3FD": {
        unified: "1F469-1F3FC-200D-1F91D-200D-1F468-1F3FD",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd.png",
        sheet_x: 20,
        sheet_y: 27,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC-1F3FE": {
        unified: "1F469-1F3FC-200D-1F91D-200D-1F468-1F3FE",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe.png",
        sheet_x: 20,
        sheet_y: 28,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC-1F3FF": {
        unified: "1F469-1F3FC-200D-1F91D-200D-1F468-1F3FF",
        non_qualified: null,
        image: "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff.png",
        sheet_x: 20,
        sheet_y: 29,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FB": {
        unified: "1F469-1F3FD-200D-1F91D-200D-1F468-1F3FB",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb.png",
        sheet_x: 20,
        sheet_y: 30,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FC": {
        unified: "1F469-1F3FD-200D-1F91D-200D-1F468-1F3FC",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc.png",
        sheet_x: 20,
        sheet_y: 31,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FE": {
        unified: "1F469-1F3FD-200D-1F91D-200D-1F468-1F3FE",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe.png",
        sheet_x: 20,
        sheet_y: 32,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FF": {
        unified: "1F469-1F3FD-200D-1F91D-200D-1F468-1F3FF",
        non_qualified: null,
        image: "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff.png",
        sheet_x: 20,
        sheet_y: 33,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FB": {
        unified: "1F469-1F3FE-200D-1F91D-200D-1F468-1F3FB",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb.png",
        sheet_x: 20,
        sheet_y: 34,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FC": {
        unified: "1F469-1F3FE-200D-1F91D-200D-1F468-1F3FC",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc.png",
        sheet_x: 20,
        sheet_y: 35,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FD": {
        unified: "1F469-1F3FE-200D-1F91D-200D-1F468-1F3FD",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd.png",
        sheet_x: 20,
        sheet_y: 36,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FF": {
        unified: "1F469-1F3FE-200D-1F91D-200D-1F468-1F3FF",
        non_qualified: null,
        image: "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff.png",
        sheet_x: 20,
        sheet_y: 37,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FB": {
        unified: "1F469-1F3FF-200D-1F91D-200D-1F468-1F3FB",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb.png",
        sheet_x: 20,
        sheet_y: 38,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FC": {
        unified: "1F469-1F3FF-200D-1F91D-200D-1F468-1F3FC",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc.png",
        sheet_x: 20,
        sheet_y: 39,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FD": {
        unified: "1F469-1F3FF-200D-1F91D-200D-1F468-1F3FD",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd.png",
        sheet_x: 20,
        sheet_y: 40,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FE": {
        unified: "1F469-1F3FF-200D-1F91D-200D-1F468-1F3FE",
        non_qualified: null,
        image: "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe.png",
        sheet_x: 20,
        sheet_y: 41,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Man and Woman Holding Hands",
    b: "1F46B",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "pair",
      "people",
      "human",
      "love",
      "date",
      "dating",
      "like",
      "affection",
      "valentines",
      "marriage"
    ],
    k: [
      20,
      16
    ],
    n: [
      "man_and_woman_holding_hands",
      "woman_and_man_holding_hands"
    ],
    o: 2
  },
  two_men_holding_hands: {
    skin_variations: {
      "1F3FB": {
        unified: "1F46C-1F3FB",
        non_qualified: null,
        image: "1f46c-1f3fb.png",
        sheet_x: 20,
        sheet_y: 43,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC": {
        unified: "1F46C-1F3FC",
        non_qualified: null,
        image: "1f46c-1f3fc.png",
        sheet_x: 20,
        sheet_y: 44,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD": {
        unified: "1F46C-1F3FD",
        non_qualified: null,
        image: "1f46c-1f3fd.png",
        sheet_x: 20,
        sheet_y: 45,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE": {
        unified: "1F46C-1F3FE",
        non_qualified: null,
        image: "1f46c-1f3fe.png",
        sheet_x: 20,
        sheet_y: 46,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF": {
        unified: "1F46C-1F3FF",
        non_qualified: null,
        image: "1f46c-1f3ff.png",
        sheet_x: 20,
        sheet_y: 47,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FB-1F3FC": {
        unified: "1F468-1F3FB-200D-1F91D-200D-1F468-1F3FC",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc.png",
        sheet_x: 20,
        sheet_y: 48,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FB-1F3FD": {
        unified: "1F468-1F3FB-200D-1F91D-200D-1F468-1F3FD",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd.png",
        sheet_x: 20,
        sheet_y: 49,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FB-1F3FE": {
        unified: "1F468-1F3FB-200D-1F91D-200D-1F468-1F3FE",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe.png",
        sheet_x: 20,
        sheet_y: 50,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FB-1F3FF": {
        unified: "1F468-1F3FB-200D-1F91D-200D-1F468-1F3FF",
        non_qualified: null,
        image: "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff.png",
        sheet_x: 20,
        sheet_y: 51,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC-1F3FB": {
        unified: "1F468-1F3FC-200D-1F91D-200D-1F468-1F3FB",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb.png",
        sheet_x: 20,
        sheet_y: 52,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FC-1F3FD": {
        unified: "1F468-1F3FC-200D-1F91D-200D-1F468-1F3FD",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd.png",
        sheet_x: 20,
        sheet_y: 53,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC-1F3FE": {
        unified: "1F468-1F3FC-200D-1F91D-200D-1F468-1F3FE",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe.png",
        sheet_x: 20,
        sheet_y: 54,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FC-1F3FF": {
        unified: "1F468-1F3FC-200D-1F91D-200D-1F468-1F3FF",
        non_qualified: null,
        image: "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff.png",
        sheet_x: 20,
        sheet_y: 55,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD-1F3FB": {
        unified: "1F468-1F3FD-200D-1F91D-200D-1F468-1F3FB",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb.png",
        sheet_x: 20,
        sheet_y: 56,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FC": {
        unified: "1F468-1F3FD-200D-1F91D-200D-1F468-1F3FC",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc.png",
        sheet_x: 21,
        sheet_y: 0,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FD-1F3FE": {
        unified: "1F468-1F3FD-200D-1F91D-200D-1F468-1F3FE",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe.png",
        sheet_x: 21,
        sheet_y: 1,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FD-1F3FF": {
        unified: "1F468-1F3FD-200D-1F91D-200D-1F468-1F3FF",
        non_qualified: null,
        image: "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff.png",
        sheet_x: 21,
        sheet_y: 2,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FE-1F3FB": {
        unified: "1F468-1F3FE-200D-1F91D-200D-1F468-1F3FB",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb.png",
        sheet_x: 21,
        sheet_y: 3,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FC": {
        unified: "1F468-1F3FE-200D-1F91D-200D-1F468-1F3FC",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc.png",
        sheet_x: 21,
        sheet_y: 4,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FD": {
        unified: "1F468-1F3FE-200D-1F91D-200D-1F468-1F3FD",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd.png",
        sheet_x: 21,
        sheet_y: 5,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FE-1F3FF": {
        unified: "1F468-1F3FE-200D-1F91D-200D-1F468-1F3FF",
        non_qualified: null,
        image: "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff.png",
        sheet_x: 21,
        sheet_y: 6,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !1,
        has_img_twitter: !0,
        has_img_facebook: !1
      },
      "1F3FF-1F3FB": {
        unified: "1F468-1F3FF-200D-1F91D-200D-1F468-1F3FB",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb.png",
        sheet_x: 21,
        sheet_y: 7,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FC": {
        unified: "1F468-1F3FF-200D-1F91D-200D-1F468-1F3FC",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc.png",
        sheet_x: 21,
        sheet_y: 8,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FD": {
        unified: "1F468-1F3FF-200D-1F91D-200D-1F468-1F3FD",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd.png",
        sheet_x: 21,
        sheet_y: 9,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      },
      "1F3FF-1F3FE": {
        unified: "1F468-1F3FF-200D-1F91D-200D-1F468-1F3FE",
        non_qualified: null,
        image: "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe.png",
        sheet_x: 21,
        sheet_y: 10,
        added_in: "12.1",
        has_img_apple: !0,
        has_img_google: !0,
        has_img_twitter: !0,
        has_img_facebook: !0
      }
    },
    a: "Two Men Holding Hands",
    b: "1F46C",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "pair",
      "couple",
      "love",
      "like",
      "bromance",
      "friendship",
      "people",
      "human"
    ],
    k: [
      20,
      42
    ],
    n: [
      "men_holding_hands"
    ],
    o: 2
  },
  couplekiss: {
    obsoleted_by: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",
    a: "Kiss",
    b: "1F48F",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      25,
      25
    ],
    o: 2
  },
  "woman-kiss-man": {
    obsoletes: "1F48F",
    a: "Woman Kiss Man",
    b: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",
    c: "1F469-200D-2764-200D-1F48B-200D-1F468",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      20,
      7
    ],
    o: 2
  },
  "man-kiss-man": {
    a: "Man Kiss Man",
    b: "1F468-200D-2764-FE0F-200D-1F48B-200D-1F468",
    c: "1F468-200D-2764-200D-1F48B-200D-1F468",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      21
    ],
    o: 2
  },
  "woman-kiss-woman": {
    a: "Woman Kiss Woman",
    b: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F469",
    c: "1F469-200D-2764-200D-1F48B-200D-1F469",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      20,
      8
    ],
    o: 2
  },
  couple_with_heart: {
    obsoleted_by: "1F469-200D-2764-FE0F-200D-1F468",
    a: "Couple with Heart",
    b: "1F491",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      25,
      27
    ],
    o: 2
  },
  "woman-heart-man": {
    obsoletes: "1F491",
    a: "Woman Heart Man",
    b: "1F469-200D-2764-FE0F-200D-1F468",
    c: "1F469-200D-2764-200D-1F468",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      20,
      5
    ],
    o: 2
  },
  "man-heart-man": {
    a: "Man Heart Man",
    b: "1F468-200D-2764-FE0F-200D-1F468",
    c: "1F468-200D-2764-200D-1F468",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      17,
      20
    ],
    o: 2
  },
  "woman-heart-woman": {
    a: "Woman Heart Woman",
    b: "1F469-200D-2764-FE0F-200D-1F469",
    c: "1F469-200D-2764-200D-1F469",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      20,
      6
    ],
    o: 2
  },
  family: {
    obsoleted_by: "1F468-200D-1F469-200D-1F466",
    a: "Family",
    b: "1F46A",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      20,
      15
    ],
    n: [
      "man-woman-boy"
    ],
    o: 2
  },
  "man-woman-boy": {
    obsoletes: "1F46A",
    a: "Man Woman Boy",
    b: "1F468-200D-1F469-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      33
    ],
    n: [
      "family"
    ],
    o: 2
  },
  "man-woman-girl": {
    a: "Man Woman Girl",
    b: "1F468-200D-1F469-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      35
    ],
    o: 2
  },
  "man-woman-girl-boy": {
    a: "Man Woman Girl Boy",
    b: "1F468-200D-1F469-200D-1F467-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      36
    ],
    o: 2
  },
  "man-woman-boy-boy": {
    a: "Man Woman Boy Boy",
    b: "1F468-200D-1F469-200D-1F466-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      34
    ],
    o: 2
  },
  "man-woman-girl-girl": {
    a: "Man Woman Girl Girl",
    b: "1F468-200D-1F469-200D-1F467-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      37
    ],
    o: 2
  },
  "man-man-boy": {
    a: "Man Man Boy",
    b: "1F468-200D-1F468-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      28
    ],
    o: 2
  },
  "man-man-girl": {
    a: "Man Man Girl",
    b: "1F468-200D-1F468-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      30
    ],
    o: 2
  },
  "man-man-girl-boy": {
    a: "Man Man Girl Boy",
    b: "1F468-200D-1F468-200D-1F467-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      31
    ],
    o: 2
  },
  "man-man-boy-boy": {
    a: "Man Man Boy Boy",
    b: "1F468-200D-1F468-200D-1F466-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      29
    ],
    o: 2
  },
  "man-man-girl-girl": {
    a: "Man Man Girl Girl",
    b: "1F468-200D-1F468-200D-1F467-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      32
    ],
    o: 2
  },
  "woman-woman-boy": {
    a: "Woman Woman Boy",
    b: "1F469-200D-1F469-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      18
    ],
    o: 2
  },
  "woman-woman-girl": {
    a: "Woman Woman Girl",
    b: "1F469-200D-1F469-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      20
    ],
    o: 2
  },
  "woman-woman-girl-boy": {
    a: "Woman Woman Girl Boy",
    b: "1F469-200D-1F469-200D-1F467-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      21
    ],
    o: 2
  },
  "woman-woman-boy-boy": {
    a: "Woman Woman Boy Boy",
    b: "1F469-200D-1F469-200D-1F466-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      19
    ],
    o: 2
  },
  "woman-woman-girl-girl": {
    a: "Woman Woman Girl Girl",
    b: "1F469-200D-1F469-200D-1F467-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      22
    ],
    o: 2
  },
  "man-boy": {
    a: "Man Boy",
    b: "1F468-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      24
    ],
    o: 4
  },
  "man-boy-boy": {
    a: "Man Boy Boy",
    b: "1F468-200D-1F466-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      23
    ],
    o: 4
  },
  "man-girl": {
    a: "Man Girl",
    b: "1F468-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      27
    ],
    o: 4
  },
  "man-girl-boy": {
    a: "Man Girl Boy",
    b: "1F468-200D-1F467-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      25
    ],
    o: 4
  },
  "man-girl-girl": {
    a: "Man Girl Girl",
    b: "1F468-200D-1F467-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      15,
      26
    ],
    o: 4
  },
  "woman-boy": {
    a: "Woman Boy",
    b: "1F469-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      14
    ],
    o: 4
  },
  "woman-boy-boy": {
    a: "Woman Boy Boy",
    b: "1F469-200D-1F466-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      13
    ],
    o: 4
  },
  "woman-girl": {
    a: "Woman Girl",
    b: "1F469-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      17
    ],
    o: 4
  },
  "woman-girl-boy": {
    a: "Woman Girl Boy",
    b: "1F469-200D-1F467-200D-1F466",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      15
    ],
    o: 4
  },
  "woman-girl-girl": {
    a: "Woman Girl Girl",
    b: "1F469-200D-1F467-200D-1F467",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      18,
      16
    ],
    o: 4
  },
  speaking_head_in_silhouette: {
    a: "Speaking Head in Silhouette",
    b: "1F5E3-FE0F",
    c: "1F5E3",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    k: [
      30,
      25
    ],
    o: 2
  },
  bust_in_silhouette: {
    a: "Bust in Silhouette",
    b: "1F464",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "user",
      "person",
      "human"
    ],
    k: [
      14,
      24
    ],
    o: 2
  },
  busts_in_silhouette: {
    a: "Busts in Silhouette",
    b: "1F465",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "user",
      "person",
      "human",
      "group",
      "team"
    ],
    k: [
      14,
      25
    ],
    o: 2
  },
  footprints: {
    a: "Footprints",
    b: "1F463",
    d: !0,
    e: !0,
    f: !0,
    h: !0,
    j: [
      "feet",
      "tracking",
      "walking",
      "beach"
    ],
    k: [
      14,
      23
    ],
    o: 2
  }
}, NH = {
  raised_hand: "hand",
  satisfied: "laughing",
  tshirt: "shirt",
  hand_with_index_and_middle_fingers_crossed: "crossed_fingers",
  sign_of_the_horns: "the_horns",
  grinning_face_with_star_eyes: "star-struck",
  reversed_hand_with_middle_finger_extended: "middle_finger",
  thumbsup: "+1",
  thumbsdown: "-1",
  punch: "facepunch",
  grinning_face_with_one_large_and_one_small_eye: "zany_face",
  shoe: "mans_shoe",
  smiling_face_with_smiling_eyes_and_hand_covering_mouth: "face_with_hand_over_mouth",
  face_with_finger_covering_closed_lips: "shushing_face",
  face_with_one_eyebrow_raised: "face_with_raised_eyebrow",
  face_with_open_mouth_vomiting: "face_vomiting",
  cooking: "fried_egg",
  "flag-cn": "cn",
  shocked_face_with_exploding_head: "exploding_head",
  paw_prints: "feet",
  "flag-de": "de",
  telephone: "phone",
  "flag-es": "es",
  red_car: "car",
  flipper: "dolphin",
  "flag-fr": "fr",
  uk: "gb",
  "flag-gb": "gb",
  serious_face_with_symbols_covering_mouth: "face_with_symbols_on_mouth",
  poop: "hankey",
  shit: "hankey",
  honeybee: "bee",
  staff_of_aesculapius: "medical_symbol",
  lantern: "izakaya_lantern",
  open_book: "book",
  sailboat: "boat",
  knife: "hocho",
  "flag-it": "it",
  heavy_exclamation_mark: "exclamation",
  "flag-jp": "jp",
  envelope: "email",
  "flag-kr": "kr",
  collision: "boom",
  pencil: "memo",
  waxing_gibbous_moon: "moon",
  mother_christmas: "mrs_claus",
  sun_small_cloud: "mostly_sunny",
  sun_behind_cloud: "barely_sunny",
  sun_behind_rain_cloud: "partly_sunny_rain",
  lightning_cloud: "lightning",
  tornado_cloud: "tornado",
  "flag-ru": "ru",
  running: "runner",
  "flag-us": "us",
  women_holding_hands: "two_women_holding_hands",
  man_and_woman_holding_hands: "couple",
  woman_and_man_holding_hands: "couple",
  men_holding_hands: "two_men_holding_hands",
  "man-woman-boy": "family",
  family: "man-woman-boy"
}, V3 = {
  compressed: jH,
  categories: MH,
  emojis: BH,
  aliases: NH
};
function pa(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ys(e) {
  return ys = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ys(e);
}
function LH(e, t) {
  if (ys(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ys(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ox(e) {
  var t = LH(e, "string");
  return ys(t) === "symbol" ? t : String(t);
}
function O6(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ox(n.key), n);
  }
}
function Fa(e, t, r) {
  return t && O6(e.prototype, t), r && O6(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var x_ = {
  name: "a",
  unified: "b",
  non_qualified: "c",
  has_img_apple: "d",
  has_img_google: "e",
  has_img_twitter: "f",
  has_img_facebook: "h",
  keywords: "j",
  sheet: "k",
  emoticons: "l",
  text: "m",
  short_names: "n",
  added_in: "o"
}, sx = function(t) {
  var r = [], n = function(i, o) {
    i && (Array.isArray(i) ? i : [i]).forEach(function(u) {
      (o ? u.split(/[-|_|\s]+/) : [u]).forEach(function(d) {
        d = d.toLowerCase(), r.indexOf(d) == -1 && r.push(d);
      });
    });
  };
  return n(t.short_names, !0), n(t.name, !0), n(t.keywords, !1), n(t.emoticons, !1), r.join(",");
}, H3 = function(t) {
  t.compressed = !1;
  for (var r in t.emojis) {
    var n = t.emojis[r];
    for (var a in x_)
      n[a] = n[x_[a]], delete n[x_[a]];
    n.short_names || (n.short_names = []), n.short_names.unshift(r), n.sheet_x = n.sheet[0], n.sheet_y = n.sheet[1], delete n.sheet, n.text || (n.text = ""), n.added_in || (n.added_in = 6), n.added_in = n.added_in.toFixed(1), n.search = sx(n);
  }
}, qH = String;
const UH = qH.fromCodePoint || function() {
  var t = 16384, r = [], n, a, i = -1, o = arguments.length;
  if (!o)
    return "";
  for (var u = ""; ++i < o; ) {
    var d = Number(arguments[i]);
    if (!isFinite(d) || // `NaN`, `+Infinity`, or `-Infinity`
    d < 0 || // not a valid Unicode code point
    d > 1114111 || // not a valid Unicode code point
    Math.floor(d) != d)
      throw RangeError("Invalid code point: " + d);
    d <= 65535 ? r.push(d) : (d -= 65536, n = (d >> 10) + 55296, a = d % 1024 + 56320, r.push(n, a)), (i + 1 === o || r.length > t) && (u += String.fromCharCode.apply(null, r), r.length = 0);
  }
  return u;
};
var GH = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/, WH = ["1F3FA", "1F3FB", "1F3FC", "1F3FD", "1F3FE", "1F3FF"];
function ux(e) {
  var t = e.split("-"), r = t.map(function(n) {
    return "0x".concat(n);
  });
  return UH.apply(null, r);
}
function VH(e) {
  var t = e.name, r = e.short_names, n = e.skin_tone, a = e.skin_variations, i = e.emoticons, o = e.unified, u = e.custom, d = e.customCategory, s = e.imageUrl, l = e.id || r[0], f = ":".concat(l, ":");
  return u ? {
    id: l,
    name: t,
    short_names: r,
    colons: f,
    emoticons: i,
    custom: u,
    customCategory: d,
    imageUrl: s
  } : (n && (f += ":skin-tone-".concat(n, ":")), {
    id: l,
    name: t,
    short_names: r,
    colons: f,
    emoticons: i,
    unified: o.toLowerCase(),
    skin: n || (a ? 1 : null),
    native: ux(o)
  });
}
function ll() {
  return VH(If.apply(void 0, arguments));
}
function If(e, t, r, n) {
  var a = {};
  if (typeof e == "string") {
    var i = e.match(GH);
    if (i && (e = i[1], i[2] && (t = parseInt(i[2], 10))), n.aliases.hasOwnProperty(e) && (e = n.aliases[e]), n.emojis.hasOwnProperty(e))
      a = n.emojis[e];
    else
      return null;
  } else
    e.id && (n.aliases.hasOwnProperty(e.id) && (e.id = n.aliases[e.id]), n.emojis.hasOwnProperty(e.id) && (a = n.emojis[e.id], t || (t = e.skin)));
  if (Object.keys(a).length || (a = e, a.custom = !0, a.search || (a.search = sx(e))), a.emoticons || (a.emoticons = []), a.variations || (a.variations = []), a.skin_variations && t > 1) {
    a = JSON.parse(JSON.stringify(a));
    var o = WH[t - 1], u = a.skin_variations[o];
    if (u && (!u.variations && a.variations && delete a.variations, r && (u["has_img_".concat(r)] == null || u["has_img_".concat(r)]) || !r)) {
      a.skin_tone = t;
      for (var d in u) {
        var s = u[d];
        a[d] = s;
      }
    }
  }
  return a.variations && a.variations.length && (a = JSON.parse(JSON.stringify(a)), a.unified = a.variations.shift()), a;
}
function T6(e) {
  return e.reduce(function(t, r) {
    return t.indexOf(r) === -1 && t.push(r), t;
  }, []);
}
function HH(e, t) {
  var r = T6(e), n = T6(t);
  return r.filter(function(a) {
    return n.indexOf(a) >= 0;
  });
}
function z2(e, t) {
  var r = {};
  for (var n in e) {
    var a = e[n], i = a;
    t.hasOwnProperty(n) && (i = t[n]), ys(i) === "object" && (i = z2(a, i)), r[n] = i;
  }
  return r;
}
function zH() {
  if (typeof document > "u")
    return 0;
  var e = document.createElement("div");
  e.style.width = "100px", e.style.height = "100px", e.style.overflow = "scroll", e.style.position = "absolute", e.style.top = "-9999px", document.body.appendChild(e);
  var t = e.offsetWidth - e.clientWidth;
  return document.body.removeChild(e), t;
}
function KH(e) {
  var t = typeof requestIdleCallback == "function" ? requestIdleCallback : setTimeout, r = !1;
  return function() {
    r || (r = !0, t(function() {
      r = !1, e();
    }));
  };
}
var z3 = "emoji-mart", dx = typeof window < "u" && "localStorage" in window, K2, Y2;
function YH(e) {
  e || (e = {}), K2 = e.getter, Y2 = e.setter;
}
function XH(e) {
  z3 = e;
}
function QH(e) {
  for (var t in e) {
    var r = e[t];
    lx(t, r);
  }
}
function lx(e, t) {
  if (Y2)
    Y2(e, t);
  else {
    if (!dx)
      return;
    try {
      window.localStorage["".concat(z3, ".").concat(e)] = JSON.stringify(t);
    } catch {
    }
  }
}
function ZH(e) {
  if (K2)
    return K2(e);
  if (!dx)
    return;
  try {
    var t = window.localStorage["".concat(z3, ".").concat(e)];
    if (t)
      return JSON.parse(t);
  } catch {
    return;
  }
}
const bs = {
  update: QH,
  set: lx,
  get: ZH,
  setNamespace: XH,
  setHandlers: YH
};
var fx = /* @__PURE__ */ function() {
  function e(t, r) {
    pa(this, e), t.compressed && H3(t), this.data = t || {}, this.set = r || null, this.originalPool = {}, this.index = {}, this.emojis = {}, this.emoticons = {}, this.customEmojisList = [], this.buildIndex();
  }
  return Fa(e, [{
    key: "buildIndex",
    value: function() {
      var r = this, n = function(o) {
        var u = r.data.emojis[o], d = u.short_names, s = u.emoticons, l = u.skin_variations, f = d[0];
        if (s && s.forEach(function(h) {
          r.emoticons[h] || (r.emoticons[h] = f);
        }), l) {
          r.emojis[f] = {};
          for (var c = 1; c <= 6; c++)
            r.emojis[f][c] = ll({
              id: f,
              skin: c
            }, c, r.set, r.data);
        } else
          r.emojis[f] = ll(f, null, r.set, r.data);
        r.originalPool[f] = u;
      };
      for (var a in this.data.emojis)
        n(a);
    }
  }, {
    key: "clearCustomEmojis",
    value: function(r) {
      var n = this;
      this.customEmojisList.forEach(function(a) {
        var i = a.id || a.short_names[0];
        delete r[i], delete n.emojis[i];
      });
    }
  }, {
    key: "addCustomToPool",
    value: function(r, n) {
      var a = this;
      this.customEmojisList.length && this.clearCustomEmojis(n), r.forEach(function(i) {
        var o = i.id || i.short_names[0];
        o && !n[o] && (n[o] = If(i, null, null, a.data), a.emojis[o] = ll(i, null, null, a.data));
      }), this.customEmojisList = r, this.index = {};
    }
  }, {
    key: "search",
    value: function(r) {
      var n = this, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = a.emojisToShowFilter, o = a.maxResults, u = a.include, d = a.exclude, s = a.custom, l = s === void 0 ? [] : s;
      this.customEmojisList != l && this.addCustomToPool(l, this.originalPool);
      var f = bs.get("skin") || 1;
      o || (o = 75), u || (u = []), d || (d = []);
      var c = null, h = this.originalPool;
      if (r.length) {
        if (r == "-" || r == "-1")
          return [this.emojis[-1][f]];
        var _ = r.toLowerCase().split(/[\s|,|\-|_]+/), F = [];
        if (_.length > 2 && (_ = [_[0], _[1]]), (u.length || d.length) && (h = {}, this.data.categories.forEach(function(E) {
          var D = u && u.length ? u.indexOf(E.id) > -1 : !0, w = d && d.length ? d.indexOf(E.id) > -1 : !1;
          !D || w || E.emojis.forEach(function(k) {
            return h[k] = n.data.emojis[k];
          });
        }), l.length)) {
          var v = u && u.length ? u.indexOf("custom") > -1 : !0, $ = d && d.length ? d.indexOf("custom") > -1 : !1;
          v && !$ && this.addCustomToPool(l, h);
        }
        F = _.map(function(E) {
          for (var D = h, w = n.index, k = 0, A = 0; A < E.length; A++) {
            var P = E[A];
            k++, w[P] || (w[P] = {}), w = w[P], w.results || function() {
              var S = {};
              w.results = [], w.pool = {};
              for (var N in D) {
                var W = D[N], V = W.search, K = E.substr(0, k), U = V.indexOf(K);
                if (U != -1) {
                  var j = U + 1;
                  K == N && (j = 0), n.emojis[N] && n.emojis[N][f] ? w.results.push(n.emojis[N][f]) : w.results.push(n.emojis[N]), w.pool[N] = W, S[N] = j;
                }
              }
              w.results.sort(function(G, H) {
                var J = S[G.id], ae = S[H.id];
                return J == ae ? G.id.localeCompare(H.id) : J - ae;
              });
            }(), D = w.pool;
          }
          return w.results;
        }).filter(function(E) {
          return E;
        }), F.length > 1 ? c = HH.apply(null, F) : F.length ? c = F[0] : c = [];
      }
      return c && (i && (c = c.filter(function(E) {
        return i(h[E.id]);
      })), c && c.length > o && (c = c.slice(0, o))), c;
    }
  }]), e;
}(), H1 = new fx(V3), JH = H1.emojis, ez = H1.emoticons;
function tz() {
  return H1.search.apply(H1, arguments);
}
const cx = {
  search: tz,
  emojis: JH,
  emoticons: ez
};
var P6 = ["+1", "grinning", "kissing_heart", "heart_eyes", "laughing", "stuck_out_tongue_winking_eye", "sweat_smile", "joy", "scream", "disappointed", "unamused", "weary", "sob", "sunglasses", "heart", "poop"], Nn, K3, X2 = {};
function hx() {
  K3 = !0, Nn = bs.get("frequently");
}
function rz(e) {
  K3 || hx();
  var t = e.id;
  Nn || (Nn = X2), Nn[t] || (Nn[t] = 0), Nn[t] += 1, bs.set("last", t), bs.set("frequently", Nn);
}
function nz(e) {
  if (K3 || hx(), !Nn) {
    X2 = {};
    for (var t = [], r = 0; r < e; r++)
      X2[P6[r]] = e - r, t.push(P6[r]);
    return t;
  }
  var n = e * 4, a = [];
  for (var i in Nn)
    Nn.hasOwnProperty(i) && a.push(i);
  var o = a.sort(function(s, l) {
    return Nn[s] - Nn[l];
  }).reverse(), u = o.slice(0, n), d = bs.get("last");
  return d && u.indexOf(d) == -1 && (u.pop(), u.push(d)), u;
}
const gx = {
  add: rz,
  get: nz
};
function xs(e, t, r) {
  return t = ox(t), t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function Tu() {
  return Tu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Tu.apply(this, arguments);
}
function Gt(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Xa(e, t) {
  if (t && (ys(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Gt(e);
}
function zn(e) {
  return zn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, zn(e);
}
function Q2(e, t) {
  return Q2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Q2(e, t);
}
function Qa(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Q2(e, t);
}
var re = {}, I6 = {
  get exports() {
    return re;
  },
  set exports(e) {
    re = e;
  }
}, z1 = {}, az = {
  get exports() {
    return z1;
  },
  set exports(e) {
    z1 = e;
  }
}, It = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var R6;
function iz() {
  if (R6)
    return It;
  R6 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, s = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, c = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, _ = e ? Symbol.for("react.lazy") : 60116, F = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function D(k) {
    if (typeof k == "object" && k !== null) {
      var A = k.$$typeof;
      switch (A) {
        case t:
          switch (k = k.type, k) {
            case d:
            case s:
            case n:
            case i:
            case a:
            case f:
              return k;
            default:
              switch (k = k && k.$$typeof, k) {
                case u:
                case l:
                case _:
                case h:
                case o:
                  return k;
                default:
                  return A;
              }
          }
        case r:
          return A;
      }
    }
  }
  function w(k) {
    return D(k) === s;
  }
  return It.AsyncMode = d, It.ConcurrentMode = s, It.ContextConsumer = u, It.ContextProvider = o, It.Element = t, It.ForwardRef = l, It.Fragment = n, It.Lazy = _, It.Memo = h, It.Portal = r, It.Profiler = i, It.StrictMode = a, It.Suspense = f, It.isAsyncMode = function(k) {
    return w(k) || D(k) === d;
  }, It.isConcurrentMode = w, It.isContextConsumer = function(k) {
    return D(k) === u;
  }, It.isContextProvider = function(k) {
    return D(k) === o;
  }, It.isElement = function(k) {
    return typeof k == "object" && k !== null && k.$$typeof === t;
  }, It.isForwardRef = function(k) {
    return D(k) === l;
  }, It.isFragment = function(k) {
    return D(k) === n;
  }, It.isLazy = function(k) {
    return D(k) === _;
  }, It.isMemo = function(k) {
    return D(k) === h;
  }, It.isPortal = function(k) {
    return D(k) === r;
  }, It.isProfiler = function(k) {
    return D(k) === i;
  }, It.isStrictMode = function(k) {
    return D(k) === a;
  }, It.isSuspense = function(k) {
    return D(k) === f;
  }, It.isValidElementType = function(k) {
    return typeof k == "string" || typeof k == "function" || k === n || k === s || k === i || k === a || k === f || k === c || typeof k == "object" && k !== null && (k.$$typeof === _ || k.$$typeof === h || k.$$typeof === o || k.$$typeof === u || k.$$typeof === l || k.$$typeof === v || k.$$typeof === $ || k.$$typeof === E || k.$$typeof === F);
  }, It.typeOf = D, It;
}
var Rt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var j6;
function oz() {
  return j6 || (j6 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, s = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, c = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, _ = e ? Symbol.for("react.lazy") : 60116, F = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function D(z) {
      return typeof z == "string" || typeof z == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      z === n || z === s || z === i || z === a || z === f || z === c || typeof z == "object" && z !== null && (z.$$typeof === _ || z.$$typeof === h || z.$$typeof === o || z.$$typeof === u || z.$$typeof === l || z.$$typeof === v || z.$$typeof === $ || z.$$typeof === E || z.$$typeof === F);
    }
    function w(z) {
      if (typeof z == "object" && z !== null) {
        var Me = z.$$typeof;
        switch (Me) {
          case t:
            var le = z.type;
            switch (le) {
              case d:
              case s:
              case n:
              case i:
              case a:
              case f:
                return le;
              default:
                var Be = le && le.$$typeof;
                switch (Be) {
                  case u:
                  case l:
                  case _:
                  case h:
                  case o:
                    return Be;
                  default:
                    return Me;
                }
            }
          case r:
            return Me;
        }
      }
    }
    var k = d, A = s, P = u, S = o, N = t, W = l, V = n, K = _, U = h, j = r, G = i, H = a, J = f, ae = !1;
    function de(z) {
      return ae || (ae = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), te(z) || w(z) === d;
    }
    function te(z) {
      return w(z) === s;
    }
    function ee(z) {
      return w(z) === u;
    }
    function ge(z) {
      return w(z) === o;
    }
    function De(z) {
      return typeof z == "object" && z !== null && z.$$typeof === t;
    }
    function xe(z) {
      return w(z) === l;
    }
    function ze(z) {
      return w(z) === n;
    }
    function q(z) {
      return w(z) === _;
    }
    function Ue(z) {
      return w(z) === h;
    }
    function Ce(z) {
      return w(z) === r;
    }
    function me(z) {
      return w(z) === i;
    }
    function Fe(z) {
      return w(z) === a;
    }
    function ce(z) {
      return w(z) === f;
    }
    Rt.AsyncMode = k, Rt.ConcurrentMode = A, Rt.ContextConsumer = P, Rt.ContextProvider = S, Rt.Element = N, Rt.ForwardRef = W, Rt.Fragment = V, Rt.Lazy = K, Rt.Memo = U, Rt.Portal = j, Rt.Profiler = G, Rt.StrictMode = H, Rt.Suspense = J, Rt.isAsyncMode = de, Rt.isConcurrentMode = te, Rt.isContextConsumer = ee, Rt.isContextProvider = ge, Rt.isElement = De, Rt.isForwardRef = xe, Rt.isFragment = ze, Rt.isLazy = q, Rt.isMemo = Ue, Rt.isPortal = Ce, Rt.isProfiler = me, Rt.isStrictMode = Fe, Rt.isSuspense = ce, Rt.isValidElementType = D, Rt.typeOf = w;
  }()), Rt;
}
var M6;
function Y3() {
  return M6 || (M6 = 1, function(e) {
    process.env.NODE_ENV === "production" ? e.exports = iz() : e.exports = oz();
  }(az)), z1;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var D_, B6;
function sz() {
  if (B6)
    return D_;
  B6 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, u = 0; u < 10; u++)
        o["_" + String.fromCharCode(u)] = u;
      var d = Object.getOwnPropertyNames(o).map(function(l) {
        return o[l];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var s = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        s[l] = l;
      }), Object.keys(Object.assign({}, s)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return D_ = a() ? Object.assign : function(i, o) {
    for (var u, d = n(i), s, l = 1; l < arguments.length; l++) {
      u = Object(arguments[l]);
      for (var f in u)
        t.call(u, f) && (d[f] = u[f]);
      if (e) {
        s = e(u);
        for (var c = 0; c < s.length; c++)
          r.call(u, s[c]) && (d[s[c]] = u[s[c]]);
      }
    }
    return d;
  }, D_;
}
var C_, N6;
function X3() {
  if (N6)
    return C_;
  N6 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return C_ = e, C_;
}
var S_, L6;
function _x() {
  return L6 || (L6 = 1, S_ = Function.call.bind(Object.prototype.hasOwnProperty)), S_;
}
var A_, q6;
function uz() {
  if (q6)
    return A_;
  q6 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = X3(), r = {}, n = _x();
    e = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, u, d, s) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in i)
        if (n(i, l)) {
          var f;
          try {
            if (typeof i[l] != "function") {
              var c = Error(
                (d || "React class") + ": " + u + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw c.name = "Invariant Violation", c;
            }
            f = i[l](o, l, d, u, null, t);
          } catch (_) {
            f = _;
          }
          if (f && !(f instanceof Error) && e(
            (d || "React class") + ": type specification of " + u + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var h = s ? s() : "";
            e(
              "Failed " + u + " type: " + f.message + (h ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, A_ = a, A_;
}
var O_, U6;
function dz() {
  if (U6)
    return O_;
  U6 = 1;
  var e = Y3(), t = sz(), r = X3(), n = _x(), a = uz(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(u) {
    var d = "Warning: " + u;
    typeof console < "u" && console.error(d);
    try {
      throw new Error(d);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return O_ = function(u, d) {
    var s = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function f(te) {
      var ee = te && (s && te[s] || te[l]);
      if (typeof ee == "function")
        return ee;
    }
    var c = "<<anonymous>>", h = {
      array: $("array"),
      bigint: $("bigint"),
      bool: $("boolean"),
      func: $("function"),
      number: $("number"),
      object: $("object"),
      string: $("string"),
      symbol: $("symbol"),
      any: E(),
      arrayOf: D,
      element: w(),
      elementType: k(),
      instanceOf: A,
      node: W(),
      objectOf: S,
      oneOf: P,
      oneOfType: N,
      shape: K,
      exact: U
    };
    function _(te, ee) {
      return te === ee ? te !== 0 || 1 / te === 1 / ee : te !== te && ee !== ee;
    }
    function F(te, ee) {
      this.message = te, this.data = ee && typeof ee == "object" ? ee : {}, this.stack = "";
    }
    F.prototype = Error.prototype;
    function v(te) {
      if (process.env.NODE_ENV !== "production")
        var ee = {}, ge = 0;
      function De(ze, q, Ue, Ce, me, Fe, ce) {
        if (Ce = Ce || c, Fe = Fe || Ue, ce !== r) {
          if (d) {
            var z = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw z.name = "Invariant Violation", z;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Me = Ce + ":" + Ue;
            !ee[Me] && // Avoid spamming the console because they are often not actionable except for lib authors
            ge < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + Fe + "` prop on `" + Ce + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), ee[Me] = !0, ge++);
          }
        }
        return q[Ue] == null ? ze ? q[Ue] === null ? new F("The " + me + " `" + Fe + "` is marked as required " + ("in `" + Ce + "`, but its value is `null`.")) : new F("The " + me + " `" + Fe + "` is marked as required in " + ("`" + Ce + "`, but its value is `undefined`.")) : null : te(q, Ue, Ce, me, Fe);
      }
      var xe = De.bind(null, !1);
      return xe.isRequired = De.bind(null, !0), xe;
    }
    function $(te) {
      function ee(ge, De, xe, ze, q, Ue) {
        var Ce = ge[De], me = H(Ce);
        if (me !== te) {
          var Fe = J(Ce);
          return new F(
            "Invalid " + ze + " `" + q + "` of type " + ("`" + Fe + "` supplied to `" + xe + "`, expected ") + ("`" + te + "`."),
            { expectedType: te }
          );
        }
        return null;
      }
      return v(ee);
    }
    function E() {
      return v(o);
    }
    function D(te) {
      function ee(ge, De, xe, ze, q) {
        if (typeof te != "function")
          return new F("Property `" + q + "` of component `" + xe + "` has invalid PropType notation inside arrayOf.");
        var Ue = ge[De];
        if (!Array.isArray(Ue)) {
          var Ce = H(Ue);
          return new F("Invalid " + ze + " `" + q + "` of type " + ("`" + Ce + "` supplied to `" + xe + "`, expected an array."));
        }
        for (var me = 0; me < Ue.length; me++) {
          var Fe = te(Ue, me, xe, ze, q + "[" + me + "]", r);
          if (Fe instanceof Error)
            return Fe;
        }
        return null;
      }
      return v(ee);
    }
    function w() {
      function te(ee, ge, De, xe, ze) {
        var q = ee[ge];
        if (!u(q)) {
          var Ue = H(q);
          return new F("Invalid " + xe + " `" + ze + "` of type " + ("`" + Ue + "` supplied to `" + De + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(te);
    }
    function k() {
      function te(ee, ge, De, xe, ze) {
        var q = ee[ge];
        if (!e.isValidElementType(q)) {
          var Ue = H(q);
          return new F("Invalid " + xe + " `" + ze + "` of type " + ("`" + Ue + "` supplied to `" + De + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(te);
    }
    function A(te) {
      function ee(ge, De, xe, ze, q) {
        if (!(ge[De] instanceof te)) {
          var Ue = te.name || c, Ce = de(ge[De]);
          return new F("Invalid " + ze + " `" + q + "` of type " + ("`" + Ce + "` supplied to `" + xe + "`, expected ") + ("instance of `" + Ue + "`."));
        }
        return null;
      }
      return v(ee);
    }
    function P(te) {
      if (!Array.isArray(te))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function ee(ge, De, xe, ze, q) {
        for (var Ue = ge[De], Ce = 0; Ce < te.length; Ce++)
          if (_(Ue, te[Ce]))
            return null;
        var me = JSON.stringify(te, function(ce, z) {
          var Me = J(z);
          return Me === "symbol" ? String(z) : z;
        });
        return new F("Invalid " + ze + " `" + q + "` of value `" + String(Ue) + "` " + ("supplied to `" + xe + "`, expected one of " + me + "."));
      }
      return v(ee);
    }
    function S(te) {
      function ee(ge, De, xe, ze, q) {
        if (typeof te != "function")
          return new F("Property `" + q + "` of component `" + xe + "` has invalid PropType notation inside objectOf.");
        var Ue = ge[De], Ce = H(Ue);
        if (Ce !== "object")
          return new F("Invalid " + ze + " `" + q + "` of type " + ("`" + Ce + "` supplied to `" + xe + "`, expected an object."));
        for (var me in Ue)
          if (n(Ue, me)) {
            var Fe = te(Ue, me, xe, ze, q + "." + me, r);
            if (Fe instanceof Error)
              return Fe;
          }
        return null;
      }
      return v(ee);
    }
    function N(te) {
      if (!Array.isArray(te))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var ee = 0; ee < te.length; ee++) {
        var ge = te[ee];
        if (typeof ge != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ae(ge) + " at index " + ee + "."
          ), o;
      }
      function De(xe, ze, q, Ue, Ce) {
        for (var me = [], Fe = 0; Fe < te.length; Fe++) {
          var ce = te[Fe], z = ce(xe, ze, q, Ue, Ce, r);
          if (z == null)
            return null;
          z.data && n(z.data, "expectedType") && me.push(z.data.expectedType);
        }
        var Me = me.length > 0 ? ", expected one of type [" + me.join(", ") + "]" : "";
        return new F("Invalid " + Ue + " `" + Ce + "` supplied to " + ("`" + q + "`" + Me + "."));
      }
      return v(De);
    }
    function W() {
      function te(ee, ge, De, xe, ze) {
        return j(ee[ge]) ? null : new F("Invalid " + xe + " `" + ze + "` supplied to " + ("`" + De + "`, expected a ReactNode."));
      }
      return v(te);
    }
    function V(te, ee, ge, De, xe) {
      return new F(
        (te || "React class") + ": " + ee + " type `" + ge + "." + De + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + xe + "`."
      );
    }
    function K(te) {
      function ee(ge, De, xe, ze, q) {
        var Ue = ge[De], Ce = H(Ue);
        if (Ce !== "object")
          return new F("Invalid " + ze + " `" + q + "` of type `" + Ce + "` " + ("supplied to `" + xe + "`, expected `object`."));
        for (var me in te) {
          var Fe = te[me];
          if (typeof Fe != "function")
            return V(xe, ze, q, me, J(Fe));
          var ce = Fe(Ue, me, xe, ze, q + "." + me, r);
          if (ce)
            return ce;
        }
        return null;
      }
      return v(ee);
    }
    function U(te) {
      function ee(ge, De, xe, ze, q) {
        var Ue = ge[De], Ce = H(Ue);
        if (Ce !== "object")
          return new F("Invalid " + ze + " `" + q + "` of type `" + Ce + "` " + ("supplied to `" + xe + "`, expected `object`."));
        var me = t({}, ge[De], te);
        for (var Fe in me) {
          var ce = te[Fe];
          if (n(te, Fe) && typeof ce != "function")
            return V(xe, ze, q, Fe, J(ce));
          if (!ce)
            return new F(
              "Invalid " + ze + " `" + q + "` key `" + Fe + "` supplied to `" + xe + "`.\nBad object: " + JSON.stringify(ge[De], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(te), null, "  ")
            );
          var z = ce(Ue, Fe, xe, ze, q + "." + Fe, r);
          if (z)
            return z;
        }
        return null;
      }
      return v(ee);
    }
    function j(te) {
      switch (typeof te) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !te;
        case "object":
          if (Array.isArray(te))
            return te.every(j);
          if (te === null || u(te))
            return !0;
          var ee = f(te);
          if (ee) {
            var ge = ee.call(te), De;
            if (ee !== te.entries) {
              for (; !(De = ge.next()).done; )
                if (!j(De.value))
                  return !1;
            } else
              for (; !(De = ge.next()).done; ) {
                var xe = De.value;
                if (xe && !j(xe[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function G(te, ee) {
      return te === "symbol" ? !0 : ee ? ee["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && ee instanceof Symbol : !1;
    }
    function H(te) {
      var ee = typeof te;
      return Array.isArray(te) ? "array" : te instanceof RegExp ? "object" : G(ee, te) ? "symbol" : ee;
    }
    function J(te) {
      if (typeof te > "u" || te === null)
        return "" + te;
      var ee = H(te);
      if (ee === "object") {
        if (te instanceof Date)
          return "date";
        if (te instanceof RegExp)
          return "regexp";
      }
      return ee;
    }
    function ae(te) {
      var ee = J(te);
      switch (ee) {
        case "array":
        case "object":
          return "an " + ee;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + ee;
        default:
          return ee;
      }
    }
    function de(te) {
      return !te.constructor || !te.constructor.name ? c : te.constructor.name;
    }
    return h.checkPropTypes = a, h.resetWarningCache = a.resetWarningCache, h.PropTypes = h, h;
  }, O_;
}
var T_, G6;
function lz() {
  if (G6)
    return T_;
  G6 = 1;
  var e = X3();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, T_ = function() {
    function n(o, u, d, s, l, f) {
      if (f !== e) {
        var c = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw c.name = "Invariant Violation", c;
      }
    }
    n.isRequired = n;
    function a() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: a,
      element: n,
      elementType: n,
      instanceOf: a,
      node: n,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, T_;
}
if (process.env.NODE_ENV !== "production") {
  var fz = Y3(), cz = !0;
  I6.exports = dz()(fz.isElement, cz);
} else
  I6.exports = lz()();
var hz = {
  activity: function() {
    return M.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, M.createElement("path", {
      d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"
    }));
  },
  custom: function() {
    return M.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, M.createElement("g", {
      transform: "translate(2.000000, 1.000000)"
    }, M.createElement("rect", {
      id: "Rectangle",
      x: "8",
      y: "0",
      width: "3",
      height: "21",
      rx: "1.5"
    }), M.createElement("rect", {
      id: "Rectangle",
      transform: "translate(9.843, 10.549) rotate(60) translate(-9.843, -10.549) ",
      x: "8.343",
      y: "0.049",
      width: "3",
      height: "21",
      rx: "1.5"
    }), M.createElement("rect", {
      id: "Rectangle",
      transform: "translate(9.843, 10.549) rotate(-60) translate(-9.843, -10.549) ",
      x: "8.343",
      y: "0.049",
      width: "3",
      height: "21",
      rx: "1.5"
    })));
  },
  flags: function() {
    return M.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, M.createElement("path", {
      d: "M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"
    }));
  },
  foods: function() {
    return M.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, M.createElement("path", {
      d: "M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"
    }));
  },
  nature: function() {
    return M.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, M.createElement("path", {
      d: "M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"
    }), M.createElement("path", {
      d: "M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"
    }));
  },
  objects: function() {
    return M.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, M.createElement("path", {
      d: "M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"
    }), M.createElement("path", {
      d: "M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"
    }));
  },
  people: function() {
    return M.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, M.createElement("path", {
      d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
    }), M.createElement("path", {
      d: "M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"
    }));
  },
  places: function() {
    return M.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, M.createElement("path", {
      d: "M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"
    }), M.createElement("path", {
      d: "M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"
    }));
  },
  recent: function() {
    return M.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, M.createElement("path", {
      d: "M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"
    }), M.createElement("path", {
      d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
    }));
  },
  symbols: function() {
    return M.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24"
    }, M.createElement("path", {
      d: "M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"
    }));
  }
}, x1 = {
  search: function() {
    return M.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "13",
      height: "13",
      viewBox: "0 0 20 20",
      opacity: "0.5"
    }, M.createElement("path", {
      d: "M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
    }));
  },
  delete: function() {
    return M.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "13",
      height: "13",
      viewBox: "0 0 20 20",
      opacity: "0.5"
    }, M.createElement("path", {
      d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
    }));
  }
};
const gz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  categories: hz,
  search: x1
}, Symbol.toStringTag, { value: "Module" }));
var uo = {
  data: re.object.isRequired,
  onOver: re.func,
  onLeave: re.func,
  onClick: re.func,
  fallback: re.func,
  backgroundImageFn: re.func,
  native: re.bool,
  forceSize: re.bool,
  tooltip: re.bool,
  useButton: re.bool,
  skin: re.oneOf([1, 2, 3, 4, 5, 6]),
  sheetSize: re.oneOf([16, 20, 32, 64]),
  sheetColumns: re.number,
  sheetRows: re.number,
  set: re.oneOf(["apple", "google", "twitter", "facebook"]),
  size: re.number.isRequired,
  emoji: re.oneOfType([re.string, re.object]).isRequired
}, mx = {
  onClick: re.func,
  onSelect: re.func,
  onSkinChange: re.func,
  perLine: re.number,
  emojiSize: re.number,
  i18n: re.object,
  style: re.object,
  title: re.string,
  emoji: re.string,
  color: re.string,
  set: uo.set,
  skin: uo.skin,
  native: re.bool,
  backgroundImageFn: uo.backgroundImageFn,
  sheetSize: uo.sheetSize,
  emojisToShowFilter: re.func,
  showPreview: re.bool,
  showSkinTones: re.bool,
  emojiTooltip: uo.tooltip,
  useButton: uo.useButton,
  theme: re.oneOf(["auto", "light", "dark"]),
  include: re.arrayOf(re.string),
  exclude: re.arrayOf(re.string),
  recent: re.arrayOf(re.string),
  autoFocus: re.bool,
  enableFrequentEmojiSort: re.bool,
  custom: re.arrayOf(re.shape({
    name: re.string.isRequired,
    short_names: re.arrayOf(re.string).isRequired,
    emoticons: re.arrayOf(re.string),
    keywords: re.arrayOf(re.string),
    imageUrl: re.string,
    spriteUrl: re.string,
    sheet_x: re.number,
    sheet_y: re.number,
    size: re.number,
    sheetColumns: re.number,
    sheetRows: re.number
  })),
  skinEmoji: re.string,
  notFound: re.func,
  notFoundEmoji: re.string,
  icons: re.object
}, Q3 = /* @__PURE__ */ function(e) {
  Qa(t, e);
  function t(r) {
    var n;
    pa(this, t), n = Xa(this, zn(t).call(this, r));
    var a = r.categories.filter(function(i) {
      return i.first;
    })[0];
    return n.state = {
      selected: a.name
    }, n.handleClick = n.handleClick.bind(Gt(n)), n;
  }
  return Fa(t, [{
    key: "handleClick",
    value: function(n) {
      var a = n.currentTarget.getAttribute("data-index"), i = this.props, o = i.categories, u = i.onAnchorClick;
      u(o[a], a);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.categories, o = a.color, u = a.i18n, d = a.icons, s = this.state.selected;
      return M.createElement("nav", {
        className: "emoji-mart-anchors",
        "aria-label": u.categorieslabel
      }, i.map(function(l, f) {
        var c = l.id, h = l.name, _ = l.anchor, F = h == s;
        if (_ === !1)
          return null;
        var v = c.startsWith("custom-") ? "custom" : c;
        return M.createElement("button", {
          key: c,
          "aria-label": u.categories[v],
          title: u.categories[v],
          "data-index": f,
          type: "button",
          onClick: n.handleClick,
          className: "emoji-mart-anchor ".concat(F ? "emoji-mart-anchor-selected" : ""),
          style: {
            color: F ? o : null
          }
        }, M.createElement("div", {
          className: "emoji-mart-anchor-icon"
        }, d.categories[v]()), M.createElement("span", {
          className: "emoji-mart-anchor-bar",
          style: {
            backgroundColor: o
          }
        }));
      }));
    }
  }]), t;
}(M.PureComponent);
Q3.propTypes = {
  categories: re.array,
  onAnchorClick: re.func,
  icons: re.object
};
Q3.defaultProps = {
  categories: [],
  onAnchorClick: function() {
  },
  icons: {}
};
var pi = {
  skin: 1,
  set: "apple",
  sheetSize: 64,
  sheetColumns: 57,
  sheetRows: 57,
  native: !1,
  forceSize: !1,
  tooltip: !1,
  useButton: !0,
  backgroundImageFn: function(t, r) {
    return "https://unpkg.com/emoji-datasource-".concat(t, "@").concat("5.0.1", "/img/").concat(t, "/sheets-256/").concat(r, ".png");
  }
}, K1 = {
  onClick: function() {
  },
  onSelect: function() {
  },
  onSkinChange: function() {
  },
  emojiSize: 24,
  perLine: 9,
  i18n: {},
  style: {},
  title: "Emoji Mart™",
  emoji: "department_store",
  color: "#ae65c5",
  set: pi.set,
  theme: "light",
  skin: null,
  defaultSkin: pi.skin,
  native: pi.native,
  sheetSize: pi.sheetSize,
  backgroundImageFn: pi.backgroundImageFn,
  emojisToShowFilter: null,
  showPreview: !0,
  showSkinTones: !0,
  emojiTooltip: pi.tooltip,
  useButton: pi.useButton,
  autoFocus: !1,
  enableFrequentEmojiSort: !1,
  custom: [],
  skinEmoji: "",
  notFound: function() {
  },
  notFoundEmoji: "sleuth_or_spy",
  icons: {}
};
function W6(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Z2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? W6(Object(r), !0).forEach(function(n) {
      xs(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : W6(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
var px = function(t) {
  var r = t.emoji, n = t.skin, a = t.set, i = t.data;
  return If(r, n, a, i);
}, V6 = function(t) {
  var r = px(t), n = r.sheet_x, a = r.sheet_y, i = 100 / (t.sheetColumns - 1), o = 100 / (t.sheetRows - 1);
  return "".concat(i * n, "% ").concat(o * a, "%");
}, Z3 = function(t) {
  var r = t.emoji, n = t.skin, a = t.set, i = t.data;
  return ll(r, n, a, i);
}, _z = function(t, r) {
  if (r.onClick) {
    var n = r.onClick, a = Z3(r);
    n(a, t);
  }
}, mz = function(t, r) {
  if (r.onOver) {
    var n = r.onOver, a = Z3(r);
    n(a, t);
  }
}, pz = function(t, r) {
  if (r.onLeave) {
    var n = r.onLeave, a = Z3(r);
    n(a, t);
  }
}, Fz = function(t) {
  return !isNaN(t - parseFloat(t));
}, yz = function(t) {
  var r = document.createElement("div");
  for (var n in t) {
    var a = t[n];
    Fz(a) && (a += "px"), r.style[n] = a;
  }
  return r.getAttribute("style");
}, Fo = function e(t) {
  t.data.compressed && H3(t.data);
  for (var r in e.defaultProps)
    t[r] == null && e.defaultProps[r] != null && (t[r] = e.defaultProps[r]);
  var n = px(t);
  if (!n)
    return t.fallback ? t.fallback(null, t) : null;
  var a = n.unified, i = n.custom, o = n.short_names, u = n.imageUrl, d = {}, s = t.children, l = "emoji-mart-emoji", f = a && ux(a), c = [f].concat(o).filter(Boolean).join(", "), h = null;
  if (!a && !i)
    return t.fallback ? t.fallback(n, t) : null;
  if (t.tooltip && (h = o[0]), t.native && a)
    l += " emoji-mart-emoji-native", d = {
      fontSize: t.size
    }, s = f, t.forceSize && (d.display = "inline-block", d.width = t.size, d.height = t.size, d.wordBreak = "keep-all");
  else if (i)
    l += " emoji-mart-emoji-custom", d = {
      width: t.size,
      height: t.size,
      display: "inline-block"
    }, n.spriteUrl ? d = Z2({}, d, {
      backgroundImage: "url(".concat(n.spriteUrl, ")"),
      backgroundSize: "".concat(100 * t.sheetColumns, "% ").concat(100 * t.sheetRows, "%"),
      backgroundPosition: V6(t)
    }) : d = Z2({}, d, {
      backgroundImage: "url(".concat(u, ")"),
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center"
    });
  else {
    var _ = n["has_img_".concat(t.set)] == null || n["has_img_".concat(t.set)];
    if (_)
      d = {
        width: t.size,
        height: t.size,
        display: "inline-block",
        backgroundImage: "url(".concat(t.backgroundImageFn(t.set, t.sheetSize), ")"),
        backgroundSize: "".concat(100 * t.sheetColumns, "% ").concat(100 * t.sheetRows, "%"),
        backgroundPosition: V6(t)
      };
    else
      return t.fallback ? t.fallback(n, t) : null;
  }
  var F = {
    name: "span",
    props: {}
  };
  return t.onClick && t.useButton && (F.name = "button", F.props = {
    type: "button"
  }), t.html ? (d = yz(d), "<".concat(F.name, " style='").concat(d, "' aria-label='").concat(c, "' ").concat(h ? "title='".concat(h, "'") : "", " class='").concat(l, "'>").concat(s || "", "</").concat(F.name, ">")) : M.createElement(F.name, Tu({
    onClick: function($) {
      return _z($, t);
    },
    onMouseEnter: function($) {
      return mz($, t);
    },
    onMouseLeave: function($) {
      return pz($, t);
    },
    "aria-label": c,
    title: h,
    className: l
  }, F.props), M.createElement("span", {
    style: d
  }, s));
};
Fo.propTypes = Z2({}, uo, {
  data: re.object.isRequired
});
Fo.defaultProps = pi;
function H6(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function bz(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? H6(Object(r), !0).forEach(function(n) {
      xs(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : H6(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
var Fx = /* @__PURE__ */ function(e) {
  Qa(t, e);
  function t() {
    return pa(this, t), Xa(this, zn(t).apply(this, arguments));
  }
  return Fa(t, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.data, i = n.emojiProps, o = n.i18n, u = n.notFound, d = n.notFoundEmoji, s = u && u() || M.createElement("div", {
        className: "emoji-mart-no-results"
      }, Fo(bz({
        data: a
      }, i, {
        size: 38,
        emoji: d,
        onOver: null,
        onLeave: null,
        onClick: null
      })), M.createElement("div", {
        className: "emoji-mart-no-results-label"
      }, o.notfound));
      return s;
    }
  }]), t;
}(M.PureComponent);
Fx.propTypes = {
  notFound: re.func.isRequired,
  emojiProps: re.object.isRequired
};
function z6(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vz(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? z6(Object(r), !0).forEach(function(n) {
      xs(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : z6(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
var J3 = /* @__PURE__ */ function(e) {
  Qa(t, e);
  function t(r) {
    var n;
    return pa(this, t), n = Xa(this, zn(t).call(this, r)), n.data = r.data, n.setContainerRef = n.setContainerRef.bind(Gt(n)), n.setLabelRef = n.setLabelRef.bind(Gt(n)), n;
  }
  return Fa(t, [{
    key: "componentDidMount",
    value: function() {
      this.margin = 0, this.minMargin = 0, this.memoizeSize();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function(n, a) {
      var i = this.props, o = i.name, u = i.perLine, d = i.native, s = i.hasStickyPosition, l = i.emojis, f = i.emojiProps, c = f.skin, h = f.size, _ = f.set, F = n.perLine, v = n.native, $ = n.hasStickyPosition, E = n.emojis, D = n.emojiProps, w = D.skin, k = D.size, A = D.set, P = !1;
      return o == "Recent" && u != F && (P = !0), o == "Search" && (P = l != E), (c != w || h != k || d != v || _ != A || s != $) && (P = !0), P;
    }
  }, {
    key: "memoizeSize",
    value: function() {
      if (!this.container) {
        this.top = 0, this.maxMargin = 0;
        return;
      }
      var n = this.container.parentElement, a = this.container.getBoundingClientRect(), i = a.top, o = a.height, u = n.getBoundingClientRect(), d = u.top, s = this.label.getBoundingClientRect(), l = s.height;
      this.top = i - d + n.scrollTop, o == 0 ? this.maxMargin = 0 : this.maxMargin = o - l;
    }
  }, {
    key: "handleScroll",
    value: function(n) {
      var a = n - this.top;
      if (a = a < this.minMargin ? this.minMargin : a, a = a > this.maxMargin ? this.maxMargin : a, a != this.margin)
        return this.props.hasStickyPosition || (this.label.style.top = "".concat(a, "px")), this.margin = a, !0;
    }
  }, {
    key: "getEmojis",
    value: function() {
      var n = this, a = this.props, i = a.name, o = a.emojis, u = a.recent, d = a.perLine;
      if (i == "Recent") {
        var s = this.props.custom, l = u || gx.get(d);
        if (l.length && (o = l.map(function(f) {
          var c = s.filter(function(h) {
            return h.id === f;
          })[0];
          return c || f;
        }).filter(function(f) {
          return !!If(f, null, null, n.data);
        })), o.length === 0 && l.length > 0)
          return null;
      }
      return o && (o = o.slice(0)), o;
    }
  }, {
    key: "updateDisplay",
    value: function(n) {
      var a = this.getEmojis();
      !a || !this.container || (this.container.style.display = n);
    }
  }, {
    key: "setContainerRef",
    value: function(n) {
      this.container = n;
    }
  }, {
    key: "setLabelRef",
    value: function(n) {
      this.label = n;
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.id, o = a.name, u = a.hasStickyPosition, d = a.emojiProps, s = a.i18n, l = a.notFound, f = a.notFoundEmoji, c = this.getEmojis(), h = {}, _ = {}, F = {};
      c || (F = {
        display: "none"
      }), u || (h = {
        height: 28
      }, _ = {
        position: "absolute"
      });
      var v = s.categories[i] || o;
      return M.createElement("section", {
        ref: this.setContainerRef,
        className: "emoji-mart-category",
        "aria-label": v,
        style: F
      }, M.createElement("div", {
        style: h,
        "data-name": o,
        className: "emoji-mart-category-label"
      }, M.createElement("span", {
        style: _,
        ref: this.setLabelRef,
        "aria-hidden": !0
        /* already labeled by the section aria-label */
      }, v)), M.createElement("ul", {
        className: "emoji-mart-category-list"
      }, c && c.map(function($) {
        return M.createElement("li", {
          key: $.short_names && $.short_names.join("_") || $
        }, Fo(vz({
          emoji: $,
          data: n.data
        }, d)));
      })), c && !c.length && M.createElement(Fx, {
        i18n: s,
        notFound: l,
        notFoundEmoji: f,
        data: this.data,
        emojiProps: d
      }));
    }
  }]), t;
}(M.Component);
J3.propTypes = {
  emojis: re.array,
  hasStickyPosition: re.bool,
  name: re.string.isRequired,
  native: re.bool.isRequired,
  perLine: re.number.isRequired,
  emojiProps: re.object.isRequired,
  recent: re.arrayOf(re.string),
  notFound: re.func,
  notFoundEmoji: re.string.isRequired
};
J3.defaultProps = {
  emojis: [],
  hasStickyPosition: !0
};
var wh = /* @__PURE__ */ function(e) {
  Qa(t, e);
  function t(r) {
    var n;
    return pa(this, t), n = Xa(this, zn(t).call(this, r)), n.state = {
      opened: !1
    }, n;
  }
  return Fa(t, [{
    key: "handleClick",
    value: function(n) {
      var a = parseInt(n.currentTarget.getAttribute("data-skin")), i = this.props.onChange;
      this.state.opened ? (this.setState({
        opened: !1
      }), a != this.props.skin && i(a)) : this.setState({
        opened: !0
      });
    }
  }, {
    key: "render",
    value: function() {
      return null;
    }
  }]), t;
}(M.PureComponent);
wh.propTypes = {
  onChange: re.func,
  skin: re.number.isRequired
};
wh.defaultProps = {
  onChange: function() {
  }
};
var eF = /* @__PURE__ */ function(e) {
  Qa(t, e);
  function t(r) {
    var n;
    return pa(this, t), n = Xa(this, zn(t).call(this, r)), n.handleClick = n.handleClick.bind(Gt(n)), n;
  }
  return Fa(t, [{
    key: "render",
    value: function() {
      for (var n = this.props, a = n.skin, i = n.emojiProps, o = n.data, u = n.skinEmoji, d = n.i18n, s = this.state.opened, l = [], f = 1; f <= 6; f++) {
        var c = f === a;
        l.push(M.createElement("span", {
          key: "skin-tone-".concat(f),
          className: "emoji-mart-skin-swatch custom".concat(c ? " selected" : "")
        }, M.createElement("span", {
          onClick: this.handleClick,
          "data-skin": f,
          className: "emoji-mart-skin-tone-".concat(f)
        }, Fo({
          emoji: u,
          data: o,
          skin: f,
          backgroundImageFn: i.backgroundImageFn,
          native: i.native,
          set: i.set,
          sheetSize: i.sheetSize,
          size: 23
        }))));
      }
      return M.createElement("div", {
        className: "emoji-mart-skin-swatches custom".concat(s ? " opened" : "")
      }, M.createElement("div", {
        className: "emoji-mart-skin-text".concat(s ? " opened" : "")
      }, d.skintext), l);
    }
  }]), t;
}(wh);
eF.propTypes = {
  onChange: re.func,
  skin: re.number.isRequired,
  emojiProps: re.object.isRequired,
  skinTone: re.number,
  skinEmoji: re.string.isRequired,
  i18n: re.object
};
eF.defaultProps = {
  onChange: function() {
  },
  skinTone: null
};
var tF = /* @__PURE__ */ function(e) {
  Qa(t, e);
  function t(r) {
    var n;
    return pa(this, t), n = Xa(this, zn(t).call(this, r)), n.handleClick = n.handleClick.bind(Gt(n)), n.handleKeyDown = n.handleKeyDown.bind(Gt(n)), n;
  }
  return Fa(t, [{
    key: "handleKeyDown",
    value: function(n) {
      (n.keyCode === 13 || n.keyCode === 32) && (n.preventDefault(), this.handleClick(n));
    }
  }, {
    key: "render",
    value: function() {
      for (var n = this.props, a = n.skin, i = n.i18n, o = this.state.opened, u = [], d = 1; d <= 6; d++) {
        var s = d === a, l = o || s;
        u.push(M.createElement("span", Tu({
          key: "skin-tone-".concat(d),
          className: "emoji-mart-skin-swatch".concat(s ? " selected" : ""),
          "aria-label": i.skintones[d],
          "aria-hidden": !l
        }, o ? {
          role: "menuitem"
        } : {}), M.createElement("span", Tu({
          onClick: this.handleClick,
          onKeyDown: this.handleKeyDown,
          role: "button"
        }, s ? {
          "aria-haspopup": !0,
          "aria-expanded": !!o
        } : {}, o ? {
          "aria-pressed": !!s
        } : {}, {
          tabIndex: l ? "0" : "",
          "aria-label": i.skintones[d],
          title: i.skintones[d],
          "data-skin": d,
          className: "emoji-mart-skin emoji-mart-skin-tone-".concat(d)
        }))));
      }
      return M.createElement("section", {
        className: "emoji-mart-skin-swatches".concat(o ? " opened" : ""),
        "aria-label": i.skintext
      }, M.createElement("div", o ? {
        role: "menubar"
      } : {}, u));
    }
  }]), t;
}(wh);
tF.propTypes = {
  onChange: re.func,
  skin: re.number.isRequired,
  i18n: re.object
};
tF.defaultProps = {
  onChange: function() {
  }
};
function K6(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Y6(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? K6(Object(r), !0).forEach(function(n) {
      xs(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : K6(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
var rF = /* @__PURE__ */ function(e) {
  Qa(t, e);
  function t(r) {
    var n;
    return pa(this, t), n = Xa(this, zn(t).call(this, r)), n.data = r.data, n.state = {
      emoji: null
    }, n;
  }
  return Fa(t, [{
    key: "render",
    value: function() {
      var n = this.state.emoji, a = this.props, i = a.emojiProps, o = a.skinsProps, u = a.showSkinTones, d = a.title, s = a.emoji, l = a.i18n, f = a.showPreview;
      if (n && f) {
        var c = If(n, null, null, this.data), h = c.emoticons, _ = h === void 0 ? [] : h, F = [], v = [];
        return _.forEach(function($) {
          F.indexOf($.toLowerCase()) >= 0 || (F.push($.toLowerCase()), v.push($));
        }), M.createElement("div", {
          className: "emoji-mart-preview"
        }, M.createElement("div", {
          className: "emoji-mart-preview-emoji",
          "aria-hidden": "true"
        }, Fo(Y6({
          key: n.id,
          emoji: n,
          data: this.data
        }, i))), M.createElement("div", {
          className: "emoji-mart-preview-data",
          "aria-hidden": "true"
        }, M.createElement("div", {
          className: "emoji-mart-preview-name"
        }, n.name), M.createElement("div", {
          className: "emoji-mart-preview-shortnames"
        }, c.short_names.map(function($) {
          return M.createElement("span", {
            key: $,
            className: "emoji-mart-preview-shortname"
          }, ":", $, ":");
        })), M.createElement("div", {
          className: "emoji-mart-preview-emoticons"
        }, v.map(function($) {
          return M.createElement("span", {
            key: $,
            className: "emoji-mart-preview-emoticon"
          }, $);
        }))));
      } else
        return M.createElement("div", {
          className: "emoji-mart-preview"
        }, M.createElement("div", {
          className: "emoji-mart-preview-emoji",
          "aria-hidden": "true"
        }, s && s.length && Fo(Y6({
          emoji: s,
          data: this.data
        }, i))), M.createElement("div", {
          className: "emoji-mart-preview-data",
          "aria-hidden": "true"
        }, M.createElement("span", {
          className: "emoji-mart-title-label"
        }, d)), u && M.createElement("div", {
          className: "emoji-mart-preview-skins".concat(o.skinEmoji ? " custom" : "")
        }, o.skinEmoji ? M.createElement(eF, {
          skin: o.skin,
          emojiProps: i,
          data: this.data,
          skinEmoji: o.skinEmoji,
          i18n: l,
          onChange: o.onChange
        }) : M.createElement(tF, {
          skin: o.skin,
          i18n: l,
          onChange: o.onChange
        })));
    }
  }]), t;
}(M.PureComponent);
rF.propTypes = {
  showSkinTones: re.bool,
  title: re.string.isRequired,
  emoji: re.string.isRequired,
  emojiProps: re.object.isRequired,
  skinsProps: re.object.isRequired
};
rF.defaultProps = {
  showSkinTones: !0,
  onChange: function() {
  }
};
var Ez = 0, nF = /* @__PURE__ */ function(e) {
  Qa(t, e);
  function t(r) {
    var n;
    return pa(this, t), n = Xa(this, zn(t).call(this, r)), n.state = {
      icon: x1.search,
      isSearching: !1,
      id: ++Ez
    }, n.data = r.data, n.emojiIndex = new fx(n.data), n.setRef = n.setRef.bind(Gt(n)), n.clear = n.clear.bind(Gt(n)), n.handleKeyUp = n.handleKeyUp.bind(Gt(n)), n.handleChange = KH(n.handleChange.bind(Gt(n))), n;
  }
  return Fa(t, [{
    key: "componentDidMount",
    value: function() {
      this.input && this.input.value && this.search(this.input.value);
    }
  }, {
    key: "search",
    value: function(n) {
      n == "" ? this.setState({
        icon: x1.search,
        isSearching: !1
      }) : this.setState({
        icon: x1.delete,
        isSearching: !0
      }), this.props.onSearch(this.emojiIndex.search(n, {
        emojisToShowFilter: this.props.emojisToShowFilter,
        maxResults: this.props.maxResults,
        include: this.props.include,
        exclude: this.props.exclude,
        custom: this.props.custom
      }));
    }
  }, {
    key: "clear",
    value: function() {
      this.input.value != "" && (this.input.value = "", this.input.focus(), this.search(""));
    }
  }, {
    key: "handleChange",
    value: function() {
      this.input && this.search(this.input.value);
    }
  }, {
    key: "handleKeyUp",
    value: function(n) {
      n.keyCode === 13 && this.clear();
    }
  }, {
    key: "setRef",
    value: function(n) {
      this.input = n;
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.i18n, i = n.autoFocus, o = this.state, u = o.icon, d = o.isSearching, s = o.id, l = "emoji-mart-search-".concat(s);
      return M.createElement("section", {
        className: "emoji-mart-search",
        "aria-label": a.search
      }, M.createElement("input", {
        id: l,
        ref: this.setRef,
        type: "search",
        onChange: this.handleChange,
        placeholder: a.search,
        autoFocus: i
      }), M.createElement("label", {
        className: "emoji-mart-sr-only",
        htmlFor: l
      }, a.search), M.createElement("button", {
        className: "emoji-mart-search-icon",
        onClick: this.clear,
        onKeyUp: this.handleKeyUp,
        "aria-label": a.clear,
        disabled: !d
      }, u()));
    }
  }]), t;
}(M.PureComponent);
nF.propTypes = {
  onSearch: re.func,
  maxResults: re.number,
  emojisToShowFilter: re.func,
  autoFocus: re.bool
};
nF.defaultProps = {
  onSearch: function() {
  },
  maxResults: 75,
  emojisToShowFilter: null,
  autoFocus: !1
};
function X6(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Y1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? X6(Object(r), !0).forEach(function(n) {
      xs(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : X6(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
var $z = {
  search: "Search",
  clear: "Clear",
  // Accessible label on "clear" button
  notfound: "No Emoji Found",
  skintext: "Choose your default skin tone",
  categories: {
    search: "Search Results",
    recent: "Frequently Used",
    people: "Smileys & People",
    nature: "Animals & Nature",
    foods: "Food & Drink",
    activity: "Activity",
    places: "Travel & Places",
    objects: "Objects",
    symbols: "Symbols",
    flags: "Flags",
    custom: "Custom"
  },
  categorieslabel: "Emoji categories",
  // Accessible title for the list of categories
  skintones: {
    1: "Default Skin Tone",
    2: "Light Skin Tone",
    3: "Medium-Light Skin Tone",
    4: "Medium Skin Tone",
    5: "Medium-Dark Skin Tone",
    6: "Dark Skin Tone"
  }
}, aF = /* @__PURE__ */ function(e) {
  Qa(t, e);
  function t(r) {
    var n;
    pa(this, t), n = Xa(this, zn(t).call(this, r)), n.CUSTOM = [], n.RECENT_CATEGORY = {
      id: "recent",
      name: "Recent",
      emojis: null
    }, n.SEARCH_CATEGORY = {
      id: "search",
      name: "Search",
      emojis: null,
      anchor: !1
    }, r.data.compressed && H3(r.data), n.data = r.data, n.i18n = z2($z, r.i18n), n.icons = z2(gz, r.icons), n.state = {
      firstRender: !0
    }, n.categories = [];
    var a = [].concat(n.data.categories);
    if (r.custom.length > 0) {
      var i = {}, o = 0;
      r.custom.forEach(function(E) {
        i[E.customCategory] || (i[E.customCategory] = {
          id: E.customCategory ? "custom-".concat(E.customCategory) : "custom",
          name: E.customCategory || "Custom",
          emojis: [],
          anchor: o === 0
        }, o++);
        var D = i[E.customCategory], w = Y1({}, E, {
          // `<Category />` expects emoji to have an `id`.
          id: E.short_names[0],
          custom: !0
        });
        D.emojis.push(w), n.CUSTOM.push(w);
      }), a = a.concat(Object.keys(i).map(function(E) {
        return i[E];
      }));
    }
    n.hideRecent = !0, r.include != null && a.sort(function(E, D) {
      return r.include.indexOf(E.id) > r.include.indexOf(D.id) ? 1 : -1;
    });
    for (var u = 0; u < a.length; u++) {
      var d = a[u], s = r.include && r.include.length ? r.include.indexOf(d.id) > -1 : !0, l = r.exclude && r.exclude.length ? r.exclude.indexOf(d.id) > -1 : !1;
      if (!(!s || l))
        if (r.emojisToShowFilter) {
          for (var f = [], c = d.emojis, h = 0; h < c.length; h++) {
            var _ = c[h];
            r.emojisToShowFilter(n.data.emojis[_] || _) && f.push(_);
          }
          if (f.length) {
            var F = {
              emojis: f,
              name: d.name,
              id: d.id
            };
            n.categories.push(F);
          }
        } else
          n.categories.push(d);
    }
    var v = r.include && r.include.length ? r.include.indexOf(n.RECENT_CATEGORY.id) > -1 : !0, $ = r.exclude && r.exclude.length ? r.exclude.indexOf(n.RECENT_CATEGORY.id) > -1 : !1;
    return v && !$ && (n.hideRecent = !1, n.categories.unshift(n.RECENT_CATEGORY)), n.categories[0] && (n.categories[0].first = !0), n.categories.unshift(n.SEARCH_CATEGORY), n.setAnchorsRef = n.setAnchorsRef.bind(Gt(n)), n.handleAnchorClick = n.handleAnchorClick.bind(Gt(n)), n.setSearchRef = n.setSearchRef.bind(Gt(n)), n.handleSearch = n.handleSearch.bind(Gt(n)), n.setScrollRef = n.setScrollRef.bind(Gt(n)), n.handleScroll = n.handleScroll.bind(Gt(n)), n.handleScrollPaint = n.handleScrollPaint.bind(Gt(n)), n.handleEmojiOver = n.handleEmojiOver.bind(Gt(n)), n.handleEmojiLeave = n.handleEmojiLeave.bind(Gt(n)), n.handleEmojiClick = n.handleEmojiClick.bind(Gt(n)), n.handleEmojiSelect = n.handleEmojiSelect.bind(Gt(n)), n.setPreviewRef = n.setPreviewRef.bind(Gt(n)), n.handleSkinChange = n.handleSkinChange.bind(Gt(n)), n.handleKeyDown = n.handleKeyDown.bind(Gt(n)), n.handleDarkMatchMediaChange = n.handleDarkMatchMediaChange.bind(Gt(n)), n;
  }
  return Fa(t, [{
    key: "componentDidMount",
    value: function() {
      var n = this;
      this.state.firstRender && (this.testStickyPosition(), this.firstRenderTimeout = setTimeout(function() {
        n.setState({
          firstRender: !1
        });
      }, 60));
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateCategoriesSize(), this.handleScroll();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.SEARCH_CATEGORY.emojis = null, clearTimeout(this.leaveTimeout), clearTimeout(this.firstRenderTimeout), this.darkMatchMedia && this.darkMatchMedia.removeListener(this.handleDarkMatchMediaChange);
    }
  }, {
    key: "testStickyPosition",
    value: function() {
      var n = document.createElement("div"), a = ["", "-webkit-", "-ms-", "-moz-", "-o-"];
      a.forEach(function(i) {
        return n.style.position = "".concat(i, "sticky");
      }), this.hasStickyPosition = !!n.style.position.length;
    }
  }, {
    key: "getPreferredTheme",
    value: function() {
      return this.props.theme != "auto" ? this.props.theme : this.state.theme ? this.state.theme : typeof matchMedia != "function" || (this.darkMatchMedia || (this.darkMatchMedia = matchMedia("(prefers-color-scheme: dark)"), this.darkMatchMedia.addListener(this.handleDarkMatchMediaChange)), this.darkMatchMedia.media.match(/^not/)) ? K1.theme : this.darkMatchMedia.matches ? "dark" : "light";
    }
  }, {
    key: "handleDarkMatchMediaChange",
    value: function() {
      this.setState({
        theme: this.darkMatchMedia.matches ? "dark" : "light"
      });
    }
  }, {
    key: "handleEmojiOver",
    value: function(n) {
      var a = this.preview;
      if (a) {
        var i = this.CUSTOM.filter(function(u) {
          return u.id === n.id;
        })[0];
        for (var o in i)
          i.hasOwnProperty(o) && (n[o] = i[o]);
        a.setState({
          emoji: n
        }), clearTimeout(this.leaveTimeout);
      }
    }
  }, {
    key: "handleEmojiLeave",
    value: function(n) {
      var a = this.preview;
      a && (this.leaveTimeout = setTimeout(function() {
        a.setState({
          emoji: null
        });
      }, 16));
    }
  }, {
    key: "handleEmojiClick",
    value: function(n, a) {
      this.props.onClick(n, a), this.handleEmojiSelect(n);
    }
  }, {
    key: "handleEmojiSelect",
    value: function(n) {
      var a = this;
      this.props.onSelect(n), !this.hideRecent && !this.props.recent && gx.add(n);
      var i = this.categoryRefs["category-1"];
      if (i) {
        var o = i.maxMargin;
        this.props.enableFrequentEmojiSort && i.forceUpdate(), requestAnimationFrame(function() {
          a.scroll && (i.memoizeSize(), o != i.maxMargin && (a.updateCategoriesSize(), a.handleScrollPaint(), a.SEARCH_CATEGORY.emojis && i.updateDisplay("none")));
        });
      }
    }
  }, {
    key: "handleScroll",
    value: function() {
      this.waitingForPaint || (this.waitingForPaint = !0, requestAnimationFrame(this.handleScrollPaint));
    }
  }, {
    key: "handleScrollPaint",
    value: function() {
      if (this.waitingForPaint = !1, !!this.scroll) {
        var n = null;
        if (this.SEARCH_CATEGORY.emojis)
          n = this.SEARCH_CATEGORY;
        else {
          for (var a = this.scroll, i = a.scrollTop, o = i > (this.scrollTop || 0), u = 0, d = 0, s = this.categories.length; d < s; d++) {
            var l = o ? this.categories.length - 1 - d : d, f = this.categories[l], c = this.categoryRefs["category-".concat(l)];
            if (c) {
              var h = c.handleScroll(i);
              (!u || c.top < u) && c.top > 0 && (u = c.top), h && !n && (n = f);
            }
          }
          i < u ? n = this.categories.filter(function($) {
            return $.anchor !== !1;
          })[0] : i + this.clientHeight >= this.scrollHeight && (n = this.categories[this.categories.length - 1]);
        }
        if (n) {
          var _ = this.anchors, F = n, v = F.name;
          _.state.selected != v && _.setState({
            selected: v
          });
        }
        this.scrollTop = i;
      }
    }
  }, {
    key: "handleSearch",
    value: function(n) {
      this.SEARCH_CATEGORY.emojis = n;
      for (var a = 0, i = this.categories.length; a < i; a++) {
        var o = this.categoryRefs["category-".concat(a)];
        if (o && o.props.name != "Search") {
          var u = n ? "none" : "inherit";
          o.updateDisplay(u);
        }
      }
      this.forceUpdate(), this.scroll && (this.scroll.scrollTop = 0), this.handleScroll();
    }
  }, {
    key: "handleAnchorClick",
    value: function(n, a) {
      var i = this.categoryRefs["category-".concat(a)], o = this.scroll;
      this.anchors;
      var u = null;
      u = function() {
        if (i) {
          var s = i.top;
          n.first ? s = 0 : s += 1, o.scrollTop = s;
        }
      }, this.SEARCH_CATEGORY.emojis ? (this.handleSearch(null), this.search.clear(), requestAnimationFrame(u)) : u();
    }
  }, {
    key: "handleSkinChange",
    value: function(n) {
      var a = {
        skin: n
      }, i = this.props.onSkinChange;
      this.setState(a), bs.update(a), i(n);
    }
  }, {
    key: "handleKeyDown",
    value: function(n) {
      var a = !1;
      switch (n.keyCode) {
        case 13:
          var i;
          this.SEARCH_CATEGORY.emojis && this.SEARCH_CATEGORY.emojis.length && (i = ll(this.SEARCH_CATEGORY.emojis[0], this.state.skin, this.props.set, this.props.data)) && (this.handleEmojiSelect(i), a = !0);
          break;
      }
      a && n.preventDefault();
    }
  }, {
    key: "updateCategoriesSize",
    value: function() {
      for (var n = 0, a = this.categories.length; n < a; n++) {
        var i = this.categoryRefs["category-".concat(n)];
        i && i.memoizeSize();
      }
      if (this.scroll) {
        var o = this.scroll;
        this.scrollHeight = o.scrollHeight, this.clientHeight = o.clientHeight;
      }
    }
  }, {
    key: "getCategories",
    value: function() {
      return this.state.firstRender ? this.categories.slice(0, 3) : this.categories;
    }
  }, {
    key: "setAnchorsRef",
    value: function(n) {
      this.anchors = n;
    }
  }, {
    key: "setSearchRef",
    value: function(n) {
      this.search = n;
    }
  }, {
    key: "setPreviewRef",
    value: function(n) {
      this.preview = n;
    }
  }, {
    key: "setScrollRef",
    value: function(n) {
      this.scroll = n;
    }
  }, {
    key: "setCategoryRef",
    value: function(n, a) {
      this.categoryRefs || (this.categoryRefs = {}), this.categoryRefs[n] = a;
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.perLine, o = a.emojiSize, u = a.set, d = a.sheetSize, s = a.sheetColumns, l = a.sheetRows, f = a.style, c = a.title, h = a.emoji, _ = a.color, F = a.native, v = a.backgroundImageFn, $ = a.emojisToShowFilter, E = a.showPreview, D = a.showSkinTones, w = a.emojiTooltip, k = a.useButton, A = a.include, P = a.exclude, S = a.recent, N = a.autoFocus, W = a.skinEmoji, V = a.notFound, K = a.notFoundEmoji, U = i * (o + 12) + 12 + 2 + zH(), j = this.getPreferredTheme(), G = this.props.skin || this.state.skin || bs.get("skin") || this.props.defaultSkin;
      return M.createElement("section", {
        style: Y1({
          width: U
        }, f),
        className: "emoji-mart emoji-mart-".concat(j),
        "aria-label": c,
        onKeyDown: this.handleKeyDown
      }, M.createElement("div", {
        className: "emoji-mart-bar"
      }, M.createElement(Q3, {
        ref: this.setAnchorsRef,
        data: this.data,
        i18n: this.i18n,
        color: _,
        categories: this.categories,
        onAnchorClick: this.handleAnchorClick,
        icons: this.icons
      })), M.createElement(nF, {
        ref: this.setSearchRef,
        onSearch: this.handleSearch,
        data: this.data,
        i18n: this.i18n,
        emojisToShowFilter: $,
        include: A,
        exclude: P,
        custom: this.CUSTOM,
        autoFocus: N
      }), M.createElement("div", {
        ref: this.setScrollRef,
        className: "emoji-mart-scroll",
        onScroll: this.handleScroll
      }, this.getCategories().map(function(H, J) {
        return M.createElement(J3, {
          ref: n.setCategoryRef.bind(n, "category-".concat(J)),
          key: H.name,
          id: H.id,
          name: H.name,
          emojis: H.emojis,
          perLine: i,
          native: F,
          hasStickyPosition: n.hasStickyPosition,
          data: n.data,
          i18n: n.i18n,
          recent: H.id == n.RECENT_CATEGORY.id ? S : void 0,
          custom: H.id == n.RECENT_CATEGORY.id ? n.CUSTOM : void 0,
          emojiProps: {
            native: F,
            skin: G,
            size: o,
            set: u,
            sheetSize: d,
            sheetColumns: s,
            sheetRows: l,
            forceSize: F,
            tooltip: w,
            backgroundImageFn: v,
            useButton: k,
            onOver: n.handleEmojiOver,
            onLeave: n.handleEmojiLeave,
            onClick: n.handleEmojiClick
          },
          notFound: V,
          notFoundEmoji: K
        });
      })), (E || D) && M.createElement("div", {
        className: "emoji-mart-bar"
      }, M.createElement(rF, {
        ref: this.setPreviewRef,
        data: this.data,
        title: c,
        emoji: h,
        showSkinTones: D,
        showPreview: E,
        emojiProps: {
          native: F,
          size: 38,
          skin: G,
          set: u,
          sheetSize: d,
          sheetColumns: s,
          sheetRows: l,
          backgroundImageFn: v
        },
        skinsProps: {
          skin: G,
          onChange: this.handleSkinChange,
          skinEmoji: W
        },
        i18n: this.i18n
      })));
    }
  }]), t;
}(M.PureComponent);
aF.propTypes = Y1({}, mx, {
  data: re.object.isRequired
});
aF.defaultProps = Y1({}, K1);
function Q6(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function wz(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q6(Object(r), !0).forEach(function(n) {
      xs(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Q6(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
var iF = /* @__PURE__ */ function(e) {
  Qa(t, e);
  function t() {
    return pa(this, t), Xa(this, zn(t).apply(this, arguments));
  }
  return Fa(t, [{
    key: "render",
    value: function() {
      return M.createElement(aF, Tu({}, this.props, this.state));
    }
  }]), t;
}(M.PureComponent);
iF.propTypes = mx;
iF.defaultProps = wz({}, K1, {
  data: V3
});
function Z6(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function yx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Z6(Object(r), !0).forEach(function(n) {
      xs(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Z6(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
var oF = function e(t) {
  for (var r in e.defaultProps)
    t[r] == null && e.defaultProps[r] != null && (t[r] = e.defaultProps[r]);
  return Fo(yx({}, t));
};
oF.propTypes = uo;
oF.defaultProps = yx({}, pi, {
  data: V3
});
const kz = [
  {
    emoji: "🙂",
    category: "People",
    code: "smile",
    actual: "slightly_smiling_face"
  },
  {
    emoji: "🤓",
    category: "People",
    code: "nerd_face",
    actual: "nerd_face"
  },
  {
    emoji: "😎",
    category: "People",
    code: "sunglasses",
    actual: "sunglasses"
  },
  {
    emoji: "😍",
    category: "People",
    code: "heart_eyes",
    actual: "heart_eyes"
  },
  {
    emoji: "😡",
    category: "People",
    code: "rage",
    actual: "rage"
  },
  {
    emoji: "💩",
    category: "People",
    code: "hankey",
    actual: "hankey"
  },
  {
    emoji: "💪",
    category: "People",
    code: "muscle",
    actual: "muscle"
  },
  {
    emoji: "👋",
    category: "People",
    code: "wave",
    actual: "wave"
  },
  {
    emoji: "🤑",
    category: "People",
    code: "money_mouth_face",
    actual: "money_mouth_face"
  },
  {
    emoji: "🚲",
    category: "Places",
    code: "bike",
    actual: "bike"
  },
  {
    emoji: "🚜",
    category: "Places",
    code: "tractor",
    actual: "tractor"
  },
  {
    emoji: "🚖",
    category: "Places",
    code: "oncoming_taxi",
    actual: "oncoming_taxi"
  },
  {
    emoji: "🌈",
    category: "Nature",
    code: "rainbow",
    actual: "rainbow"
  },
  {
    emoji: "🚀",
    category: "Places",
    code: "rocket",
    actual: "rocket"
  },
  {
    emoji: "🐵",
    category: "Nature",
    code: "monkey_face",
    actual: "monkey_face"
  },
  {
    emoji: "🦄",
    category: "Nature",
    code: "unicorn",
    actual: "unicorn_face"
  },
  {
    emoji: "🐷",
    category: "Nature",
    code: "pig",
    actual: "pig"
  },
  {
    emoji: "🐸",
    category: "Nature",
    code: "frog",
    actual: "frog"
  },
  {
    emoji: "🐳",
    category: "Nature",
    code: "whale",
    actual: "whale"
  },
  {
    emoji: "🌵",
    category: "Nature",
    code: "cactus",
    actual: "cactus"
  },
  {
    emoji: "🍀",
    category: "Nature",
    code: "four_leaf_clover",
    actual: "four_leaf_clover"
  },
  {
    emoji: "⚡️",
    category: "Nature",
    code: "zap",
    actual: "zap"
  },
  {
    emoji: "🔥",
    category: "Nature",
    code: "fire",
    actual: "fire"
  },
  {
    emoji: "💥",
    category: "Nature",
    code: "boom",
    actual: "boom"
  },
  {
    emoji: "☀️",
    category: "Nature",
    code: "sunny",
    actual: "sunny"
  },
  {
    emoji: "🚑",
    category: "Places",
    code: "ambulance",
    actual: "ambulance"
  },
  {
    emoji: "❤️",
    category: "Symbols",
    code: "heart",
    actual: "heart"
  },
  {
    emoji: "💘",
    category: "Symbols",
    code: "cupid",
    actual: "cupid"
  },
  {
    emoji: "🎁",
    category: "Objects",
    code: "gift",
    actual: "gift"
  },
  {
    emoji: "🍾",
    category: "Foods",
    code: "champagne",
    actual: "champagne"
  },
  {
    emoji: "💯",
    category: "Symbols",
    code: "100",
    actual: "100"
  },
  {
    emoji: "⛔️",
    category: "Symbols",
    code: "no_entry",
    actual: "no_entry"
  },
  {
    emoji: "📫",
    category: "Objects",
    code: "mailbox",
    actual: "mailbox"
  },
  {
    emoji: "📈",
    category: "Objects",
    code: "chart_with_upwards_trend",
    actual: "chart_with_upwards_trend"
  },
  {
    emoji: "♻️",
    category: "Symbols",
    code: "recycle",
    actual: "recycle"
  },
  {
    emoji: "🔒",
    category: "Objects",
    code: "lock",
    actual: "lock"
  },
  {
    emoji: "☎️",
    category: "Objects",
    code: "phone",
    actual: "phone"
  },
  {
    emoji: "💸",
    category: "Objects",
    code: "money_with_wings",
    actual: "money_with_wings"
  },
  {
    emoji: "💳",
    category: "Objects",
    code: "credit_card",
    actual: "credit_card"
  },
  {
    emoji: "💣",
    category: "Objects",
    code: "bomb",
    actual: "bomb"
  },
  {
    emoji: "😇",
    category: "People",
    code: "innocent",
    actual: "innocent"
  },
  {
    emoji: "😀",
    category: "People",
    code: "grinning",
    actual: "grinning"
  },
  {
    emoji: "😱",
    category: "People",
    code: "scream",
    actual: "scream"
  },
  {
    emoji: "😜",
    category: "People",
    code: "stuck_out_tongue_winking_eye",
    actual: "stuck_out_tongue_winking_eye"
  },
  {
    emoji: "🌊",
    category: "Nature",
    code: "ocean",
    actual: "ocean"
  },
  {
    emoji: "🎉",
    category: "Objects",
    code: "tada",
    actual: "tada"
  },
  {
    emoji: "✨",
    category: "Activities",
    code: "sparkles",
    actual: "sparkles"
  },
  {
    emoji: "🇫🇷",
    category: "Flags",
    code: "fr",
    actual: "fr"
  },
  {
    emoji: "🇺🇸",
    category: "Flags",
    code: "us",
    actual: "us"
  },
  {
    emoji: "🇬🇧",
    category: "Flags",
    code: "gb",
    actual: "gb"
  },
  {
    emoji: "🇪🇸",
    category: "Flags",
    code: "es",
    actual: "es"
  },
  {
    emoji: "🇩🇪",
    category: "Flags",
    code: "de",
    actual: "de"
  },
  {
    emoji: "🇧🇷",
    category: "Flags",
    code: "brazil",
    actual: "flag-br"
  },
  {
    emoji: "🇨🇦",
    category: "Flags",
    code: "canada",
    actual: "flag-ca"
  },
  {
    emoji: "🇮🇹",
    category: "Flags",
    code: "italy",
    actual: "it"
  }
], xz = kz, bx = (e) => {
  const t = xz.find((i) => i.code === e), r = (t == null ? void 0 : t.actual) || e, n = cx.search(r);
  if (!(n != null && n.length))
    return null;
  const a = n.find(
    (i) => i.colons === r || i.id === r
  );
  return a || null;
};
function J6(e, t) {
  return bx(t || e || "") || cx.emojis.slightly_smiling_face;
}
class vx extends Error {
  constructor(r, n) {
    super(r.message);
    tu(this, "trace");
    this.error = r, this.trace = n, Object.setPrototypeOf(this, vx.prototype);
  }
}
var J2 = function(e, t) {
  return J2 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var a in n)
      Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
  }, J2(e, t);
};
function Ex(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  J2(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var Kr = function() {
  return Kr = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, Kr.apply(this, arguments);
};
function e9(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
var P_ = "Invariant Violation", t9 = Object.setPrototypeOf, Dz = t9 === void 0 ? function(e, t) {
  return e.__proto__ = t, e;
} : t9, Cz = (
  /** @class */
  function(e) {
    Ex(t, e);
    function t(r) {
      r === void 0 && (r = P_);
      var n = e.call(this, typeof r == "number" ? P_ + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
      return n.framesToPop = 1, n.name = P_, Dz(n, t.prototype), n;
    }
    return t;
  }(Error)
);
function Or(e, t) {
  if (!e)
    throw new Cz(t);
}
var $x = ["debug", "log", "warn", "error", "silent"], Sz = $x.indexOf("log");
function a1(e) {
  return function() {
    if ($x.indexOf(e) >= Sz) {
      var t = console[e] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = a1("debug"), e.log = a1("log"), e.warn = a1("warn"), e.error = a1("error");
})(Or || (Or = {}));
function Ma(e) {
  try {
    return e();
  } catch {
  }
}
const r9 = Ma(function() {
  return globalThis;
}) || Ma(function() {
  return window;
}) || Ma(function() {
  return self;
}) || Ma(function() {
  return global;
}) || Ma(function() {
  return Ma.constructor("return this")();
});
var n9 = "__", a9 = [n9, n9].join("DEV");
function Az() {
  try {
    return Boolean(__DEV__);
  } catch {
    return Object.defineProperty(r9, a9, {
      value: Ma(function() {
        return process.env.NODE_ENV;
      }) !== "production",
      enumerable: !1,
      configurable: !0,
      writable: !0
    }), r9[a9];
  }
}
const I_ = Az();
function lo(e) {
  try {
    return e();
  } catch {
  }
}
var em = lo(function() {
  return globalThis;
}) || lo(function() {
  return window;
}) || lo(function() {
  return self;
}) || lo(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
lo(function() {
  return lo.constructor("return this")();
}), tm = !1;
function Oz() {
  em && !lo(function() {
    return process.env.NODE_ENV;
  }) && !lo(function() {
    return process;
  }) && (Object.defineProperty(em, "process", {
    value: {
      env: {
        // This default needs to be "production" instead of "development", to
        // avoid the problem https://github.com/graphql/graphql-js/pull/2894
        // will eventually solve, once merged and released.
        NODE_ENV: "production"
      }
    },
    // Let anyone else change global.process as they see fit, but hide it from
    // Object.keys(global) enumeration.
    configurable: !0,
    enumerable: !1,
    writable: !0
  }), tm = !0);
}
Oz();
function i9() {
  tm && (delete em.process, tm = !1);
}
var Tz = typeof Symbol == "function" && Symbol.toStringTag != null ? Symbol.toStringTag : "@@toStringTag", Pz = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : void 0;
const Iz = Pz;
function D1(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? D1 = function(r) {
    return typeof r;
  } : D1 = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, D1(e);
}
var Rz = 10, wx = 2;
function jz(e) {
  return kh(e, []);
}
function kh(e, t) {
  switch (D1(e)) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? "[function ".concat(e.name, "]") : "[function]";
    case "object":
      return e === null ? "null" : Mz(e, t);
    default:
      return String(e);
  }
}
function Mz(e, t) {
  if (t.indexOf(e) !== -1)
    return "[Circular]";
  var r = [].concat(t, [e]), n = Lz(e);
  if (n !== void 0) {
    var a = n.call(e);
    if (a !== e)
      return typeof a == "string" ? a : kh(a, r);
  } else if (Array.isArray(e))
    return Nz(e, r);
  return Bz(e, r);
}
function Bz(e, t) {
  var r = Object.keys(e);
  if (r.length === 0)
    return "{}";
  if (t.length > wx)
    return "[" + qz(e) + "]";
  var n = r.map(function(a) {
    var i = kh(e[a], t);
    return a + ": " + i;
  });
  return "{ " + n.join(", ") + " }";
}
function Nz(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > wx)
    return "[Array]";
  for (var r = Math.min(Rz, e.length), n = e.length - r, a = [], i = 0; i < r; ++i)
    a.push(kh(e[i], t));
  return n === 1 ? a.push("... 1 more item") : n > 1 && a.push("... ".concat(n, " more items")), "[" + a.join(", ") + "]";
}
function Lz(e) {
  var t = e[String(Iz)];
  if (typeof t == "function")
    return t;
  if (typeof e.inspect == "function")
    return e.inspect;
}
function qz(e) {
  var t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    var r = e.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return t;
}
function R_(e, t) {
  var r = Boolean(e);
  if (!r)
    throw new Error(t);
}
function o9(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Uz(e, t, r) {
  return t && o9(e.prototype, t), r && o9(e, r), e;
}
var Gz = /* @__PURE__ */ function() {
  function e(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "GraphQL request", n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
      line: 1,
      column: 1
    };
    typeof t == "string" || R_(0, "Body must be a string. Received: ".concat(jz(t), ".")), this.body = t, this.name = r, this.locationOffset = n, this.locationOffset.line > 0 || R_(0, "line in locationOffset is 1-indexed and must be positive."), this.locationOffset.column > 0 || R_(0, "column in locationOffset is 1-indexed and must be positive.");
  }
  return Uz(e, [{
    key: Tz,
    get: function() {
      return "Source";
    }
  }]), e;
}();
function Wz() {
  return i9();
}
function Vz() {
  __DEV__ ? Or(typeof I_ == "boolean", I_) : Or(typeof I_ == "boolean", 36);
}
Wz();
Vz();
function s9(e) {
  return e !== null && typeof e == "object";
}
function Hz(e) {
  var t = /* @__PURE__ */ new Set([e]);
  return t.forEach(function(r) {
    s9(r) && zz(r) === r && Object.getOwnPropertyNames(r).forEach(function(n) {
      s9(r[n]) && t.add(r[n]);
    });
  }), e;
}
function zz(e) {
  if (__DEV__ && !Object.isFrozen(e))
    try {
      Object.freeze(e);
    } catch (t) {
      if (t instanceof TypeError)
        return null;
      throw t;
    }
  return e;
}
function u9(e) {
  return __DEV__ && Hz(e), e;
}
var Kz = typeof WeakMap == "function" && Ma(function() {
  return navigator.product;
}) !== "ReactNative", Yz = typeof WeakSet == "function", Xz = typeof Symbol == "function" && typeof Symbol.for == "function", Qz = typeof Ma(function() {
  return window.document.createElement;
}) == "function", Zz = Ma(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
}) || !1, Jz = Qz && !Zz;
function rm(e) {
  return Array.isArray(e) && e.length > 0;
}
function kx() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = /* @__PURE__ */ Object.create(null);
  return e.forEach(function(n) {
    n && Object.keys(n).forEach(function(a) {
      var i = n[a];
      i !== void 0 && (r[a] = i);
    });
  }), r;
}
function sF(e, t) {
  return kx(e, t, t.variables && {
    variables: Kr(Kr({}, e && e.variables), t.variables)
  });
}
var xx = Object.prototype, d9 = xx.toString, eK = xx.hasOwnProperty, l9 = Function.prototype.toString, nm = /* @__PURE__ */ new Map();
function fl(e, t) {
  try {
    return am(e, t);
  } finally {
    nm.clear();
  }
}
function am(e, t) {
  if (e === t)
    return !0;
  var r = d9.call(e), n = d9.call(t);
  if (r !== n)
    return !1;
  switch (r) {
    case "[object Array]":
      if (e.length !== t.length)
        return !1;
    case "[object Object]": {
      if (c9(e, t))
        return !0;
      var a = f9(e), i = f9(t), o = a.length;
      if (o !== i.length)
        return !1;
      for (var u = 0; u < o; ++u)
        if (!eK.call(t, a[u]))
          return !1;
      for (var u = 0; u < o; ++u) {
        var d = a[u];
        if (!am(e[d], t[d]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return e.name === t.name && e.message === t.message;
    case "[object Number]":
      if (e !== e)
        return t !== t;
    case "[object Boolean]":
    case "[object Date]":
      return +e == +t;
    case "[object RegExp]":
    case "[object String]":
      return e == "" + t;
    case "[object Map]":
    case "[object Set]": {
      if (e.size !== t.size)
        return !1;
      if (c9(e, t))
        return !0;
      for (var s = e.entries(), l = r === "[object Map]"; ; ) {
        var f = s.next();
        if (f.done)
          break;
        var c = f.value, h = c[0], _ = c[1];
        if (!t.has(h) || l && !am(_, t.get(h)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      e = new Uint8Array(e), t = new Uint8Array(t);
    case "[object DataView]": {
      var F = e.byteLength;
      if (F === t.byteLength)
        for (; F-- && e[F] === t[F]; )
          ;
      return F === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      var v = l9.call(e);
      return v !== l9.call(t) ? !1 : !nK(v, rK);
    }
  }
  return !1;
}
function f9(e) {
  return Object.keys(e).filter(tK, e);
}
function tK(e) {
  return this[e] !== void 0;
}
var rK = "{ [native code] }";
function nK(e, t) {
  var r = e.length - t.length;
  return r >= 0 && e.indexOf(t, r) === r;
}
function c9(e, t) {
  var r = nm.get(e);
  if (r) {
    if (r.has(t))
      return !0;
  } else
    nm.set(e, r = /* @__PURE__ */ new Set());
  return r.add(t), !1;
}
var aK = function(e) {
  var t = "";
  if (rm(e.graphQLErrors) || rm(e.clientErrors)) {
    var r = (e.graphQLErrors || []).concat(e.clientErrors || []);
    r.forEach(function(n) {
      var a = n ? n.message : "Error message not found.";
      t += "".concat(a, `
`);
    });
  }
  return e.networkError && (t += "".concat(e.networkError.message, `
`)), t = t.replace(/\n$/, ""), t;
}, sd = function(e) {
  Ex(t, e);
  function t(r) {
    var n = r.graphQLErrors, a = r.clientErrors, i = r.networkError, o = r.errorMessage, u = r.extraInfo, d = e.call(this, o) || this;
    return d.graphQLErrors = n || [], d.clientErrors = a || [], d.networkError = i || null, d.message = o || aK(d), d.extraInfo = u, d.__proto__ = t.prototype, d;
  }
  return t;
}(Error), hu;
(function(e) {
  e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
})(hu || (hu = {}));
var h9 = Xz ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function Dx() {
  var e = se.createContext[h9];
  return e || (Object.defineProperty(se.createContext, h9, {
    value: e = se.createContext({}),
    enumerable: !1,
    writable: !1,
    configurable: !0
  }), e.displayName = "ApolloContext"), e;
}
function Rf(e) {
  var t = Et(Dx()), r = e || t.client;
  return __DEV__ ? Or(!!r, 'Could not find "client" in the context or passed in as an option. Wrap the root component in an <ApolloProvider>, or pass an ApolloClient instance in via options.') : Or(!!r, 29), r;
}
var g9 = !1, iK = "useSyncExternalStore", oK = se[iK], sK = oK || function(e, t, r) {
  var n = t();
  __DEV__ && !g9 && n !== t() && (g9 = !0, __DEV__ && Or.error("The result of getSnapshot should be cached to avoid an infinite loop"));
  var a = se.useState({ inst: { value: n, getSnapshot: t } }), i = a[0].inst, o = a[1];
  return Jz ? se.useLayoutEffect(function() {
    Object.assign(i, { value: n, getSnapshot: t }), j_(i) && o({ inst: i });
  }, [e, n, t]) : Object.assign(i, { value: n, getSnapshot: t }), se.useEffect(function() {
    return j_(i) && o({ inst: i }), e(function() {
      j_(i) && o({ inst: i });
    });
  }, [e]), n;
};
function j_(e) {
  var t = e.value, r = e.getSnapshot;
  try {
    return t !== r();
  } catch {
    return !0;
  }
}
var Ua;
(function(e) {
  e[e.Query = 0] = "Query", e[e.Mutation = 1] = "Mutation", e[e.Subscription = 2] = "Subscription";
})(Ua || (Ua = {}));
var _9 = /* @__PURE__ */ new Map();
function m9(e) {
  var t;
  switch (e) {
    case Ua.Query:
      t = "Query";
      break;
    case Ua.Mutation:
      t = "Mutation";
      break;
    case Ua.Subscription:
      t = "Subscription";
      break;
  }
  return t;
}
function uK(e) {
  var t = _9.get(e);
  if (t)
    return t;
  var r, n, a;
  __DEV__ ? Or(!!e && !!e.kind, "Argument of ".concat(e, " passed to parser was not a valid GraphQL ") + "DocumentNode. You may need to use 'graphql-tag' or another method to convert your operation into a document") : Or(!!e && !!e.kind, 30);
  for (var i = [], o = [], u = [], d = [], s = 0, l = e.definitions; s < l.length; s++) {
    var f = l[s];
    if (f.kind === "FragmentDefinition") {
      i.push(f);
      continue;
    }
    if (f.kind === "OperationDefinition")
      switch (f.operation) {
        case "query":
          o.push(f);
          break;
        case "mutation":
          u.push(f);
          break;
        case "subscription":
          d.push(f);
          break;
      }
  }
  __DEV__ ? Or(!i.length || o.length || u.length || d.length, "Passing only a fragment to 'graphql' is not yet supported. You must include a query, subscription or mutation as well") : Or(!i.length || o.length || u.length || d.length, 31), __DEV__ ? Or(o.length + u.length + d.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " + "".concat(e, " had ").concat(o.length, " queries, ").concat(d.length, " ") + "subscriptions and ".concat(u.length, " mutations. ") + "You can use 'compose' to join multiple operation types to a component") : Or(o.length + u.length + d.length <= 1, 32), n = o.length ? Ua.Query : Ua.Mutation, !o.length && !u.length && (n = Ua.Subscription);
  var c = o.length ? o : u.length ? u : d;
  __DEV__ ? Or(c.length === 1, "react-apollo only supports one definition per HOC. ".concat(e, " had ") + "".concat(c.length, " definitions. ") + "You can use 'compose' to join multiple operation types to a component") : Or(c.length === 1, 33);
  var h = c[0];
  r = h.variableDefinitions || [], h.name && h.name.kind === "Name" ? a = h.name.value : a = "data";
  var _ = { name: a, type: n, variables: r };
  return _9.set(e, _), _;
}
function Cx(e, t) {
  var r = uK(e), n = m9(t), a = m9(r.type);
  __DEV__ ? Or(r.type === t, "Running a ".concat(n, " requires a graphql ") + "".concat(n, ", but a ").concat(a, " was used instead.")) : Or(r.type === t, 34);
}
var dK = Object.prototype.hasOwnProperty;
function lK(e, t) {
  return t === void 0 && (t = /* @__PURE__ */ Object.create(null)), Sx(Rf(t.client), e).useQuery(t);
}
function Sx(e, t) {
  var r = tt();
  (!r.current || e !== r.current.client || t !== r.current.query) && (r.current = new fK(e, t, r.current));
  var n = r.current, a = Xe(0);
  a[0];
  var i = a[1];
  return n.forceUpdate = function() {
    i(function(o) {
      return o + 1;
    });
  }, n;
}
var fK = function() {
  function e(t, r, n) {
    this.client = t, this.query = r, this.asyncResolveFns = /* @__PURE__ */ new Set(), this.optionsToIgnoreOnce = new (Yz ? WeakSet : Set)(), this.ssrDisabledResult = u9({
      loading: !0,
      data: void 0,
      error: void 0,
      networkStatus: hu.loading
    }), this.skipStandbyResult = u9({
      loading: !1,
      data: void 0,
      error: void 0,
      networkStatus: hu.ready
    }), this.toQueryResultCache = new (Kz ? WeakMap : Map)(), Cx(r, Ua.Query);
    var a = n && n.result, i = a && a.data;
    i && (this.previousData = i);
  }
  return e.prototype.forceUpdate = function() {
    __DEV__ && Or.warn("Calling default no-op implementation of InternalState#forceUpdate");
  }, e.prototype.asyncUpdate = function() {
    var t = this;
    return new Promise(function(r) {
      t.asyncResolveFns.add(r), t.optionsToIgnoreOnce.add(t.watchQueryOptions), t.forceUpdate();
    });
  }, e.prototype.useQuery = function(t) {
    var r = this;
    this.renderPromises = Et(Dx()).renderPromises, this.useOptions(t);
    var n = this.useObservableQuery(), a = sK(ue(function() {
      if (r.renderPromises)
        return function() {
        };
      var o = function() {
        var s = r.result, l = n.getCurrentResult();
        s && s.loading === l.loading && s.networkStatus === l.networkStatus && fl(s.data, l.data) || r.setResult(l);
      }, u = function(s) {
        var l = n.last;
        d.unsubscribe();
        try {
          n.resetLastResults(), d = n.subscribe(o, u);
        } finally {
          n.last = l;
        }
        if (!dK.call(s, "graphQLErrors"))
          throw s;
        var f = r.result;
        (!f || f && f.loading || !fl(s, f.error)) && r.setResult({
          data: f && f.data,
          error: s,
          loading: !1,
          networkStatus: hu.error
        });
      }, d = n.subscribe(o, u);
      return function() {
        return d.unsubscribe();
      };
    }, [
      n,
      this.renderPromises,
      this.client.disableNetworkFetches
    ]), function() {
      return r.getCurrentResult();
    }, function() {
      return r.getCurrentResult();
    });
    this.unsafeHandlePartialRefetch(a);
    var i = this.toQueryResult(a);
    return !i.loading && this.asyncResolveFns.size && (this.asyncResolveFns.forEach(function(o) {
      return o(i);
    }), this.asyncResolveFns.clear()), i;
  }, e.prototype.useOptions = function(t) {
    var r, n = this.createWatchQueryOptions(this.queryHookOptions = t), a = this.watchQueryOptions;
    (this.optionsToIgnoreOnce.has(a) || !fl(n, a)) && (this.watchQueryOptions = n, a && this.observable && (this.optionsToIgnoreOnce.delete(a), this.observable.reobserve(this.getObsQueryOptions()), this.previousData = ((r = this.result) === null || r === void 0 ? void 0 : r.data) || this.previousData, this.result = void 0)), this.onCompleted = t.onCompleted || e.prototype.onCompleted, this.onError = t.onError || e.prototype.onError, (this.renderPromises || this.client.disableNetworkFetches) && this.queryHookOptions.ssr === !1 && !this.queryHookOptions.skip ? this.result = this.ssrDisabledResult : this.queryHookOptions.skip || this.watchQueryOptions.fetchPolicy === "standby" ? this.result = this.skipStandbyResult : (this.result === this.ssrDisabledResult || this.result === this.skipStandbyResult) && (this.result = void 0);
  }, e.prototype.getObsQueryOptions = function() {
    var t = [], r = this.client.defaultOptions.watchQuery;
    return r && t.push(r), this.queryHookOptions.defaultOptions && t.push(this.queryHookOptions.defaultOptions), t.push(kx(this.observable && this.observable.options, this.watchQueryOptions)), t.reduce(sF);
  }, e.prototype.createWatchQueryOptions = function(t) {
    var r;
    t === void 0 && (t = {});
    var n = t.skip;
    t.ssr, t.onCompleted, t.onError, t.displayName, t.defaultOptions;
    var a = e9(t, ["skip", "ssr", "onCompleted", "onError", "displayName", "defaultOptions"]), i = Object.assign(a, { query: this.query });
    if (this.renderPromises && (i.fetchPolicy === "network-only" || i.fetchPolicy === "cache-and-network") && (i.fetchPolicy = "cache-first"), i.variables || (i.variables = {}), n) {
      var o = i.fetchPolicy, u = o === void 0 ? this.getDefaultFetchPolicy() : o, d = i.initialFetchPolicy, s = d === void 0 ? u : d;
      Object.assign(i, {
        initialFetchPolicy: s,
        fetchPolicy: "standby"
      });
    } else
      i.fetchPolicy || (i.fetchPolicy = ((r = this.observable) === null || r === void 0 ? void 0 : r.options.initialFetchPolicy) || this.getDefaultFetchPolicy());
    return i;
  }, e.prototype.getDefaultFetchPolicy = function() {
    var t, r;
    return ((t = this.queryHookOptions.defaultOptions) === null || t === void 0 ? void 0 : t.fetchPolicy) || ((r = this.client.defaultOptions.watchQuery) === null || r === void 0 ? void 0 : r.fetchPolicy) || "cache-first";
  }, e.prototype.onCompleted = function(t) {
  }, e.prototype.onError = function(t) {
  }, e.prototype.useObservableQuery = function() {
    var t = this.observable = this.renderPromises && this.renderPromises.getSSRObservable(this.watchQueryOptions) || this.observable || this.client.watchQuery(this.getObsQueryOptions());
    this.obsQueryFields = qe(function() {
      return {
        refetch: t.refetch.bind(t),
        reobserve: t.reobserve.bind(t),
        fetchMore: t.fetchMore.bind(t),
        updateQuery: t.updateQuery.bind(t),
        startPolling: t.startPolling.bind(t),
        stopPolling: t.stopPolling.bind(t),
        subscribeToMore: t.subscribeToMore.bind(t)
      };
    }, [t]);
    var r = !(this.queryHookOptions.ssr === !1 || this.queryHookOptions.skip);
    return this.renderPromises && r && (this.renderPromises.registerSSRObservable(t), t.getCurrentResult().loading && this.renderPromises.addObservableQueryPromise(t)), t;
  }, e.prototype.setResult = function(t) {
    var r = this.result;
    r && r.data && (this.previousData = r.data), this.result = t, this.forceUpdate(), this.handleErrorOrCompleted(t);
  }, e.prototype.handleErrorOrCompleted = function(t) {
    t.loading || (t.error ? this.onError(t.error) : t.data && this.onCompleted(t.data));
  }, e.prototype.getCurrentResult = function() {
    return this.result || this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult()), this.result;
  }, e.prototype.toQueryResult = function(t) {
    var r = this.toQueryResultCache.get(t);
    if (r)
      return r;
    var n = t.data;
    t.partial;
    var a = e9(t, ["data", "partial"]);
    return this.toQueryResultCache.set(t, r = Kr(Kr(Kr({ data: n }, a), this.obsQueryFields), { client: this.client, observable: this.observable, variables: this.observable.variables, called: !this.queryHookOptions.skip, previousData: this.previousData })), !r.error && rm(t.errors) && (r.error = new sd({ graphQLErrors: t.errors })), r;
  }, e.prototype.unsafeHandlePartialRefetch = function(t) {
    t.partial && this.queryHookOptions.partialRefetch && !t.loading && (!t.data || Object.keys(t.data).length === 0) && this.observable.options.fetchPolicy !== "cache-only" && (Object.assign(t, {
      loading: !0,
      networkStatus: hu.refetch
    }), this.observable.refetch());
  }, e;
}(), cK = [
  "refetch",
  "reobserve",
  "fetchMore",
  "updateQuery",
  "startPolling",
  "subscribeToMore"
];
function hK(e, t) {
  var r = Sx(Rf(t && t.client), e), n = tt(), a = n.current ? sF(t, n.current) : t, i = r.useQuery(Kr(Kr({}, a), { skip: !n.current })), o = i.observable.options.initialFetchPolicy || r.getDefaultFetchPolicy(), u = Object.assign(i, {
    called: !!n.current
  }), d = qe(function() {
    for (var l = {}, f = function(F) {
      var v = u[F];
      l[F] = function() {
        return n.current || (n.current = /* @__PURE__ */ Object.create(null), r.forceUpdate()), v.apply(this, arguments);
      };
    }, c = 0, h = cK; c < h.length; c++) {
      var _ = h[c];
      f(_);
    }
    return l;
  }, []);
  Object.assign(u, d);
  var s = ue(function(l) {
    n.current = l ? Kr(Kr({}, l), { fetchPolicy: l.fetchPolicy || o }) : {
      fetchPolicy: o
    };
    var f = r.asyncUpdate().then(function(c) {
      return Object.assign(c, d);
    });
    return f.catch(function() {
    }), f;
  }, []);
  return [s, u];
}
function gK(e, t) {
  var r = Rf(t == null ? void 0 : t.client);
  Cx(e, Ua.Mutation);
  var n = Xe({
    called: !1,
    loading: !1,
    client: r
  }), a = n[0], i = n[1], o = tt({
    result: a,
    mutationId: 0,
    isMounted: !0,
    client: r,
    mutation: e,
    options: t
  });
  Object.assign(o.current, { client: r, options: t, mutation: e });
  var u = ue(function(s) {
    s === void 0 && (s = {});
    var l = o.current, f = l.client, c = l.options, h = l.mutation, _ = Kr(Kr({}, c), { mutation: h });
    !o.current.result.loading && !_.ignoreResults && i(o.current.result = {
      loading: !0,
      error: void 0,
      data: void 0,
      called: !0,
      client: f
    });
    var F = ++o.current.mutationId, v = sF(_, s);
    return f.mutate(v).then(function($) {
      var E, D, w, k = $.data, A = $.errors, P = A && A.length > 0 ? new sd({ graphQLErrors: A }) : void 0;
      if (F === o.current.mutationId && !v.ignoreResults) {
        var S = {
          called: !0,
          loading: !1,
          data: k,
          error: P,
          client: f
        };
        o.current.isMounted && !fl(o.current.result, S) && i(o.current.result = S);
      }
      return (D = (E = o.current.options) === null || E === void 0 ? void 0 : E.onCompleted) === null || D === void 0 || D.call(E, $.data), (w = s.onCompleted) === null || w === void 0 || w.call(s, $.data), $;
    }).catch(function($) {
      var E, D, w, k;
      if (F === o.current.mutationId && o.current.isMounted) {
        var A = {
          loading: !1,
          error: $,
          data: void 0,
          called: !0,
          client: f
        };
        fl(o.current.result, A) || i(o.current.result = A);
      }
      if (!((E = o.current.options) === null || E === void 0) && E.onError || v.onError)
        return (w = (D = o.current.options) === null || D === void 0 ? void 0 : D.onError) === null || w === void 0 || w.call(D, $), (k = s.onError) === null || k === void 0 || k.call(s, $), { data: void 0, errors: $ };
      throw $;
    });
  }, []), d = ue(function() {
    i({ called: !1, loading: !1, client: r });
  }, []);
  return at(function() {
    return o.current.isMounted = !0, function() {
      o.current.isMounted = !1;
    };
  }, []), [u, Kr({ reset: d }, a)];
}
var X1 = {}, _K = {
  get exports() {
    return X1;
  },
  set exports(e) {
    X1 = e;
  }
};
const mK = /[\p{Lu}]/u, pK = /[\p{Ll}]/u, p9 = /^[\p{Lu}](?![\p{Lu}])/gu, Ax = /([\p{Alpha}\p{N}_]|$)/u, Ox = /[_.\- ]+/, FK = new RegExp("^" + Ox.source), F9 = new RegExp(Ox.source + Ax.source, "gu"), y9 = new RegExp("\\d+" + Ax.source, "gu"), yK = (e, t, r) => {
  let n = !1, a = !1, i = !1;
  for (let o = 0; o < e.length; o++) {
    const u = e[o];
    n && mK.test(u) ? (e = e.slice(0, o) + "-" + e.slice(o), n = !1, i = a, a = !0, o++) : a && i && pK.test(u) ? (e = e.slice(0, o - 1) + "-" + e.slice(o - 1), i = a, a = !1, n = !0) : (n = t(u) === u && r(u) !== u, i = a, a = r(u) === u && t(u) !== u);
  }
  return e;
}, bK = (e, t) => (p9.lastIndex = 0, e.replace(p9, (r) => t(r))), vK = (e, t) => (F9.lastIndex = 0, y9.lastIndex = 0, e.replace(F9, (r, n) => t(n)).replace(y9, (r) => t(r))), Tx = (e, t) => {
  if (!(typeof e == "string" || Array.isArray(e)))
    throw new TypeError("Expected the input to be `string | string[]`");
  if (t = {
    pascalCase: !1,
    preserveConsecutiveUppercase: !1,
    ...t
  }, Array.isArray(e) ? e = e.map((i) => i.trim()).filter((i) => i.length).join("-") : e = e.trim(), e.length === 0)
    return "";
  const r = t.locale === !1 ? (i) => i.toLowerCase() : (i) => i.toLocaleLowerCase(t.locale), n = t.locale === !1 ? (i) => i.toUpperCase() : (i) => i.toLocaleUpperCase(t.locale);
  return e.length === 1 ? t.pascalCase ? n(e) : r(e) : (e !== r(e) && (e = yK(e, r, n)), e = e.replace(FK, ""), t.preserveConsecutiveUppercase ? e = bK(e, r) : e = r(e), t.pascalCase && (e = n(e.charAt(0)) + e.slice(1)), vK(e, n));
};
_K.exports = Tx;
X1.default = Tx;
var EK = typeof global == "object" && global && global.Object === Object && global;
const Px = EK;
var $K = typeof self == "object" && self && self.Object === Object && self, wK = Px || $K || Function("return this")();
const ya = wK;
var kK = ya.Symbol;
const za = kK;
var Ix = Object.prototype, xK = Ix.hasOwnProperty, DK = Ix.toString, Wd = za ? za.toStringTag : void 0;
function CK(e) {
  var t = xK.call(e, Wd), r = e[Wd];
  try {
    e[Wd] = void 0;
    var n = !0;
  } catch {
  }
  var a = DK.call(e);
  return n && (t ? e[Wd] = r : delete e[Wd]), a;
}
var SK = Object.prototype, AK = SK.toString;
function OK(e) {
  return AK.call(e);
}
var TK = "[object Null]", PK = "[object Undefined]", b9 = za ? za.toStringTag : void 0;
function Ds(e) {
  return e == null ? e === void 0 ? PK : TK : b9 && b9 in Object(e) ? CK(e) : OK(e);
}
function Cs(e) {
  return e != null && typeof e == "object";
}
var IK = "[object Symbol]";
function xh(e) {
  return typeof e == "symbol" || Cs(e) && Ds(e) == IK;
}
function Rx(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var RK = Array.isArray;
const Ss = RK;
var jK = 1 / 0, v9 = za ? za.prototype : void 0, E9 = v9 ? v9.toString : void 0;
function jx(e) {
  if (typeof e == "string")
    return e;
  if (Ss(e))
    return Rx(e, jx) + "";
  if (xh(e))
    return E9 ? E9.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -jK ? "-0" : t;
}
var MK = /\s/;
function BK(e) {
  for (var t = e.length; t-- && MK.test(e.charAt(t)); )
    ;
  return t;
}
var NK = /^\s+/;
function LK(e) {
  return e && e.slice(0, BK(e) + 1).replace(NK, "");
}
function Ai(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var $9 = 0 / 0, qK = /^[-+]0x[0-9a-f]+$/i, UK = /^0b[01]+$/i, GK = /^0o[0-7]+$/i, WK = parseInt;
function w9(e) {
  if (typeof e == "number")
    return e;
  if (xh(e))
    return $9;
  if (Ai(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Ai(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = LK(e);
  var r = UK.test(e);
  return r || GK.test(e) ? WK(e.slice(2), r ? 2 : 8) : qK.test(e) ? $9 : +e;
}
function VK(e) {
  return e;
}
var HK = "[object AsyncFunction]", zK = "[object Function]", KK = "[object GeneratorFunction]", YK = "[object Proxy]";
function Mx(e) {
  if (!Ai(e))
    return !1;
  var t = Ds(e);
  return t == zK || t == KK || t == HK || t == YK;
}
var XK = ya["__core-js_shared__"];
const M_ = XK;
var k9 = function() {
  var e = /[^.]+$/.exec(M_ && M_.keys && M_.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function QK(e) {
  return !!k9 && k9 in e;
}
var ZK = Function.prototype, JK = ZK.toString;
function As(e) {
  if (e != null) {
    try {
      return JK.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var eY = /[\\^$.*+?()[\]{}|]/g, tY = /^\[object .+?Constructor\]$/, rY = Function.prototype, nY = Object.prototype, aY = rY.toString, iY = nY.hasOwnProperty, oY = RegExp(
  "^" + aY.call(iY).replace(eY, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function sY(e) {
  if (!Ai(e) || QK(e))
    return !1;
  var t = Mx(e) ? oY : tY;
  return t.test(As(e));
}
function uY(e, t) {
  return e == null ? void 0 : e[t];
}
function Os(e, t) {
  var r = uY(e, t);
  return sY(r) ? r : void 0;
}
var dY = Os(ya, "WeakMap");
const im = dY;
var x9 = Object.create, lY = function() {
  function e() {
  }
  return function(t) {
    if (!Ai(t))
      return {};
    if (x9)
      return x9(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}();
const fY = lY;
function cY(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
function kn() {
}
function hY(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var gY = 800, _Y = 16, mY = Date.now;
function pY(e) {
  var t = 0, r = 0;
  return function() {
    var n = mY(), a = _Y - (n - r);
    if (r = n, a > 0) {
      if (++t >= gY)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function FY(e) {
  return function() {
    return e;
  };
}
var yY = function() {
  try {
    var e = Os(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
const Q1 = yY;
var bY = Q1 ? function(e, t) {
  return Q1(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: FY(t),
    writable: !0
  });
} : VK;
const vY = bY;
var EY = pY(vY);
const $Y = EY;
function wY(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n && t(e[r], r, e) !== !1; )
    ;
  return e;
}
var kY = 9007199254740991, xY = /^(?:0|[1-9]\d*)$/;
function DY(e, t) {
  var r = typeof e;
  return t = t ?? kY, !!t && (r == "number" || r != "symbol" && xY.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function Bx(e, t, r) {
  t == "__proto__" && Q1 ? Q1(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
function Nx(e, t) {
  return e === t || e !== e && t !== t;
}
var CY = Object.prototype, SY = CY.hasOwnProperty;
function Lx(e, t, r) {
  var n = e[t];
  (!(SY.call(e, t) && Nx(n, r)) || r === void 0 && !(t in e)) && Bx(e, t, r);
}
function jf(e, t, r, n) {
  var a = !r;
  r || (r = {});
  for (var i = -1, o = t.length; ++i < o; ) {
    var u = t[i], d = n ? n(r[u], e[u], u, r, e) : void 0;
    d === void 0 && (d = e[u]), a ? Bx(r, u, d) : Lx(r, u, d);
  }
  return r;
}
var D9 = Math.max;
function AY(e, t, r) {
  return t = D9(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, a = -1, i = D9(n.length - t, 0), o = Array(i); ++a < i; )
      o[a] = n[t + a];
    a = -1;
    for (var u = Array(t + 1); ++a < t; )
      u[a] = n[a];
    return u[t] = r(o), cY(e, this, u);
  };
}
var OY = 9007199254740991;
function qx(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= OY;
}
function Ux(e) {
  return e != null && qx(e.length) && !Mx(e);
}
var TY = Object.prototype;
function uF(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || TY;
  return e === r;
}
function PY(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var IY = "[object Arguments]";
function C9(e) {
  return Cs(e) && Ds(e) == IY;
}
var Gx = Object.prototype, RY = Gx.hasOwnProperty, jY = Gx.propertyIsEnumerable, MY = C9(function() {
  return arguments;
}()) ? C9 : function(e) {
  return Cs(e) && RY.call(e, "callee") && !jY.call(e, "callee");
};
const Wx = MY;
function BY() {
  return !1;
}
var Vx = typeof exports == "object" && exports && !exports.nodeType && exports, S9 = Vx && typeof module == "object" && module && !module.nodeType && module, NY = S9 && S9.exports === Vx, A9 = NY ? ya.Buffer : void 0, LY = A9 ? A9.isBuffer : void 0, qY = LY || BY;
const Hx = qY;
var UY = "[object Arguments]", GY = "[object Array]", WY = "[object Boolean]", VY = "[object Date]", HY = "[object Error]", zY = "[object Function]", KY = "[object Map]", YY = "[object Number]", XY = "[object Object]", QY = "[object RegExp]", ZY = "[object Set]", JY = "[object String]", eX = "[object WeakMap]", tX = "[object ArrayBuffer]", rX = "[object DataView]", nX = "[object Float32Array]", aX = "[object Float64Array]", iX = "[object Int8Array]", oX = "[object Int16Array]", sX = "[object Int32Array]", uX = "[object Uint8Array]", dX = "[object Uint8ClampedArray]", lX = "[object Uint16Array]", fX = "[object Uint32Array]", Xt = {};
Xt[nX] = Xt[aX] = Xt[iX] = Xt[oX] = Xt[sX] = Xt[uX] = Xt[dX] = Xt[lX] = Xt[fX] = !0;
Xt[UY] = Xt[GY] = Xt[tX] = Xt[WY] = Xt[rX] = Xt[VY] = Xt[HY] = Xt[zY] = Xt[KY] = Xt[YY] = Xt[XY] = Xt[QY] = Xt[ZY] = Xt[JY] = Xt[eX] = !1;
function cX(e) {
  return Cs(e) && qx(e.length) && !!Xt[Ds(e)];
}
function dF(e) {
  return function(t) {
    return e(t);
  };
}
var zx = typeof exports == "object" && exports && !exports.nodeType && exports, cl = zx && typeof module == "object" && module && !module.nodeType && module, hX = cl && cl.exports === zx, B_ = hX && Px.process, gX = function() {
  try {
    var e = cl && cl.require && cl.require("util").types;
    return e || B_ && B_.binding && B_.binding("util");
  } catch {
  }
}();
const Pu = gX;
var O9 = Pu && Pu.isTypedArray, _X = O9 ? dF(O9) : cX;
const mX = _X;
var pX = Object.prototype, FX = pX.hasOwnProperty;
function Kx(e, t) {
  var r = Ss(e), n = !r && Wx(e), a = !r && !n && Hx(e), i = !r && !n && !a && mX(e), o = r || n || a || i, u = o ? PY(e.length, String) : [], d = u.length;
  for (var s in e)
    (t || FX.call(e, s)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (s == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (s == "offset" || s == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (s == "buffer" || s == "byteLength" || s == "byteOffset") || // Skip index properties.
    DY(s, d))) && u.push(s);
  return u;
}
function Yx(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var yX = Yx(Object.keys, Object);
const bX = yX;
var vX = Object.prototype, EX = vX.hasOwnProperty;
function $X(e) {
  if (!uF(e))
    return bX(e);
  var t = [];
  for (var r in Object(e))
    EX.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function lF(e) {
  return Ux(e) ? Kx(e) : $X(e);
}
function wX(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var kX = Object.prototype, xX = kX.hasOwnProperty;
function DX(e) {
  if (!Ai(e))
    return wX(e);
  var t = uF(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !xX.call(e, n)) || r.push(n);
  return r;
}
function fF(e) {
  return Ux(e) ? Kx(e, !0) : DX(e);
}
var CX = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, SX = /^\w*$/;
function AX(e, t) {
  if (Ss(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || xh(e) ? !0 : SX.test(e) || !CX.test(e) || t != null && e in Object(t);
}
var OX = Os(Object, "create");
const Sl = OX;
function TX() {
  this.__data__ = Sl ? Sl(null) : {}, this.size = 0;
}
function PX(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var IX = "__lodash_hash_undefined__", RX = Object.prototype, jX = RX.hasOwnProperty;
function MX(e) {
  var t = this.__data__;
  if (Sl) {
    var r = t[e];
    return r === IX ? void 0 : r;
  }
  return jX.call(t, e) ? t[e] : void 0;
}
var BX = Object.prototype, NX = BX.hasOwnProperty;
function LX(e) {
  var t = this.__data__;
  return Sl ? t[e] !== void 0 : NX.call(t, e);
}
var qX = "__lodash_hash_undefined__";
function UX(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Sl && t === void 0 ? qX : t, this;
}
function vs(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
vs.prototype.clear = TX;
vs.prototype.delete = PX;
vs.prototype.get = MX;
vs.prototype.has = LX;
vs.prototype.set = UX;
function GX() {
  this.__data__ = [], this.size = 0;
}
function Dh(e, t) {
  for (var r = e.length; r--; )
    if (Nx(e[r][0], t))
      return r;
  return -1;
}
var WX = Array.prototype, VX = WX.splice;
function HX(e) {
  var t = this.__data__, r = Dh(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : VX.call(t, r, 1), --this.size, !0;
}
function zX(e) {
  var t = this.__data__, r = Dh(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function KX(e) {
  return Dh(this.__data__, e) > -1;
}
function YX(e, t) {
  var r = this.__data__, n = Dh(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function Bi(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Bi.prototype.clear = GX;
Bi.prototype.delete = HX;
Bi.prototype.get = zX;
Bi.prototype.has = KX;
Bi.prototype.set = YX;
var XX = Os(ya, "Map");
const Al = XX;
function QX() {
  this.size = 0, this.__data__ = {
    hash: new vs(),
    map: new (Al || Bi)(),
    string: new vs()
  };
}
function ZX(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Ch(e, t) {
  var r = e.__data__;
  return ZX(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function JX(e) {
  var t = Ch(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function eQ(e) {
  return Ch(this, e).get(e);
}
function tQ(e) {
  return Ch(this, e).has(e);
}
function rQ(e, t) {
  var r = Ch(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function wo(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
wo.prototype.clear = QX;
wo.prototype.delete = JX;
wo.prototype.get = eQ;
wo.prototype.has = tQ;
wo.prototype.set = rQ;
var nQ = "Expected a function";
function cF(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(nQ);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, n);
    return r.cache = i.set(a, o) || i, o;
  };
  return r.cache = new (cF.Cache || wo)(), r;
}
cF.Cache = wo;
var aQ = 500;
function iQ(e) {
  var t = cF(e, function(n) {
    return r.size === aQ && r.clear(), n;
  }), r = t.cache;
  return t;
}
var oQ = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, sQ = /\\(\\)?/g, uQ = iQ(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(oQ, function(r, n, a, i) {
    t.push(a ? i.replace(sQ, "$1") : n || r);
  }), t;
});
const dQ = uQ;
function lQ(e) {
  return e == null ? "" : jx(e);
}
function hF(e, t) {
  return Ss(e) ? e : AX(e, t) ? [e] : dQ(lQ(e));
}
var fQ = 1 / 0;
function Xx(e) {
  if (typeof e == "string" || xh(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -fQ ? "-0" : t;
}
function cQ(e, t) {
  t = hF(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[Xx(t[r++])];
  return r && r == n ? e : void 0;
}
function gF(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var T9 = za ? za.isConcatSpreadable : void 0;
function hQ(e) {
  return Ss(e) || Wx(e) || !!(T9 && e && e[T9]);
}
function Qx(e, t, r, n, a) {
  var i = -1, o = e.length;
  for (r || (r = hQ), a || (a = []); ++i < o; ) {
    var u = e[i];
    t > 0 && r(u) ? t > 1 ? Qx(u, t - 1, r, n, a) : gF(a, u) : n || (a[a.length] = u);
  }
  return a;
}
function gQ(e) {
  var t = e == null ? 0 : e.length;
  return t ? Qx(e, 1) : [];
}
function _Q(e) {
  return $Y(AY(e, void 0, gQ), e + "");
}
var mQ = Yx(Object.getPrototypeOf, Object);
const _F = mQ;
var pQ = "[object Object]", FQ = Function.prototype, yQ = Object.prototype, Zx = FQ.toString, bQ = yQ.hasOwnProperty, vQ = Zx.call(Object);
function EQ(e) {
  if (!Cs(e) || Ds(e) != pQ)
    return !1;
  var t = _F(e);
  if (t === null)
    return !0;
  var r = bQ.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && Zx.call(r) == vQ;
}
function $Q(e, t, r) {
  var n = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), r = r > a ? a : r, r < 0 && (r += a), a = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var i = Array(a); ++n < a; )
    i[n] = e[n + t];
  return i;
}
function wQ() {
  this.__data__ = new Bi(), this.size = 0;
}
function kQ(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function xQ(e) {
  return this.__data__.get(e);
}
function DQ(e) {
  return this.__data__.has(e);
}
var CQ = 200;
function SQ(e, t) {
  var r = this.__data__;
  if (r instanceof Bi) {
    var n = r.__data__;
    if (!Al || n.length < CQ - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new wo(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function ud(e) {
  var t = this.__data__ = new Bi(e);
  this.size = t.size;
}
ud.prototype.clear = wQ;
ud.prototype.delete = kQ;
ud.prototype.get = xQ;
ud.prototype.has = DQ;
ud.prototype.set = SQ;
function AQ(e, t) {
  return e && jf(t, lF(t), e);
}
function OQ(e, t) {
  return e && jf(t, fF(t), e);
}
var Jx = typeof exports == "object" && exports && !exports.nodeType && exports, P9 = Jx && typeof module == "object" && module && !module.nodeType && module, TQ = P9 && P9.exports === Jx, I9 = TQ ? ya.Buffer : void 0, R9 = I9 ? I9.allocUnsafe : void 0;
function PQ(e, t) {
  if (t)
    return e.slice();
  var r = e.length, n = R9 ? R9(r) : new e.constructor(r);
  return e.copy(n), n;
}
function IQ(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (i[a++] = o);
  }
  return i;
}
function eD() {
  return [];
}
var RQ = Object.prototype, jQ = RQ.propertyIsEnumerable, j9 = Object.getOwnPropertySymbols, MQ = j9 ? function(e) {
  return e == null ? [] : (e = Object(e), IQ(j9(e), function(t) {
    return jQ.call(e, t);
  }));
} : eD;
const mF = MQ;
function BQ(e, t) {
  return jf(e, mF(e), t);
}
var NQ = Object.getOwnPropertySymbols, LQ = NQ ? function(e) {
  for (var t = []; e; )
    gF(t, mF(e)), e = _F(e);
  return t;
} : eD;
const tD = LQ;
function qQ(e, t) {
  return jf(e, tD(e), t);
}
function rD(e, t, r) {
  var n = t(e);
  return Ss(e) ? n : gF(n, r(e));
}
function UQ(e) {
  return rD(e, lF, mF);
}
function nD(e) {
  return rD(e, fF, tD);
}
var GQ = Os(ya, "DataView");
const om = GQ;
var WQ = Os(ya, "Promise");
const sm = WQ;
var VQ = Os(ya, "Set");
const um = VQ;
var M9 = "[object Map]", HQ = "[object Object]", B9 = "[object Promise]", N9 = "[object Set]", L9 = "[object WeakMap]", q9 = "[object DataView]", zQ = As(om), KQ = As(Al), YQ = As(sm), XQ = As(um), QQ = As(im), Yo = Ds;
(om && Yo(new om(new ArrayBuffer(1))) != q9 || Al && Yo(new Al()) != M9 || sm && Yo(sm.resolve()) != B9 || um && Yo(new um()) != N9 || im && Yo(new im()) != L9) && (Yo = function(e) {
  var t = Ds(e), r = t == HQ ? e.constructor : void 0, n = r ? As(r) : "";
  if (n)
    switch (n) {
      case zQ:
        return q9;
      case KQ:
        return M9;
      case YQ:
        return B9;
      case XQ:
        return N9;
      case QQ:
        return L9;
    }
  return t;
});
const pF = Yo;
var ZQ = Object.prototype, JQ = ZQ.hasOwnProperty;
function eZ(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && JQ.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var tZ = ya.Uint8Array;
const U9 = tZ;
function FF(e) {
  var t = new e.constructor(e.byteLength);
  return new U9(t).set(new U9(e)), t;
}
function rZ(e, t) {
  var r = t ? FF(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var nZ = /\w*$/;
function aZ(e) {
  var t = new e.constructor(e.source, nZ.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var G9 = za ? za.prototype : void 0, W9 = G9 ? G9.valueOf : void 0;
function iZ(e) {
  return W9 ? Object(W9.call(e)) : {};
}
function oZ(e, t) {
  var r = t ? FF(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var sZ = "[object Boolean]", uZ = "[object Date]", dZ = "[object Map]", lZ = "[object Number]", fZ = "[object RegExp]", cZ = "[object Set]", hZ = "[object String]", gZ = "[object Symbol]", _Z = "[object ArrayBuffer]", mZ = "[object DataView]", pZ = "[object Float32Array]", FZ = "[object Float64Array]", yZ = "[object Int8Array]", bZ = "[object Int16Array]", vZ = "[object Int32Array]", EZ = "[object Uint8Array]", $Z = "[object Uint8ClampedArray]", wZ = "[object Uint16Array]", kZ = "[object Uint32Array]";
function xZ(e, t, r) {
  var n = e.constructor;
  switch (t) {
    case _Z:
      return FF(e);
    case sZ:
    case uZ:
      return new n(+e);
    case mZ:
      return rZ(e, r);
    case pZ:
    case FZ:
    case yZ:
    case bZ:
    case vZ:
    case EZ:
    case $Z:
    case wZ:
    case kZ:
      return oZ(e, r);
    case dZ:
      return new n();
    case lZ:
    case hZ:
      return new n(e);
    case fZ:
      return aZ(e);
    case cZ:
      return new n();
    case gZ:
      return iZ(e);
  }
}
function DZ(e) {
  return typeof e.constructor == "function" && !uF(e) ? fY(_F(e)) : {};
}
var CZ = "[object Map]";
function SZ(e) {
  return Cs(e) && pF(e) == CZ;
}
var V9 = Pu && Pu.isMap, AZ = V9 ? dF(V9) : SZ;
const OZ = AZ;
var TZ = "[object Set]";
function PZ(e) {
  return Cs(e) && pF(e) == TZ;
}
var H9 = Pu && Pu.isSet, IZ = H9 ? dF(H9) : PZ;
const RZ = IZ;
var jZ = 1, MZ = 2, BZ = 4, aD = "[object Arguments]", NZ = "[object Array]", LZ = "[object Boolean]", qZ = "[object Date]", UZ = "[object Error]", iD = "[object Function]", GZ = "[object GeneratorFunction]", WZ = "[object Map]", VZ = "[object Number]", oD = "[object Object]", HZ = "[object RegExp]", zZ = "[object Set]", KZ = "[object String]", YZ = "[object Symbol]", XZ = "[object WeakMap]", QZ = "[object ArrayBuffer]", ZZ = "[object DataView]", JZ = "[object Float32Array]", eJ = "[object Float64Array]", tJ = "[object Int8Array]", rJ = "[object Int16Array]", nJ = "[object Int32Array]", aJ = "[object Uint8Array]", iJ = "[object Uint8ClampedArray]", oJ = "[object Uint16Array]", sJ = "[object Uint32Array]", Ut = {};
Ut[aD] = Ut[NZ] = Ut[QZ] = Ut[ZZ] = Ut[LZ] = Ut[qZ] = Ut[JZ] = Ut[eJ] = Ut[tJ] = Ut[rJ] = Ut[nJ] = Ut[WZ] = Ut[VZ] = Ut[oD] = Ut[HZ] = Ut[zZ] = Ut[KZ] = Ut[YZ] = Ut[aJ] = Ut[iJ] = Ut[oJ] = Ut[sJ] = !0;
Ut[UZ] = Ut[iD] = Ut[XZ] = !1;
function hl(e, t, r, n, a, i) {
  var o, u = t & jZ, d = t & MZ, s = t & BZ;
  if (r && (o = a ? r(e, n, a, i) : r(e)), o !== void 0)
    return o;
  if (!Ai(e))
    return e;
  var l = Ss(e);
  if (l) {
    if (o = eZ(e), !u)
      return hY(e, o);
  } else {
    var f = pF(e), c = f == iD || f == GZ;
    if (Hx(e))
      return PQ(e, u);
    if (f == oD || f == aD || c && !a) {
      if (o = d || c ? {} : DZ(e), !u)
        return d ? qQ(e, OQ(o, e)) : BQ(e, AQ(o, e));
    } else {
      if (!Ut[f])
        return a ? e : {};
      o = xZ(e, f, u);
    }
  }
  i || (i = new ud());
  var h = i.get(e);
  if (h)
    return h;
  i.set(e, o), RZ(e) ? e.forEach(function(v) {
    o.add(hl(v, t, r, v, e, i));
  }) : OZ(e) && e.forEach(function(v, $) {
    o.set($, hl(v, t, r, $, e, i));
  });
  var _ = s ? d ? nD : UQ : d ? fF : lF, F = l ? void 0 : _(e);
  return wY(F || e, function(v, $) {
    F && ($ = v, v = e[$]), Lx(o, $, hl(v, t, r, $, e, i));
  }), o;
}
var uJ = 1, dJ = 4;
function lJ(e) {
  return hl(e, uJ | dJ);
}
var fJ = function() {
  return ya.Date.now();
};
const N_ = fJ;
var cJ = "Expected a function", hJ = Math.max, gJ = Math.min;
function Iu(e, t, r) {
  var n, a, i, o, u, d, s = 0, l = !1, f = !1, c = !0;
  if (typeof e != "function")
    throw new TypeError(cJ);
  t = w9(t) || 0, Ai(r) && (l = !!r.leading, f = "maxWait" in r, i = f ? hJ(w9(r.maxWait) || 0, t) : i, c = "trailing" in r ? !!r.trailing : c);
  function h(A) {
    var P = n, S = a;
    return n = a = void 0, s = A, o = e.apply(S, P), o;
  }
  function _(A) {
    return s = A, u = setTimeout($, t), l ? h(A) : o;
  }
  function F(A) {
    var P = A - d, S = A - s, N = t - P;
    return f ? gJ(N, i - S) : N;
  }
  function v(A) {
    var P = A - d, S = A - s;
    return d === void 0 || P >= t || P < 0 || f && S >= i;
  }
  function $() {
    var A = N_();
    if (v(A))
      return E(A);
    u = setTimeout($, F(A));
  }
  function E(A) {
    return u = void 0, c && n ? h(A) : (n = a = void 0, o);
  }
  function D() {
    u !== void 0 && clearTimeout(u), s = 0, n = d = a = u = void 0;
  }
  function w() {
    return u === void 0 ? o : E(N_());
  }
  function k() {
    var A = N_(), P = v(A);
    if (n = arguments, a = this, d = A, P) {
      if (u === void 0)
        return _(d);
      if (f)
        return clearTimeout(u), u = setTimeout($, t), h(d);
    }
    return u === void 0 && (u = setTimeout($, t)), o;
  }
  return k.cancel = D, k.flush = w, k;
}
function _J(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
function mJ(e, t) {
  return t.length < 2 ? e : cQ(e, $Q(t, 0, -1));
}
function pJ(e, t) {
  return t = hF(t, e), e = mJ(e, t), e == null || delete e[Xx(_J(t))];
}
function FJ(e) {
  return EQ(e) ? void 0 : e;
}
var yJ = 1, bJ = 2, vJ = 4, EJ = _Q(function(e, t) {
  var r = {};
  if (e == null)
    return r;
  var n = !1;
  t = Rx(t, function(i) {
    return i = hF(i, e), n || (n = i.length > 1), i;
  }), jf(e, nD(e), r), n && (r = hl(r, yJ | bJ | vJ, FJ));
  for (var a = t.length; a--; )
    pJ(r, t[a]);
  return r;
});
const $J = EJ, yF = sh, NAe = (e, t, r) => r.some((n) => e[n] !== t[n]);
function LAe(e, t) {
  return [.../* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)])].filter((n) => e[n] !== t[n]);
}
function qAe(e, t) {
  return [.../* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)])].filter((n) => e[n] === t[n]);
}
const bF = (e, t) => e < t ? -1 : e > t ? 1 : 0, UAe = (e) => (t, r) => bF(
  e(t).toLowerCase(),
  e(r).toLowerCase()
), wJ = (e) => e instanceof Object && e.constructor === Object, GAe = (e) => Array(e).fill(void 0), WAe = (e, t) => {
  let r = lJ(e);
  return t.forEach((n) => {
    const a = (i, o) => i === n ? void 0 : o;
    r = JSON.parse(JSON.stringify(r), a);
  }), r;
}, VAe = (e) => new Promise((t) => {
  setTimeout(() => {
    t();
  }, e);
});
function kJ() {
  return Math.random().toString(16).slice(2);
}
function xJ() {
  return crypto != null && crypto.randomUUID ? crypto.randomUUID() : kJ();
}
var Qr = /* @__PURE__ */ ((e) => (e.INVALID_DATA = "INVALID_DATA", e.VALIDATION = "VALIDATION", e.NETWORK = "NETWORK", e.UNKNOWN = "UNKNOWN", e.UNAUTHORIZED = "UNAUTHORIZED", e.NOT_FOUND = "NOT_FOUND", e.TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS", e.GATEWAY_TIMEOUT = "GATEWAY_TIMEOUT", e))(Qr || {});
const DJ = (e) => e instanceof sd && e.networkError ? !e.networkError.statusCode : !1, Vd = (e) => (t) => t.networkError && "statusCode" in t.networkError ? e.includes(t.networkError.statusCode) : !1, sD = (e) => e instanceof sd && !!e.graphQLErrors.length, L_ = (e) => (t) => sD(t) ? t.graphQLErrors[0].message ? t.graphQLErrors[0].message.includes(e) : t.graphQLErrors.includes(e) : !1, CJ = (e) => Array.isArray(e) && e.length ? e[0] : typeof e == "string" ? e : wJ(e) ? Object.values(e)[0] : "", z9 = (e) => {
  if (!e)
    return null;
  let t = e;
  return e.errors ? t = e.errors : typeof e.error == "string" ? t = e : e.error && (t = e.error), Object.keys(t).reduce((r, n) => {
    const a = t[n];
    return { ...r, [X1(n)]: CJ(a) };
  }, {});
}, K9 = (e) => {
  const t = bH[e];
  return t || null;
}, Y9 = (e, t) => !e || !Object.keys(e).length ? null : Object.entries(e).reduce((r, [n, a]) => {
  var u, d, s;
  if (((u = t == null ? void 0 : t.keyMapper) == null ? void 0 : u[n]) === "")
    return r;
  const i = ((d = t == null ? void 0 : t.keyMapper) == null ? void 0 : d[n]) || n, o = yH[a] || ((s = t == null ? void 0 : t.valueMapper) == null ? void 0 : s[i]) || a;
  return {
    ...r,
    [i]: o
  };
}, {}), Es = (e) => {
  if (sD(e)) {
    const r = e.graphQLErrors;
    if (L_(D6)(e))
      return {
        type: Qr.NOT_FOUND,
        message: D6,
        errorI18nKey: pn.UNKNOWN_ERROR,
        graphQlErrors: r
      };
    if (L_($_)(e))
      return {
        type: Qr.NOT_FOUND,
        message: $_,
        graphQlErrors: r,
        errorI18nKey: pn.UNKNOWN_ERROR
      };
    if (L_(C6)(e))
      return {
        type: Qr.INVALID_DATA,
        message: C6,
        graphQlErrors: r,
        errorI18nKey: pn.INVALID_DATA_ERROR
      };
    if (r[0].status === 404)
      return {
        type: Qr.NOT_FOUND,
        message: $_,
        graphQlErrors: r,
        errorI18nKey: pn.UNKNOWN_ERROR
      };
    if (r.length && r[0].message && K9(r[0].message)) {
      const i = z9(
        r.reduce(
          (d, s) => ({
            ...d,
            [K9(s.message)]: s.message
          }),
          {}
        )
      ), o = Y9(i);
      return {
        type: Qr.VALIDATION,
        validationErrors: i,
        message: r[0].message,
        errorI18nKey: o ? Object.values(o)[0] : (
          /* istanbul ignore next */
          pn.UNKNOWN_ERROR
        ),
        validationErrorsI18nKeys: o,
        graphQlErrors: r
      };
    }
    return {
      type: Qr.UNKNOWN,
      message: e.message,
      graphQlErrors: r,
      errorI18nKey: pn.UNKNOWN_ERROR
    };
  }
  if (DJ(e))
    return {
      type: Qr.NETWORK,
      message: e.message,
      errorI18nKey: pn.NETWORK_ERROR
    };
  if (Vd(FH)(e))
    return {
      type: Qr.GATEWAY_TIMEOUT,
      message: e.message,
      errorI18nKey: pn.GATEWAY_TIMEOUT_ERROR
    };
  if (Vd(gH)(e))
    return {
      type: Qr.UNAUTHORIZED,
      message: e.message,
      errorI18nKey: pn.UNKNOWN_ERROR
    };
  if (Vd(_H)(e))
    return {
      type: Qr.NOT_FOUND,
      message: e.message,
      errorI18nKey: pn.UNKNOWN_ERROR
    };
  if (Vd(pH)(e))
    return {
      type: Qr.TOO_MANY_REQUESTS,
      message: e.message,
      errorI18nKey: pn.TOO_MANY_REQUESTS
    };
  if (Vd(mH)(e)) {
    const r = e.networkError, n = z9(r.result), a = Y9(n);
    return {
      type: Qr.VALIDATION,
      message: e.message,
      validationErrors: n,
      errorI18nKey: a ? Object.values(a)[0] : pn.UNKNOWN_ERROR,
      validationErrorsI18nKeys: a
    };
  }
  return {
    type: Qr.UNKNOWN,
    message: e.message,
    errorI18nKey: pn.UNKNOWN_ERROR
  };
};
class Sh extends Error {
  constructor(t, r) {
    super(t.statusText), this.response = t, this.body = r, Object.setPrototypeOf(this, Sh.prototype);
  }
}
class Ah extends Error {
  constructor(t) {
    super(t), Object.setPrototypeOf(this, Ah.prototype);
  }
}
class vF extends Error {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  constructor(r, n) {
    super(r);
    tu(this, "message");
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tu(this, "extraInfo");
    this.message = r, this.extraInfo = n, Object.setPrototypeOf(this, vF.prototype);
  }
}
class EF extends Error {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  constructor(r, n) {
    super(r);
    tu(this, "message");
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tu(this, "extraInfo");
    this.message = r, this.extraInfo = n, Object.setPrototypeOf(this, EF.prototype);
  }
}
const SJ = 46e5, HAe = (e) => {
  if (["image/jpeg", "image/png"].indexOf(e) === -1)
    return wr.WRONG_PICTURE_FORMAT;
}, zAe = (e) => {
  if (e > SJ)
    return wr.PICTURE_SIZE_TOO_LARGE;
};
async function KAe(e) {
  return new Promise((t, r) => {
    const n = new FileReader();
    n.readAsDataURL(e), n.onload = () => {
      t(n.result);
    }, n.onerror = r;
  });
}
const AJ = ["scroll", "auto"];
function OJ(e) {
  const t = e.scrollHeight > e.clientHeight, r = window.getComputedStyle(e).overflowY, n = AJ.includes(r);
  return t && n;
}
function uD(e) {
  return !e || e === document.body ? document.body : OJ(e) ? e : uD(e.parentNode);
}
var Ol = {}, TJ = {
  get exports() {
    return Ol;
  },
  set exports(e) {
    Ol = e;
  }
};
const dD = (e) => typeof e == "object" && e !== null, lD = Symbol("skip"), X9 = (e) => dD(e) && !(e instanceof RegExp) && !(e instanceof Error) && !(e instanceof Date), dm = (e, t, r, n = /* @__PURE__ */ new WeakMap()) => {
  if (r = {
    deep: !1,
    target: {},
    ...r
  }, n.has(e))
    return n.get(e);
  n.set(e, r.target);
  const { target: a } = r;
  delete r.target;
  const i = (o) => o.map((u) => X9(u) ? dm(u, t, r, n) : u);
  if (Array.isArray(e))
    return i(e);
  for (const [o, u] of Object.entries(e)) {
    const d = t(o, u, e);
    if (d === lD)
      continue;
    let [s, l, { shouldRecurse: f = !0 } = {}] = d;
    s !== "__proto__" && (r.deep && f && X9(l) && (l = Array.isArray(l) ? i(l) : dm(l, t, r, n)), a[s] = l);
  }
  return a;
};
TJ.exports = (e, t, r) => {
  if (!dD(e))
    throw new TypeError(`Expected an object, got \`${e}\` (${typeof e})`);
  return dm(e, t, r);
};
Ol.mapObjectSkip = lD;
const PJ = /[\p{Lu}]/u, IJ = /[\p{Ll}]/u, Q9 = /^[\p{Lu}](?![\p{Lu}])/gu, fD = /([\p{Alpha}\p{N}_]|$)/u, $F = /[_.\- ]+/, RJ = new RegExp("^" + $F.source), Z9 = new RegExp($F.source + fD.source, "gu"), J9 = new RegExp("\\d+" + fD.source, "gu"), jJ = (e, t, r, n) => {
  let a = !1, i = !1, o = !1, u = !1;
  for (let d = 0; d < e.length; d++) {
    const s = e[d];
    u = d > 2 ? e[d - 3] === "-" : !0, a && PJ.test(s) ? (e = e.slice(0, d) + "-" + e.slice(d), a = !1, o = i, i = !0, d++) : i && o && IJ.test(s) && (!u || n) ? (e = e.slice(0, d - 1) + "-" + e.slice(d - 1), o = i, i = !1, a = !0) : (a = t(s) === s && r(s) !== s, o = i, i = r(s) === s && t(s) !== s);
  }
  return e;
}, MJ = (e, t) => (Q9.lastIndex = 0, e.replace(Q9, (r) => t(r))), BJ = (e, t) => (Z9.lastIndex = 0, J9.lastIndex = 0, e.replace(Z9, (r, n) => t(n)).replace(J9, (r) => t(r)));
function NJ(e, t) {
  if (!(typeof e == "string" || Array.isArray(e)))
    throw new TypeError("Expected the input to be `string | string[]`");
  if (t = {
    pascalCase: !1,
    preserveConsecutiveUppercase: !1,
    ...t
  }, Array.isArray(e) ? e = e.map((i) => i.trim()).filter((i) => i.length).join("-") : e = e.trim(), e.length === 0)
    return "";
  const r = t.locale === !1 ? (i) => i.toLowerCase() : (i) => i.toLocaleLowerCase(t.locale), n = t.locale === !1 ? (i) => i.toUpperCase() : (i) => i.toLocaleUpperCase(t.locale);
  return e.length === 1 ? $F.test(e) ? "" : t.pascalCase ? n(e) : r(e) : (e !== r(e) && (e = jJ(e, r, n, t.preserveConsecutiveUppercase)), e = e.replace(RJ, ""), e = t.preserveConsecutiveUppercase ? MJ(e, r) : r(e), t.pascalCase && (e = n(e.charAt(0)) + e.slice(1)), BJ(e, n));
}
class LJ extends Map {
  constructor(t = {}) {
    if (super(), !(t.maxSize && t.maxSize > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    if (typeof t.maxAge == "number" && t.maxAge === 0)
      throw new TypeError("`maxAge` must be a number greater than 0");
    this.maxSize = t.maxSize, this.maxAge = t.maxAge || Number.POSITIVE_INFINITY, this.onEviction = t.onEviction, this.cache = /* @__PURE__ */ new Map(), this.oldCache = /* @__PURE__ */ new Map(), this._size = 0;
  }
  // TODO: Use private class methods when targeting Node.js 16.
  _emitEvictions(t) {
    if (typeof this.onEviction == "function")
      for (const [r, n] of t)
        this.onEviction(r, n.value);
  }
  _deleteIfExpired(t, r) {
    return typeof r.expiry == "number" && r.expiry <= Date.now() ? (typeof this.onEviction == "function" && this.onEviction(t, r.value), this.delete(t)) : !1;
  }
  _getOrDeleteIfExpired(t, r) {
    if (this._deleteIfExpired(t, r) === !1)
      return r.value;
  }
  _getItemValue(t, r) {
    return r.expiry ? this._getOrDeleteIfExpired(t, r) : r.value;
  }
  _peek(t, r) {
    const n = r.get(t);
    return this._getItemValue(t, n);
  }
  _set(t, r) {
    this.cache.set(t, r), this._size++, this._size >= this.maxSize && (this._size = 0, this._emitEvictions(this.oldCache), this.oldCache = this.cache, this.cache = /* @__PURE__ */ new Map());
  }
  _moveToRecent(t, r) {
    this.oldCache.delete(t), this._set(t, r);
  }
  *_entriesAscending() {
    for (const t of this.oldCache) {
      const [r, n] = t;
      this.cache.has(r) || this._deleteIfExpired(r, n) === !1 && (yield t);
    }
    for (const t of this.cache) {
      const [r, n] = t;
      this._deleteIfExpired(r, n) === !1 && (yield t);
    }
  }
  get(t) {
    if (this.cache.has(t)) {
      const r = this.cache.get(t);
      return this._getItemValue(t, r);
    }
    if (this.oldCache.has(t)) {
      const r = this.oldCache.get(t);
      if (this._deleteIfExpired(t, r) === !1)
        return this._moveToRecent(t, r), r.value;
    }
  }
  set(t, r, { maxAge: n = this.maxAge } = {}) {
    const a = typeof n == "number" && n !== Number.POSITIVE_INFINITY ? Date.now() + n : void 0;
    this.cache.has(t) ? this.cache.set(t, {
      value: r,
      expiry: a
    }) : this._set(t, { value: r, expiry: a });
  }
  has(t) {
    return this.cache.has(t) ? !this._deleteIfExpired(t, this.cache.get(t)) : this.oldCache.has(t) ? !this._deleteIfExpired(t, this.oldCache.get(t)) : !1;
  }
  peek(t) {
    if (this.cache.has(t))
      return this._peek(t, this.cache);
    if (this.oldCache.has(t))
      return this._peek(t, this.oldCache);
  }
  delete(t) {
    const r = this.cache.delete(t);
    return r && this._size--, this.oldCache.delete(t) || r;
  }
  clear() {
    this.cache.clear(), this.oldCache.clear(), this._size = 0;
  }
  resize(t) {
    if (!(t && t > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    const r = [...this._entriesAscending()], n = r.length - t;
    n < 0 ? (this.cache = new Map(r), this.oldCache = /* @__PURE__ */ new Map(), this._size = r.length) : (n > 0 && this._emitEvictions(r.slice(0, n)), this.oldCache = new Map(r.slice(n)), this.cache = /* @__PURE__ */ new Map(), this._size = 0), this.maxSize = t;
  }
  *keys() {
    for (const [t] of this)
      yield t;
  }
  *values() {
    for (const [, t] of this)
      yield t;
  }
  *[Symbol.iterator]() {
    for (const t of this.cache) {
      const [r, n] = t;
      this._deleteIfExpired(r, n) === !1 && (yield [r, n.value]);
    }
    for (const t of this.oldCache) {
      const [r, n] = t;
      this.cache.has(r) || this._deleteIfExpired(r, n) === !1 && (yield [r, n.value]);
    }
  }
  *entriesDescending() {
    let t = [...this.cache];
    for (let r = t.length - 1; r >= 0; --r) {
      const n = t[r], [a, i] = n;
      this._deleteIfExpired(a, i) === !1 && (yield [a, i.value]);
    }
    t = [...this.oldCache];
    for (let r = t.length - 1; r >= 0; --r) {
      const n = t[r], [a, i] = n;
      this.cache.has(a) || this._deleteIfExpired(a, i) === !1 && (yield [a, i.value]);
    }
  }
  *entriesAscending() {
    for (const [t, r] of this._entriesAscending())
      yield [t, r.value];
  }
  get size() {
    if (!this._size)
      return this.oldCache.size;
    let t = 0;
    for (const r of this.oldCache.keys())
      this.cache.has(r) || t++;
    return Math.min(this._size + t, this.maxSize);
  }
  entries() {
    return this.entriesAscending();
  }
  forEach(t, r = this) {
    for (const [n, a] of this.entriesAscending())
      t.call(r, a, n, this);
  }
  get [Symbol.toStringTag]() {
    return JSON.stringify([...this.entriesAscending()]);
  }
}
const qJ = (e, t) => e.some((r) => typeof r == "string" ? r === t : (r.lastIndex = 0, r.test(t))), q_ = new LJ({ maxSize: 1e5 }), ev = (e) => typeof e == "object" && e !== null && !(e instanceof RegExp) && !(e instanceof Error) && !(e instanceof Date), tv = (e, t) => {
  if (!ev(e))
    return e;
  t = {
    deep: !1,
    pascalCase: !1,
    ...t
  };
  const { exclude: r, pascalCase: n, stopPaths: a, deep: i } = t, o = new Set(a), u = (d) => (s, l) => {
    if (i && ev(l)) {
      const f = d === void 0 ? s : `${d}.${s}`;
      o.has(f) || (l = Ol(l, u(f)));
    }
    if (!(r && qJ(r, s))) {
      const f = n ? `${s}_` : s;
      if (q_.has(f))
        s = q_.get(f);
      else {
        const c = NJ(s, { pascalCase: n, locale: !1 });
        s.length < 100 && q_.set(f, c), s = c;
      }
    }
    return [s, l];
  };
  return Ol(e, u(void 0));
};
function UJ(e, t) {
  return Array.isArray(e) ? Object.keys(e).map((r) => tv(e[r], t)) : tv(e, t);
}
var Z1 = {}, GJ = {
  get exports() {
    return Z1;
  },
  set exports(e) {
    Z1 = e;
  }
};
const cD = (e) => typeof e == "object" && e !== null, hD = Symbol("skip"), rv = (e) => cD(e) && !(e instanceof RegExp) && !(e instanceof Error) && !(e instanceof Date), lm = (e, t, r, n = /* @__PURE__ */ new WeakMap()) => {
  if (r = {
    deep: !1,
    target: {},
    ...r
  }, n.has(e))
    return n.get(e);
  n.set(e, r.target);
  const { target: a } = r;
  delete r.target;
  const i = (o) => o.map((u) => rv(u) ? lm(u, t, r, n) : u);
  if (Array.isArray(e))
    return i(e);
  for (const [o, u] of Object.entries(e)) {
    const d = t(o, u, e);
    if (d === hD)
      continue;
    let [s, l, { shouldRecurse: f = !0 } = {}] = d;
    s !== "__proto__" && (r.deep && f && rv(l) && (l = Array.isArray(l) ? i(l) : lm(l, t, r, n)), a[s] = l);
  }
  return a;
};
GJ.exports = (e, t, r) => {
  if (!cD(e))
    throw new TypeError(`Expected an object, got \`${e}\` (${typeof e})`);
  return lm(e, t, r);
};
Z1.mapObjectSkip = hD;
function WJ(e) {
  return e.toLowerCase();
}
var VJ = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g], HJ = /[^A-Z0-9]+/gi;
function zJ(e, t) {
  t === void 0 && (t = {});
  for (var r = t.splitRegexp, n = r === void 0 ? VJ : r, a = t.stripRegexp, i = a === void 0 ? HJ : a, o = t.transform, u = o === void 0 ? WJ : o, d = t.delimiter, s = d === void 0 ? " " : d, l = nv(nv(e, n, "$1\0$2"), i, "\0"), f = 0, c = l.length; l.charAt(f) === "\0"; )
    f++;
  for (; l.charAt(c - 1) === "\0"; )
    c--;
  return l.slice(f, c).split("\0").map(u).join(s);
}
function nv(e, t, r) {
  return t instanceof RegExp ? e.replace(t, r) : t.reduce(function(n, a) {
    return n.replace(a, r);
  }, e);
}
function KJ(e, t) {
  return t === void 0 && (t = {}), zJ(e, Kr({ delimiter: "." }, t));
}
function gD(e, t) {
  return t === void 0 && (t = {}), KJ(e, Kr({ delimiter: "_" }, t));
}
const YJ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  snakeCase: gD
}, Symbol.toStringTag, { value: "Module" })), XJ = /* @__PURE__ */ oB(YJ), QJ = Z1, { snakeCase: ZJ } = XJ;
var _i = function(e, t) {
  return t = Object.assign({ deep: !0, exclude: [], parsingOptions: {} }, t), QJ(e, function(r, n) {
    return [
      JJ(t.exclude, r) ? r : ZJ(r, t.parsingOptions),
      n
    ];
  }, t);
};
function JJ(e, t) {
  return e.some(function(r) {
    return typeof r == "string" ? r === t : r.test(t);
  });
}
const eee = (e) => e.replace(/([^:]\/)\/+/g, "$1"), YAe = (e, t) => Object.keys(t).reduce(
  (r, n) => ({
    ...r,
    [n]: eee(e + t[n])
  }),
  {}
), _D = (e, t) => t ? Object.keys(t).reduce(
  (r, n) => r.replace(`:${n}`, t[n].toString()),
  e
) : e;
function XAe(e) {
  try {
    new URL(e);
  } catch {
    return !1;
  }
  return !0;
}
const mD = [
  "Timeout",
  "Failed to fetch",
  "Network request failed"
];
async function tee(e) {
  const t = e.clone();
  let r;
  try {
    r = await e.json();
  } catch {
    r = await t.text();
  }
  return r;
}
async function Oh(e, t, r) {
  const n = typeof e == "string" ? e : _D(e.route, e.routeParams), a = {};
  r && (a.authorization = `Bearer ${r}`);
  const i = {
    ...t,
    headers: {
      ...a,
      ...t.headers
    }
  };
  try {
    const o = await fetch(n, i), u = await tee(o);
    if (!o.ok)
      throw new Sh(o, u);
    return u;
  } catch (o) {
    throw o instanceof TypeError && mD.includes(o.message) ? new Ah(o.message) : o;
  }
}
function QAe({ base64: e, fileName: t }) {
  const r = document.createElement("a");
  r.href = `data:application/pdf;base64,${e}`, r.download = t.toLowerCase().endsWith(".pdf") ? t : `${t}.pdf`, r.click(), r.remove();
}
async function ZAe(e, t, r = {}) {
  try {
    const n = await fetch(e, {
      headers: r,
      mode: "cors"
    }), a = await n.blob(), i = window.URL.createObjectURL(a), o = document.createElement("a");
    if (o.href = i, o.setAttribute("download", t), o.click(), window.URL.revokeObjectURL(i), o.remove(), !n.ok)
      throw new Sh(n, a);
    return a;
  } catch (n) {
    throw n instanceof TypeError && mD.includes(n.message) ? new Ah(n.message) : n;
  }
}
async function JAe(e, t, r) {
  return Oh(
    e,
    {
      method: "GET",
      headers: { "content-type": "application/json", ...t }
    },
    r
  );
}
async function eOe(e, t, r) {
  return Oh(
    e,
    {
      method: "DELETE",
      headers: { "content-type": "application/json", ...t }
    },
    r
  );
}
function ree(e, t, r, n) {
  return Oh(
    e,
    {
      method: "POST",
      body: JSON.stringify(t),
      headers: { "content-type": "application/json", ...r }
    },
    n
  );
}
async function tOe(e, t, r, n) {
  const a = await ree(
    e,
    _i(t, { deep: !0 }),
    r,
    n
  );
  return await UJ(a, {
    deep: !0
  });
}
function rOe(e, t, r) {
  return Oh(
    e,
    {
      body: t,
      method: "POST"
    },
    r
  );
}
function nOe(e = 0, t = 0) {
  return e * 60 + t;
}
function aOe(e) {
  return {
    minutes: Math.floor(e / 60),
    seconds: e % 60
  };
}
const nee = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6], 0, 0, 0, 0, 0, 0, 0, [["6[2-467]\\d{3}", [5]], ["4\\d{4}", [5]], 0, 0, 0, 0, ["(?:0[1-9]|[1589]\\d)\\d{4}", [6]]]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [["[78]\\d{5}", [6]], ["690\\d{6}|[356]\\d{5}", [6, 9]], ["180[02]\\d{4}", [8]], ["[19]\\d{5}", [6]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[2-4679][2-8]\\d{6}", [8]], ["5[024-68]\\d{7}", [9]], ["400\\d{6}|800\\d{2,9}"], ["900[02]\\d{5}", [9]], 0, 0, ["600[25]\\d{5}", [9]], 0, 0, ["700[05]\\d{5}", [9]]]], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}"], ["7\\d{8}"]]], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268", [["268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}"], ["268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["26840[69]\\d{4}"], ["26848[01]\\d{4}"]]], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264", [["264(?:292|4(?:6[12]|9[78]))\\d{4}"], ["264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["264724\\d{4}"]]], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", [8]], ["6(?:[78][2-9]|9\\d)\\d{6}", [9]], ["800\\d{4}", [7]], ["900[1-9]\\d\\d", [6]], ["700[2-9]\\d{4}", [8]], 0, 0, 0, 0, ["808[1-9]\\d\\d", [6]]]], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}"], ["(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"], ["800\\d{5}"], ["90[016]\\d{5}"], 0, 0, 0, 0, ["60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[01])\\d{4}"], ["80[1-4]\\d{5}"]]], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}"], ["9[1-59]\\d{7}"]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1", 0, 0, [["3888[013-9]\\d{5}|3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}", [10]], ["93(?:7(?:1[15]|81)[46]|8(?:(?:21|4[16]|69|9[12])[46]|88[013-9]))\\d{5}|9(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"], ["800\\d{7,8}"], ["60[04579]\\d{7}", [10]], 0, 0, ["810\\d{7}", [10]]]], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684", [["6846(?:22|33|44|55|77|88|9[19])\\d{4}"], ["684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}"], ["6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", [7, 8, 9, 10, 11, 12, 13]], ["800\\d{6,10}", [9, 10, 11, 12, 13]], ["(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", [9, 10, 11, 12, 13]], 0, 0, 0, 0, ["5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", [5, 6, 7, 8, 9, 10, 11, 12, 13]], ["8(?:10|2[018])\\d{6,10}|828\\d{5}", [8, 9, 10, 11, 12, 13]]]], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], 0, 0, 0, 0, 0, 0, [["5(?:2\\d|8[1-9])\\d{4}"], ["(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"], ["800\\d{4}"], ["900\\d{4}"], 0, 0, 0, 0, ["(?:28\\d|501)\\d{4}"]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", [["18[1-8]\\d{3,6}", [6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}"], ["36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}"], ["88\\d{7}"], ["900200\\d{3}"]]], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", [8]], ["6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"], ["8[08]\\d{6}", [8]], ["9[0246]\\d{6}", [8]], 0, 0, ["703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", [8]], 0, 0, ["8[12]\\d{6}", [8]]]], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246", [["246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}"], ["246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:246976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}"], 0, ["24631\\d{5}"]]], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:222|[45]\\d)\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}"], ["(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", [10]], ["80[03]\\d{7}", [10]], 0, 0, 0, 0, 0, ["96(?:0[469]|1[0-47]|3[389]|6[69]|7[78])\\d{6}", [10]]]], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, [["80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", [8]], ["4[5-9]\\d{7}", [9]], ["800[1-9]\\d{4}", [8]], ["(?:70(?:2[0-57]|3[04-7]|44|6[569]|7[0579])|90(?:0[0-8]|1[36]|2[0-3568]|3[0-689]|4[02-68]|5[1-68]|6[0-378]|7[2-68]|9[34679]))\\d{4}", [8]], 0, 0, ["78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}", [8]], 0, 0, ["7879\\d{4}", [8]]]], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}"], ["(?:0[1-35-7]|5[1-8]|[67]\\d)\\d{6}"]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", [6, 7, 8]], ["(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", [8, 9]], ["(?:00800\\d\\d|800)\\d{5}", [8, 12]], ["90\\d{6}", [8]], 0, 0, 0, 0, 0, ["700\\d{5}", [8]]]], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[047]"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9]|88)|9[69][69])|7(?:1(?:11|78)|7\\d\\d))\\d{4}"], ["(?:3(?:[1-79]\\d|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}"], ["80\\d{6}"], ["(?:87|9[014578])\\d{6}"], 0, 0, 0, 0, 0, ["84\\d{6}"]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], 0, 0, 0, 0, 0, 0, [["(?:22|31)\\d{6}"], ["(?:29|[67][125-9])\\d{6}"]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]], 0, 0, 0, 0, 0, 0, [["2(?:02|1[037]|2[45]|3[68]|4\\d)\\d{5}"], ["(?:4[0-2]|[56]\\d|9[013-9])\\d{6}"], 0, 0, 0, 0, ["81\\d{6}"], 0, ["857[58]\\d{4}"]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[01])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441", [["441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}"], ["441(?:[2378]\\d|5[0-39]|92)\\d{5}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}"], ["(?:22[89]|[78]\\d\\d)\\d{4}"], 0, 0, 0, 0, 0, 0, ["5[34]\\d{5}"]]], BO: ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?", 0, 0, 0, [["(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", [8]], ["[67]\\d{7}", [8]], ["8001[07]\\d{4}", [9]]]], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]", [["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}"], ["(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]]], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", 0, 0, [["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", [10]], ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", [10, 11]], ["800\\d{6,7}", [9, 10]], ["300\\d{6}|[59]00\\d{6,7}", [9, 10]], 0, 0, 0, 0, 0, ["(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", [8, 10]]]], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242", [["242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}"], ["242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}"], ["242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["242225\\d{4}"]]], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", [7]], ["(?:1[67]|77)\\d{6}", [8]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-79]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}", [7]], ["(?:321|7(?:[1-7]\\d|8[0-4]))\\d{5}", [8]], ["(?:0800|800\\d)\\d{6}", [10]], ["90\\d{5}", [7]], 0, 0, 0, 0, ["79(?:1(?:[01]\\d|2[0-7])|2[0-7]\\d)\\d{3}", [8]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, [["(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", [9]], ["(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}", [9]], ["800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}"], ["(?:810|902)\\d{7}", [10]], 0, 0, 0, 0, ["249\\d{6}", [9]]], "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", [7]], ["6[0-35-7]\\d{5}", [7]], ["0800\\d{7}", [11]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["12\\d{7}|[1-6]\\d{6}"], ["88\\d{5}|(?:8[0-59]|9[017-9])\\d{7}"]]], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], 0, 0, 0, 0, 0, 0, [["2[12]\\d{6}"], ["7[024-7]\\d{6}"], 0, ["8776\\d{4}"]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], 0, 0, 0, 0, 0, 0, [["222[1-589]\\d{5}"], ["026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"], 0, ["80(?:0\\d\\d|120)\\d{4}"]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}"], ["7[35-9]\\d{7}"], ["800\\d{6}"], ["90[016]\\d{6}"], ["878\\d{6}"], 0, ["5[18]\\d{7}"], ["74[0248]\\d{6}"], 0, ["84[0248]\\d{6}"]]], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], 0, 0, 0, 0, 0, 0, [["2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}"], ["0[157]\\d{8}"]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[13-7]|4[1-5])\\d{3}"], ["[578]\\d{4}"]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], 0, 0, 0, 0, 0, 0, [["2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", [9]], ["", [9]], ["(?:123|8)00\\d{6}", [9, 11]], 0, 0, 0, 0, 0, ["44\\d{7}", [9]], ["600\\d{7,8}", [10, 11]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], 0, 0, 0, 0, 0, 0, [["2(?:22|33)\\d{6}", [9]], ["(?:24[23]|6[25-9]\\d)\\d{6}", [9]], ["88\\d{6,7}"]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, [["(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))", [7, 8, 9, 10, 11]], ["1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", [11]], ["(?:(?:10|21)8|8)00\\d{7}", [10, 12]], ["16[08]\\d{5}", [8]], 0, 0, 0, 0, 0, ["10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}", [7, 8, 9, 10, 11]]], "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0(4(?:[14]4|56)|[579])?", 0, 0, 0, [["601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|60[124-8][2-9]\\d{6}", [10]], ["3333(?:0(?:0\\d|1[0-5])|[4-9]\\d\\d)\\d{3}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}", [10]], ["1800\\d{7}", [11]], ["19(?:0[01]|4[78])\\d{7}", [11]]]], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))", 0, 0, 0, [["210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", [8]], ["(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", [8]], ["800\\d{7}", [10]], ["90[059]\\d{7}", [10]], 0, 0, 0, 0, ["(?:210[0-6]|4\\d{3}|5100)\\d{4}", [8]]]], CU: ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[23]|48)\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}"], ["5\\d{7}", [8]], ["800\\d{7}", [10]], 0, 0, 0, 0, 0, 0, ["807\\d{7}", [10]]]], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}"], ["(?:36|5[1-389]|9\\d)\\d{5}"], ["800\\d{4}"], 0, 0, 0, 0, 0, ["(?:3[3-5]|4[356])\\d{5}"]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]", [["9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}"], ["953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"], 0, 0, 0, 0, 0, ["955\\d{5}", [8]], 0, ["60[0-2]\\d{4}", [7]]]], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], 0, 0, 0, 0, 0, 0, [["2[2-6]\\d{6}"], ["9(?:10|[4-79]\\d)\\d{5}"], ["800\\d{5}"], ["90[09]\\d{5}"], ["700\\d{5}"], 0, ["(?:50|77)\\d{6}"], 0, 0, ["80[1-9]\\d{5}"]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}"], ["(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}"], ["800\\d{6}"], ["9(?:0[05689]|76)\\d{6}"], ["70[01]\\d{6}"], 0, ["9(?:5\\d|7[2-4])\\d{6}"], 0, ["9[17]0\\d{6}"], ["8[134]\\d{7}"]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0", 0, 0, 0, 0, 0, [["32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}", [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]], ["15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}", [10, 11]], ["800\\d{7,12}", [10, 11, 12, 13, 14, 15]], ["(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", [10, 11]], ["700\\d{8}", [11]], 0, ["18(?:1\\d{5,11}|[2-9]\\d{8})", [8, 9, 10, 11, 12, 13, 14]], ["16(?:4\\d{1,10}|[89]\\d{1,11})", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], 0, ["180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", [7, 8, 9, 10, 11, 12, 13, 14]]]], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], 0, 0, 0, 0, 0, 0, [["2(?:1[2-5]|7[45])\\d{5}"], ["77\\d{6}"]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}"], [""], ["80\\d{6}"], ["90\\d{6}"]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767", [["767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}"], ["767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9", [["8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}"], ["8[024]9[2-9]\\d{6}"], ["8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}"], ["(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["80[3-689]1\\d{5}", [9]], 0, 0, 0, 0, ["98[23]\\d{6}", [9]], ["80[12]1\\d{5}", [9]]]], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["[2-7][2-7]\\d{6}", [8]], ["964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", [9]], ["1800\\d{7}|1[78]00\\d{6}", [10, 11]], 0, 0, 0, 0, 0, ["[2-7]890\\d{4}", [8]]]], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", [7]], ["(?:5\\d{5}|8(?:1(?:0(?:000|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[3679]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", [7, 8]], ["800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}"], ["(?:40\\d\\d|900)\\d{4}", [7, 8]], ["70[0-2]\\d{5}", [8]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[189]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", [8, 9]], ["1[0-25]\\d{8}", [10]], ["800\\d{7}", [10]], ["900\\d{7}", [10]]]], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]", [["528[89]\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}"], ["80\\d{7}"], ["89\\d{7}"], 0, 0, 0, 0, ["592(?:4[0-2]|93)\\d{4}"]]], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}"], ["(?:17[1-3]|7\\d\\d)\\d{4}"]]], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}"], ["(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"], ["[89]00\\d{6}"], ["80[367]\\d{6}"], ["70\\d{7}"], 0, ["51\\d{7}"], 0, 0, ["90[12]\\d{6}"]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}"], ["7001\\d{5}|(?:7(?:0[1-9]|1[01]|77|86|99)|9\\d\\d)\\d{6}"]]], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", [["(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}", [5, 6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, [["603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", [7]], ["(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", [7]], ["0800\\d{7}", [11]]], "00"], FK: ["500", "00", "[2-7]\\d{4}", [5], 0, 0, 0, 0, 0, 0, 0, [["[2-47]\\d{4}"], ["[56]\\d{4}"]]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], 0, 0, 0, 0, 0, 0, [["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}"], ["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))", 0, 0, 0, [["(?:20|[34]\\d|8[19])\\d{4}"], ["(?:[27][1-9]|5\\d|9[16])\\d{4}"], ["80[257-9]\\d{3}"], ["90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d"], 0, 0, 0, 0, ["(?:6[0-36]|88)\\d{4}"]]], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:[1-35]\\d|4[1-9])\\d{7}"], ["(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}"], ["80[0-5]\\d{6}"], ["836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}"], 0, 0, ["80[6-9]\\d{6}"], 0, ["9\\d{8}"], ["8(?:1[01]|2[0156]|4[02]|84)\\d{6}"]]], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", 0, 0, [["[01]1\\d{6}", [8]], ["(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}"]]], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-579])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-246-9])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473", [["473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}"], ["473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}"], ["5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|(?:5(?:00(?:0\\d|44|5[05]|77|88|99)|1(?:1(?:00|[124]\\d|3[01])|4\\d\\d)|(?:44|68)\\d\\d|5(?:[0157-9]\\d\\d|200)|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[01]\\d|2[0-4])|58[89]|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}|5(?:0(?:070|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["70[67]\\d{6}"]]], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["594(?:[0239]\\d|1[0-2]|4[03-9]|5[6-9]|6[0-3]|80)\\d{4}"], ["694(?:[0-249]\\d|3[0-8])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:396|76\\d)\\d|476[01])\\d{4}"]]], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", [9]], ["(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", [9]], ["800\\d{5}", [8]]]], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]], 0, 0, 0, 0, 0, 0, [["2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}"], ["5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}"]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:19|3[1-7]|6[14689]|70|8[14-79]|9\\d)\\d{4}"], ["[245]\\d{5}"], ["80\\d{4}"], 0, 0, 0, 0, 0, ["3[89]\\d{4}"]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}"], ["(?:[23679]\\d|5[0-489])\\d{5}"]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", [8]], ["6[0-356]\\d{7}", [9]], 0, 0, 0, 0, 0, 0, ["722\\d{6}", [9]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1289]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[01])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}"], ["(?:222|55\\d)\\d{6}"], ["80\\d[1-9]\\d{5}"], ["90\\d[1-9]\\d{5}"]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}", [10]], ["68[57-9]\\d{7}|(?:69|94)\\d{8}", [10]], ["800\\d{7,9}"], ["90[19]\\d{7}", [10]], ["70\\d{8}", [10]], 0, ["5005000\\d{3}", [10]], 0, 0, ["8(?:0[16]|12|[27]5|50)\\d{7}", [10]]]], GT: ["502", "00", "(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["[267][2-9]\\d{6}", [8]], ["[3-5]\\d{7}", [8]], ["18[01]\\d{8}", [11]], ["19\\d{9}", [11]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([3-9]\\d{6})$|1", "671$1", 0, "671", [["671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], 0, 0, 0, 0, 0, 0, [["443\\d{6}", [9]], ["9(?:5\\d|6[569]|77)\\d{6}", [9]], 0, 0, 0, 0, 0, 0, ["40\\d{5}", [7]]]], GY: ["592", "001", "9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}"], ["(?:6\\d\\d|70[0-35-7])\\d{4}"], ["(?:289|862)\\d{4}"], ["9008\\d{3}"]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:[45][0-8]|6[01]|9\\d))|58(?:0[1-8]|1[2-9]))\\d{4}", [8]], ["(?:4(?:44[5-9]|6(?:0[0-7]|1[0-6]|4[0-57-9]|6[0-4]|7[0-8]))|573[0-6]|6(?:26[013-8]|66[0-3])|70(?:7[1-5]|8[0-4])|848[015-9]|9(?:29[013-9]|59[0-4]))\\d{4}|(?:4(?:4[01]|6[2358])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", [8]], ["800\\d{6}", [9]], ["900(?:[0-24-9]\\d{7}|3\\d{1,4})", [5, 6, 7, 8, 11]], ["8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", [8]], 0, ["30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", [8]], ["7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", [8]]], "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}", [8]], ["[37-9]\\d{7}", [8]], ["8002\\d{7}", [11]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", [8, 9]], ["9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|77|9[67])))\\d{4}|98\\d{6}", [8, 9]], ["80[01]\\d{4,6}", [7, 8, 9]], ["6[01459]\\d{6}|6[01]\\d{4,5}", [6, 7, 8]], ["7[45]\\d{6}", [8]], 0, ["62\\d{6,7}|72\\d{6}", [8, 9]]]], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2\\d|5[1-5]|81|9[149])\\d{5}"], ["(?:[34]\\d|55)\\d{6}"], ["8\\d{7}"], 0, 0, 0, 0, 0, ["9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}"]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06", 0, 0, 0, 0, 0, [["(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", [8]], ["(?:[257]0|3[01])\\d{7}", [9]], ["(?:[48]0\\d|680[29])\\d{5}"], ["9[01]\\d{6}", [8]], 0, 0, ["38\\d{7}", [9]], 0, ["21\\d{7}", [9]]]], ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}", [7, 8, 9, 10, 11]], ["8[1-35-9]\\d{7,10}", [9, 10, 11, 12]], ["00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}", [8, 9, 10, 11, 12, 13]], ["809\\d{7}", [10]], 0, 0, ["(?:1500|8071\\d{3})\\d{3}", [7, 10]], 0, 0, ["804\\d{7}", [10]]]], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}"], ["8(?:22|[35-9]\\d)\\d{6}", [9]], ["1800\\d{6}", [10]], ["15(?:1[2-8]|[2-8]0|9[089])\\d{6}", [10]], ["700\\d{6}", [9]], 0, ["818\\d{6}", [9]], 0, ["76\\d{7}", [9]], ["18[59]0\\d{6}", [10]]]], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0", 0, 0, 0, 0, 0, [["153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}", [8, 11, 12]], ["5(?:(?:[02368]\\d|[19][2-9]|4[1-9])\\d|5(?:01|1[79]|2[2-9]|3[0-3]|4[34]|5[015689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", [9]], ["1(?:255|80[019]\\d{3})\\d{3}", [7, 10]], ["1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", [8, 10]], 0, 0, ["1599\\d{6}", [10]], 0, ["7(?:380|8(?:33|55|77|81))\\d{5}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}", [9]], ["1700\\d{6}", [10]]]], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24", [["1624(?:230|[5-8]\\d\\d)\\d{3}"], ["76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"], ["808162\\d{4}"], ["8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}"], ["70\\d{8}"], 0, ["3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}"], 0, ["56\\d{8}"]]], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0", 0, 0, 0, 0, 0, [["2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}", [10]], ["(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}", [10]], ["000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))"], ["186[12]\\d{9}", [13]], 0, 0, ["140\\d{7}", [10]], 0, 0, ["1860\\d{7}", [11]]]], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]], 0, 0, 0, 0, 0, 0, [["37\\d{5}"], ["38\\d{5}"]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", [8, 9]], ["7[3-9]\\d{8}", [10]]]], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}", [6, 7, 10]], ["9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:1\\d|88)|9(?:0[0-3]|[19]\\d|21|77|8[7-9])))\\d{5}", [10]], 0, 0, 0, 0, ["96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])", [4, 5]]]], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", [7]], ["(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}"], ["80[0-8]\\d{4}", [7]], ["90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}", [7]], 0, 0, ["809\\d{4}", [7]], 0, ["49[0-24-79]\\d{4}", [7]]], "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876", [["8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[025-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}"], ["(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}", [8]], ["7(?:[78][0-25-9]|9\\d)\\d{6}", [9]], ["80\\d{6}", [8]], ["9\\d{7}", [8]], ["70\\d{7}", [9]], 0, ["8(?:10|8\\d)\\d{5}", [8]], ["74(?:66|77)\\d{5}", [9]], 0, ["85\\d{6}", [8]]]], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", [9]], ["[7-9]0[1-9]\\d{7}", [10]], ["00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}"], ["990\\d{6}", [9]], ["60\\d{7}", [9]], 0, ["570\\d{6}", [9]], ["20\\d{8}", [10]], ["50[1-9]\\d{7}", [10]]]], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}", [7, 8, 9]], ["(?:1(?:0[0-6]|1[0-5]|2[014]|30)|7\\d\\d)\\d{6}", [9]], ["800[2-8]\\d{5,6}", [9, 10]], ["900[02-9]\\d{5}", [9]]]], KG: ["996", "00", "8\\d{9}|(?:[235-8]\\d|99)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", [9]], ["312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|99[05-9])\\d{6}", [9]], ["800\\d{6,7}"]]], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})", [8, 9]], ["(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", [8, 9]], ["1800(?:1\\d|2[019])\\d{4}", [10]], ["1900(?:1\\d|2[09])\\d{4}", [10]]]], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0", 0, 0, 0, 0, 0, [["(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}"], ["(?:63\\d{3}|73(?:0[0-5]\\d|140))\\d{3}|[67]200[01]\\d{3}", [8]], 0, 0, 0, 0, 0, 0, ["30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", [8]]]], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]], 0, 0, 0, 0, 0, 0, [["7[4-7]\\d{5}"], ["[34]\\d{6}"], 0, ["8\\d{6}"]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869", [["869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}"], ["869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}"], ["19[1-3]\\d{7}", [10]]]], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?", 0, 0, 0, [["(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}", [5, 6, 8, 9, 10]], ["1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[1-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", [9, 10]], ["00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}", [9, 11, 12, 13, 14]], ["60[2-9]\\d{6}", [9]], ["50\\d{8,9}", [10, 11]], 0, ["1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[168]|88)|8(?:00|33|55|77|99))\\d{4}", [8]], ["15\\d{7,8}", [9, 10]], ["70\\d{8}", [10]]]], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", [8]], ["(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|66)|222|3[36]3|444|7(?:0[013-9]|[67]\\d)|888|9(?:[069]\\d|3[039]))|9(?:(?:0[09]|[4679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}", [8]], ["18\\d{5}", [7]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345", [["345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}"], ["345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:345976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["345849\\d{4}"]]], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", [["(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}", [10]], ["7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", [10]], ["8(?:00|108\\d{3})\\d{7}"], ["809\\d{7}", [10]], ["808\\d{7}", [10]], 0, 0, 0, ["751\\d{7}", [10]]], "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[13]|[35-7][14]|41|8[1468])\\d{6}", [8]], ["(?:20(?:[2359]\\d|7[6-8]|88)|302\\d)\\d{6}", [10]], 0, 0, 0, 0, ["30[013-9]\\d{6}", [9]]]], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0", 0, 0, 0, 0, 0, [["7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}"], ["793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}"], 0, ["9[01]\\d{6}", [8]], 0, 0, 0, 0, 0, ["80\\d{6}", [8]]]], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758", [["758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}"], ["758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0", 0, 0, 0, [["(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}", [7]], ["(?:6(?:(?:4[5-9]|5[0-4])\\d|6(?:[0245]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"], ["8002[28]\\d\\d|80(?:05\\d|9)\\d{4}"], ["90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", [7]], 0, 0, ["870(?:28|87)\\d\\d", [7]]]], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}"], ["7(?:[0-25-8]\\d|4[0-4])\\d{6}"], 0, 0, 0, 0, ["1973\\d{5}"]]], LR: ["231", "00", "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2\\d{3}|33333)\\d{4}", [8, 9]], ["(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}", [7, 9]], 0, ["332(?:02|[34]\\d)\\d{4}", [9]]]], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["[56]\\d{7}"], ["800[256]\\d{4}"]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]", 0, 0, 0, [["(?:3[1478]|4[124-6]|52)\\d{6}"], ["6\\d{7}"], ["80[02]\\d{5}"], ["9(?:0[0239]|10)\\d{5}"], ["70[05]\\d{5}"], 0, ["70[67]\\d{5}"], 0, ["[89]01\\d{5}"], ["808\\d{5}"]]], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", 0, 0, 0, [["(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}"], ["6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", [9]], ["800\\d{5}", [8]], ["90[015]\\d{5}", [8]], 0, 0, 0, 0, ["20(?:1\\d{5}|[2-689]\\d{1,7})", [4, 5, 6, 7, 8, 9, 10]], ["801\\d{5}", [8]]]], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]], 0, 0, 0, 0, 0, 0, [["6\\d{7}"], ["23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}"], ["80\\d{6}"], ["90\\d{6}"], 0, 0, 0, 0, 0, ["81\\d{6}"]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}"], ["9[1-6]\\d{7}"]]], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29[1289]|389)", "529(?:1[1-46-9]|2[013-8]|90)|5(?:298|389)[0-46-9]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5293[01]\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|9[0-289])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[0189]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}"], ["80\\d{7}"], ["89\\d{7}"], 0, 0, 0, 0, ["592(?:4[0-2]|93)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:870|9[2-47-9]\\d)\\d{5}", [8]], ["4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"], ["(?:800|90\\d)\\d{5}", [8]]]], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}"], ["562\\d{5}|(?:6\\d|7[16-9])\\d{6}"], ["800\\d{5}"], ["90[056]\\d{5}"], 0, 0, ["803\\d{5}"], 0, ["3[08]\\d{6}"], ["808\\d{5}"]]], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}", [8]], ["6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", [8]], ["80(?:[0-2578]|9\\d)\\d{5}"], ["9(?:4[1568]|5[178])\\d{5}", [8]], 0, 0, ["77[1-9]\\d{5}", [8]], 0, ["78[1-49]\\d{5}", [8]]]], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[01])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1", 0, 0, [["2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}"], ["3[2-47-9]\\d{7}"], 0, 0, 0, 0, 0, 0, ["22\\d{7}"]]], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1", 0, 0, 0, 0, 0, [["(?:247|528|625)\\d{4}"], ["(?:(?:23|54)5|329|45[356])\\d{4}"], 0, 0, 0, 0, 0, 0, ["635\\d{4}"]]], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}"], ["7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}"], ["800\\d{5}"], ["5\\d{7}"], 0, 0, 0, 0, 0, ["8(?:0[1-9]|[1-9]\\d)\\d{5}"]]], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}"], ["2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}"], ["80\\d{6}"]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[29]|39|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|39|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:(?:3\\d|8[01459])\\d|4(?:39|[67]0))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}", [6, 7, 8, 9]], ["(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", [7, 8, 9, 10]], ["80080(?:0[1-9]|2\\d)\\d{3}", [10]], 0, 0, 0, 0, 0, ["1333\\d{4}|[12]468\\d{4}", [8]]]], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[12]2[1-3]\\d{5,6}|7(?:0[0-5]\\d|128)\\d{4}|(?:[12](?:1|27)|5[368])\\d{6}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}"], ["(?:83[01]|920)\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}", [8]], 0, 0, 0, 0, 0, 0, ["712[0-79]\\d{4}|7(?:1[013-9]|[25-9]\\d)\\d{5}", [8]]]], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], 0, 0, 0, 0, 0, 0, [["(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}", [8]], ["6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", [8]], ["0800\\d{3}", [7]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670", [["670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["596(?:[03-7]\\d|10|2[7-9]|8[09]|9[4-9])\\d{4}"], ["69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:397[01]|477[0-2]|76(?:6\\d|7[0-367]))\\d{4}"]]], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]], 0, 0, 0, 0, 0, 0, [["(?:25[08]|35\\d|45[1-7])\\d{5}"], ["[2-4][0-46-9]\\d{6}"], ["800\\d{5}"]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664", [["6644(?:1[0-3]|91)\\d{4}"], ["664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], 0, 0, 0, 0, 0, 0, [["20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}"], ["(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"], ["800(?:02|[3467]\\d)\\d{3}"], ["5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}"], 0, 0, ["501\\d{5}"], ["7117\\d{4}"], ["3550\\d{4}"]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-7])|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", [7, 8]], ["5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[01]|3[03]))\\d{5}", [8]], ["802\\d{7}|80[0-2]\\d{4}", [7, 10]], ["30\\d{5}", [7]], 0, 0, 0, 0, ["3(?:20|9\\d)\\d{4}", [7]]], "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:0[0-3]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}", [7]], ["(?:46[46]|[79]\\d\\d)\\d{4}", [7]], ["800\\d{7}", [10]], ["900\\d{7}", [10]], 0, 0, ["4(?:0[01]|50)\\d{4}", [7]]], "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[2-9]|2[12]\\d\\d)\\d{5}"], ["111\\d{6}|(?:31|77|[89][89])\\d{7}", [9]]]], MX: ["52", "0[09]", "1(?:(?:[27]2|44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, [["657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}", [10]], ["657[12]\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}"], ["8(?:00|88)\\d{7}", [10]], ["900\\d{7}", [10]], ["500\\d{7}", [10]], 0, 0, 0, 0, ["300\\d{7}", [10]]], "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", [8, 9]], ["1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-6]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}", [9, 10]], ["1[378]00\\d{6}", [10]], ["1600\\d{6}", [10]], 0, 0, 0, 0, ["15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}", [10]]]], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", [8]], ["8[2-79]\\d{7}", [9]], ["800\\d{6}", [9]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}"], ["(?:60|8[1245])\\d{7}", [9]], ["80\\d{7}", [9]], ["8701\\d{5}", [9]], 0, 0, 0, 0, ["8(?:3\\d\\d|86)\\d{5}"]]], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}"], ["(?:5[0-4]|[79]\\d|8[0-79])\\d{4}"], ["050\\d{3}"], ["36\\d{4}"]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[04]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}"], ["(?:23|7[04]|[89]\\d)\\d{6}"], ["08\\d{6}"], ["09\\d{6}"]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1", 0, 0, [["(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}"], ["(?:14|3[58])\\d{4}"]]], NG: ["234", "009", "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}", [7, 8]], ["(?:702[0-24-9]|819[01])\\d{6}|(?:70[13-689]|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-356]))\\d{7}", [10]], ["800\\d{7,11}", [10, 11, 12, 13, 14]], 0, 0, 0, ["700\\d{7,11}", [10, 11, 12, 13, 14]]]], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"], ["1800\\d{4}"]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}", [9]], ["(?:6[1-58]|970\\d)\\d{7}", [9, 11]], ["800\\d{4,7}", [7, 8, 9, 10]], ["90[069]\\d{4,7}", [7, 8, 9, 10]], 0, 0, ["140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", [5, 6, 9]], ["66\\d{7}", [9]], ["(?:85|91)\\d{7}", [9]]]], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[489]|59"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]", [["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", [8]], ["(?:4[015-8]|59|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], 0, ["(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", [8]], ["9(?:6[0-3]|7[024-6]|8[0-24-68])\\d{7}", [10]], ["1(?:66001|800\\d\\d)\\d{5}", [11]]]], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]], 0, 0, 0, 0, 0, 0, [["444\\d{4}"], ["(?:55[3-9]|666|8\\d\\d)\\d{4}"]]], NU: ["683", "00", "(?:[47]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["[47]\\d{3}", [4]], ["888[4-9]\\d{3}", [7]]]], NZ: ["64", "0(?:0|161)", "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-579]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|[89]0", "50(?:[0367]|88)|[89]0"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[59]|80"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7|86"], "0$1"]], "0", 0, 0, 0, 0, 0, [["24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", [8]], ["2[0-27-9]\\d{7,8}|21\\d{6}", [8, 9, 10]], ["508\\d{6,7}|80\\d{6,8}", [8, 9, 10]], ["(?:11\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", [7, 8, 9, 10]], ["70\\d{7}", [9]], 0, ["8(?:1[6-9]|22|3\\d|4[045]|5[459]|7[0-3579]|90)\\d{2,7}"], ["[28]6\\d{6,7}", [8, 9]]], "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], 0, 0, 0, 0, 0, 0, [["2[2-6]\\d{6}", [8]], ["1505\\d{4}|(?:7(?:[1289]\\d|7[0-5])|9(?:0[1-9]|[1-9]\\d))\\d{5}", [8]], ["8007\\d{4,5}|(?:500|800[05])\\d{4}"], ["900\\d{5}", [8]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[58]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[089]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068]|7[0-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[056]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}", [7]], ["(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", [7, 8]], ["800\\d{4,5}|(?:00800|800\\d)\\d{6}"], ["(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", [7]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", [8]], ["9\\d{8}", [9]], ["800\\d{5}", [8]], ["805\\d{5}", [8]], ["80[24]\\d{5}", [8]], 0, 0, 0, 0, ["801\\d{5}", [8]]], "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["4(?:0[4-689]|9[4-68])\\d{5}", [8]], ["8[7-9]\\d{6}", [8]], ["80[0-5]\\d{6}", [9]], 0, 0, 0, ["44\\d{4}", [6]], 0, ["499\\d{5}", [8]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, [["(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", [7]], ["(?:7\\d|8[128])\\d{6}", [8]], ["180\\d{4}", [7]], 0, 0, 0, 0, ["27[01]\\d{4}", [7]], ["2(?:0[0-57]|7[568])\\d{4}", [7]]], "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}", [6, 8, 9, 10]], ["(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", [10]], ["1800\\d{7,9}", [11, 12, 13]]]], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", [9, 10]], ["3(?:[0-24]\\d|3[0-7]|55|64)\\d{7}", [10]], ["800\\d{5}(?:\\d{3})?", [8, 11]], ["900\\d{5}", [8]], ["122\\d{6}", [9]], 0, ["(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}", [11, 12]]]], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", [7, 9]], ["21(?:1(?:[145]\\d|3[1-5])|2[0-4]\\d)\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", [9]], ["800\\d{6,7}", [9, 10]], ["70[01346-8]\\d{6}", [9]], 0, 0, ["804\\d{6}", [9]], ["64\\d{4,7}", [6, 7, 8, 9]], ["39\\d{7}", [9]], ["801\\d{6}", [9]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[1-356]|50)\\d{4}", [6]], ["(?:4[02-4]|5[056]|708[45][0-5])\\d{4}"], ["80[0-5]\\d{6}", [9]]]], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939", [["(?:787|939)[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}", [8]], ["5[69]\\d{7}", [9]], ["1800\\d{6}", [10]], 0, 0, 0, 0, 0, 0, ["1700\\d{6}", [10]]]], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}"], ["6(?:[06]92(?:30|9\\d)|[35]92(?:3[03]|9\\d))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"], ["80[02]\\d{6}"], ["(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}"], ["884[0-4689]\\d{5}"], 0, ["70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}"], ["6222\\d{5}"], ["30\\d{7}"], ["80(?:8\\d|9[1579])\\d{5}"]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}"], ["(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}"]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}", [7, 8, 9]], ["9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}", [9]], ["9800\\d{5,7}", [9, 10, 11]], 0, 0, 0, ["[2-9]0\\d{4,7}", [6, 7, 8, 9]], 0, ["8700[0-4]\\d{4}", [9]]]], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], 0, 0, 0, 0, 0, 0, [["4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}", [8]], ["[35-7]\\d{7}", [8]], ["800\\d{4}|(?:0080[01]|800)\\d{6}", [7, 9, 11]], 0, 0, 0, 0, ["2(?:1\\d|61)\\d{4}", [7]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-3]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:0[0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|6[0-6]|7[0-27]|8[0-8]|9[0-479]))|9(?:399[0-2]|479[01]|76(?:2[27]|3[0-37]|9\\d)))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, 0, ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d"], ["7020\\d{5}|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-29])\\d{6}", [9]], ["800\\d{6}", [9]], ["90[0136]\\d{6}", [9]], 0, 0, ["(?:37\\d|80[578])\\d{6}", [9]], 0, 0, ["801\\d{6}", [9]]], 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", [7, 8, 9, 10, 11, 12]], ["6(?:[0-689]|7\\d)\\d{6,7}", [8, 9, 10]], ["800\\d{3,9}"], ["(?:78\\d|90[0169])\\d{3,7}", [6, 7, 8, 9, 10]], 0, 0, ["7[06]\\d{4,10}"]]], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", [["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]]], "0", 0, 0, 0, 0, 0, [["(?:06|2[23568]\\d)\\d{6}"], ["7[2389]\\d{7}", [9]], ["800\\d{6}", [9]], ["900\\d{6}", [9]]]], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, 0, 0, 0, 0, [["1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", [9]], ["579[01]\\d{5}|5(?:[013-689]\\d|7[0-35-8])\\d{6}", [9]], ["800\\d{7}", [10]], ["925\\d{6}", [9]], 0, 0, ["811\\d{7}", [10]], 0, 0, ["920\\d{6}", [9]]]], SB: ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]], 0, 0, 0, 0, 0, 0, [["(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", [5]], ["48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"], ["1[38]\\d{3}", [5]], 0, 0, 0, 0, 0, ["5[12]\\d{3}", [5]]]], SC: ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, [["4[2-46]\\d{5}"], ["2[125-8]\\d{5}"], ["800[08]\\d{3}"], 0, 0, 0, 0, 0, ["971\\d{4}|(?:64|95)\\d{5}"]], "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:5\\d|8[35-7])\\d{6}"], ["(?:1[0-2]|9[0-3569])\\d{7}"]]], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0", 0, 0, 0, 0, 0, [["(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}", [7, 8, 9]], ["7[02369]\\d{7}", [9]], ["20\\d{4,7}", [6, 7, 8, 9]], ["649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", [7, 8, 9, 10]], ["75[1-8]\\d{6}", [9]], 0, ["10[1-8]\\d{6}", [9]], ["74[02-9]\\d{6}", [9]], 0, ["77[0-7]\\d{6}", [9]]]], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-6]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}", [8]], ["8(?:06[0-6]|95[0-2])\\d{4}|(?:8(?:0[1-5]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}", [8]], ["(?:18|8)00\\d{7}", [10, 11]], ["1900\\d{7}", [11]], 0, 0, ["7000\\d{7}", [11]], 0, ["(?:3[12]\\d|666)\\d{5}", [8]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]", [["2(?:[0-57-9]\\d|6[4-9])\\d\\d"], ["[56]\\d{4}", [5]], 0, 0, 0, 0, 0, 0, ["262\\d\\d", [5]]]], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:[1-357][2-8]|4[24-8])\\d{6}", [8]], ["65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", [8]], ["80\\d{4,6}", [6, 7, 8]], ["89[1-3]\\d{2,5}|90\\d{4,6}"], 0, 0, 0, 0, ["(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", [8]]], "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79", [["79\\d{6}", [8]], ["(?:4[015-8]|59|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], 0, ["(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d"], ["909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["9(?:00|[78]\\d)\\d{6}", [9]], 0, 0, ["96\\d{7}", [9]], ["9090\\d{3}", [7]], ["6(?:02|5[0-4]|9[0-6])\\d{6}", [9]], ["8[5-9]\\d{7}", [9]]]], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["22[2-4][2-9]\\d{4}"], ["(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}"]]], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1", 0, 0, [["0549(?:8[0157-9]|9\\d)\\d{4}", [10]], ["6[16]\\d{6}", [8]], 0, ["7[178]\\d{6}", [8]], 0, 0, 0, 0, ["5[158]\\d{6}", [8]]]], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}"], ["7(?:(?:[06-8]\\d|21|90)\\d|5(?:01|[19]0|25|[38]3|[4-7]\\d))\\d{5}"], ["800\\d{6}"], ["88[4689]\\d{6}"], 0, 0, 0, 0, ["(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}"], ["81[02468]\\d{6}"]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3478]|64|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"]]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}", [6, 7]], ["(?:(?:15|(?:3[59]|4[89]|79|8[08])\\d|6(?:0[5-7]|[1-9]\\d)|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", [7, 8, 9]]]], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}"], ["(?:7[124-7]|8[124-9])\\d{5}", [7]], 0, 0, 0, 0, 0, 0, ["56\\d{4}", [6]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1[89]\\d{7}"], ["(?:12|9[1257-9])\\d{7}"]]], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["22\\d{5}"], ["900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"]]], SV: ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[1-6]\\d{3}|[79]90[034]|890[0245])\\d{3}", [8]], ["66(?:[02-9]\\d\\d|1(?:[02-9]\\d|16))\\d{3}|(?:6[0-57-9]|7\\d)\\d{6}", [8]], ["800\\d{4}(?:\\d{4})?", [7, 11]], ["900\\d{4}(?:\\d{4})?", [7, 11]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721", [["7215(?:4[2-8]|8[239]|9[056])\\d{4}"], ["7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}"], ["9[1-689]\\d{7}", [9]]]], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]], 0, 0, 0, 0, 0, 0, [["[23][2-5]\\d{6}", [8]], ["7[6-9]\\d{6}", [8]], ["0800\\d{4}", [8]], ["900\\d{6}", [9]], 0, 0, 0, 0, ["70\\d{6}", [8]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8", [["8\\d{3}"]]], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649", [["649(?:266|712|9(?:4\\d|50))\\d{4}"], ["649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["649(?:71[01]|966)\\d{4}"]]], TD: ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, [["22(?:[37-9]0|5[0-5]|6[89])\\d{4}"], ["(?:6[0235689]|77|9\\d)\\d{6}"]], "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}"], ["(?:7[019]|9[0-36-9])\\d{6}"]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", [8]], ["671[0-8]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", [9]], ["(?:001800\\d|1800)\\d{6}", [10, 13]], ["1900\\d{6}", [10]], 0, 0, 0, 0, ["6[08]\\d{7}", [9]]]], TJ: ["992", "810", "(?:00|[1-57-9]\\d)\\d{7}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}"], ["41[18]\\d{6}|(?:[034]0|1[017]|2[02]|5[05]|7[0178]|8[078]|9\\d)\\d{7}"]], "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7], 0, 0, 0, 0, 0, 0, 0, [["(?:2[2-4]|[34]\\d)\\d{2,5}"], ["7[2-4]\\d{2,5}"]]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", [7]], ["7[2-8]\\d{6}", [8]], ["80\\d{5}", [7]], ["90\\d{5}", [7]], ["70\\d{5}", [7]]]], TM: ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, [["(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}"], ["6\\d{7}"]], "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], 0, 0, 0, 0, 0, 0, [["81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}"], ["3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-7])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"], ["8010\\d{4}"], ["88\\d{6}"], 0, 0, 0, 0, 0, ["8[12]10\\d{4}"]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", [5]], ["(?:55[4-6]|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}", [7]], ["0800\\d{3}", [7]], 0, 0, 0, 0, 0, ["55[0-37-9]\\d{4}", [7]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}", [10]], ["56161\\d{5}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", [10]], ["8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", [10, 12, 13]], ["(?:8[89]8|900)\\d{7}", [10]], ["592(?:21[12]|461)\\d{4}", [10]], 0, ["444\\d{4}", [7]], ["512\\d{7}", [10]], ["850\\d{7}", [10]]]], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868", [["868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}"], ["868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["2[02-9]\\d{3}", [5]], ["(?:7[01]\\d|90)\\d{4}", [6, 7]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}", [8, 9]], ["(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", [9]], ["80[0-79]\\d{6}|800\\d{5}", [8, 9]], ["20(?:[013-9]\\d\\d|2)\\d{4}", [7, 9]], ["99\\d{7}", [9]], 0, ["50[0-46-9]\\d{6}", [9]], 0, ["7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", [10, 11]]], 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[2-8]\\d{7}"], ["77[2-9]\\d{6}|(?:6[125-9]|7[13-689])\\d{7}"], ["80[08]\\d{6}"], ["90\\d{7}"], 0, 0, 0, 0, ["41\\d{7}"], ["8(?:40|6[01])\\d{6}"]]], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", [9]], ["(?:39|50|6[36-8]|7[1-3]|9[1-9])\\d{7}", [9]], ["800[1-8]\\d{5,6}"], ["900[239]\\d{5,6}"], 0, 0, 0, 0, ["89[1-579]\\d{6}", [9]]], "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|32|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}"], ["726[01]\\d{5}|7(?:[01578]\\d|20|36|[46][0-4]|9[89])\\d{6}"], ["800[1-3]\\d{5}"], ["90[1-3]\\d{6}"]]], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:4722(?:0[0-35]|27)|505(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|4[46])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "(?:0004|4)\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [7, 8, 10, 13], [["(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, [["(?:1(?:770|987)|(?:2\\d|4[2-7])\\d\\d)\\d{4}", [8]], ["9[1-9]\\d{6}", [8]], ["(?:(?:0004|4)\\d{5}|80[05])\\d{4}|405\\d{4}", [7, 10, 13]], ["90[0-8]\\d{4}", [7]]], "00", " int. "], UZ: ["998", "810", "(?:33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[35-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, [["(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|8\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}"], ["(?:(?:33|50|88|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"]], "8~10"], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698", [["06698\\d{1,6}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784", [["784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}"], ["784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["78451[0-2]\\d{4}"]]], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}"], ["4(?:1[24-8]|2[46])\\d{7}"], ["800\\d{7}"], ["90[01]\\d{7}"], 0, 0, ["501\\d{7}"]]], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284", [["284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}"], ["284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340", [["340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", [10]], ["(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", [9]], ["1800\\d{4,6}|12(?:0[13]|28)\\d{4}", [8, 9, 10]], ["1900\\d{4,6}", [8, 9, 10]], 0, 0, ["(?:[17]99|80\\d)\\d{4}|69\\d{5,6}", [7, 8]], 0, ["672\\d{6}", [9]]]], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", [5]], ["(?:[58]\\d|7[013-7])\\d{5}", [7]], ["81[18]\\d\\d", [5]], 0, 0, 0, ["(?:3[03]|900\\d)\\d{3}"], 0, ["9(?:0[1-9]|1[01])\\d{4}", [7]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["72\\d{4}", [6]], ["(?:72|8[23])\\d{4}", [6]], ["80[0-5]\\d{6}", [9]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", [5, 6]], ["(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", [7, 10]], ["800\\d{3}", [6]]]], XK: ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[89]|39)0\\d{6}|[23][89]\\d{6}"], ["4[3-9]\\d{6}", [8]], ["800\\d{5}", [8]], ["900\\d{5}", [8]]]], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", [7, 8]], ["7[01378]\\d{7}", [9]]]], YT: ["262", "00", "(?:(?:(?:26|63)9|80\\d)\\d\\d|93980)\\d{4}", [9], 0, "0", 0, 0, 0, 0, "269|63|9398", [["269(?:0[0-467]|5[0-3]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|93980)\\d{4}"], ["80\\d{7}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", [9]], ["(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", [5, 6, 7, 8, 9]], ["80\\d{7}", [9]], ["(?:86[2-9]|9[0-2]\\d)\\d{6}", [9]], 0, 0, ["861\\d{6,7}", [9, 10]], 0, ["87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}", [9]], ["860\\d{6}", [9]]]], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["21[1-8]\\d{6}"], ["(?:7[5-79]|9[5-8])\\d{7}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["63\\d{7}"]]], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}"], ["7(?:[178]\\d|3[1-9])\\d{6}", [9]], ["80(?:[01]\\d|20|8[0-8])\\d{3}", [7]], 0, 0, 0, 0, 0, ["86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", [10]]]] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "[0-36-9]\\d{8}", [9], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[013-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function aee(e, t) {
  var r = Array.prototype.slice.call(t);
  return r.push(nee), e.apply(this, r);
}
function fm(e) {
  return fm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fm(e);
}
function av(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function iee(e, t, r) {
  return t && av(e.prototype, t), r && av(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function oee(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function see(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Tl(e, t);
}
function uee(e) {
  var t = FD();
  return function() {
    var n = Pl(e), a;
    if (t) {
      var i = Pl(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return dee(this, a);
  };
}
function dee(e, t) {
  if (t && (fm(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return pD(e);
}
function pD(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function cm(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return cm = function(n) {
    if (n === null || !lee(n))
      return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(n))
        return t.get(n);
      t.set(n, a);
    }
    function a() {
      return C1(n, arguments, Pl(this).constructor);
    }
    return a.prototype = Object.create(n.prototype, { constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 } }), Tl(a, n);
  }, cm(e);
}
function C1(e, t, r) {
  return FD() ? C1 = Reflect.construct : C1 = function(a, i, o) {
    var u = [null];
    u.push.apply(u, i);
    var d = Function.bind.apply(a, u), s = new d();
    return o && Tl(s, o.prototype), s;
  }, C1.apply(null, arguments);
}
function FD() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function lee(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function Tl(e, t) {
  return Tl = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, Tl(e, t);
}
function Pl(e) {
  return Pl = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Pl(e);
}
var vi = /* @__PURE__ */ function(e) {
  see(r, e);
  var t = uee(r);
  function r(n) {
    var a;
    return oee(this, r), a = t.call(this, n), Object.setPrototypeOf(pD(a), r.prototype), a.name = a.constructor.name, a;
  }
  return iee(r);
}(/* @__PURE__ */ cm(Error)), wF = 2, fee = 17, cee = 3, tn = "0-9０-９٠-٩۰-۹", hee = "-‐-―−ー－", gee = "／/", _ee = "．.", mee = "  ­​⁠　", pee = "()（）［］\\[\\]", Fee = "~⁓∼～", ha = "".concat(hee).concat(gee).concat(_ee).concat(mee).concat(pee).concat(Fee), Th = "+＋";
function iv(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var r = e[0].split("."), n = t[0].split("."), a = 0; a < 3; a++) {
    var i = Number(r[a]), o = Number(n[a]);
    if (i > o)
      return 1;
    if (o > i)
      return -1;
    if (!isNaN(i) && isNaN(o))
      return 1;
    if (isNaN(i) && !isNaN(o))
      return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
function J1(e) {
  return J1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, J1(e);
}
function Ph(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ov(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Ih(e, t, r) {
  return t && ov(e.prototype, t), r && ov(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var yee = "1.2.0", bee = "1.7.35", sv = " ext. ", vee = /^\d+$/, Yr = /* @__PURE__ */ function() {
  function e(t) {
    Ph(this, e), kee(t), this.metadata = t, yD.call(this, t);
  }
  return Ih(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(r) {
        return r !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(r) {
      return this.metadata.countries[r];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(r) {
      return this.getCountryMetadata(r) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(r) {
      if (this.getCountryCodesForCallingCode(r))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[r])
          return !0;
      } else {
        var n = this.countryCallingCodes()[r];
        if (n && n.length === 1 && n[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(r) {
      return this.nonGeographic() ? !!this.nonGeographic()[r] : !this.getCountryCodesForCallingCode(r);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(r) {
      return this.selectNumberingPlan(r);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(r, n) {
      if (r && vee.test(r) && (n = r, r = null), r && r !== "001") {
        if (!this.hasCountry(r))
          throw new Error("Unknown country: ".concat(r));
        this.numberingPlan = new uv(this.getCountryMetadata(r), this);
      } else if (n) {
        if (!this.hasCallingCode(n))
          throw new Error("Unknown calling code: ".concat(n));
        this.numberingPlan = new uv(this.getNumberingPlanMetadata(n), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(r) {
      var n = this.countryCallingCodes()[r];
      if (n)
        return n.length === 1 && n[0].length === 3 ? void 0 : n;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(r) {
      var n = this.getCountryCodesForCallingCode(r);
      if (n)
        return n[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(r) {
      var n = this.getCountryCodeForCallingCode(r);
      if (n)
        return this.getCountryMetadata(n);
      if (this.nonGeographic()) {
        var a = this.nonGeographic()[r];
        if (a)
          return a;
      } else {
        var i = this.countryCallingCodes()[r];
        if (i && i.length === 1 && i[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(r) {
      return this.numberingPlan.type(r);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(r) {
      return this.selectNumberingPlan(r);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), uv = /* @__PURE__ */ function() {
  function e(t, r) {
    Ph(this, e), this.globalMetadataObject = r, this.metadata = t, yD.call(this, r.metadata);
  }
  return Ih(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(r) {
      return r[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var r = this, n = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return n.map(function(a) {
        return new Eee(a, r);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(r) {
      return r[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(r) {
      if (this.hasTypes() && dv(this.types(), r))
        return new wee(dv(this.types(), r), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? sv : this.metadata[13] || sv;
    }
  }]), e;
}(), Eee = /* @__PURE__ */ function() {
  function e(t, r) {
    Ph(this, e), this._format = t, this.metadata = r;
  }
  return Ih(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !$ee.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), $ee = /^\(?\$1\)?$/, wee = /* @__PURE__ */ function() {
  function e(t, r) {
    Ph(this, e), this.type = t, this.metadata = r;
  }
  return Ih(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function dv(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function kee(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!U_(e) || !U_(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(U_(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + xee(e) + ": " + e, "."));
}
var U_ = function(t) {
  return J1(t) === "object";
}, xee = function(t) {
  return J1(t);
};
function kF(e, t) {
  if (t = new Yr(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function Dee(e, t) {
  return t.countries[e] !== void 0;
}
function yD(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? iv(t, yee) === -1 ? this.v2 = !0 : iv(t, bee) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var Cee = ";ext=", ou = function(t) {
  return "([".concat(tn, "]{1,").concat(t, "})");
};
function bD(e) {
  var t = "20", r = "15", n = "9", a = "6", i = "[  \\t,]*", o = "[:\\.．]?[  \\t,-]*", u = "#?", d = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", s = "(?:[xｘ#＃~～]|int|ｉｎｔ)", l = "[- ]+", f = "[  \\t]*", c = "(?:,{2}|;)", h = Cee + ou(t), _ = i + d + o + ou(t) + u, F = i + s + o + ou(n) + u, v = l + ou(a) + "#", $ = f + c + o + ou(r) + u, E = f + "(?:,)+" + o + ou(n) + u;
  return h + "|" + _ + "|" + F + "|" + v + "|" + $ + "|" + E;
}
var See = "[" + tn + "]{" + wF + "}", Aee = "[" + Th + "]{0,1}(?:[" + ha + "]*[" + tn + "]){3,}[" + ha + tn + "]*", Oee = new RegExp("^[" + Th + "]{0,1}(?:[" + ha + "]*[" + tn + "]){1,2}$", "i"), Tee = Aee + // Phone number extensions
"(?:" + bD() + ")?", Pee = new RegExp(
  // Either a short two-digit-only phone number
  "^" + See + "$|^" + Tee + "$",
  "i"
);
function Iee(e) {
  return e.length >= wF && Pee.test(e);
}
function Ree(e) {
  return Oee.test(e);
}
var lv = new RegExp("(?:" + bD() + ")$", "i");
function jee(e) {
  var t = e.search(lv);
  if (t < 0)
    return {};
  for (var r = e.slice(0, t), n = e.match(lv), a = 1; a < n.length; ) {
    if (n[a])
      return {
        number: r,
        ext: n[a]
      };
    a++;
  }
}
function Mee(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r)
    return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Bee(e)) || t && e && typeof e.length == "number") {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Bee(e, t) {
  if (e) {
    if (typeof e == "string")
      return fv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return fv(e, t);
  }
}
function fv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var Nee = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function vD(e) {
  return Nee[e];
}
function e0(e) {
  for (var t = "", r = Mee(e.split("")), n; !(n = r()).done; ) {
    var a = n.value, i = vD(a);
    i && (t += i);
  }
  return t;
}
function Lee(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r)
    return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = qee(e)) || t && e && typeof e.length == "number") {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qee(e, t) {
  if (e) {
    if (typeof e == "string")
      return cv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return cv(e, t);
  }
}
function cv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function hv(e) {
  for (var t = "", r = Lee(e.split("")), n; !(n = r()).done; ) {
    var a = n.value;
    t += Uee(a, t) || "";
  }
  return t;
}
function Uee(e, t) {
  return e === "+" ? t ? void 0 : "+" : vD(e);
}
function Gee(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r)
    return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Wee(e)) || t && e && typeof e.length == "number") {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Wee(e, t) {
  if (e) {
    if (typeof e == "string")
      return gv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return gv(e, t);
  }
}
function gv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Vee(e, t) {
  for (var r = e.slice(), n = Gee(t), a; !(a = n()).done; ) {
    var i = a.value;
    e.indexOf(i) < 0 && r.push(i);
  }
  return r.sort(function(o, u) {
    return o - u;
  });
}
function Rh(e, t) {
  return ED(e, void 0, t);
}
function ED(e, t, r) {
  var n = r.type(t), a = n && n.possibleLengths() || r.possibleLengths();
  if (!a)
    return "IS_POSSIBLE";
  if (t === "FIXED_LINE_OR_MOBILE") {
    if (!r.type("FIXED_LINE"))
      return ED(e, "MOBILE", r);
    var i = r.type("MOBILE");
    i && (a = Vee(a, i.possibleLengths()));
  } else if (t && !n)
    return "INVALID_LENGTH";
  var o = e.length, u = a[0];
  return u === o ? "IS_POSSIBLE" : u > o ? "TOO_SHORT" : a[a.length - 1] < o ? "TOO_LONG" : a.indexOf(o, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function Hee(e, t, r) {
  if (t === void 0 && (t = {}), r = new Yr(r), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    r.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!r.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      r.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      r.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (r.possibleLengths())
    return $D(e.phone || e.nationalNumber, r);
  if (e.countryCallingCode && r.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function $D(e, t) {
  switch (Rh(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function Oi(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function zee(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r)
    return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Kee(e)) || t && e && typeof e.length == "number") {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Kee(e, t) {
  if (e) {
    if (typeof e == "string")
      return _v(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return _v(e, t);
  }
}
function _v(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var Yee = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function xF(e, t, r) {
  if (t = t || {}, !!e.country) {
    r = new Yr(r), r.selectNumberingPlan(e.country, e.countryCallingCode);
    var n = t.v2 ? e.nationalNumber : e.phone;
    if (Oi(n, r.nationalNumberPattern())) {
      if (G_(n, "FIXED_LINE", r))
        return r.type("MOBILE") && r.type("MOBILE").pattern() === "" || !r.type("MOBILE") || G_(n, "MOBILE", r) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var a = zee(Yee), i; !(i = a()).done; ) {
        var o = i.value;
        if (G_(n, o, r))
          return o;
      }
    }
  }
}
function G_(e, t, r) {
  return t = r.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : Oi(e, t.pattern());
}
function Xee(e, t, r) {
  if (t = t || {}, r = new Yr(r), r.selectNumberingPlan(e.country, e.countryCallingCode), r.hasTypes())
    return xF(e, t, r.metadata) !== void 0;
  var n = t.v2 ? e.nationalNumber : e.phone;
  return Oi(n, r.nationalNumberPattern());
}
function Qee(e, t, r) {
  var n = new Yr(r), a = n.getCountryCodesForCallingCode(e);
  return a ? a.filter(function(i) {
    return Zee(t, i, r);
  }) : [];
}
function Zee(e, t, r) {
  var n = new Yr(r);
  return n.selectNumberingPlan(t), n.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
function wD(e) {
  return e.replace(new RegExp("[".concat(ha, "]+"), "g"), " ").trim();
}
var kD = /(\$\d)/;
function xD(e, t, r) {
  var n = r.useInternationalFormat, a = r.withNationalPrefix;
  r.carrierCode, r.metadata;
  var i = e.replace(new RegExp(t.pattern()), n ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    a && t.nationalPrefixFormattingRule() ? t.format().replace(kD, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return n ? wD(i) : i;
}
var Jee = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function ete(e, t, r) {
  var n = new Yr(r);
  if (n.selectNumberingPlan(e, t), n.defaultIDDPrefix())
    return n.defaultIDDPrefix();
  if (Jee.test(n.IDDPrefix()))
    return n.IDDPrefix();
}
function tte(e) {
  var t = e.number, r = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(r ? ";ext=" + r : "");
}
function rte(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r)
    return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = nte(e)) || t && e && typeof e.length == "number") {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nte(e, t) {
  if (e) {
    if (typeof e == "string")
      return mv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return mv(e, t);
  }
}
function mv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function pv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Fv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pv(Object(r), !0).forEach(function(n) {
      ate(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : pv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ate(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var yv = {
  formatExtension: function(t, r, n) {
    return "".concat(t).concat(n.ext()).concat(r);
  }
};
function ite(e, t, r, n) {
  if (r ? r = Fv(Fv({}, yv), r) : r = yv, n = new Yr(n), e.country && e.country !== "001") {
    if (!n.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    n.country(e.country);
  } else if (e.countryCallingCode)
    n.selectNumberingPlan(e.countryCallingCode);
  else
    return e.phone || "";
  var a = n.countryCallingCode(), i = r.v2 ? e.nationalNumber : e.phone, o;
  switch (t) {
    case "NATIONAL":
      return i ? (o = t0(i, e.carrierCode, "NATIONAL", n, r), W_(o, e.ext, n, r.formatExtension)) : "";
    case "INTERNATIONAL":
      return i ? (o = t0(i, null, "INTERNATIONAL", n, r), o = "+".concat(a, " ").concat(o), W_(o, e.ext, n, r.formatExtension)) : "+".concat(a);
    case "E.164":
      return "+".concat(a).concat(i);
    case "RFC3966":
      return tte({
        number: "+".concat(a).concat(i),
        ext: e.ext
      });
    case "IDD":
      if (!r.fromCountry)
        return;
      var u = ste(i, e.carrierCode, a, r.fromCountry, n);
      return W_(u, e.ext, n, r.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function t0(e, t, r, n, a) {
  var i = ote(n.formats(), e);
  return i ? xD(e, i, {
    useInternationalFormat: r === "INTERNATIONAL",
    withNationalPrefix: !(i.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && a && a.nationalPrefix === !1),
    carrierCode: t,
    metadata: n
  }) : e;
}
function ote(e, t) {
  for (var r = rte(e), n; !(n = r()).done; ) {
    var a = n.value;
    if (a.leadingDigitsPatterns().length > 0) {
      var i = a.leadingDigitsPatterns()[a.leadingDigitsPatterns().length - 1];
      if (t.search(i) !== 0)
        continue;
    }
    if (Oi(t, a.pattern()))
      return a;
  }
}
function W_(e, t, r, n) {
  return t ? n(e, t, r) : e;
}
function ste(e, t, r, n, a) {
  var i = kF(n, a.metadata);
  if (i === r) {
    var o = t0(e, t, "NATIONAL", a);
    return r === "1" ? r + " " + o : o;
  }
  var u = ete(n, void 0, a.metadata);
  if (u)
    return "".concat(u, " ").concat(r, " ").concat(t0(e, null, "INTERNATIONAL", a));
}
function bv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bv(Object(r), !0).forEach(function(n) {
      ute(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ute(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function dte(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ev(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function lte(e, t, r) {
  return t && Ev(e.prototype, t), r && Ev(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var DD = /* @__PURE__ */ function() {
  function e(t, r, n) {
    if (dte(this, e), !t)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!r)
      throw new TypeError("`nationalNumber` not passed");
    if (!n)
      throw new TypeError("`metadata` not passed");
    var a = cte(t, n), i = a.country, o = a.countryCallingCode;
    this.country = i, this.countryCallingCode = o, this.nationalNumber = r, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.metadata = n;
  }
  return lte(e, [{
    key: "setExt",
    value: function(r) {
      this.ext = r;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : Qee(this.countryCallingCode, this.nationalNumber, this.metadata);
    }
  }, {
    key: "isPossible",
    value: function() {
      return Hee(this, {
        v2: !0
      }, this.metadata);
    }
  }, {
    key: "isValid",
    value: function() {
      return Xee(this, {
        v2: !0
      }, this.metadata);
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var r = new Yr(this.metadata);
      return r.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(r) {
      return this.number === r.number && this.ext === r.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.metadata)
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return xF(this, {
        v2: !0
      }, this.metadata);
    }
  }, {
    key: "format",
    value: function(r, n) {
      return ite(this, r, n ? vv(vv({}, n), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.metadata);
    }
  }, {
    key: "formatNational",
    value: function(r) {
      return this.format("NATIONAL", r);
    }
  }, {
    key: "formatInternational",
    value: function(r) {
      return this.format("INTERNATIONAL", r);
    }
  }, {
    key: "getURI",
    value: function(r) {
      return this.format("RFC3966", r);
    }
  }]), e;
}(), fte = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function cte(e, t) {
  var r, n, a = new Yr(t);
  return fte(e) ? (r = e, a.selectNumberingPlan(r), n = a.countryCallingCode()) : n = e, {
    country: r,
    countryCallingCode: n
  };
}
var hte = new RegExp("([" + tn + "])");
function CD(e, t, r, n) {
  if (t) {
    var a = new Yr(n);
    a.selectNumberingPlan(t, r);
    var i = new RegExp(a.IDDPrefix());
    if (e.search(i) === 0) {
      e = e.slice(e.match(i)[0].length);
      var o = e.match(hte);
      if (!(o && o[1] != null && o[1].length > 0 && o[1] === "0"))
        return e;
    }
  }
}
function hm(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var r = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), n = r.exec(e);
    if (n) {
      var a, i, o = n.length - 1, u = o > 0 && n[o];
      if (t.nationalPrefixTransformRule() && u)
        a = e.replace(r, t.nationalPrefixTransformRule()), o > 1 && (i = n[1]);
      else {
        var d = n[0];
        a = e.slice(d.length), u && (i = n[1]);
      }
      var s;
      if (u) {
        var l = e.indexOf(n[1]), f = e.slice(0, l);
        f === t.numberingPlan.nationalPrefix() && (s = t.numberingPlan.nationalPrefix());
      } else
        s = n[0];
      return {
        nationalNumber: a,
        nationalPrefix: s,
        carrierCode: i
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function gm(e, t) {
  var r = hm(e, t), n = r.carrierCode, a = r.nationalNumber;
  if (a !== e) {
    if (!gte(e, a, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !_te(a, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: a,
    carrierCode: n
  };
}
function gte(e, t, r) {
  return !(Oi(e, r.nationalNumberPattern()) && !Oi(t, r.nationalNumberPattern()));
}
function _te(e, t) {
  switch (Rh(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function SD(e, t, r, n) {
  var a = t ? kF(t, n) : r;
  if (e.indexOf(a) === 0) {
    n = new Yr(n), n.selectNumberingPlan(t, r);
    var i = e.slice(a.length), o = gm(i, n), u = o.nationalNumber, d = gm(e, n), s = d.nationalNumber;
    if (!Oi(s, n.nationalNumberPattern()) && Oi(u, n.nationalNumberPattern()) || Rh(s, n) === "TOO_LONG")
      return {
        countryCallingCode: a,
        number: i
      };
  }
  return {
    number: e
  };
}
function AD(e, t, r, n) {
  if (!e)
    return {};
  var a;
  if (e[0] !== "+") {
    var i = CD(e, t, r, n);
    if (i && i !== e)
      a = !0, e = "+" + i;
    else {
      if (t || r) {
        var o = SD(e, t, r, n), u = o.countryCallingCode, d = o.number;
        if (u)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: u,
            number: d
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  n = new Yr(n);
  for (var s = 2; s - 1 <= cee && s <= e.length; ) {
    var l = e.slice(1, s);
    if (n.hasCallingCode(l))
      return n.selectNumberingPlan(l), {
        countryCallingCodeSource: a ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: l,
        number: e.slice(s)
      };
    s++;
  }
  return {};
}
function mte(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r)
    return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = pte(e)) || t && e && typeof e.length == "number") {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pte(e, t) {
  if (e) {
    if (typeof e == "string")
      return $v(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return $v(e, t);
  }
}
function $v(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Fte(e, t, r) {
  r = new Yr(r);
  for (var n = mte(e), a; !(a = n()).done; ) {
    var i = a.value;
    if (r.country(i), r.leadingDigits()) {
      if (t && t.search(r.leadingDigits()) === 0)
        return i;
    } else if (xF({
      phone: t,
      country: i
    }, void 0, r.metadata))
      return i;
  }
}
var yte = !1;
function OD(e, t, r) {
  if (yte && r.isNonGeographicCallingCode(e))
    return "001";
  var n = r.getCountryCodesForCallingCode(e);
  if (n)
    return n.length === 1 ? n[0] : Fte(n, t, r.metadata);
}
var TD = "+", bte = "[\\-\\.\\(\\)]?", wv = "([" + tn + "]|" + bte + ")", vte = "^\\" + TD + wv + "*[" + tn + "]" + wv + "*$", Ete = new RegExp(vte, "g"), _m = tn, $te = "[" + _m + "]+((\\-)*[" + _m + "])*", wte = "a-zA-Z", kte = "[" + wte + "]+((\\-)*[" + _m + "])*", xte = "^(" + $te + "\\.)*" + kte + "\\.?$", Dte = new RegExp(xte, "g"), kv = "tel:", mm = ";phone-context=", Cte = ";isub=";
function Ste(e) {
  var t = e.indexOf(mm);
  if (t < 0)
    return null;
  var r = t + mm.length;
  if (r >= e.length)
    return "";
  var n = e.indexOf(";", r);
  return n >= 0 ? e.substring(r, n) : e.substring(r);
}
function Ate(e) {
  return e === null ? !0 : e.length === 0 ? !1 : Ete.test(e) || Dte.test(e);
}
function Ote(e, t) {
  var r = t.extractFormattedPhoneNumber, n = Ste(e);
  if (!Ate(n))
    throw new vi("NOT_A_NUMBER");
  var a;
  if (n === null)
    a = r(e) || "";
  else {
    a = "", n.charAt(0) === TD && (a += n);
    var i = e.indexOf(kv), o;
    i >= 0 ? o = i + kv.length : o = 0;
    var u = e.indexOf(mm);
    a += e.substring(o, u);
  }
  var d = a.indexOf(Cte);
  if (d > 0 && (a = a.substring(0, d)), a !== "")
    return a;
}
var Tte = 250, Pte = new RegExp("[" + Th + tn + "]"), Ite = new RegExp("[^" + tn + "#]+$");
function Rte(e, t, r) {
  if (t = t || {}, r = new Yr(r), t.defaultCountry && !r.hasCountry(t.defaultCountry))
    throw t.v2 ? new vi("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var n = Mte(e, t.v2, t.extract), a = n.number, i = n.ext, o = n.error;
  if (!a) {
    if (t.v2)
      throw o === "TOO_SHORT" ? new vi("TOO_SHORT") : new vi("NOT_A_NUMBER");
    return {};
  }
  var u = Nte(a, t.defaultCountry, t.defaultCallingCode, r), d = u.country, s = u.nationalNumber, l = u.countryCallingCode, f = u.countryCallingCodeSource, c = u.carrierCode;
  if (!r.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new vi("INVALID_COUNTRY");
    return {};
  }
  if (!s || s.length < wF) {
    if (t.v2)
      throw new vi("TOO_SHORT");
    return {};
  }
  if (s.length > fee) {
    if (t.v2)
      throw new vi("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var h = new DD(l, s, r.metadata);
    return d && (h.country = d), c && (h.carrierCode = c), i && (h.ext = i), h.__countryCallingCodeSource = f, h;
  }
  var _ = (t.extended ? r.hasSelectedNumberingPlan() : d) ? Oi(s, r.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: d,
    countryCallingCode: l,
    carrierCode: c,
    valid: _,
    possible: _ ? !0 : !!(t.extended === !0 && r.possibleLengths() && $D(s, r)),
    phone: s,
    ext: i
  } : _ ? Bte(d, s, i) : {};
}
function jte(e, t, r) {
  if (e) {
    if (e.length > Tte) {
      if (r)
        throw new vi("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var n = e.search(Pte);
    if (!(n < 0))
      return e.slice(n).replace(Ite, "");
  }
}
function Mte(e, t, r) {
  var n = Ote(e, {
    extractFormattedPhoneNumber: function(o) {
      return jte(o, r, t);
    }
  });
  if (!n)
    return {};
  if (!Iee(n))
    return Ree(n) ? {
      error: "TOO_SHORT"
    } : {};
  var a = jee(n);
  return a.ext ? a : {
    number: n
  };
}
function Bte(e, t, r) {
  var n = {
    country: e,
    phone: t
  };
  return r && (n.ext = r), n;
}
function Nte(e, t, r, n) {
  var a = AD(hv(e), t, r, n.metadata), i = a.countryCallingCodeSource, o = a.countryCallingCode, u = a.number, d;
  if (o)
    n.selectNumberingPlan(o);
  else if (u && (t || r))
    n.selectNumberingPlan(t, r), t && (d = t), o = r || kF(t, n.metadata);
  else
    return {};
  if (!u)
    return {
      countryCallingCodeSource: i,
      countryCallingCode: o
    };
  var s = gm(hv(u), n), l = s.nationalNumber, f = s.carrierCode, c = OD(o, l, n);
  return c && (d = c, c === "001" || n.country(d)), {
    country: d,
    countryCallingCode: o,
    countryCallingCodeSource: i,
    nationalNumber: l,
    carrierCode: f
  };
}
function xv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Dv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xv(Object(r), !0).forEach(function(n) {
      Lte(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Lte(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function PD(e, t, r) {
  return Rte(e, Dv(Dv({}, t), {}, {
    v2: !0
  }), r);
}
function pm(e) {
  return pm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, pm(e);
}
function Cv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qte(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Cv(Object(r), !0).forEach(function(n) {
      Ute(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Cv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ute(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Gte(e, t) {
  return zte(e) || Hte(e, t) || Vte(e, t) || Wte();
}
function Wte() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Vte(e, t) {
  if (e) {
    if (typeof e == "string")
      return Sv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Sv(e, t);
  }
}
function Sv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Hte(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], a = !0, i = !1, o, u;
    try {
      for (r = r.call(e); !(a = (o = r.next()).done) && (n.push(o.value), !(t && n.length === t)); a = !0)
        ;
    } catch (d) {
      i = !0, u = d;
    } finally {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (i)
          throw u;
      }
    }
    return n;
  }
}
function zte(e) {
  if (Array.isArray(e))
    return e;
}
function ID(e) {
  var t = Array.prototype.slice.call(e), r = Gte(t, 4), n = r[0], a = r[1], i = r[2], o = r[3], u, d, s;
  if (typeof n == "string")
    u = n;
  else
    throw new TypeError("A text for parsing must be a string.");
  if (!a || typeof a == "string")
    o ? (d = i, s = o) : (d = void 0, s = i), a && (d = qte({
      defaultCountry: a
    }, d));
  else if (Kte(a))
    i ? (d = a, s = i) : s = a;
  else
    throw new Error("Invalid second argument: ".concat(a));
  return {
    text: u,
    options: d,
    metadata: s
  };
}
var Kte = function(t) {
  return pm(t) === "object";
};
function RD() {
  var e = ID(arguments), t = e.text, r = e.options, n = e.metadata;
  return PD(t, r, n);
}
function Av(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ov(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Av(Object(r), !0).forEach(function(n) {
      Yte(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Av(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Yte(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Xte(e, t, r) {
  t && t.defaultCountry && !Dee(t.defaultCountry, r) && (t = Ov(Ov({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return PD(e, t, r);
  } catch (n) {
    if (!(n instanceof vi))
      throw n;
  }
}
function Tv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Pv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Tv(Object(r), !0).forEach(function(n) {
      Qte(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Tv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Qte(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Zte() {
  var e = ID(arguments), t = e.text, r = e.options, n = e.metadata;
  r = Pv(Pv({}, r), {}, {
    extract: !1
  });
  var a = Xte(t, r, n);
  return a && a.isValid() || !1;
}
function Jte(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Iv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function ere(e, t, r) {
  return t && Iv(e.prototype, t), r && Iv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var tre = /* @__PURE__ */ function() {
  function e(t) {
    var r = t.onCountryChange, n = t.onCallingCodeChange;
    Jte(this, e), this.onCountryChange = r, this.onCallingCodeChange = n;
  }
  return ere(e, [{
    key: "reset",
    value: function(r) {
      var n = r.country, a = r.callingCode;
      this.international = !1, this.IDDPrefix = void 0, this.missingPlus = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(n, a);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "update",
    value: function(r) {
      for (var n = 0, a = Object.keys(r); n < a.length; n++) {
        var i = a[n];
        this[i] = r[i];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(r, n) {
      this.setCountry(r), this.setCallingCode(n);
    }
  }, {
    key: "setCountry",
    value: function(r) {
      this.country = r, this.onCountryChange(r);
    }
  }, {
    key: "setCallingCode",
    value: function(r) {
      this.callingCode = r, this.onCallingCodeChange(r, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(r, n) {
      this.international = !0, this.initCountryAndCallingCode(r, n);
    }
  }, {
    key: "appendDigits",
    value: function(r) {
      this.digits += r;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(r) {
      this.nationalSignificantNumber += r;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]), e;
}();
function rre(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r)
    return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = nre(e)) || t && e && typeof e.length == "number") {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nre(e, t) {
  if (e) {
    if (typeof e == "string")
      return Rv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Rv(e, t);
  }
}
function Rv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var fa = "x", V_ = new RegExp(fa);
function S1(e, t) {
  if (t < 1)
    return "";
  for (var r = ""; t > 1; )
    t & 1 && (r += e), t >>= 1, e += e;
  return r + e;
}
function jv(e, t) {
  return e[t] === ")" && t++, are(e.slice(0, t));
}
function are(e) {
  for (var t = [], r = 0; r < e.length; )
    e[r] === "(" ? t.push(r) : e[r] === ")" && t.pop(), r++;
  var n = 0, a = "";
  t.push(e.length);
  for (var i = 0, o = t; i < o.length; i++) {
    var u = o[i];
    a += e.slice(n, u), n = u + 1;
  }
  return a;
}
function ire(e, t, r) {
  for (var n = rre(r.split("")), a; !(a = n()).done; ) {
    var i = a.value;
    if (e.slice(t + 1).search(V_) < 0)
      return;
    t = e.search(V_), e = e.replace(V_, i);
  }
  return [e, t];
}
function ore(e, t, r) {
  var n = r.metadata, a = r.shouldTryNationalPrefixFormattingRule, i = r.getSeparatorAfterNationalPrefix, o = new RegExp("^(?:".concat(t.pattern(), ")$"));
  if (o.test(e.nationalSignificantNumber))
    return ure(e, t, {
      metadata: n,
      shouldTryNationalPrefixFormattingRule: a,
      getSeparatorAfterNationalPrefix: i
    });
}
function sre(e, t) {
  return Rh(e, t) === "IS_POSSIBLE";
}
function ure(e, t, r) {
  var n = r.metadata, a = r.shouldTryNationalPrefixFormattingRule, i = r.getSeparatorAfterNationalPrefix;
  if (e.nationalSignificantNumber, e.international, e.nationalPrefix, e.carrierCode, a(t)) {
    var o = Mv(e, t, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: i,
      metadata: n
    });
    if (o)
      return o;
  }
  return Mv(e, t, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: i,
    metadata: n
  });
}
function Mv(e, t, r) {
  var n = r.metadata, a = r.useNationalPrefixFormattingRule, i = r.getSeparatorAfterNationalPrefix, o = xD(e.nationalSignificantNumber, t, {
    carrierCode: e.carrierCode,
    useInternationalFormat: e.international,
    withNationalPrefix: a,
    metadata: n
  });
  if (a || (e.nationalPrefix ? o = e.nationalPrefix + i(t) + o : e.complexPrefixBeforeNationalSignificantNumber && (o = e.complexPrefixBeforeNationalSignificantNumber + " " + o)), dre(o, e))
    return o;
}
function dre(e, t) {
  return e0(e) === t.getNationalDigits();
}
function lre(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Bv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function fre(e, t, r) {
  return t && Bv(e.prototype, t), r && Bv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var cre = /* @__PURE__ */ function() {
  function e() {
    lre(this, e);
  }
  return fre(e, [{
    key: "parse",
    value: function(r) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(r), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var n = this.context[0], a = n.branches, i = n.instructions;
      if (a)
        return {
          op: "|",
          args: a.concat([H_(i)])
        };
      if (i.length === 0)
        throw new Error("Pattern is required");
      return i.length === 1 ? i[0] : i;
    }
  }, {
    key: "startContext",
    value: function(r) {
      this.context.push(r);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(r) {
      if (!r)
        throw new Error("Pattern is required");
      var n = r.match(_re);
      if (!n) {
        if (gre.test(r))
          throw new Error("Illegal characters found in a pattern: ".concat(r));
        this.getContext().instructions = this.getContext().instructions.concat(r.split(""));
        return;
      }
      var a = n[1], i = r.slice(0, n.index), o = r.slice(n.index + a.length);
      switch (a) {
        case "(?:":
          i && this.parsePattern(i), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (i && this.parsePattern(i), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var u = this.getContext(), d = u.branches;
          d.push(H_(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: d
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (i && this.parsePattern(i), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(H_(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          i && this.parsePattern(i), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: hre(i)
          });
          break;
        default:
          throw new Error("Unknown operator: ".concat(a));
      }
      o && this.parsePattern(o);
    }
  }]), e;
}();
function hre(e) {
  for (var t = [], r = 0; r < e.length; ) {
    if (e[r] === "-") {
      if (r === 0 || r === e.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(e));
      for (var n = e[r - 1].charCodeAt(0) + 1, a = e[r + 1].charCodeAt(0) - 1, i = n; i <= a; )
        t.push(String.fromCharCode(i)), i++;
    } else
      t.push(e[r]);
    r++;
  }
  return t;
}
var gre = /[\(\)\[\]\?\:\|]/, _re = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function H_(e) {
  return e.length === 1 ? e[0] : e;
}
function Nv(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r)
    return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = mre(e)) || t && e && typeof e.length == "number") {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function mre(e, t) {
  if (e) {
    if (typeof e == "string")
      return Lv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Lv(e, t);
  }
}
function Lv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function pre(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function qv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Fre(e, t, r) {
  return t && qv(e.prototype, t), r && qv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var yre = /* @__PURE__ */ function() {
  function e(t) {
    pre(this, e), this.matchTree = new cre().parse(t);
  }
  return Fre(e, [{
    key: "match",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.allowOverflow;
      if (!r)
        throw new Error("String is required");
      var i = Fm(r.split(""), this.matchTree, !0);
      if (i && i.match && delete i.matchedChars, !(i && i.overflow && !a))
        return i;
    }
  }]), e;
}();
function Fm(e, t, r) {
  if (typeof t == "string") {
    var n = e.join("");
    return t.indexOf(n) === 0 ? e.length === t.length ? {
      match: !0,
      matchedChars: e
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : n.indexOf(t) === 0 ? r && e.length > t.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, t.length)
    } : void 0;
  }
  if (Array.isArray(t)) {
    for (var a = e.slice(), i = 0; i < t.length; ) {
      var o = t[i], u = Fm(a, o, r && i === t.length - 1);
      if (u) {
        if (u.overflow)
          return u;
        if (u.match) {
          if (a = a.slice(u.matchedChars.length), a.length === 0)
            return i === t.length - 1 ? {
              match: !0,
              matchedChars: e
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (u.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(u, null, 2)));
        }
      } else
        return;
      i++;
    }
    return r ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, e.length - a.length)
    };
  }
  switch (t.op) {
    case "|":
      for (var d, s = Nv(t.args), l; !(l = s()).done; ) {
        var f = l.value, c = Fm(e, f, r);
        if (c) {
          if (c.overflow)
            return c;
          if (c.match)
            return {
              match: !0,
              matchedChars: c.matchedChars
            };
          if (c.partialMatch)
            d = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(c, null, 2)));
        }
      }
      return d ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var h = Nv(t.args), _; !(_ = h()).done; ) {
        var F = _.value;
        if (e[0] === F)
          return e.length === 1 ? {
            match: !0,
            matchedChars: e
          } : r ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [F]
          };
      }
      return;
    default:
      throw new Error("Unsupported instruction tree: ".concat(t));
  }
}
function Uv(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r)
    return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = bre(e)) || t && e && typeof e.length == "number") {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bre(e, t) {
  if (e) {
    if (typeof e == "string")
      return Gv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Gv(e, t);
  }
}
function Gv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function vre(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Wv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Ere(e, t, r) {
  return t && Wv(e.prototype, t), r && Wv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var ym = "9", $re = 15, wre = S1(ym, $re), kre = /[- ]/, xre = function() {
  return /\[([^\[\]])*\]/g;
}, Dre = function() {
  return /\d(?=[^,}][^,}])/g;
}, Cre = new RegExp("[" + ha + "]*\\$1[" + ha + "]*(\\$\\d[" + ha + "]*)*$"), Vv = 3, Sre = /* @__PURE__ */ function() {
  function e(t) {
    t.state;
    var r = t.metadata;
    vre(this, e), this.metadata = r, this.resetFormat();
  }
  return Ere(e, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(r, n) {
      this.resetFormat(), r ? (this.isNANP = r.callingCode() === "1", this.matchingFormats = r.formats(), n.nationalSignificantNumber && this.narrowDownMatchingFormats(n)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(r, n) {
      var a = this;
      if (sre(n.nationalSignificantNumber, this.metadata))
        for (var i = Uv(this.matchingFormats), o; !(o = i()).done; ) {
          var u = o.value, d = ore(n, u, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(l) {
              return a.shouldTryNationalPrefixFormattingRule(l, {
                international: n.international,
                nationalPrefix: n.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(l) {
              return a.getSeparatorAfterNationalPrefix(l);
            }
          });
          if (d)
            return this.resetFormat(), this.chosenFormat = u, this.setNationalNumberTemplate(d.replace(/\d/g, fa), n), this.populatedNationalNumberTemplate = d, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(fa), d;
        }
      return this.formatNationalNumberWithNextDigits(r, n);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(r, n) {
      var a = this.chosenFormat, i = this.chooseFormat(n);
      if (i)
        return i === a ? this.formatNextNationalNumberDigits(r) : this.formatNextNationalNumberDigits(n.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(r) {
      var n = this, a = r.nationalSignificantNumber, i = r.nationalPrefix, o = r.international, u = a, d = u.length - Vv;
      d < 0 && (d = 0), this.matchingFormats = this.matchingFormats.filter(function(s) {
        return n.formatSuits(s, o, i) && n.formatMatches(s, u, d);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(r, n, a) {
      return !(a && !r.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !r.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !n && !a && r.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(r, n, a) {
      var i = r.leadingDigitsPatterns().length;
      if (i === 0)
        return !0;
      a = Math.min(a, i - 1);
      var o = r.leadingDigitsPatterns()[a];
      if (n.length < Vv)
        try {
          return new yre(o).match(n, {
            allowOverflow: !0
          }) !== void 0;
        } catch (u) {
          return console.error(u), !0;
        }
      return new RegExp("^(".concat(o, ")")).test(n);
    }
  }, {
    key: "getFormatFormat",
    value: function(r, n) {
      return n ? r.internationalFormat() : r.format();
    }
  }, {
    key: "chooseFormat",
    value: function(r) {
      for (var n = this, a = function() {
        var s = o.value;
        return n.chosenFormat === s ? "break" : Cre.test(n.getFormatFormat(s, r.international)) ? n.createTemplateForFormat(s, r) ? (n.chosenFormat = s, "break") : (n.matchingFormats = n.matchingFormats.filter(function(l) {
          return l !== s;
        }), "continue") : "continue";
      }, i = Uv(this.matchingFormats.slice()), o; !(o = i()).done; ) {
        var u = a();
        if (u === "break")
          break;
      }
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(r, n) {
      if (!(r.pattern().indexOf("|") >= 0)) {
        var a = this.getTemplateForFormat(r, n);
        if (a)
          return this.setNationalNumberTemplate(a, n), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(r) {
      return this.isNANP || r && r.nationalPrefixFormattingRule() && kre.test(r.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(r, n) {
      var a = r.IDDPrefix, i = r.missingPlus;
      return a ? n && n.spacing === !1 ? a : a + " " : i ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(r) {
      if (this.template) {
        for (var n = -1, a = 0, i = r.international ? this.getInternationalPrefixBeforeCountryCallingCode(r, {
          spacing: !1
        }) : ""; a < i.length + r.getDigitsWithoutInternationalPrefix().length; )
          n = this.template.indexOf(fa, n + 1), a++;
        return jv(this.template, n + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(r, n) {
      this.nationalNumberTemplate = r, this.populatedNationalNumberTemplate = r, this.populatedNationalNumberTemplatePosition = -1, n.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(n).replace(/[\d\+]/g, fa) + S1(fa, n.callingCode.length) + " " + r : this.template = r;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(r, n) {
      var a = n.nationalSignificantNumber, i = n.international, o = n.nationalPrefix, u = n.complexPrefixBeforeNationalSignificantNumber, d = r.pattern();
      d = d.replace(xre(), "\\d").replace(Dre(), "\\d");
      var s = wre.match(d)[0];
      if (!(a.length > s.length)) {
        var l = new RegExp("^" + d + "$"), f = a.replace(/\d/g, ym);
        l.test(f) && (s = f);
        var c = this.getFormatFormat(r, i), h;
        if (this.shouldTryNationalPrefixFormattingRule(r, {
          international: i,
          nationalPrefix: o
        })) {
          var _ = c.replace(kD, r.nationalPrefixFormattingRule());
          if (e0(r.nationalPrefixFormattingRule()) === (o || "") + e0("$1") && (c = _, h = !0, o))
            for (var F = o.length; F > 0; )
              c = c.replace(/\d/, fa), F--;
        }
        var v = s.replace(new RegExp(d), c).replace(new RegExp(ym, "g"), fa);
        return h || (u ? v = S1(fa, u.length) + " " + v : o && (v = S1(fa, o.length) + this.getSeparatorAfterNationalPrefix(r) + v)), i && (v = wD(v)), v;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(r) {
      var n = ire(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, r);
      if (!n) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = n[0], this.populatedNationalNumberTemplatePosition = n[1], jv(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(r, n) {
      var a = n.international, i = n.nationalPrefix;
      if (r.nationalPrefixFormattingRule()) {
        var o = r.usesNationalPrefix();
        if (o && i || !o && !a)
          return !0;
      }
    }
  }]), e;
}();
function jD(e, t) {
  return Pre(e) || Tre(e, t) || Ore(e, t) || Are();
}
function Are() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ore(e, t) {
  if (e) {
    if (typeof e == "string")
      return Hv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Hv(e, t);
  }
}
function Hv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Tre(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], a = !0, i = !1, o, u;
    try {
      for (r = r.call(e); !(a = (o = r.next()).done) && (n.push(o.value), !(t && n.length === t)); a = !0)
        ;
    } catch (d) {
      i = !0, u = d;
    } finally {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (i)
          throw u;
      }
    }
    return n;
  }
}
function Pre(e) {
  if (Array.isArray(e))
    return e;
}
function Ire(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function zv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Rre(e, t, r) {
  return t && zv(e.prototype, t), r && zv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var jre = "[" + ha + tn + "]+", Mre = new RegExp("^" + jre + "$", "i"), Bre = "(?:[" + Th + "][" + ha + tn + "]*|[" + ha + tn + "]+)", Nre = new RegExp("[^" + ha + tn + "]+.*$"), Lre = /[^\d\[\]]/, qre = /* @__PURE__ */ function() {
  function e(t) {
    var r = t.defaultCountry, n = t.defaultCallingCode, a = t.metadata, i = t.onNationalSignificantNumberChange;
    Ire(this, e), this.defaultCountry = r, this.defaultCallingCode = n, this.metadata = a, this.onNationalSignificantNumberChange = i;
  }
  return Rre(e, [{
    key: "input",
    value: function(r, n) {
      var a = Wre(r), i = jD(a, 2), o = i[0], u = i[1], d = e0(o), s;
      return u && (n.digits || (n.startInternationalNumber(), d || (s = !0))), d && this.inputDigits(d, n), {
        digits: d,
        justLeadingPlus: s
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(r, n) {
      var a = n.digits, i = a.length < 3 && a.length + r.length >= 3;
      if (n.appendDigits(r), i && this.extractIddPrefix(n), this.isWaitingForCountryCallingCode(n)) {
        if (!this.extractCountryCallingCode(n))
          return;
      } else
        n.appendNationalSignificantNumberDigits(r);
      n.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(n.getNationalDigits(), function(o) {
        return n.update(o);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(r) {
      var n = r.international, a = r.callingCode;
      return n && !a;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(r) {
      var n = AD("+" + r.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), a = n.countryCallingCode, i = n.number;
      if (a)
        return r.setCallingCode(a), r.update({
          nationalSignificantNumber: i
        }), !0;
    }
  }, {
    key: "reset",
    value: function(r) {
      if (r) {
        this.hasSelectedNumberingPlan = !0;
        var n = r._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = n && Lre.test(n);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(r, n) {
      if (this.hasSelectedNumberingPlan) {
        var a = hm(r, this.metadata), i = a.nationalPrefix, o = a.nationalNumber, u = a.carrierCode;
        if (o !== r)
          return this.onExtractedNationalNumber(i, u, o, r, n), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(r, n, a) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(r, a);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var i = hm(r, this.metadata), o = i.nationalPrefix, u = i.nationalNumber, d = i.carrierCode;
        if (u !== n)
          return this.onExtractedNationalNumber(o, d, u, r, a), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(r, n, a, i, o) {
      var u, d, s = i.lastIndexOf(a);
      if (s >= 0 && s === i.length - a.length) {
        d = !0;
        var l = i.slice(0, s);
        l !== r && (u = l);
      }
      o({
        nationalPrefix: r,
        carrierCode: n,
        nationalSignificantNumber: a,
        nationalSignificantNumberMatchesInput: d,
        complexPrefixBeforeNationalSignificantNumber: u
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(r) {
      if (this.extractAnotherNationalSignificantNumber(r.getNationalDigits(), r.nationalSignificantNumber, function(n) {
        return r.update(n);
      }))
        return !0;
      if (this.extractIddPrefix(r))
        return this.extractCallingCodeAndNationalSignificantNumber(r), !0;
      if (this.fixMissingPlus(r))
        return this.extractCallingCodeAndNationalSignificantNumber(r), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(r) {
      var n = r.international, a = r.IDDPrefix, i = r.digits;
      if (r.nationalSignificantNumber, !(n || a)) {
        var o = CD(i, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (o !== void 0 && o !== i)
          return r.update({
            IDDPrefix: i.slice(0, i.length - o.length)
          }), this.startInternationalNumber(r, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(r) {
      if (!r.international) {
        var n = SD(r.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), a = n.countryCallingCode;
        if (n.number, a)
          return r.update({
            missingPlus: !0
          }), this.startInternationalNumber(r, {
            country: r.country,
            callingCode: a
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(r, n) {
      var a = n.country, i = n.callingCode;
      r.startInternationalNumber(a, i), r.nationalSignificantNumber && (r.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(r) {
      this.extractCountryCallingCode(r) && this.extractNationalSignificantNumber(r.getNationalDigits(), function(n) {
        return r.update(n);
      });
    }
  }]), e;
}();
function Ure(e) {
  var t = e.search(Bre);
  if (!(t < 0)) {
    e = e.slice(t);
    var r;
    return e[0] === "+" && (r = !0, e = e.slice(1)), e = e.replace(Nre, ""), r && (e = "+" + e), e;
  }
}
function Gre(e) {
  var t = Ure(e) || "";
  return t[0] === "+" ? [t.slice(1), !0] : [t];
}
function Wre(e) {
  var t = Gre(e), r = jD(t, 2), n = r[0], a = r[1];
  return Mre.test(n) || (n = ""), [n, a];
}
function bm(e) {
  return bm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, bm(e);
}
function Vre(e, t) {
  return Yre(e) || Kre(e, t) || zre(e, t) || Hre();
}
function Hre() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zre(e, t) {
  if (e) {
    if (typeof e == "string")
      return Kv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Kv(e, t);
  }
}
function Kv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Kre(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], a = !0, i = !1, o, u;
    try {
      for (r = r.call(e); !(a = (o = r.next()).done) && (n.push(o.value), !(t && n.length === t)); a = !0)
        ;
    } catch (d) {
      i = !0, u = d;
    } finally {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (i)
          throw u;
      }
    }
    return n;
  }
}
function Yre(e) {
  if (Array.isArray(e))
    return e;
}
function Xre(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Yv(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Qre(e, t, r) {
  return t && Yv(e.prototype, t), r && Yv(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var MD = /* @__PURE__ */ function() {
  function e(t, r) {
    Xre(this, e), this.metadata = new Yr(r);
    var n = this.getCountryAndCallingCode(t), a = Vre(n, 2), i = a[0], o = a[1];
    this.defaultCountry = i, this.defaultCallingCode = o, this.reset();
  }
  return Qre(e, [{
    key: "getCountryAndCallingCode",
    value: function(r) {
      var n, a;
      return r && (bm(r) === "object" ? (n = r.defaultCountry, a = r.defaultCallingCode) : n = r), n && !this.metadata.hasCountry(n) && (n = void 0), [n, a];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(r) {
      var n = this.parser.input(r, this.state), a = n.digits, i = n.justLeadingPlus;
      if (i)
        this.formattedOutput = "+";
      else if (a) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var o;
        if (this.metadata.hasSelectedNumberingPlan() && (o = this.formatter.format(a, this.state)), o === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var u = this.state.getNationalDigits();
          u && (o = this.formatter.format(u, this.state));
        }
        this.formattedOutput = o ? this.getFullNumber(o) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var r = this;
      return this.state = new tre({
        onCountryChange: function(a) {
          r.country = a;
        },
        onCallingCodeChange: function(a, i) {
          r.metadata.selectNumberingPlan(i, a), r.formatter.reset(r.metadata.numberingPlan, r.state), r.parser.reset(r.metadata.numberingPlan);
        }
      }), this.formatter = new Sre({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new qre({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          r.determineTheCountryIfNeeded(), r.formatter.reset(r.metadata.numberingPlan, r.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var r = this.state.digits;
      if (r)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var r = this.state.country;
      return r;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(r) {
      var n = this;
      if (this.isInternational()) {
        var a = function(u) {
          return n.formatter.getInternationalPrefixBeforeCountryCallingCode(n.state, {
            spacing: !!u
          }) + u;
        }, i = this.state.callingCode;
        return a(i ? r ? "".concat(i, " ").concat(r) : i : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return r;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var r = this.state, n = r.nationalSignificantNumber, a = r.complexPrefixBeforeNationalSignificantNumber, i = r.nationalPrefix, o = n, u = a || i;
      return u && (o = u + o), o;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var r = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(r ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var r = this.getNonFormattedNumber();
      if (r)
        return r.replace(/[\+\d]/g, fa);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var r = this.state.callingCode, n = this.metadata.getCountryCodesForCallingCode(r);
      return n && n.length > 1;
    }
    // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(OD(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, this.state.nationalSignificantNumber, this.metadata));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var r = this.state, n = r.digits, a = r.callingCode, i = r.country, o = r.nationalSignificantNumber;
      if (n) {
        if (this.isInternational())
          return a ? "+" + a + o : "+" + n;
        if (i || a) {
          var u = i ? this.metadata.countryCallingCode() : a;
          return "+" + u + o;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var r = this.state, n = r.nationalSignificantNumber, a = r.carrierCode, i = r.callingCode, o = this._getCountry();
      if (n && !(!o && !i)) {
        var u = new DD(o || i, n, this.metadata.metadata);
        return a && (u.carrierCode = a), u;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var r = this.getNumber();
      return r ? r.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var r = this.getNumber();
      return r ? r.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]), e;
}();
function vm() {
  return aee(RD, arguments);
}
function Zre(e, t = "") {
  return e.startsWith("+") || e === "anonymous" ? e : `+${t}${e}`;
}
function Jre(e, t) {
  try {
    return t ? vm(e, t).formatInternational() : vm(Zre(e)).formatInternational();
  } catch {
    return e;
  }
}
function ene(e, t = "en-US") {
  return new Intl.NumberFormat(t, {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 1
  }).format(e);
}
function iOe(e) {
  try {
    return vm(e).number;
  } catch {
    return e;
  }
}
function tne(e, t, r = 10) {
  const n = r ** t;
  return Math.round(e * n) / n;
}
const rne = "/", nne = "/company", ane = "/onboarding", BD = "/download", ine = "/analytics", one = "/analytics/:tab", sne = "/numbers", une = "/numbers/active", dne = "/numbers/unverified", lne = "/numbers/:numberId", fne = "/numbers/:numberId/:tab", cne = "/numbers/purchase", hne = "/numbers/purchase/:numberId/:key", gne = "/numbers/purchase/:numberId/:key/:settingId", _ne = "/numbers/:number/proof_of_id", mne = "/teams", pne = "/teams/:teamId", Fne = "/users", yne = "/users/:userId", bne = "/users/:userId/:tab", vne = "/calls", Ene = {
  TAGS: "/calls/tags",
  BLOCKED_NUMBERS: "/calls/blocked_numbers",
  CALL_ASSET: "/calls/:callId/:callType"
}, ND = "/integrations", $ne = "/integrations/:tab", wne = "/check-health", kne = "/stats", xne = "/stats/:tab", Dne = {
  OVERVIEW: "/stats/overview",
  OVERVIEW_BETA: "/stats/overview_beta",
  ANALYTICS: "/stats/analytics",
  ANALYTICS_PLUS: "/stats/analytics_plus",
  MONITORING: "/stats/monitoring",
  INBOUND: "/stats/inbound",
  AVAILABILITIES: "/stats/availabilities",
  CALL_HISTORY: "/stats/call_history"
}, Cne = "/activity_feed", Em = {
  /** Integration settings page */
  INTEGRATION_SETTINGS: "/:applicationType/:integrationName/:integrationId",
  INTEGRATION_SETTINGS_TAB: "/:applicationType/:integrationName/:integrationId/:tab",
  /** Application page */
  APPLICATION: "/app/:applicationType/:applicationName/:applicationId",
  /** Flow installation pages */
  FLOW_INSTALL: "/flow/install/:applicationType/:applicationName/:applicationId",
  FLOW_CREATE: "/flow/create/:applicationType/:applicationName/:applicationId",
  FLOW_COMPLETE: "/flow/complete/:applicationType/:applicationName/:applicationId"
}, Sne = Object.keys(
  Em
).reduce(
  (e, t) => {
    const r = t;
    return e[r] = `${ND}${e[r]}`, e;
  },
  { ...Em }
), Ane = "/oauth/authorize", One = "/oauth/success", Tne = "/sso/zendesk", Pne = "/sso/sandbox", Ine = "/", LD = "/sso", DF = "/login", Rne = `${DF}${LD}`, qD = "/forgot_password", UD = "/reset_password", GD = "/confirm_invitation", WD = "/users/confirmation", jne = "/test", Mne = [
  DF,
  qD,
  UD,
  GD,
  WD,
  BD
], Bne = "/account", Nne = "/addons/:addonName", Lne = "/account/plan/purchase", qne = "/account/plan/cancel", Une = "/account/:tab";
var VD = /* @__PURE__ */ ((e) => (e.GENERAL = "general", e.YOUR_PLAN = "plan", e.BILLING = "billing", e.SECURITY = "security", e.PERMISSIONS = "permissions", e))(VD || {});
const Gne = "/unauthorized", Xv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACCOUNT_PLAN_CANCEL_ROUTE: qne,
  ACCOUNT_PLAN_PURCHASE_ROUTE: Lne,
  ACCOUNT_ROUTE: Bne,
  ACCOUNT_ROUTE_TAB: Une,
  ACCOUNT_TABS: VD,
  ACTIVITY_FEED_ROUTE: Cne,
  ADDONS_DETAIL_ROUTE: Nne,
  ANALYTICS_ROUTE: ine,
  ANALYTICS_ROUTE_TAB: one,
  CALLS_CHILD_ROUTE: Ene,
  CALLS_ROUTE: vne,
  CHECK_HEALTH: wne,
  COMPANY_ROUTE: nne,
  CONFIRM_INVITATION_ROUTE: GD,
  CONFIRM_USER_CREATION_ROUTE: WD,
  DOWNLOAD_APP_ROUTE: BD,
  FORGOT_PASSWORD_ROUTE: qD,
  HOME_ROUTE: rne,
  INTEGRATIONS_ROUTE: ND,
  INTEGRATIONS_ROUTE_TAB: $ne,
  INTEGRATION_AUTHORIZE: Ane,
  INTEGRATION_AUTHORIZE_SUCCESS: One,
  INTEGRATION_CHILD_ROUTES: Em,
  INTEGRATION_FULL_ROUTES: Sne,
  LOGIN_ROUTE: DF,
  LOGIN_SSO_ROUTE: Rne,
  LOGIN_SUB_PASSWORD_ROUTE: Ine,
  LOGIN_SUB_SSO_ROUTE: LD,
  NUMBERS_ROUTE: sne,
  NUMBERS_ROUTE_TAB_ACTIVE: une,
  NUMBERS_ROUTE_TAB_UNVERIFIED: dne,
  NUMBER_DETAIL_ROUTE: lne,
  NUMBER_DETAIL_ROUTE_TAB: fne,
  NUMBER_PROOF_OF_ID_ROUTE: _ne,
  NUMBER_PURCHASE_ROUTE: cne,
  NUMBER_PURCHASE_ROUTE_AT_IVR_CREATION: hne,
  NUMBER_PURCHASE_ROUTE_AT_IVR_EDITION: gne,
  ONBOARDING_ROUTE: ane,
  PUBLIC_ROUTES: Mne,
  RESET_PASSWORD_ROUTE: UD,
  SANDBOX_SSO: Pne,
  STATS_CHILD_ROUTE: Dne,
  STATS_ROUTE: kne,
  STATS_ROUTE_TAB: xne,
  TEAMS_ROUTE: mne,
  TEAM_DETAIL_ROUTE: pne,
  TEST_ROUTE: jne,
  UNAUTHORIZED_ROUTE: Gne,
  USERS_ROUTE: Fne,
  USER_DETAIL_ROUTE: yne,
  USER_DETAIL_ROUTE_TAB: bne,
  ZENDESK_SSO: Tne
}, Symbol.toStringTag, { value: "Module" })), Wne = Object.keys(Xv).flatMap((e) => {
  const t = Xv[e];
  return e === "INTEGRATION_CHILD_ROUTES" ? [] : Ai(t) ? Object.values(t) : t;
});
function Vne(e) {
  return Wne.find((t) => YM(t, e));
}
var Fn = /* @__PURE__ */ ((e) => (e.NUMBERS = "NUMBERS", e.TEAMS = "TEAMS", e.USERS = "USERS", e.STATS = "STATS", e.ACTIVITY_FEED = "ACTIVITY_FEED", e.CALL_SETTINGS = "CALL_SETTINGS", e.INTEGRATIONS = "INTEGRATIONS", e.COMPANY_GENERAL = "COMPANY_GENERAL", e.COMPANY_PLAN = "COMPANY_PLAN", e.COMPANY_BILLING = "COMPANY_BILLING", e.COMPANY_SECURITY = "COMPANY_SECURITY", e.COMPANY_ROLES = "COMPANY_ROLES", e.ASSET = "ASSET", e.DASHBOARD_V2 = "DASHBOARD_V2", e.ROLE_MANAGEMENT = "ROLE_MANAGEMENT", e.CONVERSATIONS_CENTER = "CONVERSATIONS_CENTER", e))(Fn || {}), jh = /* @__PURE__ */ ((e) => (e.CREATE = "c", e.READ = "r", e.UPDATE = "u", e.DELETE = "d", e))(jh || {});
const Jr = {
  OWNER: "Owner",
  ADMIN: "Admin",
  SUPERVISOR: "Supervisor",
  AGENT: "Agent"
}, Qv = {
  [Jr.OWNER]: 1,
  [Jr.ADMIN]: 2,
  [Jr.SUPERVISOR]: 3,
  [Jr.AGENT]: 4
}, oOe = "permissions_modal";
function Hne(e, t) {
  if (e in t)
    return t[e];
  const r = Vne(e);
  return r && r in t ? t[r] : null;
}
function su(e, t) {
  return e.some((r) => r.name === t);
}
function sOe(e, t, r, n) {
  return e === r ? !1 : su(t, Jr.ADMIN) && su(t, Jr.OWNER) ? !0 : su(t, Jr.OWNER) ? su(n, Jr.OWNER) : su(t, Jr.ADMIN) ? !su(n, Jr.OWNER) : !1;
}
const zne = M.forwardRef;
function uOe(e) {
  return e === __.Asc ? __.Desc : __.Asc;
}
function Kne(e, t = ["default", "blue", "green", "yellow"]) {
  return t[(e.charCodeAt(0) + (e.charCodeAt(1) || 0)) % t.length];
}
const Yne = Mw.colors, dOe = {
  ...Mw,
  colors: {
    // Customize colors here
    ...Yne
  }
}, Xne = ({
  platform: e = "dashboard",
  release: t
}) => ({
  platform: e,
  release: t,
  screen_size: `${window.screen.width}x${window.screen.height}`,
  window_size: `${window.outerWidth}x${window.outerHeight}`,
  os_version: wW().osVersion
}), lOe = ({
  event: e,
  settingsSection: t,
  setting: r,
  field: n,
  action: a,
  isOwnUser: i
}) => ({
  event: e,
  payload: {
    ...i !== void 0 && {
      target_user: i ? "self" : "other_user"
    },
    settings_section: t,
    setting: r,
    action: `${gD(n)}_${a || "updated"}`
  }
});
function HD(e) {
  return typeof e < "u";
}
function zD(e) {
  return Boolean(e);
}
const KD = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[047]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[01])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-79]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0(4(?:[14]4|56)|[579])?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[189]"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-579])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-246-9])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1289]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[01])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([3-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|(?:[235-8]\\d|99)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29[1289]|389)", "529(?:1[1-46-9]|2[013-8]|90)|5(?:298|389)[0-46-9]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5293[01]\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|9[0-289])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[0189]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}"], ["80\\d{7}"], ["89\\d{7}"], 0, 0, 0, 0, ["592(?:4[0-2]|93)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[01])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "1(?:(?:[27]2|44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[04]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[489]|59"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[47]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-579]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|[89]0", "50(?:[0367]|88)|[89]0"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[59]|80"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7|86"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-3]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:0[0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|6[0-6]|7[0-27]|8[0-8]|9[0-479]))|9(?:399[0-2]|479[01]|76(?:2[27]|3[0-37]|9\\d)))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, 0, ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-6]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3478]|64|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "(?:00|[1-57-9]\\d)\\d{7}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:4722(?:0[0-35]|27)|505(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|4[46])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "(?:0004|4)\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [7, 8, 10, 13], [["(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "810", "(?:33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[35-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "(?:(?:(?:26|63)9|80\\d)\\d\\d|93980)\\d{4}", [9], 0, "0", 0, 0, 0, 0, "269|63|9398"], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "[0-36-9]\\d{8}", [9], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[013-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function YD(e, t) {
  var r = Array.prototype.slice.call(t);
  return r.push(KD), e.apply(this, r);
}
function XD() {
  return YD(RD, arguments);
}
function Qne() {
  return YD(Zte, arguments);
}
function Il(e) {
  return MD.call(this, e, KD);
}
Il.prototype = Object.create(MD.prototype, {});
Il.prototype.constructor = Il;
const QD = (e) => e ? void 0 : wr.REQUIRED_FIELD, fOe = (e) => {
  const t = QD(e);
  return t || (vH.test(e) ? void 0 : wr.INVALID_EMAIL);
}, cOe = (e) => (t) => {
  if (e.includes(t))
    return wr.ALREADY_EXISTS;
}, hOe = (e) => (t, r) => {
  const n = QD(t);
  return n || (t === r[e] ? void 0 : wr.PASSWORD_NOT_MATCH);
}, gOe = (e) => EH.test(e) ? void 0 : wr.PASSWORD_LENGTH, _Oe = (e) => $H.test(e) ? void 0 : wr.PASSWORD_STRENGTH, mOe = (e) => (t = "") => t.length > e ? wr.MAX_LENGTH : void 0, pOe = (e) => (t) => (e || wH).test(t) ? void 0 : wr.WRONG_FORMAT, FOe = (...e) => (t) => e.reduce(
  (r, n) => r || n(t, {}),
  void 0
), yOe = (e) => (t) => {
  if (!t)
    return;
  const r = parseInt(t);
  if (Number.isNaN(r) || r < e)
    return wr.INVALID_VALUE;
}, bOe = (e) => (t) => {
  if (!t)
    return;
  const r = parseInt(t);
  if (Number.isNaN(r) || r > e)
    return wr.INVALID_VALUE;
}, vOe = (e) => e ? !tx.test(e) && wr.WRONG_FORMAT : !1, EOe = (e) => !e || tx.test(e) || kH.test(e) ? !1 : wr.WRONG_FORMAT, $Oe = (e) => (t) => {
  if (!t)
    return;
  const r = (a) => a.replace(xH, "");
  return e.some(
    (a) => r(a) === r(t)
  ) ? wr.ALREADY_EXISTS : void 0;
}, wOe = (e) => {
  if (!e || e.length < 6)
    return wr.TOO_SHORT;
  try {
    const { country: t, number: r } = XD(e);
    return Qne(r.toString(), t) ? void 0 : wr.WRONG_FORMAT;
  } catch {
    return wr.INVALID_VALUE;
  }
}, kOe = (e) => {
  if (/[,%_^"]/.test(e))
    return wr.INVALID_NUMBER_NAME;
};
function Zne(e, t) {
  var r = rae(t);
  return r.formatToParts ? eae(r, e) : tae(r, e);
}
var Jne = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function eae(e, t) {
  try {
    for (var r = e.formatToParts(t), n = [], a = 0; a < r.length; a++) {
      var i = Jne[r[a].type];
      i >= 0 && (n[i] = parseInt(r[a].value, 10));
    }
    return n;
  } catch (o) {
    if (o instanceof RangeError)
      return [NaN];
    throw o;
  }
}
function tae(e, t) {
  var r = e.format(t).replace(/\u200E/g, ""), n = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(r);
  return [n[3], n[1], n[2], n[4], n[5], n[6]];
}
var z_ = {};
function rae(e) {
  if (!z_[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(new Date("2014-06-25T04:00:00.123Z")), r = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    z_[e] = r ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return z_[e];
}
function ZD(e, t, r, n, a, i, o) {
  var u = new Date(0);
  return u.setUTCFullYear(e, t, r), u.setUTCHours(n, a, i, o), u;
}
var Zv = 36e5, nae = 6e4, K_ = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function aae(e, t, r) {
  var n, a;
  if (!e || (n = K_.timezoneZ.exec(e), n))
    return 0;
  var i;
  if (n = K_.timezoneHH.exec(e), n)
    return i = parseInt(n[1], 10), Jv(i) ? -(i * Zv) : NaN;
  if (n = K_.timezoneHHMM.exec(e), n) {
    i = parseInt(n[1], 10);
    var o = parseInt(n[2], 10);
    return Jv(i, o) ? (a = Math.abs(i) * Zv + o * nae, i > 0 ? -a : a) : NaN;
  }
  if (sae(e)) {
    t = new Date(t || Date.now());
    var u = r ? t : iae(t), d = $m(u, e), s = r ? d : oae(t, d, e);
    return -s;
  }
  return NaN;
}
function iae(e) {
  return ZD(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function $m(e, t) {
  var r = Zne(e, t), n = ZD(
    r[0],
    r[1] - 1,
    r[2],
    r[3] % 24,
    r[4],
    r[5],
    0
  ).getTime(), a = e.getTime(), i = a % 1e3;
  return a -= i >= 0 ? i : 1e3 + i, n - a;
}
function oae(e, t, r) {
  var n = e.getTime(), a = n - t, i = $m(new Date(a), r);
  if (t === i)
    return t;
  a -= i - t;
  var o = $m(new Date(a), r);
  return i === o ? i : Math.max(i, o);
}
function Jv(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var e5 = {};
function sae(e) {
  if (e5[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), e5[e] = !0, !0;
  } catch {
    return !1;
  }
}
function uae(e, t) {
  return -aae(e, t);
}
const dae = [
  {
    value: "Etc/GMT+12",
    name: "International Date Line West"
  },
  {
    value: "Pacific/Pago_Pago",
    name: "American Samoa"
  },
  {
    value: "Pacific/Midway",
    name: "Midway Island"
  },
  {
    value: "Pacific/Honolulu",
    name: "Hawaii"
  },
  {
    value: "America/Juneau",
    name: "Alaska"
  },
  {
    value: "America/Los_Angeles",
    name: "Pacific Time (US & Canada)"
  },
  {
    value: "America/Tijuana",
    name: "Tijuana"
  },
  {
    value: "America/Phoenix",
    name: "Arizona"
  },
  {
    value: "America/Chihuahua",
    name: "Chihuahua"
  },
  {
    value: "America/Mazatlan",
    name: "Mazatlan"
  },
  {
    value: "America/Denver",
    name: "Mountain Time (US & Canada)"
  },
  {
    value: "America/Guatemala",
    name: "Central America"
  },
  {
    value: "America/Chicago",
    name: "Central Time (US & Canada)"
  },
  {
    value: "America/Mexico_City",
    name: "Mexico City"
  },
  {
    value: "America/Monterrey",
    name: "Monterrey"
  },
  {
    value: "America/Regina",
    name: "Saskatchewan"
  },
  {
    value: "America/Bogota",
    name: "Bogota"
  },
  {
    value: "America/New_York",
    name: "Eastern Time (US & Canada)"
  },
  {
    value: "America/Indiana/Indianapolis",
    name: "Indiana (East)"
  },
  {
    value: "America/Lima",
    name: "Lima"
  },
  {
    value: "America/Halifax",
    name: "Atlantic Time (Canada)"
  },
  {
    value: "America/Caracas",
    name: "Caracas"
  },
  {
    value: "America/Guyana",
    name: "Georgetown"
  },
  {
    value: "America/La_Paz",
    name: "La Paz"
  },
  {
    value: "America/Puerto_Rico",
    name: "Puerto Rico"
  },
  {
    value: "America/Santiago",
    name: "Santiago"
  },
  {
    value: "America/St_Johns",
    name: "Newfoundland"
  },
  {
    value: "America/Sao_Paulo",
    name: "Brasilia"
  },
  {
    value: "America/Argentina/Buenos_Aires",
    name: "Buenos Aires"
  },
  {
    value: "America/Godthab",
    name: "Greenland"
  },
  {
    value: "America/Montevideo",
    name: "Montevideo"
  },
  {
    value: "Atlantic/South_Georgia",
    name: "Mid-Atlantic"
  },
  {
    value: "Atlantic/Azores",
    name: "Azores"
  },
  {
    value: "Atlantic/Cape_Verde",
    name: "Cape Verde Is."
  },
  {
    value: "Africa/Casablanca",
    name: "Casablanca"
  },
  {
    value: "Europe/Dublin",
    name: "Dublin"
  },
  {
    value: "Europe/Lisbon",
    name: "Lisbon"
  },
  {
    value: "Europe/London",
    name: "London"
  },
  {
    value: "Africa/Monrovia",
    name: "Monrovia"
  },
  {
    value: "Etc/UTC",
    name: "UTC"
  },
  {
    value: "Europe/Amsterdam",
    name: "Amsterdam"
  },
  {
    value: "Europe/Belgrade",
    name: "Belgrade"
  },
  {
    value: "Europe/Berlin",
    name: "Berlin"
  },
  {
    value: "Europe/Bratislava",
    name: "Bratislava"
  },
  {
    value: "Europe/Brussels",
    name: "Brussels"
  },
  {
    value: "Europe/Budapest",
    name: "Budapest"
  },
  {
    value: "Europe/Copenhagen",
    name: "Copenhagen"
  },
  {
    value: "Europe/Ljubljana",
    name: "Ljubljana"
  },
  {
    value: "Europe/Madrid",
    name: "Madrid"
  },
  {
    value: "Europe/Paris",
    name: "Paris"
  },
  {
    value: "Europe/Prague",
    name: "Prague"
  },
  {
    value: "Europe/Rome",
    name: "Rome"
  },
  {
    value: "Europe/Sarajevo",
    name: "Sarajevo"
  },
  {
    value: "Europe/Skopje",
    name: "Skopje"
  },
  {
    value: "Europe/Stockholm",
    name: "Stockholm"
  },
  {
    value: "Europe/Vienna",
    name: "Vienna"
  },
  {
    value: "Europe/Warsaw",
    name: "Warsaw"
  },
  {
    value: "Africa/Algiers",
    name: "West Central Africa"
  },
  {
    value: "Europe/Zagreb",
    name: "Zagreb"
  },
  {
    value: "Europe/Zurich",
    name: "Zurich"
  },
  {
    value: "Europe/Athens",
    name: "Athens"
  },
  {
    value: "Europe/Bucharest",
    name: "Bucharest"
  },
  {
    value: "Africa/Cairo",
    name: "Cairo"
  },
  {
    value: "Africa/Harare",
    name: "Harare"
  },
  {
    value: "Europe/Helsinki",
    name: "Helsinki"
  },
  {
    value: "Asia/Jerusalem",
    name: "Jerusalem"
  },
  {
    value: "Europe/Kaliningrad",
    name: "Kaliningrad"
  },
  {
    value: "Europe/Kiev",
    name: "Kyiv"
  },
  {
    value: "Africa/Johannesburg",
    name: "Pretoria"
  },
  {
    value: "Europe/Riga",
    name: "Riga"
  },
  {
    value: "Europe/Sofia",
    name: "Sofia"
  },
  {
    value: "Europe/Tallinn",
    name: "Tallinn"
  },
  {
    value: "Europe/Vilnius",
    name: "Vilnius"
  },
  {
    value: "Asia/Baghdad",
    name: "Baghdad"
  },
  {
    value: "Europe/Istanbul",
    name: "Istanbul"
  },
  {
    value: "Asia/Kuwait",
    name: "Kuwait"
  },
  {
    value: "Europe/Minsk",
    name: "Minsk"
  },
  {
    value: "Europe/Moscow",
    name: "Moscow"
  },
  {
    value: "Africa/Nairobi",
    name: "Nairobi"
  },
  {
    value: "Asia/Riyadh",
    name: "Riyadh"
  },
  {
    value: "Asia/Tehran",
    name: "Tehran"
  },
  {
    value: "Asia/Baku",
    name: "Baku"
  },
  {
    value: "Asia/Muscat",
    name: "Muscat"
  },
  {
    value: "Europe/Samara",
    name: "Samara"
  },
  {
    value: "Asia/Tbilisi",
    name: "Tbilisi"
  },
  {
    value: "Europe/Volgograd",
    name: "Volgograd"
  },
  {
    value: "Asia/Yerevan",
    name: "Yerevan"
  },
  {
    value: "Asia/Kabul",
    name: "Kabul"
  },
  {
    value: "Asia/Yekaterinburg",
    name: "Ekaterinburg"
  },
  {
    value: "Asia/Karachi",
    name: "Karachi"
  },
  {
    value: "Asia/Tashkent",
    name: "Tashkent"
  },
  {
    value: "Asia/Kolkata",
    name: "Kolkata"
  },
  {
    value: "Asia/Colombo",
    name: "Sri Jayawardenepura"
  },
  {
    value: "Asia/Kathmandu",
    name: "Kathmandu"
  },
  {
    value: "Asia/Almaty",
    name: "Almaty"
  },
  {
    value: "Asia/Dhaka",
    name: "Dhaka"
  },
  {
    value: "Asia/Urumqi",
    name: "Urumqi"
  },
  {
    value: "Asia/Rangoon",
    name: "Rangoon"
  },
  {
    value: "Asia/Bangkok",
    name: "Bangkok"
  },
  {
    value: "Asia/Jakarta",
    name: "Jakarta"
  },
  {
    value: "Asia/Krasnoyarsk",
    name: "Krasnoyarsk"
  },
  {
    value: "Asia/Novosibirsk",
    name: "Novosibirsk"
  },
  {
    value: "Asia/Shanghai",
    name: "Beijing"
  },
  {
    value: "Asia/Chongqing",
    name: "Chongqing"
  },
  {
    value: "Asia/Hong_Kong",
    name: "Hong Kong"
  },
  {
    value: "Asia/Irkutsk",
    name: "Irkutsk"
  },
  {
    value: "Asia/Kuala_Lumpur",
    name: "Kuala Lumpur"
  },
  {
    value: "Australia/Perth",
    name: "Perth"
  },
  {
    value: "Asia/Singapore",
    name: "Singapore"
  },
  {
    value: "Asia/Taipei",
    name: "Taipei"
  },
  {
    value: "Asia/Ulaanbaatar",
    name: "Ulaanbaatar"
  },
  {
    value: "Asia/Seoul",
    name: "Seoul"
  },
  {
    value: "Asia/Tokyo",
    name: "Tokyo"
  },
  {
    value: "Asia/Yakutsk",
    name: "Yakutsk"
  },
  {
    value: "Australia/Adelaide",
    name: "Adelaide"
  },
  {
    value: "Australia/Darwin",
    name: "Darwin"
  },
  {
    value: "Australia/Brisbane",
    name: "Brisbane"
  },
  {
    value: "Pacific/Guam",
    name: "Guam"
  },
  {
    value: "Australia/Hobart",
    name: "Hobart"
  },
  {
    value: "Australia/Melbourne",
    name: "Melbourne"
  },
  {
    value: "Pacific/Port_Moresby",
    name: "Port Moresby"
  },
  {
    value: "Australia/Sydney",
    name: "Sydney"
  },
  {
    value: "Asia/Vladivostok",
    name: "Vladivostok"
  },
  {
    value: "Asia/Magadan",
    name: "Magadan"
  },
  {
    value: "Pacific/Noumea",
    name: "New Caledonia"
  },
  {
    value: "Pacific/Guadalcanal",
    name: "Solomon Is."
  },
  {
    value: "Asia/Srednekolymsk",
    name: "Srednekolymsk"
  },
  {
    value: "Pacific/Auckland",
    name: "Auckland"
  },
  {
    value: "Pacific/Fiji",
    name: "Fiji"
  },
  {
    value: "Asia/Kamchatka",
    name: "Kamchatka"
  },
  {
    value: "Pacific/Majuro",
    name: "Marshall Is."
  },
  {
    value: "Pacific/Chatham",
    name: "Chatham Is."
  },
  {
    value: "Pacific/Tongatapu",
    name: "Nuku'alofa"
  },
  {
    value: "Pacific/Apia",
    name: "Samoa"
  },
  {
    value: "Pacific/Fakaofo",
    name: "Tokelau Is."
  }
];
function lae(e) {
  const t = uae(e), r = t >= 0 ? "+" : "-";
  let n = Math.abs(Math.floor(t / 36e5));
  e === "America/St_Johns" && (n -= 1);
  const a = r + n.toString().padStart(2, "0"), i = (Math.abs(t) % 36e5 / 6e4).toString().padStart(2, "0");
  return `${a}:${i}`;
}
function fae(e = dae) {
  function t(n) {
    const a = lae(n.value);
    return {
      ...n,
      formattedUtcOffset: `UTC${a}`,
      utcOffset: parseInt(a.replace(":", ""), 10)
    };
  }
  function r(n, a) {
    return n.utcOffset !== a.utcOffset ? n.utcOffset > a.utcOffset ? 1 : -1 : n.name > a.name ? 1 : -1;
  }
  return e.map(t).sort(r);
}
const Mh = M.memo(
  ({
    initials: e,
    "data-test": t = "dashboard-avatar",
    src: r,
    variant: n,
    ...a
  }) => {
    const i = n || Kne(e);
    return /* @__PURE__ */ b(ch, { "data-test": t, variant: i, ...a, children: r ? /* @__PURE__ */ b(Bw, { src: r }) : /* @__PURE__ */ b(mM, { initials: e }) });
  }
);
function cae({
  status: e,
  tooltipDurations: t,
  texts: r
}) {
  let n = null;
  switch (e) {
    case Je.IN_IVR: {
      n = /* @__PURE__ */ b($e, { children: r.tooltip });
      break;
    }
    case Je.RINGING:
    case Je.IN_CALL:
    case Je.IN_QUEUE: {
      n = /* @__PURE__ */ b(Ae, { children: /* @__PURE__ */ b($e, { children: r.tooltip }) });
      break;
    }
    case Je.UNANSWERED:
    case Je.UNANSWERED_ABANDONED_BEFORE_10_SECONDS:
    case Je.UNANSWERED_ABANDONED_DURING_WELCOME_MESSAGE:
    case Je.UNANSWERED_ABANDONED_IN_IVR:
    case Je.UNANSWERED_ALL_AGENTS_UNAVAILABLE:
    case Je.UNANSWERED_CALLBACK_REQUEST:
    case Je.UNANSWERED_OUTSIDE_BUSINESS_HOURS:
    case Je.UNANSWERED_USERS_DID_NOT_ANSWER:
    case Je.ANSWERED: {
      n = /* @__PURE__ */ b(
        Bh,
        {
          rows: t.map((a, i) => {
            var o;
            return [
              // eslint-disable-next-line react/no-array-index-key
              /* @__PURE__ */ b(n4, { display: "inline", seconds: a }, i),
              (o = r.tooltipDurations) == null ? void 0 : o[i]
            ];
          })
        }
      );
      break;
    }
  }
  return /* @__PURE__ */ b(ot, { "data-test": "call-status-tooltip-content", children: n });
}
function hae({
  duration: e,
  status: t,
  texts: r
}) {
  let n = "text-base", a = null;
  switch (t) {
    case Je.IN_IVR:
    case Je.IN_QUEUE:
    case Je.RINGING:
    case Je.IN_CALL:
      a = /* @__PURE__ */ b($e, { color: n, variant: "bodyMediumS", children: r.title });
      break;
    case Je.ANSWERED:
      a = /* @__PURE__ */ b(n4, { color: n, variant: "bodyMediumS", seconds: e, children: (i) => r.duration(i) });
      break;
    case Je.UNANSWERED:
    case Je.UNANSWERED_ABANDONED_BEFORE_10_SECONDS:
    case Je.UNANSWERED_ABANDONED_DURING_WELCOME_MESSAGE:
    case Je.UNANSWERED_ABANDONED_IN_IVR:
    case Je.UNANSWERED_ALL_AGENTS_UNAVAILABLE:
    case Je.UNANSWERED_CALLBACK_REQUEST:
    case Je.UNANSWERED_OUTSIDE_BUSINESS_HOURS:
    case Je.UNANSWERED_USERS_DID_NOT_ANSWER:
      n = "text-placeholder", a = /* @__PURE__ */ b($e, { color: n, variant: "bodyMediumS", children: "0s" });
      break;
  }
  return a;
}
function gae({
  status: e,
  duration: t,
  texts: r
}) {
  let n = null;
  switch (e) {
    case Je.IN_IVR:
    case Je.IN_QUEUE:
    case Je.RINGING:
    case Je.IN_CALL:
      n = /* @__PURE__ */ b(
        r4,
        {
          color: "neutral-400",
          variant: "supportingMediumS",
          seconds: t,
          children: (a) => r.duration(a)
        }
      );
      break;
    case Je.ANSWERED:
    case Je.UNANSWERED:
    case Je.UNANSWERED_ABANDONED_BEFORE_10_SECONDS:
    case Je.UNANSWERED_ABANDONED_DURING_WELCOME_MESSAGE:
    case Je.UNANSWERED_ABANDONED_IN_IVR:
    case Je.UNANSWERED_ALL_AGENTS_UNAVAILABLE:
    case Je.UNANSWERED_CALLBACK_REQUEST:
    case Je.UNANSWERED_OUTSIDE_BUSINESS_HOURS:
    case Je.UNANSWERED_USERS_DID_NOT_ANSWER:
      break;
    default:
      n = /* @__PURE__ */ b($e, { color: "neutral-400", variant: "supportingMediumS" });
      break;
  }
  return n;
}
function wm({
  status: e,
  size: t,
  "data-test": r = "call-status-icon",
  ...n
}) {
  let a = "secondary-700", i = null;
  switch (e) {
    case Je.IN_IVR:
      i = tM;
      break;
    case Je.IN_QUEUE:
      i = eM;
      break;
    case Je.RINGING:
      i = Jj;
      break;
    case Je.IN_CALL:
      i = Zj, a = "primary-500";
      break;
    case Je.ANSWERED:
      i = Qj;
      break;
    default:
      i = Xj, a = "critical-500";
      break;
  }
  return /* @__PURE__ */ b(
    sr,
    {
      "data-test": `${r}-${e}`,
      size: t,
      color: a,
      ...n,
      component: i
    }
  );
}
function xOe({
  status: e,
  iconSize: t = 24,
  duration: r = 0,
  tooltipDurations: n = [],
  texts: a,
  "data-test": i = "call-status"
}) {
  const o = [
    Je.IN_IVR,
    Je.IN_QUEUE,
    Je.RINGING,
    Je.IN_CALL
  ].includes(e);
  return /* @__PURE__ */ b(
    hh,
    {
      content: /* @__PURE__ */ b(
        cae,
        {
          status: e,
          duration: r,
          tooltipDurations: n,
          texts: a
        }
      ),
      sideOffset: 2,
      children: /* @__PURE__ */ ne(Dt, { space: "xxs", alignItems: "center", "data-test": i, children: [
        o ? /* @__PURE__ */ b(
          wm,
          {
            status: e,
            size: t,
            "data-test": `${i}-icon`
          }
        ) : /* @__PURE__ */ b(ot, { w: t, h: t }),
        /* @__PURE__ */ ne(Dt, { space: 0, direction: "vertical", children: [
          /* @__PURE__ */ b(hae, { status: e, duration: r, texts: a }),
          /* @__PURE__ */ b(
            gae,
            {
              status: e,
              duration: r,
              texts: a
            }
          )
        ] })
      ] })
    }
  );
}
function ko({
  children: e,
  visible: t,
  "data-test": r = "conditional-tooltip",
  ...n
}) {
  return t ? /* @__PURE__ */ b(hh, { ...n, "data-test": r, children: e }) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment -- required for valid return type
    /* @__PURE__ */ b(Nr, { children: e })
  );
}
function Bh({ rows: e }) {
  return /* @__PURE__ */ b($e, { display: "inline", "data-test": "tooltip-content", children: e.map(([t, r], n) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ ne(ot, { children: [
      t,
      r && /* @__PURE__ */ ne($e, { display: "inline", color: "text-placeholder", children: [
        " - ",
        r
      ] })
    ] }, n)
  )) });
}
function _ae(e, t, r) {
  if (r)
    return "warning-500";
  switch (t) {
    case Je.IN_CALL:
    case Je.ANSWERED:
      return e === W1.INBOUND ? "primary-500" : "informative-500";
    case Je.IN_IVR:
    case Je.IN_QUEUE:
    case Je.RINGING:
      return "neutral-400";
    default:
      return "critical-500";
  }
}
function mae(e, t, r) {
  if (r)
    return xb;
  switch (e) {
    case W1.INBOUND:
      return nM;
    case W1.OUTBOUND:
      return rM;
    default:
      return xb;
  }
}
function DOe({
  direction: e,
  status: t,
  texts: r,
  withVoicemail: n = !1,
  ...a
}) {
  var u;
  const i = _ae(e, t, n), o = mae(e, t, n);
  return /* @__PURE__ */ b(
    ko,
    {
      visible: !!((u = r == null ? void 0 : r.tooltip) != null && u.length),
      content: /* @__PURE__ */ b(Bh, { rows: (r == null ? void 0 : r.tooltip) || [] }),
      align: "center",
      side: "top",
      sideOffset: -2,
      mouseEnterDelay: 0,
      mouseLeaveDelay: 100,
      "data-test": "call-type-icon-tooltip",
      children: /* @__PURE__ */ b(sr, { ...a, color: i, component: o })
    }
  );
}
const pae = Ge(sr)`
  display: flex;
  width: max-content;
  align-items: center;
  justify-content: center;
  padding: 0 ${vt("s")} 0 ${vt("xxs")};
  cursor: ${({ cursor: e }) => e ?? "default"};
`;
function COe({ direction: e, ...t }) {
  return /* @__PURE__ */ b(
    pae,
    {
      "data-test": "chevron",
      ...t,
      component: e === "up" ? F3 : Su
    }
  );
}
function SOe({
  children: e,
  show: t,
  onConfirm: r,
  onCancel: n,
  disabled: a,
  loading: i = !1,
  "data-test": o = "confirmation-modal",
  texts: u
}) {
  return /* @__PURE__ */ ne(
    b3,
    {
      show: t,
      onHide: n,
      size: "small",
      "data-test": o,
      children: [
        /* @__PURE__ */ b(v3, { children: /* @__PURE__ */ ne(Dt, { direction: "vertical", space: "m", fluid: !0, children: [
          /* @__PURE__ */ ne(
            Dt,
            {
              alignItems: "center",
              justifyContent: "center",
              direction: "vertical",
              space: "m",
              fluid: !0,
              children: [
                /* @__PURE__ */ b(
                  $e,
                  {
                    variant: "bodySemiboldM",
                    textAlign: "center",
                    whiteSpace: "break-spaces",
                    children: u.confirmation
                  }
                ),
                e
              ]
            }
          ),
          u.error || u.banner ? /* @__PURE__ */ ne(Dt, { space: "xxs", direction: "vertical", fluid: !0, children: [
            u.banner && /* @__PURE__ */ ne(wl, { variant: "warning", inline: !0, children: [
              /* @__PURE__ */ b(kl, {}),
              /* @__PURE__ */ b(xl, { children: u.banner })
            ] }),
            u.error && /* @__PURE__ */ ne(wl, { variant: "critical", inline: !0, children: [
              /* @__PURE__ */ b(kl, {}),
              /* @__PURE__ */ b(xl, { children: u.error })
            ] })
          ] }) : null
        ] }) }),
        /* @__PURE__ */ b(E3, { children: /* @__PURE__ */ ne(Dt, { space: "xxs", alignItems: "center", children: [
          /* @__PURE__ */ b(
            nr,
            {
              mode: "ghost",
              variant: "secondary",
              onClick: n,
              "data-test": `${o}-cancel`,
              children: u.cancel
            }
          ),
          i ? /* @__PURE__ */ b(nr, { disabled: !0, "data-test": `${o}-loading`, children: /* @__PURE__ */ b(sr, { component: Pw, spin: !0 }) }) : /* @__PURE__ */ b(
            nr,
            {
              disabled: a,
              onClick: r,
              "data-test": `${o}-confirm`,
              children: u.confirm
            }
          )
        ] }) })
      ]
    }
  );
}
function Fae() {
  return (e) => {
    const t = document.createElement("textarea");
    t.value = e, document.body.appendChild(t), t.select(), document.execCommand("copy"), document.body.removeChild(t);
  };
}
const yae = 1e3;
function AOe({
  content: e,
  texts: t = {
    copy: "Copy",
    copied: "Copied"
  },
  ...r
}) {
  const n = Fae(), [a, i] = Xe(!1), o = tt(0), u = ue(() => {
    a || (n(e), i(!0), o.current = window.setTimeout(() => {
      i(!1);
    }, yae));
  }, [a, n, e]);
  return at(() => () => clearTimeout(o.current), []), /* @__PURE__ */ ne(nr, { ...r, onClick: u, children: [
    /* @__PURE__ */ b(ot, { display: "inline", position: "relative", children: a ? /* @__PURE__ */ b(lh, {}) : /* @__PURE__ */ b(Iw, {}) }),
    a ? t.copied : t.copy
  ] });
}
var bae = typeof un == "object" && un && un.Object === Object && un, vae = typeof self == "object" && self && self.Object === Object && self;
bae || vae || Function("return this")();
var JD = typeof window < "u" ? td : at;
function r0(e, t, r, n) {
  const a = tt(t);
  JD(() => {
    a.current = t;
  }, [t]), at(() => {
    const i = (r == null ? void 0 : r.current) ?? window;
    if (!(i && i.addEventListener))
      return;
    const o = (u) => {
      a.current(u);
    };
    return i.addEventListener(e, o, n), () => {
      i.removeEventListener(e, o, n);
    };
  }, [e, r, n]);
}
function Eae() {
  const [e, t] = Xe(null), r = ue(async (n) => {
    if (!(navigator != null && navigator.clipboard))
      return console.warn("Clipboard not supported"), !1;
    try {
      return await navigator.clipboard.writeText(n), t(n), !0;
    } catch (a) {
      return console.warn("Copy failed", a), t(null), !1;
    }
  }, []);
  return [e, r];
}
function t5(e) {
  const t = tt(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return JD(() => {
    t.current = e;
  }, [e]), ue((...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, [t]);
}
var Y_ = typeof window > "u";
function eC(e, t, r = {}) {
  const { initializeWithValue: n = !0 } = r, a = ue(
    (c) => r.serializer ? r.serializer(c) : JSON.stringify(c),
    [r]
  ), i = ue(
    (c) => {
      if (r.deserializer)
        return r.deserializer(c);
      if (c === "undefined")
        return;
      const h = t instanceof Function ? t() : t;
      let _;
      try {
        _ = JSON.parse(c);
      } catch (F) {
        return console.error("Error parsing JSON:", F), h;
      }
      return _;
    },
    [r, t]
  ), o = ue(() => {
    const c = t instanceof Function ? t() : t;
    if (Y_)
      return c;
    try {
      const h = window.localStorage.getItem(e);
      return h ? i(h) : c;
    } catch (h) {
      return console.warn(`Error reading localStorage key “${e}”:`, h), c;
    }
  }, [t, e, i]), [u, d] = Xe(() => n ? o() : t instanceof Function ? t() : t), s = t5((c) => {
    Y_ && console.warn(
      `Tried setting localStorage key “${e}” even though environment is not a client`
    );
    try {
      const h = c instanceof Function ? c(o()) : c;
      window.localStorage.setItem(e, a(h)), d(h), window.dispatchEvent(new StorageEvent("local-storage", { key: e }));
    } catch (h) {
      console.warn(`Error setting localStorage key “${e}”:`, h);
    }
  }), l = t5(() => {
    Y_ && console.warn(
      `Tried removing localStorage key “${e}” even though environment is not a client`
    );
    const c = t instanceof Function ? t() : t;
    window.localStorage.removeItem(e), d(c), window.dispatchEvent(new StorageEvent("local-storage", { key: e }));
  });
  at(() => {
    d(o());
  }, [e]);
  const f = ue(
    (c) => {
      c.key && c.key !== e || d(o());
    },
    [e, o]
  );
  return r0("storage", f), r0("local-storage", f), [u, s, l];
}
function $ae(e) {
  const [t, r] = Xe(!1), n = () => {
    r(!0);
  }, a = () => {
    r(!1);
  };
  return r0("mouseenter", n, e), r0("mouseleave", a, e), t;
}
function OOe({
  children: e,
  timeoutDuration: t = 1e3,
  tooltipTexts: r
}) {
  const [, n] = Eae(), [a, i] = Xe(!1), o = tt(0), u = ue(() => {
    a || (n(e), i(!0), o.current = window.setTimeout(() => {
      i(!1);
    }, t));
  }, [a, n, e, t]);
  at(() => () => clearTimeout(o.current), []);
  const d = a ? void 0 : u, s = a ? lh : Iw, l = a ? "primary-500" : "neutral-400";
  return /* @__PURE__ */ ne(ur, { alignItems: "center", gap: "xxs", children: [
    /* @__PURE__ */ b($e, { color: l, children: e }),
    /* @__PURE__ */ b(
      ko,
      {
        visible: !!r,
        title: a ? r == null ? void 0 : r.copied : r == null ? void 0 : r.copy,
        align: "center",
        side: "top",
        mouseEnterDelay: 0,
        mouseLeaveDelay: 100,
        children: /* @__PURE__ */ b(
          _a,
          {
            "data-test": a ? "copied-icon" : "copy-icon",
            size: 24,
            onClick: d,
            component: s,
            color: l
          }
        )
      }
    )
  ] });
}
function Ru({ countryCode: e, size: t = 24, ...r }) {
  return /* @__PURE__ */ b(Nw, { countryCode: e, size: t, ...r });
}
const wae = function({
  option: t,
  render: r,
  renderPrefix: n,
  renderSuffix: a,
  renderDescription: i
}) {
  const { value: o, label: u } = t, d = n == null ? void 0 : n(t), s = a == null ? void 0 : a(t), l = i == null ? void 0 : i(t);
  return /* @__PURE__ */ b(pM, { itemKey: o, style: { borderBottom: "none" }, children: r ? r(t) : /* @__PURE__ */ ne(Nr, { children: [
    d && /* @__PURE__ */ b(FM, { pl: "4px", children: d }),
    /* @__PURE__ */ b($3, { children: /* @__PURE__ */ b($e, { ellipsis: 2, variant: "bodyRegularS", children: u }) }),
    s && /* @__PURE__ */ b(w3, { pl: "4px", children: s }),
    l && /* @__PURE__ */ b(yM, { children: l })
  ] }) }, o);
}, km = sh(
  wae
);
function CF({
  children: e,
  quantity: t,
  ...r
}) {
  return /* @__PURE__ */ b(Dt, { ...r, children: Array(t).fill(void 0).map((n, a) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ b(m3, { children: e(a) }, a)
  )) });
}
function tC({
  count: e = 3,
  "data-test": t = "multi-select-loader"
}) {
  return /* @__PURE__ */ b(
    CF,
    {
      gap: "s",
      direction: "vertical",
      quantity: e,
      px: "s",
      py: "m",
      "data-test": t,
      children: (r) => /* @__PURE__ */ ne(Ae, { gap: "s", alignItems: "center", children: [
        /* @__PURE__ */ b(ls, { h: 16, w: 16, shape: "squircle" }),
        /* @__PURE__ */ b(ls, { h: 12, flex: "1" })
      ] }, r)
    }
  );
}
const kae = Ge(Ae)`
  height: 1px;
  background: ${He("neutral-200")};
`;
function xae({
  allowRemove: e,
  children: t,
  className: r,
  options: n,
  loading: a,
  renderItem: i,
  renderItemPrefix: o,
  renderItemSuffix: u,
  renderTriggerLabel: d,
  renderTriggerPrefix: s,
  renderTriggerSuffix: l,
  w: f,
  minWidth: c,
  maxW: h,
  menuMaxWidth: _,
  menuMinWidth: F = "max-content",
  showSelectedOnTop: v = !1,
  texts: $,
  loadingSkeletonsCount: E,
  "data-test": D = "multi-select",
  disabled: w = !1,
  triggerStyle: k = "filter"
}) {
  const { selectedKeys: A } = rd(), P = {
    placeholder: "Select",
    item: "item",
    items: "items",
    result: "result",
    results: "results",
    ...$ || {}
  }, [S, N] = Xe(/* @__PURE__ */ new Map());
  at(() => {
    N((j) => (A.forEach((G) => {
      if (!j.has(G)) {
        const H = n.find((J) => J.value === G);
        H && j.set(G, H);
      }
    }), j));
  }, [A, n, S]);
  const W = A.reduce((j, G) => {
    const H = n.find((J) => J.value === G) || S.get(G);
    return [...j, ...H ? [H] : []];
  }, []), V = n.filter(
    (j) => v ? !W.find((G) => j.value === G.value) : !0
  ).map((j) => /* @__PURE__ */ b(
    km,
    {
      option: j,
      render: i,
      renderPrefix: o,
      renderSuffix: u
    },
    j.value
  )), K = v ? W.map((j) => /* @__PURE__ */ b(
    km,
    {
      option: j,
      render: i,
      renderPrefix: o,
      renderSuffix: u
    },
    j.value
  )) : [];
  return /* @__PURE__ */ ne(Nr, { children: [
    /* @__PURE__ */ b(Lw, { children: (() => {
      const j = {
        allowRemove: e,
        className: r,
        "data-test": `${D}-trigger`,
        selectedOptions: W,
        placeholder: P.placeholder,
        texts: P,
        minWidth: c,
        maxW: h,
        w: f,
        disabled: w
      };
      return k === "select" ? /* @__PURE__ */ b(
        Iae,
        {
          renderTriggerLabel: d,
          renderTriggerPrefix: s,
          renderTriggerSuffix: l,
          ...j
        }
      ) : /* @__PURE__ */ b(Nae, { ...j });
    })() }),
    /* @__PURE__ */ ne(
      qw,
      {
        takeTriggerWidth: !0,
        maxW: _,
        minWidth: F,
        "data-test": `${D}-content`,
        children: [
          t,
          a ? /* @__PURE__ */ b(
            tC,
            {
              count: E,
              "data-test": `${D}-loader`
            }
          ) : /* @__PURE__ */ ne(Uw, { maxH: "314px", p: "xxs", pt: t ? "0" : "xs", children: [
            K,
            K.length && V.length ? /* @__PURE__ */ b(kae, { "data-test": `${D}-separator` }) : null,
            V
          ] })
        ]
      }
    )
  ] });
}
function Dae(e) {
  const { onSelect: t, ...r } = e, n = ue(
    (a) => {
      t(a);
    },
    [t]
  );
  return /* @__PURE__ */ b(
    Gw,
    {
      selectionMode: "multiple",
      ...r,
      onSelectionChange: n,
      children: /* @__PURE__ */ b(xae, { ...e })
    }
  );
}
function Cae({
  onChange: e,
  value: t,
  onClear: r
}) {
  const n = ue(
    (a) => {
      e(a.target.value);
    },
    [e]
  );
  return /* @__PURE__ */ b(
    nd,
    {
      "data-test": "multi-select-input",
      icon: fh,
      autoFocus: !0,
      value: t,
      onChange: n,
      onClear: t.length ? r : void 0
    }
  );
}
function Sae({
  count: e,
  texts: t = {
    result: "result",
    results: "results"
  }
}) {
  const { side: r } = bM();
  return /* @__PURE__ */ b(Ae, { h: "40px", alignItems: "center", children: /* @__PURE__ */ ne(
    $e,
    {
      variant: "bodyRegularS",
      color: "text-secondary",
      order: r === "top" ? 1 : void 0,
      px: "s",
      children: [
        e,
        " ",
        e === 1 ? t.result : t.results
      ]
    }
  ) });
}
function SF({
  options: e,
  onSearch: t,
  debounceDuration: r = 400,
  loading: n,
  showSelectedOnTop: a = !0,
  resetSearchOnSelect: i = !1,
  isSearch: o = !1,
  onSelect: u,
  resultsCount: d,
  selectionMode: s = "multiple",
  ...l
}) {
  const [f, c] = Xe(""), h = tt(Iu(t, r)), _ = {
    placeholder: "Select",
    item: "item",
    items: "items",
    result: "result",
    results: "results",
    ...l.texts || {}
  }, F = ue(
    ($, E = !1) => {
      c($), E || !r ? t == null || t($) : h.current($);
    },
    [r, t]
  ), v = ue(
    ($) => {
      i && o && F("", !0), u($);
    },
    [F, o, u, i]
  );
  return /* @__PURE__ */ b(
    Dae,
    {
      texts: _,
      options: e,
      loading: n,
      showSelectedOnTop: o ? !1 : a,
      ...l,
      selectionMode: s,
      onSelect: v,
      children: /* @__PURE__ */ ne(Ae, { margin: "xxs", marginBottom: "0", flexDirection: "column", children: [
        /* @__PURE__ */ b(
          Cae,
          {
            onChange: F,
            onClear: () => F("", !0),
            value: f
          }
        ),
        !n && /* @__PURE__ */ b(
          Sae,
          {
            texts: { result: _.result, results: _.results },
            count: d ?? e.length
          }
        )
      ] })
    }
  );
}
function Aae(e, t, r) {
  return t.length > e.length ? `${t.length} ${t.length === 1 ? r.item : r.items}` : e.length > 0 ? e.map(({ label: n }) => n).join(", ") : null;
}
function Oae({ disabled: e }) {
  return e ? _r`
      background-color: ${pt("surface-disabled")};
      border: 1px solid;
      border-color: ${pt("graphic-disabled")};
      cursor: not-allowed;
    ` : _r`
    background-color: ${pt("surface-default")};
    border: 1px solid;
    border-color: ${pt("graphic-interactive-default")};

    &:hover {
      border-color: ${pt("graphic-interactive-default-hover")};
    }

    &:active {
      border-color: ${pt("graphic-interactive-default-active")};
    }
  `;
}
const Tae = Ge(Ae)`
  ${Oae};

  height: 48px;

  transition:
    300ms background-color,
    300ms border-color;
`;
function Pae({
  className: e,
  placeholder: t,
  texts: r,
  selectedOptions: n,
  "data-test": a = "multi-select-trigger",
  renderTriggerLabel: i,
  renderTriggerPrefix: o,
  renderTriggerSuffix: u,
  disabled: d,
  allowRemove: s = !1,
  ...l
}, f) {
  const { selectedKeys: c, open: h, removeAll: _ } = rd(), v = c.length > 0, $ = (i == null ? void 0 : i(n)) || Aae(n, c, r), E = ue(
    (w) => {
      w.stopPropagation(), _();
    },
    [_]
  ), D = () => v && s ? /* @__PURE__ */ b(
    _a,
    {
      "data-test": "multi-select-trigger-remove",
      "aria-label": "remove selection",
      disabled: d,
      color: d ? "icon-disabled" : "icon-default",
      size: "24px",
      ml: "auto",
      component: Rw,
      onClick: d ? void 0 : E
    }
  ) : /* @__PURE__ */ b(
    sr,
    {
      "data-test": h ? "multi-select-trigger-arrow-up" : "multi-select-trigger-arrow-down",
      color: d ? "icon-disabled" : "icon-default",
      ml: "auto",
      size: "24px",
      component: h ? F3 : Su
    }
  );
  return /* @__PURE__ */ ne(
    Tae,
    {
      "data-test": a,
      borderRadius: "sm",
      className: e,
      color: d ? "text-disabled" : "text-base",
      cursor: "pointer",
      px: "xs",
      alignItems: "center",
      userSelect: "none",
      ref: f,
      disabled: d,
      gap: "xxs",
      ...l,
      children: [
        n.length === 1 ? o == null ? void 0 : o(n[0]) : null,
        /* @__PURE__ */ b(
          $e,
          {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            variant: d ? "bodyMediumS" : "bodyRegularS",
            title: typeof $ == "string" ? $ : "",
            children: $ ?? t
          }
        ),
        n.length === 1 ? u == null ? void 0 : u(n[0]) : null,
        D()
      ]
    }
  );
}
const Iae = Xn(Pae);
function Rae(e, t) {
  return !t && e > 0 ? "text-inverted" : t ? "text-disabled" : "text-base";
}
function jae(e, t, r) {
  const n = t.length, [a] = e;
  return n === 1 && (a == null ? void 0 : a.value) === t[0] ? a.label : n >= 1 ? `${n} ${n === 1 ? r.item : r.items}` : null;
}
function Mae({
  disabled: e,
  hasSelectedKeys: t
}) {
  return e ? _r`
      background-color: ${pt(t ? "surface-interactive-disabled" : "surface-default")};
      border: 1px solid;
      border-color: ${pt("graphic-disabled")};
      cursor: not-allowed;
    ` : t ? _r`
      background-color: ${pt("surface-interactive-secondary")};
      border: 1px solid;
      border-color: ${pt("graphic-interactive-primary-ghost")};

      &:hover {
        background-color: ${pt("surface-interactive-secondary-hover")};
      }

      &:active {
        background-color: ${pt("surface-interactive-secondary-active")};
      }
    ` : _r`
    background-color: ${pt("surface-default")};
    border: 1px solid;
    border-color: ${pt("graphic-interactive-default")};

    &:hover {
      border-color: ${pt("graphic-interactive-default-hover")};
    }

    &:active {
      border-color: ${pt("graphic-interactive-default-active")};
    }
  `;
}
const rC = Ge(Ae)`
  ${Mae};

  height: 40px;

  transition:
    300ms background-color,
    300ms border-color;
`;
function Bae({
  allowRemove: e = !0,
  className: t,
  placeholder: r,
  texts: n,
  selectedOptions: a,
  "data-test": i = "multi-select-trigger",
  disabled: o,
  ...u
}, d) {
  const { selectedKeys: s, removeAll: l, open: f } = rd(), c = s.length, h = c > 0, _ = ue(
    (E) => {
      E.stopPropagation(), l();
    },
    [l]
  );
  function F() {
    return h ? e ? /* @__PURE__ */ b(
      _a,
      {
        "data-test": "multi-select-trigger-remove",
        "aria-label": "remove selection",
        color: o ? "icon-disabled" : "icon-inverted",
        discColor: "icon-interactive-secondary",
        disabled: o,
        size: "24px",
        ml: "auto",
        component: Cf,
        onClick: o ? void 0 : _
      }
    ) : null : /* @__PURE__ */ b(
      sr,
      {
        "data-test": f ? "multi-select-trigger-arrow-up" : "multi-select-trigger-arrow-down",
        color: o ? "icon-disabled" : "icon-default",
        ml: "auto",
        size: "16px",
        component: f ? dh : Df
      }
    );
  }
  const v = Rae(c, o), $ = jae(a, s, n);
  return /* @__PURE__ */ ne(
    rC,
    {
      className: t,
      "data-test": i,
      borderRadius: "sm",
      color: v,
      cursor: "pointer",
      px: "xs",
      alignItems: "center",
      userSelect: "none",
      hasSelectedKeys: h,
      ref: d,
      disabled: o,
      gap: "xxs",
      ...u,
      children: [
        /* @__PURE__ */ b(
          $e,
          {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            variant: "bodyMediumS",
            title: $ ?? "",
            children: $ ?? r
          }
        ),
        F()
      ]
    }
  );
}
const Nae = Xn(Bae);
function TOe({
  language: e,
  showDialCode: t = !1,
  w: r = "200px",
  maxW: n = "200px",
  disabled: a,
  triggerStyle: i,
  countries: o,
  ...u
}) {
  const [d, s] = Xe(void 0), l = qe(() => Hk.filter(
    (E) => o ? o.includes(E.code) : !0
  ).map((E) => ({
    ...E,
    name: rx(E.code, e)
  })).sort((E, D) => bF(E.name, D.name)).map((E) => ({
    label: E.name,
    value: E.code,
    dialCode: E.dial_code
  })), [o, e]), f = ue(
    ($) => /* @__PURE__ */ b(Ru, { countryCode: $.value, size: 24, mr: "xxs" }),
    []
  ), c = ue(
    ($) => t ? /* @__PURE__ */ ne(
      $e,
      {
        color: a ? "text-disabled" : "text-base",
        variant: "bodyRegularS",
        flexShrink: 0,
        children: [
          " (",
          $.dialCode,
          ")"
        ]
      }
    ) : null,
    [t, a]
  ), h = ue(
    ($) => /* @__PURE__ */ b(Ru, { countryCode: $.value }),
    []
  ), _ = ue(
    ($) => t ? /* @__PURE__ */ b($e, { color: "text-base", variant: "bodyRegularS", children: $.dialCode }) : null,
    [t]
  ), F = ue(
    ($) => {
      if ($ === "") {
        s(void 0);
        return;
      }
      const E = l.filter(
        (D) => nx(D.label, $)
      );
      s(E);
    },
    [l]
  ), { texts: v } = u;
  return /* @__PURE__ */ b(
    SF,
    {
      ...u,
      options: d || l,
      isSearch: !!d,
      renderItemPrefix: h,
      renderItemSuffix: _,
      renderTriggerPrefix: f,
      renderTriggerSuffix: c,
      triggerStyle: i,
      texts: v || {
        item: "country",
        items: "countries",
        result: "result",
        results: "results"
      },
      w: r,
      maxW: n,
      disabled: a,
      onSearch: F,
      debounceDuration: 0
    }
  );
}
function Lae({
  language: e,
  w: t = "200px",
  maxW: r = "200px",
  disabled: n,
  showCountryName: a = !0,
  ...i
}) {
  const [o, u] = Xe(void 0), d = qe(() => Hk.map((F) => ({
    ...F,
    name: rx(F.code, e)
  })).sort((F, v) => bF(F.name, v.name)).map((F) => {
    const { name: v, dial_code: $ } = F;
    return {
      label: `${$} ${v}`,
      value: F.code,
      countryName: v,
      dialCode: $
    };
  }), [e]), s = ue(
    (_) => {
      if (_ === "") {
        u(void 0);
        return;
      }
      const F = d.filter(
        (v) => nx(v.label, _)
      );
      u(F);
    },
    [d]
  ), l = ue(
    (_) => /* @__PURE__ */ b(Ru, { countryCode: _.value }),
    []
  ), f = ue(
    (_) => /* @__PURE__ */ b(Ru, { countryCode: _.value, size: 24, mr: "xxs" }),
    []
  ), c = ue(
    (_) => {
      const F = _[0];
      if (!F)
        return "";
      const { countryName: v, dialCode: $ } = F;
      return a ? `${$} ${v}` : `${$}`;
    },
    [a]
  ), { texts: h } = i;
  return /* @__PURE__ */ b(
    SF,
    {
      ...i,
      selectionMode: "single",
      triggerStyle: "select",
      options: o || d,
      isSearch: !!o,
      renderItemPrefix: l,
      renderTriggerLabel: c,
      renderTriggerPrefix: f,
      texts: h || {
        item: "country",
        items: "countries",
        result: "result",
        results: "results"
      },
      w: t,
      maxW: r,
      disabled: n,
      onSearch: s,
      debounceDuration: 0
    }
  );
}
function qae(e, t, r = "en-US") {
  if (!t)
    return `${n1(e, r)} -`;
  if (!ex(e, t))
    return `${n1(e, r)} - ${n1(t, r)}`;
  if (H2(e, t))
    return x6(e) ? `${k_(e, r)} ${w_(
      e,
      r
    )}` : `${n1(e, r)}`;
  const n = [
    k_(e, r),
    k_(t, r)
  ], a = [
    w_(e, r),
    w_(t, r)
  ], i = hH(e, t) ? "" : `${n[1]} `, o = x6(e) ? "" : `, ${lH(e)}`, u = `${n[0]} ${a[0]}`, d = `${i}${a[1]}`;
  return `${u} - ${d}${o}`;
}
function Uae(e, t, r = []) {
  if (e && t)
    return r.find(
      ({ startDate: n, endDate: a }) => H2(n, e) && H2(a, t)
    );
}
function Gae(e, t = [], r = "en-US") {
  const { startDate: n, endDate: a } = e;
  if (t.length > 0) {
    const i = Uae(
      n,
      a,
      t
    );
    if (i)
      return i.label;
  }
  return n ? qae(n, a, r) : null;
}
function Wae(e, t) {
  return !t && e ? "text-inverted" : t ? "text-disabled" : "text-base";
}
function Vae({
  allowRemove: e = !0,
  className: t,
  "data-test": r = "date-select-input",
  value: n,
  placeholder: a,
  onClear: i,
  icon: o = Df,
  disabled: u = !1,
  ...d
}, s) {
  const l = ue(
    (h) => {
      n && (h.stopPropagation(), i());
    },
    [n, i]
  );
  function f() {
    return n ? e ? /* @__PURE__ */ b(
      _a,
      {
        color: u ? "icon-disabled" : "icon-inverted",
        discColor: "icon-interactive-secondary",
        disabled: u,
        ml: "auto",
        size: "24px",
        "data-test": "clear-button-icon-circle",
        component: Cf,
        onClick: u ? void 0 : l
      }
    ) : null : /* @__PURE__ */ b(
      sr,
      {
        color: u ? "icon-disabled" : "icon-default",
        ml: "auto",
        size: "16px",
        "data-test": "clear-button-icon-arrow",
        component: o,
        onClick: l
      }
    );
  }
  const c = Wae(!!n, u);
  return /* @__PURE__ */ ne(
    rC,
    {
      className: t,
      "data-test": r,
      borderRadius: "sm",
      color: c,
      cursor: "pointer",
      px: "xs",
      hasSelectedKeys: !!n,
      alignItems: "center",
      userSelect: "none",
      ref: s,
      disabled: u,
      gap: "xxs",
      ...d,
      children: [
        /* @__PURE__ */ b(
          $e,
          {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            variant: "bodyMediumS",
            title: n ?? "",
            children: n ?? a
          }
        ),
        f()
      ]
    }
  );
}
const Hae = Xn(Vae), zae = Ge(nr).attrs({
  mode: "link",
  size: "xSmall",
  justifyContent: "start",
  my: "xxxs",
  selected: !1
})`
  border-radius: 4px;

  color: text-base;
  &:hover {
    background-color: ${pt("surface-interactive-default-active")};
    text-decoration: none;
    color: ${pt("text-interactive-primary")};
  }

  &:disabled {
    background-color: ${pt("surface-interactive-default-active")};
    color: ${pt("text-interactive-primary")};
  }
`;
function Kae({
  "data-test": e = "predefined-dates-picker",
  onClick: t,
  ranges: r
}) {
  return /* @__PURE__ */ b(Ae, { "data-test": e, flexDirection: "column", justifyContent: "center", children: r.map((n) => {
    const { label: a, rangeValue: i, startDate: o, endDate: u } = n;
    return /* @__PURE__ */ b(
      zae,
      {
        tabIndex: -1,
        onClick: () => t({ rangeValue: i, startDate: o, endDate: u }),
        "data-test": a,
        type: "button",
        children: /* @__PURE__ */ b($e, { variant: "bodyRegularM", p: "0.5 xxxs", children: a })
      },
      a
    );
  }) });
}
function Yae({
  value: e,
  onChange: t,
  ranges: r,
  "data-test": n = "date-select-menu",
  footer: a,
  ...i
}) {
  return /* @__PURE__ */ ne(
    Ae,
    {
      flexDirection: "column",
      gap: "xxxs",
      "data-test": n,
      w: "min-content",
      children: [
        r ? /* @__PURE__ */ ne(Ae, { alignItems: "center", flexDirection: "row", px: 2, children: [
          /* @__PURE__ */ b(Kae, { ranges: r, onClick: t }),
          /* @__PURE__ */ b(
            Db,
            {
              value: e,
              onChange: t,
              initialDate: (e == null ? void 0 : e.startDate) ?? void 0,
              ...i
            }
          )
        ] }) : /* @__PURE__ */ b(
          Db,
          {
            value: e,
            onChange: t,
            initialDate: (e == null ? void 0 : e.startDate) ?? void 0,
            ...i
          }
        ),
        a
      ]
    }
  );
}
function Xae({
  onChange: e,
  ...t
}) {
  const { setOpen: r } = vM(), n = ue(() => {
    r(!1);
  }, [r]), a = ue(
    (i) => {
      i.endDate && n(), e(i);
    },
    [e, n]
  );
  return /* @__PURE__ */ b(Yae, { onChange: a, ...t });
}
function POe({
  allowRemove: e,
  className: t,
  placeholder: r = "Select date range",
  onClear: n,
  value: a,
  defaultValue: i,
  onChange: o,
  ranges: u = [],
  onClose: d,
  onOpen: s,
  locale: l = "en-US",
  maxW: f = "200px",
  w: c = "200px",
  ...h
}) {
  const [_, F] = O3({
    prop: a,
    defaultProp: i,
    onChange: o
  }), v = qe(
    () => _ ? Gae(_, u, l) : void 0,
    [_, l, u]
  );
  return /* @__PURE__ */ b(
    k3,
    {
      closeOnInsideClick: !1,
      onVisibilityChange: (D) => {
        D ? s == null || s() : d == null || d();
      },
      trigger: /* @__PURE__ */ b(
        Hae,
        {
          allowRemove: e,
          className: t,
          value: v,
          onClear: () => {
            F({
              rangeValue: void 0,
              startDate: null,
              endDate: null
            }), n == null || n();
          },
          placeholder: r,
          maxW: f,
          w: c
        }
      ),
      maxWidth: "unset",
      align: "start",
      children: /* @__PURE__ */ b(
        Xae,
        {
          locale: l,
          value: _,
          onChange: F,
          ranges: u,
          ...h
        }
      )
    }
  );
}
function Kn() {
  return Kn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Kn.apply(this, arguments);
}
function Nh(e, t, r, n) {
  n === void 0 && (n = e), delete e.fields[t.name], e.fields[r] = Kn({}, t, {
    name: r,
    // prevent functions from being overwritten
    // if the state.fields[destKey] does not exist, it will be created
    // when that field gets registered, with its own change/blur/focus callbacks
    change: n.fields[r] && n.fields[r].change,
    blur: n.fields[r] && n.fields[r].blur,
    focus: n.fields[r] && n.fields[r].focus,
    lastFieldState: void 0
    // clearing lastFieldState forces renotification
  }), e.fields[r].change || delete e.fields[r].change, e.fields[r].blur || delete e.fields[r].blur, e.fields[r].focus || delete e.fields[r].focus;
}
var Lh = function(t) {
  return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}, nC = function(t, r, n) {
  var a = t[0], i = t[1], o = t[2], u = n.changeValue;
  n.resetFieldState, u(r, a, function(l) {
    var f = [].concat(l || []);
    return f.splice(i, 0, o), f;
  });
  var d = Kn({}, r.fields), s = new RegExp("^" + Lh(a) + "\\[(\\d+)\\](.*)");
  Object.keys(r.fields).sort().reverse().forEach(function(l) {
    var f = s.exec(l);
    if (f) {
      var c = Number(f[1]);
      if (c >= i) {
        var h = a + "[" + (c + 1) + "]" + f[2];
        Nh(r, d[l], h);
      }
    }
  });
}, Qae = function(t, r, n) {
  var a = t[0], i = t[1], o = n.changeValue;
  o(r, a, function(u) {
    return u ? [].concat(u, i) : i;
  });
};
function is(e, t, r, n) {
  Object.keys(n.fields).forEach(function(a) {
    if (a.substring(0, t.length) === t) {
      var i = a.substring(t.length), o = e + "[" + r + "]" + i;
      Nh(n, n.fields[a], o);
    }
  });
}
function aC(e, t) {
  Object.keys(e.fields).forEach(function(r) {
    e.fields[r] = Kn({}, e.fields[r], {
      change: e.fields[r].change || t.fields[r] && t.fields[r].change,
      blur: e.fields[r].blur || t.fields[r] && t.fields[r].blur,
      focus: e.fields[r].focus || t.fields[r] && t.fields[r].focus
    }), e.fields[r].change || delete e.fields[r].change, e.fields[r].blur || delete e.fields[r].blur, e.fields[r].focus || delete e.fields[r].focus;
  });
}
var r5 = "tmp", Zae = function(t, r, n) {
  var a = t[0], i = t[1], o = t[2], u = n.changeValue;
  if (i !== o) {
    u(r, a, function(F) {
      var v = [].concat(F || []), $ = v[i];
      return v.splice(i, 1), v.splice(o, 0, $), v;
    });
    var d = Kn({}, r, {
      fields: Kn({}, r.fields)
      // move this row to tmp index
    }), s = a + "[" + i + "]";
    if (is(a, s, r5, r), i < o)
      for (var l = i + 1; l <= o; l++) {
        var f = a + "[" + l + "]";
        is(a, f, "" + (l - 1), r);
      }
    else
      for (var c = i - 1; c >= o; c--) {
        var h = a + "[" + c + "]";
        is(a, h, "" + (c + 1), r);
      }
    var _ = a + "[" + r5 + "]";
    is(a, _, o, r), aC(r, d);
  }
}, Jae = function(t, r, n) {
  var a = t[0], i = n.changeValue, o, u;
  if (i(r, a, function(s) {
    if (s)
      return s.length ? (u = s.length - 1, o = s[u], s.slice(0, u)) : [];
  }), u !== void 0) {
    var d = new RegExp("^" + Lh(a) + "\\[" + u + "].*");
    Object.keys(r.fields).forEach(function(s) {
      d.test(s) && delete r.fields[s];
    });
  }
  return o;
}, eie = function(t, r, n) {
  var a = t[0], i = t[1], o = n.changeValue;
  o(r, a, function(u) {
    return u ? [].concat(u, [i]) : [i];
  });
}, iC = function(t, r, n) {
  var a = t[0], i = t[1], o = n.changeValue, u = n.renameField, d;
  o(r, a, function(f) {
    var c = [].concat(f || []);
    return d = c[i], c.splice(i, 1), c;
  });
  var s = new RegExp("^" + Lh(a) + "\\[(\\d+)\\](.*)"), l = Kn({}, r, {
    fields: Kn({}, r.fields)
  });
  return Object.keys(r.fields).forEach(function(f) {
    var c = s.exec(f);
    if (c) {
      var h = Number(c[1]);
      if (h === i)
        delete r.fields[f];
      else if (h > i) {
        delete r.fields[f];
        var _ = a + "[" + (h - 1) + "]" + c[2];
        l.fields[_] ? Nh(r, l.fields[f], _, l) : u(r, f, _);
      }
    }
  }), d;
}, tie = function(t, r) {
  return t.reduce(function(n, a) {
    return a < r ? n + 1 : n;
  }, 0);
}, rie = function(t, r, n) {
  var a = t[0], i = t[1], o = n.changeValue, u = [].concat(i);
  u.sort();
  for (var d = 0; d < u.length; d++)
    d > 0 && u[d] === u[d - 1] && u.splice(d--, 1);
  var s = [];
  o(r, a, function(c) {
    if (s = i.map(function(F) {
      return c && c[F];
    }), !c || !u.length)
      return c;
    var h = [].concat(c), _ = [];
    return u.forEach(function(F) {
      h.splice(F - _.length, 1), _.push(c && c[F]);
    }), h;
  });
  var l = new RegExp("^" + Lh(a) + "\\[(\\d+)\\](.*)"), f = Kn({}, r, {
    fields: {}
  });
  return Object.keys(r.fields).forEach(function(c) {
    var h = l.exec(c);
    if (h) {
      var _ = Number(h[1]);
      if (!~u.indexOf(_)) {
        var F = a + "[" + (_ - tie(u, _)) + "]" + h[2];
        Nh(f, r.fields[c], F, r);
      }
    } else
      f.fields[c] = r.fields[c];
  }), r.fields = f.fields, s;
}, nie = function(t, r, n) {
  var a = t[0];
  return iC([a, 0], r, n);
}, n5 = "tmp", aie = function(t, r, n) {
  var a = t[0], i = t[1], o = t[2], u = n.changeValue;
  if (i !== o) {
    u(r, a, function(c) {
      var h = [].concat(c || []), _ = h[i];
      return h[i] = h[o], h[o] = _, h;
    });
    var d = Kn({}, r, {
      fields: Kn({}, r.fields)
      // swap all field state that begin with "name[indexA]" with that under "name[indexB]"
    }), s = a + "[" + i + "]", l = a + "[" + o + "]", f = a + "[" + n5 + "]";
    is(a, s, n5, r), is(a, l, i, r), is(a, f, o, r), aC(r, d);
  }
}, iie = function(t, r, n) {
  var a = t[0], i = t[1];
  return nC([a, 0, i], r, n);
}, oie = function(t, r, n) {
  var a = t[0], i = t[1], o = t[2], u = n.changeValue;
  u(r, a, function(d) {
    var s = [].concat(d || []);
    return s.splice(i, 1, o), s;
  });
}, sie = {
  insert: nC,
  concat: Qae,
  move: Zae,
  pop: Jae,
  push: eie,
  remove: iC,
  removeBatch: rie,
  shift: nie,
  swap: aie,
  unshift: iie,
  update: oie
};
const uie = {
  _: 16,
  lg: 24
};
function AF({ children: e, ...t }) {
  return /* @__PURE__ */ b(
    ad,
    {
      gridTemplateColumns: "repeat(12, 1fr)",
      columnGap: uie,
      rowGap: "s",
      gridAutoFlow: "row",
      ...t,
      children: e
    }
  );
}
function go({
  xs: e,
  sm: t,
  md: r,
  lg: n,
  xl: a,
  children: i,
  ...o
}) {
  const u = {
    _: `span ${e}`,
    sm: t ? `span ${t}` : void 0,
    md: r ? `span ${r}` : void 0,
    lg: n ? `span ${n}` : void 0,
    xl: a ? `span ${a}` : void 0
  };
  return /* @__PURE__ */ b(ot, { gridColumn: u, ...o, children: i });
}
const oC = dr({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), qh = dr({}), Uh = dr(null), Gh = typeof document < "u", n0 = Gh ? td : at, sC = dr({ strict: !1 });
function die(e, t, r, n) {
  const { visualElement: a } = Et(qh), i = Et(sC), o = Et(Uh), u = Et(oC).reducedMotion, d = tt();
  n = n || i.renderer, !d.current && n && (d.current = n(e, {
    visualState: t,
    parent: a,
    props: r,
    presenceContext: o,
    blockInitialAnimation: o ? o.initial === !1 : !1,
    reducedMotionConfig: u
  }));
  const s = d.current;
  return Aw(() => {
    s && s.update(r, o);
  }), n0(() => {
    s && s.render();
  }), at(() => {
    s && s.updateFeatures();
  }), (window.HandoffAppearAnimations ? n0 : at)(() => {
    s && s.animationState && s.animationState.animateChanges();
  }), s;
}
function gu(e) {
  return typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function lie(e, t, r) {
  return ue(
    (n) => {
      n && e.mount && e.mount(n), t && (n ? t.mount(n) : t.unmount()), r && (typeof r == "function" ? r(n) : gu(r) && (r.current = n));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function Rl(e) {
  return typeof e == "string" || Array.isArray(e);
}
function Wh(e) {
  return typeof e == "object" && typeof e.start == "function";
}
const OF = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], TF = ["initial", ...OF];
function Vh(e) {
  return Wh(e.animate) || TF.some((t) => Rl(e[t]));
}
function uC(e) {
  return Boolean(Vh(e) || e.variants);
}
function fie(e, t) {
  if (Vh(e)) {
    const { initial: r, animate: n } = e;
    return {
      initial: r === !1 || Rl(r) ? r : void 0,
      animate: Rl(n) ? n : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function cie(e) {
  const { initial: t, animate: r } = fie(e, Et(qh));
  return qe(() => ({ initial: t, animate: r }), [a5(t), a5(r)]);
}
function a5(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const i5 = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, jl = {};
for (const e in i5)
  jl[e] = {
    isEnabled: (t) => i5[e].some((r) => !!t[r])
  };
function hie(e) {
  for (const t in e)
    jl[t] = {
      ...jl[t],
      ...e[t]
    };
}
const PF = dr({}), dC = dr({}), gie = Symbol.for("motionComponentSymbol");
function _ie({ preloadedFeatures: e, createVisualElement: t, useRender: r, useVisualState: n, Component: a }) {
  e && hie(e);
  function i(u, d) {
    let s;
    const l = {
      ...Et(oC),
      ...u,
      layoutId: mie(u)
    }, { isStatic: f } = l, c = cie(u), h = n(u, f);
    if (!f && Gh) {
      c.visualElement = die(a, h, l, t);
      const _ = Et(dC), F = Et(sC).strict;
      c.visualElement && (s = c.visualElement.loadFeatures(
        // Note: Pass the full new combined props to correctly re-render dynamic feature components.
        l,
        F,
        e,
        _
      ));
    }
    return se.createElement(
      qh.Provider,
      { value: c },
      s && c.visualElement ? se.createElement(s, { visualElement: c.visualElement, ...l }) : null,
      r(a, u, lie(h, c.visualElement, d), h, f, c.visualElement)
    );
  }
  const o = Xn(i);
  return o[gie] = a, o;
}
function mie({ layoutId: e }) {
  const t = Et(PF).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function pie(e) {
  function t(n, a = {}) {
    return _ie(e(n, a));
  }
  if (typeof Proxy > "u")
    return t;
  const r = /* @__PURE__ */ new Map();
  return new Proxy(t, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (n, a) => (r.has(a) || r.set(a, t(a)), r.get(a))
  });
}
const Fie = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function IF(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(Fie.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
const a0 = {};
function yie(e) {
  Object.assign(a0, e);
}
const Mf = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Ts = new Set(Mf);
function lC(e, { layout: t, layoutId: r }) {
  return Ts.has(e) || e.startsWith("origin") || (t || r !== void 0) && (!!a0[e] || e === "opacity");
}
const fn = (e) => Boolean(e && e.getVelocity), bie = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, vie = Mf.length;
function Eie(e, { enableHardwareAcceleration: t = !0, allowTransformNone: r = !0 }, n, a) {
  let i = "";
  for (let o = 0; o < vie; o++) {
    const u = Mf[o];
    if (e[u] !== void 0) {
      const d = bie[u] || u;
      i += `${d}(${e[u]}) `;
    }
  }
  return t && !e.z && (i += "translateZ(0)"), i = i.trim(), a ? i = a(e, n ? "" : i) : r && n && (i = "none"), i;
}
const fC = (e) => (t) => typeof t == "string" && t.startsWith(e), cC = fC("--"), xm = fC("var(--"), $ie = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g, wie = (e, t) => t && typeof e == "number" ? t.transform(e) : e, yo = (e, t, r) => Math.min(Math.max(r, e), t), Ps = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, gl = {
  ...Ps,
  transform: (e) => yo(0, 1, e)
}, i1 = {
  ...Ps,
  default: 1
}, _l = (e) => Math.round(e * 1e5) / 1e5, Hh = /(-)?([\d]*\.?[\d])+/g, hC = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi, kie = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function Bf(e) {
  return typeof e == "string";
}
const Nf = (e) => ({
  test: (t) => Bf(t) && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), oo = Nf("deg"), Ga = Nf("%"), ut = Nf("px"), xie = Nf("vh"), Die = Nf("vw"), o5 = {
  ...Ga,
  parse: (e) => Ga.parse(e) / 100,
  transform: (e) => Ga.transform(e * 100)
}, s5 = {
  ...Ps,
  transform: Math.round
}, gC = {
  // Border props
  borderWidth: ut,
  borderTopWidth: ut,
  borderRightWidth: ut,
  borderBottomWidth: ut,
  borderLeftWidth: ut,
  borderRadius: ut,
  radius: ut,
  borderTopLeftRadius: ut,
  borderTopRightRadius: ut,
  borderBottomRightRadius: ut,
  borderBottomLeftRadius: ut,
  // Positioning props
  width: ut,
  maxWidth: ut,
  height: ut,
  maxHeight: ut,
  size: ut,
  top: ut,
  right: ut,
  bottom: ut,
  left: ut,
  // Spacing props
  padding: ut,
  paddingTop: ut,
  paddingRight: ut,
  paddingBottom: ut,
  paddingLeft: ut,
  margin: ut,
  marginTop: ut,
  marginRight: ut,
  marginBottom: ut,
  marginLeft: ut,
  // Transform props
  rotate: oo,
  rotateX: oo,
  rotateY: oo,
  rotateZ: oo,
  scale: i1,
  scaleX: i1,
  scaleY: i1,
  scaleZ: i1,
  skew: oo,
  skewX: oo,
  skewY: oo,
  distance: ut,
  translateX: ut,
  translateY: ut,
  translateZ: ut,
  x: ut,
  y: ut,
  z: ut,
  perspective: ut,
  transformPerspective: ut,
  opacity: gl,
  originX: o5,
  originY: o5,
  originZ: ut,
  // Misc
  zIndex: s5,
  // SVG
  fillOpacity: gl,
  strokeOpacity: gl,
  numOctaves: s5
};
function RF(e, t, r, n) {
  const { style: a, vars: i, transform: o, transformOrigin: u } = e;
  let d = !1, s = !1, l = !0;
  for (const f in t) {
    const c = t[f];
    if (cC(f)) {
      i[f] = c;
      continue;
    }
    const h = gC[f], _ = wie(c, h);
    if (Ts.has(f)) {
      if (d = !0, o[f] = _, !l)
        continue;
      c !== (h.default || 0) && (l = !1);
    } else
      f.startsWith("origin") ? (s = !0, u[f] = _) : a[f] = _;
  }
  if (t.transform || (d || n ? a.transform = Eie(e.transform, r, l, n) : a.transform && (a.transform = "none")), s) {
    const { originX: f = "50%", originY: c = "50%", originZ: h = 0 } = u;
    a.transformOrigin = `${f} ${c} ${h}`;
  }
}
const jF = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function _C(e, t, r) {
  for (const n in t)
    !fn(t[n]) && !lC(n, r) && (e[n] = t[n]);
}
function Cie({ transformTemplate: e }, t, r) {
  return qe(() => {
    const n = jF();
    return RF(n, t, { enableHardwareAcceleration: !r }, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function Sie(e, t, r) {
  const n = e.style || {}, a = {};
  return _C(a, n, e), Object.assign(a, Cie(e, t, r)), e.transformValues ? e.transformValues(a) : a;
}
function Aie(e, t, r) {
  const n = {}, a = Sie(e, t, r);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, a.userSelect = a.WebkitUserSelect = a.WebkitTouchCallout = "none", a.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = a, n;
}
const Oie = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "ignoreStrict",
  "viewport"
]);
function i0(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || Oie.has(e);
}
let mC = (e) => !i0(e);
function Tie(e) {
  e && (mC = (t) => t.startsWith("on") ? !i0(t) : e(t));
}
try {
  Tie(require("@emotion/is-prop-valid").default);
} catch {
}
function Pie(e, t, r) {
  const n = {};
  for (const a in e)
    a === "values" && typeof e.values == "object" || (mC(a) || r === !0 && i0(a) || !t && !i0(a) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && a.startsWith("onDrag")) && (n[a] = e[a]);
  return n;
}
function u5(e, t, r) {
  return typeof e == "string" ? e : ut.transform(t + r * e);
}
function Iie(e, t, r) {
  const n = u5(t, e.x, e.width), a = u5(r, e.y, e.height);
  return `${n} ${a}`;
}
const Rie = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, jie = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function Mie(e, t, r = 1, n = 0, a = !0) {
  e.pathLength = 1;
  const i = a ? Rie : jie;
  e[i.offset] = ut.transform(-n);
  const o = ut.transform(t), u = ut.transform(r);
  e[i.array] = `${o} ${u}`;
}
function MF(e, {
  attrX: t,
  attrY: r,
  attrScale: n,
  originX: a,
  originY: i,
  pathLength: o,
  pathSpacing: u = 1,
  pathOffset: d = 0,
  // This is object creation, which we try to avoid per-frame.
  ...s
}, l, f, c) {
  if (RF(e, s, l, c), f) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: h, style: _, dimensions: F } = e;
  h.transform && (F && (_.transform = h.transform), delete h.transform), F && (a !== void 0 || i !== void 0 || _.transform) && (_.transformOrigin = Iie(F, a !== void 0 ? a : 0.5, i !== void 0 ? i : 0.5)), t !== void 0 && (h.x = t), r !== void 0 && (h.y = r), n !== void 0 && (h.scale = n), o !== void 0 && Mie(h, o, u, d, !1);
}
const pC = () => ({
  ...jF(),
  attrs: {}
}), BF = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function Bie(e, t, r, n) {
  const a = qe(() => {
    const i = pC();
    return MF(i, t, { enableHardwareAcceleration: !1 }, BF(n), e.transformTemplate), {
      ...i.attrs,
      style: { ...i.style }
    };
  }, [t]);
  if (e.style) {
    const i = {};
    _C(i, e.style, e), a.style = { ...i, ...a.style };
  }
  return a;
}
function Nie(e = !1) {
  return (r, n, a, { latestValues: i }, o) => {
    const d = (IF(r) ? Bie : Aie)(n, i, o, r), l = {
      ...Pie(n, typeof r == "string", e),
      ...d,
      ref: a
    }, { children: f } = n, c = qe(() => fn(f) ? f.get() : f, [f]);
    return uh(r, {
      ...l,
      children: c
    });
  };
}
const NF = (e) => e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
function FC(e, { style: t, vars: r }, n, a) {
  Object.assign(e.style, t, a && a.getProjectionStyles(n));
  for (const i in r)
    e.style.setProperty(i, r[i]);
}
const yC = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function bC(e, t, r, n) {
  FC(e, t, void 0, n);
  for (const a in t.attrs)
    e.setAttribute(yC.has(a) ? a : NF(a), t.attrs[a]);
}
function LF(e, t) {
  const { style: r } = e, n = {};
  for (const a in r)
    (fn(r[a]) || t.style && fn(t.style[a]) || lC(a, e)) && (n[a] = r[a]);
  return n;
}
function vC(e, t) {
  const r = LF(e, t);
  for (const n in e)
    if (fn(e[n]) || fn(t[n])) {
      const a = Mf.indexOf(n) !== -1 ? "attr" + n.charAt(0).toUpperCase() + n.substring(1) : n;
      r[a] = e[n];
    }
  return r;
}
function qF(e, t, r, n = {}, a = {}) {
  return typeof t == "function" && (t = t(r !== void 0 ? r : e.custom, n, a)), typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function" && (t = t(r !== void 0 ? r : e.custom, n, a)), t;
}
function EC(e) {
  const t = tt(null);
  return t.current === null && (t.current = e()), t.current;
}
const o0 = (e) => Array.isArray(e), Lie = (e) => Boolean(e && typeof e == "object" && e.mix && e.toValue), qie = (e) => o0(e) ? e[e.length - 1] || 0 : e;
function A1(e) {
  const t = fn(e) ? e.get() : e;
  return Lie(t) ? t.toValue() : t;
}
function Uie({ scrapeMotionValuesFromProps: e, createRenderState: t, onMount: r }, n, a, i) {
  const o = {
    latestValues: Gie(n, a, i, e),
    renderState: t()
  };
  return r && (o.mount = (u) => r(n, u, o)), o;
}
const $C = (e) => (t, r) => {
  const n = Et(qh), a = Et(Uh), i = () => Uie(e, t, n, a);
  return r ? i() : EC(i);
};
function Gie(e, t, r, n) {
  const a = {}, i = n(e, {});
  for (const c in i)
    a[c] = A1(i[c]);
  let { initial: o, animate: u } = e;
  const d = Vh(e), s = uC(e);
  t && s && !d && e.inherit !== !1 && (o === void 0 && (o = t.initial), u === void 0 && (u = t.animate));
  let l = r ? r.initial === !1 : !1;
  l = l || o === !1;
  const f = l ? u : o;
  return f && typeof f != "boolean" && !Wh(f) && (Array.isArray(f) ? f : [f]).forEach((h) => {
    const _ = qF(e, h);
    if (!_)
      return;
    const { transitionEnd: F, transition: v, ...$ } = _;
    for (const E in $) {
      let D = $[E];
      if (Array.isArray(D)) {
        const w = l ? D.length - 1 : 0;
        D = D[w];
      }
      D !== null && (a[E] = D);
    }
    for (const E in F)
      a[E] = F[E];
  }), a;
}
const Wie = {
  useVisualState: $C({
    scrapeMotionValuesFromProps: vC,
    createRenderState: pC,
    onMount: (e, t, { renderState: r, latestValues: n }) => {
      try {
        r.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
      } catch {
        r.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      MF(r, n, { enableHardwareAcceleration: !1 }, BF(t.tagName), e.transformTemplate), bC(t, r);
    }
  })
}, Vie = {
  useVisualState: $C({
    scrapeMotionValuesFromProps: LF,
    createRenderState: jF
  })
};
function Hie(e, { forwardMotionProps: t = !1 }, r, n) {
  return {
    ...IF(e) ? Wie : Vie,
    preloadedFeatures: r,
    useRender: Nie(t),
    createVisualElement: n,
    Component: e
  };
}
function Ei(e, t, r, n = { passive: !0 }) {
  return e.addEventListener(t, r, n), () => e.removeEventListener(t, r);
}
const wC = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function zh(e, t = "page") {
  return {
    point: {
      x: e[t + "X"],
      y: e[t + "Y"]
    }
  };
}
const zie = (e) => (t) => wC(t) && e(t, zh(t));
function ki(e, t, r, n) {
  return Ei(e, t, zie(r), n);
}
const Kie = (e, t) => (r) => t(e(r)), _o = (...e) => e.reduce(Kie);
function kC(e) {
  let t = null;
  return () => {
    const r = () => {
      t = null;
    };
    return t === null ? (t = e, r) : !1;
  };
}
const d5 = kC("dragHorizontal"), l5 = kC("dragVertical");
function xC(e) {
  let t = !1;
  if (e === "y")
    t = l5();
  else if (e === "x")
    t = d5();
  else {
    const r = d5(), n = l5();
    r && n ? t = () => {
      r(), n();
    } : (r && r(), n && n());
  }
  return t;
}
function DC() {
  const e = xC(!0);
  return e ? (e(), !1) : !0;
}
class xo {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
function Yie(e) {
  let t = [], r = [], n = 0, a = !1, i = !1;
  const o = /* @__PURE__ */ new WeakSet(), u = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (d, s = !1, l = !1) => {
      const f = l && a, c = f ? t : r;
      return s && o.add(d), c.indexOf(d) === -1 && (c.push(d), f && a && (n = t.length)), d;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (d) => {
      const s = r.indexOf(d);
      s !== -1 && r.splice(s, 1), o.delete(d);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (d) => {
      if (a) {
        i = !0;
        return;
      }
      if (a = !0, [t, r] = [r, t], r.length = 0, n = t.length, n)
        for (let s = 0; s < n; s++) {
          const l = t[s];
          l(d), o.has(l) && (u.schedule(l), e());
        }
      a = !1, i && (i = !1, u.process(d));
    }
  };
  return u;
}
const ir = {
  delta: 0,
  timestamp: 0,
  isProcessing: !1
}, Xie = 40;
let Dm = !0, Ml = !1;
const Kh = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], ku = Kh.reduce((e, t) => (e[t] = Yie(() => Ml = !0), e), {}), Qie = (e) => ku[e].process(ir), CC = (e) => {
  Ml = !1, ir.delta = Dm ? 1e3 / 60 : Math.max(Math.min(e - ir.timestamp, Xie), 1), ir.timestamp = e, ir.isProcessing = !0, Kh.forEach(Qie), ir.isProcessing = !1, Ml && (Dm = !1, requestAnimationFrame(CC));
}, Zie = () => {
  Ml = !0, Dm = !0, ir.isProcessing || requestAnimationFrame(CC);
}, tr = Kh.reduce((e, t) => {
  const r = ku[t];
  return e[t] = (n, a = !1, i = !1) => (Ml || Zie(), r.schedule(n, a, i)), e;
}, {});
function Ti(e) {
  Kh.forEach((t) => ku[t].cancel(e));
}
function f5(e, t) {
  const r = "pointer" + (t ? "enter" : "leave"), n = "onHover" + (t ? "Start" : "End"), a = (i, o) => {
    if (i.type === "touch" || DC())
      return;
    const u = e.getProps();
    e.animationState && u.whileHover && e.animationState.setActive("whileHover", t), u[n] && tr.update(() => u[n](i, o));
  };
  return ki(e.current, r, a, {
    passive: !e.getProps()[n]
  });
}
class Jie extends xo {
  mount() {
    this.unmount = _o(f5(this.node, !0), f5(this.node, !1));
  }
  unmount() {
  }
}
class eoe extends xo {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = _o(Ei(this.node.current, "focus", () => this.onFocus()), Ei(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const SC = (e, t) => t ? e === t ? !0 : SC(e, t.parentElement) : !1, Er = (e) => e;
function X_(e, t) {
  if (!t)
    return;
  const r = new PointerEvent("pointer" + e);
  t(r, zh(r));
}
class toe extends xo {
  constructor() {
    super(...arguments), this.removeStartListeners = Er, this.removeEndListeners = Er, this.removeAccessibleListeners = Er, this.startPointerPress = (t, r) => {
      if (this.removeEndListeners(), this.isPressing)
        return;
      const n = this.node.getProps(), i = ki(window, "pointerup", (u, d) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: s, onTapCancel: l } = this.node.getProps();
        tr.update(() => {
          SC(this.node.current, u.target) ? s && s(u, d) : l && l(u, d);
        });
      }, { passive: !(n.onTap || n.onPointerUp) }), o = ki(window, "pointercancel", (u, d) => this.cancelPress(u, d), { passive: !(n.onTapCancel || n.onPointerCancel) });
      this.removeEndListeners = _o(i, o), this.startPress(t, r);
    }, this.startAccessiblePress = () => {
      const t = (i) => {
        if (i.key !== "Enter" || this.isPressing)
          return;
        const o = (u) => {
          u.key !== "Enter" || !this.checkPressEnd() || X_("up", (d, s) => {
            const { onTap: l } = this.node.getProps();
            l && tr.update(() => l(d, s));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = Ei(this.node.current, "keyup", o), X_("down", (u, d) => {
          this.startPress(u, d);
        });
      }, r = Ei(this.node.current, "keydown", t), n = () => {
        this.isPressing && X_("cancel", (i, o) => this.cancelPress(i, o));
      }, a = Ei(this.node.current, "blur", n);
      this.removeAccessibleListeners = _o(r, a);
    };
  }
  startPress(t, r) {
    this.isPressing = !0;
    const { onTapStart: n, whileTap: a } = this.node.getProps();
    a && this.node.animationState && this.node.animationState.setActive("whileTap", !0), n && tr.update(() => n(t, r));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !DC();
  }
  cancelPress(t, r) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: n } = this.node.getProps();
    n && tr.update(() => n(t, r));
  }
  mount() {
    const t = this.node.getProps(), r = ki(this.node.current, "pointerdown", this.startPointerPress, { passive: !(t.onTapStart || t.onPointerStart) }), n = Ei(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = _o(r, n);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const Cm = /* @__PURE__ */ new WeakMap(), Q_ = /* @__PURE__ */ new WeakMap(), roe = (e) => {
  const t = Cm.get(e.target);
  t && t(e);
}, noe = (e) => {
  e.forEach(roe);
};
function aoe({ root: e, ...t }) {
  const r = e || document;
  Q_.has(r) || Q_.set(r, {});
  const n = Q_.get(r), a = JSON.stringify(t);
  return n[a] || (n[a] = new IntersectionObserver(noe, { root: e, ...t })), n[a];
}
function ioe(e, t, r) {
  const n = aoe(t);
  return Cm.set(e, r), n.observe(e), () => {
    Cm.delete(e), n.unobserve(e);
  };
}
const ooe = {
  some: 0,
  all: 1
};
class soe extends xo {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: r, margin: n, amount: a = "some", once: i } = t, o = {
      root: r ? r.current : void 0,
      rootMargin: n,
      threshold: typeof a == "number" ? a : ooe[a]
    }, u = (d) => {
      const { isIntersecting: s } = d;
      if (this.isInView === s || (this.isInView = s, i && !s && this.hasEnteredView))
        return;
      s && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", s);
      const { onViewportEnter: l, onViewportLeave: f } = this.node.getProps(), c = s ? l : f;
      c && c(d);
    };
    return ioe(this.node.current, o, u);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: r } = this.node;
    ["amount", "margin", "root"].some(uoe(t, r)) && this.startObserver();
  }
  unmount() {
  }
}
function uoe({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (r) => e[r] !== t[r];
}
const doe = {
  inView: {
    Feature: soe
  },
  tap: {
    Feature: toe
  },
  focus: {
    Feature: eoe
  },
  hover: {
    Feature: Jie
  }
};
function AC(e, t) {
  if (!Array.isArray(t))
    return !1;
  const r = t.length;
  if (r !== e.length)
    return !1;
  for (let n = 0; n < r; n++)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
function loe(e) {
  const t = {};
  return e.values.forEach((r, n) => t[n] = r.get()), t;
}
function foe(e) {
  const t = {};
  return e.values.forEach((r, n) => t[n] = r.getVelocity()), t;
}
function Yh(e, t, r) {
  const n = e.getProps();
  return qF(n, t, r !== void 0 ? r : n.custom, loe(e), foe(e));
}
const coe = "framerAppearId", hoe = "data-" + NF(coe);
let Lf = Er, ma = Er;
process.env.NODE_ENV !== "production" && (Lf = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, ma = (e, t) => {
  if (!e)
    throw new Error(t);
});
const mo = (e) => e * 1e3, xi = (e) => e / 1e3, goe = {
  current: !1
}, OC = (e) => Array.isArray(e) && typeof e[0] == "number";
function TC(e) {
  return Boolean(!e || typeof e == "string" && PC[e] || OC(e) || Array.isArray(e) && e.every(TC));
}
const nl = ([e, t, r, n]) => `cubic-bezier(${e}, ${t}, ${r}, ${n})`, PC = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: nl([0, 0.65, 0.55, 1]),
  circOut: nl([0.55, 0, 1, 0.45]),
  backIn: nl([0.31, 0.01, 0.66, -0.59]),
  backOut: nl([0.33, 1.53, 0.69, 0.99])
};
function IC(e) {
  if (e)
    return OC(e) ? nl(e) : Array.isArray(e) ? e.map(IC) : PC[e];
}
function _oe(e, t, r, { delay: n = 0, duration: a, repeat: i = 0, repeatType: o = "loop", ease: u, times: d } = {}) {
  const s = { [t]: r };
  d && (s.offset = d);
  const l = IC(u);
  return Array.isArray(l) && (s.easing = l), e.animate(s, {
    delay: n,
    duration: a,
    easing: Array.isArray(l) ? "linear" : l,
    fill: "both",
    iterations: i + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  });
}
const c5 = {
  waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate")
}, Z_ = {}, RC = {};
for (const e in c5)
  RC[e] = () => (Z_[e] === void 0 && (Z_[e] = c5[e]()), Z_[e]);
function moe(e, { repeat: t, repeatType: r = "loop" }) {
  const n = t && r !== "loop" && t % 2 === 1 ? 0 : e.length - 1;
  return e[n];
}
const jC = (e, t, r) => (((1 - 3 * r + 3 * t) * e + (3 * r - 6 * t)) * e + 3 * t) * e, poe = 1e-7, Foe = 12;
function yoe(e, t, r, n, a) {
  let i, o, u = 0;
  do
    o = t + (r - t) / 2, i = jC(o, n, a) - e, i > 0 ? r = o : t = o;
  while (Math.abs(i) > poe && ++u < Foe);
  return o;
}
function qf(e, t, r, n) {
  if (e === t && r === n)
    return Er;
  const a = (i) => yoe(i, 0, 1, e, r);
  return (i) => i === 0 || i === 1 ? i : jC(a(i), t, n);
}
const boe = qf(0.42, 0, 1, 1), voe = qf(0, 0, 0.58, 1), MC = qf(0.42, 0, 0.58, 1), Eoe = (e) => Array.isArray(e) && typeof e[0] != "number", BC = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, NC = (e) => (t) => 1 - e(1 - t), LC = (e) => 1 - Math.sin(Math.acos(e)), UF = NC(LC), $oe = BC(UF), qC = qf(0.33, 1.53, 0.69, 0.99), GF = NC(qC), woe = BC(GF), koe = (e) => (e *= 2) < 1 ? 0.5 * GF(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), h5 = {
  linear: Er,
  easeIn: boe,
  easeInOut: MC,
  easeOut: voe,
  circIn: LC,
  circInOut: $oe,
  circOut: UF,
  backIn: GF,
  backInOut: woe,
  backOut: qC,
  anticipate: koe
}, g5 = (e) => {
  if (Array.isArray(e)) {
    ma(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, r, n, a] = e;
    return qf(t, r, n, a);
  } else if (typeof e == "string")
    return ma(h5[e] !== void 0, `Invalid easing type '${e}'`), h5[e];
  return e;
}, WF = (e, t) => (r) => Boolean(Bf(r) && kie.test(r) && r.startsWith(e) || t && Object.prototype.hasOwnProperty.call(r, t)), UC = (e, t, r) => (n) => {
  if (!Bf(n))
    return n;
  const [a, i, o, u] = n.match(Hh);
  return {
    [e]: parseFloat(a),
    [t]: parseFloat(i),
    [r]: parseFloat(o),
    alpha: u !== void 0 ? parseFloat(u) : 1
  };
}, xoe = (e) => yo(0, 255, e), J_ = {
  ...Ps,
  transform: (e) => Math.round(xoe(e))
}, os = {
  test: WF("rgb", "red"),
  parse: UC("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: r, alpha: n = 1 }) => "rgba(" + J_.transform(e) + ", " + J_.transform(t) + ", " + J_.transform(r) + ", " + _l(gl.transform(n)) + ")"
};
function Doe(e) {
  let t = "", r = "", n = "", a = "";
  return e.length > 5 ? (t = e.substring(1, 3), r = e.substring(3, 5), n = e.substring(5, 7), a = e.substring(7, 9)) : (t = e.substring(1, 2), r = e.substring(2, 3), n = e.substring(3, 4), a = e.substring(4, 5), t += t, r += r, n += n, a += a), {
    red: parseInt(t, 16),
    green: parseInt(r, 16),
    blue: parseInt(n, 16),
    alpha: a ? parseInt(a, 16) / 255 : 1
  };
}
const Sm = {
  test: WF("#"),
  parse: Doe,
  transform: os.transform
}, _u = {
  test: WF("hsl", "hue"),
  parse: UC("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: r, alpha: n = 1 }) => "hsla(" + Math.round(e) + ", " + Ga.transform(_l(t)) + ", " + Ga.transform(_l(r)) + ", " + _l(gl.transform(n)) + ")"
}, Zr = {
  test: (e) => os.test(e) || Sm.test(e) || _u.test(e),
  parse: (e) => os.test(e) ? os.parse(e) : _u.test(e) ? _u.parse(e) : Sm.parse(e),
  transform: (e) => Bf(e) ? e : e.hasOwnProperty("red") ? os.transform(e) : _u.transform(e)
}, or = (e, t, r) => -r * e + r * t + e;
function e2(e, t, r) {
  return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? e + (t - e) * 6 * r : r < 1 / 2 ? t : r < 2 / 3 ? e + (t - e) * (2 / 3 - r) * 6 : e;
}
function Coe({ hue: e, saturation: t, lightness: r, alpha: n }) {
  e /= 360, t /= 100, r /= 100;
  let a = 0, i = 0, o = 0;
  if (!t)
    a = i = o = r;
  else {
    const u = r < 0.5 ? r * (1 + t) : r + t - r * t, d = 2 * r - u;
    a = e2(d, u, e + 1 / 3), i = e2(d, u, e), o = e2(d, u, e - 1 / 3);
  }
  return {
    red: Math.round(a * 255),
    green: Math.round(i * 255),
    blue: Math.round(o * 255),
    alpha: n
  };
}
const t2 = (e, t, r) => {
  const n = e * e;
  return Math.sqrt(Math.max(0, r * (t * t - n) + n));
}, Soe = [Sm, os, _u], Aoe = (e) => Soe.find((t) => t.test(e));
function _5(e) {
  const t = Aoe(e);
  ma(Boolean(t), `'${e}' is not an animatable color. Use the equivalent color code instead.`);
  let r = t.parse(e);
  return t === _u && (r = Coe(r)), r;
}
const GC = (e, t) => {
  const r = _5(e), n = _5(t), a = { ...r };
  return (i) => (a.red = t2(r.red, n.red, i), a.green = t2(r.green, n.green, i), a.blue = t2(r.blue, n.blue, i), a.alpha = or(r.alpha, n.alpha, i), os.transform(a));
};
function Ooe(e) {
  var t, r;
  return isNaN(e) && Bf(e) && (((t = e.match(Hh)) === null || t === void 0 ? void 0 : t.length) || 0) + (((r = e.match(hC)) === null || r === void 0 ? void 0 : r.length) || 0) > 0;
}
const WC = {
  regex: $ie,
  countKey: "Vars",
  token: "${v}",
  parse: Er
}, VC = {
  regex: hC,
  countKey: "Colors",
  token: "${c}",
  parse: Zr.parse
}, HC = {
  regex: Hh,
  countKey: "Numbers",
  token: "${n}",
  parse: Ps.parse
};
function r2(e, { regex: t, countKey: r, token: n, parse: a }) {
  const i = e.tokenised.match(t);
  i && (e["num" + r] = i.length, e.tokenised = e.tokenised.replace(t, n), e.values.push(...i.map(a)));
}
function s0(e) {
  const t = e.toString(), r = {
    value: t,
    tokenised: t,
    values: [],
    numVars: 0,
    numColors: 0,
    numNumbers: 0
  };
  return r.value.includes("var(--") && r2(r, WC), r2(r, VC), r2(r, HC), r;
}
function zC(e) {
  return s0(e).values;
}
function KC(e) {
  const { values: t, numColors: r, numVars: n, tokenised: a } = s0(e), i = t.length;
  return (o) => {
    let u = a;
    for (let d = 0; d < i; d++)
      d < n ? u = u.replace(WC.token, o[d]) : d < n + r ? u = u.replace(VC.token, Zr.transform(o[d])) : u = u.replace(HC.token, _l(o[d]));
    return u;
  };
}
const Toe = (e) => typeof e == "number" ? 0 : e;
function Poe(e) {
  const t = zC(e);
  return KC(e)(t.map(Toe));
}
const bo = {
  test: Ooe,
  parse: zC,
  createTransformer: KC,
  getAnimatableNone: Poe
}, YC = (e, t) => (r) => `${r > 0 ? t : e}`;
function XC(e, t) {
  return typeof e == "number" ? (r) => or(e, t, r) : Zr.test(e) ? GC(e, t) : e.startsWith("var(") ? YC(e, t) : ZC(e, t);
}
const QC = (e, t) => {
  const r = [...e], n = r.length, a = e.map((i, o) => XC(i, t[o]));
  return (i) => {
    for (let o = 0; o < n; o++)
      r[o] = a[o](i);
    return r;
  };
}, Ioe = (e, t) => {
  const r = { ...e, ...t }, n = {};
  for (const a in r)
    e[a] !== void 0 && t[a] !== void 0 && (n[a] = XC(e[a], t[a]));
  return (a) => {
    for (const i in n)
      r[i] = n[i](a);
    return r;
  };
}, ZC = (e, t) => {
  const r = bo.createTransformer(t), n = s0(e), a = s0(t);
  return n.numVars === a.numVars && n.numColors === a.numColors && n.numNumbers >= a.numNumbers ? _o(QC(n.values, a.values), r) : (Lf(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), YC(e, t));
}, Bl = (e, t, r) => {
  const n = t - e;
  return n === 0 ? 1 : (r - e) / n;
}, m5 = (e, t) => (r) => or(e, t, r);
function Roe(e) {
  return typeof e == "number" ? m5 : typeof e == "string" ? Zr.test(e) ? GC : ZC : Array.isArray(e) ? QC : typeof e == "object" ? Ioe : m5;
}
function joe(e, t, r) {
  const n = [], a = r || Roe(e[0]), i = e.length - 1;
  for (let o = 0; o < i; o++) {
    let u = a(e[o], e[o + 1]);
    if (t) {
      const d = Array.isArray(t) ? t[o] || Er : t;
      u = _o(d, u);
    }
    n.push(u);
  }
  return n;
}
function JC(e, t, { clamp: r = !0, ease: n, mixer: a } = {}) {
  const i = e.length;
  if (ma(i === t.length, "Both input and output ranges must be the same length"), i === 1)
    return () => t[0];
  e[0] > e[i - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const o = joe(t, n, a), u = o.length, d = (s) => {
    let l = 0;
    if (u > 1)
      for (; l < e.length - 2 && !(s < e[l + 1]); l++)
        ;
    const f = Bl(e[l], e[l + 1], s);
    return o[l](f);
  };
  return r ? (s) => d(yo(e[0], e[i - 1], s)) : d;
}
function Moe(e, t) {
  const r = e[e.length - 1];
  for (let n = 1; n <= t; n++) {
    const a = Bl(0, t, n);
    e.push(or(r, 1, a));
  }
}
function Boe(e) {
  const t = [0];
  return Moe(t, e.length - 1), t;
}
function Noe(e, t) {
  return e.map((r) => r * t);
}
function Loe(e, t) {
  return e.map(() => t || MC).splice(0, e.length - 1);
}
function u0({ duration: e = 300, keyframes: t, times: r, ease: n = "easeInOut" }) {
  const a = Eoe(n) ? n.map(g5) : g5(n), i = {
    done: !1,
    value: t[0]
  }, o = Noe(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    r && r.length === t.length ? r : Boe(t),
    e
  ), u = JC(o, t, {
    ease: Array.isArray(a) ? a : Loe(t, a)
  });
  return {
    calculatedDuration: e,
    next: (d) => (i.value = u(d), i.done = d >= e, i)
  };
}
function eS(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const qoe = 5;
function tS(e, t, r) {
  const n = Math.max(t - qoe, 0);
  return eS(r - e(n), t - n);
}
const n2 = 1e-3, Uoe = 0.01, p5 = 10, Goe = 0.05, Woe = 1;
function Voe({ duration: e = 800, bounce: t = 0.25, velocity: r = 0, mass: n = 1 }) {
  let a, i;
  Lf(e <= mo(p5), "Spring duration must be 10 seconds or less");
  let o = 1 - t;
  o = yo(Goe, Woe, o), e = yo(Uoe, p5, xi(e)), o < 1 ? (a = (s) => {
    const l = s * o, f = l * e, c = l - r, h = Am(s, o), _ = Math.exp(-f);
    return n2 - c / h * _;
  }, i = (s) => {
    const f = s * o * e, c = f * r + r, h = Math.pow(o, 2) * Math.pow(s, 2) * e, _ = Math.exp(-f), F = Am(Math.pow(s, 2), o);
    return (-a(s) + n2 > 0 ? -1 : 1) * ((c - h) * _) / F;
  }) : (a = (s) => {
    const l = Math.exp(-s * e), f = (s - r) * e + 1;
    return -n2 + l * f;
  }, i = (s) => {
    const l = Math.exp(-s * e), f = (r - s) * (e * e);
    return l * f;
  });
  const u = 5 / e, d = zoe(a, i, u);
  if (e = mo(e), isNaN(d))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const s = Math.pow(d, 2) * n;
    return {
      stiffness: s,
      damping: o * 2 * Math.sqrt(n * s),
      duration: e
    };
  }
}
const Hoe = 12;
function zoe(e, t, r) {
  let n = r;
  for (let a = 1; a < Hoe; a++)
    n = n - e(n) / t(n);
  return n;
}
function Am(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const Koe = ["duration", "bounce"], Yoe = ["stiffness", "damping", "mass"];
function F5(e, t) {
  return t.some((r) => e[r] !== void 0);
}
function Xoe(e) {
  let t = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!F5(e, Yoe) && F5(e, Koe)) {
    const r = Voe(e);
    t = {
      ...t,
      ...r,
      velocity: 0,
      mass: 1
    }, t.isResolvedFromDuration = !0;
  }
  return t;
}
function rS({ keyframes: e, restDelta: t, restSpeed: r, ...n }) {
  const a = e[0], i = e[e.length - 1], o = { done: !1, value: a }, { stiffness: u, damping: d, mass: s, velocity: l, duration: f, isResolvedFromDuration: c } = Xoe(n), h = l ? -xi(l) : 0, _ = d / (2 * Math.sqrt(u * s)), F = i - a, v = xi(Math.sqrt(u / s)), $ = Math.abs(F) < 5;
  r || (r = $ ? 0.01 : 2), t || (t = $ ? 5e-3 : 0.5);
  let E;
  if (_ < 1) {
    const D = Am(v, _);
    E = (w) => {
      const k = Math.exp(-_ * v * w);
      return i - k * ((h + _ * v * F) / D * Math.sin(D * w) + F * Math.cos(D * w));
    };
  } else if (_ === 1)
    E = (D) => i - Math.exp(-v * D) * (F + (h + v * F) * D);
  else {
    const D = v * Math.sqrt(_ * _ - 1);
    E = (w) => {
      const k = Math.exp(-_ * v * w), A = Math.min(D * w, 300);
      return i - k * ((h + _ * v * F) * Math.sinh(A) + D * F * Math.cosh(A)) / D;
    };
  }
  return {
    calculatedDuration: c && f || null,
    next: (D) => {
      const w = E(D);
      if (c)
        o.done = D >= f;
      else {
        let k = h;
        D !== 0 && (_ < 1 ? k = tS(E, D, w) : k = 0);
        const A = Math.abs(k) <= r, P = Math.abs(i - w) <= t;
        o.done = A && P;
      }
      return o.value = o.done ? i : w, o;
    }
  };
}
function y5({ keyframes: e, velocity: t = 0, power: r = 0.8, timeConstant: n = 325, bounceDamping: a = 10, bounceStiffness: i = 500, modifyTarget: o, min: u, max: d, restDelta: s = 0.5, restSpeed: l }) {
  const f = e[0], c = {
    done: !1,
    value: f
  }, h = (S) => u !== void 0 && S < u || d !== void 0 && S > d, _ = (S) => u === void 0 ? d : d === void 0 || Math.abs(u - S) < Math.abs(d - S) ? u : d;
  let F = r * t;
  const v = f + F, $ = o === void 0 ? v : o(v);
  $ !== v && (F = $ - f);
  const E = (S) => -F * Math.exp(-S / n), D = (S) => $ + E(S), w = (S) => {
    const N = E(S), W = D(S);
    c.done = Math.abs(N) <= s, c.value = c.done ? $ : W;
  };
  let k, A;
  const P = (S) => {
    h(c.value) && (k = S, A = rS({
      keyframes: [c.value, _(c.value)],
      velocity: tS(D, S, c.value),
      damping: a,
      stiffness: i,
      restDelta: s,
      restSpeed: l
    }));
  };
  return P(0), {
    calculatedDuration: null,
    next: (S) => {
      let N = !1;
      return !A && k === void 0 && (N = !0, w(S), P(S)), k !== void 0 && S > k ? A.next(S - k) : (!N && w(S), c);
    }
  };
}
const Qoe = (e) => {
  const t = ({ timestamp: r }) => e(r);
  return {
    start: () => tr.update(t, !0),
    stop: () => Ti(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => ir.isProcessing ? ir.timestamp : performance.now()
  };
}, b5 = 2e4;
function v5(e) {
  let t = 0;
  const r = 50;
  let n = e.next(t);
  for (; !n.done && t < b5; )
    t += r, n = e.next(t);
  return t >= b5 ? 1 / 0 : t;
}
const Zoe = {
  decay: y5,
  inertia: y5,
  tween: u0,
  keyframes: u0,
  spring: rS
};
function d0({ autoplay: e = !0, delay: t = 0, driver: r = Qoe, keyframes: n, type: a = "keyframes", repeat: i = 0, repeatDelay: o = 0, repeatType: u = "loop", onPlay: d, onStop: s, onComplete: l, onUpdate: f, ...c }) {
  let h = 1, _ = !1, F, v;
  const $ = () => {
    F && F(), v = new Promise((ee) => {
      F = ee;
    });
  };
  $();
  let E;
  const D = Zoe[a] || u0;
  let w;
  D !== u0 && typeof n[0] != "number" && (w = JC([0, 100], n, {
    clamp: !1
  }), n = [0, 100]);
  const k = D({ ...c, keyframes: n });
  let A;
  u === "mirror" && (A = D({
    ...c,
    keyframes: [...n].reverse(),
    velocity: -(c.velocity || 0)
  }));
  let P = "idle", S = null, N = null, W = null;
  k.calculatedDuration === null && i && (k.calculatedDuration = v5(k));
  const { calculatedDuration: V } = k;
  let K = 1 / 0, U = 1 / 0;
  V !== null && (K = V + o, U = K * (i + 1) - o);
  let j = 0;
  const G = (ee) => {
    if (N === null)
      return;
    h > 0 && (N = Math.min(N, ee)), S !== null ? j = S : j = (ee - N) * h;
    const ge = j - t, De = ge < 0;
    j = Math.max(ge, 0), P === "finished" && S === null && (j = U);
    let xe = j, ze = k;
    if (i) {
      const me = j / K;
      let Fe = Math.floor(me), ce = me % 1;
      !ce && me >= 1 && (ce = 1), ce === 1 && Fe--, Fe = Math.min(Fe, i + 1);
      const z = Boolean(Fe % 2);
      z && (u === "reverse" ? (ce = 1 - ce, o && (ce -= o / K)) : u === "mirror" && (ze = A));
      let Me = yo(0, 1, ce);
      j > U && (Me = u === "reverse" && z ? 1 : 0), xe = Me * K;
    }
    const q = De ? { done: !1, value: n[0] } : ze.next(xe);
    w && (q.value = w(q.value));
    let { done: Ue } = q;
    !De && V !== null && (Ue = j >= U);
    const Ce = S === null && (P === "finished" || P === "running" && Ue || h < 0 && j <= 0);
    return f && f(q.value), Ce && ae(), q;
  }, H = () => {
    E && E.stop(), E = void 0;
  }, J = () => {
    P = "idle", H(), $(), N = W = null;
  }, ae = () => {
    P = "finished", l && l(), H(), $();
  }, de = () => {
    if (_)
      return;
    E || (E = r(G));
    const ee = E.now();
    d && d(), S !== null ? N = ee - S : (!N || P === "finished") && (N = ee), W = N, S = null, P = "running", E.start();
  };
  e && de();
  const te = {
    then(ee, ge) {
      return v.then(ee, ge);
    },
    get time() {
      return xi(j);
    },
    set time(ee) {
      ee = mo(ee), j = ee, S !== null || !E || h === 0 ? S = ee : N = E.now() - ee / h;
    },
    get duration() {
      const ee = k.calculatedDuration === null ? v5(k) : k.calculatedDuration;
      return xi(ee);
    },
    get speed() {
      return h;
    },
    set speed(ee) {
      ee === h || !E || (h = ee, te.time = xi(j));
    },
    get state() {
      return P;
    },
    play: de,
    pause: () => {
      P = "paused", S = j;
    },
    stop: () => {
      _ = !0, P !== "idle" && (P = "idle", s && s(), J());
    },
    cancel: () => {
      W !== null && G(W), J();
    },
    complete: () => {
      P = "finished";
    },
    sample: (ee) => (N = 0, G(ee))
  };
  return te;
}
const Joe = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), o1 = 10, ese = 2e4, tse = (e, t) => t.type === "spring" || e === "backgroundColor" || !TC(t.ease);
function rse(e, t, { onUpdate: r, onComplete: n, ...a }) {
  if (!(RC.waapi() && Joe.has(t) && !a.repeatDelay && a.repeatType !== "mirror" && a.damping !== 0 && a.type !== "inertia"))
    return !1;
  let o = !1, u, d;
  const s = () => {
    d = new Promise(($) => {
      u = $;
    });
  };
  s();
  let { keyframes: l, duration: f = 300, ease: c, times: h } = a;
  if (tse(t, a)) {
    const $ = d0({
      ...a,
      repeat: 0,
      delay: 0
    });
    let E = { done: !1, value: l[0] };
    const D = [];
    let w = 0;
    for (; !E.done && w < ese; )
      E = $.sample(w), D.push(E.value), w += o1;
    h = void 0, l = D, f = w - o1, c = "linear";
  }
  const _ = _oe(e.owner.current, t, l, {
    ...a,
    duration: f,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: c,
    times: h
  }), F = () => _.cancel(), v = () => {
    tr.update(F), u(), s();
  };
  return _.onfinish = () => {
    e.set(moe(l, a)), n && n(), v();
  }, {
    then($, E) {
      return d.then($, E);
    },
    get time() {
      return xi(_.currentTime || 0);
    },
    set time($) {
      _.currentTime = mo($);
    },
    get speed() {
      return _.playbackRate;
    },
    set speed($) {
      _.playbackRate = $;
    },
    get duration() {
      return xi(f);
    },
    play: () => {
      o || (_.play(), Ti(F));
    },
    pause: () => _.pause(),
    stop: () => {
      if (o = !0, _.playState === "idle")
        return;
      const { currentTime: $ } = _;
      if ($) {
        const E = d0({
          ...a,
          autoplay: !1
        });
        e.setWithVelocity(E.sample($ - o1).value, E.sample($).value, o1);
      }
      v();
    },
    complete: () => _.finish(),
    cancel: v
  };
}
function nse({ keyframes: e, delay: t, onUpdate: r, onComplete: n }) {
  const a = () => (r && r(e[e.length - 1]), n && n(), {
    time: 0,
    speed: 1,
    duration: 0,
    play: Er,
    pause: Er,
    stop: Er,
    then: (i) => (i(), Promise.resolve()),
    cancel: Er,
    complete: Er
  });
  return t ? d0({
    keyframes: [0, 1],
    duration: 0,
    delay: t,
    onComplete: a
  }) : a();
}
const ase = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, ise = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), ose = {
  type: "keyframes",
  duration: 0.8
}, sse = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, use = (e, { keyframes: t }) => t.length > 2 ? ose : Ts.has(e) ? e.startsWith("scale") ? ise(t[1]) : ase : sse, Om = (e, t) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(bo.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url(")), dse = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function lse(e) {
  const [t, r] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [n] = r.match(Hh) || [];
  if (!n)
    return e;
  const a = r.replace(n, "");
  let i = dse.has(t) ? 1 : 0;
  return n !== r && (i *= 100), t + "(" + i + a + ")";
}
const fse = /([a-z-]*)\(.*?\)/g, Tm = {
  ...bo,
  getAnimatableNone: (e) => {
    const t = e.match(fse);
    return t ? t.map(lse).join(" ") : e;
  }
}, cse = {
  ...gC,
  // Color props
  color: Zr,
  backgroundColor: Zr,
  outlineColor: Zr,
  fill: Zr,
  stroke: Zr,
  // Border props
  borderColor: Zr,
  borderTopColor: Zr,
  borderRightColor: Zr,
  borderBottomColor: Zr,
  borderLeftColor: Zr,
  filter: Tm,
  WebkitFilter: Tm
}, VF = (e) => cse[e];
function nS(e, t) {
  let r = VF(e);
  return r !== Tm && (r = bo), r.getAnimatableNone ? r.getAnimatableNone(t) : void 0;
}
const aS = (e) => /^0[^.\s]+$/.test(e);
function hse(e) {
  if (typeof e == "number")
    return e === 0;
  if (e !== null)
    return e === "none" || e === "0" || aS(e);
}
function gse(e, t, r, n) {
  const a = Om(t, r);
  let i;
  Array.isArray(r) ? i = [...r] : i = [null, r];
  const o = n.from !== void 0 ? n.from : e.get();
  let u;
  const d = [];
  for (let s = 0; s < i.length; s++)
    i[s] === null && (i[s] = s === 0 ? o : i[s - 1]), hse(i[s]) && d.push(s), typeof i[s] == "string" && i[s] !== "none" && i[s] !== "0" && (u = i[s]);
  if (a && d.length && u)
    for (let s = 0; s < d.length; s++) {
      const l = d[s];
      i[l] = nS(t, u);
    }
  return i;
}
function _se({ when: e, delay: t, delayChildren: r, staggerChildren: n, staggerDirection: a, repeat: i, repeatType: o, repeatDelay: u, from: d, elapsed: s, ...l }) {
  return !!Object.keys(l).length;
}
function iS(e, t) {
  return e[t] || e.default || e;
}
const HF = (e, t, r, n = {}) => (a) => {
  const i = iS(n, e) || {}, o = i.delay || n.delay || 0;
  let { elapsed: u = 0 } = n;
  u = u - mo(o);
  const d = gse(t, e, r, i), s = d[0], l = d[d.length - 1], f = Om(e, s), c = Om(e, l);
  Lf(f === c, `You are trying to animate ${e} from "${s}" to "${l}". ${s} is not an animatable value - to enable this animation set ${s} to a value animatable to ${l} via the \`style\` property.`);
  let h = {
    keyframes: d,
    velocity: t.getVelocity(),
    ease: "easeOut",
    ...i,
    delay: -u,
    onUpdate: (_) => {
      t.set(_), i.onUpdate && i.onUpdate(_);
    },
    onComplete: () => {
      a(), i.onComplete && i.onComplete();
    }
  };
  if (_se(i) || (h = {
    ...h,
    ...use(e, h)
  }), h.duration && (h.duration = mo(h.duration)), h.repeatDelay && (h.repeatDelay = mo(h.repeatDelay)), !f || !c || goe.current || i.type === !1)
    return nse(h);
  if (t.owner && t.owner.current instanceof HTMLElement && !t.owner.getProps().onUpdate) {
    const _ = rse(t, e, h);
    if (_)
      return _;
  }
  return d0(h);
};
function l0(e) {
  return Boolean(fn(e) && e.add);
}
const mse = (e) => /^\-?\d*\.?\d+$/.test(e);
function zF(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function KF(e, t) {
  const r = e.indexOf(t);
  r > -1 && e.splice(r, 1);
}
class YF {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return zF(this.subscriptions, t), () => KF(this.subscriptions, t);
  }
  notify(t, r, n) {
    const a = this.subscriptions.length;
    if (a)
      if (a === 1)
        this.subscriptions[0](t, r, n);
      else
        for (let i = 0; i < a; i++) {
          const o = this.subscriptions[i];
          o && o(t, r, n);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const E5 = /* @__PURE__ */ new Set();
function XF(e, t, r) {
  e || E5.has(t) || (console.warn(t), r && console.warn(r), E5.add(t));
}
const pse = (e) => !isNaN(parseFloat(e));
class Fse {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(t, r = {}) {
    this.version = "10.12.16", this.timeDelta = 0, this.lastUpdated = 0, this.canTrackVelocity = !1, this.events = {}, this.updateAndNotify = (n, a = !0) => {
      this.prev = this.current, this.current = n;
      const { delta: i, timestamp: o } = ir;
      this.lastUpdated !== o && (this.timeDelta = i, this.lastUpdated = o, tr.postRender(this.scheduleVelocityCheck)), this.prev !== this.current && this.events.change && this.events.change.notify(this.current), this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()), a && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.scheduleVelocityCheck = () => tr.postRender(this.velocityCheck), this.velocityCheck = ({ timestamp: n }) => {
      n !== this.lastUpdated && (this.prev = this.current, this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()));
    }, this.hasAnimated = !1, this.prev = this.current = t, this.canTrackVelocity = pse(this.current), this.owner = r.owner;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && XF(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, r) {
    this.events[t] || (this.events[t] = new YF());
    const n = this.events[t].add(r);
    return t === "change" ? () => {
      n(), tr.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : n;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(t, r) {
    this.passiveEffect = t, this.stopPassiveEffect = r;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, r = !0) {
    !r || !this.passiveEffect ? this.updateAndNotify(t, r) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, r, n) {
    this.set(r), this.prev = t, this.timeDelta = n;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t) {
    this.updateAndNotify(t), this.prev = t, this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    return this.canTrackVelocity ? (
      // These casts could be avoided if parseFloat would be typed better
      eS(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
    ) : 0;
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(t) {
    return this.stop(), new Promise((r) => {
      this.hasAnimated = !0, this.animation = t(r), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function ju(e, t) {
  return new Fse(e, t);
}
const oS = (e) => (t) => t.test(e), yse = {
  test: (e) => e === "auto",
  parse: (e) => e
}, sS = [Ps, ut, Ga, oo, Die, xie, yse], Hd = (e) => sS.find(oS(e)), bse = [...sS, Zr, bo], vse = (e) => bse.find(oS(e));
function Ese(e, t, r) {
  e.hasValue(t) ? e.getValue(t).set(r) : e.addValue(t, ju(r));
}
function $se(e, t) {
  const r = Yh(e, t);
  let { transitionEnd: n = {}, transition: a = {}, ...i } = r ? e.makeTargetAnimatable(r, !1) : {};
  i = { ...i, ...n };
  for (const o in i) {
    const u = qie(i[o]);
    Ese(e, o, u);
  }
}
function wse(e, t, r) {
  var n, a;
  const i = Object.keys(t).filter((u) => !e.hasValue(u)), o = i.length;
  if (o)
    for (let u = 0; u < o; u++) {
      const d = i[u], s = t[d];
      let l = null;
      Array.isArray(s) && (l = s[0]), l === null && (l = (a = (n = r[d]) !== null && n !== void 0 ? n : e.readValue(d)) !== null && a !== void 0 ? a : t[d]), l != null && (typeof l == "string" && (mse(l) || aS(l)) ? l = parseFloat(l) : !vse(l) && bo.test(s) && (l = nS(d, s)), e.addValue(d, ju(l, { owner: e })), r[d] === void 0 && (r[d] = l), l !== null && e.setBaseTarget(d, l));
    }
}
function kse(e, t) {
  return t ? (t[e] || t.default || t).from : void 0;
}
function xse(e, t, r) {
  const n = {};
  for (const a in e) {
    const i = kse(a, t);
    if (i !== void 0)
      n[a] = i;
    else {
      const o = r.getValue(a);
      o && (n[a] = o.get());
    }
  }
  return n;
}
function Dse({ protectedKeys: e, needsAnimating: t }, r) {
  const n = e.hasOwnProperty(r) && t[r] !== !0;
  return t[r] = !1, n;
}
function uS(e, t, { delay: r = 0, transitionOverride: n, type: a } = {}) {
  let { transition: i = e.getDefaultTransition(), transitionEnd: o, ...u } = e.makeTargetAnimatable(t);
  const d = e.getValue("willChange");
  n && (i = n);
  const s = [], l = a && e.animationState && e.animationState.getState()[a];
  for (const f in u) {
    const c = e.getValue(f), h = u[f];
    if (!c || h === void 0 || l && Dse(l, f))
      continue;
    const _ = { delay: r, elapsed: 0, ...i };
    if (window.HandoffAppearAnimations && !c.hasAnimated) {
      const v = e.getProps()[hoe];
      v && (_.elapsed = window.HandoffAppearAnimations(v, f, c, tr));
    }
    c.start(HF(f, c, h, e.shouldReduceMotion && Ts.has(f) ? { type: !1 } : _));
    const F = c.animation;
    l0(d) && (d.add(f), F.then(() => d.remove(f))), s.push(F);
  }
  return o && Promise.all(s).then(() => {
    o && $se(e, o);
  }), s;
}
function Pm(e, t, r = {}) {
  const n = Yh(e, t, r.custom);
  let { transition: a = e.getDefaultTransition() || {} } = n || {};
  r.transitionOverride && (a = r.transitionOverride);
  const i = n ? () => Promise.all(uS(e, n, r)) : () => Promise.resolve(), o = e.variantChildren && e.variantChildren.size ? (d = 0) => {
    const { delayChildren: s = 0, staggerChildren: l, staggerDirection: f } = a;
    return Cse(e, t, s + d, l, f, r);
  } : () => Promise.resolve(), { when: u } = a;
  if (u) {
    const [d, s] = u === "beforeChildren" ? [i, o] : [o, i];
    return d().then(() => s());
  } else
    return Promise.all([i(), o(r.delay)]);
}
function Cse(e, t, r = 0, n = 0, a = 1, i) {
  const o = [], u = (e.variantChildren.size - 1) * n, d = a === 1 ? (s = 0) => s * n : (s = 0) => u - s * n;
  return Array.from(e.variantChildren).sort(Sse).forEach((s, l) => {
    s.notify("AnimationStart", t), o.push(Pm(s, t, {
      ...i,
      delay: r + d(l)
    }).then(() => s.notify("AnimationComplete", t)));
  }), Promise.all(o);
}
function Sse(e, t) {
  return e.sortNodePosition(t);
}
function Ase(e, t, r = {}) {
  e.notify("AnimationStart", t);
  let n;
  if (Array.isArray(t)) {
    const a = t.map((i) => Pm(e, i, r));
    n = Promise.all(a);
  } else if (typeof t == "string")
    n = Pm(e, t, r);
  else {
    const a = typeof t == "function" ? Yh(e, t, r.custom) : t;
    n = Promise.all(uS(e, a, r));
  }
  return n.then(() => e.notify("AnimationComplete", t));
}
const Ose = [...OF].reverse(), Tse = OF.length;
function Pse(e) {
  return (t) => Promise.all(t.map(({ animation: r, options: n }) => Ase(e, r, n)));
}
function Ise(e) {
  let t = Pse(e);
  const r = jse();
  let n = !0;
  const a = (d, s) => {
    const l = Yh(e, s);
    if (l) {
      const { transition: f, transitionEnd: c, ...h } = l;
      d = { ...d, ...h, ...c };
    }
    return d;
  };
  function i(d) {
    t = d(e);
  }
  function o(d, s) {
    const l = e.getProps(), f = e.getVariantContext(!0) || {}, c = [], h = /* @__PURE__ */ new Set();
    let _ = {}, F = 1 / 0;
    for (let $ = 0; $ < Tse; $++) {
      const E = Ose[$], D = r[E], w = l[E] !== void 0 ? l[E] : f[E], k = Rl(w), A = E === s ? D.isActive : null;
      A === !1 && (F = $);
      let P = w === f[E] && w !== l[E] && k;
      if (P && n && e.manuallyAnimateOnMount && (P = !1), D.protectedKeys = { ..._ }, // If it isn't active and hasn't *just* been set as inactive
      !D.isActive && A === null || // If we didn't and don't have any defined prop for this animation type
      !w && !D.prevProp || // Or if the prop doesn't define an animation
      Wh(w) || typeof w == "boolean")
        continue;
      const S = Rse(D.prevProp, w);
      let N = S || // If we're making this variant active, we want to always make it active
      E === s && D.isActive && !P && k || // If we removed a higher-priority variant (i is in reverse order)
      $ > F && k;
      const W = Array.isArray(w) ? w : [w];
      let V = W.reduce(a, {});
      A === !1 && (V = {});
      const { prevResolvedValues: K = {} } = D, U = {
        ...K,
        ...V
      }, j = (G) => {
        N = !0, h.delete(G), D.needsAnimating[G] = !0;
      };
      for (const G in U) {
        const H = V[G], J = K[G];
        _.hasOwnProperty(G) || (H !== J ? o0(H) && o0(J) ? !AC(H, J) || S ? j(G) : D.protectedKeys[G] = !0 : H !== void 0 ? j(G) : h.add(G) : H !== void 0 && h.has(G) ? j(G) : D.protectedKeys[G] = !0);
      }
      D.prevProp = w, D.prevResolvedValues = V, D.isActive && (_ = { ..._, ...V }), n && e.blockInitialAnimation && (N = !1), N && !P && c.push(...W.map((G) => ({
        animation: G,
        options: { type: E, ...d }
      })));
    }
    if (h.size) {
      const $ = {};
      h.forEach((E) => {
        const D = e.getBaseTarget(E);
        D !== void 0 && ($[E] = D);
      }), c.push({ animation: $ });
    }
    let v = Boolean(c.length);
    return n && l.initial === !1 && !e.manuallyAnimateOnMount && (v = !1), n = !1, v ? t(c) : Promise.resolve();
  }
  function u(d, s, l) {
    var f;
    if (r[d].isActive === s)
      return Promise.resolve();
    (f = e.variantChildren) === null || f === void 0 || f.forEach((h) => {
      var _;
      return (_ = h.animationState) === null || _ === void 0 ? void 0 : _.setActive(d, s);
    }), r[d].isActive = s;
    const c = o(l, d);
    for (const h in r)
      r[h].protectedKeys = {};
    return c;
  }
  return {
    animateChanges: o,
    setActive: u,
    setAnimateFunction: i,
    getState: () => r
  };
}
function Rse(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !AC(t, e) : !1;
}
function Go(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function jse() {
  return {
    animate: Go(!0),
    whileInView: Go(),
    whileHover: Go(),
    whileTap: Go(),
    whileDrag: Go(),
    whileFocus: Go(),
    exit: Go()
  };
}
class Mse extends xo {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = Ise(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    this.unmount(), Wh(t) && (this.unmount = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: r } = this.node.prevProps || {};
    t !== r && this.updateAnimationControlsSubscription();
  }
  unmount() {
  }
}
let Bse = 0;
class Nse extends xo {
  constructor() {
    super(...arguments), this.id = Bse++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: r, custom: n } = this.node.presenceContext, { isPresent: a } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === a)
      return;
    const i = this.node.animationState.setActive("exit", !t, { custom: n ?? this.node.getProps().custom });
    r && !t && i.then(() => r(this.id));
  }
  mount() {
    const { register: t } = this.node.presenceContext || {};
    t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const Lse = {
  animation: {
    Feature: Mse
  },
  exit: {
    Feature: Nse
  }
}, $5 = (e, t) => Math.abs(e - t);
function qse(e, t) {
  const r = $5(e.x, t.x), n = $5(e.y, t.y);
  return Math.sqrt(r ** 2 + n ** 2);
}
class dS {
  constructor(t, r, { transformPagePoint: n } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const s = i2(this.lastMoveEventInfo, this.history), l = this.startEvent !== null, f = qse(s.offset, { x: 0, y: 0 }) >= 3;
      if (!l && !f)
        return;
      const { point: c } = s, { timestamp: h } = ir;
      this.history.push({ ...c, timestamp: h });
      const { onStart: _, onMove: F } = this.handlers;
      l || (_ && _(this.lastMoveEvent, s), this.startEvent = this.lastMoveEvent), F && F(this.lastMoveEvent, s);
    }, this.handlePointerMove = (s, l) => {
      this.lastMoveEvent = s, this.lastMoveEventInfo = a2(l, this.transformPagePoint), tr.update(this.updatePoint, !0);
    }, this.handlePointerUp = (s, l) => {
      if (this.end(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const { onEnd: f, onSessionEnd: c } = this.handlers, h = i2(s.type === "pointercancel" ? this.lastMoveEventInfo : a2(l, this.transformPagePoint), this.history);
      this.startEvent && f && f(s, h), c && c(s, h);
    }, !wC(t))
      return;
    this.handlers = r, this.transformPagePoint = n;
    const a = zh(t), i = a2(a, this.transformPagePoint), { point: o } = i, { timestamp: u } = ir;
    this.history = [{ ...o, timestamp: u }];
    const { onSessionStart: d } = r;
    d && d(t, i2(i, this.history)), this.removeListeners = _o(ki(window, "pointermove", this.handlePointerMove), ki(window, "pointerup", this.handlePointerUp), ki(window, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), Ti(this.updatePoint);
  }
}
function a2(e, t) {
  return t ? { point: t(e.point) } : e;
}
function w5(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function i2({ point: e }, t) {
  return {
    point: e,
    delta: w5(e, lS(t)),
    offset: w5(e, Use(t)),
    velocity: Gse(t, 0.1)
  };
}
function Use(e) {
  return e[0];
}
function lS(e) {
  return e[e.length - 1];
}
function Gse(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let r = e.length - 1, n = null;
  const a = lS(e);
  for (; r >= 0 && (n = e[r], !(a.timestamp - n.timestamp > mo(t))); )
    r--;
  if (!n)
    return { x: 0, y: 0 };
  const i = xi(a.timestamp - n.timestamp);
  if (i === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (a.x - n.x) / i,
    y: (a.y - n.y) / i
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function xn(e) {
  return e.max - e.min;
}
function Im(e, t = 0, r = 0.01) {
  return Math.abs(e - t) <= r;
}
function k5(e, t, r, n = 0.5) {
  e.origin = n, e.originPoint = or(t.min, t.max, e.origin), e.scale = xn(r) / xn(t), (Im(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = or(r.min, r.max, e.origin) - e.originPoint, (Im(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function ml(e, t, r, n) {
  k5(e.x, t.x, r.x, n ? n.originX : void 0), k5(e.y, t.y, r.y, n ? n.originY : void 0);
}
function x5(e, t, r) {
  e.min = r.min + t.min, e.max = e.min + xn(t);
}
function Wse(e, t, r) {
  x5(e.x, t.x, r.x), x5(e.y, t.y, r.y);
}
function D5(e, t, r) {
  e.min = t.min - r.min, e.max = e.min + xn(t);
}
function pl(e, t, r) {
  D5(e.x, t.x, r.x), D5(e.y, t.y, r.y);
}
function Vse(e, { min: t, max: r }, n) {
  return t !== void 0 && e < t ? e = n ? or(t, e, n.min) : Math.max(e, t) : r !== void 0 && e > r && (e = n ? or(r, e, n.max) : Math.min(e, r)), e;
}
function C5(e, t, r) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: r !== void 0 ? e.max + r - (e.max - e.min) : void 0
  };
}
function Hse(e, { top: t, left: r, bottom: n, right: a }) {
  return {
    x: C5(e.x, r, a),
    y: C5(e.y, t, n)
  };
}
function S5(e, t) {
  let r = t.min - e.min, n = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([r, n] = [n, r]), { min: r, max: n };
}
function zse(e, t) {
  return {
    x: S5(e.x, t.x),
    y: S5(e.y, t.y)
  };
}
function Kse(e, t) {
  let r = 0.5;
  const n = xn(e), a = xn(t);
  return a > n ? r = Bl(t.min, t.max - n, e.min) : n > a && (r = Bl(e.min, e.max - a, t.min)), yo(0, 1, r);
}
function Yse(e, t) {
  const r = {};
  return t.min !== void 0 && (r.min = t.min - e.min), t.max !== void 0 && (r.max = t.max - e.min), r;
}
const Rm = 0.35;
function Xse(e = Rm) {
  return e === !1 ? e = 0 : e === !0 && (e = Rm), {
    x: A5(e, "left", "right"),
    y: A5(e, "top", "bottom")
  };
}
function A5(e, t, r) {
  return {
    min: O5(e, t),
    max: O5(e, r)
  };
}
function O5(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const T5 = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), mu = () => ({
  x: T5(),
  y: T5()
}), P5 = () => ({ min: 0, max: 0 }), Fr = () => ({
  x: P5(),
  y: P5()
});
function ja(e) {
  return [e("x"), e("y")];
}
function fS({ top: e, left: t, right: r, bottom: n }) {
  return {
    x: { min: t, max: r },
    y: { min: e, max: n }
  };
}
function Qse({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function Zse(e, t) {
  if (!t)
    return e;
  const r = t({ x: e.left, y: e.top }), n = t({ x: e.right, y: e.bottom });
  return {
    top: r.y,
    left: r.x,
    bottom: n.y,
    right: n.x
  };
}
function o2(e) {
  return e === void 0 || e === 1;
}
function jm({ scale: e, scaleX: t, scaleY: r }) {
  return !o2(e) || !o2(t) || !o2(r);
}
function Xo(e) {
  return jm(e) || cS(e) || e.z || e.rotate || e.rotateX || e.rotateY;
}
function cS(e) {
  return I5(e.x) || I5(e.y);
}
function I5(e) {
  return e && e !== "0%";
}
function f0(e, t, r) {
  const n = e - r, a = t * n;
  return r + a;
}
function R5(e, t, r, n, a) {
  return a !== void 0 && (e = f0(e, a, n)), f0(e, r, n) + t;
}
function Mm(e, t = 0, r = 1, n, a) {
  e.min = R5(e.min, t, r, n, a), e.max = R5(e.max, t, r, n, a);
}
function hS(e, { x: t, y: r }) {
  Mm(e.x, t.translate, t.scale, t.originPoint), Mm(e.y, r.translate, r.scale, r.originPoint);
}
function Jse(e, t, r, n = !1) {
  const a = r.length;
  if (!a)
    return;
  t.x = t.y = 1;
  let i, o;
  for (let u = 0; u < a; u++) {
    i = r[u], o = i.projectionDelta;
    const d = i.instance;
    d && d.style && d.style.display === "contents" || (n && i.options.layoutScroll && i.scroll && i !== i.root && pu(e, {
      x: -i.scroll.offset.x,
      y: -i.scroll.offset.y
    }), o && (t.x *= o.x.scale, t.y *= o.y.scale, hS(e, o)), n && Xo(i.latestValues) && pu(e, i.latestValues));
  }
  t.x = j5(t.x), t.y = j5(t.y);
}
function j5(e) {
  return Number.isInteger(e) || e > 1.0000000000001 || e < 0.999999999999 ? e : 1;
}
function fo(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function M5(e, t, [r, n, a]) {
  const i = t[a] !== void 0 ? t[a] : 0.5, o = or(e.min, e.max, i);
  Mm(e, t[r], t[n], o, t.scale);
}
const eue = ["x", "scaleX", "originX"], tue = ["y", "scaleY", "originY"];
function pu(e, t) {
  M5(e.x, t, eue), M5(e.y, t, tue);
}
function gS(e, t) {
  return fS(Zse(e.getBoundingClientRect(), t));
}
function rue(e, t, r) {
  const n = gS(e, r), { scroll: a } = t;
  return a && (fo(n.x, a.offset.x), fo(n.y, a.offset.y)), n;
}
const nue = /* @__PURE__ */ new WeakMap();
class aue {
  constructor(t) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = Fr(), this.visualElement = t;
  }
  start(t, { snapToCursor: r = !1 } = {}) {
    const { presenceContext: n } = this.visualElement;
    if (n && n.isPresent === !1)
      return;
    const a = (d) => {
      this.stopAnimation(), r && this.snapToCursor(zh(d, "page").point);
    }, i = (d, s) => {
      const { drag: l, dragPropagation: f, onDragStart: c } = this.getProps();
      if (l && !f && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = xC(l), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), ja((_) => {
        let F = this.getAxisMotionValue(_).get() || 0;
        if (Ga.test(F)) {
          const { projection: v } = this.visualElement;
          if (v && v.layout) {
            const $ = v.layout.layoutBox[_];
            $ && (F = xn($) * (parseFloat(F) / 100));
          }
        }
        this.originPoint[_] = F;
      }), c && tr.update(() => c(d, s), !1, !0);
      const { animationState: h } = this.visualElement;
      h && h.setActive("whileDrag", !0);
    }, o = (d, s) => {
      const { dragPropagation: l, dragDirectionLock: f, onDirectionLock: c, onDrag: h } = this.getProps();
      if (!l && !this.openGlobalLock)
        return;
      const { offset: _ } = s;
      if (f && this.currentDirection === null) {
        this.currentDirection = iue(_), this.currentDirection !== null && c && c(this.currentDirection);
        return;
      }
      this.updateAxis("x", s.point, _), this.updateAxis("y", s.point, _), this.visualElement.render(), h && h(d, s);
    }, u = (d, s) => this.stop(d, s);
    this.panSession = new dS(t, {
      onSessionStart: a,
      onStart: i,
      onMove: o,
      onSessionEnd: u
    }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
  }
  stop(t, r) {
    const n = this.isDragging;
    if (this.cancel(), !n)
      return;
    const { velocity: a } = r;
    this.startAnimation(a);
    const { onDragEnd: i } = this.getProps();
    i && tr.update(() => i(t, r));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: r } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: n } = this.getProps();
    !n && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), r && r.setActive("whileDrag", !1);
  }
  updateAxis(t, r, n) {
    const { drag: a } = this.getProps();
    if (!n || !s1(t, a, this.currentDirection))
      return;
    const i = this.getAxisMotionValue(t);
    let o = this.originPoint[t] + n[t];
    this.constraints && this.constraints[t] && (o = Vse(o, this.constraints[t], this.elastic[t])), i.set(o);
  }
  resolveConstraints() {
    const { dragConstraints: t, dragElastic: r } = this.getProps(), { layout: n } = this.visualElement.projection || {}, a = this.constraints;
    t && gu(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && n ? this.constraints = Hse(n.layoutBox, t) : this.constraints = !1, this.elastic = Xse(r), a !== this.constraints && n && this.constraints && !this.hasMutatedConstraints && ja((i) => {
      this.getAxisMotionValue(i) && (this.constraints[i] = Yse(n.layoutBox[i], this.constraints[i]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: r } = this.getProps();
    if (!t || !gu(t))
      return !1;
    const n = t.current;
    ma(n !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: a } = this.visualElement;
    if (!a || !a.layout)
      return !1;
    const i = rue(n, a.root, this.visualElement.getTransformPagePoint());
    let o = zse(a.layout.layoutBox, i);
    if (r) {
      const u = r(Qse(o));
      this.hasMutatedConstraints = !!u, u && (o = fS(u));
    }
    return o;
  }
  startAnimation(t) {
    const { drag: r, dragMomentum: n, dragElastic: a, dragTransition: i, dragSnapToOrigin: o, onDragTransitionEnd: u } = this.getProps(), d = this.constraints || {}, s = ja((l) => {
      if (!s1(l, r, this.currentDirection))
        return;
      let f = d && d[l] || {};
      o && (f = { min: 0, max: 0 });
      const c = a ? 200 : 1e6, h = a ? 40 : 1e7, _ = {
        type: "inertia",
        velocity: n ? t[l] : 0,
        bounceStiffness: c,
        bounceDamping: h,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...i,
        ...f
      };
      return this.startAxisValueAnimation(l, _);
    });
    return Promise.all(s).then(u);
  }
  startAxisValueAnimation(t, r) {
    const n = this.getAxisMotionValue(t);
    return n.start(HF(t, n, 0, r));
  }
  stopAnimation() {
    ja((t) => this.getAxisMotionValue(t).stop());
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const r = "_drag" + t.toUpperCase(), n = this.visualElement.getProps(), a = n[r];
    return a || this.visualElement.getValue(t, (n.initial ? n.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    ja((r) => {
      const { drag: n } = this.getProps();
      if (!s1(r, n, this.currentDirection))
        return;
      const { projection: a } = this.visualElement, i = this.getAxisMotionValue(r);
      if (a && a.layout) {
        const { min: o, max: u } = a.layout.layoutBox[r];
        i.set(t[r] - or(o, u, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: r } = this.getProps(), { projection: n } = this.visualElement;
    if (!gu(r) || !n || !this.constraints)
      return;
    this.stopAnimation();
    const a = { x: 0, y: 0 };
    ja((o) => {
      const u = this.getAxisMotionValue(o);
      if (u) {
        const d = u.get();
        a[o] = Kse({ min: d, max: d }, this.constraints[o]);
      }
    });
    const { transformTemplate: i } = this.visualElement.getProps();
    this.visualElement.current.style.transform = i ? i({}, "") : "none", n.root && n.root.updateScroll(), n.updateLayout(), this.resolveConstraints(), ja((o) => {
      if (!s1(o, t, null))
        return;
      const u = this.getAxisMotionValue(o), { min: d, max: s } = this.constraints[o];
      u.set(or(d, s, a[o]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    nue.set(this.visualElement, this);
    const t = this.visualElement.current, r = ki(t, "pointerdown", (d) => {
      const { drag: s, dragListener: l = !0 } = this.getProps();
      s && l && this.start(d);
    }), n = () => {
      const { dragConstraints: d } = this.getProps();
      gu(d) && (this.constraints = this.resolveRefConstraints());
    }, { projection: a } = this.visualElement, i = a.addEventListener("measure", n);
    a && !a.layout && (a.root && a.root.updateScroll(), a.updateLayout()), n();
    const o = Ei(window, "resize", () => this.scalePositionWithinConstraints()), u = a.addEventListener("didUpdate", ({ delta: d, hasLayoutChanged: s }) => {
      this.isDragging && s && (ja((l) => {
        const f = this.getAxisMotionValue(l);
        f && (this.originPoint[l] += d[l].translate, f.set(f.get() + d[l].translate));
      }), this.visualElement.render());
    });
    return () => {
      o(), r(), i(), u && u();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: r = !1, dragDirectionLock: n = !1, dragPropagation: a = !1, dragConstraints: i = !1, dragElastic: o = Rm, dragMomentum: u = !0 } = t;
    return {
      ...t,
      drag: r,
      dragDirectionLock: n,
      dragPropagation: a,
      dragConstraints: i,
      dragElastic: o,
      dragMomentum: u
    };
  }
}
function s1(e, t, r) {
  return (t === !0 || t === e) && (r === null || r === e);
}
function iue(e, t = 10) {
  let r = null;
  return Math.abs(e.y) > t ? r = "y" : Math.abs(e.x) > t && (r = "x"), r;
}
class oue extends xo {
  constructor(t) {
    super(t), this.removeGroupControls = Er, this.removeListeners = Er, this.controls = new aue(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Er;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const B5 = (e) => (t, r) => {
  e && tr.update(() => e(t, r));
};
class sue extends xo {
  constructor() {
    super(...arguments), this.removePointerDownListener = Er;
  }
  onPointerDown(t) {
    this.session = new dS(t, this.createPanHandlers(), { transformPagePoint: this.node.getTransformPagePoint() });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: r, onPan: n, onPanEnd: a } = this.node.getProps();
    return {
      onSessionStart: B5(t),
      onStart: B5(r),
      onMove: n,
      onEnd: (i, o) => {
        delete this.session, a && tr.update(() => a(i, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = ki(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
function uue() {
  const e = Et(Uh);
  if (e === null)
    return [!0, null];
  const { isPresent: t, onExitComplete: r, register: n } = e, a = p3();
  return at(() => n(a), []), !t && r ? [!1, () => r && r(a)] : [!0];
}
const O1 = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function N5(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const zd = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (ut.test(e))
        e = parseFloat(e);
      else
        return e;
    const r = N5(e, t.target.x), n = N5(e, t.target.y);
    return `${r}% ${n}%`;
  }
}, due = {
  correct: (e, { treeScale: t, projectionDelta: r }) => {
    const n = e, a = bo.parse(e);
    if (a.length > 5)
      return n;
    const i = bo.createTransformer(e), o = typeof a[0] != "number" ? 1 : 0, u = r.x.scale * t.x, d = r.y.scale * t.y;
    a[0 + o] /= u, a[1 + o] /= d;
    const s = or(u, d, 0.5);
    return typeof a[2 + o] == "number" && (a[2 + o] /= s), typeof a[3 + o] == "number" && (a[3 + o] /= s), i(a);
  }
};
class lue extends M.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: r, switchLayoutGroup: n, layoutId: a } = this.props, { projection: i } = t;
    yie(fue), i && (r.group && r.group.add(i), n && n.register && a && n.register(i), i.root.didUpdate(), i.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), i.setOptions({
      ...i.options,
      onExitComplete: () => this.safeToRemove()
    })), O1.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: r, visualElement: n, drag: a, isPresent: i } = this.props, o = n.projection;
    return o && (o.isPresent = i, a || t.layoutDependency !== r || r === void 0 ? o.willUpdate() : this.safeToRemove(), t.isPresent !== i && (i ? o.promote() : o.relegate() || tr.postRender(() => {
      const u = o.getStack();
      (!u || !u.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), queueMicrotask(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: r, switchLayoutGroup: n } = this.props, { projection: a } = t;
    a && (a.scheduleCheckAfterUnmount(), r && r.group && r.group.remove(a), n && n.deregister && n.deregister(a));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function _S(e) {
  const [t, r] = uue(), n = Et(PF);
  return M.createElement(lue, { ...e, layoutGroup: n, switchLayoutGroup: Et(dC), isPresent: t, safeToRemove: r });
}
const fue = {
  borderRadius: {
    ...zd,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: zd,
  borderTopRightRadius: zd,
  borderBottomLeftRadius: zd,
  borderBottomRightRadius: zd,
  boxShadow: due
}, mS = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], cue = mS.length, L5 = (e) => typeof e == "string" ? parseFloat(e) : e, q5 = (e) => typeof e == "number" || ut.test(e);
function hue(e, t, r, n, a, i) {
  a ? (e.opacity = or(
    0,
    // TODO Reinstate this if only child
    r.opacity !== void 0 ? r.opacity : 1,
    gue(n)
  ), e.opacityExit = or(t.opacity !== void 0 ? t.opacity : 1, 0, _ue(n))) : i && (e.opacity = or(t.opacity !== void 0 ? t.opacity : 1, r.opacity !== void 0 ? r.opacity : 1, n));
  for (let o = 0; o < cue; o++) {
    const u = `border${mS[o]}Radius`;
    let d = U5(t, u), s = U5(r, u);
    if (d === void 0 && s === void 0)
      continue;
    d || (d = 0), s || (s = 0), d === 0 || s === 0 || q5(d) === q5(s) ? (e[u] = Math.max(or(L5(d), L5(s), n), 0), (Ga.test(s) || Ga.test(d)) && (e[u] += "%")) : e[u] = s;
  }
  (t.rotate || r.rotate) && (e.rotate = or(t.rotate || 0, r.rotate || 0, n));
}
function U5(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const gue = pS(0, 0.5, UF), _ue = pS(0.5, 0.95, Er);
function pS(e, t, r) {
  return (n) => n < e ? 0 : n > t ? 1 : r(Bl(e, t, n));
}
function G5(e, t) {
  e.min = t.min, e.max = t.max;
}
function In(e, t) {
  G5(e.x, t.x), G5(e.y, t.y);
}
function W5(e, t, r, n, a) {
  return e -= t, e = f0(e, 1 / r, n), a !== void 0 && (e = f0(e, 1 / a, n)), e;
}
function mue(e, t = 0, r = 1, n = 0.5, a, i = e, o = e) {
  if (Ga.test(t) && (t = parseFloat(t), t = or(o.min, o.max, t / 100) - o.min), typeof t != "number")
    return;
  let u = or(i.min, i.max, n);
  e === i && (u -= t), e.min = W5(e.min, t, r, u, a), e.max = W5(e.max, t, r, u, a);
}
function V5(e, t, [r, n, a], i, o) {
  mue(e, t[r], t[n], t[a], t.scale, i, o);
}
const pue = ["x", "scaleX", "originX"], Fue = ["y", "scaleY", "originY"];
function H5(e, t, r, n) {
  V5(e.x, t, pue, r ? r.x : void 0, n ? n.x : void 0), V5(e.y, t, Fue, r ? r.y : void 0, n ? n.y : void 0);
}
function z5(e) {
  return e.translate === 0 && e.scale === 1;
}
function FS(e) {
  return z5(e.x) && z5(e.y);
}
function Bm(e, t) {
  return e.x.min === t.x.min && e.x.max === t.x.max && e.y.min === t.y.min && e.y.max === t.y.max;
}
function K5(e) {
  return xn(e.x) / xn(e.y);
}
class yue {
  constructor() {
    this.members = [];
  }
  add(t) {
    zF(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (KF(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const r = this.members[this.members.length - 1];
      r && this.promote(r);
    }
  }
  relegate(t) {
    const r = this.members.findIndex((a) => t === a);
    if (r === 0)
      return !1;
    let n;
    for (let a = r; a >= 0; a--) {
      const i = this.members[a];
      if (i.isPresent !== !1) {
        n = i;
        break;
      }
    }
    return n ? (this.promote(n), !0) : !1;
  }
  promote(t, r) {
    const n = this.lead;
    if (t !== n && (this.prevLead = n, this.lead = t, t.show(), n)) {
      n.instance && n.scheduleRender(), t.scheduleRender(), t.resumeFrom = n, r && (t.resumeFrom.preserveOpacity = !0), n.snapshot && (t.snapshot = n.snapshot, t.snapshot.latestValues = n.animationValues || n.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: a } = t.options;
      a === !1 && n.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: r, resumingFrom: n } = t;
      r.onExitComplete && r.onExitComplete(), n && n.options.onExitComplete && n.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function Y5(e, t, r) {
  let n = "";
  const a = e.x.translate / t.x, i = e.y.translate / t.y;
  if ((a || i) && (n = `translate3d(${a}px, ${i}px, 0) `), (t.x !== 1 || t.y !== 1) && (n += `scale(${1 / t.x}, ${1 / t.y}) `), r) {
    const { rotate: d, rotateX: s, rotateY: l } = r;
    d && (n += `rotate(${d}deg) `), s && (n += `rotateX(${s}deg) `), l && (n += `rotateY(${l}deg) `);
  }
  const o = e.x.scale * t.x, u = e.y.scale * t.y;
  return (o !== 1 || u !== 1) && (n += `scale(${o}, ${u})`), n || "none";
}
const bue = (e, t) => e.depth - t.depth;
class vue {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    zF(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    KF(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(bue), this.isDirty = !1, this.children.forEach(t);
  }
}
function Eue(e, t) {
  const r = performance.now(), n = ({ timestamp: a }) => {
    const i = a - r;
    i >= t && (Ti(n), e(i - t));
  };
  return tr.read(n, !0), () => Ti(n);
}
function $ue(e) {
  window.MotionDebug && window.MotionDebug.record(e);
}
function wue(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
function kue(e, t, r) {
  const n = fn(e) ? e : ju(e);
  return n.start(HF("", n, t, r)), n.animation;
}
const X5 = ["", "X", "Y", "Z"], Q5 = 1e3;
let xue = 0;
const Qo = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function yS({ attachResizeListener: e, defaultParent: t, measureScroll: r, checkIsScrollRoot: n, resetTransform: a }) {
  return class {
    constructor(o = {}, u = t == null ? void 0 : t()) {
      this.id = xue++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        Qo.totalNodes = Qo.resolvedTargetDeltas = Qo.recalculatedProjection = 0, this.nodes.forEach(Sue), this.nodes.forEach(Iue), this.nodes.forEach(Rue), this.nodes.forEach(Aue), $ue(Qo);
      }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = o, this.root = u ? u.root || u : this, this.path = u ? [...u.path, u] : [], this.parent = u, this.depth = u ? u.depth + 1 : 0;
      for (let d = 0; d < this.path.length; d++)
        this.path[d].shouldResetTransform = !0;
      this.root === this && (this.nodes = new vue());
    }
    addEventListener(o, u) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new YF()), this.eventHandlers.get(o).add(u);
    }
    notifyListeners(o, ...u) {
      const d = this.eventHandlers.get(o);
      d && d.notify(...u);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    /**
     * Lifecycles
     */
    mount(o, u = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = wue(o), this.instance = o;
      const { layoutId: d, layout: s, visualElement: l } = this.options;
      if (l && !l.current && l.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), u && (s || d) && (this.isLayoutDirty = !0), e) {
        let f;
        const c = () => this.root.updateBlockedByResize = !1;
        e(o, () => {
          this.root.updateBlockedByResize = !0, f && f(), f = Eue(c, 250), O1.hasAnimatedSinceResize && (O1.hasAnimatedSinceResize = !1, this.nodes.forEach(J5));
        });
      }
      d && this.root.registerSharedNode(d, this), this.options.animate !== !1 && l && (d || s) && this.addEventListener("didUpdate", ({ delta: f, hasLayoutChanged: c, hasRelativeTargetChanged: h, layout: _ }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const F = this.options.transition || l.getDefaultTransition() || Lue, { onLayoutAnimationStart: v, onLayoutAnimationComplete: $ } = l.getProps(), E = !this.targetLayout || !Bm(this.targetLayout, _) || h, D = !c && h;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || D || c && (E || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(f, D);
          const w = {
            ...iS(F, "layout"),
            onPlay: v,
            onComplete: $
          };
          (l.shouldReduceMotion || this.options.layoutRoot) && (w.delay = 0, w.type = !1), this.startAnimation(w);
        } else
          c || J5(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = _;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, Ti(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(jue), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (!this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let l = 0; l < this.path.length; l++) {
        const f = this.path[l];
        f.shouldResetTransform = !0, f.updateScroll("snapshot"), f.options.layoutRoot && f.willUpdate(!1);
      }
      const { layoutId: u, layout: d } = this.options;
      if (u === void 0 && !d)
        return;
      const s = this.getTransformTemplate();
      this.prevTransformTemplateValue = s ? s(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Z5);
        return;
      }
      this.isUpdating || this.nodes.forEach(Tue), this.isUpdating = !1, this.nodes.forEach(Pue), this.nodes.forEach(Due), this.nodes.forEach(Cue), this.clearAllSnapshots();
      const u = performance.now();
      ir.delta = yo(0, 1e3 / 60, u - ir.timestamp), ir.timestamp = u, ir.isProcessing = !0, ku.update.process(ir), ku.preRender.process(ir), ku.render.process(ir), ir.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, queueMicrotask(() => this.update()));
    }
    clearAllSnapshots() {
      this.nodes.forEach(Oue), this.sharedNodes.forEach(Mue);
    }
    scheduleUpdateProjection() {
      tr.preRender(this.updateProjection, !1, !0);
    }
    scheduleCheckAfterUnmount() {
      tr.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let d = 0; d < this.path.length; d++)
          this.path[d].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = Fr(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: u } = this.options;
      u && u.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let u = Boolean(this.options.layoutScroll && this.instance);
      this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (u = !1), u && (this.scroll = {
        animationId: this.root.animationId,
        phase: o,
        isRoot: n(this.instance),
        offset: r(this.instance)
      });
    }
    resetTransform() {
      if (!a)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform, u = this.projectionDelta && !FS(this.projectionDelta), d = this.getTransformTemplate(), s = d ? d(this.latestValues, "") : void 0, l = s !== this.prevTransformTemplateValue;
      o && (u || Xo(this.latestValues) || l) && (a(this.instance, s), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const u = this.measurePageBox();
      let d = this.removeElementScroll(u);
      return o && (d = this.removeTransform(d)), que(d), {
        animationId: this.root.animationId,
        measuredBox: u,
        layoutBox: d,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: o } = this.options;
      if (!o)
        return Fr();
      const u = o.measureViewportBox(), { scroll: d } = this.root;
      return d && (fo(u.x, d.offset.x), fo(u.y, d.offset.y)), u;
    }
    removeElementScroll(o) {
      const u = Fr();
      In(u, o);
      for (let d = 0; d < this.path.length; d++) {
        const s = this.path[d], { scroll: l, options: f } = s;
        if (s !== this.root && l && f.layoutScroll) {
          if (l.isRoot) {
            In(u, o);
            const { scroll: c } = this.root;
            c && (fo(u.x, -c.offset.x), fo(u.y, -c.offset.y));
          }
          fo(u.x, l.offset.x), fo(u.y, l.offset.y);
        }
      }
      return u;
    }
    applyTransform(o, u = !1) {
      const d = Fr();
      In(d, o);
      for (let s = 0; s < this.path.length; s++) {
        const l = this.path[s];
        !u && l.options.layoutScroll && l.scroll && l !== l.root && pu(d, {
          x: -l.scroll.offset.x,
          y: -l.scroll.offset.y
        }), Xo(l.latestValues) && pu(d, l.latestValues);
      }
      return Xo(this.latestValues) && pu(d, this.latestValues), d;
    }
    removeTransform(o) {
      const u = Fr();
      In(u, o);
      for (let d = 0; d < this.path.length; d++) {
        const s = this.path[d];
        if (!s.instance || !Xo(s.latestValues))
          continue;
        jm(s.latestValues) && s.updateSnapshot();
        const l = Fr(), f = s.measurePageBox();
        In(l, f), H5(u, s.latestValues, s.snapshot ? s.snapshot.layoutBox : void 0, l);
      }
      return Xo(this.latestValues) && H5(u, this.latestValues), u;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== ir.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(o = !1) {
      var u;
      const d = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = d.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = d.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = d.isSharedProjectionDirty);
      const s = Boolean(this.resumingFrom) || this !== d;
      if (!(o || s && this.isSharedProjectionDirty || this.isProjectionDirty || !((u = this.parent) === null || u === void 0) && u.isProjectionDirty || this.attemptToResolveRelativeTarget))
        return;
      const { layout: f, layoutId: c } = this.options;
      if (!(!this.layout || !(f || c))) {
        if (this.resolvedRelativeTargetAt = ir.timestamp, !this.targetDelta && !this.relativeTarget) {
          const h = this.getClosestProjectingParent();
          h && h.layout && this.animationProgress !== 1 ? (this.relativeParent = h, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Fr(), this.relativeTargetOrigin = Fr(), pl(this.relativeTargetOrigin, this.layout.layoutBox, h.layout.layoutBox), In(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = Fr(), this.targetWithTransforms = Fr()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), Wse(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (Boolean(this.resumingFrom) ? this.target = this.applyTransform(this.layout.layoutBox) : In(this.target, this.layout.layoutBox), hS(this.target, this.targetDelta)) : In(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const h = this.getClosestProjectingParent();
            h && Boolean(h.resumingFrom) === Boolean(this.resumingFrom) && !h.options.layoutScroll && h.target && this.animationProgress !== 1 ? (this.relativeParent = h, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Fr(), this.relativeTargetOrigin = Fr(), pl(this.relativeTargetOrigin, this.target, h.target), In(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          Qo.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || jm(this.parent.latestValues) || cS(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var o;
      const u = this.getLead(), d = Boolean(this.resumingFrom) || this !== u;
      let s = !0;
      if ((this.isProjectionDirty || !((o = this.parent) === null || o === void 0) && o.isProjectionDirty) && (s = !1), d && (this.isSharedProjectionDirty || this.isTransformDirty) && (s = !1), this.resolvedRelativeTargetAt === ir.timestamp && (s = !1), s)
        return;
      const { layout: l, layoutId: f } = this.options;
      if (this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(l || f))
        return;
      In(this.layoutCorrected, this.layout.layoutBox);
      const c = this.treeScale.x, h = this.treeScale.y;
      Jse(this.layoutCorrected, this.treeScale, this.path, d), u.layout && !u.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (u.target = u.layout.layoutBox);
      const { target: _ } = u;
      if (!_) {
        this.projectionTransform && (this.projectionDelta = mu(), this.projectionTransform = "none", this.scheduleRender());
        return;
      }
      this.projectionDelta || (this.projectionDelta = mu(), this.projectionDeltaWithTransform = mu());
      const F = this.projectionTransform;
      ml(this.projectionDelta, this.layoutCorrected, _, this.latestValues), this.projectionTransform = Y5(this.projectionDelta, this.treeScale), (this.projectionTransform !== F || this.treeScale.x !== c || this.treeScale.y !== h) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", _)), Qo.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      if (this.options.scheduleRender && this.options.scheduleRender(), o) {
        const u = this.getStack();
        u && u.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    setAnimationOrigin(o, u = !1) {
      const d = this.snapshot, s = d ? d.latestValues : {}, l = { ...this.latestValues }, f = mu();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !u;
      const c = Fr(), h = d ? d.source : void 0, _ = this.layout ? this.layout.source : void 0, F = h !== _, v = this.getStack(), $ = !v || v.members.length <= 1, E = Boolean(F && !$ && this.options.crossfade === !0 && !this.path.some(Nue));
      this.animationProgress = 0;
      let D;
      this.mixTargetDelta = (w) => {
        const k = w / 1e3;
        e8(f.x, o.x, k), e8(f.y, o.y, k), this.setTargetDelta(f), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (pl(c, this.layout.layoutBox, this.relativeParent.layout.layoutBox), Bue(this.relativeTarget, this.relativeTargetOrigin, c, k), D && Bm(this.relativeTarget, D) && (this.isProjectionDirty = !1), D || (D = Fr()), In(D, this.relativeTarget)), F && (this.animationValues = l, hue(l, s, this.latestValues, k, E, $)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = k;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (Ti(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = tr.update(() => {
        O1.hasAnimatedSinceResize = !0, this.currentAnimation = kue(0, Q5, {
          ...o,
          onUpdate: (u) => {
            this.mixTargetDelta(u), o.onUpdate && o.onUpdate(u);
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Q5), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: u, target: d, layout: s, latestValues: l } = o;
      if (!(!u || !d || !s)) {
        if (this !== o && this.layout && s && bS(this.options.animationType, this.layout.layoutBox, s.layoutBox)) {
          d = this.target || Fr();
          const f = xn(this.layout.layoutBox.x);
          d.x.min = o.target.x.min, d.x.max = d.x.min + f;
          const c = xn(this.layout.layoutBox.y);
          d.y.min = o.target.y.min, d.y.max = d.y.min + c;
        }
        In(u, d), pu(u, l), ml(this.projectionDeltaWithTransform, this.layoutCorrected, u, l);
      }
    }
    registerSharedNode(o, u) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new yue()), this.sharedNodes.get(o).add(u);
      const s = u.options.initialPromotionConfig;
      u.promote({
        transition: s ? s.transition : void 0,
        preserveFollowOpacity: s && s.shouldPreserveFollowOpacity ? s.shouldPreserveFollowOpacity(u) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      var o;
      const { layoutId: u } = this.options;
      return u ? ((o = this.getStack()) === null || o === void 0 ? void 0 : o.lead) || this : this;
    }
    getPrevLead() {
      var o;
      const { layoutId: u } = this.options;
      return u ? (o = this.getStack()) === null || o === void 0 ? void 0 : o.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: u, preserveFollowOpacity: d } = {}) {
      const s = this.getStack();
      s && s.promote(this, d), o && (this.projectionDelta = void 0, this.needsReset = !0), u && this.setOptions({ transition: u });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let u = !1;
      const { latestValues: d } = o;
      if ((d.rotate || d.rotateX || d.rotateY || d.rotateZ) && (u = !0), !u)
        return;
      const s = {};
      for (let l = 0; l < X5.length; l++) {
        const f = "rotate" + X5[l];
        d[f] && (s[f] = d[f], o.setStaticValue(f, 0));
      }
      o.render();
      for (const l in s)
        o.setStaticValue(l, s[l]);
      o.scheduleRender();
    }
    getProjectionStyles(o = {}) {
      var u, d;
      const s = {};
      if (!this.instance || this.isSVG)
        return s;
      if (this.isVisible)
        s.visibility = "";
      else
        return { visibility: "hidden" };
      const l = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, s.opacity = "", s.pointerEvents = A1(o.pointerEvents) || "", s.transform = l ? l(this.latestValues, "") : "none", s;
      const f = this.getLead();
      if (!this.projectionDelta || !this.layout || !f.target) {
        const F = {};
        return this.options.layoutId && (F.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, F.pointerEvents = A1(o.pointerEvents) || ""), this.hasProjected && !Xo(this.latestValues) && (F.transform = l ? l({}, "") : "none", this.hasProjected = !1), F;
      }
      const c = f.animationValues || f.latestValues;
      this.applyTransformsToTarget(), s.transform = Y5(this.projectionDeltaWithTransform, this.treeScale, c), l && (s.transform = l(c, s.transform));
      const { x: h, y: _ } = this.projectionDelta;
      s.transformOrigin = `${h.origin * 100}% ${_.origin * 100}% 0`, f.animationValues ? s.opacity = f === this ? (d = (u = c.opacity) !== null && u !== void 0 ? u : this.latestValues.opacity) !== null && d !== void 0 ? d : 1 : this.preserveOpacity ? this.latestValues.opacity : c.opacityExit : s.opacity = f === this ? c.opacity !== void 0 ? c.opacity : "" : c.opacityExit !== void 0 ? c.opacityExit : 0;
      for (const F in a0) {
        if (c[F] === void 0)
          continue;
        const { correct: v, applyTo: $ } = a0[F], E = s.transform === "none" ? c[F] : v(c[F], f);
        if ($) {
          const D = $.length;
          for (let w = 0; w < D; w++)
            s[$[w]] = E;
        } else
          s[F] = E;
      }
      return this.options.layoutId && (s.pointerEvents = f === this ? A1(o.pointerEvents) || "" : "none"), s;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => {
        var u;
        return (u = o.currentAnimation) === null || u === void 0 ? void 0 : u.stop();
      }), this.root.nodes.forEach(Z5), this.root.sharedNodes.clear();
    }
  };
}
function Due(e) {
  e.updateLayout();
}
function Cue(e) {
  var t;
  const r = ((t = e.resumeFrom) === null || t === void 0 ? void 0 : t.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && r && e.hasListeners("didUpdate")) {
    const { layoutBox: n, measuredBox: a } = e.layout, { animationType: i } = e.options, o = r.source !== e.layout.source;
    i === "size" ? ja((f) => {
      const c = o ? r.measuredBox[f] : r.layoutBox[f], h = xn(c);
      c.min = n[f].min, c.max = c.min + h;
    }) : bS(i, r.layoutBox, n) && ja((f) => {
      const c = o ? r.measuredBox[f] : r.layoutBox[f], h = xn(n[f]);
      c.max = c.min + h, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[f].max = e.relativeTarget[f].min + h);
    });
    const u = mu();
    ml(u, n, r.layoutBox);
    const d = mu();
    o ? ml(d, e.applyTransform(a, !0), r.measuredBox) : ml(d, n, r.layoutBox);
    const s = !FS(u);
    let l = !1;
    if (!e.resumeFrom) {
      const f = e.getClosestProjectingParent();
      if (f && !f.resumeFrom) {
        const { snapshot: c, layout: h } = f;
        if (c && h) {
          const _ = Fr();
          pl(_, r.layoutBox, c.layoutBox);
          const F = Fr();
          pl(F, n, h.layoutBox), Bm(_, F) || (l = !0), f.options.layoutRoot && (e.relativeTarget = F, e.relativeTargetOrigin = _, e.relativeParent = f);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: n,
      snapshot: r,
      delta: d,
      layoutDelta: u,
      hasLayoutChanged: s,
      hasRelativeTargetChanged: l
    });
  } else if (e.isLead()) {
    const { onExitComplete: n } = e.options;
    n && n();
  }
  e.options.transition = void 0;
}
function Sue(e) {
  Qo.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = Boolean(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function Aue(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function Oue(e) {
  e.clearSnapshot();
}
function Z5(e) {
  e.clearMeasurements();
}
function Tue(e) {
  e.isLayoutDirty = !1;
}
function Pue(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function J5(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function Iue(e) {
  e.resolveTargetDelta();
}
function Rue(e) {
  e.calcProjection();
}
function jue(e) {
  e.resetRotation();
}
function Mue(e) {
  e.removeLeadSnapshot();
}
function e8(e, t, r) {
  e.translate = or(t.translate, 0, r), e.scale = or(t.scale, 1, r), e.origin = t.origin, e.originPoint = t.originPoint;
}
function t8(e, t, r, n) {
  e.min = or(t.min, r.min, n), e.max = or(t.max, r.max, n);
}
function Bue(e, t, r, n) {
  t8(e.x, t.x, r.x, n), t8(e.y, t.y, r.y, n);
}
function Nue(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const Lue = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function r8(e) {
  e.min = Math.round(e.min), e.max = Math.round(e.max);
}
function que(e) {
  r8(e.x), r8(e.y);
}
function bS(e, t, r) {
  return e === "position" || e === "preserve-aspect" && !Im(K5(t), K5(r), 0.2);
}
const Uue = yS({
  attachResizeListener: (e, t) => Ei(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), s2 = {
  current: void 0
}, vS = yS({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!s2.current) {
      const e = new Uue({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), s2.current = e;
    }
    return s2.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => Boolean(window.getComputedStyle(e).position === "fixed")
}), Gue = {
  pan: {
    Feature: sue
  },
  drag: {
    Feature: oue,
    ProjectionNode: vS,
    MeasureLayout: _S
  }
}, Wue = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function Vue(e) {
  const t = Wue.exec(e);
  if (!t)
    return [,];
  const [, r, n] = t;
  return [r, n];
}
const Hue = 4;
function Nm(e, t, r = 1) {
  ma(r <= Hue, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [n, a] = Vue(e);
  if (!n)
    return;
  const i = window.getComputedStyle(t).getPropertyValue(n);
  return i ? i.trim() : xm(a) ? Nm(a, t, r + 1) : a;
}
function zue(e, { ...t }, r) {
  const n = e.current;
  if (!(n instanceof Element))
    return { target: t, transitionEnd: r };
  r && (r = { ...r }), e.values.forEach((a) => {
    const i = a.get();
    if (!xm(i))
      return;
    const o = Nm(i, n);
    o && a.set(o);
  });
  for (const a in t) {
    const i = t[a];
    if (!xm(i))
      continue;
    const o = Nm(i, n);
    o && (t[a] = o, r || (r = {}), r[a] === void 0 && (r[a] = i));
  }
  return { target: t, transitionEnd: r };
}
const Kue = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), ES = (e) => Kue.has(e), Yue = (e) => Object.keys(e).some(ES), u1 = (e) => e === Ps || e === ut, n8 = (e, t) => parseFloat(e.split(", ")[t]), a8 = (e, t) => (r, { transform: n }) => {
  if (n === "none" || !n)
    return 0;
  const a = n.match(/^matrix3d\((.+)\)$/);
  if (a)
    return n8(a[1], t);
  {
    const i = n.match(/^matrix\((.+)\)$/);
    return i ? n8(i[1], e) : 0;
  }
}, Xue = /* @__PURE__ */ new Set(["x", "y", "z"]), Que = Mf.filter((e) => !Xue.has(e));
function Zue(e) {
  const t = [];
  return Que.forEach((r) => {
    const n = e.getValue(r);
    n !== void 0 && (t.push([r, n.get()]), n.set(r.startsWith("scale") ? 1 : 0));
  }), t.length && e.render(), t;
}
const i8 = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: r = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(r),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: r = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(r),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: a8(4, 13),
  y: a8(5, 14)
}, Jue = (e, t, r) => {
  const n = t.measureViewportBox(), a = t.current, i = getComputedStyle(a), { display: o } = i, u = {};
  o === "none" && t.setStaticValue("display", e.display || "block"), r.forEach((s) => {
    u[s] = i8[s](n, i);
  }), t.render();
  const d = t.measureViewportBox();
  return r.forEach((s) => {
    const l = t.getValue(s);
    l && l.jump(u[s]), e[s] = i8[s](d, i);
  }), e;
}, ede = (e, t, r = {}, n = {}) => {
  t = { ...t }, n = { ...n };
  const a = Object.keys(t).filter(ES);
  let i = [], o = !1;
  const u = [];
  if (a.forEach((d) => {
    const s = e.getValue(d);
    if (!e.hasValue(d))
      return;
    let l = r[d], f = Hd(l);
    const c = t[d];
    let h;
    if (o0(c)) {
      const _ = c.length, F = c[0] === null ? 1 : 0;
      l = c[F], f = Hd(l);
      for (let v = F; v < _ && c[v] !== null; v++)
        h ? ma(Hd(c[v]) === h, "All keyframes must be of the same type") : (h = Hd(c[v]), ma(h === f || u1(f) && u1(h), "Keyframes must be of the same dimension as the current value"));
    } else
      h = Hd(c);
    if (f !== h)
      if (u1(f) && u1(h)) {
        const _ = s.get();
        typeof _ == "string" && s.set(parseFloat(_)), typeof c == "string" ? t[d] = parseFloat(c) : Array.isArray(c) && h === ut && (t[d] = c.map(parseFloat));
      } else
        f != null && f.transform && (h != null && h.transform) && (l === 0 || c === 0) ? l === 0 ? s.set(h.transform(l)) : t[d] = f.transform(c) : (o || (i = Zue(e), o = !0), u.push(d), n[d] = n[d] !== void 0 ? n[d] : t[d], s.jump(c));
  }), u.length) {
    const d = u.indexOf("height") >= 0 ? window.pageYOffset : null, s = Jue(t, e, u);
    return i.length && i.forEach(([l, f]) => {
      e.getValue(l).set(f);
    }), e.render(), Gh && d !== null && window.scrollTo({ top: d }), { target: s, transitionEnd: n };
  } else
    return { target: t, transitionEnd: n };
};
function tde(e, t, r, n) {
  return Yue(t) ? ede(e, t, r, n) : { target: t, transitionEnd: n };
}
const rde = (e, t, r, n) => {
  const a = zue(e, t, n);
  return t = a.target, n = a.transitionEnd, tde(e, t, r, n);
}, Lm = { current: null }, $S = { current: !1 };
function nde() {
  if ($S.current = !0, !!Gh)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => Lm.current = e.matches;
      e.addListener(t), t();
    } else
      Lm.current = !1;
}
function ade(e, t, r) {
  const { willChange: n } = t;
  for (const a in t) {
    const i = t[a], o = r[a];
    if (fn(i))
      e.addValue(a, i), l0(n) && n.add(a), process.env.NODE_ENV === "development" && XF(i.version === "10.12.16", `Attempting to mix Framer Motion versions ${i.version} with 10.12.16 may not work as expected.`);
    else if (fn(o))
      e.addValue(a, ju(i, { owner: e })), l0(n) && n.remove(a);
    else if (o !== i)
      if (e.hasValue(a)) {
        const u = e.getValue(a);
        !u.hasAnimated && u.set(i);
      } else {
        const u = e.getStaticValue(a);
        e.addValue(a, ju(u !== void 0 ? u : i, { owner: e }));
      }
  }
  for (const a in r)
    t[a] === void 0 && e.removeValue(a);
  return t;
}
const o8 = /* @__PURE__ */ new WeakMap(), wS = Object.keys(jl), ide = wS.length, s8 = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], ode = TF.length;
class sde {
  constructor({ parent: t, props: r, presenceContext: n, reducedMotionConfig: a, visualState: i }, o = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.scheduleRender = () => tr.render(this.render, !1, !0);
    const { latestValues: u, renderState: d } = i;
    this.latestValues = u, this.baseTarget = { ...u }, this.initialValues = r.initial ? { ...u } : {}, this.renderState = d, this.parent = t, this.props = r, this.presenceContext = n, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = a, this.options = o, this.isControllingVariants = Vh(r), this.isVariantNode = uC(r), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = Boolean(t && t.current);
    const { willChange: s, ...l } = this.scrapeMotionValuesFromProps(r, {});
    for (const f in l) {
      const c = l[f];
      u[f] !== void 0 && fn(c) && (c.set(u[f], !1), l0(s) && s.add(f));
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, r) {
    return {};
  }
  mount(t) {
    this.current = t, o8.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((r, n) => this.bindToMotionValue(n, r)), $S.current || nde(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : Lm.current, process.env.NODE_ENV !== "production" && XF(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    o8.delete(this.current), this.projection && this.projection.unmount(), Ti(this.notifyUpdate), Ti(this.render), this.valueSubscriptions.forEach((t) => t()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features)
      this.features[t].unmount();
    this.current = null;
  }
  bindToMotionValue(t, r) {
    const n = Ts.has(t), a = r.on("change", (o) => {
      this.latestValues[t] = o, this.props.onUpdate && tr.update(this.notifyUpdate, !1, !0), n && this.projection && (this.projection.isTransformDirty = !0);
    }), i = r.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(t, () => {
      a(), i();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  loadFeatures({ children: t, ...r }, n, a, i) {
    let o, u;
    if (process.env.NODE_ENV !== "production" && a && n) {
      const d = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      r.ignoreStrict ? Lf(!1, d) : ma(!1, d);
    }
    for (let d = 0; d < ide; d++) {
      const s = wS[d], { isEnabled: l, Feature: f, ProjectionNode: c, MeasureLayout: h } = jl[s];
      c && (o = c), l(r) && (!this.features[s] && f && (this.features[s] = new f(this)), h && (u = h));
    }
    if (!this.projection && o) {
      this.projection = new o(this.latestValues, this.parent && this.parent.projection);
      const { layoutId: d, layout: s, drag: l, dragConstraints: f, layoutScroll: c, layoutRoot: h } = r;
      this.projection.setOptions({
        layoutId: d,
        layout: s,
        alwaysMeasureLayout: Boolean(l) || f && gu(f),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof s == "string" ? s : "both",
        initialPromotionConfig: i,
        layoutScroll: c,
        layoutRoot: h
      });
    }
    return u;
  }
  updateFeatures() {
    for (const t in this.features) {
      const r = this.features[t];
      r.isMounted ? r.update() : (r.mount(), r.isMounted = !0);
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : Fr();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, r) {
    this.latestValues[t] = r;
  }
  /**
   * Make a target animatable by Popmotion. For instance, if we're
   * trying to animate width from 100px to 100vw we need to measure 100vw
   * in pixels to determine what we really need to animate to. This is also
   * pluggable to support Framer's custom value types like Color,
   * and CSS variables.
   */
  makeTargetAnimatable(t, r = !0) {
    return this.makeTargetAnimatableFromInstance(t, this.props, r);
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, r) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = r;
    for (let n = 0; n < s8.length; n++) {
      const a = s8[n];
      this.propEventSubscriptions[a] && (this.propEventSubscriptions[a](), delete this.propEventSubscriptions[a]);
      const i = t["on" + a];
      i && (this.propEventSubscriptions[a] = this.on(a, i));
    }
    this.prevMotionValues = ade(this, this.scrapeMotionValuesFromProps(t, this.prevProps), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(t = !1) {
    if (t)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const n = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (n.initial = this.props.initial), n;
    }
    const r = {};
    for (let n = 0; n < ode; n++) {
      const a = TF[n], i = this.props[a];
      (Rl(i) || i === !1) && (r[a] = i);
    }
    return r;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const r = this.getClosestVariantNode();
    if (r)
      return r.variantChildren && r.variantChildren.add(t), () => r.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, r) {
    r !== this.values.get(t) && (this.removeValue(t), this.bindToMotionValue(t, r)), this.values.set(t, r), this.latestValues[t] = r.get();
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const r = this.valueSubscriptions.get(t);
    r && (r(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, r) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let n = this.values.get(t);
    return n === void 0 && r !== void 0 && (n = ju(r, { owner: this }), this.addValue(t, n)), n;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t) {
    return this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.readValueFromInstance(this.current, t, this.options);
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, r) {
    this.baseTarget[t] = r;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var r;
    const { initial: n } = this.props, a = typeof n == "string" || typeof n == "object" ? (r = qF(this.props, n)) === null || r === void 0 ? void 0 : r[t] : void 0;
    if (n && a !== void 0)
      return a;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !fn(i) ? i : this.initialValues[t] !== void 0 && a === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, r) {
    return this.events[t] || (this.events[t] = new YF()), this.events[t].add(r);
  }
  notify(t, ...r) {
    this.events[t] && this.events[t].notify(...r);
  }
}
class kS extends sde {
  sortInstanceNodePosition(t, r) {
    return t.compareDocumentPosition(r) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, r) {
    return t.style ? t.style[r] : void 0;
  }
  removeValueFromRenderState(t, { vars: r, style: n }) {
    delete r[t], delete n[t];
  }
  makeTargetAnimatableFromInstance({ transition: t, transitionEnd: r, ...n }, { transformValues: a }, i) {
    let o = xse(n, t || {}, this);
    if (a && (r && (r = a(r)), n && (n = a(n)), o && (o = a(o))), i) {
      wse(this, n, o);
      const u = rde(this, n, o, r);
      r = u.transitionEnd, n = u.target;
    }
    return {
      transition: t,
      transitionEnd: r,
      ...n
    };
  }
}
function ude(e) {
  return window.getComputedStyle(e);
}
class dde extends kS {
  readValueFromInstance(t, r) {
    if (Ts.has(r)) {
      const n = VF(r);
      return n && n.default || 0;
    } else {
      const n = ude(t), a = (cC(r) ? n.getPropertyValue(r) : n[r]) || 0;
      return typeof a == "string" ? a.trim() : a;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: r }) {
    return gS(t, r);
  }
  build(t, r, n, a) {
    RF(t, r, n, a.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, r) {
    return LF(t, r);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    fn(t) && (this.childSubscription = t.on("change", (r) => {
      this.current && (this.current.textContent = `${r}`);
    }));
  }
  renderInstance(t, r, n, a) {
    FC(t, r, n, a);
  }
}
class lde extends kS {
  constructor() {
    super(...arguments), this.isSVGTag = !1;
  }
  getBaseTargetFromProps(t, r) {
    return t[r];
  }
  readValueFromInstance(t, r) {
    if (Ts.has(r)) {
      const n = VF(r);
      return n && n.default || 0;
    }
    return r = yC.has(r) ? r : NF(r), t.getAttribute(r);
  }
  measureInstanceViewportBox() {
    return Fr();
  }
  scrapeMotionValuesFromProps(t, r) {
    return vC(t, r);
  }
  build(t, r, n, a) {
    MF(t, r, n, this.isSVGTag, a.transformTemplate);
  }
  renderInstance(t, r, n, a) {
    bC(t, r, n, a);
  }
  mount(t) {
    this.isSVGTag = BF(t.tagName), super.mount(t);
  }
}
const fde = (e, t) => IF(e) ? new lde(t, { enableHardwareAcceleration: !1 }) : new dde(t, { enableHardwareAcceleration: !0 }), cde = {
  layout: {
    ProjectionNode: vS,
    MeasureLayout: _S
  }
}, hde = {
  ...Lse,
  ...doe,
  ...Gue,
  ...cde
}, xS = /* @__PURE__ */ pie((e, t) => Hie(e, t, hde, fde));
function DS() {
  const e = tt(!1);
  return n0(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function gde() {
  const e = DS(), [t, r] = Xe(0), n = ue(() => {
    e.current && r(t + 1);
  }, [t]);
  return [ue(() => tr.postRender(n), [n]), t];
}
class _de extends se.Component {
  getSnapshotBeforeUpdate(t) {
    const r = this.props.childRef.current;
    if (r && t.isPresent && !this.props.isPresent) {
      const n = this.props.sizeRef.current;
      n.height = r.offsetHeight || 0, n.width = r.offsetWidth || 0, n.top = r.offsetTop, n.left = r.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function mde({ children: e, isPresent: t }) {
  const r = p3(), n = tt(null), a = tt({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  return Aw(() => {
    const { width: i, height: o, top: u, left: d } = a.current;
    if (t || !n.current || !i || !o)
      return;
    n.current.dataset.motionPopId = r;
    const s = document.createElement("style");
    return document.head.appendChild(s), s.sheet && s.sheet.insertRule(`
          [data-motion-pop-id="${r}"] {
            position: absolute !important;
            width: ${i}px !important;
            height: ${o}px !important;
            top: ${u}px !important;
            left: ${d}px !important;
          }
        `), () => {
      document.head.removeChild(s);
    };
  }, [t]), se.createElement(_de, { isPresent: t, childRef: n, sizeRef: a }, se.cloneElement(e, { ref: n }));
}
const u2 = ({ children: e, initial: t, isPresent: r, onExitComplete: n, custom: a, presenceAffectsLayout: i, mode: o }) => {
  const u = EC(pde), d = p3(), s = qe(
    () => ({
      id: d,
      initial: t,
      isPresent: r,
      custom: a,
      onExitComplete: (l) => {
        u.set(l, !0);
        for (const f of u.values())
          if (!f)
            return;
        n && n();
      },
      register: (l) => (u.set(l, !1), () => u.delete(l))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    i ? void 0 : [r]
  );
  return qe(() => {
    u.forEach((l, f) => u.set(f, !1));
  }, [r]), se.useEffect(() => {
    !r && !u.size && n && n();
  }, [r]), o === "popLayout" && (e = se.createElement(mde, { isPresent: r }, e)), se.createElement(Uh.Provider, { value: s }, e);
};
function pde() {
  return /* @__PURE__ */ new Map();
}
function Fde(e) {
  return at(() => () => e(), []);
}
const lu = (e) => e.key || "";
function yde(e, t) {
  e.forEach((r) => {
    const n = lu(r);
    t.set(n, r);
  });
}
function bde(e) {
  const t = [];
  return Vn.forEach(e, (r) => {
    $n(r) && t.push(r);
  }), t;
}
const Uf = ({ children: e, custom: t, initial: r = !0, onExitComplete: n, exitBeforeEnter: a, presenceAffectsLayout: i = !0, mode: o = "sync" }) => {
  ma(!a, "Replace exitBeforeEnter with mode='wait'");
  const u = Et(PF).forceRender || gde()[0], d = DS(), s = bde(e);
  let l = s;
  const f = tt(/* @__PURE__ */ new Map()).current, c = tt(l), h = tt(/* @__PURE__ */ new Map()).current, _ = tt(!0);
  if (n0(() => {
    _.current = !1, yde(s, h), c.current = l;
  }), Fde(() => {
    _.current = !0, h.clear(), f.clear();
  }), _.current)
    return se.createElement(se.Fragment, null, l.map((E) => se.createElement(u2, { key: lu(E), isPresent: !0, initial: r ? void 0 : !1, presenceAffectsLayout: i, mode: o }, E)));
  l = [...l];
  const F = c.current.map(lu), v = s.map(lu), $ = F.length;
  for (let E = 0; E < $; E++) {
    const D = F[E];
    v.indexOf(D) === -1 && !f.has(D) && f.set(D, void 0);
  }
  return o === "wait" && f.size && (l = []), f.forEach((E, D) => {
    if (v.indexOf(D) !== -1)
      return;
    const w = h.get(D);
    if (!w)
      return;
    const k = F.indexOf(D);
    let A = E;
    if (!A) {
      const P = () => {
        h.delete(D), f.delete(D);
        const S = c.current.findIndex((N) => N.key === D);
        if (c.current.splice(S, 1), !f.size) {
          if (c.current = s, d.current === !1)
            return;
          u(), n && n();
        }
      };
      A = se.createElement(u2, { key: lu(w), isPresent: !1, onExitComplete: P, custom: t, presenceAffectsLayout: i, mode: o }, w), f.set(D, A);
    }
    l.splice(k, 0, A);
  }), l = l.map((E) => {
    const D = E.key;
    return f.has(D) ? E : se.createElement(u2, { key: lu(E), isPresent: !0, presenceAffectsLayout: i, mode: o }, E);
  }), process.env.NODE_ENV !== "production" && o === "wait" && l.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`), se.createElement(se.Fragment, null, f.size ? l : l.map((E) => gr(E)));
};
function vde({
  children: e,
  footer: t,
  title: r,
  subtitle: n,
  fluid: a,
  disabled: i,
  disabledText: o,
  titleSide: u,
  ...d
}) {
  return /* @__PURE__ */ ne(
    ot,
    {
      borderRadius: "sm",
      maxWidth: 1372,
      border: "1px solid",
      borderColor: "neutral-200",
      backgroundColor: "white",
      ...i && { cursor: "not-allowed" },
      ...d,
      children: [
        /* @__PURE__ */ ne(AF, { w: "100%", rowGap: "m", columnGap: { _: "m", md: "l" }, p: "m", children: [
          r && /* @__PURE__ */ b(go, { xs: 12, gridRow: 1, children: /* @__PURE__ */ ne(Dt, { alignItems: "center", space: "xs", children: [
            /* @__PURE__ */ ne(
              $e,
              {
                variant: "headingBoldS",
                "data-test": "paper-title",
                mb: n ? "-8px" : 0,
                display: "flex",
                color: i ? "neutral-300" : "neutral-1000",
                children: [
                  r,
                  i && o ? /* @__PURE__ */ ne(Ae, { alignItems: "center", ml: 34, children: [
                    /* @__PURE__ */ b(aM, { color: "neutral-400", size: 16 }),
                    /* @__PURE__ */ b(
                      $e,
                      {
                        fontSize: 14,
                        ml: 10,
                        color: "neutral-400",
                        fontWeight: 500,
                        children: o
                      }
                    )
                  ] }) : null
                ]
              }
            ),
            u && /* @__PURE__ */ b(ot, { children: u })
          ] }) }),
          n && /* @__PURE__ */ b(go, { xs: 12, lg: 8, gridRow: 2, children: /* @__PURE__ */ b(
            $e,
            {
              variant: "bodyMediumS",
              "data-test": "paper-subtitle",
              color: i ? "secondary-100" : "neutral-1000",
              children: n
            }
          ) }),
          /* @__PURE__ */ b(go, { xs: 12, lg: a ? 12 : 8, children: e })
        ] }),
        t
      ]
    }
  );
}
function CS(e) {
  return /* @__PURE__ */ b(
    sr,
    {
      "data-test": "loader",
      spin: !0,
      component: iM,
      ...e
    }
  );
}
function dd({
  "data-test": e = "loading",
  size: t = 40,
  color: r = "primary-500",
  ...n
}) {
  return /* @__PURE__ */ b(
    Ae,
    {
      "data-test": e,
      w: "100%",
      h: "100%",
      alignItems: "center",
      justifyContent: "center",
      ...n,
      children: /* @__PURE__ */ b(CS, { color: r, size: t })
    }
  );
}
const ga = {
  UNSAVED: "unsaved",
  SAVING: "saving",
  SAVED: "saved"
}, Ede = Ge(nr)`
  transition: 0.5s all ease-in-out;
`;
function Nl({
  mode: e = "fill",
  status: t,
  unsavedText: r = "Save changes",
  savedText: n = "Saved",
  "data-test": a = "save-button",
  ...i
}) {
  const o = qe(
    () => ({
      unsaved: r,
      saving: /* @__PURE__ */ b(
        dd,
        {
          "data-test": `${a}-saving-icon`,
          size: 24,
          color: e === "fill" ? "neutral-0" : "primary-500"
        }
      ),
      saved: n
    }),
    [r, a, e, n]
  ), u = qe(() => e === "fill" ? t === ga.SAVED ? "outline" : "fill" : e, [e, t]);
  return /* @__PURE__ */ ne(
    Ede,
    {
      "data-test": a,
      mode: u,
      readOnly: t !== ga.UNSAVED,
      ...i,
      children: [
        t === ga.SAVED && /* @__PURE__ */ b(lh, {}),
        o[t]
      ]
    }
  );
}
const SS = dr({
  containerElement: null
});
function ROe({
  portalContainerRef: e,
  children: t
}) {
  const [r, n] = Xe(null), a = qe(
    () => ({ containerElement: r }),
    [r]
  );
  return at(() => {
    n(e.current);
  }, [e]), /* @__PURE__ */ b(SS.Provider, { value: a, children: t });
}
const AS = () => {
  const e = Et(tA);
  return e || (console.error(
    "useNavigationBlocker must be used within a <NavigationBlockerProvider>"
  ), {});
};
function OS(e = !0) {
  const { setBlockedTransition: t } = AS(), r = Et(
    XM
  );
  at(() => {
    var a, i;
    if (!e || !t)
      return kn;
    const n = (i = (a = r.navigator).block) == null ? void 0 : i.call(a, (o) => {
      const u = {
        ...o,
        retry() {
          n(), o.retry();
        }
      };
      t(u);
    });
    return n;
  }, [e, r, t]);
}
const $de = 4e3;
function wde(e) {
  Ww.showToast({
    ...e,
    message: e.message,
    dismissIn: e.dismissIn ?? $de,
    variant: e.variant ?? "info",
    icon: e.icon ?? !0
  });
}
function QF() {
  return qe(
    () => ({
      remove: Ww.removeToast,
      show: wde
    }),
    []
  );
}
function jOe(e, t) {
  const r = Rf(), n = QF(), [a, i] = Xe(!0), [o, u] = Xe(), [d, s] = Xe(null), l = tt(), f = ue(() => {
    l.current && (l.current.unsubscribe(), l.current = void 0, i(!1));
  }, []), c = ue(() => {
    const _ = r.watchQuery({
      query: e,
      ...t
    }).subscribe({
      next(F) {
        f(), s(null), u(F.data);
      },
      error(F) {
        i(!1), f();
        const v = Es(F);
        s(v), u(void 0), t != null && t.showErrorToast && n.show({
          variant: "critical",
          message: t.showErrorToast(v.errorI18nKey)
        });
      }
    });
    l.current = _;
  }, [f, r, t, e, n]);
  return at(
    () => () => {
      f();
    },
    [f]
  ), {
    loading: a,
    data: o,
    error: d,
    lazyQuery: c,
    cancel: f
  };
}
const kde = (...e) => ue(
  (t) => e.forEach((r) => {
    if (r) {
      if (typeof r == "function") {
        r(t);
        return;
      }
      r.current = t;
    }
  }),
  [e]
), xde = Ge(ot)`
  grid-area: header;
`, Dde = Ge(nr)`
  position: absolute;
  right: ${vt("s")};
`;
function Cde({
  "data-test": e = "form-wizard-header-title",
  children: t,
  className: r
}) {
  return /* @__PURE__ */ b(
    $e,
    {
      "data-test": e,
      variant: "headingBoldS",
      className: r,
      children: t
    }
  );
}
function Sde({
  "data-test": e = "form-wizard-header-close",
  onClick: t,
  children: r,
  className: n
}) {
  const { onClose: a } = ld();
  return /* @__PURE__ */ ne(
    Dde,
    {
      "data-test": e,
      variant: "secondary",
      mode: "ghost",
      onClick: t || a,
      className: n,
      children: [
        r,
        /* @__PURE__ */ b(oM, {})
      ]
    }
  );
}
function Ade({
  "data-test": e = "form-wizard-header",
  children: t,
  className: r
}) {
  return /* @__PURE__ */ ne(xde, { "data-test": e, h: "72px", bg: "white", className: r, children: [
    /* @__PURE__ */ b(
      Ae,
      {
        backgroundColor: "white",
        h: "100%",
        alignItems: "center",
        justifyContent: "center",
        children: t
      }
    ),
    /* @__PURE__ */ b(
      Vw,
      {
        orientation: "horizontal",
        size: "xSmall",
        backgroundColor: "neutral-200"
      }
    )
  ] });
}
const Ode = Ge(Ae)`
  position: relative;
  flex-direction: column;
  margin: ${vt("xl")} 0 50vh;
  background: white;
  width: 700px;
  border-radius: ${Ba("sm")};
`;
function Tde({
  children: e,
  "data-test": t = "form-wizard-page",
  loading: r = !1,
  className: n
}) {
  return r ? /* @__PURE__ */ b(dd, { "data-test": `${t}-loading` }) : /* @__PURE__ */ b(Ode, { "data-test": t, className: n, children: e });
}
function Pde({
  "data-test": e = "form-wizard-page-content",
  children: t,
  className: r
}) {
  return /* @__PURE__ */ b(Ae, { "data-test": e, padding: "xl", className: r, children: t });
}
function Ide({
  "data-test": e = "form-wizard-page-footer",
  children: t,
  className: r
}) {
  return /* @__PURE__ */ ne(Ae, { "data-test": e, flexDirection: "column", className: r, children: [
    /* @__PURE__ */ b(
      Vw,
      {
        orientation: "horizontal",
        size: "xSmall",
        backgroundColor: "neutral-200"
      }
    ),
    /* @__PURE__ */ b(Ae, { gap: "s", p: "s", px: "xl", justifyContent: "flex-end", children: t })
  ] });
}
function TS({
  children: e,
  loading: t = !1,
  loadingText: r = "Loading",
  "data-test": n = "loading-button",
  disabled: a = !1,
  ...i
}) {
  return /* @__PURE__ */ b(
    nr,
    {
      "data-test": n,
      ...i,
      disabled: a || t,
      children: t ? /* @__PURE__ */ ne(Nr, { children: [
        /* @__PURE__ */ b(CS, { "data-test": `${n}-loader`, size: 24 }),
        r
      ] }) : e
    }
  );
}
function Rde({
  "data-test": e = "form-wizard-page-footer-next",
  children: t,
  onClick: r,
  loading: n = !1,
  ...a
}) {
  return /* @__PURE__ */ b(
    TS,
    {
      "data-test": e,
      variant: "primary",
      mode: "fill",
      onClick: r,
      loading: n,
      ...a,
      children: t
    }
  );
}
function jde({
  children: e,
  onClick: t,
  "data-test": r = "form-wizard-page-footer-prev",
  className: n,
  ...a
}) {
  return /* @__PURE__ */ b(
    nr,
    {
      "data-test": r,
      variant: "secondary",
      mode: "ghost",
      onClick: t,
      className: n,
      ...a,
      children: e
    }
  );
}
function Mde({
  children: e,
  className: t
}) {
  return /* @__PURE__ */ b(
    $e,
    {
      variant: "bodyRegularS",
      color: "neutral-400",
      className: t,
      children: e
    }
  );
}
function Bde({
  children: e,
  className: t
}) {
  return /* @__PURE__ */ b($e, { variant: "headingBoldM", className: t, children: e });
}
function Nde({
  "data-test": e = "form-wizard-page-header",
  children: t,
  className: r
}) {
  return /* @__PURE__ */ b(
    ur,
    {
      padding: "xl",
      pb: "0",
      "data-test": e,
      flexDirection: "column",
      gap: "xxs",
      className: r,
      children: t
    }
  );
}
function Lde() {
  const e = tt(null), { setSideRef: t, hasSide: r } = ld();
  return at(() => {
    t(e);
  }, [e, t]), /* @__PURE__ */ b(ot, { ref: e, display: r ? "block" : "none" });
}
const d2 = Ge(Ae)`
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: white;
  border-radius: ${Ba("sm")};
  flex-shrink: 0;
`;
function qde({ marginRight: e }) {
  return /* @__PURE__ */ ne(Ae, { flexDirection: "column", gap: "3px", marginRight: e, children: [
    /* @__PURE__ */ b(Ae, { backgroundColor: "neutral-500", w: "1px", h: "3px", borderRadius: "1px" }),
    /* @__PURE__ */ b(Ae, { backgroundColor: "neutral-500", w: "1px", h: "5px", borderRadius: "1px" }),
    /* @__PURE__ */ b(Ae, { backgroundColor: "neutral-500", w: "1px", h: "5px", borderRadius: "1px" }),
    /* @__PURE__ */ b(Ae, { backgroundColor: "neutral-500", w: "1px", h: "3px", borderRadius: "1px" })
  ] });
}
function Ude() {
  const { pageIndex: e, hasStepper: t, stepTitles: r } = ld();
  if (!t)
    return null;
  const n = r.map((a, i) => {
    const o = i === e, u = i < e, d = i > e;
    return /* @__PURE__ */ ne(M.Fragment, { children: [
      i > 0 && /* @__PURE__ */ b(qde, { marginRight: "11px" }),
      /* @__PURE__ */ ne(Ae, { alignItems: "center", justifyContent: "center", gap: "xxs", children: [
        u && /* @__PURE__ */ ne(Nr, { children: [
          /* @__PURE__ */ b(
            $e,
            {
              variant: "bodyRegularS",
              color: "primary-500",
              textAlign: "right",
              children: a
            }
          ),
          /* @__PURE__ */ b(
            d2,
            {
              backgroundColor: "white",
              border: "1px solid",
              borderColor: "primary-500",
              children: /* @__PURE__ */ b(lh, { color: "primary-500", size: "18px" })
            }
          )
        ] }),
        o && /* @__PURE__ */ ne(Nr, { children: [
          /* @__PURE__ */ b($e, { variant: "bodyMediumS", textAlign: "right", children: a }),
          /* @__PURE__ */ b(
            d2,
            {
              backgroundColor: "primary-500",
              border: "1px solid",
              borderColor: "primary-500",
              children: /* @__PURE__ */ b($e, { variant: "bodyRegularS", color: "white", children: i + 1 })
            }
          )
        ] }),
        d && /* @__PURE__ */ ne(Nr, { children: [
          /* @__PURE__ */ b(
            $e,
            {
              variant: "bodyRegularS",
              color: "neutral-400",
              textAlign: "right",
              children: a
            }
          ),
          /* @__PURE__ */ b(
            d2,
            {
              backgroundColor: "white",
              border: "1px solid",
              borderColor: "neutral-400",
              children: /* @__PURE__ */ b($e, { variant: "bodyRegularS", color: "neutral-400", children: i + 1 })
            }
          )
        ] })
      ] })
    ] }, a);
  });
  return /* @__PURE__ */ b(
    Ae,
    {
      w: "200px",
      marginTop: "xl",
      flexDirection: "column",
      alignItems: "flex-end",
      userSelect: "none",
      children: n
    }
  );
}
const Gde = Nk`
  body {
    overflow: hidden;
  }
`, Wde = Ge(Ae)`
  align-items: flex-start;
  justify-content: center;
  grid-area: page;
  overflow: auto;
  gap: ${vt("m")};
`;
function Vde({
  "data-test": e = "form-wizard-page",
  children: t,
  className: r
}) {
  const { pageIndex: n, setNumberOfPages: a, setStepTitles: i } = ld(), o = Vn.count(t), u = Vn.toArray(t), d = qe(() => {
    const l = Vn.map(t, (f) => !f || !$n(f) ? null : f.props.stepTitle);
    return l ? l.filter(zD) : [];
  }, [t]);
  at(() => {
    i(d);
  }, [i, d]), at(() => {
    a(o);
  }, [o, a]);
  const s = u[n];
  return /* @__PURE__ */ ne(Wde, { "data-test": e, className: r, children: [
    /* @__PURE__ */ b(Gde, {}),
    /* @__PURE__ */ b(Ude, {}),
    s,
    /* @__PURE__ */ b(Lde, {})
  ] });
}
function Hde({
  children: e,
  className: t
}) {
  return /* @__PURE__ */ b(
    $e,
    {
      variant: "bodyRegularS",
      color: "neutral-400",
      position: "absolute",
      bottom: "-30px",
      className: t,
      children: e
    }
  );
}
function zde({
  children: e
}) {
  const { sideRef: t, setHasSide: r } = ld();
  return at(() => {
    r(!0);
  }, [r]), t != null && t.current ? I3(e, t.current) : null;
}
function Kde() {
  const { setHasStepper: e } = ld();
  return at(() => (e(!0), () => e(!1)), [e]), null;
}
const PS = dr(void 0), Yde = Ge(Ae)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  display: grid;
  background: ${He("neutral-100")};
  grid-template-areas:
    "header"
    "page";
  grid-template-rows: auto 1fr;
`;
function rn({
  children: e,
  onSuccess: t = kn,
  onClose: r = kn,
  onCancel: n = kn,
  "data-test": a = "form-wizard",
  initialData: i = {},
  currentPageIndex: o = 0,
  className: u
}) {
  const [d, s] = Xe(o), [l, f] = Xe(i), [c, h] = Xe(0), [_, F] = Xe(!1), [v, $] = Xe(!1), [E, D] = Xe([]), [w, k] = Xe(!1), [A, P] = Xe(null);
  at(() => {
    s(o);
  }, [o]);
  const S = ue(() => {
    if (d === c - 1) {
      t(l);
      return;
    }
    s((V) => V + 1);
  }, [l, c, t, d]), N = ue((V) => {
    f((K) => ({ ...K, ...V }));
  }, []), W = qe(
    () => ({
      data: l,
      pageIndex: d,
      numberOfPages: c,
      setNumberOfPages: h,
      hasStepper: v,
      setHasStepper: $,
      sideRef: A,
      setSideRef: P,
      hasSide: w,
      setHasSide: k,
      stepTitles: E,
      setStepTitles: D,
      setData: f,
      editData: N,
      navigateToNextPage: S,
      navigateToPrevPage: () => {
        s((V) => V >= 1 ? V - 1 : 0);
      },
      onCancel: n,
      onClose: r,
      setPageIndex: s,
      nextDisabled: _,
      setNextDisabled: F
    }),
    [
      l,
      d,
      c,
      v,
      A,
      w,
      E,
      N,
      S,
      n,
      r,
      _
    ]
  );
  return /* @__PURE__ */ b(PS.Provider, { value: W, children: /* @__PURE__ */ b(Yde, { "data-test": a, className: u, children: e }) });
}
rn.Stepper = Kde;
rn.Header = Ade;
rn.HeaderTitle = Cde;
rn.HeaderClose = Sde;
rn.Pages = Vde;
rn.Page = Tde;
rn.PageContent = Pde;
rn.PageFooter = Ide;
rn.PageFooterPrev = jde;
rn.PageFooterNext = Rde;
rn.PageHeader = Nde;
rn.PageHeaderTitle = Bde;
rn.PageHeaderSubtitle = Mde;
rn.PageSubText = Hde;
rn.Side = zde;
function ld() {
  const e = Et(PS);
  if (!e)
    throw new Error(
      "useFormWizard should be used within a FormWizard provider"
    );
  return e;
}
const MOe = (e, t) => {
  const [r, { error: n, ...a }] = hK(
    e,
    t
  );
  return [
    ue(
      async (o) => {
        try {
          const { data: u, error: d } = await r(o);
          if (!u)
            throw new sd({ graphQLErrors: [] });
          return { data: u, error: void 0 };
        } catch (u) {
          return {
            data: void 0,
            error: Es(u).errorI18nKey
          };
        }
      },
      [r]
    ),
    {
      ...a,
      error: n ? Es(n) : void 0
    }
  ];
}, BOe = (e, t) => {
  const r = QF(), [n, a] = gK(e, t), i = ue(
    async (u, d = {}) => {
      const { successMessage: s, getErrorMessage: l } = d;
      try {
        const { data: f } = await n(u);
        if (!f)
          throw new sd({ graphQLErrors: [] });
        return s != null && s.length && r.show({
          variant: "success",
          message: s
        }), {
          data: f,
          error: void 0,
          validationErrors: void 0,
          clientError: void 0,
          apolloError: void 0
        };
      } catch (f) {
        const c = f, h = Es(c), _ = h, F = l ?? (t == null ? void 0 : t.showErrorToast) ?? (t == null ? void 0 : t.getErrorMessage);
        return F && r.show({
          variant: "critical",
          message: F(h.errorI18nKey)
        }), {
          data: void 0,
          error: h.errorI18nKey,
          validationErrors: _.validationErrorsI18nKeys,
          clientError: h,
          apolloError: c
        };
      }
    },
    [n, t, r]
  );
  at(() => {
    a.error && console.error(a.error);
  }, [a.error]);
  const o = a.error ? Es(a.error) : void 0;
  return [
    i,
    {
      ...a,
      clientError: o
    }
  ];
};
function ZF(e, t) {
  const r = QF(), { throwError: n = !0 } = t ?? {}, { error: a, data: i, previousData: o, ...u } = lK(e, t);
  let d;
  if (a && (d = Es(a), n))
    throw d.type === Qr.NOT_FOUND ? new vF("Could not find resource", {
      options: t,
      apolloError: a
    }) : new EF("An unknown error has ocurred", {
      options: t,
      apolloError: a
    });
  return at(() => {
    d && (t != null && t.showErrorToast) && r.show({
      variant: "critical",
      message: t.showErrorToast(d.errorI18nKey)
    });
  }, [a, r, t == null ? void 0 : t.showErrorToast, t, d]), {
    error: d,
    data: i,
    previousData: o,
    staleData: i ?? o,
    ...u
  };
}
function Xde(e, t, r) {
  const n = tt(null), a = tt(null), i = ue(() => {
    a.current && clearTimeout(a.current);
  }, []), o = ue(
    (...u) => {
      i();
      const d = new Date(), s = n.current ? d.getTime() - n.current.getTime() : t;
      s >= t ? (e(...u), n.current = d) : a.current = window.setTimeout(() => {
        e(...u), n.current = new Date();
      }, t - s);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...r, e, t, i]
  );
  return at(() => () => i(), [i]), [o, i];
}
function Qde({
  containerRef: e,
  threshold: t,
  onLoad: r,
  skip: n
}) {
  var d;
  const a = tt(((d = e == null ? void 0 : e.current) == null ? void 0 : d.scrollTop) || 0), [i, o] = Xe(!1), [u] = Xde(
    () => {
      const s = e == null ? void 0 : e.current;
      if (!s)
        return;
      const f = s.scrollHeight - s.clientHeight - s.scrollTop - t <= 0;
      s.scrollTop > a.current && f && !n ? (o(!0), r()) : o(!1), a.current = s.scrollTop;
    },
    500,
    [e, t, n, r]
  );
  return td(() => {
    const s = e == null ? void 0 : e.current;
    return s == null || s.addEventListener("scroll", u), () => {
      s == null || s.removeEventListener("scroll", u);
    };
  }), { scrollAtBottom: i };
}
function NOe({
  query: e,
  queryOptions: t,
  paginationOptions: r
}) {
  const {
    checkHasMore: n,
    onFetchMore: a,
    containerRef: i,
    threshold: o = 1500
  } = r, u = qe(
    () => t.variables,
    // We use JSON.stringify to deep compare the variables
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(t.variables)]
  );
  if (!u)
    throw new Error("You must provide variables to useGraphQueryPaginated");
  const [d, s] = Xe(!1), { loading: l, fetchMore: f, data: c, ...h } = ZF(e, {
    ...t,
    notifyOnNetworkStatusChange: !0,
    variables: u
  }), _ = tt(u), F = c ? n(c, _.current) : !1;
  at(() => {
    u && (_.current = u);
  }, [u]);
  const v = ue(async () => {
    if (!F || !c)
      return;
    s(!0);
    const E = a(c, _.current);
    _.current = {
      ...u,
      ...E
    }, await f({
      variables: E
    }), s(!1);
  }, [c, f, F, a, u]), { scrollAtBottom: $ } = Qde({
    containerRef: i,
    threshold: o,
    skip: l,
    onLoad: v
  });
  return {
    data: c,
    loading: l,
    loadMore: v,
    hasMore: F,
    loadingMore: d,
    scrollAtBottom: $,
    ...h
  };
}
const IS = dr(void 0);
function RS({ name: e, children: t }) {
  return /* @__PURE__ */ b(IS.Provider, { value: e, children: t });
}
function Zde(e = {}) {
  const t = Af();
  return Et(IS) || Hne(t.pathname, e);
}
function qm(e) {
  this.message = e;
}
qm.prototype = new Error(), qm.prototype.name = "InvalidCharacterError";
var u8 = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1)
    throw new qm("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var r, n, a = 0, i = 0, o = ""; n = t.charAt(i++); ~n && (r = a % 4 ? 64 * r + n : n, a++ % 4) ? o += String.fromCharCode(255 & r >> (-2 * a & 6)) : 0)
    n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(n);
  return o;
};
function Jde(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(r) {
      return decodeURIComponent(u8(r).replace(/(.)/g, function(n, a) {
        var i = a.charCodeAt(0).toString(16).toUpperCase();
        return i.length < 2 && (i = "0" + i), "%" + i;
      }));
    }(t);
  } catch {
    return u8(t);
  }
}
function c0(e) {
  this.message = e;
}
function ele(e, t) {
  if (typeof e != "string")
    throw new c0("Invalid token specified");
  var r = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(Jde(e.split(".")[r]));
  } catch (n) {
    throw new c0("Invalid token specified: " + n.message);
  }
}
c0.prototype = new Error(), c0.prototype.name = "InvalidTokenError";
function tle(e) {
  const t = e.toLowerCase().charAt(0);
  return !t || !Object.values(jh).includes(t) ? null : t;
}
function rle(e) {
  const t = "custom:permissions", r = e[t] || "{}";
  let n = {};
  try {
    const a = JSON.parse(r);
    n = Object.entries(a).reduce((i, [o, u]) => {
      const d = u.map(tle).filter(zD);
      return { ...i, [o]: d };
    }, {});
  } catch {
  }
  return {
    ...e,
    [t]: n
  };
}
const jS = dr(
  {}
);
function nle(e) {
  const t = ele(e);
  return rle(t);
}
function LOe({
  children: e,
  token: t
}) {
  const r = qe(() => {
    const n = nle(t), { "custom:permissions": a } = n, i = [
      Fn.NUMBERS,
      Fn.TEAMS,
      Fn.USERS,
      Fn.STATS,
      Fn.ACTIVITY_FEED,
      Fn.CALL_SETTINGS,
      Fn.INTEGRATIONS,
      Fn.COMPANY_GENERAL,
      Fn.COMPANY_PLAN,
      Fn.COMPANY_BILLING,
      Fn.COMPANY_SECURITY,
      Fn.COMPANY_ROLES
    ], o = Object.keys(a).some(
      (u) => i.includes(u)
    );
    return {
      permissions: a,
      // The user has access to the dashboard if he has any of the dashboard permissions
      hasDashboardAccess: o,
      token: t
    };
  }, [t]);
  return /* @__PURE__ */ b(jS.Provider, { value: r, children: typeof e == "function" ? e(r) : e });
}
function JF() {
  const e = Et(jS), t = Zde(), r = ue(
    (n, a) => {
      const i = a || t;
      if (!i)
        throw new Error("No resource found.");
      const o = e.permissions[i];
      return o ? o.includes(n) : !1;
    },
    [e.permissions, t]
  );
  return {
    ...e,
    resource: t,
    checkAccess: r
  };
}
function qOe(e, t) {
  const { checkAccess: r } = JF();
  return e.map(
    (n) => r(n, t)
  );
}
function UOe(e) {
  const t = Rf();
  return ue(
    async (n) => {
      try {
        return { result: await t.query({
          ...e,
          variables: n
        }), error: void 0 };
      } catch (a) {
        return { result: void 0, error: Es(a).errorI18nKey };
      }
    },
    [t, e]
  );
}
function ale({
  targetRef: e,
  root: t,
  margin: r = 100,
  onIntersect: n
}) {
  const [a, i] = Xe(!1);
  return at(() => {
    if (!e.current)
      return Hw;
    function o(d) {
      d.some((l) => l.isIntersecting) && (n == null || n(), i(!0));
    }
    const u = new IntersectionObserver(o, {
      root: t,
      rootMargin: `${r}px`
    });
    return u.observe(e.current), () => {
      u.disconnect();
    };
  }, [n, t, r, e]), a;
}
const d8 = "#ffffff", ile = "#000000";
function l8(e, t, r) {
  const n = [e, t, r].map((u) => {
    const d = u / 255;
    return d <= 0.03928 ? d / 12.92 : ((d + 0.055) / 1.055) ** 2.4;
  }), [a, i, o] = n;
  return a * 0.2126 + i * 0.7152 + o * 0.0722;
}
const ole = [0, 179, 136], sle = "#00b388";
function ule({
  color: e,
  threshold: t
}) {
  const r = qe(() => L1(e), [e]), n = qe(
    () => r ?? ole,
    [r]
  ), a = qe(() => L1(d8), []), i = qe(
    () => l8(n[0], n[1], n[2]),
    [n]
  ), o = qe(
    () => l8(a[0], a[1], a[2]),
    [a]
  );
  return {
    textColor: qe(
      () => i > o ? (o + 0.05) / (i + 0.05) : (i + 0.05) / (o + 0.05),
      [i, o]
    ) < t ? d8 : ile,
    bgColor: r ? e : sle
  };
}
function GOe({
  query: e,
  queryOptions: t,
  getTotal: r
}) {
  const n = qe(
    () => ({
      from: 0,
      limit: 50,
      ...t == null ? void 0 : t.variables
    }),
    [t == null ? void 0 : t.variables]
  ), a = {
    ...t,
    notifyOnNetworkStatusChange: !0,
    variables: n
  }, i = tt(n.from), { loading: o, fetchMore: u, data: d, ...s } = ZF(e, a), l = r(d), f = i.current + n.limit < l, c = ue(async () => {
    if (!f)
      return;
    const h = i.current + n.limit;
    await u({
      variables: { ...n, from: h }
    }), i.current = h;
  }, [u, f, n]);
  return at(() => {
    i.current = 0;
  }, [n.filter]), {
    data: d,
    loading: o,
    loadMore: c,
    hasMore: f,
    ...s
  };
}
function dle(e, t, r) {
  const n = tt(t), a = tt(r);
  return qe(() => {
    let i = e;
    return {
      get current() {
        return a.current === void 0 ? i : a.current(i);
      },
      set current(o) {
        i = n.current === void 0 ? o : n.current(o);
      }
    };
  }, []);
}
function WOe() {
  const [e, t] = Xe(null), r = dle(null, (o) => (t(o), o)), [n, a] = Xe({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  }), i = qe(
    () => new window.ResizeObserver(([o]) => {
      if (o) {
        const { x: u, y: d, width: s, height: l, top: f, left: c, bottom: h, right: _ } = o.contentRect;
        a({ x: u, y: d, width: s, height: l, top: f, left: c, bottom: h, right: _ });
      }
    }),
    []
  );
  return td(() => {
    if (e)
      return i.observe(e), () => {
        i.disconnect();
      };
  }, [e, i]), [r, n];
}
const lle = (e) => (t, r, n = {}) => e(_D(t, r), n);
function VOe() {
  const e = tk();
  return qe(() => lle(e), [e]);
}
function Um(e) {
  const t = tt(), [r, n] = Xe(e), a = ue(
    (i, o, u) => {
      n(i), o !== void 0 && u !== void 0 && (t.current = window.setTimeout(() => {
        n(u);
      }, o));
    },
    []
  );
  return at(() => () => clearTimeout(t.current), []), [r, a];
}
function HOe(e = !1) {
  const [t, r] = Xe(e), n = ue(() => r((o) => !o), []), a = ue(() => r(!0), []), i = ue(() => r(!1), []);
  return [t, n, a, i];
}
var Ll = {}, fle = {
  get exports() {
    return Ll;
  },
  set exports(e) {
    Ll = e;
  }
};
(function(e, t) {
  (function(r, n) {
    n(t);
  })(un, function(r) {
    function n(p, g) {
      var m = Object.keys(p);
      if (Object.getOwnPropertySymbols) {
        var y = Object.getOwnPropertySymbols(p);
        g && (y = y.filter(function(O) {
          return Object.getOwnPropertyDescriptor(p, O).enumerable;
        })), m.push.apply(m, y);
      }
      return m;
    }
    function a(p) {
      for (var g = 1; g < arguments.length; g++) {
        var m = arguments[g] != null ? arguments[g] : {};
        g % 2 ? n(Object(m), !0).forEach(function(y) {
          s(p, y, m[y]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(p, Object.getOwnPropertyDescriptors(m)) : n(Object(m)).forEach(function(y) {
          Object.defineProperty(p, y, Object.getOwnPropertyDescriptor(m, y));
        });
      }
      return p;
    }
    function i(p) {
      return i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(g) {
        return typeof g;
      } : function(g) {
        return g && typeof Symbol == "function" && g.constructor === Symbol && g !== Symbol.prototype ? "symbol" : typeof g;
      }, i(p);
    }
    function o(p, g) {
      if (!(p instanceof g))
        throw new TypeError("Cannot call a class as a function");
    }
    function u(p, g) {
      for (var m = 0; m < g.length; m++) {
        var y = g[m];
        y.enumerable = y.enumerable || !1, y.configurable = !0, "value" in y && (y.writable = !0), Object.defineProperty(p, _(y.key), y);
      }
    }
    function d(p, g, m) {
      return g && u(p.prototype, g), m && u(p, m), Object.defineProperty(p, "prototype", { writable: !1 }), p;
    }
    function s(p, g, m) {
      return (g = _(g)) in p ? Object.defineProperty(p, g, { value: m, enumerable: !0, configurable: !0, writable: !0 }) : p[g] = m, p;
    }
    function l() {
      return l = Object.assign ? Object.assign.bind() : function(p) {
        for (var g = 1; g < arguments.length; g++) {
          var m = arguments[g];
          for (var y in m)
            Object.prototype.hasOwnProperty.call(m, y) && (p[y] = m[y]);
        }
        return p;
      }, l.apply(this, arguments);
    }
    function f(p) {
      return function(g) {
        if (Array.isArray(g))
          return h(g);
      }(p) || function(g) {
        if (typeof Symbol < "u" && g[Symbol.iterator] != null || g["@@iterator"] != null)
          return Array.from(g);
      }(p) || c(p) || function() {
        throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }();
    }
    function c(p, g) {
      if (p) {
        if (typeof p == "string")
          return h(p, g);
        var m = Object.prototype.toString.call(p).slice(8, -1);
        return m === "Object" && p.constructor && (m = p.constructor.name), m === "Map" || m === "Set" ? Array.from(p) : m === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(m) ? h(p, g) : void 0;
      }
    }
    function h(p, g) {
      (g == null || g > p.length) && (g = p.length);
      for (var m = 0, y = new Array(g); m < g; m++)
        y[m] = p[m];
      return y;
    }
    function _(p) {
      var g = function(m, y) {
        if (typeof m != "object" || m === null)
          return m;
        var O = m[Symbol.toPrimitive];
        if (O !== void 0) {
          var C = O.call(m, y || "default");
          if (typeof C != "object")
            return C;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (y === "string" ? String : Number)(m);
      }(p, "string");
      return typeof g == "symbol" ? g : String(g);
    }
    function F(p) {
      if (p.__esModule)
        return p;
      var g = p.default;
      if (typeof g == "function") {
        var m = function y() {
          if (this instanceof y) {
            var O = [null];
            O.push.apply(O, arguments);
            var C = Function.bind.apply(g, O);
            return new C();
          }
          return g.apply(this, arguments);
        };
        m.prototype = g.prototype;
      } else
        m = {};
      return Object.defineProperty(m, "__esModule", { value: !0 }), Object.keys(p).forEach(function(y) {
        var O = Object.getOwnPropertyDescriptor(p, y);
        Object.defineProperty(m, y, O.get ? O : { enumerable: !0, get: function() {
          return p[y];
        } });
      }), m;
    }
    var v = {};
    (function(p) {
      function g(m) {
        if (m)
          return function(y) {
            for (var O in g.prototype)
              y[O] = g.prototype[O];
            return y;
          }(m);
      }
      p.exports = g, g.prototype.on = g.prototype.addEventListener = function(m, y) {
        return this._callbacks = this._callbacks || {}, (this._callbacks["$" + m] = this._callbacks["$" + m] || []).push(y), this;
      }, g.prototype.once = function(m, y) {
        function O() {
          this.off(m, O), y.apply(this, arguments);
        }
        return O.fn = y, this.on(m, O), this;
      }, g.prototype.off = g.prototype.removeListener = g.prototype.removeAllListeners = g.prototype.removeEventListener = function(m, y) {
        if (this._callbacks = this._callbacks || {}, arguments.length == 0)
          return this._callbacks = {}, this;
        var O, C = this._callbacks["$" + m];
        if (!C)
          return this;
        if (arguments.length == 1)
          return delete this._callbacks["$" + m], this;
        for (var T = 0; T < C.length; T++)
          if ((O = C[T]) === y || O.fn === y) {
            C.splice(T, 1);
            break;
          }
        return C.length === 0 && delete this._callbacks["$" + m], this;
      }, g.prototype.emit = function(m) {
        this._callbacks = this._callbacks || {};
        for (var y = new Array(arguments.length - 1), O = this._callbacks["$" + m], C = 1; C < arguments.length; C++)
          y[C - 1] = arguments[C];
        if (O) {
          C = 0;
          for (var T = (O = O.slice(0)).length; C < T; ++C)
            O[C].apply(this, y);
        }
        return this;
      }, g.prototype.listeners = function(m) {
        return this._callbacks = this._callbacks || {}, this._callbacks["$" + m] || [];
      }, g.prototype.hasListeners = function(m) {
        return !!this.listeners(m).length;
      };
    })({ get exports() {
      return v;
    }, set exports(p) {
      v = p;
    } });
    var $ = v, E = {};
    (function(p, g) {
      (g = p.exports = function(m) {
        return m.trim ? m.trim() : g.right(g.left(m));
      }).left = function(m) {
        return m.trimLeft ? m.trimLeft() : m.replace(/^\s\s*/, "");
      }, g.right = function(m) {
        if (m.trimRight)
          return m.trimRight();
        for (var y = /\s/, O = m.length; y.test(m.charAt(--O)); )
          ;
        return m.slice(0, O + 1);
      };
    })({ get exports() {
      return E;
    }, set exports(p) {
      E = p;
    } }, E);
    var D = E, w = /(\w+)\[(\d+)\]/, k = function(p) {
      try {
        return decodeURIComponent(p.replace(/\+/g, " "));
      } catch {
        return p;
      }
    }, A = function(p) {
      if (typeof p != "string")
        return {};
      if ((p = D(p)) == "")
        return {};
      p.charAt(0) == "?" && (p = p.slice(1));
      for (var g = {}, m = p.split("&"), y = 0; y < m.length; y++) {
        var O, C = m[y].split("="), T = k(C[0]);
        (O = w.exec(T)) ? (g[O[1]] = g[O[1]] || [], g[O[1]][O[2]] = k(C[1])) : g[C[0]] = C[1] == null ? "" : k(C[1]);
      }
      return g;
    };
    function P(p) {
      return p != null && i(p) === "object" && p["@@functional/placeholder"] === !0;
    }
    function S(p) {
      return function g(m) {
        return arguments.length === 0 || P(m) ? g : p.apply(this, arguments);
      };
    }
    function N(p) {
      return function g(m, y) {
        switch (arguments.length) {
          case 0:
            return g;
          case 1:
            return P(m) ? g : S(function(O) {
              return p(m, O);
            });
          default:
            return P(m) && P(y) ? g : P(m) ? S(function(O) {
              return p(O, y);
            }) : P(y) ? S(function(O) {
              return p(m, O);
            }) : p(m, y);
        }
      };
    }
    function W(p) {
      return function g(m, y, O) {
        switch (arguments.length) {
          case 0:
            return g;
          case 1:
            return P(m) ? g : N(function(C, T) {
              return p(m, C, T);
            });
          case 2:
            return P(m) && P(y) ? g : P(m) ? N(function(C, T) {
              return p(C, y, T);
            }) : P(y) ? N(function(C, T) {
              return p(m, C, T);
            }) : S(function(C) {
              return p(m, y, C);
            });
          default:
            return P(m) && P(y) && P(O) ? g : P(m) && P(y) ? N(function(C, T) {
              return p(C, T, O);
            }) : P(m) && P(O) ? N(function(C, T) {
              return p(C, y, T);
            }) : P(y) && P(O) ? N(function(C, T) {
              return p(m, C, T);
            }) : P(m) ? S(function(C) {
              return p(C, y, O);
            }) : P(y) ? S(function(C) {
              return p(m, C, O);
            }) : P(O) ? S(function(C) {
              return p(m, y, C);
            }) : p(m, y, O);
        }
      };
    }
    function V(p, g) {
      return Object.prototype.hasOwnProperty.call(g, p);
    }
    var K = S(function(p) {
      return p === null ? "Null" : p === void 0 ? "Undefined" : Object.prototype.toString.call(p).slice(8, -1);
    });
    function U(p, g, m, y) {
      var O = function(C) {
        for (var T = g.length, R = 0; R < T; ) {
          if (p === g[R])
            return m[R];
          R += 1;
        }
        for (var B in g[R] = p, m[R] = C, p)
          p.hasOwnProperty(B) && (C[B] = y ? U(p[B], g, m, !0) : p[B]);
        return C;
      };
      switch (K(p)) {
        case "Object":
          return O(Object.create(Object.getPrototypeOf(p)));
        case "Array":
          return O([]);
        case "Date":
          return new Date(p.valueOf());
        case "RegExp":
          return function(C) {
            return new RegExp(C.source, (C.global ? "g" : "") + (C.ignoreCase ? "i" : "") + (C.multiline ? "m" : "") + (C.sticky ? "y" : "") + (C.unicode ? "u" : ""));
          }(p);
        case "Int8Array":
        case "Uint8Array":
        case "Uint8ClampedArray":
        case "Int16Array":
        case "Uint16Array":
        case "Int32Array":
        case "Uint32Array":
        case "Float32Array":
        case "Float64Array":
        case "BigInt64Array":
        case "BigUint64Array":
          return p.slice();
        default:
          return p;
      }
    }
    var j = S(function(p) {
      return p != null && typeof p.clone == "function" ? p.clone() : U(p, [], [], !0);
    });
    function G(p) {
      return Object.prototype.toString.call(p) === "[object Object]";
    }
    var H = W(function(p, g, m) {
      var y, O = {};
      for (y in g)
        V(y, g) && (O[y] = V(y, m) ? p(y, g[y], m[y]) : g[y]);
      for (y in m)
        V(y, m) && !V(y, O) && (O[y] = m[y]);
      return O;
    }), J = W(function p(g, m, y) {
      return H(function(O, C, T) {
        return G(C) && G(T) ? p(g, C, T) : g(O, C, T);
      }, m, y);
    }), ae = W(function(p, g, m) {
      return J(function(y, O, C) {
        return p(O, C);
      }, g, m);
    }), de = {};
    (function(p) {
      function g(m) {
        switch (m) {
          case "http:":
            return 80;
          case "https:":
            return 443;
          default:
            return location.port;
        }
      }
      p.parse = function(m) {
        var y = document.createElement("a");
        return y.href = m, { href: y.href, host: y.host || location.host, port: y.port === "0" || y.port === "" ? g(y.protocol) : y.port, hash: y.hash, hostname: y.hostname || location.hostname, pathname: y.pathname.charAt(0) != "/" ? "/" + y.pathname : y.pathname, protocol: y.protocol && y.protocol != ":" ? y.protocol : location.protocol, search: y.search, query: y.search.slice(1) };
      }, p.isAbsolute = function(m) {
        return m.indexOf("//") == 0 || !!~m.indexOf("://");
      }, p.isRelative = function(m) {
        return !p.isAbsolute(m);
      }, p.isCrossDomain = function(m) {
        m = p.parse(m);
        var y = p.parse(window.location.href);
        return m.hostname !== y.hostname || m.port !== y.port || m.protocol !== y.protocol;
      };
    })(de);
    var te = function(p) {
      return p != null && i(p) === "object" && Array.isArray(p) === !1;
    }, ee = function(p, g, m) {
      if (te(m) || (m = { default: m }), !xe(p))
        return m.default !== void 0 ? m.default : p;
      typeof g == "number" && (g = String(g));
      var y = Array.isArray(g), O = typeof g == "string", C = m.separator || ".", T = m.joinChar || (typeof C == "string" ? C : ".");
      if (!O && !y)
        return p;
      if (O && g in p)
        return De(g, p, m) ? p[g] : m.default;
      var R = y ? g : function(Z, fe, ye) {
        return typeof ye.split == "function" ? ye.split(Z) : Z.split(fe);
      }(g, C, m), B = R.length, I = 0;
      do {
        var X = R[I];
        for (typeof X == "number" && (X = String(X)); X && X.slice(-1) === "\\"; )
          X = ge([X.slice(0, -1), R[++I] || ""], T, m);
        if (X in p) {
          if (!De(X, p, m))
            return m.default;
          p = p[X];
        } else {
          for (var Q = !1, oe = I + 1; oe < B; )
            if (Q = (X = ge([X, R[oe++]], T, m)) in p) {
              if (!De(X, p, m))
                return m.default;
              p = p[X], I = oe - 1;
              break;
            }
          if (!Q)
            return m.default;
        }
      } while (++I < B && xe(p));
      return I === B ? p : m.default;
    };
    function ge(p, g, m) {
      return typeof m.join == "function" ? m.join(p) : p[0] + g + p[1];
    }
    function De(p, g, m) {
      return typeof m.isValid != "function" || m.isValid(p, g);
    }
    function xe(p) {
      return te(p) || Array.isArray(p) || typeof p == "function";
    }
    for (var ze, q = 256, Ue = []; q--; )
      Ue[q] = (q + 256).toString(16).substring(1);
    for (var Ce, me = [], Fe = 0; Fe < 256; Fe++)
      me[Fe] = (Fe + 256).toString(16).substring(1);
    function ce() {
      var p;
      (!Ce || Fe + 16 > 4096) && (p = 4096, Ce = crypto.getRandomValues(new Uint8Array(p)), Fe = 0);
      for (var g, m = 0, y = ""; m < 16; m++)
        g = Ce[Fe + m], y += m == 6 ? me[15 & g | 64] : m == 8 ? me[63 & g | 128] : me[g], 1 & m && m > 1 && m < 11 && (y += "-");
      return Fe += 16, y;
    }
    var z, Me, le, Be, rt, ve, qt, fr, Kt, hr, mr, Lr, Oe, Pe, st, Qe, et, Tt, qr, hn, Cn, gn, Zn, Sn, va, Ea, _n, xr, Oo, Jn, ea, An, To, Ms, Dr, ta, ra, na, Bs, aa, On, Ns, ia, Tn, oa, L, we, Te, it, $t, bt, ht, dt, Jt, Pt, Ot, Pr, Ur, nn, an, tc, rc, Ls, nc, ac, ei, ic, wd, $a, kd, oc, ti, sy, Ui = 4, fP = function(p) {
      switch (p.toUpperCase()) {
        case "INFO":
          Ui = 1;
          break;
        case "DEBUG":
          Ui = 2;
          break;
        case "WARN":
          Ui = 3;
          break;
        default:
          Ui = 4;
      }
    }, cP = function() {
      var p;
      Ui <= 1 && (p = console).info.apply(p, arguments);
    }, hP = function() {
      var p;
      Ui <= 2 && (p = console).log.apply(p, arguments);
    }, uy = function() {
      var p;
      Ui <= 3 && (p = console).warn.apply(p, arguments);
    }, Cr = function() {
      var p;
      Ui <= 4 && (p = console).error.apply(p, arguments);
    }, wa = "ADOBE_ANALYTICS", gP = (z = { "Adobe Analytics": wa, ADOBEANALYTICS: wa, "ADOBE ANALYTICS": wa }, s(z, wa, wa), s(z, "AdobeAnalytics", wa), s(z, "adobeanalytics", wa), s(z, "adobe analytics", wa), s(z, "Adobe analytics", wa), s(z, "adobe Analytics", wa), z), xd = "AM", _P = (Me = {}, s(Me, xd, xd), s(Me, "AMPLITUDE", xd), s(Me, "Amplitude", xd), s(Me, "am", xd), Me), Dd = "APPCUES", mP = (le = {}, s(le, Dd, Dd), s(le, "Appcues", Dd), s(le, "App Cues", Dd), s(le, "appcues", Dd), le), Gi = "BINGADS", pP = (Be = {}, s(Be, Gi, Gi), s(Be, "BingAds", Gi), s(Be, "bingads", Gi), s(Be, "Bing Ads", Gi), s(Be, "Bing ads", Gi), s(Be, "bing Ads", Gi), s(Be, "bing ads", Gi), Be), sc = "BRAZE", FP = (rt = {}, s(rt, sc, sc), s(rt, "Braze", sc), s(rt, "braze", sc), rt), uc = "BUGSNAG", yP = (ve = {}, s(ve, uc, uc), s(ve, "bugsnag", uc), s(ve, "Bugsnag", uc), ve), qs = "CHARTBEAT", bP = (qt = {}, s(qt, qs, qs), s(qt, "Chartbeat", qs), s(qt, "chartbeat", qs), s(qt, "Chart Beat", qs), s(qt, "chart beat", qs), qt), dc = "CLEVERTAP", vP = (fr = {}, s(fr, dc, dc), s(fr, "Clevertap", dc), s(fr, "clevertap", dc), fr), Po = "COMSCORE", EP = (Kt = {}, s(Kt, Po, Po), s(Kt, "Comscore", Po), s(Kt, "Com Score", Po), s(Kt, "com Score", Po), s(Kt, "com score", Po), s(Kt, "Com score", Po), Kt), lc = "CRITEO", $P = (hr = {}, s(hr, lc, lc), s(hr, "Criteo", lc), s(hr, "criteo", lc), hr), Us = "CUSTOMERIO", wP = (mr = {}, s(mr, Us, Us), s(mr, "Customerio", Us), s(mr, "Customer.io", Us), s(mr, "CUSTOMER.IO", Us), s(mr, "customer.io", Us), mr), fc = "DRIP", kP = (Lr = {}, s(Lr, fc, fc), s(Lr, "Drip", fc), s(Lr, "drip", fc), Lr), Wi = "FACEBOOK_PIXEL", xP = (Oe = {}, s(Oe, Wi, Wi), s(Oe, "FB Pixel", Wi), s(Oe, "Facebook Pixel", Wi), s(Oe, "facebook pixel", Wi), s(Oe, "fbpixel", Wi), s(Oe, "FBPIXEL", Wi), s(Oe, "FB_PIXEL", Wi), Oe), ri = "FULLSTORY", DP = (Pe = {}, s(Pe, ri, ri), s(Pe, "Fullstory", ri), s(Pe, "FullStory", ri), s(Pe, "full Story", ri), s(Pe, "Full Story", ri), s(Pe, "Full story", ri), s(Pe, "full story", ri), s(Pe, "fullstory", ri), Pe), Gs = "GA", CP = (s(st = {}, Gs, Gs), s(st, "Google Analytics", Gs), s(st, "GoogleAnalytics", Gs), s(st, "GOOGLE ANALYTICS", Gs), s(st, "google analytics", Gs), st), ni = "GA4", SP = (s(Qe = {}, ni, ni), s(Qe, "Google Analytics 4", ni), s(Qe, "Google analytics 4", ni), s(Qe, "google analytics 4", ni), s(Qe, "Google Analytics4", ni), s(Qe, "Google analytics4", ni), s(Qe, "google analytics4", ni), s(Qe, "GoogleAnalytics4", ni), Qe), Io = "GOOGLEADS", AP = (s(et = {}, Io, Io), s(et, "Google Ads", Io), s(et, "GoogleAds", Io), s(et, "GOOGLE ADS", Io), s(et, "google ads", Io), s(et, "googleads", Io), et), ai = "GOOGLE_OPTIMIZE", OP = (s(Tt = {}, ai, ai), s(Tt, "Google Optimize", ai), s(Tt, "GoogleOptimize", ai), s(Tt, "Googleoptimize", ai), s(Tt, "GOOGLEOPTIMIZE", ai), s(Tt, "google optimize", ai), s(Tt, "Google optimize", ai), s(Tt, "GOOGLE OPTIMIZE", ai), Tt), Ws = "GTM", TP = (s(qr = {}, Ws, Ws), s(qr, "Google Tag Manager", Ws), s(qr, "google tag manager", Ws), s(qr, "googletag manager", Ws), s(qr, "googletagmanager", Ws), qr), Cd = "HEAP", PP = (s(hn = {}, Cd, Cd), s(hn, "Heap", Cd), s(hn, "heap", Cd), s(hn, "Heap.io", Cd), hn), Vs = "HOTJAR", IP = (s(Cn = {}, Vs, Vs), s(Cn, "Hotjar", Vs), s(Cn, "hotjar", Vs), s(Cn, "Hot Jar", Vs), s(Cn, "hot jar", Vs), Cn), Ro = "HS", RP = (s(gn = {}, Ro, Ro), s(gn, "Hubspot", Ro), s(gn, "HUBSPOT", Ro), s(gn, "hub spot", Ro), s(gn, "Hub Spot", Ro), s(gn, "Hub spot", Ro), gn), cc = "INTERCOM", jP = (s(Zn = {}, cc, cc), s(Zn, "Intercom", cc), s(Zn, "intercom", cc), Zn), Hs = "KEEN", MP = (s(Sn = {}, Hs, Hs), s(Sn, "Keen", Hs), s(Sn, "Keen.io", Hs), s(Sn, "keen", Hs), s(Sn, "keen.io", Hs), Sn), hc = "KISSMETRICS", BP = (s(va = {}, hc, hc), s(va, "Kissmetrics", hc), s(va, "kissmetrics", hc), va), gc = "KLAVIYO", NP = (s(Ea = {}, gc, gc), s(Ea, "Klaviyo", gc), s(Ea, "klaviyo", gc), Ea), jo = "LAUNCHDARKLY", LP = (s(_n = {}, jo, jo), s(_n, "LaunchDarkly", jo), s(_n, "Launch_Darkly", jo), s(_n, "Launch Darkly", jo), s(_n, "launchDarkly", jo), s(_n, "launch darkly", jo), _n), Pn = "LINKEDIN_INSIGHT_TAG", qP = (s(xr = {}, Pn, Pn), s(xr, "LinkedIn Insight Tag", Pn), s(xr, "LinkedIn insight tag", Pn), s(xr, "linkedIn insight tag", Pn), s(xr, "Linkedin_insight_tag", Pn), s(xr, "LinkedinInsighttag", Pn), s(xr, "LinkedinInsightTag", Pn), s(xr, "LinkedInInsightTag", Pn), s(xr, "Linkedininsighttag", Pn), s(xr, "LINKEDININSIGHTTAG", Pn), s(xr, "linkedininsighttag", Pn), xr), _c = "LOTAME", UP = (s(Oo = {}, _c, _c), s(Oo, "Lotame", _c), s(Oo, "lotame", _c), Oo), mc = "LYTICS", GP = (s(Jn = {}, mc, mc), s(Jn, "Lytics", mc), s(Jn, "lytics", mc), Jn), Mo = "MP", WP = (s(ea = {}, Mo, Mo), s(ea, "MIXPANEL", Mo), s(ea, "Mixpanel", Mo), s(ea, "MIX PANEL", Mo), s(ea, "Mix panel", Mo), s(ea, "Mix Panel", Mo), ea), Vi = "MOENGAGE", VP = (s(An = {}, Vi, Vi), s(An, "MoEngage", Vi), s(An, "moengage", Vi), s(An, "Moengage", Vi), s(An, "Mo Engage", Vi), s(An, "mo engage", Vi), s(An, "Mo engage", Vi), An), pc = "OPTIMIZELY", HP = (s(To = {}, pc, pc), s(To, "Optimizely", pc), s(To, "optimizely", pc), To), Fc = "PENDO", zP = (s(Ms = {}, Fc, Fc), s(Ms, "Pendo", Fc), s(Ms, "pendo", Fc), Ms), Xr = "PINTEREST_TAG", KP = (s(Dr = {}, Xr, Xr), s(Dr, "PinterestTag", Xr), s(Dr, "Pinterest_Tag", Xr), s(Dr, "PINTERESTTAG", Xr), s(Dr, "pinterest", Xr), s(Dr, "PinterestAds", Xr), s(Dr, "Pinterest_Ads", Xr), s(Dr, "Pinterest", Xr), s(Dr, "Pinterest Tag", Xr), s(Dr, "Pinterest tag", Xr), s(Dr, "PINTEREST TAG", Xr), s(Dr, "pinterest tag", Xr), s(Dr, "Pinterest Ads", Xr), s(Dr, "Pinterest ads", Xr), Dr), ii = "POST_AFFILIATE_PRO", YP = (s(ta = {}, ii, ii), s(ta, "PostAffiliatePro", ii), s(ta, "Post_affiliate_pro", ii), s(ta, "Post Affiliate Pro", ii), s(ta, "Post affiliate pro", ii), s(ta, "post affiliate pro", ii), s(ta, "postaffiliatepro", ii), s(ta, "POSTAFFILIATEPRO", ii), ta), Hi = "POSTHOG", XP = (s(ra = {}, Hi, Hi), s(ra, "PostHog", Hi), s(ra, "Posthog", Hi), s(ra, "posthog", Hi), s(ra, "Post Hog", Hi), s(ra, "Post hog", Hi), s(ra, "post hog", Hi), ra), zi = "PROFITWELL", QP = (s(na = {}, zi, zi), s(na, "ProfitWell", zi), s(na, "profitwell", zi), s(na, "Profitwell", zi), s(na, "Profit Well", zi), s(na, "profit well", zi), s(na, "Profit well", zi), na), yc = "QUALTRICS", ZP = (s(Bs = {}, yc, yc), s(Bs, "Qualtrics", yc), s(Bs, "qualtrics", yc), Bs), oi = "QUANTUMMETRIC", JP = (s(aa = {}, oi, oi), s(aa, "Quantum Metric", oi), s(aa, "quantum Metric", oi), s(aa, "quantum metric", oi), s(aa, "QuantumMetric", oi), s(aa, "quantumMetric", oi), s(aa, "quantummetric", oi), s(aa, "Quantum_Metric", oi), aa), si = "REDDIT_PIXEL", eI = (s(On = {}, si, si), s(On, "Reddit_Pixel", si), s(On, "RedditPixel", si), s(On, "REDDITPIXEL", si), s(On, "redditpixel", si), s(On, "Reddit Pixel", si), s(On, "REDDIT PIXEL", si), s(On, "reddit pixel", si), On), bc = "SENTRY", tI = (s(Ns = {}, bc, bc), s(Ns, "sentry", bc), s(Ns, "Sentry", bc), Ns), ui = "SNAP_PIXEL", rI = (s(ia = {}, ui, ui), s(ia, "Snap_Pixel", ui), s(ia, "SnapPixel", ui), s(ia, "SNAPPIXEL", ui), s(ia, "snappixel", ui), s(ia, "Snap Pixel", ui), s(ia, "SNAP PIXEL", ui), s(ia, "snap pixel", ui), ia), ka = "TVSQUARED", nI = (s(Tn = {}, ka, ka), s(Tn, "TVSquared", ka), s(Tn, "tvsquared", ka), s(Tn, "tvSquared", ka), s(Tn, "TvSquared", ka), s(Tn, "Tvsquared", ka), s(Tn, "TV Squared", ka), s(Tn, "tv squared", ka), s(Tn, "tv Squared", ka), Tn), di = "VWO", aI = (s(oa = {}, di, di), s(oa, "VisualWebsiteOptimizer", di), s(oa, "Visualwebsiteoptimizer", di), s(oa, "visualwebsiteoptimizer", di), s(oa, "vwo", di), s(oa, "Visual Website Optimizer", di), s(oa, "Visual website optimizer", di), s(oa, "visual website optimizer", di), oa), xa = "GA360", iI = (s(L = {}, xa, xa), s(L, "Google Analytics 360", xa), s(L, "Google analytics 360", xa), s(L, "google analytics 360", xa), s(L, "Google Analytics360", xa), s(L, "Google analytics360", xa), s(L, "google analytics360", xa), s(L, "GoogleAnalytics360", xa), s(L, "GA 360", xa), L), zs = "ADROLL", oI = (s(we = {}, zs, zs), s(we, "Adroll", zs), s(we, "Ad roll", zs), s(we, "ad roll", zs), s(we, "adroll", zs), we), Da = "DCM_FLOODLIGHT", sI = (s(Te = {}, Da, Da), s(Te, "DCM Floodlight", Da), s(Te, "dcm floodlight", Da), s(Te, "Dcm Floodlight", Da), s(Te, "DCMFloodlight", Da), s(Te, "dcmfloodlight", Da), s(Te, "DcmFloodlight", Da), s(Te, "dcm_floodlight", Da), s(Te, "DCM_Floodlight", Da), Te), vc = "MATOMO", uI = (s(it = {}, vc, vc), s(it, "Matomo", vc), s(it, "matomo", vc), it), Ec = "VERO", dI = (s($t = {}, Ec, Ec), s($t, "Vero", Ec), s($t, "vero", Ec), $t), Ca = "MOUSEFLOW", lI = (s(bt = {}, Ca, Ca), s(bt, "Mouseflow", Ca), s(bt, "mouseflow", Ca), s(bt, "mouseFlow", Ca), s(bt, "MouseFlow", Ca), s(bt, "Mouse flow", Ca), s(bt, "mouse flow", Ca), s(bt, "mouse Flow", Ca), s(bt, "Mouse Flow", Ca), bt), Ki = "ROCKERBOX", fI = (s(ht = {}, Ki, Ki), s(ht, "Rockerbox", Ki), s(ht, "rockerbox", Ki), s(ht, "RockerBox", Ki), s(ht, "Rocker box", Ki), s(ht, "rocker box", Ki), s(ht, "Rocker Box", Ki), ht), sa = "CONVERTFLOW", cI = (s(dt = {}, sa, sa), s(dt, "Convertflow", sa), s(dt, "convertflow", sa), s(dt, "convertFlow", sa), s(dt, "ConvertFlow", sa), s(dt, "Convert flow", sa), s(dt, "convert flow", sa), s(dt, "convert Flow", sa), s(dt, "Convert Flow", sa), s(dt, "CONVERT FLOW", sa), dt), Yi = "SNAPENGAGE", hI = (s(Jt = {}, Yi, Yi), s(Jt, "SnapEngage", Yi), s(Jt, "Snap_Engage", Yi), s(Jt, "snapengage", Yi), s(Jt, "SNAP ENGAGE", Yi), s(Jt, "Snap Engage", Yi), s(Jt, "snap engage", Yi), Jt), Xi = "LIVECHAT", gI = (s(Pt = {}, Xi, Xi), s(Pt, "LiveChat", Xi), s(Pt, "Live_Chat", Xi), s(Pt, "livechat", Xi), s(Pt, "LIVE CHAT", Xi), s(Pt, "Live Chat", Xi), s(Pt, "live chat", Xi), Pt), Sa = "SHYNET", _I = (s(Ot = {}, Sa, Sa), s(Ot, "shynet", Sa), s(Ot, "ShyNet", Sa), s(Ot, "shyNet", Sa), s(Ot, "Shynet", Sa), s(Ot, "shy net", Sa), s(Ot, "Shy Net", Sa), s(Ot, "shy Net", Sa), s(Ot, "Shy net", Sa), Ot), $c = "WOOPRA", mI = (s(Pr = {}, $c, $c), s(Pr, "Woopra", $c), s(Pr, "woopra", $c), Pr), li = "ROLLBAR", pI = (s(Ur = {}, li, li), s(Ur, "RollBar", li), s(Ur, "Roll_Bar", li), s(Ur, "rollbar", li), s(Ur, "Rollbar", li), s(Ur, "ROLL BAR", li), s(Ur, "Roll Bar", li), s(Ur, "roll bar", li), Ur), ua = "QUORA_PIXEL", FI = (s(nn = {}, ua, ua), s(nn, "Quora Pixel", ua), s(nn, "Quora pixel", ua), s(nn, "QUORA PIXEL", ua), s(nn, "QuoraPixel", ua), s(nn, "Quorapixel", ua), s(nn, "QUORAPIXEL", ua), s(nn, "Quora_Pixel", ua), s(nn, "quora_pixel", ua), s(nn, "Quora", ua), nn), wc = "JUNE", yI = (s(an = {}, wc, wc), s(an, "June", wc), s(an, "june", wc), an), kc = "ENGAGE", bI = (s(tc = {}, kc, kc), s(tc, "Engage", kc), s(tc, "engage", kc), tc), xc = "ITERABLE", vI = (s(rc = {}, xc, xc), s(rc, "Iterable", xc), s(rc, "iterable", xc), rc), Ks = "YANDEX_METRICA", EI = (s(Ls = {}, Ks, Ks), s(Ls, "Yandexmetrica", Ks), s(Ls, "yandexmetrica", Ks), s(Ls, "yandexMetrica", Ks), s(Ls, "YandexMetrica", Ks), Ls), Dc = "REFINER", $I = (s(nc = {}, Dc, Dc), s(nc, "Refiner", Dc), s(nc, "refiner", Dc), nc), Cc = "QUALAROO", wI = (s(ac = {}, Cc, Cc), s(ac, "Qualaroo", Cc), s(ac, "qualaroo", Cc), ac), fi = "PODSIGHTS", kI = (s(ei = {}, fi, fi), s(ei, "Podsights", fi), s(ei, "PodSights", fi), s(ei, "pod Sights", fi), s(ei, "Pod Sights", fi), s(ei, "pod sights", fi), s(ei, "POD SIGHTS", fi), s(ei, "Pod sights", fi), ei), Sc = "AXEPTIO", xI = (s(ic = {}, Sc, Sc), s(ic, "Axeptio", Sc), s(ic, "axeptio", Sc), ic), Sd = "SATISMETER", DI = (s(wd = {}, Sd, Sd), s(wd, "Satismeter", Sd), s(wd, "SatisMeter", Sd), s(wd, "SATISMETER", Sd), wd), Aa = "MICROSOFT_CLARITY", CI = (s($a = {}, Aa, Aa), s($a, "Microsoft Clarity", Aa), s($a, "Microsoft clarity", Aa), s($a, "microsoft clarity", Aa), s($a, "Microsoft_clarity", Aa), s($a, "MicrosoftClarity", Aa), s($a, "MICROSOFTCLARITY", Aa), s($a, "microsoftclarity", Aa), s($a, "microsoftClarity", Aa), $a), Ad = "SENDINBLUE", SI = (s(kd = {}, Ad, Ad), s(kd, "Sendinblue", Ad), s(kd, "sendinblue", Ad), s(kd, "SendinBlue", Ad), kd), Ac = "OLARK", AI = (s(oc = {}, Ac, Ac), s(oc, "Olark", Ac), s(oc, "olark", Ac), oc), ci = "LEMNISK", OI = (s(ti = {}, ci, ci), s(ti, "LEMNISK_MARKETING_AUTOMATION", ci), s(ti, "Lemnisk Marketing Automation", ci), s(ti, "LemniskMarketingAutomation", ci), s(ti, "lemniskmarketingautomation", ci), s(ti, "lemniskMarketingAutomation", ci), s(ti, "lemnisk", ci), s(ti, "Lemnisk", ci), ti), dy = a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a(a({ All: "All" }, gP), _P), mP), pP), FP), yP), bP), vP), EP), $P), wP), kP), xP), DP), CP), SP), iI), AP), OP), TP), PP), IP), RP), jP), MP), BP), NP), LP), qP), UP), GP), WP), VP), HP), zP), KP), YP), XP), QP), ZP), JP), eI), tI), rI), nI), aI), oI), sI), uI), dI), lI), cI), hI), gI), _I), mI), pI), FI), yI), bI), vI), fI), EI), $I), wI), kI), xI), DI), CI), SI), AI), OI), TI = { All: "All", GA: "Google Analytics", GOOGLEADS: "Google Ads", BRAZE: "Braze", CHARTBEAT: "Chartbeat", COMSCORE: "Comscore", CUSTOMERIO: "Customer IO", DCM_Floodlight: "DCM Floodlight", FACEBOOK_PIXEL: "Facebook Pixel", GTM: "Google Tag Manager", HOTJAR: "Hotjar", HS: "HubSpot", INTERCOM: "Intercom", KEEN: "Keen", KISSMETRICS: "Kiss Metrics", LOTAME: "Lotame", VWO: "VWO", OPTIMIZELY: "Optimizely Web", FULLSTORY: "Fullstory", TVSQUARED: "TVSquared", GA4: "Google Analytics 4", MOENGAGE: "MoEngage", AM: "Amplitude", PENDO: "Pendo", LYTICS: "Lytics", APPCUES: "Appcues", POSTHOG: "PostHog", PROFITWELL: "ProfitWell", KLAVIYO: "Klaviyo", CLEVERTAP: "CleverTap", BINGADS: "Bing Ads", PINTEREST_TAG: "Pinterest Tag", SNAP_PIXEL: "Snap Pixel", LINKEDIN_INSIGHT_TAG: "Linkedin Insight Tag", REDDIT_PIXEL: "Reddit Pixel", DRIP: "Drip", HEAP: "Heap.io", CRITEO: "Criteo", MP: "Mixpanel", QUALTRICS: "Qualtrics", SENTRY: "Sentry", GOOGLE_OPTIMIZE: "Google Optimize", POST_AFFILIATE_PRO: "Post Affiliate Pro", LAUNCHDARKLY: "LaunchDarkly", GA360: "Google Analytics 360", ADROLL: "Adroll", VERO: "Vero", MATOMO: "Matomo", MOUSEFLOW: "Mouseflow", ROCKERBOX: "Rockerbox", CONVERTFLOW: "ConvertFlow", SNAPENGAGE: "SnapEngage", LIVECHAT: "LiveChat", SHYNET: "Shynet", WOOPRA: "Woopra", ROLLBAR: "RollBar", QUORA_PIXEL: "Quora Pixel", JUNE: "June", ENGAGE: "Engage", ITERABLE: "Iterable", YANDEX_METRICA: "Yandex.Metrica", REFINER: "Refiner", QUALAROO: "Qualaroo", PODSIGHTS: "Podsights", AXEPTIO: "Axeptio", SATISMETER: "Satismeter", MICROSOFT_CLARITY: "Microsoft Clarity", SENDINBLUE: "Sendinblue", OLARK: "Olark", LEMNISK: "Lemnisk" }, Og = ["anonymous_id", "id", "sent_at", "received_at", "timestamp", "original_timestamp", "event_text", "event"], ly = "https://api.rudderlabs.com/sourceConfig/?p=npm&v=2.28.0", fy = "v1.1", cy = "js-integrations", hy = "".concat("https://cdn.rudderlabs.com", "/").concat(fy, "/").concat(cy), Oc = 1e4, Tc = 1e3, gy = "_RS", _y = "bugsnag", PI = [_y], II = ["Lax", "None", "Strict"], RI = ["US", "EU"], jI = ["oneTrust"], my = ["library", "consentManagement"], MI = ["none", "default", "full"], Tg = {}, Pg = {}, BI = { get exports() {
      return Pg;
    }, set exports(p) {
      Pg = p;
    } };
    function Qi() {
      return sy || (sy = 1, function(p, g) {
        var m;
        p.exports = (m = m || function(y, O) {
          var C = Object.create || function() {
            function Y() {
            }
            return function(he) {
              var _e;
              return Y.prototype = he, _e = new Y(), Y.prototype = null, _e;
            };
          }(), T = {}, R = T.lib = {}, B = R.Base = { extend: function(Y) {
            var he = C(this);
            return Y && he.mixIn(Y), he.hasOwnProperty("init") && this.init !== he.init || (he.init = function() {
              he.$super.init.apply(this, arguments);
            }), he.init.prototype = he, he.$super = this, he;
          }, create: function() {
            var Y = this.extend();
            return Y.init.apply(Y, arguments), Y;
          }, init: function() {
          }, mixIn: function(Y) {
            for (var he in Y)
              Y.hasOwnProperty(he) && (this[he] = Y[he]);
            Y.hasOwnProperty("toString") && (this.toString = Y.toString);
          }, clone: function() {
            return this.init.prototype.extend(this);
          } }, I = R.WordArray = B.extend({ init: function(Y, he) {
            Y = this.words = Y || [], this.sigBytes = he != O ? he : 4 * Y.length;
          }, toString: function(Y) {
            return (Y || Q).stringify(this);
          }, concat: function(Y) {
            var he = this.words, _e = Y.words, Ee = this.sigBytes, be = Y.sigBytes;
            if (this.clamp(), Ee % 4)
              for (var We = 0; We < be; We++) {
                var Ye = _e[We >>> 2] >>> 24 - We % 4 * 8 & 255;
                he[Ee + We >>> 2] |= Ye << 24 - (Ee + We) % 4 * 8;
              }
            else
              for (We = 0; We < be; We += 4)
                he[Ee + We >>> 2] = _e[We >>> 2];
            return this.sigBytes += be, this;
          }, clamp: function() {
            var Y = this.words, he = this.sigBytes;
            Y[he >>> 2] &= 4294967295 << 32 - he % 4 * 8, Y.length = y.ceil(he / 4);
          }, clone: function() {
            var Y = B.clone.call(this);
            return Y.words = this.words.slice(0), Y;
          }, random: function(Y) {
            for (var he, _e = [], Ee = function(Ye) {
              var ft = 987654321, nt = 4294967295;
              return function() {
                var ke = ((ft = 36969 * (65535 & ft) + (ft >> 16) & nt) << 16) + (Ye = 18e3 * (65535 & Ye) + (Ye >> 16) & nt) & nt;
                return ke /= 4294967296, (ke += 0.5) * (y.random() > 0.5 ? 1 : -1);
              };
            }, be = 0; be < Y; be += 4) {
              var We = Ee(4294967296 * (he || y.random()));
              he = 987654071 * We(), _e.push(4294967296 * We() | 0);
            }
            return new I.init(_e, Y);
          } }), X = T.enc = {}, Q = X.Hex = { stringify: function(Y) {
            for (var he = Y.words, _e = Y.sigBytes, Ee = [], be = 0; be < _e; be++) {
              var We = he[be >>> 2] >>> 24 - be % 4 * 8 & 255;
              Ee.push((We >>> 4).toString(16)), Ee.push((15 & We).toString(16));
            }
            return Ee.join("");
          }, parse: function(Y) {
            for (var he = Y.length, _e = [], Ee = 0; Ee < he; Ee += 2)
              _e[Ee >>> 3] |= parseInt(Y.substr(Ee, 2), 16) << 24 - Ee % 8 * 4;
            return new I.init(_e, he / 2);
          } }, oe = X.Latin1 = { stringify: function(Y) {
            for (var he = Y.words, _e = Y.sigBytes, Ee = [], be = 0; be < _e; be++) {
              var We = he[be >>> 2] >>> 24 - be % 4 * 8 & 255;
              Ee.push(String.fromCharCode(We));
            }
            return Ee.join("");
          }, parse: function(Y) {
            for (var he = Y.length, _e = [], Ee = 0; Ee < he; Ee++)
              _e[Ee >>> 2] |= (255 & Y.charCodeAt(Ee)) << 24 - Ee % 4 * 8;
            return new I.init(_e, he);
          } }, Z = X.Utf8 = { stringify: function(Y) {
            try {
              return decodeURIComponent(escape(oe.stringify(Y)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          }, parse: function(Y) {
            return oe.parse(unescape(encodeURIComponent(Y)));
          } }, fe = R.BufferedBlockAlgorithm = B.extend({ reset: function() {
            this._data = new I.init(), this._nDataBytes = 0;
          }, _append: function(Y) {
            typeof Y == "string" && (Y = Z.parse(Y)), this._data.concat(Y), this._nDataBytes += Y.sigBytes;
          }, _process: function(Y) {
            var he = this._data, _e = he.words, Ee = he.sigBytes, be = this.blockSize, We = Ee / (4 * be), Ye = (We = Y ? y.ceil(We) : y.max((0 | We) - this._minBufferSize, 0)) * be, ft = y.min(4 * Ye, Ee);
            if (Ye) {
              for (var nt = 0; nt < Ye; nt += be)
                this._doProcessBlock(_e, nt);
              var ke = _e.splice(0, Ye);
              he.sigBytes -= ft;
            }
            return new I.init(ke, ft);
          }, clone: function() {
            var Y = B.clone.call(this);
            return Y._data = this._data.clone(), Y;
          }, _minBufferSize: 0 });
          R.Hasher = fe.extend({ cfg: B.extend(), init: function(Y) {
            this.cfg = this.cfg.extend(Y), this.reset();
          }, reset: function() {
            fe.reset.call(this), this._doReset();
          }, update: function(Y) {
            return this._append(Y), this._process(), this;
          }, finalize: function(Y) {
            return Y && this._append(Y), this._doFinalize();
          }, blockSize: 16, _createHelper: function(Y) {
            return function(he, _e) {
              return new Y.init(_e).finalize(he);
            };
          }, _createHmacHelper: function(Y) {
            return function(he, _e) {
              return new ye.HMAC.init(Y, _e).finalize(he);
            };
          } });
          var ye = T.algo = {};
          return T;
        }(Math), m);
      }(BI)), Pg;
    }
    var py, Ig = {}, NI = { get exports() {
      return Ig;
    }, set exports(p) {
      Ig = p;
    } };
    function LI() {
      return py || (py = 1, function(p, g) {
        var m;
        p.exports = (m = Qi(), function() {
          var y = m, O = y.lib.WordArray;
          function C(T, R, B) {
            for (var I = [], X = 0, Q = 0; Q < R; Q++)
              if (Q % 4) {
                var oe = B[T.charCodeAt(Q - 1)] << Q % 4 * 2, Z = B[T.charCodeAt(Q)] >>> 6 - Q % 4 * 2;
                I[X >>> 2] |= (oe | Z) << 24 - X % 4 * 8, X++;
              }
            return O.create(I, X);
          }
          y.enc.Base64 = { stringify: function(T) {
            var R = T.words, B = T.sigBytes, I = this._map;
            T.clamp();
            for (var X = [], Q = 0; Q < B; Q += 3)
              for (var oe = (R[Q >>> 2] >>> 24 - Q % 4 * 8 & 255) << 16 | (R[Q + 1 >>> 2] >>> 24 - (Q + 1) % 4 * 8 & 255) << 8 | R[Q + 2 >>> 2] >>> 24 - (Q + 2) % 4 * 8 & 255, Z = 0; Z < 4 && Q + 0.75 * Z < B; Z++)
                X.push(I.charAt(oe >>> 6 * (3 - Z) & 63));
            var fe = I.charAt(64);
            if (fe)
              for (; X.length % 4; )
                X.push(fe);
            return X.join("");
          }, parse: function(T) {
            var R = T.length, B = this._map, I = this._reverseMap;
            if (!I) {
              I = this._reverseMap = [];
              for (var X = 0; X < B.length; X++)
                I[B.charCodeAt(X)] = X;
            }
            var Q = B.charAt(64);
            if (Q) {
              var oe = T.indexOf(Q);
              oe !== -1 && (R = oe);
            }
            return C(T, R, I);
          }, _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=" };
        }(), m.enc.Base64);
      }(NI)), Ig;
    }
    var Fy, Rg = {}, qI = { get exports() {
      return Rg;
    }, set exports(p) {
      Rg = p;
    } };
    function UI() {
      return Fy || (Fy = 1, function(p, g) {
        var m;
        p.exports = (m = Qi(), function(y) {
          var O = m, C = O.lib, T = C.WordArray, R = C.Hasher, B = O.algo, I = [];
          (function() {
            for (var ye = 0; ye < 64; ye++)
              I[ye] = 4294967296 * y.abs(y.sin(ye + 1)) | 0;
          })();
          var X = B.MD5 = R.extend({ _doReset: function() {
            this._hash = new T.init([1732584193, 4023233417, 2562383102, 271733878]);
          }, _doProcessBlock: function(ye, Y) {
            for (var he = 0; he < 16; he++) {
              var _e = Y + he, Ee = ye[_e];
              ye[_e] = 16711935 & (Ee << 8 | Ee >>> 24) | 4278255360 & (Ee << 24 | Ee >>> 8);
            }
            var be = this._hash.words, We = ye[Y + 0], Ye = ye[Y + 1], ft = ye[Y + 2], nt = ye[Y + 3], ke = ye[Y + 4], Se = ye[Y + 5], Ze = ye[Y + 6], Le = ye[Y + 7], gt = ye[Y + 8], kt = ye[Y + 9], Yt = ye[Y + 10], on = ye[Y + 11], to = ye[Y + 12], ro = ye[Y + 13], no = ye[Y + 14], ao = ye[Y + 15], Ie = be[0], Ne = be[1], Re = be[2], je = be[3];
            Ie = Q(Ie, Ne, Re, je, We, 7, I[0]), je = Q(je, Ie, Ne, Re, Ye, 12, I[1]), Re = Q(Re, je, Ie, Ne, ft, 17, I[2]), Ne = Q(Ne, Re, je, Ie, nt, 22, I[3]), Ie = Q(Ie, Ne, Re, je, ke, 7, I[4]), je = Q(je, Ie, Ne, Re, Se, 12, I[5]), Re = Q(Re, je, Ie, Ne, Ze, 17, I[6]), Ne = Q(Ne, Re, je, Ie, Le, 22, I[7]), Ie = Q(Ie, Ne, Re, je, gt, 7, I[8]), je = Q(je, Ie, Ne, Re, kt, 12, I[9]), Re = Q(Re, je, Ie, Ne, Yt, 17, I[10]), Ne = Q(Ne, Re, je, Ie, on, 22, I[11]), Ie = Q(Ie, Ne, Re, je, to, 7, I[12]), je = Q(je, Ie, Ne, Re, ro, 12, I[13]), Re = Q(Re, je, Ie, Ne, no, 17, I[14]), Ie = oe(Ie, Ne = Q(Ne, Re, je, Ie, ao, 22, I[15]), Re, je, Ye, 5, I[16]), je = oe(je, Ie, Ne, Re, Ze, 9, I[17]), Re = oe(Re, je, Ie, Ne, on, 14, I[18]), Ne = oe(Ne, Re, je, Ie, We, 20, I[19]), Ie = oe(Ie, Ne, Re, je, Se, 5, I[20]), je = oe(je, Ie, Ne, Re, Yt, 9, I[21]), Re = oe(Re, je, Ie, Ne, ao, 14, I[22]), Ne = oe(Ne, Re, je, Ie, ke, 20, I[23]), Ie = oe(Ie, Ne, Re, je, kt, 5, I[24]), je = oe(je, Ie, Ne, Re, no, 9, I[25]), Re = oe(Re, je, Ie, Ne, nt, 14, I[26]), Ne = oe(Ne, Re, je, Ie, gt, 20, I[27]), Ie = oe(Ie, Ne, Re, je, ro, 5, I[28]), je = oe(je, Ie, Ne, Re, ft, 9, I[29]), Re = oe(Re, je, Ie, Ne, Le, 14, I[30]), Ie = Z(Ie, Ne = oe(Ne, Re, je, Ie, to, 20, I[31]), Re, je, Se, 4, I[32]), je = Z(je, Ie, Ne, Re, gt, 11, I[33]), Re = Z(Re, je, Ie, Ne, on, 16, I[34]), Ne = Z(Ne, Re, je, Ie, no, 23, I[35]), Ie = Z(Ie, Ne, Re, je, Ye, 4, I[36]), je = Z(je, Ie, Ne, Re, ke, 11, I[37]), Re = Z(Re, je, Ie, Ne, Le, 16, I[38]), Ne = Z(Ne, Re, je, Ie, Yt, 23, I[39]), Ie = Z(Ie, Ne, Re, je, ro, 4, I[40]), je = Z(je, Ie, Ne, Re, We, 11, I[41]), Re = Z(Re, je, Ie, Ne, nt, 16, I[42]), Ne = Z(Ne, Re, je, Ie, Ze, 23, I[43]), Ie = Z(Ie, Ne, Re, je, kt, 4, I[44]), je = Z(je, Ie, Ne, Re, to, 11, I[45]), Re = Z(Re, je, Ie, Ne, ao, 16, I[46]), Ie = fe(Ie, Ne = Z(Ne, Re, je, Ie, ft, 23, I[47]), Re, je, We, 6, I[48]), je = fe(je, Ie, Ne, Re, Le, 10, I[49]), Re = fe(Re, je, Ie, Ne, no, 15, I[50]), Ne = fe(Ne, Re, je, Ie, Se, 21, I[51]), Ie = fe(Ie, Ne, Re, je, to, 6, I[52]), je = fe(je, Ie, Ne, Re, nt, 10, I[53]), Re = fe(Re, je, Ie, Ne, Yt, 15, I[54]), Ne = fe(Ne, Re, je, Ie, Ye, 21, I[55]), Ie = fe(Ie, Ne, Re, je, gt, 6, I[56]), je = fe(je, Ie, Ne, Re, ao, 10, I[57]), Re = fe(Re, je, Ie, Ne, Ze, 15, I[58]), Ne = fe(Ne, Re, je, Ie, ro, 21, I[59]), Ie = fe(Ie, Ne, Re, je, ke, 6, I[60]), je = fe(je, Ie, Ne, Re, on, 10, I[61]), Re = fe(Re, je, Ie, Ne, ft, 15, I[62]), Ne = fe(Ne, Re, je, Ie, kt, 21, I[63]), be[0] = be[0] + Ie | 0, be[1] = be[1] + Ne | 0, be[2] = be[2] + Re | 0, be[3] = be[3] + je | 0;
          }, _doFinalize: function() {
            var ye = this._data, Y = ye.words, he = 8 * this._nDataBytes, _e = 8 * ye.sigBytes;
            Y[_e >>> 5] |= 128 << 24 - _e % 32;
            var Ee = y.floor(he / 4294967296), be = he;
            Y[15 + (_e + 64 >>> 9 << 4)] = 16711935 & (Ee << 8 | Ee >>> 24) | 4278255360 & (Ee << 24 | Ee >>> 8), Y[14 + (_e + 64 >>> 9 << 4)] = 16711935 & (be << 8 | be >>> 24) | 4278255360 & (be << 24 | be >>> 8), ye.sigBytes = 4 * (Y.length + 1), this._process();
            for (var We = this._hash, Ye = We.words, ft = 0; ft < 4; ft++) {
              var nt = Ye[ft];
              Ye[ft] = 16711935 & (nt << 8 | nt >>> 24) | 4278255360 & (nt << 24 | nt >>> 8);
            }
            return We;
          }, clone: function() {
            var ye = R.clone.call(this);
            return ye._hash = this._hash.clone(), ye;
          } });
          function Q(ye, Y, he, _e, Ee, be, We) {
            var Ye = ye + (Y & he | ~Y & _e) + Ee + We;
            return (Ye << be | Ye >>> 32 - be) + Y;
          }
          function oe(ye, Y, he, _e, Ee, be, We) {
            var Ye = ye + (Y & _e | he & ~_e) + Ee + We;
            return (Ye << be | Ye >>> 32 - be) + Y;
          }
          function Z(ye, Y, he, _e, Ee, be, We) {
            var Ye = ye + (Y ^ he ^ _e) + Ee + We;
            return (Ye << be | Ye >>> 32 - be) + Y;
          }
          function fe(ye, Y, he, _e, Ee, be, We) {
            var Ye = ye + (he ^ (Y | ~_e)) + Ee + We;
            return (Ye << be | Ye >>> 32 - be) + Y;
          }
          O.MD5 = R._createHelper(X), O.HmacMD5 = R._createHmacHelper(X);
        }(Math), m.MD5);
      }(qI)), Rg;
    }
    var yy, jg = {}, GI = { get exports() {
      return jg;
    }, set exports(p) {
      jg = p;
    } }, Mg = {}, WI = { get exports() {
      return Mg;
    }, set exports(p) {
      Mg = p;
    } };
    function VI() {
      return yy || (yy = 1, function(p, g) {
        var m, y, O, C, T, R, B, I;
        p.exports = (I = Qi(), y = (m = I).lib, O = y.WordArray, C = y.Hasher, T = m.algo, R = [], B = T.SHA1 = C.extend({ _doReset: function() {
          this._hash = new O.init([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
        }, _doProcessBlock: function(X, Q) {
          for (var oe = this._hash.words, Z = oe[0], fe = oe[1], ye = oe[2], Y = oe[3], he = oe[4], _e = 0; _e < 80; _e++) {
            if (_e < 16)
              R[_e] = 0 | X[Q + _e];
            else {
              var Ee = R[_e - 3] ^ R[_e - 8] ^ R[_e - 14] ^ R[_e - 16];
              R[_e] = Ee << 1 | Ee >>> 31;
            }
            var be = (Z << 5 | Z >>> 27) + he + R[_e];
            be += _e < 20 ? 1518500249 + (fe & ye | ~fe & Y) : _e < 40 ? 1859775393 + (fe ^ ye ^ Y) : _e < 60 ? (fe & ye | fe & Y | ye & Y) - 1894007588 : (fe ^ ye ^ Y) - 899497514, he = Y, Y = ye, ye = fe << 30 | fe >>> 2, fe = Z, Z = be;
          }
          oe[0] = oe[0] + Z | 0, oe[1] = oe[1] + fe | 0, oe[2] = oe[2] + ye | 0, oe[3] = oe[3] + Y | 0, oe[4] = oe[4] + he | 0;
        }, _doFinalize: function() {
          var X = this._data, Q = X.words, oe = 8 * this._nDataBytes, Z = 8 * X.sigBytes;
          return Q[Z >>> 5] |= 128 << 24 - Z % 32, Q[14 + (Z + 64 >>> 9 << 4)] = Math.floor(oe / 4294967296), Q[15 + (Z + 64 >>> 9 << 4)] = oe, X.sigBytes = 4 * Q.length, this._process(), this._hash;
        }, clone: function() {
          var X = C.clone.call(this);
          return X._hash = this._hash.clone(), X;
        } }), m.SHA1 = C._createHelper(B), m.HmacSHA1 = C._createHmacHelper(B), I.SHA1);
      }(WI)), Mg;
    }
    var by, vy, Ey = {}, HI = { get exports() {
      return Ey;
    }, set exports(p) {
      Ey = p;
    } };
    function $y() {
      return vy || (vy = 1, function(p, g) {
        var m, y, O, C, T, R, B, I;
        p.exports = (I = Qi(), VI(), by || (by = 1, function(X, Q) {
          var oe;
          X.exports = (oe = Qi(), void function() {
            var Z = oe, fe = Z.lib.Base, ye = Z.enc.Utf8;
            Z.algo.HMAC = fe.extend({ init: function(Y, he) {
              Y = this._hasher = new Y.init(), typeof he == "string" && (he = ye.parse(he));
              var _e = Y.blockSize, Ee = 4 * _e;
              he.sigBytes > Ee && (he = Y.finalize(he)), he.clamp();
              for (var be = this._oKey = he.clone(), We = this._iKey = he.clone(), Ye = be.words, ft = We.words, nt = 0; nt < _e; nt++)
                Ye[nt] ^= 1549556828, ft[nt] ^= 909522486;
              be.sigBytes = We.sigBytes = Ee, this.reset();
            }, reset: function() {
              var Y = this._hasher;
              Y.reset(), Y.update(this._iKey);
            }, update: function(Y) {
              return this._hasher.update(Y), this;
            }, finalize: function(Y) {
              var he = this._hasher, _e = he.finalize(Y);
              return he.reset(), he.finalize(this._oKey.clone().concat(_e));
            } });
          }());
        }(HI)), y = (m = I).lib, O = y.Base, C = y.WordArray, T = m.algo, R = T.MD5, B = T.EvpKDF = O.extend({ cfg: O.extend({ keySize: 4, hasher: R, iterations: 1 }), init: function(X) {
          this.cfg = this.cfg.extend(X);
        }, compute: function(X, Q) {
          for (var oe = this.cfg, Z = oe.hasher.create(), fe = C.create(), ye = fe.words, Y = oe.keySize, he = oe.iterations; ye.length < Y; ) {
            _e && Z.update(_e);
            var _e = Z.update(X).finalize(Q);
            Z.reset();
            for (var Ee = 1; Ee < he; Ee++)
              _e = Z.finalize(_e), Z.reset();
            fe.concat(_e);
          }
          return fe.sigBytes = 4 * Y, fe;
        } }), m.EvpKDF = function(X, Q, oe) {
          return B.create(oe).compute(X, Q);
        }, I.EvpKDF);
      }(GI)), jg;
    }
    var wy, ky = {}, zI = { get exports() {
      return ky;
    }, set exports(p) {
      ky = p;
    } };
    (function(p, g) {
      var m;
      p.exports = (m = Qi(), LI(), UI(), $y(), wy || (wy = 1, function(y, O) {
        var C;
        y.exports = (C = Qi(), $y(), void (C.lib.Cipher || function(T) {
          var R = C, B = R.lib, I = B.Base, X = B.WordArray, Q = B.BufferedBlockAlgorithm, oe = R.enc;
          oe.Utf8;
          var Z = oe.Base64, fe = R.algo.EvpKDF, ye = B.Cipher = Q.extend({ cfg: I.extend(), createEncryptor: function(ke, Se) {
            return this.create(this._ENC_XFORM_MODE, ke, Se);
          }, createDecryptor: function(ke, Se) {
            return this.create(this._DEC_XFORM_MODE, ke, Se);
          }, init: function(ke, Se, Ze) {
            this.cfg = this.cfg.extend(Ze), this._xformMode = ke, this._key = Se, this.reset();
          }, reset: function() {
            Q.reset.call(this), this._doReset();
          }, process: function(ke) {
            return this._append(ke), this._process();
          }, finalize: function(ke) {
            return ke && this._append(ke), this._doFinalize();
          }, keySize: 4, ivSize: 4, _ENC_XFORM_MODE: 1, _DEC_XFORM_MODE: 2, _createHelper: function() {
            function ke(Se) {
              return typeof Se == "string" ? nt : Ye;
            }
            return function(Se) {
              return { encrypt: function(Ze, Le, gt) {
                return ke(Le).encrypt(Se, Ze, Le, gt);
              }, decrypt: function(Ze, Le, gt) {
                return ke(Le).decrypt(Se, Ze, Le, gt);
              } };
            };
          }() });
          B.StreamCipher = ye.extend({ _doFinalize: function() {
            return this._process(!0);
          }, blockSize: 1 });
          var Y = R.mode = {}, he = B.BlockCipherMode = I.extend({ createEncryptor: function(ke, Se) {
            return this.Encryptor.create(ke, Se);
          }, createDecryptor: function(ke, Se) {
            return this.Decryptor.create(ke, Se);
          }, init: function(ke, Se) {
            this._cipher = ke, this._iv = Se;
          } }), _e = Y.CBC = function() {
            var ke = he.extend();
            function Se(Ze, Le, gt) {
              var kt = this._iv;
              if (kt) {
                var Yt = kt;
                this._iv = T;
              } else
                Yt = this._prevBlock;
              for (var on = 0; on < gt; on++)
                Ze[Le + on] ^= Yt[on];
            }
            return ke.Encryptor = ke.extend({ processBlock: function(Ze, Le) {
              var gt = this._cipher, kt = gt.blockSize;
              Se.call(this, Ze, Le, kt), gt.encryptBlock(Ze, Le), this._prevBlock = Ze.slice(Le, Le + kt);
            } }), ke.Decryptor = ke.extend({ processBlock: function(Ze, Le) {
              var gt = this._cipher, kt = gt.blockSize, Yt = Ze.slice(Le, Le + kt);
              gt.decryptBlock(Ze, Le), Se.call(this, Ze, Le, kt), this._prevBlock = Yt;
            } }), ke;
          }(), Ee = (R.pad = {}).Pkcs7 = { pad: function(ke, Se) {
            for (var Ze = 4 * Se, Le = Ze - ke.sigBytes % Ze, gt = Le << 24 | Le << 16 | Le << 8 | Le, kt = [], Yt = 0; Yt < Le; Yt += 4)
              kt.push(gt);
            var on = X.create(kt, Le);
            ke.concat(on);
          }, unpad: function(ke) {
            var Se = 255 & ke.words[ke.sigBytes - 1 >>> 2];
            ke.sigBytes -= Se;
          } };
          B.BlockCipher = ye.extend({ cfg: ye.cfg.extend({ mode: _e, padding: Ee }), reset: function() {
            ye.reset.call(this);
            var ke = this.cfg, Se = ke.iv, Ze = ke.mode;
            if (this._xformMode == this._ENC_XFORM_MODE)
              var Le = Ze.createEncryptor;
            else
              Le = Ze.createDecryptor, this._minBufferSize = 1;
            this._mode && this._mode.__creator == Le ? this._mode.init(this, Se && Se.words) : (this._mode = Le.call(Ze, this, Se && Se.words), this._mode.__creator = Le);
          }, _doProcessBlock: function(ke, Se) {
            this._mode.processBlock(ke, Se);
          }, _doFinalize: function() {
            var ke = this.cfg.padding;
            if (this._xformMode == this._ENC_XFORM_MODE) {
              ke.pad(this._data, this.blockSize);
              var Se = this._process(!0);
            } else
              Se = this._process(!0), ke.unpad(Se);
            return Se;
          }, blockSize: 4 });
          var be = B.CipherParams = I.extend({ init: function(ke) {
            this.mixIn(ke);
          }, toString: function(ke) {
            return (ke || this.formatter).stringify(this);
          } }), We = (R.format = {}).OpenSSL = { stringify: function(ke) {
            var Se = ke.ciphertext, Ze = ke.salt;
            if (Ze)
              var Le = X.create([1398893684, 1701076831]).concat(Ze).concat(Se);
            else
              Le = Se;
            return Le.toString(Z);
          }, parse: function(ke) {
            var Se = Z.parse(ke), Ze = Se.words;
            if (Ze[0] == 1398893684 && Ze[1] == 1701076831) {
              var Le = X.create(Ze.slice(2, 4));
              Ze.splice(0, 4), Se.sigBytes -= 16;
            }
            return be.create({ ciphertext: Se, salt: Le });
          } }, Ye = B.SerializableCipher = I.extend({ cfg: I.extend({ format: We }), encrypt: function(ke, Se, Ze, Le) {
            Le = this.cfg.extend(Le);
            var gt = ke.createEncryptor(Ze, Le), kt = gt.finalize(Se), Yt = gt.cfg;
            return be.create({ ciphertext: kt, key: Ze, iv: Yt.iv, algorithm: ke, mode: Yt.mode, padding: Yt.padding, blockSize: ke.blockSize, formatter: Le.format });
          }, decrypt: function(ke, Se, Ze, Le) {
            return Le = this.cfg.extend(Le), Se = this._parse(Se, Le.format), ke.createDecryptor(Ze, Le).finalize(Se.ciphertext);
          }, _parse: function(ke, Se) {
            return typeof ke == "string" ? Se.parse(ke, this) : ke;
          } }), ft = (R.kdf = {}).OpenSSL = { execute: function(ke, Se, Ze, Le) {
            Le || (Le = X.random(8));
            var gt = fe.create({ keySize: Se + Ze }).compute(ke, Le), kt = X.create(gt.words.slice(Se), 4 * Ze);
            return gt.sigBytes = 4 * Se, be.create({ key: gt, iv: kt, salt: Le });
          } }, nt = B.PasswordBasedCipher = Ye.extend({ cfg: Ye.cfg.extend({ kdf: ft }), encrypt: function(ke, Se, Ze, Le) {
            var gt = (Le = this.cfg.extend(Le)).kdf.execute(Ze, ke.keySize, ke.ivSize);
            Le.iv = gt.iv;
            var kt = Ye.encrypt.call(this, ke, Se, gt.key, Le);
            return kt.mixIn(gt), kt;
          }, decrypt: function(ke, Se, Ze, Le) {
            Le = this.cfg.extend(Le), Se = this._parse(Se, Le.format);
            var gt = Le.kdf.execute(Ze, ke.keySize, ke.ivSize, Se.salt);
            return Le.iv = gt.iv, Ye.decrypt.call(this, ke, Se, gt.key, Le);
          } });
        }()));
      }(zI)), function() {
        var y = m, O = y.lib.BlockCipher, C = y.algo, T = [], R = [], B = [], I = [], X = [], Q = [], oe = [], Z = [], fe = [], ye = [];
        (function() {
          for (var _e = [], Ee = 0; Ee < 256; Ee++)
            _e[Ee] = Ee < 128 ? Ee << 1 : Ee << 1 ^ 283;
          var be = 0, We = 0;
          for (Ee = 0; Ee < 256; Ee++) {
            var Ye = We ^ We << 1 ^ We << 2 ^ We << 3 ^ We << 4;
            Ye = Ye >>> 8 ^ 255 & Ye ^ 99, T[be] = Ye, R[Ye] = be;
            var ft = _e[be], nt = _e[ft], ke = _e[nt], Se = 257 * _e[Ye] ^ 16843008 * Ye;
            B[be] = Se << 24 | Se >>> 8, I[be] = Se << 16 | Se >>> 16, X[be] = Se << 8 | Se >>> 24, Q[be] = Se, Se = 16843009 * ke ^ 65537 * nt ^ 257 * ft ^ 16843008 * be, oe[Ye] = Se << 24 | Se >>> 8, Z[Ye] = Se << 16 | Se >>> 16, fe[Ye] = Se << 8 | Se >>> 24, ye[Ye] = Se, be ? (be = ft ^ _e[_e[_e[ke ^ ft]]], We ^= _e[_e[We]]) : be = We = 1;
          }
        })();
        var Y = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], he = C.AES = O.extend({ _doReset: function() {
          if (!this._nRounds || this._keyPriorReset !== this._key) {
            for (var _e = this._keyPriorReset = this._key, Ee = _e.words, be = _e.sigBytes / 4, We = 4 * ((this._nRounds = be + 6) + 1), Ye = this._keySchedule = [], ft = 0; ft < We; ft++)
              if (ft < be)
                Ye[ft] = Ee[ft];
              else {
                var nt = Ye[ft - 1];
                ft % be ? be > 6 && ft % be == 4 && (nt = T[nt >>> 24] << 24 | T[nt >>> 16 & 255] << 16 | T[nt >>> 8 & 255] << 8 | T[255 & nt]) : (nt = T[(nt = nt << 8 | nt >>> 24) >>> 24] << 24 | T[nt >>> 16 & 255] << 16 | T[nt >>> 8 & 255] << 8 | T[255 & nt], nt ^= Y[ft / be | 0] << 24), Ye[ft] = Ye[ft - be] ^ nt;
              }
            for (var ke = this._invKeySchedule = [], Se = 0; Se < We; Se++)
              ft = We - Se, nt = Se % 4 ? Ye[ft] : Ye[ft - 4], ke[Se] = Se < 4 || ft <= 4 ? nt : oe[T[nt >>> 24]] ^ Z[T[nt >>> 16 & 255]] ^ fe[T[nt >>> 8 & 255]] ^ ye[T[255 & nt]];
          }
        }, encryptBlock: function(_e, Ee) {
          this._doCryptBlock(_e, Ee, this._keySchedule, B, I, X, Q, T);
        }, decryptBlock: function(_e, Ee) {
          var be = _e[Ee + 1];
          _e[Ee + 1] = _e[Ee + 3], _e[Ee + 3] = be, this._doCryptBlock(_e, Ee, this._invKeySchedule, oe, Z, fe, ye, R), be = _e[Ee + 1], _e[Ee + 1] = _e[Ee + 3], _e[Ee + 3] = be;
        }, _doCryptBlock: function(_e, Ee, be, We, Ye, ft, nt, ke) {
          for (var Se = this._nRounds, Ze = _e[Ee] ^ be[0], Le = _e[Ee + 1] ^ be[1], gt = _e[Ee + 2] ^ be[2], kt = _e[Ee + 3] ^ be[3], Yt = 4, on = 1; on < Se; on++) {
            var to = We[Ze >>> 24] ^ Ye[Le >>> 16 & 255] ^ ft[gt >>> 8 & 255] ^ nt[255 & kt] ^ be[Yt++], ro = We[Le >>> 24] ^ Ye[gt >>> 16 & 255] ^ ft[kt >>> 8 & 255] ^ nt[255 & Ze] ^ be[Yt++], no = We[gt >>> 24] ^ Ye[kt >>> 16 & 255] ^ ft[Ze >>> 8 & 255] ^ nt[255 & Le] ^ be[Yt++], ao = We[kt >>> 24] ^ Ye[Ze >>> 16 & 255] ^ ft[Le >>> 8 & 255] ^ nt[255 & gt] ^ be[Yt++];
            Ze = to, Le = ro, gt = no, kt = ao;
          }
          to = (ke[Ze >>> 24] << 24 | ke[Le >>> 16 & 255] << 16 | ke[gt >>> 8 & 255] << 8 | ke[255 & kt]) ^ be[Yt++], ro = (ke[Le >>> 24] << 24 | ke[gt >>> 16 & 255] << 16 | ke[kt >>> 8 & 255] << 8 | ke[255 & Ze]) ^ be[Yt++], no = (ke[gt >>> 24] << 24 | ke[kt >>> 16 & 255] << 16 | ke[Ze >>> 8 & 255] << 8 | ke[255 & Le]) ^ be[Yt++], ao = (ke[kt >>> 24] << 24 | ke[Ze >>> 16 & 255] << 16 | ke[Le >>> 8 & 255] << 8 | ke[255 & gt]) ^ be[Yt++], _e[Ee] = to, _e[Ee + 1] = ro, _e[Ee + 2] = no, _e[Ee + 3] = ao;
        }, keySize: 8 });
        y.AES = O._createHelper(he);
      }(), m.AES);
    })({ get exports() {
      return Tg;
    }, set exports(p) {
      Tg = p;
    } });
    var xy = Tg, Bg = {};
    (function(p, g) {
      p.exports = Qi().enc.Utf8;
    })({ get exports() {
      return Bg;
    }, set exports(p) {
      Bg = p;
    } });
    var KI = Bg, Ng = typeof un < "u" ? un : typeof self < "u" ? self : typeof window < "u" ? window : {};
    function Dy() {
      throw new Error("setTimeout has not been defined");
    }
    function Cy() {
      throw new Error("clearTimeout has not been defined");
    }
    var Zi = Dy, Ji = Cy;
    function Sy(p) {
      if (Zi === setTimeout)
        return setTimeout(p, 0);
      if ((Zi === Dy || !Zi) && setTimeout)
        return Zi = setTimeout, setTimeout(p, 0);
      try {
        return Zi(p, 0);
      } catch {
        try {
          return Zi.call(null, p, 0);
        } catch {
          return Zi.call(this, p, 0);
        }
      }
    }
    typeof Ng.setTimeout == "function" && (Zi = setTimeout), typeof Ng.clearTimeout == "function" && (Ji = clearTimeout);
    var Bo, hi = [], Ys = !1, Pc = -1;
    function YI() {
      Ys && Bo && (Ys = !1, Bo.length ? hi = Bo.concat(hi) : Pc = -1, hi.length && Ay());
    }
    function Ay() {
      if (!Ys) {
        var p = Sy(YI);
        Ys = !0;
        for (var g = hi.length; g; ) {
          for (Bo = hi, hi = []; ++Pc < g; )
            Bo && Bo[Pc].run();
          Pc = -1, g = hi.length;
        }
        Bo = null, Ys = !1, function(m) {
          if (Ji === clearTimeout)
            return clearTimeout(m);
          if ((Ji === Cy || !Ji) && clearTimeout)
            return Ji = clearTimeout, clearTimeout(m);
          try {
            Ji(m);
          } catch {
            try {
              return Ji.call(null, m);
            } catch {
              return Ji.call(this, m);
            }
          }
        }(p);
      }
    }
    function Oy(p, g) {
      this.fun = p, this.array = g;
    }
    Oy.prototype.run = function() {
      this.fun.apply(null, this.array);
    };
    function No() {
    }
    var XI = No, QI = No, ZI = No, JI = No, eR = No, tR = No, rR = No, Xs = Ng.performance || {}, nR = Xs.now || Xs.mozNow || Xs.msNow || Xs.oNow || Xs.webkitNow || function() {
      return new Date().getTime();
    }, aR = new Date(), Lg, Ty, qg = { nextTick: function(p) {
      var g = new Array(arguments.length - 1);
      if (arguments.length > 1)
        for (var m = 1; m < arguments.length; m++)
          g[m - 1] = arguments[m];
      hi.push(new Oy(p, g)), hi.length !== 1 || Ys || Sy(Ay);
    }, title: "browser", browser: !0, env: {}, argv: [], version: "", versions: {}, on: XI, addListener: QI, once: ZI, off: JI, removeListener: eR, removeAllListeners: tR, emit: rR, binding: function(p) {
      throw new Error("process.binding is not supported");
    }, cwd: function() {
      return "/";
    }, chdir: function(p) {
      throw new Error("process.chdir is not supported");
    }, umask: function() {
      return 0;
    }, hrtime: function(p) {
      var g = 1e-3 * nR.call(Xs), m = Math.floor(g), y = Math.floor(g % 1 * 1e9);
      return p && (m -= p[0], (y -= p[1]) < 0 && (m--, y += 1e9)), [m, y];
    }, platform: "browser", release: {}, config: {}, uptime: function() {
      return (new Date() - aR) / 1e3;
    } }, Qs = {};
    function iR() {
      if (Ty)
        return Lg;
      Ty = 1;
      var p = 1e3, g = 60 * p, m = 60 * g, y = 24 * m, O = 7 * y, C = 365.25 * y;
      function T(R, B, I, X) {
        var Q = B >= 1.5 * I;
        return Math.round(R / I) + " " + X + (Q ? "s" : "");
      }
      return Lg = function(R, B) {
        B = B || {};
        var I = i(R);
        if (I === "string" && R.length > 0)
          return function(X) {
            if (!((X = String(X)).length > 100)) {
              var Q = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(X);
              if (Q) {
                var oe = parseFloat(Q[1]);
                switch ((Q[2] || "ms").toLowerCase()) {
                  case "years":
                  case "year":
                  case "yrs":
                  case "yr":
                  case "y":
                    return oe * C;
                  case "weeks":
                  case "week":
                  case "w":
                    return oe * O;
                  case "days":
                  case "day":
                  case "d":
                    return oe * y;
                  case "hours":
                  case "hour":
                  case "hrs":
                  case "hr":
                  case "h":
                    return oe * m;
                  case "minutes":
                  case "minute":
                  case "mins":
                  case "min":
                  case "m":
                    return oe * g;
                  case "seconds":
                  case "second":
                  case "secs":
                  case "sec":
                  case "s":
                    return oe * p;
                  case "milliseconds":
                  case "millisecond":
                  case "msecs":
                  case "msec":
                  case "ms":
                    return oe;
                  default:
                    return;
                }
              }
            }
          }(R);
        if (I === "number" && isFinite(R))
          return B.long ? function(X) {
            var Q = Math.abs(X);
            return Q >= y ? T(X, Q, y, "day") : Q >= m ? T(X, Q, m, "hour") : Q >= g ? T(X, Q, g, "minute") : Q >= p ? T(X, Q, p, "second") : X + " ms";
          }(R) : function(X) {
            var Q = Math.abs(X);
            return Q >= y ? Math.round(X / y) + "d" : Q >= m ? Math.round(X / m) + "h" : Q >= g ? Math.round(X / g) + "m" : Q >= p ? Math.round(X / p) + "s" : X + "ms";
          }(R);
        throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(R));
      }, Lg;
    }
    var oR = function(p) {
      function g(O) {
        var C, T, R, B = null;
        function I() {
          for (var X = arguments.length, Q = new Array(X), oe = 0; oe < X; oe++)
            Q[oe] = arguments[oe];
          if (I.enabled) {
            var Z = I, fe = Number(new Date()), ye = fe - (C || fe);
            Z.diff = ye, Z.prev = C, Z.curr = fe, C = fe, Q[0] = g.coerce(Q[0]), typeof Q[0] != "string" && Q.unshift("%O");
            var Y = 0;
            Q[0] = Q[0].replace(/%([a-zA-Z%])/g, function(_e, Ee) {
              if (_e === "%%")
                return "%";
              Y++;
              var be = g.formatters[Ee];
              if (typeof be == "function") {
                var We = Q[Y];
                _e = be.call(Z, We), Q.splice(Y, 1), Y--;
              }
              return _e;
            }), g.formatArgs.call(Z, Q);
            var he = Z.log || g.log;
            he.apply(Z, Q);
          }
        }
        return I.namespace = O, I.useColors = g.useColors(), I.color = g.selectColor(O), I.extend = m, I.destroy = g.destroy, Object.defineProperty(I, "enabled", { enumerable: !0, configurable: !1, get: function() {
          return B !== null ? B : (T !== g.namespaces && (T = g.namespaces, R = g.enabled(O)), R);
        }, set: function(X) {
          B = X;
        } }), typeof g.init == "function" && g.init(I), I;
      }
      function m(O, C) {
        var T = g(this.namespace + (C === void 0 ? ":" : C) + O);
        return T.log = this.log, T;
      }
      function y(O) {
        return O.toString().substring(2, O.toString().length - 2).replace(/\.\*\?$/, "*");
      }
      return g.debug = g, g.default = g, g.coerce = function(O) {
        return O instanceof Error ? O.stack || O.message : O;
      }, g.disable = function() {
        var O = [].concat(f(g.names.map(y)), f(g.skips.map(y).map(function(C) {
          return "-" + C;
        }))).join(",");
        return g.enable(""), O;
      }, g.enable = function(O) {
        var C;
        g.save(O), g.namespaces = O, g.names = [], g.skips = [];
        var T = (typeof O == "string" ? O : "").split(/[\s,]+/), R = T.length;
        for (C = 0; C < R; C++)
          T[C] && ((O = T[C].replace(/\*/g, ".*?"))[0] === "-" ? g.skips.push(new RegExp("^" + O.slice(1) + "$")) : g.names.push(new RegExp("^" + O + "$")));
      }, g.enabled = function(O) {
        if (O[O.length - 1] === "*")
          return !0;
        var C, T;
        for (C = 0, T = g.skips.length; C < T; C++)
          if (g.skips[C].test(O))
            return !1;
        for (C = 0, T = g.names.length; C < T; C++)
          if (g.names[C].test(O))
            return !0;
        return !1;
      }, g.humanize = iR(), g.destroy = function() {
        console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
      }, Object.keys(p).forEach(function(O) {
        g[O] = p[O];
      }), g.names = [], g.skips = [], g.formatters = {}, g.selectColor = function(O) {
        for (var C = 0, T = 0; T < O.length; T++)
          C = (C << 5) - C + O.charCodeAt(T), C |= 0;
        return g.colors[Math.abs(C) % g.colors.length];
      }, g.enable(g.load()), g;
    };
    (function(p, g) {
      var m;
      g.formatArgs = function(y) {
        if (y[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + y[0] + (this.useColors ? "%c " : " ") + "+" + p.exports.humanize(this.diff), !!this.useColors) {
          var O = "color: " + this.color;
          y.splice(1, 0, O, "color: inherit");
          var C = 0, T = 0;
          y[0].replace(/%[a-zA-Z%]/g, function(R) {
            R !== "%%" && (C++, R === "%c" && (T = C));
          }), y.splice(T, 0, O);
        }
      }, g.save = function(y) {
        try {
          y ? g.storage.setItem("debug", y) : g.storage.removeItem("debug");
        } catch {
        }
      }, g.load = function() {
        var y;
        try {
          y = g.storage.getItem("debug");
        } catch {
        }
        return !y && qg !== void 0 && "env" in qg && (y = qg.env.DEBUG), y;
      }, g.useColors = function() {
        return typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs) ? !0 : typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
      }, g.storage = function() {
        try {
          return localStorage;
        } catch {
        }
      }(), g.destroy = (m = !1, function() {
        m || (m = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
      }), g.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], g.log = console.debug || console.log || function() {
      }, p.exports = oR(g), p.exports.formatters.j = function(y) {
        try {
          return JSON.stringify(y);
        } catch (O) {
          return "[UnexpectedJSONParseError]: " + O.message;
        }
      };
    })({ get exports() {
      return Qs;
    }, set exports(p) {
      Qs = p;
    } }, Qs);
    var Py = Qs("cookie"), Ug = function(p, g, m) {
      switch (arguments.length) {
        case 3:
        case 2:
          return sR(p, g, m);
        case 1:
          return uR(p);
        default:
          return Iy();
      }
    };
    function sR(p, g, m) {
      m = m || {};
      var y = Ry(p) + "=" + Ry(g);
      g == null && (m.maxage = -1), m.maxage && (m.expires = new Date(+new Date() + m.maxage)), m.path && (y += "; path=" + m.path), m.domain && (y += "; domain=" + m.domain), m.expires && (y += "; expires=" + m.expires.toUTCString()), m.samesite && (y += "; samesite=" + m.samesite), m.secure && (y += "; secure"), document.cookie = y;
    }
    function Iy() {
      var p;
      try {
        p = document.cookie;
      } catch (g) {
        return typeof console < "u" && typeof console.error == "function" && console.error(g.stack || g), {};
      }
      return function(g) {
        var m, y = {}, O = g.split(/ *; */);
        if (O[0] == "")
          return y;
        for (var C = 0; C < O.length; ++C)
          y[jy((m = O[C].split("="))[0])] = jy(m[1]);
        return y;
      }(p);
    }
    function uR(p) {
      return Iy()[p];
    }
    function Ry(p) {
      try {
        return encodeURIComponent(p);
      } catch (g) {
        Py("error `encode(%o)` - %o", p, g);
      }
    }
    function jy(p) {
      try {
        return decodeURIComponent(p);
      } catch (g) {
        Py("error `decode(%o)` - %o", p, g);
      }
    }
    var Od = {}, dR = { get exports() {
      return Od;
    }, set exports(p) {
      Od = p;
    } }, My = Math.max, lR = function(p, g) {
      var m = g ? g.length : 0;
      if (!m)
        return [];
      for (var y = My(Number(p) || 0, 0), O = My(m - y, 0), C = new Array(O), T = 0; T < O; T += 1)
        C[T] = g[T + y];
      return C;
    }, fR = Math.max, cR = function(p) {
      if (p == null || !p.length)
        return [];
      for (var g = new Array(fR(p.length - 2, 0)), m = 1; m < p.length; m += 1)
        g[m - 1] = p[m];
      return g;
    }, hR = lR, By = cR, Ny = Object.prototype.hasOwnProperty, gR = Object.prototype.toString, _R = function(p) {
      return Boolean(p) && i(p) === "object";
    }, Ly = function(p) {
      return Boolean(p) && gR.call(p) === "[object Object]";
    }, mR = function(p, g, m, y) {
      return Ny.call(g, y) && p[y] === void 0 && (p[y] = m), g;
    }, pR = function(p, g, m, y) {
      return Ny.call(g, y) && (Ly(p[y]) && Ly(m) ? p[y] = Uy(p[y], m) : p[y] === void 0 && (p[y] = m)), g;
    }, qy = function(p, g) {
      if (!_R(g))
        return g;
      p = p || mR;
      for (var m = hR(2, arguments), y = 0; y < m.length; y += 1)
        for (var O in m[y])
          p(g, m[y], m[y][O], O);
      return g;
    }, Uy = function(p) {
      return qy.apply(null, [pR, p].concat(By(arguments)));
    };
    dR.exports = function(p) {
      return qy.apply(null, [null, p].concat(By(arguments)));
    }, Od.deep = Uy;
    var Ic = {}, FR = { get exports() {
      return Ic;
    }, set exports(p) {
      Ic = p;
    } }, Gy = Qs("cookie"), yR = function(p, g, m) {
      switch (arguments.length) {
        case 3:
        case 2:
          return bR(p, g, m);
        case 1:
          return vR(p);
        default:
          return Wy();
      }
    };
    function bR(p, g, m) {
      m = m || {};
      var y = Vy(p) + "=" + Vy(g);
      g == null && (m.maxage = -1), m.maxage && (m.expires = new Date(+new Date() + m.maxage)), m.path && (y += "; path=" + m.path), m.domain && (y += "; domain=" + m.domain), m.expires && (y += "; expires=" + m.expires.toUTCString()), m.secure && (y += "; secure"), document.cookie = y;
    }
    function Wy() {
      var p;
      try {
        p = document.cookie;
      } catch (g) {
        return typeof console < "u" && typeof console.error == "function" && console.error(g.stack || g), {};
      }
      return function(g) {
        var m, y = {}, O = g.split(/ *; */);
        if (O[0] == "")
          return y;
        for (var C = 0; C < O.length; ++C)
          y[Hy((m = O[C].split("="))[0])] = Hy(m[1]);
        return y;
      }(p);
    }
    function vR(p) {
      return Wy()[p];
    }
    function Vy(p) {
      try {
        return encodeURIComponent(p);
      } catch (g) {
        Gy("error `encode(%o)` - %o", p, g);
      }
    }
    function Hy(p) {
      try {
        return decodeURIComponent(p);
      } catch (g) {
        Gy("error `decode(%o)` - %o", p, g);
      }
    }
    (function(p, g) {
      var m = de.parse, y = yR;
      function O(C) {
        for (var T = g.cookie, R = g.levels(C), B = 0; B < R.length; ++B) {
          var I = "__tld__", X = R[B], Q = { domain: "." + X };
          if (T(I, 1, Q), T(I))
            return T(I, null, Q), X;
        }
        return "";
      }
      O.levels = function(C) {
        var T = m(C).hostname.split("."), R = T[T.length - 1], B = [];
        if (T.length === 4 && R === parseInt(R, 10) || T.length <= 1)
          return B;
        for (var I = T.length - 2; I >= 0; --I)
          B.push(T.slice(I).join("."));
        return B;
      }, O.cookie = y, g = p.exports = O;
    })(FR, Ic);
    var ER = Ic, $R = function() {
      function p(g) {
        o(this, p), this.cOpts = {}, this.options(g), this.isSupportAvailable = this.checkSupportAvailability();
      }
      return d(p, [{ key: "options", value: function() {
        var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (arguments.length === 0)
          return this.cOpts;
        var m = ".".concat(ER(window.location.href));
        return m === "." && (m = null), this.cOpts = Od(g, { maxage: 31536e6, path: "/", domain: m, samesite: "Lax" }), this.cOpts;
      } }, { key: "set", value: function(g, m) {
        try {
          return Ug(g, m, j(this.cOpts)), !0;
        } catch (y) {
          return Cr(y), !1;
        }
      } }, { key: "get", value: function(g) {
        return Ug(g);
      } }, { key: "remove", value: function(g) {
        try {
          return Ug(g, null, j(this.cOpts)), !0;
        } catch {
          return !1;
        }
      } }, { key: "checkSupportAvailability", value: function() {
        var g = "test_rudder_cookie";
        return this.set(g, !0), !!this.get(g) && (this.remove(g), !0);
      } }]), p;
    }(), Rc = new $R({}), Gg = {};
    (function(p, g) {
      p.exports = function() {
        var m = window.localStorage;
        function y(Z) {
          return Z = JSON.stringify(Z), !!/^\{[\s\S]*\}$/.test(Z);
        }
        function O(Z) {
          return Z === void 0 || typeof Z == "function" ? Z + "" : JSON.stringify(Z);
        }
        function C(Z) {
          if (typeof Z == "string")
            try {
              return JSON.parse(Z);
            } catch {
              return Z;
            }
        }
        function T(Z) {
          return {}.toString.call(Z) === "[object Function]";
        }
        function R(Z) {
          return Object.prototype.toString.call(Z) === "[object Array]";
        }
        function B(Z) {
          var fe = "_Is_Incognit", ye = "yes";
          try {
            Z.setItem(fe, ye);
          } catch (he) {
            if (he.name === "QuotaExceededError") {
              var Y = function() {
              };
              Z.__proto__ = { setItem: Y, getItem: Y, removeItem: Y, clear: Y };
            }
          } finally {
            Z.getItem(fe) === ye && Z.removeItem(fe);
          }
          return Z;
        }
        function I() {
          if (!(this instanceof I))
            return new I();
        }
        m = B(m), I.prototype = { set: function(Z, fe) {
          if (Z && !y(Z))
            m.setItem(Z, O(fe));
          else if (y(Z))
            for (var ye in Z)
              this.set(ye, Z[ye]);
          return this;
        }, get: function(Z) {
          if (!Z) {
            var fe = {};
            return this.forEach(function(be, We) {
              return fe[be] = We;
            }), fe;
          }
          if (Z.charAt(0) === "?")
            return this.has(Z.substr(1));
          var ye = arguments;
          if (ye.length > 1) {
            for (var Y = {}, he = 0, _e = ye.length; he < _e; he++) {
              var Ee = C(m.getItem(ye[he]));
              this.has(ye[he]) && (Y[ye[he]] = Ee);
            }
            return Y;
          }
          return C(m.getItem(Z));
        }, clear: function() {
          return m.clear(), this;
        }, remove: function(Z) {
          var fe = this.get(Z);
          return m.removeItem(Z), fe;
        }, has: function(Z) {
          return {}.hasOwnProperty.call(this.get(), Z);
        }, keys: function() {
          var Z = [];
          return this.forEach(function(fe) {
            Z.push(fe);
          }), Z;
        }, forEach: function(Z) {
          for (var fe = 0, ye = m.length; fe < ye; fe++) {
            var Y = m.key(fe);
            Z(Y, this.get(Y));
          }
          return this;
        }, search: function(Z) {
          for (var fe = this.keys(), ye = {}, Y = 0, he = fe.length; Y < he; Y++)
            fe[Y].indexOf(Z) > -1 && (ye[fe[Y]] = this.get(fe[Y]));
          return ye;
        } };
        var X = null;
        function Q(Z, fe) {
          var ye = arguments, Y = null;
          if (X || (X = I()), ye.length === 0)
            return X.get();
          if (ye.length === 1) {
            if (typeof Z == "string")
              return X.get(Z);
            if (y(Z))
              return X.set(Z);
          }
          if (ye.length === 2 && typeof Z == "string") {
            if (!fe)
              return X.remove(Z);
            if (fe && typeof fe == "string")
              return X.set(Z, fe);
            fe && T(fe) && (Y = null, Y = fe(Z, X.get(Z)), Q.set(Z, Y));
          }
          if (ye.length === 2 && R(Z) && T(fe))
            for (var he = 0, _e = Z.length; he < _e; he++)
              Y = fe(Z[he], X.get(Z[he])), Q.set(Z[he], Y);
          return Q;
        }
        for (var oe in I.prototype)
          Q[oe] = I.prototype[oe];
        return Q;
      }();
    })({ get exports() {
      return Gg;
    }, set exports(p) {
      Gg = p;
    } });
    var Wg = Gg, wR = function() {
      function p(g) {
        o(this, p), this.sOpts = {}, this.enabled = this.checkSupportAvailability(), this.options(g);
      }
      return d(p, [{ key: "options", value: function() {
        var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return arguments.length === 0 || (Od(g, { enabled: !0 }), this.enabled = g.enabled && this.enabled, this.sOpts = g), this.sOpts;
      } }, { key: "set", value: function(g, m) {
        return Wg.set(g, m);
      } }, { key: "get", value: function(g) {
        return Wg.get(g);
      } }, { key: "remove", value: function(g) {
        return Wg.remove(g);
      } }, { key: "checkSupportAvailability", value: function() {
        var g = "test_rudder_ls";
        return this.set(g, !0), !!this.get(g) && (this.remove(g), !0);
      } }]), p;
    }(), Td = new wR({}), Vg = "rl_user_id", Hg = "rl_trait", zg = "rl_anonymous_id", Kg = "rl_group_id", Yg = "rl_group_trait", zy = "rl_page_init_referrer", Ky = "rl_page_init_referring_domain", Xg = "rl_session", jc = "RudderEncrypt:", Yy = "Rudder", Qg = { segment: "ajs_anonymous_id" };
    function Xy(p) {
      try {
        return p ? JSON.parse(p) : null;
      } catch (g) {
        return Cr(g), p || null;
      }
    }
    function Qy(p) {
      return p.replace(/^\s+|\s+$/gm, "");
    }
    function Zy(p) {
      return !p || typeof p == "string" && Qy(p) === "" ? p : p.substring(0, jc.length) === jc ? xy.decrypt(p.substring(jc.length), Yy).toString(KI) : p;
    }
    var kR = function() {
      function p() {
        o(this, p), Rc.isSupportAvailable ? this.storage = Rc : (Td.enabled && (this.storage = Td), this.storage || Cr("No storage is available :: initializing the SDK without storage"));
      }
      return d(p, [{ key: "options", value: function() {
        var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        this.storage.options(g);
      } }, { key: "setItem", value: function(g, m) {
        this.storage.set(g, function(y) {
          return Qy(y) === "" ? y : "".concat(jc).concat(xy.encrypt(y, Yy).toString());
        }(function(y) {
          return JSON.stringify(y);
        }(m)));
      } }, { key: "setStringItem", value: function(g, m) {
        typeof m == "string" ? this.setItem(g, m) : Cr("[Storage] ".concat(g, " should be string"));
      } }, { key: "setUserId", value: function(g) {
        this.setStringItem(Vg, g);
      } }, { key: "setUserTraits", value: function(g) {
        this.setItem(Hg, g);
      } }, { key: "setGroupId", value: function(g) {
        this.setStringItem(Kg, g);
      } }, { key: "setGroupTraits", value: function(g) {
        this.setItem(Yg, g);
      } }, { key: "setAnonymousId", value: function(g) {
        this.setStringItem(zg, g);
      } }, { key: "setInitialReferrer", value: function(g) {
        this.setItem(zy, g);
      } }, { key: "setInitialReferringDomain", value: function(g) {
        this.setItem(Ky, g);
      } }, { key: "setSessionInfo", value: function(g) {
        this.setItem(Xg, g);
      } }, { key: "getItem", value: function(g) {
        return Xy(Zy(this.storage.get(g)));
      } }, { key: "getUserId", value: function() {
        return this.getItem(Vg);
      } }, { key: "getUserTraits", value: function() {
        return this.getItem(Hg);
      } }, { key: "getGroupId", value: function() {
        return this.getItem(Kg);
      } }, { key: "getGroupTraits", value: function() {
        return this.getItem(Yg);
      } }, { key: "fetchExternalAnonymousId", value: function(g) {
        var m, y = g.toLowerCase();
        return Object.keys(Qg).includes(y) && y === "segment" && (Td.enabled && (m = Td.get(Qg[y])), !m && Rc.isSupportAvailable && (m = Rc.get(Qg[y]))), m;
      } }, { key: "getAnonymousId", value: function(g) {
        var m = Xy(Zy(this.storage.get(zg)));
        if (m)
          return m;
        var y = ee(g, "autoCapture.source");
        if (ee(g, "autoCapture.enabled") === !0 && typeof y == "string") {
          var O = this.fetchExternalAnonymousId(y);
          if (O)
            return O;
        }
        return m;
      } }, { key: "getInitialReferrer", value: function() {
        return this.getItem(zy);
      } }, { key: "getInitialReferringDomain", value: function() {
        return this.getItem(Ky);
      } }, { key: "getSessionInfo", value: function() {
        return this.getItem(Xg);
      } }, { key: "removeItem", value: function(g) {
        return this.storage.remove(g);
      } }, { key: "removeSessionInfo", value: function() {
        this.removeItem(Xg);
      } }, { key: "clear", value: function(g) {
        this.storage.remove(Vg), this.storage.remove(Hg), this.storage.remove(Kg), this.storage.remove(Yg), g && this.storage.remove(zg);
      } }]), p;
    }(), Mc = new kR(), Jy = "RS_JS_SDK", Bc = function(p, g) {
      var m = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, y = document.getElementById(p);
      if (!y) {
        var O = document.createElement("script");
        O.src = g, O.async = m.async === void 0 || m.async, O.type = "text/javascript", O.id = p, m.skipDatasetAttributes !== !0 && (O.setAttribute("data-loader", Jy), m.isNonNativeSDK !== void 0 && O.setAttribute("data-isNonNativeSDK", m.isNonNativeSDK));
        var C = document.getElementsByTagName("head");
        if (C.length !== 0)
          C[0].insertBefore(O, C[0].firstChild);
        else {
          var T = document.getElementsByTagName("script")[0];
          T.parentNode.insertBefore(O, T);
        }
      }
    };
    function Oa(p) {
      window.rsBugsnagClient && window.rsBugsnagClient.leaveBreadcrumb(p);
    }
    function eb(p) {
      window.rsBugsnagClient && window.rsBugsnagClient.notify(p);
    }
    function pr(p, g, m) {
      var y;
      try {
        y = function(C, T, R) {
          var B;
          try {
            B = typeof C == "string" ? C : C instanceof Error || C.message ? C.message : JSON.stringify(C);
          } catch {
            B = "";
          }
          if (C instanceof Event) {
            if (C.target && C.target.localName !== "script" || C.target.dataset && (C.target.dataset.loader !== Jy || C.target.dataset.isNonNativeSDK !== "true"))
              return "";
            if (B = "error in script loading:: src::  ".concat(C.target.src, " id:: ").concat(C.target.id), C.target.id === "ad-block")
              return R.page("RudderJS-Initiated", "ad-block page request", { path: "/ad-blocked", title: B }, R.sendAdblockPageOptions), "";
          }
          return "[handleError]::".concat(T || "", ' "').concat(B, '"');
        }(p, g, m);
      } catch (C) {
        Cr("[handleError] Exception:: ", C), Cr("[handleError] Original error:: ", JSON.stringify(p)), eb(C);
      }
      if (y) {
        Cr(y);
        var O = p;
        p instanceof Error || (O = new Error(y)), eb(O);
      }
    }
    function Nc(p, g) {
      if (g != null)
        return g;
    }
    function Lc(p) {
      return p && p.endsWith("/") ? p.replace(/\/+$/, "") : p;
    }
    function tb() {
      return window.crypto && typeof window.crypto.getRandomValues == "function" ? ce() : function() {
        var p, g = 0, m = "";
        if (!ze || q + 16 > 256) {
          for (ze = Array(g = 256); g--; )
            ze[g] = 256 * Math.random() | 0;
          g = q = 0;
        }
        for (; g < 16; g++)
          p = ze[q + g], m += g == 6 ? Ue[15 & p | 64] : g == 8 ? Ue[63 & p | 128] : Ue[p], 1 & g && g > 1 && g < 11 && (m += "-");
        return q++, m;
      }();
    }
    function Zg() {
      return new Date().toISOString();
    }
    function Jg() {
      var p = ab(), g = p ? de.parse(p).pathname : window.location.pathname, m = window.location.search, y = document.title, O = function(R) {
        var B = ab(), I = B ? B.indexOf("?") > -1 ? B : B + R : window.location.href, X = I.indexOf("#");
        return X > -1 ? I.slice(0, X) : I;
      }(m), C = window.location.href, T = rb();
      return { path: g, referrer: T, referring_domain: nb(T), search: m, title: y, url: O, tab_url: C, initial_referrer: Mc.getInitialReferrer(), initial_referring_domain: Mc.getInitialReferringDomain() };
    }
    function rb() {
      return document.referrer || "$direct";
    }
    function nb(p) {
      var g = p.split("/");
      return g.length >= 3 ? g[2] : "";
    }
    function ab() {
      for (var p, g = document.getElementsByTagName("link"), m = 0; p = g[m]; m++)
        if (p.getAttribute("rel") === "canonical")
          return p.getAttribute("href");
    }
    function ib(p, g) {
      Object.keys(p).forEach(function(m) {
        p.hasOwnProperty(m) && (g[m] && (p[g[m]] = p[m]), m != "All" && g[m] != null && g[m] != m && delete p[m]);
      });
    }
    function e_(p) {
      ib(p, dy);
    }
    function t_(p, g) {
      var m = [];
      if (!g || g.length === 0)
        return m;
      var y = !0;
      p.All !== void 0 && (y = p.All);
      var O = [];
      return typeof g[0] == "string" ? g.forEach(function(C) {
        O.push({ intgName: C, intObj: C });
      }) : i(g[0]) === "object" && g.forEach(function(C) {
        O.push({ intgName: C.name, intObj: C });
      }), O.forEach(function(C) {
        var T = C.intgName, R = C.intObj;
        if (y) {
          var B = !0;
          p[T] != null && p[T] == 0 && (B = !1), B && m.push(R);
        } else
          p[T] != null && p[T] == 1 && m.push(R);
      }), m;
    }
    for (var qc, ob = function() {
      for (var p, g = document.getElementsByTagName("script"), m = !1, y = 0; y < g.length; y += 1) {
        var O = Lc(g[y].getAttribute("src"));
        if (O) {
          var C = O.match(/^.*rudder-analytics(-staging)?(\.min)?\.js$/);
          if (C) {
            p = O, m = C[1] !== void 0;
            break;
          }
        }
      }
      return { sdkURL: p, isStaging: m };
    }, Uc = function(p) {
      return typeof p == "string" || p == null ? p : JSON.stringify(p);
    }, sb = function(p) {
      return !(!p || typeof p != "string" || p.trim().length === 0);
    }, xR = function(p, g, m) {
      try {
        var y = p.source.dataplanes || {};
        if (Object.keys(y).length) {
          var O = function(R) {
            var B = R ? R.residencyServer : void 0;
            if (B)
              return typeof B == "string" && RI.includes(B.toUpperCase()) ? B.toUpperCase() : void Cr("Invalid residencyServer input");
          }(m), C = y[O] || y.US;
          if (C) {
            var T = function(R) {
              if (Array.isArray(R) && R.length) {
                var B = R.find(function(I) {
                  return I.default === !0;
                });
                if (B && sb(B.url))
                  return B.url;
              }
            }(C);
            if (T)
              return T;
          }
        }
        if (sb(g))
          return g;
        throw Error("Unable to load the SDK due to invalid data plane url");
      } catch (R) {
        throw Error(R);
      }
    }, DR = d(function p() {
      o(this, p), this.name = "RudderLabs JavaScript SDK", this.namespace = "com.rudderlabs.javascript", this.version = "2.28.0";
    }), CR = d(function p() {
      o(this, p), this.name = "RudderLabs JavaScript SDK", this.version = "2.28.0";
    }), SR = d(function p() {
      o(this, p), this.name = "", this.version = "";
    }), AR = d(function p() {
      o(this, p), this.density = 0, this.width = 0, this.height = 0, this.innerWidth = 0, this.innerHeight = 0;
    }), OR = d(function p() {
      var g;
      o(this, p), this.app = new DR(), this.traits = null, this.library = new CR(), this.userAgent = function() {
        if (typeof navigator > "u")
          return null;
        var m = navigator.userAgent, y = navigator.brave;
        if (y && Object.getPrototypeOf(y).isBrave) {
          var O = m.match(/(chrome)\/([\w.]+)/i);
          O && (m = "".concat(m, " Brave/").concat(O[2]));
        }
        return m;
      }(), this.device = null, this.network = null, this.os = new SR(), this.locale = typeof navigator > "u" ? null : navigator.language || navigator.browserLanguage, this.screen = (g = new AR(), typeof window > "u" || (g.width = window.screen.width, g.height = window.screen.height, g.density = window.devicePixelRatio, g.innerWidth = window.innerWidth, g.innerHeight = window.innerHeight), g);
    }), TR = function() {
      function p() {
        o(this, p), this.channel = "web", this.context = new OR(), this.type = null, this.messageId = tb(), this.originalTimestamp = new Date().toISOString(), this.anonymousId = null, this.userId = null, this.event = null, this.properties = {}, this.integrations = {}, this.integrations.All = !0;
      }
      return d(p, [{ key: "getProperty", value: function(g) {
        return this.properties[g];
      } }, { key: "addProperty", value: function(g, m) {
        this.properties[g] = m;
      } }]), p;
    }(), PR = function() {
      function p() {
        o(this, p), this.message = new TR();
      }
      return d(p, [{ key: "setType", value: function(g) {
        this.message.type = g;
      } }, { key: "setProperty", value: function(g) {
        this.message.properties = g;
      } }, { key: "setUserProperty", value: function(g) {
        this.message.user_properties = g;
      } }, { key: "setUserId", value: function(g) {
        this.message.userId = g;
      } }, { key: "setEventName", value: function(g) {
        this.message.event = g;
      } }, { key: "getElementContent", value: function() {
        return this.message;
      } }]), p;
    }(), Pd = function() {
      function p() {
        o(this, p), this.rudderProperty = null, this.rudderUserProperty = null, this.event = null, this.userId = null, this.type = null;
      }
      return d(p, [{ key: "setType", value: function(g) {
        return this.type = g, this;
      } }, { key: "build", value: function() {
        var g = new PR();
        return g.setUserId(this.userId), g.setType(this.type), g.setEventName(this.event), g.setProperty(this.rudderProperty), g.setUserProperty(this.rudderUserProperty), g;
      } }]), p;
    }(), ub = {}, Lo = 256, Gc = []; Lo--; )
      Gc[Lo] = (Lo + 256).toString(16).substring(1);
    ub.v4 = function() {
      var p, g = 0, m = "";
      if (!qc || Lo + 16 > 256) {
        for (qc = Array(g = 256); g--; )
          qc[g] = 256 * Math.random() | 0;
        g = Lo = 0;
      }
      for (; g < 16; g++)
        p = qc[Lo + g], m += g == 6 ? Gc[15 & p | 64] : g == 8 ? Gc[63 & p | 128] : Gc[p], 1 & g && g > 1 && g < 11 && (m += "-");
      return Lo++, m;
    };
    var r_, Wc = {}, IR = Object.prototype.hasOwnProperty, RR = String.prototype.charAt, jR = Object.prototype.toString, MR = function(p, g) {
      return RR.call(p, g);
    }, n_ = function(p, g) {
      return IR.call(p, g);
    }, db = function(p, g) {
      g = g || n_;
      for (var m = [], y = 0, O = p.length; y < O; y += 1)
        g(p, y) && m.push(String(y));
      return m;
    }, a_ = function(p) {
      return p == null ? [] : (g = p, jR.call(g) === "[object String]" ? db(p, MR) : function(m) {
        return m != null && typeof m != "function" && typeof m.length == "number";
      }(p) ? db(p, n_) : function(m, y) {
        y = y || n_;
        var O = [];
        for (var C in m)
          y(m, C) && O.push(String(C));
        return O;
      }(p));
      var g;
    }, BR = new Uint8Array(16);
    function lb() {
      if (!r_ && !(r_ = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto)))
        throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
      return r_(BR);
    }
    var NR = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
    function Vc(p) {
      return typeof p == "string" && NR.test(p);
    }
    for (var fb, i_, Ir = [], o_ = 0; o_ < 256; ++o_)
      Ir.push((o_ + 256).toString(16).substr(1));
    function Hc(p) {
      var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, m = (Ir[p[g + 0]] + Ir[p[g + 1]] + Ir[p[g + 2]] + Ir[p[g + 3]] + "-" + Ir[p[g + 4]] + Ir[p[g + 5]] + "-" + Ir[p[g + 6]] + Ir[p[g + 7]] + "-" + Ir[p[g + 8]] + Ir[p[g + 9]] + "-" + Ir[p[g + 10]] + Ir[p[g + 11]] + Ir[p[g + 12]] + Ir[p[g + 13]] + Ir[p[g + 14]] + Ir[p[g + 15]]).toLowerCase();
      if (!Vc(m))
        throw TypeError("Stringified UUID is invalid");
      return m;
    }
    var s_ = 0, u_ = 0;
    function cb(p) {
      if (!Vc(p))
        throw TypeError("Invalid UUID");
      var g, m = new Uint8Array(16);
      return m[0] = (g = parseInt(p.slice(0, 8), 16)) >>> 24, m[1] = g >>> 16 & 255, m[2] = g >>> 8 & 255, m[3] = 255 & g, m[4] = (g = parseInt(p.slice(9, 13), 16)) >>> 8, m[5] = 255 & g, m[6] = (g = parseInt(p.slice(14, 18), 16)) >>> 8, m[7] = 255 & g, m[8] = (g = parseInt(p.slice(19, 23), 16)) >>> 8, m[9] = 255 & g, m[10] = (g = parseInt(p.slice(24, 36), 16)) / 1099511627776 & 255, m[11] = g / 4294967296 & 255, m[12] = g >>> 24 & 255, m[13] = g >>> 16 & 255, m[14] = g >>> 8 & 255, m[15] = 255 & g, m;
    }
    function hb(p, g, m) {
      function y(O, C, T, R) {
        if (typeof O == "string" && (O = function(X) {
          X = unescape(encodeURIComponent(X));
          for (var Q = [], oe = 0; oe < X.length; ++oe)
            Q.push(X.charCodeAt(oe));
          return Q;
        }(O)), typeof C == "string" && (C = cb(C)), C.length !== 16)
          throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
        var B = new Uint8Array(16 + O.length);
        if (B.set(C), B.set(O, C.length), (B = m(B))[6] = 15 & B[6] | g, B[8] = 63 & B[8] | 128, T) {
          R = R || 0;
          for (var I = 0; I < 16; ++I)
            T[R + I] = B[I];
          return T;
        }
        return Hc(B);
      }
      try {
        y.name = p;
      } catch {
      }
      return y.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", y.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", y;
    }
    function gb(p) {
      return 14 + (p + 64 >>> 9 << 4) + 1;
    }
    function eo(p, g) {
      var m = (65535 & p) + (65535 & g);
      return (p >> 16) + (g >> 16) + (m >> 16) << 16 | 65535 & m;
    }
    function zc(p, g, m, y, O, C) {
      return eo((T = eo(eo(g, p), eo(y, C))) << (R = O) | T >>> 32 - R, m);
      var T, R;
    }
    function Gr(p, g, m, y, O, C, T) {
      return zc(g & m | ~g & y, p, g, O, C, T);
    }
    function Wr(p, g, m, y, O, C, T) {
      return zc(g & y | m & ~y, p, g, O, C, T);
    }
    function Vr(p, g, m, y, O, C, T) {
      return zc(g ^ m ^ y, p, g, O, C, T);
    }
    function Hr(p, g, m, y, O, C, T) {
      return zc(m ^ (g | ~y), p, g, O, C, T);
    }
    var LR = hb("v3", 48, function(p) {
      if (typeof p == "string") {
        var g = unescape(encodeURIComponent(p));
        p = new Uint8Array(g.length);
        for (var m = 0; m < g.length; ++m)
          p[m] = g.charCodeAt(m);
      }
      return function(y) {
        for (var O = [], C = 32 * y.length, T = "0123456789abcdef", R = 0; R < C; R += 8) {
          var B = y[R >> 5] >>> R % 32 & 255, I = parseInt(T.charAt(B >>> 4 & 15) + T.charAt(15 & B), 16);
          O.push(I);
        }
        return O;
      }(function(y, O) {
        y[O >> 5] |= 128 << O % 32, y[gb(O) - 1] = O;
        for (var C = 1732584193, T = -271733879, R = -1732584194, B = 271733878, I = 0; I < y.length; I += 16) {
          var X = C, Q = T, oe = R, Z = B;
          C = Gr(C, T, R, B, y[I], 7, -680876936), B = Gr(B, C, T, R, y[I + 1], 12, -389564586), R = Gr(R, B, C, T, y[I + 2], 17, 606105819), T = Gr(T, R, B, C, y[I + 3], 22, -1044525330), C = Gr(C, T, R, B, y[I + 4], 7, -176418897), B = Gr(B, C, T, R, y[I + 5], 12, 1200080426), R = Gr(R, B, C, T, y[I + 6], 17, -1473231341), T = Gr(T, R, B, C, y[I + 7], 22, -45705983), C = Gr(C, T, R, B, y[I + 8], 7, 1770035416), B = Gr(B, C, T, R, y[I + 9], 12, -1958414417), R = Gr(R, B, C, T, y[I + 10], 17, -42063), T = Gr(T, R, B, C, y[I + 11], 22, -1990404162), C = Gr(C, T, R, B, y[I + 12], 7, 1804603682), B = Gr(B, C, T, R, y[I + 13], 12, -40341101), R = Gr(R, B, C, T, y[I + 14], 17, -1502002290), C = Wr(C, T = Gr(T, R, B, C, y[I + 15], 22, 1236535329), R, B, y[I + 1], 5, -165796510), B = Wr(B, C, T, R, y[I + 6], 9, -1069501632), R = Wr(R, B, C, T, y[I + 11], 14, 643717713), T = Wr(T, R, B, C, y[I], 20, -373897302), C = Wr(C, T, R, B, y[I + 5], 5, -701558691), B = Wr(B, C, T, R, y[I + 10], 9, 38016083), R = Wr(R, B, C, T, y[I + 15], 14, -660478335), T = Wr(T, R, B, C, y[I + 4], 20, -405537848), C = Wr(C, T, R, B, y[I + 9], 5, 568446438), B = Wr(B, C, T, R, y[I + 14], 9, -1019803690), R = Wr(R, B, C, T, y[I + 3], 14, -187363961), T = Wr(T, R, B, C, y[I + 8], 20, 1163531501), C = Wr(C, T, R, B, y[I + 13], 5, -1444681467), B = Wr(B, C, T, R, y[I + 2], 9, -51403784), R = Wr(R, B, C, T, y[I + 7], 14, 1735328473), C = Vr(C, T = Wr(T, R, B, C, y[I + 12], 20, -1926607734), R, B, y[I + 5], 4, -378558), B = Vr(B, C, T, R, y[I + 8], 11, -2022574463), R = Vr(R, B, C, T, y[I + 11], 16, 1839030562), T = Vr(T, R, B, C, y[I + 14], 23, -35309556), C = Vr(C, T, R, B, y[I + 1], 4, -1530992060), B = Vr(B, C, T, R, y[I + 4], 11, 1272893353), R = Vr(R, B, C, T, y[I + 7], 16, -155497632), T = Vr(T, R, B, C, y[I + 10], 23, -1094730640), C = Vr(C, T, R, B, y[I + 13], 4, 681279174), B = Vr(B, C, T, R, y[I], 11, -358537222), R = Vr(R, B, C, T, y[I + 3], 16, -722521979), T = Vr(T, R, B, C, y[I + 6], 23, 76029189), C = Vr(C, T, R, B, y[I + 9], 4, -640364487), B = Vr(B, C, T, R, y[I + 12], 11, -421815835), R = Vr(R, B, C, T, y[I + 15], 16, 530742520), C = Hr(C, T = Vr(T, R, B, C, y[I + 2], 23, -995338651), R, B, y[I], 6, -198630844), B = Hr(B, C, T, R, y[I + 7], 10, 1126891415), R = Hr(R, B, C, T, y[I + 14], 15, -1416354905), T = Hr(T, R, B, C, y[I + 5], 21, -57434055), C = Hr(C, T, R, B, y[I + 12], 6, 1700485571), B = Hr(B, C, T, R, y[I + 3], 10, -1894986606), R = Hr(R, B, C, T, y[I + 10], 15, -1051523), T = Hr(T, R, B, C, y[I + 1], 21, -2054922799), C = Hr(C, T, R, B, y[I + 8], 6, 1873313359), B = Hr(B, C, T, R, y[I + 15], 10, -30611744), R = Hr(R, B, C, T, y[I + 6], 15, -1560198380), T = Hr(T, R, B, C, y[I + 13], 21, 1309151649), C = Hr(C, T, R, B, y[I + 4], 6, -145523070), B = Hr(B, C, T, R, y[I + 11], 10, -1120210379), R = Hr(R, B, C, T, y[I + 2], 15, 718787259), T = Hr(T, R, B, C, y[I + 9], 21, -343485551), C = eo(C, X), T = eo(T, Q), R = eo(R, oe), B = eo(B, Z);
        }
        return [C, T, R, B];
      }(function(y) {
        if (y.length === 0)
          return [];
        for (var O = 8 * y.length, C = new Uint32Array(gb(O)), T = 0; T < O; T += 8)
          C[T >> 5] |= (255 & y[T / 8]) << T % 32;
        return C;
      }(p), 8 * p.length));
    }), qR = LR;
    function UR(p, g, m, y) {
      switch (p) {
        case 0:
          return g & m ^ ~g & y;
        case 1:
        case 3:
          return g ^ m ^ y;
        case 2:
          return g & m ^ g & y ^ m & y;
      }
    }
    function d_(p, g) {
      return p << g | p >>> 32 - g;
    }
    var GR = hb("v5", 80, function(p) {
      var g = [1518500249, 1859775393, 2400959708, 3395469782], m = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
      if (typeof p == "string") {
        var y = unescape(encodeURIComponent(p));
        p = [];
        for (var O = 0; O < y.length; ++O)
          p.push(y.charCodeAt(O));
      } else
        Array.isArray(p) || (p = Array.prototype.slice.call(p));
      p.push(128);
      for (var C = p.length / 4 + 2, T = Math.ceil(C / 16), R = new Array(T), B = 0; B < T; ++B) {
        for (var I = new Uint32Array(16), X = 0; X < 16; ++X)
          I[X] = p[64 * B + 4 * X] << 24 | p[64 * B + 4 * X + 1] << 16 | p[64 * B + 4 * X + 2] << 8 | p[64 * B + 4 * X + 3];
        R[B] = I;
      }
      R[T - 1][14] = 8 * (p.length - 1) / Math.pow(2, 32), R[T - 1][14] = Math.floor(R[T - 1][14]), R[T - 1][15] = 8 * (p.length - 1) & 4294967295;
      for (var Q = 0; Q < T; ++Q) {
        for (var oe = new Uint32Array(80), Z = 0; Z < 16; ++Z)
          oe[Z] = R[Q][Z];
        for (var fe = 16; fe < 80; ++fe)
          oe[fe] = d_(oe[fe - 3] ^ oe[fe - 8] ^ oe[fe - 14] ^ oe[fe - 16], 1);
        for (var ye = m[0], Y = m[1], he = m[2], _e = m[3], Ee = m[4], be = 0; be < 80; ++be) {
          var We = Math.floor(be / 20), Ye = d_(ye, 5) + UR(We, Y, he, _e) + Ee + g[We] + oe[be] >>> 0;
          Ee = _e, _e = he, he = d_(Y, 30) >>> 0, Y = ye, ye = Ye;
        }
        m[0] = m[0] + ye >>> 0, m[1] = m[1] + Y >>> 0, m[2] = m[2] + he >>> 0, m[3] = m[3] + _e >>> 0, m[4] = m[4] + Ee >>> 0;
      }
      return [m[0] >> 24 & 255, m[0] >> 16 & 255, m[0] >> 8 & 255, 255 & m[0], m[1] >> 24 & 255, m[1] >> 16 & 255, m[1] >> 8 & 255, 255 & m[1], m[2] >> 24 & 255, m[2] >> 16 & 255, m[2] >> 8 & 255, 255 & m[2], m[3] >> 24 & 255, m[3] >> 16 & 255, m[3] >> 8 & 255, 255 & m[3], m[4] >> 24 & 255, m[4] >> 16 & 255, m[4] >> 8 & 255, 255 & m[4]];
    }), WR = GR, VR = Object.freeze({ __proto__: null, v1: function(p, g, m) {
      var y = g && m || 0, O = g || new Array(16), C = (p = p || {}).node || fb, T = p.clockseq !== void 0 ? p.clockseq : i_;
      if (C == null || T == null) {
        var R = p.random || (p.rng || lb)();
        C == null && (C = fb = [1 | R[0], R[1], R[2], R[3], R[4], R[5]]), T == null && (T = i_ = 16383 & (R[6] << 8 | R[7]));
      }
      var B = p.msecs !== void 0 ? p.msecs : Date.now(), I = p.nsecs !== void 0 ? p.nsecs : u_ + 1, X = B - s_ + (I - u_) / 1e4;
      if (X < 0 && p.clockseq === void 0 && (T = T + 1 & 16383), (X < 0 || B > s_) && p.nsecs === void 0 && (I = 0), I >= 1e4)
        throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
      s_ = B, u_ = I, i_ = T;
      var Q = (1e4 * (268435455 & (B += 122192928e5)) + I) % 4294967296;
      O[y++] = Q >>> 24 & 255, O[y++] = Q >>> 16 & 255, O[y++] = Q >>> 8 & 255, O[y++] = 255 & Q;
      var oe = B / 4294967296 * 1e4 & 268435455;
      O[y++] = oe >>> 8 & 255, O[y++] = 255 & oe, O[y++] = oe >>> 24 & 15 | 16, O[y++] = oe >>> 16 & 255, O[y++] = T >>> 8 | 128, O[y++] = 255 & T;
      for (var Z = 0; Z < 6; ++Z)
        O[y + Z] = C[Z];
      return g || Hc(O);
    }, v3: qR, v4: function(p, g, m) {
      var y = (p = p || {}).random || (p.rng || lb)();
      if (y[6] = 15 & y[6] | 64, y[8] = 63 & y[8] | 128, g) {
        m = m || 0;
        for (var O = 0; O < 16; ++O)
          g[m + O] = y[O];
        return g;
      }
      return Hc(y);
    }, v5: WR, NIL: "00000000-0000-0000-0000-000000000000", version: function(p) {
      if (!Vc(p))
        throw TypeError("Invalid UUID");
      return parseInt(p.substr(14, 1), 16);
    }, validate: Vc, stringify: Hc, parse: cb }), l_ = a_, HR = F(VR).v4, _b = { _data: {}, length: 0, setItem: function(p, g) {
      return this._data[p] = g, this.length = l_(this._data).length, g;
    }, getItem: function(p) {
      return p in this._data ? this._data[p] : null;
    }, removeItem: function(p) {
      return p in this._data && delete this._data[p], this.length = l_(this._data).length, null;
    }, clear: function() {
      this._data = {}, this.length = 0;
    }, key: function(p) {
      return l_(this._data)[p];
    } };
    Wc.defaultEngine = function() {
      try {
        if (!window.localStorage)
          return !1;
        var p = HR();
        window.localStorage.setItem(p, "test_value");
        var g = window.localStorage.getItem(p);
        return window.localStorage.removeItem(p), g === "test_value";
      } catch {
        return !1;
      }
    }() ? window.localStorage : _b, Wc.inMemoryEngine = _b;
    var zR = a_, mb = Object.prototype.toString, KR = typeof Array.isArray == "function" ? Array.isArray : function(p) {
      return mb.call(p) === "[object Array]";
    }, YR = function(p) {
      return p != null && (KR(p) || p !== "function" && function(g) {
        var m = i(g);
        return m === "number" || m === "object" && mb.call(g) === "[object Number]";
      }(p.length));
    }, XR = function(p, g) {
      for (var m = 0; m < g.length && p(g[m], m, g) !== !1; m += 1)
        ;
    }, QR = function(p, g) {
      for (var m = zR(g), y = 0; y < m.length && p(g[m[y]], m[y], g) !== !1; y += 1)
        ;
    }, f_ = function(p, g) {
      return (YR(g) ? XR : QR).call(this, p, g);
    }, ZR = Wc.defaultEngine, pb = Wc.inMemoryEngine, Fb = f_, JR = a_, yb = JSON;
    function qo(p, g, m, y) {
      this.id = g, this.name = p, this.keys = m || {}, this.engine = y || ZR, this.originalEngine = this.engine;
    }
    qo.prototype.set = function(p, g) {
      var m = this._createValidKey(p);
      if (m)
        try {
          this.engine.setItem(m, yb.stringify(g));
        } catch (y) {
          (function(O) {
            var C = !1;
            if (O.code)
              switch (O.code) {
                case 22:
                  C = !0;
                  break;
                case 1014:
                  O.name === "NS_ERROR_DOM_QUOTA_REACHED" && (C = !0);
              }
            else
              O.number === -2147024882 && (C = !0);
            return C;
          })(y) && (this._swapEngine(), this.set(p, g));
        }
    }, qo.prototype.get = function(p) {
      try {
        var g = this.engine.getItem(this._createValidKey(p));
        return g === null ? null : yb.parse(g);
      } catch {
        return null;
      }
    }, qo.prototype.getOriginalEngine = function() {
      return this.originalEngine;
    }, qo.prototype.remove = function(p) {
      this.engine.removeItem(this._createValidKey(p));
    }, qo.prototype._createValidKey = function(p) {
      var g, m = this.name, y = this.id;
      return JR(this.keys).length ? (Fb(function(O) {
        O === p && (g = [m, y, p].join("."));
      }, this.keys), g) : [m, y, p].join(".");
    }, qo.prototype._swapEngine = function() {
      var p = this;
      Fb(function(g) {
        var m = p.get(g);
        pb.setItem([p.name, p.id, g].join("."), m), p.remove(g);
      }, this.keys), this.engine = pb;
    };
    var ej = qo, tj = f_, bb = { setTimeout: function(p, g) {
      return window.setTimeout(p, g);
    }, clearTimeout: function(p) {
      return window.clearTimeout(p);
    }, Date: window.Date }, Zs = bb, Kc = { ASAP: 1, RESCHEDULE: 2, ABANDON: 3 };
    function gi() {
      this.tasks = {}, this.nextId = 1;
    }
    gi.prototype.now = function() {
      return +new Zs.Date();
    }, gi.prototype.run = function(p, g, m) {
      var y = this.nextId++;
      return this.tasks[y] = Zs.setTimeout(this._handle(y, p, g, m || Kc.ASAP), g), y;
    }, gi.prototype.cancel = function(p) {
      this.tasks[p] && (Zs.clearTimeout(this.tasks[p]), delete this.tasks[p]);
    }, gi.prototype.cancelAll = function() {
      tj(Zs.clearTimeout, this.tasks), this.tasks = {};
    }, gi.prototype._handle = function(p, g, m, y) {
      var O = this, C = O.now();
      return function() {
        if (delete O.tasks[p], !(y >= Kc.RESCHEDULE && C + 2 * m < O.now()))
          return g();
        y === Kc.RESCHEDULE && O.run(g, m, y);
      };
    }, gi.setClock = function(p) {
      Zs = p;
    }, gi.resetClock = function() {
      Zs = bb;
    }, gi.Modes = Kc;
    var rj = gi, Id = ub.v4, c_ = ej, h_ = f_, Js = rj, nj = Qs("localstorage-retry");
    function g_(p, g) {
      return function() {
        return p.apply(g, arguments);
      };
    }
    function mn(p, g, m) {
      typeof g == "function" && (m = g), this.name = p, this.id = Id(), this.fn = m, this.maxItems = g.maxItems || 1 / 0, this.maxAttempts = g.maxAttempts || 1 / 0, this.backoff = { MIN_RETRY_DELAY: g.minRetryDelay || 1e3, MAX_RETRY_DELAY: g.maxRetryDelay || 3e4, FACTOR: g.backoffFactor || 2, JITTER: g.backoffJitter || 0 }, this.timeouts = { ACK_TIMER: 1e3, RECLAIM_TIMER: 3e3, RECLAIM_TIMEOUT: 1e4, RECLAIM_WAIT: 500 }, this.keys = { IN_PROGRESS: "inProgress", QUEUE: "queue", RECLAIM_START: "reclaimStart", RECLAIM_END: "reclaimEnd", ACK: "ack" }, this._schedule = new Js(), this._processId = 0, this._store = new c_(this.name, this.id, this.keys), this._store.set(this.keys.IN_PROGRESS, {}), this._store.set(this.keys.QUEUE, []), this._ack = g_(this._ack, this), this._checkReclaim = g_(this._checkReclaim, this), this._processHead = g_(this._processHead, this), this._running = !1;
    }
    v(mn.prototype), mn.prototype.start = function() {
      this._running && this.stop(), this._running = !0, this._ack(), this._checkReclaim(), this._processHead();
    }, mn.prototype.stop = function() {
      this._schedule.cancelAll(), this._running = !1;
    }, mn.prototype.shouldRetry = function(p, g) {
      return !(g > this.maxAttempts);
    }, mn.prototype.getDelay = function(p) {
      var g = this.backoff.MIN_RETRY_DELAY * Math.pow(this.backoff.FACTOR, p);
      if (this.backoff.JITTER) {
        var m = Math.random(), y = Math.floor(m * this.backoff.JITTER * g);
        Math.floor(10 * m) < 5 ? g -= y : g += y;
      }
      return Number(Math.min(g, this.backoff.MAX_RETRY_DELAY).toPrecision(1));
    }, mn.prototype.addItem = function(p) {
      this._enqueue({ item: p, attemptNumber: 0, time: this._schedule.now(), id: Id() });
    }, mn.prototype.requeue = function(p, g, m, y) {
      this.shouldRetry(p, g, m) ? this._enqueue({ item: p, attemptNumber: g, time: this._schedule.now() + this.getDelay(g), id: y || Id() }) : this.emit("discard", p, g);
    }, mn.prototype._enqueue = function(p) {
      var g = this._store.get(this.keys.QUEUE) || [];
      (g = g.slice(-(this.maxItems - 1))).push(p), g = g.sort(function(m, y) {
        return m.time - y.time;
      }), this._store.set(this.keys.QUEUE, g), this._running && this._processHead();
    }, mn.prototype._processHead = function() {
      var p = this, g = this._store;
      this._schedule.cancel(this._processId);
      var m = g.get(this.keys.QUEUE) || [], y = g.get(this.keys.IN_PROGRESS) || {}, O = this._schedule.now(), C = [];
      function T(X, Q) {
        C.push({ item: X.item, done: function(oe, Z) {
          var fe = g.get(p.keys.IN_PROGRESS) || {};
          delete fe[Q], g.set(p.keys.IN_PROGRESS, fe), p.emit("processed", oe, Z, X.item), oe && p.requeue(X.item, X.attemptNumber + 1, oe, X.id);
        } });
      }
      for (var R = Object.keys(y).length; m.length && m[0].time <= O && R++ < p.maxItems; ) {
        var B = m.shift(), I = Id();
        y[I] = { item: B.item, attemptNumber: B.attemptNumber, time: p._schedule.now() }, T(B, I);
      }
      g.set(this.keys.QUEUE, m), g.set(this.keys.IN_PROGRESS, y), h_(function(X) {
        try {
          p.fn(X.item, X.done);
        } catch (Q) {
          nj("Process function threw error: " + Q);
        }
      }, C), m = g.get(this.keys.QUEUE) || [], this._schedule.cancel(this._processId), m.length > 0 && (this._processId = this._schedule.run(this._processHead, m[0].time - O, Js.Modes.ASAP));
    }, mn.prototype._ack = function() {
      this._store.set(this.keys.ACK, this._schedule.now()), this._store.set(this.keys.RECLAIM_START, null), this._store.set(this.keys.RECLAIM_END, null), this._schedule.run(this._ack, this.timeouts.ACK_TIMER, Js.Modes.ASAP);
    }, mn.prototype._checkReclaim = function() {
      var p = this;
      h_(function(g) {
        g.id !== p.id && (p._schedule.now() - g.get(p.keys.ACK) < p.timeouts.RECLAIM_TIMEOUT || function(m) {
          m.set(p.keys.RECLAIM_START, p.id), m.set(p.keys.ACK, p._schedule.now()), p._schedule.run(function() {
            m.get(p.keys.RECLAIM_START) === p.id && (m.set(p.keys.RECLAIM_END, p.id), p._schedule.run(function() {
              m.get(p.keys.RECLAIM_END) === p.id && m.get(p.keys.RECLAIM_START) === p.id && p._reclaim(m.id);
            }, p.timeouts.RECLAIM_WAIT, Js.Modes.ABANDON));
          }, p.timeouts.RECLAIM_WAIT, Js.Modes.ABANDON);
        }(g));
      }, function(g) {
        for (var m = [], y = p._store.getOriginalEngine(), O = 0; O < y.length; O++) {
          var C = y.key(O).split(".");
          C.length === 3 && C[0] === g && C[2] === "ack" && m.push(new c_(g, C[1], p.keys));
        }
        return m;
      }(this.name)), this._schedule.run(this._checkReclaim, this.timeouts.RECLAIM_TIMER, Js.Modes.RESCHEDULE);
    }, mn.prototype._reclaim = function(p) {
      var g = this, m = new c_(this.name, p, this.keys), y = { queue: this._store.get(this.keys.QUEUE) || [] }, O = { inProgress: m.get(this.keys.IN_PROGRESS) || {}, queue: m.get(this.keys.QUEUE) || [] }, C = [], T = function(R, B) {
        h_(function(I) {
          var X = I.id || Id();
          C.indexOf(X) >= 0 ? g.emit("duplication", I.item, I.attemptNumber) : (y.queue.push({ item: I.item, attemptNumber: I.attemptNumber + B, time: g._schedule.now(), id: X }), C.push(X));
        }, R);
      };
      T(O.queue, 0), T(O.inProgress, 1), y.queue = y.queue.sort(function(R, B) {
        return R.time - B.time;
      }), this._store.set(this.keys.QUEUE, y.queue), m.remove(this.keys.IN_PROGRESS), m.remove(this.keys.QUEUE), m.remove(this.keys.RECLAIM_START), m.remove(this.keys.RECLAIM_END), m.remove(this.keys.ACK), this._processHead();
    };
    var aj = mn, vb = { maxRetryDelay: 36e4, minRetryDelay: 1e3, backoffFactor: 2, maxAttempts: 10, maxItems: 100 }, ij = function() {
      function p() {
        o(this, p), this.url = "", this.writeKey = "";
      }
      return d(p, [{ key: "init", value: function(g, m, y) {
        this.url = m, this.writeKey = g, y && l(vb, y), this.payloadQueue = new aj("rudder", vb, function(O, C) {
          O.message.sentAt = Zg(), this.processQueueElement(O.url, O.headers, O.message, 1e4, function(T, R) {
            if (T)
              return C(T);
            C(null, R);
          });
        }.bind(this)), this.payloadQueue.start();
      } }, { key: "processQueueElement", value: function(g, m, y, O, C) {
        try {
          var T = new XMLHttpRequest();
          for (var R in T.open("POST", g, !0), m)
            T.setRequestHeader(R, m[R]);
          T.timeout = O, T.ontimeout = C, T.onerror = C, T.onreadystatechange = function() {
            T.readyState === 4 && (T.status === 429 || T.status >= 500 && T.status < 600 ? (pr(new Error("request failed with status: ".concat(T.status).concat(T.statusText, " for url: ").concat(g))), C(new Error("request failed with status: ".concat(T.status).concat(T.statusText, " for url: ").concat(g)))) : C(null, T.status));
          }, T.send(JSON.stringify(y, Nc));
        } catch (B) {
          C(B);
        }
      } }, { key: "enqueue", value: function(g, m) {
        var y = { "Content-Type": "application/json", Authorization: "Basic ".concat(btoa("".concat(this.writeKey, ":"))), AnonymousId: btoa(g.anonymousId) };
        this.payloadQueue.addItem({ url: "".concat(this.url, "/v1/").concat(m), headers: y, message: g });
      } }]), p;
    }(), oj = "queue", sj = 64e3, uj = function() {
      function p() {
        o(this, p), this.storage = Td, this.maxItems = 10, this.flushQueueTimeOut = void 0, this.timeOutActive = !1, this.flushQueueTimeOutInterval = 6e5, this.url = "", this.writekey = "", this.queueName = "".concat(oj, ".").concat(Date.now()), this.send = navigator.sendBeacon && navigator.sendBeacon.bind(navigator);
      }
      return d(p, [{ key: "sendQueueDataForBeacon", value: function() {
        this.sendDataFromQueueAndDestroyQueue();
      } }, { key: "init", value: function(g, m, y) {
        this.url = m, this.writekey = g, y.maxItems && (this.maxItems = y.maxItems), y.flushQueueInterval && (this.flushQueueTimeOutInterval = y.flushQueueInterval);
        var O = this.sendQueueDataForBeacon.bind(this);
        window.addEventListener("unload", O);
      } }, { key: "getQueue", value: function() {
        return this.storage.get(this.queueName);
      } }, { key: "setQueue", value: function(g) {
        this.storage.set(this.queueName, g);
      } }, { key: "enqueue", value: function(g) {
        var m = this.getQueue() || [];
        (m = m.slice(-(this.maxItems - 1))).push(g);
        var y = m.slice(0), O = { batch: y };
        JSON.stringify(O, Nc).length > sj && (y = m.slice(0, m.length - 1), this.flushQueue(y), (m = this.getQueue()).push(g)), this.setQueue(m), this.setTimer(), m.length === this.maxItems && this.flushQueue(y);
      } }, { key: "sendDataFromQueueAndDestroyQueue", value: function() {
        this.sendDataFromQueue(), this.storage.remove(this.queueName);
      } }, { key: "sendDataFromQueue", value: function() {
        var g = this.getQueue();
        if (g && g.length > 0) {
          var m = g.slice(0, g.length);
          this.flushQueue(m);
        }
      } }, { key: "flushQueue", value: function(g) {
        g.forEach(function(C) {
          C.sentAt = new Date().toISOString();
        });
        var m = { batch: g }, y = JSON.stringify(m, Nc), O = new Blob([y], { type: "text/plain" });
        try {
          this.send("".concat(this.url, "?writeKey=").concat(this.writekey), O) || pr(new Error("Unable to queue data to browser's beacon queue"));
        } catch (C) {
          pr(C);
        }
        this.setQueue([]), this.clearTimer();
      } }, { key: "setTimer", value: function() {
        this.timeOutActive || (this.flushQueueTimeOut = setTimeout(this.sendDataFromQueue.bind(this), this.flushQueueTimeOutInterval), this.timeOutActive = !0);
      } }, { key: "clearTimer", value: function() {
        this.timeOutActive && (clearTimeout(this.flushQueueTimeOut), this.timeOutActive = !1);
      } }]), p;
    }(), dj = function() {
      function p() {
        o(this, p), this.queue = void 0;
      }
      return d(p, [{ key: "initialize", value: function(g, m, y) {
        var O = {}, C = Lc(m);
        y && y.useBeacon && navigator.sendBeacon ? (y && y.beaconQueueOptions && y.beaconQueueOptions != null && i(y.beaconQueueOptions) === "object" && (O = y.beaconQueueOptions), C = "".concat(C, "/beacon/v1/batch"), this.queue = new uj()) : (y && y.useBeacon && cP("[EventRepository] sendBeacon feature not available in this browser :: fallback to XHR"), y && y.queueOptions && y.queueOptions != null && i(y.queueOptions) === "object" && (O = y.queueOptions), this.queue = new ij()), this.queue.init(g, C, O);
      } }, { key: "enqueue", value: function(g, m) {
        var y = g.getElementContent();
        y.originalTimestamp = y.originalTimestamp || Zg(), y.sentAt = Zg(), JSON.stringify(y, Nc).length > 32e3 && Cr("[EventRepository] enqueue:: message length greater 32 Kb ", y), this.queue.enqueue(y, m);
      } }]), p;
    }(), lj = new dj(), fj = function() {
      return navigator && navigator.language;
    }, cj = function() {
      return navigator && navigator.userAgent;
    };
    function hj(p) {
      return decodeURIComponent(atob(p).split("").map(function(g) {
        return "%".concat("00".concat(g.charCodeAt(0).toString(16)).slice(-2));
      }).join(""));
    }
    function gj() {
      var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return hj(p = p.endsWith("..") ? p.substr(0, p.length - 2) : p);
    }
    var _j = /^[a-zA-Z0-9\-_.]+$/, Rd = "*";
    function mj(p, g, m, y) {
      var O = function(R, B) {
        return [R, new Date().getTimezoneOffset(), B].join(Rd);
      }(m, y), C = g || 0, T = function(R) {
        for (var B = function() {
          for (var Q, oe = [], Z = 0; Z < 256; Z++) {
            Q = Z;
            for (var fe = 0; fe < 8; fe++)
              Q = 1 & Q ? 3988292384 ^ Q >>> 1 : Q >>> 1;
            oe[Z] = Q;
          }
          return oe;
        }(), I = -1, X = 0; X < R.length; X++)
          I = I >>> 8 ^ B[255 & (I ^ R.charCodeAt(X))];
        return (-1 ^ I) >>> 0;
      }([O, Math.floor(Date.now() / 6e4) - C, p].join(Rd));
      return T.toString(36);
    }
    function pj(p) {
      var g = function(O) {
        var C = O.split(Rd), T = C.length % 2 == 0;
        return C.length < 4 || !T || Number(C.shift()) !== 1 ? null : { checksum: C.shift(), serializedIds: C.join(Rd) };
      }(p);
      if (!g)
        return null;
      var m = g.checksum, y = g.serializedIds;
      return function(O, C) {
        for (var T = cj(), R = fj(), B = 0; B <= 1; B += 1)
          if (mj(O, B, T, R) === C)
            return !0;
        return !1;
      }(y, m) ? function(O) {
        for (var C = {}, T = O.split(Rd), R = 0; R < T.length; R += 2) {
          var B = T[R];
          if (_j.test(B)) {
            var I = gj(T[R + 1]);
            C[B] = I;
          }
        }
        return C;
      }(y) : null;
    }
    var Yc = { HS: "HubSpot", GA: "GA", HOTJAR: "Hotjar", GOOGLEADS: "GoogleAds", VWO: "VWO", GTM: "GoogleTagManager", BRAZE: "Braze", INTERCOM: "INTERCOM", KEEN: "Keen", KISSMETRICS: "Kissmetrics", CUSTOMERIO: "CustomerIO", CHARTBEAT: "Chartbeat", COMSCORE: "Comscore", FACEBOOK_PIXEL: "FacebookPixel", LOTAME: "Lotame", OPTIMIZELY: "Optimizely", BUGSNAG: "Bugsnag", FULLSTORY: "Fullstory", TVSQUARED: "TVSquared", GA4: "GA4", MOENGAGE: "MoEngage", AM: "Amplitude", PENDO: "Pendo", LYTICS: "Lytics", APPCUES: "Appcues", POSTHOG: "Posthog", KLAVIYO: "Klaviyo", CLEVERTAP: "Clevertap", BINGADS: "BingAds", PINTEREST_TAG: "PinterestTag", ADOBE_ANALYTICS: "AdobeAnalytics", LINKEDIN_INSIGHT_TAG: "LinkedInInsightTag", REDDIT_PIXEL: "RedditPixel", DRIP: "Drip", HEAP: "Heap", CRITEO: "Criteo", MP: "Mixpanel", QUALTRICS: "Qualtrics", PROFITWELL: "ProfitWell", SENTRY: "Sentry", QUANTUMMETRIC: "QuantumMetric", SNAP_PIXEL: "SnapPixel", POST_AFFILIATE_PRO: "PostAffiliatePro", GOOGLE_OPTIMIZE: "GoogleOptimize", LAUNCHDARKLY: "LaunchDarkly", GA360: "GA360", ADROLL: "Adroll", DCM_FLOODLIGHT: "DCMFloodlight", MATOMO: "Matomo", VERO: "Vero", MOUSEFLOW: "Mouseflow", ROCKERBOX: "Rockerbox", CONVERTFLOW: "ConvertFlow", SNAPENGAGE: "SnapEngage", LIVECHAT: "LiveChat", SHYNET: "Shynet", WOOPRA: "Woopra", ROLLBAR: "RollBar", QUORA_PIXEL: "QuoraPixel", JUNE: "June", ENGAGE: "Engage", ITERABLE: "Iterable", YANDEX_METRICA: "YandexMetrica", REFINER: "Refiner", QUALAROO: "Qualaroo", PODSIGHTS: "Podsights", AXEPTIO: "Axeptio", SATISMETER: "Satismeter", MICROSOFT_CLARITY: "MicrosoftClarity", SENDINBLUE: "Sendinblue", OLARK: "Olark", LEMNISK: "Lemnisk" }, Fj = function() {
      function p() {
        var g = this;
        if (o(this, p), !window.OneTrust || !window.OnetrustActiveGroups)
          throw new Error("OneTrust resources are not accessible. Thus all the destinations will be loaded");
        this.userSetConsentGroupIds = window.OnetrustActiveGroups.split(",").filter(function(y) {
          return y;
        });
        var m = window.OneTrust.GetDomainData().Groups;
        this.userSetConsentGroupNames = [], this.userDeniedConsentGroupIds = [], m.forEach(function(y) {
          var O = y.CustomGroupId, C = y.GroupName;
          g.userSetConsentGroupIds.includes(O) ? g.userSetConsentGroupNames.push(C.toUpperCase().trim()) : g.userDeniedConsentGroupIds.push(O);
        }), this.userSetConsentGroupIds = this.userSetConsentGroupIds.map(function(y) {
          return y.toUpperCase();
        });
      }
      return d(p, [{ key: "isEnabled", value: function(g) {
        var m = this;
        try {
          var y = g.oneTrustCookieCategories;
          if (!y)
            return !0;
          var O = y.map(function(C) {
            return C.oneTrustCookieCategory;
          }).filter(function(C) {
            return C;
          });
          return O.every(function(C) {
            return m.userSetConsentGroupIds.includes(C.toUpperCase().trim()) || m.userSetConsentGroupNames.includes(C.toUpperCase().trim());
          });
        } catch (C) {
          return Cr("Error during onetrust cookie consent management ".concat(C)), !0;
        }
      } }, { key: "getDeniedList", value: function() {
        return this.userDeniedConsentGroupIds;
      } }]), p;
    }(), yj = function() {
      function p() {
        o(this, p);
      }
      return d(p, null, [{ key: "initialize", value: function(g) {
        var m;
        return g != null && (m = g.oneTrust) !== null && m !== void 0 && m.enabled ? new Fj() : null;
      } }]), p;
    }(), bj = { SDK: { name: "JS", installType: "npm" } }, Eb = "{{RS_BUGSNAG_API_KEY}}", vj = ["rudder-analytics.min.js"].concat(f(Object.keys(Yc).map(function(p) {
      return "".concat(Yc[p], ".min.js");
    })));
    function $b(p) {
      if (window.Bugsnag !== void 0 && Eb.match(/{{.+}}/) === null) {
        var g = window.location.hostname;
        window.rsBugsnagClient = window.Bugsnag.start({ apiKey: Eb, appVersion: "2.28.0", metadata: bj, onError: function(m) {
          try {
            var y = ee(m, "errors.0.stacktrace.0.file");
            if (!y || typeof y != "string")
              return !1;
            var O = y.substring(y.lastIndexOf("/") + 1);
            if (!vj.includes(O))
              return !1;
            m.addMetadata("source", { sourceId: p });
            var C = m.errors[0].errorMessage;
            return m.context = C, C.includes("error in script loading") && (m.context = "Script load failures"), m.severity = "error", !0;
          } catch {
            return !1;
          }
        }, autoTrackSessions: !1, collectUserIp: !1, enabledBreadcrumbTypes: ["error", "log", "user"], maxEvents: 100, releaseStage: g && ["localhost", "127.0.0.1", "[::1]"].includes(g) ? "development" : "production" });
      }
    }
    var Ej = new (function() {
      function p() {
        o(this, p), this.storage = Mc, this.timeout = 18e5, this.sessionInfo = this.storage.getSessionInfo() || { autoTrack: !0 };
      }
      return d(p, [{ key: "initialize", value: function(g) {
        try {
          var m;
          if (this.sessionInfo.autoTrack = !((g == null || (m = g.sessions) === null || m === void 0 ? void 0 : m.autoTrack) === !1 || this.sessionInfo.manualTrack), g != null && g.sessions && !isNaN(g.sessions.timeout)) {
            var y = g.sessions.timeout;
            y === 0 && (uy("[Session]:: Provided timeout value 0 will disable the auto session tracking feature."), this.sessionInfo.autoTrack = !1), y > 0 && y < 1e4 && uy('[Session]:: It is not advised to set "timeout" less than 10 seconds'), this.timeout = y;
          }
          this.sessionInfo.autoTrack ? this.startAutoTracking() : this.sessionInfo.autoTrack !== !1 || this.sessionInfo.manualTrack || this.end();
        } catch (O) {
          pr(O);
        }
      } }, { key: "isValidSession", value: function(g) {
        return g <= this.sessionInfo.expiresAt;
      } }, { key: "generateSessionId", value: function() {
        return Date.now();
      } }, { key: "startAutoTracking", value: function() {
        var g = Date.now();
        this.isValidSession(g) || (this.sessionInfo = {}, this.sessionInfo.id = g, this.sessionInfo.expiresAt = g + this.timeout, this.sessionInfo.sessionStart = !0, this.sessionInfo.autoTrack = !0), this.storage.setSessionInfo(this.sessionInfo);
      } }, { key: "validateSessionId", value: function(g) {
        if (typeof g == "number" && g % 1 == 0) {
          var m;
          if (!(((m = g) ? m.toString().length : 0) < 10))
            return g;
          Cr('[Session]:: "sessionId" should at least be "'.concat(10, '" digits long'));
        } else
          Cr('[Session]:: "sessionId" should only be a positive integer');
      } }, { key: "start", value: function(g) {
        var m = g ? this.validateSessionId(g) : this.generateSessionId();
        this.sessionInfo = { id: m || this.generateSessionId(), sessionStart: !0, manualTrack: !0 }, this.storage.setSessionInfo(this.sessionInfo);
      } }, { key: "getSessionId", value: function() {
        return this.sessionInfo.autoTrack && this.isValidSession(Date.now()) || this.sessionInfo.manualTrack ? this.sessionInfo.id : null;
      } }, { key: "end", value: function() {
        this.sessionInfo = {}, this.storage.removeSessionInfo();
      } }, { key: "getSessionInfo", value: function() {
        var g = {};
        if (this.sessionInfo.autoTrack || this.sessionInfo.manualTrack) {
          if (this.sessionInfo.autoTrack) {
            var m = Date.now();
            this.isValidSession(m) ? this.sessionInfo.expiresAt = m + this.timeout : this.startAutoTracking();
          }
          this.sessionInfo.sessionStart && (g.sessionStart = !0, this.sessionInfo.sessionStart = !1), g.sessionId = this.sessionInfo.id, this.storage.setSessionInfo(this.sessionInfo);
        }
        return g;
      } }, { key: "reset", value: function() {
        var g = this.sessionInfo, m = g.manualTrack;
        g.autoTrack ? (this.sessionInfo = {}, this.startAutoTracking()) : m && this.start();
      } }]), p;
    }())(), $j = function(p, g) {
      if (!Array.isArray(p) || !Array.isArray(g))
        return j(g);
      var m = j(p);
      return g.forEach(function(y, O) {
        m[O] = jd(m[O], y);
      }), m;
    }, jd = function(p, g) {
      return ae($j, p, g);
    }, wb = ["integrations", "anonymousId", "originalTimestamp"], wj = function() {
      function p() {
        o(this, p), this.initialized = !1, this.clientIntegrations = [], this.loadOnlyIntegrations = {}, this.clientIntegrationObjects = void 0, this.successfullyLoadedIntegration = [], this.failedToBeLoadedIntegration = [], this.toBeProcessedArray = [], this.toBeProcessedByIntegrationArray = [], this.storage = Mc, this.eventRepository = lj, this.sendAdblockPage = !1, this.sendAdblockPageOptions = {}, this.clientSuppliedCallbacks = {}, this.readyCallbacks = [], this.methodToCallbackMapping = { syncPixel: "syncPixelCallback" }, this.loaded = !1, this.loadIntegration = !0, this.integrationsData = {}, this.dynamicallyLoadedIntegrations = {}, this.destSDKBaseURL = hy, this.cookieConsentOptions = {}, this.logLevel = void 0, this.clientIntegrationsReady = !1, this.uSession = Ej, this.version = "2.28.0", this.lockIntegrationsVersion = !1, this.deniedConsentIds = [];
      }
      return d(p, [{ key: "initializeUser", value: function(g) {
        this.userId = this.storage.getUserId() || "", this.storage.setUserId(this.userId), this.userTraits = this.storage.getUserTraits() || {}, this.storage.setUserTraits(this.userTraits), this.groupId = this.storage.getGroupId() || "", this.storage.setGroupId(this.groupId), this.groupTraits = this.storage.getGroupTraits() || {}, this.storage.setGroupTraits(this.groupTraits), this.anonymousId = this.getAnonymousId(g), this.storage.setAnonymousId(this.anonymousId);
      } }, { key: "setInitialPageProperties", value: function() {
        if (this.storage.getInitialReferrer() == null && this.storage.getInitialReferringDomain() == null) {
          var g = rb();
          this.storage.setInitialReferrer(g), this.storage.setInitialReferringDomain(nb(g));
        }
      } }, { key: "allModulesInitialized", value: function() {
        var g = this, m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        return new Promise(function(y) {
          g.clientIntegrations.every(function(O) {
            return g.dynamicallyLoadedIntegrations["".concat(Yc[O.name]).concat(gy)] != null;
          }) || m >= 2e4 ? y(g) : g.pause(Tc).then(function() {
            return g.allModulesInitialized(m + Tc).then(y);
          });
        });
      } }, { key: "executeReadyCallback", value: function() {
        this.readyCallbacks.forEach(function(g) {
          return g();
        });
      } }, { key: "integrationSDKLoaded", value: function(g, m) {
        try {
          return window.hasOwnProperty(g) && window[g][m] && window[g][m].prototype.constructor !== void 0;
        } catch (y) {
          return pr(y), !1;
        }
      } }, { key: "processResponse", value: function(g, m) {
        var y, O = this;
        try {
          var C = m;
          try {
            if (typeof m == "string" && (C = JSON.parse(m)), !C || i(C) !== "object" || Array.isArray(C))
              throw new Error("Invalid source configuration");
          } catch (X) {
            return void pr(X);
          }
          if (ee(C.source.config, "statsCollection.errorReports.enabled") === !0) {
            var T = ee(C.source.config, "statsCollection.errorReports.provider") || _y;
            PI.includes(T) || Cr("Invalid error reporting provider value"), T === "bugsnag" && (y = "bugsnag", window.hasOwnProperty(y) || Bc(y, "https://d2wy8f7a9ursnm.cloudfront.net/v7/bugsnag.min.js", { isNonNativeSDK: "true" }), function(X) {
              if (!window.hasOwnProperty("rsBugsnagClient"))
                if (window.Bugsnag !== void 0)
                  $b(X);
                else {
                  var Q = setInterval(function() {
                    window.Bugsnag !== void 0 && (clearInterval(Q), $b(X));
                  }, 100);
                  setTimeout(function() {
                    clearInterval(Q);
                  }, Oc);
                }
            }(C.source.id));
          }
          if (this.serverUrl = xR(C, this.serverUrl, this.options), this.eventRepository.initialize(this.writeKey, this.serverUrl, this.options), this.loaded = !0, this.options && typeof this.options.onLoaded == "function" && this.options.onLoaded(this), function(X) {
            if (X.toBeProcessedArray.length > 0)
              for (; X.toBeProcessedArray.length > 0; ) {
                var Q = f(X.toBeProcessedArray[0]);
                X.toBeProcessedArray.shift();
                var oe = Q[0];
                Q.shift(), X[oe].apply(X, f(Q));
              }
          }(this), C.source.destinations.forEach(function(X) {
            X.enabled && this.clientIntegrations.push({ name: X.destinationDefinition.name, config: X.config });
          }, this), this.clientIntegrations = t_(this.loadOnlyIntegrations, this.clientIntegrations), Object.keys(this.cookieConsentOptions).length > 0)
            try {
              var R = yj.initialize(this.cookieConsentOptions);
              this.deniedConsentIds = R && R.getDeniedList(), this.clientIntegrations = this.clientIntegrations.filter(function(X) {
                return !R || R && R.isEnabled(X.config);
              });
            } catch (X) {
              pr(X);
            }
          var B = "";
          ob().isStaging && (B = "-staging"), Oa("Starting device-mode initialization"), this.clientIntegrations.forEach(function(X) {
            var Q = Yc[X.name], oe = "".concat(Q).concat(gy), Z = "".concat(O.destSDKBaseURL, "/").concat(Q).concat(B, ".min.js");
            window.hasOwnProperty(oe) || Bc(oe, Z, { isNonNativeSDK: !0 });
            var fe = O, ye = setInterval(function() {
              if (fe.integrationSDKLoaded(oe, Q)) {
                var Y, he = window[oe];
                clearInterval(ye);
                try {
                  Oa("[Analytics] processResponse :: trying to initialize integration name:: ".concat(oe)), (Y = new he[Q](X.config, fe)).init(), fe.isInitialized(Y).then(function() {
                    fe.dynamicallyLoadedIntegrations[oe] = he[Q];
                  });
                } catch (_e) {
                  pr(_e, "[Analytics] 'integration.init()' failed :: ".concat(oe, " :: ").concat(_e.message)), fe.failedToBeLoadedIntegration.push(Y);
                }
              }
            }, 100);
            setTimeout(function() {
              clearInterval(ye);
            }, Oc);
          });
          var I = this;
          this.allModulesInitialized().then(function() {
            if (!I.clientIntegrations || I.clientIntegrations.length === 0)
              return O.clientIntegrationsReady = !0, O.executeReadyCallback(), void (O.toBeProcessedByIntegrationArray = []);
            I.replayEvents(I);
          });
        } catch (X) {
          pr(X);
        }
      } }, { key: "replayEvents", value: function(g) {
        var m, y, O;
        Oa("Started replaying buffered events"), g.clientIntegrationObjects = [], g.clientIntegrationObjects = g.successfullyLoadedIntegration, g.clientIntegrationObjects.every(function(C) {
          return !C.isReady || C.isReady();
        }) && (this.integrationsData = (m = this.integrationsData, y = g.clientIntegrationObjects, O = j(m), y.forEach(function(C) {
          if (C.getDataForIntegrationsObject)
            try {
              O = jd(O, C.getDataForIntegrationsObject());
            } catch (T) {
              hP("[Analytics: prepareDataForIntegrationsObj]", T);
            }
        }), O), g.clientIntegrationsReady = !0, g.executeReadyCallback()), g.toBeProcessedByIntegrationArray.forEach(function(C) {
          var T = C[0];
          C.shift(), Object.keys(C[0].message.integrations).length > 0 && e_(C[0].message.integrations);
          var R, B = function(Q, oe) {
            var Z = typeof Symbol < "u" && Q[Symbol.iterator] || Q["@@iterator"];
            if (!Z) {
              if (Array.isArray(Q) || (Z = c(Q)) || oe && Q && typeof Q.length == "number") {
                Z && (Q = Z);
                var fe = 0, ye = function() {
                };
                return { s: ye, n: function() {
                  return fe >= Q.length ? { done: !0 } : { done: !1, value: Q[fe++] };
                }, e: function(Ee) {
                  throw Ee;
                }, f: ye };
              }
              throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            var Y, he = !0, _e = !1;
            return { s: function() {
              Z = Z.call(Q);
            }, n: function() {
              var Ee = Z.next();
              return he = Ee.done, Ee;
            }, e: function(Ee) {
              _e = !0, Y = Ee;
            }, f: function() {
              try {
                he || Z.return == null || Z.return();
              } finally {
                if (_e)
                  throw Y;
              }
            } };
          }(t_(C[0].message.integrations, g.clientIntegrationObjects));
          try {
            for (B.s(); !(R = B.n()).done; ) {
              var I = R.value;
              try {
                if ((!I.isFailed || !I.isFailed()) && I[T] && !g.IsEventBlackListed(C[0].message.event, I.name)) {
                  var X = j(C);
                  I[T].apply(I, f(X));
                }
              } catch (Q) {
                pr(Q);
              }
            }
          } catch (Q) {
            B.e(Q);
          } finally {
            B.f();
          }
        }), g.toBeProcessedByIntegrationArray = [];
      } }, { key: "pause", value: function(g) {
        return new Promise(function(m) {
          setTimeout(m, g);
        });
      } }, { key: "isInitialized", value: function(g) {
        var m = this, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        return new Promise(function(O) {
          g.isLoaded() ? (m.successfullyLoadedIntegration.push(g), O(m)) : y >= Oc ? (m.failedToBeLoadedIntegration.push(g), O(m)) : m.pause(Tc).then(function() {
            return m.isInitialized(g, y + Tc).then(O);
          });
        });
      } }, { key: "page", value: function(g, m, y, O, C) {
        if (Oa("Page event"), this.loaded) {
          typeof O == "function" && (C = O, O = null), typeof y == "function" && (C = y, O = y = null), typeof m == "function" && (C = m, O = y = m = null), typeof g == "function" && (C = g, O = y = m = g = null), i(g) === "object" && g != null && g != null && (O = m, y = g, m = g = null), i(m) === "object" && m != null && m != null && (O = y, y = m, m = null), typeof g == "string" && typeof m != "string" && (m = g, g = null), this.sendAdblockPage && g != "RudderJS-Initiated" && this.sendSampleRequest();
          var T = j(y), R = j(O), B = new Pd().setType("page").build();
          T || (T = {}), m && (B.message.name = T.name = m), g && (B.message.category = T.category = g), B.message.properties = this.getPageProperties(T), this.processAndSendDataToDestinations("page", B, R, C);
        } else
          this.toBeProcessedArray.push(["page"].concat(Array.prototype.slice.call(arguments)));
      } }, { key: "track", value: function(g, m, y, O) {
        if (Oa("Track event"), this.loaded) {
          typeof y == "function" && (O = y, y = null), typeof m == "function" && (O = m, y = null, m = null);
          var C = j(m), T = j(y), R = new Pd().setType("track").build();
          g && R.setEventName(g), R.setProperty(C || {}), this.processAndSendDataToDestinations("track", R, T, O);
        } else
          this.toBeProcessedArray.push(["track"].concat(Array.prototype.slice.call(arguments)));
      } }, { key: "identify", value: function(g, m, y, O) {
        if (Oa("Identify event"), this.loaded) {
          typeof y == "function" && (O = y, y = null), typeof m == "function" && (O = m, y = null, m = null), i(g) === "object" && (y = m, m = g, g = this.userId), g && this.userId && g !== this.userId && this.reset(), this.userId = Uc(g), this.storage.setUserId(this.userId);
          var C = j(m), T = j(y);
          if (C) {
            for (var R in C)
              this.userTraits[R] = C[R];
            this.storage.setUserTraits(this.userTraits);
          }
          var B = new Pd().setType("identify").build();
          this.processAndSendDataToDestinations("identify", B, T, O);
        } else
          this.toBeProcessedArray.push(["identify"].concat(Array.prototype.slice.call(arguments)));
      } }, { key: "alias", value: function(g, m, y, O) {
        if (Oa("Alias event"), this.loaded) {
          typeof y == "function" && (O = y, y = null), typeof m == "function" && (O = m, y = null, m = null), typeof g == "function" && (O = g, y = null, m = null, g = null), i(m) === "object" && (y = m, m = null), i(g) === "object" && (y = g, m = null, g = null);
          var C = new Pd().setType("alias").build();
          C.message.previousId = Uc(m) || (this.userId ? this.userId : this.getAnonymousId()), C.message.userId = Uc(g);
          var T = j(y);
          this.processAndSendDataToDestinations("alias", C, T, O);
        } else
          this.toBeProcessedArray.push(["alias"].concat(Array.prototype.slice.call(arguments)));
      } }, { key: "group", value: function(g, m, y, O) {
        if (Oa("Group event"), this.loaded) {
          if (arguments.length !== 0) {
            typeof y == "function" && (O = y, y = null), typeof m == "function" && (O = m, y = null, m = null), i(g) === "object" && (y = m, m = g, g = this.groupId), typeof g == "function" && (O = g, y = null, m = null, g = this.groupId), this.groupId = Uc(g), this.storage.setGroupId(this.groupId);
            var C = j(m), T = j(y), R = new Pd().setType("group").build();
            if (C)
              for (var B in C)
                this.groupTraits[B] = C[B];
            else
              this.groupTraits = {};
            this.storage.setGroupTraits(this.groupTraits), this.processAndSendDataToDestinations("group", R, T, O);
          }
        } else
          this.toBeProcessedArray.push(["group"].concat(Array.prototype.slice.call(arguments)));
      } }, { key: "IsEventBlackListed", value: function(g, m) {
        if (!g || typeof g != "string")
          return !1;
        var y = dy[m], O = this.clientIntegrations.find(function(I) {
          return I.name === y;
        }).config, C = O.blacklistedEvents, T = O.whitelistedEvents, R = O.eventFilteringOption;
        if (!R)
          return !1;
        var B = g.trim().toUpperCase();
        switch (R) {
          case "disable":
          default:
            return !1;
          case "blacklistedEvents":
            return !!Array.isArray(C) && C.some(function(I) {
              return I.eventName.trim().toUpperCase() === B;
            });
          case "whitelistedEvents":
            return !Array.isArray(T) || !T.some(function(I) {
              return I.eventName.trim().toUpperCase() === B;
            });
        }
      } }, { key: "processAndSendDataToDestinations", value: function(g, m, y, O) {
        var C, T, R = this;
        try {
          this.anonymousId || this.setAnonymousId(), Oa("Started sending data to destinations"), m.message.context.traits = a({}, this.userTraits), m.message.anonymousId = this.anonymousId, m.message.userId = m.message.userId ? m.message.userId : this.userId, g == "group" && (this.groupId && (m.message.groupId = this.groupId), this.groupTraits && (m.message.traits = a({}, this.groupTraits)));
          try {
            var B = this.uSession.getSessionInfo(), I = B.sessionId, X = B.sessionStart;
            m.message.context.sessionId = I, X && (m.message.context.sessionStart = !0);
          } catch (oe) {
            pr(oe);
          }
          C = this.cookieConsentOptions, T = !1, Object.keys(C).forEach(function(oe) {
            jI.includes(oe) && typeof C[oe].enabled == "boolean" && C[oe].enabled === !0 && (T = !0);
          }), T && (m.message.context.consentManagement = { deniedConsentIds: this.deniedConsentIds }), this.processOptionsParam(m, y), function(oe, Z) {
            var fe = oe.properties, ye = oe.traits;
            fe && Object.keys(fe).forEach(function(he) {
              Og.indexOf(he.toLowerCase()) >= 0 && Cr("Warning! : Reserved keyword used in properties--> ".concat(he, " with ").concat(Z, " call"));
            }), ye && Object.keys(ye).forEach(function(he) {
              Og.indexOf(he.toLowerCase()) >= 0 && Cr("Warning! : Reserved keyword used in traits--> ".concat(he, " with ").concat(Z, " call"));
            });
            var Y = oe.context.traits;
            Y && Object.keys(Y).forEach(function(he) {
              Og.indexOf(he.toLowerCase()) >= 0 && Cr("Warning! : Reserved keyword used in traits --> ".concat(he, " with ").concat(Z, " call"));
            });
          }(m.message, g);
          var Q = m.message.integrations || { All: !0 };
          e_(Q), m.message.integrations = Q;
          try {
            m.message.context["ua-ch"] = this.uach;
          } catch (oe) {
            pr(oe);
          }
          this.clientIntegrationObjects ? t_(Q, this.clientIntegrationObjects).forEach(function(oe) {
            try {
              if ((!oe.isFailed || !oe.isFailed()) && oe[g] && !R.IsEventBlackListed(m.message.event, oe.name)) {
                var Z = j(m);
                oe[g](Z);
              }
            } catch (fe) {
              pr(fe, "[sendToNative]:: [Destination: ".concat(oe.name, "]:: "));
            }
          }) : this.toBeProcessedByIntegrationArray.push([g, m]), ib(m.message.integrations, TI), m.message.integrations = function(oe, Z) {
            var fe = j(oe), ye = Object.keys(Z).filter(function(Y) {
              return !(Z[Y] === !0 && fe[Y]);
            }).reduce(function(Y, he) {
              return Y[he] = Z[he], Y;
            }, {});
            return jd(fe, ye);
          }(this.integrationsData, Q), this.eventRepository.enqueue(m, g), O && O(m);
        } catch (oe) {
          pr(oe);
        }
      } }, { key: "utm", value: function(g) {
        var m;
        g.charAt(0) === "?" && (g = g.substring(1)), g = g.replace(/\?/g, "&");
        var y = A(g), O = {};
        for (var C in y)
          Object.prototype.hasOwnProperty.call(y, C) && C.substr(0, 4) === "utm_" && ((m = C.substr(4)) === "campaign" && (m = "name"), O[m] = y[C]);
        return O;
      } }, { key: "addCampaignInfo", value: function(g) {
        var m = g.message.context;
        if (m && i(m) === "object") {
          var y = Jg().search;
          g.message.context.campaign = this.utm(y);
        }
      } }, { key: "processOptionsParam", value: function(g, m) {
        var y = g.message, O = y.type, C = y.properties;
        this.addCampaignInfo(g), g.message.context.page = this.getContextPageProperties(O === "page" ? C : void 0), function(T) {
          var R = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          i(R) === "object" && R !== null && Object.keys(R).forEach(function(B) {
            wb.includes(B) && (T[B] = R[B]);
          });
        }(g.message, m), g.message.context = function(T) {
          var R = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, B = T.context;
          return i(R) !== "object" || R === null || Object.keys(R).forEach(function(I) {
            if (!wb.includes(I) && !my.includes(I))
              if (I !== "context")
                B = jd(B, s({}, I, R[I]));
              else if (i(R[I]) === "object" && R[I] !== null) {
                var X = {};
                Object.keys(R[I]).forEach(function(Q) {
                  my.includes(Q) || (X[Q] = R[I][Q]);
                }), B = jd(B, a({}, X));
              } else
                Cr("[Analytics: processOptionsParam] context passed in options ".concat(I, " is not object."));
          }), B;
        }(g.message, m);
      } }, { key: "getPageProperties", value: function(g, m) {
        var y = Jg(), O = m && m.page || {};
        for (var C in y)
          g[C] === void 0 && (g[C] = O[C] || y[C]);
        return g;
      } }, { key: "getContextPageProperties", value: function(g) {
        var m = Jg(), y = {};
        for (var O in m)
          y[O] = g && g[O] ? g[O] : m[O];
        return y;
      } }, { key: "reset", value: function(g) {
        Oa("reset API :: flag: ".concat(g)), this.loaded ? (g && (this.anonymousId = ""), this.userId = "", this.userTraits = {}, this.groupId = "", this.groupTraits = {}, this.uSession.reset(), this.storage.clear(g)) : this.toBeProcessedArray.push(["reset", g]);
      } }, { key: "getAnonymousId", value: function(g) {
        return this.anonymousId = this.storage.getAnonymousId(g), this.anonymousId || this.setAnonymousId(), this.anonymousId;
      } }, { key: "getUserId", value: function() {
        return this.userId;
      } }, { key: "getSessionId", value: function() {
        return this.uSession.getSessionId();
      } }, { key: "getUserTraits", value: function() {
        return this.userTraits;
      } }, { key: "getGroupId", value: function() {
        return this.groupId;
      } }, { key: "getGroupTraits", value: function() {
        return this.groupTraits;
      } }, { key: "setAnonymousId", value: function(g, m) {
        var y = m ? pj(m) : null, O = y ? y.rs_amp_id : null;
        this.anonymousId = g || O || tb(), this.storage.setAnonymousId(this.anonymousId);
      } }, { key: "isValidWriteKey", value: function(g) {
        return g && typeof g == "string" && g.trim().length > 0;
      } }, { key: "isValidServerUrl", value: function(g) {
        return g && typeof g == "string" && g.trim().length > 0;
      } }, { key: "isDatasetAvailable", value: function() {
        var g = document.createElement("div");
        return g.setAttribute("data-a-b", "c"), !!g.dataset && g.dataset.aB === "c";
      } }, { key: "loadAfterPolyfill", value: function(g, m, y) {
        var O = this;
        if (i(m) === "object" && m !== null && (y = m, m = null), y && y.logLevel && (this.logLevel = y.logLevel, fP(y.logLevel)), !this.isValidWriteKey(g))
          throw Error("Unable to load the SDK due to invalid writeKey");
        if (!this.storage || Object.keys(this.storage).length === 0)
          throw Error("Cannot proceed as no storage is available");
        y && y.cookieConsentManager && (this.cookieConsentOptions = y.cookieConsentManager), this.writeKey = g, this.serverUrl = m, this.options = y;
        var C = {};
        if (y && y.setCookieDomain && (C = a(a({}, C), {}, { domain: y.setCookieDomain })), y && typeof y.secureCookie == "boolean" && (C = a(a({}, C), {}, { secure: y.secureCookie })), y && II.includes(y.sameSiteCookie) && (C = a(a({}, C), {}, { samesite: y.sameSiteCookie })), this.storage.options(C), y && typeof y.uaChTrackLevel == "string" && MI.includes(y.uaChTrackLevel) && (this.uaChTrackLevel = y.uaChTrackLevel), navigator.userAgentData && function(I) {
          var X = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
          X === "none" && I(void 0), X === "default" && I(navigator.userAgentData), X === "full" && navigator.userAgentData.getHighEntropyValues(["architecture", "bitness", "brands", "mobile", "model", "platform", "platformVersion", "uaFullVersion", "fullVersionList", "wow64"]).then(function(Q) {
            I(Q);
          });
        }(function(I) {
          O.uach = I;
        }, this.uaChTrackLevel), y && y.integrations && (l(this.loadOnlyIntegrations, y.integrations), e_(this.loadOnlyIntegrations)), y && y.sendAdblockPage && (this.sendAdblockPage = !0), y && y.sendAdblockPageOptions && i(y.sendAdblockPageOptions) === "object" && (this.sendAdblockPageOptions = y.sendAdblockPageOptions), this.uSession.initialize(y), y && y.clientSuppliedCallbacks) {
          var T = {};
          Object.keys(this.methodToCallbackMapping).forEach(function(I) {
            O.methodToCallbackMapping.hasOwnProperty(I) && y.clientSuppliedCallbacks[O.methodToCallbackMapping[I]] && (T[I] = y.clientSuppliedCallbacks[O.methodToCallbackMapping[I]]);
          }), l(this.clientSuppliedCallbacks, T), this.registerCallbacks(!0);
        }
        if (y && y.loadIntegration != null && (this.loadIntegration = !!y.loadIntegration), y && y.lockIntegrationsVersion !== void 0 && (this.lockIntegrationsVersion = y.lockIntegrationsVersion === !0), this.eventRepository.initialize(g, m, y), this.initializeUser(y ? y.anonymousIdOptions : void 0), this.setInitialPageProperties(), this.destSDKBaseURL = function(I, X, Q) {
          var oe = "";
          if (Q) {
            if (!(oe = Lc(Q))) {
              var Z = "CDN base URL for integrations is not valid";
              throw pr({ message: "[Analytics] load:: ".concat(Z) }), Error("Failed to load Rudder SDK: ".concat(Z));
            }
            return oe;
          }
          var fe = ob().sdkURL;
          return oe = fe ? fe.split("/").slice(0, -1).concat(cy).join("/") : hy, X && (oe = oe.replace(fy, I)), oe;
        }(this.version, this.lockIntegrationsVersion, y && y.destSDKBaseURL), y && y.getSourceConfig)
          if (typeof y.getSourceConfig != "function")
            pr(new Error('option "getSourceConfig" must be a function'));
          else {
            var R = y.getSourceConfig();
            R instanceof Promise ? R.then(function(I) {
              return O.processResponse(200, I);
            }).catch(pr) : this.processResponse(200, R);
          }
        else {
          var B = function(I) {
            return ly.concat(ly.includes("?") ? "&" : "?").concat(I ? "writeKey=".concat(I) : "");
          }(g);
          y && y.configUrl && (B = function(I, X) {
            var Q = I;
            Q.indexOf("sourceConfig") === -1 && (Q = "".concat(Lc(Q), "/sourceConfig/")), Q = Q.slice(-1) === "/" ? Q : "".concat(Q, "/");
            var oe = X.split("?")[1], Z = Q.split("?");
            return Z.length > 1 && Z[1] !== oe ? "".concat(Z[0], "?").concat(oe) : "".concat(Q, "?").concat(oe);
          }(y.configUrl, B));
          try {
            (function(I, X, Q, oe) {
              var Z = oe.bind(I), fe = new XMLHttpRequest();
              fe.open("GET", X, !0), fe.setRequestHeader("Authorization", "Basic ".concat(btoa("".concat(Q, ":")))), fe.onload = function() {
                var ye = fe.status;
                ye == 200 ? Z(200, fe.responseText) : (pr(new Error("request failed with status: ".concat(fe.status, " for url: ").concat(X))), Z(ye));
              }, fe.send();
            })(this, B, g, this.processResponse);
          } catch (I) {
            pr(I);
          }
        }
      } }, { key: "load", value: function(g, m, y) {
        if (!this.loaded) {
          var O = j(y);
          if (!(!O || typeof O.polyfillIfRequired != "boolean" || O.polyfillIfRequired) || String.prototype.endsWith && String.prototype.startsWith && String.prototype.includes && Array.prototype.find && Array.prototype.includes && Promise && Object.entries && Object.values && String.prototype.replaceAll && this.isDatasetAvailable())
            this.loadAfterPolyfill(g, m, O);
          else {
            var C = "polyfill";
            Bc(C, "https://polyfill.io/v3/polyfill.min.js?features=Array.prototype.find%2CArray.prototype.includes%2CPromise%2CString.prototype.endsWith%2CString.prototype.includes%2CString.prototype.startsWith%2CObject.entries%2CObject.values%2CElement.prototype.dataset%2CString.prototype.replaceAll", { skipDatasetAttributes: !0 });
            var T = this, R = setInterval(function() {
              (window.hasOwnProperty(C) || document.getElementById(C) !== null) && (clearInterval(R), T.loadAfterPolyfill(g, m, O));
            }, 100);
            setTimeout(function() {
              clearInterval(R);
            }, Oc);
          }
        }
      } }, { key: "ready", value: function(g) {
        this.loaded ? typeof g != "function" ? Cr("ready callback is not a function") : this.clientIntegrationsReady ? g() : this.readyCallbacks.push(g) : this.toBeProcessedArray.push(["ready", g]);
      } }, { key: "initializeCallbacks", value: function() {
        var g = this;
        Object.keys(this.methodToCallbackMapping).forEach(function(m) {
          g.methodToCallbackMapping.hasOwnProperty(m) && g.on(m, function() {
          });
        });
      } }, { key: "registerCallbacks", value: function(g) {
        var m = this;
        g || Object.keys(this.methodToCallbackMapping).forEach(function(y) {
          m.methodToCallbackMapping.hasOwnProperty(y) && window.rudderanalytics && typeof window.rudderanalytics[m.methodToCallbackMapping[y]] == "function" && (m.clientSuppliedCallbacks[y] = window.rudderanalytics[m.methodToCallbackMapping[y]]);
        }), Object.keys(this.clientSuppliedCallbacks).forEach(function(y) {
          m.clientSuppliedCallbacks.hasOwnProperty(y) && m.on(y, m.clientSuppliedCallbacks[y]);
        });
      } }, { key: "sendSampleRequest", value: function() {
        Bc("ad-block", "//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js");
      } }, { key: "startSession", value: function(g) {
        this.uSession.start(g);
      } }, { key: "endSession", value: function() {
        this.uSession.end();
      } }]), p;
    }(), ct = new wj();
    $(ct), window.addEventListener("error", function(p) {
      pr(p, void 0, ct);
    }, !0), ct.initializeCallbacks(), ct.registerCallbacks(!1);
    var Md, kj = "load", Uo = window.rudderanalytics, kb = Array.isArray(Uo);
    if (kb)
      for (var eu = 0; eu < Uo.length; ) {
        if (Uo[eu] && Uo[eu][0] === kj) {
          Md = Uo[eu], Uo.splice(eu, 1);
          break;
        }
        eu += 1;
      }
    (function(p) {
      var g = "ajs_trait_", m = "ajs_prop_";
      function y(C, T) {
        var R = {};
        return Object.keys(C).forEach(function(B) {
          B.startsWith(T) && (R[B.substr(T.length)] = C[B]);
        }), R;
      }
      var O = A(p);
      O.ajs_aid && ct.toBeProcessedArray.push(["setAnonymousId", O.ajs_aid]), O.ajs_uid && ct.toBeProcessedArray.push(["identify", O.ajs_uid, y(O, g)]), O.ajs_event && ct.toBeProcessedArray.push(["track", O.ajs_event, y(O, m)]);
    })(window.location.search), kb && Uo.forEach(function(p) {
      return ct.toBeProcessedArray.push(p);
    }), Md && Md.length > 0 && (Md.shift(), ct.load.apply(ct, f(Md)));
    var xj = ct.ready.bind(ct), Dj = ct.identify.bind(ct), Cj = ct.page.bind(ct), Sj = ct.track.bind(ct), Aj = ct.alias.bind(ct), Oj = ct.group.bind(ct), Tj = ct.reset.bind(ct), Pj = ct.load.bind(ct), Ij = ct.initialized = !0, Rj = ct.getUserId.bind(ct), jj = ct.getSessionId.bind(ct), Mj = ct.getUserTraits.bind(ct), Bj = ct.getAnonymousId.bind(ct), Nj = ct.setAnonymousId.bind(ct), Lj = ct.getGroupId.bind(ct), qj = ct.getGroupTraits.bind(ct), Uj = ct.startSession.bind(ct), Gj = ct.endSession.bind(ct);
    r.alias = Aj, r.endSession = Gj, r.getAnonymousId = Bj, r.getGroupId = Lj, r.getGroupTraits = qj, r.getSessionId = jj, r.getUserId = Rj, r.getUserTraits = Mj, r.group = Oj, r.identify = Dj, r.initialized = Ij, r.load = Pj, r.page = Cj, r.ready = xj, r.reset = Tj, r.setAnonymousId = Nj, r.startSession = Uj, r.track = Sj, Object.defineProperty(r, "__esModule", { value: !0 });
  });
})(fle, Ll);
const cle = /* @__PURE__ */ iB(Ll), hle = /* @__PURE__ */ aB({
  __proto__: null,
  default: cle
}, [Ll]);
function f8(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, mle(n.key), n);
  }
}
function gle(e, t, r) {
  return t && f8(e.prototype, t), r && f8(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Gm() {
  return Gm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Gm.apply(this, arguments);
}
function _le(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function mle(e) {
  var t = _le(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var ple = "https://aircall-dataplane.rudderstack.com", h0;
(function(e) {
  e.DEVELOPMENT = "development", e.TEST = "test", e.STAGING = "staging", e.BETA = "beta", e.PRODUCTION = "production";
})(h0 || (h0 = {}));
var Fle = {
  user_id: 0,
  created_at: "",
  release: "default",
  device: "",
  email: "",
  is_admin: !1,
  name: "",
  platform: "default",
  environment: h0.DEVELOPMENT,
  language: ""
}, yle = /* @__PURE__ */ function() {
  function e() {
    this.identified = !1, this.identification = Fle;
  }
  var t = e.prototype;
  return t.init = function(n) {
    this.analytics = hle, this.analytics.load(n.key, ple);
  }, t.identify = function(n) {
    var a;
    (a = this.sdk) == null || a.identify(n.user_id.toString(), n), this.identification = n, this.identified = !0;
  }, t.addContext = function(n) {
    this.context = n;
  }, t.track = function(n, a) {
    a === void 0 && (a = {});
    var i = Gm({}, a, this.context);
    if (this.isDevelopment)
      console.log("TRACK", n, i);
    else {
      var o;
      (o = this.sdk) == null || o.track(n, i);
    }
  }, t.reset = function() {
    var n;
    (n = this.sdk) == null || n.reset();
  }, gle(e, [{
    key: "isDevelopment",
    get: function() {
      return this.identification.environment === h0.DEVELOPMENT;
    }
    // Getter to check if the module is identified with user's information
  }, {
    key: "isIdentified",
    get: function() {
      return this.identified;
    }
    // Getter to access the RudderStack SDK
  }, {
    key: "sdk",
    get: function() {
      return this.analytics;
    }
  }]), e;
}(), c8;
(function(e) {
  e.INIT = "TRACKER_INIT", e.TRACK = "TRACKER_TRACK";
})(c8 || (c8 = {}));
var ble = /* @__PURE__ */ new yle();
const vle = ble;
function zOe({
  skip: e = !1,
  release: t,
  platform: r
}) {
  const n = ue(
    ({ event: a, payload: i = {} }) => {
      vle.track(a, {
        ...Xne({ platform: r, release: t }),
        ...i
      });
    },
    [r, t]
  );
  return { track: e ? Hw : n };
}
const Ele = ({
  eleRef: e,
  innerScrollRef: t,
  open: r,
  onClose: n
}) => {
  const a = ue(
    (o) => {
      t != null && t.current && !t.current.contains(o.target) && n();
    },
    [n, t]
  ), i = tt();
  return at(() => {
    if (i.current = uD(e.current), !r)
      return kn;
    const o = i.current === document.body, u = o ? window : i.current;
    return u.addEventListener("scroll", a), o || window.addEventListener("scroll", a), () => {
      u.removeEventListener("scroll", a), o || window.removeEventListener("scroll", a);
    };
  }, [e, a, r, i]), { outerScrollableEle: i.current };
};
function KOe(e) {
  const { state: t } = Af();
  return (t == null ? void 0 : t.from) === e;
}
const $le = ({
  ref: e,
  onResize: t
}) => {
  at(() => {
    const r = e == null ? void 0 : e.current;
    if (!r)
      return kn;
    if (typeof window.ResizeObserver > "u")
      return window.addEventListener("resize", t), () => {
        window.removeEventListener("resize", t);
      };
    const n = new window.ResizeObserver(
      (a) => {
        a.length && t();
      }
    );
    return n.observe(r), () => {
      n.unobserve(r);
    };
  }, [t, e]);
}, wle = (e) => {
  const [t, r] = Xe(), n = ue(() => {
    var o;
    const i = (o = e.current) == null ? void 0 : o.getBoundingClientRect();
    r(i);
  }, [e]);
  td(() => {
    n();
  }, [n]);
  const a = ue(
    () => window.requestAnimationFrame(n),
    [n]
  );
  return $le({ ref: e, onResize: a }), {
    boundingRect: t,
    updateLayoutPosition: n
  };
}, kle = (e) => new URLSearchParams(e), T1 = (e) => e ? Object.fromEntries(e) : {}, YOe = (e) => {
  const t = e;
  return Object.keys(t).forEach(
    (r) => !t[r] && e[r] !== void 0 && delete t[r]
  ), t;
}, xle = (e, t) => {
  const r = new URLSearchParams(e.toString());
  return t.forEach((n) => r.delete(n)), r;
}, XOe = (e, t) => e.toString() === t.toString(), h8 = (e) => Array.from(e.keys()).length, QOe = (e, t) => new URLSearchParams({
  ...Object.fromEntries(e),
  ...Object.fromEntries(t)
});
function ZOe({
  children: e
}) {
  const t = Af(), { persistedSearchParams: r, setPersistedSearchParams: n } = MS();
  if (at(() => {
    h8(r) && n(
      T1(r),
      !1
    );
  }, []), h8(r) && !t.search) {
    const a = `${t.pathname}?${r.toString()}`;
    return /* @__PURE__ */ b(QM, { to: a });
  }
  return e || /* @__PURE__ */ b(rk, {});
}
const Dle = "PERSIST_SEARCH_PARAMS";
function MS() {
  const { pathname: e } = Af(), [t, r] = eC(Dle, {}), [n, a] = ZM(), i = qe(
    () => kle(t[e]),
    [t, e]
  ), o = qe(() => {
    const s = new URLSearchParams(i);
    return n.forEach((l, f) => {
      i.has(f) && s.set(f, l);
    }), s;
  }, [i, n]), u = ue(
    (s, l = !0) => {
      const f = {
        ...T1(o),
        ...s
      };
      if (r((c) => ({
        ...c,
        [e]: f
      })), l) {
        const c = new URLSearchParams({
          ...T1(n),
          ...f
        });
        a(c);
      }
    },
    [
      e,
      o,
      n,
      r,
      a
    ]
  ), d = ue(
    (s) => {
      const l = Array.isArray(s) ? s : [s], f = $J(
        t[e],
        l
      );
      r({
        ...t,
        [e]: f
      });
      const c = xle(
        n,
        l
      ), h = new URLSearchParams({
        ...T1(c),
        ...f
      });
      a(h);
    },
    [
      t,
      e,
      n,
      r,
      a
    ]
  );
  return {
    persistedSearchParams: o,
    setPersistedSearchParams: u,
    deletePersistedSearchParams: d
  };
}
var P1 = /* @__PURE__ */ ((e) => (e.IVR = "IVR", e.CLASSIC = "Classic", e.SMARTFLOW = "Smartflow", e.SMS = "SMS", e.MMS = "MMS", e))(P1 || {}), Cle = /* @__PURE__ */ ((e) => (e.AVAILABLE = "Available", e.OFFLINE = "Offline", e.PENDING_VALIDATION = "Pending Validation", e))(Cle || {}), Ia = /* @__PURE__ */ ((e) => (e.TEAMS = "teams", e.SEARCH = "search", e.ROLES = "roles", e.AVAILABILITY = "availability", e.COUNTRY = "country", e.LINE_TYPE = "type", e.LINE_STATUS = "status", e.SORT_DIRECTION = "direction", e.SORT_FIELD = "field", e))(Ia || {}), Sle = /* @__PURE__ */ ((e) => (e.ACTION_NEEDED = "ACTION_NEEDED", e.ALWAYS_CLOSED = "ALWAYS_CLOSED", e.ALWAYS_OPENED = "ALWAYS_OPENED", e.CLOSED = "CLOSED", e.OPENED = "OPENED", e))(Sle || {});
function JOe({
  debounceTimeout: e = 500,
  onSet: t
} = {}) {
  const {
    persistedSearchParams: r,
    setPersistedSearchParams: n,
    deletePersistedSearchParams: a
  } = MS();
  function i(f, c) {
    let h = c;
    switch (f) {
      case Ia.COUNTRY:
      case Ia.TEAMS:
        h = c.split(",");
        break;
      case Ia.SORT_DIRECTION:
        h = c.toUpperCase();
        break;
      case Ia.LINE_STATUS:
        h = c.toUpperCase().split(",");
        break;
      case Ia.ROLES:
      case Ia.AVAILABILITY:
        h = c.split(",").map((_) => V1(_));
        break;
      case Ia.LINE_TYPE: {
        h = c.split(",").map((_) => [
          P1.SMS.toLowerCase(),
          P1.MMS.toLowerCase(),
          P1.IVR.toLowerCase()
        ].includes(_) ? _.toUpperCase() : V1(_));
        break;
      }
      default:
        h = c;
        break;
    }
    return h;
  }
  function o(f, c) {
    let h;
    return Array.isArray(c) ? h = c.join(",") : h = c, [Ia.SEARCH, Ia.SORT_FIELD].includes(f) ? h : h.toLowerCase();
  }
  const u = ue(
    (f, c) => {
      const h = o(f, c);
      h === "" ? a(f) : n({ [f]: h }), t == null || t(f, h);
    },
    [a, t, n]
  ), d = qe(
    () => Iu(u, e),
    [e, u]
  ), s = ue(
    (f) => {
      const c = Object.entries(f).reduce(
        (h, [_, F]) => {
          const v = _, $ = o(
            v,
            F
          );
          return $ === "" && a(v), t == null || t(v, $), {
            ...h,
            ...$ && { [v]: $ }
          };
        },
        {}
      );
      n(c);
    },
    [a, t, n]
  ), l = ue(
    (f, c = null) => {
      const h = r.get(f);
      return h ? i(f, h) : c || null;
    },
    [r]
  );
  return { set: u, setDebounced: d, setMultiple: s, get: l };
}
function eTe() {
  const e = tk(), { pathname: t, search: r } = Af(), n = qe(() => new URLSearchParams(r), [r]), a = ue(
    (i) => {
      i && i.toString() !== "" ? e(`${t}?${i.toString()}`, { replace: !0 }) : e(`${t}`, { replace: !0 });
    },
    [e, t]
  );
  return { searchParams: n, setSearchParams: a };
}
const Ale = 5e3, Ole = 5;
function Tle({
  name: e,
  search: t,
  maxRows: r = Ole,
  saveDelayTime: n = Ale
}) {
  const a = tt(), i = qe(() => `${e}-history`, [e]), [o, u] = eC(
    i,
    []
  ), d = ue(
    (f) => {
      u((c) => {
        let h = c;
        const _ = c.indexOf(f);
        return _ >= 0 ? h = [
          f,
          ...c.slice(0, _),
          ...c.slice(_ + 1, c.length)
        ] : h.unshift(f), h.length > r && h.pop(), h;
      });
    },
    [r, u]
  ), s = ue(
    (f) => {
      a.current && clearTimeout(a.current), d(f);
    },
    [d]
  ), l = ue(() => {
    u([]);
  }, [u]);
  return at(() => t ? (a.current && clearTimeout(a.current), a.current = window.setTimeout(() => {
    d(t);
  }, n), () => {
    clearTimeout(a.current);
  }) : kn, [s, d, n, t]), {
    recentSearches: o,
    addSearch: s,
    clearAllSearch: l
  };
}
function Ple(e) {
  function t() {
    const a = xJ();
    return sessionStorage.setItem(e, a), a;
  }
  function r() {
    const a = sessionStorage.getItem(e);
    return a || t();
  }
  function n() {
    sessionStorage.removeItem(e);
  }
  return {
    setAndReturnNewFunnelId: t,
    getExistingOrNewFunnelId: r,
    deleteFunnelId: n
  };
}
const Ile = "add_on_subscription_funnel_started", Rle = "add_on_subscription_funnel_trial_initialized", jle = "add_on_subscription_funnel_trial_completed", Mle = "add_on_subscription_funnel_request_quote_completed", Ble = "add_on_subscription_funnel_request_quote_clicked", Nle = "add_on_subscription_funnel_learn_more_clicked", Lle = "add_on_subscription_funnel_blocked", qle = "add_on_subscription_funnel_upgrade_clicked", Ule = "addon_subscription_funnel_id";
function Gle(e) {
  const t = ik(), { setAndReturnNewFunnelId: r, getExistingOrNewFunnelId: n, deleteFunnelId: a } = Ple(Ule), i = ue(
    (_) => {
      e(
        Ile,
        _i({
          ..._,
          funnelId: r(),
          pagePath: t.pathname
        })
      );
    },
    [t.pathname, r, e]
  ), o = ue(
    (_) => {
      e(
        Rle,
        _i({
          ..._,
          funnelId: n()
        })
      );
    },
    [n, e]
  ), u = ue(
    (_) => {
      e(
        jle,
        _i({
          ..._,
          funnelId: n()
        })
      ), a();
    },
    [a, n, e]
  ), d = ue(
    (_) => {
      e(
        Mle,
        _i({
          ..._,
          funnelId: n()
        })
      ), a();
    },
    [a, n, e]
  ), s = ue(
    (_) => {
      e(
        Ble,
        _i({
          ..._,
          funnelId: n()
        })
      );
    },
    [n, e]
  ), l = ue(
    (_) => {
      e(
        qle,
        _i({
          ..._,
          funnelId: n()
        })
      ), a();
    },
    [a, n, e]
  ), f = ue(
    (_) => {
      e(
        Nle,
        _i({
          ..._
        })
      );
    },
    [e]
  ), c = ue(
    (_) => {
      e(
        Lle,
        _i({
          ..._,
          funnelId: n()
        })
      ), a();
    },
    [a, n, e]
  );
  return qe(
    () => ({
      trackAddonSubscriptionFunnelStarted: i,
      trackAddonTrialInitialized: o,
      trackAddonTrialCompleted: u,
      trackAddonRequestQuoteCompleted: d,
      trackAddonLearnMoreClicked: f,
      trackAddonSubscriptionFunnelBlocked: c,
      trackAddonRequestQuoteClicked: s,
      trackAddonUpgradeClicked: l
    }),
    [
      i,
      o,
      u,
      d,
      f,
      c,
      s,
      l
    ]
  );
}
function tTe(e) {
  const t = eB(), r = ik(), { trackAddonSubscriptionFunnelStarted: n } = Gle(e);
  return ue(
    (i, o) => {
      n({ addonName: i, buttonNameClicked: o }), t(`/addons/${i}?from=${r.pathname}`);
    },
    [t, n, r.pathname]
  );
}
const Wle = Ge(Ae)`
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 16px;
  border-top: 1px solid ${He("neutral-200")};
  will-change: transform;
`, Vle = xS(ot), g8 = {
  enter: {
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: "easeInOut"
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.35,
      ease: "easeInOut"
    }
  }
}, Hle = {
  enter: {
    ...g8.enter,
    height: 65
  },
  exit: {
    ...g8.exit,
    height: 0
  }
};
function Xh({
  pristine: e,
  submitting: t,
  submitSucceeded: r
}) {
  return t ? ga.SAVING : r && e ? ga.SAVED : ga.UNSAVED;
}
const _8 = yF(
  ({
    formProps: e,
    lang: t,
    submitButtonText: r,
    successButtonText: n,
    undoButtonText: a
  }) => {
    const { hasValidationErrors: i, handleSubmit: o } = e, u = e.form.reset, d = Xh(e);
    return /* @__PURE__ */ b(
      Vle,
      {
        "data-test": "save-bar",
        overflow: "hidden",
        variants: Hle,
        initial: "exit",
        animate: "enter",
        exit: "exit",
        children: /* @__PURE__ */ b(Wle, { children: /* @__PURE__ */ ne(Dt, { space: "xxs", alignItems: "center", children: [
          u && d === "unsaved" && /* @__PURE__ */ b(
            nr,
            {
              "data-test": "undo-button",
              onClick: u,
              variant: "secondary",
              mode: "ghost",
              children: a || qa[t][La.UNDO]
            }
          ),
          /* @__PURE__ */ b(
            Nl,
            {
              status: d,
              onClick: o,
              disabled: i,
              savedText: n || qa[t][La.SAVED],
              unsavedText: r || qa[t][La.UNSAVED]
            }
          )
        ] }) })
      }
    );
  }
), m8 = yF(
  ({
    children: e,
    shouldBlockNavigation: t = !1,
    formProps: r
  }) => {
    const { pristine: n, submitSucceeded: a, submitFailed: i } = r, [o, u] = Um(!1);
    OS(
      // only block the navigation if the form values are changed
      t && !n
    );
    const d = Xh(r);
    at(() => {
      d === ga.SAVED && u(!0, 1e3, !1);
    }, [d, u]);
    const s = d === ga.SAVING;
    return /* @__PURE__ */ b(Uf, { children: (!n || s || a && o || i) && e });
  }
), zle = yF(
  ({
    shouldUseContext: e = !0,
    formProps: t,
    lang: r = "en",
    ...n
  }) => {
    const { containerElement: a } = Et(SS);
    return e && a ? I3(
      /* @__PURE__ */ b(m8, { formProps: t, children: /* @__PURE__ */ b(_8, { formProps: t, lang: r, ...n }) }),
      a
    ) : /* @__PURE__ */ b(m8, { formProps: t, ...n, children: /* @__PURE__ */ b(_8, { formProps: t, lang: r, ...n }) });
  }
);
function Kle({
  children: e,
  title: t,
  subtitle: r,
  shouldBlockNavigation: n,
  formProps: a,
  getErrorMessage: i,
  lang: o,
  submitButtonText: u,
  successButtonText: d,
  undoButtonText: s,
  ...l
}) {
  return /* @__PURE__ */ b(T3, { ...a, children: (f) => /* @__PURE__ */ b(x3, { onSubmit: f.handleSubmit, children: /* @__PURE__ */ b(
    vde,
    {
      ...l,
      title: t,
      subtitle: r,
      footer: /* @__PURE__ */ ne(Nr, { children: [
        /* @__PURE__ */ b(Uf, { children: i && f.submitError && /* @__PURE__ */ ne(
          wl,
          {
            "data-test": "paper-form-error-banner",
            variant: "critical",
            children: [
              /* @__PURE__ */ b(kl, {}),
              /* @__PURE__ */ b(xl, { children: i(f.submitError) })
            ]
          }
        ) }),
        /* @__PURE__ */ b(
          zle,
          {
            formProps: f,
            shouldUseContext: !1,
            shouldBlockNavigation: n,
            lang: o,
            submitButtonText: u,
            successButtonText: d,
            undoButtonText: s
          }
        )
      ] }),
      children: e(f)
    }
  ) }) });
}
function Yle({
  name: e,
  label: t,
  options: r,
  placeholder: n,
  onChange: a,
  validate: i,
  t: o,
  children: u,
  ...d
}) {
  const {
    input: { value: s, onChange: l, onBlur: f },
    meta: { error: c, touched: h }
  } = ak(e, { validate: i }), _ = c && h, F = ue(
    ($) => {
      a ? a($[0]) : l($[0]);
    },
    [l, a]
  ), v = s ? [s] : void 0;
  return /* @__PURE__ */ b(
    fs,
    {
      label: t,
      name: e,
      gridAutoRows: "max-content",
      validationStatus: _ ? "error" : void 0,
      helpText: _ ? o(c) : void 0,
      children: u ? u({ onChange: F, selectedKeys: v, onBlur: f }) : /* @__PURE__ */ b(
        Sf,
        {
          placeholder: n,
          options: r,
          onSelectionChange: F,
          onBlur: f,
          selectedKeys: v,
          ...d
        }
      )
    }
  );
}
function p8({
  "data-test": e = "time-select",
  value: t = 0,
  from: r = 0,
  // 00:00
  to: n = 1440,
  // 24:00
  onChange: a
}) {
  const i = (u) => {
    a(u == null ? void 0 : u[0]);
  }, o = qe(
    () => [...new Array(49)].reduce((u, d, s) => {
      const l = r + s * 30;
      if (l > n)
        return u;
      const f = (l % 60).toString().padStart(2, "0"), h = `${Math.floor(l / 60).toString().padStart(2, "0")}:${f}`;
      return [...u, { value: l, label: h }];
    }, []),
    [r, n]
  );
  return /* @__PURE__ */ b(
    Sf,
    {
      "data-test": e,
      selectedKeys: [t],
      options: o,
      onSelectionChange: i
    }
  );
}
const Xle = Ge(AF)`
  position: relative;
`;
function Qle({
  from: e,
  to: t,
  name: r,
  hasIcon: n,
  onRemove: a,
  "data-test": i,
  texts: o,
  ...u
}) {
  const d = P3(), s = ue(
    (l) => {
      d.change(`${r}.from`, l), d.change(`${r}.to`, Math.max(l + 30, t));
    },
    [d, r, t]
  );
  return /* @__PURE__ */ ne(
    Xle,
    {
      gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
      w: "100%",
      p: "s",
      pr: "xl",
      "data-test": i,
      ...u,
      children: [
        /* @__PURE__ */ b(go, { xs: 6, children: /* @__PURE__ */ b(fs, { label: "Available on", children: /* @__PURE__ */ b(sl, { name: `${r}.days`, children: ({ input: { value: l, onChange: f } }) => /* @__PURE__ */ b(
          lfe,
          {
            mt: 12,
            selectedDays: l,
            onChange: f,
            texts: o.days
          }
        ) }) }) }),
        /* @__PURE__ */ b(go, { xs: 6, children: /* @__PURE__ */ ne(Dt, { space: "s", children: [
          /* @__PURE__ */ b(fs, { label: "From", children: /* @__PURE__ */ b(sl, { name: `${r}.from`, children: ({ input: { value: l } }) => /* @__PURE__ */ b(
            p8,
            {
              "data-test": `${i}-from-time-select`,
              value: l,
              from: 0,
              to: 1410,
              onChange: s
            }
          ) }) }),
          /* @__PURE__ */ b(fs, { label: "To", children: /* @__PURE__ */ b(sl, { name: `${r}.to`, children: ({ input: { value: l, onChange: f } }) => /* @__PURE__ */ b(
            p8,
            {
              "data-test": `${i}-to-time-select`,
              value: l,
              from: e + 30,
              onChange: f
            }
          ) }) })
        ] }) }),
        n && /* @__PURE__ */ b(ot, { position: "absolute", top: "2px", right: "2px", children: /* @__PURE__ */ b(
          zw,
          {
            trigger: /* @__PURE__ */ b(
              nr,
              {
                mode: "ghost",
                shape: "circle",
                variant: "secondary",
                size: "xSmall",
                "data-test": `${i}-action-button`,
                children: /* @__PURE__ */ b(y3, {})
              }
            ),
            items: [
              {
                name: o.remove,
                onClick: a
              }
            ]
          }
        ) })
      ]
    }
  );
}
function vo() {
  return vo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, vo.apply(this, arguments);
}
function g0(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Zle(e, t) {
  var r = e.render, n = e.children, a = e.component, i = g0(e, ["render", "children", "component"]);
  if (a)
    return /* @__PURE__ */ uh(a, vo({}, i, {
      children: n,
      render: r
    }));
  if (r)
    return r(n === void 0 ? i : vo({}, i, {
      children: n
    }));
  if (typeof n != "function")
    throw new Error("Must specify either a render prop, a render function as children, or a component prop to " + t);
  return n(i);
}
var Jle = function(t, r) {
  return t === r || Array.isArray(t) && Array.isArray(r) && t.length === r.length && !t.some(function(n, a) {
    return n !== r[a];
  });
};
function F8(e) {
  var t = M.useRef();
  return t.current || (t.current = e()), t.current;
}
var efe = tB.reduce(function(e, t) {
  return e[t] = !0, e;
}, {}), tfe = function(t, r) {
  var n = r === void 0 ? {} : r, a = n.subscription, i = a === void 0 ? efe : a, o = n.defaultValue, u = n.initialValue, d = n.isEqual, s = d === void 0 ? Jle : d, l = n.validate, f = P3("useFieldArray"), c = f.mutators, h = !!(c && c.push && c.pop);
  if (!h)
    throw new Error("Array mutators not found. You need to provide the mutators from final-form-arrays to your form");
  var _ = F8(function() {
    return (
      // curry the field name onto all mutator calls
      Object.keys(c).reduce(function(S, N) {
        return S[N] = function() {
          for (var W = arguments.length, V = new Array(W), K = 0; K < W; K++)
            V[K] = arguments[K];
          return c[N].apply(c, [t].concat(V));
        }, S;
      }, {})
    );
  }), F = F8(function() {
    return function(S, N, W) {
      if (l) {
        var V = l(S, N, W);
        if (!V || Array.isArray(V))
          return V;
        var K = [];
        return K[nB] = V, K;
      }
    };
  }), v = ak(t, {
    subscription: vo({}, i, {
      length: !0
    }),
    defaultValue: o,
    initialValue: u,
    isEqual: s,
    validate: F,
    format: function(N) {
      return N;
    }
  }), $ = v.meta, E = $.length, D = g0($, ["length"]), w = v.input, k = g0(v, ["meta", "input"]), A = function(N) {
    for (var W = E || 0, V = 0; V < W; V++)
      N(t + "[" + V + "]", V);
  }, P = function(N) {
    for (var W = E || 0, V = [], K = 0; K < W; K++)
      V.push(N(t + "[" + K + "]", K));
    return V;
  };
  return {
    fields: vo({
      name: t,
      forEach: A,
      length: E || 0,
      map: P
    }, _, k, {
      value: w.value
    }),
    meta: D
  };
}, rfe = "3.1.2", nfe = {
  "final-form": rB,
  "react-final-form": JM,
  "react-final-form-arrays": rfe
}, afe = function(t) {
  var r = t.name, n = t.subscription, a = t.defaultValue, i = t.initialValue, o = t.isEqual, u = t.validate, d = g0(t, ["name", "subscription", "defaultValue", "initialValue", "isEqual", "validate"]), s = tfe(r, {
    subscription: n,
    defaultValue: a,
    initialValue: i,
    isEqual: o,
    validate: u
  }), l = s.fields, f = s.meta;
  return Zle(vo({
    fields: l,
    meta: vo({}, f, {
      __versions: nfe
    })
  }, d), "FieldArray(" + r + ")");
};
function ife({ slots: e, texts: t }) {
  const r = P3(), n = ue(() => {
    r.mutators.push("slots", {
      __typename: "AvailabilitySlot",
      days: [
        bn.MONDAY,
        bn.TUESDAY,
        bn.WEDNESDAY,
        bn.THURSDAY,
        bn.FRIDAY
      ],
      from: 540,
      to: 1080
    });
  }, [r]);
  function a(i) {
    r.mutators.remove("slots", i);
  }
  return /* @__PURE__ */ ne(Nr, { children: [
    /* @__PURE__ */ b(afe, { name: "slots", children: ({ fields: i }) => /* @__PURE__ */ b(fs, { label: t.timeslotLabel, children: /* @__PURE__ */ b(EM, { "data-test": "timeslots", children: /* @__PURE__ */ b($M, { children: i.map((o, u) => /* @__PURE__ */ b(Kw, { h: "auto", children: /* @__PURE__ */ b(
      Qle,
      {
        hasIcon: i.length !== 1,
        name: o,
        ...e[u],
        onRemove: () => a(u),
        "data-test": `timeslot-${u + 1}`,
        texts: {
          remove: t.remove,
          days: t.days
        }
      }
    ) }, o)) }) }) }) }),
    /* @__PURE__ */ b(
      nG,
      {
        "data-test": "timeslots-add-button",
        isLarge: !1,
        onClick: n,
        children: t.addNew
      }
    )
  ] });
}
function ofe({
  "data-test": e = "single-search-select",
  ...t
}) {
  return /* @__PURE__ */ b(
    SF,
    {
      ...t,
      "data-test": e,
      showSelectedOnTop: !1,
      selectionMode: "single",
      resetSearchOnSelect: !1
    }
  );
}
function sfe({
  onChange: e,
  shouldGuessTimezone: t,
  value: r,
  options: n,
  ...a
}) {
  const i = qe(
    () => fae(n).map((f) => ({
      formattedUtcOffset: f.formattedUtcOffset,
      label: f.name,
      value: f.value
    })),
    [n]
  ), [o, u] = Xe(i), d = (f) => {
    const c = f.trim().toLocaleLowerCase();
    u(
      i.filter(
        (h) => {
          var _;
          return h.label.toLowerCase().includes(c) || ((_ = h.formattedUtcOffset) == null ? void 0 : _.toLowerCase().includes(c));
        }
      )
    );
  }, s = (f) => {
    e(f == null ? void 0 : f[0]);
  }, l = qe(() => {
    if (r)
      return [r];
    if (t) {
      const f = window.Intl.DateTimeFormat().resolvedOptions().timeZone;
      return o.find((c) => c.value === f) ? [f] : [o[0].value];
    }
    return [];
  }, [r, t, o]);
  return /* @__PURE__ */ b(
    ofe,
    {
      ...a,
      options: o,
      onSearch: d,
      renderItem: (f) => /* @__PURE__ */ ne(Nr, { children: [
        /* @__PURE__ */ b($3, { children: f.label }),
        /* @__PURE__ */ b(w3, { children: /* @__PURE__ */ b($e, { color: "neutral-400", variant: "bodyRegularS", children: f.formattedUtcOffset }) })
      ] }),
      selectedKeys: l,
      onSelect: s
    }
  );
}
function rTe({
  initialValues: e,
  onSubmit: t,
  title: r,
  texts: n,
  t: a,
  ...i
}) {
  const { addNew: o, timeslotLabel: u, remove: d, days: s } = n, l = ue(
    (f) => {
      const { availability: c } = f;
      return c === so.CUSTOM ? /* @__PURE__ */ b(go, { xs: 12, children: /* @__PURE__ */ b(
        ife,
        {
          slots: f.slots,
          texts: {
            addNew: o,
            timeslotLabel: u,
            remove: d,
            days: s
          }
        }
      ) }) : null;
    },
    [o, s, d, u]
  );
  return /* @__PURE__ */ b(
    Kle,
    {
      title: r,
      shouldBlockNavigation: !0,
      formProps: {
        onSubmit: t,
        initialValues: e,
        mutators: { ...sie }
      },
      fluid: !0,
      ...i,
      children: ({ values: f }) => /* @__PURE__ */ ne(AF, { children: [
        /* @__PURE__ */ b(go, { xs: 6, children: /* @__PURE__ */ b(fs, { label: n.timezone, children: /* @__PURE__ */ b(sl, { name: "timezone", children: ({ input: { value: c, onChange: h } }) => /* @__PURE__ */ b(
          sfe,
          {
            onChange: h,
            triggerStyle: "select",
            value: c
          }
        ) }) }) }),
        /* @__PURE__ */ b(go, { xs: 6, children: /* @__PURE__ */ b(
          Yle,
          {
            label: n.availabilityLabel,
            name: "availability",
            size: "regular",
            "data-test": "availability-select",
            t: a,
            children: ({ selectedKeys: c, onChange: h, onBlur: _ }) => /* @__PURE__ */ b(
              iG,
              {
                onSelectionChange: h,
                onBlur: _,
                selectedKeys: c,
                texts: {
                  always: n.always,
                  alwaysDescription: n.alwaysDescription,
                  never: n.never,
                  neverDescription: n.neverDescription,
                  scheduled: n.scheduled
                }
              }
            )
          }
        ) }),
        l(f)
      ] })
    }
  );
}
var bn = /* @__PURE__ */ ((e) => (e.FRIDAY = "FRIDAY", e.MONDAY = "MONDAY", e.SATURDAY = "SATURDAY", e.SUNDAY = "SUNDAY", e.THURSDAY = "THURSDAY", e.TUESDAY = "TUESDAY", e.WEDNESDAY = "WEDNESDAY", e))(bn || {});
const ufe = Ge(Ae)`
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  ${({ isActive: e }) => _r`
    background-color: ${e ? "primary-500" : "neutral-400"};
  `};
  color: text-inverted;
  cursor: pointer;
  user-select: none;
`;
function dfe({
  dayOfWeek: e,
  isActive: t,
  onClick: r,
  texts: n
}) {
  return /* @__PURE__ */ b(
    ufe,
    {
      isActive: t,
      onClick: () => r(e),
      "data-test": `day-of-week-${e}`,
      children: /* @__PURE__ */ b($e, { variant: "bodyMediumS", top: 2, children: n[e] })
    }
  );
}
function lfe({
  selectedDays: e,
  onChange: t,
  texts: r,
  ...n
}) {
  const a = ue(
    (o) => {
      const u = e.includes(o) ? e.filter((d) => d !== o) : [...e, o];
      t == null || t(u);
    },
    [t, e]
  ), i = [
    bn.MONDAY,
    bn.TUESDAY,
    bn.WEDNESDAY,
    bn.THURSDAY,
    bn.FRIDAY,
    bn.SATURDAY,
    bn.SUNDAY
  ].map((o) => /* @__PURE__ */ b(
    dfe,
    {
      dayOfWeek: o,
      onClick: a,
      isActive: e.includes(o),
      texts: r
    },
    o
  ));
  return /* @__PURE__ */ b(Dt, { space: "xxs", ...n, children: i });
}
function ffe({ date: e, locale: t, ...r }) {
  return /* @__PURE__ */ b($e, { ...r, children: e.toLocaleDateString(t, {
    day: "numeric",
    month: "short"
  }) });
}
function e4({ date: e, locale: t, ...r }) {
  return /* @__PURE__ */ b($e, { ...r, children: OH(e, t) });
}
function cfe({ date: e, locale: t, ...r }) {
  return /* @__PURE__ */ ne($e, { ...r, children: [
    /* @__PURE__ */ b(ffe, { date: e, locale: t, ...r, display: "inline" }),
    " - ",
    /* @__PURE__ */ b(e4, { date: e, locale: t, ...r, display: "inline" })
  ] });
}
function nTe({
  children: e,
  "data-test": t = "drawer-section",
  ...r
}) {
  return /* @__PURE__ */ b(ur, { gap: "xxs", flexDirection: "column", "data-test": t, ...r, children: e });
}
function aTe({
  children: e,
  "data-test": t = "drawer-section-body",
  ...r
}) {
  return /* @__PURE__ */ b(ur, { gap: "xxs", "data-test": t, ...r, children: e });
}
function hfe({
  component: e,
  color: t,
  size: r,
  ...n
}) {
  return M.isValidElement(e) ? e : /* @__PURE__ */ b(
    sr,
    {
      component: e,
      color: t,
      size: r,
      ...n
    }
  );
}
function iTe({
  icon: {
    component: e,
    color: t = "icon-default",
    size: r = 16,
    ...n
  },
  title: a,
  typography: {
    color: i = "neutral-800",
    variant: o = "bodySemiboldM",
    ...u
  } = {},
  "data-test": d = "drawer-section-header",
  ...s
}) {
  return /* @__PURE__ */ ne(ur, { gap: "xxs", alignItems: "center", "data-test": d, ...s, children: [
    /* @__PURE__ */ b(
      hfe,
      {
        component: e,
        color: t,
        size: r,
        "data-test": `${d}-icon`,
        ...n
      }
    ),
    /* @__PURE__ */ b(
      $e,
      {
        variant: o,
        color: i,
        "data-test": `${d}-title`,
        ...u,
        children: a
      }
    )
  ] });
}
function fd(e, t, r, n) {
  function a(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        o(f);
      }
    }
    function d(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        o(f);
      }
    }
    function s(l) {
      l.done ? i(l.value) : a(l.value).then(u, d);
    }
    s((n = n.apply(e, t || [])).next());
  });
}
function cd(e, t) {
  var r = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function u(s) {
    return function(l) {
      return d([s, l]);
    };
  }
  function d(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (r = 0)), r; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return r.label++, { value: s[1], done: !1 };
          case 5:
            r.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (i = r.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              r = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              r.label = s[1];
              break;
            }
            if (s[0] === 6 && r.label < i[1]) {
              r.label = i[1], i = s;
              break;
            }
            if (i && r.label < i[2]) {
              r.label = i[2], r.ops.push(s);
              break;
            }
            i[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        s = t.call(e, r);
      } catch (l) {
        s = [6, l], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}
function y8(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), a, i = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      a && !a.done && (r = n.return) && r.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}
function b8(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, a = t.length, i; n < a; n++)
      (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var gfe = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function Gf(e, t) {
  var r = _fe(e);
  if (typeof r.path != "string") {
    var n = e.webkitRelativePath;
    Object.defineProperty(r, "path", {
      value: typeof t == "string" ? t : typeof n == "string" && n.length > 0 ? n : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return r;
}
function _fe(e) {
  var t = e.name, r = t && t.lastIndexOf(".") !== -1;
  if (r && !e.type) {
    var n = t.split(".").pop().toLowerCase(), a = gfe.get(n);
    a && Object.defineProperty(e, "type", {
      value: a,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var mfe = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function pfe(e) {
  return fd(this, void 0, void 0, function() {
    return cd(this, function(t) {
      return _0(e) && Ffe(e.dataTransfer) ? [2, Efe(e.dataTransfer, e.type)] : yfe(e) ? [2, bfe(e)] : Array.isArray(e) && e.every(function(r) {
        return "getFile" in r && typeof r.getFile == "function";
      }) ? [2, vfe(e)] : [2, []];
    });
  });
}
function Ffe(e) {
  return _0(e);
}
function yfe(e) {
  return _0(e) && _0(e.target);
}
function _0(e) {
  return typeof e == "object" && e !== null;
}
function bfe(e) {
  return Wm(e.target.files).map(function(t) {
    return Gf(t);
  });
}
function vfe(e) {
  return fd(this, void 0, void 0, function() {
    var t;
    return cd(this, function(r) {
      switch (r.label) {
        case 0:
          return [4, Promise.all(e.map(function(n) {
            return n.getFile();
          }))];
        case 1:
          return t = r.sent(), [2, t.map(function(n) {
            return Gf(n);
          })];
      }
    });
  });
}
function Efe(e, t) {
  return fd(this, void 0, void 0, function() {
    var r, n;
    return cd(this, function(a) {
      switch (a.label) {
        case 0:
          return e.items ? (r = Wm(e.items).filter(function(i) {
            return i.kind === "file";
          }), t !== "drop" ? [2, r] : [4, Promise.all(r.map($fe))]) : [3, 2];
        case 1:
          return n = a.sent(), [2, v8(BS(n))];
        case 2:
          return [2, v8(Wm(e.files).map(function(i) {
            return Gf(i);
          }))];
      }
    });
  });
}
function v8(e) {
  return e.filter(function(t) {
    return mfe.indexOf(t.name) === -1;
  });
}
function Wm(e) {
  if (e === null)
    return [];
  for (var t = [], r = 0; r < e.length; r++) {
    var n = e[r];
    t.push(n);
  }
  return t;
}
function $fe(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return E8(e);
  var t = e.webkitGetAsEntry();
  return t && t.isDirectory ? NS(t) : E8(e);
}
function BS(e) {
  return e.reduce(function(t, r) {
    return b8(b8([], y8(t), !1), y8(Array.isArray(r) ? BS(r) : [r]), !1);
  }, []);
}
function E8(e) {
  var t = e.getAsFile();
  if (!t)
    return Promise.reject("".concat(e, " is not a File"));
  var r = Gf(t);
  return Promise.resolve(r);
}
function wfe(e) {
  return fd(this, void 0, void 0, function() {
    return cd(this, function(t) {
      return [2, e.isDirectory ? NS(e) : kfe(e)];
    });
  });
}
function NS(e) {
  var t = e.createReader();
  return new Promise(function(r, n) {
    var a = [];
    function i() {
      var o = this;
      t.readEntries(function(u) {
        return fd(o, void 0, void 0, function() {
          var d, s, l;
          return cd(this, function(f) {
            switch (f.label) {
              case 0:
                if (u.length)
                  return [3, 5];
                f.label = 1;
              case 1:
                return f.trys.push([1, 3, , 4]), [4, Promise.all(a)];
              case 2:
                return d = f.sent(), r(d), [3, 4];
              case 3:
                return s = f.sent(), n(s), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                l = Promise.all(u.map(wfe)), a.push(l), i(), f.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(u) {
        n(u);
      });
    }
    i();
  });
}
function kfe(e) {
  return fd(this, void 0, void 0, function() {
    return cd(this, function(t) {
      return [2, new Promise(function(r, n) {
        e.file(function(a) {
          var i = Gf(a, e.fullPath);
          r(i);
        }, function(a) {
          n(a);
        });
      })];
    });
  });
}
var xfe = function(e, t) {
  if (e && t) {
    var r = Array.isArray(t) ? t : t.split(","), n = e.name || "", a = (e.type || "").toLowerCase(), i = a.replace(/\/.*$/, "");
    return r.some(function(o) {
      var u = o.trim().toLowerCase();
      return u.charAt(0) === "." ? n.toLowerCase().endsWith(u) : u.endsWith("/*") ? i === u.replace(/\/.*$/, "") : a === u;
    });
  }
  return !0;
};
function $8(e) {
  return Sfe(e) || Cfe(e) || LS(e) || Dfe();
}
function Dfe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Cfe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Sfe(e) {
  if (Array.isArray(e))
    return Vm(e);
}
function Afe(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ql(e, t) {
  return Pfe(e) || Tfe(e, t) || LS(e, t) || Ofe();
}
function Ofe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function LS(e, t) {
  if (e) {
    if (typeof e == "string")
      return Vm(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Vm(e, t);
  }
}
function Vm(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Tfe(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], a = !0, i = !1, o, u;
    try {
      for (r = r.call(e); !(a = (o = r.next()).done) && (n.push(o.value), !(t && n.length === t)); a = !0)
        ;
    } catch (d) {
      i = !0, u = d;
    } finally {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (i)
          throw u;
      }
    }
    return n;
  }
}
function Pfe(e) {
  if (Array.isArray(e))
    return e;
}
var Ife = "file-invalid-type", Rfe = "file-too-large", jfe = "file-too-small", Mfe = "too-many-files", Bfe = function(t) {
  t = Array.isArray(t) && t.length === 1 ? t[0] : t;
  var r = Array.isArray(t) ? "one of ".concat(t.join(", ")) : t;
  return {
    code: Ife,
    message: "File type must be ".concat(r)
  };
}, w8 = function(t) {
  return {
    code: Rfe,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, k8 = function(t) {
  return {
    code: jfe,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, Nfe = {
  code: Mfe,
  message: "Too many files"
};
function qS(e, t) {
  var r = e.type === "application/x-moz-file" || xfe(e, t);
  return [r, r ? null : Bfe(t)];
}
function US(e, t, r) {
  if (rs(e.size))
    if (rs(t) && rs(r)) {
      if (e.size > r)
        return [!1, w8(r)];
      if (e.size < t)
        return [!1, k8(t)];
    } else {
      if (rs(t) && e.size < t)
        return [!1, k8(t)];
      if (rs(r) && e.size > r)
        return [!1, w8(r)];
    }
  return [!0, null];
}
function rs(e) {
  return e != null;
}
function Lfe(e) {
  var t = e.files, r = e.accept, n = e.minSize, a = e.maxSize, i = e.multiple, o = e.maxFiles, u = e.validator;
  return !i && t.length > 1 || i && o >= 1 && t.length > o ? !1 : t.every(function(d) {
    var s = qS(d, r), l = ql(s, 1), f = l[0], c = US(d, n, a), h = ql(c, 1), _ = h[0], F = u ? u(d) : null;
    return f && _ && !F;
  });
}
function m0(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function d1(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function x8(e) {
  e.preventDefault();
}
function qfe(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function Ufe(e) {
  return e.indexOf("Edge/") !== -1;
}
function Gfe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return qfe(e) || Ufe(e);
}
function Ta() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return function(n) {
    for (var a = arguments.length, i = new Array(a > 1 ? a - 1 : 0), o = 1; o < a; o++)
      i[o - 1] = arguments[o];
    return t.some(function(u) {
      return !m0(n) && u && u.apply(void 0, [n].concat(i)), m0(n);
    });
  };
}
function Wfe() {
  return "showOpenFilePicker" in window;
}
function Vfe(e) {
  return rs(e) ? Object.entries(e).filter(function(t) {
    var r = ql(t, 2), n = r[0], a = r[1], i = !0;
    return GS(n) || (console.warn('Skipped "'.concat(n, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), i = !1), (!Array.isArray(a) || !a.every(WS)) && (console.warn('Skipped "'.concat(n, '" because an invalid file extension was provided.')), i = !1), i;
  }).map(function(t) {
    var r = ql(t, 2), n = r[0], a = r[1];
    return {
      accept: Afe({}, n, a)
    };
  }) : e;
}
function Hfe(e) {
  if (rs(e))
    return Object.entries(e).reduce(function(t, r) {
      var n = ql(r, 2), a = n[0], i = n[1];
      return [].concat($8(t), [a], $8(i));
    }, []).filter(function(t) {
      return GS(t) || WS(t);
    }).join(",");
}
function zfe(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function Kfe(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function GS(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function WS(e) {
  return /^.*\.[\w]+$/.test(e);
}
var Yfe = ["children"], Xfe = ["open"], Qfe = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], Zfe = ["refKey", "onChange", "onClick"];
function Jfe(e) {
  return rce(e) || tce(e) || VS(e) || ece();
}
function ece() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tce(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function rce(e) {
  if (Array.isArray(e))
    return Hm(e);
}
function l2(e, t) {
  return ice(e) || ace(e, t) || VS(e, t) || nce();
}
function nce() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function VS(e, t) {
  if (e) {
    if (typeof e == "string")
      return Hm(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Hm(e, t);
  }
}
function Hm(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function ace(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], a = !0, i = !1, o, u;
    try {
      for (r = r.call(e); !(a = (o = r.next()).done) && (n.push(o.value), !(t && n.length === t)); a = !0)
        ;
    } catch (d) {
      i = !0, u = d;
    } finally {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (i)
          throw u;
      }
    }
    return n;
  }
}
function ice(e) {
  if (Array.isArray(e))
    return e;
}
function D8(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ar(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? D8(Object(r), !0).forEach(function(n) {
      zm(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : D8(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function zm(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function p0(e, t) {
  if (e == null)
    return {};
  var r = oce(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function oce(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var t4 = /* @__PURE__ */ Xn(function(e, t) {
  var r = e.children, n = p0(e, Yfe), a = zS(n), i = a.open, o = p0(a, Xfe);
  return Tw(t, function() {
    return {
      open: i
    };
  }, [i]), /* @__PURE__ */ M.createElement(m3, null, r(ar(ar({}, o), {}, {
    open: i
  })));
});
t4.displayName = "Dropzone";
var HS = {
  disabled: !1,
  getFilesFromEvent: pfe,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0,
  autoFocus: !1
};
t4.defaultProps = HS;
t4.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: re.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: re.objectOf(re.arrayOf(re.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: re.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: re.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: re.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: re.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: re.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: re.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: re.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: re.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: re.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: re.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: re.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: re.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: re.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: re.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: re.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: re.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: re.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: re.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: re.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: re.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: re.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: re.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: re.func
};
var Km = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function zS() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = ar(ar({}, HS), e), r = t.accept, n = t.disabled, a = t.getFilesFromEvent, i = t.maxSize, o = t.minSize, u = t.multiple, d = t.maxFiles, s = t.onDragEnter, l = t.onDragLeave, f = t.onDragOver, c = t.onDrop, h = t.onDropAccepted, _ = t.onDropRejected, F = t.onFileDialogCancel, v = t.onFileDialogOpen, $ = t.useFsAccessApi, E = t.autoFocus, D = t.preventDropOnDocument, w = t.noClick, k = t.noKeyboard, A = t.noDrag, P = t.noDragEventsBubbling, S = t.onError, N = t.validator, W = qe(function() {
    return Hfe(r);
  }, [r]), V = qe(function() {
    return Vfe(r);
  }, [r]), K = qe(function() {
    return typeof v == "function" ? v : C8;
  }, [v]), U = qe(function() {
    return typeof F == "function" ? F : C8;
  }, [F]), j = tt(null), G = tt(null), H = Ow(sce, Km), J = l2(H, 2), ae = J[0], de = J[1], te = ae.isFocused, ee = ae.isFileDialogActive, ge = tt(typeof window < "u" && window.isSecureContext && $ && Wfe()), De = function() {
    !ge.current && ee && setTimeout(function() {
      if (G.current) {
        var Pe = G.current.files;
        Pe.length || (de({
          type: "closeDialog"
        }), U());
      }
    }, 300);
  };
  at(function() {
    return window.addEventListener("focus", De, !1), function() {
      window.removeEventListener("focus", De, !1);
    };
  }, [G, ee, U, ge]);
  var xe = tt([]), ze = function(Pe) {
    j.current && j.current.contains(Pe.target) || (Pe.preventDefault(), xe.current = []);
  };
  at(function() {
    return D && (document.addEventListener("dragover", x8, !1), document.addEventListener("drop", ze, !1)), function() {
      D && (document.removeEventListener("dragover", x8), document.removeEventListener("drop", ze));
    };
  }, [j, D]), at(function() {
    return !n && E && j.current && j.current.focus(), function() {
    };
  }, [j, E, n]);
  var q = ue(function(Oe) {
    S ? S(Oe) : console.error(Oe);
  }, [S]), Ue = ue(function(Oe) {
    Oe.preventDefault(), Oe.persist(), Kt(Oe), xe.current = [].concat(Jfe(xe.current), [Oe.target]), d1(Oe) && Promise.resolve(a(Oe)).then(function(Pe) {
      if (!(m0(Oe) && !P)) {
        var st = Pe.length, Qe = st > 0 && Lfe({
          files: Pe,
          accept: W,
          minSize: o,
          maxSize: i,
          multiple: u,
          maxFiles: d,
          validator: N
        }), et = st > 0 && !Qe;
        de({
          isDragAccept: Qe,
          isDragReject: et,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), s && s(Oe);
      }
    }).catch(function(Pe) {
      return q(Pe);
    });
  }, [a, s, q, P, W, o, i, u, d, N]), Ce = ue(function(Oe) {
    Oe.preventDefault(), Oe.persist(), Kt(Oe);
    var Pe = d1(Oe);
    if (Pe && Oe.dataTransfer)
      try {
        Oe.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return Pe && f && f(Oe), !1;
  }, [f, P]), me = ue(function(Oe) {
    Oe.preventDefault(), Oe.persist(), Kt(Oe);
    var Pe = xe.current.filter(function(Qe) {
      return j.current && j.current.contains(Qe);
    }), st = Pe.indexOf(Oe.target);
    st !== -1 && Pe.splice(st, 1), xe.current = Pe, !(Pe.length > 0) && (de({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), d1(Oe) && l && l(Oe));
  }, [j, l, P]), Fe = ue(function(Oe, Pe) {
    var st = [], Qe = [];
    Oe.forEach(function(et) {
      var Tt = qS(et, W), qr = l2(Tt, 2), hn = qr[0], Cn = qr[1], gn = US(et, o, i), Zn = l2(gn, 2), Sn = Zn[0], va = Zn[1], Ea = N ? N(et) : null;
      if (hn && Sn && !Ea)
        st.push(et);
      else {
        var _n = [Cn, va];
        Ea && (_n = _n.concat(Ea)), Qe.push({
          file: et,
          errors: _n.filter(function(xr) {
            return xr;
          })
        });
      }
    }), (!u && st.length > 1 || u && d >= 1 && st.length > d) && (st.forEach(function(et) {
      Qe.push({
        file: et,
        errors: [Nfe]
      });
    }), st.splice(0)), de({
      acceptedFiles: st,
      fileRejections: Qe,
      type: "setFiles"
    }), c && c(st, Qe, Pe), Qe.length > 0 && _ && _(Qe, Pe), st.length > 0 && h && h(st, Pe);
  }, [de, u, W, o, i, d, c, h, _, N]), ce = ue(function(Oe) {
    Oe.preventDefault(), Oe.persist(), Kt(Oe), xe.current = [], d1(Oe) && Promise.resolve(a(Oe)).then(function(Pe) {
      m0(Oe) && !P || Fe(Pe, Oe);
    }).catch(function(Pe) {
      return q(Pe);
    }), de({
      type: "reset"
    });
  }, [a, Fe, q, P]), z = ue(function() {
    if (ge.current) {
      de({
        type: "openDialog"
      }), K();
      var Oe = {
        multiple: u,
        types: V
      };
      window.showOpenFilePicker(Oe).then(function(Pe) {
        return a(Pe);
      }).then(function(Pe) {
        Fe(Pe, null), de({
          type: "closeDialog"
        });
      }).catch(function(Pe) {
        zfe(Pe) ? (U(Pe), de({
          type: "closeDialog"
        })) : Kfe(Pe) ? (ge.current = !1, G.current ? (G.current.value = null, G.current.click()) : q(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : q(Pe);
      });
      return;
    }
    G.current && (de({
      type: "openDialog"
    }), K(), G.current.value = null, G.current.click());
  }, [de, K, U, $, Fe, q, V, u]), Me = ue(function(Oe) {
    !j.current || !j.current.isEqualNode(Oe.target) || (Oe.key === " " || Oe.key === "Enter" || Oe.keyCode === 32 || Oe.keyCode === 13) && (Oe.preventDefault(), z());
  }, [j, z]), le = ue(function() {
    de({
      type: "focus"
    });
  }, []), Be = ue(function() {
    de({
      type: "blur"
    });
  }, []), rt = ue(function() {
    w || (Gfe() ? setTimeout(z, 0) : z());
  }, [w, z]), ve = function(Pe) {
    return n ? null : Pe;
  }, qt = function(Pe) {
    return k ? null : ve(Pe);
  }, fr = function(Pe) {
    return A ? null : ve(Pe);
  }, Kt = function(Pe) {
    P && Pe.stopPropagation();
  }, hr = qe(function() {
    return function() {
      var Oe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Pe = Oe.refKey, st = Pe === void 0 ? "ref" : Pe, Qe = Oe.role, et = Oe.onKeyDown, Tt = Oe.onFocus, qr = Oe.onBlur, hn = Oe.onClick, Cn = Oe.onDragEnter, gn = Oe.onDragOver, Zn = Oe.onDragLeave, Sn = Oe.onDrop, va = p0(Oe, Qfe);
      return ar(ar(zm({
        onKeyDown: qt(Ta(et, Me)),
        onFocus: qt(Ta(Tt, le)),
        onBlur: qt(Ta(qr, Be)),
        onClick: ve(Ta(hn, rt)),
        onDragEnter: fr(Ta(Cn, Ue)),
        onDragOver: fr(Ta(gn, Ce)),
        onDragLeave: fr(Ta(Zn, me)),
        onDrop: fr(Ta(Sn, ce)),
        role: typeof Qe == "string" && Qe !== "" ? Qe : "presentation"
      }, st, j), !n && !k ? {
        tabIndex: 0
      } : {}), va);
    };
  }, [j, Me, le, Be, rt, Ue, Ce, me, ce, k, A, n]), mr = ue(function(Oe) {
    Oe.stopPropagation();
  }, []), Lr = qe(function() {
    return function() {
      var Oe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Pe = Oe.refKey, st = Pe === void 0 ? "ref" : Pe, Qe = Oe.onChange, et = Oe.onClick, Tt = p0(Oe, Zfe), qr = zm({
        accept: W,
        multiple: u,
        type: "file",
        style: {
          display: "none"
        },
        onChange: ve(Ta(Qe, ce)),
        onClick: ve(Ta(et, mr)),
        tabIndex: -1
      }, st, G);
      return ar(ar({}, qr), Tt);
    };
  }, [G, r, u, ce, n]);
  return ar(ar({}, ae), {}, {
    isFocused: te && !n,
    getRootProps: hr,
    getInputProps: Lr,
    rootRef: j,
    inputRef: G,
    open: ve(z)
  });
}
function sce(e, t) {
  switch (t.type) {
    case "focus":
      return ar(ar({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return ar(ar({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return ar(ar({}, Km), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return ar(ar({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return ar(ar({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return ar(ar({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections
      });
    case "reset":
      return ar({}, Km);
    default:
      return e;
  }
}
function C8() {
}
const uce = ({
  isDragActive: e,
  variant: t
}) => e ? _r`
      border: 1px solid ${He("primary-700")};
      border-top: ${t === "secondary" ? "none" : void 0};
      background-color: ${He("primary-100")};
    ` : _r`
    border: 1px dashed ${He("neutral-600")};
    border-top: ${t === "secondary" ? "none" : void 0};
  `, dce = Ge(Ae)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: ${({ backgroundColor: e, bg: t, background: r }) => e ?? t ?? r ?? He("neutral-100")};
  cursor: pointer;
  padding: ${vt("xxl")} ${vt("xl")};

  ${uce}

  ${({ disabled: e }) => e && _r`
      background-color: ${He("neutral-200")};
      border: 1px solid ${He("neutral-400")};
      cursor: not-allowed;
    `}

  &:hover {
    border: 1px solid ${He("neutral-600")};
  }
`;
function S8({
  children: e,
  ...t
}) {
  return typeof e == "string" ? /* @__PURE__ */ b($e, { ...t, children: e }) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    /* @__PURE__ */ b(Nr, { children: e })
  );
}
function oTe({
  dropzoneOptions: e,
  children: t,
  errorText: r,
  "data-test": n = "dropzone",
  disabled: a = !1,
  text: i,
  subtext: o,
  ...u
}) {
  const { getRootProps: d, getInputProps: s, isDragActive: l, fileRejections: f } = zS({
    ...e,
    disabled: a
  }), c = f.length ? r || f[0].errors[0].message : void 0;
  return /* @__PURE__ */ ne(Dt, { direction: "vertical", space: "xxs", fluid: !0, children: [
    /* @__PURE__ */ ne(
      dce,
      {
        "data-test": n,
        ...d({ isDragActive: l }),
        ...u,
        disabled: a,
        children: [
          /* @__PURE__ */ b("input", { ...s(), "data-test": `${n}-input` }),
          (i || o) && /* @__PURE__ */ ne(Dt, { direction: "vertical", space: "xxxs", alignItems: "center", children: [
            i && /* @__PURE__ */ b(
              S8,
              {
                variant: "bodyMediumM",
                color: "neutral-800",
                textAlign: "center",
                children: i
              }
            ),
            o && /* @__PURE__ */ b(
              S8,
              {
                variant: "bodyRegularM",
                color: "neutral-400",
                textAlign: "center",
                children: o
              }
            )
          ] }),
          t
        ]
      }
    ),
    c && /* @__PURE__ */ ne(
      wl,
      {
        "data-test": `${n}-error-banner`,
        variant: "critical",
        inline: !0,
        children: [
          /* @__PURE__ */ b(kl, {}),
          /* @__PURE__ */ b(xl, { children: c })
        ]
      }
    )
  ] });
}
function r4({ seconds: e, ...t }) {
  const [r, n] = Xe(e);
  return at(() => {
    const a = setInterval(() => {
      n((i) => i + 1);
    }, 1e3);
    return () => clearInterval(a);
  }, []), /* @__PURE__ */ b(n4, { seconds: r, ...t });
}
function n4({
  seconds: e,
  children: t,
  isLive: r = !1,
  ...n
}) {
  if (r)
    return /* @__PURE__ */ b(r4, { seconds: e, ...n, children: t });
  const a = ix(e), i = t ? t(a) : a;
  return /* @__PURE__ */ b($e, { ...n, children: i });
}
const lce = {
  large: 28,
  regular: 18,
  small: 12
}, fce = Ge(Ae)`
  height: fit-content;
  & > span {
    display: inline-flex;
  }
`, KS = M.memo(({ name: e, size: t = "large" }) => {
  var a;
  const r = lce[t], n = ((a = bx(e)) == null ? void 0 : a.id) || e;
  return /* @__PURE__ */ b(fce, { "data-test": "emoji", children: /* @__PURE__ */ b(oF, { set: "apple", size: r, emoji: n }) });
}), sTe = M.memo(
  ({ name: e, size: t = "large" }) => /* @__PURE__ */ b(ch, { size: t, variant: "default", "data-test": "emoji-avatar", children: /* @__PURE__ */ b(KS, { name: e, size: t }) })
);
import("./emoji-mart-47677b51.mjs");
const cce = Ge(ot)`
  align-items: center;
  justify-content: center;
  gap: ${vt("xxs")};

  > .emoji-mart-emoji {
    margin-right: ${vt("xxs")};
  }

  &:hover {
    border-color: ${He("neutral-300")};
  }
`, hce = Ge(ot)`
  .emoji-mart {
    border: 1px solid ${He("neutral-200")};
    border-radius: ${Ba("sm")};
    font-family: inherit;
    font-size: 1rem;

    &-bar {
      border: 0;
    }

    &-anchor {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: ${vt("xxs")};
      color: ${He("neutral-400")};
      cursor: pointer;

      &:hover {
        color: ${He("black")};
      }

      > span {
        display: none;
      }

      &-selected {
        > div {
          color: ${He("primary-500")} !important;
        }
      }
    }

    &-search {
      margin: 0 ${vt("xxs")} ${vt("xxs")};

      > input {
        border-radius: ${Ba("sm")};
      }
    }

    &-scroll {
      padding: 0 ${vt("xxs")};
    }

    &-category-label > span {
      padding: ${vt("xxs")};
      background: ${He("neutral-0")};
    }

    &-category-list > li {
      margin: 1px;
      cursor: pointer;
    }

    &-category .emoji-mart-emoji {
      cursor: inherit;
      ${({ selectedEmoji: e }) => !!e && _r`
          &[aria-label="${e}"]::before {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background-color: ${He("primary-500")};
            border-radius: ${Ba("sm")};
            content: "";
          }
        `}
      outline: 0;

      > span {
        cursor: inherit;
      }

      &:hover::before {
        background-color: ${He("neutral-300")};
        border-radius: ${Ba("sm")};
      }
    }

    &-preview {
      height: max-content;

      &-skins {
        position: relative;
        top: 0;
        right: 0;
        left: 0;
        width: max-content;
        padding: ${vt("xxs")};
        transform: translate(0);
      }

      &-data,
      &-emoji {
        display: none;
      }
    }

    &-skin {
      &-swatches {
        border: 0;
        background: transparent;
      }

      &-swatch {
        > span {
          outline: 0;
        }
      }
    }
  }
`, uTe = sh(
  ({
    defaultValue: e,
    value: t,
    onChange: r = kn,
    closeOnSelect: n = !0,
    name: a,
    pullRight: i = !1,
    autoFocus: o = !1,
    hideSkinSelector: u = !1,
    "data-test": d = "emoji-picker"
  }) => {
    const [s, l] = Xe(o), [f, c] = Xe(
      qe(() => J6(e, t), [t, e])
    ), h = tt(null);
    at(() => {
      !e && t && c(J6(e, t));
    }, [t, e]);
    const _ = ue(() => {
      l(!s);
    }, [l, s]);
    at(() => {
      const $ = (D) => {
        var w;
        (w = h.current) != null && w.contains(D.target) || l(!1);
      }, E = (D) => {
        D.key === "Escape" && s && l(!1);
      };
      return document.addEventListener("click", $, !0), document.addEventListener("keyup", E, !0), () => {
        document.removeEventListener("click", $, !0), document.removeEventListener("keyup", E, !0);
      };
    }, [s]);
    const F = ue(
      ($) => {
        e && !t && c($), r($), n && l(!1);
      },
      [c, r, e, t, n]
    ), v = Mr("neutral-200");
    return /* @__PURE__ */ ne(ot, { ref: h, "data-test": d, position: "relative", children: [
      /* @__PURE__ */ ne(
        cce,
        {
          display: "inline-flex",
          h: "48px",
          p: "xs",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: v,
          borderRadius: "sm",
          background: "white",
          cursor: "pointer",
          onClick: _,
          "data-test": `${d}-text`,
          children: [
            /* @__PURE__ */ b(KS, { name: f.id, size: "large" }),
            /* @__PURE__ */ b(
              sr,
              {
                component: s ? F3 : Su,
                size: 15,
                onClick: kn
              }
            ),
            /* @__PURE__ */ b(
              "input",
              {
                hidden: !0,
                value: f == null ? void 0 : f.id,
                readOnly: !0,
                name: a,
                "data-test": `${d}-text-input`
              }
            )
          ]
        }
      ),
      s && /* @__PURE__ */ b(
        hce,
        {
          position: "absolute",
          zIndex: "1000",
          top: "calc(100% + 10px)",
          overflow: "hidden",
          ...i ? { right: 0 } : { left: 0 },
          selectedEmoji: `${f.native}, ${f.id}`,
          "data-test": i ? `${d}-dropdown-right` : `${d}-dropdown-left`,
          children: /* @__PURE__ */ b(
            iF,
            {
              set: "apple",
              onSelect: F,
              autoFocus: !0,
              showPreview: !1,
              theme: "light",
              skinEmoji: "thumbsup",
              showSkinTones: !u
            }
          )
        }
      )
    ] });
  }
), gce = Ge.img`
  border-radius: ${Ba("default")};
`;
function dTe({
  "data-test": e = "empty-state-view",
  children: t,
  imageSrc: r,
  text: n,
  title: a,
  ...i
}) {
  return /* @__PURE__ */ ne(
    Ae,
    {
      alignItems: "center",
      "data-test": e,
      flexDirection: "column",
      justifyContent: "center",
      gap: "xs",
      ...i,
      children: [
        r && /* @__PURE__ */ b(gce, { alt: "", src: r }),
        /* @__PURE__ */ b($e, { color: "text-highlight", variant: "headingBoldS", children: a }),
        n !== void 0 && /* @__PURE__ */ b($e, { color: "text-highlight", variant: "bodyRegularM", children: n }),
        t
      ]
    }
  );
}
const _ce = Ge(ad)`
  flex: ${({ isExpanded: e }) => e ? "1" : "0"};
  grid-template-columns: ${({ isExpanded: e }) => e ? "auto 1fr" : "auto"};
  transition: all 0.5s ease-in-out;
`;
function mce({
  onPlay: e,
  loading: t = !1,
  tooltipTexts: r,
  color: n = "default",
  "data-test": a = "expandable-audio-player"
}) {
  const [i, o] = Xe(!1), { isPlaying: u } = Yw();
  return at(() => {
    !i && u && (o(!0), e == null || e());
  }, [e, i, u]), /* @__PURE__ */ ne(_ce, { isExpanded: i, gap: "xxs", children: [
    /* @__PURE__ */ b(
      ko,
      {
        visible: !!r,
        title: u ? r == null ? void 0 : r.pause : r == null ? void 0 : r.play,
        align: "center",
        side: "top",
        mouseEnterDelay: 0,
        mouseLeaveDelay: 100,
        children: /* @__PURE__ */ b(ot, { w: "fit-content", "data-test": `${a}-play-button`, children: /* @__PURE__ */ b(wM, { loading: t, color: n }) })
      }
    ),
    /* @__PURE__ */ b(Uf, { children: i && /* @__PURE__ */ ne(
      kM,
      {
        animate: { opacity: 1 },
        initial: { opacity: 0 },
        exit: { opacity: 0 },
        "data-test": `${a}-audio-bar`,
        children: [
          /* @__PURE__ */ ne(Ae, { justifyContent: "space-between", pb: "xxs", children: [
            /* @__PURE__ */ b(xM, {}),
            /* @__PURE__ */ b(DM, {})
          ] }),
          /* @__PURE__ */ b(CM, { color: n })
        ]
      }
    ) })
  ] });
}
function lTe({
  src: e,
  ...t
}) {
  return /* @__PURE__ */ b(Xw, { children: /* @__PURE__ */ b(Qw, { src: e, children: /* @__PURE__ */ b(mce, { ...t }) }) });
}
const pce = Ge(Ae)`
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: ${vt("s")} ${vt("xs")};
  border: 1px dashed ${He("neutral-200")};
  border-radius: ${Ba("sm")};
  background: ${He("neutral-0")};
  color: ${He("neutral-400")};
`;
function fTe({
  file: e,
  onRemove: t,
  "data-test": r
}) {
  return /* @__PURE__ */ ne(pce, { "data-test": r, children: [
    e.name,
    /* @__PURE__ */ b(
      _a,
      {
        type: "button",
        "data-test": `${r}-remove`,
        onClick: t,
        size: 24,
        component: Cf,
        color: "neutral-200"
      }
    )
  ] });
}
function Fce({
  name: e,
  "data-test": t = "password-field",
  ...r
}) {
  return /* @__PURE__ */ b(SM, { id: e, "data-test": t, ...r });
}
const yce = Ge(nd)`
  ${({ ellipsis: e }) => e && "text-overflow: ellipsis"};
  ${({ hasHelperText: e }) => e && "border-radius: 0 8px 8px 0;"};
`;
function bce({
  helperText: e,
  name: t,
  "data-test": r = "text-field",
  ...n
}) {
  return /* @__PURE__ */ b(
    yce,
    {
      id: t,
      hasHelperText: !!e,
      "data-test": r,
      ...n
    }
  );
}
const vce = Ge(Ae)`
  align-items: center;
  background-color: ${He("background-01")};
  border-bottom: 1px solid ${He("input-border-01")};
  border-left: 1px solid ${He("input-border-01")};
  border-radius: 8px 0 0 8px;
  border-top: 1px solid ${He("input-border-01")};
  padding: 0 16px;
  white-space: nowrap;
`, Ece = Ge(ad)`
  position: relative;

  ${({ hasHelperText: e }) => e && "grid-template-columns: fit-content(100%) 1fr;"}
`;
function $ce(e) {
  const { type: t } = e;
  switch (t) {
    case "password":
      return /* @__PURE__ */ b(Fce, { ...e });
    case "text":
    default:
      return /* @__PURE__ */ b(bce, { ...e });
  }
}
function cTe({
  autoFocus: e = !1,
  clearable: t,
  defaultValue: r,
  disabled: n,
  ellipsis: a = !1,
  getErrorMessage: i,
  helperText: o,
  label: u,
  name: d,
  placeholder: s,
  type: l = "text",
  validate: f,
  validateInitial: c,
  ...h
}) {
  return /* @__PURE__ */ b(
    sl,
    {
      component: "input",
      type: l,
      name: d,
      validate: f,
      initialValue: r,
      format: SH,
      formatOnBlur: !0,
      children: ({
        input: { onBlur: _, onChange: F, value: v },
        meta: { error: $, submitError: E, touched: D }
      }) => {
        const w = $ ?? E, k = (D || c) && w;
        return /* @__PURE__ */ b(
          fs,
          {
            label: u,
            name: d,
            helpText: k && i(w),
            validationStatus: k && "error",
            gridAutoRows: "max-content",
            children: /* @__PURE__ */ ne(Ece, { hasHelperText: !!o, children: [
              o && /* @__PURE__ */ b(vce, { children: o }),
              /* @__PURE__ */ b(
                $ce,
                {
                  autoFocus: e,
                  disabled: n,
                  ellipsis: a,
                  helperText: o,
                  id: d,
                  label: u,
                  name: d,
                  onBlur: _,
                  onChange: F,
                  onClear: t && v ? () => F("") : void 0,
                  placeholder: s,
                  type: l,
                  value: v,
                  ...h
                }
              )
            ] })
          }
        );
      }
    }
  );
}
function hTe({
  children: e,
  query: t,
  queryOptions: r,
  "data-test": n = "graph-query"
}) {
  const { data: a, loading: i } = ZF(t, {
    ...r,
    throwError: !0
  });
  return i && !a ? /* @__PURE__ */ b(dd, { "data-test": `${n}-loading`, size: 30 }) : e({ data: a });
}
function wce({
  action: e = jh.READ,
  children: t,
  shouldThrow: r = !1,
  resource: n,
  oneOf: a
}) {
  const { checkAccess: i } = JF();
  if (!(a ? a.some((u) => i(e, u)) : i(e, n))) {
    if (r)
      throw new Error("You do not have access to this page.");
    return null;
  }
  return t;
}
function kce({
  error: e,
  onRetry: t,
  retryLabel: r
}) {
  return /* @__PURE__ */ ne(
    Ae,
    {
      backgroundColor: "red-100",
      justifyContent: "space-between",
      alignItems: "center",
      h: 48,
      px: 16,
      children: [
        /* @__PURE__ */ b($e, { variant: "supportingRegularS", "data-test": "image-uploader-error", children: e }),
        /* @__PURE__ */ b(
          nr,
          {
            variant: "secondary",
            mode: "outline",
            size: "xSmall",
            onClick: t,
            "data-test": "retry-button",
            children: r
          }
        )
      ]
    }
  );
}
const xce = Ge.input`
  display: none;
`;
function A8(e, t) {
  return e ? ga.SAVING : t ? ga.SAVED : ga.UNSAVED;
}
function gTe({
  defaultImage: e,
  image: t,
  onDelete: r,
  onUpload: n,
  "data-test": a = "image-uploader",
  texts: i = {
    upload: "Upload",
    uploaded: "Uploaded",
    delete: "Delete",
    deleted: "Deleted",
    retry: "Retry"
  }
}) {
  const [[o, u], d] = Um([
    !1,
    !1
  ]), [[s, l], f] = Um([
    !1,
    !1
  ]), [c, h] = Xe(null), _ = tt(null), F = o || s, v = ue(async () => {
    f([!0, !1]);
    const D = await r();
    if (f([!1, !1]), D) {
      h(D);
      return;
    }
    f([!1, !0], 2e3, [!1, !1]);
  }, [r, f]), $ = ue(() => {
    var D;
    (D = _.current) == null || D.click();
  }, [_]), E = ue(
    async (D) => {
      var A;
      d([!0, !1]);
      const w = (A = D.target.files) == null ? void 0 : A[0];
      if (!w)
        return;
      const k = await n(w);
      if (d([!1, !1]), _.current && (_.current.value = ""), k) {
        h(k);
        return;
      }
      d([!1, !0], 2e3, [!1, !1]);
    },
    [n, d]
  );
  return /* @__PURE__ */ ne(
    ot,
    {
      borderRadius: 8,
      border: "1px solid",
      borderColor: "secondary-100",
      backgroundColor: "neutral-0",
      overflow: "hidden",
      maxWidth: "400px",
      children: [
        /* @__PURE__ */ b(Ae, { py: "l", flexDirection: "column", alignItems: "center", children: t ? /* @__PURE__ */ b(ch, { size: "xLarge", "data-test": `${a}-avatar`, children: /* @__PURE__ */ b(Bw, { src: t }) }) : e }),
        /* @__PURE__ */ b(
          xce,
          {
            type: "file",
            accept: "image/png,image/jpeg",
            onChange: E,
            ref: _,
            "data-test": `${a}-input`
          }
        ),
        c ? /* @__PURE__ */ b(
          kce,
          {
            error: c,
            onRetry: () => h(null),
            retryLabel: i.retry
          }
        ) : /* @__PURE__ */ ne(Ae, { borderTop: "1px solid", borderColor: "secondary-100", children: [
          (!!t || s || l) && /* @__PURE__ */ b(
            Ae,
            {
              flexGrow: 1,
              flexBasis: 0,
              alignItems: "center",
              borderRight: "1px solid",
              borderColor: "secondary-100",
              children: /* @__PURE__ */ b(
                Nl,
                {
                  size: "xSmall",
                  "data-test": `${a}-delete-button`,
                  mode: "link",
                  type: "button",
                  block: !0,
                  onClick: v,
                  disabled: F,
                  status: A8(s, l),
                  unsavedText: i.delete,
                  savedText: i.deleted
                }
              )
            }
          ),
          /* @__PURE__ */ b(ot, { flexGrow: 1, flexBasis: 0, py: 10, children: /* @__PURE__ */ b(
            Nl,
            {
              size: "xSmall",
              "data-test": `${a}-upload-button`,
              mode: "link",
              type: "button",
              block: !0,
              status: A8(o, u),
              disabled: F,
              onClick: $,
              unsavedText: i.upload,
              savedText: i.uploaded
            }
          ) })
        ] })
      ]
    }
  );
}
const YS = dr(null), XS = () => Et(YS);
function Dce({
  open: e,
  defaultOpen: t,
  onOpenChange: r,
  children: n,
  align: a,
  side: i,
  mouseEnterDelay: o,
  mouseLeaveDelay: u,
  "data-test": d
}) {
  const [s, l] = O3({
    prop: e,
    defaultProp: t,
    onChange: r
  }), f = qe(
    () => Iu(() => {
      l(!1);
    }, u),
    [l, u]
  ), c = qe(
    () => Iu(() => {
      f.cancel(), l(!0);
    }, o),
    [o, f, l]
  ), h = qe(
    () => ({
      openPopup: c,
      closePopup: f,
      cancelClose: f.cancel,
      align: a,
      side: i
    }),
    [a, f, c, i]
  );
  return /* @__PURE__ */ b(YS.Provider, { value: h, children: /* @__PURE__ */ b(D3.Root, { open: s, "data-test": d, children: n }) });
}
function _Te({
  children: e,
  align: t,
  side: r,
  mouseEnterDelay: n = 0,
  mouseLeaveDelay: a = 100,
  ...i
}) {
  return /* @__PURE__ */ b(
    Dce,
    {
      align: t,
      side: r,
      mouseEnterDelay: n,
      mouseLeaveDelay: a,
      ...i,
      children: e
    }
  );
}
function mTe({
  children: e,
  ...t
}) {
  const { align: r, side: n, cancelClose: a, closePopup: i } = XS();
  return /* @__PURE__ */ b(
    D3.Content,
    {
      align: r,
      side: n,
      sideOffset: 8,
      onMouseEnter: a,
      onMouseLeave: i,
      children: /* @__PURE__ */ b(
        ot,
        {
          backgroundColor: "surface-default",
          boxShadow: 1,
          borderRadius: "sm",
          p: "m",
          ...t,
          children: e
        }
      )
    }
  );
}
function pTe({
  children: e,
  "data-test": t
}) {
  const { openPopup: r, closePopup: n } = XS();
  return /* @__PURE__ */ b(
    D3.Trigger,
    {
      onMouseEnter: r,
      onMouseLeave: n,
      "data-test": t,
      children: Vn.only(e)
    }
  );
}
const Cce = Ge(ot)`
  visibility: ${({ visible: e }) => e ? "hidden" : "initial"};
`;
function Sce({
  submitting: e,
  onClose: t,
  shouldDisableSubmit: r,
  handleSubmit: n,
  formRenderProps: a,
  submitButtonText: i,
  successButtonText: o,
  cancelButtonText: u,
  shouldBlockNavigation: d = !1,
  lang: s = "en"
}) {
  const { pristine: l } = a;
  return OS(
    // only block the navigation if the form values are changed
    d && !l
  ), /* @__PURE__ */ ne(Dt, { space: "xxs", children: [
    /* @__PURE__ */ b(
      Cce,
      {
        visible: e,
        "data-test": "inline-form-cancel-button-container",
        children: /* @__PURE__ */ b(
          nr,
          {
            onClick: t,
            type: "button",
            mode: "ghost",
            variant: "secondary",
            "data-test": "inline-form-cancel-button",
            children: u || qa[s][La.CANCEL]
          }
        )
      }
    ),
    /* @__PURE__ */ b(
      Nl,
      {
        type: "submit",
        disabled: r,
        onClick: n,
        "data-test": "inline-form-submit-button",
        status: Xh(a),
        savedText: o || qa[s][La.SAVED],
        unsavedText: i || qa[s][La.SUBMIT]
      }
    )
  ] });
}
const Ace = Ge(x3)`
  width: 100%;
  background: ${He("neutral-0")};
`;
function FTe({
  formProps: e,
  children: t,
  onClose: r,
  submitButtonText: n,
  successButtonText: a,
  cancelButtonText: i,
  shouldBlockNavigation: o,
  "data-test": u = "inline-form",
  ...d
}) {
  const { onSubmit: s, ...l } = e;
  return /* @__PURE__ */ b(
    T3,
    {
      ...l,
      onSubmit: async (f, c, h) => {
        await s(f, c, h) || r();
      },
      children: (f) => {
        const { handleSubmit: c, pristine: h, submitting: _ } = f, F = _ || h;
        return /* @__PURE__ */ b(Ace, { onSubmit: c, "data-test": u, children: /* @__PURE__ */ ne(Ae, { p: "s", justifyContent: "space-between", ...d, children: [
          /* @__PURE__ */ b(Ae, { flex: "1", alignItems: "center", children: t(f) }),
          /* @__PURE__ */ b(ot, { ml: "s", children: /* @__PURE__ */ b(
            Sce,
            {
              submitting: _,
              onClose: r,
              shouldDisableSubmit: F,
              handleSubmit: c,
              formRenderProps: f,
              submitButtonText: n,
              shouldBlockNavigation: o,
              successButtonText: a,
              cancelButtonText: i
            }
          ) })
        ] }) });
      }
    }
  );
}
function Wf({
  value: e,
  countryCode: t,
  ...r
}) {
  return /* @__PURE__ */ b($e, { ...r, children: Jre(e, t) });
}
function Oce({
  "data-test": e = "line-title",
  ...t
}) {
  const r = Et(Qh), n = {
    "data-test": e,
    variant: "bodySemiboldS",
    color: r.isClickable ? "text-interactive-secondary" : "text-base",
    ...t,
    ellipsis: !0,
    gridArea: "title"
  };
  return r.name ? /* @__PURE__ */ b($e, { ...n, children: r.name }) : /* @__PURE__ */ b(
    Wf,
    {
      ...n,
      value: r.number,
      countryCode: r.countryCode
    }
  );
}
const Qh = dr({
  countryCode: null,
  name: null,
  number: null,
  isClickable: !1
}), Tce = Ge(ad)`
  grid-template-areas:
    "flag title"
    "flag subtitle";
  grid-row-gap: unset;
  grid-template-rows: 1fr auto;
  grid-template-columns: auto 1fr auto;
  align-items: center;
`;
function Pce({
  countryCode: e,
  name: t,
  number: r
}) {
  const n = /* @__PURE__ */ b(
    Wf,
    {
      display: "inline",
      value: r,
      countryCode: e
    }
  );
  return r && !t ? n : /* @__PURE__ */ b(Bh, { rows: [[t, n]] });
}
function yTe({
  "data-test": e = "line",
  children: t,
  countryCode: r,
  hasTooltip: n = !0,
  number: a,
  name: i,
  onClick: o,
  ...u
}) {
  const d = qe(
    () => ({ countryCode: r, name: i, number: a, isClickable: !!o }),
    [r, i, a, o]
  );
  return /* @__PURE__ */ b(Qh.Provider, { value: d, children: /* @__PURE__ */ b(
    ko,
    {
      visible: n && !!a,
      content: /* @__PURE__ */ b(
        Pce,
        {
          countryCode: r,
          number: a,
          name: i
        }
      ),
      side: "top",
      sideOffset: 4,
      "data-test": `${e}-tooltip`,
      children: /* @__PURE__ */ b(
        Tce,
        {
          gap: "xxs",
          "data-test": e,
          onClick: o,
          cursor: o ? "pointer" : "default",
          ...u,
          children: t || /* @__PURE__ */ b(Oce, {})
        }
      )
    }
  ) });
}
const Ice = Ge(Nw)`
  grid-area: flag;
`;
function bTe({
  size: e = 20,
  "data-test": t = "line-flag",
  ...r
}) {
  const n = Et(Qh);
  return /* @__PURE__ */ b(
    Ice,
    {
      countryCode: n.countryCode,
      size: e,
      "data-test": t,
      ...r
    }
  );
}
function vTe({
  "data-test": e = "line-subtitle",
  ...t
}) {
  const r = Et(Qh);
  return /* @__PURE__ */ b(
    Wf,
    {
      "data-test": e,
      variant: "supportingMediumS",
      color: "text-secondary",
      ...t,
      gridArea: "subtitle",
      ellipsis: !0,
      value: r.number,
      countryCode: r.countryCode
    }
  );
}
const Rce = Ge(nk)`
  color: ${({ color: e }) => e || "inherit"};
  text-decoration: none;

  &:visited,
  &:active {
    color: ${({ color: e }) => e || "inherit"};
  }
`, ETe = Ge(Rce)`
  text-decoration: underline;
`, $Te = Ge(Zw)`
  text-decoration: underline;
`, jce = Ge(ot)`
  overflow: auto;
  padding: 0;
  margin: 0;
  list-style-type: none;
  ${({ hasBottomShadow: e, hasTopShadow: t }) => `box-shadow: ${[
  ...t ? ["inset 0 19px 20px -31px grey"] : [],
  ...e ? ["inset 0 -19px 20px -31px grey"] : []
].join(",")};`}
  ${({ hasBottomBorder: e }) => e && `border-bottom: 1px solid ${He("neutral-500")};`};
  ${({ maxHeight: e }) => `max-height: ${e};`}
`;
function Mce({
  children: e,
  maxHeight: t = "100%",
  hasBottomBorder: r = !1,
  forceShadow: n = !1,
  "data-test": a = "scroll-container",
  as: i = "div",
  ...o
}, u) {
  const d = M.useRef(null), s = kde(d, u), [l, f] = Xe(!1), [c, h] = Xe(!1), _ = ue((v) => {
    const $ = AM(v), E = OM(v);
    f(!$), h(!E);
  }, []);
  at(() => {
    _(d.current);
  }, [d, _]);
  const F = ue(
    (v) => {
      _(v.currentTarget);
    },
    [_]
  );
  return /* @__PURE__ */ b(
    jce,
    {
      ref: s,
      as: i,
      "data-test": a,
      hasTopShadow: c,
      hasBottomShadow: n || l,
      hasBottomBorder: r,
      onScroll: F,
      maxHeight: t,
      ...o,
      children: e
    }
  );
}
const Bce = zne(
  Mce
), Nce = Ge(ot)`
  position: relative;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  border: 1px solid ${He("neutral-200")};
  border-radius: ${Ba("sm")};
  background: ${He("neutral-0")};
  transition: 500ms box-shadow;
`, Lce = Ge.ul`
  padding: 0;
  margin: 0;
  list-style-type: none;
`, qce = Ge.li`
  border-bottom: 1px solid ${He("neutral-200")};

  &:last-child {
    border-bottom: none;
  }
`, Uce = Ge(Ae)`
  position: absolute;
  z-index: 3;
  bottom: 0;
  width: 100%;
  height: ${vt("xl")};
  padding: ${vt("m")};
  background: ${He("neutral-0")};
  border-top: 1px solid ${He("neutral-100")};
`, Gce = Ge(Ae)`
  position: absolute;
  z-index: 10;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  background: rgb(255 255 255 / 0.8);
`, O8 = 41, Wce = 9, QS = Xn(
  ({
    children: e,
    forceShadow: t = !1,
    "data-test": r = "list",
    hasScroll: n = !1,
    isLoadingMoreItems: a = !1,
    customLoader: i,
    stickyFooter: o,
    overLoading: u = !1,
    w: d = "100%",
    ...s
  }, l) => {
    const f = M.Children.toArray(e).filter(
      (h) => M.isValidElement(h)
    ).length === 0;
    if (f && !o)
      return null;
    const c = M.Children.map(
      e,
      (h, _) => h && /* @__PURE__ */ b(qce, { "data-test": `list-item-${_}`, children: h })
    );
    return /* @__PURE__ */ ne(Nce, { w: d, ...s, children: [
      u && /* @__PURE__ */ b(Gce, { "data-test": "list-over-loading", children: /* @__PURE__ */ b(dd, { color: "primary-500", size: 28 }) }),
      n ? /* @__PURE__ */ ne(Nr, { children: [
        /* @__PURE__ */ b(
          Bce,
          {
            as: "ul",
            ref: l,
            "data-test": r,
            forceShadow: t,
            hasBottomBorder: !!(o && !f),
            maxHeight: Math.ceil(
              O8 * Wce + O8 / 2
            ),
            children: c
          }
        ),
        o && /* @__PURE__ */ b(
          Ae,
          {
            borderTop: c != null && c.length ? "1px solid" : "none",
            borderColor: "neutral-200",
            children: o
          }
        ),
        a && i && /* @__PURE__ */ b(
          Uce,
          {
            "data-test": "list-custom-loader",
            justifyContent: "center",
            alignItems: "center",
            children: i
          }
        )
      ] }) : /* @__PURE__ */ b(Lce, { "data-test": r, children: c })
    ] });
  }
), Vce = Ge(TM)`
  > div:first-child {
    ${({ hideLimit: e }) => e && "display: none;"}
  }
`;
function wTe({
  children: e,
  activePage: t,
  onPageChange: r,
  onPageSizeChange: n,
  pageSize: a,
  recordsTotalCount: i,
  hideLimit: o = !1,
  ...u
}) {
  const { "data-test": d = "list-paginated" } = u;
  return /* @__PURE__ */ ne(Dt, { fluid: !0, direction: "vertical", space: "xs", children: [
    /* @__PURE__ */ b(QS, { ...u, children: e }),
    /* @__PURE__ */ b(
      Vce,
      {
        "data-test": `${d}-pagination`,
        hideLimit: o,
        activePage: t,
        onPageChange: r,
        onPageSizeChange: n,
        pageSize: a,
        recordsTotalCount: i
      }
    )
  ] });
}
const Hce = Ge(Ae)`
  position: relative;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  ${({ hasCustomHeight: e }) => !e && _r`
      &:hover {
        background-color: ${He("neutral-100")};
        transition: all 0.25s ease-in-out;
      }
    `}

  & > div:nth-child(2) {
    border-left: 1px solid ${He("neutral-200")};

    &:hover {
      & > div {
        background: ${He("neutral-200")};
      }
    }
  }
`, ZS = Ge(Ae)`
  align-items: center;
  justify-content: center;
  padding: ${vt("xxs")};
  border-radius: 50%;
  transition: all 0.25s ease-in-out;
`, zce = Ge(Ae)`
  align-items: center;
  justify-content: center;
  padding: ${vt("xxxs")};
  cursor: pointer;

  &:hover {
    > ${ZS} {
      background-color: ${He("neutral-300")};
    }
  }
  ${({ hasCustomHeight: e }) => e ? _r`
          position: absolute;
          top: 0;
          right: 0;
        ` : _r`
          border-left: 1px solid ${He("neutral-300")};
        `}
`;
function kTe({
  avatar: e,
  primaryText: t,
  secondaryText: r,
  children: n,
  dropdownOptions: a,
  "data-test": i = "list-item",
  ...o
}) {
  const { space: u } = PM(), { h: d } = o, s = !!(d && d !== u.xl);
  return /* @__PURE__ */ ne(
    Hce,
    {
      h: u.xl,
      "data-test": i,
      hasCustomHeight: s,
      ...o,
      children: [
        t && /* @__PURE__ */ ne(Dt, { space: "xxs", direction: "horizontal", alignItems: "center", px: "s", children: [
          e,
          /* @__PURE__ */ b(
            $e,
            {
              variant: "bodyRegularS",
              "data-test": `${i}-primary-text`,
              children: t
            }
          ),
          r && /* @__PURE__ */ b(
            $e,
            {
              variant: "supportingMediumS",
              color: "neutral-400",
              ml: "xxs",
              "data-test": `${i}-secondary-text`,
              children: r
            }
          )
        ] }),
        n,
        a && /* @__PURE__ */ b(
          k3,
          {
            trigger: /* @__PURE__ */ b(zce, { hasCustomHeight: s, children: /* @__PURE__ */ b(ZS, { children: /* @__PURE__ */ b(
              _a,
              {
                size: u.s,
                component: y3,
                color: "neutral-600",
                "data-test": `${i}-dropdown-trigger`,
                discColor: "transparent",
                type: "button"
              }
            ) }) }),
            side: "bottom",
            align: "start",
            children: /* @__PURE__ */ b(C3, { children: a.map(({ title: l, callback: f }, c) => /* @__PURE__ */ b(
              S3,
              {
                itemKey: l,
                onClick: f,
                "data-test": `${i}-dropdown-menu-item-${c}`,
                children: /* @__PURE__ */ b($3, { children: l })
              },
              l
            )) })
          }
        )
      ]
    }
  );
}
function xTe({
  children: e,
  actions: t = []
}) {
  return /* @__PURE__ */ ne(Kw, { background: "white", w: "100%", p: "s", position: "relative", children: [
    e,
    t.length ? /* @__PURE__ */ b(ot, { position: "absolute", top: "4px", right: "4px", children: /* @__PURE__ */ b(
      zw,
      {
        trigger: /* @__PURE__ */ b(
          nr,
          {
            mode: "ghost",
            shape: "circle",
            variant: "secondary",
            size: "xSmall",
            "data-test": "action-button",
            children: /* @__PURE__ */ b(y3, {})
          }
        ),
        items: t
      }
    ) }) : null
  ] });
}
var JS = /* @__PURE__ */ ((e) => (e.Button = "button", e.Scroll = "scroll", e))(JS || {});
const eA = Xn(
  ({ children: e, "data-test": t, ...r }, n) => /* @__PURE__ */ b("tfoot", { "data-test": t, children: /* @__PURE__ */ b("tr", { children: /* @__PURE__ */ b("td", { colSpan: 9999, style: { padding: 0 }, children: /* @__PURE__ */ b(
    Ae,
    {
      w: "100%",
      borderTop: "1px solid",
      borderColor: "neutral-200",
      alignItems: "center",
      justifyContent: "center",
      p: "m",
      ref: n,
      ...r,
      children: e
    }
  ) }) }) })
);
function Kce({
  onLoadMore: e,
  loading: t,
  loadingText: r,
  buttonText: n,
  hasMore: a,
  dataTest: i
}) {
  return a ? /* @__PURE__ */ b(eA, { "data-test": `${i}-footer`, children: /* @__PURE__ */ b(
    TS,
    {
      onClick: e,
      loading: t,
      loadingText: r,
      children: n
    }
  ) }) : null;
}
function Yce({
  hasMore: e,
  dataTest: t,
  containerRef: r,
  scrollThreshold: n,
  onLoadMore: a
}) {
  var u;
  const i = tt(null), o = (u = r.current) == null ? void 0 : u.querySelector(`[data-test="${t}"]`);
  return ale({
    targetRef: i,
    root: o,
    onIntersect: a,
    margin: n
  }), e ? /* @__PURE__ */ b(
    eA,
    {
      ref: i,
      "data-test": `${t}-footer`,
      p: "xs",
      children: /* @__PURE__ */ b(
        dd,
        {
          size: 34,
          w: "100%",
          h: "100%",
          background: "rgba(255,255,255,0.7)",
          "data-test": `${t}-loading`
        }
      )
    }
  ) : null;
}
function DTe({
  buttonText: e = "Load more",
  data: t,
  hasMore: r,
  loading: n = !1,
  loadingMore: a = !1,
  loadingText: i,
  noDataMessage: o,
  onLoadMore: u,
  "data-test": d = "load-more-table",
  strategy: s = JS.Button,
  scrollThreshold: l = 100,
  ...f
}) {
  const c = tt(null);
  return /* @__PURE__ */ ne(Ae, { flex: "1", overflow: "auto", position: "relative", ref: c, children: [
    n && /* @__PURE__ */ b(
      dd,
      {
        size: 34,
        color: "neutral-300",
        position: "absolute",
        zIndex: "10",
        borderRadius: "sm",
        w: "100%",
        h: "100%",
        background: "rgba(255,255,255,0.7)",
        "data-test": `${d}-loading`
      }
    ),
    /* @__PURE__ */ b(
      IM,
      {
        ...f,
        data: t ?? /* istanbul ignore next */
        [],
        noDataMessage: t ? o : " ",
        footer: s === "button" ? /* @__PURE__ */ b(
          Kce,
          {
            loading: a,
            loadingText: i,
            buttonText: e,
            hasMore: r,
            dataTest: d,
            onLoadMore: u
          }
        ) : /* @__PURE__ */ b(
          Yce,
          {
            hasMore: r,
            dataTest: d,
            containerRef: c,
            scrollThreshold: l,
            onLoadMore: u
          }
        ),
        "data-test": d
      }
    )
  ] });
}
function Vf({
  buttonText: e,
  image: t,
  onClick: r,
  subtitle: n,
  title: a,
  "data-test": i = "message-screen",
  w: o = "100%",
  h: u = "100%",
  backgroundColor: d = "neutral-100",
  ...s
}) {
  return /* @__PURE__ */ ne(
    ur,
    {
      gap: "xl",
      w: o,
      h: u,
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: d,
      "data-test": i,
      ...s,
      children: [
        t && /* @__PURE__ */ b(t, {}),
        /* @__PURE__ */ ne(ur, { gap: "s", flexDirection: "column", alignItems: "center", children: [
          /* @__PURE__ */ b(
            $e,
            {
              variant: "headingBoldM",
              color: "text-highlight",
              "data-test": `${i}-title`,
              children: a
            }
          ),
          /* @__PURE__ */ b(
            $e,
            {
              variant: "bodyRegularM",
              textAlign: "center",
              "data-test": `${i}-subtitle`,
              children: n
            }
          )
        ] }),
        r && e && /* @__PURE__ */ b(nr, { "data-test": `${i}-button`, onClick: r, children: e })
      ]
    }
  );
}
const Xce = (e) => /* @__PURE__ */ se.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ se.createElement("circle", { cx: 60, cy: 60, r: 60, fill: "#CACCD8", fillOpacity: 0.25 }), /* @__PURE__ */ se.createElement("path", { d: "M72.0691 87.9346C71.1159 85.5825 69.0929 83.8114 66.6313 83.2759C65.1584 82.9234 62.7372 82.6935 60 82.6935C57.2629 82.6935 54.8417 82.9234 53.3688 83.2759C50.9248 83.8076 48.9131 85.5573 47.9516 87.8843C47.6181 88.6913 46.8191 89.1838 45.9738 89.1033C45.7648 89.0834 45.5842 89.0656 45.4321 89.0499C41.4933 88.6433 38.3974 88.0761 36.5987 87.4141C36.5958 87.4125 36.5922 87.4109 36.588 87.4093C35.381 86.939 34.5221 85.7312 34.5221 84.3155C34.5221 84.2803 34.5226 84.2452 34.5237 84.2103C34.5264 84.1533 34.5297 84.0951 34.5334 84.0358C34.5344 84.0225 34.5356 84.0093 34.5368 83.9961C34.5402 83.959 34.5424 83.9232 34.5432 83.8886C34.8498 79.6386 37.3394 69.6885 41.0579 58.3317C45.3088 45.3486 49.7544 34.8376 51.7591 32.7875C52.0791 32.4421 52.4483 32.1528 52.8564 31.9297C53.0157 31.8354 53.2175 31.7452 53.4571 31.6601C53.4634 31.6579 53.4697 31.6556 53.4759 31.6534C54.7931 31.1917 57.2205 30.8824 59.9976 30.8824C62.7796 30.8824 65.207 31.1917 66.5217 31.6526C66.5304 31.6556 66.5367 31.6579 66.5429 31.6601C66.7826 31.7452 66.9844 31.8354 67.1437 31.9297C67.5518 32.1528 67.921 32.4421 68.238 32.7838C68.2391 32.7849 68.2401 32.7861 68.241 32.7875C70.2456 34.8376 74.6912 45.3486 78.9422 58.3317C82.6607 69.6885 85.1502 79.6386 85.4568 83.8886C85.4577 83.9232 85.4598 83.959 85.4633 83.9961C85.4645 84.0093 85.4656 84.0225 85.4667 84.0358C85.4704 84.0951 85.4736 84.1533 85.4764 84.2103C85.4774 84.2452 85.478 84.2803 85.478 84.3155C85.478 85.7312 84.6191 86.939 83.4121 87.4093C83.4078 87.4109 83.4043 87.4125 83.4014 87.4141C81.6042 88.0755 78.5122 88.6423 74.5783 89.0488C74.4077 89.0664 74.2013 89.0867 73.9592 89.1096L73.9592 89.1096C73.1487 89.1863 72.3836 88.7107 72.0691 87.9346Z", fill: "#80939A" }));
function CTe({
  "data-test": e = "coming-soon-screen",
  ...t
}) {
  return /* @__PURE__ */ b(Vf, { image: Xce, "data-test": e, ...t });
}
const Qce = (e) => /* @__PURE__ */ se.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ se.createElement("circle", { cx: 60, cy: 60, r: 60, fill: "#3086EE" }), /* @__PURE__ */ se.createElement("path", { opacity: 0.5, d: "M90.3256 51.502H87.7711C86.7489 51.502 85.839 50.8729 85.4638 49.9226C85.3582 49.653 85.2481 49.3879 85.1336 49.1228C84.7269 48.1859 84.9246 47.0963 85.648 46.3728L87.4544 44.5665C89.8246 42.1963 89.8246 38.3523 87.4544 35.9798L84.0215 32.5469C81.6512 30.1767 77.8072 30.1767 75.4347 32.5469L73.6284 34.3532C72.905 35.0766 71.8176 35.2743 70.8785 34.8677C70.6134 34.7531 70.3483 34.643 70.0787 34.5374C69.1283 34.1622 68.4993 33.2523 68.4993 32.2301V29.6756C68.4993 26.3236 65.7808 23.6052 62.4288 23.6052H57.5737C54.2217 23.6052 51.5033 26.3236 51.5033 29.6756V32.2301C51.5033 33.2523 50.8742 34.1622 49.9239 34.5374C49.6543 34.643 49.3891 34.7531 49.124 34.8677C48.1872 35.2743 47.0976 35.0766 46.3741 34.3532L44.5678 32.5469C42.1976 30.1767 38.3535 30.1767 35.9811 32.5469L32.5482 35.9798C30.1779 38.35 30.1779 42.194 32.5482 44.5665L34.3545 46.3728C35.0779 47.0963 35.2756 48.1837 34.869 49.1228C34.7544 49.3879 34.6443 49.653 34.5387 49.9226C34.1635 50.8729 33.2536 51.502 32.2314 51.502H29.6769C26.3249 51.502 23.6064 54.2204 23.6064 57.5725V62.4275C23.6064 65.7795 26.3249 68.498 29.6769 68.498H32.2314C33.2536 68.498 34.1635 69.127 34.5387 70.0774C34.6443 70.347 34.7544 70.6121 34.869 70.8772C35.2756 71.8141 35.0779 72.9037 34.3545 73.6271L32.5482 75.4334C30.1779 77.8037 30.1779 81.6477 32.5482 84.0202L35.9811 87.4531C38.3513 89.8233 42.1953 89.8233 44.5678 87.4531L46.3741 85.6468C47.0976 84.9233 48.1849 84.7256 49.124 85.1323C49.3891 85.2468 49.6543 85.3569 49.9239 85.4625C50.8742 85.8377 51.5033 86.7476 51.5033 87.7698V90.3243C51.5033 93.6763 54.2217 96.3948 57.5737 96.3948H62.4288C65.7808 96.3948 68.4993 93.6763 68.4993 90.3243V87.7698C68.4993 86.7476 69.1283 85.8377 70.0787 85.4625C70.3483 85.3569 70.6134 85.2468 70.8785 85.1323C71.8153 84.7256 72.905 84.9233 73.6284 85.6468L75.4347 87.4531C77.8049 89.8233 81.649 89.8233 84.0215 87.4531L87.4544 84.0202C89.8246 81.6499 89.8246 77.8059 87.4544 75.4334L85.648 73.6271C84.9246 72.9037 84.7269 71.8163 85.1336 70.8772C85.2481 70.6121 85.3582 70.347 85.4638 70.0774C85.839 69.127 86.7489 68.498 87.7711 68.498H90.3256C93.6776 68.498 96.3961 65.7795 96.3961 62.4275V57.5725C96.3961 54.2204 93.6776 51.502 90.3256 51.502V51.502Z", fill: "white" }), /* @__PURE__ */ se.createElement("circle", { cx: 60, cy: 60, r: 13.6489, fill: "white" }));
function STe({
  "data-test": e = "no-support-screen",
  ...t
}) {
  return /* @__PURE__ */ b(Vf, { image: Qce, "data-test": e, ...t });
}
const Zce = (e) => /* @__PURE__ */ se.createElement("svg", { width: 440, height: 325, viewBox: "0 0 440 325", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ se.createElement("g", { filter: "url(#filter0_bdd_13925_39989)" }, /* @__PURE__ */ se.createElement("g", { clipPath: "url(#clip0_13925_39989)" }, /* @__PURE__ */ se.createElement("rect", { x: 91.4678, y: 117.032, width: 218.474, height: 141.663, rx: 10.3226, fill: "#CACCD8", fillOpacity: 0.2, shapeRendering: "crispEdges" }), /* @__PURE__ */ se.createElement("g", { filter: "url(#filter1_dd_13925_39989)" }, /* @__PURE__ */ se.createElement("rect", { width: 20.6452, height: 177.419, transform: "translate(91.4678 117.032)", fill: "#CACCD8", fillOpacity: 0.5 }), /* @__PURE__ */ se.createElement("g", { clipPath: "url(#clip1_13925_39989)" }, /* @__PURE__ */ se.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M101.79 128C103.128 128 104.311 128.109 105.031 128.275C106.467 128.578 107.597 129.711 107.898 131.151C108.065 131.873 108.173 133.06 108.173 134.402C108.173 135.744 108.065 136.93 107.898 137.652C107.597 139.092 106.467 140.226 105.031 140.528C104.311 140.695 103.128 140.803 101.79 140.803C100.452 140.803 99.2681 140.695 98.5481 140.528C97.1126 140.226 95.9821 139.092 95.6808 137.652C95.5147 136.93 95.4062 135.744 95.4062 134.402C95.4062 133.06 95.5147 131.873 95.6808 131.151C95.9821 129.711 97.1126 128.578 98.5481 128.275C99.2681 128.109 100.452 128 101.79 128ZM102.632 137.255C102.945 137.321 103.202 137.539 103.323 137.828C103.363 137.923 103.461 137.982 103.564 137.972C103.594 137.97 103.621 137.967 103.642 137.965C104.142 137.915 104.535 137.845 104.764 137.764L104.765 137.763C104.918 137.706 105.028 137.557 105.028 137.383C105.028 137.379 105.028 137.374 105.027 137.37L105.026 137.349L105.026 137.344C105.025 137.339 105.025 137.335 105.025 137.331C104.986 136.808 104.67 135.585 104.197 134.189C103.657 132.592 103.092 131.3 102.837 131.048C102.797 131.006 102.749 130.97 102.697 130.943C102.677 130.931 102.652 130.92 102.621 130.91L102.618 130.909C102.451 130.852 102.143 130.814 101.789 130.814C101.436 130.814 101.128 130.852 100.96 130.909L100.958 130.91C100.927 130.92 100.902 130.931 100.882 130.943C100.83 130.97 100.783 131.006 100.742 131.048C100.487 131.3 99.9223 132.592 99.3821 134.189C98.9095 135.585 98.5931 136.808 98.5541 137.331C98.554 137.335 98.5537 137.339 98.5533 137.344L98.5528 137.349L98.5516 137.37C98.5515 137.372 98.5515 137.375 98.5515 137.377C98.5514 137.379 98.5514 137.381 98.5514 137.383C98.5514 137.557 98.6606 137.706 98.814 137.763L98.8153 137.764C99.0439 137.845 99.4374 137.915 99.938 137.965C99.9573 137.967 99.9803 137.969 100.007 137.972C100.114 137.982 100.216 137.921 100.258 137.822C100.38 137.536 100.636 137.321 100.947 137.255C101.134 137.212 101.442 137.184 101.79 137.184C102.137 137.184 102.445 137.212 102.632 137.255Z", fill: "#F7F8FC" })), /* @__PURE__ */ se.createElement("rect", { x: 96.6289, y: 151.771, width: 10.3226, height: 10.3226, rx: 2.09732, fill: "#F7F8FC" }), /* @__PURE__ */ se.createElement("rect", { x: 96.6289, y: 169.836, width: 10.3226, height: 10.3226, rx: 2.09732, fill: "#F7F8FC" }), /* @__PURE__ */ se.createElement("rect", { x: 96.6289, y: 187.9, width: 10.3226, height: 10.3226, rx: 2.09732, fill: "#F7F8FC" }), /* @__PURE__ */ se.createElement("rect", { x: 96.6289, y: 205.965, width: 10.3226, height: 10.3226, rx: 2.09732, fill: "#F7F8FC" }), /* @__PURE__ */ se.createElement("rect", { x: 96.6289, y: 224.029, width: 10.3226, height: 10.3226, rx: 2.09732, fill: "#F7F8FC" })), /* @__PURE__ */ se.createElement("g", { clipPath: "url(#clip2_13925_39989)" }, /* @__PURE__ */ se.createElement("rect", { width: 197.829, height: 46.3624, transform: "translate(112.113 117.032)", fill: "#CACCD8", fillOpacity: 0.25 }), /* @__PURE__ */ se.createElement("rect", { x: 128.597, y: 133.517, width: 30.9082, height: 6.18165, rx: 3.09082, fill: "#F7F8FC" }), /* @__PURE__ */ se.createElement("rect", { x: 128.597, y: 143.819, width: 41.211, height: 3.09082, rx: 1.54541, fill: "#F7F8FC" }))), /* @__PURE__ */ se.createElement("rect", { x: 91.339, y: 116.904, width: 218.732, height: 141.92, rx: 10.4514, stroke: "#EAEBF0", strokeWidth: 0.257569, shapeRendering: "crispEdges" })), /* @__PURE__ */ se.createElement("mask", { id: "mask0_13925_39989", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 264, y: 82, width: 71, height: 72 }, /* @__PURE__ */ se.createElement("circle", { cx: 299.655, cy: 117.897, r: 35.17, fill: "#74B5FF" })), /* @__PURE__ */ se.createElement("g", { mask: "url(#mask0_13925_39989)" }, /* @__PURE__ */ se.createElement("g", { filter: "url(#filter2_f_13925_39989)" }, /* @__PURE__ */ se.createElement("rect", { x: 290.178, y: 123.484, width: 103.058, height: 84.1643, fill: "#CACCD8", fillOpacity: 0.5 })), /* @__PURE__ */ se.createElement("g", { filter: "url(#filter3_bdd_13925_39989)" }, /* @__PURE__ */ se.createElement("g", { clipPath: "url(#clip3_13925_39989)" }, /* @__PURE__ */ se.createElement("path", { d: "M148.243 111.001C148.243 103.874 154.02 98.0973 161.146 98.0973H306.307C313.433 98.0973 319.21 103.874 319.21 111.001V356.162H148.243V111.001Z", fill: "#CACCD8", fillOpacity: 0.2, shapeRendering: "crispEdges" }), /* @__PURE__ */ se.createElement("g", { filter: "url(#filter4_bd_13925_39989)" }, /* @__PURE__ */ se.createElement("rect", { x: 195.017, y: 189.233, width: 77.4194, height: 77.4194, rx: 38.7097, fill: "#3086EE", shapeRendering: "crispEdges" }))), /* @__PURE__ */ se.createElement("path", { d: "M319.21 356.323H319.371V356.162V111.001C319.371 103.785 313.522 97.9363 306.307 97.9363H161.146C153.931 97.9363 148.082 103.785 148.082 111.001V356.162V356.323H148.243H319.21Z", stroke: "#EAEBF0", strokeWidth: 0.321961, shapeRendering: "crispEdges" }))), /* @__PURE__ */ se.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M299.426 151.215C317.241 151.215 331.684 136.773 331.684 118.957C331.684 101.142 317.241 86.6991 299.426 86.6991C281.61 86.6991 267.167 101.142 267.167 118.957C267.167 136.773 281.61 151.215 299.426 151.215ZM299.426 172.721C329.118 172.721 353.189 148.65 353.189 118.957C353.189 89.2644 329.118 65.1937 299.426 65.1937C269.733 65.1937 245.662 89.2644 245.662 118.957C245.662 148.65 269.733 172.721 299.426 172.721Z", fill: "#FFC000" }), /* @__PURE__ */ se.createElement("path", { opacity: 0.6, d: "M329.074 163.813C335.106 159.817 340.286 154.638 344.281 148.606L369.697 174.022C373.896 178.222 373.896 185.029 369.697 189.229C365.498 193.428 358.689 193.428 354.49 189.229L329.074 163.813Z", fill: "#FFC000" }), /* @__PURE__ */ se.createElement("path", { d: "M364.445 73.0314C369.872 73.0314 373.748 76.4998 373.748 81.3964C373.748 87.6558 368.641 88.8622 366.761 91.5769C366.042 92.6144 365.054 93.7194 363.792 93.7194C362.53 93.7194 361.46 92.6749 361.774 91.4526C363.094 86.3096 368.851 86.1128 368.851 81.8861C368.851 79.397 366.974 77.6832 364.281 77.6832C362.141 77.6832 360.473 78.7693 359.653 80.4913C359.073 81.7095 357.958 82.7961 356.615 82.6665C355.395 82.5488 354.445 81.4927 354.729 80.3006C355.76 75.9789 359.48 73.0314 364.445 73.0314Z", fill: "#FFE185" }), /* @__PURE__ */ se.createElement("path", { opacity: 0.6, d: "M360.771 99.3094C360.771 101.023 362.158 102.411 363.912 102.411C365.708 102.411 367.054 101.023 367.054 99.3094C367.054 97.5548 365.708 96.2083 363.912 96.2083C362.158 96.2083 360.771 97.5548 360.771 99.3094Z", fill: "#FFE185" }), /* @__PURE__ */ se.createElement("defs", null, /* @__PURE__ */ se.createElement("filter", { id: "filter0_bdd_13925_39989", x: 60.2422, y: 90.9683, width: 280.925, height: 214.436, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ se.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ se.createElement("feGaussianBlur", { in: "BackgroundImageFix", stdDeviation: 12.9032 }), /* @__PURE__ */ se.createElement("feComposite", { in2: "SourceAlpha", operator: "in", result: "effect1_backgroundBlur_13925_39989" }), /* @__PURE__ */ se.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ se.createElement("feOffset", { dy: 15.4839 }), /* @__PURE__ */ se.createElement("feGaussianBlur", { stdDeviation: 15.4839 }), /* @__PURE__ */ se.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ se.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0" }), /* @__PURE__ */ se.createElement("feBlend", { mode: "normal", in2: "effect1_backgroundBlur_13925_39989", result: "effect2_dropShadow_13925_39989" }), /* @__PURE__ */ se.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ se.createElement("feOffset", { dx: -2.58065, dy: 2.58065 }), /* @__PURE__ */ se.createElement("feGaussianBlur", { stdDeviation: 3.87097 }), /* @__PURE__ */ se.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ se.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.0823529 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0" }), /* @__PURE__ */ se.createElement("feBlend", { mode: "normal", in2: "effect2_dropShadow_13925_39989", result: "effect3_dropShadow_13925_39989" }), /* @__PURE__ */ se.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect3_dropShadow_13925_39989", result: "shape" })), /* @__PURE__ */ se.createElement("filter", { id: "filter1_dd_13925_39989", x: 88.1121, y: 115.354, width: 27.3564, height: 184.131, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ se.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ se.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ se.createElement("feOffset", { dy: 0.419464 }), /* @__PURE__ */ se.createElement("feGaussianBlur", { stdDeviation: 0.419464 }), /* @__PURE__ */ se.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ se.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.00392157 0 0 0 0 0.14902 0 0 0 0 0.207843 0 0 0 0.05 0" }), /* @__PURE__ */ se.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_13925_39989" }), /* @__PURE__ */ se.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ se.createElement("feOffset", { dy: 1.67785 }), /* @__PURE__ */ se.createElement("feGaussianBlur", { stdDeviation: 1.67785 }), /* @__PURE__ */ se.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ se.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.00392157 0 0 0 0 0.14902 0 0 0 0 0.207843 0 0 0 0.05 0" }), /* @__PURE__ */ se.createElement("feBlend", { mode: "normal", in2: "effect1_dropShadow_13925_39989", result: "effect2_dropShadow_13925_39989" }), /* @__PURE__ */ se.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_13925_39989", result: "shape" })), /* @__PURE__ */ se.createElement("filter", { id: "filter2_f_13925_39989", x: 135.34, y: -31.3544, width: 412.736, height: 393.842, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ se.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ se.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }), /* @__PURE__ */ se.createElement("feGaussianBlur", { stdDeviation: 77.4193, result: "effect1_foregroundBlur_13925_39989" })), /* @__PURE__ */ se.createElement("filter", { id: "filter3_bdd_13925_39989", x: 109.211, y: 65.5173, width: 249.031, height: 349.031, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ se.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ se.createElement("feGaussianBlur", { in: "BackgroundImageFix", stdDeviation: 16.129 }), /* @__PURE__ */ se.createElement("feComposite", { in2: "SourceAlpha", operator: "in", result: "effect1_backgroundBlur_13925_39989" }), /* @__PURE__ */ se.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ se.createElement("feOffset", { dy: 19.3548 }), /* @__PURE__ */ se.createElement("feGaussianBlur", { stdDeviation: 19.3548 }), /* @__PURE__ */ se.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ se.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0" }), /* @__PURE__ */ se.createElement("feBlend", { mode: "normal", in2: "effect1_backgroundBlur_13925_39989", result: "effect2_dropShadow_13925_39989" }), /* @__PURE__ */ se.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ se.createElement("feOffset", { dx: -3.22581, dy: 3.22581 }), /* @__PURE__ */ se.createElement("feGaussianBlur", { stdDeviation: 4.83871 }), /* @__PURE__ */ se.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ se.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.0823529 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0" }), /* @__PURE__ */ se.createElement("feBlend", { mode: "normal", in2: "effect2_dropShadow_13925_39989", result: "effect3_dropShadow_13925_39989" }), /* @__PURE__ */ se.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect3_dropShadow_13925_39989", result: "shape" })), /* @__PURE__ */ se.createElement("filter", { id: "filter4_bd_13925_39989", x: 117.598, y: 124.717, width: 232.258, height: 258.065, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ se.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ se.createElement("feGaussianBlur", { in: "BackgroundImageFix", stdDeviation: 32.2581 }), /* @__PURE__ */ se.createElement("feComposite", { in2: "SourceAlpha", operator: "in", result: "effect1_backgroundBlur_13925_39989" }), /* @__PURE__ */ se.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ se.createElement("feOffset", { dy: 38.7097 }), /* @__PURE__ */ se.createElement("feGaussianBlur", { stdDeviation: 38.7097 }), /* @__PURE__ */ se.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ se.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.05 0" }), /* @__PURE__ */ se.createElement("feBlend", { mode: "normal", in2: "effect1_backgroundBlur_13925_39989", result: "effect2_dropShadow_13925_39989" }), /* @__PURE__ */ se.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_13925_39989", result: "shape" })), /* @__PURE__ */ se.createElement("clipPath", { id: "clip0_13925_39989" }, /* @__PURE__ */ se.createElement("rect", { x: 91.4678, y: 117.032, width: 218.474, height: 141.663, rx: 10.3226, fill: "white" })), /* @__PURE__ */ se.createElement("clipPath", { id: "clip1_13925_39989" }, /* @__PURE__ */ se.createElement("rect", { width: 12.7668, height: 12.8033, fill: "white", transform: "translate(95.4062 128)" })), /* @__PURE__ */ se.createElement("clipPath", { id: "clip2_13925_39989" }, /* @__PURE__ */ se.createElement("rect", { width: 197.829, height: 141.663, fill: "white", transform: "translate(112.113 117.032)" })), /* @__PURE__ */ se.createElement("clipPath", { id: "clip3_13925_39989" }, /* @__PURE__ */ se.createElement("path", { d: "M148.243 111.001C148.243 103.874 154.02 98.0973 161.146 98.0973H306.307C313.433 98.0973 319.21 103.874 319.21 111.001V356.162H148.243V111.001Z", fill: "white" }))));
function ATe({
  "data-test": e = "not-found-screen",
  ...t
}) {
  return /* @__PURE__ */ b(Vf, { image: Zce, "data-test": e, ...t });
}
const Jce = (e) => /* @__PURE__ */ se.createElement("svg", { width: 120, height: 120, viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ se.createElement("circle", { cx: 60, cy: 60, r: 60, fill: "#E85B79" }), /* @__PURE__ */ se.createElement("path", { opacity: 0.5, d: "M27.2426 74.5588C27.2426 56.5751 31.097 52.7206 49.0808 52.7206H70.919C88.9028 52.7206 92.7573 56.5751 92.7573 74.5588C92.7573 92.5426 88.9028 96.3971 70.919 96.3971H49.0808C31.097 96.3971 27.2426 92.5426 27.2426 74.5588Z", fill: "white" }), /* @__PURE__ */ se.createElement("path", { d: "M56.3603 70.9191C56.3603 68.909 57.9898 67.2794 60 67.2794C62.0101 67.2794 63.6397 68.909 63.6397 70.9191V78.1985C63.6397 80.2087 62.0101 81.8383 60 81.8383C57.9898 81.8383 56.3603 80.2087 56.3603 78.1985V70.9191Z", fill: "white" }), /* @__PURE__ */ se.createElement("path", { d: "M60 23.603C47.9391 23.603 38.1617 33.3803 38.1617 45.4412V53.5862C40.2094 53.1384 42.6171 52.8896 45.4412 52.7833V45.4412C45.4412 37.4006 51.9594 30.8824 60 30.8824C68.0406 30.8824 74.5588 37.4006 74.5588 45.4412V52.7833C77.3829 52.8896 79.7906 53.1384 81.8382 53.5862V45.4412C81.8382 33.3803 72.0609 23.603 60 23.603Z", fill: "white" }));
function e1e({
  "data-test": e = "restricted-access-screen",
  ...t
}) {
  return /* @__PURE__ */ b(Vf, { image: Jce, "data-test": e, ...t });
}
const t1e = (e) => /* @__PURE__ */ se.createElement("svg", { width: 121, height: 120, viewBox: "0 0 121 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...e }, /* @__PURE__ */ se.createElement("circle", { cx: 60.5, cy: 60, r: 60, fill: "#F49C17" }), /* @__PURE__ */ se.createElement("path", { d: "M64.4637 64.76C64.4637 66.7702 62.8342 68.3997 60.824 68.3997C58.8139 68.3997 57.1843 66.7702 57.1843 64.76L57.1843 52.7203C57.1843 50.7101 58.8139 49.0806 60.824 49.0806C62.8342 49.0806 64.4637 50.7101 64.4637 52.7203V64.76Z", fill: "#F49C17" }), /* @__PURE__ */ se.createElement("path", { d: "M64.4637 76.3447C64.4637 78.3549 62.8342 79.9844 60.824 79.9844C58.8139 79.9844 57.1843 78.3549 57.1843 76.3447V75.5996C57.1843 73.5895 58.8139 71.9599 60.824 71.9599C62.8342 71.9599 64.4637 73.5895 64.4637 75.5996V76.3447Z", fill: "#F49C17" }), /* @__PURE__ */ se.createElement("path", { opacity: 0.5, fillRule: "evenodd", clipRule: "evenodd", d: "M71.1357 36.918C67.1117 28.8701 55.6269 28.8701 51.6029 36.918L32.8734 74.3771C29.2433 81.6372 34.5227 90.1794 42.6397 90.1794H80.0989C88.2159 90.1794 93.4953 81.6372 89.8652 74.3771L71.1357 36.918ZM60.8242 68.3997C62.8343 68.3997 64.4639 66.7702 64.4639 64.76V52.7203C64.4639 50.7101 62.8343 49.0806 60.8242 49.0806C58.814 49.0806 57.1845 50.7101 57.1845 52.7203V64.76C57.1845 66.7702 58.814 68.3997 60.8242 68.3997ZM60.8242 79.9844C62.8343 79.9844 64.4639 78.3549 64.4639 76.3447V75.5996C64.4639 73.5894 62.8343 71.9599 60.8242 71.9599C58.814 71.9599 57.1845 73.5894 57.1845 75.5996V76.3447C57.1845 78.3549 58.814 79.9844 60.8242 79.9844Z", fill: "white" }), /* @__PURE__ */ se.createElement("path", { d: "M64.4669 64.7605C64.4669 66.7706 62.8374 68.4002 60.8272 68.4002C58.8171 68.4002 57.1875 66.7706 57.1875 64.7605L57.1875 52.7208C57.1875 50.7106 58.8171 49.0811 60.8272 49.0811C62.8374 49.0811 64.4669 50.7106 64.4669 52.7208V64.7605Z", fill: "white" }), /* @__PURE__ */ se.createElement("path", { d: "M64.4669 76.3452C64.4669 78.3553 62.8374 79.9849 60.8272 79.9849C58.8171 79.9849 57.1875 78.3553 57.1875 76.3452V75.6001C57.1875 73.5899 58.8171 71.9604 60.8272 71.9604C62.8374 71.9604 64.4669 73.5899 64.4669 75.6001V76.3452Z", fill: "white" }));
function OTe({
  "data-test": e = "unknown-error-screen",
  ...t
}) {
  return /* @__PURE__ */ b(Vf, { image: t1e, "data-test": e, ...t });
}
function r1e({
  onPlay: e,
  icons: {
    play: t = sM,
    stop: r = uM
  } = {},
  "data-test": n = "mini-audio-player",
  ...a
}) {
  const { isPlaying: i, pause: o, play: u, seek: d } = Yw(), s = ue(
    (l) => {
      l.stopPropagation(), i ? (e == null || e(), o(), d(0)) : u();
    },
    [i, e, o, u, d]
  );
  return /* @__PURE__ */ b(
    _a,
    {
      ...a,
      component: i ? r : t,
      onClick: s,
      "data-test": `${n}-play-button`
    }
  );
}
function TTe({ src: e, ...t }) {
  return /* @__PURE__ */ b(Xw, { children: /* @__PURE__ */ b(Qw, { src: e, children: /* @__PURE__ */ b(r1e, { ...t }) }) });
}
function PTe({ avatar: e, tag: t, title: r }) {
  const n = Mr("neutral-200");
  return /* @__PURE__ */ ne(
    ur,
    {
      minWidth: 160,
      gap: "xxxs",
      p: "s",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: "white",
      border: `1px solid ${n}`,
      borderRadius: "sm",
      children: [
        e,
        /* @__PURE__ */ b($e, { variant: "bodySemiboldM", ellipsis: !0, children: r }),
        t
      ]
    }
  );
}
const n1e = Ge(x3)`
  display: flex;
  height: 100%;
  overflow-y: auto;
  flex-direction: column;
`;
function ITe({
  show: e,
  formProps: t,
  onHide: r,
  onCancel: n = r,
  title: a,
  children: i,
  submitButtonText: o,
  size: u = "regular",
  allowPristineSubmit: d = !1,
  extraFooterContent: s,
  lang: l = "en",
  "data-test": f = "modal-form",
  getErrorMessage: c
}) {
  return /* @__PURE__ */ b(b3, { show: e, onHide: r, size: u, children: /* @__PURE__ */ b(T3, { ...t, children: (h) => {
    const {
      handleSubmit: _,
      hasValidationErrors: F,
      pristine: v,
      submitError: $,
      submitting: E
    } = h, D = E || F || !d && v;
    return /* @__PURE__ */ ne(n1e, { onSubmit: _, "data-test": f, children: [
      /* @__PURE__ */ b(RM, { children: /* @__PURE__ */ b(jM, { children: a }) }),
      /* @__PURE__ */ b(v3, { children: i(h) }),
      /* @__PURE__ */ b(Uf, { children: $ && /* @__PURE__ */ ne(
        wl,
        {
          variant: "critical",
          "data-text": "modal-form-error-banner",
          children: [
            /* @__PURE__ */ b(kl, {}),
            /* @__PURE__ */ b(xl, { children: c == null ? void 0 : c($) })
          ]
        }
      ) }),
      /* @__PURE__ */ b(E3, { children: /* @__PURE__ */ ne(
        Dt,
        {
          space: "xxs",
          alignItems: "center",
          justifyContent: "space-between",
          children: [
            s && /* @__PURE__ */ b(ot, { children: s }),
            /* @__PURE__ */ b(
              nr,
              {
                onClick: n,
                type: "button",
                mode: "ghost",
                variant: "secondary",
                "data-test": "modal-form-cancel-button",
                children: qa[l][La.CANCEL]
              }
            ),
            /* @__PURE__ */ b(
              Nl,
              {
                type: "submit",
                "data-test": "modal-form-submit-button",
                disabled: D,
                status: Xh(h),
                savedText: qa[l][La.SAVED],
                unsavedText: o || qa[l][La.SUBMIT]
              }
            )
          ]
        }
      ) })
    ] });
  } }) });
}
function a1e({ item: e, "data-test": t }) {
  const { removeKey: r, disabled: n } = rd(), a = AH(e.label, 35), i = ue(
    (o) => {
      o.stopPropagation(), r(e.value);
    },
    [e.value, r]
  );
  return /* @__PURE__ */ ne(ms, { variant: "grey", size: "small", "data-test": t, children: [
    /* @__PURE__ */ b(MM, { "data-test": `${t}-label`, children: a }),
    /* @__PURE__ */ b(
      BM,
      {
        "data-test": `${t}-delete-icon`,
        onClick: n ? void 0 : i
      }
    )
  ] });
}
const i1e = sh(
  a1e
);
function o1e({
  selectedOptions: e,
  "data-test": t,
  renderItem: r
}) {
  return e.length === 0 ? null : /* @__PURE__ */ b(Nr, { children: e.map(
    (n) => r ? /* @__PURE__ */ b(m3, { children: r(n) }, n.value) : /* @__PURE__ */ b(
      i1e,
      {
        item: n,
        "data-test": `${t}-${n.value}`
      },
      n.value
    )
  ) });
}
const s1e = Ge.input`
  &,
  &:hover,
  &:active,
  &:focus {
    border: none;
  }
  background: transparent;
  outline: none;
`;
function u1e({
  onValueChange: e,
  value: t,
  inputRef: r,
  selectedOptions: n,
  "data-test": a,
  renderTag: i
}) {
  const { removeKey: o, open: u, setOpen: d, disabled: s } = rd();
  at(() => {
    var h;
    u && ((h = r == null ? void 0 : r.current) == null || h.focus());
  }, [r, u]);
  const l = (h) => {
    e(h.target.value);
  }, f = (h) => {
    if (u || d(!0), h.key === "Backspace" && t === "") {
      const _ = n[n.length - 1];
      _ && o(_.value);
    }
  };
  return /* @__PURE__ */ ne(
    Ae,
    {
      flexWrap: "wrap",
      "data-test": a,
      gap: "xxxs",
      onClick: s ? void 0 : (h) => {
        h.stopPropagation(), u || d(!0);
      },
      children: [
        /* @__PURE__ */ b(
          o1e,
          {
            "data-test": `${a}-tag`,
            selectedOptions: n,
            renderItem: i
          }
        ),
        !s && /* @__PURE__ */ b(
          s1e,
          {
            "data-test": `${a}-input`,
            value: t,
            onChange: l,
            onKeyDown: f,
            ref: r
          }
        )
      ]
    }
  );
}
function d1e({
  onClearAll: e,
  hideClearAll: t,
  "data-test": r
}) {
  const { removeAll: n, selectedKeys: a, disabled: i } = rd();
  return t || i ? /* @__PURE__ */ b(
    sr,
    {
      "data-test": `${r}-down`,
      color: "icon-default",
      ml: "auto",
      size: "16px",
      component: Su
    }
  ) : /* @__PURE__ */ b(
    sr,
    {
      "data-test": `${r}-${a.length ? "close" : "down"}`,
      color: "icon-default",
      ml: "auto",
      size: "16px",
      component: a.length ? Rw : Su,
      onClick: () => {
        a.length && (n(), e());
      }
    }
  );
}
function l1e({
  options: e,
  renderItem: t,
  renderItemPrefix: r,
  renderItemSuffix: n,
  renderItemDescription: a,
  maxMenuHeight: i,
  "data-test": o
}) {
  return /* @__PURE__ */ b(Uw, { py: "xxs", maxHeight: i, "data-test": o, children: e.map((u) => /* @__PURE__ */ b(
    km,
    {
      option: u,
      render: t,
      renderPrefix: r,
      renderSuffix: n,
      renderDescription: a
    },
    u.value
  )) });
}
function RTe({
  options: e,
  onSelect: t,
  onSearch: r,
  onClose: n = kn,
  onClearAll: a = kn,
  open: i,
  defaultOpen: o,
  loading: u = !1,
  hideSelectedOptions: d = !0,
  hideClearAll: s = !1,
  defaultSelectedKeys: l,
  selectedKeys: f,
  renderTag: c,
  renderItem: h,
  renderItemPrefix: _,
  renderItemSuffix: F,
  renderItemDescription: v,
  emptyLabel: $ = "0 result",
  debounceDuration: E = 400,
  maxMenuHeight: D = "314px",
  "data-test": w = "multi-inline-search",
  disabled: k = !1
}) {
  const [A, P] = O3({
    prop: f,
    defaultProp: l,
    onChange: t
  }), [S, N] = Xe(""), W = tt(null), V = tt(Iu(r, E)), [K, U] = Xe(/* @__PURE__ */ new Map()), j = (de) => {
    N(de), V.current(de);
  };
  at(() => {
    U((de) => (A == null || A.forEach((te) => {
      if (!de.has(te)) {
        const ee = e.find((ge) => ge.value === te);
        ee && de.set(te, ee);
      }
    }), de));
  }, [A, e, K]);
  const G = (de) => {
    var te;
    P(de), (te = W.current) == null || te.focus();
  }, H = qe(
    () => (A == null ? void 0 : A.reduce((de, te) => {
      const ee = e.find((ge) => ge.value === te) || K.get(te);
      return ee ? [...de, ee] : de;
    }, [])) || [],
    [A, e, K]
  ), J = e.filter(
    (de) => !(A != null && A.includes(de.value))
  ), ae = qe(
    () => k ? {
      borderColor: "graphic-disabled",
      backgroundColor: "surface-disabled"
    } : {
      borderColor: "graphic-interactive-default",
      backgroundColor: "surface-interactive-default"
    },
    [k]
  );
  return /* @__PURE__ */ ne(
    Gw,
    {
      selectionMode: "multiple",
      onSelectionChange: G,
      selectedKeys: A,
      onClose: n,
      "data-test": w,
      defaultOpen: o,
      open: i,
      disabled: k,
      children: [
        /* @__PURE__ */ b(Lw, { "data-test": `${w}-trigger`, children: /* @__PURE__ */ ne(
          Ae,
          {
            border: "1px solid",
            borderRadius: "sm",
            ...ae,
            w: "100%",
            minH: "48px",
            p: "8px",
            alignItems: "center",
            justifyContent: "space-between",
            children: [
              /* @__PURE__ */ b(
                u1e,
                {
                  renderTag: c,
                  "data-test": `${w}-box`,
                  value: S,
                  onValueChange: j,
                  inputRef: W,
                  selectedOptions: H
                }
              ),
              /* @__PURE__ */ b(
                d1e,
                {
                  "data-test": `${w}-icon`,
                  hideClearAll: s,
                  onClearAll: a
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ ne(
          qw,
          {
            closeOnInsideClick: !1,
            "data-test": `${w}-content`,
            children: [
              u && /* @__PURE__ */ b(tC, { "data-test": `${w}-loader` }),
              !u && e.length === 0 && /* @__PURE__ */ b($e, { p: "s", "data-test": "multi-inline-search-empty-label", children: $ }),
              !u && e.length > 0 && /* @__PURE__ */ b(
                l1e,
                {
                  "data-test": `${w}-menu`,
                  options: d ? J : e,
                  maxMenuHeight: D,
                  renderItem: h,
                  renderItemPrefix: _,
                  renderItemSuffix: F,
                  renderItemDescription: v
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const tA = dr(void 0);
function jTe({
  children: e
}) {
  const [t, r] = Xe(!1), n = tt(null), a = ue(() => {
    r(!1), n.current && n.current.retry();
  }, []), i = ue(() => {
    r(!1);
  }, []), o = ue((d) => {
    n.current = d, r(!0);
  }, []), u = qe(
    () => ({
      navPromptShown: t,
      setNavPromptShown: r,
      cancelNavigation: i,
      confirmNavigation: a,
      setBlockedTransition: o
    }),
    [i, a, t, o]
  );
  return /* @__PURE__ */ b(tA.Provider, { value: u, children: e });
}
function MTe({
  descriptionText: e = "You have unsaved changes. Are you sure you want to leave?",
  cancelText: t = "Cancel",
  discardText: r = "Discard"
}) {
  const { navPromptShown: n, cancelNavigation: a, confirmNavigation: i } = AS();
  return /* @__PURE__ */ ne(b3, { size: "xSmall", show: n, onHide: a, children: [
    /* @__PURE__ */ b(v3, { p: "m", children: /* @__PURE__ */ b($e, { variant: "bodyMediumS", children: e }) }),
    /* @__PURE__ */ b(E3, { children: /* @__PURE__ */ ne(Dt, { direction: "horizontal", space: "xxs", children: [
      /* @__PURE__ */ b(
        nr,
        {
          "data-test": "navigation-blocker-dialog-cancel",
          mode: "ghost",
          variant: "secondary",
          onClick: a,
          children: t
        }
      ),
      /* @__PURE__ */ b(
        nr,
        {
          "data-test": "navigation-blocker-dialog-confirm",
          onClick: i,
          children: r
        }
      )
    ] }) })
  ] });
}
function BTe({
  children: e,
  user: t,
  date: r,
  locale: n,
  w: a = "100%",
  ...i
}) {
  return /* @__PURE__ */ ne(ur, { flexDirection: "column", space: "xxs", w: a, ...i, children: [
    /* @__PURE__ */ ne(ur, { alignItems: "center", justifyContent: "space-between", children: [
      t,
      /* @__PURE__ */ b(
        cfe,
        {
          date: r,
          locale: n,
          variant: "bodyRegularS",
          color: "text-placeholder"
        }
      )
    ] }),
    /* @__PURE__ */ b($e, { variant: "bodyRegularS", children: e })
  ] });
}
const f1e = ({ variant: e }) => {
  switch (e) {
    case "yellow":
      return _r`
        background: ${pt("warning-100")};
      `;
    case "green":
      return _r`
        background: ${pt("primary-100")};
      `;
    default:
      return "background: none;";
  }
}, c1e = Ge(ch)`
  ${f1e}

  &::after {
    display: none;
  }
`;
function NTe({
  "data-test": e = "number-box",
  value: t,
  maxValue: r
}) {
  return /* @__PURE__ */ b(
    c1e,
    {
      size: "xLarge",
      variant: r !== void 0 && t >= r ? "yellow" : "green",
      "data-test": "avatar-with-number",
      children: r !== void 0 ? /* @__PURE__ */ ne(Nr, { children: [
        /* @__PURE__ */ b(
          $e,
          {
            variant: "headingBoldS",
            mb: "xs",
            "data-test": `${e}-count`,
            children: t
          }
        ),
        /* @__PURE__ */ ne(
          $e,
          {
            variant: "bodyRegularS",
            mt: "s",
            "data-test": `${e}-max-number`,
            children: [
              "/ ",
              r
            ]
          }
        )
      ] }) : /* @__PURE__ */ b($e, { variant: "headingBoldS", "data-test": `${e}-count`, children: t })
    }
  );
}
const h1e = Ge(Ae)`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  align-items: center;
  justify-content: end;
  gap: xxs;
  margin-right: xs;
  width: 60px;
`, g1e = Ge(nd)`
  // the width of Right element
  padding-right: 60px;
  /* Hide native number input arrows */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
`;
function LTe({
  unit: e,
  value: t,
  width: r,
  onChange: n,
  min: a,
  max: i,
  step: o = 1,
  decimalPlaces: u = 0,
  minWidth: d,
  ...s
}) {
  const [l, f] = Xe(t.toString());
  at(() => {
    f(t.toString());
  }, [t]);
  const c = ue(
    (v) => {
      f(($) => {
        const E = parseFloat($);
        let D = v(E);
        a !== void 0 && D < a && (D = a), i !== void 0 && D > i && (D = i);
        const w = tne(D, u);
        return n == null || n(w), w.toString();
      });
    },
    [u, i, a, n]
  ), h = ue(() => {
    c((v) => v + o);
  }, [o, c]), _ = ue(() => {
    c((v) => v - o);
  }, [o, c]), F = ue(
    (v) => {
      const $ = v.target.value, E = parseFloat($);
      if ($ === "" || Number.isNaN(E)) {
        f("");
        return;
      }
      c(() => E);
    },
    [c]
  );
  return /* @__PURE__ */ ne(
    ot,
    {
      "data-test": "number-input",
      w: r,
      minWidth: d,
      position: "relative",
      children: [
        /* @__PURE__ */ b(
          g1e,
          {
            ...s,
            type: "number",
            width: "100%",
            min: a,
            max: i,
            step: o,
            value: l,
            onChange: F,
            "data-test": "number-input-input"
          }
        ),
        /* @__PURE__ */ ne(h1e, { children: [
          /* @__PURE__ */ b($e, { color: "text-secondary", children: e }),
          /* @__PURE__ */ ne(Ae, { flexDirection: "column", gap: "0px", children: [
            /* @__PURE__ */ b(
              _a,
              {
                type: "button",
                component: dh,
                size: 16,
                color: "icon-default",
                onClick: h,
                "data-test": "number-input-up"
              }
            ),
            /* @__PURE__ */ b(
              _a,
              {
                type: "button",
                component: Df,
                size: 16,
                color: "icon-default",
                onClick: _,
                "data-test": "number-input-down"
              }
            )
          ] })
        ] })
      ]
    }
  );
}
const T8 = Ge(ot).attrs(({ progress: e }) => ({
  style: {
    width: `${e ?? "100"}%`
  }
}))`
  position: absolute;
  height: ${({ barHeight: e }) => e}px;
  border-radius: ${({ barHeight: e }) => Math.round(e / 2)}px;
  background-color: ${({ color: e }) => He(e ?? "neutral-200")};
  ${({ animated: e }) => e && "transition: width 0.25s"}
`, _1e = M.forwardRef(
  ({
    progress: e,
    disabled: t,
    height: r = 2,
    animated: n = !1,
    color: a = "success-300",
    ...i
  }, o) => /* @__PURE__ */ b(jw, { children: /* @__PURE__ */ ne(
    ot,
    {
      ...i,
      ref: o,
      position: "relative",
      "data-test": "progress-bar",
      borderRadius: r / 2,
      h: `${r}px`,
      overflow: "hidden",
      children: [
        /* @__PURE__ */ b(T8, { animated: !1, barHeight: r }),
        /* @__PURE__ */ b(
          T8,
          {
            progress: e,
            color: t ? "neutral-400" : a,
            "data-test": "progress-bar-gauge",
            animated: n,
            barHeight: r
          }
        )
      ]
    }
  ) })
);
var Ul = /* @__PURE__ */ ((e) => (e.INCREASE = "INCREASE", e.UPDATE = "UPDATE", e))(Ul || {});
const m1e = 500;
function p1e(e, t) {
  const { type: r, value: n } = t;
  switch (r) {
    case Ul.INCREASE: {
      const { capping: a, maxCapping: i, actualProgress: o } = t, u = Math.min(e + n, o + a);
      return Math.min(u, i);
    }
    case Ul.UPDATE:
      return e > n ? e : n;
    default:
      return e;
  }
}
function qTe({
  speed: e,
  capping: t,
  maxCapping: r,
  progress: n,
  ...a
}) {
  const [i, o] = Ow(
    p1e,
    n
  ), u = tt(Date.now());
  return at(() => {
    const d = setInterval(() => {
      const s = Date.now(), l = (s - u.current) / 1e3;
      o({
        type: Ul.INCREASE,
        value: l * e,
        actualProgress: n,
        capping: t,
        maxCapping: r
      }), u.current = s;
    }, m1e);
    return o({ type: Ul.UPDATE, value: n }), () => clearInterval(d);
  }, [n, o, t, e, r]), /* @__PURE__ */ b(
    _1e,
    {
      w: "100%",
      progress: Math.round(i),
      animated: !0,
      ...a
    }
  );
}
const F1e = ({
  portalRootElement: e = "portal-root",
  children: t
}) => {
  const r = tt(document.createElement("div"));
  return at(() => {
    const n = document.getElementById(e), { current: a } = r;
    return n && n.appendChild(a), () => {
      n && n.removeChild(a);
    };
  }, [e]), I3(t, r.current);
}, f2 = {
  Container: NM,
  Content: LM,
  Menu: Ge(qM).attrs(() => ({
    space: "s",
    variant: "auto"
  }))`
    padding-right: ${vt("l")};
    padding-left: ${vt("l")};
  `,
  MenuItem: Ge(UM)`
    height: 100%;
    opacity: ${({ active: e = !0 }) => e ? 1 : 0.4};
    font-size: ${({ theme: e }) => e.typography.bodySemiboldM.fontSize};
    padding: ${vt("xxs")} 0 ${vt("s")};
    margin: 0 ${vt("xxs")};
  `,
  Item: Ge(Cb)`
    padding: ${vt("xl")};
  `,
  BaseTabItem: Ge(Cb)`
    padding: 0;
  `
}, y1e = Ge(ot)`
  border-bottom: 1px solid ${He("graphic-default")};
`;
function b1e({ children: e, to: t, ...r }) {
  return /* @__PURE__ */ b(nk, { to: t, ...r, children: /* @__PURE__ */ ne(nr, { mode: "ghost", size: "xSmall", variant: "secondary", children: [
    /* @__PURE__ */ b(
      sr,
      {
        component: dM,
        size: 16,
        color: "text-interactive-secondary"
      }
    ),
    /* @__PURE__ */ b($e, { color: "text-interactive-secondary", variant: "bodySemiboldM", children: e })
  ] }) });
}
const v1e = Ge(b1e)`
  display: block;
  width: max-content;
  margin-bottom: ${vt("xxs")};
`;
function UTe({
  largeTitle: e,
  title: t,
  subtitle: r,
  "data-test": n = "page-header",
  icon: a,
  avatarSrc: i,
  avatarInitials: o = "",
  children: u,
  activeTabId: d = "1",
  gobackLinkRoute: s,
  gobackLinkText: l,
  onTabChange: f = kn,
  renderAvatar: c,
  renderExtra: h,
  renderSubLeft: _,
  renderSubRight: F,
  renderTitleRight: v,
  titleProps: $
}) {
  const E = !!e, D = !!(i || o), w = !!(s && l), k = M.Children.toArray(u), [A, P, S] = k.reduce(
    (V, K) => {
      switch (K.type) {
        case f2.Menu:
          V[0].push(K);
          break;
        case f2.Content:
          V[1].push(K);
          break;
        default:
          V[2].push(K);
          break;
      }
      return V;
    },
    [[], [], []]
  ), N = !!A.length, W = /* @__PURE__ */ ne(
    y1e,
    {
      backgroundColor: "neutral-0",
      w: "100%",
      "data-test": n,
      hasTabs: N,
      children: [
        /* @__PURE__ */ ne(ot, { pl: "xl", pr: "s", pt: w ? 0 : "xs", pb: "xs", children: [
          w && /* @__PURE__ */ b(
            v1e,
            {
              "data-test": `${n}-link`,
              to: s,
              children: l
            }
          ),
          /* @__PURE__ */ ne(Ae, { alignItems: "center", fluid: !0, ...$, children: [
            /* @__PURE__ */ ne(Dt, { alignItems: "center", space: "s", children: [
              c == null ? void 0 : c(),
              !!a && /* @__PURE__ */ b(sr, { "data-test": "page-header-icon", component: a, size: "l" }),
              D && /* @__PURE__ */ b(
                Mh,
                {
                  "data-test": "page-header-avatar",
                  src: i,
                  initials: o,
                  size: "regular"
                }
              ),
              /* @__PURE__ */ ne(Dt, { direction: "vertical", children: [
                E && /* @__PURE__ */ b(
                  $e,
                  {
                    variant: "headingBoldM",
                    fontWeight: 700,
                    color: "neutral-1000",
                    "data-test": `${n}-large-title`,
                    children: e
                  }
                ),
                !!t && /* @__PURE__ */ b(
                  $e,
                  {
                    variant: "headingBoldS",
                    color: "neutral-1000",
                    "data-test": `${n}-title`,
                    children: t
                  }
                ),
                !!(_ || r || F) && /* @__PURE__ */ ne(Dt, { space: "xxs", alignItems: "center", children: [
                  _ == null ? void 0 : _(),
                  !!r && /* @__PURE__ */ b(
                    $e,
                    {
                      variant: "bodyRegularS",
                      color: "secondary-600",
                      "data-test": `${n}-subtitle`,
                      children: r
                    }
                  ),
                  F == null ? void 0 : F()
                ] })
              ] })
            ] }),
            v == null ? void 0 : v()
          ] }),
          h == null ? void 0 : h()
        ] }),
        N && /* @__PURE__ */ b(ot, { children: A })
      ]
    }
  );
  return N ? /* @__PURE__ */ ne(f2.Container, { activeTabId: d, onChange: f, children: [
    W,
    S,
    P
  ] }) : W;
}
var al = /* @__PURE__ */ ((e) => (e.RED = "red", e.YELLOW = "yellow", e.GREEN = "green", e.DARK_SECONDARY = "darkSecondary", e))(al || {});
function E1e(e, t) {
  return e === 0 ? al.DARK_SECONDARY : e >= Math.max(...t) ? al.GREEN : e >= Math.min(...t) ? al.YELLOW : al.RED;
}
const $1e = Ge(ms)`
  padding-left: ${vt("xs")};
  padding-right: ${vt("xs")};
`;
function GTe({
  value: e,
  thresholds: t,
  "data-test": r = "percentage-tag",
  size: n = "large",
  ...a
}) {
  return /* @__PURE__ */ b(
    $1e,
    {
      ...a,
      variant: E1e(e, t),
      size: n,
      "data-test": r,
      children: /* @__PURE__ */ ne($e, { variant: "bodyMediumS", children: [
        e,
        "%"
      ] })
    }
  );
}
const w1e = Ge(Ae)`
  border: 1px solid ${He("neutral-200")};
  border-radius: 8px;
  background: white;

  :focus-within {
    border: 1px solid ${He("neutral-300")};
  }

  > div {
    border: none;
  }

  input {
    border: none;
    padding-left: 0px;
  }
`;
function WTe({
  defaultCountryPrefix: e = "FR",
  onChange: t,
  ...r
}) {
  const [n, a] = Xe(e), [i, o] = Xe(""), u = ue(
    (s) => {
      const l = s[0];
      a(l);
      const f = new Il(l).input(
        i
      );
      o(f);
    },
    [i]
  ), d = ue(
    (s) => {
      const {
        target: { value: l }
      } = s, f = new Il(n).input(
        l
      );
      o(f);
      try {
        const c = XD(
          l,
          n
        ), h = c.country;
        l.startsWith("+") && h && a(h), t(c.number);
      } catch {
      }
    },
    [n, t]
  );
  return /* @__PURE__ */ ne(w1e, { children: [
    /* @__PURE__ */ b(
      Lae,
      {
        "data-test": "phone-input-country-prefix",
        w: "140px",
        selectedKeys: [n],
        onSelect: u,
        showCountryName: !1
      }
    ),
    /* @__PURE__ */ b(
      nd,
      {
        "data-test": "phone-input-text-input",
        value: i,
        onChange: d,
        ...r
      }
    )
  ] });
}
function rA(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var a = e.length;
      for (t = 0; t < a; t++)
        e[t] && (r = rA(e[t])) && (n && (n += " "), n += r);
    } else
      for (r in e)
        e[r] && (n && (n += " "), n += r);
  return n;
}
function Ct() {
  for (var e, t, r = 0, n = "", a = arguments.length; r < a; r++)
    (e = arguments[r]) && (t = rA(e)) && (n && (n += " "), n += t);
  return n;
}
var k1e = Array.isArray, cn = k1e, x1e = typeof un == "object" && un && un.Object === Object && un, nA = x1e, D1e = nA, C1e = typeof self == "object" && self && self.Object === Object && self, S1e = D1e || C1e || Function("return this")(), Za = S1e, A1e = Za, O1e = A1e.Symbol, Hf = O1e, P8 = Hf, aA = Object.prototype, T1e = aA.hasOwnProperty, P1e = aA.toString, Kd = P8 ? P8.toStringTag : void 0;
function I1e(e) {
  var t = T1e.call(e, Kd), r = e[Kd];
  try {
    e[Kd] = void 0;
    var n = !0;
  } catch {
  }
  var a = P1e.call(e);
  return n && (t ? e[Kd] = r : delete e[Kd]), a;
}
var R1e = I1e, j1e = Object.prototype, M1e = j1e.toString;
function B1e(e) {
  return M1e.call(e);
}
var N1e = B1e, I8 = Hf, L1e = R1e, q1e = N1e, U1e = "[object Null]", G1e = "[object Undefined]", R8 = I8 ? I8.toStringTag : void 0;
function W1e(e) {
  return e == null ? e === void 0 ? G1e : U1e : R8 && R8 in Object(e) ? L1e(e) : q1e(e);
}
var Ni = W1e;
function V1e(e) {
  return e != null && typeof e == "object";
}
var Li = V1e, H1e = Ni, z1e = Li, K1e = "[object Symbol]";
function Y1e(e) {
  return typeof e == "symbol" || z1e(e) && H1e(e) == K1e;
}
var hd = Y1e, X1e = cn, Q1e = hd, Z1e = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, J1e = /^\w*$/;
function e0e(e, t) {
  if (X1e(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || Q1e(e) ? !0 : J1e.test(e) || !Z1e.test(e) || t != null && e in Object(t);
}
var a4 = e0e;
function t0e(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Dn = t0e, r0e = Ni, n0e = Dn, a0e = "[object AsyncFunction]", i0e = "[object Function]", o0e = "[object GeneratorFunction]", s0e = "[object Proxy]";
function u0e(e) {
  if (!n0e(e))
    return !1;
  var t = r0e(e);
  return t == i0e || t == o0e || t == a0e || t == s0e;
}
var Ft = u0e, d0e = Za, l0e = d0e["__core-js_shared__"], f0e = l0e, c2 = f0e, j8 = function() {
  var e = /[^.]+$/.exec(c2 && c2.keys && c2.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function c0e(e) {
  return !!j8 && j8 in e;
}
var h0e = c0e, g0e = Function.prototype, _0e = g0e.toString;
function m0e(e) {
  if (e != null) {
    try {
      return _0e.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var iA = m0e, p0e = Ft, F0e = h0e, y0e = Dn, b0e = iA, v0e = /[\\^$.*+?()[\]{}|]/g, E0e = /^\[object .+?Constructor\]$/, $0e = Function.prototype, w0e = Object.prototype, k0e = $0e.toString, x0e = w0e.hasOwnProperty, D0e = RegExp(
  "^" + k0e.call(x0e).replace(v0e, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function C0e(e) {
  if (!y0e(e) || F0e(e))
    return !1;
  var t = p0e(e) ? D0e : E0e;
  return t.test(b0e(e));
}
var S0e = C0e;
function A0e(e, t) {
  return e == null ? void 0 : e[t];
}
var O0e = A0e, T0e = S0e, P0e = O0e;
function I0e(e, t) {
  var r = P0e(e, t);
  return T0e(r) ? r : void 0;
}
var Is = I0e, R0e = Is, j0e = R0e(Object, "create"), Zh = j0e, M8 = Zh;
function M0e() {
  this.__data__ = M8 ? M8(null) : {}, this.size = 0;
}
var B0e = M0e;
function N0e(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var L0e = N0e, q0e = Zh, U0e = "__lodash_hash_undefined__", G0e = Object.prototype, W0e = G0e.hasOwnProperty;
function V0e(e) {
  var t = this.__data__;
  if (q0e) {
    var r = t[e];
    return r === U0e ? void 0 : r;
  }
  return W0e.call(t, e) ? t[e] : void 0;
}
var H0e = V0e, z0e = Zh, K0e = Object.prototype, Y0e = K0e.hasOwnProperty;
function X0e(e) {
  var t = this.__data__;
  return z0e ? t[e] !== void 0 : Y0e.call(t, e);
}
var Q0e = X0e, Z0e = Zh, J0e = "__lodash_hash_undefined__";
function ehe(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Z0e && t === void 0 ? J0e : t, this;
}
var the = ehe, rhe = B0e, nhe = L0e, ahe = H0e, ihe = Q0e, ohe = the;
function gd(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
gd.prototype.clear = rhe;
gd.prototype.delete = nhe;
gd.prototype.get = ahe;
gd.prototype.has = ihe;
gd.prototype.set = ohe;
var she = gd;
function uhe() {
  this.__data__ = [], this.size = 0;
}
var dhe = uhe;
function lhe(e, t) {
  return e === t || e !== e && t !== t;
}
var i4 = lhe, fhe = i4;
function che(e, t) {
  for (var r = e.length; r--; )
    if (fhe(e[r][0], t))
      return r;
  return -1;
}
var Jh = che, hhe = Jh, ghe = Array.prototype, _he = ghe.splice;
function mhe(e) {
  var t = this.__data__, r = hhe(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : _he.call(t, r, 1), --this.size, !0;
}
var phe = mhe, Fhe = Jh;
function yhe(e) {
  var t = this.__data__, r = Fhe(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var bhe = yhe, vhe = Jh;
function Ehe(e) {
  return vhe(this.__data__, e) > -1;
}
var $he = Ehe, whe = Jh;
function khe(e, t) {
  var r = this.__data__, n = whe(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var xhe = khe, Dhe = dhe, Che = phe, She = bhe, Ahe = $he, Ohe = xhe;
function _d(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
_d.prototype.clear = Dhe;
_d.prototype.delete = Che;
_d.prototype.get = She;
_d.prototype.has = Ahe;
_d.prototype.set = Ohe;
var eg = _d, The = Is, Phe = Za, Ihe = The(Phe, "Map"), o4 = Ihe, B8 = she, Rhe = eg, jhe = o4;
function Mhe() {
  this.size = 0, this.__data__ = {
    hash: new B8(),
    map: new (jhe || Rhe)(),
    string: new B8()
  };
}
var Bhe = Mhe;
function Nhe(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Lhe = Nhe, qhe = Lhe;
function Uhe(e, t) {
  var r = e.__data__;
  return qhe(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var tg = Uhe, Ghe = tg;
function Whe(e) {
  var t = Ghe(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var Vhe = Whe, Hhe = tg;
function zhe(e) {
  return Hhe(this, e).get(e);
}
var Khe = zhe, Yhe = tg;
function Xhe(e) {
  return Yhe(this, e).has(e);
}
var Qhe = Xhe, Zhe = tg;
function Jhe(e, t) {
  var r = Zhe(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var ege = Jhe, tge = Bhe, rge = Vhe, nge = Khe, age = Qhe, ige = ege;
function md(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
md.prototype.clear = tge;
md.prototype.delete = rge;
md.prototype.get = nge;
md.prototype.has = age;
md.prototype.set = ige;
var s4 = md, oA = s4, oge = "Expected a function";
function u4(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(oge);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, n);
    return r.cache = i.set(a, o) || i, o;
  };
  return r.cache = new (u4.Cache || oA)(), r;
}
u4.Cache = oA;
var sA = u4, sge = sA, uge = 500;
function dge(e) {
  var t = sge(e, function(n) {
    return r.size === uge && r.clear(), n;
  }), r = t.cache;
  return t;
}
var lge = dge, fge = lge, cge = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, hge = /\\(\\)?/g, gge = fge(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(cge, function(r, n, a, i) {
    t.push(a ? i.replace(hge, "$1") : n || r);
  }), t;
}), _ge = gge;
function mge(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var d4 = mge, N8 = Hf, pge = d4, Fge = cn, yge = hd, bge = 1 / 0, L8 = N8 ? N8.prototype : void 0, q8 = L8 ? L8.toString : void 0;
function uA(e) {
  if (typeof e == "string")
    return e;
  if (Fge(e))
    return pge(e, uA) + "";
  if (yge(e))
    return q8 ? q8.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -bge ? "-0" : t;
}
var vge = uA, Ege = vge;
function $ge(e) {
  return e == null ? "" : Ege(e);
}
var dA = $ge, wge = cn, kge = a4, xge = _ge, Dge = dA;
function Cge(e, t) {
  return wge(e) ? e : kge(e, t) ? [e] : xge(Dge(e));
}
var lA = Cge, Sge = hd, Age = 1 / 0;
function Oge(e) {
  if (typeof e == "string" || Sge(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -Age ? "-0" : t;
}
var rg = Oge, Tge = lA, Pge = rg;
function Ige(e, t) {
  t = Tge(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[Pge(t[r++])];
  return r && r == n ? e : void 0;
}
var l4 = Ige, Rge = l4;
function jge(e, t, r) {
  var n = e == null ? void 0 : Rge(e, t);
  return n === void 0 ? r : n;
}
var Hn = jge;
function Mge(e) {
  return e == null;
}
var wt = Mge, Bge = Ni, Nge = cn, Lge = Li, qge = "[object String]";
function Uge(e) {
  return typeof e == "string" || !Nge(e) && Lge(e) && Bge(e) == qge;
}
var Gge = Uge;
const zf = Gge;
var Ym = Y3(), Wge = Ni, Vge = Li, Hge = "[object Number]";
function zge(e) {
  return typeof e == "number" || Vge(e) && Wge(e) == Hge;
}
var fA = zge, Kge = fA;
function Yge(e) {
  return Kge(e) && e != +e;
}
var Kf = Yge, Un = function(t) {
  return t === 0 ? 0 : t > 0 ? 1 : -1;
}, ss = function(t) {
  return zf(t) && t.indexOf("%") === t.length - 1;
}, Ve = function(t) {
  return fA(t) && !Kf(t);
}, $r = function(t) {
  return Ve(t) || zf(t);
}, Xge = 0, ng = function(t) {
  var r = ++Xge;
  return "".concat(t || "").concat(r);
}, dn = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!Ve(t) && !zf(t))
    return n;
  var i;
  if (ss(t)) {
    var o = t.indexOf("%");
    i = r * parseFloat(t.slice(0, o)) / 100;
  } else
    i = +t;
  return Kf(i) && (i = n), a && i > r && (i = r), i;
}, fu = function(t) {
  if (!t)
    return null;
  var r = Object.keys(t);
  return r && r.length ? t[r[0]] : null;
}, Qge = function(t) {
  if (!Array.isArray(t))
    return !1;
  for (var r = t.length, n = {}, a = 0; a < r; a++)
    if (!n[t[a]])
      n[t[a]] = !0;
    else
      return !0;
  return !1;
}, U8 = function(t, r) {
  return Ve(t) && Ve(r) ? function(n) {
    return t + n * (r - t);
  } : function() {
    return r;
  };
};
function Xm(e, t, r) {
  return !e || !e.length ? null : e.find(function(n) {
    return n && (typeof t == "function" ? t(n) : Hn(n, t)) === r;
  });
}
function Qm(e, t) {
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r) && (!{}.hasOwnProperty.call(t, r) || e[r] !== t[r]))
      return !1;
  for (var n in t)
    if ({}.hasOwnProperty.call(t, n) && !{}.hasOwnProperty.call(e, n))
      return !1;
  return !0;
}
function Zm(e) {
  return Zm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zm(e);
}
var Zge = ["viewBox", "children"], Jge = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], G8 = ["points", "pathLength"], h2 = {
  svg: Zge,
  polygon: G8,
  polyline: G8
}, f4 = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], F0 = function(t, r) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var n = t;
  if (/* @__PURE__ */ $n(t) && (n = t.props), !Dn(n))
    return null;
  var a = {};
  return Object.keys(n).forEach(function(i) {
    f4.includes(i) && (a[i] = r || function(o) {
      return n[i](n, o);
    });
  }), a;
}, e_e = function(t, r, n) {
  return function(a) {
    return t(r, n, a), null;
  };
}, ag = function(t, r, n) {
  if (!Dn(t) || Zm(t) !== "object")
    return null;
  var a = null;
  return Object.keys(t).forEach(function(i) {
    var o = t[i];
    f4.includes(i) && typeof o == "function" && (a || (a = {}), a[i] = e_e(o, r, n));
  }), a;
}, t_e = ["children"], r_e = ["children"];
function W8(e, t) {
  if (e == null)
    return {};
  var r = n_e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function n_e(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var V8 = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart"
}, Di = function(t) {
  return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
}, H8 = null, g2 = null, c4 = function e(t) {
  if (t === H8 && Array.isArray(g2))
    return g2;
  var r = [];
  return Vn.forEach(t, function(n) {
    wt(n) || (Ym.isFragment(n) ? r = r.concat(e(n.props.children)) : r.push(n));
  }), g2 = r, H8 = t, r;
};
function Wa(e, t) {
  var r = [], n = [];
  return Array.isArray(t) ? n = t.map(function(a) {
    return Di(a);
  }) : n = [Di(t)], c4(e).forEach(function(a) {
    var i = Hn(a, "type.displayName") || Hn(a, "type.name");
    n.indexOf(i) !== -1 && r.push(a);
  }), r;
}
function Bn(e, t) {
  var r = Wa(e, t);
  return r && r[0];
}
var z8 = function(t) {
  if (!t || !t.props)
    return !1;
  var r = t.props, n = r.width, a = r.height;
  return !(!Ve(n) || n <= 0 || !Ve(a) || a <= 0);
}, a_e = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], i_e = function(t) {
  return t && t.type && zf(t.type) && a_e.indexOf(t.type) >= 0;
}, o_e = function(t, r, n, a) {
  var i, o = (i = h2 == null ? void 0 : h2[a]) !== null && i !== void 0 ? i : [];
  return !Ft(t) && (a && o.includes(r) || Jge.includes(r)) || n && f4.includes(r);
}, _t = function(t, r, n) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var a = t;
  if (/* @__PURE__ */ $n(t) && (a = t.props), !Dn(a))
    return null;
  var i = {};
  return Object.keys(a).forEach(function(o) {
    var u;
    o_e((u = a) === null || u === void 0 ? void 0 : u[o], o, r, n) && (i[o] = a[o]);
  }), i;
}, Jm = function e(t, r) {
  if (t === r)
    return !0;
  var n = Vn.count(t);
  if (n !== Vn.count(r))
    return !1;
  if (n === 0)
    return !0;
  if (n === 1)
    return K8(Array.isArray(t) ? t[0] : t, Array.isArray(r) ? r[0] : r);
  for (var a = 0; a < n; a++) {
    var i = t[a], o = r[a];
    if (Array.isArray(i) || Array.isArray(o)) {
      if (!e(i, o))
        return !1;
    } else if (!K8(i, o))
      return !1;
  }
  return !0;
}, K8 = function(t, r) {
  if (wt(t) && wt(r))
    return !0;
  if (!wt(t) && !wt(r)) {
    var n = t.props || {}, a = n.children, i = W8(n, t_e), o = r.props || {}, u = o.children, d = W8(o, r_e);
    return a && u ? Qm(i, d) && Jm(a, u) : !a && !u ? Qm(i, d) : !1;
  }
  return !1;
}, Y8 = function(t, r) {
  var n = [], a = {};
  return c4(t).forEach(function(i, o) {
    if (i_e(i))
      n.push(i);
    else if (i) {
      var u = Di(i.type), d = r[u] || {}, s = d.handler, l = d.once;
      if (s && (!l || !a[u])) {
        var f = s(i, u, o);
        n.push(f), a[u] = !0;
      }
    }
  }), n;
}, s_e = function(t) {
  var r = t && t.type;
  return r && V8[r] ? V8[r] : null;
}, u_e = function(t, r) {
  return c4(r).indexOf(t);
}, d_e = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function ep() {
  return ep = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ep.apply(this, arguments);
}
function l_e(e, t) {
  if (e == null)
    return {};
  var r = f_e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function f_e(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function tp(e) {
  var t = e.children, r = e.width, n = e.height, a = e.viewBox, i = e.className, o = e.style, u = e.title, d = e.desc, s = l_e(e, d_e), l = a || {
    width: r,
    height: n,
    x: 0,
    y: 0
  }, f = Ct("recharts-surface", i);
  return /* @__PURE__ */ M.createElement("svg", ep({}, _t(s, !0, "svg"), {
    className: f,
    width: r,
    height: n,
    style: o,
    viewBox: "".concat(l.x, " ").concat(l.y, " ").concat(l.width, " ").concat(l.height)
  }), /* @__PURE__ */ M.createElement("title", null, u), /* @__PURE__ */ M.createElement("desc", null, d), t);
}
var c_e = ["children", "className"];
function rp() {
  return rp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rp.apply(this, arguments);
}
function h_e(e, t) {
  if (e == null)
    return {};
  var r = g_e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function g_e(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var cr = /* @__PURE__ */ M.forwardRef(function(e, t) {
  var r = e.children, n = e.className, a = h_e(e, c_e), i = Ct("recharts-layer", n);
  return /* @__PURE__ */ M.createElement("g", rp({
    className: i
  }, _t(a, !0), {
    ref: t
  }), r);
}), __e = process.env.NODE_ENV !== "production", Ci = function(t, r) {
  for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    a[i - 2] = arguments[i];
  if (__e && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var o = 0;
      console.warn(r.replace(/%s/g, function() {
        return a[o++];
      }));
    }
};
function m_e(e, t, r) {
  var n = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), r = r > a ? a : r, r < 0 && (r += a), a = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var i = Array(a); ++n < a; )
    i[n] = e[n + t];
  return i;
}
var p_e = m_e, F_e = p_e;
function y_e(e, t, r) {
  var n = e.length;
  return r = r === void 0 ? n : r, !t && r >= n ? e : F_e(e, t, r);
}
var b_e = y_e, v_e = "\\ud800-\\udfff", E_e = "\\u0300-\\u036f", $_e = "\\ufe20-\\ufe2f", w_e = "\\u20d0-\\u20ff", k_e = E_e + $_e + w_e, x_e = "\\ufe0e\\ufe0f", D_e = "\\u200d", C_e = RegExp("[" + D_e + v_e + k_e + x_e + "]");
function S_e(e) {
  return C_e.test(e);
}
var cA = S_e;
function A_e(e) {
  return e.split("");
}
var O_e = A_e, hA = "\\ud800-\\udfff", T_e = "\\u0300-\\u036f", P_e = "\\ufe20-\\ufe2f", I_e = "\\u20d0-\\u20ff", R_e = T_e + P_e + I_e, j_e = "\\ufe0e\\ufe0f", M_e = "[" + hA + "]", np = "[" + R_e + "]", ap = "\\ud83c[\\udffb-\\udfff]", B_e = "(?:" + np + "|" + ap + ")", gA = "[^" + hA + "]", _A = "(?:\\ud83c[\\udde6-\\uddff]){2}", mA = "[\\ud800-\\udbff][\\udc00-\\udfff]", N_e = "\\u200d", pA = B_e + "?", FA = "[" + j_e + "]?", L_e = "(?:" + N_e + "(?:" + [gA, _A, mA].join("|") + ")" + FA + pA + ")*", q_e = FA + pA + L_e, U_e = "(?:" + [gA + np + "?", np, _A, mA, M_e].join("|") + ")", G_e = RegExp(ap + "(?=" + ap + ")|" + U_e + q_e, "g");
function W_e(e) {
  return e.match(G_e) || [];
}
var V_e = W_e, H_e = O_e, z_e = cA, K_e = V_e;
function Y_e(e) {
  return z_e(e) ? K_e(e) : H_e(e);
}
var X_e = Y_e, Q_e = b_e, Z_e = cA, J_e = X_e, e2e = dA;
function t2e(e) {
  return function(t) {
    t = e2e(t);
    var r = Z_e(t) ? J_e(t) : void 0, n = r ? r[0] : t.charAt(0), a = r ? Q_e(r, 1).join("") : t.slice(1);
    return n[e]() + a;
  };
}
var r2e = t2e, n2e = r2e, a2e = n2e("toUpperCase"), ig = a2e;
function Wt(e) {
  return function() {
    return e;
  };
}
const yA = Math.cos, y0 = Math.sin, ba = Math.sqrt, b0 = Math.PI, og = 2 * b0, ip = Math.PI, op = 2 * ip, Zo = 1e-6, i2e = op - Zo;
function bA(e) {
  this._ += e[0];
  for (let t = 1, r = e.length; t < r; ++t)
    this._ += arguments[t] + e[t];
}
function o2e(e) {
  let t = Math.floor(e);
  if (!(t >= 0))
    throw new Error(`invalid digits: ${e}`);
  if (t > 15)
    return bA;
  const r = 10 ** t;
  return function(n) {
    this._ += n[0];
    for (let a = 1, i = n.length; a < i; ++a)
      this._ += Math.round(arguments[a] * r) / r + n[a];
  };
}
class s2e {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? bA : o2e(t);
  }
  moveTo(t, r) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, r) {
    this._append`L${this._x1 = +t},${this._y1 = +r}`;
  }
  quadraticCurveTo(t, r, n, a) {
    this._append`Q${+t},${+r},${this._x1 = +n},${this._y1 = +a}`;
  }
  bezierCurveTo(t, r, n, a, i, o) {
    this._append`C${+t},${+r},${+n},${+a},${this._x1 = +i},${this._y1 = +o}`;
  }
  arcTo(t, r, n, a, i) {
    if (t = +t, r = +r, n = +n, a = +a, i = +i, i < 0)
      throw new Error(`negative radius: ${i}`);
    let o = this._x1, u = this._y1, d = n - t, s = a - r, l = o - t, f = u - r, c = l * l + f * f;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = r}`;
    else if (c > Zo)
      if (!(Math.abs(f * d - s * l) > Zo) || !i)
        this._append`L${this._x1 = t},${this._y1 = r}`;
      else {
        let h = n - o, _ = a - u, F = d * d + s * s, v = h * h + _ * _, $ = Math.sqrt(F), E = Math.sqrt(c), D = i * Math.tan((ip - Math.acos((F + c - v) / (2 * $ * E))) / 2), w = D / E, k = D / $;
        Math.abs(w - 1) > Zo && this._append`L${t + w * l},${r + w * f}`, this._append`A${i},${i},0,0,${+(f * h > l * _)},${this._x1 = t + k * d},${this._y1 = r + k * s}`;
      }
  }
  arc(t, r, n, a, i, o) {
    if (t = +t, r = +r, n = +n, o = !!o, n < 0)
      throw new Error(`negative radius: ${n}`);
    let u = n * Math.cos(a), d = n * Math.sin(a), s = t + u, l = r + d, f = 1 ^ o, c = o ? a - i : i - a;
    this._x1 === null ? this._append`M${s},${l}` : (Math.abs(this._x1 - s) > Zo || Math.abs(this._y1 - l) > Zo) && this._append`L${s},${l}`, n && (c < 0 && (c = c % op + op), c > i2e ? this._append`A${n},${n},0,1,${f},${t - u},${r - d}A${n},${n},0,1,${f},${this._x1 = s},${this._y1 = l}` : c > Zo && this._append`A${n},${n},0,${+(c >= ip)},${f},${this._x1 = t + n * Math.cos(i)},${this._y1 = r + n * Math.sin(i)}`);
  }
  rect(t, r, n, a) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}h${n = +n}v${+a}h${-n}Z`;
  }
  toString() {
    return this._;
  }
}
function h4(e) {
  let t = 3;
  return e.digits = function(r) {
    if (!arguments.length)
      return t;
    if (r == null)
      t = null;
    else {
      const n = Math.floor(r);
      if (!(n >= 0))
        throw new RangeError(`invalid digits: ${r}`);
      t = n;
    }
    return e;
  }, () => new s2e(t);
}
function g4(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function vA(e) {
  this._context = e;
}
vA.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function sg(e) {
  return new vA(e);
}
function EA(e) {
  return e[0];
}
function $A(e) {
  return e[1];
}
function wA(e, t) {
  var r = Wt(!0), n = null, a = sg, i = null, o = h4(u);
  e = typeof e == "function" ? e : e === void 0 ? EA : Wt(e), t = typeof t == "function" ? t : t === void 0 ? $A : Wt(t);
  function u(d) {
    var s, l = (d = g4(d)).length, f, c = !1, h;
    for (n == null && (i = a(h = o())), s = 0; s <= l; ++s)
      !(s < l && r(f = d[s], s, d)) === c && ((c = !c) ? i.lineStart() : i.lineEnd()), c && i.point(+e(f, s, d), +t(f, s, d));
    if (h)
      return i = null, h + "" || null;
  }
  return u.x = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : Wt(+d), u) : e;
  }, u.y = function(d) {
    return arguments.length ? (t = typeof d == "function" ? d : Wt(+d), u) : t;
  }, u.defined = function(d) {
    return arguments.length ? (r = typeof d == "function" ? d : Wt(!!d), u) : r;
  }, u.curve = function(d) {
    return arguments.length ? (a = d, n != null && (i = a(n)), u) : a;
  }, u.context = function(d) {
    return arguments.length ? (d == null ? n = i = null : i = a(n = d), u) : n;
  }, u;
}
function l1(e, t, r) {
  var n = null, a = Wt(!0), i = null, o = sg, u = null, d = h4(s);
  e = typeof e == "function" ? e : e === void 0 ? EA : Wt(+e), t = typeof t == "function" ? t : Wt(t === void 0 ? 0 : +t), r = typeof r == "function" ? r : r === void 0 ? $A : Wt(+r);
  function s(f) {
    var c, h, _, F = (f = g4(f)).length, v, $ = !1, E, D = new Array(F), w = new Array(F);
    for (i == null && (u = o(E = d())), c = 0; c <= F; ++c) {
      if (!(c < F && a(v = f[c], c, f)) === $)
        if ($ = !$)
          h = c, u.areaStart(), u.lineStart();
        else {
          for (u.lineEnd(), u.lineStart(), _ = c - 1; _ >= h; --_)
            u.point(D[_], w[_]);
          u.lineEnd(), u.areaEnd();
        }
      $ && (D[c] = +e(v, c, f), w[c] = +t(v, c, f), u.point(n ? +n(v, c, f) : D[c], r ? +r(v, c, f) : w[c]));
    }
    if (E)
      return u = null, E + "" || null;
  }
  function l() {
    return wA().defined(a).curve(o).context(i);
  }
  return s.x = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : Wt(+f), n = null, s) : e;
  }, s.x0 = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : Wt(+f), s) : e;
  }, s.x1 = function(f) {
    return arguments.length ? (n = f == null ? null : typeof f == "function" ? f : Wt(+f), s) : n;
  }, s.y = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : Wt(+f), r = null, s) : t;
  }, s.y0 = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : Wt(+f), s) : t;
  }, s.y1 = function(f) {
    return arguments.length ? (r = f == null ? null : typeof f == "function" ? f : Wt(+f), s) : r;
  }, s.lineX0 = s.lineY0 = function() {
    return l().x(e).y(t);
  }, s.lineY1 = function() {
    return l().x(e).y(r);
  }, s.lineX1 = function() {
    return l().x(n).y(t);
  }, s.defined = function(f) {
    return arguments.length ? (a = typeof f == "function" ? f : Wt(!!f), s) : a;
  }, s.curve = function(f) {
    return arguments.length ? (o = f, i != null && (u = o(i)), s) : o;
  }, s.context = function(f) {
    return arguments.length ? (f == null ? i = u = null : u = o(i = f), s) : i;
  }, s;
}
class kA {
  constructor(t, r) {
    this._context = t, this._x = r;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, r) {
    switch (t = +t, r = +r, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, r) : this._context.moveTo(t, r);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, r, t, r) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + r) / 2, t, this._y0, t, r);
        break;
      }
    }
    this._x0 = t, this._y0 = r;
  }
}
function u2e(e) {
  return new kA(e, !0);
}
function d2e(e) {
  return new kA(e, !1);
}
const _4 = {
  draw(e, t) {
    const r = ba(t / b0);
    e.moveTo(r, 0), e.arc(0, 0, r, 0, og);
  }
}, l2e = {
  draw(e, t) {
    const r = ba(t / 5) / 2;
    e.moveTo(-3 * r, -r), e.lineTo(-r, -r), e.lineTo(-r, -3 * r), e.lineTo(r, -3 * r), e.lineTo(r, -r), e.lineTo(3 * r, -r), e.lineTo(3 * r, r), e.lineTo(r, r), e.lineTo(r, 3 * r), e.lineTo(-r, 3 * r), e.lineTo(-r, r), e.lineTo(-3 * r, r), e.closePath();
  }
}, xA = ba(1 / 3), f2e = xA * 2, c2e = {
  draw(e, t) {
    const r = ba(t / f2e), n = r * xA;
    e.moveTo(0, -r), e.lineTo(n, 0), e.lineTo(0, r), e.lineTo(-n, 0), e.closePath();
  }
}, h2e = {
  draw(e, t) {
    const r = ba(t), n = -r / 2;
    e.rect(n, n, r, r);
  }
}, g2e = 0.8908130915292852, DA = y0(b0 / 10) / y0(7 * b0 / 10), _2e = y0(og / 10) * DA, m2e = -yA(og / 10) * DA, p2e = {
  draw(e, t) {
    const r = ba(t * g2e), n = _2e * r, a = m2e * r;
    e.moveTo(0, -r), e.lineTo(n, a);
    for (let i = 1; i < 5; ++i) {
      const o = og * i / 5, u = yA(o), d = y0(o);
      e.lineTo(d * r, -u * r), e.lineTo(u * n - d * a, d * n + u * a);
    }
    e.closePath();
  }
}, _2 = ba(3), F2e = {
  draw(e, t) {
    const r = -ba(t / (_2 * 3));
    e.moveTo(0, r * 2), e.lineTo(-_2 * r, -r), e.lineTo(_2 * r, -r), e.closePath();
  }
}, Rn = -0.5, jn = ba(3) / 2, sp = 1 / ba(12), y2e = (sp / 2 + 1) * 3, b2e = {
  draw(e, t) {
    const r = ba(t / y2e), n = r / 2, a = r * sp, i = n, o = r * sp + r, u = -i, d = o;
    e.moveTo(n, a), e.lineTo(i, o), e.lineTo(u, d), e.lineTo(Rn * n - jn * a, jn * n + Rn * a), e.lineTo(Rn * i - jn * o, jn * i + Rn * o), e.lineTo(Rn * u - jn * d, jn * u + Rn * d), e.lineTo(Rn * n + jn * a, Rn * a - jn * n), e.lineTo(Rn * i + jn * o, Rn * o - jn * i), e.lineTo(Rn * u + jn * d, Rn * d - jn * u), e.closePath();
  }
};
function v2e(e, t) {
  let r = null, n = h4(a);
  e = typeof e == "function" ? e : Wt(e || _4), t = typeof t == "function" ? t : Wt(t === void 0 ? 64 : +t);
  function a() {
    let i;
    if (r || (r = i = n()), e.apply(this, arguments).draw(r, +t.apply(this, arguments)), i)
      return r = null, i + "" || null;
  }
  return a.type = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : Wt(i), a) : e;
  }, a.size = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : Wt(+i), a) : t;
  }, a.context = function(i) {
    return arguments.length ? (r = i ?? null, a) : r;
  }, a;
}
function v0() {
}
function E0(e, t, r) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + r) / 6
  );
}
function CA(e) {
  this._context = e;
}
CA.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        E0(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        E0(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function E2e(e) {
  return new CA(e);
}
function SA(e) {
  this._context = e;
}
SA.prototype = {
  areaStart: v0,
  areaEnd: v0,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        E0(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function $2e(e) {
  return new SA(e);
}
function AA(e) {
  this._context = e;
}
AA.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var r = (this._x0 + 4 * this._x1 + e) / 6, n = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
        break;
      case 3:
        this._point = 4;
      default:
        E0(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function w2e(e) {
  return new AA(e);
}
function OA(e) {
  this._context = e;
}
OA.prototype = {
  areaStart: v0,
  areaEnd: v0,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function k2e(e) {
  return new OA(e);
}
function X8(e) {
  return e < 0 ? -1 : 1;
}
function Q8(e, t, r) {
  var n = e._x1 - e._x0, a = t - e._x1, i = (e._y1 - e._y0) / (n || a < 0 && -0), o = (r - e._y1) / (a || n < 0 && -0), u = (i * a + o * n) / (n + a);
  return (X8(i) + X8(o)) * Math.min(Math.abs(i), Math.abs(o), 0.5 * Math.abs(u)) || 0;
}
function Z8(e, t) {
  var r = e._x1 - e._x0;
  return r ? (3 * (e._y1 - e._y0) / r - t) / 2 : t;
}
function m2(e, t, r) {
  var n = e._x0, a = e._y0, i = e._x1, o = e._y1, u = (i - n) / 3;
  e._context.bezierCurveTo(n + u, a + u * t, i - u, o - u * r, i, o);
}
function $0(e) {
  this._context = e;
}
$0.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        m2(this, this._t0, Z8(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var r = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, m2(this, Z8(this, r = Q8(this, e, t)), r);
          break;
        default:
          m2(this, this._t0, r = Q8(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = r;
    }
  }
};
function TA(e) {
  this._context = new PA(e);
}
(TA.prototype = Object.create($0.prototype)).point = function(e, t) {
  $0.prototype.point.call(this, t, e);
};
function PA(e) {
  this._context = e;
}
PA.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, r, n, a, i) {
    this._context.bezierCurveTo(t, e, n, r, i, a);
  }
};
function x2e(e) {
  return new $0(e);
}
function D2e(e) {
  return new TA(e);
}
function IA(e) {
  this._context = e;
}
IA.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, r = e.length;
    if (r)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), r === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var n = J8(e), a = J8(t), i = 0, o = 1; o < r; ++i, ++o)
          this._context.bezierCurveTo(n[0][i], a[0][i], n[1][i], a[1][i], e[o], t[o]);
    (this._line || this._line !== 0 && r === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function J8(e) {
  var t, r = e.length - 1, n, a = new Array(r), i = new Array(r), o = new Array(r);
  for (a[0] = 0, i[0] = 2, o[0] = e[0] + 2 * e[1], t = 1; t < r - 1; ++t)
    a[t] = 1, i[t] = 4, o[t] = 4 * e[t] + 2 * e[t + 1];
  for (a[r - 1] = 2, i[r - 1] = 7, o[r - 1] = 8 * e[r - 1] + e[r], t = 1; t < r; ++t)
    n = a[t] / i[t - 1], i[t] -= n, o[t] -= n * o[t - 1];
  for (a[r - 1] = o[r - 1] / i[r - 1], t = r - 2; t >= 0; --t)
    a[t] = (o[t] - a[t + 1]) / i[t];
  for (i[r - 1] = (e[r] + a[r - 1]) / 2, t = 0; t < r - 1; ++t)
    i[t] = 2 * e[t + 1] - a[t + 1];
  return [a, i];
}
function C2e(e) {
  return new IA(e);
}
function ug(e, t) {
  this._context = e, this._t = t;
}
ug.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var r = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(r, this._y), this._context.lineTo(r, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function S2e(e) {
  return new ug(e, 0.5);
}
function A2e(e) {
  return new ug(e, 0);
}
function O2e(e) {
  return new ug(e, 1);
}
function Mu(e, t) {
  if ((o = e.length) > 1)
    for (var r = 1, n, a, i = e[t[0]], o, u = i.length; r < o; ++r)
      for (a = i, i = e[t[r]], n = 0; n < u; ++n)
        i[n][1] += i[n][0] = isNaN(a[n][1]) ? a[n][0] : a[n][1];
}
function up(e) {
  for (var t = e.length, r = new Array(t); --t >= 0; )
    r[t] = t;
  return r;
}
function T2e(e, t) {
  return e[t];
}
function P2e(e) {
  const t = [];
  return t.key = e, t;
}
function I2e() {
  var e = Wt([]), t = up, r = Mu, n = T2e;
  function a(i) {
    var o = Array.from(e.apply(this, arguments), P2e), u, d = o.length, s = -1, l;
    for (const f of i)
      for (u = 0, ++s; u < d; ++u)
        (o[u][s] = [0, +n(f, o[u].key, s, i)]).data = f;
    for (u = 0, l = g4(t(o)); u < d; ++u)
      o[l[u]].index = u;
    return r(o, l), o;
  }
  return a.keys = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : Wt(Array.from(i)), a) : e;
  }, a.value = function(i) {
    return arguments.length ? (n = typeof i == "function" ? i : Wt(+i), a) : n;
  }, a.order = function(i) {
    return arguments.length ? (t = i == null ? up : typeof i == "function" ? i : Wt(Array.from(i)), a) : t;
  }, a.offset = function(i) {
    return arguments.length ? (r = i ?? Mu, a) : r;
  }, a;
}
function R2e(e, t) {
  if ((n = e.length) > 0) {
    for (var r, n, a = 0, i = e[0].length, o; a < i; ++a) {
      for (o = r = 0; r < n; ++r)
        o += e[r][a][1] || 0;
      if (o)
        for (r = 0; r < n; ++r)
          e[r][a][1] /= o;
    }
    Mu(e, t);
  }
}
function j2e(e, t) {
  if ((a = e.length) > 0) {
    for (var r = 0, n = e[t[0]], a, i = n.length; r < i; ++r) {
      for (var o = 0, u = 0; o < a; ++o)
        u += e[o][r][1] || 0;
      n[r][1] += n[r][0] = -u / 2;
    }
    Mu(e, t);
  }
}
function M2e(e, t) {
  if (!(!((o = e.length) > 0) || !((i = (a = e[t[0]]).length) > 0))) {
    for (var r = 0, n = 1, a, i, o; n < i; ++n) {
      for (var u = 0, d = 0, s = 0; u < o; ++u) {
        for (var l = e[t[u]], f = l[n][1] || 0, c = l[n - 1][1] || 0, h = (f - c) / 2, _ = 0; _ < u; ++_) {
          var F = e[t[_]], v = F[n][1] || 0, $ = F[n - 1][1] || 0;
          h += v - $;
        }
        d += f, s += h * f;
      }
      a[n - 1][1] += a[n - 1][0] = r, d && (r -= s / d);
    }
    a[n - 1][1] += a[n - 1][0] = r, Mu(e, t);
  }
}
function Gl(e) {
  return Gl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gl(e);
}
var B2e = ["type", "size", "sizeType"];
function dp() {
  return dp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, dp.apply(this, arguments);
}
function e7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function t7(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? e7(Object(r), !0).forEach(function(n) {
      N2e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : e7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function N2e(e, t, r) {
  return t = L2e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function L2e(e) {
  var t = q2e(e, "string");
  return Gl(t) == "symbol" ? t : String(t);
}
function q2e(e, t) {
  if (Gl(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Gl(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function U2e(e, t) {
  if (e == null)
    return {};
  var r = G2e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function G2e(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var RA = {
  symbolCircle: _4,
  symbolCross: l2e,
  symbolDiamond: c2e,
  symbolSquare: h2e,
  symbolStar: p2e,
  symbolTriangle: F2e,
  symbolWye: b2e
}, W2e = Math.PI / 180, V2e = function(t) {
  var r = "symbol".concat(ig(t));
  return RA[r] || _4;
}, H2e = function(t, r, n) {
  if (r === "area")
    return t;
  switch (n) {
    case "cross":
      return 5 * t * t / 9;
    case "diamond":
      return 0.5 * t * t / Math.sqrt(3);
    case "square":
      return t * t;
    case "star": {
      var a = 18 * W2e;
      return 1.25 * t * t * (Math.tan(a) - Math.tan(a * 2) * Math.pow(Math.tan(a), 2));
    }
    case "triangle":
      return Math.sqrt(3) * t * t / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * t * t / 8;
    default:
      return Math.PI * t * t / 4;
  }
}, z2e = function(t, r) {
  RA["symbol".concat(ig(t))] = r;
}, m4 = function(t) {
  var r = t.type, n = r === void 0 ? "circle" : r, a = t.size, i = a === void 0 ? 64 : a, o = t.sizeType, u = o === void 0 ? "area" : o, d = U2e(t, B2e), s = t7(t7({}, d), {}, {
    type: n,
    size: i,
    sizeType: u
  }), l = function() {
    var v = V2e(n), $ = v2e().type(v).size(H2e(i, u, n));
    return $();
  }, f = s.className, c = s.cx, h = s.cy, _ = _t(s, !0);
  return c === +c && h === +h && i === +i ? /* @__PURE__ */ M.createElement("path", dp({}, _, {
    className: Ct("recharts-symbols", f),
    transform: "translate(".concat(c, ", ").concat(h, ")"),
    d: l()
  })) : null;
};
m4.registerSymbol = z2e;
function Bu(e) {
  return Bu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bu(e);
}
function lp() {
  return lp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, lp.apply(this, arguments);
}
function r7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function K2e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? r7(Object(r), !0).forEach(function(n) {
      Wl(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : r7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Y2e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function n7(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, MA(n.key), n);
  }
}
function X2e(e, t, r) {
  return t && n7(e.prototype, t), r && n7(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Q2e(e, t, r) {
  return t = w0(t), Z2e(e, jA() ? Reflect.construct(t, r || [], w0(e).constructor) : t.apply(e, r));
}
function Z2e(e, t) {
  if (t && (Bu(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return J2e(e);
}
function J2e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function jA() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (jA = function() {
    return !!e;
  })();
}
function w0(e) {
  return w0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, w0(e);
}
function eme(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && fp(e, t);
}
function fp(e, t) {
  return fp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, fp(e, t);
}
function Wl(e, t, r) {
  return t = MA(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function MA(e) {
  var t = tme(e, "string");
  return Bu(t) == "symbol" ? t : String(t);
}
function tme(e, t) {
  if (Bu(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Bu(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Mn = 32, p4 = /* @__PURE__ */ function(e) {
  eme(t, e);
  function t() {
    return Y2e(this, t), Q2e(this, t, arguments);
  }
  return X2e(t, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(n) {
        var a = this.props.inactiveColor, i = Mn / 2, o = Mn / 6, u = Mn / 3, d = n.inactive ? a : n.color;
        if (n.type === "plainline")
          return /* @__PURE__ */ M.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: d,
            strokeDasharray: n.payload.strokeDasharray,
            x1: 0,
            y1: i,
            x2: Mn,
            y2: i,
            className: "recharts-legend-icon"
          });
        if (n.type === "line")
          return /* @__PURE__ */ M.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: d,
            d: "M0,".concat(i, "h").concat(u, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(2 * u, ",").concat(i, `
            H`).concat(Mn, "M").concat(2 * u, ",").concat(i, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(u, ",").concat(i),
            className: "recharts-legend-icon"
          });
        if (n.type === "rect")
          return /* @__PURE__ */ M.createElement("path", {
            stroke: "none",
            fill: d,
            d: "M0,".concat(Mn / 8, "h").concat(Mn, "v").concat(Mn * 3 / 4, "h").concat(-Mn, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ M.isValidElement(n.legendIcon)) {
          var s = K2e({}, n);
          return delete s.legendIcon, /* @__PURE__ */ M.cloneElement(n.legendIcon, s);
        }
        return /* @__PURE__ */ M.createElement(m4, {
          fill: d,
          cx: i,
          cy: i,
          size: Mn,
          sizeType: "diameter",
          type: n.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var n = this, a = this.props, i = a.payload, o = a.iconSize, u = a.layout, d = a.formatter, s = a.inactiveColor, l = {
        x: 0,
        y: 0,
        width: Mn,
        height: Mn
      }, f = {
        display: u === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, c = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return i.map(function(h, _) {
        var F = h.formatter || d, v = Ct(Wl(Wl({
          "recharts-legend-item": !0
        }, "legend-item-".concat(_), !0), "inactive", h.inactive));
        if (h.type === "none")
          return null;
        var $ = Ft(h.value) ? null : h.value;
        Ci(
          !Ft(h.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var E = h.inactive ? s : h.color;
        return /* @__PURE__ */ M.createElement("li", lp({
          className: v,
          style: f,
          key: "legend-item-".concat(_)
        }, ag(n.props, h, _)), /* @__PURE__ */ M.createElement(tp, {
          width: o,
          height: o,
          viewBox: l,
          style: c
        }, n.renderIcon(h)), /* @__PURE__ */ M.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: E
          }
        }, F ? F($, h, _) : $));
      });
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.payload, i = n.layout, o = n.align;
      if (!a || !a.length)
        return null;
      var u = {
        padding: 0,
        margin: 0,
        textAlign: i === "horizontal" ? o : "left"
      };
      return /* @__PURE__ */ M.createElement("ul", {
        className: "recharts-default-legend",
        style: u
      }, this.renderItems());
    }
  }]), t;
}(ji);
Wl(p4, "displayName", "Legend");
Wl(p4, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var rme = eg;
function nme() {
  this.__data__ = new rme(), this.size = 0;
}
var ame = nme;
function ime(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var ome = ime;
function sme(e) {
  return this.__data__.get(e);
}
var ume = sme;
function dme(e) {
  return this.__data__.has(e);
}
var lme = dme, fme = eg, cme = o4, hme = s4, gme = 200;
function _me(e, t) {
  var r = this.__data__;
  if (r instanceof fme) {
    var n = r.__data__;
    if (!cme || n.length < gme - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new hme(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var mme = _me, pme = eg, Fme = ame, yme = ome, bme = ume, vme = lme, Eme = mme;
function pd(e) {
  var t = this.__data__ = new pme(e);
  this.size = t.size;
}
pd.prototype.clear = Fme;
pd.prototype.delete = yme;
pd.prototype.get = bme;
pd.prototype.has = vme;
pd.prototype.set = Eme;
var BA = pd, $me = "__lodash_hash_undefined__";
function wme(e) {
  return this.__data__.set(e, $me), this;
}
var kme = wme;
function xme(e) {
  return this.__data__.has(e);
}
var Dme = xme, Cme = s4, Sme = kme, Ame = Dme;
function k0(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Cme(); ++t < r; )
    this.add(e[t]);
}
k0.prototype.add = k0.prototype.push = Sme;
k0.prototype.has = Ame;
var NA = k0;
function Ome(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var LA = Ome;
function Tme(e, t) {
  return e.has(t);
}
var qA = Tme, Pme = NA, Ime = LA, Rme = qA, jme = 1, Mme = 2;
function Bme(e, t, r, n, a, i) {
  var o = r & jme, u = e.length, d = t.length;
  if (u != d && !(o && d > u))
    return !1;
  var s = i.get(e), l = i.get(t);
  if (s && l)
    return s == t && l == e;
  var f = -1, c = !0, h = r & Mme ? new Pme() : void 0;
  for (i.set(e, t), i.set(t, e); ++f < u; ) {
    var _ = e[f], F = t[f];
    if (n)
      var v = o ? n(F, _, f, t, e, i) : n(_, F, f, e, t, i);
    if (v !== void 0) {
      if (v)
        continue;
      c = !1;
      break;
    }
    if (h) {
      if (!Ime(t, function($, E) {
        if (!Rme(h, E) && (_ === $ || a(_, $, r, n, i)))
          return h.push(E);
      })) {
        c = !1;
        break;
      }
    } else if (!(_ === F || a(_, F, r, n, i))) {
      c = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), c;
}
var UA = Bme, Nme = Za, Lme = Nme.Uint8Array, qme = Lme;
function Ume(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
var Gme = Ume;
function Wme(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var F4 = Wme, a7 = Hf, i7 = qme, Vme = i4, Hme = UA, zme = Gme, Kme = F4, Yme = 1, Xme = 2, Qme = "[object Boolean]", Zme = "[object Date]", Jme = "[object Error]", epe = "[object Map]", tpe = "[object Number]", rpe = "[object RegExp]", npe = "[object Set]", ape = "[object String]", ipe = "[object Symbol]", ope = "[object ArrayBuffer]", spe = "[object DataView]", o7 = a7 ? a7.prototype : void 0, p2 = o7 ? o7.valueOf : void 0;
function upe(e, t, r, n, a, i, o) {
  switch (r) {
    case spe:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case ope:
      return !(e.byteLength != t.byteLength || !i(new i7(e), new i7(t)));
    case Qme:
    case Zme:
    case tpe:
      return Vme(+e, +t);
    case Jme:
      return e.name == t.name && e.message == t.message;
    case rpe:
    case ape:
      return e == t + "";
    case epe:
      var u = zme;
    case npe:
      var d = n & Yme;
      if (u || (u = Kme), e.size != t.size && !d)
        return !1;
      var s = o.get(e);
      if (s)
        return s == t;
      n |= Xme, o.set(e, t);
      var l = Hme(u(e), u(t), n, a, i, o);
      return o.delete(e), l;
    case ipe:
      if (p2)
        return p2.call(e) == p2.call(t);
  }
  return !1;
}
var dpe = upe;
function lpe(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var GA = lpe, fpe = GA, cpe = cn;
function hpe(e, t, r) {
  var n = t(e);
  return cpe(e) ? n : fpe(n, r(e));
}
var gpe = hpe;
function _pe(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (i[a++] = o);
  }
  return i;
}
var mpe = _pe;
function ppe() {
  return [];
}
var Fpe = ppe, ype = mpe, bpe = Fpe, vpe = Object.prototype, Epe = vpe.propertyIsEnumerable, s7 = Object.getOwnPropertySymbols, $pe = s7 ? function(e) {
  return e == null ? [] : (e = Object(e), ype(s7(e), function(t) {
    return Epe.call(e, t);
  }));
} : bpe, wpe = $pe;
function kpe(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var xpe = kpe, Dpe = Ni, Cpe = Li, Spe = "[object Arguments]";
function Ape(e) {
  return Cpe(e) && Dpe(e) == Spe;
}
var Ope = Ape, u7 = Ope, Tpe = Li, WA = Object.prototype, Ppe = WA.hasOwnProperty, Ipe = WA.propertyIsEnumerable, Rpe = u7(function() {
  return arguments;
}()) ? u7 : function(e) {
  return Tpe(e) && Ppe.call(e, "callee") && !Ipe.call(e, "callee");
}, y4 = Rpe, Vl = {}, jpe = {
  get exports() {
    return Vl;
  },
  set exports(e) {
    Vl = e;
  }
};
function Mpe() {
  return !1;
}
var Bpe = Mpe;
(function(e, t) {
  var r = Za, n = Bpe, a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, u = o ? r.Buffer : void 0, d = u ? u.isBuffer : void 0, s = d || n;
  e.exports = s;
})(jpe, Vl);
var Npe = 9007199254740991, Lpe = /^(?:0|[1-9]\d*)$/;
function qpe(e, t) {
  var r = typeof e;
  return t = t ?? Npe, !!t && (r == "number" || r != "symbol" && Lpe.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var b4 = qpe, Upe = 9007199254740991;
function Gpe(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Upe;
}
var v4 = Gpe, Wpe = Ni, Vpe = v4, Hpe = Li, zpe = "[object Arguments]", Kpe = "[object Array]", Ype = "[object Boolean]", Xpe = "[object Date]", Qpe = "[object Error]", Zpe = "[object Function]", Jpe = "[object Map]", e3e = "[object Number]", t3e = "[object Object]", r3e = "[object RegExp]", n3e = "[object Set]", a3e = "[object String]", i3e = "[object WeakMap]", o3e = "[object ArrayBuffer]", s3e = "[object DataView]", u3e = "[object Float32Array]", d3e = "[object Float64Array]", l3e = "[object Int8Array]", f3e = "[object Int16Array]", c3e = "[object Int32Array]", h3e = "[object Uint8Array]", g3e = "[object Uint8ClampedArray]", _3e = "[object Uint16Array]", m3e = "[object Uint32Array]", Qt = {};
Qt[u3e] = Qt[d3e] = Qt[l3e] = Qt[f3e] = Qt[c3e] = Qt[h3e] = Qt[g3e] = Qt[_3e] = Qt[m3e] = !0;
Qt[zpe] = Qt[Kpe] = Qt[o3e] = Qt[Ype] = Qt[s3e] = Qt[Xpe] = Qt[Qpe] = Qt[Zpe] = Qt[Jpe] = Qt[e3e] = Qt[t3e] = Qt[r3e] = Qt[n3e] = Qt[a3e] = Qt[i3e] = !1;
function p3e(e) {
  return Hpe(e) && Vpe(e.length) && !!Qt[Wpe(e)];
}
var F3e = p3e;
function y3e(e) {
  return function(t) {
    return e(t);
  };
}
var VA = y3e, x0 = {}, b3e = {
  get exports() {
    return x0;
  },
  set exports(e) {
    x0 = e;
  }
};
(function(e, t) {
  var r = nA, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, o = i && r.process, u = function() {
    try {
      var d = a && a.require && a.require("util").types;
      return d || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = u;
})(b3e, x0);
var v3e = F3e, E3e = VA, d7 = x0, l7 = d7 && d7.isTypedArray, $3e = l7 ? E3e(l7) : v3e, HA = $3e, w3e = xpe, k3e = y4, x3e = cn, D3e = Vl, C3e = b4, S3e = HA, A3e = Object.prototype, O3e = A3e.hasOwnProperty;
function T3e(e, t) {
  var r = x3e(e), n = !r && k3e(e), a = !r && !n && D3e(e), i = !r && !n && !a && S3e(e), o = r || n || a || i, u = o ? w3e(e.length, String) : [], d = u.length;
  for (var s in e)
    (t || O3e.call(e, s)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (s == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (s == "offset" || s == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (s == "buffer" || s == "byteLength" || s == "byteOffset") || // Skip index properties.
    C3e(s, d))) && u.push(s);
  return u;
}
var P3e = T3e, I3e = Object.prototype;
function R3e(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || I3e;
  return e === r;
}
var j3e = R3e;
function M3e(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var zA = M3e, B3e = zA, N3e = B3e(Object.keys, Object), L3e = N3e, q3e = j3e, U3e = L3e, G3e = Object.prototype, W3e = G3e.hasOwnProperty;
function V3e(e) {
  if (!q3e(e))
    return U3e(e);
  var t = [];
  for (var r in Object(e))
    W3e.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var H3e = V3e, z3e = Ft, K3e = v4;
function Y3e(e) {
  return e != null && K3e(e.length) && !z3e(e);
}
var dg = Y3e, X3e = P3e, Q3e = H3e, Z3e = dg;
function J3e(e) {
  return Z3e(e) ? X3e(e) : Q3e(e);
}
var E4 = J3e, eFe = gpe, tFe = wpe, rFe = E4;
function nFe(e) {
  return eFe(e, rFe, tFe);
}
var aFe = nFe, f7 = aFe, iFe = 1, oFe = Object.prototype, sFe = oFe.hasOwnProperty;
function uFe(e, t, r, n, a, i) {
  var o = r & iFe, u = f7(e), d = u.length, s = f7(t), l = s.length;
  if (d != l && !o)
    return !1;
  for (var f = d; f--; ) {
    var c = u[f];
    if (!(o ? c in t : sFe.call(t, c)))
      return !1;
  }
  var h = i.get(e), _ = i.get(t);
  if (h && _)
    return h == t && _ == e;
  var F = !0;
  i.set(e, t), i.set(t, e);
  for (var v = o; ++f < d; ) {
    c = u[f];
    var $ = e[c], E = t[c];
    if (n)
      var D = o ? n(E, $, c, t, e, i) : n($, E, c, e, t, i);
    if (!(D === void 0 ? $ === E || a($, E, r, n, i) : D)) {
      F = !1;
      break;
    }
    v || (v = c == "constructor");
  }
  if (F && !v) {
    var w = e.constructor, k = t.constructor;
    w != k && "constructor" in e && "constructor" in t && !(typeof w == "function" && w instanceof w && typeof k == "function" && k instanceof k) && (F = !1);
  }
  return i.delete(e), i.delete(t), F;
}
var dFe = uFe, lFe = Is, fFe = Za, cFe = lFe(fFe, "DataView"), hFe = cFe, gFe = Is, _Fe = Za, mFe = gFe(_Fe, "Promise"), pFe = mFe, FFe = Is, yFe = Za, bFe = FFe(yFe, "Set"), KA = bFe, vFe = Is, EFe = Za, $Fe = vFe(EFe, "WeakMap"), wFe = $Fe, cp = hFe, hp = o4, gp = pFe, _p = KA, mp = wFe, YA = Ni, Fd = iA, c7 = "[object Map]", kFe = "[object Object]", h7 = "[object Promise]", g7 = "[object Set]", _7 = "[object WeakMap]", m7 = "[object DataView]", xFe = Fd(cp), DFe = Fd(hp), CFe = Fd(gp), SFe = Fd(_p), AFe = Fd(mp), Jo = YA;
(cp && Jo(new cp(new ArrayBuffer(1))) != m7 || hp && Jo(new hp()) != c7 || gp && Jo(gp.resolve()) != h7 || _p && Jo(new _p()) != g7 || mp && Jo(new mp()) != _7) && (Jo = function(e) {
  var t = YA(e), r = t == kFe ? e.constructor : void 0, n = r ? Fd(r) : "";
  if (n)
    switch (n) {
      case xFe:
        return m7;
      case DFe:
        return c7;
      case CFe:
        return h7;
      case SFe:
        return g7;
      case AFe:
        return _7;
    }
  return t;
});
var OFe = Jo, F2 = BA, TFe = UA, PFe = dpe, IFe = dFe, p7 = OFe, F7 = cn, y7 = Vl, RFe = HA, jFe = 1, b7 = "[object Arguments]", v7 = "[object Array]", f1 = "[object Object]", MFe = Object.prototype, E7 = MFe.hasOwnProperty;
function BFe(e, t, r, n, a, i) {
  var o = F7(e), u = F7(t), d = o ? v7 : p7(e), s = u ? v7 : p7(t);
  d = d == b7 ? f1 : d, s = s == b7 ? f1 : s;
  var l = d == f1, f = s == f1, c = d == s;
  if (c && y7(e)) {
    if (!y7(t))
      return !1;
    o = !0, l = !1;
  }
  if (c && !l)
    return i || (i = new F2()), o || RFe(e) ? TFe(e, t, r, n, a, i) : PFe(e, t, d, r, n, a, i);
  if (!(r & jFe)) {
    var h = l && E7.call(e, "__wrapped__"), _ = f && E7.call(t, "__wrapped__");
    if (h || _) {
      var F = h ? e.value() : e, v = _ ? t.value() : t;
      return i || (i = new F2()), a(F, v, r, n, i);
    }
  }
  return c ? (i || (i = new F2()), IFe(e, t, r, n, a, i)) : !1;
}
var NFe = BFe, LFe = NFe, $7 = Li;
function XA(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !$7(e) && !$7(t) ? e !== e && t !== t : LFe(e, t, r, n, XA, a);
}
var $4 = XA, qFe = BA, UFe = $4, GFe = 1, WFe = 2;
function VFe(e, t, r, n) {
  var a = r.length, i = a, o = !n;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var u = r[a];
    if (o && u[2] ? u[1] !== e[u[0]] : !(u[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    u = r[a];
    var d = u[0], s = e[d], l = u[1];
    if (o && u[2]) {
      if (s === void 0 && !(d in e))
        return !1;
    } else {
      var f = new qFe();
      if (n)
        var c = n(s, l, d, e, t, f);
      if (!(c === void 0 ? UFe(l, s, GFe | WFe, n, f) : c))
        return !1;
    }
  }
  return !0;
}
var HFe = VFe, zFe = Dn;
function KFe(e) {
  return e === e && !zFe(e);
}
var QA = KFe, YFe = QA, XFe = E4;
function QFe(e) {
  for (var t = XFe(e), r = t.length; r--; ) {
    var n = t[r], a = e[n];
    t[r] = [n, a, YFe(a)];
  }
  return t;
}
var ZFe = QFe;
function JFe(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var ZA = JFe, e4e = HFe, t4e = ZFe, r4e = ZA;
function n4e(e) {
  var t = t4e(e);
  return t.length == 1 && t[0][2] ? r4e(t[0][0], t[0][1]) : function(r) {
    return r === e || e4e(r, e, t);
  };
}
var a4e = n4e;
function i4e(e, t) {
  return e != null && t in Object(e);
}
var o4e = i4e, s4e = lA, u4e = y4, d4e = cn, l4e = b4, f4e = v4, c4e = rg;
function h4e(e, t, r) {
  t = s4e(t, e);
  for (var n = -1, a = t.length, i = !1; ++n < a; ) {
    var o = c4e(t[n]);
    if (!(i = e != null && r(e, o)))
      break;
    e = e[o];
  }
  return i || ++n != a ? i : (a = e == null ? 0 : e.length, !!a && f4e(a) && l4e(o, a) && (d4e(e) || u4e(e)));
}
var g4e = h4e, _4e = o4e, m4e = g4e;
function p4e(e, t) {
  return e != null && m4e(e, t, _4e);
}
var F4e = p4e, y4e = $4, b4e = Hn, v4e = F4e, E4e = a4, $4e = QA, w4e = ZA, k4e = rg, x4e = 1, D4e = 2;
function C4e(e, t) {
  return E4e(e) && $4e(t) ? w4e(k4e(e), t) : function(r) {
    var n = b4e(r, e);
    return n === void 0 && n === t ? v4e(r, e) : y4e(t, n, x4e | D4e);
  };
}
var S4e = C4e;
function A4e(e) {
  return e;
}
var yd = A4e;
function O4e(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var T4e = O4e, P4e = l4;
function I4e(e) {
  return function(t) {
    return P4e(t, e);
  };
}
var R4e = I4e, j4e = T4e, M4e = R4e, B4e = a4, N4e = rg;
function L4e(e) {
  return B4e(e) ? j4e(N4e(e)) : M4e(e);
}
var q4e = L4e, U4e = a4e, G4e = S4e, W4e = yd, V4e = cn, H4e = q4e;
function z4e(e) {
  return typeof e == "function" ? e : e == null ? W4e : typeof e == "object" ? V4e(e) ? G4e(e[0], e[1]) : U4e(e) : H4e(e);
}
var Do = z4e;
function K4e(e, t, r, n) {
  for (var a = e.length, i = r + (n ? 1 : -1); n ? i-- : ++i < a; )
    if (t(e[i], i, e))
      return i;
  return -1;
}
var Y4e = K4e;
function X4e(e) {
  return e !== e;
}
var Q4e = X4e;
function Z4e(e, t, r) {
  for (var n = r - 1, a = e.length; ++n < a; )
    if (e[n] === t)
      return n;
  return -1;
}
var J4e = Z4e, eye = Y4e, tye = Q4e, rye = J4e;
function nye(e, t, r) {
  return t === t ? rye(e, t, r) : eye(e, tye, r);
}
var aye = nye, iye = aye;
function oye(e, t) {
  var r = e == null ? 0 : e.length;
  return !!r && iye(e, t, 0) > -1;
}
var sye = oye;
function uye(e, t, r) {
  for (var n = -1, a = e == null ? 0 : e.length; ++n < a; )
    if (r(t, e[n]))
      return !0;
  return !1;
}
var dye = uye;
function lye() {
}
var fye = lye, y2 = KA, cye = fye, hye = F4, gye = 1 / 0, _ye = y2 && 1 / hye(new y2([, -0]))[1] == gye ? function(e) {
  return new y2(e);
} : cye, mye = _ye, pye = NA, Fye = sye, yye = dye, bye = qA, vye = mye, Eye = F4, $ye = 200;
function wye(e, t, r) {
  var n = -1, a = Fye, i = e.length, o = !0, u = [], d = u;
  if (r)
    o = !1, a = yye;
  else if (i >= $ye) {
    var s = t ? null : vye(e);
    if (s)
      return Eye(s);
    o = !1, a = bye, d = new pye();
  } else
    d = t ? [] : u;
  e:
    for (; ++n < i; ) {
      var l = e[n], f = t ? t(l) : l;
      if (l = r || l !== 0 ? l : 0, o && f === f) {
        for (var c = d.length; c--; )
          if (d[c] === f)
            continue e;
        t && d.push(f), u.push(l);
      } else
        a(d, f, r) || (d !== u && d.push(f), u.push(l));
    }
  return u;
}
var kye = wye, xye = Do, Dye = kye;
function Cye(e, t) {
  return e && e.length ? Dye(e, xye(t)) : [];
}
var Sye = Cye;
const w7 = Sye;
function JA(e, t, r) {
  return t === !0 ? w7(e, r) : Ft(t) ? w7(e, t) : e;
}
function Nu(e) {
  return Nu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Nu(e);
}
var Aye = ["ref"];
function k7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Wo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? k7(Object(r), !0).forEach(function(n) {
      lg(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : k7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Oye(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function x7(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, rO(n.key), n);
  }
}
function Tye(e, t, r) {
  return t && x7(e.prototype, t), r && x7(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Pye(e, t, r) {
  return t = D0(t), Iye(e, eO() ? Reflect.construct(t, r || [], D0(e).constructor) : t.apply(e, r));
}
function Iye(e, t) {
  if (t && (Nu(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return tO(e);
}
function eO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (eO = function() {
    return !!e;
  })();
}
function D0(e) {
  return D0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, D0(e);
}
function tO(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Rye(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && pp(e, t);
}
function pp(e, t) {
  return pp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, pp(e, t);
}
function lg(e, t, r) {
  return t = rO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function rO(e) {
  var t = jye(e, "string");
  return Nu(t) == "symbol" ? t : String(t);
}
function jye(e, t) {
  if (Nu(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Nu(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Mye(e, t) {
  if (e == null)
    return {};
  var r = Bye(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Bye(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Nye(e) {
  return e.value;
}
function Lye(e, t) {
  if (/* @__PURE__ */ M.isValidElement(e))
    return /* @__PURE__ */ M.cloneElement(e, t);
  if (typeof e == "function")
    return /* @__PURE__ */ M.createElement(e, t);
  t.ref;
  var r = Mye(t, Aye);
  return /* @__PURE__ */ M.createElement(p4, r);
}
var D7 = 1, Lu = /* @__PURE__ */ function(e) {
  Rye(t, e);
  function t() {
    var r;
    Oye(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = Pye(this, t, [].concat(a)), lg(tO(r), "lastBoundingBox", {
      width: -1,
      height: -1
    }), r;
  }
  return Tye(t, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        return n.height = this.wrapperNode.offsetHeight, n.width = this.wrapperNode.offsetWidth, n;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var n = this.props.onBBoxUpdate, a = this.getBBox();
      a ? (Math.abs(a.width - this.lastBoundingBox.width) > D7 || Math.abs(a.height - this.lastBoundingBox.height) > D7) && (this.lastBoundingBox.width = a.width, this.lastBoundingBox.height = a.height, n && n(a)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, n && n(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? Wo({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(n) {
      var a = this.props, i = a.layout, o = a.align, u = a.verticalAlign, d = a.margin, s = a.chartWidth, l = a.chartHeight, f, c;
      if (!n || (n.left === void 0 || n.left === null) && (n.right === void 0 || n.right === null))
        if (o === "center" && i === "vertical") {
          var h = this.getBBoxSnapshot();
          f = {
            left: ((s || 0) - h.width) / 2
          };
        } else
          f = o === "right" ? {
            right: d && d.right || 0
          } : {
            left: d && d.left || 0
          };
      if (!n || (n.top === void 0 || n.top === null) && (n.bottom === void 0 || n.bottom === null))
        if (u === "middle") {
          var _ = this.getBBoxSnapshot();
          c = {
            top: ((l || 0) - _.height) / 2
          };
        } else
          c = u === "bottom" ? {
            bottom: d && d.bottom || 0
          } : {
            top: d && d.top || 0
          };
      return Wo(Wo({}, f), c);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.content, o = a.width, u = a.height, d = a.wrapperStyle, s = a.payloadUniqBy, l = a.payload, f = Wo(Wo({
        position: "absolute",
        width: o || "auto",
        height: u || "auto"
      }, this.getDefaultPosition(d)), d);
      return /* @__PURE__ */ M.createElement("div", {
        className: "recharts-legend-wrapper",
        style: f,
        ref: function(h) {
          n.wrapperNode = h;
        }
      }, Lye(i, Wo(Wo({}, this.props), {}, {
        payload: JA(l, s, Nye)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(n, a) {
      var i = n.props.layout;
      return i === "vertical" && Ve(n.props.height) ? {
        height: n.props.height
      } : i === "horizontal" ? {
        width: n.props.width || a
      } : null;
    }
  }]), t;
}(ji);
lg(Lu, "displayName", "Legend");
lg(Lu, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var C7 = Hf, qye = y4, Uye = cn, S7 = C7 ? C7.isConcatSpreadable : void 0;
function Gye(e) {
  return Uye(e) || qye(e) || !!(S7 && e && e[S7]);
}
var Wye = Gye, Vye = GA, Hye = Wye;
function nO(e, t, r, n, a) {
  var i = -1, o = e.length;
  for (r || (r = Hye), a || (a = []); ++i < o; ) {
    var u = e[i];
    t > 0 && r(u) ? t > 1 ? nO(u, t - 1, r, n, a) : Vye(a, u) : n || (a[a.length] = u);
  }
  return a;
}
var aO = nO;
function zye(e) {
  return function(t, r, n) {
    for (var a = -1, i = Object(t), o = n(t), u = o.length; u--; ) {
      var d = o[e ? u : ++a];
      if (r(i[d], d, i) === !1)
        break;
    }
    return t;
  };
}
var Kye = zye, Yye = Kye, Xye = Yye(), Qye = Xye, Zye = Qye, Jye = E4;
function ebe(e, t) {
  return e && Zye(e, t, Jye);
}
var iO = ebe, tbe = dg;
function rbe(e, t) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!tbe(r))
      return e(r, n);
    for (var a = r.length, i = t ? a : -1, o = Object(r); (t ? i-- : ++i < a) && n(o[i], i, o) !== !1; )
      ;
    return r;
  };
}
var nbe = rbe, abe = iO, ibe = nbe, obe = ibe(abe), w4 = obe, sbe = w4, ube = dg;
function dbe(e, t) {
  var r = -1, n = ube(e) ? Array(e.length) : [];
  return sbe(e, function(a, i, o) {
    n[++r] = t(a, i, o);
  }), n;
}
var oO = dbe;
function lbe(e, t) {
  var r = e.length;
  for (e.sort(t); r--; )
    e[r] = e[r].value;
  return e;
}
var fbe = lbe, A7 = hd;
function cbe(e, t) {
  if (e !== t) {
    var r = e !== void 0, n = e === null, a = e === e, i = A7(e), o = t !== void 0, u = t === null, d = t === t, s = A7(t);
    if (!u && !s && !i && e > t || i && o && d && !u && !s || n && o && d || !r && d || !a)
      return 1;
    if (!n && !i && !s && e < t || s && r && a && !n && !i || u && r && a || !o && a || !d)
      return -1;
  }
  return 0;
}
var hbe = cbe, gbe = hbe;
function _be(e, t, r) {
  for (var n = -1, a = e.criteria, i = t.criteria, o = a.length, u = r.length; ++n < o; ) {
    var d = gbe(a[n], i[n]);
    if (d) {
      if (n >= u)
        return d;
      var s = r[n];
      return d * (s == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
var mbe = _be, b2 = d4, pbe = l4, Fbe = Do, ybe = oO, bbe = fbe, vbe = VA, Ebe = mbe, $be = yd, wbe = cn;
function kbe(e, t, r) {
  t.length ? t = b2(t, function(i) {
    return wbe(i) ? function(o) {
      return pbe(o, i.length === 1 ? i[0] : i);
    } : i;
  }) : t = [$be];
  var n = -1;
  t = b2(t, vbe(Fbe));
  var a = ybe(e, function(i, o, u) {
    var d = b2(t, function(s) {
      return s(i);
    });
    return { criteria: d, index: ++n, value: i };
  });
  return bbe(a, function(i, o) {
    return Ebe(i, o, r);
  });
}
var xbe = kbe;
function Dbe(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
var Cbe = Dbe, Sbe = Cbe, O7 = Math.max;
function Abe(e, t, r) {
  return t = O7(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, a = -1, i = O7(n.length - t, 0), o = Array(i); ++a < i; )
      o[a] = n[t + a];
    a = -1;
    for (var u = Array(t + 1); ++a < t; )
      u[a] = n[a];
    return u[t] = r(o), Sbe(e, this, u);
  };
}
var Obe = Abe;
function Tbe(e) {
  return function() {
    return e;
  };
}
var Pbe = Tbe, Ibe = Is, Rbe = function() {
  try {
    var e = Ibe(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), sO = Rbe, jbe = Pbe, T7 = sO, Mbe = yd, Bbe = T7 ? function(e, t) {
  return T7(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: jbe(t),
    writable: !0
  });
} : Mbe, Nbe = Bbe, Lbe = 800, qbe = 16, Ube = Date.now;
function Gbe(e) {
  var t = 0, r = 0;
  return function() {
    var n = Ube(), a = qbe - (n - r);
    if (r = n, a > 0) {
      if (++t >= Lbe)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var Wbe = Gbe, Vbe = Nbe, Hbe = Wbe, zbe = Hbe(Vbe), Kbe = zbe, Ybe = yd, Xbe = Obe, Qbe = Kbe;
function Zbe(e, t) {
  return Qbe(Xbe(e, t, Ybe), e + "");
}
var Jbe = Zbe, e6e = i4, t6e = dg, r6e = b4, n6e = Dn;
function a6e(e, t, r) {
  if (!n6e(r))
    return !1;
  var n = typeof t;
  return (n == "number" ? t6e(r) && r6e(t, r.length) : n == "string" && t in r) ? e6e(r[t], e) : !1;
}
var fg = a6e, i6e = aO, o6e = xbe, s6e = Jbe, P7 = fg, u6e = s6e(function(e, t) {
  if (e == null)
    return [];
  var r = t.length;
  return r > 1 && P7(e, t[0], t[1]) ? t = [] : r > 2 && P7(t[0], t[1], t[2]) && (t = [t[0]]), o6e(e, i6e(t, 1), []);
}), k4 = u6e;
function Hl(e) {
  return Hl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Hl(e);
}
function Fp() {
  return Fp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fp.apply(this, arguments);
}
function d6e(e, t) {
  return h6e(e) || c6e(e, t) || f6e(e, t) || l6e();
}
function l6e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function f6e(e, t) {
  if (e) {
    if (typeof e == "string")
      return I7(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return I7(e, t);
  }
}
function I7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function c6e(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], d = !0, s = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        d = !1;
      } else
        for (; !(d = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); d = !0)
          ;
    } catch (l) {
      s = !0, a = l;
    } finally {
      try {
        if (!d && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (s)
          throw a;
      }
    }
    return u;
  }
}
function h6e(e) {
  if (Array.isArray(e))
    return e;
}
function R7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function v2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? R7(Object(r), !0).forEach(function(n) {
      g6e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : R7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function g6e(e, t, r) {
  return t = _6e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function _6e(e) {
  var t = m6e(e, "string");
  return Hl(t) == "symbol" ? t : String(t);
}
function m6e(e, t) {
  if (Hl(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Hl(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function p6e(e) {
  return Array.isArray(e) && $r(e[0]) && $r(e[1]) ? e.join(" ~ ") : e;
}
var F6e = function(t) {
  var r = t.separator, n = r === void 0 ? " : " : r, a = t.contentStyle, i = a === void 0 ? {} : a, o = t.itemStyle, u = o === void 0 ? {} : o, d = t.labelStyle, s = d === void 0 ? {} : d, l = t.payload, f = t.formatter, c = t.itemSorter, h = t.wrapperClassName, _ = t.labelClassName, F = t.label, v = t.labelFormatter, $ = t.accessibilityLayer, E = $ === void 0 ? !1 : $, D = function() {
    if (l && l.length) {
      var K = {
        padding: 0,
        margin: 0
      }, U = (c ? k4(l, c) : l).map(function(j, G) {
        if (j.type === "none")
          return null;
        var H = v2({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: j.color || "#000"
        }, u), J = j.formatter || f || p6e, ae = j.value, de = j.name, te = ae, ee = de;
        if (J && te != null && ee != null) {
          var ge = J(ae, de, j, G, l);
          if (Array.isArray(ge)) {
            var De = d6e(ge, 2);
            te = De[0], ee = De[1];
          } else
            te = ge;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ M.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(G),
            style: H
          }, $r(ee) ? /* @__PURE__ */ M.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, ee) : null, $r(ee) ? /* @__PURE__ */ M.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, n) : null, /* @__PURE__ */ M.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, te), /* @__PURE__ */ M.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, j.unit || ""))
        );
      });
      return /* @__PURE__ */ M.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: K
      }, U);
    }
    return null;
  }, w = v2({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, i), k = v2({
    margin: 0
  }, s), A = !wt(F), P = A ? F : "", S = Ct("recharts-default-tooltip", h), N = Ct("recharts-tooltip-label", _);
  A && v && l !== void 0 && l !== null && (P = v(F, l));
  var W = E ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ M.createElement("div", Fp({
    className: S,
    style: w
  }, W), /* @__PURE__ */ M.createElement("p", {
    className: N,
    style: k
  }, /* @__PURE__ */ M.isValidElement(P) ? P : "".concat(P)), D());
};
function zl(e) {
  return zl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zl(e);
}
function c1(e, t, r) {
  return t = y6e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function y6e(e) {
  var t = b6e(e, "string");
  return zl(t) == "symbol" ? t : String(t);
}
function b6e(e, t) {
  if (zl(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (zl(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Yd = "recharts-tooltip-wrapper", v6e = {
  visibility: "hidden"
};
function E6e(e) {
  var t = e.coordinate, r = e.translateX, n = e.translateY;
  return Ct(Yd, c1(c1(c1(c1({}, "".concat(Yd, "-right"), Ve(r) && t && Ve(t.x) && r >= t.x), "".concat(Yd, "-left"), Ve(r) && t && Ve(t.x) && r < t.x), "".concat(Yd, "-bottom"), Ve(n) && t && Ve(t.y) && n >= t.y), "".concat(Yd, "-top"), Ve(n) && t && Ve(t.y) && n < t.y));
}
function j7(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.key, a = e.offsetTopLeft, i = e.position, o = e.reverseDirection, u = e.tooltipDimension, d = e.viewBox, s = e.viewBoxDimension;
  if (i && Ve(i[n]))
    return i[n];
  var l = r[n] - u - a, f = r[n] + a;
  if (t[n])
    return o[n] ? l : f;
  if (o[n]) {
    var c = l, h = d[n];
    return c < h ? Math.max(f, d[n]) : Math.max(l, d[n]);
  }
  var _ = f + u, F = d[n] + s;
  return _ > F ? Math.max(l, d[n]) : Math.max(f, d[n]);
}
function $6e(e) {
  var t = e.translateX, r = e.translateY, n = e.useTranslate3d;
  return {
    transform: n ? "translate3d(".concat(t, "px, ").concat(r, "px, 0)") : "translate(".concat(t, "px, ").concat(r, "px)")
  };
}
function w6e(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.offsetTopLeft, a = e.position, i = e.reverseDirection, o = e.tooltipBox, u = e.useTranslate3d, d = e.viewBox, s, l, f;
  return o.height > 0 && o.width > 0 && r ? (l = j7({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "x",
    offsetTopLeft: n,
    position: a,
    reverseDirection: i,
    tooltipDimension: o.width,
    viewBox: d,
    viewBoxDimension: d.width
  }), f = j7({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "y",
    offsetTopLeft: n,
    position: a,
    reverseDirection: i,
    tooltipDimension: o.height,
    viewBox: d,
    viewBoxDimension: d.height
  }), s = $6e({
    translateX: l,
    translateY: f,
    useTranslate3d: u
  })) : s = v6e, {
    cssProperties: s,
    cssClasses: E6e({
      translateX: l,
      translateY: f,
      coordinate: r
    })
  };
}
function qu(e) {
  return qu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qu(e);
}
function M7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function B7(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? M7(Object(r), !0).forEach(function(n) {
      vp(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : M7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function k6e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function N7(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, dO(n.key), n);
  }
}
function x6e(e, t, r) {
  return t && N7(e.prototype, t), r && N7(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function D6e(e, t, r) {
  return t = C0(t), C6e(e, uO() ? Reflect.construct(t, r || [], C0(e).constructor) : t.apply(e, r));
}
function C6e(e, t) {
  if (t && (qu(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return yp(e);
}
function uO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (uO = function() {
    return !!e;
  })();
}
function C0(e) {
  return C0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, C0(e);
}
function yp(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function S6e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && bp(e, t);
}
function bp(e, t) {
  return bp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, bp(e, t);
}
function vp(e, t, r) {
  return t = dO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function dO(e) {
  var t = A6e(e, "string");
  return qu(t) == "symbol" ? t : String(t);
}
function A6e(e, t) {
  if (qu(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (qu(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var L7 = 1, O6e = /* @__PURE__ */ function(e) {
  S6e(t, e);
  function t() {
    var r;
    k6e(this, t);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = D6e(this, t, [].concat(a)), vp(yp(r), "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), vp(yp(r), "handleKeyDown", function(o) {
      if (o.key === "Escape") {
        var u, d, s, l;
        r.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (u = (d = r.props.coordinate) === null || d === void 0 ? void 0 : d.x) !== null && u !== void 0 ? u : 0,
            y: (s = (l = r.props.coordinate) === null || l === void 0 ? void 0 : l.y) !== null && s !== void 0 ? s : 0
          }
        });
      }
    }), r;
  }
  return x6e(t, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        (Math.abs(n.width - this.state.lastBoundingBox.width) > L7 || Math.abs(n.height - this.state.lastBoundingBox.height) > L7) && this.setState({
          lastBoundingBox: {
            width: n.width,
            height: n.height
          }
        });
      } else
        (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
          lastBoundingBox: {
            width: -1,
            height: -1
          }
        });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var n, a;
      this.props.active && this.updateBBox(), this.state.dismissed && (((n = this.props.coordinate) === null || n === void 0 ? void 0 : n.x) !== this.state.dismissedAtCoordinate.x || ((a = this.props.coordinate) === null || a === void 0 ? void 0 : a.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.active, o = a.allowEscapeViewBox, u = a.animationDuration, d = a.animationEasing, s = a.children, l = a.coordinate, f = a.hasPayload, c = a.isAnimationActive, h = a.offset, _ = a.position, F = a.reverseDirection, v = a.useTranslate3d, $ = a.viewBox, E = a.wrapperStyle, D = w6e({
        allowEscapeViewBox: o,
        coordinate: l,
        offsetTopLeft: h,
        position: _,
        reverseDirection: F,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: v,
        viewBox: $
      }), w = D.cssClasses, k = D.cssProperties, A = B7(B7({
        transition: c && i ? "transform ".concat(u, "ms ").concat(d) : void 0
      }, k), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && i && f ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, E);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ M.createElement("div", {
          tabIndex: -1,
          className: w,
          style: A,
          ref: function(S) {
            n.wrapperNode = S;
          }
        }, s)
      );
    }
  }]), t;
}(ji), T6e = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, cs = {
  isSsr: T6e(),
  get: function(t) {
    return cs[t];
  },
  set: function(t, r) {
    if (typeof t == "string")
      cs[t] = r;
    else {
      var n = Object.keys(t);
      n && n.length && n.forEach(function(a) {
        cs[a] = t[a];
      });
    }
  }
};
function Uu(e) {
  return Uu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Uu(e);
}
function q7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function U7(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? q7(Object(r), !0).forEach(function(n) {
      x4(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : q7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function P6e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function G7(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, fO(n.key), n);
  }
}
function I6e(e, t, r) {
  return t && G7(e.prototype, t), r && G7(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function R6e(e, t, r) {
  return t = S0(t), j6e(e, lO() ? Reflect.construct(t, r || [], S0(e).constructor) : t.apply(e, r));
}
function j6e(e, t) {
  if (t && (Uu(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return M6e(e);
}
function M6e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function lO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (lO = function() {
    return !!e;
  })();
}
function S0(e) {
  return S0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, S0(e);
}
function B6e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ep(e, t);
}
function Ep(e, t) {
  return Ep = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Ep(e, t);
}
function x4(e, t, r) {
  return t = fO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function fO(e) {
  var t = N6e(e, "string");
  return Uu(t) == "symbol" ? t : String(t);
}
function N6e(e, t) {
  if (Uu(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Uu(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function L6e(e) {
  return e.dataKey;
}
function q6e(e, t) {
  return /* @__PURE__ */ M.isValidElement(e) ? /* @__PURE__ */ M.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ M.createElement(e, t) : /* @__PURE__ */ M.createElement(F6e, t);
}
var Fi = /* @__PURE__ */ function(e) {
  B6e(t, e);
  function t() {
    return P6e(this, t), R6e(this, t, arguments);
  }
  return I6e(t, [{
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.active, o = a.allowEscapeViewBox, u = a.animationDuration, d = a.animationEasing, s = a.content, l = a.coordinate, f = a.filterNull, c = a.isAnimationActive, h = a.offset, _ = a.payload, F = a.payloadUniqBy, v = a.position, $ = a.reverseDirection, E = a.useTranslate3d, D = a.viewBox, w = a.wrapperStyle, k = _ ?? [];
      f && k.length && (k = JA(_.filter(function(P) {
        return P.value != null && (P.hide !== !0 || n.props.includeHidden);
      }), F, L6e));
      var A = k.length > 0;
      return /* @__PURE__ */ M.createElement(O6e, {
        allowEscapeViewBox: o,
        animationDuration: u,
        animationEasing: d,
        isAnimationActive: c,
        active: i,
        coordinate: l,
        hasPayload: A,
        offset: h,
        position: v,
        reverseDirection: $,
        useTranslate3d: E,
        viewBox: D,
        wrapperStyle: w
      }, q6e(s, U7(U7({}, this.props), {}, {
        payload: k
      })));
    }
  }]), t;
}(ji);
x4(Fi, "displayName", "Tooltip");
x4(Fi, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !cs.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var U6e = Za, G6e = function() {
  return U6e.Date.now();
}, W6e = G6e, V6e = /\s/;
function H6e(e) {
  for (var t = e.length; t-- && V6e.test(e.charAt(t)); )
    ;
  return t;
}
var z6e = H6e, K6e = z6e, Y6e = /^\s+/;
function X6e(e) {
  return e && e.slice(0, K6e(e) + 1).replace(Y6e, "");
}
var Q6e = X6e, Z6e = Q6e, W7 = Dn, J6e = hd, V7 = 0 / 0, e9e = /^[-+]0x[0-9a-f]+$/i, t9e = /^0b[01]+$/i, r9e = /^0o[0-7]+$/i, n9e = parseInt;
function a9e(e) {
  if (typeof e == "number")
    return e;
  if (J6e(e))
    return V7;
  if (W7(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = W7(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Z6e(e);
  var r = t9e.test(e);
  return r || r9e.test(e) ? n9e(e.slice(2), r ? 2 : 8) : e9e.test(e) ? V7 : +e;
}
var cO = a9e, i9e = Dn, E2 = W6e, H7 = cO, o9e = "Expected a function", s9e = Math.max, u9e = Math.min;
function d9e(e, t, r) {
  var n, a, i, o, u, d, s = 0, l = !1, f = !1, c = !0;
  if (typeof e != "function")
    throw new TypeError(o9e);
  t = H7(t) || 0, i9e(r) && (l = !!r.leading, f = "maxWait" in r, i = f ? s9e(H7(r.maxWait) || 0, t) : i, c = "trailing" in r ? !!r.trailing : c);
  function h(A) {
    var P = n, S = a;
    return n = a = void 0, s = A, o = e.apply(S, P), o;
  }
  function _(A) {
    return s = A, u = setTimeout($, t), l ? h(A) : o;
  }
  function F(A) {
    var P = A - d, S = A - s, N = t - P;
    return f ? u9e(N, i - S) : N;
  }
  function v(A) {
    var P = A - d, S = A - s;
    return d === void 0 || P >= t || P < 0 || f && S >= i;
  }
  function $() {
    var A = E2();
    if (v(A))
      return E(A);
    u = setTimeout($, F(A));
  }
  function E(A) {
    return u = void 0, c && n ? h(A) : (n = a = void 0, o);
  }
  function D() {
    u !== void 0 && clearTimeout(u), s = 0, n = d = a = u = void 0;
  }
  function w() {
    return u === void 0 ? o : E(E2());
  }
  function k() {
    var A = E2(), P = v(A);
    if (n = arguments, a = this, d = A, P) {
      if (u === void 0)
        return _(d);
      if (f)
        return clearTimeout(u), u = setTimeout($, t), h(d);
    }
    return u === void 0 && (u = setTimeout($, t)), o;
  }
  return k.cancel = D, k.flush = w, k;
}
var l9e = d9e, f9e = l9e, c9e = Dn, h9e = "Expected a function";
function g9e(e, t, r) {
  var n = !0, a = !0;
  if (typeof e != "function")
    throw new TypeError(h9e);
  return c9e(r) && (n = "leading" in r ? !!r.leading : n, a = "trailing" in r ? !!r.trailing : a), f9e(e, t, {
    leading: n,
    maxWait: t,
    trailing: a
  });
}
var hO = g9e;
function Kl(e) {
  return Kl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Kl(e);
}
function z7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function h1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? z7(Object(r), !0).forEach(function(n) {
      _9e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : z7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function _9e(e, t, r) {
  return t = m9e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function m9e(e) {
  var t = p9e(e, "string");
  return Kl(t) == "symbol" ? t : String(t);
}
function p9e(e, t) {
  if (Kl(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Kl(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function F9e(e, t) {
  return E9e(e) || v9e(e, t) || b9e(e, t) || y9e();
}
function y9e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function b9e(e, t) {
  if (e) {
    if (typeof e == "string")
      return K7(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return K7(e, t);
  }
}
function K7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function v9e(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], d = !0, s = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        d = !1;
      } else
        for (; !(d = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); d = !0)
          ;
    } catch (l) {
      s = !0, a = l;
    } finally {
      try {
        if (!d && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (s)
          throw a;
      }
    }
    return u;
  }
}
function E9e(e) {
  if (Array.isArray(e))
    return e;
}
var gO = /* @__PURE__ */ Xn(function(e, t) {
  var r = e.aspect, n = e.initialDimension, a = n === void 0 ? {
    width: -1,
    height: -1
  } : n, i = e.width, o = i === void 0 ? "100%" : i, u = e.height, d = u === void 0 ? "100%" : u, s = e.minWidth, l = s === void 0 ? 0 : s, f = e.minHeight, c = e.maxHeight, h = e.children, _ = e.debounce, F = _ === void 0 ? 0 : _, v = e.id, $ = e.className, E = e.onResize, D = e.style, w = D === void 0 ? {} : D, k = tt(null), A = tt();
  A.current = E, Tw(t, function() {
    return Object.defineProperty(k.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), k.current;
      },
      configurable: !0
    });
  });
  var P = Xe({
    containerWidth: a.width,
    containerHeight: a.height
  }), S = F9e(P, 2), N = S[0], W = S[1], V = ue(function(U, j) {
    W(function(G) {
      var H = Math.round(U), J = Math.round(j);
      return G.containerWidth === H && G.containerHeight === J ? G : {
        containerWidth: H,
        containerHeight: J
      };
    });
  }, []);
  at(function() {
    var U = function(de) {
      var te, ee = de[0].contentRect, ge = ee.width, De = ee.height;
      V(ge, De), (te = A.current) === null || te === void 0 || te.call(A, ge, De);
    };
    F > 0 && (U = hO(U, F, {
      trailing: !0,
      leading: !1
    }));
    var j = new ResizeObserver(U), G = k.current.getBoundingClientRect(), H = G.width, J = G.height;
    return V(H, J), j.observe(k.current), function() {
      j.disconnect();
    };
  }, [V, F]);
  var K = qe(function() {
    var U = N.containerWidth, j = N.containerHeight;
    if (U < 0 || j < 0)
      return null;
    Ci(ss(o) || ss(d), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, o, d), Ci(!r || r > 0, "The aspect(%s) must be greater than zero.", r);
    var G = ss(o) ? U : o, H = ss(d) ? j : d;
    r && r > 0 && (G ? H = G / r : H && (G = H * r), c && H > c && (H = c)), Ci(G > 0 || H > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, G, H, o, d, l, f, r);
    var J = !Array.isArray(h) && Ym.isElement(h) && Di(h.type).endsWith("Chart");
    return M.Children.map(h, function(ae) {
      return Ym.isElement(ae) ? /* @__PURE__ */ gr(ae, h1({
        width: G,
        height: H
      }, J ? {
        style: h1({
          height: "100%",
          width: "100%",
          maxHeight: H,
          maxWidth: G
        }, ae.props.style)
      } : {})) : ae;
    });
  }, [r, h, d, c, f, l, N, o]);
  return /* @__PURE__ */ M.createElement("div", {
    id: v ? "".concat(v) : void 0,
    className: Ct("recharts-responsive-container", $),
    style: h1(h1({}, w), {}, {
      width: o,
      height: d,
      minWidth: l,
      minHeight: f,
      maxHeight: c
    }),
    ref: k
  }, K);
}), A0 = function(t) {
  return null;
};
A0.displayName = "Cell";
function Yl(e) {
  return Yl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yl(e);
}
function Y7(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $p(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Y7(Object(r), !0).forEach(function(n) {
      $9e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Y7(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function $9e(e, t, r) {
  return t = w9e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function w9e(e) {
  var t = k9e(e, "string");
  return Yl(t) == "symbol" ? t : String(t);
}
function k9e(e, t) {
  if (Yl(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Yl(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var uu = {
  widthCache: {},
  cacheCount: 0
}, x9e = 2e3, D9e = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, X7 = "recharts_measurement_span";
function C9e(e) {
  var t = $p({}, e);
  return Object.keys(t).forEach(function(r) {
    t[r] || delete t[r];
  }), t;
}
var Q7 = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || cs.isSsr)
    return {
      width: 0,
      height: 0
    };
  var n = C9e(r), a = JSON.stringify({
    text: t,
    copyStyle: n
  });
  if (uu.widthCache[a])
    return uu.widthCache[a];
  try {
    var i = document.getElementById(X7);
    i || (i = document.createElement("span"), i.setAttribute("id", X7), i.setAttribute("aria-hidden", "true"), document.body.appendChild(i));
    var o = $p($p({}, D9e), n);
    Object.assign(i.style, o), i.textContent = "".concat(t);
    var u = i.getBoundingClientRect(), d = {
      width: u.width,
      height: u.height
    };
    return uu.widthCache[a] = d, ++uu.cacheCount > x9e && (uu.cacheCount = 0, uu.widthCache = {}), d;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, S9e = function(t) {
  return {
    top: t.top + window.scrollY - document.documentElement.clientTop,
    left: t.left + window.scrollX - document.documentElement.clientLeft
  };
};
function Xl(e) {
  return Xl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xl(e);
}
function O0(e, t) {
  return P9e(e) || T9e(e, t) || O9e(e, t) || A9e();
}
function A9e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function O9e(e, t) {
  if (e) {
    if (typeof e == "string")
      return Z7(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Z7(e, t);
  }
}
function Z7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function T9e(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], d = !0, s = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        d = !1;
      } else
        for (; !(d = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); d = !0)
          ;
    } catch (l) {
      s = !0, a = l;
    } finally {
      try {
        if (!d && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (s)
          throw a;
      }
    }
    return u;
  }
}
function P9e(e) {
  if (Array.isArray(e))
    return e;
}
function I9e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function J7(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, j9e(n.key), n);
  }
}
function R9e(e, t, r) {
  return t && J7(e.prototype, t), r && J7(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function j9e(e) {
  var t = M9e(e, "string");
  return Xl(t) == "symbol" ? t : String(t);
}
function M9e(e, t) {
  if (Xl(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Xl(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var eE = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, tE = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, B9e = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, N9e = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, _O = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, L9e = Object.keys(_O), Fu = "NaN";
function q9e(e, t) {
  return e * _O[t];
}
var g1 = /* @__PURE__ */ function() {
  function e(t, r) {
    I9e(this, e), this.num = t, this.unit = r, this.num = t, this.unit = r, Number.isNaN(t) && (this.unit = ""), r !== "" && !B9e.test(r) && (this.num = NaN, this.unit = ""), L9e.includes(r) && (this.num = q9e(t, r), this.unit = "px");
  }
  return R9e(e, [{
    key: "add",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num + r.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num - r.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num * r.num, this.unit || r.unit);
    }
  }, {
    key: "divide",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num / r.num, this.unit || r.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(r) {
      var n, a = (n = N9e.exec(r)) !== null && n !== void 0 ? n : [], i = O0(a, 3), o = i[1], u = i[2];
      return new e(parseFloat(o), u ?? "");
    }
  }]), e;
}();
function mO(e) {
  if (e.includes(Fu))
    return Fu;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var r, n = (r = eE.exec(t)) !== null && r !== void 0 ? r : [], a = O0(n, 4), i = a[1], o = a[2], u = a[3], d = g1.parse(i ?? ""), s = g1.parse(u ?? ""), l = o === "*" ? d.multiply(s) : d.divide(s);
    if (l.isNaN())
      return Fu;
    t = t.replace(eE, l.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var f, c = (f = tE.exec(t)) !== null && f !== void 0 ? f : [], h = O0(c, 4), _ = h[1], F = h[2], v = h[3], $ = g1.parse(_ ?? ""), E = g1.parse(v ?? ""), D = F === "+" ? $.add(E) : $.subtract(E);
    if (D.isNaN())
      return Fu;
    t = t.replace(tE, D.toString());
  }
  return t;
}
var rE = /\(([^()]*)\)/;
function U9e(e) {
  for (var t = e; t.includes("("); ) {
    var r = rE.exec(t), n = O0(r, 2), a = n[1];
    t = t.replace(rE, mO(a));
  }
  return t;
}
function G9e(e) {
  var t = e.replace(/\s+/g, "");
  return t = U9e(t), t = mO(t), t;
}
function W9e(e) {
  try {
    return G9e(e);
  } catch {
    return Fu;
  }
}
function $2(e) {
  var t = W9e(e.slice(5, -1));
  return t === Fu ? "" : t;
}
var V9e = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], H9e = ["dx", "dy", "angle", "className", "breakAll"];
function wp() {
  return wp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wp.apply(this, arguments);
}
function nE(e, t) {
  if (e == null)
    return {};
  var r = z9e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function z9e(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function aE(e, t) {
  return Q9e(e) || X9e(e, t) || Y9e(e, t) || K9e();
}
function K9e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Y9e(e, t) {
  if (e) {
    if (typeof e == "string")
      return iE(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return iE(e, t);
  }
}
function iE(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function X9e(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], d = !0, s = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        d = !1;
      } else
        for (; !(d = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); d = !0)
          ;
    } catch (l) {
      s = !0, a = l;
    } finally {
      try {
        if (!d && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (s)
          throw a;
      }
    }
    return u;
  }
}
function Q9e(e) {
  if (Array.isArray(e))
    return e;
}
var pO = /[ \f\n\r\t\v\u2028\u2029]+/, FO = function(t) {
  var r = t.children, n = t.breakAll, a = t.style;
  try {
    var i = [];
    wt(r) || (n ? i = r.toString().split("") : i = r.toString().split(pO));
    var o = i.map(function(d) {
      return {
        word: d,
        width: Q7(d, a).width
      };
    }), u = n ? 0 : Q7(" ", a).width;
    return {
      wordsWithComputedWidth: o,
      spaceWidth: u
    };
  } catch {
    return null;
  }
}, Z9e = function(t, r, n, a, i) {
  var o = t.maxLines, u = t.children, d = t.style, s = t.breakAll, l = Ve(o), f = u, c = function() {
    var G = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return G.reduce(function(H, J) {
      var ae = J.word, de = J.width, te = H[H.length - 1];
      if (te && (a == null || i || te.width + de + n < Number(a)))
        te.words.push(ae), te.width += de + n;
      else {
        var ee = {
          words: [ae],
          width: de
        };
        H.push(ee);
      }
      return H;
    }, []);
  }, h = c(r), _ = function(G) {
    return G.reduce(function(H, J) {
      return H.width > J.width ? H : J;
    });
  };
  if (!l)
    return h;
  for (var F = "…", v = function(G) {
    var H = f.slice(0, G), J = FO({
      breakAll: s,
      style: d,
      children: H + F
    }).wordsWithComputedWidth, ae = c(J), de = ae.length > o || _(ae).width > Number(a);
    return [de, ae];
  }, $ = 0, E = f.length - 1, D = 0, w; $ <= E && D <= f.length - 1; ) {
    var k = Math.floor(($ + E) / 2), A = k - 1, P = v(A), S = aE(P, 2), N = S[0], W = S[1], V = v(k), K = aE(V, 1), U = K[0];
    if (!N && !U && ($ = k + 1), N && U && (E = k - 1), !N && U) {
      w = W;
      break;
    }
    D++;
  }
  return w || h;
}, oE = function(t) {
  var r = wt(t) ? [] : t.toString().split(pO);
  return [{
    words: r
  }];
}, J9e = function(t) {
  var r = t.width, n = t.scaleToFit, a = t.children, i = t.style, o = t.breakAll, u = t.maxLines;
  if ((r || n) && !cs.isSsr) {
    var d, s, l = FO({
      breakAll: o,
      children: a,
      style: i
    });
    if (l) {
      var f = l.wordsWithComputedWidth, c = l.spaceWidth;
      d = f, s = c;
    } else
      return oE(a);
    return Z9e({
      breakAll: o,
      children: a,
      maxLines: u,
      style: i
    }, d, s, r, n);
  }
  return oE(a);
}, sE = "#808080", Gu = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, a = t.y, i = a === void 0 ? 0 : a, o = t.lineHeight, u = o === void 0 ? "1em" : o, d = t.capHeight, s = d === void 0 ? "0.71em" : d, l = t.scaleToFit, f = l === void 0 ? !1 : l, c = t.textAnchor, h = c === void 0 ? "start" : c, _ = t.verticalAnchor, F = _ === void 0 ? "end" : _, v = t.fill, $ = v === void 0 ? sE : v, E = nE(t, V9e), D = qe(function() {
    return J9e({
      breakAll: E.breakAll,
      children: E.children,
      maxLines: E.maxLines,
      scaleToFit: f,
      style: E.style,
      width: E.width
    });
  }, [E.breakAll, E.children, E.maxLines, f, E.style, E.width]), w = E.dx, k = E.dy, A = E.angle, P = E.className, S = E.breakAll, N = nE(E, H9e);
  if (!$r(n) || !$r(i))
    return null;
  var W = n + (Ve(w) ? w : 0), V = i + (Ve(k) ? k : 0), K;
  switch (F) {
    case "start":
      K = $2("calc(".concat(s, ")"));
      break;
    case "middle":
      K = $2("calc(".concat((D.length - 1) / 2, " * -").concat(u, " + (").concat(s, " / 2))"));
      break;
    default:
      K = $2("calc(".concat(D.length - 1, " * -").concat(u, ")"));
      break;
  }
  var U = [];
  if (f) {
    var j = D[0].width, G = E.width;
    U.push("scale(".concat((Ve(G) ? G / j : 1) / j, ")"));
  }
  return A && U.push("rotate(".concat(A, ", ").concat(W, ", ").concat(V, ")")), U.length && (N.transform = U.join(" ")), /* @__PURE__ */ M.createElement("text", wp({}, _t(N, !0), {
    x: W,
    y: V,
    className: Ct("recharts-text", P),
    textAnchor: h,
    fill: $.includes("url") ? sE : $
  }), D.map(function(H, J) {
    var ae = H.words.join(S ? "" : " ");
    return /* @__PURE__ */ M.createElement("tspan", {
      x: W,
      dy: J === 0 ? K : u,
      key: ae
    }, ae);
  }));
};
function po(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function eve(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function D4(e) {
  let t, r, n;
  e.length !== 2 ? (t = po, r = (u, d) => po(e(u), d), n = (u, d) => e(u) - d) : (t = e === po || e === eve ? e : tve, r = e, n = e);
  function a(u, d, s = 0, l = u.length) {
    if (s < l) {
      if (t(d, d) !== 0)
        return l;
      do {
        const f = s + l >>> 1;
        r(u[f], d) < 0 ? s = f + 1 : l = f;
      } while (s < l);
    }
    return s;
  }
  function i(u, d, s = 0, l = u.length) {
    if (s < l) {
      if (t(d, d) !== 0)
        return l;
      do {
        const f = s + l >>> 1;
        r(u[f], d) <= 0 ? s = f + 1 : l = f;
      } while (s < l);
    }
    return s;
  }
  function o(u, d, s = 0, l = u.length) {
    const f = a(u, d, s, l - 1);
    return f > s && n(u[f - 1], d) > -n(u[f], d) ? f - 1 : f;
  }
  return { left: a, center: o, right: i };
}
function tve() {
  return 0;
}
function yO(e) {
  return e === null ? NaN : +e;
}
function* rve(e, t) {
  if (t === void 0)
    for (let r of e)
      r != null && (r = +r) >= r && (yield r);
  else {
    let r = -1;
    for (let n of e)
      (n = t(n, ++r, e)) != null && (n = +n) >= n && (yield n);
  }
}
const nve = D4(po), ave = nve.right;
D4(yO).center;
const Yf = ave;
class uE extends Map {
  constructor(t, r = sve) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: r } }), t != null)
      for (const [n, a] of t)
        this.set(n, a);
  }
  get(t) {
    return super.get(dE(this, t));
  }
  has(t) {
    return super.has(dE(this, t));
  }
  set(t, r) {
    return super.set(ive(this, t), r);
  }
  delete(t) {
    return super.delete(ove(this, t));
  }
}
function dE({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : r;
}
function ive({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : (e.set(n, r), r);
}
function ove({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) && (r = e.get(n), e.delete(n)), r;
}
function sve(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function uve(e = po) {
  if (e === po)
    return bO;
  if (typeof e != "function")
    throw new TypeError("compare is not a function");
  return (t, r) => {
    const n = e(t, r);
    return n || n === 0 ? n : (e(r, r) === 0) - (e(t, t) === 0);
  };
}
function bO(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const dve = Math.sqrt(50), lve = Math.sqrt(10), fve = Math.sqrt(2);
function T0(e, t, r) {
  const n = (t - e) / Math.max(0, r), a = Math.floor(Math.log10(n)), i = n / Math.pow(10, a), o = i >= dve ? 10 : i >= lve ? 5 : i >= fve ? 2 : 1;
  let u, d, s;
  return a < 0 ? (s = Math.pow(10, -a) / o, u = Math.round(e * s), d = Math.round(t * s), u / s < e && ++u, d / s > t && --d, s = -s) : (s = Math.pow(10, a) * o, u = Math.round(e / s), d = Math.round(t / s), u * s < e && ++u, d * s > t && --d), d < u && 0.5 <= r && r < 2 ? T0(e, t, r * 2) : [u, d, s];
}
function kp(e, t, r) {
  if (t = +t, e = +e, r = +r, !(r > 0))
    return [];
  if (e === t)
    return [e];
  const n = t < e, [a, i, o] = n ? T0(t, e, r) : T0(e, t, r);
  if (!(i >= a))
    return [];
  const u = i - a + 1, d = new Array(u);
  if (n)
    if (o < 0)
      for (let s = 0; s < u; ++s)
        d[s] = (i - s) / -o;
    else
      for (let s = 0; s < u; ++s)
        d[s] = (i - s) * o;
  else if (o < 0)
    for (let s = 0; s < u; ++s)
      d[s] = (a + s) / -o;
  else
    for (let s = 0; s < u; ++s)
      d[s] = (a + s) * o;
  return d;
}
function xp(e, t, r) {
  return t = +t, e = +e, r = +r, T0(e, t, r)[2];
}
function Dp(e, t, r) {
  t = +t, e = +e, r = +r;
  const n = t < e, a = n ? xp(t, e, r) : xp(e, t, r);
  return (n ? -1 : 1) * (a < 0 ? 1 / -a : a);
}
function lE(e, t) {
  let r;
  if (t === void 0)
    for (const n of e)
      n != null && (r < n || r === void 0 && n >= n) && (r = n);
  else {
    let n = -1;
    for (let a of e)
      (a = t(a, ++n, e)) != null && (r < a || r === void 0 && a >= a) && (r = a);
  }
  return r;
}
function fE(e, t) {
  let r;
  if (t === void 0)
    for (const n of e)
      n != null && (r > n || r === void 0 && n >= n) && (r = n);
  else {
    let n = -1;
    for (let a of e)
      (a = t(a, ++n, e)) != null && (r > a || r === void 0 && a >= a) && (r = a);
  }
  return r;
}
function vO(e, t, r = 0, n = 1 / 0, a) {
  if (t = Math.floor(t), r = Math.floor(Math.max(0, r)), n = Math.floor(Math.min(e.length - 1, n)), !(r <= t && t <= n))
    return e;
  for (a = a === void 0 ? bO : uve(a); n > r; ) {
    if (n - r > 600) {
      const d = n - r + 1, s = t - r + 1, l = Math.log(d), f = 0.5 * Math.exp(2 * l / 3), c = 0.5 * Math.sqrt(l * f * (d - f) / d) * (s - d / 2 < 0 ? -1 : 1), h = Math.max(r, Math.floor(t - s * f / d + c)), _ = Math.min(n, Math.floor(t + (d - s) * f / d + c));
      vO(e, t, h, _, a);
    }
    const i = e[t];
    let o = r, u = n;
    for (Xd(e, r, t), a(e[n], i) > 0 && Xd(e, r, n); o < u; ) {
      for (Xd(e, o, u), ++o, --u; a(e[o], i) < 0; )
        ++o;
      for (; a(e[u], i) > 0; )
        --u;
    }
    a(e[r], i) === 0 ? Xd(e, r, u) : (++u, Xd(e, u, n)), u <= t && (r = u + 1), t <= u && (n = u - 1);
  }
  return e;
}
function Xd(e, t, r) {
  const n = e[t];
  e[t] = e[r], e[r] = n;
}
function cve(e, t, r) {
  if (e = Float64Array.from(rve(e, r)), !(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2)
      return fE(e);
    if (t >= 1)
      return lE(e);
    var n, a = (n - 1) * t, i = Math.floor(a), o = lE(vO(e, i).subarray(0, i + 1)), u = fE(e.subarray(i + 1));
    return o + (u - o) * (a - i);
  }
}
function hve(e, t, r = yO) {
  if (!(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2)
      return +r(e[0], 0, e);
    if (t >= 1)
      return +r(e[n - 1], n - 1, e);
    var n, a = (n - 1) * t, i = Math.floor(a), o = +r(e[i], i, e), u = +r(e[i + 1], i + 1, e);
    return o + (u - o) * (a - i);
  }
}
function gve(e, t, r) {
  e = +e, t = +t, r = (a = arguments.length) < 2 ? (t = e, e = 0, 1) : a < 3 ? 1 : +r;
  for (var n = -1, a = Math.max(0, Math.ceil((t - e) / r)) | 0, i = new Array(a); ++n < a; )
    i[n] = e + n * r;
  return i;
}
function Qn(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function qi(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const Cp = Symbol("implicit");
function C4() {
  var e = new uE(), t = [], r = [], n = Cp;
  function a(i) {
    let o = e.get(i);
    if (o === void 0) {
      if (n !== Cp)
        return n;
      e.set(i, o = t.push(i) - 1);
    }
    return r[o % r.length];
  }
  return a.domain = function(i) {
    if (!arguments.length)
      return t.slice();
    t = [], e = new uE();
    for (const o of i)
      e.has(o) || e.set(o, t.push(o) - 1);
    return a;
  }, a.range = function(i) {
    return arguments.length ? (r = Array.from(i), a) : r.slice();
  }, a.unknown = function(i) {
    return arguments.length ? (n = i, a) : n;
  }, a.copy = function() {
    return C4(t, r).unknown(n);
  }, Qn.apply(a, arguments), a;
}
function Ql() {
  var e = C4().unknown(void 0), t = e.domain, r = e.range, n = 0, a = 1, i, o, u = !1, d = 0, s = 0, l = 0.5;
  delete e.unknown;
  function f() {
    var c = t().length, h = a < n, _ = h ? a : n, F = h ? n : a;
    i = (F - _) / Math.max(1, c - d + s * 2), u && (i = Math.floor(i)), _ += (F - _ - i * (c - d)) * l, o = i * (1 - d), u && (_ = Math.round(_), o = Math.round(o));
    var v = gve(c).map(function($) {
      return _ + i * $;
    });
    return r(h ? v.reverse() : v);
  }
  return e.domain = function(c) {
    return arguments.length ? (t(c), f()) : t();
  }, e.range = function(c) {
    return arguments.length ? ([n, a] = c, n = +n, a = +a, f()) : [n, a];
  }, e.rangeRound = function(c) {
    return [n, a] = c, n = +n, a = +a, u = !0, f();
  }, e.bandwidth = function() {
    return o;
  }, e.step = function() {
    return i;
  }, e.round = function(c) {
    return arguments.length ? (u = !!c, f()) : u;
  }, e.padding = function(c) {
    return arguments.length ? (d = Math.min(1, s = +c), f()) : d;
  }, e.paddingInner = function(c) {
    return arguments.length ? (d = Math.min(1, c), f()) : d;
  }, e.paddingOuter = function(c) {
    return arguments.length ? (s = +c, f()) : s;
  }, e.align = function(c) {
    return arguments.length ? (l = Math.max(0, Math.min(1, c)), f()) : l;
  }, e.copy = function() {
    return Ql(t(), [n, a]).round(u).paddingInner(d).paddingOuter(s).align(l);
  }, Qn.apply(f(), arguments);
}
function EO(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return EO(t());
  }, e;
}
function Fl() {
  return EO(Ql.apply(null, arguments).paddingInner(1));
}
function S4(e, t, r) {
  e.prototype = t.prototype = r, r.constructor = e;
}
function $O(e, t) {
  var r = Object.create(e.prototype);
  for (var n in t)
    r[n] = t[n];
  return r;
}
function Xf() {
}
var Zl = 0.7, P0 = 1 / Zl, xu = "\\s*([+-]?\\d+)\\s*", Jl = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Va = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", _ve = /^#([0-9a-f]{3,8})$/, mve = new RegExp(`^rgb\\(${xu},${xu},${xu}\\)$`), pve = new RegExp(`^rgb\\(${Va},${Va},${Va}\\)$`), Fve = new RegExp(`^rgba\\(${xu},${xu},${xu},${Jl}\\)$`), yve = new RegExp(`^rgba\\(${Va},${Va},${Va},${Jl}\\)$`), bve = new RegExp(`^hsl\\(${Jl},${Va},${Va}\\)$`), vve = new RegExp(`^hsla\\(${Jl},${Va},${Va},${Jl}\\)$`), cE = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
S4(Xf, ef, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: hE,
  // Deprecated! Use color.formatHex.
  formatHex: hE,
  formatHex8: Eve,
  formatHsl: $ve,
  formatRgb: gE,
  toString: gE
});
function hE() {
  return this.rgb().formatHex();
}
function Eve() {
  return this.rgb().formatHex8();
}
function $ve() {
  return wO(this).formatHsl();
}
function gE() {
  return this.rgb().formatRgb();
}
function ef(e) {
  var t, r;
  return e = (e + "").trim().toLowerCase(), (t = _ve.exec(e)) ? (r = t[1].length, t = parseInt(t[1], 16), r === 6 ? _E(t) : r === 3 ? new ln(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : r === 8 ? _1(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : r === 4 ? _1(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = mve.exec(e)) ? new ln(t[1], t[2], t[3], 1) : (t = pve.exec(e)) ? new ln(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = Fve.exec(e)) ? _1(t[1], t[2], t[3], t[4]) : (t = yve.exec(e)) ? _1(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = bve.exec(e)) ? FE(t[1], t[2] / 100, t[3] / 100, 1) : (t = vve.exec(e)) ? FE(t[1], t[2] / 100, t[3] / 100, t[4]) : cE.hasOwnProperty(e) ? _E(cE[e]) : e === "transparent" ? new ln(NaN, NaN, NaN, 0) : null;
}
function _E(e) {
  return new ln(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function _1(e, t, r, n) {
  return n <= 0 && (e = t = r = NaN), new ln(e, t, r, n);
}
function wve(e) {
  return e instanceof Xf || (e = ef(e)), e ? (e = e.rgb(), new ln(e.r, e.g, e.b, e.opacity)) : new ln();
}
function Sp(e, t, r, n) {
  return arguments.length === 1 ? wve(e) : new ln(e, t, r, n ?? 1);
}
function ln(e, t, r, n) {
  this.r = +e, this.g = +t, this.b = +r, this.opacity = +n;
}
S4(ln, Sp, $O(Xf, {
  brighter(e) {
    return e = e == null ? P0 : Math.pow(P0, e), new ln(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Zl : Math.pow(Zl, e), new ln(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new ln(hs(this.r), hs(this.g), hs(this.b), I0(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: mE,
  // Deprecated! Use color.formatHex.
  formatHex: mE,
  formatHex8: kve,
  formatRgb: pE,
  toString: pE
}));
function mE() {
  return `#${us(this.r)}${us(this.g)}${us(this.b)}`;
}
function kve() {
  return `#${us(this.r)}${us(this.g)}${us(this.b)}${us((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function pE() {
  const e = I0(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${hs(this.r)}, ${hs(this.g)}, ${hs(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function I0(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function hs(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function us(e) {
  return e = hs(e), (e < 16 ? "0" : "") + e.toString(16);
}
function FE(e, t, r, n) {
  return n <= 0 ? e = t = r = NaN : r <= 0 || r >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new ca(e, t, r, n);
}
function wO(e) {
  if (e instanceof ca)
    return new ca(e.h, e.s, e.l, e.opacity);
  if (e instanceof Xf || (e = ef(e)), !e)
    return new ca();
  if (e instanceof ca)
    return e;
  e = e.rgb();
  var t = e.r / 255, r = e.g / 255, n = e.b / 255, a = Math.min(t, r, n), i = Math.max(t, r, n), o = NaN, u = i - a, d = (i + a) / 2;
  return u ? (t === i ? o = (r - n) / u + (r < n) * 6 : r === i ? o = (n - t) / u + 2 : o = (t - r) / u + 4, u /= d < 0.5 ? i + a : 2 - i - a, o *= 60) : u = d > 0 && d < 1 ? 0 : o, new ca(o, u, d, e.opacity);
}
function xve(e, t, r, n) {
  return arguments.length === 1 ? wO(e) : new ca(e, t, r, n ?? 1);
}
function ca(e, t, r, n) {
  this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
}
S4(ca, xve, $O(Xf, {
  brighter(e) {
    return e = e == null ? P0 : Math.pow(P0, e), new ca(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Zl : Math.pow(Zl, e), new ca(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < 0.5 ? r : 1 - r) * t, a = 2 * r - n;
    return new ln(
      w2(e >= 240 ? e - 240 : e + 120, a, n),
      w2(e, a, n),
      w2(e < 120 ? e + 240 : e - 120, a, n),
      this.opacity
    );
  },
  clamp() {
    return new ca(yE(this.h), m1(this.s), m1(this.l), I0(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = I0(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${yE(this.h)}, ${m1(this.s) * 100}%, ${m1(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function yE(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function m1(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function w2(e, t, r) {
  return (e < 60 ? t + (r - t) * e / 60 : e < 180 ? r : e < 240 ? t + (r - t) * (240 - e) / 60 : t) * 255;
}
const A4 = (e) => () => e;
function Dve(e, t) {
  return function(r) {
    return e + r * t;
  };
}
function Cve(e, t, r) {
  return e = Math.pow(e, r), t = Math.pow(t, r) - e, r = 1 / r, function(n) {
    return Math.pow(e + n * t, r);
  };
}
function Sve(e) {
  return (e = +e) == 1 ? kO : function(t, r) {
    return r - t ? Cve(t, r, e) : A4(isNaN(t) ? r : t);
  };
}
function kO(e, t) {
  var r = t - e;
  return r ? Dve(e, r) : A4(isNaN(e) ? t : e);
}
const bE = function e(t) {
  var r = Sve(t);
  function n(a, i) {
    var o = r((a = Sp(a)).r, (i = Sp(i)).r), u = r(a.g, i.g), d = r(a.b, i.b), s = kO(a.opacity, i.opacity);
    return function(l) {
      return a.r = o(l), a.g = u(l), a.b = d(l), a.opacity = s(l), a + "";
    };
  }
  return n.gamma = e, n;
}(1);
function Ave(e, t) {
  t || (t = []);
  var r = e ? Math.min(t.length, e.length) : 0, n = t.slice(), a;
  return function(i) {
    for (a = 0; a < r; ++a)
      n[a] = e[a] * (1 - i) + t[a] * i;
    return n;
  };
}
function Ove(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function Tve(e, t) {
  var r = t ? t.length : 0, n = e ? Math.min(r, e.length) : 0, a = new Array(n), i = new Array(r), o;
  for (o = 0; o < n; ++o)
    a[o] = bd(e[o], t[o]);
  for (; o < r; ++o)
    i[o] = t[o];
  return function(u) {
    for (o = 0; o < n; ++o)
      i[o] = a[o](u);
    return i;
  };
}
function Pve(e, t) {
  var r = new Date();
  return e = +e, t = +t, function(n) {
    return r.setTime(e * (1 - n) + t * n), r;
  };
}
function R0(e, t) {
  return e = +e, t = +t, function(r) {
    return e * (1 - r) + t * r;
  };
}
function Ive(e, t) {
  var r = {}, n = {}, a;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (a in t)
    a in e ? r[a] = bd(e[a], t[a]) : n[a] = t[a];
  return function(i) {
    for (a in r)
      n[a] = r[a](i);
    return n;
  };
}
var Ap = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, k2 = new RegExp(Ap.source, "g");
function Rve(e) {
  return function() {
    return e;
  };
}
function jve(e) {
  return function(t) {
    return e(t) + "";
  };
}
function Mve(e, t) {
  var r = Ap.lastIndex = k2.lastIndex = 0, n, a, i, o = -1, u = [], d = [];
  for (e = e + "", t = t + ""; (n = Ap.exec(e)) && (a = k2.exec(t)); )
    (i = a.index) > r && (i = t.slice(r, i), u[o] ? u[o] += i : u[++o] = i), (n = n[0]) === (a = a[0]) ? u[o] ? u[o] += a : u[++o] = a : (u[++o] = null, d.push({ i: o, x: R0(n, a) })), r = k2.lastIndex;
  return r < t.length && (i = t.slice(r), u[o] ? u[o] += i : u[++o] = i), u.length < 2 ? d[0] ? jve(d[0].x) : Rve(t) : (t = d.length, function(s) {
    for (var l = 0, f; l < t; ++l)
      u[(f = d[l]).i] = f.x(s);
    return u.join("");
  });
}
function bd(e, t) {
  var r = typeof t, n;
  return t == null || r === "boolean" ? A4(t) : (r === "number" ? R0 : r === "string" ? (n = ef(t)) ? (t = n, bE) : Mve : t instanceof ef ? bE : t instanceof Date ? Pve : Ove(t) ? Ave : Array.isArray(t) ? Tve : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? Ive : R0)(e, t);
}
function O4(e, t) {
  return e = +e, t = +t, function(r) {
    return Math.round(e * (1 - r) + t * r);
  };
}
function Bve(e, t) {
  t === void 0 && (t = e, e = bd);
  for (var r = 0, n = t.length - 1, a = t[0], i = new Array(n < 0 ? 0 : n); r < n; )
    i[r] = e(a, a = t[++r]);
  return function(o) {
    var u = Math.max(0, Math.min(n - 1, Math.floor(o *= n)));
    return i[u](o - u);
  };
}
function Nve(e) {
  return function() {
    return e;
  };
}
function j0(e) {
  return +e;
}
var vE = [0, 1];
function en(e) {
  return e;
}
function Op(e, t) {
  return (t -= e = +e) ? function(r) {
    return (r - e) / t;
  } : Nve(isNaN(t) ? NaN : 0.5);
}
function Lve(e, t) {
  var r;
  return e > t && (r = e, e = t, t = r), function(n) {
    return Math.max(e, Math.min(t, n));
  };
}
function qve(e, t, r) {
  var n = e[0], a = e[1], i = t[0], o = t[1];
  return a < n ? (n = Op(a, n), i = r(o, i)) : (n = Op(n, a), i = r(i, o)), function(u) {
    return i(n(u));
  };
}
function Uve(e, t, r) {
  var n = Math.min(e.length, t.length) - 1, a = new Array(n), i = new Array(n), o = -1;
  for (e[n] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++o < n; )
    a[o] = Op(e[o], e[o + 1]), i[o] = r(t[o], t[o + 1]);
  return function(u) {
    var d = Yf(e, u, 1, n) - 1;
    return i[d](a[d](u));
  };
}
function Qf(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function cg() {
  var e = vE, t = vE, r = bd, n, a, i, o = en, u, d, s;
  function l() {
    var c = Math.min(e.length, t.length);
    return o !== en && (o = Lve(e[0], e[c - 1])), u = c > 2 ? Uve : qve, d = s = null, f;
  }
  function f(c) {
    return c == null || isNaN(c = +c) ? i : (d || (d = u(e.map(n), t, r)))(n(o(c)));
  }
  return f.invert = function(c) {
    return o(a((s || (s = u(t, e.map(n), R0)))(c)));
  }, f.domain = function(c) {
    return arguments.length ? (e = Array.from(c, j0), l()) : e.slice();
  }, f.range = function(c) {
    return arguments.length ? (t = Array.from(c), l()) : t.slice();
  }, f.rangeRound = function(c) {
    return t = Array.from(c), r = O4, l();
  }, f.clamp = function(c) {
    return arguments.length ? (o = c ? !0 : en, l()) : o !== en;
  }, f.interpolate = function(c) {
    return arguments.length ? (r = c, l()) : r;
  }, f.unknown = function(c) {
    return arguments.length ? (i = c, f) : i;
  }, function(c, h) {
    return n = c, a = h, l();
  };
}
function T4() {
  return cg()(en, en);
}
function Gve(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function M0(e, t) {
  if ((r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0)
    return null;
  var r, n = e.slice(0, r);
  return [
    n.length > 1 ? n[0] + n.slice(2) : n,
    +e.slice(r + 1)
  ];
}
function Wu(e) {
  return e = M0(Math.abs(e)), e ? e[1] : NaN;
}
function Wve(e, t) {
  return function(r, n) {
    for (var a = r.length, i = [], o = 0, u = e[0], d = 0; a > 0 && u > 0 && (d + u + 1 > n && (u = Math.max(1, n - d)), i.push(r.substring(a -= u, a + u)), !((d += u + 1) > n)); )
      u = e[o = (o + 1) % e.length];
    return i.reverse().join(t);
  };
}
function Vve(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(r) {
      return e[+r];
    });
  };
}
var Hve = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function tf(e) {
  if (!(t = Hve.exec(e)))
    throw new Error("invalid format: " + e);
  var t;
  return new P4({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
tf.prototype = P4.prototype;
function P4(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
P4.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function zve(e) {
  e:
    for (var t = e.length, r = 1, n = -1, a; r < t; ++r)
      switch (e[r]) {
        case ".":
          n = a = r;
          break;
        case "0":
          n === 0 && (n = r), a = r;
          break;
        default:
          if (!+e[r])
            break e;
          n > 0 && (n = 0);
          break;
      }
  return n > 0 ? e.slice(0, n) + e.slice(a + 1) : e;
}
var xO;
function Kve(e, t) {
  var r = M0(e, t);
  if (!r)
    return e + "";
  var n = r[0], a = r[1], i = a - (xO = Math.max(-8, Math.min(8, Math.floor(a / 3))) * 3) + 1, o = n.length;
  return i === o ? n : i > o ? n + new Array(i - o + 1).join("0") : i > 0 ? n.slice(0, i) + "." + n.slice(i) : "0." + new Array(1 - i).join("0") + M0(e, Math.max(0, t + i - 1))[0];
}
function EE(e, t) {
  var r = M0(e, t);
  if (!r)
    return e + "";
  var n = r[0], a = r[1];
  return a < 0 ? "0." + new Array(-a).join("0") + n : n.length > a + 1 ? n.slice(0, a + 1) + "." + n.slice(a + 1) : n + new Array(a - n.length + 2).join("0");
}
const $E = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: Gve,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => EE(e * 100, t),
  r: EE,
  s: Kve,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function wE(e) {
  return e;
}
var kE = Array.prototype.map, xE = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function Yve(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? wE : Wve(kE.call(e.grouping, Number), e.thousands + ""), r = e.currency === void 0 ? "" : e.currency[0] + "", n = e.currency === void 0 ? "" : e.currency[1] + "", a = e.decimal === void 0 ? "." : e.decimal + "", i = e.numerals === void 0 ? wE : Vve(kE.call(e.numerals, String)), o = e.percent === void 0 ? "%" : e.percent + "", u = e.minus === void 0 ? "−" : e.minus + "", d = e.nan === void 0 ? "NaN" : e.nan + "";
  function s(f) {
    f = tf(f);
    var c = f.fill, h = f.align, _ = f.sign, F = f.symbol, v = f.zero, $ = f.width, E = f.comma, D = f.precision, w = f.trim, k = f.type;
    k === "n" ? (E = !0, k = "g") : $E[k] || (D === void 0 && (D = 12), w = !0, k = "g"), (v || c === "0" && h === "=") && (v = !0, c = "0", h = "=");
    var A = F === "$" ? r : F === "#" && /[boxX]/.test(k) ? "0" + k.toLowerCase() : "", P = F === "$" ? n : /[%p]/.test(k) ? o : "", S = $E[k], N = /[defgprs%]/.test(k);
    D = D === void 0 ? 6 : /[gprs]/.test(k) ? Math.max(1, Math.min(21, D)) : Math.max(0, Math.min(20, D));
    function W(V) {
      var K = A, U = P, j, G, H;
      if (k === "c")
        U = S(V) + U, V = "";
      else {
        V = +V;
        var J = V < 0 || 1 / V < 0;
        if (V = isNaN(V) ? d : S(Math.abs(V), D), w && (V = zve(V)), J && +V == 0 && _ !== "+" && (J = !1), K = (J ? _ === "(" ? _ : u : _ === "-" || _ === "(" ? "" : _) + K, U = (k === "s" ? xE[8 + xO / 3] : "") + U + (J && _ === "(" ? ")" : ""), N) {
          for (j = -1, G = V.length; ++j < G; )
            if (H = V.charCodeAt(j), 48 > H || H > 57) {
              U = (H === 46 ? a + V.slice(j + 1) : V.slice(j)) + U, V = V.slice(0, j);
              break;
            }
        }
      }
      E && !v && (V = t(V, 1 / 0));
      var ae = K.length + V.length + U.length, de = ae < $ ? new Array($ - ae + 1).join(c) : "";
      switch (E && v && (V = t(de + V, de.length ? $ - U.length : 1 / 0), de = ""), h) {
        case "<":
          V = K + V + U + de;
          break;
        case "=":
          V = K + de + V + U;
          break;
        case "^":
          V = de.slice(0, ae = de.length >> 1) + K + V + U + de.slice(ae);
          break;
        default:
          V = de + K + V + U;
          break;
      }
      return i(V);
    }
    return W.toString = function() {
      return f + "";
    }, W;
  }
  function l(f, c) {
    var h = s((f = tf(f), f.type = "f", f)), _ = Math.max(-8, Math.min(8, Math.floor(Wu(c) / 3))) * 3, F = Math.pow(10, -_), v = xE[8 + _ / 3];
    return function($) {
      return h(F * $) + v;
    };
  }
  return {
    format: s,
    formatPrefix: l
  };
}
var p1, I4, DO;
Xve({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function Xve(e) {
  return p1 = Yve(e), I4 = p1.format, DO = p1.formatPrefix, p1;
}
function Qve(e) {
  return Math.max(0, -Wu(Math.abs(e)));
}
function Zve(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Wu(t) / 3))) * 3 - Wu(Math.abs(e)));
}
function Jve(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, Wu(t) - Wu(e)) + 1;
}
function CO(e, t, r, n) {
  var a = Dp(e, t, r), i;
  switch (n = tf(n ?? ",f"), n.type) {
    case "s": {
      var o = Math.max(Math.abs(e), Math.abs(t));
      return n.precision == null && !isNaN(i = Zve(a, o)) && (n.precision = i), DO(n, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(i = Jve(a, Math.max(Math.abs(e), Math.abs(t)))) && (n.precision = i - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(i = Qve(a)) && (n.precision = i - (n.type === "%") * 2);
      break;
    }
  }
  return I4(n);
}
function Co(e) {
  var t = e.domain;
  return e.ticks = function(r) {
    var n = t();
    return kp(n[0], n[n.length - 1], r ?? 10);
  }, e.tickFormat = function(r, n) {
    var a = t();
    return CO(a[0], a[a.length - 1], r ?? 10, n);
  }, e.nice = function(r) {
    r == null && (r = 10);
    var n = t(), a = 0, i = n.length - 1, o = n[a], u = n[i], d, s, l = 10;
    for (u < o && (s = o, o = u, u = s, s = a, a = i, i = s); l-- > 0; ) {
      if (s = xp(o, u, r), s === d)
        return n[a] = o, n[i] = u, t(n);
      if (s > 0)
        o = Math.floor(o / s) * s, u = Math.ceil(u / s) * s;
      else if (s < 0)
        o = Math.ceil(o * s) / s, u = Math.floor(u * s) / s;
      else
        break;
      d = s;
    }
    return e;
  }, e;
}
function B0() {
  var e = T4();
  return e.copy = function() {
    return Qf(e, B0());
  }, Qn.apply(e, arguments), Co(e);
}
function SO(e) {
  var t;
  function r(n) {
    return n == null || isNaN(n = +n) ? t : n;
  }
  return r.invert = r, r.domain = r.range = function(n) {
    return arguments.length ? (e = Array.from(n, j0), r) : e.slice();
  }, r.unknown = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.copy = function() {
    return SO(e).unknown(t);
  }, e = arguments.length ? Array.from(e, j0) : [0, 1], Co(r);
}
function AO(e, t) {
  e = e.slice();
  var r = 0, n = e.length - 1, a = e[r], i = e[n], o;
  return i < a && (o = r, r = n, n = o, o = a, a = i, i = o), e[r] = t.floor(a), e[n] = t.ceil(i), e;
}
function DE(e) {
  return Math.log(e);
}
function CE(e) {
  return Math.exp(e);
}
function e5e(e) {
  return -Math.log(-e);
}
function t5e(e) {
  return -Math.exp(-e);
}
function r5e(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function n5e(e) {
  return e === 10 ? r5e : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function a5e(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function SE(e) {
  return (t, r) => -e(-t, r);
}
function R4(e) {
  const t = e(DE, CE), r = t.domain;
  let n = 10, a, i;
  function o() {
    return a = a5e(n), i = n5e(n), r()[0] < 0 ? (a = SE(a), i = SE(i), e(e5e, t5e)) : e(DE, CE), t;
  }
  return t.base = function(u) {
    return arguments.length ? (n = +u, o()) : n;
  }, t.domain = function(u) {
    return arguments.length ? (r(u), o()) : r();
  }, t.ticks = (u) => {
    const d = r();
    let s = d[0], l = d[d.length - 1];
    const f = l < s;
    f && ([s, l] = [l, s]);
    let c = a(s), h = a(l), _, F;
    const v = u == null ? 10 : +u;
    let $ = [];
    if (!(n % 1) && h - c < v) {
      if (c = Math.floor(c), h = Math.ceil(h), s > 0) {
        for (; c <= h; ++c)
          for (_ = 1; _ < n; ++_)
            if (F = c < 0 ? _ / i(-c) : _ * i(c), !(F < s)) {
              if (F > l)
                break;
              $.push(F);
            }
      } else
        for (; c <= h; ++c)
          for (_ = n - 1; _ >= 1; --_)
            if (F = c > 0 ? _ / i(-c) : _ * i(c), !(F < s)) {
              if (F > l)
                break;
              $.push(F);
            }
      $.length * 2 < v && ($ = kp(s, l, v));
    } else
      $ = kp(c, h, Math.min(h - c, v)).map(i);
    return f ? $.reverse() : $;
  }, t.tickFormat = (u, d) => {
    if (u == null && (u = 10), d == null && (d = n === 10 ? "s" : ","), typeof d != "function" && (!(n % 1) && (d = tf(d)).precision == null && (d.trim = !0), d = I4(d)), u === 1 / 0)
      return d;
    const s = Math.max(1, n * u / t.ticks().length);
    return (l) => {
      let f = l / i(Math.round(a(l)));
      return f * n < n - 0.5 && (f *= n), f <= s ? d(l) : "";
    };
  }, t.nice = () => r(AO(r(), {
    floor: (u) => i(Math.floor(a(u))),
    ceil: (u) => i(Math.ceil(a(u)))
  })), t;
}
function OO() {
  const e = R4(cg()).domain([1, 10]);
  return e.copy = () => Qf(e, OO()).base(e.base()), Qn.apply(e, arguments), e;
}
function AE(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function OE(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function j4(e) {
  var t = 1, r = e(AE(t), OE(t));
  return r.constant = function(n) {
    return arguments.length ? e(AE(t = +n), OE(t)) : t;
  }, Co(r);
}
function TO() {
  var e = j4(cg());
  return e.copy = function() {
    return Qf(e, TO()).constant(e.constant());
  }, Qn.apply(e, arguments);
}
function TE(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function i5e(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function o5e(e) {
  return e < 0 ? -e * e : e * e;
}
function M4(e) {
  var t = e(en, en), r = 1;
  function n() {
    return r === 1 ? e(en, en) : r === 0.5 ? e(i5e, o5e) : e(TE(r), TE(1 / r));
  }
  return t.exponent = function(a) {
    return arguments.length ? (r = +a, n()) : r;
  }, Co(t);
}
function B4() {
  var e = M4(cg());
  return e.copy = function() {
    return Qf(e, B4()).exponent(e.exponent());
  }, Qn.apply(e, arguments), e;
}
function s5e() {
  return B4.apply(null, arguments).exponent(0.5);
}
function PE(e) {
  return Math.sign(e) * e * e;
}
function u5e(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function PO() {
  var e = T4(), t = [0, 1], r = !1, n;
  function a(i) {
    var o = u5e(e(i));
    return isNaN(o) ? n : r ? Math.round(o) : o;
  }
  return a.invert = function(i) {
    return e.invert(PE(i));
  }, a.domain = function(i) {
    return arguments.length ? (e.domain(i), a) : e.domain();
  }, a.range = function(i) {
    return arguments.length ? (e.range((t = Array.from(i, j0)).map(PE)), a) : t.slice();
  }, a.rangeRound = function(i) {
    return a.range(i).round(!0);
  }, a.round = function(i) {
    return arguments.length ? (r = !!i, a) : r;
  }, a.clamp = function(i) {
    return arguments.length ? (e.clamp(i), a) : e.clamp();
  }, a.unknown = function(i) {
    return arguments.length ? (n = i, a) : n;
  }, a.copy = function() {
    return PO(e.domain(), t).round(r).clamp(e.clamp()).unknown(n);
  }, Qn.apply(a, arguments), Co(a);
}
function IO() {
  var e = [], t = [], r = [], n;
  function a() {
    var o = 0, u = Math.max(1, t.length);
    for (r = new Array(u - 1); ++o < u; )
      r[o - 1] = hve(e, o / u);
    return i;
  }
  function i(o) {
    return o == null || isNaN(o = +o) ? n : t[Yf(r, o)];
  }
  return i.invertExtent = function(o) {
    var u = t.indexOf(o);
    return u < 0 ? [NaN, NaN] : [
      u > 0 ? r[u - 1] : e[0],
      u < r.length ? r[u] : e[e.length - 1]
    ];
  }, i.domain = function(o) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (let u of o)
      u != null && !isNaN(u = +u) && e.push(u);
    return e.sort(po), a();
  }, i.range = function(o) {
    return arguments.length ? (t = Array.from(o), a()) : t.slice();
  }, i.unknown = function(o) {
    return arguments.length ? (n = o, i) : n;
  }, i.quantiles = function() {
    return r.slice();
  }, i.copy = function() {
    return IO().domain(e).range(t).unknown(n);
  }, Qn.apply(i, arguments);
}
function RO() {
  var e = 0, t = 1, r = 1, n = [0.5], a = [0, 1], i;
  function o(d) {
    return d != null && d <= d ? a[Yf(n, d, 0, r)] : i;
  }
  function u() {
    var d = -1;
    for (n = new Array(r); ++d < r; )
      n[d] = ((d + 1) * t - (d - r) * e) / (r + 1);
    return o;
  }
  return o.domain = function(d) {
    return arguments.length ? ([e, t] = d, e = +e, t = +t, u()) : [e, t];
  }, o.range = function(d) {
    return arguments.length ? (r = (a = Array.from(d)).length - 1, u()) : a.slice();
  }, o.invertExtent = function(d) {
    var s = a.indexOf(d);
    return s < 0 ? [NaN, NaN] : s < 1 ? [e, n[0]] : s >= r ? [n[r - 1], t] : [n[s - 1], n[s]];
  }, o.unknown = function(d) {
    return arguments.length && (i = d), o;
  }, o.thresholds = function() {
    return n.slice();
  }, o.copy = function() {
    return RO().domain([e, t]).range(a).unknown(i);
  }, Qn.apply(Co(o), arguments);
}
function jO() {
  var e = [0.5], t = [0, 1], r, n = 1;
  function a(i) {
    return i != null && i <= i ? t[Yf(e, i, 0, n)] : r;
  }
  return a.domain = function(i) {
    return arguments.length ? (e = Array.from(i), n = Math.min(e.length, t.length - 1), a) : e.slice();
  }, a.range = function(i) {
    return arguments.length ? (t = Array.from(i), n = Math.min(e.length, t.length - 1), a) : t.slice();
  }, a.invertExtent = function(i) {
    var o = t.indexOf(i);
    return [e[o - 1], e[o]];
  }, a.unknown = function(i) {
    return arguments.length ? (r = i, a) : r;
  }, a.copy = function() {
    return jO().domain(e).range(t).unknown(r);
  }, Qn.apply(a, arguments);
}
const x2 = new Date(), D2 = new Date();
function kr(e, t, r, n) {
  function a(i) {
    return e(i = arguments.length === 0 ? new Date() : new Date(+i)), i;
  }
  return a.floor = (i) => (e(i = new Date(+i)), i), a.ceil = (i) => (e(i = new Date(i - 1)), t(i, 1), e(i), i), a.round = (i) => {
    const o = a(i), u = a.ceil(i);
    return i - o < u - i ? o : u;
  }, a.offset = (i, o) => (t(i = new Date(+i), o == null ? 1 : Math.floor(o)), i), a.range = (i, o, u) => {
    const d = [];
    if (i = a.ceil(i), u = u == null ? 1 : Math.floor(u), !(i < o) || !(u > 0))
      return d;
    let s;
    do
      d.push(s = new Date(+i)), t(i, u), e(i);
    while (s < i && i < o);
    return d;
  }, a.filter = (i) => kr((o) => {
    if (o >= o)
      for (; e(o), !i(o); )
        o.setTime(o - 1);
  }, (o, u) => {
    if (o >= o)
      if (u < 0)
        for (; ++u <= 0; )
          for (; t(o, -1), !i(o); )
            ;
      else
        for (; --u >= 0; )
          for (; t(o, 1), !i(o); )
            ;
  }), r && (a.count = (i, o) => (x2.setTime(+i), D2.setTime(+o), e(x2), e(D2), Math.floor(r(x2, D2))), a.every = (i) => (i = Math.floor(i), !isFinite(i) || !(i > 0) ? null : i > 1 ? a.filter(n ? (o) => n(o) % i === 0 : (o) => a.count(0, o) % i === 0) : a)), a;
}
const N0 = kr(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
N0.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? kr((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, r) => {
  t.setTime(+t + r * e);
}, (t, r) => (r - t) / e) : N0);
N0.range;
const $i = 1e3, Gn = $i * 60, wi = Gn * 60, Pi = wi * 24, N4 = Pi * 7, IE = Pi * 30, C2 = Pi * 365, ds = kr((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * $i);
}, (e, t) => (t - e) / $i, (e) => e.getUTCSeconds());
ds.range;
const L4 = kr((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * $i);
}, (e, t) => {
  e.setTime(+e + t * Gn);
}, (e, t) => (t - e) / Gn, (e) => e.getMinutes());
L4.range;
const q4 = kr((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * Gn);
}, (e, t) => (t - e) / Gn, (e) => e.getUTCMinutes());
q4.range;
const U4 = kr((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * $i - e.getMinutes() * Gn);
}, (e, t) => {
  e.setTime(+e + t * wi);
}, (e, t) => (t - e) / wi, (e) => e.getHours());
U4.range;
const G4 = kr((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * wi);
}, (e, t) => (t - e) / wi, (e) => e.getUTCHours());
G4.range;
const Zf = kr(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * Gn) / Pi,
  (e) => e.getDate() - 1
);
Zf.range;
const hg = kr((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Pi, (e) => e.getUTCDate() - 1);
hg.range;
const MO = kr((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Pi, (e) => Math.floor(e / Pi));
MO.range;
function Rs(e) {
  return kr((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setDate(t.getDate() + r * 7);
  }, (t, r) => (r - t - (r.getTimezoneOffset() - t.getTimezoneOffset()) * Gn) / N4);
}
const gg = Rs(0), L0 = Rs(1), d5e = Rs(2), l5e = Rs(3), Vu = Rs(4), f5e = Rs(5), c5e = Rs(6);
gg.range;
L0.range;
d5e.range;
l5e.range;
Vu.range;
f5e.range;
c5e.range;
function js(e) {
  return kr((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setUTCDate(t.getUTCDate() + r * 7);
  }, (t, r) => (r - t) / N4);
}
const _g = js(0), q0 = js(1), h5e = js(2), g5e = js(3), Hu = js(4), _5e = js(5), m5e = js(6);
_g.range;
q0.range;
h5e.range;
g5e.range;
Hu.range;
_5e.range;
m5e.range;
const W4 = kr((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
W4.range;
const V4 = kr((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
V4.range;
const Ii = kr((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Ii.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : kr((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, r) => {
  t.setFullYear(t.getFullYear() + r * e);
});
Ii.range;
const Ri = kr((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
Ri.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : kr((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, r) => {
  t.setUTCFullYear(t.getUTCFullYear() + r * e);
});
Ri.range;
function BO(e, t, r, n, a, i) {
  const o = [
    [ds, 1, $i],
    [ds, 5, 5 * $i],
    [ds, 15, 15 * $i],
    [ds, 30, 30 * $i],
    [i, 1, Gn],
    [i, 5, 5 * Gn],
    [i, 15, 15 * Gn],
    [i, 30, 30 * Gn],
    [a, 1, wi],
    [a, 3, 3 * wi],
    [a, 6, 6 * wi],
    [a, 12, 12 * wi],
    [n, 1, Pi],
    [n, 2, 2 * Pi],
    [r, 1, N4],
    [t, 1, IE],
    [t, 3, 3 * IE],
    [e, 1, C2]
  ];
  function u(s, l, f) {
    const c = l < s;
    c && ([s, l] = [l, s]);
    const h = f && typeof f.range == "function" ? f : d(s, l, f), _ = h ? h.range(s, +l + 1) : [];
    return c ? _.reverse() : _;
  }
  function d(s, l, f) {
    const c = Math.abs(l - s) / f, h = D4(([, , v]) => v).right(o, c);
    if (h === o.length)
      return e.every(Dp(s / C2, l / C2, f));
    if (h === 0)
      return N0.every(Math.max(Dp(s, l, f), 1));
    const [_, F] = o[c / o[h - 1][2] < o[h][2] / c ? h - 1 : h];
    return _.every(F);
  }
  return [u, d];
}
const [p5e, F5e] = BO(Ri, V4, _g, MO, G4, q4), [y5e, b5e] = BO(Ii, W4, gg, Zf, U4, L4);
function S2(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function A2(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Qd(e, t, r) {
  return { y: e, m: t, d: r, H: 0, M: 0, S: 0, L: 0 };
}
function v5e(e) {
  var t = e.dateTime, r = e.date, n = e.time, a = e.periods, i = e.days, o = e.shortDays, u = e.months, d = e.shortMonths, s = Zd(a), l = Jd(a), f = Zd(i), c = Jd(i), h = Zd(o), _ = Jd(o), F = Zd(u), v = Jd(u), $ = Zd(d), E = Jd(d), D = {
    a: J,
    A: ae,
    b: de,
    B: te,
    c: null,
    d: LE,
    e: LE,
    f: W5e,
    g: e8e,
    G: r8e,
    H: q5e,
    I: U5e,
    j: G5e,
    L: NO,
    m: V5e,
    M: H5e,
    p: ee,
    q: ge,
    Q: GE,
    s: WE,
    S: z5e,
    u: K5e,
    U: Y5e,
    V: X5e,
    w: Q5e,
    W: Z5e,
    x: null,
    X: null,
    y: J5e,
    Y: t8e,
    Z: n8e,
    "%": UE
  }, w = {
    a: De,
    A: xe,
    b: ze,
    B: q,
    c: null,
    d: qE,
    e: qE,
    f: s8e,
    g: p8e,
    G: y8e,
    H: a8e,
    I: i8e,
    j: o8e,
    L: qO,
    m: u8e,
    M: d8e,
    p: Ue,
    q: Ce,
    Q: GE,
    s: WE,
    S: l8e,
    u: f8e,
    U: c8e,
    V: h8e,
    w: g8e,
    W: _8e,
    x: null,
    X: null,
    y: m8e,
    Y: F8e,
    Z: b8e,
    "%": UE
  }, k = {
    a: W,
    A: V,
    b: K,
    B: U,
    c: j,
    d: BE,
    e: BE,
    f: M5e,
    g: ME,
    G: jE,
    H: NE,
    I: NE,
    j: P5e,
    L: j5e,
    m: T5e,
    M: I5e,
    p: N,
    q: O5e,
    Q: N5e,
    s: L5e,
    S: R5e,
    u: x5e,
    U: D5e,
    V: C5e,
    w: k5e,
    W: S5e,
    x: G,
    X: H,
    y: ME,
    Y: jE,
    Z: A5e,
    "%": B5e
  };
  D.x = A(r, D), D.X = A(n, D), D.c = A(t, D), w.x = A(r, w), w.X = A(n, w), w.c = A(t, w);
  function A(me, Fe) {
    return function(ce) {
      var z = [], Me = -1, le = 0, Be = me.length, rt, ve, qt;
      for (ce instanceof Date || (ce = new Date(+ce)); ++Me < Be; )
        me.charCodeAt(Me) === 37 && (z.push(me.slice(le, Me)), (ve = RE[rt = me.charAt(++Me)]) != null ? rt = me.charAt(++Me) : ve = rt === "e" ? " " : "0", (qt = Fe[rt]) && (rt = qt(ce, ve)), z.push(rt), le = Me + 1);
      return z.push(me.slice(le, Me)), z.join("");
    };
  }
  function P(me, Fe) {
    return function(ce) {
      var z = Qd(1900, void 0, 1), Me = S(z, me, ce += "", 0), le, Be;
      if (Me != ce.length)
        return null;
      if ("Q" in z)
        return new Date(z.Q);
      if ("s" in z)
        return new Date(z.s * 1e3 + ("L" in z ? z.L : 0));
      if (Fe && !("Z" in z) && (z.Z = 0), "p" in z && (z.H = z.H % 12 + z.p * 12), z.m === void 0 && (z.m = "q" in z ? z.q : 0), "V" in z) {
        if (z.V < 1 || z.V > 53)
          return null;
        "w" in z || (z.w = 1), "Z" in z ? (le = A2(Qd(z.y, 0, 1)), Be = le.getUTCDay(), le = Be > 4 || Be === 0 ? q0.ceil(le) : q0(le), le = hg.offset(le, (z.V - 1) * 7), z.y = le.getUTCFullYear(), z.m = le.getUTCMonth(), z.d = le.getUTCDate() + (z.w + 6) % 7) : (le = S2(Qd(z.y, 0, 1)), Be = le.getDay(), le = Be > 4 || Be === 0 ? L0.ceil(le) : L0(le), le = Zf.offset(le, (z.V - 1) * 7), z.y = le.getFullYear(), z.m = le.getMonth(), z.d = le.getDate() + (z.w + 6) % 7);
      } else
        ("W" in z || "U" in z) && ("w" in z || (z.w = "u" in z ? z.u % 7 : "W" in z ? 1 : 0), Be = "Z" in z ? A2(Qd(z.y, 0, 1)).getUTCDay() : S2(Qd(z.y, 0, 1)).getDay(), z.m = 0, z.d = "W" in z ? (z.w + 6) % 7 + z.W * 7 - (Be + 5) % 7 : z.w + z.U * 7 - (Be + 6) % 7);
      return "Z" in z ? (z.H += z.Z / 100 | 0, z.M += z.Z % 100, A2(z)) : S2(z);
    };
  }
  function S(me, Fe, ce, z) {
    for (var Me = 0, le = Fe.length, Be = ce.length, rt, ve; Me < le; ) {
      if (z >= Be)
        return -1;
      if (rt = Fe.charCodeAt(Me++), rt === 37) {
        if (rt = Fe.charAt(Me++), ve = k[rt in RE ? Fe.charAt(Me++) : rt], !ve || (z = ve(me, ce, z)) < 0)
          return -1;
      } else if (rt != ce.charCodeAt(z++))
        return -1;
    }
    return z;
  }
  function N(me, Fe, ce) {
    var z = s.exec(Fe.slice(ce));
    return z ? (me.p = l.get(z[0].toLowerCase()), ce + z[0].length) : -1;
  }
  function W(me, Fe, ce) {
    var z = h.exec(Fe.slice(ce));
    return z ? (me.w = _.get(z[0].toLowerCase()), ce + z[0].length) : -1;
  }
  function V(me, Fe, ce) {
    var z = f.exec(Fe.slice(ce));
    return z ? (me.w = c.get(z[0].toLowerCase()), ce + z[0].length) : -1;
  }
  function K(me, Fe, ce) {
    var z = $.exec(Fe.slice(ce));
    return z ? (me.m = E.get(z[0].toLowerCase()), ce + z[0].length) : -1;
  }
  function U(me, Fe, ce) {
    var z = F.exec(Fe.slice(ce));
    return z ? (me.m = v.get(z[0].toLowerCase()), ce + z[0].length) : -1;
  }
  function j(me, Fe, ce) {
    return S(me, t, Fe, ce);
  }
  function G(me, Fe, ce) {
    return S(me, r, Fe, ce);
  }
  function H(me, Fe, ce) {
    return S(me, n, Fe, ce);
  }
  function J(me) {
    return o[me.getDay()];
  }
  function ae(me) {
    return i[me.getDay()];
  }
  function de(me) {
    return d[me.getMonth()];
  }
  function te(me) {
    return u[me.getMonth()];
  }
  function ee(me) {
    return a[+(me.getHours() >= 12)];
  }
  function ge(me) {
    return 1 + ~~(me.getMonth() / 3);
  }
  function De(me) {
    return o[me.getUTCDay()];
  }
  function xe(me) {
    return i[me.getUTCDay()];
  }
  function ze(me) {
    return d[me.getUTCMonth()];
  }
  function q(me) {
    return u[me.getUTCMonth()];
  }
  function Ue(me) {
    return a[+(me.getUTCHours() >= 12)];
  }
  function Ce(me) {
    return 1 + ~~(me.getUTCMonth() / 3);
  }
  return {
    format: function(me) {
      var Fe = A(me += "", D);
      return Fe.toString = function() {
        return me;
      }, Fe;
    },
    parse: function(me) {
      var Fe = P(me += "", !1);
      return Fe.toString = function() {
        return me;
      }, Fe;
    },
    utcFormat: function(me) {
      var Fe = A(me += "", w);
      return Fe.toString = function() {
        return me;
      }, Fe;
    },
    utcParse: function(me) {
      var Fe = P(me += "", !0);
      return Fe.toString = function() {
        return me;
      }, Fe;
    }
  };
}
var RE = { "-": "", _: " ", 0: "0" }, Tr = /^\s*\d+/, E5e = /^%/, $5e = /[\\^$*+?|[\]().{}]/g;
function At(e, t, r) {
  var n = e < 0 ? "-" : "", a = (n ? -e : e) + "", i = a.length;
  return n + (i < r ? new Array(r - i + 1).join(t) + a : a);
}
function w5e(e) {
  return e.replace($5e, "\\$&");
}
function Zd(e) {
  return new RegExp("^(?:" + e.map(w5e).join("|") + ")", "i");
}
function Jd(e) {
  return new Map(e.map((t, r) => [t.toLowerCase(), r]));
}
function k5e(e, t, r) {
  var n = Tr.exec(t.slice(r, r + 1));
  return n ? (e.w = +n[0], r + n[0].length) : -1;
}
function x5e(e, t, r) {
  var n = Tr.exec(t.slice(r, r + 1));
  return n ? (e.u = +n[0], r + n[0].length) : -1;
}
function D5e(e, t, r) {
  var n = Tr.exec(t.slice(r, r + 2));
  return n ? (e.U = +n[0], r + n[0].length) : -1;
}
function C5e(e, t, r) {
  var n = Tr.exec(t.slice(r, r + 2));
  return n ? (e.V = +n[0], r + n[0].length) : -1;
}
function S5e(e, t, r) {
  var n = Tr.exec(t.slice(r, r + 2));
  return n ? (e.W = +n[0], r + n[0].length) : -1;
}
function jE(e, t, r) {
  var n = Tr.exec(t.slice(r, r + 4));
  return n ? (e.y = +n[0], r + n[0].length) : -1;
}
function ME(e, t, r) {
  var n = Tr.exec(t.slice(r, r + 2));
  return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
}
function A5e(e, t, r) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
  return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
}
function O5e(e, t, r) {
  var n = Tr.exec(t.slice(r, r + 1));
  return n ? (e.q = n[0] * 3 - 3, r + n[0].length) : -1;
}
function T5e(e, t, r) {
  var n = Tr.exec(t.slice(r, r + 2));
  return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
}
function BE(e, t, r) {
  var n = Tr.exec(t.slice(r, r + 2));
  return n ? (e.d = +n[0], r + n[0].length) : -1;
}
function P5e(e, t, r) {
  var n = Tr.exec(t.slice(r, r + 3));
  return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
}
function NE(e, t, r) {
  var n = Tr.exec(t.slice(r, r + 2));
  return n ? (e.H = +n[0], r + n[0].length) : -1;
}
function I5e(e, t, r) {
  var n = Tr.exec(t.slice(r, r + 2));
  return n ? (e.M = +n[0], r + n[0].length) : -1;
}
function R5e(e, t, r) {
  var n = Tr.exec(t.slice(r, r + 2));
  return n ? (e.S = +n[0], r + n[0].length) : -1;
}
function j5e(e, t, r) {
  var n = Tr.exec(t.slice(r, r + 3));
  return n ? (e.L = +n[0], r + n[0].length) : -1;
}
function M5e(e, t, r) {
  var n = Tr.exec(t.slice(r, r + 6));
  return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
}
function B5e(e, t, r) {
  var n = E5e.exec(t.slice(r, r + 1));
  return n ? r + n[0].length : -1;
}
function N5e(e, t, r) {
  var n = Tr.exec(t.slice(r));
  return n ? (e.Q = +n[0], r + n[0].length) : -1;
}
function L5e(e, t, r) {
  var n = Tr.exec(t.slice(r));
  return n ? (e.s = +n[0], r + n[0].length) : -1;
}
function LE(e, t) {
  return At(e.getDate(), t, 2);
}
function q5e(e, t) {
  return At(e.getHours(), t, 2);
}
function U5e(e, t) {
  return At(e.getHours() % 12 || 12, t, 2);
}
function G5e(e, t) {
  return At(1 + Zf.count(Ii(e), e), t, 3);
}
function NO(e, t) {
  return At(e.getMilliseconds(), t, 3);
}
function W5e(e, t) {
  return NO(e, t) + "000";
}
function V5e(e, t) {
  return At(e.getMonth() + 1, t, 2);
}
function H5e(e, t) {
  return At(e.getMinutes(), t, 2);
}
function z5e(e, t) {
  return At(e.getSeconds(), t, 2);
}
function K5e(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function Y5e(e, t) {
  return At(gg.count(Ii(e) - 1, e), t, 2);
}
function LO(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? Vu(e) : Vu.ceil(e);
}
function X5e(e, t) {
  return e = LO(e), At(Vu.count(Ii(e), e) + (Ii(e).getDay() === 4), t, 2);
}
function Q5e(e) {
  return e.getDay();
}
function Z5e(e, t) {
  return At(L0.count(Ii(e) - 1, e), t, 2);
}
function J5e(e, t) {
  return At(e.getFullYear() % 100, t, 2);
}
function e8e(e, t) {
  return e = LO(e), At(e.getFullYear() % 100, t, 2);
}
function t8e(e, t) {
  return At(e.getFullYear() % 1e4, t, 4);
}
function r8e(e, t) {
  var r = e.getDay();
  return e = r >= 4 || r === 0 ? Vu(e) : Vu.ceil(e), At(e.getFullYear() % 1e4, t, 4);
}
function n8e(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + At(t / 60 | 0, "0", 2) + At(t % 60, "0", 2);
}
function qE(e, t) {
  return At(e.getUTCDate(), t, 2);
}
function a8e(e, t) {
  return At(e.getUTCHours(), t, 2);
}
function i8e(e, t) {
  return At(e.getUTCHours() % 12 || 12, t, 2);
}
function o8e(e, t) {
  return At(1 + hg.count(Ri(e), e), t, 3);
}
function qO(e, t) {
  return At(e.getUTCMilliseconds(), t, 3);
}
function s8e(e, t) {
  return qO(e, t) + "000";
}
function u8e(e, t) {
  return At(e.getUTCMonth() + 1, t, 2);
}
function d8e(e, t) {
  return At(e.getUTCMinutes(), t, 2);
}
function l8e(e, t) {
  return At(e.getUTCSeconds(), t, 2);
}
function f8e(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function c8e(e, t) {
  return At(_g.count(Ri(e) - 1, e), t, 2);
}
function UO(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? Hu(e) : Hu.ceil(e);
}
function h8e(e, t) {
  return e = UO(e), At(Hu.count(Ri(e), e) + (Ri(e).getUTCDay() === 4), t, 2);
}
function g8e(e) {
  return e.getUTCDay();
}
function _8e(e, t) {
  return At(q0.count(Ri(e) - 1, e), t, 2);
}
function m8e(e, t) {
  return At(e.getUTCFullYear() % 100, t, 2);
}
function p8e(e, t) {
  return e = UO(e), At(e.getUTCFullYear() % 100, t, 2);
}
function F8e(e, t) {
  return At(e.getUTCFullYear() % 1e4, t, 4);
}
function y8e(e, t) {
  var r = e.getUTCDay();
  return e = r >= 4 || r === 0 ? Hu(e) : Hu.ceil(e), At(e.getUTCFullYear() % 1e4, t, 4);
}
function b8e() {
  return "+0000";
}
function UE() {
  return "%";
}
function GE(e) {
  return +e;
}
function WE(e) {
  return Math.floor(+e / 1e3);
}
var du, GO, WO;
v8e({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function v8e(e) {
  return du = v5e(e), GO = du.format, du.parse, WO = du.utcFormat, du.utcParse, du;
}
function E8e(e) {
  return new Date(e);
}
function $8e(e) {
  return e instanceof Date ? +e : +new Date(+e);
}
function H4(e, t, r, n, a, i, o, u, d, s) {
  var l = T4(), f = l.invert, c = l.domain, h = s(".%L"), _ = s(":%S"), F = s("%I:%M"), v = s("%I %p"), $ = s("%a %d"), E = s("%b %d"), D = s("%B"), w = s("%Y");
  function k(A) {
    return (d(A) < A ? h : u(A) < A ? _ : o(A) < A ? F : i(A) < A ? v : n(A) < A ? a(A) < A ? $ : E : r(A) < A ? D : w)(A);
  }
  return l.invert = function(A) {
    return new Date(f(A));
  }, l.domain = function(A) {
    return arguments.length ? c(Array.from(A, $8e)) : c().map(E8e);
  }, l.ticks = function(A) {
    var P = c();
    return e(P[0], P[P.length - 1], A ?? 10);
  }, l.tickFormat = function(A, P) {
    return P == null ? k : s(P);
  }, l.nice = function(A) {
    var P = c();
    return (!A || typeof A.range != "function") && (A = t(P[0], P[P.length - 1], A ?? 10)), A ? c(AO(P, A)) : l;
  }, l.copy = function() {
    return Qf(l, H4(e, t, r, n, a, i, o, u, d, s));
  }, l;
}
function w8e() {
  return Qn.apply(H4(y5e, b5e, Ii, W4, gg, Zf, U4, L4, ds, GO).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function k8e() {
  return Qn.apply(H4(p5e, F5e, Ri, V4, _g, hg, G4, q4, ds, WO).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function mg() {
  var e = 0, t = 1, r, n, a, i, o = en, u = !1, d;
  function s(f) {
    return f == null || isNaN(f = +f) ? d : o(a === 0 ? 0.5 : (f = (i(f) - r) * a, u ? Math.max(0, Math.min(1, f)) : f));
  }
  s.domain = function(f) {
    return arguments.length ? ([e, t] = f, r = i(e = +e), n = i(t = +t), a = r === n ? 0 : 1 / (n - r), s) : [e, t];
  }, s.clamp = function(f) {
    return arguments.length ? (u = !!f, s) : u;
  }, s.interpolator = function(f) {
    return arguments.length ? (o = f, s) : o;
  };
  function l(f) {
    return function(c) {
      var h, _;
      return arguments.length ? ([h, _] = c, o = f(h, _), s) : [o(0), o(1)];
    };
  }
  return s.range = l(bd), s.rangeRound = l(O4), s.unknown = function(f) {
    return arguments.length ? (d = f, s) : d;
  }, function(f) {
    return i = f, r = f(e), n = f(t), a = r === n ? 0 : 1 / (n - r), s;
  };
}
function So(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function VO() {
  var e = Co(mg()(en));
  return e.copy = function() {
    return So(e, VO());
  }, qi.apply(e, arguments);
}
function HO() {
  var e = R4(mg()).domain([1, 10]);
  return e.copy = function() {
    return So(e, HO()).base(e.base());
  }, qi.apply(e, arguments);
}
function zO() {
  var e = j4(mg());
  return e.copy = function() {
    return So(e, zO()).constant(e.constant());
  }, qi.apply(e, arguments);
}
function z4() {
  var e = M4(mg());
  return e.copy = function() {
    return So(e, z4()).exponent(e.exponent());
  }, qi.apply(e, arguments);
}
function x8e() {
  return z4.apply(null, arguments).exponent(0.5);
}
function KO() {
  var e = [], t = en;
  function r(n) {
    if (n != null && !isNaN(n = +n))
      return t((Yf(e, n, 1) - 1) / (e.length - 1));
  }
  return r.domain = function(n) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (let a of n)
      a != null && !isNaN(a = +a) && e.push(a);
    return e.sort(po), r;
  }, r.interpolator = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.range = function() {
    return e.map((n, a) => t(a / (e.length - 1)));
  }, r.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (a, i) => cve(e, i / n));
  }, r.copy = function() {
    return KO(t).domain(e);
  }, qi.apply(r, arguments);
}
function pg() {
  var e = 0, t = 0.5, r = 1, n = 1, a, i, o, u, d, s = en, l, f = !1, c;
  function h(F) {
    return isNaN(F = +F) ? c : (F = 0.5 + ((F = +l(F)) - i) * (n * F < n * i ? u : d), s(f ? Math.max(0, Math.min(1, F)) : F));
  }
  h.domain = function(F) {
    return arguments.length ? ([e, t, r] = F, a = l(e = +e), i = l(t = +t), o = l(r = +r), u = a === i ? 0 : 0.5 / (i - a), d = i === o ? 0 : 0.5 / (o - i), n = i < a ? -1 : 1, h) : [e, t, r];
  }, h.clamp = function(F) {
    return arguments.length ? (f = !!F, h) : f;
  }, h.interpolator = function(F) {
    return arguments.length ? (s = F, h) : s;
  };
  function _(F) {
    return function(v) {
      var $, E, D;
      return arguments.length ? ([$, E, D] = v, s = Bve(F, [$, E, D]), h) : [s(0), s(0.5), s(1)];
    };
  }
  return h.range = _(bd), h.rangeRound = _(O4), h.unknown = function(F) {
    return arguments.length ? (c = F, h) : c;
  }, function(F) {
    return l = F, a = F(e), i = F(t), o = F(r), u = a === i ? 0 : 0.5 / (i - a), d = i === o ? 0 : 0.5 / (o - i), n = i < a ? -1 : 1, h;
  };
}
function YO() {
  var e = Co(pg()(en));
  return e.copy = function() {
    return So(e, YO());
  }, qi.apply(e, arguments);
}
function XO() {
  var e = R4(pg()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return So(e, XO()).base(e.base());
  }, qi.apply(e, arguments);
}
function QO() {
  var e = j4(pg());
  return e.copy = function() {
    return So(e, QO()).constant(e.constant());
  }, qi.apply(e, arguments);
}
function K4() {
  var e = M4(pg());
  return e.copy = function() {
    return So(e, K4()).exponent(e.exponent());
  }, qi.apply(e, arguments);
}
function D8e() {
  return K4.apply(null, arguments).exponent(0.5);
}
const VE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: Ql,
  scaleDiverging: YO,
  scaleDivergingLog: XO,
  scaleDivergingPow: K4,
  scaleDivergingSqrt: D8e,
  scaleDivergingSymlog: QO,
  scaleIdentity: SO,
  scaleImplicit: Cp,
  scaleLinear: B0,
  scaleLog: OO,
  scaleOrdinal: C4,
  scalePoint: Fl,
  scalePow: B4,
  scaleQuantile: IO,
  scaleQuantize: RO,
  scaleRadial: PO,
  scaleSequential: VO,
  scaleSequentialLog: HO,
  scaleSequentialPow: z4,
  scaleSequentialQuantile: KO,
  scaleSequentialSqrt: x8e,
  scaleSequentialSymlog: zO,
  scaleSqrt: s5e,
  scaleSymlog: TO,
  scaleThreshold: jO,
  scaleTime: w8e,
  scaleUtc: k8e,
  tickFormat: CO
}, Symbol.toStringTag, { value: "Module" }));
var C8e = hd;
function S8e(e, t, r) {
  for (var n = -1, a = e.length; ++n < a; ) {
    var i = e[n], o = t(i);
    if (o != null && (u === void 0 ? o === o && !C8e(o) : r(o, u)))
      var u = o, d = i;
  }
  return d;
}
var Fg = S8e;
function A8e(e, t) {
  return e > t;
}
var ZO = A8e, O8e = Fg, T8e = ZO, P8e = yd;
function I8e(e) {
  return e && e.length ? O8e(e, P8e, T8e) : void 0;
}
var yg = I8e;
function R8e(e, t) {
  return e < t;
}
var JO = R8e, j8e = Fg, M8e = JO, B8e = yd;
function N8e(e) {
  return e && e.length ? j8e(e, B8e, M8e) : void 0;
}
var bg = N8e, L8e = d4, q8e = Do, U8e = oO, G8e = cn;
function W8e(e, t) {
  var r = G8e(e) ? L8e : U8e;
  return r(e, q8e(t));
}
var V8e = W8e, H8e = aO, z8e = V8e;
function K8e(e, t) {
  return H8e(z8e(e, t), 1);
}
var Y8e = K8e, X8e = $4;
function Q8e(e, t) {
  return X8e(e, t);
}
var Y4 = Q8e, vd = 1e9, Z8e = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, Q4, rr = !0, Yn = "[DecimalError] ", gs = Yn + "Invalid argument: ", X4 = Yn + "Exponent out of range: ", Ed = Math.floor, es = Math.pow, J8e = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, vn, Ar = 1e7, Zt = 7, eT = 9007199254740991, U0 = Ed(eT / Zt), Ke = {};
Ke.absoluteValue = Ke.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
Ke.comparedTo = Ke.cmp = function(e) {
  var t, r, n, a, i = this;
  if (e = new i.constructor(e), i.s !== e.s)
    return i.s || -e.s;
  if (i.e !== e.e)
    return i.e > e.e ^ i.s < 0 ? 1 : -1;
  for (n = i.d.length, a = e.d.length, t = 0, r = n < a ? n : a; t < r; ++t)
    if (i.d[t] !== e.d[t])
      return i.d[t] > e.d[t] ^ i.s < 0 ? 1 : -1;
  return n === a ? 0 : n > a ^ i.s < 0 ? 1 : -1;
};
Ke.decimalPlaces = Ke.dp = function() {
  var e = this, t = e.d.length - 1, r = (t - e.e) * Zt;
  if (t = e.d[t], t)
    for (; t % 10 == 0; t /= 10)
      r--;
  return r < 0 ? 0 : r;
};
Ke.dividedBy = Ke.div = function(e) {
  return Si(this, new this.constructor(e));
};
Ke.dividedToIntegerBy = Ke.idiv = function(e) {
  var t = this, r = t.constructor;
  return Lt(Si(t, new r(e), 0, 1), r.precision);
};
Ke.equals = Ke.eq = function(e) {
  return !this.cmp(e);
};
Ke.exponent = function() {
  return yr(this);
};
Ke.greaterThan = Ke.gt = function(e) {
  return this.cmp(e) > 0;
};
Ke.greaterThanOrEqualTo = Ke.gte = function(e) {
  return this.cmp(e) >= 0;
};
Ke.isInteger = Ke.isint = function() {
  return this.e > this.d.length - 2;
};
Ke.isNegative = Ke.isneg = function() {
  return this.s < 0;
};
Ke.isPositive = Ke.ispos = function() {
  return this.s > 0;
};
Ke.isZero = function() {
  return this.s === 0;
};
Ke.lessThan = Ke.lt = function(e) {
  return this.cmp(e) < 0;
};
Ke.lessThanOrEqualTo = Ke.lte = function(e) {
  return this.cmp(e) < 1;
};
Ke.logarithm = Ke.log = function(e) {
  var t, r = this, n = r.constructor, a = n.precision, i = a + 5;
  if (e === void 0)
    e = new n(10);
  else if (e = new n(e), e.s < 1 || e.eq(vn))
    throw Error(Yn + "NaN");
  if (r.s < 1)
    throw Error(Yn + (r.s ? "NaN" : "-Infinity"));
  return r.eq(vn) ? new n(0) : (rr = !1, t = Si(rf(r, i), rf(e, i), i), rr = !0, Lt(t, a));
};
Ke.minus = Ke.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? nT(t, e) : tT(t, (e.s = -e.s, e));
};
Ke.modulo = Ke.mod = function(e) {
  var t, r = this, n = r.constructor, a = n.precision;
  if (e = new n(e), !e.s)
    throw Error(Yn + "NaN");
  return r.s ? (rr = !1, t = Si(r, e, 0, 1).times(e), rr = !0, r.minus(t)) : Lt(new n(r), a);
};
Ke.naturalExponential = Ke.exp = function() {
  return rT(this);
};
Ke.naturalLogarithm = Ke.ln = function() {
  return rf(this);
};
Ke.negated = Ke.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
Ke.plus = Ke.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? tT(t, e) : nT(t, (e.s = -e.s, e));
};
Ke.precision = Ke.sd = function(e) {
  var t, r, n, a = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0)
    throw Error(gs + e);
  if (t = yr(a) + 1, n = a.d.length - 1, r = n * Zt + 1, n = a.d[n], n) {
    for (; n % 10 == 0; n /= 10)
      r--;
    for (n = a.d[0]; n >= 10; n /= 10)
      r++;
  }
  return e && t > r ? t : r;
};
Ke.squareRoot = Ke.sqrt = function() {
  var e, t, r, n, a, i, o, u = this, d = u.constructor;
  if (u.s < 1) {
    if (!u.s)
      return new d(0);
    throw Error(Yn + "NaN");
  }
  for (e = yr(u), rr = !1, a = Math.sqrt(+u), a == 0 || a == 1 / 0 ? (t = Na(u.d), (t.length + e) % 2 == 0 && (t += "0"), a = Math.sqrt(t), e = Ed((e + 1) / 2) - (e < 0 || e % 2), a == 1 / 0 ? t = "5e" + e : (t = a.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), n = new d(t)) : n = new d(a.toString()), r = d.precision, a = o = r + 3; ; )
    if (i = n, n = i.plus(Si(u, i, o + 2)).times(0.5), Na(i.d).slice(0, o) === (t = Na(n.d)).slice(0, o)) {
      if (t = t.slice(o - 3, o + 1), a == o && t == "4999") {
        if (Lt(i, r + 1, 0), i.times(i).eq(u)) {
          n = i;
          break;
        }
      } else if (t != "9999")
        break;
      o += 4;
    }
  return rr = !0, Lt(n, r);
};
Ke.times = Ke.mul = function(e) {
  var t, r, n, a, i, o, u, d, s, l = this, f = l.constructor, c = l.d, h = (e = new f(e)).d;
  if (!l.s || !e.s)
    return new f(0);
  for (e.s *= l.s, r = l.e + e.e, d = c.length, s = h.length, d < s && (i = c, c = h, h = i, o = d, d = s, s = o), i = [], o = d + s, n = o; n--; )
    i.push(0);
  for (n = s; --n >= 0; ) {
    for (t = 0, a = d + n; a > n; )
      u = i[a] + h[n] * c[a - n - 1] + t, i[a--] = u % Ar | 0, t = u / Ar | 0;
    i[a] = (i[a] + t) % Ar | 0;
  }
  for (; !i[--o]; )
    i.pop();
  return t ? ++r : i.shift(), e.d = i, e.e = r, rr ? Lt(e, f.precision) : e;
};
Ke.toDecimalPlaces = Ke.todp = function(e, t) {
  var r = this, n = r.constructor;
  return r = new n(r), e === void 0 ? r : (Ka(e, 0, vd), t === void 0 ? t = n.rounding : Ka(t, 0, 8), Lt(r, e + yr(r) + 1, t));
};
Ke.toExponential = function(e, t) {
  var r, n = this, a = n.constructor;
  return e === void 0 ? r = $s(n, !0) : (Ka(e, 0, vd), t === void 0 ? t = a.rounding : Ka(t, 0, 8), n = Lt(new a(n), e + 1, t), r = $s(n, !0, e + 1)), r;
};
Ke.toFixed = function(e, t) {
  var r, n, a = this, i = a.constructor;
  return e === void 0 ? $s(a) : (Ka(e, 0, vd), t === void 0 ? t = i.rounding : Ka(t, 0, 8), n = Lt(new i(a), e + yr(a) + 1, t), r = $s(n.abs(), !1, e + yr(n) + 1), a.isneg() && !a.isZero() ? "-" + r : r);
};
Ke.toInteger = Ke.toint = function() {
  var e = this, t = e.constructor;
  return Lt(new t(e), yr(e) + 1, t.rounding);
};
Ke.toNumber = function() {
  return +this;
};
Ke.toPower = Ke.pow = function(e) {
  var t, r, n, a, i, o, u = this, d = u.constructor, s = 12, l = +(e = new d(e));
  if (!e.s)
    return new d(vn);
  if (u = new d(u), !u.s) {
    if (e.s < 1)
      throw Error(Yn + "Infinity");
    return u;
  }
  if (u.eq(vn))
    return u;
  if (n = d.precision, e.eq(vn))
    return Lt(u, n);
  if (t = e.e, r = e.d.length - 1, o = t >= r, i = u.s, o) {
    if ((r = l < 0 ? -l : l) <= eT) {
      for (a = new d(vn), t = Math.ceil(n / Zt + 4), rr = !1; r % 2 && (a = a.times(u), zE(a.d, t)), r = Ed(r / 2), r !== 0; )
        u = u.times(u), zE(u.d, t);
      return rr = !0, e.s < 0 ? new d(vn).div(a) : Lt(a, n);
    }
  } else if (i < 0)
    throw Error(Yn + "NaN");
  return i = i < 0 && e.d[Math.max(t, r)] & 1 ? -1 : 1, u.s = 1, rr = !1, a = e.times(rf(u, n + s)), rr = !0, a = rT(a), a.s = i, a;
};
Ke.toPrecision = function(e, t) {
  var r, n, a = this, i = a.constructor;
  return e === void 0 ? (r = yr(a), n = $s(a, r <= i.toExpNeg || r >= i.toExpPos)) : (Ka(e, 1, vd), t === void 0 ? t = i.rounding : Ka(t, 0, 8), a = Lt(new i(a), e, t), r = yr(a), n = $s(a, e <= r || r <= i.toExpNeg, e)), n;
};
Ke.toSignificantDigits = Ke.tosd = function(e, t) {
  var r = this, n = r.constructor;
  return e === void 0 ? (e = n.precision, t = n.rounding) : (Ka(e, 1, vd), t === void 0 ? t = n.rounding : Ka(t, 0, 8)), Lt(new n(r), e, t);
};
Ke.toString = Ke.valueOf = Ke.val = Ke.toJSON = Ke[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = yr(e), r = e.constructor;
  return $s(e, t <= r.toExpNeg || t >= r.toExpPos);
};
function tT(e, t) {
  var r, n, a, i, o, u, d, s, l = e.constructor, f = l.precision;
  if (!e.s || !t.s)
    return t.s || (t = new l(e)), rr ? Lt(t, f) : t;
  if (d = e.d, s = t.d, o = e.e, a = t.e, d = d.slice(), i = o - a, i) {
    for (i < 0 ? (n = d, i = -i, u = s.length) : (n = s, a = o, u = d.length), o = Math.ceil(f / Zt), u = o > u ? o + 1 : u + 1, i > u && (i = u, n.length = 1), n.reverse(); i--; )
      n.push(0);
    n.reverse();
  }
  for (u = d.length, i = s.length, u - i < 0 && (i = u, n = s, s = d, d = n), r = 0; i; )
    r = (d[--i] = d[i] + s[i] + r) / Ar | 0, d[i] %= Ar;
  for (r && (d.unshift(r), ++a), u = d.length; d[--u] == 0; )
    d.pop();
  return t.d = d, t.e = a, rr ? Lt(t, f) : t;
}
function Ka(e, t, r) {
  if (e !== ~~e || e < t || e > r)
    throw Error(gs + e);
}
function Na(e) {
  var t, r, n, a = e.length - 1, i = "", o = e[0];
  if (a > 0) {
    for (i += o, t = 1; t < a; t++)
      n = e[t] + "", r = Zt - n.length, r && (i += co(r)), i += n;
    o = e[t], n = o + "", r = Zt - n.length, r && (i += co(r));
  } else if (o === 0)
    return "0";
  for (; o % 10 === 0; )
    o /= 10;
  return i + o;
}
var Si = function() {
  function e(n, a) {
    var i, o = 0, u = n.length;
    for (n = n.slice(); u--; )
      i = n[u] * a + o, n[u] = i % Ar | 0, o = i / Ar | 0;
    return o && n.unshift(o), n;
  }
  function t(n, a, i, o) {
    var u, d;
    if (i != o)
      d = i > o ? 1 : -1;
    else
      for (u = d = 0; u < i; u++)
        if (n[u] != a[u]) {
          d = n[u] > a[u] ? 1 : -1;
          break;
        }
    return d;
  }
  function r(n, a, i) {
    for (var o = 0; i--; )
      n[i] -= o, o = n[i] < a[i] ? 1 : 0, n[i] = o * Ar + n[i] - a[i];
    for (; !n[0] && n.length > 1; )
      n.shift();
  }
  return function(n, a, i, o) {
    var u, d, s, l, f, c, h, _, F, v, $, E, D, w, k, A, P, S, N = n.constructor, W = n.s == a.s ? 1 : -1, V = n.d, K = a.d;
    if (!n.s)
      return new N(n);
    if (!a.s)
      throw Error(Yn + "Division by zero");
    for (d = n.e - a.e, P = K.length, k = V.length, h = new N(W), _ = h.d = [], s = 0; K[s] == (V[s] || 0); )
      ++s;
    if (K[s] > (V[s] || 0) && --d, i == null ? E = i = N.precision : o ? E = i + (yr(n) - yr(a)) + 1 : E = i, E < 0)
      return new N(0);
    if (E = E / Zt + 2 | 0, s = 0, P == 1)
      for (l = 0, K = K[0], E++; (s < k || l) && E--; s++)
        D = l * Ar + (V[s] || 0), _[s] = D / K | 0, l = D % K | 0;
    else {
      for (l = Ar / (K[0] + 1) | 0, l > 1 && (K = e(K, l), V = e(V, l), P = K.length, k = V.length), w = P, F = V.slice(0, P), v = F.length; v < P; )
        F[v++] = 0;
      S = K.slice(), S.unshift(0), A = K[0], K[1] >= Ar / 2 && ++A;
      do
        l = 0, u = t(K, F, P, v), u < 0 ? ($ = F[0], P != v && ($ = $ * Ar + (F[1] || 0)), l = $ / A | 0, l > 1 ? (l >= Ar && (l = Ar - 1), f = e(K, l), c = f.length, v = F.length, u = t(f, F, c, v), u == 1 && (l--, r(f, P < c ? S : K, c))) : (l == 0 && (u = l = 1), f = K.slice()), c = f.length, c < v && f.unshift(0), r(F, f, v), u == -1 && (v = F.length, u = t(K, F, P, v), u < 1 && (l++, r(F, P < v ? S : K, v))), v = F.length) : u === 0 && (l++, F = [0]), _[s++] = l, u && F[0] ? F[v++] = V[w] || 0 : (F = [V[w]], v = 1);
      while ((w++ < k || F[0] !== void 0) && E--);
    }
    return _[0] || _.shift(), h.e = d, Lt(h, o ? i + yr(h) + 1 : i);
  };
}();
function rT(e, t) {
  var r, n, a, i, o, u, d = 0, s = 0, l = e.constructor, f = l.precision;
  if (yr(e) > 16)
    throw Error(X4 + yr(e));
  if (!e.s)
    return new l(vn);
  for (t == null ? (rr = !1, u = f) : u = t, o = new l(0.03125); e.abs().gte(0.1); )
    e = e.times(o), s += 5;
  for (n = Math.log(es(2, s)) / Math.LN10 * 2 + 5 | 0, u += n, r = a = i = new l(vn), l.precision = u; ; ) {
    if (a = Lt(a.times(e), u), r = r.times(++d), o = i.plus(Si(a, r, u)), Na(o.d).slice(0, u) === Na(i.d).slice(0, u)) {
      for (; s--; )
        i = Lt(i.times(i), u);
      return l.precision = f, t == null ? (rr = !0, Lt(i, f)) : i;
    }
    i = o;
  }
}
function yr(e) {
  for (var t = e.e * Zt, r = e.d[0]; r >= 10; r /= 10)
    t++;
  return t;
}
function O2(e, t, r) {
  if (t > e.LN10.sd())
    throw rr = !0, r && (e.precision = r), Error(Yn + "LN10 precision limit exceeded");
  return Lt(new e(e.LN10), t);
}
function co(e) {
  for (var t = ""; e--; )
    t += "0";
  return t;
}
function rf(e, t) {
  var r, n, a, i, o, u, d, s, l, f = 1, c = 10, h = e, _ = h.d, F = h.constructor, v = F.precision;
  if (h.s < 1)
    throw Error(Yn + (h.s ? "NaN" : "-Infinity"));
  if (h.eq(vn))
    return new F(0);
  if (t == null ? (rr = !1, s = v) : s = t, h.eq(10))
    return t == null && (rr = !0), O2(F, s);
  if (s += c, F.precision = s, r = Na(_), n = r.charAt(0), i = yr(h), Math.abs(i) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      h = h.times(e), r = Na(h.d), n = r.charAt(0), f++;
    i = yr(h), n > 1 ? (h = new F("0." + r), i++) : h = new F(n + "." + r.slice(1));
  } else
    return d = O2(F, s + 2, v).times(i + ""), h = rf(new F(n + "." + r.slice(1)), s - c).plus(d), F.precision = v, t == null ? (rr = !0, Lt(h, v)) : h;
  for (u = o = h = Si(h.minus(vn), h.plus(vn), s), l = Lt(h.times(h), s), a = 3; ; ) {
    if (o = Lt(o.times(l), s), d = u.plus(Si(o, new F(a), s)), Na(d.d).slice(0, s) === Na(u.d).slice(0, s))
      return u = u.times(2), i !== 0 && (u = u.plus(O2(F, s + 2, v).times(i + ""))), u = Si(u, new F(f), s), F.precision = v, t == null ? (rr = !0, Lt(u, v)) : u;
    u = d, a += 2;
  }
}
function HE(e, t) {
  var r, n, a;
  for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; )
    ++n;
  for (a = t.length; t.charCodeAt(a - 1) === 48; )
    --a;
  if (t = t.slice(n, a), t) {
    if (a -= n, r = r - n - 1, e.e = Ed(r / Zt), e.d = [], n = (r + 1) % Zt, r < 0 && (n += Zt), n < a) {
      for (n && e.d.push(+t.slice(0, n)), a -= Zt; n < a; )
        e.d.push(+t.slice(n, n += Zt));
      t = t.slice(n), n = Zt - t.length;
    } else
      n -= a;
    for (; n--; )
      t += "0";
    if (e.d.push(+t), rr && (e.e > U0 || e.e < -U0))
      throw Error(X4 + r);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function Lt(e, t, r) {
  var n, a, i, o, u, d, s, l, f = e.d;
  for (o = 1, i = f[0]; i >= 10; i /= 10)
    o++;
  if (n = t - o, n < 0)
    n += Zt, a = t, s = f[l = 0];
  else {
    if (l = Math.ceil((n + 1) / Zt), i = f.length, l >= i)
      return e;
    for (s = i = f[l], o = 1; i >= 10; i /= 10)
      o++;
    n %= Zt, a = n - Zt + o;
  }
  if (r !== void 0 && (i = es(10, o - a - 1), u = s / i % 10 | 0, d = t < 0 || f[l + 1] !== void 0 || s % i, d = r < 4 ? (u || d) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : u > 5 || u == 5 && (r == 4 || d || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (n > 0 ? a > 0 ? s / es(10, o - a) : 0 : f[l - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7))), t < 1 || !f[0])
    return d ? (i = yr(e), f.length = 1, t = t - i - 1, f[0] = es(10, (Zt - t % Zt) % Zt), e.e = Ed(-t / Zt) || 0) : (f.length = 1, f[0] = e.e = e.s = 0), e;
  if (n == 0 ? (f.length = l, i = 1, l--) : (f.length = l + 1, i = es(10, Zt - n), f[l] = a > 0 ? (s / es(10, o - a) % es(10, a) | 0) * i : 0), d)
    for (; ; )
      if (l == 0) {
        (f[0] += i) == Ar && (f[0] = 1, ++e.e);
        break;
      } else {
        if (f[l] += i, f[l] != Ar)
          break;
        f[l--] = 0, i = 1;
      }
  for (n = f.length; f[--n] === 0; )
    f.pop();
  if (rr && (e.e > U0 || e.e < -U0))
    throw Error(X4 + yr(e));
  return e;
}
function nT(e, t) {
  var r, n, a, i, o, u, d, s, l, f, c = e.constructor, h = c.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new c(e), rr ? Lt(t, h) : t;
  if (d = e.d, f = t.d, n = t.e, s = e.e, d = d.slice(), o = s - n, o) {
    for (l = o < 0, l ? (r = d, o = -o, u = f.length) : (r = f, n = s, u = d.length), a = Math.max(Math.ceil(h / Zt), u) + 2, o > a && (o = a, r.length = 1), r.reverse(), a = o; a--; )
      r.push(0);
    r.reverse();
  } else {
    for (a = d.length, u = f.length, l = a < u, l && (u = a), a = 0; a < u; a++)
      if (d[a] != f[a]) {
        l = d[a] < f[a];
        break;
      }
    o = 0;
  }
  for (l && (r = d, d = f, f = r, t.s = -t.s), u = d.length, a = f.length - u; a > 0; --a)
    d[u++] = 0;
  for (a = f.length; a > o; ) {
    if (d[--a] < f[a]) {
      for (i = a; i && d[--i] === 0; )
        d[i] = Ar - 1;
      --d[i], d[a] += Ar;
    }
    d[a] -= f[a];
  }
  for (; d[--u] === 0; )
    d.pop();
  for (; d[0] === 0; d.shift())
    --n;
  return d[0] ? (t.d = d, t.e = n, rr ? Lt(t, h) : t) : new c(0);
}
function $s(e, t, r) {
  var n, a = yr(e), i = Na(e.d), o = i.length;
  return t ? (r && (n = r - o) > 0 ? i = i.charAt(0) + "." + i.slice(1) + co(n) : o > 1 && (i = i.charAt(0) + "." + i.slice(1)), i = i + (a < 0 ? "e" : "e+") + a) : a < 0 ? (i = "0." + co(-a - 1) + i, r && (n = r - o) > 0 && (i += co(n))) : a >= o ? (i += co(a + 1 - o), r && (n = r - a - 1) > 0 && (i = i + "." + co(n))) : ((n = a + 1) < o && (i = i.slice(0, n) + "." + i.slice(n)), r && (n = r - o) > 0 && (a + 1 === o && (i += "."), i += co(n))), e.s < 0 ? "-" + i : i;
}
function zE(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function aT(e) {
  var t, r, n;
  function a(i) {
    var o = this;
    if (!(o instanceof a))
      return new a(i);
    if (o.constructor = a, i instanceof a) {
      o.s = i.s, o.e = i.e, o.d = (i = i.d) ? i.slice() : i;
      return;
    }
    if (typeof i == "number") {
      if (i * 0 !== 0)
        throw Error(gs + i);
      if (i > 0)
        o.s = 1;
      else if (i < 0)
        i = -i, o.s = -1;
      else {
        o.s = 0, o.e = 0, o.d = [0];
        return;
      }
      if (i === ~~i && i < 1e7) {
        o.e = 0, o.d = [i];
        return;
      }
      return HE(o, i.toString());
    } else if (typeof i != "string")
      throw Error(gs + i);
    if (i.charCodeAt(0) === 45 ? (i = i.slice(1), o.s = -1) : o.s = 1, J8e.test(i))
      HE(o, i);
    else
      throw Error(gs + i);
  }
  if (a.prototype = Ke, a.ROUND_UP = 0, a.ROUND_DOWN = 1, a.ROUND_CEIL = 2, a.ROUND_FLOOR = 3, a.ROUND_HALF_UP = 4, a.ROUND_HALF_DOWN = 5, a.ROUND_HALF_EVEN = 6, a.ROUND_HALF_CEIL = 7, a.ROUND_HALF_FLOOR = 8, a.clone = aT, a.config = a.set = e7e, e === void 0 && (e = {}), e)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < n.length; )
      e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
  return a.config(e), a;
}
function e7e(e) {
  if (!e || typeof e != "object")
    throw Error(Yn + "Object expected");
  var t, r, n, a = [
    "precision",
    1,
    vd,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < a.length; t += 3)
    if ((n = e[r = a[t]]) !== void 0)
      if (Ed(n) === n && n >= a[t + 1] && n <= a[t + 2])
        this[r] = n;
      else
        throw Error(gs + r + ": " + n);
  if ((n = e[r = "LN10"]) !== void 0)
    if (n == Math.LN10)
      this[r] = new this(n);
    else
      throw Error(gs + r + ": " + n);
  return this;
}
var Q4 = aT(Z8e);
vn = new Q4(1);
const Bt = Q4;
function t7e(e) {
  return i7e(e) || a7e(e) || n7e(e) || r7e();
}
function r7e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function n7e(e, t) {
  if (e) {
    if (typeof e == "string")
      return Tp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Tp(e, t);
  }
}
function a7e(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function i7e(e) {
  if (Array.isArray(e))
    return Tp(e);
}
function Tp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var o7e = function(t) {
  return t;
}, iT = {
  "@@functional/placeholder": !0
}, oT = function(t) {
  return t === iT;
}, KE = function(t) {
  return function r() {
    return arguments.length === 0 || arguments.length === 1 && oT(arguments.length <= 0 ? void 0 : arguments[0]) ? r : t.apply(void 0, arguments);
  };
}, s7e = function e(t, r) {
  return t === 1 ? r : KE(function() {
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    var o = a.filter(function(u) {
      return u !== iT;
    }).length;
    return o >= t ? r.apply(void 0, a) : e(t - o, KE(function() {
      for (var u = arguments.length, d = new Array(u), s = 0; s < u; s++)
        d[s] = arguments[s];
      var l = a.map(function(f) {
        return oT(f) ? d.shift() : f;
      });
      return r.apply(void 0, t7e(l).concat(d));
    }));
  });
}, vg = function(t) {
  return s7e(t.length, t);
}, Pp = function(t, r) {
  for (var n = [], a = t; a < r; ++a)
    n[a - t] = a;
  return n;
}, u7e = vg(function(e, t) {
  return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(r) {
    return t[r];
  }).map(e);
}), d7e = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  if (!r.length)
    return o7e;
  var a = r.reverse(), i = a[0], o = a.slice(1);
  return function() {
    return o.reduce(function(u, d) {
      return d(u);
    }, i.apply(void 0, arguments));
  };
}, Ip = function(t) {
  return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
}, sT = function(t) {
  var r = null, n = null;
  return function() {
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r && i.every(function(u, d) {
      return u === r[d];
    }) || (r = i, n = t.apply(void 0, i)), n;
  };
};
function l7e(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new Bt(e).abs().log(10).toNumber()) + 1, t;
}
function f7e(e, t, r) {
  for (var n = new Bt(e), a = 0, i = []; n.lt(t) && a < 1e5; )
    i.push(n.toNumber()), n = n.add(r), a++;
  return i;
}
var c7e = vg(function(e, t, r) {
  var n = +e, a = +t;
  return n + r * (a - n);
}), h7e = vg(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, (r - e) / n;
}), g7e = vg(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, Math.max(0, Math.min(1, (r - e) / n));
});
const Eg = {
  rangeStep: f7e,
  getDigitCount: l7e,
  interpolateNumber: c7e,
  uninterpolateNumber: h7e,
  uninterpolateTruncation: g7e
};
function Rp(e) {
  return p7e(e) || m7e(e) || uT(e) || _7e();
}
function _7e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function m7e(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function p7e(e) {
  if (Array.isArray(e))
    return jp(e);
}
function nf(e, t) {
  return b7e(e) || y7e(e, t) || uT(e, t) || F7e();
}
function F7e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function uT(e, t) {
  if (e) {
    if (typeof e == "string")
      return jp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return jp(e, t);
  }
}
function jp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function y7e(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], n = !0, a = !1, i = void 0;
    try {
      for (var o = e[Symbol.iterator](), u; !(n = (u = o.next()).done) && (r.push(u.value), !(t && r.length === t)); n = !0)
        ;
    } catch (d) {
      a = !0, i = d;
    } finally {
      try {
        !n && o.return != null && o.return();
      } finally {
        if (a)
          throw i;
      }
    }
    return r;
  }
}
function b7e(e) {
  if (Array.isArray(e))
    return e;
}
function dT(e) {
  var t = nf(e, 2), r = t[0], n = t[1], a = r, i = n;
  return r > n && (a = n, i = r), [a, i];
}
function lT(e, t, r) {
  if (e.lte(0))
    return new Bt(0);
  var n = Eg.getDigitCount(e.toNumber()), a = new Bt(10).pow(n), i = e.div(a), o = n !== 1 ? 0.05 : 0.1, u = new Bt(Math.ceil(i.div(o).toNumber())).add(r).mul(o), d = u.mul(a);
  return t ? d : new Bt(Math.ceil(d));
}
function v7e(e, t, r) {
  var n = 1, a = new Bt(e);
  if (!a.isint() && r) {
    var i = Math.abs(e);
    i < 1 ? (n = new Bt(10).pow(Eg.getDigitCount(e) - 1), a = new Bt(Math.floor(a.div(n).toNumber())).mul(n)) : i > 1 && (a = new Bt(Math.floor(e)));
  } else
    e === 0 ? a = new Bt(Math.floor((t - 1) / 2)) : r || (a = new Bt(Math.floor(e)));
  var o = Math.floor((t - 1) / 2), u = d7e(u7e(function(d) {
    return a.add(new Bt(d - o).mul(n)).toNumber();
  }), Pp);
  return u(0, t);
}
function fT(e, t, r, n) {
  var a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((t - e) / (r - 1)))
    return {
      step: new Bt(0),
      tickMin: new Bt(0),
      tickMax: new Bt(0)
    };
  var i = lT(new Bt(t).sub(e).div(r - 1), n, a), o;
  e <= 0 && t >= 0 ? o = new Bt(0) : (o = new Bt(e).add(t).div(2), o = o.sub(new Bt(o).mod(i)));
  var u = Math.ceil(o.sub(e).div(i).toNumber()), d = Math.ceil(new Bt(t).sub(o).div(i).toNumber()), s = u + d + 1;
  return s > r ? fT(e, t, r, n, a + 1) : (s < r && (d = t > 0 ? d + (r - s) : d, u = t > 0 ? u : u + (r - s)), {
    step: i,
    tickMin: o.sub(new Bt(u).mul(i)),
    tickMax: o.add(new Bt(d).mul(i))
  });
}
function E7e(e) {
  var t = nf(e, 2), r = t[0], n = t[1], a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = Math.max(a, 2), u = dT([r, n]), d = nf(u, 2), s = d[0], l = d[1];
  if (s === -1 / 0 || l === 1 / 0) {
    var f = l === 1 / 0 ? [s].concat(Rp(Pp(0, a - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(Rp(Pp(0, a - 1).map(function() {
      return -1 / 0;
    })), [l]);
    return r > n ? Ip(f) : f;
  }
  if (s === l)
    return v7e(s, a, i);
  var c = fT(s, l, o, i), h = c.step, _ = c.tickMin, F = c.tickMax, v = Eg.rangeStep(_, F.add(new Bt(0.1).mul(h)), h);
  return r > n ? Ip(v) : v;
}
function $7e(e, t) {
  var r = nf(e, 2), n = r[0], a = r[1], i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = dT([n, a]), u = nf(o, 2), d = u[0], s = u[1];
  if (d === -1 / 0 || s === 1 / 0)
    return [n, a];
  if (d === s)
    return [d];
  var l = Math.max(t, 2), f = lT(new Bt(s).sub(d).div(l - 1), i, 0), c = [].concat(Rp(Eg.rangeStep(new Bt(d), new Bt(s).sub(new Bt(0.99).mul(f)), f)), [s]);
  return n > a ? Ip(c) : c;
}
var w7e = sT(E7e), k7e = sT($7e), x7e = process.env.NODE_ENV === "production", T2 = "Invariant failed";
function Wn(e, t) {
  if (!e) {
    if (x7e)
      throw new Error(T2);
    var r = typeof t == "function" ? t() : t, n = r ? "".concat(T2, ": ").concat(r) : T2;
    throw new Error(n);
  }
}
var D7e = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function G0() {
  return G0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, G0.apply(this, arguments);
}
function C7e(e, t) {
  return T7e(e) || O7e(e, t) || A7e(e, t) || S7e();
}
function S7e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function A7e(e, t) {
  if (e) {
    if (typeof e == "string")
      return YE(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return YE(e, t);
  }
}
function YE(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function O7e(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], d = !0, s = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        d = !1;
      } else
        for (; !(d = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); d = !0)
          ;
    } catch (l) {
      s = !0, a = l;
    } finally {
      try {
        if (!d && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (s)
          throw a;
      }
    }
    return u;
  }
}
function T7e(e) {
  if (Array.isArray(e))
    return e;
}
function P7e(e, t) {
  if (e == null)
    return {};
  var r = I7e(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function I7e(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Z4(e) {
  var t = e.offset, r = e.layout, n = e.width, a = e.dataKey, i = e.data, o = e.dataPointFormatter, u = e.xAxis, d = e.yAxis, s = P7e(e, D7e), l = _t(s, !1);
  e.direction === "x" && u.type !== "number" && (process.env.NODE_ENV !== "production" ? Wn(!1, 'ErrorBar requires Axis type property to be "number".') : Wn(!1));
  var f = i.map(function(c) {
    var h = o(c, a), _ = h.x, F = h.y, v = h.value, $ = h.errorVal;
    if (!$)
      return null;
    var E = [], D, w;
    if (Array.isArray($)) {
      var k = C7e($, 2);
      D = k[0], w = k[1];
    } else
      D = w = $;
    if (r === "vertical") {
      var A = u.scale, P = F + t, S = P + n, N = P - n, W = A(v - D), V = A(v + w);
      E.push({
        x1: V,
        y1: S,
        x2: V,
        y2: N
      }), E.push({
        x1: W,
        y1: P,
        x2: V,
        y2: P
      }), E.push({
        x1: W,
        y1: S,
        x2: W,
        y2: N
      });
    } else if (r === "horizontal") {
      var K = d.scale, U = _ + t, j = U - n, G = U + n, H = K(v - D), J = K(v + w);
      E.push({
        x1: j,
        y1: J,
        x2: G,
        y2: J
      }), E.push({
        x1: U,
        y1: H,
        x2: U,
        y2: J
      }), E.push({
        x1: j,
        y1: H,
        x2: G,
        y2: H
      });
    }
    return /* @__PURE__ */ M.createElement(cr, G0({
      className: "recharts-errorBar",
      key: "bar-".concat(E.map(function(ae) {
        return "".concat(ae.x1, "-").concat(ae.x2, "-").concat(ae.y1, "-").concat(ae.y2);
      }))
    }, l), E.map(function(ae) {
      return /* @__PURE__ */ M.createElement("line", G0({}, ae, {
        key: "line-".concat(ae.x1, "-").concat(ae.x2, "-").concat(ae.y1, "-").concat(ae.y2)
      }));
    }));
  });
  return /* @__PURE__ */ M.createElement(cr, {
    className: "recharts-errorBars"
  }, f);
}
Z4.defaultProps = {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
};
Z4.displayName = "ErrorBar";
function af(e) {
  return af = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, af(e);
}
function XE(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function P2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? XE(Object(r), !0).forEach(function(n) {
      R7e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : XE(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function R7e(e, t, r) {
  return t = j7e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function j7e(e) {
  var t = M7e(e, "string");
  return af(t) == "symbol" ? t : String(t);
}
function M7e(e, t) {
  if (af(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (af(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var cT = function(t) {
  var r = t.children, n = t.formattedGraphicalItems, a = t.legendWidth, i = t.legendContent, o = Bn(r, Lu);
  if (!o)
    return null;
  var u;
  return o.props && o.props.payload ? u = o.props && o.props.payload : i === "children" ? u = (n || []).reduce(function(d, s) {
    var l = s.item, f = s.props, c = f.sectors || f.data || [];
    return d.concat(c.map(function(h) {
      return {
        type: o.props.iconType || l.props.legendType,
        value: h.name,
        color: h.fill,
        payload: h
      };
    }));
  }, []) : u = (n || []).map(function(d) {
    var s = d.item, l = s.props, f = l.dataKey, c = l.name, h = l.legendType, _ = l.hide;
    return {
      inactive: _,
      dataKey: f,
      type: o.props.iconType || h || "square",
      color: J4(s),
      value: c || f,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: s.props
    };
  }), P2(P2(P2({}, o.props), Lu.getWithHeight(o, a)), {}, {
    payload: u,
    item: o
  });
};
function of(e) {
  return of = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, of(e);
}
function QE(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ln(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? QE(Object(r), !0).forEach(function(n) {
      Du(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : QE(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Du(e, t, r) {
  return t = B7e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function B7e(e) {
  var t = N7e(e, "string");
  return of(t) == "symbol" ? t : String(t);
}
function N7e(e, t) {
  if (of(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (of(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ZE(e) {
  return G7e(e) || U7e(e) || q7e(e) || L7e();
}
function L7e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function q7e(e, t) {
  if (e) {
    if (typeof e == "string")
      return Mp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Mp(e, t);
  }
}
function U7e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function G7e(e) {
  if (Array.isArray(e))
    return Mp(e);
}
function Mp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function En(e, t, r) {
  return wt(e) || wt(t) ? r : $r(t) ? Hn(e, t, r) : Ft(t) ? t(e) : r;
}
function yl(e, t, r, n) {
  var a = Y8e(e, function(u) {
    return En(u, t);
  });
  if (r === "number") {
    var i = a.filter(function(u) {
      return Ve(u) || parseFloat(u);
    });
    return i.length ? [bg(i), yg(i)] : [1 / 0, -1 / 0];
  }
  var o = n ? a.filter(function(u) {
    return !wt(u);
  }) : a;
  return o.map(function(u) {
    return $r(u) || u instanceof Date ? u : "";
  });
}
var W7e = function(t) {
  var r, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], a = arguments.length > 2 ? arguments[2] : void 0, i = arguments.length > 3 ? arguments[3] : void 0, o = -1, u = (r = n == null ? void 0 : n.length) !== null && r !== void 0 ? r : 0;
  if (u <= 1)
    return 0;
  if (i && i.axisType === "angleAxis" && Math.abs(Math.abs(i.range[1] - i.range[0]) - 360) <= 1e-6)
    for (var d = i.range, s = 0; s < u; s++) {
      var l = s > 0 ? a[s - 1].coordinate : a[u - 1].coordinate, f = a[s].coordinate, c = s >= u - 1 ? a[0].coordinate : a[s + 1].coordinate, h = void 0;
      if (Un(f - l) !== Un(c - f)) {
        var _ = [];
        if (Un(c - f) === Un(d[1] - d[0])) {
          h = c;
          var F = f + d[1] - d[0];
          _[0] = Math.min(F, (F + l) / 2), _[1] = Math.max(F, (F + l) / 2);
        } else {
          h = l;
          var v = c + d[1] - d[0];
          _[0] = Math.min(f, (v + f) / 2), _[1] = Math.max(f, (v + f) / 2);
        }
        var $ = [Math.min(f, (h + f) / 2), Math.max(f, (h + f) / 2)];
        if (t > $[0] && t <= $[1] || t >= _[0] && t <= _[1]) {
          o = a[s].index;
          break;
        }
      } else {
        var E = Math.min(l, c), D = Math.max(l, c);
        if (t > (E + f) / 2 && t <= (D + f) / 2) {
          o = a[s].index;
          break;
        }
      }
    }
  else
    for (var w = 0; w < u; w++)
      if (w === 0 && t <= (n[w].coordinate + n[w + 1].coordinate) / 2 || w > 0 && w < u - 1 && t > (n[w].coordinate + n[w - 1].coordinate) / 2 && t <= (n[w].coordinate + n[w + 1].coordinate) / 2 || w === u - 1 && t > (n[w].coordinate + n[w - 1].coordinate) / 2) {
        o = n[w].index;
        break;
      }
  return o;
}, J4 = function(t) {
  var r = t, n = r.type.displayName, a = t.props, i = a.stroke, o = a.fill, u;
  switch (n) {
    case "Line":
      u = i;
      break;
    case "Area":
    case "Radar":
      u = i && i !== "none" ? i : o;
      break;
    default:
      u = o;
      break;
  }
  return u;
}, V7e = function(t) {
  var r = t.barSize, n = t.totalSize, a = t.stackGroups, i = a === void 0 ? {} : a;
  if (!i)
    return {};
  for (var o = {}, u = Object.keys(i), d = 0, s = u.length; d < s; d++)
    for (var l = i[u[d]].stackGroups, f = Object.keys(l), c = 0, h = f.length; c < h; c++) {
      var _ = l[f[c]], F = _.items, v = _.cateAxisId, $ = F.filter(function(k) {
        return Di(k.type).indexOf("Bar") >= 0;
      });
      if ($ && $.length) {
        var E = $[0].props.barSize, D = $[0].props[v];
        o[D] || (o[D] = []);
        var w = wt(E) ? r : E;
        o[D].push({
          item: $[0],
          stackList: $.slice(1),
          barSize: wt(w) ? void 0 : dn(w, n, 0)
        });
      }
    }
  return o;
}, H7e = function(t) {
  var r = t.barGap, n = t.barCategoryGap, a = t.bandSize, i = t.sizeList, o = i === void 0 ? [] : i, u = t.maxBarSize, d = o.length;
  if (d < 1)
    return null;
  var s = dn(r, a, 0, !0), l, f = [];
  if (o[0].barSize === +o[0].barSize) {
    var c = !1, h = a / d, _ = o.reduce(function(w, k) {
      return w + k.barSize || 0;
    }, 0);
    _ += (d - 1) * s, _ >= a && (_ -= (d - 1) * s, s = 0), _ >= a && h > 0 && (c = !0, h *= 0.9, _ = d * h);
    var F = (a - _) / 2 >> 0, v = {
      offset: F - s,
      size: 0
    };
    l = o.reduce(function(w, k) {
      var A = {
        item: k.item,
        position: {
          offset: v.offset + v.size + s,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: c ? h : k.barSize
        }
      }, P = [].concat(ZE(w), [A]);
      return v = P[P.length - 1].position, k.stackList && k.stackList.length && k.stackList.forEach(function(S) {
        P.push({
          item: S,
          position: v
        });
      }), P;
    }, f);
  } else {
    var $ = dn(n, a, 0, !0);
    a - 2 * $ - (d - 1) * s <= 0 && (s = 0);
    var E = (a - 2 * $ - (d - 1) * s) / d;
    E > 1 && (E >>= 0);
    var D = u === +u ? Math.min(E, u) : E;
    l = o.reduce(function(w, k, A) {
      var P = [].concat(ZE(w), [{
        item: k.item,
        position: {
          offset: $ + (E + s) * A + (E - D) / 2,
          size: D
        }
      }]);
      return k.stackList && k.stackList.length && k.stackList.forEach(function(S) {
        P.push({
          item: S,
          position: P[P.length - 1].position
        });
      }), P;
    }, f);
  }
  return l;
}, z7e = function(t, r, n, a) {
  var i = n.children, o = n.width, u = n.margin, d = o - (u.left || 0) - (u.right || 0), s = cT({
    children: i,
    legendWidth: d
  });
  if (s) {
    var l = a || {}, f = l.width, c = l.height, h = s.align, _ = s.verticalAlign, F = s.layout;
    if ((F === "vertical" || F === "horizontal" && _ === "middle") && h !== "center" && Ve(t[h]))
      return Ln(Ln({}, t), {}, Du({}, h, t[h] + (f || 0)));
    if ((F === "horizontal" || F === "vertical" && h === "center") && _ !== "middle" && Ve(t[_]))
      return Ln(Ln({}, t), {}, Du({}, _, t[_] + (c || 0)));
  }
  return t;
}, K7e = function(t, r, n) {
  return wt(r) ? !0 : t === "horizontal" ? r === "yAxis" : t === "vertical" || n === "x" ? r === "xAxis" : n === "y" ? r === "yAxis" : !0;
}, hT = function(t, r, n, a, i) {
  var o = r.props.children, u = Wa(o, Z4).filter(function(s) {
    return K7e(a, i, s.props.direction);
  });
  if (u && u.length) {
    var d = u.map(function(s) {
      return s.props.dataKey;
    });
    return t.reduce(function(s, l) {
      var f = En(l, n);
      if (wt(f))
        return s;
      var c = Array.isArray(f) ? [bg(f), yg(f)] : [f, f], h = d.reduce(function(_, F) {
        var v = En(l, F, 0), $ = c[0] - Math.abs(Array.isArray(v) ? v[0] : v), E = c[1] + Math.abs(Array.isArray(v) ? v[1] : v);
        return [Math.min($, _[0]), Math.max(E, _[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(h[0], s[0]), Math.max(h[1], s[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, Y7e = function(t, r, n, a, i) {
  var o = r.map(function(u) {
    return hT(t, u, n, i, a);
  }).filter(function(u) {
    return !wt(u);
  });
  return o && o.length ? o.reduce(function(u, d) {
    return [Math.min(u[0], d[0]), Math.max(u[1], d[1])];
  }, [1 / 0, -1 / 0]) : null;
}, gT = function(t, r, n, a, i) {
  var o = r.map(function(d) {
    var s = d.props.dataKey;
    return n === "number" && s && hT(t, d, s, a) || yl(t, s, n, i);
  });
  if (n === "number")
    return o.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(d, s) {
        return [Math.min(d[0], s[0]), Math.max(d[1], s[1])];
      },
      [1 / 0, -1 / 0]
    );
  var u = {};
  return o.reduce(function(d, s) {
    for (var l = 0, f = s.length; l < f; l++)
      u[s[l]] || (u[s[l]] = !0, d.push(s[l]));
    return d;
  }, []);
}, _T = function(t, r) {
  return t === "horizontal" && r === "xAxis" || t === "vertical" && r === "yAxis" || t === "centric" && r === "angleAxis" || t === "radial" && r === "radiusAxis";
}, il = function(t, r, n) {
  if (!t)
    return null;
  var a = t.scale, i = t.duplicateDomain, o = t.type, u = t.range, d = t.realScaleType === "scaleBand" ? a.bandwidth() / 2 : 2, s = (r || n) && o === "category" && a.bandwidth ? a.bandwidth() / d : 0;
  if (s = t.axisType === "angleAxis" && (u == null ? void 0 : u.length) >= 2 ? Un(u[0] - u[1]) * 2 * s : s, r && (t.ticks || t.niceTicks)) {
    var l = (t.ticks || t.niceTicks).map(function(f) {
      var c = i ? i.indexOf(f) : f;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: a(c) + s,
        value: f,
        offset: s
      };
    });
    return l.filter(function(f) {
      return !Kf(f.coordinate);
    });
  }
  return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(f, c) {
    return {
      coordinate: a(f) + s,
      value: f,
      index: c,
      offset: s
    };
  }) : a.ticks && !n ? a.ticks(t.tickCount).map(function(f) {
    return {
      coordinate: a(f) + s,
      value: f,
      offset: s
    };
  }) : a.domain().map(function(f, c) {
    return {
      coordinate: a(f) + s,
      value: i ? i[f] : f,
      index: c,
      offset: s
    };
  });
}, I2 = /* @__PURE__ */ new WeakMap(), F1 = function(t, r) {
  if (typeof r != "function")
    return t;
  I2.has(t) || I2.set(t, /* @__PURE__ */ new WeakMap());
  var n = I2.get(t);
  if (n.has(r))
    return n.get(r);
  var a = function() {
    t.apply(void 0, arguments), r.apply(void 0, arguments);
  };
  return n.set(r, a), a;
}, X7e = function(t, r, n) {
  var a = t.scale, i = t.type, o = t.layout, u = t.axisType;
  if (a === "auto")
    return o === "radial" && u === "radiusAxis" ? {
      scale: Ql(),
      realScaleType: "band"
    } : o === "radial" && u === "angleAxis" ? {
      scale: B0(),
      realScaleType: "linear"
    } : i === "category" && r && (r.indexOf("LineChart") >= 0 || r.indexOf("AreaChart") >= 0 || r.indexOf("ComposedChart") >= 0 && !n) ? {
      scale: Fl(),
      realScaleType: "point"
    } : i === "category" ? {
      scale: Ql(),
      realScaleType: "band"
    } : {
      scale: B0(),
      realScaleType: "linear"
    };
  if (zf(a)) {
    var d = "scale".concat(ig(a));
    return {
      scale: (VE[d] || Fl)(),
      realScaleType: VE[d] ? d : "point"
    };
  }
  return Ft(a) ? {
    scale: a
  } : {
    scale: Fl(),
    realScaleType: "point"
  };
}, JE = 1e-4, Q7e = function(t) {
  var r = t.domain();
  if (!(!r || r.length <= 2)) {
    var n = r.length, a = t.range(), i = Math.min(a[0], a[1]) - JE, o = Math.max(a[0], a[1]) + JE, u = t(r[0]), d = t(r[n - 1]);
    (u < i || u > o || d < i || d > o) && t.domain([r[0], r[n - 1]]);
  }
}, Z7e = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, a = t[0].length; n < a; ++n)
      for (var i = 0, o = 0, u = 0; u < r; ++u) {
        var d = Kf(t[u][n][1]) ? t[u][n][0] : t[u][n][1];
        d >= 0 ? (t[u][n][0] = i, t[u][n][1] = i + d, i = t[u][n][1]) : (t[u][n][0] = o, t[u][n][1] = o + d, o = t[u][n][1]);
      }
}, J7e = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, a = t[0].length; n < a; ++n)
      for (var i = 0, o = 0; o < r; ++o) {
        var u = Kf(t[o][n][1]) ? t[o][n][0] : t[o][n][1];
        u >= 0 ? (t[o][n][0] = i, t[o][n][1] = i + u, i = t[o][n][1]) : (t[o][n][0] = 0, t[o][n][1] = 0);
      }
}, eEe = {
  sign: Z7e,
  // @ts-expect-error definitelytyped types are incorrect
  expand: R2e,
  // @ts-expect-error definitelytyped types are incorrect
  none: Mu,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: j2e,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: M2e,
  positive: J7e
}, tEe = function(t, r, n) {
  var a = r.map(function(u) {
    return u.props.dataKey;
  }), i = eEe[n], o = I2e().keys(a).value(function(u, d) {
    return +En(u, d, 0);
  }).order(up).offset(i);
  return o(t);
}, rEe = function(t, r, n, a, i, o) {
  if (!t)
    return null;
  var u = o ? r.reverse() : r, d = {}, s = u.reduce(function(f, c) {
    var h = c.props, _ = h.stackId, F = h.hide;
    if (F)
      return f;
    var v = c.props[n], $ = f[v] || {
      hasStack: !1,
      stackGroups: {}
    };
    if ($r(_)) {
      var E = $.stackGroups[_] || {
        numericAxisId: n,
        cateAxisId: a,
        items: []
      };
      E.items.push(c), $.hasStack = !0, $.stackGroups[_] = E;
    } else
      $.stackGroups[ng("_stackId_")] = {
        numericAxisId: n,
        cateAxisId: a,
        items: [c]
      };
    return Ln(Ln({}, f), {}, Du({}, v, $));
  }, d), l = {};
  return Object.keys(s).reduce(function(f, c) {
    var h = s[c];
    if (h.hasStack) {
      var _ = {};
      h.stackGroups = Object.keys(h.stackGroups).reduce(function(F, v) {
        var $ = h.stackGroups[v];
        return Ln(Ln({}, F), {}, Du({}, v, {
          numericAxisId: n,
          cateAxisId: a,
          items: $.items,
          stackedData: tEe(t, $.items, i)
        }));
      }, _);
    }
    return Ln(Ln({}, f), {}, Du({}, c, h));
  }, l);
}, nEe = function(t, r) {
  var n = r.realScaleType, a = r.type, i = r.tickCount, o = r.originalDomain, u = r.allowDecimals, d = n || r.scale;
  if (d !== "auto" && d !== "linear")
    return null;
  if (i && a === "number" && o && (o[0] === "auto" || o[1] === "auto")) {
    var s = t.domain();
    if (!s.length)
      return null;
    var l = w7e(s, i, u);
    return t.domain([bg(l), yg(l)]), {
      niceTicks: l
    };
  }
  if (i && a === "number") {
    var f = t.domain(), c = k7e(f, i, u);
    return {
      niceTicks: c
    };
  }
  return null;
}, aEe = function(t, r) {
  var n = t.props.stackId;
  if ($r(n)) {
    var a = r[n];
    if (a) {
      var i = a.items.indexOf(t);
      return i >= 0 ? a.stackedData[i] : null;
    }
  }
  return null;
}, iEe = function(t) {
  return t.reduce(function(r, n) {
    return [bg(n.concat([r[0]]).filter(Ve)), yg(n.concat([r[1]]).filter(Ve))];
  }, [1 / 0, -1 / 0]);
}, mT = function(t, r, n) {
  return Object.keys(t).reduce(function(a, i) {
    var o = t[i], u = o.stackedData, d = u.reduce(function(s, l) {
      var f = iEe(l.slice(r, n + 1));
      return [Math.min(s[0], f[0]), Math.max(s[1], f[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(d[0], a[0]), Math.max(d[1], a[1])];
  }, [1 / 0, -1 / 0]).map(function(a) {
    return a === 1 / 0 || a === -1 / 0 ? 0 : a;
  });
}, e$ = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, t$ = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, Bp = function(t, r, n) {
  if (Ft(t))
    return t(r, n);
  if (!Array.isArray(t))
    return r;
  var a = [];
  if (Ve(t[0]))
    a[0] = n ? t[0] : Math.min(t[0], r[0]);
  else if (e$.test(t[0])) {
    var i = +e$.exec(t[0])[1];
    a[0] = r[0] - i;
  } else
    Ft(t[0]) ? a[0] = t[0](r[0]) : a[0] = r[0];
  if (Ve(t[1]))
    a[1] = n ? t[1] : Math.max(t[1], r[1]);
  else if (t$.test(t[1])) {
    var o = +t$.exec(t[1])[1];
    a[1] = r[1] + o;
  } else
    Ft(t[1]) ? a[1] = t[1](r[1]) : a[1] = r[1];
  return a;
}, Np = function(t, r, n) {
  if (t && t.scale && t.scale.bandwidth) {
    var a = t.scale.bandwidth();
    if (!n || a > 0)
      return a;
  }
  if (t && r && r.length >= 2) {
    for (var i = k4(r, function(f) {
      return f.coordinate;
    }), o = 1 / 0, u = 1, d = i.length; u < d; u++) {
      var s = i[u], l = i[u - 1];
      o = Math.min((s.coordinate || 0) - (l.coordinate || 0), o);
    }
    return o === 1 / 0 ? 0 : o;
  }
  return n ? void 0 : 0;
}, r$ = function(t, r, n) {
  return !t || !t.length || Y4(t, Hn(n, "type.defaultProps.domain")) ? r : t;
}, oEe = function(t, r) {
  var n = t.props, a = n.dataKey, i = n.name, o = n.unit, u = n.formatter, d = n.tooltipType, s = n.chartType, l = n.hide;
  return Ln(Ln({}, _t(t, !1)), {}, {
    dataKey: a,
    unit: o,
    formatter: u,
    name: i || a,
    color: J4(t),
    value: En(r, a),
    type: d,
    payload: r,
    chartType: s,
    hide: l
  });
};
function sf(e) {
  return sf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, sf(e);
}
function n$(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function yi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? n$(Object(r), !0).forEach(function(n) {
      pT(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n$(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function pT(e, t, r) {
  return t = sEe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function sEe(e) {
  var t = uEe(e, "string");
  return sf(t) == "symbol" ? t : String(t);
}
function uEe(e, t) {
  if (sf(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (sf(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function dEe(e, t) {
  return hEe(e) || cEe(e, t) || fEe(e, t) || lEe();
}
function lEe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fEe(e, t) {
  if (e) {
    if (typeof e == "string")
      return a$(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return a$(e, t);
  }
}
function a$(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function cEe(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], d = !0, s = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        d = !1;
      } else
        for (; !(d = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); d = !0)
          ;
    } catch (l) {
      s = !0, a = l;
    } finally {
      try {
        if (!d && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (s)
          throw a;
      }
    }
    return u;
  }
}
function hEe(e) {
  if (Array.isArray(e))
    return e;
}
var W0 = Math.PI / 180, gEe = function(t) {
  return t * 180 / Math.PI;
}, Vt = function(t, r, n, a) {
  return {
    x: t + Math.cos(-W0 * a) * n,
    y: r + Math.sin(-W0 * a) * n
  };
}, FT = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(t - (n.left || 0) - (n.right || 0)), Math.abs(r - (n.top || 0) - (n.bottom || 0))) / 2;
}, _Ee = function(t, r, n, a, i) {
  var o = t.width, u = t.height, d = t.startAngle, s = t.endAngle, l = dn(t.cx, o, o / 2), f = dn(t.cy, u, u / 2), c = FT(o, u, n), h = dn(t.innerRadius, c, 0), _ = dn(t.outerRadius, c, c * 0.8), F = Object.keys(r);
  return F.reduce(function(v, $) {
    var E = r[$], D = E.domain, w = E.reversed, k;
    if (wt(E.range))
      a === "angleAxis" ? k = [d, s] : a === "radiusAxis" && (k = [h, _]), w && (k = [k[1], k[0]]);
    else {
      k = E.range;
      var A = k, P = dEe(A, 2);
      d = P[0], s = P[1];
    }
    var S = X7e(E, i), N = S.realScaleType, W = S.scale;
    W.domain(D).range(k), Q7e(W);
    var V = nEe(W, yi(yi({}, E), {}, {
      realScaleType: N
    })), K = yi(yi(yi({}, E), V), {}, {
      range: k,
      radius: _,
      realScaleType: N,
      scale: W,
      cx: l,
      cy: f,
      innerRadius: h,
      outerRadius: _,
      startAngle: d,
      endAngle: s
    });
    return yi(yi({}, v), {}, pT({}, $, K));
  }, {});
}, mEe = function(t, r) {
  var n = t.x, a = t.y, i = r.x, o = r.y;
  return Math.sqrt(Math.pow(n - i, 2) + Math.pow(a - o, 2));
}, pEe = function(t, r) {
  var n = t.x, a = t.y, i = r.cx, o = r.cy, u = mEe({
    x: n,
    y: a
  }, {
    x: i,
    y: o
  });
  if (u <= 0)
    return {
      radius: u
    };
  var d = (n - i) / u, s = Math.acos(d);
  return a > o && (s = 2 * Math.PI - s), {
    radius: u,
    angle: gEe(s),
    angleInRadian: s
  };
}, FEe = function(t) {
  var r = t.startAngle, n = t.endAngle, a = Math.floor(r / 360), i = Math.floor(n / 360), o = Math.min(a, i);
  return {
    startAngle: r - o * 360,
    endAngle: n - o * 360
  };
}, yEe = function(t, r) {
  var n = r.startAngle, a = r.endAngle, i = Math.floor(n / 360), o = Math.floor(a / 360), u = Math.min(i, o);
  return t + u * 360;
}, i$ = function(t, r) {
  var n = t.x, a = t.y, i = pEe({
    x: n,
    y: a
  }, r), o = i.radius, u = i.angle, d = r.innerRadius, s = r.outerRadius;
  if (o < d || o > s)
    return !1;
  if (o === 0)
    return !0;
  var l = FEe(r), f = l.startAngle, c = l.endAngle, h = u, _;
  if (f <= c) {
    for (; h > c; )
      h -= 360;
    for (; h < f; )
      h += 360;
    _ = h >= f && h <= c;
  } else {
    for (; h > f; )
      h -= 360;
    for (; h < c; )
      h += 360;
    _ = h >= c && h <= f;
  }
  return _ ? yi(yi({}, r), {}, {
    radius: o,
    angle: yEe(h, r)
  }) : null;
}, yT = function(t) {
  return !/* @__PURE__ */ $n(t) && !Ft(t) && typeof t != "boolean" ? t.className : "";
};
function uf(e) {
  return uf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, uf(e);
}
var bEe = ["offset"];
function vEe(e) {
  return kEe(e) || wEe(e) || $Ee(e) || EEe();
}
function EEe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $Ee(e, t) {
  if (e) {
    if (typeof e == "string")
      return Lp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Lp(e, t);
  }
}
function wEe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function kEe(e) {
  if (Array.isArray(e))
    return Lp(e);
}
function Lp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function xEe(e, t) {
  if (e == null)
    return {};
  var r = DEe(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function DEe(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function o$(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? o$(Object(r), !0).forEach(function(n) {
      CEe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : o$(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function CEe(e, t, r) {
  return t = SEe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function SEe(e) {
  var t = AEe(e, "string");
  return uf(t) == "symbol" ? t : String(t);
}
function AEe(e, t) {
  if (uf(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (uf(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function df() {
  return df = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, df.apply(this, arguments);
}
var OEe = function(t) {
  var r = t.value, n = t.formatter, a = wt(t.children) ? r : t.children;
  return Ft(n) ? n(a) : a;
}, TEe = function(t, r) {
  var n = Un(r - t), a = Math.min(Math.abs(r - t), 360);
  return n * a;
}, PEe = function(t, r, n) {
  var a = t.position, i = t.viewBox, o = t.offset, u = t.className, d = i, s = d.cx, l = d.cy, f = d.innerRadius, c = d.outerRadius, h = d.startAngle, _ = d.endAngle, F = d.clockWise, v = (f + c) / 2, $ = TEe(h, _), E = $ >= 0 ? 1 : -1, D, w;
  a === "insideStart" ? (D = h + E * o, w = F) : a === "insideEnd" ? (D = _ - E * o, w = !F) : a === "end" && (D = _ + E * o, w = F), w = $ <= 0 ? w : !w;
  var k = Vt(s, l, v, D), A = Vt(s, l, v, D + (w ? 1 : -1) * 359), P = "M".concat(k.x, ",").concat(k.y, `
    A`).concat(v, ",").concat(v, ",0,1,").concat(w ? 0 : 1, `,
    `).concat(A.x, ",").concat(A.y), S = wt(t.id) ? ng("recharts-radial-line-") : t.id;
  return /* @__PURE__ */ M.createElement("text", df({}, n, {
    dominantBaseline: "central",
    className: Ct("recharts-radial-bar-label", u)
  }), /* @__PURE__ */ M.createElement("defs", null, /* @__PURE__ */ M.createElement("path", {
    id: S,
    d: P
  })), /* @__PURE__ */ M.createElement("textPath", {
    xlinkHref: "#".concat(S)
  }, r));
}, IEe = function(t) {
  var r = t.viewBox, n = t.offset, a = t.position, i = r, o = i.cx, u = i.cy, d = i.innerRadius, s = i.outerRadius, l = i.startAngle, f = i.endAngle, c = (l + f) / 2;
  if (a === "outside") {
    var h = Vt(o, u, s + n, c), _ = h.x, F = h.y;
    return {
      x: _,
      y: F,
      textAnchor: _ >= o ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (a === "center")
    return {
      x: o,
      y: u,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (a === "centerTop")
    return {
      x: o,
      y: u,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (a === "centerBottom")
    return {
      x: o,
      y: u,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var v = (d + s) / 2, $ = Vt(o, u, v, c), E = $.x, D = $.y;
  return {
    x: E,
    y: D,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, REe = function(t) {
  var r = t.viewBox, n = t.parentViewBox, a = t.offset, i = t.position, o = r, u = o.x, d = o.y, s = o.width, l = o.height, f = l >= 0 ? 1 : -1, c = f * a, h = f > 0 ? "end" : "start", _ = f > 0 ? "start" : "end", F = s >= 0 ? 1 : -1, v = F * a, $ = F > 0 ? "end" : "start", E = F > 0 ? "start" : "end";
  if (i === "top") {
    var D = {
      x: u + s / 2,
      y: d - f * a,
      textAnchor: "middle",
      verticalAnchor: h
    };
    return vr(vr({}, D), n ? {
      height: Math.max(d - n.y, 0),
      width: s
    } : {});
  }
  if (i === "bottom") {
    var w = {
      x: u + s / 2,
      y: d + l + c,
      textAnchor: "middle",
      verticalAnchor: _
    };
    return vr(vr({}, w), n ? {
      height: Math.max(n.y + n.height - (d + l), 0),
      width: s
    } : {});
  }
  if (i === "left") {
    var k = {
      x: u - v,
      y: d + l / 2,
      textAnchor: $,
      verticalAnchor: "middle"
    };
    return vr(vr({}, k), n ? {
      width: Math.max(k.x - n.x, 0),
      height: l
    } : {});
  }
  if (i === "right") {
    var A = {
      x: u + s + v,
      y: d + l / 2,
      textAnchor: E,
      verticalAnchor: "middle"
    };
    return vr(vr({}, A), n ? {
      width: Math.max(n.x + n.width - A.x, 0),
      height: l
    } : {});
  }
  var P = n ? {
    width: s,
    height: l
  } : {};
  return i === "insideLeft" ? vr({
    x: u + v,
    y: d + l / 2,
    textAnchor: E,
    verticalAnchor: "middle"
  }, P) : i === "insideRight" ? vr({
    x: u + s - v,
    y: d + l / 2,
    textAnchor: $,
    verticalAnchor: "middle"
  }, P) : i === "insideTop" ? vr({
    x: u + s / 2,
    y: d + c,
    textAnchor: "middle",
    verticalAnchor: _
  }, P) : i === "insideBottom" ? vr({
    x: u + s / 2,
    y: d + l - c,
    textAnchor: "middle",
    verticalAnchor: h
  }, P) : i === "insideTopLeft" ? vr({
    x: u + v,
    y: d + c,
    textAnchor: E,
    verticalAnchor: _
  }, P) : i === "insideTopRight" ? vr({
    x: u + s - v,
    y: d + c,
    textAnchor: $,
    verticalAnchor: _
  }, P) : i === "insideBottomLeft" ? vr({
    x: u + v,
    y: d + l - c,
    textAnchor: E,
    verticalAnchor: h
  }, P) : i === "insideBottomRight" ? vr({
    x: u + s - v,
    y: d + l - c,
    textAnchor: $,
    verticalAnchor: h
  }, P) : Dn(i) && (Ve(i.x) || ss(i.x)) && (Ve(i.y) || ss(i.y)) ? vr({
    x: u + dn(i.x, s),
    y: d + dn(i.y, l),
    textAnchor: "end",
    verticalAnchor: "end"
  }, P) : vr({
    x: u + s / 2,
    y: d + l / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, P);
}, jEe = function(t) {
  return "cx" in t && Ve(t.cx);
};
function Br(e) {
  var t = e.offset, r = t === void 0 ? 5 : t, n = xEe(e, bEe), a = vr({
    offset: r
  }, n), i = a.viewBox, o = a.position, u = a.value, d = a.children, s = a.content, l = a.className, f = l === void 0 ? "" : l, c = a.textBreakAll;
  if (!i || wt(u) && wt(d) && !/* @__PURE__ */ $n(s) && !Ft(s))
    return null;
  if (/* @__PURE__ */ $n(s))
    return /* @__PURE__ */ gr(s, a);
  var h;
  if (Ft(s)) {
    if (h = /* @__PURE__ */ uh(s, a), /* @__PURE__ */ $n(h))
      return h;
  } else
    h = OEe(a);
  var _ = jEe(i), F = _t(a, !0);
  if (_ && (o === "insideStart" || o === "insideEnd" || o === "end"))
    return PEe(a, h, F);
  var v = _ ? IEe(a) : REe(a);
  return /* @__PURE__ */ M.createElement(Gu, df({
    className: Ct("recharts-label", f)
  }, F, v, {
    breakAll: c
  }), h);
}
Br.displayName = "Label";
var bT = function(t) {
  var r = t.cx, n = t.cy, a = t.angle, i = t.startAngle, o = t.endAngle, u = t.r, d = t.radius, s = t.innerRadius, l = t.outerRadius, f = t.x, c = t.y, h = t.top, _ = t.left, F = t.width, v = t.height, $ = t.clockWise, E = t.labelViewBox;
  if (E)
    return E;
  if (Ve(F) && Ve(v)) {
    if (Ve(f) && Ve(c))
      return {
        x: f,
        y: c,
        width: F,
        height: v
      };
    if (Ve(h) && Ve(_))
      return {
        x: h,
        y: _,
        width: F,
        height: v
      };
  }
  return Ve(f) && Ve(c) ? {
    x: f,
    y: c,
    width: 0,
    height: 0
  } : Ve(r) && Ve(n) ? {
    cx: r,
    cy: n,
    startAngle: i || a || 0,
    endAngle: o || a || 0,
    innerRadius: s || 0,
    outerRadius: l || d || u || 0,
    clockWise: $
  } : t.viewBox ? t.viewBox : {};
}, MEe = function(t, r) {
  return t ? t === !0 ? /* @__PURE__ */ M.createElement(Br, {
    key: "label-implicit",
    viewBox: r
  }) : $r(t) ? /* @__PURE__ */ M.createElement(Br, {
    key: "label-implicit",
    viewBox: r,
    value: t
  }) : /* @__PURE__ */ $n(t) ? t.type === Br ? /* @__PURE__ */ gr(t, {
    key: "label-implicit",
    viewBox: r
  }) : /* @__PURE__ */ M.createElement(Br, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : Ft(t) ? /* @__PURE__ */ M.createElement(Br, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : Dn(t) ? /* @__PURE__ */ M.createElement(Br, df({
    viewBox: r
  }, t, {
    key: "label-implicit"
  })) : null : null;
}, BEe = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && n && !t.label)
    return null;
  var a = t.children, i = bT(t), o = Wa(a, Br).map(function(d, s) {
    return /* @__PURE__ */ gr(d, {
      viewBox: r || i,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(s)
    });
  });
  if (!n)
    return o;
  var u = MEe(t.label, r || i);
  return [u].concat(vEe(o));
};
Br.parseViewBox = bT;
Br.renderCallByParent = BEe;
function NEe(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var LEe = NEe;
function lf(e) {
  return lf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, lf(e);
}
var qEe = ["valueAccessor"], UEe = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function GEe(e) {
  return zEe(e) || HEe(e) || VEe(e) || WEe();
}
function WEe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function VEe(e, t) {
  if (e) {
    if (typeof e == "string")
      return qp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return qp(e, t);
  }
}
function HEe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function zEe(e) {
  if (Array.isArray(e))
    return qp(e);
}
function qp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function V0() {
  return V0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, V0.apply(this, arguments);
}
function s$(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function u$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? s$(Object(r), !0).forEach(function(n) {
      KEe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : s$(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function KEe(e, t, r) {
  return t = YEe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function YEe(e) {
  var t = XEe(e, "string");
  return lf(t) == "symbol" ? t : String(t);
}
function XEe(e, t) {
  if (lf(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (lf(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function d$(e, t) {
  if (e == null)
    return {};
  var r = QEe(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function QEe(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var ZEe = function(t) {
  return Array.isArray(t.value) ? LEe(t.value) : t.value;
};
function _s(e) {
  var t = e.valueAccessor, r = t === void 0 ? ZEe : t, n = d$(e, qEe), a = n.data, i = n.dataKey, o = n.clockWise, u = n.id, d = n.textBreakAll, s = d$(n, UEe);
  return !a || !a.length ? null : /* @__PURE__ */ M.createElement(cr, {
    className: "recharts-label-list"
  }, a.map(function(l, f) {
    var c = wt(i) ? r(l, f) : En(l && l.payload, i), h = wt(u) ? {} : {
      id: "".concat(u, "-").concat(f)
    };
    return /* @__PURE__ */ M.createElement(Br, V0({}, _t(l, !0), s, h, {
      parentViewBox: l.parentViewBox,
      value: c,
      textBreakAll: d,
      viewBox: Br.parseViewBox(wt(o) ? l : u$(u$({}, l), {}, {
        clockWise: o
      })),
      key: "label-".concat(f),
      index: f
    }));
  }));
}
_s.displayName = "LabelList";
function JEe(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ M.createElement(_s, {
    key: "labelList-implicit",
    data: t
  }) : /* @__PURE__ */ M.isValidElement(e) || Ft(e) ? /* @__PURE__ */ M.createElement(_s, {
    key: "labelList-implicit",
    data: t,
    content: e
  }) : Dn(e) ? /* @__PURE__ */ M.createElement(_s, V0({
    data: t
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function e$e(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && r && !e.label)
    return null;
  var n = e.children, a = Wa(n, _s).map(function(o, u) {
    return /* @__PURE__ */ gr(o, {
      data: t,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(u)
    });
  });
  if (!r)
    return a;
  var i = JEe(e.label, t);
  return [i].concat(GEe(a));
}
_s.renderCallByParent = e$e;
function ff(e) {
  return ff = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ff(e);
}
function Up() {
  return Up = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Up.apply(this, arguments);
}
function l$(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function f$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? l$(Object(r), !0).forEach(function(n) {
      t$e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : l$(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function t$e(e, t, r) {
  return t = r$e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function r$e(e) {
  var t = n$e(e, "string");
  return ff(t) == "symbol" ? t : String(t);
}
function n$e(e, t) {
  if (ff(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (ff(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var a$e = function(t, r) {
  var n = Un(r - t), a = Math.min(Math.abs(r - t), 359.999);
  return n * a;
}, y1 = function(t) {
  var r = t.cx, n = t.cy, a = t.radius, i = t.angle, o = t.sign, u = t.isExternal, d = t.cornerRadius, s = t.cornerIsExternal, l = d * (u ? 1 : -1) + a, f = Math.asin(d / l) / W0, c = s ? i : i + o * f, h = Vt(r, n, l, c), _ = Vt(r, n, a, c), F = s ? i - o * f : i, v = Vt(r, n, l * Math.cos(f * W0), F);
  return {
    center: h,
    circleTangency: _,
    lineTangency: v,
    theta: f
  };
}, vT = function(t) {
  var r = t.cx, n = t.cy, a = t.innerRadius, i = t.outerRadius, o = t.startAngle, u = t.endAngle, d = a$e(o, u), s = o + d, l = Vt(r, n, i, o), f = Vt(r, n, i, s), c = "M ".concat(l.x, ",").concat(l.y, `
    A `).concat(i, ",").concat(i, `,0,
    `).concat(+(Math.abs(d) > 180), ",").concat(+(o > s), `,
    `).concat(f.x, ",").concat(f.y, `
  `);
  if (a > 0) {
    var h = Vt(r, n, a, o), _ = Vt(r, n, a, s);
    c += "L ".concat(_.x, ",").concat(_.y, `
            A `).concat(a, ",").concat(a, `,0,
            `).concat(+(Math.abs(d) > 180), ",").concat(+(o <= s), `,
            `).concat(h.x, ",").concat(h.y, " Z");
  } else
    c += "L ".concat(r, ",").concat(n, " Z");
  return c;
}, i$e = function(t) {
  var r = t.cx, n = t.cy, a = t.innerRadius, i = t.outerRadius, o = t.cornerRadius, u = t.forceCornerRadius, d = t.cornerIsExternal, s = t.startAngle, l = t.endAngle, f = Un(l - s), c = y1({
    cx: r,
    cy: n,
    radius: i,
    angle: s,
    sign: f,
    cornerRadius: o,
    cornerIsExternal: d
  }), h = c.circleTangency, _ = c.lineTangency, F = c.theta, v = y1({
    cx: r,
    cy: n,
    radius: i,
    angle: l,
    sign: -f,
    cornerRadius: o,
    cornerIsExternal: d
  }), $ = v.circleTangency, E = v.lineTangency, D = v.theta, w = d ? Math.abs(s - l) : Math.abs(s - l) - F - D;
  if (w < 0)
    return u ? "M ".concat(_.x, ",").concat(_.y, `
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(o * 2, `,0
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(-o * 2, `,0
      `) : vT({
      cx: r,
      cy: n,
      innerRadius: a,
      outerRadius: i,
      startAngle: s,
      endAngle: l
    });
  var k = "M ".concat(_.x, ",").concat(_.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(h.x, ",").concat(h.y, `
    A`).concat(i, ",").concat(i, ",0,").concat(+(w > 180), ",").concat(+(f < 0), ",").concat($.x, ",").concat($.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(E.x, ",").concat(E.y, `
  `);
  if (a > 0) {
    var A = y1({
      cx: r,
      cy: n,
      radius: a,
      angle: s,
      sign: f,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: d
    }), P = A.circleTangency, S = A.lineTangency, N = A.theta, W = y1({
      cx: r,
      cy: n,
      radius: a,
      angle: l,
      sign: -f,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: d
    }), V = W.circleTangency, K = W.lineTangency, U = W.theta, j = d ? Math.abs(s - l) : Math.abs(s - l) - N - U;
    if (j < 0 && o === 0)
      return "".concat(k, "L").concat(r, ",").concat(n, "Z");
    k += "L".concat(K.x, ",").concat(K.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(V.x, ",").concat(V.y, `
      A`).concat(a, ",").concat(a, ",0,").concat(+(j > 180), ",").concat(+(f > 0), ",").concat(P.x, ",").concat(P.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(S.x, ",").concat(S.y, "Z");
  } else
    k += "L".concat(r, ",").concat(n, "Z");
  return k;
}, o$e = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, ET = function(t) {
  var r = f$(f$({}, o$e), t), n = r.cx, a = r.cy, i = r.innerRadius, o = r.outerRadius, u = r.cornerRadius, d = r.forceCornerRadius, s = r.cornerIsExternal, l = r.startAngle, f = r.endAngle, c = r.className;
  if (o < i || l === f)
    return null;
  var h = Ct("recharts-sector", c), _ = o - i, F = dn(u, _, 0, !0), v;
  return F > 0 && Math.abs(l - f) < 360 ? v = i$e({
    cx: n,
    cy: a,
    innerRadius: i,
    outerRadius: o,
    cornerRadius: Math.min(F, _ / 2),
    forceCornerRadius: d,
    cornerIsExternal: s,
    startAngle: l,
    endAngle: f
  }) : v = vT({
    cx: n,
    cy: a,
    innerRadius: i,
    outerRadius: o,
    startAngle: l,
    endAngle: f
  }), /* @__PURE__ */ M.createElement("path", Up({}, _t(r, !0), {
    className: h,
    d: v,
    role: "img"
  }));
};
function cf(e) {
  return cf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, cf(e);
}
function Gp() {
  return Gp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Gp.apply(this, arguments);
}
function c$(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function h$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? c$(Object(r), !0).forEach(function(n) {
      s$e(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : c$(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function s$e(e, t, r) {
  return t = u$e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function u$e(e) {
  var t = d$e(e, "string");
  return cf(t) == "symbol" ? t : String(t);
}
function d$e(e, t) {
  if (cf(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (cf(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var g$ = {
  curveBasisClosed: $2e,
  curveBasisOpen: w2e,
  curveBasis: E2e,
  curveBumpX: u2e,
  curveBumpY: d2e,
  curveLinearClosed: k2e,
  curveLinear: sg,
  curveMonotoneX: x2e,
  curveMonotoneY: D2e,
  curveNatural: C2e,
  curveStep: S2e,
  curveStepAfter: O2e,
  curveStepBefore: A2e
}, b1 = function(t) {
  return t.x === +t.x && t.y === +t.y;
}, el = function(t) {
  return t.x;
}, tl = function(t) {
  return t.y;
}, l$e = function(t, r) {
  if (Ft(t))
    return t;
  var n = "curve".concat(ig(t));
  return (n === "curveMonotone" || n === "curveBump") && r ? g$["".concat(n).concat(r === "vertical" ? "Y" : "X")] : g$[n] || sg;
}, f$e = function(t) {
  var r = t.type, n = r === void 0 ? "linear" : r, a = t.points, i = a === void 0 ? [] : a, o = t.baseLine, u = t.layout, d = t.connectNulls, s = d === void 0 ? !1 : d, l = l$e(n, u), f = s ? i.filter(function(F) {
    return b1(F);
  }) : i, c;
  if (Array.isArray(o)) {
    var h = s ? o.filter(function(F) {
      return b1(F);
    }) : o, _ = f.map(function(F, v) {
      return h$(h$({}, F), {}, {
        base: h[v]
      });
    });
    return u === "vertical" ? c = l1().y(tl).x1(el).x0(function(F) {
      return F.base.x;
    }) : c = l1().x(el).y1(tl).y0(function(F) {
      return F.base.y;
    }), c.defined(b1).curve(l), c(_);
  }
  return u === "vertical" && Ve(o) ? c = l1().y(tl).x1(el).x0(o) : Ve(o) ? c = l1().x(el).y1(tl).y0(o) : c = wA().x(el).y(tl), c.defined(b1).curve(l), c(f);
}, Wp = function(t) {
  var r = t.className, n = t.points, a = t.path, i = t.pathRef;
  if ((!n || !n.length) && !a)
    return null;
  var o = n && n.length ? f$e(t) : a;
  return /* @__PURE__ */ M.createElement("path", Gp({}, _t(t, !1), F0(t), {
    className: Ct("recharts-curve", r),
    d: o,
    ref: i
  }));
}, c$e = Object.getOwnPropertyNames, h$e = Object.getOwnPropertySymbols, g$e = Object.prototype.hasOwnProperty;
function _$(e, t) {
  return function(n, a, i) {
    return e(n, a, i) && t(n, a, i);
  };
}
function v1(e) {
  return function(r, n, a) {
    if (!r || !n || typeof r != "object" || typeof n != "object")
      return e(r, n, a);
    var i = a.cache, o = i.get(r), u = i.get(n);
    if (o && u)
      return o === n && u === r;
    i.set(r, n), i.set(n, r);
    var d = e(r, n, a);
    return i.delete(r), i.delete(n), d;
  };
}
function m$(e) {
  return c$e(e).concat(h$e(e));
}
var $T = Object.hasOwn || function(e, t) {
  return g$e.call(e, t);
};
function $d(e, t) {
  return e || t ? e === t : e === t || e !== e && t !== t;
}
var wT = "_owner", p$ = Object.getOwnPropertyDescriptor, F$ = Object.keys;
function _$e(e, t, r) {
  var n = e.length;
  if (t.length !== n)
    return !1;
  for (; n-- > 0; )
    if (!r.equals(e[n], t[n], n, n, e, t, r))
      return !1;
  return !0;
}
function m$e(e, t) {
  return $d(e.getTime(), t.getTime());
}
function y$(e, t, r) {
  if (e.size !== t.size)
    return !1;
  for (var n = {}, a = e.entries(), i = 0, o, u; (o = a.next()) && !o.done; ) {
    for (var d = t.entries(), s = !1, l = 0; (u = d.next()) && !u.done; ) {
      var f = o.value, c = f[0], h = f[1], _ = u.value, F = _[0], v = _[1];
      !s && !n[l] && (s = r.equals(c, F, i, l, e, t, r) && r.equals(h, v, c, F, e, t, r)) && (n[l] = !0), l++;
    }
    if (!s)
      return !1;
    i++;
  }
  return !0;
}
function p$e(e, t, r) {
  var n = F$(e), a = n.length;
  if (F$(t).length !== a)
    return !1;
  for (var i; a-- > 0; )
    if (i = n[a], i === wT && (e.$$typeof || t.$$typeof) && e.$$typeof !== t.$$typeof || !$T(t, i) || !r.equals(e[i], t[i], i, i, e, t, r))
      return !1;
  return !0;
}
function rl(e, t, r) {
  var n = m$(e), a = n.length;
  if (m$(t).length !== a)
    return !1;
  for (var i, o, u; a-- > 0; )
    if (i = n[a], i === wT && (e.$$typeof || t.$$typeof) && e.$$typeof !== t.$$typeof || !$T(t, i) || !r.equals(e[i], t[i], i, i, e, t, r) || (o = p$(e, i), u = p$(t, i), (o || u) && (!o || !u || o.configurable !== u.configurable || o.enumerable !== u.enumerable || o.writable !== u.writable)))
      return !1;
  return !0;
}
function F$e(e, t) {
  return $d(e.valueOf(), t.valueOf());
}
function y$e(e, t) {
  return e.source === t.source && e.flags === t.flags;
}
function b$(e, t, r) {
  if (e.size !== t.size)
    return !1;
  for (var n = {}, a = e.values(), i, o; (i = a.next()) && !i.done; ) {
    for (var u = t.values(), d = !1, s = 0; (o = u.next()) && !o.done; )
      !d && !n[s] && (d = r.equals(i.value, o.value, i.value, o.value, e, t, r)) && (n[s] = !0), s++;
    if (!d)
      return !1;
  }
  return !0;
}
function b$e(e, t) {
  var r = e.length;
  if (t.length !== r)
    return !1;
  for (; r-- > 0; )
    if (e[r] !== t[r])
      return !1;
  return !0;
}
var v$e = "[object Arguments]", E$e = "[object Boolean]", $$e = "[object Date]", w$e = "[object Map]", k$e = "[object Number]", x$e = "[object Object]", D$e = "[object RegExp]", C$e = "[object Set]", S$e = "[object String]", A$e = Array.isArray, v$ = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, E$ = Object.assign, O$e = Object.prototype.toString.call.bind(Object.prototype.toString);
function T$e(e) {
  var t = e.areArraysEqual, r = e.areDatesEqual, n = e.areMapsEqual, a = e.areObjectsEqual, i = e.arePrimitiveWrappersEqual, o = e.areRegExpsEqual, u = e.areSetsEqual, d = e.areTypedArraysEqual;
  return function(l, f, c) {
    if (l === f)
      return !0;
    if (l == null || f == null || typeof l != "object" || typeof f != "object")
      return l !== l && f !== f;
    var h = l.constructor;
    if (h !== f.constructor)
      return !1;
    if (h === Object)
      return a(l, f, c);
    if (A$e(l))
      return t(l, f, c);
    if (v$ != null && v$(l))
      return d(l, f, c);
    if (h === Date)
      return r(l, f, c);
    if (h === RegExp)
      return o(l, f, c);
    if (h === Map)
      return n(l, f, c);
    if (h === Set)
      return u(l, f, c);
    var _ = O$e(l);
    return _ === $$e ? r(l, f, c) : _ === D$e ? o(l, f, c) : _ === w$e ? n(l, f, c) : _ === C$e ? u(l, f, c) : _ === x$e ? typeof l.then != "function" && typeof f.then != "function" && a(l, f, c) : _ === v$e ? a(l, f, c) : _ === E$e || _ === k$e || _ === S$e ? i(l, f, c) : !1;
  };
}
function P$e(e) {
  var t = e.circular, r = e.createCustomConfig, n = e.strict, a = {
    areArraysEqual: n ? rl : _$e,
    areDatesEqual: m$e,
    areMapsEqual: n ? _$(y$, rl) : y$,
    areObjectsEqual: n ? rl : p$e,
    arePrimitiveWrappersEqual: F$e,
    areRegExpsEqual: y$e,
    areSetsEqual: n ? _$(b$, rl) : b$,
    areTypedArraysEqual: n ? rl : b$e
  };
  if (r && (a = E$({}, a, r(a))), t) {
    var i = v1(a.areArraysEqual), o = v1(a.areMapsEqual), u = v1(a.areObjectsEqual), d = v1(a.areSetsEqual);
    a = E$({}, a, {
      areArraysEqual: i,
      areMapsEqual: o,
      areObjectsEqual: u,
      areSetsEqual: d
    });
  }
  return a;
}
function I$e(e) {
  return function(t, r, n, a, i, o, u) {
    return e(t, r, u);
  };
}
function R$e(e) {
  var t = e.circular, r = e.comparator, n = e.createState, a = e.equals, i = e.strict;
  if (n)
    return function(d, s) {
      var l = n(), f = l.cache, c = f === void 0 ? t ? /* @__PURE__ */ new WeakMap() : void 0 : f, h = l.meta;
      return r(d, s, {
        cache: c,
        equals: a,
        meta: h,
        strict: i
      });
    };
  if (t)
    return function(d, s) {
      return r(d, s, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: a,
        meta: void 0,
        strict: i
      });
    };
  var o = {
    cache: void 0,
    equals: a,
    meta: void 0,
    strict: i
  };
  return function(d, s) {
    return r(d, s, o);
  };
}
var j$e = Ao();
Ao({ strict: !0 });
Ao({ circular: !0 });
Ao({
  circular: !0,
  strict: !0
});
Ao({
  createInternalComparator: function() {
    return $d;
  }
});
Ao({
  strict: !0,
  createInternalComparator: function() {
    return $d;
  }
});
Ao({
  circular: !0,
  createInternalComparator: function() {
    return $d;
  }
});
Ao({
  circular: !0,
  createInternalComparator: function() {
    return $d;
  },
  strict: !0
});
function Ao(e) {
  e === void 0 && (e = {});
  var t = e.circular, r = t === void 0 ? !1 : t, n = e.createInternalComparator, a = e.createState, i = e.strict, o = i === void 0 ? !1 : i, u = P$e(e), d = T$e(u), s = n ? n(d) : I$e(d);
  return R$e({ circular: r, comparator: d, createState: a, equals: s, strict: o });
}
function M$e(e) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
}
function $$(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = -1, n = function a(i) {
    r < 0 && (r = i), i - r > t ? (e(i), r = -1) : M$e(a);
  };
  requestAnimationFrame(n);
}
function Vp(e) {
  return Vp = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Vp(e);
}
function B$e(e) {
  return U$e(e) || q$e(e) || L$e(e) || N$e();
}
function N$e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function L$e(e, t) {
  if (e) {
    if (typeof e == "string")
      return w$(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return w$(e, t);
  }
}
function w$(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function q$e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function U$e(e) {
  if (Array.isArray(e))
    return e;
}
function G$e() {
  var e = {}, t = function() {
    return null;
  }, r = !1, n = function a(i) {
    if (!r) {
      if (Array.isArray(i)) {
        if (!i.length)
          return;
        var o = i, u = B$e(o), d = u[0], s = u.slice(1);
        if (typeof d == "number") {
          $$(a.bind(null, s), d);
          return;
        }
        a(d), $$(a.bind(null, s));
        return;
      }
      Vp(i) === "object" && (e = i, t(e)), typeof i == "function" && i();
    }
  };
  return {
    stop: function() {
      r = !0;
    },
    start: function(i) {
      r = !1, n(i);
    },
    subscribe: function(i) {
      return t = i, function() {
        t = function() {
          return null;
        };
      };
    }
  };
}
function hf(e) {
  return hf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, hf(e);
}
function k$(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function x$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? k$(Object(r), !0).forEach(function(n) {
      kT(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : k$(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function kT(e, t, r) {
  return t = W$e(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function W$e(e) {
  var t = V$e(e, "string");
  return hf(t) === "symbol" ? t : String(t);
}
function V$e(e, t) {
  if (hf(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (hf(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var H$e = function(t, r) {
  return [Object.keys(t), Object.keys(r)].reduce(function(n, a) {
    return n.filter(function(i) {
      return a.includes(i);
    });
  });
}, z$e = function(t) {
  return t;
}, K$e = function(t) {
  return t.replace(/([A-Z])/g, function(r) {
    return "-".concat(r.toLowerCase());
  });
}, bl = function(t, r) {
  return Object.keys(r).reduce(function(n, a) {
    return x$(x$({}, n), {}, kT({}, a, t(a, r[a])));
  }, {});
}, D$ = function(t, r, n) {
  return t.map(function(a) {
    return "".concat(K$e(a), " ").concat(r, "ms ").concat(n);
  }).join(",");
}, Y$e = process.env.NODE_ENV !== "production", H0 = function(t, r, n, a, i, o, u, d) {
  if (Y$e && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var s = [n, a, i, o, u, d], l = 0;
      console.warn(r.replace(/%s/g, function() {
        return s[l++];
      }));
    }
};
function X$e(e, t) {
  return J$e(e) || Z$e(e, t) || xT(e, t) || Q$e();
}
function Q$e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Z$e(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], d = !0, s = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        d = !1;
      } else
        for (; !(d = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); d = !0)
          ;
    } catch (l) {
      s = !0, a = l;
    } finally {
      try {
        if (!d && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (s)
          throw a;
      }
    }
    return u;
  }
}
function J$e(e) {
  if (Array.isArray(e))
    return e;
}
function ewe(e) {
  return nwe(e) || rwe(e) || xT(e) || twe();
}
function twe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xT(e, t) {
  if (e) {
    if (typeof e == "string")
      return Hp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Hp(e, t);
  }
}
function rwe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function nwe(e) {
  if (Array.isArray(e))
    return Hp(e);
}
function Hp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var z0 = 1e-4, DT = function(t, r) {
  return [0, 3 * t, 3 * r - 6 * t, 3 * t - 3 * r + 1];
}, CT = function(t, r) {
  return t.map(function(n, a) {
    return n * Math.pow(r, a);
  }).reduce(function(n, a) {
    return n + a;
  });
}, C$ = function(t, r) {
  return function(n) {
    var a = DT(t, r);
    return CT(a, n);
  };
}, awe = function(t, r) {
  return function(n) {
    var a = DT(t, r), i = [].concat(ewe(a.map(function(o, u) {
      return o * u;
    }).slice(1)), [0]);
    return CT(i, n);
  };
}, S$ = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var a = r[0], i = r[1], o = r[2], u = r[3];
  if (r.length === 1)
    switch (r[0]) {
      case "linear":
        a = 0, i = 0, o = 1, u = 1;
        break;
      case "ease":
        a = 0.25, i = 0.1, o = 0.25, u = 1;
        break;
      case "ease-in":
        a = 0.42, i = 0, o = 1, u = 1;
        break;
      case "ease-out":
        a = 0.42, i = 0, o = 0.58, u = 1;
        break;
      case "ease-in-out":
        a = 0, i = 0, o = 0.58, u = 1;
        break;
      default: {
        var d = r[0].split("(");
        if (d[0] === "cubic-bezier" && d[1].split(")")[0].split(",").length === 4) {
          var s = d[1].split(")")[0].split(",").map(function(v) {
            return parseFloat(v);
          }), l = X$e(s, 4);
          a = l[0], i = l[1], o = l[2], u = l[3];
        } else
          H0(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", r);
      }
    }
  H0([a, o, i, u].every(function(v) {
    return typeof v == "number" && v >= 0 && v <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", r);
  var f = C$(a, o), c = C$(i, u), h = awe(a, o), _ = function($) {
    return $ > 1 ? 1 : $ < 0 ? 0 : $;
  }, F = function($) {
    for (var E = $ > 1 ? 1 : $, D = E, w = 0; w < 8; ++w) {
      var k = f(D) - E, A = h(D);
      if (Math.abs(k - E) < z0 || A < z0)
        return c(D);
      D = _(D - k / A);
    }
    return c(D);
  };
  return F.isStepper = !1, F;
}, iwe = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.stiff, n = r === void 0 ? 100 : r, a = t.damping, i = a === void 0 ? 8 : a, o = t.dt, u = o === void 0 ? 17 : o, d = function(l, f, c) {
    var h = -(l - f) * n, _ = c * i, F = c + (h - _) * u / 1e3, v = c * u / 1e3 + l;
    return Math.abs(v - f) < z0 && Math.abs(F) < z0 ? [f, 0] : [v, F];
  };
  return d.isStepper = !0, d.dt = u, d;
}, owe = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var a = r[0];
  if (typeof a == "string")
    switch (a) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return S$(a);
      case "spring":
        return iwe();
      default:
        if (a.split("(")[0] === "cubic-bezier")
          return S$(a);
        H0(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", r);
    }
  return typeof a == "function" ? a : (H0(!1, "[configEasing]: first argument type should be function or string, instead received %s", r), null);
};
function gf(e) {
  return gf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, gf(e);
}
function A$(e) {
  return dwe(e) || uwe(e) || ST(e) || swe();
}
function swe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function uwe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function dwe(e) {
  if (Array.isArray(e))
    return Kp(e);
}
function O$(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function jr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? O$(Object(r), !0).forEach(function(n) {
      zp(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : O$(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function zp(e, t, r) {
  return t = lwe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function lwe(e) {
  var t = fwe(e, "string");
  return gf(t) === "symbol" ? t : String(t);
}
function fwe(e, t) {
  if (gf(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (gf(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function cwe(e, t) {
  return _we(e) || gwe(e, t) || ST(e, t) || hwe();
}
function hwe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ST(e, t) {
  if (e) {
    if (typeof e == "string")
      return Kp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Kp(e, t);
  }
}
function Kp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function gwe(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], d = !0, s = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        d = !1;
      } else
        for (; !(d = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); d = !0)
          ;
    } catch (l) {
      s = !0, a = l;
    } finally {
      try {
        if (!d && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (s)
          throw a;
      }
    }
    return u;
  }
}
function _we(e) {
  if (Array.isArray(e))
    return e;
}
var K0 = function(t, r, n) {
  return t + (r - t) * n;
}, Yp = function(t) {
  var r = t.from, n = t.to;
  return r !== n;
}, mwe = function e(t, r, n) {
  var a = bl(function(i, o) {
    if (Yp(o)) {
      var u = t(o.from, o.to, o.velocity), d = cwe(u, 2), s = d[0], l = d[1];
      return jr(jr({}, o), {}, {
        from: s,
        velocity: l
      });
    }
    return o;
  }, r);
  return n < 1 ? bl(function(i, o) {
    return Yp(o) ? jr(jr({}, o), {}, {
      velocity: K0(o.velocity, a[i].velocity, n),
      from: K0(o.from, a[i].from, n)
    }) : o;
  }, r) : e(t, a, n - 1);
};
const pwe = function(e, t, r, n, a) {
  var i = H$e(e, t), o = i.reduce(function(v, $) {
    return jr(jr({}, v), {}, zp({}, $, [e[$], t[$]]));
  }, {}), u = i.reduce(function(v, $) {
    return jr(jr({}, v), {}, zp({}, $, {
      from: e[$],
      velocity: 0,
      to: t[$]
    }));
  }, {}), d = -1, s, l, f = function() {
    return null;
  }, c = function() {
    return bl(function($, E) {
      return E.from;
    }, u);
  }, h = function() {
    return !Object.values(u).filter(Yp).length;
  }, _ = function($) {
    s || (s = $);
    var E = $ - s, D = E / r.dt;
    u = mwe(r, u, D), a(jr(jr(jr({}, e), t), c())), s = $, h() || (d = requestAnimationFrame(f));
  }, F = function($) {
    l || (l = $);
    var E = ($ - l) / n, D = bl(function(k, A) {
      return K0.apply(void 0, A$(A).concat([r(E)]));
    }, o);
    if (a(jr(jr(jr({}, e), t), D)), E < 1)
      d = requestAnimationFrame(f);
    else {
      var w = bl(function(k, A) {
        return K0.apply(void 0, A$(A).concat([r(1)]));
      }, o);
      a(jr(jr(jr({}, e), t), w));
    }
  };
  return f = r.isStepper ? _ : F, function() {
    return requestAnimationFrame(f), function() {
      cancelAnimationFrame(d);
    };
  };
};
function zu(e) {
  return zu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zu(e);
}
var Fwe = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function ywe(e, t) {
  if (e == null)
    return {};
  var r = bwe(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function bwe(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function R2(e) {
  return wwe(e) || $we(e) || Ewe(e) || vwe();
}
function vwe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ewe(e, t) {
  if (e) {
    if (typeof e == "string")
      return Xp(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Xp(e, t);
  }
}
function $we(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function wwe(e) {
  if (Array.isArray(e))
    return Xp(e);
}
function Xp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function T$(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function da(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? T$(Object(r), !0).forEach(function(n) {
      ol(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : T$(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ol(e, t, r) {
  return t = AT(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function kwe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function P$(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, AT(n.key), n);
  }
}
function xwe(e, t, r) {
  return t && P$(e.prototype, t), r && P$(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function AT(e) {
  var t = Dwe(e, "string");
  return zu(t) === "symbol" ? t : String(t);
}
function Dwe(e, t) {
  if (zu(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (zu(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Cwe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Qp(e, t);
}
function Qp(e, t) {
  return Qp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Qp(e, t);
}
function Swe(e) {
  var t = Awe();
  return function() {
    var n = Y0(e), a;
    if (t) {
      var i = Y0(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return Zp(this, a);
  };
}
function Zp(e, t) {
  if (t && (zu(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Jp(e);
}
function Jp(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Awe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Y0(e) {
  return Y0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Y0(e);
}
var Eo = /* @__PURE__ */ function(e) {
  Cwe(r, e);
  var t = Swe(r);
  function r(n, a) {
    var i;
    kwe(this, r), i = t.call(this, n, a);
    var o = i.props, u = o.isActive, d = o.attributeName, s = o.from, l = o.to, f = o.steps, c = o.children, h = o.duration;
    if (i.handleStyleChange = i.handleStyleChange.bind(Jp(i)), i.changeStyle = i.changeStyle.bind(Jp(i)), !u || h <= 0)
      return i.state = {
        style: {}
      }, typeof c == "function" && (i.state = {
        style: l
      }), Zp(i);
    if (f && f.length)
      i.state = {
        style: f[0].style
      };
    else if (s) {
      if (typeof c == "function")
        return i.state = {
          style: s
        }, Zp(i);
      i.state = {
        style: d ? ol({}, d, s) : s
      };
    } else
      i.state = {
        style: {}
      };
    return i;
  }
  return xwe(r, [{
    key: "componentDidMount",
    value: function() {
      var a = this.props, i = a.isActive, o = a.canBegin;
      this.mounted = !0, !(!i || !o) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      var i = this.props, o = i.isActive, u = i.canBegin, d = i.attributeName, s = i.shouldReAnimate, l = i.to, f = i.from, c = this.state.style;
      if (u) {
        if (!o) {
          var h = {
            style: d ? ol({}, d, l) : l
          };
          this.state && c && (d && c[d] !== l || !d && c !== l) && this.setState(h);
          return;
        }
        if (!(j$e(a.to, l) && a.canBegin && a.isActive)) {
          var _ = !a.canBegin || !a.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var F = _ || s ? f : a.to;
          if (this.state && c) {
            var v = {
              style: d ? ol({}, d, F) : F
            };
            (d && c[d] !== F || !d && c !== F) && this.setState(v);
          }
          this.runAnimation(da(da({}, this.props), {}, {
            from: F,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var a = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), a && a();
    }
  }, {
    key: "handleStyleChange",
    value: function(a) {
      this.changeStyle(a);
    }
  }, {
    key: "changeStyle",
    value: function(a) {
      this.mounted && this.setState({
        style: a
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(a) {
      var i = this, o = a.from, u = a.to, d = a.duration, s = a.easing, l = a.begin, f = a.onAnimationEnd, c = a.onAnimationStart, h = pwe(o, u, owe(s), d, this.changeStyle), _ = function() {
        i.stopJSAnimation = h();
      };
      this.manager.start([c, l, _, d, f]);
    }
  }, {
    key: "runStepAnimation",
    value: function(a) {
      var i = this, o = a.steps, u = a.begin, d = a.onAnimationStart, s = o[0], l = s.style, f = s.duration, c = f === void 0 ? 0 : f, h = function(F, v, $) {
        if ($ === 0)
          return F;
        var E = v.duration, D = v.easing, w = D === void 0 ? "ease" : D, k = v.style, A = v.properties, P = v.onAnimationEnd, S = $ > 0 ? o[$ - 1] : v, N = A || Object.keys(k);
        if (typeof w == "function" || w === "spring")
          return [].concat(R2(F), [i.runJSAnimation.bind(i, {
            from: S.style,
            to: k,
            duration: E,
            easing: w
          }), E]);
        var W = D$(N, E, w), V = da(da(da({}, S.style), k), {}, {
          transition: W
        });
        return [].concat(R2(F), [V, E, P]).filter(z$e);
      };
      return this.manager.start([d].concat(R2(o.reduce(h, [l, Math.max(c, u)])), [a.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(a) {
      this.manager || (this.manager = G$e());
      var i = a.begin, o = a.duration, u = a.attributeName, d = a.to, s = a.easing, l = a.onAnimationStart, f = a.onAnimationEnd, c = a.steps, h = a.children, _ = this.manager;
      if (this.unSubscribe = _.subscribe(this.handleStyleChange), typeof s == "function" || typeof h == "function" || s === "spring") {
        this.runJSAnimation(a);
        return;
      }
      if (c.length > 1) {
        this.runStepAnimation(a);
        return;
      }
      var F = u ? ol({}, u, d) : d, v = D$(Object.keys(F), o, s);
      _.start([l, i, da(da({}, F), {}, {
        transition: v
      }), o, f]);
    }
  }, {
    key: "render",
    value: function() {
      var a = this.props, i = a.children;
      a.begin;
      var o = a.duration;
      a.attributeName, a.easing;
      var u = a.isActive;
      a.steps, a.from, a.to, a.canBegin, a.onAnimationEnd, a.shouldReAnimate, a.onAnimationReStart;
      var d = ywe(a, Fwe), s = Vn.count(i), l = this.state.style;
      if (typeof i == "function")
        return i(l);
      if (!u || s === 0 || o <= 0)
        return i;
      var f = function(h) {
        var _ = h.props, F = _.style, v = F === void 0 ? {} : F, $ = _.className, E = /* @__PURE__ */ gr(h, da(da({}, d), {}, {
          style: da(da({}, v), l),
          className: $
        }));
        return E;
      };
      return s === 1 ? f(Vn.only(i)) : /* @__PURE__ */ M.createElement("div", null, Vn.map(i, function(c) {
        return f(c);
      }));
    }
  }]), r;
}(ji);
Eo.displayName = "Animate";
Eo.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
Eo.propTypes = {
  from: re.oneOfType([re.object, re.string]),
  to: re.oneOfType([re.object, re.string]),
  attributeName: re.string,
  // animation duration
  duration: re.number,
  begin: re.number,
  easing: re.oneOfType([re.string, re.func]),
  steps: re.arrayOf(re.shape({
    duration: re.number.isRequired,
    style: re.object.isRequired,
    easing: re.oneOfType([re.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), re.func]),
    // transition css properties(dash case), optional
    properties: re.arrayOf("string"),
    onAnimationEnd: re.func
  })),
  children: re.oneOfType([re.node, re.func]),
  isActive: re.bool,
  canBegin: re.bool,
  onAnimationEnd: re.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: re.bool,
  onAnimationStart: re.func,
  onAnimationReStart: re.func
};
re.object, re.object, re.object, re.element;
re.object, re.object, re.object, re.oneOfType([re.array, re.element]), re.any;
function _f(e) {
  return _f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _f(e);
}
function X0() {
  return X0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, X0.apply(this, arguments);
}
function Owe(e, t) {
  return Rwe(e) || Iwe(e, t) || Pwe(e, t) || Twe();
}
function Twe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Pwe(e, t) {
  if (e) {
    if (typeof e == "string")
      return I$(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return I$(e, t);
  }
}
function I$(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Iwe(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], d = !0, s = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        d = !1;
      } else
        for (; !(d = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); d = !0)
          ;
    } catch (l) {
      s = !0, a = l;
    } finally {
      try {
        if (!d && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (s)
          throw a;
      }
    }
    return u;
  }
}
function Rwe(e) {
  if (Array.isArray(e))
    return e;
}
function R$(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function j$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? R$(Object(r), !0).forEach(function(n) {
      jwe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : R$(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function jwe(e, t, r) {
  return t = Mwe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Mwe(e) {
  var t = Bwe(e, "string");
  return _f(t) == "symbol" ? t : String(t);
}
function Bwe(e, t) {
  if (_f(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (_f(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var M$ = function(t, r, n, a, i) {
  var o = Math.min(Math.abs(n) / 2, Math.abs(a) / 2), u = a >= 0 ? 1 : -1, d = n >= 0 ? 1 : -1, s = a >= 0 && n >= 0 || a < 0 && n < 0 ? 1 : 0, l;
  if (o > 0 && i instanceof Array) {
    for (var f = [0, 0, 0, 0], c = 0, h = 4; c < h; c++)
      f[c] = i[c] > o ? o : i[c];
    l = "M".concat(t, ",").concat(r + u * f[0]), f[0] > 0 && (l += "A ".concat(f[0], ",").concat(f[0], ",0,0,").concat(s, ",").concat(t + d * f[0], ",").concat(r)), l += "L ".concat(t + n - d * f[1], ",").concat(r), f[1] > 0 && (l += "A ".concat(f[1], ",").concat(f[1], ",0,0,").concat(s, `,
        `).concat(t + n, ",").concat(r + u * f[1])), l += "L ".concat(t + n, ",").concat(r + a - u * f[2]), f[2] > 0 && (l += "A ".concat(f[2], ",").concat(f[2], ",0,0,").concat(s, `,
        `).concat(t + n - d * f[2], ",").concat(r + a)), l += "L ".concat(t + d * f[3], ",").concat(r + a), f[3] > 0 && (l += "A ".concat(f[3], ",").concat(f[3], ",0,0,").concat(s, `,
        `).concat(t, ",").concat(r + a - u * f[3])), l += "Z";
  } else if (o > 0 && i === +i && i > 0) {
    var _ = Math.min(o, i);
    l = "M ".concat(t, ",").concat(r + u * _, `
            A `).concat(_, ",").concat(_, ",0,0,").concat(s, ",").concat(t + d * _, ",").concat(r, `
            L `).concat(t + n - d * _, ",").concat(r, `
            A `).concat(_, ",").concat(_, ",0,0,").concat(s, ",").concat(t + n, ",").concat(r + u * _, `
            L `).concat(t + n, ",").concat(r + a - u * _, `
            A `).concat(_, ",").concat(_, ",0,0,").concat(s, ",").concat(t + n - d * _, ",").concat(r + a, `
            L `).concat(t + d * _, ",").concat(r + a, `
            A `).concat(_, ",").concat(_, ",0,0,").concat(s, ",").concat(t, ",").concat(r + a - u * _, " Z");
  } else
    l = "M ".concat(t, ",").concat(r, " h ").concat(n, " v ").concat(a, " h ").concat(-n, " Z");
  return l;
}, Nwe = function(t, r) {
  if (!t || !r)
    return !1;
  var n = t.x, a = t.y, i = r.x, o = r.y, u = r.width, d = r.height;
  if (Math.abs(u) > 0 && Math.abs(d) > 0) {
    var s = Math.min(i, i + u), l = Math.max(i, i + u), f = Math.min(o, o + d), c = Math.max(o, o + d);
    return n >= s && n <= l && a >= f && a <= c;
  }
  return !1;
}, Lwe = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, ey = function(t) {
  var r = j$(j$({}, Lwe), t), n = tt(), a = Xe(-1), i = Owe(a, 2), o = i[0], u = i[1];
  at(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var w = n.current.getTotalLength();
        w && u(w);
      } catch {
      }
  }, []);
  var d = r.x, s = r.y, l = r.width, f = r.height, c = r.radius, h = r.className, _ = r.animationEasing, F = r.animationDuration, v = r.animationBegin, $ = r.isAnimationActive, E = r.isUpdateAnimationActive;
  if (d !== +d || s !== +s || l !== +l || f !== +f || l === 0 || f === 0)
    return null;
  var D = Ct("recharts-rectangle", h);
  return E ? /* @__PURE__ */ M.createElement(Eo, {
    canBegin: o > 0,
    from: {
      width: l,
      height: f,
      x: d,
      y: s
    },
    to: {
      width: l,
      height: f,
      x: d,
      y: s
    },
    duration: F,
    animationEasing: _,
    isActive: E
  }, function(w) {
    var k = w.width, A = w.height, P = w.x, S = w.y;
    return /* @__PURE__ */ M.createElement(Eo, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: v,
      duration: F,
      isActive: $,
      easing: _
    }, /* @__PURE__ */ M.createElement("path", X0({}, _t(r, !0), {
      className: D,
      d: M$(P, S, k, A, c),
      ref: n
    })));
  }) : /* @__PURE__ */ M.createElement("path", X0({}, _t(r, !0), {
    className: D,
    d: M$(d, s, l, f, c)
  }));
}, qwe = ["points", "className", "baseLinePoints", "connectNulls"];
function yu() {
  return yu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yu.apply(this, arguments);
}
function Uwe(e, t) {
  if (e == null)
    return {};
  var r = Gwe(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Gwe(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function B$(e) {
  return zwe(e) || Hwe(e) || Vwe(e) || Wwe();
}
function Wwe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Vwe(e, t) {
  if (e) {
    if (typeof e == "string")
      return e3(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return e3(e, t);
  }
}
function Hwe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function zwe(e) {
  if (Array.isArray(e))
    return e3(e);
}
function e3(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var N$ = function(t) {
  return t && t.x === +t.x && t.y === +t.y;
}, Kwe = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = [[]];
  return t.forEach(function(n) {
    N$(n) ? r[r.length - 1].push(n) : r[r.length - 1].length > 0 && r.push([]);
  }), N$(t[0]) && r[r.length - 1].push(t[0]), r[r.length - 1].length <= 0 && (r = r.slice(0, -1)), r;
}, vl = function(t, r) {
  var n = Kwe(t);
  r && (n = [n.reduce(function(i, o) {
    return [].concat(B$(i), B$(o));
  }, [])]);
  var a = n.map(function(i) {
    return i.reduce(function(o, u, d) {
      return "".concat(o).concat(d === 0 ? "M" : "L").concat(u.x, ",").concat(u.y);
    }, "");
  }).join("");
  return n.length === 1 ? "".concat(a, "Z") : a;
}, Ywe = function(t, r, n) {
  var a = vl(t, n);
  return "".concat(a.slice(-1) === "Z" ? a.slice(0, -1) : a, "L").concat(vl(r.reverse(), n).slice(1));
}, Xwe = function(t) {
  var r = t.points, n = t.className, a = t.baseLinePoints, i = t.connectNulls, o = Uwe(t, qwe);
  if (!r || !r.length)
    return null;
  var u = Ct("recharts-polygon", n);
  if (a && a.length) {
    var d = o.stroke && o.stroke !== "none", s = Ywe(r, a, i);
    return /* @__PURE__ */ M.createElement("g", {
      className: u
    }, /* @__PURE__ */ M.createElement("path", yu({}, _t(o, !0), {
      fill: s.slice(-1) === "Z" ? o.fill : "none",
      stroke: "none",
      d: s
    })), d ? /* @__PURE__ */ M.createElement("path", yu({}, _t(o, !0), {
      fill: "none",
      d: vl(r, i)
    })) : null, d ? /* @__PURE__ */ M.createElement("path", yu({}, _t(o, !0), {
      fill: "none",
      d: vl(a, i)
    })) : null);
  }
  var l = vl(r, i);
  return /* @__PURE__ */ M.createElement("path", yu({}, _t(o, !0), {
    fill: l.slice(-1) === "Z" ? o.fill : "none",
    className: u,
    d: l
  }));
};
function t3() {
  return t3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, t3.apply(this, arguments);
}
var ty = function(t) {
  var r = t.cx, n = t.cy, a = t.r, i = t.className, o = Ct("recharts-dot", i);
  return r === +r && n === +n && a === +a ? /* @__PURE__ */ M.createElement("circle", t3({}, _t(t, !1), F0(t), {
    className: o,
    cx: r,
    cy: n,
    r: a
  })) : null;
};
function mf(e) {
  return mf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, mf(e);
}
var Qwe = ["x", "y", "top", "left", "width", "height", "className"];
function r3() {
  return r3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, r3.apply(this, arguments);
}
function L$(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Zwe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? L$(Object(r), !0).forEach(function(n) {
      Jwe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : L$(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Jwe(e, t, r) {
  return t = eke(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function eke(e) {
  var t = tke(e, "string");
  return mf(t) == "symbol" ? t : String(t);
}
function tke(e, t) {
  if (mf(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (mf(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function rke(e, t) {
  if (e == null)
    return {};
  var r = nke(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function nke(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var ake = function(t, r, n, a, i, o) {
  return "M".concat(t, ",").concat(i, "v").concat(a, "M").concat(o, ",").concat(r, "h").concat(n);
}, ike = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, a = t.y, i = a === void 0 ? 0 : a, o = t.top, u = o === void 0 ? 0 : o, d = t.left, s = d === void 0 ? 0 : d, l = t.width, f = l === void 0 ? 0 : l, c = t.height, h = c === void 0 ? 0 : c, _ = t.className, F = rke(t, Qwe), v = Zwe({
    x: n,
    y: i,
    top: u,
    left: s,
    width: f,
    height: h
  }, F);
  return !Ve(n) || !Ve(i) || !Ve(f) || !Ve(h) || !Ve(u) || !Ve(s) ? null : /* @__PURE__ */ M.createElement("path", r3({}, _t(v, !0), {
    className: Ct("recharts-cross", _),
    d: ake(n, i, f, h, u, s)
  }));
}, oke = Fg, ske = ZO, uke = Do;
function dke(e, t) {
  return e && e.length ? oke(e, uke(t), ske) : void 0;
}
var lke = dke, fke = Fg, cke = Do, hke = JO;
function gke(e, t) {
  return e && e.length ? fke(e, cke(t), hke) : void 0;
}
var _ke = gke, mke = ["cx", "cy", "angle", "ticks", "axisLine"], pke = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function Ku(e) {
  return Ku = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ku(e);
}
function El() {
  return El = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, El.apply(this, arguments);
}
function q$(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Vo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? q$(Object(r), !0).forEach(function(n) {
      $g(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : q$(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function U$(e, t) {
  if (e == null)
    return {};
  var r = Fke(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Fke(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function yke(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function G$(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, TT(n.key), n);
  }
}
function bke(e, t, r) {
  return t && G$(e.prototype, t), r && G$(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function vke(e, t, r) {
  return t = Q0(t), Eke(e, OT() ? Reflect.construct(t, r || [], Q0(e).constructor) : t.apply(e, r));
}
function Eke(e, t) {
  if (t && (Ku(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return $ke(e);
}
function $ke(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function OT() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (OT = function() {
    return !!e;
  })();
}
function Q0(e) {
  return Q0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Q0(e);
}
function wke(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && n3(e, t);
}
function n3(e, t) {
  return n3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, n3(e, t);
}
function $g(e, t, r) {
  return t = TT(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function TT(e) {
  var t = kke(e, "string");
  return Ku(t) == "symbol" ? t : String(t);
}
function kke(e, t) {
  if (Ku(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ku(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var wg = /* @__PURE__ */ function(e) {
  wke(t, e);
  function t() {
    return yke(this, t), vke(this, t, arguments);
  }
  return bke(t, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      function(n) {
        var a = n.coordinate, i = this.props, o = i.angle, u = i.cx, d = i.cy;
        return Vt(u, d, a, o);
      }
    )
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props.orientation, a;
      switch (n) {
        case "left":
          a = "end";
          break;
        case "right":
          a = "start";
          break;
        default:
          a = "middle";
          break;
      }
      return a;
    }
  }, {
    key: "getViewBox",
    value: function() {
      var n = this.props, a = n.cx, i = n.cy, o = n.angle, u = n.ticks, d = lke(u, function(l) {
        return l.coordinate || 0;
      }), s = _ke(u, function(l) {
        return l.coordinate || 0;
      });
      return {
        cx: a,
        cy: i,
        startAngle: o,
        endAngle: o,
        innerRadius: s.coordinate || 0,
        outerRadius: d.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.cx, i = n.cy, o = n.angle, u = n.ticks, d = n.axisLine, s = U$(n, mke), l = u.reduce(function(_, F) {
        return [Math.min(_[0], F.coordinate), Math.max(_[1], F.coordinate)];
      }, [1 / 0, -1 / 0]), f = Vt(a, i, l[0], o), c = Vt(a, i, l[1], o), h = Vo(Vo(Vo({}, _t(s, !1)), {}, {
        fill: "none"
      }, _t(d, !1)), {}, {
        x1: f.x,
        y1: f.y,
        x2: c.x,
        y2: c.y
      });
      return /* @__PURE__ */ M.createElement("line", El({
        className: "recharts-polar-radius-axis-line"
      }, h));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, a = this.props, i = a.ticks, o = a.tick, u = a.angle, d = a.tickFormatter, s = a.stroke, l = U$(a, pke), f = this.getTickTextAnchor(), c = _t(l, !1), h = _t(o, !1), _ = i.map(function(F, v) {
        var $ = n.getTickValueCoord(F), E = Vo(Vo(Vo(Vo({
          textAnchor: f,
          transform: "rotate(".concat(90 - u, ", ").concat($.x, ", ").concat($.y, ")")
        }, c), {}, {
          stroke: "none",
          fill: s
        }, h), {}, {
          index: v
        }, $), {}, {
          payload: F
        });
        return /* @__PURE__ */ M.createElement(cr, El({
          className: Ct("recharts-polar-radius-axis-tick", yT(o)),
          key: "tick-".concat(F.coordinate)
        }, ag(n.props, F, v)), t.renderTickItem(o, E, d ? d(F.value, v) : F.value));
      });
      return /* @__PURE__ */ M.createElement(cr, {
        className: "recharts-polar-radius-axis-ticks"
      }, _);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.ticks, i = n.axisLine, o = n.tick;
      return !a || !a.length ? null : /* @__PURE__ */ M.createElement(cr, {
        className: Ct("recharts-polar-radius-axis", this.props.className)
      }, i && this.renderAxisLine(), o && this.renderTicks(), Br.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, i) {
      var o;
      return /* @__PURE__ */ M.isValidElement(n) ? o = /* @__PURE__ */ M.cloneElement(n, a) : Ft(n) ? o = n(a) : o = /* @__PURE__ */ M.createElement(Gu, El({}, a, {
        className: "recharts-polar-radius-axis-tick-value"
      }), i), o;
    }
  }]), t;
}(ji);
$g(wg, "displayName", "PolarRadiusAxis");
$g(wg, "axisType", "radiusAxis");
$g(wg, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: !0,
  tick: !0,
  tickCount: 5,
  allowDataOverflow: !1,
  scale: "auto",
  allowDuplicatedCategory: !0
});
function Yu(e) {
  return Yu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yu(e);
}
function ns() {
  return ns = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ns.apply(this, arguments);
}
function W$(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ho(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? W$(Object(r), !0).forEach(function(n) {
      kg(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : W$(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function xke(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function V$(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, IT(n.key), n);
  }
}
function Dke(e, t, r) {
  return t && V$(e.prototype, t), r && V$(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Cke(e, t, r) {
  return t = Z0(t), Ske(e, PT() ? Reflect.construct(t, r || [], Z0(e).constructor) : t.apply(e, r));
}
function Ske(e, t) {
  if (t && (Yu(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ake(e);
}
function Ake(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function PT() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (PT = function() {
    return !!e;
  })();
}
function Z0(e) {
  return Z0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Z0(e);
}
function Oke(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && a3(e, t);
}
function a3(e, t) {
  return a3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, a3(e, t);
}
function kg(e, t, r) {
  return t = IT(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function IT(e) {
  var t = Tke(e, "string");
  return Yu(t) == "symbol" ? t : String(t);
}
function Tke(e, t) {
  if (Yu(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Yu(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Pke = Math.PI / 180, H$ = 1e-5, xg = /* @__PURE__ */ function(e) {
  Oke(t, e);
  function t() {
    return xke(this, t), Cke(this, t, arguments);
  }
  return Dke(t, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function(n) {
        var a = this.props, i = a.cx, o = a.cy, u = a.radius, d = a.orientation, s = a.tickSize, l = s || 8, f = Vt(i, o, u, n.coordinate), c = Vt(i, o, u + (d === "inner" ? -1 : 1) * l, n.coordinate);
        return {
          x1: f.x,
          y1: f.y,
          x2: c.x,
          y2: c.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function(n) {
      var a = this.props.orientation, i = Math.cos(-n.coordinate * Pke), o;
      return i > H$ ? o = a === "outer" ? "start" : "end" : i < -H$ ? o = a === "outer" ? "end" : "start" : o = "middle", o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.cx, i = n.cy, o = n.radius, u = n.axisLine, d = n.axisLineType, s = Ho(Ho({}, _t(this.props, !1)), {}, {
        fill: "none"
      }, _t(u, !1));
      if (d === "circle")
        return /* @__PURE__ */ M.createElement(ty, ns({
          className: "recharts-polar-angle-axis-line"
        }, s, {
          cx: a,
          cy: i,
          r: o
        }));
      var l = this.props.ticks, f = l.map(function(c) {
        return Vt(a, i, o, c.coordinate);
      });
      return /* @__PURE__ */ M.createElement(Xwe, ns({
        className: "recharts-polar-angle-axis-line"
      }, s, {
        points: f
      }));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, a = this.props, i = a.ticks, o = a.tick, u = a.tickLine, d = a.tickFormatter, s = a.stroke, l = _t(this.props, !1), f = _t(o, !1), c = Ho(Ho({}, l), {}, {
        fill: "none"
      }, _t(u, !1)), h = i.map(function(_, F) {
        var v = n.getTickLineCoord(_), $ = n.getTickTextAnchor(_), E = Ho(Ho(Ho({
          textAnchor: $
        }, l), {}, {
          stroke: "none",
          fill: s
        }, f), {}, {
          index: F,
          payload: _,
          x: v.x2,
          y: v.y2
        });
        return /* @__PURE__ */ M.createElement(cr, ns({
          className: Ct("recharts-polar-angle-axis-tick", yT(o)),
          key: "tick-".concat(_.coordinate)
        }, ag(n.props, _, F)), u && /* @__PURE__ */ M.createElement("line", ns({
          className: "recharts-polar-angle-axis-tick-line"
        }, c, v)), o && t.renderTickItem(o, E, d ? d(_.value, F) : _.value));
      });
      return /* @__PURE__ */ M.createElement(cr, {
        className: "recharts-polar-angle-axis-ticks"
      }, h);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.ticks, i = n.radius, o = n.axisLine;
      return i <= 0 || !a || !a.length ? null : /* @__PURE__ */ M.createElement(cr, {
        className: Ct("recharts-polar-angle-axis", this.props.className)
      }, o && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, i) {
      var o;
      return /* @__PURE__ */ M.isValidElement(n) ? o = /* @__PURE__ */ M.cloneElement(n, a) : Ft(n) ? o = n(a) : o = /* @__PURE__ */ M.createElement(Gu, ns({}, a, {
        className: "recharts-polar-angle-axis-tick-value"
      }), i), o;
    }
  }]), t;
}(ji);
kg(xg, "displayName", "PolarAngleAxis");
kg(xg, "axisType", "angleAxis");
kg(xg, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
});
var Ike = zA, Rke = Ike(Object.getPrototypeOf, Object), jke = Rke, Mke = Ni, Bke = jke, Nke = Li, Lke = "[object Object]", qke = Function.prototype, Uke = Object.prototype, RT = qke.toString, Gke = Uke.hasOwnProperty, Wke = RT.call(Object);
function Vke(e) {
  if (!Nke(e) || Mke(e) != Lke)
    return !1;
  var t = Bke(e);
  if (t === null)
    return !0;
  var r = Gke.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && RT.call(r) == Wke;
}
var Hke = Vke, zke = Ni, Kke = Li, Yke = "[object Boolean]";
function Xke(e) {
  return e === !0 || e === !1 || Kke(e) && zke(e) == Yke;
}
var Qke = Xke;
function pf(e) {
  return pf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, pf(e);
}
function J0() {
  return J0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, J0.apply(this, arguments);
}
function Zke(e, t) {
  return rxe(e) || txe(e, t) || exe(e, t) || Jke();
}
function Jke() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function exe(e, t) {
  if (e) {
    if (typeof e == "string")
      return z$(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return z$(e, t);
  }
}
function z$(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function txe(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], d = !0, s = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        d = !1;
      } else
        for (; !(d = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); d = !0)
          ;
    } catch (l) {
      s = !0, a = l;
    } finally {
      try {
        if (!d && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (s)
          throw a;
      }
    }
    return u;
  }
}
function rxe(e) {
  if (Array.isArray(e))
    return e;
}
function K$(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Y$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? K$(Object(r), !0).forEach(function(n) {
      nxe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : K$(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function nxe(e, t, r) {
  return t = axe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function axe(e) {
  var t = ixe(e, "string");
  return pf(t) == "symbol" ? t : String(t);
}
function ixe(e, t) {
  if (pf(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (pf(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var X$ = function(t, r, n, a, i) {
  var o = n - a, u;
  return u = "M ".concat(t, ",").concat(r), u += "L ".concat(t + n, ",").concat(r), u += "L ".concat(t + n - o / 2, ",").concat(r + i), u += "L ".concat(t + n - o / 2 - a, ",").concat(r + i), u += "L ".concat(t, ",").concat(r, " Z"), u;
}, oxe = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, sxe = function(t) {
  var r = Y$(Y$({}, oxe), t), n = tt(), a = Xe(-1), i = Zke(a, 2), o = i[0], u = i[1];
  at(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var D = n.current.getTotalLength();
        D && u(D);
      } catch {
      }
  }, []);
  var d = r.x, s = r.y, l = r.upperWidth, f = r.lowerWidth, c = r.height, h = r.className, _ = r.animationEasing, F = r.animationDuration, v = r.animationBegin, $ = r.isUpdateAnimationActive;
  if (d !== +d || s !== +s || l !== +l || f !== +f || c !== +c || l === 0 && f === 0 || c === 0)
    return null;
  var E = Ct("recharts-trapezoid", h);
  return $ ? /* @__PURE__ */ M.createElement(Eo, {
    canBegin: o > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: c,
      x: d,
      y: s
    },
    to: {
      upperWidth: l,
      lowerWidth: f,
      height: c,
      x: d,
      y: s
    },
    duration: F,
    animationEasing: _,
    isActive: $
  }, function(D) {
    var w = D.upperWidth, k = D.lowerWidth, A = D.height, P = D.x, S = D.y;
    return /* @__PURE__ */ M.createElement(Eo, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: v,
      duration: F,
      easing: _
    }, /* @__PURE__ */ M.createElement("path", J0({}, _t(r, !0), {
      className: E,
      d: X$(P, S, w, k, A),
      ref: n
    })));
  }) : /* @__PURE__ */ M.createElement("g", null, /* @__PURE__ */ M.createElement("path", J0({}, _t(r, !0), {
    className: E,
    d: X$(d, s, l, f, c)
  })));
}, uxe = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function Ff(e) {
  return Ff = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ff(e);
}
function dxe(e, t) {
  if (e == null)
    return {};
  var r = lxe(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function lxe(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Q$(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function eh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q$(Object(r), !0).forEach(function(n) {
      fxe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Q$(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function fxe(e, t, r) {
  return t = cxe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function cxe(e) {
  var t = hxe(e, "string");
  return Ff(t) == "symbol" ? t : String(t);
}
function hxe(e, t) {
  if (Ff(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ff(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function gxe(e, t) {
  return eh(eh({}, t), e);
}
function _xe(e, t) {
  return e === "symbols";
}
function Z$(e) {
  var t = e.shapeType, r = e.elementProps;
  switch (t) {
    case "rectangle":
      return /* @__PURE__ */ M.createElement(ey, r);
    case "trapezoid":
      return /* @__PURE__ */ M.createElement(sxe, r);
    case "sector":
      return /* @__PURE__ */ M.createElement(ET, r);
    case "symbols":
      if (_xe(t))
        return /* @__PURE__ */ M.createElement(m4, r);
      break;
    default:
      return null;
  }
}
function mxe(e) {
  return /* @__PURE__ */ $n(e) ? e.props : e;
}
function pxe(e) {
  var t = e.option, r = e.shapeType, n = e.propTransformer, a = n === void 0 ? gxe : n, i = e.activeClassName, o = i === void 0 ? "recharts-active-shape" : i, u = e.isActive, d = dxe(e, uxe), s;
  if (/* @__PURE__ */ $n(t))
    s = /* @__PURE__ */ gr(t, eh(eh({}, d), mxe(t)));
  else if (Ft(t))
    s = t(d);
  else if (Hke(t) && !Qke(t)) {
    var l = a(t, d);
    s = /* @__PURE__ */ M.createElement(Z$, {
      shapeType: r,
      elementProps: l
    });
  } else {
    var f = d;
    s = /* @__PURE__ */ M.createElement(Z$, {
      shapeType: r,
      elementProps: f
    });
  }
  return u ? /* @__PURE__ */ M.createElement(cr, {
    className: o
  }, s) : s;
}
function Dg(e, t) {
  return t != null && "trapezoids" in e.props;
}
function Cg(e, t) {
  return t != null && "sectors" in e.props;
}
function yf(e, t) {
  return t != null && "points" in e.props;
}
function Fxe(e, t) {
  var r, n, a = e.x === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.x) || e.x === t.x, i = e.y === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.y) || e.y === t.y;
  return a && i;
}
function yxe(e, t) {
  var r = e.endAngle === t.endAngle, n = e.startAngle === t.startAngle;
  return r && n;
}
function bxe(e, t) {
  var r = e.x === t.x, n = e.y === t.y, a = e.z === t.z;
  return r && n && a;
}
function vxe(e, t) {
  var r;
  return Dg(e, t) ? r = Fxe : Cg(e, t) ? r = yxe : yf(e, t) && (r = bxe), r;
}
function Exe(e, t) {
  var r;
  return Dg(e, t) ? r = "trapezoids" : Cg(e, t) ? r = "sectors" : yf(e, t) && (r = "points"), r;
}
function $xe(e, t) {
  if (Dg(e, t)) {
    var r;
    return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  if (Cg(e, t)) {
    var n;
    return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  return yf(e, t) ? t.payload : {};
}
function wxe(e) {
  var t = e.activeTooltipItem, r = e.graphicalItem, n = e.itemData, a = Exe(r, t), i = $xe(r, t), o = n.filter(function(d, s) {
    var l = Y4(i, d), f = r.props[a].filter(function(_) {
      var F = vxe(r, t);
      return F(_, t);
    }), c = r.props[a].indexOf(f[f.length - 1]), h = s === c;
    return l && h;
  }), u = n.indexOf(o[o.length - 1]);
  return u;
}
var I1;
function Xu(e) {
  return Xu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xu(e);
}
function bu() {
  return bu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, bu.apply(this, arguments);
}
function J$(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function er(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? J$(Object(r), !0).forEach(function(n) {
      qn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : J$(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function kxe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ew(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, MT(n.key), n);
  }
}
function xxe(e, t, r) {
  return t && ew(e.prototype, t), r && ew(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Dxe(e, t, r) {
  return t = th(t), Cxe(e, jT() ? Reflect.construct(t, r || [], th(e).constructor) : t.apply(e, r));
}
function Cxe(e, t) {
  if (t && (Xu(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return cu(e);
}
function jT() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (jT = function() {
    return !!e;
  })();
}
function th(e) {
  return th = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, th(e);
}
function cu(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Sxe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && i3(e, t);
}
function i3(e, t) {
  return i3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, i3(e, t);
}
function qn(e, t, r) {
  return t = MT(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function MT(e) {
  var t = Axe(e, "string");
  return Xu(t) == "symbol" ? t : String(t);
}
function Axe(e, t) {
  if (Xu(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Xu(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ja = /* @__PURE__ */ function(e) {
  Sxe(t, e);
  function t(r) {
    var n;
    return kxe(this, t), n = Dxe(this, t, [r]), qn(cu(n), "pieRef", null), qn(cu(n), "sectorRefs", []), qn(cu(n), "id", ng("recharts-pie-")), qn(cu(n), "handleAnimationEnd", function() {
      var a = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), Ft(a) && a();
    }), qn(cu(n), "handleAnimationStart", function() {
      var a = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), Ft(a) && a();
    }), n.state = {
      isAnimationFinished: !r.isAnimationActive,
      prevIsAnimationActive: r.isAnimationActive,
      prevAnimationId: r.animationId,
      sectorToFocus: 0
    }, n;
  }
  return xxe(t, [{
    key: "isActiveIndex",
    value: function(n) {
      var a = this.props.activeIndex;
      return Array.isArray(a) ? a.indexOf(n) !== -1 : n === a;
    }
  }, {
    key: "hasActiveIndex",
    value: function() {
      var n = this.props.activeIndex;
      return Array.isArray(n) ? n.length !== 0 : n || n === 0;
    }
  }, {
    key: "renderLabels",
    value: function(n) {
      var a = this.props.isAnimationActive;
      if (a && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.label, u = i.labelLine, d = i.dataKey, s = i.valueKey, l = _t(this.props, !1), f = _t(o, !1), c = _t(u, !1), h = o && o.offsetRadius || 20, _ = n.map(function(F, v) {
        var $ = (F.startAngle + F.endAngle) / 2, E = Vt(F.cx, F.cy, F.outerRadius + h, $), D = er(er(er(er({}, l), F), {}, {
          stroke: "none"
        }, f), {}, {
          index: v,
          textAnchor: t.getTextAnchor(E.x, F.cx)
        }, E), w = er(er(er(er({}, l), F), {}, {
          fill: "none",
          stroke: F.fill
        }, c), {}, {
          index: v,
          points: [Vt(F.cx, F.cy, F.outerRadius, $), E],
          key: "line"
        }), k = d;
        return wt(d) && wt(s) ? k = "value" : wt(d) && (k = s), // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ M.createElement(cr, {
          key: "label-".concat(F.startAngle, "-").concat(F.endAngle, "-").concat(F.midAngle, "-").concat(v)
        }, u && t.renderLabelLineItem(u, w), t.renderLabelItem(o, D, En(F, k)));
      });
      return /* @__PURE__ */ M.createElement(cr, {
        className: "recharts-pie-labels"
      }, _);
    }
  }, {
    key: "renderSectorsStatically",
    value: function(n) {
      var a = this, i = this.props, o = i.activeShape, u = i.blendStroke, d = i.inactiveShape;
      return n.map(function(s, l) {
        if ((s == null ? void 0 : s.startAngle) === 0 && (s == null ? void 0 : s.endAngle) === 0 && n.length !== 1)
          return null;
        var f = a.isActiveIndex(l), c = d && a.hasActiveIndex() ? d : null, h = f ? o : c, _ = er(er({}, s), {}, {
          stroke: u ? s.fill : s.stroke,
          tabIndex: -1
        });
        return /* @__PURE__ */ M.createElement(cr, bu({
          ref: function(v) {
            v && !a.sectorRefs.includes(v) && a.sectorRefs.push(v);
          },
          tabIndex: -1,
          className: "recharts-pie-sector"
        }, ag(a.props, s, l), {
          // eslint-disable-next-line react/no-array-index-key
          key: "sector-".concat(s == null ? void 0 : s.startAngle, "-").concat(s == null ? void 0 : s.endAngle, "-").concat(s.midAngle, "-").concat(l)
        }), /* @__PURE__ */ M.createElement(pxe, bu({
          option: h,
          isActive: f,
          shapeType: "sector"
        }, _)));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function() {
      var n = this, a = this.props, i = a.sectors, o = a.isAnimationActive, u = a.animationBegin, d = a.animationDuration, s = a.animationEasing, l = a.animationId, f = this.state, c = f.prevSectors, h = f.prevIsAnimationActive;
      return /* @__PURE__ */ M.createElement(Eo, {
        begin: u,
        duration: d,
        isActive: o,
        easing: s,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(l, "-").concat(h),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function(_) {
        var F = _.t, v = [], $ = i && i[0], E = $.startAngle;
        return i.forEach(function(D, w) {
          var k = c && c[w], A = w > 0 ? Hn(D, "paddingAngle", 0) : 0;
          if (k) {
            var P = U8(k.endAngle - k.startAngle, D.endAngle - D.startAngle), S = er(er({}, D), {}, {
              startAngle: E + A,
              endAngle: E + P(F) + A
            });
            v.push(S), E = S.endAngle;
          } else {
            var N = D.endAngle, W = D.startAngle, V = U8(0, N - W), K = V(F), U = er(er({}, D), {}, {
              startAngle: E + A,
              endAngle: E + K + A
            });
            v.push(U), E = U.endAngle;
          }
        }), /* @__PURE__ */ M.createElement(cr, null, n.renderSectorsStatically(v));
      });
    }
  }, {
    key: "attachKeyboardHandlers",
    value: function(n) {
      var a = this;
      n.onkeydown = function(i) {
        if (!i.altKey)
          switch (i.key) {
            case "ArrowLeft": {
              var o = ++a.state.sectorToFocus % a.sectorRefs.length;
              a.sectorRefs[o].focus(), a.setState({
                sectorToFocus: o
              });
              break;
            }
            case "ArrowRight": {
              var u = --a.state.sectorToFocus < 0 ? a.sectorRefs.length - 1 : a.state.sectorToFocus % a.sectorRefs.length;
              a.sectorRefs[u].focus(), a.setState({
                sectorToFocus: u
              });
              break;
            }
            case "Escape": {
              a.sectorRefs[a.state.sectorToFocus].blur(), a.setState({
                sectorToFocus: 0
              });
              break;
            }
          }
      };
    }
  }, {
    key: "renderSectors",
    value: function() {
      var n = this.props, a = n.sectors, i = n.isAnimationActive, o = this.state.prevSectors;
      return i && a && a.length && (!o || !Y4(o, a)) ? this.renderSectorsWithAnimation() : this.renderSectorsStatically(a);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.pieRef && this.attachKeyboardHandlers(this.pieRef);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.hide, o = a.sectors, u = a.className, d = a.label, s = a.cx, l = a.cy, f = a.innerRadius, c = a.outerRadius, h = a.isAnimationActive, _ = this.state.isAnimationFinished;
      if (i || !o || !o.length || !Ve(s) || !Ve(l) || !Ve(f) || !Ve(c))
        return null;
      var F = Ct("recharts-pie", u);
      return /* @__PURE__ */ M.createElement(cr, {
        tabIndex: this.props.rootTabIndex,
        className: F,
        ref: function($) {
          n.pieRef = $;
        }
      }, this.renderSectors(), d && this.renderLabels(o), Br.renderCallByParent(this.props, null, !1), (!h || _) && _s.renderCallByParent(this.props, o, !1));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return a.prevIsAnimationActive !== n.isAnimationActive ? {
        prevIsAnimationActive: n.isAnimationActive,
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: [],
        isAnimationFinished: !0
      } : n.isAnimationActive && n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: a.curSectors,
        isAnimationFinished: !0
      } : n.sectors !== a.curSectors ? {
        curSectors: n.sectors,
        isAnimationFinished: !0
      } : null;
    }
  }, {
    key: "getTextAnchor",
    value: function(n, a) {
      return n > a ? "start" : n < a ? "end" : "middle";
    }
  }, {
    key: "renderLabelLineItem",
    value: function(n, a) {
      if (/* @__PURE__ */ M.isValidElement(n))
        return /* @__PURE__ */ M.cloneElement(n, a);
      if (Ft(n))
        return n(a);
      var i = Ct("recharts-pie-label-line", typeof n != "boolean" ? n.className : "");
      return /* @__PURE__ */ M.createElement(Wp, bu({}, a, {
        type: "linear",
        className: i
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function(n, a, i) {
      if (/* @__PURE__ */ M.isValidElement(n))
        return /* @__PURE__ */ M.cloneElement(n, a);
      var o = i;
      if (Ft(n) && (o = n(a), /* @__PURE__ */ M.isValidElement(o)))
        return o;
      var u = Ct("recharts-pie-label-text", typeof n != "boolean" && !Ft(n) ? n.className : "");
      return /* @__PURE__ */ M.createElement(Gu, bu({}, a, {
        alignmentBaseline: "middle",
        className: u
      }), o);
    }
  }]), t;
}(ji);
I1 = Ja;
qn(Ja, "displayName", "Pie");
qn(Ja, "defaultProps", {
  stroke: "#fff",
  fill: "#808080",
  legendType: "rect",
  cx: "50%",
  cy: "50%",
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: "80%",
  paddingAngle: 0,
  labelLine: !0,
  hide: !1,
  minAngle: 0,
  isAnimationActive: !cs.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: "ease",
  nameKey: "name",
  blendStroke: !1,
  rootTabIndex: 0
});
qn(Ja, "parseDeltaAngle", function(e, t) {
  var r = Un(t - e), n = Math.min(Math.abs(t - e), 360);
  return r * n;
});
qn(Ja, "getRealPieData", function(e) {
  var t = e.props, r = t.data, n = t.children, a = _t(e.props, !1), i = Wa(n, A0);
  return r && r.length ? r.map(function(o, u) {
    return er(er(er({
      payload: o
    }, a), o), i && i[u] && i[u].props);
  }) : i && i.length ? i.map(function(o) {
    return er(er({}, a), o.props);
  }) : [];
});
qn(Ja, "parseCoordinateOfPie", function(e, t) {
  var r = t.top, n = t.left, a = t.width, i = t.height, o = FT(a, i), u = n + dn(e.props.cx, a, a / 2), d = r + dn(e.props.cy, i, i / 2), s = dn(e.props.innerRadius, o, 0), l = dn(e.props.outerRadius, o, o * 0.8), f = e.props.maxRadius || Math.sqrt(a * a + i * i) / 2;
  return {
    cx: u,
    cy: d,
    innerRadius: s,
    outerRadius: l,
    maxRadius: f
  };
});
qn(Ja, "getComposedData", function(e) {
  var t = e.item, r = e.offset, n = I1.getRealPieData(t);
  if (!n || !n.length)
    return null;
  var a = t.props, i = a.cornerRadius, o = a.startAngle, u = a.endAngle, d = a.paddingAngle, s = a.dataKey, l = a.nameKey, f = a.valueKey, c = a.tooltipType, h = Math.abs(t.props.minAngle), _ = I1.parseCoordinateOfPie(t, r), F = I1.parseDeltaAngle(o, u), v = Math.abs(F), $ = s;
  wt(s) && wt(f) ? (Ci(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), $ = "value") : wt(s) && (Ci(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), $ = f);
  var E = n.filter(function(S) {
    return En(S, $, 0) !== 0;
  }).length, D = (v >= 360 ? E : E - 1) * d, w = v - E * h - D, k = n.reduce(function(S, N) {
    var W = En(N, $, 0);
    return S + (Ve(W) ? W : 0);
  }, 0), A;
  if (k > 0) {
    var P;
    A = n.map(function(S, N) {
      var W = En(S, $, 0), V = En(S, l, N), K = (Ve(W) ? W : 0) / k, U;
      N ? U = P.endAngle + Un(F) * d * (W !== 0 ? 1 : 0) : U = o;
      var j = U + Un(F) * ((W !== 0 ? h : 0) + K * w), G = (U + j) / 2, H = (_.innerRadius + _.outerRadius) / 2, J = [{
        name: V,
        value: W,
        payload: S,
        dataKey: $,
        type: c
      }], ae = Vt(_.cx, _.cy, H, G);
      return P = er(er(er({
        percent: K,
        cornerRadius: i,
        name: V,
        tooltipPayload: J,
        midAngle: G,
        middleRadius: H,
        tooltipPosition: ae
      }, S), _), {}, {
        value: En(S, $),
        startAngle: U,
        endAngle: j,
        payload: S,
        paddingAngle: Un(F) * d
      }), P;
    });
  }
  return er(er({}, _), {}, {
    sectors: A,
    data: n
  });
});
var Oxe = Math.ceil, Txe = Math.max;
function Pxe(e, t, r, n) {
  for (var a = -1, i = Txe(Oxe((t - e) / (r || 1)), 0), o = Array(i); i--; )
    o[n ? i : ++a] = e, e += r;
  return o;
}
var Ixe = Pxe, Rxe = cO, tw = 1 / 0, jxe = 17976931348623157e292;
function Mxe(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = Rxe(e), e === tw || e === -tw) {
    var t = e < 0 ? -1 : 1;
    return t * jxe;
  }
  return e === e ? e : 0;
}
var Bxe = Mxe, Nxe = Ixe, Lxe = fg, j2 = Bxe;
function qxe(e) {
  return function(t, r, n) {
    return n && typeof n != "number" && Lxe(t, r, n) && (r = n = void 0), t = j2(t), r === void 0 ? (r = t, t = 0) : r = j2(r), n = n === void 0 ? t < r ? 1 : -1 : j2(n), Nxe(t, r, n, e);
  };
}
var Uxe = qxe, Gxe = Uxe, Wxe = Gxe(), rh = Wxe;
function bf(e) {
  return bf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, bf(e);
}
function rw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function nw(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? rw(Object(r), !0).forEach(function(n) {
      BT(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : rw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function BT(e, t, r) {
  return t = Vxe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Vxe(e) {
  var t = Hxe(e, "string");
  return bf(t) == "symbol" ? t : String(t);
}
function Hxe(e, t) {
  if (bf(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (bf(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var zxe = ["Webkit", "Moz", "O", "ms"], Kxe = function(t, r) {
  if (!t)
    return null;
  var n = t.replace(/(\w)/, function(i) {
    return i.toUpperCase();
  }), a = zxe.reduce(function(i, o) {
    return nw(nw({}, i), {}, BT({}, o + n, r));
  }, {});
  return a[t] = r, a;
};
function Qu(e) {
  return Qu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Qu(e);
}
function nh() {
  return nh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, nh.apply(this, arguments);
}
function aw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function M2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? aw(Object(r), !0).forEach(function(n) {
      yn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : aw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Yxe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function iw(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, LT(n.key), n);
  }
}
function Xxe(e, t, r) {
  return t && iw(e.prototype, t), r && iw(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Qxe(e, t, r) {
  return t = ah(t), Zxe(e, NT() ? Reflect.construct(t, r || [], ah(e).constructor) : t.apply(e, r));
}
function Zxe(e, t) {
  if (t && (Qu(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ra(e);
}
function NT() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (NT = function() {
    return !!e;
  })();
}
function ah(e) {
  return ah = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ah(e);
}
function Ra(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Jxe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && o3(e, t);
}
function o3(e, t) {
  return o3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, o3(e, t);
}
function yn(e, t, r) {
  return t = LT(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function LT(e) {
  var t = eDe(e, "string");
  return Qu(t) == "symbol" ? t : String(t);
}
function eDe(e, t) {
  if (Qu(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Qu(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var tDe = function(t) {
  var r = t.data, n = t.startIndex, a = t.endIndex, i = t.x, o = t.width, u = t.travellerWidth;
  if (!r || !r.length)
    return {};
  var d = r.length, s = Fl().domain(rh(0, d)).range([i, i + o - u]), l = s.domain().map(function(f) {
    return s(f);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: s(n),
    endX: s(a),
    scale: s,
    scaleValues: l
  };
}, ow = function(t) {
  return t.changedTouches && !!t.changedTouches.length;
}, Zu = /* @__PURE__ */ function(e) {
  Jxe(t, e);
  function t(r) {
    var n;
    return Yxe(this, t), n = Qxe(this, t, [r]), yn(Ra(n), "handleDrag", function(a) {
      n.leaveTimer && (clearTimeout(n.leaveTimer), n.leaveTimer = null), n.state.isTravellerMoving ? n.handleTravellerMove(a) : n.state.isSlideMoving && n.handleSlideDrag(a);
    }), yn(Ra(n), "handleTouchMove", function(a) {
      a.changedTouches != null && a.changedTouches.length > 0 && n.handleDrag(a.changedTouches[0]);
    }), yn(Ra(n), "handleDragEnd", function() {
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var a = n.props, i = a.endIndex, o = a.onDragEnd, u = a.startIndex;
        o == null || o({
          endIndex: i,
          startIndex: u
        });
      }), n.detachDragEndListener();
    }), yn(Ra(n), "handleLeaveWrapper", function() {
      (n.state.isTravellerMoving || n.state.isSlideMoving) && (n.leaveTimer = window.setTimeout(n.handleDragEnd, n.props.leaveTimeOut));
    }), yn(Ra(n), "handleEnterSlideOrTraveller", function() {
      n.setState({
        isTextActive: !0
      });
    }), yn(Ra(n), "handleLeaveSlideOrTraveller", function() {
      n.setState({
        isTextActive: !1
      });
    }), yn(Ra(n), "handleSlideDragStart", function(a) {
      var i = ow(a) ? a.changedTouches[0] : a;
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: i.pageX
      }), n.attachDragEndListener();
    }), n.travellerDragStartHandlers = {
      startX: n.handleTravellerDragStart.bind(Ra(n), "startX"),
      endX: n.handleTravellerDragStart.bind(Ra(n), "endX")
    }, n.state = {}, n;
  }
  return Xxe(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(n) {
      var a = n.startX, i = n.endX, o = this.state.scaleValues, u = this.props, d = u.gap, s = u.data, l = s.length - 1, f = Math.min(a, i), c = Math.max(a, i), h = t.getIndexInRange(o, f), _ = t.getIndexInRange(o, c);
      return {
        startIndex: h - h % d,
        endIndex: _ === l ? l : _ - _ % d
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(n) {
      var a = this.props, i = a.data, o = a.tickFormatter, u = a.dataKey, d = En(i[n], u, n);
      return Ft(o) ? o(d, n) : d;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(n) {
      var a = this.state, i = a.slideMoveStartX, o = a.startX, u = a.endX, d = this.props, s = d.x, l = d.width, f = d.travellerWidth, c = d.startIndex, h = d.endIndex, _ = d.onChange, F = n.pageX - i;
      F > 0 ? F = Math.min(F, s + l - f - u, s + l - f - o) : F < 0 && (F = Math.max(F, s - o, s - u));
      var v = this.getIndex({
        startX: o + F,
        endX: u + F
      });
      (v.startIndex !== c || v.endIndex !== h) && _ && _(v), this.setState({
        startX: o + F,
        endX: u + F,
        slideMoveStartX: n.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(n, a) {
      var i = ow(a) ? a.changedTouches[0] : a;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: n,
        brushMoveStartX: i.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(n) {
      var a = this.state, i = a.brushMoveStartX, o = a.movingTravellerId, u = a.endX, d = a.startX, s = this.state[o], l = this.props, f = l.x, c = l.width, h = l.travellerWidth, _ = l.onChange, F = l.gap, v = l.data, $ = {
        startX: this.state.startX,
        endX: this.state.endX
      }, E = n.pageX - i;
      E > 0 ? E = Math.min(E, f + c - h - s) : E < 0 && (E = Math.max(E, f - s)), $[o] = s + E;
      var D = this.getIndex($), w = D.startIndex, k = D.endIndex, A = function() {
        var S = v.length - 1;
        return o === "startX" && (u > d ? w % F === 0 : k % F === 0) || u < d && k === S || o === "endX" && (u > d ? k % F === 0 : w % F === 0) || u > d && k === S;
      };
      this.setState(yn(yn({}, o, s + E), "brushMoveStartX", n.pageX), function() {
        _ && A() && _(D);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(n, a) {
      var i = this, o = this.state, u = o.scaleValues, d = o.startX, s = o.endX, l = this.state[a], f = u.indexOf(l);
      if (f !== -1) {
        var c = f + n;
        if (!(c === -1 || c >= u.length)) {
          var h = u[c];
          a === "startX" && h >= s || a === "endX" && h <= d || this.setState(yn({}, a, h), function() {
            i.props.onChange(i.getIndex({
              startX: i.state.startX,
              endX: i.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, u = n.height, d = n.fill, s = n.stroke;
      return /* @__PURE__ */ M.createElement("rect", {
        stroke: s,
        fill: d,
        x: a,
        y: i,
        width: o,
        height: u
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, u = n.height, d = n.data, s = n.children, l = n.padding, f = Vn.only(s);
      return f ? /* @__PURE__ */ M.cloneElement(f, {
        x: a,
        y: i,
        width: o,
        height: u,
        margin: l,
        compact: !0,
        data: d
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(n, a) {
      var i = this, o = this.props, u = o.y, d = o.travellerWidth, s = o.height, l = o.traveller, f = o.ariaLabel, c = o.data, h = o.startIndex, _ = o.endIndex, F = Math.max(n, this.props.x), v = M2(M2({}, _t(this.props, !1)), {}, {
        x: F,
        y: u,
        width: d,
        height: s
      }), $ = f || "Min value: ".concat(c[h].name, ", Max value: ").concat(c[_].name);
      return /* @__PURE__ */ M.createElement(cr, {
        tabIndex: 0,
        role: "slider",
        "aria-label": $,
        "aria-valuenow": n,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[a],
        onTouchStart: this.travellerDragStartHandlers[a],
        onKeyDown: function(D) {
          ["ArrowLeft", "ArrowRight"].includes(D.key) && (D.preventDefault(), D.stopPropagation(), i.handleTravellerMoveKeyboard(D.key === "ArrowRight" ? 1 : -1, a));
        },
        onFocus: function() {
          i.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          i.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, t.renderTraveller(l, v));
    }
  }, {
    key: "renderSlide",
    value: function(n, a) {
      var i = this.props, o = i.y, u = i.height, d = i.stroke, s = i.travellerWidth, l = Math.min(n, a) + s, f = Math.max(Math.abs(a - n) - s, 0);
      return /* @__PURE__ */ M.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: d,
        fillOpacity: 0.2,
        x: l,
        y: o,
        width: f,
        height: u
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var n = this.props, a = n.startIndex, i = n.endIndex, o = n.y, u = n.height, d = n.travellerWidth, s = n.stroke, l = this.state, f = l.startX, c = l.endX, h = 5, _ = {
        pointerEvents: "none",
        fill: s
      };
      return /* @__PURE__ */ M.createElement(cr, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ M.createElement(Gu, nh({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(f, c) - h,
        y: o + u / 2
      }, _), this.getTextOfTick(a)), /* @__PURE__ */ M.createElement(Gu, nh({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(f, c) + d + h,
        y: o + u / 2
      }, _), this.getTextOfTick(i)));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.data, i = n.className, o = n.children, u = n.x, d = n.y, s = n.width, l = n.height, f = n.alwaysShowText, c = this.state, h = c.startX, _ = c.endX, F = c.isTextActive, v = c.isSlideMoving, $ = c.isTravellerMoving, E = c.isTravellerFocused;
      if (!a || !a.length || !Ve(u) || !Ve(d) || !Ve(s) || !Ve(l) || s <= 0 || l <= 0)
        return null;
      var D = Ct("recharts-brush", i), w = M.Children.count(o) === 1, k = Kxe("userSelect", "none");
      return /* @__PURE__ */ M.createElement(cr, {
        className: D,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: k
      }, this.renderBackground(), w && this.renderPanorama(), this.renderSlide(h, _), this.renderTravellerLayer(h, "startX"), this.renderTravellerLayer(_, "endX"), (F || v || $ || E || f) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(n) {
      var a = n.x, i = n.y, o = n.width, u = n.height, d = n.stroke, s = Math.floor(i + u / 2) - 1;
      return /* @__PURE__ */ M.createElement(M.Fragment, null, /* @__PURE__ */ M.createElement("rect", {
        x: a,
        y: i,
        width: o,
        height: u,
        fill: d,
        stroke: "none"
      }), /* @__PURE__ */ M.createElement("line", {
        x1: a + 1,
        y1: s,
        x2: a + o - 1,
        y2: s,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ M.createElement("line", {
        x1: a + 1,
        y1: s + 2,
        x2: a + o - 1,
        y2: s + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(n, a) {
      var i;
      return /* @__PURE__ */ M.isValidElement(n) ? i = /* @__PURE__ */ M.cloneElement(n, a) : Ft(n) ? i = n(a) : i = t.renderDefaultTraveller(a), i;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      var i = n.data, o = n.width, u = n.x, d = n.travellerWidth, s = n.updateId, l = n.startIndex, f = n.endIndex;
      if (i !== a.prevData || s !== a.prevUpdateId)
        return M2({
          prevData: i,
          prevTravellerWidth: d,
          prevUpdateId: s,
          prevX: u,
          prevWidth: o
        }, i && i.length ? tDe({
          data: i,
          width: o,
          x: u,
          travellerWidth: d,
          startIndex: l,
          endIndex: f
        }) : {
          scale: null,
          scaleValues: null
        });
      if (a.scale && (o !== a.prevWidth || u !== a.prevX || d !== a.prevTravellerWidth)) {
        a.scale.range([u, u + o - d]);
        var c = a.scale.domain().map(function(h) {
          return a.scale(h);
        });
        return {
          prevData: i,
          prevTravellerWidth: d,
          prevUpdateId: s,
          prevX: u,
          prevWidth: o,
          startX: a.scale(n.startIndex),
          endX: a.scale(n.endIndex),
          scaleValues: c
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(n, a) {
      for (var i = n.length, o = 0, u = i - 1; u - o > 1; ) {
        var d = Math.floor((o + u) / 2);
        n[d] > a ? u = d : o = d;
      }
      return a >= n[u] ? u : o;
    }
  }]), t;
}(ji);
yn(Zu, "displayName", "Brush");
yn(Zu, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var rDe = w4;
function nDe(e, t) {
  var r;
  return rDe(e, function(n, a, i) {
    return r = t(n, a, i), !r;
  }), !!r;
}
var aDe = nDe, iDe = LA, oDe = Do, sDe = aDe, uDe = cn, dDe = fg;
function lDe(e, t, r) {
  var n = uDe(e) ? iDe : sDe;
  return r && dDe(e, t, r) && (t = void 0), n(e, oDe(t));
}
var fDe = lDe, Ha = function(t, r) {
  var n = t.alwaysShow, a = t.ifOverflow;
  return n && (a = "extendDomain"), a === r;
}, sw = sO;
function cDe(e, t, r) {
  t == "__proto__" && sw ? sw(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var hDe = cDe, gDe = hDe, _De = iO, mDe = Do;
function pDe(e, t) {
  var r = {};
  return t = mDe(t), _De(e, function(n, a, i) {
    gDe(r, a, t(n, a, i));
  }), r;
}
var FDe = pDe;
function yDe(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (!t(e[r], r, e))
      return !1;
  return !0;
}
var bDe = yDe, vDe = w4;
function EDe(e, t) {
  var r = !0;
  return vDe(e, function(n, a, i) {
    return r = !!t(n, a, i), r;
  }), r;
}
var $De = EDe, wDe = bDe, kDe = $De, xDe = Do, DDe = cn, CDe = fg;
function SDe(e, t, r) {
  var n = DDe(e) ? wDe : kDe;
  return r && CDe(e, t, r) && (t = void 0), n(e, xDe(t));
}
var ADe = SDe;
function vf(e) {
  return vf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vf(e);
}
function ODe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function uw(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, qT(n.key), n);
  }
}
function TDe(e, t, r) {
  return t && uw(e.prototype, t), r && uw(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function dw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function E1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dw(Object(r), !0).forEach(function(n) {
      ry(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : dw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ry(e, t, r) {
  return t = qT(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function qT(e) {
  var t = PDe(e, "string");
  return vf(t) == "symbol" ? t : String(t);
}
function PDe(e, t) {
  if (vf(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (vf(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var UT = function(t, r) {
  var n = t.x, a = t.y, i = r.x, o = r.y;
  return {
    x: Math.min(n, i),
    y: Math.min(a, o),
    width: Math.abs(i - n),
    height: Math.abs(o - a)
  };
}, IDe = function(t) {
  var r = t.x1, n = t.y1, a = t.x2, i = t.y2;
  return UT({
    x: r,
    y: n
  }, {
    x: a,
    y: i
  });
}, GT = /* @__PURE__ */ function() {
  function e(t) {
    ODe(this, e), this.scale = t;
  }
  return TDe(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.bandAware, i = n.position;
      if (r !== void 0) {
        if (i)
          switch (i) {
            case "start":
              return this.scale(r);
            case "middle": {
              var o = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(r) + o;
            }
            case "end": {
              var u = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(r) + u;
            }
            default:
              return this.scale(r);
          }
        if (a) {
          var d = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(r) + d;
        }
        return this.scale(r);
      }
    }
  }, {
    key: "isInRange",
    value: function(r) {
      var n = this.range(), a = n[0], i = n[n.length - 1];
      return a <= i ? r >= a && r <= i : r >= i && r <= a;
    }
  }], [{
    key: "create",
    value: function(r) {
      return new e(r);
    }
  }]), e;
}();
ry(GT, "EPS", 1e-4);
var ny = function(t) {
  var r = Object.keys(t).reduce(function(n, a) {
    return E1(E1({}, n), {}, ry({}, a, GT.create(t[a])));
  }, {});
  return E1(E1({}, r), {}, {
    apply: function(a) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = i.bandAware, u = i.position;
      return FDe(a, function(d, s) {
        return r[s].apply(d, {
          bandAware: o,
          position: u
        });
      });
    },
    isInRange: function(a) {
      return ADe(a, function(i, o) {
        return r[o].isInRange(i);
      });
    }
  });
}, RDe = sA(function(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width,
    height: e.height
  };
}, function(e) {
  return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
});
function ih(e) {
  return ih = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ih(e);
}
var WT = /* @__PURE__ */ dr(void 0), VT = /* @__PURE__ */ dr(void 0), HT = /* @__PURE__ */ dr(void 0), jDe = /* @__PURE__ */ dr({}), zT = /* @__PURE__ */ dr(void 0), MDe = /* @__PURE__ */ dr(0), BDe = /* @__PURE__ */ dr(0), lw = function(t) {
  var r = t.state, n = r.xAxisMap, a = r.yAxisMap, i = r.offset, o = t.clipPathId, u = t.children, d = t.width, s = t.height, l = RDe(i);
  return /* @__PURE__ */ M.createElement(WT.Provider, {
    value: n
  }, /* @__PURE__ */ M.createElement(VT.Provider, {
    value: a
  }, /* @__PURE__ */ M.createElement(jDe.Provider, {
    value: i
  }, /* @__PURE__ */ M.createElement(HT.Provider, {
    value: l
  }, /* @__PURE__ */ M.createElement(zT.Provider, {
    value: o
  }, /* @__PURE__ */ M.createElement(MDe.Provider, {
    value: s
  }, /* @__PURE__ */ M.createElement(BDe.Provider, {
    value: d
  }, u)))))));
}, NDe = function() {
  return Et(zT);
};
function KT(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
}
var LDe = function(t) {
  var r = Et(WT);
  r == null && (process.env.NODE_ENV !== "production" ? Wn(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : Wn(!1));
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? Wn(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(ih(t), "]. ").concat(KT(r))) : Wn(!1)), n;
}, qDe = function(t) {
  var r = Et(VT);
  r == null && (process.env.NODE_ENV !== "production" ? Wn(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : Wn(!1));
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? Wn(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(ih(t), "]. ").concat(KT(r))) : Wn(!1)), n;
}, UDe = function() {
  var t = Et(HT);
  return t;
};
function Ef(e) {
  return Ef = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ef(e);
}
function fw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function cw(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fw(Object(r), !0).forEach(function(n) {
      GDe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function GDe(e, t, r) {
  return t = WDe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function WDe(e) {
  var t = VDe(e, "string");
  return Ef(t) == "symbol" ? t : String(t);
}
function VDe(e, t) {
  if (Ef(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ef(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function HDe(e, t) {
  return XDe(e) || YDe(e, t) || KDe(e, t) || zDe();
}
function zDe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function KDe(e, t) {
  if (e) {
    if (typeof e == "string")
      return hw(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return hw(e, t);
  }
}
function hw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function YDe(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], d = !0, s = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        d = !1;
      } else
        for (; !(d = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); d = !0)
          ;
    } catch (l) {
      s = !0, a = l;
    } finally {
      try {
        if (!d && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (s)
          throw a;
      }
    }
    return u;
  }
}
function XDe(e) {
  if (Array.isArray(e))
    return e;
}
function s3() {
  return s3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, s3.apply(this, arguments);
}
var QDe = function(t, r) {
  var n;
  return /* @__PURE__ */ M.isValidElement(t) ? n = /* @__PURE__ */ M.cloneElement(t, r) : Ft(t) ? n = t(r) : n = /* @__PURE__ */ M.createElement("line", s3({}, r, {
    className: "recharts-reference-line-line"
  })), n;
}, ZDe = function(t, r, n, a, i, o, u, d, s) {
  var l = i.x, f = i.y, c = i.width, h = i.height;
  if (n) {
    var _ = s.y, F = t.y.apply(_, {
      position: o
    });
    if (Ha(s, "discard") && !t.y.isInRange(F))
      return null;
    var v = [{
      x: l + c,
      y: F
    }, {
      x: l,
      y: F
    }];
    return d === "left" ? v.reverse() : v;
  }
  if (r) {
    var $ = s.x, E = t.x.apply($, {
      position: o
    });
    if (Ha(s, "discard") && !t.x.isInRange(E))
      return null;
    var D = [{
      x: E,
      y: f + h
    }, {
      x: E,
      y: f
    }];
    return u === "top" ? D.reverse() : D;
  }
  if (a) {
    var w = s.segment, k = w.map(function(A) {
      return t.apply(A, {
        position: o
      });
    });
    return Ha(s, "discard") && fDe(k, function(A) {
      return !t.isInRange(A);
    }) ? null : k;
  }
  return null;
};
function ay(e) {
  var t = e.x, r = e.y, n = e.segment, a = e.xAxisId, i = e.yAxisId, o = e.shape, u = e.className, d = e.alwaysShow, s = NDe(), l = LDe(a), f = qDe(i), c = UDe();
  if (!s || !c)
    return null;
  Ci(d === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var h = ny({
    x: l.scale,
    y: f.scale
  }), _ = $r(t), F = $r(r), v = n && n.length === 2, $ = ZDe(h, _, F, v, c, e.position, l.orientation, f.orientation, e);
  if (!$)
    return null;
  var E = HDe($, 2), D = E[0], w = D.x, k = D.y, A = E[1], P = A.x, S = A.y, N = Ha(e, "hidden") ? "url(#".concat(s, ")") : void 0, W = cw(cw({
    clipPath: N
  }, _t(e, !0)), {}, {
    x1: w,
    y1: k,
    x2: P,
    y2: S
  });
  return /* @__PURE__ */ M.createElement(cr, {
    className: Ct("recharts-reference-line", u)
  }, QDe(o, W), Br.renderCallByParent(e, IDe({
    x1: w,
    y1: k,
    x2: P,
    y2: S
  })));
}
ay.displayName = "ReferenceLine";
ay.defaultProps = {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
};
function $f(e) {
  return $f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $f(e);
}
function u3() {
  return u3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, u3.apply(this, arguments);
}
function gw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _w(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gw(Object(r), !0).forEach(function(n) {
      JDe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : gw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function JDe(e, t, r) {
  return t = eCe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function eCe(e) {
  var t = tCe(e, "string");
  return $f(t) == "symbol" ? t : String(t);
}
function tCe(e, t) {
  if ($f(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if ($f(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var rCe = function(t) {
  var r = t.x, n = t.y, a = t.xAxis, i = t.yAxis, o = ny({
    x: a.scale,
    y: i.scale
  }), u = o.apply({
    x: r,
    y: n
  }, {
    bandAware: !0
  });
  return Ha(t, "discard") && !o.isInRange(u) ? null : u;
};
function Jf(e) {
  var t = e.x, r = e.y, n = e.r, a = e.alwaysShow, i = e.clipPathId, o = $r(t), u = $r(r);
  if (Ci(a === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !o || !u)
    return null;
  var d = rCe(e);
  if (!d)
    return null;
  var s = d.x, l = d.y, f = e.shape, c = e.className, h = Ha(e, "hidden") ? "url(#".concat(i, ")") : void 0, _ = _w(_w({
    clipPath: h
  }, _t(e, !0)), {}, {
    cx: s,
    cy: l
  });
  return /* @__PURE__ */ M.createElement(cr, {
    className: Ct("recharts-reference-dot", c)
  }, Jf.renderDot(f, _), Br.renderCallByParent(e, {
    x: s - n,
    y: l - n,
    width: 2 * n,
    height: 2 * n
  }));
}
Jf.displayName = "ReferenceDot";
Jf.defaultProps = {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
};
Jf.renderDot = function(e, t) {
  var r;
  return /* @__PURE__ */ M.isValidElement(e) ? r = /* @__PURE__ */ M.cloneElement(e, t) : Ft(e) ? r = e(t) : r = /* @__PURE__ */ M.createElement(ty, u3({}, t, {
    cx: t.cx,
    cy: t.cy,
    className: "recharts-reference-dot-dot"
  })), r;
};
function wf(e) {
  return wf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wf(e);
}
function d3() {
  return d3 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, d3.apply(this, arguments);
}
function mw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pw(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? mw(Object(r), !0).forEach(function(n) {
      nCe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : mw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function nCe(e, t, r) {
  return t = aCe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function aCe(e) {
  var t = iCe(e, "string");
  return wf(t) == "symbol" ? t : String(t);
}
function iCe(e, t) {
  if (wf(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (wf(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var oCe = function(t, r, n, a, i) {
  var o = i.x1, u = i.x2, d = i.y1, s = i.y2, l = i.xAxis, f = i.yAxis;
  if (!l || !f)
    return null;
  var c = ny({
    x: l.scale,
    y: f.scale
  }), h = {
    x: t ? c.x.apply(o, {
      position: "start"
    }) : c.x.rangeMin,
    y: n ? c.y.apply(d, {
      position: "start"
    }) : c.y.rangeMin
  }, _ = {
    x: r ? c.x.apply(u, {
      position: "end"
    }) : c.x.rangeMax,
    y: a ? c.y.apply(s, {
      position: "end"
    }) : c.y.rangeMax
  };
  return Ha(i, "discard") && (!c.isInRange(h) || !c.isInRange(_)) ? null : UT(h, _);
};
function ec(e) {
  var t = e.x1, r = e.x2, n = e.y1, a = e.y2, i = e.className, o = e.alwaysShow, u = e.clipPathId;
  Ci(o === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var d = $r(t), s = $r(r), l = $r(n), f = $r(a), c = e.shape;
  if (!d && !s && !l && !f && !c)
    return null;
  var h = oCe(d, s, l, f, e);
  if (!h && !c)
    return null;
  var _ = Ha(e, "hidden") ? "url(#".concat(u, ")") : void 0;
  return /* @__PURE__ */ M.createElement(cr, {
    className: Ct("recharts-reference-area", i)
  }, ec.renderRect(c, pw(pw({
    clipPath: _
  }, _t(e, !0)), h)), Br.renderCallByParent(e, h));
}
ec.displayName = "ReferenceArea";
ec.defaultProps = {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
};
ec.renderRect = function(e, t) {
  var r;
  return /* @__PURE__ */ M.isValidElement(e) ? r = /* @__PURE__ */ M.cloneElement(e, t) : Ft(e) ? r = e(t) : r = /* @__PURE__ */ M.createElement(ey, d3({}, t, {
    className: "recharts-reference-area-rect"
  })), r;
};
function Fw(e) {
  return lCe(e) || dCe(e) || uCe(e) || sCe();
}
function sCe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function uCe(e, t) {
  if (e) {
    if (typeof e == "string")
      return l3(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return l3(e, t);
  }
}
function dCe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function lCe(e) {
  if (Array.isArray(e))
    return l3(e);
}
function l3(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var f3 = function(t, r, n, a, i) {
  var o = Wa(t, ay), u = Wa(t, Jf), d = [].concat(Fw(o), Fw(u)), s = Wa(t, ec), l = "".concat(a, "Id"), f = a[0], c = r;
  if (d.length && (c = d.reduce(function(F, v) {
    if (v.props[l] === n && Ha(v.props, "extendDomain") && Ve(v.props[f])) {
      var $ = v.props[f];
      return [Math.min(F[0], $), Math.max(F[1], $)];
    }
    return F;
  }, c)), s.length) {
    var h = "".concat(f, "1"), _ = "".concat(f, "2");
    c = s.reduce(function(F, v) {
      if (v.props[l] === n && Ha(v.props, "extendDomain") && Ve(v.props[h]) && Ve(v.props[_])) {
        var $ = v.props[h], E = v.props[_];
        return [Math.min(F[0], $, E), Math.max(F[1], $, E)];
      }
      return F;
    }, c);
  }
  return i && i.length && (c = i.reduce(function(F, v) {
    return Ve(v) ? [Math.min(F[0], v), Math.max(F[1], v)] : F;
  }, c)), c;
}, c3 = {}, fCe = {
  get exports() {
    return c3;
  },
  set exports(e) {
    c3 = e;
  }
};
(function(e) {
  var t = Object.prototype.hasOwnProperty, r = "~";
  function n() {
  }
  Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
  function a(d, s, l) {
    this.fn = d, this.context = s, this.once = l || !1;
  }
  function i(d, s, l, f, c) {
    if (typeof l != "function")
      throw new TypeError("The listener must be a function");
    var h = new a(l, f || d, c), _ = r ? r + s : s;
    return d._events[_] ? d._events[_].fn ? d._events[_] = [d._events[_], h] : d._events[_].push(h) : (d._events[_] = h, d._eventsCount++), d;
  }
  function o(d, s) {
    --d._eventsCount === 0 ? d._events = new n() : delete d._events[s];
  }
  function u() {
    this._events = new n(), this._eventsCount = 0;
  }
  u.prototype.eventNames = function() {
    var s = [], l, f;
    if (this._eventsCount === 0)
      return s;
    for (f in l = this._events)
      t.call(l, f) && s.push(r ? f.slice(1) : f);
    return Object.getOwnPropertySymbols ? s.concat(Object.getOwnPropertySymbols(l)) : s;
  }, u.prototype.listeners = function(s) {
    var l = r ? r + s : s, f = this._events[l];
    if (!f)
      return [];
    if (f.fn)
      return [f.fn];
    for (var c = 0, h = f.length, _ = new Array(h); c < h; c++)
      _[c] = f[c].fn;
    return _;
  }, u.prototype.listenerCount = function(s) {
    var l = r ? r + s : s, f = this._events[l];
    return f ? f.fn ? 1 : f.length : 0;
  }, u.prototype.emit = function(s, l, f, c, h, _) {
    var F = r ? r + s : s;
    if (!this._events[F])
      return !1;
    var v = this._events[F], $ = arguments.length, E, D;
    if (v.fn) {
      switch (v.once && this.removeListener(s, v.fn, void 0, !0), $) {
        case 1:
          return v.fn.call(v.context), !0;
        case 2:
          return v.fn.call(v.context, l), !0;
        case 3:
          return v.fn.call(v.context, l, f), !0;
        case 4:
          return v.fn.call(v.context, l, f, c), !0;
        case 5:
          return v.fn.call(v.context, l, f, c, h), !0;
        case 6:
          return v.fn.call(v.context, l, f, c, h, _), !0;
      }
      for (D = 1, E = new Array($ - 1); D < $; D++)
        E[D - 1] = arguments[D];
      v.fn.apply(v.context, E);
    } else {
      var w = v.length, k;
      for (D = 0; D < w; D++)
        switch (v[D].once && this.removeListener(s, v[D].fn, void 0, !0), $) {
          case 1:
            v[D].fn.call(v[D].context);
            break;
          case 2:
            v[D].fn.call(v[D].context, l);
            break;
          case 3:
            v[D].fn.call(v[D].context, l, f);
            break;
          case 4:
            v[D].fn.call(v[D].context, l, f, c);
            break;
          default:
            if (!E)
              for (k = 1, E = new Array($ - 1); k < $; k++)
                E[k - 1] = arguments[k];
            v[D].fn.apply(v[D].context, E);
        }
    }
    return !0;
  }, u.prototype.on = function(s, l, f) {
    return i(this, s, l, f, !1);
  }, u.prototype.once = function(s, l, f) {
    return i(this, s, l, f, !0);
  }, u.prototype.removeListener = function(s, l, f, c) {
    var h = r ? r + s : s;
    if (!this._events[h])
      return this;
    if (!l)
      return o(this, h), this;
    var _ = this._events[h];
    if (_.fn)
      _.fn === l && (!c || _.once) && (!f || _.context === f) && o(this, h);
    else {
      for (var F = 0, v = [], $ = _.length; F < $; F++)
        (_[F].fn !== l || c && !_[F].once || f && _[F].context !== f) && v.push(_[F]);
      v.length ? this._events[h] = v.length === 1 ? v[0] : v : o(this, h);
    }
    return this;
  }, u.prototype.removeAllListeners = function(s) {
    var l;
    return s ? (l = r ? r + s : s, this._events[l] && o(this, l)) : (this._events = new n(), this._eventsCount = 0), this;
  }, u.prototype.off = u.prototype.removeListener, u.prototype.addListener = u.prototype.on, u.prefixed = r, u.EventEmitter = u, e.exports = u;
})(fCe);
const cCe = c3;
var B2 = new cCe(), N2 = "recharts.syncMouseEvents";
function kf(e) {
  return kf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, kf(e);
}
function hCe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function yw(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, YT(n.key), n);
  }
}
function gCe(e, t, r) {
  return t && yw(e.prototype, t), r && yw(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function L2(e, t, r) {
  return t = YT(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function YT(e) {
  var t = _Ce(e, "string");
  return kf(t) == "symbol" ? t : String(t);
}
function _Ce(e, t) {
  if (kf(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (kf(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var mCe = /* @__PURE__ */ function() {
  function e() {
    hCe(this, e), L2(this, "activeIndex", 0), L2(this, "coordinateList", []), L2(this, "layout", "horizontal");
  }
  return gCe(e, [{
    key: "setDetails",
    value: function(r) {
      var n, a = r.coordinateList, i = a === void 0 ? null : a, o = r.container, u = o === void 0 ? null : o, d = r.layout, s = d === void 0 ? null : d, l = r.offset, f = l === void 0 ? null : l, c = r.mouseHandlerCallback, h = c === void 0 ? null : c;
      this.coordinateList = (n = i ?? this.coordinateList) !== null && n !== void 0 ? n : [], this.container = u ?? this.container, this.layout = s ?? this.layout, this.offset = f ?? this.offset, this.mouseHandlerCallback = h ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(r) {
      if (this.coordinateList.length !== 0)
        switch (r.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(r) {
      this.activeIndex = r;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var r, n;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var a = this.container.getBoundingClientRect(), i = a.x, o = a.y, u = a.height, d = this.coordinateList[this.activeIndex].coordinate, s = ((r = window) === null || r === void 0 ? void 0 : r.scrollX) || 0, l = ((n = window) === null || n === void 0 ? void 0 : n.scrollY) || 0, f = i + d + s, c = o + this.offset.top + u / 2 + l;
        this.mouseHandlerCallback({
          pageX: f,
          pageY: c
        });
      }
    }
  }]), e;
}();
function pCe(e, t, r) {
  if (r === "number" && t === !0 && Array.isArray(e)) {
    var n = e == null ? void 0 : e[0], a = e == null ? void 0 : e[1];
    if (n && a && Ve(n) && Ve(a))
      return !0;
  }
  return !1;
}
function FCe(e, t, r, n) {
  var a = n / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - a : r.left + 0.5,
    y: e === "horizontal" ? r.top + 0.5 : t.y - a,
    width: e === "horizontal" ? n : r.width - 1,
    height: e === "horizontal" ? r.height - 1 : n
  };
}
function XT(e) {
  var t = e.cx, r = e.cy, n = e.radius, a = e.startAngle, i = e.endAngle, o = Vt(t, r, n, a), u = Vt(t, r, n, i);
  return {
    points: [o, u],
    cx: t,
    cy: r,
    radius: n,
    startAngle: a,
    endAngle: i
  };
}
function yCe(e, t, r) {
  var n, a, i, o;
  if (e === "horizontal")
    n = t.x, i = n, a = r.top, o = r.top + r.height;
  else if (e === "vertical")
    a = t.y, o = a, n = r.left, i = r.left + r.width;
  else if (t.cx != null && t.cy != null)
    if (e === "centric") {
      var u = t.cx, d = t.cy, s = t.innerRadius, l = t.outerRadius, f = t.angle, c = Vt(u, d, s, f), h = Vt(u, d, l, f);
      n = c.x, a = c.y, i = h.x, o = h.y;
    } else
      return XT(t);
  return [{
    x: n,
    y: a
  }, {
    x: i,
    y: o
  }];
}
function xf(e) {
  return xf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xf(e);
}
function bw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bw(Object(r), !0).forEach(function(n) {
      bCe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function bCe(e, t, r) {
  return t = vCe(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function vCe(e) {
  var t = ECe(e, "string");
  return xf(t) == "symbol" ? t : String(t);
}
function ECe(e, t) {
  if (xf(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (xf(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function $Ce(e) {
  var t = e.element, r = e.tooltipEventType, n = e.isActive, a = e.activeCoordinate, i = e.activePayload, o = e.offset, u = e.activeTooltipIndex, d = e.tooltipAxisBandSize, s = e.layout, l = e.chartName;
  if (!t || !t.props.cursor || !n || !a || l !== "ScatterChart" && r !== "axis")
    return null;
  var f, c = Wp;
  if (l === "ScatterChart")
    f = a, c = ike;
  else if (l === "BarChart")
    f = FCe(s, a, o, d), c = ey;
  else if (s === "radial") {
    var h = XT(a), _ = h.cx, F = h.cy, v = h.radius, $ = h.startAngle, E = h.endAngle;
    f = {
      cx: _,
      cy: F,
      startAngle: $,
      endAngle: E,
      innerRadius: v,
      outerRadius: v
    }, c = ET;
  } else
    f = {
      points: yCe(s, a, o)
    }, c = Wp;
  var D = $1($1($1($1({
    stroke: "#ccc",
    pointerEvents: "none"
  }, o), f), _t(t.props.cursor, !1)), {}, {
    payload: i,
    payloadIndex: u,
    className: Ct("recharts-tooltip-cursor", t.props.cursor.className)
  });
  return /* @__PURE__ */ $n(t.props.cursor) ? /* @__PURE__ */ gr(t.props.cursor, D) : /* @__PURE__ */ uh(c, D);
}
var wCe = ["item"], kCe = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function Ju(e) {
  return Ju = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ju(e);
}
function $l() {
  return $l = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $l.apply(this, arguments);
}
function vw(e, t) {
  return CCe(e) || DCe(e, t) || ZT(e, t) || xCe();
}
function xCe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function DCe(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, i, o, u = [], d = !0, s = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        d = !1;
      } else
        for (; !(d = (n = i.call(r)).done) && (u.push(n.value), u.length !== t); d = !0)
          ;
    } catch (l) {
      s = !0, a = l;
    } finally {
      try {
        if (!d && r.return != null && (o = r.return(), Object(o) !== o))
          return;
      } finally {
        if (s)
          throw a;
      }
    }
    return u;
  }
}
function CCe(e) {
  if (Array.isArray(e))
    return e;
}
function Ew(e, t) {
  if (e == null)
    return {};
  var r = SCe(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function SCe(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function ACe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function $w(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, JT(n.key), n);
  }
}
function OCe(e, t, r) {
  return t && $w(e.prototype, t), r && $w(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function TCe(e, t, r) {
  return t = oh(t), PCe(e, QT() ? Reflect.construct(t, r || [], oh(e).constructor) : t.apply(e, r));
}
function PCe(e, t) {
  if (t && (Ju(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return xt(e);
}
function QT() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (QT = function() {
    return !!e;
  })();
}
function oh(e) {
  return oh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, oh(e);
}
function xt(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ICe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && h3(e, t);
}
function h3(e, t) {
  return h3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, h3(e, t);
}
function ed(e) {
  return MCe(e) || jCe(e) || ZT(e) || RCe();
}
function RCe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ZT(e, t) {
  if (e) {
    if (typeof e == "string")
      return g3(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return g3(e, t);
  }
}
function jCe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function MCe(e) {
  if (Array.isArray(e))
    return g3(e);
}
function g3(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function ww(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ww(Object(r), !0).forEach(function(n) {
      lt(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ww(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function lt(e, t, r) {
  return t = JT(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function JT(e) {
  var t = BCe(e, "string");
  return Ju(t) == "symbol" ? t : String(t);
}
function BCe(e, t) {
  if (Ju(e) != "object" || !e)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Ju(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var NCe = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, LCe = {
  width: "100%",
  height: "100%"
}, eP = {
  x: 0,
  y: 0
};
function w1(e) {
  return e;
}
var qCe = function(t, r) {
  return r === "horizontal" ? t.x : r === "vertical" ? t.y : r === "centric" ? t.angle : t.radius;
}, UCe = function(t, r, n, a) {
  var i = r.find(function(l) {
    return l && l.index === n;
  });
  if (i) {
    if (t === "horizontal")
      return {
        x: i.coordinate,
        y: a.y
      };
    if (t === "vertical")
      return {
        x: a.x,
        y: i.coordinate
      };
    if (t === "centric") {
      var o = i.coordinate, u = a.radius;
      return pe(pe(pe({}, a), Vt(a.cx, a.cy, u, o)), {}, {
        angle: o,
        radius: u
      });
    }
    var d = i.coordinate, s = a.angle;
    return pe(pe(pe({}, a), Vt(a.cx, a.cy, d, s)), {}, {
      angle: s,
      radius: d
    });
  }
  return eP;
}, Sg = function(t, r) {
  var n = r.graphicalItems, a = r.dataStartIndex, i = r.dataEndIndex, o = (n ?? []).reduce(function(u, d) {
    var s = d.props.data;
    return s && s.length ? [].concat(ed(u), ed(s)) : u;
  }, []);
  return o.length > 0 ? o : t && t.length && Ve(a) && Ve(i) ? t.slice(a, i + 1) : [];
};
function tP(e) {
  return e === "number" ? [0, "auto"] : void 0;
}
var _3 = function(t, r, n, a) {
  var i = t.graphicalItems, o = t.tooltipAxis, u = Sg(r, t);
  return n < 0 || !i || !i.length || n >= u.length ? null : i.reduce(function(d, s) {
    var l, f = (l = s.props.data) !== null && l !== void 0 ? l : r;
    f && t.dataStartIndex + t.dataEndIndex !== 0 && (f = f.slice(t.dataStartIndex, t.dataEndIndex + 1));
    var c;
    if (o.dataKey && !o.allowDuplicatedCategory) {
      var h = f === void 0 ? u : f;
      c = Xm(h, o.dataKey, a);
    } else
      c = f && f[n] || u[n];
    return c ? [].concat(ed(d), [oEe(s, c)]) : d;
  }, []);
}, kw = function(t, r, n, a) {
  var i = a || {
    x: t.chartX,
    y: t.chartY
  }, o = qCe(i, n), u = t.orderedTooltipTicks, d = t.tooltipAxis, s = t.tooltipTicks, l = W7e(o, u, s, d);
  if (l >= 0 && s) {
    var f = s[l] && s[l].value, c = _3(t, r, l, f), h = UCe(n, u, l, i);
    return {
      activeTooltipIndex: l,
      activeLabel: f,
      activePayload: c,
      activeCoordinate: h
    };
  }
  return null;
}, GCe = function(t, r) {
  var n = r.axes, a = r.graphicalItems, i = r.axisType, o = r.axisIdKey, u = r.stackGroups, d = r.dataStartIndex, s = r.dataEndIndex, l = t.layout, f = t.children, c = t.stackOffset, h = _T(l, i);
  return n.reduce(function(_, F) {
    var v, $ = F.props, E = $.type, D = $.dataKey, w = $.allowDataOverflow, k = $.allowDuplicatedCategory, A = $.scale, P = $.ticks, S = $.includeHidden, N = F.props[o];
    if (_[N])
      return _;
    var W = Sg(t.data, {
      graphicalItems: a.filter(function(ge) {
        return ge.props[o] === N;
      }),
      dataStartIndex: d,
      dataEndIndex: s
    }), V = W.length, K, U, j;
    pCe(F.props.domain, w, E) && (K = Bp(F.props.domain, null, w), h && (E === "number" || A !== "auto") && (j = yl(W, D, "category")));
    var G = tP(E);
    if (!K || K.length === 0) {
      var H, J = (H = F.props.domain) !== null && H !== void 0 ? H : G;
      if (D) {
        if (K = yl(W, D, E), E === "category" && h) {
          var ae = Qge(K);
          k && ae ? (U = K, K = rh(0, V)) : k || (K = r$(J, K, F).reduce(function(ge, De) {
            return ge.indexOf(De) >= 0 ? ge : [].concat(ed(ge), [De]);
          }, []));
        } else if (E === "category")
          k ? K = K.filter(function(ge) {
            return ge !== "" && !wt(ge);
          }) : K = r$(J, K, F).reduce(function(ge, De) {
            return ge.indexOf(De) >= 0 || De === "" || wt(De) ? ge : [].concat(ed(ge), [De]);
          }, []);
        else if (E === "number") {
          var de = Y7e(W, a.filter(function(ge) {
            return ge.props[o] === N && (S || !ge.props.hide);
          }), D, i, l);
          de && (K = de);
        }
        h && (E === "number" || A !== "auto") && (j = yl(W, D, "category"));
      } else
        h ? K = rh(0, V) : u && u[N] && u[N].hasStack && E === "number" ? K = c === "expand" ? [0, 1] : mT(u[N].stackGroups, d, s) : K = gT(W, a.filter(function(ge) {
          return ge.props[o] === N && (S || !ge.props.hide);
        }), E, l, !0);
      if (E === "number")
        K = f3(f, K, N, i, P), J && (K = Bp(J, K, w));
      else if (E === "category" && J) {
        var te = J, ee = K.every(function(ge) {
          return te.indexOf(ge) >= 0;
        });
        ee && (K = te);
      }
    }
    return pe(pe({}, _), {}, lt({}, N, pe(pe({}, F.props), {}, {
      axisType: i,
      domain: K,
      categoricalDomain: j,
      duplicateDomain: U,
      originalDomain: (v = F.props.domain) !== null && v !== void 0 ? v : G,
      isCategorical: h,
      layout: l
    })));
  }, {});
}, WCe = function(t, r) {
  var n = r.graphicalItems, a = r.Axis, i = r.axisType, o = r.axisIdKey, u = r.stackGroups, d = r.dataStartIndex, s = r.dataEndIndex, l = t.layout, f = t.children, c = Sg(t.data, {
    graphicalItems: n,
    dataStartIndex: d,
    dataEndIndex: s
  }), h = c.length, _ = _T(l, i), F = -1;
  return n.reduce(function(v, $) {
    var E = $.props[o], D = tP("number");
    if (!v[E]) {
      F++;
      var w;
      return _ ? w = rh(0, h) : u && u[E] && u[E].hasStack ? (w = mT(u[E].stackGroups, d, s), w = f3(f, w, E, i)) : (w = Bp(D, gT(c, n.filter(function(k) {
        return k.props[o] === E && !k.props.hide;
      }), "number", l), a.defaultProps.allowDataOverflow), w = f3(f, w, E, i)), pe(pe({}, v), {}, lt({}, E, pe(pe({
        axisType: i
      }, a.defaultProps), {}, {
        hide: !0,
        orientation: Hn(NCe, "".concat(i, ".").concat(F % 2), null),
        domain: w,
        originalDomain: D,
        isCategorical: _,
        layout: l
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return v;
  }, {});
}, VCe = function(t, r) {
  var n = r.axisType, a = n === void 0 ? "xAxis" : n, i = r.AxisComp, o = r.graphicalItems, u = r.stackGroups, d = r.dataStartIndex, s = r.dataEndIndex, l = t.children, f = "".concat(a, "Id"), c = Wa(l, i), h = {};
  return c && c.length ? h = GCe(t, {
    axes: c,
    graphicalItems: o,
    axisType: a,
    axisIdKey: f,
    stackGroups: u,
    dataStartIndex: d,
    dataEndIndex: s
  }) : o && o.length && (h = WCe(t, {
    Axis: i,
    graphicalItems: o,
    axisType: a,
    axisIdKey: f,
    stackGroups: u,
    dataStartIndex: d,
    dataEndIndex: s
  })), h;
}, HCe = function(t) {
  var r = fu(t), n = il(r, !1, !0);
  return {
    tooltipTicks: n,
    orderedTooltipTicks: k4(n, function(a) {
      return a.coordinate;
    }),
    tooltipAxis: r,
    tooltipAxisBandSize: Np(r, n)
  };
}, xw = function(t) {
  var r = t.children, n = t.defaultShowTooltip, a = Bn(r, Zu), i = 0, o = 0;
  return t.data && t.data.length !== 0 && (o = t.data.length - 1), a && a.props && (a.props.startIndex >= 0 && (i = a.props.startIndex), a.props.endIndex >= 0 && (o = a.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: i,
    dataEndIndex: o,
    activeTooltipIndex: -1,
    isTooltipActive: Boolean(n)
  };
}, zCe = function(t) {
  return !t || !t.length ? !1 : t.some(function(r) {
    var n = Di(r && r.type);
    return n && n.indexOf("Bar") >= 0;
  });
}, Dw = function(t) {
  return t === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : t === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : t === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, KCe = function(t, r) {
  var n = t.props, a = t.graphicalItems, i = t.xAxisMap, o = i === void 0 ? {} : i, u = t.yAxisMap, d = u === void 0 ? {} : u, s = n.width, l = n.height, f = n.children, c = n.margin || {}, h = Bn(f, Zu), _ = Bn(f, Lu), F = Object.keys(d).reduce(function(k, A) {
    var P = d[A], S = P.orientation;
    return !P.mirror && !P.hide ? pe(pe({}, k), {}, lt({}, S, k[S] + P.width)) : k;
  }, {
    left: c.left || 0,
    right: c.right || 0
  }), v = Object.keys(o).reduce(function(k, A) {
    var P = o[A], S = P.orientation;
    return !P.mirror && !P.hide ? pe(pe({}, k), {}, lt({}, S, Hn(k, "".concat(S)) + P.height)) : k;
  }, {
    top: c.top || 0,
    bottom: c.bottom || 0
  }), $ = pe(pe({}, v), F), E = $.bottom;
  h && ($.bottom += h.props.height || Zu.defaultProps.height), _ && r && ($ = z7e($, a, n, r));
  var D = s - $.left - $.right, w = l - $.top - $.bottom;
  return pe(pe({
    brushBottom: E
  }, $), {}, {
    // never return negative values for height and width
    width: Math.max(D, 0),
    height: Math.max(w, 0)
  });
}, YCe = function(t, r) {
  if (r === "xAxis")
    return t[r].width;
  if (r === "yAxis")
    return t[r].height;
}, XCe = function(t) {
  var r, n = t.chartName, a = t.GraphicalChild, i = t.defaultTooltipEventType, o = i === void 0 ? "axis" : i, u = t.validateTooltipEventTypes, d = u === void 0 ? ["axis"] : u, s = t.axisComponents, l = t.legendContent, f = t.formatAxisMap, c = t.defaultProps, h = function(v, $) {
    var E = $.graphicalItems, D = $.stackGroups, w = $.offset, k = $.updateId, A = $.dataStartIndex, P = $.dataEndIndex, S = v.barSize, N = v.layout, W = v.barGap, V = v.barCategoryGap, K = v.maxBarSize, U = Dw(N), j = U.numericAxisName, G = U.cateAxisName, H = zCe(E), J = [];
    return E.forEach(function(ae, de) {
      var te = Sg(v.data, {
        graphicalItems: [ae],
        dataStartIndex: A,
        dataEndIndex: P
      }), ee = ae.props, ge = ee.dataKey, De = ee.maxBarSize, xe = ae.props["".concat(j, "Id")], ze = ae.props["".concat(G, "Id")], q = {}, Ue = s.reduce(function(Kt, hr) {
        var mr, Lr, Oe = $["".concat(hr.axisType, "Map")], Pe = ae.props["".concat(hr.axisType, "Id")];
        Oe && Oe[Pe] || hr.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? Wn(!1, "Specifying a(n) ".concat(hr.axisType, "Id requires a corresponding ").concat(
          hr.axisType,
          "Id on the targeted graphical component "
        ).concat((mr = ae == null || (Lr = ae.type) === null || Lr === void 0 ? void 0 : Lr.displayName) !== null && mr !== void 0 ? mr : "")) : Wn(!1));
        var st = Oe[Pe];
        return pe(pe({}, Kt), {}, lt(lt({}, hr.axisType, st), "".concat(hr.axisType, "Ticks"), il(st)));
      }, q), Ce = Ue[G], me = Ue["".concat(G, "Ticks")], Fe = D && D[xe] && D[xe].hasStack && aEe(ae, D[xe].stackGroups), ce = Di(ae.type).indexOf("Bar") >= 0, z = Np(Ce, me), Me = [], le = H && V7e({
        barSize: S,
        stackGroups: D,
        totalSize: YCe(Ue, G)
      });
      if (ce) {
        var Be, rt, ve = wt(De) ? K : De, qt = (Be = (rt = Np(Ce, me, !0)) !== null && rt !== void 0 ? rt : ve) !== null && Be !== void 0 ? Be : 0;
        Me = H7e({
          barGap: W,
          barCategoryGap: V,
          bandSize: qt !== z ? qt : z,
          sizeList: le[ze],
          maxBarSize: ve
        }), qt !== z && (Me = Me.map(function(Kt) {
          return pe(pe({}, Kt), {}, {
            position: pe(pe({}, Kt.position), {}, {
              offset: Kt.position.offset - qt / 2
            })
          });
        }));
      }
      var fr = ae && ae.type && ae.type.getComposedData;
      fr && J.push({
        props: pe(pe({}, fr(pe(pe({}, Ue), {}, {
          displayedData: te,
          props: v,
          dataKey: ge,
          item: ae,
          bandSize: z,
          barPosition: Me,
          offset: w,
          stackedData: Fe,
          layout: N,
          dataStartIndex: A,
          dataEndIndex: P
        }))), {}, lt(lt(lt({
          key: ae.key || "item-".concat(de)
        }, j, Ue[j]), G, Ue[G]), "animationId", k)),
        childIndex: u_e(ae, v.children),
        item: ae
      });
    }), J;
  }, _ = function(v, $) {
    var E = v.props, D = v.dataStartIndex, w = v.dataEndIndex, k = v.updateId;
    if (!z8({
      props: E
    }))
      return null;
    var A = E.children, P = E.layout, S = E.stackOffset, N = E.data, W = E.reverseStackOrder, V = Dw(P), K = V.numericAxisName, U = V.cateAxisName, j = Wa(A, a), G = rEe(N, j, "".concat(K, "Id"), "".concat(U, "Id"), S, W), H = s.reduce(function(ee, ge) {
      var De = "".concat(ge.axisType, "Map");
      return pe(pe({}, ee), {}, lt({}, De, VCe(E, pe(pe({}, ge), {}, {
        graphicalItems: j,
        stackGroups: ge.axisType === K && G,
        dataStartIndex: D,
        dataEndIndex: w
      }))));
    }, {}), J = KCe(pe(pe({}, H), {}, {
      props: E,
      graphicalItems: j
    }), $ == null ? void 0 : $.legendBBox);
    Object.keys(H).forEach(function(ee) {
      H[ee] = f(E, H[ee], J, ee.replace("Map", ""), n);
    });
    var ae = H["".concat(U, "Map")], de = HCe(ae), te = h(E, pe(pe({}, H), {}, {
      dataStartIndex: D,
      dataEndIndex: w,
      updateId: k,
      graphicalItems: j,
      stackGroups: G,
      offset: J
    }));
    return pe(pe({
      formattedGraphicalItems: te,
      graphicalItems: j,
      offset: J,
      stackGroups: G
    }, de), H);
  };
  return r = /* @__PURE__ */ function(F) {
    ICe(v, F);
    function v($) {
      var E, D, w;
      return ACe(this, v), w = TCe(this, v, [$]), lt(xt(w), "eventEmitterSymbol", Symbol("rechartsEventEmitter")), lt(xt(w), "accessibilityManager", new mCe()), lt(xt(w), "handleLegendBBoxUpdate", function(k) {
        if (k) {
          var A = w.state, P = A.dataStartIndex, S = A.dataEndIndex, N = A.updateId;
          w.setState(pe({
            legendBBox: k
          }, _({
            props: w.props,
            dataStartIndex: P,
            dataEndIndex: S,
            updateId: N
          }, pe(pe({}, w.state), {}, {
            legendBBox: k
          }))));
        }
      }), lt(xt(w), "handleReceiveSyncEvent", function(k, A, P) {
        if (w.props.syncId === k) {
          if (P === w.eventEmitterSymbol && typeof w.props.syncMethod != "function")
            return;
          w.applySyncEvent(A);
        }
      }), lt(xt(w), "handleBrushChange", function(k) {
        var A = k.startIndex, P = k.endIndex;
        if (A !== w.state.dataStartIndex || P !== w.state.dataEndIndex) {
          var S = w.state.updateId;
          w.setState(function() {
            return pe({
              dataStartIndex: A,
              dataEndIndex: P
            }, _({
              props: w.props,
              dataStartIndex: A,
              dataEndIndex: P,
              updateId: S
            }, w.state));
          }), w.triggerSyncEvent({
            dataStartIndex: A,
            dataEndIndex: P
          });
        }
      }), lt(xt(w), "handleMouseEnter", function(k) {
        var A = w.getMouseInfo(k);
        if (A) {
          var P = pe(pe({}, A), {}, {
            isTooltipActive: !0
          });
          w.setState(P), w.triggerSyncEvent(P);
          var S = w.props.onMouseEnter;
          Ft(S) && S(P, k);
        }
      }), lt(xt(w), "triggeredAfterMouseMove", function(k) {
        var A = w.getMouseInfo(k), P = A ? pe(pe({}, A), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        w.setState(P), w.triggerSyncEvent(P);
        var S = w.props.onMouseMove;
        Ft(S) && S(P, k);
      }), lt(xt(w), "handleItemMouseEnter", function(k) {
        w.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: k,
            activePayload: k.tooltipPayload,
            activeCoordinate: k.tooltipPosition || {
              x: k.cx,
              y: k.cy
            }
          };
        });
      }), lt(xt(w), "handleItemMouseLeave", function() {
        w.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), lt(xt(w), "handleMouseMove", function(k) {
        k.persist(), w.throttleTriggeredAfterMouseMove(k);
      }), lt(xt(w), "handleMouseLeave", function(k) {
        w.throttleTriggeredAfterMouseMove.cancel();
        var A = {
          isTooltipActive: !1
        };
        w.setState(A), w.triggerSyncEvent(A);
        var P = w.props.onMouseLeave;
        Ft(P) && P(A, k);
      }), lt(xt(w), "handleOuterEvent", function(k) {
        var A = s_e(k), P = Hn(w.props, "".concat(A));
        if (A && Ft(P)) {
          var S, N;
          /.*touch.*/i.test(A) ? N = w.getMouseInfo(k.changedTouches[0]) : N = w.getMouseInfo(k), P((S = N) !== null && S !== void 0 ? S : {}, k);
        }
      }), lt(xt(w), "handleClick", function(k) {
        var A = w.getMouseInfo(k);
        if (A) {
          var P = pe(pe({}, A), {}, {
            isTooltipActive: !0
          });
          w.setState(P), w.triggerSyncEvent(P);
          var S = w.props.onClick;
          Ft(S) && S(P, k);
        }
      }), lt(xt(w), "handleMouseDown", function(k) {
        var A = w.props.onMouseDown;
        if (Ft(A)) {
          var P = w.getMouseInfo(k);
          A(P, k);
        }
      }), lt(xt(w), "handleMouseUp", function(k) {
        var A = w.props.onMouseUp;
        if (Ft(A)) {
          var P = w.getMouseInfo(k);
          A(P, k);
        }
      }), lt(xt(w), "handleTouchMove", function(k) {
        k.changedTouches != null && k.changedTouches.length > 0 && w.throttleTriggeredAfterMouseMove(k.changedTouches[0]);
      }), lt(xt(w), "handleTouchStart", function(k) {
        k.changedTouches != null && k.changedTouches.length > 0 && w.handleMouseDown(k.changedTouches[0]);
      }), lt(xt(w), "handleTouchEnd", function(k) {
        k.changedTouches != null && k.changedTouches.length > 0 && w.handleMouseUp(k.changedTouches[0]);
      }), lt(xt(w), "triggerSyncEvent", function(k) {
        w.props.syncId !== void 0 && B2.emit(N2, w.props.syncId, k, w.eventEmitterSymbol);
      }), lt(xt(w), "applySyncEvent", function(k) {
        var A = w.props, P = A.layout, S = A.syncMethod, N = w.state.updateId, W = k.dataStartIndex, V = k.dataEndIndex;
        if (k.dataStartIndex !== void 0 || k.dataEndIndex !== void 0)
          w.setState(pe({
            dataStartIndex: W,
            dataEndIndex: V
          }, _({
            props: w.props,
            dataStartIndex: W,
            dataEndIndex: V,
            updateId: N
          }, w.state)));
        else if (k.activeTooltipIndex !== void 0) {
          var K = k.chartX, U = k.chartY, j = k.activeTooltipIndex, G = w.state, H = G.offset, J = G.tooltipTicks;
          if (!H)
            return;
          if (typeof S == "function")
            j = S(J, k);
          else if (S === "value") {
            j = -1;
            for (var ae = 0; ae < J.length; ae++)
              if (J[ae].value === k.activeLabel) {
                j = ae;
                break;
              }
          }
          var de = pe(pe({}, H), {}, {
            x: H.left,
            y: H.top
          }), te = Math.min(K, de.x + de.width), ee = Math.min(U, de.y + de.height), ge = J[j] && J[j].value, De = _3(w.state, w.props.data, j), xe = J[j] ? {
            x: P === "horizontal" ? J[j].coordinate : te,
            y: P === "horizontal" ? ee : J[j].coordinate
          } : eP;
          w.setState(pe(pe({}, k), {}, {
            activeLabel: ge,
            activeCoordinate: xe,
            activePayload: De,
            activeTooltipIndex: j
          }));
        } else
          w.setState(k);
      }), lt(xt(w), "renderCursor", function(k) {
        var A, P = w.state, S = P.isTooltipActive, N = P.activeCoordinate, W = P.activePayload, V = P.offset, K = P.activeTooltipIndex, U = P.tooltipAxisBandSize, j = w.getTooltipEventType(), G = (A = k.props.active) !== null && A !== void 0 ? A : S, H = w.props.layout, J = k.key || "_recharts-cursor";
        return /* @__PURE__ */ M.createElement($Ce, {
          key: J,
          activeCoordinate: N,
          activePayload: W,
          activeTooltipIndex: K,
          chartName: n,
          element: k,
          isActive: G,
          layout: H,
          offset: V,
          tooltipAxisBandSize: U,
          tooltipEventType: j
        });
      }), lt(xt(w), "renderPolarAxis", function(k, A, P) {
        var S = Hn(k, "type.axisType"), N = Hn(w.state, "".concat(S, "Map")), W = N && N[k.props["".concat(S, "Id")]];
        return /* @__PURE__ */ gr(k, pe(pe({}, W), {}, {
          className: Ct(S, W.className),
          key: k.key || "".concat(A, "-").concat(P),
          ticks: il(W, !0)
        }));
      }), lt(xt(w), "renderPolarGrid", function(k) {
        var A = k.props, P = A.radialLines, S = A.polarAngles, N = A.polarRadius, W = w.state, V = W.radiusAxisMap, K = W.angleAxisMap, U = fu(V), j = fu(K), G = j.cx, H = j.cy, J = j.innerRadius, ae = j.outerRadius;
        return /* @__PURE__ */ gr(k, {
          polarAngles: Array.isArray(S) ? S : il(j, !0).map(function(de) {
            return de.coordinate;
          }),
          polarRadius: Array.isArray(N) ? N : il(U, !0).map(function(de) {
            return de.coordinate;
          }),
          cx: G,
          cy: H,
          innerRadius: J,
          outerRadius: ae,
          key: k.key || "polar-grid",
          radialLines: P
        });
      }), lt(xt(w), "renderLegend", function() {
        var k = w.state.formattedGraphicalItems, A = w.props, P = A.children, S = A.width, N = A.height, W = w.props.margin || {}, V = S - (W.left || 0) - (W.right || 0), K = cT({
          children: P,
          formattedGraphicalItems: k,
          legendWidth: V,
          legendContent: l
        });
        if (!K)
          return null;
        var U = K.item, j = Ew(K, wCe);
        return /* @__PURE__ */ gr(U, pe(pe({}, j), {}, {
          chartWidth: S,
          chartHeight: N,
          margin: W,
          onBBoxUpdate: w.handleLegendBBoxUpdate
        }));
      }), lt(xt(w), "renderTooltip", function() {
        var k, A = w.props, P = A.children, S = A.accessibilityLayer, N = Bn(P, Fi);
        if (!N)
          return null;
        var W = w.state, V = W.isTooltipActive, K = W.activeCoordinate, U = W.activePayload, j = W.activeLabel, G = W.offset, H = (k = N.props.active) !== null && k !== void 0 ? k : V;
        return /* @__PURE__ */ gr(N, {
          viewBox: pe(pe({}, G), {}, {
            x: G.left,
            y: G.top
          }),
          active: H,
          label: j,
          payload: H ? U : [],
          coordinate: K,
          accessibilityLayer: S
        });
      }), lt(xt(w), "renderBrush", function(k) {
        var A = w.props, P = A.margin, S = A.data, N = w.state, W = N.offset, V = N.dataStartIndex, K = N.dataEndIndex, U = N.updateId;
        return /* @__PURE__ */ gr(k, {
          key: k.key || "_recharts-brush",
          onChange: F1(w.handleBrushChange, k.props.onChange),
          data: S,
          x: Ve(k.props.x) ? k.props.x : W.left,
          y: Ve(k.props.y) ? k.props.y : W.top + W.height + W.brushBottom - (P.bottom || 0),
          width: Ve(k.props.width) ? k.props.width : W.width,
          startIndex: V,
          endIndex: K,
          updateId: "brush-".concat(U)
        });
      }), lt(xt(w), "renderReferenceElement", function(k, A, P) {
        if (!k)
          return null;
        var S = xt(w), N = S.clipPathId, W = w.state, V = W.xAxisMap, K = W.yAxisMap, U = W.offset, j = k.props, G = j.xAxisId, H = j.yAxisId;
        return /* @__PURE__ */ gr(k, {
          key: k.key || "".concat(A, "-").concat(P),
          xAxis: V[G],
          yAxis: K[H],
          viewBox: {
            x: U.left,
            y: U.top,
            width: U.width,
            height: U.height
          },
          clipPathId: N
        });
      }), lt(xt(w), "renderActivePoints", function(k) {
        var A = k.item, P = k.activePoint, S = k.basePoint, N = k.childIndex, W = k.isRange, V = [], K = A.props.key, U = A.item.props, j = U.activeDot, G = U.dataKey, H = pe(pe({
          index: N,
          dataKey: G,
          cx: P.x,
          cy: P.y,
          r: 4,
          fill: J4(A.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: P.payload,
          value: P.value,
          key: "".concat(K, "-activePoint-").concat(N)
        }, _t(j, !1)), F0(j));
        return V.push(v.renderActiveDot(j, H)), S ? V.push(v.renderActiveDot(j, pe(pe({}, H), {}, {
          cx: S.x,
          cy: S.y,
          key: "".concat(K, "-basePoint-").concat(N)
        }))) : W && V.push(null), V;
      }), lt(xt(w), "renderGraphicChild", function(k, A, P) {
        var S = w.filterFormatItem(k, A, P);
        if (!S)
          return null;
        var N = w.getTooltipEventType(), W = w.state, V = W.isTooltipActive, K = W.tooltipAxis, U = W.activeTooltipIndex, j = W.activeLabel, G = w.props.children, H = Bn(G, Fi), J = S.props, ae = J.points, de = J.isRange, te = J.baseLine, ee = S.item.props, ge = ee.activeDot, De = ee.hide, xe = ee.activeBar, ze = ee.activeShape, q = Boolean(!De && V && H && (ge || xe || ze)), Ue = {};
        N !== "axis" && H && H.props.trigger === "click" ? Ue = {
          onClick: F1(w.handleItemMouseEnter, k.props.onClick)
        } : N !== "axis" && (Ue = {
          onMouseLeave: F1(w.handleItemMouseLeave, k.props.onMouseLeave),
          onMouseEnter: F1(w.handleItemMouseEnter, k.props.onMouseEnter)
        });
        var Ce = /* @__PURE__ */ gr(k, pe(pe({}, S.props), Ue));
        function me(hr) {
          return typeof K.dataKey == "function" ? K.dataKey(hr.payload) : null;
        }
        if (q)
          if (U >= 0) {
            var Fe, ce;
            if (K.dataKey && !K.allowDuplicatedCategory) {
              var z = typeof K.dataKey == "function" ? me : "payload.".concat(K.dataKey.toString());
              Fe = Xm(ae, z, j), ce = de && te && Xm(te, z, j);
            } else
              Fe = ae == null ? void 0 : ae[U], ce = de && te && te[U];
            if (ze || xe) {
              var Me = k.props.activeIndex !== void 0 ? k.props.activeIndex : U;
              return [/* @__PURE__ */ gr(k, pe(pe(pe({}, S.props), Ue), {}, {
                activeIndex: Me
              })), null, null];
            }
            if (!wt(Fe))
              return [Ce].concat(ed(w.renderActivePoints({
                item: S,
                activePoint: Fe,
                basePoint: ce,
                childIndex: U,
                isRange: de
              })));
          } else {
            var le, Be = (le = w.getItemByXY(w.state.activeCoordinate)) !== null && le !== void 0 ? le : {
              graphicalItem: Ce
            }, rt = Be.graphicalItem, ve = rt.item, qt = ve === void 0 ? k : ve, fr = rt.childIndex, Kt = pe(pe(pe({}, S.props), Ue), {}, {
              activeIndex: fr
            });
            return [/* @__PURE__ */ gr(qt, Kt), null, null];
          }
        return de ? [Ce, null, null] : [Ce, null];
      }), lt(xt(w), "renderCustomized", function(k, A, P) {
        return /* @__PURE__ */ gr(k, pe(pe({
          key: "recharts-customized-".concat(P)
        }, w.props), w.state));
      }), lt(xt(w), "renderMap", {
        CartesianGrid: {
          handler: w1,
          once: !0
        },
        ReferenceArea: {
          handler: w.renderReferenceElement
        },
        ReferenceLine: {
          handler: w1
        },
        ReferenceDot: {
          handler: w.renderReferenceElement
        },
        XAxis: {
          handler: w1
        },
        YAxis: {
          handler: w1
        },
        Brush: {
          handler: w.renderBrush,
          once: !0
        },
        Bar: {
          handler: w.renderGraphicChild
        },
        Line: {
          handler: w.renderGraphicChild
        },
        Area: {
          handler: w.renderGraphicChild
        },
        Radar: {
          handler: w.renderGraphicChild
        },
        RadialBar: {
          handler: w.renderGraphicChild
        },
        Scatter: {
          handler: w.renderGraphicChild
        },
        Pie: {
          handler: w.renderGraphicChild
        },
        Funnel: {
          handler: w.renderGraphicChild
        },
        Tooltip: {
          handler: w.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: w.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: w.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: w.renderPolarAxis
        },
        Customized: {
          handler: w.renderCustomized
        }
      }), w.clipPathId = "".concat((E = $.id) !== null && E !== void 0 ? E : ng("recharts"), "-clip"), w.throttleTriggeredAfterMouseMove = hO(w.triggeredAfterMouseMove, (D = $.throttleDelay) !== null && D !== void 0 ? D : 1e3 / 60), w.state = {}, w;
    }
    return OCe(v, [{
      key: "componentDidMount",
      value: function() {
        var E, D;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (E = this.props.margin.left) !== null && E !== void 0 ? E : 0,
            top: (D = this.props.margin.top) !== null && D !== void 0 ? D : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var E = this.props, D = E.children, w = E.data, k = E.height, A = E.layout, P = Bn(D, Fi);
        if (P) {
          var S = P.props.defaultIndex;
          if (!(typeof S != "number" || S < 0 || S > this.state.tooltipTicks.length)) {
            var N = this.state.tooltipTicks[S] && this.state.tooltipTicks[S].value, W = _3(this.state, w, S, N), V = this.state.tooltipTicks[S].coordinate, K = (this.state.offset.top + k) / 2, U = A === "horizontal", j = U ? {
              x: V,
              y: K
            } : {
              y: V,
              x: K
            }, G = this.state.formattedGraphicalItems.find(function(J) {
              var ae = J.item;
              return ae.type.name === "Scatter";
            });
            G && (j = pe(pe({}, j), G.props.points[S].tooltipPosition), W = G.props.points[S].tooltipPayload);
            var H = {
              activeTooltipIndex: S,
              isTooltipActive: !0,
              activeLabel: N,
              activePayload: W,
              activeCoordinate: j
            };
            this.setState(H), this.renderCursor(P), this.accessibilityManager.setIndex(S);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(E, D) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== D.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== E.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== E.margin) {
          var w, k;
          this.accessibilityManager.setDetails({
            offset: {
              left: (w = this.props.margin.left) !== null && w !== void 0 ? w : 0,
              top: (k = this.props.margin.top) !== null && k !== void 0 ? k : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(E) {
        Jm([Bn(E.children, Fi)], [Bn(this.props.children, Fi)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var E = Bn(this.props.children, Fi);
        if (E && typeof E.props.shared == "boolean") {
          var D = E.props.shared ? "axis" : "item";
          return d.indexOf(D) >= 0 ? D : o;
        }
        return o;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(E) {
        if (!this.container)
          return null;
        var D = this.container, w = D.getBoundingClientRect(), k = S9e(w), A = {
          chartX: Math.round(E.pageX - k.left),
          chartY: Math.round(E.pageY - k.top)
        }, P = w.width / D.offsetWidth || 1, S = this.inRange(A.chartX, A.chartY, P);
        if (!S)
          return null;
        var N = this.state, W = N.xAxisMap, V = N.yAxisMap, K = this.getTooltipEventType();
        if (K !== "axis" && W && V) {
          var U = fu(W).scale, j = fu(V).scale, G = U && U.invert ? U.invert(A.chartX) : null, H = j && j.invert ? j.invert(A.chartY) : null;
          return pe(pe({}, A), {}, {
            xValue: G,
            yValue: H
          });
        }
        var J = kw(this.state, this.props.data, this.props.layout, S);
        return J ? pe(pe({}, A), J) : null;
      }
    }, {
      key: "inRange",
      value: function(E, D) {
        var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, k = this.props.layout, A = E / w, P = D / w;
        if (k === "horizontal" || k === "vertical") {
          var S = this.state.offset, N = A >= S.left && A <= S.left + S.width && P >= S.top && P <= S.top + S.height;
          return N ? {
            x: A,
            y: P
          } : null;
        }
        var W = this.state, V = W.angleAxisMap, K = W.radiusAxisMap;
        if (V && K) {
          var U = fu(V);
          return i$({
            x: A,
            y: P
          }, U);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var E = this.props.children, D = this.getTooltipEventType(), w = Bn(E, Fi), k = {};
        w && D === "axis" && (w.props.trigger === "click" ? k = {
          onClick: this.handleClick
        } : k = {
          onMouseEnter: this.handleMouseEnter,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd
        });
        var A = F0(this.props, this.handleOuterEvent);
        return pe(pe({}, A), k);
      }
    }, {
      key: "addListener",
      value: function() {
        B2.on(N2, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        B2.removeListener(N2, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(E, D, w) {
        for (var k = this.state.formattedGraphicalItems, A = 0, P = k.length; A < P; A++) {
          var S = k[A];
          if (S.item === E || S.props.key === E.key || D === Di(S.item.type) && w === S.childIndex)
            return S;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var E = this.clipPathId, D = this.state.offset, w = D.left, k = D.top, A = D.height, P = D.width;
        return /* @__PURE__ */ M.createElement("defs", null, /* @__PURE__ */ M.createElement("clipPath", {
          id: E
        }, /* @__PURE__ */ M.createElement("rect", {
          x: w,
          y: k,
          height: A,
          width: P
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var E = this.state.xAxisMap;
        return E ? Object.entries(E).reduce(function(D, w) {
          var k = vw(w, 2), A = k[0], P = k[1];
          return pe(pe({}, D), {}, lt({}, A, P.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var E = this.state.yAxisMap;
        return E ? Object.entries(E).reduce(function(D, w) {
          var k = vw(w, 2), A = k[0], P = k[1];
          return pe(pe({}, D), {}, lt({}, A, P.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(E) {
        var D;
        return (D = this.state.xAxisMap) === null || D === void 0 || (D = D[E]) === null || D === void 0 ? void 0 : D.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(E) {
        var D;
        return (D = this.state.yAxisMap) === null || D === void 0 || (D = D[E]) === null || D === void 0 ? void 0 : D.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(E) {
        var D = this.state, w = D.formattedGraphicalItems, k = D.activeItem;
        if (w && w.length)
          for (var A = 0, P = w.length; A < P; A++) {
            var S = w[A], N = S.props, W = S.item, V = Di(W.type);
            if (V === "Bar") {
              var K = (N.data || []).find(function(H) {
                return Nwe(E, H);
              });
              if (K)
                return {
                  graphicalItem: S,
                  payload: K
                };
            } else if (V === "RadialBar") {
              var U = (N.data || []).find(function(H) {
                return i$(E, H);
              });
              if (U)
                return {
                  graphicalItem: S,
                  payload: U
                };
            } else if (Dg(S, k) || Cg(S, k) || yf(S, k)) {
              var j = wxe({
                graphicalItem: S,
                activeTooltipItem: k,
                itemData: W.props.data
              }), G = W.props.activeIndex === void 0 ? j : W.props.activeIndex;
              return {
                graphicalItem: pe(pe({}, S), {}, {
                  childIndex: G
                }),
                payload: yf(S, k) ? W.props.data[j] : S.props.data[j]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var E = this;
        if (!z8(this))
          return null;
        var D = this.props, w = D.children, k = D.className, A = D.width, P = D.height, S = D.style, N = D.compact, W = D.title, V = D.desc, K = Ew(D, kCe), U = _t(K, !1);
        if (N)
          return /* @__PURE__ */ M.createElement(lw, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ M.createElement(tp, $l({}, U, {
            width: A,
            height: P,
            title: W,
            desc: V
          }), this.renderClipPath(), Y8(w, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var j, G;
          U.tabIndex = (j = this.props.tabIndex) !== null && j !== void 0 ? j : 0, U.role = (G = this.props.role) !== null && G !== void 0 ? G : "application", U.onKeyDown = function(J) {
            E.accessibilityManager.keyboardEvent(J);
          }, U.onFocus = function() {
            E.accessibilityManager.focus();
          };
        }
        var H = this.parseEventsOfWrapper();
        return /* @__PURE__ */ M.createElement(lw, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ M.createElement("div", $l({
          className: Ct("recharts-wrapper", k),
          style: pe({
            position: "relative",
            cursor: "default",
            width: A,
            height: P
          }, S)
        }, H, {
          ref: function(ae) {
            E.container = ae;
          }
        }), /* @__PURE__ */ M.createElement(tp, $l({}, U, {
          width: A,
          height: P,
          title: W,
          desc: V,
          style: LCe
        }), this.renderClipPath(), Y8(w, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]), v;
  }(Hj), lt(r, "displayName", n), lt(r, "defaultProps", pe({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, c)), lt(r, "getDerivedStateFromProps", function(F, v) {
    var $ = F.dataKey, E = F.data, D = F.children, w = F.width, k = F.height, A = F.layout, P = F.stackOffset, S = F.margin, N = v.dataStartIndex, W = v.dataEndIndex;
    if (v.updateId === void 0) {
      var V = xw(F);
      return pe(pe(pe({}, V), {}, {
        updateId: 0
      }, _(pe(pe({
        props: F
      }, V), {}, {
        updateId: 0
      }), v)), {}, {
        prevDataKey: $,
        prevData: E,
        prevWidth: w,
        prevHeight: k,
        prevLayout: A,
        prevStackOffset: P,
        prevMargin: S,
        prevChildren: D
      });
    }
    if ($ !== v.prevDataKey || E !== v.prevData || w !== v.prevWidth || k !== v.prevHeight || A !== v.prevLayout || P !== v.prevStackOffset || !Qm(S, v.prevMargin)) {
      var K = xw(F), U = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: v.chartX,
        chartY: v.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: v.isTooltipActive
      }, j = pe(pe({}, kw(v, E, A)), {}, {
        updateId: v.updateId + 1
      }), G = pe(pe(pe({}, K), U), j);
      return pe(pe(pe({}, G), _(pe({
        props: F
      }, G), v)), {}, {
        prevDataKey: $,
        prevData: E,
        prevWidth: w,
        prevHeight: k,
        prevLayout: A,
        prevStackOffset: P,
        prevMargin: S,
        prevChildren: D
      });
    }
    if (!Jm(D, v.prevChildren)) {
      var H, J, ae, de, te = Bn(D, Zu), ee = te && (H = (J = te.props) === null || J === void 0 ? void 0 : J.startIndex) !== null && H !== void 0 ? H : N, ge = te && (ae = (de = te.props) === null || de === void 0 ? void 0 : de.endIndex) !== null && ae !== void 0 ? ae : W, De = ee !== N || ge !== W, xe = !wt(E), ze = xe && !De ? v.updateId : v.updateId + 1;
      return pe(pe({
        updateId: ze
      }, _(pe(pe({
        props: F
      }, v), {}, {
        updateId: ze,
        dataStartIndex: ee,
        dataEndIndex: ge
      }), v)), {}, {
        prevChildren: D,
        dataStartIndex: ee,
        dataEndIndex: ge
      });
    }
    return null;
  }), lt(r, "renderActiveDot", function(F, v) {
    var $;
    return /* @__PURE__ */ $n(F) ? $ = /* @__PURE__ */ gr(F, v) : Ft(F) ? $ = F(v) : $ = /* @__PURE__ */ M.createElement(ty, v), /* @__PURE__ */ M.createElement(cr, {
      className: "recharts-active-dot",
      key: v.key
    }, $);
  }), r;
}, rP = XCe({
  chartName: "PieChart",
  GraphicalChild: Ja,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: xg
  }, {
    axisType: "radiusAxis",
    AxisComp: wg
  }],
  formatAxisMap: _Ee,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
});
const nP = Ge.div`
  position: absolute;
  top: 50%;
  left: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
`;
function VTe({
  "data-test": e = "pie-chart",
  children: t,
  data: r,
  minAngle: n = 10,
  onHover: a,
  onUnhover: i,
  onLegendHover: o,
  onLegendUnhover: u,
  radius: d = 60,
  ringWidth: s = 6,
  showLegend: l,
  ...f
}) {
  const [c, h] = Xe(), _ = Mr("secondary-100"), F = (A, P) => {
    h(P), a == null || a(P);
  }, v = () => {
    h(void 0), i == null || i();
  }, $ = (A) => {
    h(A), o == null || o(A);
  }, E = () => {
    h(void 0), u == null || u();
  }, D = d - s * 2, w = l ? d : "50%", k = r.reduce((A, P) => A + P.value, 0) === 0;
  return /* @__PURE__ */ ne(ot, { "data-test": e, position: "relative", ...f, children: [
    t && /* @__PURE__ */ b(nP, { children: t }),
    /* @__PURE__ */ b(
      gO,
      {
        minHeight: d * 2,
        minWidth: d * 2,
        width: "100%",
        children: /* @__PURE__ */ ne(rP, { children: [
          l && !k && /* @__PURE__ */ b(
            Lu,
            {
              align: "right",
              content: /* @__PURE__ */ b(
                QCe,
                {
                  onHover: $,
                  onUnhover: E
                }
              ),
              layout: "vertical",
              verticalAlign: "middle"
            }
          ),
          /* @__PURE__ */ b(
            Ja,
            {
              minAngle: n,
              startAngle: 90,
              endAngle: -270,
              data: k ? [{ label: "", value: 1 }] : r,
              cx: w,
              cy: "50%",
              outerRadius: d,
              innerRadius: D,
              paddingAngle: 4,
              onMouseEnter: F,
              onMouseLeave: v,
              isAnimationActive: !0,
              dataKey: "value",
              nameKey: "label",
              style: { outline: "none" },
              children: k ? /* @__PURE__ */ b(
                A0,
                {
                  "data-test": "pie-chart-cell-empty",
                  fill: _
                },
                "cell-empty"
              ) : r.map((A, P) => /* @__PURE__ */ b(
                A0,
                {
                  "data-test": `pie-chart-cell-${A.value}`,
                  fill: P === c ? r[P].hoverFill : r[P].fill
                },
                `cell-${A.value}`
              ))
            }
          )
        ] })
      }
    )
  ] });
}
function QCe({
  "data-test": e = "pie-chart-legend",
  onHover: t,
  onUnhover: r,
  payload: n
}) {
  const a = (o) => {
    t == null || t(o);
  }, i = () => {
    r == null || r();
  };
  return n ? /* @__PURE__ */ b(Ae, { as: "ul", "data-test": e, flexDirection: "column", p: 0, children: n.map((o, u) => /* @__PURE__ */ ne(
    Ae,
    {
      alignItems: "center",
      as: "li",
      gap: "xxs",
      mb: "xxs",
      onMouseEnter: () => a(u),
      onMouseLeave: i,
      children: [
        /* @__PURE__ */ b(
          ot,
          {
            backgroundColor: o.color,
            borderRadius: "full",
            h: "14px",
            w: "14px"
          }
        ),
        /* @__PURE__ */ b($e, { color: "text-base", variant: "bodyMediumS", children: o.payload.label }),
        /* @__PURE__ */ b(ok, { size: "small", value: o.payload.value })
      ]
    },
    o.value
  )) }) : null;
}
function HTe({
  "data-test": e,
  children: t,
  fill: r,
  radius: n = 60,
  ringWidth: a = 5,
  value: i,
  ...o
}) {
  const u = Mr("primary-500"), d = Mr("secondary-100");
  if (i > 100 || i < 0)
    throw new Error("The provided value needs to be between 0 and 100");
  const s = [
    { value: i, fill: r || u },
    { value: 100 - i, fill: d }
  ], l = n - a * 2;
  return /* @__PURE__ */ ne(ot, { "data-test": e, position: "relative", ...o, children: [
    /* @__PURE__ */ b(
      gO,
      {
        minHeight: n * 2,
        minWidth: n * 2,
        width: "100%",
        children: /* @__PURE__ */ b(rP, { children: /* @__PURE__ */ b(
          Ja,
          {
            startAngle: 90,
            endAngle: -270,
            data: s,
            cx: "50%",
            cy: "50%",
            outerRadius: n,
            innerRadius: l,
            paddingAngle: 4,
            dataKey: "value",
            nameKey: "label",
            style: { outline: "none" }
          }
        ) })
      }
    ),
    t && /* @__PURE__ */ b(nP, { children: t })
  ] });
}
const aP = dr(void 0);
function zTe({
  "data-test": e = "radio-box-group",
  children: t,
  defaultValue: r,
  onChange: n,
  size: a = "small",
  ...i
}) {
  const [o, u] = Xe(), d = qe(
    () => ({ checkedValue: o ?? r, size: a }),
    [o, r, a]
  ), s = ue(
    (l) => {
      u(l), n == null || n(l);
    },
    [n]
  );
  return /* @__PURE__ */ b(aP.Provider, { value: d, children: /* @__PURE__ */ b(
    Jw,
    {
      ...i,
      defaultValue: r,
      onChange: s,
      value: o,
      "data-test": e,
      children: t
    }
  ) });
}
function ZCe(e) {
  const t = {
    backgroundColor: "surface-interactive-default",
    borderColor: "graphic-interactive-default",
    borderRadius: "sm",
    borderStyle: "solid",
    borderWidth: 1,
    padding: "s"
  };
  return e ? {
    ...t,
    backgroundColor: "surface-interactive-default-active",
    borderColor: "graphic-interactive-primary"
  } : t;
}
function KTe({
  description: e,
  disabled: t = !1,
  label: r,
  value: n,
  "data-test": a = "radio-box"
}) {
  const i = Et(aP);
  if (!i)
    throw new Error("RadioBox should be used inside RadioBoxGroup");
  const o = i.checkedValue === n;
  return /* @__PURE__ */ b(ot, { ...ZCe(o), children: /* @__PURE__ */ ne(
    ek,
    {
      value: n,
      size: i.size,
      disabled: t,
      "data-test": `${a}-${n}`,
      children: [
        /* @__PURE__ */ b(GM, { children: r }),
        e && /* @__PURE__ */ b(WM, { children: e })
      ]
    }
  ) });
}
const JCe = Ge(Zw)`
  position: absolute;
  top: 14px;
  right: 14px;
  display: flex;
  gap: ${lr("xxxs")};
  font-weight: 400;
`;
function YTe({
  value: e,
  title: t,
  description: r,
  content: n,
  disabled: a = !1,
  learnMoreLink: i,
  learnMoreText: o,
  "data-test": u
}) {
  return /* @__PURE__ */ ne(
    ad,
    {
      display: "inline-grid",
      columnGap: { _: "s" },
      padding: "s",
      pb: "xs",
      alignItems: "center",
      gridAutoFlow: "column",
      rowGap: "xxs",
      gridTemplateColumns: "max-content auto",
      w: "100%",
      position: "relative",
      "data-test": u,
      children: [
        o && i && /* @__PURE__ */ ne(JCe, { href: i, target: "_blank", children: [
          o,
          /* @__PURE__ */ b(lM, { size: 18 })
        ] }),
        /* @__PURE__ */ b(ot, { gridRow: 1, children: /* @__PURE__ */ b(
          ek,
          {
            value: e,
            disabled: a,
            "data-test": `${u}-radio`
          }
        ) }),
        /* @__PURE__ */ b(ot, { gridRow: 1, children: /* @__PURE__ */ b($e, { children: t }) }),
        /* @__PURE__ */ b(ot, { gridRow: 2, children: /* @__PURE__ */ b($e, { variant: "bodyRegularS", color: "neutral-400", children: r }) }),
        n && /* @__PURE__ */ b(ot, { gridRow: 3, mt: "xxs", children: n })
      ]
    }
  );
}
function XTe({
  value: e,
  children: t,
  onChange: r,
  "data-test": n
}) {
  return /* @__PURE__ */ b(
    Jw,
    {
      value: e,
      onChange: r,
      w: "100%",
      itemsSized: "evenly-sized",
      "data-test": n,
      children: /* @__PURE__ */ b(QS, { hasScroll: !1, w: "100%", children: t })
    }
  );
}
function iP({ date: e, locale: t, ...r }) {
  return /* @__PURE__ */ b($e, { ...r, children: RH(e, t) });
}
function eSe(e) {
  switch (e) {
    case Jr.OWNER:
      return "green";
    case Jr.ADMIN:
      return "purple";
    case Jr.SUPERVISOR:
      return "blue";
    case Jr.AGENT:
      return "yellow";
    default:
      return null;
  }
}
function QTe({ rolesNames: e, lang: t = "en" }) {
  if (!e.length)
    return null;
  const r = [...e].sort((n, a) => {
    const i = Qv[n] || 0, o = Qv[a] || 0;
    return i - o;
  }).map((n) => {
    const a = eSe(n);
    if (!(!a || !Object.values(Jr).includes(n)))
      return /* @__PURE__ */ b(ms, { variant: a, size: "small", children: qa[t][n] }, n);
  }).filter(HD);
  return r.length ? /* @__PURE__ */ b(Dt, { "data-test": "roles-tags", direction: "horizontal", space: "xxxs", children: r }) : null;
}
function ZTe({
  date: e,
  locale: t,
  ...r
}) {
  return /* @__PURE__ */ ne($e, { ...r, children: [
    /* @__PURE__ */ b(
      iP,
      {
        date: e,
        locale: t,
        ...r,
        display: "inline"
      }
    ),
    " - ",
    /* @__PURE__ */ b(e4, { date: e, locale: t, ...r, display: "inline" })
  ] });
}
function JTe({
  resource: e,
  action: t = jh.READ,
  children: r,
  onClick: n,
  messageTitle: a,
  messageSubtitle: i,
  messageButtonText: o
}) {
  const { checkAccess: u } = JF(), d = Array.isArray(e) ? e : [e];
  return d.every((l) => u(t, l)) ? /* @__PURE__ */ b(RS, { name: d[0], children: r || /* @__PURE__ */ b(rk, {}) }) : /* @__PURE__ */ b(
    e1e,
    {
      title: a,
      subtitle: i,
      buttonText: o,
      onClick: n,
      h: "100%"
    }
  );
}
function tSe({
  searchStr: e,
  onSelected: t,
  width: r,
  texts: n
}) {
  const [a, i] = Xe(!1), o = ue(() => {
    i(!0);
  }, []), u = ue(() => {
    i(!1);
  }, []), d = ue(() => {
    t(e);
  }, [t, e]);
  return /* @__PURE__ */ b(ot, { onMouseEnter: o, onMouseLeave: u, children: /* @__PURE__ */ ne(S3, { onClick: d, itemKey: e, children: [
    /* @__PURE__ */ ne(Dt, { space: "xs", direction: "horizontal", alignItems: "center", children: [
      /* @__PURE__ */ b(fM, {}),
      /* @__PURE__ */ b($e, { maxWidth: r, ellipsis: !0, children: e })
    ] }),
    /* @__PURE__ */ b(w3, { children: a && /* @__PURE__ */ b(ot, { color: "neutral-700", children: n.goToPageButton }) })
  ] }) });
}
const rSe = Ge(ad)`
  align-items: center;
  padding: ${vt("xs")} ${vt("s")};
  grid-template-columns: auto min-content;
`, nSe = Ge($e).attrs(() => {
})`
  color: ${He("neutral-400")};
  text-transform: uppercase;
`, aSe = Ge(nr).attrs(() => ({
  mode: "link"
}))`
  &,
  &:hover,
  &:focus {
    color: ${He("text-base")};
  }
`, iSe = Ge(
  xS.ul
)`
  position: fixed;
  z-index: 1001;
  top: ${({ top: e }) => e}px;
  left: ${({ left: e }) => e}px;
  width: ${({ width: e }) => e}px;
  min-width: fit-content;
  height: max-content;
  padding: ${vt("xs")} 0;
  border-radius: ${Ba("xs")};
  margin-top: ${vt("xxs")};
  background: ${He("neutral-0")};
  overflow-x: hidden;
  box-shadow: ${bh(5)};
`, oSe = {
  enter: {
    y: 0,
    opacity: 1
  },
  exit: {
    y: -10,
    opacity: 0
  }
}, sSe = M.memo(
  Xn(
    ({ width: e, top: t, left: r, open: n, recentSearches: a, onSelected: i, onClear: o, texts: u }, d) => {
      const s = qe(
        () => a.map((l) => /* @__PURE__ */ b(
          tSe,
          {
            width: e,
            searchStr: l,
            onSelected: i,
            texts: { goToPageButton: u.goToPageButton }
          },
          l
        )),
        [i, a, u.goToPageButton, e]
      );
      return /* @__PURE__ */ b(Uf, { children: n && a.length > 0 && /* @__PURE__ */ b(F1e, { children: /* @__PURE__ */ b("div", { ref: d, tabIndex: 0, "data-test": "recent-search-menu", children: /* @__PURE__ */ ne(
        iSe,
        {
          initial: "exit",
          animate: "enter",
          exit: "exit",
          width: e,
          top: t,
          left: r,
          variants: oSe,
          children: [
            /* @__PURE__ */ ne(rSe, { children: [
              /* @__PURE__ */ b(ot, { children: /* @__PURE__ */ b(nSe, { children: u.menuTitle }) }),
              /* @__PURE__ */ b(ot, { children: /* @__PURE__ */ b(
                aSe,
                {
                  "data-test": "clear-history-button",
                  size: "xSmall",
                  onClick: o,
                  children: u.clearButton
                }
              ) })
            ] }),
            /* @__PURE__ */ b(C3, { w: "100%", children: s })
          ]
        }
      ) }) }) });
    }
  )
);
function ePe({
  w: e = "100%",
  name: t,
  placeholder: r,
  onSearch: n,
  onClear: a = () => n(""),
  debounceTimeout: i = 800,
  value: o,
  size: u = "regular",
  "data-test": d = "search-bar",
  texts: s
}) {
  const [l, f] = Xe(o || "");
  at(() => {
    f(o || "");
  }, [o]);
  const [c, h] = Xe(!1), _ = ue(() => h(!0), []), F = ue(() => h(!1), []), v = tt(null), $ = tt(null);
  Ele({
    eleRef: v,
    innerScrollRef: $,
    open: c,
    onClose: F
  });
  const { boundingRect: E, updateLayoutPosition: D } = wle(v), w = qe(() => E ? {
    width: E.width,
    top: E.bottom,
    left: E.left
  } : {
    width: 0,
    top: 0,
    left: 0
  }, [E]);
  at(() => {
    c && D();
  }, [c, D]);
  const k = qe(
    () => Iu(n, i),
    [i, n]
  ), A = ue(() => {
    f(""), k.cancel(), a(), F();
  }, [k, a, F]), P = qe(
    () => l ? A : void 0,
    [A, l]
  ), S = ue(
    (J) => {
      const ae = J.target.value;
      F(), ae ? (f(ae), k(ae)) : A();
    },
    [A, k, F]
  ), N = ue(
    (J) => {
      if ($.current && $.current.contains(J.relatedTarget)) {
        J.target.focus();
        return;
      }
      F();
    },
    [F]
  ), { recentSearches: W, clearAllSearch: V, addSearch: K } = Tle({
    search: l,
    name: t
  }), U = ue(
    (J) => {
      k.cancel(), n(J);
    },
    [k, n]
  ), j = ue(() => {
    K(l), v.current && v.current.blur(), U(l);
  }, [K, l, U]), G = ue(
    (J) => {
      J.key === "Escape" && F(), J.key === "Enter" && j();
    },
    [F, j]
  ), H = ue(
    (J) => {
      f(J), U(J), c && F();
    },
    [F, c, U]
  );
  return at(
    () => () => {
      k.cancel();
    },
    [k]
  ), /* @__PURE__ */ ne(ot, { "data-test": `${d}-wrapper`, w: e, children: [
    /* @__PURE__ */ b(
      nd,
      {
        ref: v,
        value: l,
        name: t,
        placeholder: r,
        icon: fh,
        size: u,
        onChange: S,
        onClear: P,
        "data-test": d,
        onFocus: _,
        onBlur: N,
        onKeyDown: G,
        autoComplete: "off"
      }
    ),
    /* @__PURE__ */ b(
      sSe,
      {
        ref: $,
        open: c,
        recentSearches: W,
        onSelected: H,
        onClear: V,
        texts: s,
        ...w
      }
    )
  ] });
}
const vu = "RESULTS_OPTION_KEY", Eu = "SELECTED_OPTION_KEY", uSe = Nk`
  [data-test="${({ dataTest: e }) => e}-content"] > div:first-child,
  [data-test="select-dropdown-container"] > div:first-child {
    padding: 10px 10px 0 10px;
  }

  [data-test="${({ dataTest: e }) => e}-content"] > div:first-child > div,
  [data-test="select-dropdown-container"] > div:first-child > div {
    border: 1px solid #E0E0E0;
    border-radius: 8px;
    overflow: hidden;
  }

  [data-test="${({ dataTest: e }) => e}-content"] > div:first-child > div:focus-within,
  [data-test="select-dropdown-container"] > div:first-child > div:focus-within {
    border: 1px solid black;
  }

  [data-test="select-search-input"] {
    border-bottom: none !important;
    box-shadow: none !important;
  }

  /* results option */
  div[data-test="select-option-item-${Eu}"],
  div[data-test="select-option-item-${vu}"] {
    height: 30px;
    pointer-events: none;
  }

  /* results option checkbox */
  div[data-test="select-option-item-${Eu}"] > div:first-child,
  div[data-test="select-option-item-${vu}"] > div:first-child {
    display: none;
  }
`;
function oP(e) {
  const { "data-test": t } = e;
  return /* @__PURE__ */ ne(Nr, { children: [
    /* @__PURE__ */ b(uSe, { dataTest: t }),
    /* @__PURE__ */ b(Sf, { ...e })
  ] });
}
const dSe = Ge(_a)`
  position: absolute;
  z-index: 1;
  right: 0px;
`, lSe = Xn((e, t) => {
  const { getPlaceholder: r, onClear: n, ...a } = e, i = VM().selectedKeys, o = i.length > 0, u = r(i.length), d = ue(
    (s) => {
      s.preventDefault(), n();
    },
    [n]
  );
  return /* @__PURE__ */ b(
    Ae,
    {
      w: "100%",
      borderRadius: "8px",
      border: "1px solid",
      borderColor: "neutral-200",
      p: "xs",
      cursor: "pointer",
      alignItems: "center",
      ref: t,
      backgroundColor: o ? "#507988" : "neutral-0",
      color: o ? "neutral-0" : "neutral-1000",
      ...a,
      children: /* @__PURE__ */ b(
        Ae,
        {
          flex: "1",
          alignItems: "center",
          justifyContent: "space-between",
          position: "relative",
          children: /* @__PURE__ */ ne(ur, { flex: "1", alignItems: "center", gap: "xs", children: [
            /* @__PURE__ */ b(
              sr,
              {
                component: fh,
                color: o ? "neutral-0" : "secondary-500",
                size: 22
              }
            ),
            /* @__PURE__ */ b($e, { variant: "bodyRegularS", children: u }),
            o && /* @__PURE__ */ b(
              dSe,
              {
                "data-test": "trigger-clear",
                onClick: d,
                size: 28,
                component: Cf,
                color: "neutral-0",
                discColor: "transparent"
              }
            )
          ] })
        }
      )
    }
  );
});
function iy({
  options: e,
  placeholder: t = "Select items",
  renderOption: r,
  onSearch: n,
  total: a,
  onChange: i,
  getPlaceholder: o
}) {
  const [u, d] = Xe(!1), [s, l] = Xe([]), f = tt(e), c = tt({
    label: vu,
    value: vu
  }), h = tt({
    label: Eu,
    value: Eu
  }), _ = qe(
    () => f.current.filter((w) => s.includes(w.value)),
    [s]
  ), F = qe(
    () => [
      ..._.length ? [h.current] : [],
      ..._,
      c.current,
      ...e.filter(
        (w) => !_.map((k) => k.value).includes(w.value)
      )
    ],
    [e, _]
  ), v = ue(
    async (w) => {
      d(!0);
      const k = w.trim().toLowerCase(), A = await n(k, e);
      return d(!1), w.length ? (f.current = Lk(
        [...f.current, ...A],
        ["value"]
      ), [c.current, ...A]) : F;
    },
    [F, n, e]
  ), $ = ue(
    (w) => w.value === Eu || w.value === vu ? /* @__PURE__ */ b(Ae, { children: /* @__PURE__ */ ne($e, { variant: "bodyRegularS", color: "neutral-700", children: [
      w.value === Eu && `${_.length} selected`,
      w.value === vu && `${a} results`
    ] }) }) : r(w),
    [r, _.length, a]
  ), E = ue(
    (w) => {
      l(w), i(w);
    },
    [i]
  ), D = ue(() => {
    l([]), i([]);
  }, [i]);
  return /* @__PURE__ */ b(
    oP,
    {
      selectionMode: "multiple",
      placeholder: t,
      options: F,
      searchOptions: v,
      loading: u,
      searchable: !0,
      selectedKeys: s,
      onSelectionChange: E,
      renderOption: $,
      trigger: /* @__PURE__ */ b(lSe, { onClear: D, getPlaceholder: o }),
      takeTriggerWidth: !1
    }
  );
}
function tPe({
  lines: e,
  total: t,
  onSearch: r,
  onChange: n
}) {
  const a = qe(
    () => e.map((u) => ({
      label: u.name,
      data: u,
      value: u.id
    })),
    [e]
  ), i = ue((u) => {
    const {
      data: { name: d, number: s, countryCode: l }
    } = u;
    return /* @__PURE__ */ ne(Ae, { alignItems: "center", flex: "1", w: "360px", children: [
      /* @__PURE__ */ ne(ur, { gap: "xxs", alignItems: "center", pl: "xxs", children: [
        /* @__PURE__ */ b(Ru, { countryCode: l }),
        /* @__PURE__ */ b($e, { variant: "bodyRegularS", children: d })
      ] }),
      /* @__PURE__ */ b($e, { ml: "auto", variant: "bodyRegularS", color: "neutral-700", children: s })
    ] });
  }, []), o = ue(
    async (u) => (await r(u, a)).map((s) => ({
      label: s.name,
      data: s,
      value: s.id
    })),
    [r, a]
  );
  return /* @__PURE__ */ b(
    iy,
    {
      options: a,
      getPlaceholder: (u) => u ? `${u} numbers` : "Search lines",
      renderOption: i,
      onSearch: o,
      total: t,
      onChange: n
    }
  );
}
function rPe({
  users: e,
  total: t,
  onSearch: r,
  onChange: n
}) {
  const a = qe(
    () => e.map((u) => ({
      label: u.name,
      data: u,
      value: u.id
    })),
    [e]
  ), i = (u) => {
    const {
      data: { name: d, image: s }
    } = u;
    return /* @__PURE__ */ b(Ae, { alignItems: "center", flex: "1", w: "360px", children: /* @__PURE__ */ ne(ur, { gap: "xxs", alignItems: "center", pl: "xxs", children: [
      /* @__PURE__ */ b(
        Mh,
        {
          "data-test": "page-header-avatar",
          src: s,
          initials: W3(d),
          size: "regular"
        }
      ),
      /* @__PURE__ */ b($e, { variant: "bodyRegularS", children: d })
    ] }) });
  }, o = ue(
    async (u) => (await r(u, a)).map((s) => ({
      label: s.name,
      data: s,
      value: s.id
    })),
    [r, a]
  );
  return /* @__PURE__ */ b(
    iy,
    {
      options: a,
      getPlaceholder: (u) => u ? `${u} users` : "Search users",
      renderOption: i,
      onSearch: o,
      total: t,
      onChange: n
    }
  );
}
function nPe({
  teams: e,
  total: t,
  onSearch: r,
  onChange: n
}) {
  const a = qe(
    () => e.map((u) => ({
      label: u.name,
      data: u,
      value: u.id
    })),
    [e]
  ), i = (u) => {
    const {
      data: { name: d, emoji: s }
    } = u;
    return /* @__PURE__ */ b(Ae, { alignItems: "center", flex: "1", w: "360px", children: /* @__PURE__ */ ne(ur, { gap: "xxs", alignItems: "center", pl: "xxs", children: [
      /* @__PURE__ */ b($e, { variant: "bodyRegularS", children: s }),
      /* @__PURE__ */ b($e, { variant: "bodyRegularS", children: d })
    ] }) });
  }, o = ue(
    async (u) => (await r(u, a)).map((s) => ({
      label: s.name,
      data: s,
      value: s.id
    })),
    [r, a]
  );
  return /* @__PURE__ */ b(
    iy,
    {
      options: a,
      getPlaceholder: (u) => u ? `${u} teams` : "Search teams",
      renderOption: i,
      onSearch: o,
      total: t,
      onChange: n
    }
  );
}
const fSe = Xn((e, t) => {
  const { placeholder: r } = e;
  return /* @__PURE__ */ b(
    Ae,
    {
      w: "100%",
      borderRadius: "8px",
      border: "1px solid",
      borderColor: "neutral-200",
      p: "xs",
      cursor: "pointer",
      alignItems: "center",
      ref: t,
      backgroundColor: "neutral-0",
      ...e,
      children: /* @__PURE__ */ ne(ur, { flex: "1", alignItems: "center", gap: "xs", children: [
        /* @__PURE__ */ b(sr, { component: fh, color: "secondary-500", size: 22 }),
        /* @__PURE__ */ b(ur, { alignItems: "center", gap: "xxxs", children: /* @__PURE__ */ b($e, { variant: "bodyRegularS", children: r }) })
      ] })
    }
  );
});
function sP({
  options: e,
  renderOption: t,
  "data-test": r = "search-select",
  placeholder: n = "Search",
  getPlaceholder: a,
  onChange: i,
  onSearch: o,
  loadingText: u
}) {
  const [d, s] = Xe(!1), [l, f] = Xe([]), c = tt(e), h = qe(
    () => c.current.find((v) => v.value === l[0]),
    [l]
  ), _ = ue(
    async (v) => {
      if (!v.length)
        return e;
      s(!0);
      const $ = v.trim().toLowerCase(), E = await o($, e);
      return c.current = Lk(
        [...c.current, ...E],
        ["value"]
      ), s(!1), E;
    },
    [o, e]
  ), F = ue(
    (v) => {
      f(v);
      const $ = c.current.find(
        (E) => E.value === v[0]
      );
      if (!$)
        throw new Error("Selected option not found");
      i($);
    },
    [i]
  );
  return /* @__PURE__ */ b(
    oP,
    {
      "data-test": r,
      placeholder: n,
      options: e,
      searchOptions: _,
      loading: d,
      loadingText: u,
      searchable: !0,
      selectedKeys: l,
      renderOption: t,
      onSelectionChange: F,
      trigger: /* @__PURE__ */ b(fSe, { placeholder: a(h) })
    }
  );
}
function aPe({
  lines: e,
  onChange: t,
  onSearch: r,
  getPlaceholder: n = (a) => (a == null ? void 0 : a.data.name) || "Search lines"
}) {
  const a = qe(
    () => e.map((u) => ({
      label: u.name,
      value: u.id,
      data: u
    })),
    [e]
  ), i = ue(
    async (u) => (await r(u, a)).map((s) => ({
      label: s.name,
      value: s.id,
      data: s
    })),
    [r, a]
  ), o = ue((u) => {
    const {
      data: { name: d, number: s, countryCode: l }
    } = u;
    return /* @__PURE__ */ b(Ae, { alignItems: "center", flex: "1", w: "360px", children: /* @__PURE__ */ ne(ur, { gap: "xxs", alignItems: "center", children: [
      /* @__PURE__ */ b(Ru, { countryCode: l }),
      /* @__PURE__ */ b($e, { variant: "bodyRegularS", children: d }),
      /* @__PURE__ */ b($e, { variant: "bodyRegularS", color: "neutral-600", fontSize: 12, children: s })
    ] }) });
  }, []);
  return /* @__PURE__ */ b(
    sP,
    {
      "data-test": "search-lines-select",
      getPlaceholder: n,
      options: a,
      onSearch: i,
      onChange: t,
      renderOption: o
    }
  );
}
function iPe({
  users: e,
  onChange: t,
  onSearch: r,
  getPlaceholder: n = (i) => (i == null ? void 0 : i.data.name) || "Search users",
  loadingText: a
}) {
  const i = qe(
    () => e.map((d) => ({
      label: d.name,
      value: d.id,
      data: d
    })),
    [e]
  ), o = ue(
    async (d) => (await r(d, i)).map((l) => ({
      label: l.name,
      value: l.id,
      data: l
    })),
    [r, i]
  ), u = ue((d) => {
    const {
      data: { name: s, image: l, email: f }
    } = d;
    return /* @__PURE__ */ b(Ae, { alignItems: "center", flex: "1", w: "360px", children: /* @__PURE__ */ ne(ur, { gap: "xxs", alignItems: "center", children: [
      /* @__PURE__ */ b(Mh, { src: l, initials: W3(s), size: "regular" }),
      /* @__PURE__ */ b($e, { variant: "bodyRegularS", children: s }),
      /* @__PURE__ */ b($e, { variant: "bodyRegularS", color: "neutral-600", fontSize: 12, children: f })
    ] }) });
  }, []);
  return /* @__PURE__ */ b(
    sP,
    {
      "data-test": "search-users-select",
      getPlaceholder: n,
      options: i,
      onSearch: o,
      onChange: t,
      renderOption: u,
      loadingText: a
    }
  );
}
function cSe({
  "data-test": e = "skeleton-text",
  quantity: t = 3
}) {
  const r = ue(
    (n) => `${n === t - 1 ? Math.floor(Math.random() * 60) + 15 : 100}%`,
    [t]
  );
  return t < 1 ? null : /* @__PURE__ */ b(
    CF,
    {
      gap: "xxxs",
      w: "100%",
      direction: "vertical",
      quantity: t,
      "data-test": e,
      children: (n) => /* @__PURE__ */ b(
        ls,
        {
          h: 14,
          w: r(n),
          "data-test": `${e}-line-${n}`
        }
      )
    }
  );
}
function oPe({
  "data-test": e = "skeleton-note",
  quantity: t = 2
}) {
  return /* @__PURE__ */ ne(Dt, { direction: "vertical", gap: "xxs", w: "100%", "data-test": e, children: [
    /* @__PURE__ */ ne(Ae, { alignItems: "center", justifyContent: "space-between", gap: "xxxs", children: [
      /* @__PURE__ */ ne(Dt, { gap: "xxxs", alignItems: "center", children: [
        /* @__PURE__ */ b(ls, { h: 24, shape: "squircle", w: 24 }),
        /* @__PURE__ */ b(ls, { w: 80, h: 14 })
      ] }),
      /* @__PURE__ */ b(ls, { w: 100, h: 14 })
    ] }),
    /* @__PURE__ */ b(cSe, { quantity: t })
  ] });
}
function sPe({
  quantity: e = 3,
  gap: t = "xxs",
  "data-test": r = "skeleton-tag",
  ...n
}) {
  return /* @__PURE__ */ b(CF, { quantity: e, gap: t, flexWrap: "wrap", children: (a) => /* @__PURE__ */ b(
    ls,
    {
      w: 80,
      h: 18,
      "data-test": `${r}-${a}`,
      ...n
    },
    a
  ) });
}
function uPe({ date: e, locale: t }) {
  return /* @__PURE__ */ ne(ur, { flexDirection: "column", gap: 0, children: [
    /* @__PURE__ */ b(e4, { date: e, variant: "bodyMediumS", locale: t }),
    /* @__PURE__ */ b(
      iP,
      {
        date: e,
        color: "text-secondary",
        variant: "supportingMediumS",
        locale: t
      }
    )
  ] });
}
function dPe({
  color: e,
  children: t,
  size: r = "small",
  "data-test": n = "tag-beautified"
}) {
  const { textColor: a } = ule({
    color: e,
    threshold: hSe
  }), i = [
    Mr("secondary-800"),
    Mr("informative-500"),
    Mr("informative-600"),
    Mr("warning-500"),
    Mr("critical-300"),
    Mr("critical-500"),
    Mr("critical-700"),
    Mr("primary-300"),
    Mr("primary-600"),
    Mr("decorative1-300"),
    Mr("decorative2-700"),
    Mr("informative-100")
  ].filter(HD), { color: o } = DW(e, i);
  return /* @__PURE__ */ b(
    ms,
    {
      "data-test": n,
      bg: o,
      color: a,
      size: r,
      children: t
    }
  );
}
const hSe = 0.3;
function uP({
  color: e,
  active: t = !1,
  "data-test": r
}) {
  return /* @__PURE__ */ b(
    ot,
    {
      "data-test": r,
      borderRadius: "50%",
      w: 20,
      h: 20,
      border: "4px solid",
      borderColor: e,
      backgroundColor: t ? "transparent" : e
    }
  );
}
const gSe = Ge(Ae)`
  border: 1px solid ${He("neutral-200")};
  &:hover {
    border: 1px solid ${He("neutral-300")};
  }
`, _Se = Xn(({ value: e, onClick: t, dataTest: r, disabled: n }, a) => /* @__PURE__ */ ne(
  gSe,
  {
    alignItems: "center",
    justifyContent: "center",
    h: "48px",
    px: "xs",
    gap: "xxxs",
    borderRadius: "8px",
    cursor: n ? "not-allowed" : "pointer",
    backgroundColor: n ? "neutral-100" : "white",
    ref: a,
    onClick: n ? void 0 : t,
    "data-test": r,
    children: [
      /* @__PURE__ */ b(
        uP,
        {
          "data-test": `${r}-input-color-chip`,
          color: e || "neutral-200"
        }
      ),
      /* @__PURE__ */ b(ot, { ml: "xxxs", children: /* @__PURE__ */ b(Su, {}) })
    ]
  }
)), mSe = [
  "#003D4C",
  "#BB2100",
  "#F92C00",
  "#0662B5",
  "#008f6c",
  "#29C8FF",
  "#B285D1",
  "#FCBB26",
  "#FF9D88",
  "#FF854C",
  "#ACCCF3",
  "#48A0FF",
  "#65D289"
], pSe = mSe.map((e) => ({ label: e, value: e })), FSe = (e, t) => /* @__PURE__ */ b(
  uP,
  {
    "data-test": `color-chip-${e.value}`,
    color: e.value,
    active: t === (e == null ? void 0 : e.value)
  }
);
function lPe({
  onChange: e,
  value: t,
  dataTest: r = "tag-color-picker",
  disabled: n = !1
}) {
  return /* @__PURE__ */ b(
    Sf,
    {
      options: pSe,
      renderOption: (i) => FSe(i, t),
      trigger: /* @__PURE__ */ b(
        _Se,
        {
          value: t,
          dataTest: r,
          disabled: n
        }
      ),
      selectedKeys: t ? [t] : [],
      onSelectionChange: (i) => {
        e(i[0]);
      }
    }
  );
}
function ySe({ items: e }) {
  return /* @__PURE__ */ b(ot, { maxW: 250, children: e.map((t, r) => /* @__PURE__ */ ne($e, { color: "neutral-0", maxW: 235, ellipsis: !0, children: [
    t,
    r !== e.length - 1 && ","
  ] }, r)) });
}
function fPe({
  items: e,
  mode: t = "outline",
  size: r = "small",
  variant: n = "lightSecondary",
  maxVisibleTags: a = 5,
  "data-test": i = "tag-stack",
  ...o
}) {
  const u = qe(
    () => e.slice(a),
    [e, a]
  ), d = qe(
    () => e.slice(0, a),
    [e, a]
  );
  return /* @__PURE__ */ b(
    ko,
    {
      visible: !!u.length,
      content: /* @__PURE__ */ b(ySe, { items: u }),
      align: "end",
      "data-test": `${i}-tooltip`,
      children: /* @__PURE__ */ ne(
        Dt,
        {
          space: "xxxs",
          alignItems: "center",
          "data-test": i,
          flexWrap: "wrap",
          children: [
            d.map((s, l) => /* @__PURE__ */ b(
              ms,
              {
                size: r,
                mode: t,
                variant: n,
                ...o,
                children: s
              },
              l
            )),
            u.length && /* @__PURE__ */ b(ms, { size: "xSmall", variant: "grey", children: /* @__PURE__ */ ne($e, { color: "contrast-dark", variant: "supportingMediumS", children: [
              "+",
              u.length
            ] }) })
          ]
        }
      )
    }
  );
}
const dP = dr(
  {}
), oy = () => Et(dP);
function bSe({ children: e, disabled: t }) {
  const r = tt(null), n = $ae(r), a = qe(() => ({ disabled: t, hovering: n }), [t, n]);
  return /* @__PURE__ */ b(dP.Provider, { value: a, children: gr(e, { ref: r }) });
}
function cPe({
  "data-test": e = "tile",
  children: t,
  disabled: r = !1,
  minWidth: n = 144,
  ...a
}) {
  return /* @__PURE__ */ b(bSe, { disabled: r, children: /* @__PURE__ */ b(
    Ae,
    {
      backgroundColor: "surface-default",
      borderRadius: "sm",
      "data-test": e,
      flexDirection: "column",
      minWidth: n,
      position: "relative",
      px: "xxs",
      py: "xxs",
      ...a,
      children: t
    }
  ) });
}
function hPe({
  "data-test": e = "tile-actions",
  children: t
}) {
  return /* @__PURE__ */ b(
    Ae,
    {
      alignItems: "center",
      "data-test": e,
      position: "absolute",
      right: "8px",
      top: "8px",
      children: t
    }
  );
}
function gPe({
  "data-test": e = "tile-body",
  children: t,
  ...r
}) {
  return /* @__PURE__ */ b(Ae, { alignItems: "center", "data-test": e, gap: "xxxs", ...r, children: t });
}
var R1 = /* @__PURE__ */ ((e) => (e.NEGATIVE = "NEGATIVE", e.NEUTRAL = "NEUTRAL", e.POSITIVE = "POSITIVE", e))(R1 || {});
function vSe(e) {
  switch (e) {
    case R1.NEGATIVE:
      return /* @__PURE__ */ b(Df, { color: "graphic-critical-strong", size: 12 });
    case R1.POSITIVE:
      return /* @__PURE__ */ b(dh, { color: "graphic-success-strong", size: 12 });
    case R1.NEUTRAL:
    default:
      return /* @__PURE__ */ b(cM, { color: "graphic-neutral", size: 12 });
  }
}
function ESe({
  "data-test": e = "trend",
  tooltipContent: t,
  trend: r,
  value: n
}) {
  const a = n !== void 0;
  return /* @__PURE__ */ b(
    ko,
    {
      "data-test": `${e}-tooltip`,
      content: t,
      visible: t !== void 0,
      children: /* @__PURE__ */ ne(Ae, { alignItems: "center", "data-test": e, gap: "xxxs", children: [
        vSe(r),
        a && /* @__PURE__ */ b($e, { color: "text-secondary", variant: "supportingRegularS", children: n })
      ] })
    }
  );
}
function _Pe({
  "data-test": e = "tile-extra",
  secondaryText: t,
  trend: r,
  ...n
}) {
  const { disabled: a } = oy();
  return /* @__PURE__ */ ne(Ae, { alignItems: "center", "data-test": e, children: [
    r && /* @__PURE__ */ b(ESe, { "data-test": `${e}-trend`, trend: r, ...n }),
    t && /* @__PURE__ */ b(
      $e,
      {
        color: a ? "text-disabled" : "text-interactive-neutral",
        ml: r ? "xs" : "xxs",
        variant: "supportingRegularS",
        children: t
      }
    )
  ] });
}
const $Se = {
  small: "supportingMediumXS",
  regular: "supportingMediumXS",
  large: "supportingRegularS"
};
function wSe({
  "data-test": e = "tile-header",
  label: t,
  size: r = "regular",
  tooltipTexts: n,
  ...a
}) {
  const { hovering: i } = oy(), o = (n == null ? void 0 : n.help) ?? (n == null ? void 0 : n.info), u = o && i, d = n != null && n.help ? hM : gM;
  return /* @__PURE__ */ ne(
    Ae,
    {
      alignItems: "center",
      alignSelf: "flex-start",
      "data-test": e,
      ...a,
      children: [
        /* @__PURE__ */ b(
          $e,
          {
            color: "text-interactive-neutral",
            variant: $Se[r],
            children: t
          }
        ),
        u && /* @__PURE__ */ b(hh, { title: o, children: /* @__PURE__ */ b(
          sr,
          {
            color: "icon-default",
            component: d,
            "data-test": "tile-header-tooltip-trigger",
            ml: "xxxs",
            size: 12
          }
        ) })
      ]
    }
  );
}
const kSe = {
  small: { lineHeight: "18px", fontWeight: "500", fontSize: "14px" },
  regular: { lineHeight: "32px", fontWeight: "700", fontSize: "24px" },
  large: { lineHeight: "32px", fontWeight: "700", fontSize: "32px" }
}, xSe = {
  small: { lineHeight: "18px", fontWeight: "500", fontSize: "14px" },
  regular: { lineHeight: "18px", fontWeight: "500", fontSize: "16px" },
  large: { lineHeight: "18px", fontWeight: "500", fontSize: "16px" }
};
function DSe({
  "data-test": e = "tile-duration",
  size: t = "regular",
  value: r
}) {
  const n = ax(ix(r));
  return n ? /* @__PURE__ */ ne(Ae, { alignItems: "baseline", "data-test": e, display: "flex", children: [
    /* @__PURE__ */ b($e, { color: "inherit", ...kSe[t], children: n[0] }),
    /* @__PURE__ */ b($e, { color: "inherit", ...xSe[t], children: n[1] })
  ] }) : null;
}
const CSe = {
  small: { lineHeight: "18px", fontWeight: "500", fontSize: "14px" },
  regular: { lineHeight: "32px", fontWeight: "700", fontSize: "24px" },
  large: { lineHeight: "32px", fontWeight: "700", fontSize: "32px" }
}, SSe = {
  small: { lineHeight: "18px", fontWeight: "500", fontSize: "14px" },
  regular: { lineHeight: "18px", fontWeight: "700", fontSize: "18px" },
  large: { lineHeight: "18px", fontWeight: "700", fontSize: "24px" }
}, ASe = {
  small: { lineHeight: "18px", fontWeight: "500", fontSize: "14px" },
  regular: { lineHeight: "18px", fontWeight: "500", fontSize: "16px" },
  large: { lineHeight: "18px", fontWeight: "500", fontSize: "16px" }
};
function OSe({
  "data-test": e = "tile-number",
  locale: t = "en-US",
  size: r = "regular",
  suffix: n,
  value: a
}) {
  const i = ax(
    ene(a, t)
  );
  return i ? /* @__PURE__ */ ne(Ae, { alignItems: "baseline", "data-test": e, display: "flex", children: [
    /* @__PURE__ */ b($e, { color: "inherit", ...CSe[r], children: i[0] }),
    i[1] !== void 0 && /* @__PURE__ */ b($e, { color: "inherit", ...SSe[r], children: i[1] }),
    n !== void 0 && /* @__PURE__ */ b($e, { color: "inherit", ...ASe[r], children: n })
  ] }) : null;
}
const TSe = {
  small: { lineHeight: "18px", fontWeight: "500", fontSize: "14px" },
  regular: { lineHeight: "32px", fontWeight: "500", fontSize: "16px" },
  large: { lineHeight: "32px", fontWeight: "300", fontSize: "32px" }
};
function Cw({
  "data-test": e = "tile-text",
  size: t = "regular",
  value: r
}) {
  return /* @__PURE__ */ b($e, { color: "inherit", "data-test": e, ...TSe[t], children: r });
}
var Cu = /* @__PURE__ */ ((e) => (e.DURATION = "DURATION", e.NUMBER = "NUMBER", e.TEXT = "TEXT", e))(Cu || {});
const PSe = Ge(nr)`
  background-color: transparent;
  border: 0;
  color: ${He("text-interactive-secondary")};
  flex-direction: column;
  gap: 0;
  height: unset;
  min-width: auto;
  padding: 0;

  ${({ active: e, disabled: t, readOnly: r }) => t ? _r`
          color: ${He("text-disabled")};
          cursor: not-allowed;
        ` : !r && _r`
          color: ${He(
  e ? "text-interactive-primary-active" : "text-interactive-secondary"
)};

          &:hover {
            background-color: transparent;
            color: ${He("text-interactive-primary")};

            ::after {
              background: ${He("text-interactive-primary")};
            }
          }

          &:focus,
          &:active {
            background-color: transparent;
            color: ${He("text-interactive-primary-active")};

            ::after {
              background: ${He("text-interactive-primary-active")};
            }
          }
        `}

  ${({ active: e, readOnly: t }) => !t && _r`
      ::after {
        background: ${e ? He("text-interactive-primary-active") : _r`repeating-linear-gradient(
            to right,
            ${He("text-interactive-secondary")},
            ${He("text-interactive-secondary")} 2px,
            transparent 2px,
            transparent 4px
            )
          center/100% 2px no-repeat`};
        bottom: 0;
        content: "";
        height: 1px;
        position: absolute;
        width: 100%;
    `}
`, ISe = {
  small: "22px",
  regular: "24px",
  large: "24px"
};
function RSe(e, t, r) {
  if (t === void 0)
    return /* @__PURE__ */ b(Cw, { value: "_ _", ...r });
  switch (e) {
    case Cu.DURATION:
      return /* @__PURE__ */ b(
        DSe,
        {
          value: t,
          ...r
        }
      );
    case Cu.NUMBER:
      return /* @__PURE__ */ b(OSe, { value: t, ...r });
    case Cu.TEXT:
    default:
      return /* @__PURE__ */ b(Cw, { value: t, ...r });
  }
}
function Sw({
  "data-test": e = "tile-value",
  active: t = !1,
  loading: r,
  onClick: n,
  type: a = Cu.NUMBER,
  value: i,
  ...o
}) {
  const { disabled: u } = oy(), d = !!n;
  if (r) {
    const s = o.size ?? "regular";
    return /* @__PURE__ */ b(
      Ae,
      {
        alignItems: "center",
        "data-test": `${e}-loading`,
        h: "32px",
        justifyContent: "center",
        children: /* @__PURE__ */ b(sr, { component: Pw, size: ISe[s], spin: !0 })
      }
    );
  }
  return /* @__PURE__ */ b(
    PSe,
    {
      active: t,
      "data-test": e,
      disabled: u,
      onClick: n,
      readOnly: !d,
      type: "button",
      children: RSe(a, i, o)
    }
  );
}
const jSe = Ge(Ae)`
  top: 50%;
  transform: translateY(-50%);
`;
function mPe({
  "data-test": e = "tile-legend",
  detailedValue: t,
  label: r,
  loading: n,
  onClick: a,
  value: i
}) {
  const o = () => {
    a == null || a({ label: r, value: i });
  };
  return /* @__PURE__ */ b(
    Ae,
    {
      alignSelf: "center",
      "data-test": e,
      flexDirection: "column",
      ml: t ? "xxs" : "l",
      position: "relative",
      w: "100%",
      children: /* @__PURE__ */ b(
        jSe,
        {
          alignItems: "flex-start",
          flexDirection: "column",
          position: "absolute",
          w: "100%",
          children: t ? /* @__PURE__ */ ne(Nr, { children: [
            /* @__PURE__ */ ne(Ae, { alignItems: "center", justifyContent: "space-between", w: "100%", children: [
              /* @__PURE__ */ b(
                Sw,
                {
                  loading: n,
                  onClick: o,
                  size: "small",
                  type: Cu.TEXT,
                  value: r
                }
              ),
              /* @__PURE__ */ b($e, { variant: "supportingSemiboldS", children: i })
            ] }),
            /* @__PURE__ */ b(Ae, { as: "ul", flexDirection: "column", mt: 0.5, p: 0, w: "100%", children: t.map((u, d) => /* @__PURE__ */ ne(
              Ae,
              {
                as: "li",
                justifyContent: "space-between",
                mt: 0.5,
                children: [
                  /* @__PURE__ */ b(
                    $e,
                    {
                      color: "text-secondary",
                      variant: "supportingRegularXS",
                      children: u.label
                    }
                  ),
                  /* @__PURE__ */ b(
                    $e,
                    {
                      color: "text-secondary",
                      variant: "supportingRegularXS",
                      children: u.value
                    }
                  )
                ]
              },
              d
            )) })
          ] }) : /* @__PURE__ */ ne(Nr, { children: [
            /* @__PURE__ */ b(
              Sw,
              {
                loading: n,
                onClick: o,
                size: "large",
                value: i
              }
            ),
            /* @__PURE__ */ b(wSe, { label: r, my: "xxxs", size: "large" })
          ] })
        }
      )
    }
  );
}
function pPe({
  "data-test": e = "tile-list",
  children: t,
  ...r
}) {
  return /* @__PURE__ */ b(
    Ae,
    {
      alignItems: "center",
      backgroundColor: "surface-default",
      borderRadius: "sm",
      "data-test": e,
      justifyContent: "space-between",
      ...r,
      children: t
    }
  );
}
const MSe = 1440, BSe = (e) => {
  const t = [];
  for (let r = 0; r <= 24; r += 1)
    for (let n = 0; n < 60 && !(r * 60 + n > MSe); n += e) {
      const i = r.toString().padStart(2, "0"), o = n.toString().padStart(2, "0"), u = `${i}:${o}`, d = `${i}:${o}:00.000`;
      t.push({ label: u, value: d });
    }
  return t;
}, NSe = (e, t) => {
  if (!t)
    return "00:00";
  const [r, n] = t.split(":"), a = parseInt(r) * 60 + parseInt(n), i = a % e, o = a - i + e, u = Math.floor(o / 60), d = Math.floor(o % 60);
  return `${u}:${d}`;
}, LSe = (e, t, r, n) => {
  const [a, i] = r.split(":").map(Number), [o, u] = NSe(
    t,
    n
  ).split(":").map(Number), d = a * 60 + i, s = o * 60 + u;
  return e.filter((l) => {
    const [f, c] = l.value.split(":").map(Number), h = f * 60 + c;
    return h >= s && h <= d;
  });
}, lP = ["ZERO", "ONE", "TWO", "THREE", "FOUR", "FIVE"], qSe = (e) => [0, 1, 3, 4].includes(e), USe = (e, t, r) => {
  const n = {
    ZERO: `0${e}:${t}`,
    ONE: `${e}0:${t}`,
    THREE: `${e}:0${t}`,
    FOUR: `${e}:${t}0`
  }, a = lP[r];
  return n[a];
}, GSe = (e) => [1, 2, 3, 4, 5].includes(e), WSe = (e, t, r) => {
  const n = {
    ONE: `${e[0]}${e[2]}:${t}`,
    TWO: `${e.slice(0, 2)}:${t}`,
    THREE: `${e.slice(0, 2)}:${e[2]}${t[1]}`,
    FOUR: `${e}:${t[0]}${t[2]}`,
    FIVE: `${e}:${t.slice(0, 2)}`
  }, a = lP[r];
  return n[a];
}, VSe = (e, t) => {
  const [r, n] = e.split(":");
  return n ? (r.length === 1 || n.length === 1) && qSe(t) ? USe(r, n, t) : (r.length === 3 || n.length === 3) && GSe(t) ? WSe(r, n, t) : e : `${e.slice(0, 1)}0:${e.slice(2)}`;
}, HSe = (e, t) => {
  if (!e || !t)
    return t;
  const r = t - e;
  return t === 2 && r > 0 ? t + 1 : t === 2 && r < 0 ? t - 1 : t === 3 && r > 0 ? t + 1 : t;
}, zSe = (e, t) => {
  const [r, n] = t.split(":").map(Number), a = r * 60 + n, [i, o] = e.split(":").map(Number), u = i * 60 + o;
  return !(!/^(?:[01]\d|2[0-3]):[0-5]\d|24:00$/.test(e) || u > a);
}, KSe = Ge(nd)`
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  &::-webkit-clear-button {
    -webkit-appearance: none;
  }
  &::-webkit-calendar-picker-indicator {
    display: none;
  }
  &::-webkit-datetime-edit-hour-field,
  &::-webkit-datetime-edit-minute-field {
    &:focus,
    &:hover {
      cursor: text;
    }
    &:focus {
      background-color: ${({ theme: e }) => e.colors["surface-interactive-secondary-ghost-active"]};
      padding: 1px 3px;
      border-radius: 4px;
    }
  }
  &,
  &::-webkit-datetime-edit-hour-field:focus,
  &::-webkit-datetime-edit-minute-field:focus {
    color: ${({ theme: e }) => e.colors["text-base"]};
  }
`, YSe = Ge(HM)`
  justify-content: space-between;
  border: 1px solid;
  border-color: ${({ hasError: e }) => e ? He("graphic-interactive-critical") : He("graphic-interactive-default")};
  color: ${He("text-base")};
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  background-color: ${({ disabled: e }) => e ? He("surface-disabled") : He("surface-default")};
  pointer-events: ${({ disabled: e }) => e ? "none" : "auto"};
  width: 100%;

  &:hover {
    background-color: ${He("surface-default")};
    border-color: ${({ hasError: e }) => e ? He("graphic-interactive-critical-hover") : He("graphic-interactive-default-hover")};
  }

  &:focus,
  &:focus-within {
    background-color: ${He("surface-default")};
    border-color: ${({ hasError: e }) => e ? He("text-interactive-critical-active") : He(
  "graphic-interactive-default-active"
)}; // this is due to graphic-interactive-critical-active being bugged
  }

  > div {
    border: none;
    background-color: transparent;
    padding: 0;
  }
`, k1 = {
  MAIN: "time-picker",
  DROPDOWN: "dropdown",
  ITEM: "item",
  MENU: "menu"
};
function FPe({
  "data-test": e = k1.MAIN,
  value: t,
  onInputChange: r,
  onSelectChange: n,
  onRowDisable: a,
  error: i = !1,
  minWidth: o = "105px",
  maxHeight: u = "250px",
  excludeStartingTime: d,
  endingTime: s = "23:59",
  disabled: l = !1,
  ariaLabel: f,
  optionInterval: c = 30,
  noOptionsLabel: h
}) {
  const _ = qe(() => t.slice(0, 5), [t]), F = tt(null), [v, $] = Xe(null), E = qe(
    () => BSe(c),
    [c]
  ), D = qe(
    () => LSe(
      E,
      c,
      s,
      d
    ),
    [E, c, d, s]
  ), w = (A) => {
    A.preventDefault();
    const { value: P, selectionStart: S } = A.target, N = VSe(P, S), W = zSe(N, s), V = HSe(v, S);
    $(V), W && r(`${N}:00.000`);
  }, k = (A) => {
    $(A.target.selectionStart);
  };
  return td(() => {
    F.current.setSelectionRange(v, v);
  }, [v]), /* @__PURE__ */ b(ot, { minWidth: o, w: "100%", children: /* @__PURE__ */ b(
    k3,
    {
      align: "end",
      trigger: /* @__PURE__ */ b(
        YSe,
        {
          "data-test": `${e}-${k1.DROPDOWN}`,
          mode: "outline",
          variant: "secondary",
          hasError: i,
          disabled: l,
          "aria-label": f,
          children: /* @__PURE__ */ b(
            KSe,
            {
              ref: F,
              "data-test": e,
              value: _,
              onChange: w,
              onSelect: k
            }
          )
        }
      ),
      children: /* @__PURE__ */ b(
        C3,
        {
          "data-test": `${e}-${k1.MENU}`,
          overflowY: "scroll",
          maxH: u,
          children: D.length > 0 ? D.map((A) => /* @__PURE__ */ b(
            S3,
            {
              "data-test": `${e}-${k1.ITEM}-${A.value}`,
              onClick: () => n(A.value),
              disabled: (a == null ? void 0 : a(A.value)) ?? !1,
              children: A.label
            },
            A.value
          )) : /* @__PURE__ */ b(ot, { pl: "xs", pr: "xs", children: /* @__PURE__ */ b($e, { variant: "supportingRegularS", children: h }) })
        }
      )
    }
  ) });
}
function XSe({ items: e }) {
  return /* @__PURE__ */ b(ot, { maxW: 250, children: e.map((t, r) => /* @__PURE__ */ ne(
    $e,
    {
      color: "neutral-0",
      maxW: 235,
      ellipsis: !0,
      children: [
        t,
        r !== e.length - 1 && ","
      ]
    },
    r
  )) });
}
function QSe({
  items: [e, ...t],
  hasTooltip: r = !0,
  "data-test": n = "typography-stack",
  ...a
}) {
  return /* @__PURE__ */ b(
    ko,
    {
      visible: r && !!t.length,
      content: /* @__PURE__ */ b(XSe, { items: t }),
      "data-test": `${n}-tooltip`,
      children: /* @__PURE__ */ ne(Dt, { space: "xxxs", "data-test": n, children: [
        /* @__PURE__ */ b($e, { variant: "bodySemiboldS", ...a, ellipsis: !0, children: e }),
        t.length && /* @__PURE__ */ ne($e, { color: "text-placeholder", children: [
          "+",
          t.length
        ] })
      ] })
    }
  );
}
const Ag = dr({
  names: [],
  number: void 0,
  disabled: !1,
  hasClick: !1,
  setNames: (
    /* istanbul ignore next */
    () => {
    }
  )
});
function ZSe({
  names: e,
  children: t,
  ...r
}) {
  const { setNames: n, disabled: a, hasClick: i } = Et(Ag);
  if (at(() => {
    e ? n(e) : Array.isArray(t) ? n([t.join("")]) : t && n([t]);
  }, [n, e, t]), e)
    return /* @__PURE__ */ b(QSe, { hasTooltip: !1, items: e, ...r });
  let o = "text-base";
  return a ? o = "text-secondary" : i && (o = "text-interactive-secondary"), /* @__PURE__ */ b($e, { variant: "bodySemiboldS", color: o, ...r, children: t });
}
function yPe({ children: e }) {
  const { names: t, disabled: r } = Et(Ag), n = qe(() => {
    if (!t.length)
      return "";
    const [a, i] = t[0].split(" ");
    return W3(a, i);
  }, [t]);
  return /* @__PURE__ */ b(
    Mh,
    {
      "data-test": "user-avatar",
      initials: n,
      src: e,
      size: "small",
      disabled: r
    }
  );
}
function bPe({
  children: e,
  disabled: t = !1,
  number: r,
  countryCode: n,
  hasTooltip: a = !0,
  tooltipSecondary: i,
  ...o
}) {
  const [u, d] = Xe([]), s = typeof e == "string", l = !!o.onClick, f = qe(
    () => ({
      names: u,
      setNames: d,
      number: r,
      disabled: t,
      hasClick: l,
      countryCode: n
    }),
    [n, t, l, u, r]
  );
  function c() {
    let _;
    return !a || (r ? _ = /* @__PURE__ */ b(Wf, { value: r, countryCode: n }) : u.length === 1 ? [_] = u : u.length > 1 && (_ = u.slice(1).join(", ")), !_) ? null : /* @__PURE__ */ b(Bh, { rows: [[_, i]] });
  }
  const h = c();
  return /* @__PURE__ */ b(Ag.Provider, { value: f, children: /* @__PURE__ */ b(
    ko,
    {
      visible: !!h,
      content: h,
      align: "center",
      side: "top",
      sideOffset: 4,
      mouseEnterDelay: 0,
      mouseLeaveDelay: 100,
      children: /* @__PURE__ */ b(
        Dt,
        {
          "data-test": "user",
          alignItems: "center",
          space: "xxxs",
          cursor: l ? "pointer" : "default",
          ...o,
          children: s ? /* @__PURE__ */ b(ZSe, { children: e }) : e
        }
      )
    }
  ) });
}
function vPe({ children: e, ...t }) {
  const { countryCode: r, hasClick: n, disabled: a } = Et(Ag);
  let i = "text-base";
  return a ? i = "text-secondary" : n && (i = "text-interactive-secondary"), /* @__PURE__ */ b(
    Wf,
    {
      "data-test": "user-number",
      value: e,
      countryCode: r,
      color: i,
      variant: "bodyMediumS",
      ...t
    }
  );
}
function EPe({
  size: e,
  "data-test": t = "user-count-tag"
}) {
  const r = e === 0;
  return /* @__PURE__ */ b(
    ms,
    {
      variant: "red",
      mode: "fill",
      bg: r ? void 0 : "transparent",
      color: r ? void 0 : "neutrall-700",
      "data-test": t,
      children: /* @__PURE__ */ ne(Dt, { space: "xxxs", alignItems: "center", children: [
        /* @__PURE__ */ b(
          sr,
          {
            "data-test": `${t}-icon`,
            component: _M,
            size: 16
          }
        ),
        /* @__PURE__ */ b($e, { children: e.toString() })
      ] })
    }
  );
}
function JSe({ status: e }) {
  let t = "informative-500";
  switch (e) {
    case Ko.IN_CALL:
      return /* @__PURE__ */ b(wm, { status: Je.IN_CALL, size: 24 });
    case Ko.RINGING:
      return /* @__PURE__ */ b(wm, { status: Je.RINGING, size: 24 });
    case Ko.AFTER_CALL_WORK:
      t = "informative-500";
      break;
    case Ko.AVAILABLE:
    case Ko.ON_MOBILE:
      t = "primary-500";
      break;
    case Ko.OFFLINE:
      t = "neutral-200";
      break;
    default:
      t = "critical-500";
      break;
  }
  return /* @__PURE__ */ b(Ae, { w: 24, justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ b(ot, { w: 6, h: 6, backgroundColor: t, borderRadius: "50%" }) });
}
function eAe({
  text: e
}) {
  return /* @__PURE__ */ b(ot, { "data-test": "user-status-tooltip", children: /* @__PURE__ */ b($e, { children: e }) });
}
function $Pe({ status: e, duration: t, texts: r }) {
  return /* @__PURE__ */ b(
    hh,
    {
      content: /* @__PURE__ */ b(eAe, { text: r.tooltip }),
      sideOffset: 2,
      children: /* @__PURE__ */ ne(Dt, { space: "xxs", alignItems: "center", "data-test": "user-status", children: [
        /* @__PURE__ */ b(JSe, { status: e }),
        /* @__PURE__ */ ne(ur, { flexDirection: "column", space: 0, children: [
          /* @__PURE__ */ b($e, { color: "text-base", variant: "bodyMediumS", children: r.title }),
          /* @__PURE__ */ b(
            r4,
            {
              color: "neutral-400",
              variant: "supportingMediumS",
              seconds: t,
              children: r.duration
            }
          )
        ] })
      ] })
    }
  );
}
const wPe = (e, t) => function(n) {
  return /* @__PURE__ */ b(wce, { ...t, children: /* @__PURE__ */ b(e, { ...n }) });
}, kPe = (e, t) => function(n) {
  return /* @__PURE__ */ b(RS, { ...t, children: /* @__PURE__ */ b(e, { ...n }) });
};
export {
  qne as ACCOUNT_PLAN_CANCEL_ROUTE,
  Lne as ACCOUNT_PLAN_PURCHASE_ROUTE,
  Bne as ACCOUNT_ROUTE,
  Une as ACCOUNT_ROUTE_TAB,
  VD as ACCOUNT_TABS,
  Cne as ACTIVITY_FEED_ROUTE,
  Nne as ADDONS_DETAIL_ROUTE,
  ine as ANALYTICS_ROUTE,
  one as ANALYTICS_ROUTE_TAB,
  gH as AUTHORIZATION_ERROR_CODES,
  oG as AUTH_STRATEGY,
  Cle as AVAILABILITY_FILTER_VALUES,
  hAe as AccordionSection,
  nG as AddButton,
  gAe as AiPromotionalBanner,
  Ede as AnimatedButton,
  m8 as AnimatedSaveContainer,
  so as Availability,
  iG as AvailabilitySelect,
  Mh as Avatar,
  pn as BACKEND_ERRORS_TRANSLATION_KEYS,
  yH as BACKEND_VALIDATION_ERRORS_TRANSLATION_KEYS,
  Rr as BACKEND_VALIDATION_KEY_MAPPER,
  mW as BROWSER_CHROME_ALLOWED_VERSIONS,
  bW as BROWSER_EDGE_ALLOWED_VERSIONS,
  pW as BROWSER_FIREFOX_ALLOWED_VERSIONS,
  vW as BROWSER_IE_ALLOWED_VERSIONS,
  yW as BROWSER_OPERA_ALLOWED_VERSIONS,
  FW as BROWSER_SAFARI_ALLOWED_VERSIONS,
  Ene as CALLS_CHILD_ROUTE,
  vne as CALLS_ROUTE,
  wne as CHECK_HEALTH,
  nne as COMPANY_ROUTE,
  GD as CONFIRM_INVITATION_ROUTE,
  WD as CONFIRM_USER_CREATION_ROUTE,
  x as CURRENCIES,
  TW as CURRENCIES_SYMBOLS,
  DOe as CallDirection,
  xOe as CallStatus,
  gae as CallStatusDuration,
  wm as CallStatusIcon,
  hae as CallStatusText,
  cae as CallStatusTooltipContent,
  COe as Chevron,
  vx as ClientException,
  CTe as ComingSoonScreen,
  ko as ConditionalTooltip,
  SOe as ConfirmationModal,
  AOe as CopyToClipboardButton,
  OOe as CopyToClipboardText,
  ok as Count,
  TOe as CountryMultiSearchSelect,
  Lae as CountryPrefixSearchSelect,
  IH as DAYS_IN_WEEK,
  PH as DAY_IN_MILLISECONDS,
  F6 as DEFAULT_CURRENCY,
  uie as DEFAULT_GUTTER,
  BD as DOWNLOAD_APP_ROUTE,
  POe as DateSelect,
  Yae as DateSelectMenu,
  ffe as Day,
  bn as DayOfWeek,
  cfe as DayTime,
  lfe as DaysPicker,
  nTe as DrawerSection,
  aTe as DrawerSectionBody,
  iTe as DrawerSectionHeader,
  zce as DropdownIconWrapper,
  oTe as Dropzone,
  S8 as DropzoneTextElement,
  n4 as Duration,
  lce as EMOJI_SIZES,
  Qr as ERROR_TYPES,
  KS as Emoji,
  sTe as EmojiAvatar,
  uTe as EmojiPicker,
  dTe as EmptyStateView,
  lTe as ExpandableAudioPlayer,
  $Ae as FF_FORM_ERROR,
  qD as FORGOT_PASSWORD_ROUTE,
  La as FORM_ACTIONS,
  bH as FRONTEND_VALIDATION_ERRORS_MAPPER_OF_DESCRIPTIVE_ERROR_TO_KEY_NAME,
  wr as FRONTEND_VALIDATION_ERRORS_TRANSLATION_KEYS,
  Ule as FUNNEL_ID_SESSION_STORAGE,
  fTe as FileInput,
  Nae as FilterTrigger,
  Bae as FilterTriggerBase,
  Ru as Flag,
  cTe as FormField,
  rn as FormWizard,
  PS as FormWizardContext,
  FH as GATEWAY_TIMEOUT_ERROR_CODES,
  $_ as GRAPHQL_ERROR_INTERNAL_API_NOT_FOUND,
  C6 as GRAPHQL_ERROR_INVALID_DATA,
  D6 as GRAPHQL_ERROR_NON_EXISTENT_RESOURCE,
  ur as Gap,
  hTe as GraphQuery,
  go as GridItem,
  AF as GridLayout,
  rne as HOME_ROUTE,
  k1 as HOUR_PICKER_DATA_TEST,
  xAe as HTTPS_URL_PREFIX,
  wce as HasAccess,
  Sh as HttpError,
  sG as IDENTITY_PROVIDERS,
  ND as INTEGRATIONS_ROUTE,
  $ne as INTEGRATIONS_ROUTE_TAB,
  Ane as INTEGRATION_AUTHORIZE,
  One as INTEGRATION_AUTHORIZE_SUCCESS,
  Em as INTEGRATION_CHILD_ROUTES,
  Sne as INTEGRATION_FULL_ROUTES,
  ZS as IconWrapper,
  gTe as ImageUploader,
  _Te as InfoPopup,
  mTe as InfoPopupContent,
  pTe as InfoPopupTrigger,
  FTe as InlineForm,
  Sce as InlineFormButtons,
  pH as LIMITATION_ERROR_CODES,
  P1 as LINE_TYPE_VALUES,
  Ia as LIST_VIEW_PARAMS,
  DF as LOGIN_ROUTE,
  Rne as LOGIN_SSO_ROUTE,
  Ine as LOGIN_SUB_PASSWORD_ROUTE,
  LD as LOGIN_SUB_SSO_ROUTE,
  yTe as Line,
  Qh as LineContext,
  bTe as LineFlag,
  Sle as LineStatus,
  vTe as LineSubtitle,
  Oce as LineTitle,
  Rce as Link,
  QS as List,
  kTe as ListItem,
  xTe as ListItemActions,
  wTe as ListPaginated,
  r4 as LiveDuration,
  W1 as LiveMonitoringCallDirection,
  Je as LiveMonitoringCallStatus,
  Ko as LiveMonitoringUserStatus,
  JS as LoadMoreStrategy,
  DTe as LoadMoreTable,
  CS as Loader,
  dd as Loading,
  TS as LoadingButton,
  CH as MATCH_HTML_ELEMENTS,
  xH as MATCH_NON_DIGITS_REGEX,
  SJ as MAX_PICTURE_SIZE,
  kAe as MAX_UPLOD_IMAGE_SIZE,
  Vf as MessageScreen,
  TTe as MiniAudioPlayer,
  PTe as ModalCard,
  ITe as ModalForm,
  Vle as MotionBox,
  RTe as MultiInlineSearchSelect,
  SF as MultiSearchSelect,
  Dae as MultiSelect,
  xae as MultiSelectContent,
  Cae as MultiSelectInput,
  km as MultiSelectItem,
  tC as MultiSelectLoader,
  Sae as MultiSelectResults,
  mD as NETWORK_ERROR_MSGS,
  _H as NOT_FOUND_ERROR_CODES,
  sne as NUMBERS_ROUTE,
  une as NUMBERS_ROUTE_TAB_ACTIVE,
  dne as NUMBERS_ROUTE_TAB_UNVERIFIED,
  lne as NUMBER_DETAIL_ROUTE,
  fne as NUMBER_DETAIL_ROUTE_TAB,
  _ne as NUMBER_PROOF_OF_ID_ROUTE,
  cne as NUMBER_PURCHASE_ROUTE,
  hne as NUMBER_PURCHASE_ROUTE_AT_IVR_CREATION,
  gne as NUMBER_PURCHASE_ROUTE_AT_IVR_EDITION,
  tA as NavigationBlockerContext,
  MTe as NavigationBlockerDialog,
  jTe as NavigationBlockerProvider,
  Ah as NetworkError,
  STe as NoSupportScreen,
  vF as NotFoundError,
  ATe as NotFoundScreen,
  BTe as Note,
  NTe as NumberBox,
  Wf as NumberFormatted,
  LTe as NumberInput,
  ane as ONBOARDING_ROUTE,
  qTe as OptimisticProgressBar,
  F1e as Overlay,
  jh as PERMISSIONS_ACTIONS,
  oOe as PERMISSIONS_MODAL_LS_KEY,
  Dle as PERSIST_SEARCH_PARAMS_KEY,
  Ul as PROGRESS_ACTION_TYPE,
  Mne as PUBLIC_ROUTES,
  UTe as PageHeader,
  b1e as PageHeaderLink,
  vde as Paper,
  Kle as PaperForm,
  GTe as PercentageTag,
  jS as PermissionsContext,
  LOe as PermissionsProvider,
  ZOe as PersistedSearchParams,
  WTe as PhoneInput,
  VTe as PieChart,
  QCe as PieChartLegend,
  _1e as ProgressBar,
  HTe as ProgressChart,
  UD as RESET_PASSWORD_ROUTE,
  Fn as RESOURCE,
  vu as RESULTS_OPTION_KEY,
  Jr as ROLE_NAME,
  Qv as ROLE_ORDER,
  KTe as RadioBox,
  zTe as RadioBoxGroup,
  aP as RadioBoxGroupContext,
  YTe as RadioRow,
  XTe as RadioRows,
  iP as RelativeDay,
  ZTe as RelativeDayTime,
  CF as RenderMultiple,
  RS as Resource,
  IS as ResourceContext,
  e1e as RestrictedAccessScreen,
  QTe as RolesTags,
  JTe as RouteAccess,
  Pne as SANDBOX_SSO,
  Eu as SELECTED_OPTION_KEY,
  Dne as STATS_CHILD_ROUTE,
  kne as STATS_ROUTE,
  xne as STATS_ROUTE_TAB,
  DH as STRIP_COUNTRY_FROM_LANGUAGE,
  wAe as SUCCESS_FEEDBACK_MESSAGES,
  zle as SaveBar,
  SS as SaveBarContainerContext,
  ROe as SaveBarProvider,
  Nl as SaveButton,
  ga as SaveButtonStatus,
  jce as ScrollContainer,
  ePe as SearchBar,
  aPe as SearchLinesSelect,
  tPe as SearchMultiLinesSelect,
  iy as SearchMultiSelect,
  nPe as SearchMultiTeamsSelect,
  rPe as SearchMultiUsersSelect,
  sP as SearchSelect,
  iPe as SearchUsersSelect,
  oP as Select,
  Yle as SelectField,
  Iae as SelectTrigger,
  Pae as SelectTriggerBase,
  Bce as ShadowScrollContainer,
  Mce as ShadowScrollContainerInner,
  ofe as SingleSearchSelect,
  oPe as SkeletonNote,
  sPe as SkeletonTags,
  cSe as SkeletonText,
  uPe as StartTime,
  rC as StyledFlexTrigger,
  Wle as StyledSaveBar,
  aG as StyledSpacer,
  al as TAG_VARIANTS,
  mne as TEAMS_ROUTE,
  pne as TEAM_DETAIL_ROUTE,
  jne as TEST_ROUTE,
  hSe as THRESHOLD,
  Cu as TILE_VALUE,
  dae as TIMEZONES,
  R1 as TREND,
  f2 as Tab,
  dPe as TagBeautified,
  lPe as TagColorPicker,
  fPe as TagStack,
  cPe as Tile,
  hPe as TileActions,
  gPe as TileBody,
  _Pe as TileExtra,
  wSe as TileHeader,
  mPe as TileLegend,
  pPe as TileList,
  Sw as TileValue,
  e4 as Time,
  FPe as TimePicker,
  p8 as TimeSelect,
  Xle as TimeSlotContainer,
  Qle as TimeSlotField,
  ife as TimeSlotsField,
  rTe as TimeSlotsForm,
  sfe as TimezoneSelect,
  Bh as TooltipContent,
  ESe as Trend,
  QSe as TypographyStack,
  Gne as UNAUTHORIZED_ROUTE,
  Fne as USERS_ROUTE,
  yne as USER_DETAIL_ROUTE,
  bne as USER_DETAIL_ROUTE_TAB,
  $Te as UnderlinedExternalLink,
  ETe as UnderlinedLink,
  EF as UnknownError,
  OTe as UnknownErrorScreen,
  bPe as User,
  yPe as UserAvatar,
  EPe as UserCount,
  ZSe as UserName,
  vPe as UserNumber,
  $Pe as UserStatus,
  eAe as UserStatusTooltipContent,
  vH as VALIDATE_EMAIL_REGEX,
  tx as VALIDATE_NUMBERS_ONLY_REGEX,
  EH as VALIDATE_PASSWORD_LENGTH_REGEX,
  $H as VALIDATE_PASSWORD_STRENGTH_REGEX,
  kH as VALIDATE_PERCENTAGE_ONLY_REGEX,
  wH as VALIDATE_URL_FORMAT_REGEX,
  mH as VALIDATION_ERROR_CODES,
  Tne as ZENDESK_SSO,
  Wne as allRoutes,
  XOe as areSearchParamsEqual,
  EW as browserMapper,
  xW as calcColorDistance,
  sOe as canDeleteUser,
  V1 as capitalizeFirstLetter,
  BAe as classicFormat,
  Kne as computeThemeVariantFromInitials,
  aOe as convertSecondsToMinSecNotation,
  nOe as convertToSeconds,
  xle as copyURLSearchParamsWithoutKeys,
  PW as countriesCurrenciesMapping,
  Hk as countriesPrefix,
  yAe as countriesStates,
  CW as countryISOMapping,
  EAe as currencyValueWithSymbol,
  dOe as dashboardTheme,
  w_ as dayOfMonthFormat,
  nle as decodeToken,
  VAe as delay,
  eOe as deleteResource,
  $W as determineBrowserSupport,
  Oh as doRequest,
  QAe as downloadPdfFile,
  KAe as fileToBase64,
  Jre as formatInternationalNumber,
  vAe as formatLocalizedCurrency,
  ene as formatLocalizedNumber,
  kle as formatObjectToSearchParams,
  T1 as formatSearchParamsToObject,
  ix as formatSecondsToDuration,
  iOe as formatToE164,
  zne as forwardRefWithGenericType,
  GAe as generateEmptyArray,
  xJ as generateRandomUUID,
  kJ as generateUniqId,
  pAe as getBrowser,
  DW as getClosestColor,
  Xne as getCommonPayload,
  SW as getCountryISO3,
  bAe as getCurrencyByCountryCode,
  y6 as getCurrencySymbol,
  IAe as getDaysDifference,
  J6 as getDerivedEmoji,
  bx as getEmoji,
  K9 as getErrorKey,
  ZAe as getFile,
  FAe as getFlagName,
  lae as getFormattedTimezoneOffset,
  DAe as getFullName,
  W3 as getInitials,
  LAe as getKeysWithDifferentValues,
  qAe as getKeysWithSameValues,
  OH as getLocalizedTime,
  S6 as getMidnightDate,
  RAe as getMinutesDifference,
  mAe as getNextOS,
  wW as getOperatingSystem,
  jAe as getPeriodOfDay,
  ZCe as getRadioBoxStyles,
  RH as getRelativeDate,
  JAe as getResource,
  Hne as getResourceFromPath,
  eSe as getRoleColor,
  Vne as getRouteFromPath,
  TH as getRtf,
  Xh as getSavingStatus,
  uD as getScrollableParent,
  h8 as getSearchParamsSize,
  ax as getSplittedText,
  fae as getTimezones,
  lOe as getTrackSettingsProperties,
  rx as getTranslatedCountryName,
  z9 as getValidationErrors,
  Y9 as getValidationErrorsTranslations,
  L_ as graphqlErrorHasErrorMessage,
  Es as handleApolloError,
  Vd as hasErrorCode,
  su as hasRole,
  L1 as hexToRgb,
  NAe as isAnyFieldDifferent,
  _Ae as isBrowserAccepted,
  HD as isDefined,
  sD as isGraphQLError,
  DJ as isNetworkError,
  wJ as isObject,
  zD as isTruthy,
  XAe as isValidUrl,
  A6 as localizedRTFMap,
  PAe as longDate,
  MAe as longFormat,
  f1e as makeTextField,
  tle as mapActions,
  nx as matchPartialText,
  YAe as mergeBaseUrlWithEndpoints,
  QOe as mergeSearchParams,
  OAe as monthFormat,
  TAe as monthYearFormat,
  lle as navigation,
  Zre as normalizeNumber,
  tee as parseResponse,
  rle as parseToken,
  FOe as pipeValidators,
  rOe as postFormData,
  tOe as postNormalizedResource,
  ree as postResource,
  eee as removeDuplicateForwardSlashesFromUrl,
  Lk as removeDuplicatesByProperties,
  YOe as removeEmptyEntriesFromObject,
  WAe as removeFieldsFromObjectRecursively,
  SAe as replace,
  uOe as reverseOrderDirection,
  _D as routeReplacer,
  g8 as saveAnimationVariants,
  n1 as shortDate,
  k_ as shortMonthFormat,
  bF as sortAscending,
  UAe as sortAscendingBy,
  CAe as stringContainsHtmlTags,
  tne as toFixedNumber,
  AAe as toLower,
  qa as translations,
  SH as trimWhiteSpaces,
  AH as trimWithEllipsis,
  yF as typedMemo,
  OS as useBlocker,
  jOe as useCancellableLazyQuery,
  Ele as useCloseOnScroll,
  kde as useCombinedRefs,
  Fae as useCopyToClipboard,
  ld as useFormWizard,
  KOe as useFromRoute,
  MOe as useGraphLazyQuery,
  BOe as useGraphMutation,
  ZF as useGraphQuery,
  NOe as useGraphQueryPaginated,
  qOe as useHasAccess,
  UOe as useImperativeQuery,
  Qde as useInfiniteLoader,
  ale as useIntersection,
  wle as useLayoutPosition,
  JOe as useListViewFilters,
  GOe as useLoadMore,
  ule as useLuminance,
  WOe as useMeasureElement,
  dle as useMutableRef,
  tTe as useNavigateToAddonPage,
  VOe as useNavigateWithParamsReplace,
  AS as useNavigationBlocker,
  JF as usePermissions,
  MS as usePersistedSearchParams,
  eTe as useQueryParams,
  $le as useResizeObserver,
  Zde as useResource,
  Tle as useSearchHistory,
  Um as useStateDelay,
  Xde as useThrottledCallback,
  QF as useToast,
  HOe as useToggle,
  Gle as useTrackAddonSubscriptionFunnel,
  zOe as useTracker,
  cOe as validateAlreadyExists,
  hOe as validateConfirmedPassword,
  fOe as validateEmail,
  mOe as validateMaxLength,
  bOe as validateMaxValue,
  yOe as validateMinValue,
  kOe as validateNumberName,
  vOe as validateNumberOnly,
  gOe as validatePasswordLength,
  _Oe as validatePasswordStrength,
  EOe as validatePercentage,
  wOe as validatePhoneNumberFormat,
  HAe as validatePictureFormat,
  zAe as validatePictureSize,
  QD as validateRequired,
  $Oe as validateUniquePhoneNumber,
  pOe as validateUrlFormat,
  wPe as withAccess,
  kPe as withResource
};
